import { jsx as v, jsxs as T, Fragment as De } from "react/jsx-runtime";
import * as g from "react";
import ne, { createContext as Ot, useContext as ho, useCallback as Le, useState as Pe, useRef as Ie, useEffect as Ce, useMemo as Ho, createElement as gx, forwardRef as mt, cloneElement as Gm, useLayoutEffect as Km, useReducer as hx, Component as px, useImperativeHandle as mx } from "react";
import * as po from "react-dom";
import os from "react-dom";
import { D as Gd, p as fx, s as bx, a as _x } from "./communicationBanner-Dk53U4Iq.js";
import { g as jit, h as Oit } from "./communicationBanner-Dk53U4Iq.js";
const vx = (e, t, a, o) => {
  const n = [a, {
    code: t,
    ...o || {}
  }];
  if (e?.services?.logger?.forward)
    return e.services.logger.forward(n, "warn", "react-i18next::", !0);
  Za(n[0]) && (n[0] = `react-i18next:: ${n[0]}`), e?.services?.logger?.warn ? e.services.logger.warn(...n) : console?.warn && console.warn(...n);
}, Kd = {}, Jl = (e, t, a, o) => {
  Za(a) && Kd[a] || (Za(a) && (Kd[a] = /* @__PURE__ */ new Date()), vx(e, t, a, o));
}, Jm = (e, t) => () => {
  if (e.isInitialized)
    t();
  else {
    const a = () => {
      setTimeout(() => {
        e.off("initialized", a);
      }, 0), t();
    };
    e.on("initialized", a);
  }
}, Zl = (e, t, a) => {
  e.loadNamespaces(t, Jm(e, a));
}, Jd = (e, t, a, o) => {
  if (Za(a) && (a = [a]), e.options.preload && e.options.preload.indexOf(t) > -1) return Zl(e, a, o);
  a.forEach((n) => {
    e.options.ns.indexOf(n) < 0 && e.options.ns.push(n);
  }), e.loadLanguages(t, Jm(e, o));
}, yx = (e, t, a = {}) => !t.languages || !t.languages.length ? (Jl(t, "NO_LANGUAGES", "i18n.languages were undefined or empty", {
  languages: t.languages
}), !0) : t.hasLoadedNamespace(e, {
  lng: a.lng,
  precheck: (o, n) => {
    if (a.bindI18n && a.bindI18n.indexOf("languageChanging") > -1 && o.services.backendConnector.backend && o.isLanguageChangingTo && !n(o.isLanguageChangingTo, e)) return !1;
  }
}), Za = (e) => typeof e == "string", wx = (e) => typeof e == "object" && e !== null, kx = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, xx = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, $x = (e) => xx[e], Sx = (e) => e.replace(kx, $x);
let Cx = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: Sx
};
const Ex = () => Cx;
let jx;
const Ox = () => jx, Zm = Ot();
class zx {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(t) {
    t.forEach((a) => {
      this.usedNamespaces[a] || (this.usedNamespaces[a] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
const Ax = (e, t) => {
  const a = Ie();
  return Ce(() => {
    a.current = e;
  }, [e, t]), a.current;
}, Ym = (e, t, a, o) => e.getFixedT(t, a, o), Px = (e, t, a, o) => Le(Ym(e, t, a, o), [e, t, a, o]), mo = (e, t = {}) => {
  const {
    i18n: a
  } = t, {
    i18n: o,
    defaultNS: n
  } = ho(Zm) || {}, r = a || o || Ox();
  if (r && !r.reportNamespaces && (r.reportNamespaces = new zx()), !r) {
    Jl(r, "NO_I18NEXT_INSTANCE", "useTranslation: You will need to pass in an i18next instance by using initReactI18next");
    const k = (S, $) => Za($) ? $ : wx($) && Za($.defaultValue) ? $.defaultValue : Array.isArray(S) ? S[S.length - 1] : S, x = [k, {}, !1];
    return x.t = k, x.i18n = {}, x.ready = !1, x;
  }
  r.options.react?.wait && Jl(r, "DEPRECATED_OPTION", "useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const i = {
    ...Ex(),
    ...r.options.react,
    ...t
  }, {
    useSuspense: s,
    keyPrefix: l
  } = i;
  let c = e || n || r.options?.defaultNS;
  c = Za(c) ? [c] : c || ["translation"], r.reportNamespaces.addUsedNamespaces?.(c);
  const u = (r.isInitialized || r.initializedStoreOnce) && c.every((k) => yx(k, r, i)), d = Px(r, t.lng || null, i.nsMode === "fallback" ? c : c[0], l), h = () => d, m = () => Ym(r, t.lng || null, i.nsMode === "fallback" ? c : c[0], l), [f, p] = Pe(h);
  let b = c.join();
  t.lng && (b = `${t.lng}${b}`);
  const w = Ax(b), _ = Ie(!0);
  Ce(() => {
    const {
      bindI18n: k,
      bindI18nStore: x
    } = i;
    _.current = !0, !u && !s && (t.lng ? Jd(r, t.lng, c, () => {
      _.current && p(m);
    }) : Zl(r, c, () => {
      _.current && p(m);
    })), u && w && w !== b && _.current && p(m);
    const S = () => {
      _.current && p(m);
    };
    return k && r?.on(k, S), x && r?.store.on(x, S), () => {
      _.current = !1, r && k && k?.split(" ").forEach(($) => r.off($, S)), x && r && x.split(" ").forEach(($) => r.store.off($, S));
    };
  }, [r, b]), Ce(() => {
    _.current && u && p(h);
  }, [r, l, u]);
  const y = [f, r, u];
  if (y.t = f, y.i18n = r, y.ready = u, u || !u && !s) return y;
  throw new Promise((k) => {
    t.lng ? Jd(r, t.lng, c, () => k()) : Zl(r, c, () => k());
  });
};
function Dx({
  i18n: e,
  defaultNS: t,
  children: a
}) {
  const o = Ho(() => ({
    i18n: e,
    defaultNS: t
  }), [e, t]);
  return gx(Zm.Provider, {
    value: o
  }, a);
}
function Xm(e) {
  var t, a, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var n = e.length;
    for (t = 0; t < n; t++) e[t] && (a = Xm(e[t])) && (o && (o += " "), o += a);
  } else for (a in e) e[a] && (o && (o += " "), o += a);
  return o;
}
function Ae() {
  for (var e, t, a = 0, o = "", n = arguments.length; a < n; a++) (e = arguments[a]) && (t = Xm(e)) && (o && (o += " "), o += t);
  return o;
}
const Nx = [
  "accessible-bathroom",
  "accessible-bedroom",
  "ac",
  "ambassador_sidebar",
  "animals-card",
  "angle-left",
  "angle-left-rounded",
  "angle-right",
  "angle-right-rounded",
  "anywhere-in-the-world",
  "arrow-thin",
  "arrow-thin-right",
  "available-exchange-type",
  "average-reactivity",
  "baby-bed",
  "baby-gear",
  "baby-gear-old",
  "baby-sitter",
  "balcony-terrace",
  "bathroom",
  "bathtub",
  "bbq",
  "bedroom",
  "beds",
  "bicycle",
  "briefcase3",
  "button-power",
  "cancel",
  "calendar",
  "car",
  "cat-to-feed",
  "chat-lock",
  "check",
  "checkbox-fill",
  "children-welcome",
  "circle-close",
  "circle-help",
  "circle-left-arrow",
  "circle-right-arrow",
  "cities",
  "cleaning-person",
  "clock",
  "computer",
  "cook",
  "corona-virus",
  "countryside",
  "credit-card",
  "dashboard-saved-search",
  "dedicated-work-space",
  "disabled-access",
  "dishwasher",
  "docs",
  "dog-to-feed",
  "dollar",
  "doorman",
  "double-bed",
  "double-bed-up",
  "dryer",
  "easy-navigation",
  "electric-car",
  "electric-car-plug",
  "elevator",
  "error",
  "error-regular",
  "error-warning-fill",
  "excellent-reactivity",
  "eye",
  "eye-slash",
  "eye-slash-back",
  "facebook",
  "filter-picture",
  "fireplace",
  "flag",
  "flat",
  "folk",
  "freezer",
  "fridge",
  "garden",
  "gift",
  "gp",
  "great-reactivity",
  "guarantees",
  "guestpoint-exchange-type",
  "guestpoints",
  "guide",
  "gym",
  "header-help",
  "header-message-new",
  "header-message-read",
  "header-profile-home",
  "header-profile-profile",
  "header-profile-settings",
  "header-profile-they-love-my-home",
  "heart",
  "heart-fill",
  "heating-system",
  "high-speed-connection",
  "home-bin",
  "home-camera",
  "home-cinema",
  "home-exchange",
  "home-panel",
  "house",
  "ic-compass",
  "ic-flip-left",
  "ic-flip-right",
  "ic-location",
  "ic-move",
  "ic-shelter",
  "ic-transfer",
  "icon_facebook",
  "icon_gmail",
  "icon_messanger",
  "icon_outlook",
  "id",
  "information-circle",
  "information-circle-regular",
  "instagram",
  "internet",
  "isolated",
  "island",
  "jacuzzi",
  "key",
  "keys",
  "kids-playground",
  "kids-toys",
  "lakes",
  "lifebuoy",
  "linkedin",
  "location",
  "lock",
  "lock-credit-card",
  "low-consumption-machines",
  "marker-home",
  "marker-home-favorite",
  "marker-home-selected",
  "marker-home-selected-favorite",
  "marker-home-unavailable",
  "marker-home-unavailable-favorite",
  "low-reactivity",
  "map-1",
  "megaphone",
  "membership",
  "messenger",
  "microwave-oven",
  "minus",
  "moonplus",
  "more-filter",
  "motorboat",
  "motorcycle",
  "motor-scooter",
  "mountains",
  "my-family",
  "new-tab",
  "notification",
  "noun-loyalty-card",
  "number-eight",
  "number-five",
  "number-four",
  "number-nine",
  "number-one",
  "number-seven",
  "number-six",
  "number-three",
  "number-two",
  "ok",
  "oven",
  "parking-space",
  "pencil",
  "people",
  "pets-welcome",
  "phone",
  "piano",
  "ping-pong-table",
  "pin",
  "plants-to-water",
  "playground",
  "plus",
  "plus-sign",
  "pool-table",
  "preferred-destinations",
  "primary-home",
  "private-room",
  "public-transit-access",
  "rabbit",
  "raw",
  "reciprocal-exchange-type",
  "remove",
  "renewable-energy-provider",
  "river",
  "rooms",
  "sailboat",
  "satellite-cable",
  "sauna",
  "search",
  "search-location-pin",
  "seaside",
  "secondary-home",
  "secured-swimming-pool",
  "selective-waste-sorting",
  "shape-close",
  "share-fat",
  "simple-bed",
  "simple-bed-up",
  "size",
  "smart-tv",
  "smokers-welcome",
  "solar-panels",
  "sort-order",
  "sponsor-hand-icon",
  "star-black",
  "star-full",
  "step-free-entry",
  "sugesstion",
  "sun",
  "swimming-pool",
  "tennis-court",
  "tiktok",
  "triangle-warning",
  "tv",
  "tv-icon",
  "twitter",
  "types_of_exchanges",
  "unavailable",
  "up-arrow",
  "upload",
  "user",
  "vegetable-garden",
  "verification-check",
  "verification-check-regular",
  "video-game-console",
  "villages",
  "warning",
  "warning-regular",
  "washing-machine",
  "wide-angle",
  "wide-doors",
  "wifi",
  "youtube"
], Rx = {
  "marker-home-favorite": 3,
  "marker-home": 2,
  "marker-home-selected-favorite": 3,
  "marker-home-selected": 2,
  "marker-home-unavailable-favorite": 3,
  "marker-home-unavailable": 2,
  icon_facebook: 2,
  icon_gmail: 5
}, Ix = Nx.map((e) => ({
  name: e,
  class: `icon-${e}`,
  paths: Rx[e]
})), Tx = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, Lx = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl",
  "8xl": "is-8xl",
  "9xl": "is-9xl",
  "10xl": "is-10xl"
};
function Mx(e = 0) {
  const t = [];
  for (let a = 0; a < e; a++)
    t[a] = `path${a + 1}`;
  return t.map((a) => /* @__PURE__ */ v("span", { className: a }, a));
}
const Se = mt(
  ({ name: e, size: t = "medium", color: a = "base", className: o = "", ...n }, r) => {
    const i = Ix.find((l) => l.name === e), s = Ae("icon", `ds-${i?.class}`, Lx[t], Tx[a], o);
    return /* @__PURE__ */ v("i", { className: s, ...n, ref: r, children: Mx(i?.paths) });
  }
);
Se.displayName = "Icon";
const Wx = "_loader_1ksyv_29", Bx = "_circle_1ksyv_41", wo = {
  loader: Wx,
  "is-small": "_is-small_1ksyv_29",
  "is-medium": "_is-medium_1ksyv_33",
  "is-large": "_is-large_1ksyv_37",
  circle: Bx,
  "moving-element": "_moving-element_1ksyv_44",
  "on-dark": "_on-dark_1ksyv_47",
  "is-secondary": "_is-secondary_1ksyv_53",
  "dialog-overlay-show": "_dialog-overlay-show_1ksyv_1",
  "dialog-content-show": "_dialog-content-show_1ksyv_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1ksyv_1"
}, Fx = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large"
}, Vx = {
  primary: "is-primary",
  secondary: "is-secondary"
};
function Ux({ onDark: e, size: t = "medium", color: a = "primary", className: o }) {
  return /* @__PURE__ */ T(
    "svg",
    {
      className: Ae(
        wo.loader,
        wo[Fx[t]],
        wo[Vx[a]],
        e && wo["on-dark"],
        o
      ),
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      children: [
        /* @__PURE__ */ v("rect", { width: "100", height: "100", fill: "none", className: "bk" }),
        /* @__PURE__ */ v("circle", { className: wo.circle, cx: "50", cy: "50", r: "40", fill: "none", strokeWidth: "10", strokeLinecap: "round" }),
        /* @__PURE__ */ T(
          "circle",
          {
            className: wo["moving-element"],
            cx: "50",
            cy: "50",
            r: "40",
            fill: "none",
            strokeWidth: "6",
            strokeLinecap: "round",
            children: [
              /* @__PURE__ */ v("animate", { attributeName: "stroke-dashoffset", dur: "2s", repeatCount: "indefinite", from: "502", to: "0" }),
              /* @__PURE__ */ v(
                "animate",
                {
                  attributeName: "stroke-dasharray",
                  dur: "2s",
                  repeatCount: "indefinite",
                  values: "150.6 100.4;1 250;150.6 100.4"
                }
              )
            ]
          }
        )
      ]
    }
  );
}
const qx = "_button_z1os6_29", Hx = "_disabled_z1os6_43", Gx = "_loader_z1os6_263", sa = {
  button: qx,
  disabled: Hx,
  "is-primary": "_is-primary_z1os6_51",
  "is-contrasted": "_is-contrasted_z1os6_65",
  "is-secondary": "_is-secondary_z1os6_74",
  "is-tertiary": "_is-tertiary_z1os6_97",
  "is-eco-green": "_is-eco-green_z1os6_120",
  "is-ghost": "_is-ghost_z1os6_134",
  "is-destructive": "_is-destructive_z1os6_157",
  "is-hollow": "_is-hollow_z1os6_171",
  "is-destructive-ghost": "_is-destructive-ghost_z1os6_189",
  "is-facebook": "_is-facebook_z1os6_203",
  "is-apple": "_is-apple_z1os6_217",
  "is-google": "_is-google_z1os6_231",
  "is-regular": "_is-regular_z1os6_245",
  "is-medium": "_is-medium_z1os6_248",
  "is-small": "_is-small_z1os6_251",
  "is-full-width": "_is-full-width_z1os6_254",
  "is-loading": "_is-loading_z1os6_257",
  loader: Gx,
  "dialog-overlay-show": "_dialog-overlay-show_z1os6_1",
  "dialog-content-show": "_dialog-content-show_z1os6_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_z1os6_1"
}, ou = mt(
  ({
    text: e,
    color: t = "primary",
    size: a = "medium",
    isFullWidth: o = !1,
    icon: n,
    iconPosition: r = "left",
    isLoading: i = !1,
    iconSize: s = "medium",
    isContrasted: l = !1,
    disabled: c = !1,
    className: u,
    children: d,
    ...h
  }, m) => {
    const f = Ae(
      sa.button,
      sa[Kx[t]],
      sa[Jx[a]],
      o && sa["is-full-width"],
      c && sa.disabled,
      r === "right" && sa["has-icon-right"],
      l && sa["is-contrasted"],
      i && sa["is-loading"],
      u
    ), p = /* @__PURE__ */ T(De, { children: [
      i && /* @__PURE__ */ v(Ux, { className: sa.loader, onDark: !0, size: "small" }),
      n && r === "left" && /* @__PURE__ */ v(Se, { color: "inherit", size: s, name: n }),
      d ?? e,
      n && r === "right" && /* @__PURE__ */ v(Se, { color: "inherit", size: s, name: n })
    ] });
    if (Zx(h))
      return /* @__PURE__ */ v(
        "a",
        {
          ...h,
          href: c ? void 0 : h.href,
          className: f,
          target: h.target,
          ref: m,
          children: p
        }
      );
    if (Yx(h))
      return /* @__PURE__ */ v(
        "button",
        {
          disabled: i || c,
          ...h,
          className: f,
          ref: m,
          children: p
        }
      );
  }
);
ou.displayName = "Button";
const Kx = {
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  "eco-green": "is-eco-green",
  ghost: "is-ghost",
  "destructive-ghost": "is-destructive-ghost",
  destructive: "is-destructive",
  hollow: "is-hollow",
  facebook: "is-facebook",
  apple: "is-apple",
  google: "is-google"
}, Jx = {
  small: "is-small",
  medium: "is-medium",
  regular: "is-regular"
};
function Zx(e) {
  return "href" in e && typeof e.href == "string";
}
function Yx(e) {
  return !("href" in e);
}
const Zd = {
  MOBILE: 640,
  TABLET: 768
}, Xx = "_text_1tduc_29", xa = {
  text: Xx,
  "is-small": "_is-small_1tduc_34",
  "is-uppercase": "_is-uppercase_1tduc_38",
  "is-ellipsis": "_is-ellipsis_1tduc_41",
  "is-center": "_is-center_1tduc_47",
  "color-primary": "_color-primary_1tduc_50",
  "color-secondary": "_color-secondary_1tduc_53",
  "color-tertiary": "_color-tertiary_1tduc_56",
  "color-eco-green": "_color-eco-green_1tduc_59",
  "color-success": "_color-success_1tduc_62",
  "color-error": "_color-error_1tduc_65",
  "color-inverted": "_color-inverted_1tduc_68",
  "color-warning": "_color-warning_1tduc_71",
  "color-highlight": "_color-highlight_1tduc_74",
  "color-inherit": "_color-inherit_1tduc_77",
  "is-bold": "_is-bold_1tduc_80",
  "size-xs": "_size-xs_1tduc_83",
  "size-sm": "_size-sm_1tduc_86",
  "size-base": "_size-base_1tduc_89",
  "size-lg": "_size-lg_1tduc_92",
  "size-xl": "_size-xl_1tduc_95",
  "dialog-overlay-show": "_dialog-overlay-show_1tduc_1",
  "dialog-content-show": "_dialog-content-show_1tduc_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1tduc_1"
};
function Je({
  children: e,
  dangerouslySetInnerHTML: t,
  isSmall: a,
  isUppercase: o,
  ellipsis: n,
  isSpan: r,
  className: i = "",
  color: s = "primary",
  isBold: l,
  size: c,
  title: u,
  center: d,
  ...h
}) {
  const m = Ae(
    xa.text,
    a && xa["is-small"],
    n && xa["is-ellipsis"],
    s && xa[`color-${s}`],
    l && xa["is-bold"],
    o && xa["is-uppercase"],
    c && xa[`size-${c}`],
    d && xa["is-center"],
    i
  ), f = r ? "span" : "div";
  return t ? /* @__PURE__ */ v(f, { className: m, dangerouslySetInnerHTML: t, ...h, title: u }) : /* @__PURE__ */ v(f, { className: m, ...h, children: e });
}
const hr = {
  "flex-children": "_flex-children_7pjb4_29",
  "justify-self-start": "_justify-self-start_7pjb4_29",
  "justify-self-end": "_justify-self-end_7pjb4_32",
  "justify-self-center": "_justify-self-center_7pjb4_35",
  "align-self-start": "_align-self-start_7pjb4_38",
  "align-self-end": "_align-self-end_7pjb4_41",
  "align-self-center": "_align-self-center_7pjb4_44",
  "is-full-width": "_is-full-width_7pjb4_47",
  "dialog-overlay-show": "_dialog-overlay-show_7pjb4_1",
  "dialog-content-show": "_dialog-content-show_7pjb4_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_7pjb4_1"
}, Qx = ({ alignSelf: e, justifySelf: t, children: a, isFullWidth: o, ...n }) => {
  const r = Ae(
    hr["flex-children"],
    e && hr[`align-self-${e}`],
    t && hr[`justify-self-${t}`],
    o && hr["is-full-width"]
  );
  return /* @__PURE__ */ v("div", { className: r, ...n, children: a });
}, e1 = "_flex_1taae_29", t1 = "_wrap_1taae_67", a1 = "_nowrap_1taae_70", o1 = "_shrink_1taae_88", St = {
  flex: e1,
  "flex-row": "_flex-row_1taae_34",
  "flex-column": "_flex-column_1taae_37",
  "justify-start": "_justify-start_1taae_40",
  "justify-end": "_justify-end_1taae_43",
  "justify-center": "_justify-center_1taae_46",
  "justify-space-between": "_justify-space-between_1taae_49",
  "justify-space-around": "_justify-space-around_1taae_52",
  "align-start": "_align-start_1taae_55",
  "align-end": "_align-end_1taae_58",
  "align-center": "_align-center_1taae_61",
  "align-stretch": "_align-stretch_1taae_64",
  wrap: t1,
  nowrap: a1,
  "wrap-reverse": "_wrap-reverse_1taae_73",
  "is-full-width": "_is-full-width_1taae_79",
  "is-full-height": "_is-full-height_1taae_82",
  "flex-grow": "_flex-grow_1taae_85",
  shrink: o1,
  "hide-on-mobile": "_hide-on-mobile_1taae_91",
  "gap-0": "_gap-0_1taae_99",
  "gap-1": "_gap-1_1taae_102",
  "gap-2": "_gap-2_1taae_105",
  "gap-3": "_gap-3_1taae_108",
  "gap-4": "_gap-4_1taae_111",
  "gap-5": "_gap-5_1taae_114",
  "gap-6": "_gap-6_1taae_117",
  "gap-7": "_gap-7_1taae_120",
  "gap-8": "_gap-8_1taae_123",
  "gap-9": "_gap-9_1taae_126",
  "gap-10": "_gap-10_1taae_129",
  "gap-11": "_gap-11_1taae_132",
  "gap-12": "_gap-12_1taae_135",
  "gap-14": "_gap-14_1taae_138",
  "gap-16": "_gap-16_1taae_141",
  "gap-18": "_gap-18_1taae_144",
  "gap-20": "_gap-20_1taae_147",
  "gap-24": "_gap-24_1taae_150",
  "gap-28": "_gap-28_1taae_153",
  "gap-32": "_gap-32_1taae_156",
  "gap-36": "_gap-36_1taae_159",
  "gap-40": "_gap-40_1taae_162",
  "gap-44": "_gap-44_1taae_165",
  "gap-48": "_gap-48_1taae_168",
  "gap-52": "_gap-52_1taae_171",
  "gap-56": "_gap-56_1taae_174",
  "gap-60": "_gap-60_1taae_177",
  "gap-64": "_gap-64_1taae_180",
  "gap-72": "_gap-72_1taae_183",
  "gap-80": "_gap-80_1taae_186",
  "gap-96": "_gap-96_1taae_189",
  "no-margin": "_no-margin_1taae_192",
  "dialog-overlay-show": "_dialog-overlay-show_1taae_1",
  "dialog-content-show": "_dialog-content-show_1taae_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1taae_1"
};
function ue({
  children: e,
  direction: t = "row",
  justifyContent: a = "start",
  alignItems: o = "start",
  flexWrap: n = "wrap",
  className: r = "",
  isFullWidth: i = !1,
  isFullHeight: s = !1,
  gap: l,
  style: c,
  noMargin: u = !1,
  flexGrow: d = !1,
  hideOnMobile: h = !1,
  shrink: m = !1,
  ...f
}) {
  const p = Ae(
    St.flex,
    St[`flex-${t}`],
    St[`justify-${a}`],
    St[`align-${o}`],
    St[n],
    i && St["is-full-width"],
    s && St["is-full-height"],
    l && St[`gap-${l}`],
    u && St["no-margin"],
    d && St["flex-grow"],
    h && St["hide-on-mobile"],
    m && St.shrink,
    r
  );
  return /* @__PURE__ */ v("div", { className: p, ...f, style: c, children: e });
}
ue.FlexChildren = Qx;
function me(e, t, { checkForDefaultPrevented: a = !0 } = {}) {
  return function(o) {
    if (e?.(o), a === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
var pa = globalThis?.document ? g.useLayoutEffect : () => {
}, n1 = g[" useInsertionEffect ".trim().toString()] || pa;
function Jn({
  prop: e,
  defaultProp: t,
  onChange: a = () => {
  },
  caller: o
}) {
  const [n, r, i] = r1({
    defaultProp: t,
    onChange: a
  }), s = e !== void 0, l = s ? e : n;
  {
    const u = g.useRef(e !== void 0);
    g.useEffect(() => {
      const d = u.current;
      d !== s && console.warn(
        `${o} is changing from ${d ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), u.current = s;
    }, [s, o]);
  }
  const c = g.useCallback(
    (u) => {
      if (s) {
        const d = i1(u) ? u(e) : u;
        d !== e && i.current?.(d);
      } else
        r(u);
    },
    [s, e, r, i]
  );
  return [l, c];
}
function r1({
  defaultProp: e,
  onChange: t
}) {
  const [a, o] = g.useState(e), n = g.useRef(a), r = g.useRef(t);
  return n1(() => {
    r.current = t;
  }, [t]), g.useEffect(() => {
    n.current !== a && (r.current?.(a), n.current = a);
  }, [a, n]), [a, o, r];
}
function i1(e) {
  return typeof e == "function";
}
function Yd(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function nu(...e) {
  return (t) => {
    let a = !1;
    const o = e.map((n) => {
      const r = Yd(n, t);
      return !a && typeof r == "function" && (a = !0), r;
    });
    if (a)
      return () => {
        for (let n = 0; n < o.length; n++) {
          const r = o[n];
          typeof r == "function" ? r() : Yd(e[n], null);
        }
      };
  };
}
function We(...e) {
  return g.useCallback(nu(...e), e);
}
function s1(e, t) {
  const a = g.createContext(t), o = (r) => {
    const { children: i, ...s } = r, l = g.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ v(a.Provider, { value: l, children: i });
  };
  o.displayName = e + "Provider";
  function n(r) {
    const i = g.useContext(a);
    if (i) return i;
    if (t !== void 0) return t;
    throw new Error(`\`${r}\` must be used within \`${e}\``);
  }
  return [o, n];
}
function fo(e, t = []) {
  let a = [];
  function o(r, i) {
    const s = g.createContext(i), l = a.length;
    a = [...a, i];
    const c = (d) => {
      const { scope: h, children: m, ...f } = d, p = h?.[e]?.[l] || s, b = g.useMemo(() => f, Object.values(f));
      return /* @__PURE__ */ v(p.Provider, { value: b, children: m });
    };
    c.displayName = r + "Provider";
    function u(d, h) {
      const m = h?.[e]?.[l] || s, f = g.useContext(m);
      if (f) return f;
      if (i !== void 0) return i;
      throw new Error(`\`${d}\` must be used within \`${r}\``);
    }
    return [c, u];
  }
  const n = () => {
    const r = a.map((i) => g.createContext(i));
    return function(i) {
      const s = i?.[e] || r;
      return g.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: s } }),
        [i, s]
      );
    };
  };
  return n.scopeName = e, [o, l1(n, ...t)];
}
function l1(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const a = () => {
    const o = e.map((n) => ({
      useScope: n(),
      scopeName: n.scopeName
    }));
    return function(n) {
      const r = o.reduce((i, { useScope: s, scopeName: l }) => {
        const c = s(n)[`__scope${l}`];
        return { ...i, ...c };
      }, {});
      return g.useMemo(() => ({ [`__scope${t.scopeName}`]: r }), [r]);
    };
  };
  return a.scopeName = t.scopeName, a;
}
// @__NO_SIDE_EFFECTS__
function fi(e) {
  const t = /* @__PURE__ */ c1(e), a = g.forwardRef((o, n) => {
    const { children: r, ...i } = o, s = g.Children.toArray(r), l = s.find(d1);
    if (l) {
      const c = l.props.children, u = s.map((d) => d === l ? g.Children.count(c) > 1 ? g.Children.only(null) : g.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ v(t, { ...i, ref: n, children: g.isValidElement(c) ? g.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ v(t, { ...i, ref: n, children: r });
  });
  return a.displayName = `${e}.Slot`, a;
}
// @__NO_SIDE_EFFECTS__
function c1(e) {
  const t = g.forwardRef((a, o) => {
    const { children: n, ...r } = a;
    if (g.isValidElement(n)) {
      const i = h1(n), s = g1(r, n.props);
      return n.type !== g.Fragment && (s.ref = o ? nu(o, i) : i), g.cloneElement(n, s);
    }
    return g.Children.count(n) > 1 ? g.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var u1 = Symbol("radix.slottable");
function d1(e) {
  return g.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === u1;
}
function g1(e, t) {
  const a = { ...t };
  for (const o in t) {
    const n = e[o], r = t[o];
    /^on[A-Z]/.test(o) ? n && r ? a[o] = (...i) => {
      const s = r(...i);
      return n(...i), s;
    } : n && (a[o] = n) : o === "style" ? a[o] = { ...n, ...r } : o === "className" && (a[o] = [n, r].filter(Boolean).join(" "));
  }
  return { ...e, ...a };
}
function h1(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, a = t && "isReactWarning" in t && t.isReactWarning;
  return a ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, a = t && "isReactWarning" in t && t.isReactWarning, a ? e.props.ref : e.props.ref || e.ref);
}
var p1 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], _e = p1.reduce((e, t) => {
  const a = /* @__PURE__ */ fi(`Primitive.${t}`), o = g.forwardRef((n, r) => {
    const { asChild: i, ...s } = n, l = i ? a : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ v(l, { ...s, ref: r });
  });
  return o.displayName = `Primitive.${t}`, { ...e, [t]: o };
}, {});
function Yl(e, t) {
  e && po.flushSync(() => e.dispatchEvent(t));
}
var m1 = g.createContext(void 0);
function ns(e) {
  const t = g.useContext(m1);
  return e || t || "ltr";
}
function ru(e) {
  const t = e + "CollectionProvider", [a, o] = fo(t), [n, r] = a(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (p) => {
    const { scope: b, children: w } = p, _ = ne.useRef(null), y = ne.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ v(n, { scope: b, itemMap: y, collectionRef: _, children: w });
  };
  i.displayName = t;
  const s = e + "CollectionSlot", l = /* @__PURE__ */ fi(s), c = ne.forwardRef(
    (p, b) => {
      const { scope: w, children: _ } = p, y = r(s, w), k = We(b, y.collectionRef);
      return /* @__PURE__ */ v(l, { ref: k, children: _ });
    }
  );
  c.displayName = s;
  const u = e + "CollectionItemSlot", d = "data-radix-collection-item", h = /* @__PURE__ */ fi(u), m = ne.forwardRef(
    (p, b) => {
      const { scope: w, children: _, ...y } = p, k = ne.useRef(null), x = We(b, k), S = r(u, w);
      return ne.useEffect(() => (S.itemMap.set(k, { ref: k, ...y }), () => void S.itemMap.delete(k))), /* @__PURE__ */ v(h, { [d]: "", ref: x, children: _ });
    }
  );
  m.displayName = u;
  function f(p) {
    const b = r(e + "CollectionConsumer", p);
    return ne.useCallback(() => {
      const w = b.collectionRef.current;
      if (!w) return [];
      const _ = Array.from(w.querySelectorAll(`[${d}]`));
      return Array.from(b.itemMap.values()).sort(
        (y, k) => _.indexOf(y.ref.current) - _.indexOf(k.ref.current)
      );
    }, [b.collectionRef, b.itemMap]);
  }
  return [
    { Provider: i, Slot: c, ItemSlot: m },
    f,
    o
  ];
}
var f1 = g[" useId ".trim().toString()] || (() => {
}), b1 = 0;
function Ya(e) {
  const [t, a] = g.useState(f1());
  return pa(() => {
    a((o) => o ?? String(b1++));
  }, [e]), t ? `radix-${t}` : "";
}
function _1(e, t) {
  return g.useReducer((a, o) => t[a][o] ?? a, e);
}
var xt = (e) => {
  const { present: t, children: a } = e, o = v1(t), n = typeof a == "function" ? a({ present: o.isPresent }) : g.Children.only(a), r = We(o.ref, y1(n));
  return typeof a == "function" || o.isPresent ? g.cloneElement(n, { ref: r }) : null;
};
xt.displayName = "Presence";
function v1(e) {
  const [t, a] = g.useState(), o = g.useRef(null), n = g.useRef(e), r = g.useRef("none"), i = e ? "mounted" : "unmounted", [s, l] = _1(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return g.useEffect(() => {
    const c = pr(o.current);
    r.current = s === "mounted" ? c : "none";
  }, [s]), pa(() => {
    const c = o.current, u = n.current;
    if (u !== e) {
      const d = r.current, h = pr(c);
      e ? l("MOUNT") : h === "none" || c?.display === "none" ? l("UNMOUNT") : l(u && d !== h ? "ANIMATION_OUT" : "UNMOUNT"), n.current = e;
    }
  }, [e, l]), pa(() => {
    if (t) {
      let c;
      const u = t.ownerDocument.defaultView ?? window, d = (m) => {
        const f = pr(o.current).includes(CSS.escape(m.animationName));
        if (m.target === t && f && (l("ANIMATION_END"), !n.current)) {
          const p = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", c = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = p);
          });
        }
      }, h = (m) => {
        m.target === t && (r.current = pr(o.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        u.clearTimeout(c), t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: g.useCallback((c) => {
      o.current = c ? getComputedStyle(c) : null, a(c);
    }, [])
  };
}
function pr(e) {
  return e?.animationName || "none";
}
function y1(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, a = t && "isReactWarning" in t && t.isReactWarning;
  return a ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, a = t && "isReactWarning" in t && t.isReactWarning, a ? e.props.ref : e.props.ref || e.ref);
}
function qe(e) {
  const t = g.useRef(e);
  return g.useEffect(() => {
    t.current = e;
  }), g.useMemo(() => (...a) => t.current?.(...a), []);
}
var Js = "rovingFocusGroup.onEntryFocus", w1 = { bubbles: !1, cancelable: !0 }, Zn = "RovingFocusGroup", [Xl, Qm, k1] = ru(Zn), [x1, ef] = fo(
  Zn,
  [k1]
), [$1, S1] = x1(Zn), tf = g.forwardRef(
  (e, t) => /* @__PURE__ */ v(Xl.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ v(Xl.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ v(C1, { ...e, ref: t }) }) })
);
tf.displayName = Zn;
var C1 = g.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: a,
    orientation: o,
    loop: n = !1,
    dir: r,
    currentTabStopId: i,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: l,
    onEntryFocus: c,
    preventScrollOnEntryFocus: u = !1,
    ...d
  } = e, h = g.useRef(null), m = We(t, h), f = ns(r), [p, b] = Jn({
    prop: i,
    defaultProp: s ?? null,
    onChange: l,
    caller: Zn
  }), [w, _] = g.useState(!1), y = qe(c), k = Qm(a), x = g.useRef(!1), [S, $] = g.useState(0);
  return g.useEffect(() => {
    const E = h.current;
    if (E)
      return E.addEventListener(Js, y), () => E.removeEventListener(Js, y);
  }, [y]), /* @__PURE__ */ v(
    $1,
    {
      scope: a,
      orientation: o,
      dir: f,
      loop: n,
      currentTabStopId: p,
      onItemFocus: g.useCallback(
        (E) => b(E),
        [b]
      ),
      onItemShiftTab: g.useCallback(() => _(!0), []),
      onFocusableItemAdd: g.useCallback(
        () => $((E) => E + 1),
        []
      ),
      onFocusableItemRemove: g.useCallback(
        () => $((E) => E - 1),
        []
      ),
      children: /* @__PURE__ */ v(
        _e.div,
        {
          tabIndex: w || S === 0 ? -1 : 0,
          "data-orientation": o,
          ...d,
          ref: m,
          style: { outline: "none", ...e.style },
          onMouseDown: me(e.onMouseDown, () => {
            x.current = !0;
          }),
          onFocus: me(e.onFocus, (E) => {
            const C = !x.current;
            if (E.target === E.currentTarget && C && !w) {
              const j = new CustomEvent(Js, w1);
              if (E.currentTarget.dispatchEvent(j), !j.defaultPrevented) {
                const R = k().filter((U) => U.focusable), H = R.find((U) => U.active), L = R.find((U) => U.id === p), O = [H, L, ...R].filter(
                  Boolean
                ).map((U) => U.ref.current);
                nf(O, u);
              }
            }
            x.current = !1;
          }),
          onBlur: me(e.onBlur, () => _(!1))
        }
      )
    }
  );
}), af = "RovingFocusGroupItem", of = g.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: a,
      focusable: o = !0,
      active: n = !1,
      tabStopId: r,
      children: i,
      ...s
    } = e, l = Ya(), c = r || l, u = S1(af, a), d = u.currentTabStopId === c, h = Qm(a), { onFocusableItemAdd: m, onFocusableItemRemove: f, currentTabStopId: p } = u;
    return g.useEffect(() => {
      if (o)
        return m(), () => f();
    }, [o, m, f]), /* @__PURE__ */ v(
      Xl.ItemSlot,
      {
        scope: a,
        id: c,
        focusable: o,
        active: n,
        children: /* @__PURE__ */ v(
          _e.span,
          {
            tabIndex: d ? 0 : -1,
            "data-orientation": u.orientation,
            ...s,
            ref: t,
            onMouseDown: me(e.onMouseDown, (b) => {
              o ? u.onItemFocus(c) : b.preventDefault();
            }),
            onFocus: me(e.onFocus, () => u.onItemFocus(c)),
            onKeyDown: me(e.onKeyDown, (b) => {
              if (b.key === "Tab" && b.shiftKey) {
                u.onItemShiftTab();
                return;
              }
              if (b.target !== b.currentTarget) return;
              const w = O1(b, u.orientation, u.dir);
              if (w !== void 0) {
                if (b.metaKey || b.ctrlKey || b.altKey || b.shiftKey) return;
                b.preventDefault();
                let _ = h().filter((y) => y.focusable).map((y) => y.ref.current);
                if (w === "last") _.reverse();
                else if (w === "prev" || w === "next") {
                  w === "prev" && _.reverse();
                  const y = _.indexOf(b.currentTarget);
                  _ = u.loop ? z1(_, y + 1) : _.slice(y + 1);
                }
                setTimeout(() => nf(_));
              }
            }),
            children: typeof i == "function" ? i({ isCurrentTabStop: d, hasTabStop: p != null }) : i
          }
        )
      }
    );
  }
);
of.displayName = af;
var E1 = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function j1(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function O1(e, t, a) {
  const o = j1(e.key, a);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(o)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(o)))
    return E1[o];
}
function nf(e, t = !1) {
  const a = document.activeElement;
  for (const o of e)
    if (o === a || (o.focus({ preventScroll: t }), document.activeElement !== a)) return;
}
function z1(e, t) {
  return e.map((a, o) => e[(t + o) % e.length]);
}
var A1 = tf, P1 = of;
function D1(e) {
  const t = g.useRef({ value: e, previous: e });
  return g.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function N1(e) {
  const [t, a] = Pe(!1), o = Le(() => a(!0), []), n = Le(() => a(!1), []), r = Le(() => a((i) => !i), []);
  return { value: t, setValue: a, setTrue: o, setFalse: n, toggle: r };
}
function R1() {
  const [e, t] = Pe({
    width: typeof window > "u" ? void 0 : window.innerWidth,
    height: typeof window > "u" ? void 0 : window.innerHeight
  });
  return Ce(() => {
    function a() {
      t({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    return window.addEventListener("resize", a), a(), () => window.removeEventListener("resize", a);
  }, []), e;
}
function I1() {
  const { width: e } = R1();
  let t = "desktop";
  return e && e <= Zd.MOBILE ? t = "mobile" : e && e <= Zd.TABLET && (t = "tablet"), {
    currentWidth: e,
    currentDevice: t,
    isMobile: t === "mobile",
    isTablet: t === "tablet",
    isDesktop: t === "desktop",
    isReady: typeof window < "u"
  };
}
function T1(e, t = globalThis?.document) {
  const a = qe(e);
  g.useEffect(() => {
    const o = (n) => {
      n.key === "Escape" && a(n);
    };
    return t.addEventListener("keydown", o, { capture: !0 }), () => t.removeEventListener("keydown", o, { capture: !0 });
  }, [a, t]);
}
var L1 = "DismissableLayer", Ql = "dismissableLayer.update", M1 = "dismissableLayer.pointerDownOutside", W1 = "dismissableLayer.focusOutside", Xd, rf = g.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), iu = g.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: a = !1,
      onEscapeKeyDown: o,
      onPointerDownOutside: n,
      onFocusOutside: r,
      onInteractOutside: i,
      onDismiss: s,
      ...l
    } = e, c = g.useContext(rf), [u, d] = g.useState(null), h = u?.ownerDocument ?? globalThis?.document, [, m] = g.useState({}), f = We(t, ($) => d($)), p = Array.from(c.layers), [b] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), w = p.indexOf(b), _ = u ? p.indexOf(u) : -1, y = c.layersWithOutsidePointerEventsDisabled.size > 0, k = _ >= w, x = V1(($) => {
      const E = $.target, C = [...c.branches].some((j) => j.contains(E));
      !k || C || (n?.($), i?.($), $.defaultPrevented || s?.());
    }, h), S = U1(($) => {
      const E = $.target;
      [...c.branches].some((C) => C.contains(E)) || (r?.($), i?.($), $.defaultPrevented || s?.());
    }, h);
    return T1(($) => {
      _ === c.layers.size - 1 && (o?.($), !$.defaultPrevented && s && ($.preventDefault(), s()));
    }, h), g.useEffect(() => {
      if (u)
        return a && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (Xd = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(u)), c.layers.add(u), Qd(), () => {
          a && c.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = Xd);
        };
    }, [u, h, a, c]), g.useEffect(() => () => {
      u && (c.layers.delete(u), c.layersWithOutsidePointerEventsDisabled.delete(u), Qd());
    }, [u, c]), g.useEffect(() => {
      const $ = () => m({});
      return document.addEventListener(Ql, $), () => document.removeEventListener(Ql, $);
    }, []), /* @__PURE__ */ v(
      _e.div,
      {
        ...l,
        ref: f,
        style: {
          pointerEvents: y ? k ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: me(e.onFocusCapture, S.onFocusCapture),
        onBlurCapture: me(e.onBlurCapture, S.onBlurCapture),
        onPointerDownCapture: me(
          e.onPointerDownCapture,
          x.onPointerDownCapture
        )
      }
    );
  }
);
iu.displayName = L1;
var B1 = "DismissableLayerBranch", F1 = g.forwardRef((e, t) => {
  const a = g.useContext(rf), o = g.useRef(null), n = We(t, o);
  return g.useEffect(() => {
    const r = o.current;
    if (r)
      return a.branches.add(r), () => {
        a.branches.delete(r);
      };
  }, [a.branches]), /* @__PURE__ */ v(_e.div, { ...e, ref: n });
});
F1.displayName = B1;
function V1(e, t = globalThis?.document) {
  const a = qe(e), o = g.useRef(!1), n = g.useRef(() => {
  });
  return g.useEffect(() => {
    const r = (s) => {
      if (s.target && !o.current) {
        let l = function() {
          sf(
            M1,
            a,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", n.current), n.current = l, t.addEventListener("click", n.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", n.current);
      o.current = !1;
    }, i = window.setTimeout(() => {
      t.addEventListener("pointerdown", r);
    }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", r), t.removeEventListener("click", n.current);
    };
  }, [t, a]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function U1(e, t = globalThis?.document) {
  const a = qe(e), o = g.useRef(!1);
  return g.useEffect(() => {
    const n = (r) => {
      r.target && !o.current && sf(W1, a, { originalEvent: r }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", n), () => t.removeEventListener("focusin", n);
  }, [t, a]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function Qd() {
  const e = new CustomEvent(Ql);
  document.dispatchEvent(e);
}
function sf(e, t, a, { discrete: o }) {
  const n = a.originalEvent.target, r = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: a });
  t && n.addEventListener(e, t, { once: !0 }), o ? Yl(n, r) : n.dispatchEvent(r);
}
var q1 = "Portal", lf = g.forwardRef((e, t) => {
  const { container: a, ...o } = e, [n, r] = g.useState(!1);
  pa(() => r(!0), []);
  const i = a || n && globalThis?.document?.body;
  return i ? os.createPortal(/* @__PURE__ */ v(_e.div, { ...o, ref: t }), i) : null;
});
lf.displayName = q1;
var Ht = function() {
  return Ht = Object.assign || function(e) {
    for (var t, a = 1, o = arguments.length; a < o; a++) {
      t = arguments[a];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, Ht.apply(this, arguments);
};
function cf(e, t) {
  var a = {};
  for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (a[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, o = Object.getOwnPropertySymbols(e); n < o.length; n++)
      t.indexOf(o[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[n]) && (a[o[n]] = e[o[n]]);
  return a;
}
function H1(e, t, a) {
  for (var o = 0, n = t.length, r; o < n; o++)
    (r || !(o in t)) && (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
  return e.concat(r || Array.prototype.slice.call(t));
}
var Zs = "focusScope.autoFocusOnMount", Ys = "focusScope.autoFocusOnUnmount", eg = { bubbles: !1, cancelable: !0 }, G1 = "FocusScope", uf = g.forwardRef((e, t) => {
  const {
    loop: a = !1,
    trapped: o = !1,
    onMountAutoFocus: n,
    onUnmountAutoFocus: r,
    ...i
  } = e, [s, l] = g.useState(null), c = qe(n), u = qe(r), d = g.useRef(null), h = We(t, (p) => l(p)), m = g.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  g.useEffect(() => {
    if (o) {
      let p = function(y) {
        if (m.paused || !s) return;
        const k = y.target;
        s.contains(k) ? d.current = k : Ca(d.current, { select: !0 });
      }, b = function(y) {
        if (m.paused || !s) return;
        const k = y.relatedTarget;
        k !== null && (s.contains(k) || Ca(d.current, { select: !0 }));
      }, w = function(y) {
        if (document.activeElement === document.body)
          for (const k of y)
            k.removedNodes.length > 0 && Ca(s);
      };
      document.addEventListener("focusin", p), document.addEventListener("focusout", b);
      const _ = new MutationObserver(w);
      return s && _.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", p), document.removeEventListener("focusout", b), _.disconnect();
      };
    }
  }, [o, s, m.paused]), g.useEffect(() => {
    if (s) {
      ag.add(m);
      const p = document.activeElement;
      if (!s.contains(p)) {
        const b = new CustomEvent(Zs, eg);
        s.addEventListener(Zs, c), s.dispatchEvent(b), b.defaultPrevented || (K1(Q1(df(s)), { select: !0 }), document.activeElement === p && Ca(s));
      }
      return () => {
        s.removeEventListener(Zs, c), setTimeout(() => {
          const b = new CustomEvent(Ys, eg);
          s.addEventListener(Ys, u), s.dispatchEvent(b), b.defaultPrevented || Ca(p ?? document.body, { select: !0 }), s.removeEventListener(Ys, u), ag.remove(m);
        }, 0);
      };
    }
  }, [s, c, u, m]);
  const f = g.useCallback(
    (p) => {
      if (!a && !o || m.paused) return;
      const b = p.key === "Tab" && !p.altKey && !p.ctrlKey && !p.metaKey, w = document.activeElement;
      if (b && w) {
        const _ = p.currentTarget, [y, k] = J1(_);
        y && k ? !p.shiftKey && w === k ? (p.preventDefault(), a && Ca(y, { select: !0 })) : p.shiftKey && w === y && (p.preventDefault(), a && Ca(k, { select: !0 })) : w === _ && p.preventDefault();
      }
    },
    [a, o, m.paused]
  );
  return /* @__PURE__ */ v(_e.div, { tabIndex: -1, ...i, ref: h, onKeyDown: f });
});
uf.displayName = G1;
function K1(e, { select: t = !1 } = {}) {
  const a = document.activeElement;
  for (const o of e)
    if (Ca(o, { select: t }), document.activeElement !== a) return;
}
function J1(e) {
  const t = df(e), a = tg(t, e), o = tg(t.reverse(), e);
  return [a, o];
}
function df(e) {
  const t = [], a = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const n = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || n ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; a.nextNode(); ) t.push(a.currentNode);
  return t;
}
function tg(e, t) {
  for (const a of e)
    if (!Z1(a, { upTo: t })) return a;
}
function Z1(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function Y1(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Ca(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const a = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== a && Y1(e) && t && e.select();
  }
}
var ag = X1();
function X1() {
  let e = [];
  return {
    add(t) {
      const a = e[0];
      t !== a && a?.pause(), e = og(e, t), e.unshift(t);
    },
    remove(t) {
      e = og(e, t), e[0]?.resume();
    }
  };
}
function og(e, t) {
  const a = [...e], o = a.indexOf(t);
  return o !== -1 && a.splice(o, 1), a;
}
function Q1(e) {
  return e.filter((t) => t.tagName !== "A");
}
var Xs = 0;
function e$() {
  g.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? ng()), document.body.insertAdjacentElement("beforeend", e[1] ?? ng()), Xs++, () => {
      Xs === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Xs--;
    };
  }, []);
}
function ng() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Jr = "right-scroll-bar-position", Zr = "width-before-scroll-bar", t$ = "with-scroll-bars-hidden", a$ = "--removed-body-scroll-bar-size";
function Qs(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function o$(e, t) {
  var a = Pe(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return a.value;
        },
        set current(o) {
          var n = a.value;
          n !== o && (a.value = o, a.callback(o, n));
        }
      }
    };
  })[0];
  return a.callback = t, a.facade;
}
var n$ = typeof window < "u" ? g.useLayoutEffect : g.useEffect, rg = /* @__PURE__ */ new WeakMap();
function r$(e, t) {
  var a = o$(null, function(o) {
    return e.forEach(function(n) {
      return Qs(n, o);
    });
  });
  return n$(function() {
    var o = rg.get(a);
    if (o) {
      var n = new Set(o), r = new Set(e), i = a.current;
      n.forEach(function(s) {
        r.has(s) || Qs(s, null);
      }), r.forEach(function(s) {
        n.has(s) || Qs(s, i);
      });
    }
    rg.set(a, e);
  }, [e]), a;
}
function i$(e) {
  return e;
}
function s$(e, t) {
  t === void 0 && (t = i$);
  var a = [], o = !1, n = {
    read: function() {
      if (o)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return a.length ? a[a.length - 1] : e;
    },
    useMedium: function(r) {
      var i = t(r, o);
      return a.push(i), function() {
        a = a.filter(function(s) {
          return s !== i;
        });
      };
    },
    assignSyncMedium: function(r) {
      for (o = !0; a.length; ) {
        var i = a;
        a = [], i.forEach(r);
      }
      a = {
        push: function(s) {
          return r(s);
        },
        filter: function() {
          return a;
        }
      };
    },
    assignMedium: function(r) {
      o = !0;
      var i = [];
      if (a.length) {
        var s = a;
        a = [], s.forEach(r), i = a;
      }
      var l = function() {
        var u = i;
        i = [], u.forEach(r);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), a = {
        push: function(u) {
          i.push(u), c();
        },
        filter: function(u) {
          return i = i.filter(u), a;
        }
      };
    }
  };
  return n;
}
function l$(e) {
  e === void 0 && (e = {});
  var t = s$(null);
  return t.options = Ht({ async: !0, ssr: !1 }, e), t;
}
var gf = function(e) {
  var t = e.sideCar, a = cf(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var o = t.read();
  if (!o)
    throw new Error("Sidecar medium not found");
  return g.createElement(o, Ht({}, a));
};
gf.isSideCarExport = !0;
function c$(e, t) {
  return e.useMedium(t), gf;
}
var hf = l$(), el = function() {
}, rs = g.forwardRef(function(e, t) {
  var a = g.useRef(null), o = g.useState({
    onScrollCapture: el,
    onWheelCapture: el,
    onTouchMoveCapture: el
  }), n = o[0], r = o[1], i = e.forwardProps, s = e.children, l = e.className, c = e.removeScrollBar, u = e.enabled, d = e.shards, h = e.sideCar, m = e.noIsolation, f = e.inert, p = e.allowPinchZoom, b = e.as, w = b === void 0 ? "div" : b, _ = e.gapMode, y = cf(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), k = h, x = r$([a, t]), S = Ht(Ht({}, y), n);
  return g.createElement(
    g.Fragment,
    null,
    u && g.createElement(k, { sideCar: hf, removeScrollBar: c, shards: d, noIsolation: m, inert: f, setCallbacks: r, allowPinchZoom: !!p, lockRef: a, gapMode: _ }),
    i ? g.cloneElement(g.Children.only(s), Ht(Ht({}, S), { ref: x })) : g.createElement(w, Ht({}, S, { className: l, ref: x }), s)
  );
});
rs.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
rs.classNames = {
  fullWidth: Zr,
  zeroRight: Jr
};
var u$ = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function d$() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = u$();
  return t && e.setAttribute("nonce", t), e;
}
function g$(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function h$(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var p$ = function() {
  var e = 0, t = null;
  return {
    add: function(a) {
      e == 0 && (t = d$()) && (g$(t, a), h$(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, m$ = function() {
  var e = p$();
  return function(t, a) {
    g.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && a]);
  };
}, pf = function() {
  var e = m$(), t = function(a) {
    var o = a.styles, n = a.dynamic;
    return e(o, n), null;
  };
  return t;
}, f$ = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, tl = function(e) {
  return parseInt(e || "", 10) || 0;
}, b$ = function(e) {
  var t = window.getComputedStyle(document.body), a = t[e === "padding" ? "paddingLeft" : "marginLeft"], o = t[e === "padding" ? "paddingTop" : "marginTop"], n = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [tl(a), tl(o), tl(n)];
}, _$ = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return f$;
  var t = b$(e), a = document.documentElement.clientWidth, o = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, o - a + t[2] - t[0])
  };
}, v$ = pf(), Wo = "data-scroll-locked", y$ = function(e, t, a, o) {
  var n = e.left, r = e.top, i = e.right, s = e.gap;
  return a === void 0 && (a = "margin"), `
  .`.concat(t$, ` {
   overflow: hidden `).concat(o, `;
   padding-right: `).concat(s, "px ").concat(o, `;
  }
  body[`).concat(Wo, `] {
    overflow: hidden `).concat(o, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(o, ";"),
    a === "margin" && `
    padding-left: `.concat(n, `px;
    padding-top: `).concat(r, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(o, `;
    `),
    a === "padding" && "padding-right: ".concat(s, "px ").concat(o, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Jr, ` {
    right: `).concat(s, "px ").concat(o, `;
  }
  
  .`).concat(Zr, ` {
    margin-right: `).concat(s, "px ").concat(o, `;
  }
  
  .`).concat(Jr, " .").concat(Jr, ` {
    right: 0 `).concat(o, `;
  }
  
  .`).concat(Zr, " .").concat(Zr, ` {
    margin-right: 0 `).concat(o, `;
  }
  
  body[`).concat(Wo, `] {
    `).concat(a$, ": ").concat(s, `px;
  }
`);
}, ig = function() {
  var e = parseInt(document.body.getAttribute(Wo) || "0", 10);
  return isFinite(e) ? e : 0;
}, w$ = function() {
  g.useEffect(function() {
    return document.body.setAttribute(Wo, (ig() + 1).toString()), function() {
      var e = ig() - 1;
      e <= 0 ? document.body.removeAttribute(Wo) : document.body.setAttribute(Wo, e.toString());
    };
  }, []);
}, k$ = function(e) {
  var t = e.noRelative, a = e.noImportant, o = e.gapMode, n = o === void 0 ? "margin" : o;
  w$();
  var r = g.useMemo(function() {
    return _$(n);
  }, [n]);
  return g.createElement(v$, { styles: y$(r, !t, n, a ? "" : "!important") });
}, ec = !1;
if (typeof window < "u")
  try {
    var mr = Object.defineProperty({}, "passive", {
      get: function() {
        return ec = !0, !0;
      }
    });
    window.addEventListener("test", mr, mr), window.removeEventListener("test", mr, mr);
  } catch {
    ec = !1;
  }
var ko = ec ? { passive: !1 } : !1, x$ = function(e) {
  return e.tagName === "TEXTAREA";
}, mf = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var a = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    a[t] !== "hidden" && // contains scroll inside self
    !(a.overflowY === a.overflowX && !x$(e) && a[t] === "visible")
  );
}, $$ = function(e) {
  return mf(e, "overflowY");
}, S$ = function(e) {
  return mf(e, "overflowX");
}, sg = function(e, t) {
  var a = t.ownerDocument, o = t;
  do {
    typeof ShadowRoot < "u" && o instanceof ShadowRoot && (o = o.host);
    var n = ff(e, o);
    if (n) {
      var r = bf(e, o), i = r[1], s = r[2];
      if (i > s)
        return !0;
    }
    o = o.parentNode;
  } while (o && o !== a.body);
  return !1;
}, C$ = function(e) {
  var t = e.scrollTop, a = e.scrollHeight, o = e.clientHeight;
  return [
    t,
    a,
    o
  ];
}, E$ = function(e) {
  var t = e.scrollLeft, a = e.scrollWidth, o = e.clientWidth;
  return [
    t,
    a,
    o
  ];
}, ff = function(e, t) {
  return e === "v" ? $$(t) : S$(t);
}, bf = function(e, t) {
  return e === "v" ? C$(t) : E$(t);
}, j$ = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, O$ = function(e, t, a, o, n) {
  var r = j$(e, window.getComputedStyle(t).direction), i = r * o, s = a.target, l = t.contains(s), c = !1, u = i > 0, d = 0, h = 0;
  do {
    var m = bf(e, s), f = m[0], p = m[1], b = m[2], w = p - b - r * f;
    (f || w) && ff(e, s) && (d += w, h += f), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (u && Math.abs(d) < 1 || !u && Math.abs(h) < 1) && (c = !0), c;
}, fr = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, lg = function(e) {
  return [e.deltaX, e.deltaY];
}, cg = function(e) {
  return e && "current" in e ? e.current : e;
}, z$ = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, A$ = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, P$ = 0, xo = [];
function D$(e) {
  var t = g.useRef([]), a = g.useRef([0, 0]), o = g.useRef(), n = g.useState(P$++)[0], r = g.useState(pf)[0], i = g.useRef(e);
  g.useEffect(function() {
    i.current = e;
  }, [e]), g.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(n));
      var p = H1([e.lockRef.current], (e.shards || []).map(cg)).filter(Boolean);
      return p.forEach(function(b) {
        return b.classList.add("allow-interactivity-".concat(n));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(n)), p.forEach(function(b) {
          return b.classList.remove("allow-interactivity-".concat(n));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = g.useCallback(function(p, b) {
    if ("touches" in p && p.touches.length === 2 || p.type === "wheel" && p.ctrlKey)
      return !i.current.allowPinchZoom;
    var w = fr(p), _ = a.current, y = "deltaX" in p ? p.deltaX : _[0] - w[0], k = "deltaY" in p ? p.deltaY : _[1] - w[1], x, S = p.target, $ = Math.abs(y) > Math.abs(k) ? "h" : "v";
    if ("touches" in p && $ === "h" && S.type === "range")
      return !1;
    var E = sg($, S);
    if (!E)
      return !0;
    if (E ? x = $ : (x = $ === "v" ? "h" : "v", E = sg($, S)), !E)
      return !1;
    if (!o.current && "changedTouches" in p && (y || k) && (o.current = x), !x)
      return !0;
    var C = o.current || x;
    return O$(C, b, p, C === "h" ? y : k);
  }, []), l = g.useCallback(function(p) {
    var b = p;
    if (!(!xo.length || xo[xo.length - 1] !== r)) {
      var w = "deltaY" in b ? lg(b) : fr(b), _ = t.current.filter(function(x) {
        return x.name === b.type && (x.target === b.target || b.target === x.shadowParent) && z$(x.delta, w);
      })[0];
      if (_ && _.should) {
        b.cancelable && b.preventDefault();
        return;
      }
      if (!_) {
        var y = (i.current.shards || []).map(cg).filter(Boolean).filter(function(x) {
          return x.contains(b.target);
        }), k = y.length > 0 ? s(b, y[0]) : !i.current.noIsolation;
        k && b.cancelable && b.preventDefault();
      }
    }
  }, []), c = g.useCallback(function(p, b, w, _) {
    var y = { name: p, delta: b, target: w, should: _, shadowParent: N$(w) };
    t.current.push(y), setTimeout(function() {
      t.current = t.current.filter(function(k) {
        return k !== y;
      });
    }, 1);
  }, []), u = g.useCallback(function(p) {
    a.current = fr(p), o.current = void 0;
  }, []), d = g.useCallback(function(p) {
    c(p.type, lg(p), p.target, s(p, e.lockRef.current));
  }, []), h = g.useCallback(function(p) {
    c(p.type, fr(p), p.target, s(p, e.lockRef.current));
  }, []);
  g.useEffect(function() {
    return xo.push(r), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", l, ko), document.addEventListener("touchmove", l, ko), document.addEventListener("touchstart", u, ko), function() {
      xo = xo.filter(function(p) {
        return p !== r;
      }), document.removeEventListener("wheel", l, ko), document.removeEventListener("touchmove", l, ko), document.removeEventListener("touchstart", u, ko);
    };
  }, []);
  var m = e.removeScrollBar, f = e.inert;
  return g.createElement(
    g.Fragment,
    null,
    f ? g.createElement(r, { styles: A$(n) }) : null,
    m ? g.createElement(k$, { gapMode: e.gapMode }) : null
  );
}
function N$(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const R$ = c$(hf, D$);
var _f = g.forwardRef(function(e, t) {
  return g.createElement(rs, Ht({}, e, { ref: t, sideCar: R$ }));
});
_f.classNames = rs.classNames;
var I$ = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, $o = /* @__PURE__ */ new WeakMap(), br = /* @__PURE__ */ new WeakMap(), _r = {}, al = 0, vf = function(e) {
  return e && (e.host || vf(e.parentNode));
}, T$ = function(e, t) {
  return t.map(function(a) {
    if (e.contains(a))
      return a;
    var o = vf(a);
    return o && e.contains(o) ? o : (console.error("aria-hidden", a, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(a) {
    return !!a;
  });
}, L$ = function(e, t, a, o) {
  var n = T$(t, Array.isArray(e) ? e : [e]);
  _r[a] || (_r[a] = /* @__PURE__ */ new WeakMap());
  var r = _r[a], i = [], s = /* @__PURE__ */ new Set(), l = new Set(n), c = function(d) {
    !d || s.has(d) || (s.add(d), c(d.parentNode));
  };
  n.forEach(c);
  var u = function(d) {
    !d || l.has(d) || Array.prototype.forEach.call(d.children, function(h) {
      if (s.has(h))
        u(h);
      else
        try {
          var m = h.getAttribute(o), f = m !== null && m !== "false", p = ($o.get(h) || 0) + 1, b = (r.get(h) || 0) + 1;
          $o.set(h, p), r.set(h, b), i.push(h), p === 1 && f && br.set(h, !0), b === 1 && h.setAttribute(a, "true"), f || h.setAttribute(o, "true");
        } catch (w) {
          console.error("aria-hidden: cannot operate on ", h, w);
        }
    });
  };
  return u(t), s.clear(), al++, function() {
    i.forEach(function(d) {
      var h = $o.get(d) - 1, m = r.get(d) - 1;
      $o.set(d, h), r.set(d, m), h || (br.has(d) || d.removeAttribute(o), br.delete(d)), m || d.removeAttribute(a);
    }), al--, al || ($o = /* @__PURE__ */ new WeakMap(), $o = /* @__PURE__ */ new WeakMap(), br = /* @__PURE__ */ new WeakMap(), _r = {});
  };
}, M$ = function(e, t, a) {
  a === void 0 && (a = "data-aria-hidden");
  var o = Array.from(Array.isArray(e) ? e : [e]), n = I$(e);
  return n ? (o.push.apply(o, Array.from(n.querySelectorAll("[aria-live]"))), L$(o, n, a, "aria-hidden")) : function() {
    return null;
  };
}, is = "Dialog", [yf, nrt] = fo(is), [W$, Mt] = yf(is), wf = (e) => {
  const {
    __scopeDialog: t,
    children: a,
    open: o,
    defaultOpen: n,
    onOpenChange: r,
    modal: i = !0
  } = e, s = g.useRef(null), l = g.useRef(null), [c, u] = Jn({
    prop: o,
    defaultProp: n ?? !1,
    onChange: r,
    caller: is
  });
  return /* @__PURE__ */ v(
    W$,
    {
      scope: t,
      triggerRef: s,
      contentRef: l,
      contentId: Ya(),
      titleId: Ya(),
      descriptionId: Ya(),
      open: c,
      onOpenChange: u,
      onOpenToggle: g.useCallback(() => u((d) => !d), [u]),
      modal: i,
      children: a
    }
  );
};
wf.displayName = is;
var kf = "DialogTrigger", B$ = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, ...o } = e, n = Mt(kf, a), r = We(t, n.triggerRef);
    return /* @__PURE__ */ v(
      _e.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": n.open,
        "aria-controls": n.contentId,
        "data-state": cu(n.open),
        ...o,
        ref: r,
        onClick: me(e.onClick, n.onOpenToggle)
      }
    );
  }
);
B$.displayName = kf;
var su = "DialogPortal", [F$, xf] = yf(su, {
  forceMount: void 0
}), $f = (e) => {
  const { __scopeDialog: t, forceMount: a, children: o, container: n } = e, r = Mt(su, t);
  return /* @__PURE__ */ v(F$, { scope: t, forceMount: a, children: g.Children.map(o, (i) => /* @__PURE__ */ v(xt, { present: a || r.open, children: /* @__PURE__ */ v(lf, { asChild: !0, container: n, children: i }) })) });
};
$f.displayName = su;
var bi = "DialogOverlay", Sf = g.forwardRef(
  (e, t) => {
    const a = xf(bi, e.__scopeDialog), { forceMount: o = a.forceMount, ...n } = e, r = Mt(bi, e.__scopeDialog);
    return r.modal ? /* @__PURE__ */ v(xt, { present: o || r.open, children: /* @__PURE__ */ v(U$, { ...n, ref: t }) }) : null;
  }
);
Sf.displayName = bi;
var V$ = /* @__PURE__ */ fi("DialogOverlay.RemoveScroll"), U$ = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, ...o } = e, n = Mt(bi, a);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ v(_f, { as: V$, allowPinchZoom: !0, shards: [n.contentRef], children: /* @__PURE__ */ v(
        _e.div,
        {
          "data-state": cu(n.open),
          ...o,
          ref: t,
          style: { pointerEvents: "auto", ...o.style }
        }
      ) })
    );
  }
), eo = "DialogContent", Cf = g.forwardRef(
  (e, t) => {
    const a = xf(eo, e.__scopeDialog), { forceMount: o = a.forceMount, ...n } = e, r = Mt(eo, e.__scopeDialog);
    return /* @__PURE__ */ v(xt, { present: o || r.open, children: r.modal ? /* @__PURE__ */ v(q$, { ...n, ref: t }) : /* @__PURE__ */ v(H$, { ...n, ref: t }) });
  }
);
Cf.displayName = eo;
var q$ = g.forwardRef(
  (e, t) => {
    const a = Mt(eo, e.__scopeDialog), o = g.useRef(null), n = We(t, a.contentRef, o);
    return g.useEffect(() => {
      const r = o.current;
      if (r) return M$(r);
    }, []), /* @__PURE__ */ v(
      Ef,
      {
        ...e,
        ref: n,
        trapFocus: a.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: me(e.onCloseAutoFocus, (r) => {
          r.preventDefault(), a.triggerRef.current?.focus();
        }),
        onPointerDownOutside: me(e.onPointerDownOutside, (r) => {
          const i = r.detail.originalEvent, s = i.button === 0 && i.ctrlKey === !0;
          (i.button === 2 || s) && r.preventDefault();
        }),
        onFocusOutside: me(
          e.onFocusOutside,
          (r) => r.preventDefault()
        )
      }
    );
  }
), H$ = g.forwardRef(
  (e, t) => {
    const a = Mt(eo, e.__scopeDialog), o = g.useRef(!1), n = g.useRef(!1);
    return /* @__PURE__ */ v(
      Ef,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (r) => {
          e.onCloseAutoFocus?.(r), r.defaultPrevented || (o.current || a.triggerRef.current?.focus(), r.preventDefault()), o.current = !1, n.current = !1;
        },
        onInteractOutside: (r) => {
          e.onInteractOutside?.(r), r.defaultPrevented || (o.current = !0, r.detail.originalEvent.type === "pointerdown" && (n.current = !0));
          const i = r.target;
          a.triggerRef.current?.contains(i) && r.preventDefault(), r.detail.originalEvent.type === "focusin" && n.current && r.preventDefault();
        }
      }
    );
  }
), Ef = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, trapFocus: o, onOpenAutoFocus: n, onCloseAutoFocus: r, ...i } = e, s = Mt(eo, a), l = g.useRef(null), c = We(t, l);
    return e$(), /* @__PURE__ */ T(De, { children: [
      /* @__PURE__ */ v(
        uf,
        {
          asChild: !0,
          loop: !0,
          trapped: o,
          onMountAutoFocus: n,
          onUnmountAutoFocus: r,
          children: /* @__PURE__ */ v(
            iu,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": cu(s.open),
              ...i,
              ref: c,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ T(De, { children: [
        /* @__PURE__ */ v(J$, { titleId: s.titleId }),
        /* @__PURE__ */ v(Y$, { contentRef: l, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), lu = "DialogTitle", G$ = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, ...o } = e, n = Mt(lu, a);
    return /* @__PURE__ */ v(_e.h2, { id: n.titleId, ...o, ref: t });
  }
);
G$.displayName = lu;
var jf = "DialogDescription", K$ = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, ...o } = e, n = Mt(jf, a);
    return /* @__PURE__ */ v(_e.p, { id: n.descriptionId, ...o, ref: t });
  }
);
K$.displayName = jf;
var Of = "DialogClose", zf = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, ...o } = e, n = Mt(Of, a);
    return /* @__PURE__ */ v(
      _e.button,
      {
        type: "button",
        ...o,
        ref: t,
        onClick: me(e.onClick, () => n.onOpenChange(!1))
      }
    );
  }
);
zf.displayName = Of;
function cu(e) {
  return e ? "open" : "closed";
}
var Af = "DialogTitleWarning", [rrt, Pf] = s1(Af, {
  contentName: eo,
  titleName: lu,
  docsSlug: "dialog"
}), J$ = ({ titleId: e }) => {
  const t = Pf(Af), a = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return g.useEffect(() => {
    e && (document.getElementById(e) || console.error(a));
  }, [a, e]), null;
}, Z$ = "DialogDescriptionWarning", Y$ = ({ contentRef: e, descriptionId: t }) => {
  const a = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Pf(Z$).contentName}}.`;
  return g.useEffect(() => {
    const o = e.current?.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(a));
  }, [a, e, t]), null;
}, X$ = wf, Q$ = $f, eS = Sf, tS = Cf, aS = zf;
function oS(e, [t, a]) {
  return Math.min(a, Math.max(t, e));
}
function nS(e, t) {
  return g.useReducer((a, o) => t[a][o] ?? a, e);
}
var uu = "ScrollArea", [Df, irt] = fo(uu), [rS, zt] = Df(uu), Nf = g.forwardRef(
  (e, t) => {
    const {
      __scopeScrollArea: a,
      type: o = "hover",
      dir: n,
      scrollHideDelay: r = 600,
      ...i
    } = e, [s, l] = g.useState(null), [c, u] = g.useState(null), [d, h] = g.useState(null), [m, f] = g.useState(null), [p, b] = g.useState(null), [w, _] = g.useState(0), [y, k] = g.useState(0), [x, S] = g.useState(!1), [$, E] = g.useState(!1), C = We(t, (R) => l(R)), j = ns(n);
    return /* @__PURE__ */ v(
      rS,
      {
        scope: a,
        type: o,
        dir: j,
        scrollHideDelay: r,
        scrollArea: s,
        viewport: c,
        onViewportChange: u,
        content: d,
        onContentChange: h,
        scrollbarX: m,
        onScrollbarXChange: f,
        scrollbarXEnabled: x,
        onScrollbarXEnabledChange: S,
        scrollbarY: p,
        onScrollbarYChange: b,
        scrollbarYEnabled: $,
        onScrollbarYEnabledChange: E,
        onCornerWidthChange: _,
        onCornerHeightChange: k,
        children: /* @__PURE__ */ v(
          _e.div,
          {
            dir: j,
            ...i,
            ref: C,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": w + "px",
              "--radix-scroll-area-corner-height": y + "px",
              ...e.style
            }
          }
        )
      }
    );
  }
);
Nf.displayName = uu;
var Rf = "ScrollAreaViewport", If = g.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: a, children: o, nonce: n, ...r } = e, i = zt(Rf, a), s = g.useRef(null), l = We(t, s, i.onViewportChange);
    return /* @__PURE__ */ T(De, { children: [
      /* @__PURE__ */ v(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: n
        }
      ),
      /* @__PURE__ */ v(
        _e.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...r,
          ref: l,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: i.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: i.scrollbarYEnabled ? "scroll" : "hidden",
            ...e.style
          },
          children: /* @__PURE__ */ v("div", { ref: i.onContentChange, style: { minWidth: "100%", display: "table" }, children: o })
        }
      )
    ] });
  }
);
If.displayName = Rf;
var Qt = "ScrollAreaScrollbar", iS = g.forwardRef(
  (e, t) => {
    const { forceMount: a, ...o } = e, n = zt(Qt, e.__scopeScrollArea), { onScrollbarXEnabledChange: r, onScrollbarYEnabledChange: i } = n, s = e.orientation === "horizontal";
    return g.useEffect(() => (s ? r(!0) : i(!0), () => {
      s ? r(!1) : i(!1);
    }), [s, r, i]), n.type === "hover" ? /* @__PURE__ */ v(sS, { ...o, ref: t, forceMount: a }) : n.type === "scroll" ? /* @__PURE__ */ v(lS, { ...o, ref: t, forceMount: a }) : n.type === "auto" ? /* @__PURE__ */ v(Tf, { ...o, ref: t, forceMount: a }) : n.type === "always" ? /* @__PURE__ */ v(du, { ...o, ref: t }) : null;
  }
);
iS.displayName = Qt;
var sS = g.forwardRef((e, t) => {
  const { forceMount: a, ...o } = e, n = zt(Qt, e.__scopeScrollArea), [r, i] = g.useState(!1);
  return g.useEffect(() => {
    const s = n.scrollArea;
    let l = 0;
    if (s) {
      const c = () => {
        window.clearTimeout(l), i(!0);
      }, u = () => {
        l = window.setTimeout(() => i(!1), n.scrollHideDelay);
      };
      return s.addEventListener("pointerenter", c), s.addEventListener("pointerleave", u), () => {
        window.clearTimeout(l), s.removeEventListener("pointerenter", c), s.removeEventListener("pointerleave", u);
      };
    }
  }, [n.scrollArea, n.scrollHideDelay]), /* @__PURE__ */ v(xt, { present: a || r, children: /* @__PURE__ */ v(
    Tf,
    {
      "data-state": r ? "visible" : "hidden",
      ...o,
      ref: t
    }
  ) });
}), lS = g.forwardRef((e, t) => {
  const { forceMount: a, ...o } = e, n = zt(Qt, e.__scopeScrollArea), r = e.orientation === "horizontal", i = ls(() => l("SCROLL_END"), 100), [s, l] = nS("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return g.useEffect(() => {
    if (s === "idle") {
      const c = window.setTimeout(() => l("HIDE"), n.scrollHideDelay);
      return () => window.clearTimeout(c);
    }
  }, [s, n.scrollHideDelay, l]), g.useEffect(() => {
    const c = n.viewport, u = r ? "scrollLeft" : "scrollTop";
    if (c) {
      let d = c[u];
      const h = () => {
        const m = c[u];
        d !== m && (l("SCROLL"), i()), d = m;
      };
      return c.addEventListener("scroll", h), () => c.removeEventListener("scroll", h);
    }
  }, [n.viewport, r, l, i]), /* @__PURE__ */ v(xt, { present: a || s !== "hidden", children: /* @__PURE__ */ v(
    du,
    {
      "data-state": s === "hidden" ? "hidden" : "visible",
      ...o,
      ref: t,
      onPointerEnter: me(e.onPointerEnter, () => l("POINTER_ENTER")),
      onPointerLeave: me(e.onPointerLeave, () => l("POINTER_LEAVE"))
    }
  ) });
}), Tf = g.forwardRef((e, t) => {
  const a = zt(Qt, e.__scopeScrollArea), { forceMount: o, ...n } = e, [r, i] = g.useState(!1), s = e.orientation === "horizontal", l = ls(() => {
    if (a.viewport) {
      const c = a.viewport.offsetWidth < a.viewport.scrollWidth, u = a.viewport.offsetHeight < a.viewport.scrollHeight;
      i(s ? c : u);
    }
  }, 10);
  return Go(a.viewport, l), Go(a.content, l), /* @__PURE__ */ v(xt, { present: o || r, children: /* @__PURE__ */ v(
    du,
    {
      "data-state": r ? "visible" : "hidden",
      ...n,
      ref: t
    }
  ) });
}), du = g.forwardRef((e, t) => {
  const { orientation: a = "vertical", ...o } = e, n = zt(Qt, e.__scopeScrollArea), r = g.useRef(null), i = g.useRef(0), [s, l] = g.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), c = Wf(s.viewport, s.content), u = {
    ...o,
    sizes: s,
    onSizesChange: l,
    hasThumb: c > 0 && c < 1,
    onThumbChange: (h) => r.current = h,
    onThumbPointerUp: () => i.current = 0,
    onThumbPointerDown: (h) => i.current = h
  };
  function d(h, m) {
    return fS(h, i.current, s, m);
  }
  return a === "horizontal" ? /* @__PURE__ */ v(
    cS,
    {
      ...u,
      ref: t,
      onThumbPositionChange: () => {
        if (n.viewport && r.current) {
          const h = n.viewport.scrollLeft, m = ug(h, s, n.dir);
          r.current.style.transform = `translate3d(${m}px, 0, 0)`;
        }
      },
      onWheelScroll: (h) => {
        n.viewport && (n.viewport.scrollLeft = h);
      },
      onDragScroll: (h) => {
        n.viewport && (n.viewport.scrollLeft = d(h, n.dir));
      }
    }
  ) : a === "vertical" ? /* @__PURE__ */ v(
    uS,
    {
      ...u,
      ref: t,
      onThumbPositionChange: () => {
        if (n.viewport && r.current) {
          const h = n.viewport.scrollTop, m = ug(h, s);
          r.current.style.transform = `translate3d(0, ${m}px, 0)`;
        }
      },
      onWheelScroll: (h) => {
        n.viewport && (n.viewport.scrollTop = h);
      },
      onDragScroll: (h) => {
        n.viewport && (n.viewport.scrollTop = d(h));
      }
    }
  ) : null;
}), cS = g.forwardRef((e, t) => {
  const { sizes: a, onSizesChange: o, ...n } = e, r = zt(Qt, e.__scopeScrollArea), [i, s] = g.useState(), l = g.useRef(null), c = We(t, l, r.onScrollbarXChange);
  return g.useEffect(() => {
    l.current && s(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ v(
    Mf,
    {
      "data-orientation": "horizontal",
      ...n,
      ref: c,
      sizes: a,
      style: {
        bottom: 0,
        left: r.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: r.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": ss(a) + "px",
        ...e.style
      },
      onThumbPointerDown: (u) => e.onThumbPointerDown(u.x),
      onDragScroll: (u) => e.onDragScroll(u.x),
      onWheelScroll: (u, d) => {
        if (r.viewport) {
          const h = r.viewport.scrollLeft + u.deltaX;
          e.onWheelScroll(h), Ff(h, d) && u.preventDefault();
        }
      },
      onResize: () => {
        l.current && r.viewport && i && o({
          content: r.viewport.scrollWidth,
          viewport: r.viewport.offsetWidth,
          scrollbar: {
            size: l.current.clientWidth,
            paddingStart: vi(i.paddingLeft),
            paddingEnd: vi(i.paddingRight)
          }
        });
      }
    }
  );
}), uS = g.forwardRef((e, t) => {
  const { sizes: a, onSizesChange: o, ...n } = e, r = zt(Qt, e.__scopeScrollArea), [i, s] = g.useState(), l = g.useRef(null), c = We(t, l, r.onScrollbarYChange);
  return g.useEffect(() => {
    l.current && s(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ v(
    Mf,
    {
      "data-orientation": "vertical",
      ...n,
      ref: c,
      sizes: a,
      style: {
        top: 0,
        right: r.dir === "ltr" ? 0 : void 0,
        left: r.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": ss(a) + "px",
        ...e.style
      },
      onThumbPointerDown: (u) => e.onThumbPointerDown(u.y),
      onDragScroll: (u) => e.onDragScroll(u.y),
      onWheelScroll: (u, d) => {
        if (r.viewport) {
          const h = r.viewport.scrollTop + u.deltaY;
          e.onWheelScroll(h), Ff(h, d) && u.preventDefault();
        }
      },
      onResize: () => {
        l.current && r.viewport && i && o({
          content: r.viewport.scrollHeight,
          viewport: r.viewport.offsetHeight,
          scrollbar: {
            size: l.current.clientHeight,
            paddingStart: vi(i.paddingTop),
            paddingEnd: vi(i.paddingBottom)
          }
        });
      }
    }
  );
}), [dS, Lf] = Df(Qt), Mf = g.forwardRef((e, t) => {
  const {
    __scopeScrollArea: a,
    sizes: o,
    hasThumb: n,
    onThumbChange: r,
    onThumbPointerUp: i,
    onThumbPointerDown: s,
    onThumbPositionChange: l,
    onDragScroll: c,
    onWheelScroll: u,
    onResize: d,
    ...h
  } = e, m = zt(Qt, a), [f, p] = g.useState(null), b = We(t, (C) => p(C)), w = g.useRef(null), _ = g.useRef(""), y = m.viewport, k = o.content - o.viewport, x = qe(u), S = qe(l), $ = ls(d, 10);
  function E(C) {
    if (w.current) {
      const j = C.clientX - w.current.left, R = C.clientY - w.current.top;
      c({ x: j, y: R });
    }
  }
  return g.useEffect(() => {
    const C = (j) => {
      const R = j.target;
      f?.contains(R) && x(j, k);
    };
    return document.addEventListener("wheel", C, { passive: !1 }), () => document.removeEventListener("wheel", C, { passive: !1 });
  }, [y, f, k, x]), g.useEffect(S, [o, S]), Go(f, $), Go(m.content, $), /* @__PURE__ */ v(
    dS,
    {
      scope: a,
      scrollbar: f,
      hasThumb: n,
      onThumbChange: qe(r),
      onThumbPointerUp: qe(i),
      onThumbPositionChange: S,
      onThumbPointerDown: qe(s),
      children: /* @__PURE__ */ v(
        _e.div,
        {
          ...h,
          ref: b,
          style: { position: "absolute", ...h.style },
          onPointerDown: me(e.onPointerDown, (C) => {
            C.button === 0 && (C.target.setPointerCapture(C.pointerId), w.current = f.getBoundingClientRect(), _.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", m.viewport && (m.viewport.style.scrollBehavior = "auto"), E(C));
          }),
          onPointerMove: me(e.onPointerMove, E),
          onPointerUp: me(e.onPointerUp, (C) => {
            const j = C.target;
            j.hasPointerCapture(C.pointerId) && j.releasePointerCapture(C.pointerId), document.body.style.webkitUserSelect = _.current, m.viewport && (m.viewport.style.scrollBehavior = ""), w.current = null;
          })
        }
      )
    }
  );
}), _i = "ScrollAreaThumb", gS = g.forwardRef(
  (e, t) => {
    const { forceMount: a, ...o } = e, n = Lf(_i, e.__scopeScrollArea);
    return /* @__PURE__ */ v(xt, { present: a || n.hasThumb, children: /* @__PURE__ */ v(hS, { ref: t, ...o }) });
  }
), hS = g.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: a, style: o, ...n } = e, r = zt(_i, a), i = Lf(_i, a), { onThumbPositionChange: s } = i, l = We(
      t,
      (d) => i.onThumbChange(d)
    ), c = g.useRef(void 0), u = ls(() => {
      c.current && (c.current(), c.current = void 0);
    }, 100);
    return g.useEffect(() => {
      const d = r.viewport;
      if (d) {
        const h = () => {
          if (u(), !c.current) {
            const m = bS(d, s);
            c.current = m, s();
          }
        };
        return s(), d.addEventListener("scroll", h), () => d.removeEventListener("scroll", h);
      }
    }, [r.viewport, u, s]), /* @__PURE__ */ v(
      _e.div,
      {
        "data-state": i.hasThumb ? "visible" : "hidden",
        ...n,
        ref: l,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...o
        },
        onPointerDownCapture: me(e.onPointerDownCapture, (d) => {
          const h = d.target.getBoundingClientRect(), m = d.clientX - h.left, f = d.clientY - h.top;
          i.onThumbPointerDown({ x: m, y: f });
        }),
        onPointerUp: me(e.onPointerUp, i.onThumbPointerUp)
      }
    );
  }
);
gS.displayName = _i;
var gu = "ScrollAreaCorner", pS = g.forwardRef(
  (e, t) => {
    const a = zt(gu, e.__scopeScrollArea), o = !!(a.scrollbarX && a.scrollbarY);
    return a.type !== "scroll" && o ? /* @__PURE__ */ v(mS, { ...e, ref: t }) : null;
  }
);
pS.displayName = gu;
var mS = g.forwardRef((e, t) => {
  const { __scopeScrollArea: a, ...o } = e, n = zt(gu, a), [r, i] = g.useState(0), [s, l] = g.useState(0), c = !!(r && s);
  return Go(n.scrollbarX, () => {
    const u = n.scrollbarX?.offsetHeight || 0;
    n.onCornerHeightChange(u), l(u);
  }), Go(n.scrollbarY, () => {
    const u = n.scrollbarY?.offsetWidth || 0;
    n.onCornerWidthChange(u), i(u);
  }), c ? /* @__PURE__ */ v(
    _e.div,
    {
      ...o,
      ref: t,
      style: {
        width: r,
        height: s,
        position: "absolute",
        right: n.dir === "ltr" ? 0 : void 0,
        left: n.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...e.style
      }
    }
  ) : null;
});
function vi(e) {
  return e ? parseInt(e, 10) : 0;
}
function Wf(e, t) {
  const a = e / t;
  return isNaN(a) ? 0 : a;
}
function ss(e) {
  const t = Wf(e.viewport, e.content), a = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, o = (e.scrollbar.size - a) * t;
  return Math.max(o, 18);
}
function fS(e, t, a, o = "ltr") {
  const n = ss(a), r = n / 2, i = t || r, s = n - i, l = a.scrollbar.paddingStart + i, c = a.scrollbar.size - a.scrollbar.paddingEnd - s, u = a.content - a.viewport, d = o === "ltr" ? [0, u] : [u * -1, 0];
  return Bf([l, c], d)(e);
}
function ug(e, t, a = "ltr") {
  const o = ss(t), n = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, r = t.scrollbar.size - n, i = t.content - t.viewport, s = r - o, l = a === "ltr" ? [0, i] : [i * -1, 0], c = oS(e, l);
  return Bf([0, i], [0, s])(c);
}
function Bf(e, t) {
  return (a) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const o = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + o * (a - e[0]);
  };
}
function Ff(e, t) {
  return e > 0 && e < t;
}
var bS = (e, t = () => {
}) => {
  let a = { left: e.scrollLeft, top: e.scrollTop }, o = 0;
  return function n() {
    const r = { left: e.scrollLeft, top: e.scrollTop }, i = a.left !== r.left, s = a.top !== r.top;
    (i || s) && t(), a = r, o = window.requestAnimationFrame(n);
  }(), () => window.cancelAnimationFrame(o);
};
function ls(e, t) {
  const a = qe(e), o = g.useRef(0);
  return g.useEffect(() => () => window.clearTimeout(o.current), []), g.useCallback(() => {
    window.clearTimeout(o.current), o.current = window.setTimeout(a, t);
  }, [a, t]);
}
function Go(e, t) {
  const a = qe(t);
  pa(() => {
    let o = 0;
    if (e) {
      const n = new ResizeObserver(() => {
        cancelAnimationFrame(o), o = window.requestAnimationFrame(a);
      });
      return n.observe(e), () => {
        window.cancelAnimationFrame(o), n.unobserve(e);
      };
    }
  }, [e, a]);
}
var _S = Nf, vS = If, yS = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), wS = "VisuallyHidden", Vf = g.forwardRef(
  (e, t) => /* @__PURE__ */ v(
    _e.span,
    {
      ...e,
      ref: t,
      style: { ...yS, ...e.style }
    }
  )
);
Vf.displayName = wS;
var kS = Vf;
const xS = "_divider_dlgq8_29", $S = "_dashed_dlgq8_61", hn = {
  divider: xS,
  "small-space": "_small-space_dlgq8_35",
  "medium-space": "_medium-space_dlgq8_38",
  "no-space": "_no-space_dlgq8_41",
  "with-text": "_with-text_dlgq8_44",
  dashed: $S,
  "divider-text": "_divider-text_dlgq8_70",
  "dialog-overlay-show": "_dialog-overlay-show_dlgq8_1",
  "dialog-content-show": "_dialog-content-show_dlgq8_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_dlgq8_1"
};
function SS({ className: e, text: t, dashed: a, space: o = "medium", ...n }) {
  const r = Ae(
    hn.divider,
    hn[`${o}-space`],
    t && hn["with-text"],
    a && hn.dashed,
    e
  );
  return /* @__PURE__ */ v("div", { className: r, role: "separator", "aria-label": t || "divider", ...n, children: t && /* @__PURE__ */ v("span", { className: hn["divider-text"], children: t }) });
}
function tc(e) {
  return e.replace(/\s/g, "-");
}
function Uf(e, t) {
  return tc(`${t}-${e}`);
}
function CS(e) {
  const [t, a] = Pe([]);
  return Ce(() => {
    const o = [];
    let n = 0;
    for (const r of e) {
      const i = document.getElementById(Uf(r.title, n));
      i && (o.push(i.clientWidth), n++);
    }
    a(o);
  }, [e]), t;
}
function ES(e) {
  return Ho(() => e.map((t, a) => ({
    ...t,
    value: Uf(t.title, a)
  })), [e]);
}
function jS(e = 0) {
  const [t, a] = Pe(e);
  return {
    activeTabIndex: t,
    setActiveTabIndex: a
  };
}
var cs = "Tabs", [OS, srt] = fo(cs, [
  ef
]), qf = ef(), [zS, hu] = OS(cs), Hf = g.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: a,
      value: o,
      onValueChange: n,
      defaultValue: r,
      orientation: i = "horizontal",
      dir: s,
      activationMode: l = "automatic",
      ...c
    } = e, u = ns(s), [d, h] = Jn({
      prop: o,
      onChange: n,
      defaultProp: r ?? "",
      caller: cs
    });
    return /* @__PURE__ */ v(
      zS,
      {
        scope: a,
        baseId: Ya(),
        value: d,
        onValueChange: h,
        orientation: i,
        dir: u,
        activationMode: l,
        children: /* @__PURE__ */ v(
          _e.div,
          {
            dir: u,
            "data-orientation": i,
            ...c,
            ref: t
          }
        )
      }
    );
  }
);
Hf.displayName = cs;
var Gf = "TabsList", Kf = g.forwardRef(
  (e, t) => {
    const { __scopeTabs: a, loop: o = !0, ...n } = e, r = hu(Gf, a), i = qf(a);
    return /* @__PURE__ */ v(
      A1,
      {
        asChild: !0,
        ...i,
        orientation: r.orientation,
        dir: r.dir,
        loop: o,
        children: /* @__PURE__ */ v(
          _e.div,
          {
            role: "tablist",
            "aria-orientation": r.orientation,
            ...n,
            ref: t
          }
        )
      }
    );
  }
);
Kf.displayName = Gf;
var Jf = "TabsTrigger", Zf = g.forwardRef(
  (e, t) => {
    const { __scopeTabs: a, value: o, disabled: n = !1, ...r } = e, i = hu(Jf, a), s = qf(a), l = Qf(i.baseId, o), c = eb(i.baseId, o), u = o === i.value;
    return /* @__PURE__ */ v(
      P1,
      {
        asChild: !0,
        ...s,
        focusable: !n,
        active: u,
        children: /* @__PURE__ */ v(
          _e.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": u,
            "aria-controls": c,
            "data-state": u ? "active" : "inactive",
            "data-disabled": n ? "" : void 0,
            disabled: n,
            id: l,
            ...r,
            ref: t,
            onMouseDown: me(e.onMouseDown, (d) => {
              !n && d.button === 0 && d.ctrlKey === !1 ? i.onValueChange(o) : d.preventDefault();
            }),
            onKeyDown: me(e.onKeyDown, (d) => {
              [" ", "Enter"].includes(d.key) && i.onValueChange(o);
            }),
            onFocus: me(e.onFocus, () => {
              const d = i.activationMode !== "manual";
              !u && !n && d && i.onValueChange(o);
            })
          }
        )
      }
    );
  }
);
Zf.displayName = Jf;
var Yf = "TabsContent", Xf = g.forwardRef(
  (e, t) => {
    const { __scopeTabs: a, value: o, forceMount: n, children: r, ...i } = e, s = hu(Yf, a), l = Qf(s.baseId, o), c = eb(s.baseId, o), u = o === s.value, d = g.useRef(u);
    return g.useEffect(() => {
      const h = requestAnimationFrame(() => d.current = !1);
      return () => cancelAnimationFrame(h);
    }, []), /* @__PURE__ */ v(xt, { present: n || u, children: ({ present: h }) => /* @__PURE__ */ v(
      _e.div,
      {
        "data-state": u ? "active" : "inactive",
        "data-orientation": s.orientation,
        role: "tabpanel",
        "aria-labelledby": l,
        hidden: !h,
        id: c,
        tabIndex: 0,
        ...i,
        ref: t,
        style: {
          ...e.style,
          animationDuration: d.current ? "0s" : void 0
        },
        children: h && r
      }
    ) });
  }
);
Xf.displayName = Yf;
function Qf(e, t) {
  return `${e}-trigger-${t}`;
}
function eb(e, t) {
  return `${e}-content-${t}`;
}
var AS = Hf, PS = Kf, DS = Zf, NS = Xf;
const RS = "_tabs_11da8_29", Vt = {
  tabs: RS,
  "is-full-width": "_is-full-width_11da8_32",
  "tabs-content": "_tabs-content_11da8_35",
  "tabs-list": "_tabs-list_11da8_38",
  "is-small": "_is-small_11da8_41",
  "tabs-trigger-list": "_tabs-trigger-list_11da8_44",
  "tabs-trigger": "_tabs-trigger_11da8_44",
  "is-medium": "_is-medium_11da8_67",
  "tabs-underline": "_tabs-underline_11da8_77",
  "tabs-divider": "_tabs-divider_11da8_86",
  "dialog-overlay-show": "_dialog-overlay-show_11da8_1",
  "dialog-content-show": "_dialog-content-show_11da8_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_11da8_1"
};
function IS({
  tabs: e,
  isFullWidth: t,
  size: a = "medium",
  className: o = "",
  tabIndex: n = 0,
  onTabChange: r,
  ...i
}) {
  const { activeTabIndex: s, setActiveTabIndex: l } = jS(n), c = ES(e), u = CS(e), d = Ae(Vt.tabs, t && Vt["is-full-width"], o), h = Ae(Vt["tabs-trigger"], a && Vt[`is-${a}`]);
  return /* @__PURE__ */ T(
    AS,
    {
      onValueChange: (m) => {
        const f = c.findIndex((p) => tc(p.value) === m);
        l(f), r?.(f);
      },
      className: d,
      defaultValue: c[s]?.value,
      orientation: "horizontal",
      ...i,
      children: [
        /* @__PURE__ */ v(_S, { children: /* @__PURE__ */ v(vS, { children: /* @__PURE__ */ T(PS, { className: Ae(Vt["tabs-list"], a === "small" && Vt["is-small"]), children: [
          /* @__PURE__ */ T("div", { className: Vt["tabs-trigger-list"], children: [
            c.map((m) => {
              const f = m.value;
              return /* @__PURE__ */ v(
                DS,
                {
                  id: f,
                  "aria-controls": f,
                  "aria-labelledby": f,
                  className: h,
                  value: f,
                  children: m.title
                },
                f
              );
            }),
            /* @__PURE__ */ v(
              "span",
              {
                className: Vt["tabs-underline"],
                style: {
                  width: u[s],
                  transform: `translateX(${u.slice(0, s).reduce((m, f) => m + f, 0) + s * 16}px)`
                }
              }
            )
          ] }),
          /* @__PURE__ */ v("div", { className: Vt["tabs-divider"] })
        ] }) }) }),
        c.map((m) => {
          const f = tc(m.value);
          return /* @__PURE__ */ v(NS, { className: Vt["tabs-content"], "aria-labelledby": f, value: f, children: m.content }, f);
        })
      ]
    }
  );
}
const TS = "_drawer_1xu3v_29", ol = {
  "drawer-overlay": "_drawer-overlay_1xu3v_29",
  drawer: TS,
  "drawer-close": "_drawer-close_1xu3v_60"
};
function LS({ children: e, isOpen: t, onClose: a, className: o }) {
  const n = Ae(ol.drawer, o);
  return /* @__PURE__ */ v(X$, { defaultOpen: t, open: t, children: /* @__PURE__ */ T(Q$, { children: [
    /* @__PURE__ */ v(eS, { className: ol["drawer-overlay"], onClick: a }),
    /* @__PURE__ */ T(tS, { className: n, children: [
      e,
      /* @__PURE__ */ v(aS, { asChild: !0, children: /* @__PURE__ */ v("button", { onClick: a, className: ol["drawer-close"], "aria-label": "Close", children: /* @__PURE__ */ v(Se, { name: "remove", size: "large" }) }) })
    ] })
  ] }) });
}
var pu = "Progress", mu = 100, [MS, lrt] = fo(pu), [WS, BS] = MS(pu), tb = g.forwardRef(
  (e, t) => {
    const {
      __scopeProgress: a,
      value: o = null,
      max: n,
      getValueLabel: r = FS,
      ...i
    } = e;
    (n || n === 0) && !dg(n) && console.error(VS(`${n}`, "Progress"));
    const s = dg(n) ? n : mu;
    o !== null && !gg(o, s) && console.error(US(`${o}`, "Progress"));
    const l = gg(o, s) ? o : null, c = yi(l) ? r(l, s) : void 0;
    return /* @__PURE__ */ v(WS, { scope: a, value: l, max: s, children: /* @__PURE__ */ v(
      _e.div,
      {
        "aria-valuemax": s,
        "aria-valuemin": 0,
        "aria-valuenow": yi(l) ? l : void 0,
        "aria-valuetext": c,
        role: "progressbar",
        "data-state": nb(l, s),
        "data-value": l ?? void 0,
        "data-max": s,
        ...i,
        ref: t
      }
    ) });
  }
);
tb.displayName = pu;
var ab = "ProgressIndicator", ob = g.forwardRef(
  (e, t) => {
    const { __scopeProgress: a, ...o } = e, n = BS(ab, a);
    return /* @__PURE__ */ v(
      _e.div,
      {
        "data-state": nb(n.value, n.max),
        "data-value": n.value ?? void 0,
        "data-max": n.max,
        ...o,
        ref: t
      }
    );
  }
);
ob.displayName = ab;
function FS(e, t) {
  return `${Math.round(e / t * 100)}%`;
}
function nb(e, t) {
  return e == null ? "indeterminate" : e === t ? "complete" : "loading";
}
function yi(e) {
  return typeof e == "number";
}
function dg(e) {
  return yi(e) && !isNaN(e) && e > 0;
}
function gg(e, t) {
  return yi(e) && !isNaN(e) && e <= t && e >= 0;
}
function VS(e, t) {
  return `Invalid prop \`max\` of value \`${e}\` supplied to \`${t}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${mu}\`.`;
}
function US(e, t) {
  return `Invalid prop \`value\` of value \`${e}\` supplied to \`${t}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${mu} if no \`max\` prop is set)
  - \`null\` or \`undefined\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
var qS = tb, HS = ob;
const GS = "_small_ghhu4_36", KS = "_indicator_ghhu4_40", JS = "_primary_ghhu4_49", ZS = "_secondary_ghhu4_55", YS = "_tertiary_ghhu4_61", XS = "_success_ghhu4_67", QS = "_error_ghhu4_79", pn = {
  "progress-bar": "_progress-bar_ghhu4_29",
  small: GS,
  indicator: KS,
  "full-width": "_full-width_ghhu4_46",
  primary: JS,
  secondary: ZS,
  tertiary: YS,
  success: XS,
  "eco-green": "_eco-green_ghhu4_73",
  error: QS,
  "dialog-overlay-show": "_dialog-overlay-show_ghhu4_1",
  "dialog-content-show": "_dialog-content-show_ghhu4_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_ghhu4_1"
}, hg = ({ value: e = 0, color: t = "primary", size: a, isFullWidth: o, ariaLabel: n }) => {
  const [r, i] = Pe(0), s = Ae(
    pn["progress-bar"],
    a && pn[a],
    t && pn[t],
    o && pn["full-width"]
  );
  return Ce(() => {
    const l = setTimeout(() => i(e), 500);
    return () => clearTimeout(l);
  }, [e]), /* @__PURE__ */ v(qS, { className: s, "aria-label": n, children: /* @__PURE__ */ v(HS, { className: pn.indicator, style: { transform: `translateX(-${100 - r}%)` } }) });
}, pg = {
  "is-hidden-desktop": "_is-hidden-desktop_1m12x_29",
  "is-hidden-mobile": "_is-hidden-mobile_1m12x_40",
  "unset-ul": "_unset-ul_1m12x_54",
  "dialog-overlay-show": "_dialog-overlay-show_1m12x_1",
  "dialog-content-show": "_dialog-content-show_1m12x_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1m12x_1"
}, Ko = ({ children: e, hideOn: t, className: a }) => {
  const o = Ae(t && pg[`is-hidden-${t}`], a);
  return /* @__PURE__ */ v("li", { className: o, children: /* @__PURE__ */ v("ul", { className: pg["unset-ul"], children: e }) });
}, e0 = "_badge_zy4sa_29", t0 = "_root_zy4sa_58", mn = {
  badge: e0,
  "is-small": "_is-small_zy4sa_42",
  "has-child": "_has-child_zy4sa_48",
  "on-icon": "_on-icon_zy4sa_53",
  root: t0
};
function fu({ value: e, isSmall: t = !1, onIcon: a = !1, children: o, className: n, ...r }) {
  const i = Ae(
    mn.badge,
    t && mn["is-small"],
    a && mn["on-icon"],
    !!o && mn["has-child"],
    n
  );
  return o ? /* @__PURE__ */ T("span", { className: mn.root, ...r, children: [
    /* @__PURE__ */ v("span", { className: i, children: !t && e }),
    o
  ] }) : /* @__PURE__ */ v("span", { className: i, ...r, children: !t && e });
}
var bo = "NavigationMenu", [bu, rb, a0] = ru(bo), [ac, o0, n0] = ru(bo), [_u, crt] = fo(
  bo,
  [a0, n0]
), [r0, At] = _u(bo), [i0, s0] = _u(bo), ib = g.forwardRef(
  (e, t) => {
    const {
      __scopeNavigationMenu: a,
      value: o,
      onValueChange: n,
      defaultValue: r,
      delayDuration: i = 200,
      skipDelayDuration: s = 300,
      orientation: l = "horizontal",
      dir: c,
      ...u
    } = e, [d, h] = g.useState(null), m = We(t, (C) => h(C)), f = ns(c), p = g.useRef(0), b = g.useRef(0), w = g.useRef(0), [_, y] = g.useState(!0), [k, x] = Jn({
      prop: o,
      onChange: (C) => {
        const j = C !== "", R = s > 0;
        j ? (window.clearTimeout(w.current), R && y(!1)) : (window.clearTimeout(w.current), w.current = window.setTimeout(
          () => y(!0),
          s
        )), n?.(C);
      },
      defaultProp: r ?? "",
      caller: bo
    }), S = g.useCallback(() => {
      window.clearTimeout(b.current), b.current = window.setTimeout(() => x(""), 150);
    }, [x]), $ = g.useCallback(
      (C) => {
        window.clearTimeout(b.current), x(C);
      },
      [x]
    ), E = g.useCallback(
      (C) => {
        k === C ? window.clearTimeout(b.current) : p.current = window.setTimeout(() => {
          window.clearTimeout(b.current), x(C);
        }, i);
      },
      [k, x, i]
    );
    return g.useEffect(() => () => {
      window.clearTimeout(p.current), window.clearTimeout(b.current), window.clearTimeout(w.current);
    }, []), /* @__PURE__ */ v(
      sb,
      {
        scope: a,
        isRootMenu: !0,
        value: k,
        dir: f,
        orientation: l,
        rootNavigationMenu: d,
        onTriggerEnter: (C) => {
          window.clearTimeout(p.current), _ ? E(C) : $(C);
        },
        onTriggerLeave: () => {
          window.clearTimeout(p.current), S();
        },
        onContentEnter: () => window.clearTimeout(b.current),
        onContentLeave: S,
        onItemSelect: (C) => {
          x((j) => j === C ? "" : C);
        },
        onItemDismiss: () => x(""),
        children: /* @__PURE__ */ v(
          _e.nav,
          {
            "aria-label": "Main",
            "data-orientation": l,
            dir: f,
            ...u,
            ref: m
          }
        )
      }
    );
  }
);
ib.displayName = bo;
var oc = "NavigationMenuSub", l0 = g.forwardRef(
  (e, t) => {
    const {
      __scopeNavigationMenu: a,
      value: o,
      onValueChange: n,
      defaultValue: r,
      orientation: i = "horizontal",
      ...s
    } = e, l = At(oc, a), [c, u] = Jn({
      prop: o,
      onChange: n,
      defaultProp: r ?? "",
      caller: oc
    });
    return /* @__PURE__ */ v(
      sb,
      {
        scope: a,
        isRootMenu: !1,
        value: c,
        dir: l.dir,
        orientation: i,
        rootNavigationMenu: l.rootNavigationMenu,
        onTriggerEnter: (d) => u(d),
        onItemSelect: (d) => u(d),
        onItemDismiss: () => u(""),
        children: /* @__PURE__ */ v(_e.div, { "data-orientation": i, ...s, ref: t })
      }
    );
  }
);
l0.displayName = oc;
var sb = (e) => {
  const {
    scope: t,
    isRootMenu: a,
    rootNavigationMenu: o,
    dir: n,
    orientation: r,
    children: i,
    value: s,
    onItemSelect: l,
    onItemDismiss: c,
    onTriggerEnter: u,
    onTriggerLeave: d,
    onContentEnter: h,
    onContentLeave: m
  } = e, [f, p] = g.useState(null), [b, w] = g.useState(/* @__PURE__ */ new Map()), [_, y] = g.useState(null);
  return /* @__PURE__ */ v(
    r0,
    {
      scope: t,
      isRootMenu: a,
      rootNavigationMenu: o,
      value: s,
      previousValue: D1(s),
      baseId: Ya(),
      dir: n,
      orientation: r,
      viewport: f,
      onViewportChange: p,
      indicatorTrack: _,
      onIndicatorTrackChange: y,
      onTriggerEnter: qe(u),
      onTriggerLeave: qe(d),
      onContentEnter: qe(h),
      onContentLeave: qe(m),
      onItemSelect: qe(l),
      onItemDismiss: qe(c),
      onViewportContentChange: g.useCallback((k, x) => {
        w((S) => (S.set(k, x), new Map(S)));
      }, []),
      onViewportContentRemove: g.useCallback((k) => {
        w((x) => x.has(k) ? (x.delete(k), new Map(x)) : x);
      }, []),
      children: /* @__PURE__ */ v(bu.Provider, { scope: t, children: /* @__PURE__ */ v(i0, { scope: t, items: b, children: i }) })
    }
  );
}, lb = "NavigationMenuList", cb = g.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: a, ...o } = e, n = At(lb, a), r = /* @__PURE__ */ v(_e.ul, { "data-orientation": n.orientation, ...o, ref: t });
    return /* @__PURE__ */ v(_e.div, { style: { position: "relative" }, ref: n.onIndicatorTrackChange, children: /* @__PURE__ */ v(bu.Slot, { scope: a, children: n.isRootMenu ? /* @__PURE__ */ v(bb, { asChild: !0, children: r }) : r }) });
  }
);
cb.displayName = lb;
var ub = "NavigationMenuItem", [c0, db] = _u(ub), gb = g.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: a, value: o, ...n } = e, r = Ya(), i = o || r || "LEGACY_REACT_AUTO_VALUE", s = g.useRef(null), l = g.useRef(null), c = g.useRef(null), u = g.useRef(() => {
    }), d = g.useRef(!1), h = g.useCallback((f = "start") => {
      if (s.current) {
        u.current();
        const p = rc(s.current);
        p.length && wu(f === "start" ? p : p.reverse());
      }
    }, []), m = g.useCallback(() => {
      if (s.current) {
        const f = rc(s.current);
        f.length && (u.current = _0(f));
      }
    }, []);
    return /* @__PURE__ */ v(
      c0,
      {
        scope: a,
        value: i,
        triggerRef: l,
        contentRef: s,
        focusProxyRef: c,
        wasEscapeCloseRef: d,
        onEntryKeyDown: h,
        onFocusProxyEnter: h,
        onRootContentClose: m,
        onContentFocusOutside: m,
        children: /* @__PURE__ */ v(_e.li, { ...n, ref: t })
      }
    );
  }
);
gb.displayName = ub;
var nc = "NavigationMenuTrigger", hb = g.forwardRef((e, t) => {
  const { __scopeNavigationMenu: a, disabled: o, ...n } = e, r = At(nc, e.__scopeNavigationMenu), i = db(nc, e.__scopeNavigationMenu), s = g.useRef(null), l = We(s, i.triggerRef, t), c = vb(r.baseId, i.value), u = yb(r.baseId, i.value), d = g.useRef(!1), h = g.useRef(!1), m = i.value === r.value;
  return /* @__PURE__ */ T(De, { children: [
    /* @__PURE__ */ v(bu.ItemSlot, { scope: a, value: i.value, children: /* @__PURE__ */ v(_b, { asChild: !0, children: /* @__PURE__ */ v(
      _e.button,
      {
        id: c,
        disabled: o,
        "data-disabled": o ? "" : void 0,
        "data-state": ku(m),
        "aria-expanded": m,
        "aria-controls": u,
        ...n,
        ref: l,
        onPointerEnter: me(e.onPointerEnter, () => {
          h.current = !1, i.wasEscapeCloseRef.current = !1;
        }),
        onPointerMove: me(
          e.onPointerMove,
          wi(() => {
            o || h.current || i.wasEscapeCloseRef.current || d.current || (r.onTriggerEnter(i.value), d.current = !0);
          })
        ),
        onPointerLeave: me(
          e.onPointerLeave,
          wi(() => {
            o || (r.onTriggerLeave(), d.current = !1);
          })
        ),
        onClick: me(e.onClick, () => {
          r.onItemSelect(i.value), h.current = m;
        }),
        onKeyDown: me(e.onKeyDown, (f) => {
          const p = { horizontal: "ArrowDown", vertical: r.dir === "rtl" ? "ArrowLeft" : "ArrowRight" }[r.orientation];
          m && f.key === p && (i.onEntryKeyDown(), f.preventDefault());
        })
      }
    ) }) }),
    m && /* @__PURE__ */ T(De, { children: [
      /* @__PURE__ */ v(
        kS,
        {
          "aria-hidden": !0,
          tabIndex: 0,
          ref: i.focusProxyRef,
          onFocus: (f) => {
            const p = i.contentRef.current, b = f.relatedTarget, w = b === s.current, _ = p?.contains(b);
            (w || !_) && i.onFocusProxyEnter(w ? "start" : "end");
          }
        }
      ),
      r.viewport && /* @__PURE__ */ v("span", { "aria-owns": u })
    ] })
  ] });
});
hb.displayName = nc;
var u0 = "NavigationMenuLink", mg = "navigationMenu.linkSelect", pb = g.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: a, active: o, onSelect: n, ...r } = e;
    return /* @__PURE__ */ v(_b, { asChild: !0, children: /* @__PURE__ */ v(
      _e.a,
      {
        "data-active": o ? "" : void 0,
        "aria-current": o ? "page" : void 0,
        ...r,
        ref: t,
        onClick: me(
          e.onClick,
          (i) => {
            const s = i.target, l = new CustomEvent(mg, {
              bubbles: !0,
              cancelable: !0
            });
            if (s.addEventListener(mg, (c) => n?.(c), { once: !0 }), Yl(s, l), !l.defaultPrevented && !i.metaKey) {
              const c = new CustomEvent(Yr, {
                bubbles: !0,
                cancelable: !0
              });
              Yl(s, c);
            }
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
pb.displayName = u0;
var vu = "NavigationMenuIndicator", d0 = g.forwardRef((e, t) => {
  const { forceMount: a, ...o } = e, n = At(vu, e.__scopeNavigationMenu), r = !!n.value;
  return n.indicatorTrack ? os.createPortal(
    /* @__PURE__ */ v(xt, { present: a || r, children: /* @__PURE__ */ v(g0, { ...o, ref: t }) }),
    n.indicatorTrack
  ) : null;
});
d0.displayName = vu;
var g0 = g.forwardRef((e, t) => {
  const { __scopeNavigationMenu: a, ...o } = e, n = At(vu, a), r = rb(a), [i, s] = g.useState(
    null
  ), [l, c] = g.useState(null), u = n.orientation === "horizontal", d = !!n.value;
  g.useEffect(() => {
    const m = r().find((f) => f.value === n.value)?.ref.current;
    m && s(m);
  }, [r, n.value]);
  const h = () => {
    i && c({
      size: u ? i.offsetWidth : i.offsetHeight,
      offset: u ? i.offsetLeft : i.offsetTop
    });
  };
  return ic(i, h), ic(n.indicatorTrack, h), l ? /* @__PURE__ */ v(
    _e.div,
    {
      "aria-hidden": !0,
      "data-state": d ? "visible" : "hidden",
      "data-orientation": n.orientation,
      ...o,
      ref: t,
      style: {
        position: "absolute",
        ...u ? {
          left: 0,
          width: l.size + "px",
          transform: `translateX(${l.offset}px)`
        } : {
          top: 0,
          height: l.size + "px",
          transform: `translateY(${l.offset}px)`
        },
        ...o.style
      }
    }
  ) : null;
}), Jo = "NavigationMenuContent", mb = g.forwardRef((e, t) => {
  const { forceMount: a, ...o } = e, n = At(Jo, e.__scopeNavigationMenu), r = db(Jo, e.__scopeNavigationMenu), i = We(r.contentRef, t), s = r.value === n.value, l = {
    value: r.value,
    triggerRef: r.triggerRef,
    focusProxyRef: r.focusProxyRef,
    wasEscapeCloseRef: r.wasEscapeCloseRef,
    onContentFocusOutside: r.onContentFocusOutside,
    onRootContentClose: r.onRootContentClose,
    ...o
  };
  return n.viewport ? /* @__PURE__ */ v(h0, { forceMount: a, ...l, ref: i }) : /* @__PURE__ */ v(xt, { present: a || s, children: /* @__PURE__ */ v(
    fb,
    {
      "data-state": ku(s),
      ...l,
      ref: i,
      onPointerEnter: me(e.onPointerEnter, n.onContentEnter),
      onPointerLeave: me(
        e.onPointerLeave,
        wi(n.onContentLeave)
      ),
      style: {
        // Prevent interaction when animating out
        pointerEvents: !s && n.isRootMenu ? "none" : void 0,
        ...l.style
      }
    }
  ) });
});
mb.displayName = Jo;
var h0 = g.forwardRef((e, t) => {
  const a = At(Jo, e.__scopeNavigationMenu), { onViewportContentChange: o, onViewportContentRemove: n } = a;
  return pa(() => {
    o(e.value, {
      ref: t,
      ...e
    });
  }, [e, t, o]), pa(() => () => n(e.value), [e.value, n]), null;
}), Yr = "navigationMenu.rootContentDismiss", fb = g.forwardRef((e, t) => {
  const {
    __scopeNavigationMenu: a,
    value: o,
    triggerRef: n,
    focusProxyRef: r,
    wasEscapeCloseRef: i,
    onRootContentClose: s,
    onContentFocusOutside: l,
    ...c
  } = e, u = At(Jo, a), d = g.useRef(null), h = We(d, t), m = vb(u.baseId, o), f = yb(u.baseId, o), p = rb(a), b = g.useRef(null), { onItemDismiss: w } = u;
  g.useEffect(() => {
    const y = d.current;
    if (u.isRootMenu && y) {
      const k = () => {
        w(), s(), y.contains(document.activeElement) && n.current?.focus();
      };
      return y.addEventListener(Yr, k), () => y.removeEventListener(Yr, k);
    }
  }, [u.isRootMenu, e.value, n, w, s]);
  const _ = g.useMemo(() => {
    const y = p().map((C) => C.value);
    u.dir === "rtl" && y.reverse();
    const k = y.indexOf(u.value), x = y.indexOf(u.previousValue), S = o === u.value, $ = x === y.indexOf(o);
    if (!S && !$) return b.current;
    const E = (() => {
      if (k !== x) {
        if (S && x !== -1) return k > x ? "from-end" : "from-start";
        if ($ && k !== -1) return k > x ? "to-start" : "to-end";
      }
      return null;
    })();
    return b.current = E, E;
  }, [u.previousValue, u.value, u.dir, p, o]);
  return /* @__PURE__ */ v(bb, { asChild: !0, children: /* @__PURE__ */ v(
    iu,
    {
      id: f,
      "aria-labelledby": m,
      "data-motion": _,
      "data-orientation": u.orientation,
      ...c,
      ref: h,
      disableOutsidePointerEvents: !1,
      onDismiss: () => {
        const y = new Event(Yr, {
          bubbles: !0,
          cancelable: !0
        });
        d.current?.dispatchEvent(y);
      },
      onFocusOutside: me(e.onFocusOutside, (y) => {
        l();
        const k = y.target;
        u.rootNavigationMenu?.contains(k) && y.preventDefault();
      }),
      onPointerDownOutside: me(e.onPointerDownOutside, (y) => {
        const k = y.target, x = p().some(($) => $.ref.current?.contains(k)), S = u.isRootMenu && u.viewport?.contains(k);
        (x || S || !u.isRootMenu) && y.preventDefault();
      }),
      onKeyDown: me(e.onKeyDown, (y) => {
        const k = y.altKey || y.ctrlKey || y.metaKey;
        if (y.key === "Tab" && !k) {
          const x = rc(y.currentTarget), S = document.activeElement, $ = x.findIndex((C) => C === S), E = y.shiftKey ? x.slice(0, $).reverse() : x.slice($ + 1, x.length);
          wu(E) ? y.preventDefault() : r.current?.focus();
        }
      }),
      onEscapeKeyDown: me(e.onEscapeKeyDown, (y) => {
        i.current = !0;
      })
    }
  ) });
}), yu = "NavigationMenuViewport", p0 = g.forwardRef((e, t) => {
  const { forceMount: a, ...o } = e, n = !!At(yu, e.__scopeNavigationMenu).value;
  return /* @__PURE__ */ v(xt, { present: a || n, children: /* @__PURE__ */ v(m0, { ...o, ref: t }) });
});
p0.displayName = yu;
var m0 = g.forwardRef((e, t) => {
  const { __scopeNavigationMenu: a, children: o, ...n } = e, r = At(yu, a), i = We(t, r.onViewportChange), s = s0(
    Jo,
    e.__scopeNavigationMenu
  ), [l, c] = g.useState(null), [u, d] = g.useState(null), h = l ? l?.width + "px" : void 0, m = l ? l?.height + "px" : void 0, f = !!r.value, p = f ? r.value : r.previousValue;
  return ic(u, () => {
    u && c({ width: u.offsetWidth, height: u.offsetHeight });
  }), /* @__PURE__ */ v(
    _e.div,
    {
      "data-state": ku(f),
      "data-orientation": r.orientation,
      ...n,
      ref: i,
      style: {
        // Prevent interaction when animating out
        pointerEvents: !f && r.isRootMenu ? "none" : void 0,
        "--radix-navigation-menu-viewport-width": h,
        "--radix-navigation-menu-viewport-height": m,
        ...n.style
      },
      onPointerEnter: me(e.onPointerEnter, r.onContentEnter),
      onPointerLeave: me(e.onPointerLeave, wi(r.onContentLeave)),
      children: Array.from(s.items).map(([b, { ref: w, forceMount: _, ...y }]) => {
        const k = p === b;
        return /* @__PURE__ */ v(xt, { present: _ || k, children: /* @__PURE__ */ v(
          fb,
          {
            ...y,
            ref: nu(w, (x) => {
              k && x && d(x);
            })
          }
        ) }, b);
      })
    }
  );
}), f0 = "FocusGroup", bb = g.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: a, ...o } = e, n = At(f0, a);
    return /* @__PURE__ */ v(ac.Provider, { scope: a, children: /* @__PURE__ */ v(ac.Slot, { scope: a, children: /* @__PURE__ */ v(_e.div, { dir: n.dir, ...o, ref: t }) }) });
  }
), fg = ["ArrowRight", "ArrowLeft", "ArrowUp", "ArrowDown"], b0 = "FocusGroupItem", _b = g.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: a, ...o } = e, n = o0(a), r = At(b0, a);
    return /* @__PURE__ */ v(ac.ItemSlot, { scope: a, children: /* @__PURE__ */ v(
      _e.button,
      {
        ...o,
        ref: t,
        onKeyDown: me(e.onKeyDown, (i) => {
          if (["Home", "End", ...fg].includes(i.key)) {
            let s = n().map((l) => l.ref.current);
            if ([r.dir === "rtl" ? "ArrowRight" : "ArrowLeft", "ArrowUp", "End"].includes(i.key) && s.reverse(), fg.includes(i.key)) {
              const l = s.indexOf(i.currentTarget);
              s = s.slice(l + 1);
            }
            setTimeout(() => wu(s)), i.preventDefault();
          }
        })
      }
    ) });
  }
);
function rc(e) {
  const t = [], a = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const n = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || n ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; a.nextNode(); ) t.push(a.currentNode);
  return t;
}
function wu(e) {
  const t = document.activeElement;
  return e.some((a) => a === t ? !0 : (a.focus(), document.activeElement !== t));
}
function _0(e) {
  return e.forEach((t) => {
    t.dataset.tabindex = t.getAttribute("tabindex") || "", t.setAttribute("tabindex", "-1");
  }), () => {
    e.forEach((t) => {
      const a = t.dataset.tabindex;
      t.setAttribute("tabindex", a);
    });
  };
}
function ic(e, t) {
  const a = qe(t);
  pa(() => {
    let o = 0;
    if (e) {
      const n = new ResizeObserver(() => {
        cancelAnimationFrame(o), o = window.requestAnimationFrame(a);
      });
      return n.observe(e), () => {
        window.cancelAnimationFrame(o), n.unobserve(e);
      };
    }
  }, [e, a]);
}
function ku(e) {
  return e ? "open" : "closed";
}
function vb(e, t) {
  return `${e}-trigger-${t}`;
}
function yb(e, t) {
  return `${e}-content-${t}`;
}
function wi(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var v0 = ib, y0 = cb, ki = gb, w0 = hb, k0 = pb, x0 = mb;
const $0 = "_arrow_1367h_117", S0 = "_navbar_1367h_29", $e = {
  "navbar-item": "_navbar-item_1367h_29",
  "navbar-item-background-hover": "_navbar-item-background-hover_1367h_33",
  "navbar-drawer": "_navbar-drawer_1367h_37",
  "first-on-mobile": "_first-on-mobile_1367h_52",
  "second-on-mobile": "_second-on-mobile_1367h_61",
  "navbar-end": "_navbar-end_1367h_70",
  "navbar-item-wrapper": "_navbar-item-wrapper_1367h_89",
  "navbar-item-flex-grow": "_navbar-item-flex-grow_1367h_105",
  "navbar-item-button": "_navbar-item-button_1367h_108",
  arrow: $0,
  "navbar-has-dropdown": "_navbar-has-dropdown_1367h_130",
  "navbar-dropdown": "_navbar-dropdown_1367h_156",
  "is-size-small": "_is-size-small_1367h_161",
  "is-size-medium": "_is-size-medium_1367h_164",
  "navbar-item-no-padding-top-bottom": "_navbar-item-no-padding-top-bottom_1367h_191",
  "navbar-item-is-right": "_navbar-item-is-right_1367h_195",
  "navbar-item-is-center": "_navbar-item-is-center_1367h_200",
  "navbar-item-no-padding": "_navbar-item-no-padding_1367h_191",
  "is-right": "_is-right_1367h_207",
  "is-left": "_is-left_1367h_211",
  navbar: S0,
  "is-fixed-top": "_is-fixed-top_1367h_228",
  "navbar-burger": "_navbar-burger_1367h_241",
  "navbar-menu": "_navbar-menu_1367h_282",
  "burger-close": "_burger-close_1367h_296",
  "navbar-start": "_navbar-start_1367h_316",
  "unset-li": "_unset-li_1367h_350",
  "margin-auto-top": "_margin-auto-top_1367h_357",
  "navbar-item-larger-padding-bottom": "_navbar-item-larger-padding-bottom_1367h_366",
  "dialog-overlay-show": "_dialog-overlay-show_1367h_1",
  "dialog-content-show": "_dialog-content-show_1367h_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1367h_1"
}, wb = ({ children: e, isFixedTop: t }) => /* @__PURE__ */ v(v0, { children: /* @__PURE__ */ v(y0, { className: Ae($e.navbar, t && $e["is-fixed-top"]), children: e }) }), kb = ({ children: e, notificationValue: t }) => {
  const { value: a, toggle: o } = N1(), { isMobile: n, isTablet: r } = I1();
  return /* @__PURE__ */ T(De, { children: [
    (n || r) && /* @__PURE__ */ T(De, { children: [
      /* @__PURE__ */ v(de, { children: t ? /* @__PURE__ */ v(fu, { value: t, isSmall: !0, children: /* @__PURE__ */ T("button", { onClick: o, className: $e["navbar-burger"], "aria-label": "menu-button", children: [
        /* @__PURE__ */ v("span", { "aria-hidden": "true" }),
        /* @__PURE__ */ v("span", { "aria-hidden": "true" }),
        /* @__PURE__ */ v("span", { "aria-hidden": "true" })
      ] }) }) : /* @__PURE__ */ T("button", { onClick: o, className: $e["navbar-burger"], "aria-label": "menu-button", children: [
        /* @__PURE__ */ v("span", { "aria-hidden": "true" }),
        /* @__PURE__ */ v("span", { "aria-hidden": "true" }),
        /* @__PURE__ */ v("span", { "aria-hidden": "true" })
      ] }) }),
      /* @__PURE__ */ v(LS, { isOpen: a, onClose: o, className: Ae($e["navbar-drawer"]), children: e })
    ] }),
    /* @__PURE__ */ v("li", { className: Ae($e["navbar-menu"]), children: /* @__PURE__ */ T("ul", { children: [
      /* @__PURE__ */ v("li", { children: /* @__PURE__ */ v("button", { className: $e["burger-close"], onClick: o, "aria-label": "burger-close", children: /* @__PURE__ */ v(Se, { name: "remove", size: "large" }) }) }),
      e
    ] }) })
  ] });
}, de = ({
  children: e,
  href: t,
  hideOn: a,
  isFirstOnMobile: o,
  isSecondOnMobile: n,
  noPaddingRight: r,
  largerPaddingBottom: i,
  noTopBottomPadding: s,
  onClick: l,
  marginAutoTop: c,
  isButton: u,
  backgroundOnHover: d = !0,
  isFlexGrow: h = !1
}) => {
  const m = Ae(
    c && $e["margin-auto-top"],
    o && $e["first-on-mobile"],
    n && $e["second-on-mobile"],
    r && $e["navbar-item-no-padding"],
    u && $e["navbar-item-button"],
    s && $e["navbar-item-no-padding-top-bottom"],
    i && $e["navbar-item-larger-padding-bottom"],
    d && $e["navbar-item-background-hover"],
    h && $e["navbar-item-flex-grow"]
  ), f = t ? /* @__PURE__ */ v(ki, { onClick: l, className: Ae($e["navbar-item-wrapper"], m), children: /* @__PURE__ */ v(k0, { className: Ae($e["navbar-item"], m), href: t, children: e }) }) : /* @__PURE__ */ v(ki, { onClick: l, className: Ae($e["navbar-item"], m), children: e });
  return a ? /* @__PURE__ */ v(Ko, { hideOn: a, className: Ae($e["navbar-item-wrapper"], m), children: f }) : f;
}, xb = ({ children: e, position: t }) => {
  const a = Ae(t && $e[`navbar-${t}`]);
  return /* @__PURE__ */ v("li", { className: a, children: /* @__PURE__ */ v("ul", { className: a, children: e }) });
}, xu = ({ children: e, hideOn: t }) => {
  const a = Ae($e["navbar-has-dropdown"], $e["navbar-item-wrapper"]);
  return t ? /* @__PURE__ */ v(Ko, { hideOn: t, className: $e["navbar-item-wrapper"], children: /* @__PURE__ */ v(ki, { className: a, children: e }) }) : /* @__PURE__ */ v(ki, { className: a, children: e });
}, $u = ({ children: e }) => /* @__PURE__ */ v(w0, { className: $e["navbar-item"], children: /* @__PURE__ */ T(ue, { gap: "2", alignItems: "center", isFullWidth: !0, justifyContent: "space-between", children: [
  e,
  /* @__PURE__ */ v(Se, { name: "up-arrow", size: "small", className: $e.arrow })
] }) }), Su = ({ children: e, size: t, align: a = "right" }) => {
  const o = Ae(
    $e["navbar-dropdown"],
    $e[`is-${a}`],
    $e["navbar-item"],
    t && $e[`is-size-${t}`]
  );
  return /* @__PURE__ */ v(x0, { className: o, children: /* @__PURE__ */ v("ul", { children: e }) });
}, bg = {
  "unset-list": "_unset-list_50wvn_29",
  "navbar-brand": "_navbar-brand_50wvn_38"
}, $b = ({ children: e }) => /* @__PURE__ */ v("li", { className: bg["unset-list"], children: /* @__PURE__ */ v("ul", { className: bg["navbar-brand"], children: e }) }), nl = {
  "unset-list": "_unset-list_g6gr1_29",
  "navbar-divider": "_navbar-divider_g6gr1_35"
}, To = ({ hideOn: e }) => {
  const t = Ae(nl["navbar-divider"]);
  return e ? /* @__PURE__ */ v(Ko, { hideOn: e, children: /* @__PURE__ */ v("li", { className: nl["unset-list"], children: /* @__PURE__ */ v("hr", { className: t }) }) }) : /* @__PURE__ */ v("li", { className: nl["unset-list"], children: /* @__PURE__ */ v("hr", { className: t }) });
}, C0 = {
  "dropdown-divider": "_dropdown-divider_6mcrd_29"
}, Et = () => /* @__PURE__ */ v("hr", { className: Ae(C0["dropdown-divider"]) }), E0 = "_avatar_1ikzc_29", _g = {
  avatar: E0,
  "is-xsmall": "_is-xsmall_1ikzc_32",
  "is-small": "_is-small_1ikzc_36",
  "is-medium": "_is-medium_1ikzc_40",
  "is-large": "_is-large_1ikzc_44",
  "dialog-overlay-show": "_dialog-overlay-show_1ikzc_1",
  "dialog-content-show": "_dialog-content-show_1ikzc_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1ikzc_1"
};
function Sb({ url: e, alt: t, size: a = "medium", className: o, ...n }) {
  const r = Ae(_g.avatar, a && _g[`is-${a}`], o);
  return /* @__PURE__ */ v("img", { className: r, src: e, alt: t, ...n });
}
const vg = {
  "communication-banner": "_communication-banner_2kn0i_1"
};
function j0({ text: e, url: t }) {
  return /* @__PURE__ */ v("a", { href: t, children: /* @__PURE__ */ T("div", { className: vg["communication-banner"], children: [
    /* @__PURE__ */ v("p", { children: e }),
    /* @__PURE__ */ v(Se, { size: "2xl", name: "angle-right", className: vg.icon })
  ] }) });
}
function Cb(e) {
  var t, a, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var n = e.length;
    for (t = 0; t < n; t++) e[t] && (a = Cb(e[t])) && (o && (o += " "), o += a);
  } else for (a in e) e[a] && (o && (o += " "), o += a);
  return o;
}
function O0() {
  for (var e, t, a = 0, o = "", n = arguments.length; a < n; a++) (e = arguments[a]) && (t = Cb(e)) && (o && (o += " "), o += t);
  return o;
}
const z0 = [
  "accessible-bathroom",
  "accessible-bedroom",
  "ac",
  "ambassador_sidebar",
  "animals-card",
  "angle-left",
  "angle-left-rounded",
  "angle-right",
  "angle-right-rounded",
  "anywhere-in-the-world",
  "arrow-thin",
  "arrow-thin-right",
  "available-exchange-type",
  "average-reactivity",
  "baby-bed",
  "baby-gear",
  "baby-gear-old",
  "baby-sitter",
  "balcony-terrace",
  "bathroom",
  "bathtub",
  "bbq",
  "bedroom",
  "beds",
  "bicycle",
  "briefcase3",
  "button-power",
  "cancel",
  "calendar",
  "car",
  "cat-to-feed",
  "chat-lock",
  "check",
  "checkbox-fill",
  "children-welcome",
  "circle-close",
  "circle-help",
  "circle-left-arrow",
  "circle-right-arrow",
  "cities",
  "cleaning-person",
  "clock",
  "computer",
  "cook",
  "corona-virus",
  "countryside",
  "credit-card",
  "dashboard-saved-search",
  "dedicated-work-space",
  "disabled-access",
  "dishwasher",
  "docs",
  "dog-to-feed",
  "dollar",
  "doorman",
  "double-bed",
  "double-bed-up",
  "dryer",
  "easy-navigation",
  "electric-car",
  "electric-car-plug",
  "elevator",
  "error",
  "error-regular",
  "error-warning-fill",
  "excellent-reactivity",
  "eye",
  "eye-slash",
  "eye-slash-back",
  "facebook",
  "filter-picture",
  "fireplace",
  "flag",
  "flat",
  "folk",
  "freezer",
  "fridge",
  "garden",
  "gift",
  "gp",
  "great-reactivity",
  "guarantees",
  "guestpoint-exchange-type",
  "guestpoints",
  "guide",
  "gym",
  "header-help",
  "header-message-new",
  "header-message-read",
  "header-profile-home",
  "header-profile-profile",
  "header-profile-settings",
  "header-profile-they-love-my-home",
  "heart",
  "heart-fill",
  "heating-system",
  "high-speed-connection",
  "home-bin",
  "home-camera",
  "home-cinema",
  "home-exchange",
  "home-panel",
  "house",
  "ic-compass",
  "ic-flip-left",
  "ic-flip-right",
  "ic-location",
  "ic-move",
  "ic-shelter",
  "ic-transfer",
  "icon_facebook",
  "icon_gmail",
  "icon_messanger",
  "icon_outlook",
  "id",
  "information-circle",
  "information-circle-regular",
  "instagram",
  "internet",
  "isolated",
  "island",
  "jacuzzi",
  "key",
  "keys",
  "kids-playground",
  "kids-toys",
  "lakes",
  "lifebuoy",
  "linkedin",
  "location",
  "lock",
  "lock-credit-card",
  "low-consumption-machines",
  "marker-home",
  "marker-home-favorite",
  "marker-home-selected",
  "marker-home-selected-favorite",
  "marker-home-unavailable",
  "marker-home-unavailable-favorite",
  "low-reactivity",
  "map-1",
  "megaphone",
  "membership",
  "messenger",
  "microwave-oven",
  "minus",
  "moonplus",
  "more-filter",
  "motorboat",
  "motorcycle",
  "motor-scooter",
  "mountains",
  "my-family",
  "new-tab",
  "notification",
  "noun-loyalty-card",
  "number-eight",
  "number-five",
  "number-four",
  "number-nine",
  "number-one",
  "number-seven",
  "number-six",
  "number-three",
  "number-two",
  "ok",
  "oven",
  "parking-space",
  "pencil",
  "people",
  "pets-welcome",
  "phone",
  "piano",
  "ping-pong-table",
  "pin",
  "plants-to-water",
  "playground",
  "plus",
  "plus-sign",
  "pool-table",
  "preferred-destinations",
  "primary-home",
  "private-room",
  "public-transit-access",
  "rabbit",
  "raw",
  "reciprocal-exchange-type",
  "remove",
  "renewable-energy-provider",
  "river",
  "rooms",
  "sailboat",
  "satellite-cable",
  "sauna",
  "search",
  "search-location-pin",
  "seaside",
  "secondary-home",
  "secured-swimming-pool",
  "selective-waste-sorting",
  "shape-close",
  "share-fat",
  "simple-bed",
  "simple-bed-up",
  "size",
  "smart-tv",
  "smokers-welcome",
  "solar-panels",
  "sort-order",
  "sponsor-hand-icon",
  "star-black",
  "star-full",
  "step-free-entry",
  "sugesstion",
  "sun",
  "swimming-pool",
  "tennis-court",
  "tiktok",
  "triangle-warning",
  "tv",
  "tv-icon",
  "twitter",
  "types_of_exchanges",
  "unavailable",
  "up-arrow",
  "upload",
  "user",
  "vegetable-garden",
  "verification-check",
  "verification-check-regular",
  "video-game-console",
  "villages",
  "warning",
  "warning-regular",
  "washing-machine",
  "wide-angle",
  "wide-doors",
  "wifi",
  "youtube"
], A0 = {
  "marker-home-favorite": 3,
  "marker-home": 2,
  "marker-home-selected-favorite": 3,
  "marker-home-selected": 2,
  "marker-home-unavailable-favorite": 3,
  "marker-home-unavailable": 2,
  icon_facebook: 2,
  icon_gmail: 5
}, P0 = z0.map((e) => ({
  name: e,
  class: `icon-${e}`,
  paths: A0[e]
})), D0 = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, N0 = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl",
  "8xl": "is-8xl",
  "9xl": "is-9xl",
  "10xl": "is-10xl"
};
function R0(e = 0) {
  const t = [];
  for (let a = 0; a < e; a++)
    t[a] = `path${a + 1}`;
  return t.map((a) => /* @__PURE__ */ v("span", { className: a }, a));
}
const I0 = mt(
  ({ name: e, size: t = "medium", color: a = "base", className: o = "", ...n }, r) => {
    const i = P0.find((l) => l.name === e), s = O0("icon", `ds-${i?.class}`, N0[t], D0[a], o);
    return /* @__PURE__ */ v("i", { className: s, ...n, ref: r, children: R0(i?.paths) });
  }
);
I0.displayName = "Icon";
const T0 = ["en", "fr", "it"], Eb = Ot({
  locale: "en"
});
function jb({ children: e, ...t }) {
  return /* @__PURE__ */ v(Eb.Provider, { value: t, children: e });
}
const L0 = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_+.~#?&/=]*)$/;
function M0(e) {
  return T0.includes(e) && !0;
}
function W0(e, t) {
  const a = L0.test(t);
  let o;
  return M0(e) || a ? o = `${t}` : o = `/${e}${t}`, { url: o };
}
function Oe(e) {
  const { locale: t } = ho(Eb);
  return W0(t, e);
}
let yg = class extends Error {
  code;
  errorData;
  constructor(t, a, o) {
    super(t), this.name = "HeError", this.code = a, this.errorData = o;
  }
};
function Ob(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: B0 } = Object.prototype, { getPrototypeOf: Cu } = Object, { iterator: us, toStringTag: zb } = Symbol, ds = /* @__PURE__ */ ((e) => (t) => {
  const a = B0.call(t);
  return e[a] || (e[a] = a.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Wt = (e) => (e = e.toLowerCase(), (t) => ds(t) === e), gs = (e) => (t) => typeof t === e, { isArray: on } = Array, Zo = gs("undefined");
function Yn(e) {
  return e !== null && !Zo(e) && e.constructor !== null && !Zo(e.constructor) && dt(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Ab = Wt("ArrayBuffer");
function F0(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Ab(e.buffer), t;
}
const V0 = gs("string"), dt = gs("function"), Pb = gs("number"), Xn = (e) => e !== null && typeof e == "object", U0 = (e) => e === !0 || e === !1, Xr = (e) => {
  if (ds(e) !== "object")
    return !1;
  const t = Cu(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(zb in e) && !(us in e);
}, q0 = (e) => {
  if (!Xn(e) || Yn(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, H0 = Wt("Date"), G0 = Wt("File"), K0 = Wt("Blob"), J0 = Wt("FileList"), Z0 = (e) => Xn(e) && dt(e.pipe), Y0 = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || dt(e.append) && ((t = ds(e)) === "formdata" || // detect form-data instance
  t === "object" && dt(e.toString) && e.toString() === "[object FormData]"));
}, X0 = Wt("URLSearchParams"), [Q0, eC, tC, aC] = ["ReadableStream", "Request", "Response", "Headers"].map(Wt), oC = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Qn(e, t, { allOwnKeys: a = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let o, n;
  if (typeof e != "object" && (e = [e]), on(e))
    for (o = 0, n = e.length; o < n; o++)
      t.call(null, e[o], o, e);
  else {
    if (Yn(e))
      return;
    const r = a ? Object.getOwnPropertyNames(e) : Object.keys(e), i = r.length;
    let s;
    for (o = 0; o < i; o++)
      s = r[o], t.call(null, e[s], s, e);
  }
}
function Db(e, t) {
  if (Yn(e))
    return null;
  t = t.toLowerCase();
  const a = Object.keys(e);
  let o = a.length, n;
  for (; o-- > 0; )
    if (n = a[o], t === n.toLowerCase())
      return n;
  return null;
}
const Ha = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Nb = (e) => !Zo(e) && e !== Ha;
function sc() {
  const { caseless: e, skipUndefined: t } = Nb(this) && this || {}, a = {}, o = (n, r) => {
    const i = e && Db(a, r) || r;
    Xr(a[i]) && Xr(n) ? a[i] = sc(a[i], n) : Xr(n) ? a[i] = sc({}, n) : on(n) ? a[i] = n.slice() : (!t || !Zo(n)) && (a[i] = n);
  };
  for (let n = 0, r = arguments.length; n < r; n++)
    arguments[n] && Qn(arguments[n], o);
  return a;
}
const nC = (e, t, a, { allOwnKeys: o } = {}) => (Qn(t, (n, r) => {
  a && dt(n) ? e[r] = Ob(n, a) : e[r] = n;
}, { allOwnKeys: o }), e), rC = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), iC = (e, t, a, o) => {
  e.prototype = Object.create(t.prototype, o), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), a && Object.assign(e.prototype, a);
}, sC = (e, t, a, o) => {
  let n, r, i;
  const s = {};
  if (t = t || {}, e == null) return t;
  do {
    for (n = Object.getOwnPropertyNames(e), r = n.length; r-- > 0; )
      i = n[r], (!o || o(i, e, t)) && !s[i] && (t[i] = e[i], s[i] = !0);
    e = a !== !1 && Cu(e);
  } while (e && (!a || a(e, t)) && e !== Object.prototype);
  return t;
}, lC = (e, t, a) => {
  e = String(e), (a === void 0 || a > e.length) && (a = e.length), a -= t.length;
  const o = e.indexOf(t, a);
  return o !== -1 && o === a;
}, cC = (e) => {
  if (!e) return null;
  if (on(e)) return e;
  let t = e.length;
  if (!Pb(t)) return null;
  const a = new Array(t);
  for (; t-- > 0; )
    a[t] = e[t];
  return a;
}, uC = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && Cu(Uint8Array)), dC = (e, t) => {
  const a = (e && e[us]).call(e);
  let o;
  for (; (o = a.next()) && !o.done; ) {
    const n = o.value;
    t.call(e, n[0], n[1]);
  }
}, gC = (e, t) => {
  let a;
  const o = [];
  for (; (a = e.exec(t)) !== null; )
    o.push(a);
  return o;
}, hC = Wt("HTMLFormElement"), pC = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(t, a, o) {
    return a.toUpperCase() + o;
  }
), wg = (({ hasOwnProperty: e }) => (t, a) => e.call(t, a))(Object.prototype), mC = Wt("RegExp"), Rb = (e, t) => {
  const a = Object.getOwnPropertyDescriptors(e), o = {};
  Qn(a, (n, r) => {
    let i;
    (i = t(n, r, e)) !== !1 && (o[r] = i || n);
  }), Object.defineProperties(e, o);
}, fC = (e) => {
  Rb(e, (t, a) => {
    if (dt(e) && ["arguments", "caller", "callee"].indexOf(a) !== -1)
      return !1;
    const o = e[a];
    if (dt(o)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + a + "'");
      });
    }
  });
}, bC = (e, t) => {
  const a = {}, o = (n) => {
    n.forEach((r) => {
      a[r] = !0;
    });
  };
  return on(e) ? o(e) : o(String(e).split(t)), a;
}, _C = () => {
}, vC = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function yC(e) {
  return !!(e && dt(e.append) && e[zb] === "FormData" && e[us]);
}
const wC = (e) => {
  const t = new Array(10), a = (o, n) => {
    if (Xn(o)) {
      if (t.indexOf(o) >= 0)
        return;
      if (Yn(o))
        return o;
      if (!("toJSON" in o)) {
        t[n] = o;
        const r = on(o) ? [] : {};
        return Qn(o, (i, s) => {
          const l = a(i, n + 1);
          !Zo(l) && (r[s] = l);
        }), t[n] = void 0, r;
      }
    }
    return o;
  };
  return a(e, 0);
}, kC = Wt("AsyncFunction"), xC = (e) => e && (Xn(e) || dt(e)) && dt(e.then) && dt(e.catch), Ib = ((e, t) => e ? setImmediate : t ? ((a, o) => (Ha.addEventListener("message", ({ source: n, data: r }) => {
  n === Ha && r === a && o.length && o.shift()();
}, !1), (n) => {
  o.push(n), Ha.postMessage(a, "*");
}))(`axios@${Math.random()}`, []) : (a) => setTimeout(a))(
  typeof setImmediate == "function",
  dt(Ha.postMessage)
), $C = typeof queueMicrotask < "u" ? queueMicrotask.bind(Ha) : typeof process < "u" && process.nextTick || Ib, SC = (e) => e != null && dt(e[us]), P = {
  isArray: on,
  isArrayBuffer: Ab,
  isBuffer: Yn,
  isFormData: Y0,
  isArrayBufferView: F0,
  isString: V0,
  isNumber: Pb,
  isBoolean: U0,
  isObject: Xn,
  isPlainObject: Xr,
  isEmptyObject: q0,
  isReadableStream: Q0,
  isRequest: eC,
  isResponse: tC,
  isHeaders: aC,
  isUndefined: Zo,
  isDate: H0,
  isFile: G0,
  isBlob: K0,
  isRegExp: mC,
  isFunction: dt,
  isStream: Z0,
  isURLSearchParams: X0,
  isTypedArray: uC,
  isFileList: J0,
  forEach: Qn,
  merge: sc,
  extend: nC,
  trim: oC,
  stripBOM: rC,
  inherits: iC,
  toFlatObject: sC,
  kindOf: ds,
  kindOfTest: Wt,
  endsWith: lC,
  toArray: cC,
  forEachEntry: dC,
  matchAll: gC,
  isHTMLForm: hC,
  hasOwnProperty: wg,
  hasOwnProp: wg,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Rb,
  freezeMethods: fC,
  toObjectSet: bC,
  toCamelCase: pC,
  noop: _C,
  toFiniteNumber: vC,
  findKey: Db,
  global: Ha,
  isContextDefined: Nb,
  isSpecCompliantForm: yC,
  toJSONObject: wC,
  isAsyncFn: kC,
  isThenable: xC,
  setImmediate: Ib,
  asap: $C,
  isIterable: SC
};
function ge(e, t, a, o, n) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), a && (this.config = a), o && (this.request = o), n && (this.response = n, this.status = n.status ? n.status : null);
}
P.inherits(ge, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: P.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const Tb = ge.prototype, Lb = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  Lb[e] = { value: e };
});
Object.defineProperties(ge, Lb);
Object.defineProperty(Tb, "isAxiosError", { value: !0 });
ge.from = (e, t, a, o, n, r) => {
  const i = Object.create(Tb);
  P.toFlatObject(e, i, function(c) {
    return c !== Error.prototype;
  }, (c) => c !== "isAxiosError");
  const s = e && e.message ? e.message : "Error", l = t == null && e ? e.code : t;
  return ge.call(i, s, l, a, o, n), e && i.cause == null && Object.defineProperty(i, "cause", { value: e, configurable: !0 }), i.name = e && e.name || "Error", r && Object.assign(i, r), i;
};
const CC = null;
function lc(e) {
  return P.isPlainObject(e) || P.isArray(e);
}
function Mb(e) {
  return P.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function kg(e, t, a) {
  return e ? e.concat(t).map(function(o, n) {
    return o = Mb(o), !a && n ? "[" + o + "]" : o;
  }).join(a ? "." : "") : t;
}
function EC(e) {
  return P.isArray(e) && !e.some(lc);
}
const jC = P.toFlatObject(P, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function hs(e, t, a) {
  if (!P.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), a = P.toFlatObject(a, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(m, f) {
    return !P.isUndefined(f[m]);
  });
  const o = a.metaTokens, n = a.visitor || c, r = a.dots, i = a.indexes, s = (a.Blob || typeof Blob < "u" && Blob) && P.isSpecCompliantForm(t);
  if (!P.isFunction(n))
    throw new TypeError("visitor must be a function");
  function l(m) {
    if (m === null) return "";
    if (P.isDate(m))
      return m.toISOString();
    if (P.isBoolean(m))
      return m.toString();
    if (!s && P.isBlob(m))
      throw new ge("Blob is not supported. Use a Buffer instead.");
    return P.isArrayBuffer(m) || P.isTypedArray(m) ? s && typeof Blob == "function" ? new Blob([m]) : Buffer.from(m) : m;
  }
  function c(m, f, p) {
    let b = m;
    if (m && !p && typeof m == "object") {
      if (P.endsWith(f, "{}"))
        f = o ? f : f.slice(0, -2), m = JSON.stringify(m);
      else if (P.isArray(m) && EC(m) || (P.isFileList(m) || P.endsWith(f, "[]")) && (b = P.toArray(m)))
        return f = Mb(f), b.forEach(function(w, _) {
          !(P.isUndefined(w) || w === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            i === !0 ? kg([f], _, r) : i === null ? f : f + "[]",
            l(w)
          );
        }), !1;
    }
    return lc(m) ? !0 : (t.append(kg(p, f, r), l(m)), !1);
  }
  const u = [], d = Object.assign(jC, {
    defaultVisitor: c,
    convertValue: l,
    isVisitable: lc
  });
  function h(m, f) {
    if (!P.isUndefined(m)) {
      if (u.indexOf(m) !== -1)
        throw Error("Circular reference detected in " + f.join("."));
      u.push(m), P.forEach(m, function(p, b) {
        (!(P.isUndefined(p) || p === null) && n.call(
          t,
          p,
          P.isString(b) ? b.trim() : b,
          f,
          d
        )) === !0 && h(p, f ? f.concat(b) : [b]);
      }), u.pop();
    }
  }
  if (!P.isObject(e))
    throw new TypeError("data must be an object");
  return h(e), t;
}
function xg(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(a) {
    return t[a];
  });
}
function Eu(e, t) {
  this._pairs = [], e && hs(e, this, t);
}
const Wb = Eu.prototype;
Wb.append = function(e, t) {
  this._pairs.push([e, t]);
};
Wb.toString = function(e) {
  const t = e ? function(a) {
    return e.call(this, a, xg);
  } : xg;
  return this._pairs.map(function(a) {
    return t(a[0]) + "=" + t(a[1]);
  }, "").join("&");
};
function OC(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Bb(e, t, a) {
  if (!t)
    return e;
  const o = a && a.encode || OC;
  P.isFunction(a) && (a = {
    serialize: a
  });
  const n = a && a.serialize;
  let r;
  if (n ? r = n(t, a) : r = P.isURLSearchParams(t) ? t.toString() : new Eu(t, a).toString(o), r) {
    const i = e.indexOf("#");
    i !== -1 && (e = e.slice(0, i)), e += (e.indexOf("?") === -1 ? "?" : "&") + r;
  }
  return e;
}
let $g = class {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, a, o) {
    return this.handlers.push({
      fulfilled: t,
      rejected: a,
      synchronous: o ? o.synchronous : !1,
      runWhen: o ? o.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    P.forEach(this.handlers, function(a) {
      a !== null && t(a);
    });
  }
};
const Fb = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, zC = typeof URLSearchParams < "u" ? URLSearchParams : Eu, AC = typeof FormData < "u" ? FormData : null, PC = typeof Blob < "u" ? Blob : null, DC = {
  isBrowser: !0,
  classes: {
    URLSearchParams: zC,
    FormData: AC,
    Blob: PC
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, ju = typeof window < "u" && typeof document < "u", cc = typeof navigator == "object" && navigator || void 0, NC = ju && (!cc || ["ReactNative", "NativeScript", "NS"].indexOf(cc.product) < 0), RC = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", IC = ju && window.location.href || "http://localhost", TC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: ju,
  hasStandardBrowserEnv: NC,
  hasStandardBrowserWebWorkerEnv: RC,
  navigator: cc,
  origin: IC
}, Symbol.toStringTag, { value: "Module" })), tt = {
  ...TC,
  ...DC
};
function LC(e, t) {
  return hs(e, new tt.classes.URLSearchParams(), {
    visitor: function(a, o, n, r) {
      return tt.isNode && P.isBuffer(a) ? (this.append(o, a.toString("base64")), !1) : r.defaultVisitor.apply(this, arguments);
    },
    ...t
  });
}
function MC(e) {
  return P.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function WC(e) {
  const t = {}, a = Object.keys(e);
  let o;
  const n = a.length;
  let r;
  for (o = 0; o < n; o++)
    r = a[o], t[r] = e[r];
  return t;
}
function Vb(e) {
  function t(a, o, n, r) {
    let i = a[r++];
    if (i === "__proto__") return !0;
    const s = Number.isFinite(+i), l = r >= a.length;
    return i = !i && P.isArray(n) ? n.length : i, l ? (P.hasOwnProp(n, i) ? n[i] = [n[i], o] : n[i] = o, !s) : ((!n[i] || !P.isObject(n[i])) && (n[i] = []), t(a, o, n[i], r) && P.isArray(n[i]) && (n[i] = WC(n[i])), !s);
  }
  if (P.isFormData(e) && P.isFunction(e.entries)) {
    const a = {};
    return P.forEachEntry(e, (o, n) => {
      t(MC(o), n, a, 0);
    }), a;
  }
  return null;
}
function BC(e, t, a) {
  if (P.isString(e))
    try {
      return (t || JSON.parse)(e), P.trim(e);
    } catch (o) {
      if (o.name !== "SyntaxError")
        throw o;
    }
  return (a || JSON.stringify)(e);
}
const er = {
  transitional: Fb,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, t) {
    const a = t.getContentType() || "", o = a.indexOf("application/json") > -1, n = P.isObject(e);
    if (n && P.isHTMLForm(e) && (e = new FormData(e)), P.isFormData(e))
      return o ? JSON.stringify(Vb(e)) : e;
    if (P.isArrayBuffer(e) || P.isBuffer(e) || P.isStream(e) || P.isFile(e) || P.isBlob(e) || P.isReadableStream(e))
      return e;
    if (P.isArrayBufferView(e))
      return e.buffer;
    if (P.isURLSearchParams(e))
      return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let r;
    if (n) {
      if (a.indexOf("application/x-www-form-urlencoded") > -1)
        return LC(e, this.formSerializer).toString();
      if ((r = P.isFileList(e)) || a.indexOf("multipart/form-data") > -1) {
        const i = this.env && this.env.FormData;
        return hs(
          r ? { "files[]": e } : e,
          i && new i(),
          this.formSerializer
        );
      }
    }
    return n || o ? (t.setContentType("application/json", !1), BC(e)) : e;
  }],
  transformResponse: [function(e) {
    const t = this.transitional || er.transitional, a = t && t.forcedJSONParsing, o = this.responseType === "json";
    if (P.isResponse(e) || P.isReadableStream(e))
      return e;
    if (e && P.isString(e) && (a && !this.responseType || o)) {
      const n = !(t && t.silentJSONParsing) && o;
      try {
        return JSON.parse(e, this.parseReviver);
      } catch (r) {
        if (n)
          throw r.name === "SyntaxError" ? ge.from(r, ge.ERR_BAD_RESPONSE, this, null, this.response) : r;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: tt.classes.FormData,
    Blob: tt.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
P.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  er.headers[e] = {};
});
const FC = P.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), VC = (e) => {
  const t = {};
  let a, o, n;
  return e && e.split(`
`).forEach(function(r) {
    n = r.indexOf(":"), a = r.substring(0, n).trim().toLowerCase(), o = r.substring(n + 1).trim(), !(!a || t[a] && FC[a]) && (a === "set-cookie" ? t[a] ? t[a].push(o) : t[a] = [o] : t[a] = t[a] ? t[a] + ", " + o : o);
  }), t;
}, Sg = Symbol("internals");
function fn(e) {
  return e && String(e).trim().toLowerCase();
}
function Qr(e) {
  return e === !1 || e == null ? e : P.isArray(e) ? e.map(Qr) : String(e);
}
function UC(e) {
  const t = /* @__PURE__ */ Object.create(null), a = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let o;
  for (; o = a.exec(e); )
    t[o[1]] = o[2];
  return t;
}
const qC = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function rl(e, t, a, o, n) {
  if (P.isFunction(o))
    return o.call(this, t, a);
  if (n && (t = a), !!P.isString(t)) {
    if (P.isString(o))
      return t.indexOf(o) !== -1;
    if (P.isRegExp(o))
      return o.test(t);
  }
}
function HC(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, a, o) => a.toUpperCase() + o);
}
function GC(e, t) {
  const a = P.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((o) => {
    Object.defineProperty(e, o + a, {
      value: function(n, r, i) {
        return this[o].call(this, t, n, r, i);
      },
      configurable: !0
    });
  });
}
let gt = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, a, o) {
    const n = this;
    function r(s, l, c) {
      const u = fn(l);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const d = P.findKey(n, u);
      (!d || n[d] === void 0 || c === !0 || c === void 0 && n[d] !== !1) && (n[d || l] = Qr(s));
    }
    const i = (s, l) => P.forEach(s, (c, u) => r(c, u, l));
    if (P.isPlainObject(t) || t instanceof this.constructor)
      i(t, a);
    else if (P.isString(t) && (t = t.trim()) && !qC(t))
      i(VC(t), a);
    else if (P.isObject(t) && P.isIterable(t)) {
      let s = {}, l, c;
      for (const u of t) {
        if (!P.isArray(u))
          throw TypeError("Object iterator must return a key-value pair");
        s[c = u[0]] = (l = s[c]) ? P.isArray(l) ? [...l, u[1]] : [l, u[1]] : u[1];
      }
      i(s, a);
    } else
      t != null && r(a, t, o);
    return this;
  }
  get(t, a) {
    if (t = fn(t), t) {
      const o = P.findKey(this, t);
      if (o) {
        const n = this[o];
        if (!a)
          return n;
        if (a === !0)
          return UC(n);
        if (P.isFunction(a))
          return a.call(this, n, o);
        if (P.isRegExp(a))
          return a.exec(n);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, a) {
    if (t = fn(t), t) {
      const o = P.findKey(this, t);
      return !!(o && this[o] !== void 0 && (!a || rl(this, this[o], o, a)));
    }
    return !1;
  }
  delete(t, a) {
    const o = this;
    let n = !1;
    function r(i) {
      if (i = fn(i), i) {
        const s = P.findKey(o, i);
        s && (!a || rl(o, o[s], s, a)) && (delete o[s], n = !0);
      }
    }
    return P.isArray(t) ? t.forEach(r) : r(t), n;
  }
  clear(t) {
    const a = Object.keys(this);
    let o = a.length, n = !1;
    for (; o--; ) {
      const r = a[o];
      (!t || rl(this, this[r], r, t, !0)) && (delete this[r], n = !0);
    }
    return n;
  }
  normalize(t) {
    const a = this, o = {};
    return P.forEach(this, (n, r) => {
      const i = P.findKey(o, r);
      if (i) {
        a[i] = Qr(n), delete a[r];
        return;
      }
      const s = t ? HC(r) : String(r).trim();
      s !== r && delete a[r], a[s] = Qr(n), o[s] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const a = /* @__PURE__ */ Object.create(null);
    return P.forEach(this, (o, n) => {
      o != null && o !== !1 && (a[n] = t && P.isArray(o) ? o.join(", ") : o);
    }), a;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, a]) => t + ": " + a).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...a) {
    const o = new this(t);
    return a.forEach((n) => o.set(n)), o;
  }
  static accessor(t) {
    const a = (this[Sg] = this[Sg] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function n(r) {
      const i = fn(r);
      a[i] || (GC(o, r), a[i] = !0);
    }
    return P.isArray(t) ? t.forEach(n) : n(t), this;
  }
};
gt.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
P.reduceDescriptors(gt.prototype, ({ value: e }, t) => {
  let a = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(o) {
      this[a] = o;
    }
  };
});
P.freezeMethods(gt);
function il(e, t) {
  const a = this || er, o = t || a, n = gt.from(o.headers);
  let r = o.data;
  return P.forEach(e, function(i) {
    r = i.call(a, r, n.normalize(), t ? t.status : void 0);
  }), n.normalize(), r;
}
function Ub(e) {
  return !!(e && e.__CANCEL__);
}
function nn(e, t, a) {
  ge.call(this, e ?? "canceled", ge.ERR_CANCELED, t, a), this.name = "CanceledError";
}
P.inherits(nn, ge, {
  __CANCEL__: !0
});
function qb(e, t, a) {
  const o = a.config.validateStatus;
  !a.status || !o || o(a.status) ? e(a) : t(new ge(
    "Request failed with status code " + a.status,
    [ge.ERR_BAD_REQUEST, ge.ERR_BAD_RESPONSE][Math.floor(a.status / 100) - 4],
    a.config,
    a.request,
    a
  ));
}
function KC(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function JC(e, t) {
  e = e || 10;
  const a = new Array(e), o = new Array(e);
  let n = 0, r = 0, i;
  return t = t !== void 0 ? t : 1e3, function(s) {
    const l = Date.now(), c = o[r];
    i || (i = l), a[n] = s, o[n] = l;
    let u = r, d = 0;
    for (; u !== n; )
      d += a[u++], u = u % e;
    if (n = (n + 1) % e, n === r && (r = (r + 1) % e), l - i < t)
      return;
    const h = c && l - c;
    return h ? Math.round(d * 1e3 / h) : void 0;
  };
}
function ZC(e, t) {
  let a = 0, o = 1e3 / t, n, r;
  const i = (s, l = Date.now()) => {
    a = l, n = null, r && (clearTimeout(r), r = null), e(...s);
  };
  return [(...s) => {
    const l = Date.now(), c = l - a;
    c >= o ? i(s, l) : (n = s, r || (r = setTimeout(() => {
      r = null, i(n);
    }, o - c)));
  }, () => n && i(n)];
}
const xi = (e, t, a = 3) => {
  let o = 0;
  const n = JC(50, 250);
  return ZC((r) => {
    const i = r.loaded, s = r.lengthComputable ? r.total : void 0, l = i - o, c = n(l), u = i <= s;
    o = i;
    const d = {
      loaded: i,
      total: s,
      progress: s ? i / s : void 0,
      bytes: l,
      rate: c || void 0,
      estimated: c && s && u ? (s - i) / c : void 0,
      event: r,
      lengthComputable: s != null,
      [t ? "download" : "upload"]: !0
    };
    e(d);
  }, a);
}, Cg = (e, t) => {
  const a = e != null;
  return [(o) => t[0]({
    lengthComputable: a,
    total: e,
    loaded: o
  }), t[1]];
}, Eg = (e) => (...t) => P.asap(() => e(...t)), YC = tt.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (a) => (a = new URL(a, tt.origin), e.protocol === a.protocol && e.host === a.host && (t || e.port === a.port)))(
  new URL(tt.origin),
  tt.navigator && /(msie|trident)/i.test(tt.navigator.userAgent)
) : () => !0, XC = tt.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, a, o, n, r) {
      const i = [e + "=" + encodeURIComponent(t)];
      P.isNumber(a) && i.push("expires=" + new Date(a).toGMTString()), P.isString(o) && i.push("path=" + o), P.isString(n) && i.push("domain=" + n), r === !0 && i.push("secure"), document.cookie = i.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function QC(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function eE(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Hb(e, t, a) {
  let o = !QC(t);
  return e && (o || a == !1) ? eE(e, t) : t;
}
const jg = (e) => e instanceof gt ? { ...e } : e;
function to(e, t) {
  t = t || {};
  const a = {};
  function o(c, u, d, h) {
    return P.isPlainObject(c) && P.isPlainObject(u) ? P.merge.call({ caseless: h }, c, u) : P.isPlainObject(u) ? P.merge({}, u) : P.isArray(u) ? u.slice() : u;
  }
  function n(c, u, d, h) {
    if (P.isUndefined(u)) {
      if (!P.isUndefined(c))
        return o(void 0, c, d, h);
    } else return o(c, u, d, h);
  }
  function r(c, u) {
    if (!P.isUndefined(u))
      return o(void 0, u);
  }
  function i(c, u) {
    if (P.isUndefined(u)) {
      if (!P.isUndefined(c))
        return o(void 0, c);
    } else return o(void 0, u);
  }
  function s(c, u, d) {
    if (d in t)
      return o(c, u);
    if (d in e)
      return o(void 0, c);
  }
  const l = {
    url: r,
    method: r,
    data: r,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    withXSRFToken: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: s,
    headers: (c, u, d) => n(jg(c), jg(u), d, !0)
  };
  return P.forEach(Object.keys({ ...e, ...t }), function(c) {
    const u = l[c] || n, d = u(e[c], t[c], c);
    P.isUndefined(d) && u !== s || (a[c] = d);
  }), a;
}
const Gb = (e) => {
  const t = to({}, e);
  let { data: a, withXSRFToken: o, xsrfHeaderName: n, xsrfCookieName: r, headers: i, auth: s } = t;
  if (t.headers = i = gt.from(i), t.url = Bb(Hb(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), s && i.set(
    "Authorization",
    "Basic " + btoa((s.username || "") + ":" + (s.password ? unescape(encodeURIComponent(s.password)) : ""))
  ), P.isFormData(a)) {
    if (tt.hasStandardBrowserEnv || tt.hasStandardBrowserWebWorkerEnv)
      i.setContentType(void 0);
    else if (P.isFunction(a.getHeaders)) {
      const l = a.getHeaders(), c = ["content-type", "content-length"];
      Object.entries(l).forEach(([u, d]) => {
        c.includes(u.toLowerCase()) && i.set(u, d);
      });
    }
  }
  if (tt.hasStandardBrowserEnv && (o && P.isFunction(o) && (o = o(t)), o || o !== !1 && YC(t.url))) {
    const l = n && r && XC.read(r);
    l && i.set(n, l);
  }
  return t;
}, tE = typeof XMLHttpRequest < "u", aE = tE && function(e) {
  return new Promise(function(t, a) {
    const o = Gb(e);
    let n = o.data;
    const r = gt.from(o.headers).normalize();
    let { responseType: i, onUploadProgress: s, onDownloadProgress: l } = o, c, u, d, h, m;
    function f() {
      h && h(), m && m(), o.cancelToken && o.cancelToken.unsubscribe(c), o.signal && o.signal.removeEventListener("abort", c);
    }
    let p = new XMLHttpRequest();
    p.open(o.method.toUpperCase(), o.url, !0), p.timeout = o.timeout;
    function b() {
      if (!p)
        return;
      const _ = gt.from(
        "getAllResponseHeaders" in p && p.getAllResponseHeaders()
      ), y = {
        data: !i || i === "text" || i === "json" ? p.responseText : p.response,
        status: p.status,
        statusText: p.statusText,
        headers: _,
        config: e,
        request: p
      };
      qb(function(k) {
        t(k), f();
      }, function(k) {
        a(k), f();
      }, y), p = null;
    }
    "onloadend" in p ? p.onloadend = b : p.onreadystatechange = function() {
      !p || p.readyState !== 4 || p.status === 0 && !(p.responseURL && p.responseURL.indexOf("file:") === 0) || setTimeout(b);
    }, p.onabort = function() {
      p && (a(new ge("Request aborted", ge.ECONNABORTED, e, p)), p = null);
    }, p.onerror = function(_) {
      const y = _ && _.message ? _.message : "Network Error", k = new ge(y, ge.ERR_NETWORK, e, p);
      k.event = _ || null, a(k), p = null;
    }, p.ontimeout = function() {
      let _ = o.timeout ? "timeout of " + o.timeout + "ms exceeded" : "timeout exceeded";
      const y = o.transitional || Fb;
      o.timeoutErrorMessage && (_ = o.timeoutErrorMessage), a(new ge(
        _,
        y.clarifyTimeoutError ? ge.ETIMEDOUT : ge.ECONNABORTED,
        e,
        p
      )), p = null;
    }, n === void 0 && r.setContentType(null), "setRequestHeader" in p && P.forEach(r.toJSON(), function(_, y) {
      p.setRequestHeader(y, _);
    }), P.isUndefined(o.withCredentials) || (p.withCredentials = !!o.withCredentials), i && i !== "json" && (p.responseType = o.responseType), l && ([d, m] = xi(l, !0), p.addEventListener("progress", d)), s && p.upload && ([u, h] = xi(s), p.upload.addEventListener("progress", u), p.upload.addEventListener("loadend", h)), (o.cancelToken || o.signal) && (c = (_) => {
      p && (a(!_ || _.type ? new nn(null, e, p) : _), p.abort(), p = null);
    }, o.cancelToken && o.cancelToken.subscribe(c), o.signal && (o.signal.aborted ? c() : o.signal.addEventListener("abort", c)));
    const w = KC(o.url);
    if (w && tt.protocols.indexOf(w) === -1) {
      a(new ge("Unsupported protocol " + w + ":", ge.ERR_BAD_REQUEST, e));
      return;
    }
    p.send(n || null);
  });
}, oE = (e, t) => {
  const { length: a } = e = e ? e.filter(Boolean) : [];
  if (t || a) {
    let o = new AbortController(), n;
    const r = function(c) {
      if (!n) {
        n = !0, s();
        const u = c instanceof Error ? c : this.reason;
        o.abort(u instanceof ge ? u : new nn(u instanceof Error ? u.message : u));
      }
    };
    let i = t && setTimeout(() => {
      i = null, r(new ge(`timeout ${t} of ms exceeded`, ge.ETIMEDOUT));
    }, t);
    const s = () => {
      e && (i && clearTimeout(i), i = null, e.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(r) : c.removeEventListener("abort", r);
      }), e = null);
    };
    e.forEach((c) => c.addEventListener("abort", r));
    const { signal: l } = o;
    return l.unsubscribe = () => P.asap(s), l;
  }
}, nE = function* (e, t) {
  let a = e.byteLength;
  if (a < t) {
    yield e;
    return;
  }
  let o = 0, n;
  for (; o < a; )
    n = o + t, yield e.slice(o, n), o = n;
}, rE = async function* (e, t) {
  for await (const a of iE(e))
    yield* nE(a, t);
}, iE = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: a, value: o } = await t.read();
      if (a)
        break;
      yield o;
    }
  } finally {
    await t.cancel();
  }
}, Og = (e, t, a, o) => {
  const n = rE(e, t);
  let r = 0, i, s = (l) => {
    i || (i = !0, o && o(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: c, value: u } = await n.next();
        if (c) {
          s(), l.close();
          return;
        }
        let d = u.byteLength;
        if (a) {
          let h = r += d;
          a(h);
        }
        l.enqueue(new Uint8Array(u));
      } catch (c) {
        throw s(c), c;
      }
    },
    cancel(l) {
      return s(l), n.return();
    }
  }, {
    highWaterMark: 2
  });
}, zg = 64 * 1024, { isFunction: vr } = P, sE = (({ Request: e, Response: t }) => ({
  Request: e,
  Response: t
}))(P.global), {
  ReadableStream: Ag,
  TextEncoder: Pg
} = P.global, Dg = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, lE = (e) => {
  e = P.merge.call({
    skipUndefined: !0
  }, sE, e);
  const { fetch: t, Request: a, Response: o } = e, n = t ? vr(t) : typeof fetch == "function", r = vr(a), i = vr(o);
  if (!n)
    return !1;
  const s = n && vr(Ag), l = n && (typeof Pg == "function" ? /* @__PURE__ */ ((f) => (p) => f.encode(p))(new Pg()) : async (f) => new Uint8Array(await new a(f).arrayBuffer())), c = r && s && Dg(() => {
    let f = !1;
    const p = new a(tt.origin, {
      body: new Ag(),
      method: "POST",
      get duplex() {
        return f = !0, "half";
      }
    }).headers.has("Content-Type");
    return f && !p;
  }), u = i && s && Dg(() => P.isReadableStream(new o("").body)), d = {
    stream: u && ((f) => f.body)
  };
  n && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((f) => {
    !d[f] && (d[f] = (p, b) => {
      let w = p && p[f];
      if (w)
        return w.call(p);
      throw new ge(`Response type '${f}' is not supported`, ge.ERR_NOT_SUPPORT, b);
    });
  });
  const h = async (f) => {
    if (f == null)
      return 0;
    if (P.isBlob(f))
      return f.size;
    if (P.isSpecCompliantForm(f))
      return (await new a(tt.origin, {
        method: "POST",
        body: f
      }).arrayBuffer()).byteLength;
    if (P.isArrayBufferView(f) || P.isArrayBuffer(f))
      return f.byteLength;
    if (P.isURLSearchParams(f) && (f = f + ""), P.isString(f))
      return (await l(f)).byteLength;
  }, m = async (f, p) => P.toFiniteNumber(f.getContentLength()) ?? h(p);
  return async (f) => {
    let {
      url: p,
      method: b,
      data: w,
      signal: _,
      cancelToken: y,
      timeout: k,
      onDownloadProgress: x,
      onUploadProgress: S,
      responseType: $,
      headers: E,
      withCredentials: C = "same-origin",
      fetchOptions: j
    } = Gb(f), R = t || fetch;
    $ = $ ? ($ + "").toLowerCase() : "text";
    let H = oE([_, y && y.toAbortSignal()], k), L = null;
    const O = H && H.unsubscribe && (() => {
      H.unsubscribe();
    });
    let U;
    try {
      if (S && c && b !== "get" && b !== "head" && (U = await m(E, w)) !== 0) {
        let z = new a(p, {
          method: "POST",
          body: w,
          duplex: "half"
        }), N;
        if (P.isFormData(w) && (N = z.headers.get("content-type")) && E.setContentType(N), z.body) {
          const [B, W] = Cg(
            U,
            xi(Eg(S))
          );
          w = Og(z.body, zg, B, W);
        }
      }
      P.isString(C) || (C = C ? "include" : "omit");
      const I = r && "credentials" in a.prototype, K = {
        ...j,
        signal: H,
        method: b.toUpperCase(),
        headers: E.normalize().toJSON(),
        body: w,
        duplex: "half",
        credentials: I ? C : void 0
      };
      L = r && new a(p, K);
      let q = await (r ? R(L, j) : R(p, K));
      const te = u && ($ === "stream" || $ === "response");
      if (u && (x || te && O)) {
        const z = {};
        ["status", "statusText", "headers"].forEach((Z) => {
          z[Z] = q[Z];
        });
        const N = P.toFiniteNumber(q.headers.get("content-length")), [B, W] = x && Cg(
          N,
          xi(Eg(x), !0)
        ) || [];
        q = new o(
          Og(q.body, zg, B, () => {
            W && W(), O && O();
          }),
          z
        );
      }
      $ = $ || "text";
      let A = await d[P.findKey(d, $) || "text"](q, f);
      return !te && O && O(), await new Promise((z, N) => {
        qb(z, N, {
          data: A,
          headers: gt.from(q.headers),
          status: q.status,
          statusText: q.statusText,
          config: f,
          request: L
        });
      });
    } catch (I) {
      throw O && O(), I && I.name === "TypeError" && /Load failed|fetch/i.test(I.message) ? Object.assign(
        new ge("Network Error", ge.ERR_NETWORK, f, L),
        {
          cause: I.cause || I
        }
      ) : ge.from(I, I && I.code, f, L);
    }
  };
}, cE = /* @__PURE__ */ new Map(), Kb = (e) => {
  let t = e ? e.env : {};
  const { fetch: a, Request: o, Response: n } = t, r = [
    o,
    n,
    a
  ];
  let i = r.length, s = i, l, c, u = cE;
  for (; s--; )
    l = r[s], c = u.get(l), c === void 0 && u.set(l, c = s ? /* @__PURE__ */ new Map() : lE(t)), u = c;
  return c;
};
Kb();
const uc = {
  http: CC,
  xhr: aE,
  fetch: {
    get: Kb
  }
};
P.forEach(uc, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Ng = (e) => `- ${e}`, uE = (e) => P.isFunction(e) || e === null || e === !1, Jb = {
  getAdapter: (e, t) => {
    e = P.isArray(e) ? e : [e];
    const { length: a } = e;
    let o, n;
    const r = {};
    for (let i = 0; i < a; i++) {
      o = e[i];
      let s;
      if (n = o, !uE(o) && (n = uc[(s = String(o)).toLowerCase()], n === void 0))
        throw new ge(`Unknown adapter '${s}'`);
      if (n && (P.isFunction(n) || (n = n.get(t))))
        break;
      r[s || "#" + i] = n;
    }
    if (!n) {
      const i = Object.entries(r).map(
        ([l, c]) => `adapter ${l} ` + (c === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let s = a ? i.length > 1 ? `since :
` + i.map(Ng).join(`
`) : " " + Ng(i[0]) : "as no adapter specified";
      throw new ge(
        "There is no suitable adapter to dispatch the request " + s,
        "ERR_NOT_SUPPORT"
      );
    }
    return n;
  },
  adapters: uc
};
function sl(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new nn(null, e);
}
function Rg(e) {
  return sl(e), e.headers = gt.from(e.headers), e.data = il.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Jb.getAdapter(e.adapter || er.adapter, e)(e).then(function(t) {
    return sl(e), t.data = il.call(
      e,
      e.transformResponse,
      t
    ), t.headers = gt.from(t.headers), t;
  }, function(t) {
    return Ub(t) || (sl(e), t && t.response && (t.response.data = il.call(
      e,
      e.transformResponse,
      t.response
    ), t.response.headers = gt.from(t.response.headers))), Promise.reject(t);
  });
}
const Zb = "1.12.2", ps = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  ps[e] = function(a) {
    return typeof a === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Ig = {};
ps.transitional = function(e, t, a) {
  function o(n, r) {
    return "[Axios v" + Zb + "] Transitional option '" + n + "'" + r + (a ? ". " + a : "");
  }
  return (n, r, i) => {
    if (e === !1)
      throw new ge(
        o(r, " has been removed" + (t ? " in " + t : "")),
        ge.ERR_DEPRECATED
      );
    return t && !Ig[r] && (Ig[r] = !0, console.warn(
      o(
        r,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), e ? e(n, r, i) : !0;
  };
};
ps.spelling = function(e) {
  return (t, a) => (console.warn(`${a} is likely a misspelling of ${e}`), !0);
};
function dE(e, t, a) {
  if (typeof e != "object")
    throw new ge("options must be an object", ge.ERR_BAD_OPTION_VALUE);
  const o = Object.keys(e);
  let n = o.length;
  for (; n-- > 0; ) {
    const r = o[n], i = t[r];
    if (i) {
      const s = e[r], l = s === void 0 || i(s, r, e);
      if (l !== !0)
        throw new ge("option " + r + " must be " + l, ge.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (a !== !0)
      throw new ge("Unknown option " + r, ge.ERR_BAD_OPTION);
  }
}
const ei = {
  assertOptions: dE,
  validators: ps
}, Ut = ei.validators;
let Xa = class {
  constructor(t) {
    this.defaults = t || {}, this.interceptors = {
      request: new $g(),
      response: new $g()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, a) {
    try {
      return await this._request(t, a);
    } catch (o) {
      if (o instanceof Error) {
        let n = {};
        Error.captureStackTrace ? Error.captureStackTrace(n) : n = new Error();
        const r = n.stack ? n.stack.replace(/^.+\n/, "") : "";
        try {
          o.stack ? r && !String(o.stack).endsWith(r.replace(/^.+\n.+\n/, "")) && (o.stack += `
` + r) : o.stack = r;
        } catch {
        }
      }
      throw o;
    }
  }
  _request(t, a) {
    typeof t == "string" ? (a = a || {}, a.url = t) : a = t || {}, a = to(this.defaults, a);
    const { transitional: o, paramsSerializer: n, headers: r } = a;
    o !== void 0 && ei.assertOptions(o, {
      silentJSONParsing: Ut.transitional(Ut.boolean),
      forcedJSONParsing: Ut.transitional(Ut.boolean),
      clarifyTimeoutError: Ut.transitional(Ut.boolean)
    }, !1), n != null && (P.isFunction(n) ? a.paramsSerializer = {
      serialize: n
    } : ei.assertOptions(n, {
      encode: Ut.function,
      serialize: Ut.function
    }, !0)), a.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? a.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : a.allowAbsoluteUrls = !0), ei.assertOptions(a, {
      baseUrl: Ut.spelling("baseURL"),
      withXsrfToken: Ut.spelling("withXSRFToken")
    }, !0), a.method = (a.method || this.defaults.method || "get").toLowerCase();
    let i = r && P.merge(
      r.common,
      r[a.method]
    );
    r && P.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (f) => {
        delete r[f];
      }
    ), a.headers = gt.concat(i, r);
    const s = [];
    let l = !0;
    this.interceptors.request.forEach(function(f) {
      typeof f.runWhen == "function" && f.runWhen(a) === !1 || (l = l && f.synchronous, s.unshift(f.fulfilled, f.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(f) {
      c.push(f.fulfilled, f.rejected);
    });
    let u, d = 0, h;
    if (!l) {
      const f = [Rg.bind(this), void 0];
      for (f.unshift(...s), f.push(...c), h = f.length, u = Promise.resolve(a); d < h; )
        u = u.then(f[d++], f[d++]);
      return u;
    }
    h = s.length;
    let m = a;
    for (; d < h; ) {
      const f = s[d++], p = s[d++];
      try {
        m = f(m);
      } catch (b) {
        p.call(this, b);
        break;
      }
    }
    try {
      u = Rg.call(this, m);
    } catch (f) {
      return Promise.reject(f);
    }
    for (d = 0, h = c.length; d < h; )
      u = u.then(c[d++], c[d++]);
    return u;
  }
  getUri(t) {
    t = to(this.defaults, t);
    const a = Hb(t.baseURL, t.url, t.allowAbsoluteUrls);
    return Bb(a, t.params, t.paramsSerializer);
  }
};
P.forEach(["delete", "get", "head", "options"], function(e) {
  Xa.prototype[e] = function(t, a) {
    return this.request(to(a || {}, {
      method: e,
      url: t,
      data: (a || {}).data
    }));
  };
});
P.forEach(["post", "put", "patch"], function(e) {
  function t(a) {
    return function(o, n, r) {
      return this.request(to(r || {}, {
        method: e,
        headers: a ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: n
      }));
    };
  }
  Xa.prototype[e] = t(), Xa.prototype[e + "Form"] = t(!0);
});
let gE = class Yb {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let a;
    this.promise = new Promise(function(n) {
      a = n;
    });
    const o = this;
    this.promise.then((n) => {
      if (!o._listeners) return;
      let r = o._listeners.length;
      for (; r-- > 0; )
        o._listeners[r](n);
      o._listeners = null;
    }), this.promise.then = (n) => {
      let r;
      const i = new Promise((s) => {
        o.subscribe(s), r = s;
      }).then(n);
      return i.cancel = function() {
        o.unsubscribe(r);
      }, i;
    }, t(function(n, r, i) {
      o.reason || (o.reason = new nn(n, r, i), a(o.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const a = this._listeners.indexOf(t);
    a !== -1 && this._listeners.splice(a, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), a = (o) => {
      t.abort(o);
    };
    return this.subscribe(a), t.signal.unsubscribe = () => this.unsubscribe(a), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Yb(function(a) {
        t = a;
      }),
      cancel: t
    };
  }
};
function hE(e) {
  return function(t) {
    return e.apply(null, t);
  };
}
function pE(e) {
  return P.isObject(e) && e.isAxiosError === !0;
}
const dc = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(dc).forEach(([e, t]) => {
  dc[t] = e;
});
function Xb(e) {
  const t = new Xa(e), a = Ob(Xa.prototype.request, t);
  return P.extend(a, Xa.prototype, t, { allOwnKeys: !0 }), P.extend(a, t, null, { allOwnKeys: !0 }), a.create = function(o) {
    return Xb(to(e, o));
  }, a;
}
const Be = Xb(er);
Be.Axios = Xa;
Be.CanceledError = nn;
Be.CancelToken = gE;
Be.isCancel = Ub;
Be.VERSION = Zb;
Be.toFormData = hs;
Be.AxiosError = ge;
Be.Cancel = Be.CanceledError;
Be.all = function(e) {
  return Promise.all(e);
};
Be.spread = hE;
Be.isAxiosError = pE;
Be.mergeConfig = to;
Be.AxiosHeaders = gt;
Be.formToJSON = (e) => Vb(P.isHTMLForm(e) ? new FormData(e) : e);
Be.getAdapter = Jb.getAdapter;
Be.HttpStatusCode = dc;
Be.default = Be;
const {
  Axios: prt,
  AxiosError: mE,
  CanceledError: mrt,
  isCancel: frt,
  CancelToken: brt,
  VERSION: _rt,
  all: vrt,
  Cancel: yrt,
  isAxiosError: wrt,
  spread: krt,
  toFormData: xrt,
  AxiosHeaders: $rt,
  HttpStatusCode: Srt,
  formToJSON: Crt,
  getAdapter: Ert,
  mergeConfig: jrt
} = Be, fE = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_,+.~#?&/=]*)$/;
let Qb = class {
  baseUrl;
  headers;
  constructor(t, a = {}) {
    this.baseUrl = t, this.headers = a?.headers || {};
  }
  async fetch(t, a = "GET", o = {}) {
    if (!this.baseUrl)
      throw new Error("No base URL set");
    const n = fE.test(t) ? t : `${this.baseUrl}${t}`;
    n.includes(this.baseUrl) && (o.withCredentials = !0);
    try {
      return (await Be(n, {
        ...o,
        method: a,
        data: o.data,
        headers: { ...this.headers, ...o.headers },
        withCredentials: o.withCredentials
      })).data;
    } catch (r) {
      throw r instanceof mE ? new yg(`${r.code} - ${r.status} - ${n}`, r.status, r.response?.data) : new yg("An error occured while fetching");
    }
  }
  getBaseUrl() {
    return this.baseUrl;
  }
  setBaseUrl(t) {
    this.baseUrl = t;
  }
  async get(t, a = {}) {
    return this.fetch(t, "GET", a);
  }
  async post(t, a = {}) {
    return this.fetch(t, "POST", {
      ...a,
      headers: {
        "Content-Type": "application/json",
        ...a.headers
      }
    });
  }
  async put(t, a = {}) {
    return this.fetch(t, "PUT", {
      ...a,
      headers: {
        "Content-Type": "application/json",
        ...a.headers
      }
    });
  }
  async delete(t, a = {}) {
    return this.fetch(t, "DELETE", a);
  }
  async patch(t, a = {}) {
    return this.fetch(t, "PATCH", {
      ...a,
      headers: {
        "Content-Type": "application/json",
        ...a.headers
      }
    });
  }
};
new Qb("", {});
function bE(e, t = {}) {
  if (!e) {
    console.warn("setSearchFetchConfig: URL is empty or undefined");
    return;
  }
  new Qb(e, t);
}
const _E = "ISSuiu5R48VFKdltBfogTgBSdaH68izqpiQ9C0WkBXS2Jg1lQSp02Hy5vVPCTgfT", vE = "https://api.jawg.io", yE = "dependency,neighbourhood,locality,borough,localadmin,county,macrocounty,region,macroregion,country,postalcode", yr = {
  "access-token": _E,
  layers: yE,
  sources: "wof",
  size: 10
};
async function wE(e, t, a) {
  const o = `${vE}/places/v1/autocomplete`;
  if (!o)
    throw new Error("JAWG_URL is not defined");
  const n = yr.size;
  let r = `${o}?text=${e}&access-token=${yr["access-token"]}&layers=${yr.layers}&sources=${yr.sources}&size=${n}`;
  t && (r += `&lang=${t}`);
  const i = await fetch(r, {
    headers: {
      "Accept-Language": t || "fr"
    }
  });
  if (!i.ok)
    throw new Error(`JAWG API error: ${i.status}`);
  return i.json();
}
function e_(e) {
  var t, a, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var n = e.length;
    for (t = 0; t < n; t++) e[t] && (a = e_(e[t])) && (o && (o += " "), o += a);
  } else for (a in e) e[a] && (o && (o += " "), o += a);
  return o;
}
function ao() {
  for (var e, t, a = 0, o = "", n = arguments.length; a < n; a++) (e = arguments[a]) && (t = e_(e)) && (o && (o += " "), o += t);
  return o;
}
const kE = [
  "accessible-bathroom",
  "accessible-bedroom",
  "ac",
  "ambassador_sidebar",
  "animals-card",
  "angle-left",
  "angle-left-rounded",
  "angle-right",
  "angle-right-rounded",
  "anywhere-in-the-world",
  "arrow-thin",
  "arrow-thin-right",
  "available-exchange-type",
  "average-reactivity",
  "baby-bed",
  "baby-gear",
  "baby-gear-old",
  "baby-sitter",
  "balcony-terrace",
  "bathroom",
  "bathtub",
  "bbq",
  "bedroom",
  "beds",
  "bicycle",
  "briefcase3",
  "button-power",
  "cancel",
  "calendar",
  "car",
  "cat-to-feed",
  "chat-lock",
  "check",
  "checkbox-fill",
  "children-welcome",
  "circle-close",
  "circle-help",
  "circle-left-arrow",
  "circle-right-arrow",
  "cities",
  "cleaning-person",
  "clock",
  "computer",
  "cook",
  "corona-virus",
  "countryside",
  "credit-card",
  "dashboard-saved-search",
  "dedicated-work-space",
  "disabled-access",
  "dishwasher",
  "docs",
  "dog-to-feed",
  "dollar",
  "doorman",
  "double-bed",
  "double-bed-up",
  "dryer",
  "easy-navigation",
  "electric-car",
  "electric-car-plug",
  "elevator",
  "error",
  "error-regular",
  "error-warning-fill",
  "excellent-reactivity",
  "eye",
  "eye-slash",
  "eye-slash-back",
  "facebook",
  "filter-picture",
  "fireplace",
  "flag",
  "flat",
  "folk",
  "freezer",
  "fridge",
  "garden",
  "gift",
  "gp",
  "great-reactivity",
  "guarantees",
  "guestpoint-exchange-type",
  "guestpoints",
  "guide",
  "gym",
  "header-help",
  "header-message-new",
  "header-message-read",
  "header-profile-home",
  "header-profile-profile",
  "header-profile-settings",
  "header-profile-they-love-my-home",
  "heart",
  "heart-fill",
  "heating-system",
  "high-speed-connection",
  "home-bin",
  "home-camera",
  "home-cinema",
  "home-exchange",
  "home-panel",
  "house",
  "ic-compass",
  "ic-flip-left",
  "ic-flip-right",
  "ic-location",
  "ic-move",
  "ic-shelter",
  "ic-transfer",
  "icon_facebook",
  "icon_gmail",
  "icon_messanger",
  "icon_outlook",
  "id",
  "information-circle",
  "information-circle-regular",
  "instagram",
  "internet",
  "isolated",
  "island",
  "jacuzzi",
  "key",
  "keys",
  "kids-playground",
  "kids-toys",
  "lakes",
  "lifebuoy",
  "linkedin",
  "location",
  "lock",
  "lock-credit-card",
  "low-consumption-machines",
  "marker-home",
  "marker-home-favorite",
  "marker-home-selected",
  "marker-home-selected-favorite",
  "marker-home-unavailable",
  "marker-home-unavailable-favorite",
  "low-reactivity",
  "map-1",
  "megaphone",
  "membership",
  "messenger",
  "microwave-oven",
  "minus",
  "moonplus",
  "more-filter",
  "motorboat",
  "motorcycle",
  "motor-scooter",
  "mountains",
  "my-family",
  "new-tab",
  "notification",
  "noun-loyalty-card",
  "number-eight",
  "number-five",
  "number-four",
  "number-nine",
  "number-one",
  "number-seven",
  "number-six",
  "number-three",
  "number-two",
  "ok",
  "oven",
  "parking-space",
  "pencil",
  "people",
  "pets-welcome",
  "phone",
  "piano",
  "ping-pong-table",
  "pin",
  "plants-to-water",
  "playground",
  "plus",
  "plus-sign",
  "pool-table",
  "preferred-destinations",
  "primary-home",
  "private-room",
  "public-transit-access",
  "rabbit",
  "raw",
  "reciprocal-exchange-type",
  "remove",
  "renewable-energy-provider",
  "river",
  "rooms",
  "sailboat",
  "satellite-cable",
  "sauna",
  "search",
  "search-location-pin",
  "seaside",
  "secondary-home",
  "secured-swimming-pool",
  "selective-waste-sorting",
  "shape-close",
  "share-fat",
  "simple-bed",
  "simple-bed-up",
  "size",
  "smart-tv",
  "smokers-welcome",
  "solar-panels",
  "sort-order",
  "sponsor-hand-icon",
  "star-black",
  "star-full",
  "step-free-entry",
  "sugesstion",
  "sun",
  "swimming-pool",
  "tennis-court",
  "tiktok",
  "triangle-warning",
  "tv",
  "tv-icon",
  "twitter",
  "types_of_exchanges",
  "unavailable",
  "up-arrow",
  "upload",
  "user",
  "vegetable-garden",
  "verification-check",
  "verification-check-regular",
  "video-game-console",
  "villages",
  "warning",
  "warning-regular",
  "washing-machine",
  "wide-angle",
  "wide-doors",
  "wifi",
  "youtube"
], xE = {
  "marker-home-favorite": 3,
  "marker-home": 2,
  "marker-home-selected-favorite": 3,
  "marker-home-selected": 2,
  "marker-home-unavailable-favorite": 3,
  "marker-home-unavailable": 2,
  icon_facebook: 2,
  icon_gmail: 5
}, $E = kE.map((e) => ({
  name: e,
  class: `icon-${e}`,
  paths: xE[e]
})), SE = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, CE = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl",
  "8xl": "is-8xl",
  "9xl": "is-9xl",
  "10xl": "is-10xl"
};
function EE(e = 0) {
  const t = [];
  for (let a = 0; a < e; a++)
    t[a] = `path${a + 1}`;
  return t.map((a) => /* @__PURE__ */ v("span", { className: a }, a));
}
const In = mt(
  ({ name: e, size: t = "medium", color: a = "base", className: o = "", ...n }, r) => {
    const i = $E.find((l) => l.name === e), s = ao("icon", `ds-${i?.class}`, CE[t], SE[a], o);
    return /* @__PURE__ */ v("i", { className: s, ...n, ref: r, children: EE(i?.paths) });
  }
);
In.displayName = "Icon";
const jE = "_disabled_1rzsq_47", wr = {
  "icon-button": "_icon-button_1rzsq_29",
  "size-small": "_size-small_1rzsq_38",
  "size-medium": "_size-medium_1rzsq_41",
  "size-large": "_size-large_1rzsq_44",
  disabled: jE,
  "is-borderless": "_is-borderless_1rzsq_51",
  "dialog-overlay-show": "_dialog-overlay-show_1rzsq_1",
  "dialog-content-show": "_dialog-content-show_1rzsq_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1rzsq_1"
}, OE = mt(
  ({ icon: e, size: t, isBorderless: a, onClick: o, className: n, ...r }, i) => /* @__PURE__ */ v(
    "button",
    {
      ref: i,
      className: ao(
        wr["icon-button"],
        r.disabled && wr.disabled,
        t && wr[`size-${t}`],
        a && wr["is-borderless"],
        n
      ),
      onClick: o,
      ...r,
      children: /* @__PURE__ */ v(In, { name: e, size: t })
    }
  )
);
OE.displayName = "IconButton";
const zE = "_loader_1ksyv_29", AE = "_circle_1ksyv_41", So = {
  loader: zE,
  "is-small": "_is-small_1ksyv_29",
  "is-medium": "_is-medium_1ksyv_33",
  "is-large": "_is-large_1ksyv_37",
  circle: AE,
  "moving-element": "_moving-element_1ksyv_44",
  "on-dark": "_on-dark_1ksyv_47",
  "is-secondary": "_is-secondary_1ksyv_53",
  "dialog-overlay-show": "_dialog-overlay-show_1ksyv_1",
  "dialog-content-show": "_dialog-content-show_1ksyv_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1ksyv_1"
}, PE = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large"
}, DE = {
  primary: "is-primary",
  secondary: "is-secondary"
};
function NE({ onDark: e, size: t = "medium", color: a = "primary", className: o }) {
  return /* @__PURE__ */ T(
    "svg",
    {
      className: ao(
        So.loader,
        So[PE[t]],
        So[DE[a]],
        e && So["on-dark"],
        o
      ),
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      children: [
        /* @__PURE__ */ v("rect", { width: "100", height: "100", fill: "none", className: "bk" }),
        /* @__PURE__ */ v("circle", { className: So.circle, cx: "50", cy: "50", r: "40", fill: "none", strokeWidth: "10", strokeLinecap: "round" }),
        /* @__PURE__ */ T(
          "circle",
          {
            className: So["moving-element"],
            cx: "50",
            cy: "50",
            r: "40",
            fill: "none",
            strokeWidth: "6",
            strokeLinecap: "round",
            children: [
              /* @__PURE__ */ v("animate", { attributeName: "stroke-dashoffset", dur: "2s", repeatCount: "indefinite", from: "502", to: "0" }),
              /* @__PURE__ */ v(
                "animate",
                {
                  attributeName: "stroke-dasharray",
                  dur: "2s",
                  repeatCount: "indefinite",
                  values: "150.6 100.4;1 250;150.6 100.4"
                }
              )
            ]
          }
        )
      ]
    }
  );
}
const RE = "_button_z1os6_29", IE = "_disabled_z1os6_43", TE = "_loader_z1os6_263", la = {
  button: RE,
  disabled: IE,
  "is-primary": "_is-primary_z1os6_51",
  "is-contrasted": "_is-contrasted_z1os6_65",
  "is-secondary": "_is-secondary_z1os6_74",
  "is-tertiary": "_is-tertiary_z1os6_97",
  "is-eco-green": "_is-eco-green_z1os6_120",
  "is-ghost": "_is-ghost_z1os6_134",
  "is-destructive": "_is-destructive_z1os6_157",
  "is-hollow": "_is-hollow_z1os6_171",
  "is-destructive-ghost": "_is-destructive-ghost_z1os6_189",
  "is-facebook": "_is-facebook_z1os6_203",
  "is-apple": "_is-apple_z1os6_217",
  "is-google": "_is-google_z1os6_231",
  "is-regular": "_is-regular_z1os6_245",
  "is-medium": "_is-medium_z1os6_248",
  "is-small": "_is-small_z1os6_251",
  "is-full-width": "_is-full-width_z1os6_254",
  "is-loading": "_is-loading_z1os6_257",
  loader: TE,
  "dialog-overlay-show": "_dialog-overlay-show_z1os6_1",
  "dialog-content-show": "_dialog-content-show_z1os6_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_z1os6_1"
}, LE = mt(
  ({
    text: e,
    color: t = "primary",
    size: a = "medium",
    isFullWidth: o = !1,
    icon: n,
    iconPosition: r = "left",
    isLoading: i = !1,
    iconSize: s = "medium",
    isContrasted: l = !1,
    disabled: c = !1,
    className: u,
    children: d,
    ...h
  }, m) => {
    const f = ao(
      la.button,
      la[ME[t]],
      la[WE[a]],
      o && la["is-full-width"],
      c && la.disabled,
      r === "right" && la["has-icon-right"],
      l && la["is-contrasted"],
      i && la["is-loading"],
      u
    ), p = /* @__PURE__ */ T(De, { children: [
      i && /* @__PURE__ */ v(NE, { className: la.loader, onDark: !0, size: "small" }),
      n && r === "left" && /* @__PURE__ */ v(In, { color: "inherit", size: s, name: n }),
      d ?? e,
      n && r === "right" && /* @__PURE__ */ v(In, { color: "inherit", size: s, name: n })
    ] });
    if (BE(h))
      return /* @__PURE__ */ v(
        "a",
        {
          ...h,
          href: c ? void 0 : h.href,
          className: f,
          target: h.target,
          ref: m,
          children: p
        }
      );
    if (FE(h))
      return /* @__PURE__ */ v(
        "button",
        {
          disabled: i || c,
          ...h,
          className: f,
          ref: m,
          children: p
        }
      );
  }
);
LE.displayName = "Button";
const ME = {
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  "eco-green": "is-eco-green",
  ghost: "is-ghost",
  "destructive-ghost": "is-destructive-ghost",
  destructive: "is-destructive",
  hollow: "is-hollow",
  facebook: "is-facebook",
  apple: "is-apple",
  google: "is-google"
}, WE = {
  small: "is-small",
  medium: "is-medium",
  regular: "is-regular"
};
function BE(e) {
  return "href" in e && typeof e.href == "string";
}
function FE(e) {
  return !("href" in e);
}
const VE = (e, t) => {
  let a;
  return () => {
    clearTimeout(a), a = setTimeout(e, t);
  };
}, gc = {
  xs: { items: 1, peek: 15 },
  sm: { items: 2, peek: 20 },
  md: { items: 3, peek: 25 },
  lg: { items: 4, peek: 15 },
  xl: { items: 5, peek: 10 }
}, UE = [
  { size: 1280, key: "xl" },
  { size: 1024, key: "lg" },
  { size: 768, key: "md" },
  { size: 640, key: "sm" }
];
function qE(e, t) {
  const a = Ie(null), [o, n] = Pe("100%"), [r, i] = Pe(0), [s, l] = Pe(0), [c, u] = Pe(0), d = Ho(
    () => ({
      ...gc,
      ...t.itemsPerBreakpoint
    }),
    [t.itemsPerBreakpoint]
  ), h = () => {
    a.current && (l(a.current.scrollWidth), u(a.current.clientWidth));
  }, m = Ho(
    () => ({
      shouldDisplayNext: r + c < s,
      shouldDisplayPrev: r > 0
    }),
    [r, c, s]
  );
  Ce(() => {
    const w = a.current;
    if (!w) return;
    const _ = () => {
      const x = w.clientWidth ?? 0;
      let S = d.xs;
      for (const { size: L, key: O } of UE)
        if (window.matchMedia(`(min-width: ${L}px)`).matches) {
          S = d[O] ?? gc[O];
          break;
        }
      const $ = getComputedStyle(w), E = parseInt($.gap) || 0;
      let C = 0;
      if (t.paddingElementWrapper && w.children.length) {
        const L = w.children[w.children.length - 1], O = getComputedStyle(L);
        C = parseInt(O.paddingRight);
      }
      const j = x - E * (S.items + (S.peek === 0 ? -1 : 0)) - C, R = S.items + (S.peek === 0 ? 0 : S.peek / 100), H = j / R;
      n(`${H}px`), h();
    };
    _(), h();
    const y = () => i(w.scrollLeft), k = VE(() => {
      _(), h();
    }, 500);
    return w.addEventListener("scroll", y), window.addEventListener("resize", k), () => {
      w.removeEventListener("scroll", y), window.removeEventListener("resize", k);
    };
  }, [d, t.paddingElementWrapper, e]), Ce(h, [e]), Ce(() => {
    t.onNavigationStateChange?.(m);
  }, [m, t]);
  const f = () => {
    a.current && a.current.scrollTo({
      left: Math.max(0, r - a.current.offsetWidth),
      behavior: "smooth"
    });
  }, p = () => {
    a.current && a.current.scrollTo({
      left: Math.min(s - c, r + a.current.offsetWidth),
      behavior: "smooth"
    });
  }, b = (w) => {
    if (!a.current) return parseInt(o);
    const _ = ne.Children.count(e), y = {
      first: w === 0,
      last: w === _ - 1
    }, k = () => {
      if (!t.paddingElementWrapper) return 0;
      const x = a.current?.children[w];
      if (!x) return 0;
      const S = getComputedStyle(x);
      return y.first ? parseInt(S.paddingLeft || "0") : y.last ? parseInt(S.paddingRight || "0") : 0;
    };
    return parseInt(o) + k();
  };
  return {
    carouselRef: a,
    shouldDisplayPrev: m.shouldDisplayPrev,
    shouldDisplayNext: m.shouldDisplayNext,
    scrollPrev: f,
    scrollNext: p,
    itemWidth: o,
    getItemWidth: b
  };
}
const HE = "_carousel_u43l3_29", kr = {
  carousel: HE,
  "carousel-content": "_carousel-content_u43l3_33",
  "gap-0": "_gap-0_u43l3_47",
  "gap-1": "_gap-1_u43l3_50",
  "gap-2": "_gap-2_u43l3_53",
  "gap-3": "_gap-3_u43l3_56",
  "gap-4": "_gap-4_u43l3_59",
  "gap-5": "_gap-5_u43l3_62",
  "gap-6": "_gap-6_u43l3_65",
  "gap-7": "_gap-7_u43l3_68",
  "gap-8": "_gap-8_u43l3_71",
  "gap-9": "_gap-9_u43l3_74",
  "gap-10": "_gap-10_u43l3_77",
  "gap-11": "_gap-11_u43l3_80",
  "gap-12": "_gap-12_u43l3_83",
  "gap-14": "_gap-14_u43l3_86",
  "gap-16": "_gap-16_u43l3_89",
  "gap-18": "_gap-18_u43l3_92",
  "gap-20": "_gap-20_u43l3_95",
  "gap-24": "_gap-24_u43l3_98",
  "gap-28": "_gap-28_u43l3_101",
  "gap-32": "_gap-32_u43l3_104",
  "gap-36": "_gap-36_u43l3_107",
  "gap-40": "_gap-40_u43l3_110",
  "gap-44": "_gap-44_u43l3_113",
  "gap-48": "_gap-48_u43l3_116",
  "gap-52": "_gap-52_u43l3_119",
  "gap-56": "_gap-56_u43l3_122",
  "gap-60": "_gap-60_u43l3_125",
  "gap-64": "_gap-64_u43l3_128",
  "gap-72": "_gap-72_u43l3_131",
  "gap-80": "_gap-80_u43l3_134",
  "gap-96": "_gap-96_u43l3_137",
  "padding-element-wrapper": "_padding-element-wrapper_u43l3_140",
  "dialog-overlay-show": "_dialog-overlay-show_u43l3_1",
  "dialog-content-show": "_dialog-content-show_u43l3_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_u43l3_1"
}, GE = ({
  children: e,
  className: t = "",
  paddingElementWrapper: a = !1,
  gap: o = "8",
  itemsPerBreakpoint: n = gc,
  onNavigationStateChange: r,
  ...i
}, s) => {
  const { carouselRef: l, shouldDisplayPrev: c, shouldDisplayNext: u, scrollPrev: d, scrollNext: h, getItemWidth: m } = qE(
    e,
    {
      itemsPerBreakpoint: n,
      paddingElementWrapper: a,
      onNavigationStateChange: r
    }
  ), f = ne.Children.map(e, (b, w) => ne.isValidElement(b) ? ne.cloneElement(b, {
    style: {
      ...b.props.style,
      width: `${m(w)}px`,
      flexShrink: 0
    }
  }) : b);
  ne.useImperativeHandle(s, () => ({
    scrollNext: h,
    scrollPrev: d,
    shouldDisplayNext: u,
    shouldDisplayPrev: c,
    carouselElement: l.current
  }));
  const p = ao(kr.carousel, t);
  return /* @__PURE__ */ v("div", { className: p, ...i, children: /* @__PURE__ */ v(
    "ul",
    {
      ref: l,
      className: ao(
        kr["carousel-content"],
        a && kr["padding-element-wrapper"],
        o && kr[`gap-${o}`]
      ),
      children: f
    }
  ) });
};
ne.forwardRef(GE);
function be(e, t, { checkForDefaultPrevented: a = !0 } = {}) {
  return function(o) {
    if (e?.(o), a === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
var Da = globalThis?.document ? g.useLayoutEffect : () => {
}, KE = g[" useInsertionEffect ".trim().toString()] || Da;
function ms({
  prop: e,
  defaultProp: t,
  onChange: a = () => {
  },
  caller: o
}) {
  const [n, r, i] = JE({
    defaultProp: t,
    onChange: a
  }), s = e !== void 0, l = s ? e : n;
  {
    const u = g.useRef(e !== void 0);
    g.useEffect(() => {
      const d = u.current;
      d !== s && console.warn(
        `${o} is changing from ${d ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), u.current = s;
    }, [s, o]);
  }
  const c = g.useCallback(
    (u) => {
      if (s) {
        const d = ZE(u) ? u(e) : u;
        d !== e && i.current?.(d);
      } else
        r(u);
    },
    [s, e, r, i]
  );
  return [l, c];
}
function JE({
  defaultProp: e,
  onChange: t
}) {
  const [a, o] = g.useState(e), n = g.useRef(a), r = g.useRef(t);
  return KE(() => {
    r.current = t;
  }, [t]), g.useEffect(() => {
    n.current !== a && (r.current?.(a), n.current = a);
  }, [a, n]), [a, o, r];
}
function ZE(e) {
  return typeof e == "function";
}
function Tg(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function t_(...e) {
  return (t) => {
    let a = !1;
    const o = e.map((n) => {
      const r = Tg(n, t);
      return !a && typeof r == "function" && (a = !0), r;
    });
    if (a)
      return () => {
        for (let n = 0; n < o.length; n++) {
          const r = o[n];
          typeof r == "function" ? r() : Tg(e[n], null);
        }
      };
  };
}
function He(...e) {
  return g.useCallback(t_(...e), e);
}
function YE(e, t) {
  const a = g.createContext(t), o = (r) => {
    const { children: i, ...s } = r, l = g.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ v(a.Provider, { value: l, children: i });
  };
  o.displayName = e + "Provider";
  function n(r) {
    const i = g.useContext(a);
    if (i) return i;
    if (t !== void 0) return t;
    throw new Error(`\`${r}\` must be used within \`${e}\``);
  }
  return [o, n];
}
function _o(e, t = []) {
  let a = [];
  function o(r, i) {
    const s = g.createContext(i), l = a.length;
    a = [...a, i];
    const c = (d) => {
      const { scope: h, children: m, ...f } = d, p = h?.[e]?.[l] || s, b = g.useMemo(() => f, Object.values(f));
      return /* @__PURE__ */ v(p.Provider, { value: b, children: m });
    };
    c.displayName = r + "Provider";
    function u(d, h) {
      const m = h?.[e]?.[l] || s, f = g.useContext(m);
      if (f) return f;
      if (i !== void 0) return i;
      throw new Error(`\`${d}\` must be used within \`${r}\``);
    }
    return [c, u];
  }
  const n = () => {
    const r = a.map((i) => g.createContext(i));
    return function(i) {
      const s = i?.[e] || r;
      return g.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: s } }),
        [i, s]
      );
    };
  };
  return n.scopeName = e, [o, XE(n, ...t)];
}
function XE(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const a = () => {
    const o = e.map((n) => ({
      useScope: n(),
      scopeName: n.scopeName
    }));
    return function(n) {
      const r = o.reduce((i, { useScope: s, scopeName: l }) => {
        const c = s(n)[`__scope${l}`];
        return { ...i, ...c };
      }, {});
      return g.useMemo(() => ({ [`__scope${t.scopeName}`]: r }), [r]);
    };
  };
  return a.scopeName = t.scopeName, a;
}
// @__NO_SIDE_EFFECTS__
function $i(e) {
  const t = /* @__PURE__ */ QE(e), a = g.forwardRef((o, n) => {
    const { children: r, ...i } = o, s = g.Children.toArray(r), l = s.find(tj);
    if (l) {
      const c = l.props.children, u = s.map((d) => d === l ? g.Children.count(c) > 1 ? g.Children.only(null) : g.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ v(t, { ...i, ref: n, children: g.isValidElement(c) ? g.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ v(t, { ...i, ref: n, children: r });
  });
  return a.displayName = `${e}.Slot`, a;
}
// @__NO_SIDE_EFFECTS__
function QE(e) {
  const t = g.forwardRef((a, o) => {
    const { children: n, ...r } = a;
    if (g.isValidElement(n)) {
      const i = oj(n), s = aj(r, n.props);
      return n.type !== g.Fragment && (s.ref = o ? t_(o, i) : i), g.cloneElement(n, s);
    }
    return g.Children.count(n) > 1 ? g.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var ej = Symbol("radix.slottable");
function tj(e) {
  return g.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === ej;
}
function aj(e, t) {
  const a = { ...t };
  for (const o in t) {
    const n = e[o], r = t[o];
    /^on[A-Z]/.test(o) ? n && r ? a[o] = (...i) => {
      const s = r(...i);
      return n(...i), s;
    } : n && (a[o] = n) : o === "style" ? a[o] = { ...n, ...r } : o === "className" && (a[o] = [n, r].filter(Boolean).join(" "));
  }
  return { ...e, ...a };
}
function oj(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, a = t && "isReactWarning" in t && t.isReactWarning;
  return a ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, a = t && "isReactWarning" in t && t.isReactWarning, a ? e.props.ref : e.props.ref || e.ref);
}
var nj = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], ze = nj.reduce((e, t) => {
  const a = /* @__PURE__ */ $i(`Primitive.${t}`), o = g.forwardRef((n, r) => {
    const { asChild: i, ...s } = n, l = i ? a : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ v(l, { ...s, ref: r });
  });
  return o.displayName = `Primitive.${t}`, { ...e, [t]: o };
}, {});
function a_(e, t) {
  e && po.flushSync(() => e.dispatchEvent(t));
}
var rj = g.createContext(void 0);
function Ou(e) {
  const t = g.useContext(rj);
  return e || t || "ltr";
}
function o_(e) {
  const t = e + "CollectionProvider", [a, o] = _o(t), [n, r] = a(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (p) => {
    const { scope: b, children: w } = p, _ = ne.useRef(null), y = ne.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ v(n, { scope: b, itemMap: y, collectionRef: _, children: w });
  };
  i.displayName = t;
  const s = e + "CollectionSlot", l = /* @__PURE__ */ $i(s), c = ne.forwardRef(
    (p, b) => {
      const { scope: w, children: _ } = p, y = r(s, w), k = He(b, y.collectionRef);
      return /* @__PURE__ */ v(l, { ref: k, children: _ });
    }
  );
  c.displayName = s;
  const u = e + "CollectionItemSlot", d = "data-radix-collection-item", h = /* @__PURE__ */ $i(u), m = ne.forwardRef(
    (p, b) => {
      const { scope: w, children: _, ...y } = p, k = ne.useRef(null), x = He(b, k), S = r(u, w);
      return ne.useEffect(() => (S.itemMap.set(k, { ref: k, ...y }), () => void S.itemMap.delete(k))), /* @__PURE__ */ v(h, { [d]: "", ref: x, children: _ });
    }
  );
  m.displayName = u;
  function f(p) {
    const b = r(e + "CollectionConsumer", p);
    return ne.useCallback(() => {
      const w = b.collectionRef.current;
      if (!w) return [];
      const _ = Array.from(w.querySelectorAll(`[${d}]`));
      return Array.from(b.itemMap.values()).sort(
        (y, k) => _.indexOf(y.ref.current) - _.indexOf(k.ref.current)
      );
    }, [b.collectionRef, b.itemMap]);
  }
  return [
    { Provider: i, Slot: c, ItemSlot: m },
    f,
    o
  ];
}
var ij = g[" useId ".trim().toString()] || (() => {
}), sj = 0;
function n_(e) {
  const [t, a] = g.useState(ij());
  return Da(() => {
    a((o) => o ?? String(sj++));
  }, [e]), t ? `radix-${t}` : "";
}
function lj(e, t) {
  return g.useReducer((a, o) => t[a][o] ?? a, e);
}
var _a = (e) => {
  const { present: t, children: a } = e, o = cj(t), n = typeof a == "function" ? a({ present: o.isPresent }) : g.Children.only(a), r = He(o.ref, uj(n));
  return typeof a == "function" || o.isPresent ? g.cloneElement(n, { ref: r }) : null;
};
_a.displayName = "Presence";
function cj(e) {
  const [t, a] = g.useState(), o = g.useRef(null), n = g.useRef(e), r = g.useRef("none"), i = e ? "mounted" : "unmounted", [s, l] = lj(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return g.useEffect(() => {
    const c = xr(o.current);
    r.current = s === "mounted" ? c : "none";
  }, [s]), Da(() => {
    const c = o.current, u = n.current;
    if (u !== e) {
      const d = r.current, h = xr(c);
      e ? l("MOUNT") : h === "none" || c?.display === "none" ? l("UNMOUNT") : l(u && d !== h ? "ANIMATION_OUT" : "UNMOUNT"), n.current = e;
    }
  }, [e, l]), Da(() => {
    if (t) {
      let c;
      const u = t.ownerDocument.defaultView ?? window, d = (m) => {
        const f = xr(o.current).includes(CSS.escape(m.animationName));
        if (m.target === t && f && (l("ANIMATION_END"), !n.current)) {
          const p = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", c = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = p);
          });
        }
      }, h = (m) => {
        m.target === t && (r.current = xr(o.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        u.clearTimeout(c), t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: g.useCallback((c) => {
      o.current = c ? getComputedStyle(c) : null, a(c);
    }, [])
  };
}
function xr(e) {
  return e?.animationName || "none";
}
function uj(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, a = t && "isReactWarning" in t && t.isReactWarning;
  return a ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, a = t && "isReactWarning" in t && t.isReactWarning, a ? e.props.ref : e.props.ref || e.ref);
}
function Qe(e) {
  const t = g.useRef(e);
  return g.useEffect(() => {
    t.current = e;
  }), g.useMemo(() => (...a) => t.current?.(...a), []);
}
var ll = "rovingFocusGroup.onEntryFocus", dj = { bubbles: !1, cancelable: !0 }, tr = "RovingFocusGroup", [hc, r_, gj] = o_(tr), [hj, i_] = _o(
  tr,
  [gj]
), [pj, mj] = hj(tr), s_ = g.forwardRef(
  (e, t) => /* @__PURE__ */ v(hc.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ v(hc.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ v(fj, { ...e, ref: t }) }) })
);
s_.displayName = tr;
var fj = g.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: a,
    orientation: o,
    loop: n = !1,
    dir: r,
    currentTabStopId: i,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: l,
    onEntryFocus: c,
    preventScrollOnEntryFocus: u = !1,
    ...d
  } = e, h = g.useRef(null), m = He(t, h), f = Ou(r), [p, b] = ms({
    prop: i,
    defaultProp: s ?? null,
    onChange: l,
    caller: tr
  }), [w, _] = g.useState(!1), y = Qe(c), k = r_(a), x = g.useRef(!1), [S, $] = g.useState(0);
  return g.useEffect(() => {
    const E = h.current;
    if (E)
      return E.addEventListener(ll, y), () => E.removeEventListener(ll, y);
  }, [y]), /* @__PURE__ */ v(
    pj,
    {
      scope: a,
      orientation: o,
      dir: f,
      loop: n,
      currentTabStopId: p,
      onItemFocus: g.useCallback(
        (E) => b(E),
        [b]
      ),
      onItemShiftTab: g.useCallback(() => _(!0), []),
      onFocusableItemAdd: g.useCallback(
        () => $((E) => E + 1),
        []
      ),
      onFocusableItemRemove: g.useCallback(
        () => $((E) => E - 1),
        []
      ),
      children: /* @__PURE__ */ v(
        ze.div,
        {
          tabIndex: w || S === 0 ? -1 : 0,
          "data-orientation": o,
          ...d,
          ref: m,
          style: { outline: "none", ...e.style },
          onMouseDown: be(e.onMouseDown, () => {
            x.current = !0;
          }),
          onFocus: be(e.onFocus, (E) => {
            const C = !x.current;
            if (E.target === E.currentTarget && C && !w) {
              const j = new CustomEvent(ll, dj);
              if (E.currentTarget.dispatchEvent(j), !j.defaultPrevented) {
                const R = k().filter((U) => U.focusable), H = R.find((U) => U.active), L = R.find((U) => U.id === p), O = [H, L, ...R].filter(
                  Boolean
                ).map((U) => U.ref.current);
                u_(O, u);
              }
            }
            x.current = !1;
          }),
          onBlur: be(e.onBlur, () => _(!1))
        }
      )
    }
  );
}), l_ = "RovingFocusGroupItem", c_ = g.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: a,
      focusable: o = !0,
      active: n = !1,
      tabStopId: r,
      children: i,
      ...s
    } = e, l = n_(), c = r || l, u = mj(l_, a), d = u.currentTabStopId === c, h = r_(a), { onFocusableItemAdd: m, onFocusableItemRemove: f, currentTabStopId: p } = u;
    return g.useEffect(() => {
      if (o)
        return m(), () => f();
    }, [o, m, f]), /* @__PURE__ */ v(
      hc.ItemSlot,
      {
        scope: a,
        id: c,
        focusable: o,
        active: n,
        children: /* @__PURE__ */ v(
          ze.span,
          {
            tabIndex: d ? 0 : -1,
            "data-orientation": u.orientation,
            ...s,
            ref: t,
            onMouseDown: be(e.onMouseDown, (b) => {
              o ? u.onItemFocus(c) : b.preventDefault();
            }),
            onFocus: be(e.onFocus, () => u.onItemFocus(c)),
            onKeyDown: be(e.onKeyDown, (b) => {
              if (b.key === "Tab" && b.shiftKey) {
                u.onItemShiftTab();
                return;
              }
              if (b.target !== b.currentTarget) return;
              const w = vj(b, u.orientation, u.dir);
              if (w !== void 0) {
                if (b.metaKey || b.ctrlKey || b.altKey || b.shiftKey) return;
                b.preventDefault();
                let _ = h().filter((y) => y.focusable).map((y) => y.ref.current);
                if (w === "last") _.reverse();
                else if (w === "prev" || w === "next") {
                  w === "prev" && _.reverse();
                  const y = _.indexOf(b.currentTarget);
                  _ = u.loop ? yj(_, y + 1) : _.slice(y + 1);
                }
                setTimeout(() => u_(_));
              }
            }),
            children: typeof i == "function" ? i({ isCurrentTabStop: d, hasTabStop: p != null }) : i
          }
        )
      }
    );
  }
);
c_.displayName = l_;
var bj = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function _j(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function vj(e, t, a) {
  const o = _j(e.key, a);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(o)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(o)))
    return bj[o];
}
function u_(e, t = !1) {
  const a = document.activeElement;
  for (const o of e)
    if (o === a || (o.focus({ preventScroll: t }), document.activeElement !== a)) return;
}
function yj(e, t) {
  return e.map((a, o) => e[(t + o) % e.length]);
}
var wj = s_, kj = c_;
function xj(e) {
  const [t, a] = g.useState(void 0);
  return Da(() => {
    if (e) {
      a({ width: e.offsetWidth, height: e.offsetHeight });
      const o = new ResizeObserver((n) => {
        if (!Array.isArray(n) || !n.length)
          return;
        const r = n[0];
        let i, s;
        if ("borderBoxSize" in r) {
          const l = r.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          i = c.inlineSize, s = c.blockSize;
        } else
          i = e.offsetWidth, s = e.offsetHeight;
        a({ width: i, height: s });
      });
      return o.observe(e, { box: "border-box" }), () => o.unobserve(e);
    } else
      a(void 0);
  }, [e]), t;
}
function $j(e) {
  const t = g.useRef({ value: e, previous: e });
  return g.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
const Sj = typeof document < "u" ? ne.useLayoutEffect : () => {
};
var cl;
cl = ne.useInsertionEffect;
const Si = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
}, d_ = /* @__PURE__ */ ne.createContext(Si), Cj = /* @__PURE__ */ ne.createContext(!1);
let Ej = !!(typeof window < "u" && window.document && window.document.createElement), ul = /* @__PURE__ */ new WeakMap();
function jj(e = !1) {
  let t = ho(d_), a = Ie(null);
  if (a.current === null && !e) {
    var o, n;
    let r = (n = ne.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || n === void 0 || (o = n.ReactCurrentOwner) === null || o === void 0 ? void 0 : o.current;
    if (r) {
      let i = ul.get(r);
      i == null ? ul.set(r, {
        id: t.current,
        state: r.memoizedState
      }) : r.memoizedState !== i.state && (t.current = i.id, ul.delete(r));
    }
    a.current = ++t.current;
  }
  return a.current;
}
function Oj(e) {
  let t = ho(d_);
  t === Si && !Ej && process.env.NODE_ENV !== "production" && console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let a = jj(!!e), o = t === Si && process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${t.prefix}`;
  return e || `${o}-${a}`;
}
function zj(e) {
  let t = ne.useId(), [a] = Pe(Nj()), o = a || process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${Si.prefix}`;
  return e || `${o}-${t}`;
}
ne.useId;
function Aj() {
  return !1;
}
function Pj() {
  return !0;
}
function Dj(e) {
  return () => {
  };
}
function Nj() {
  return typeof ne.useSyncExternalStore == "function" ? ne.useSyncExternalStore(Dj, Aj, Pj) : ho(Cj);
}
let Rj = /* @__PURE__ */ new Map();
typeof FinalizationRegistry < "u" && new FinalizationRegistry((e) => {
  Rj.delete(e);
});
const Ij = /* @__PURE__ */ new Set([
  "Arab",
  "Syrc",
  "Samr",
  "Mand",
  "Thaa",
  "Mend",
  "Nkoo",
  "Adlm",
  "Rohg",
  "Hebr"
]), Tj = /* @__PURE__ */ new Set([
  "ae",
  "ar",
  "arc",
  "bcc",
  "bqi",
  "ckb",
  "dv",
  "fa",
  "glk",
  "he",
  "ku",
  "mzn",
  "nqo",
  "pnb",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi"
]);
function Lj(e) {
  if (Intl.Locale) {
    let a = new Intl.Locale(e).maximize(), o = typeof a.getTextInfo == "function" ? a.getTextInfo() : a.textInfo;
    if (o) return o.direction === "rtl";
    if (a.script) return Ij.has(a.script);
  }
  let t = e.split("-")[0];
  return Tj.has(t);
}
const Mj = Symbol.for("react-aria.i18n.locale");
function Wj() {
  let e = typeof window < "u" && window[Mj] || typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      e
    ]);
  } catch {
    e = "en-US";
  }
  return {
    locale: e,
    direction: Lj(e) ? "rtl" : "ltr"
  };
}
Wj();
const fs = (e) => {
  var t;
  return (t = e?.ownerDocument) !== null && t !== void 0 ? t : document;
}, pc = (e) => fs(e).defaultView || window;
function bs(e) {
  var t;
  if (typeof window > "u" || window.navigator == null) return !1;
  let a = (t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.brands;
  return Array.isArray(a) && a.some((o) => e.test(o.brand)) || e.test(window.navigator.userAgent);
}
function zu(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function va(e) {
  if (process.env.NODE_ENV === "test") return e;
  let t = null;
  return () => (t == null && (t = e()), t);
}
const Au = va(function() {
  return zu(/^Mac/i);
}), Bj = va(function() {
  return zu(/^iPhone/i);
}), Fj = va(function() {
  return zu(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  Au() && navigator.maxTouchPoints > 1;
}), Vj = va(function() {
  return Bj() || Fj();
});
va(function() {
  return Au() || Vj();
});
va(function() {
  return bs(/AppleWebKit/i) && !Uj();
});
const Uj = va(function() {
  return bs(/Chrome/i);
}), qj = va(function() {
  return bs(/Android/i);
});
va(function() {
  return bs(/Firefox/i);
});
let bn = /* @__PURE__ */ new Map(), Lg = /* @__PURE__ */ new Set();
function Mg() {
  if (typeof window > "u") return;
  function e(o) {
    return "propertyName" in o;
  }
  let t = (o) => {
    if (!e(o) || !o.target) return;
    let n = bn.get(o.target);
    n || (n = /* @__PURE__ */ new Set(), bn.set(o.target, n), o.target.addEventListener("transitioncancel", a, {
      once: !0
    })), n.add(o.propertyName);
  }, a = (o) => {
    if (!e(o) || !o.target) return;
    let n = bn.get(o.target);
    if (n && (n.delete(o.propertyName), n.size === 0 && (o.target.removeEventListener("transitioncancel", a), bn.delete(o.target)), bn.size === 0)) {
      for (let r of Lg) r();
      Lg.clear();
    }
  };
  document.body.addEventListener("transitionrun", t), document.body.addEventListener("transitionend", a);
}
typeof document < "u" && (document.readyState !== "loading" ? Mg() : document.addEventListener("DOMContentLoaded", Mg));
function Hj(e) {
  return e.pointerType === "" && e.isTrusted ? !0 : qj() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
let Gj = !1;
const Kj = ne.createContext({
  register: () => {
  }
});
Kj.displayName = "PressResponderContext";
let Jj = /* @__PURE__ */ new Set(), En = /* @__PURE__ */ new Map(), oo = !1, mc = !1;
function Pu(e, t) {
  for (let a of Jj) a(e, t);
}
function Zj(e) {
  return !(e.metaKey || !Au() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function Ci(e) {
  oo = !0, Zj(e) && Pu("keyboard", e);
}
function jt(e) {
  (e.type === "mousedown" || e.type === "pointerdown") && (oo = !0, Pu("pointer", e));
}
function g_(e) {
  Hj(e) && (oo = !0);
}
function h_(e) {
  e.target === window || e.target === document || Gj || !e.isTrusted || (!oo && !mc && Pu("virtual", e), oo = !1, mc = !1);
}
function p_() {
  oo = !1, mc = !0;
}
function Wg(e) {
  if (typeof window > "u" || typeof document > "u" || En.get(pc(e))) return;
  const t = pc(e), a = fs(e);
  let o = t.HTMLElement.prototype.focus;
  t.HTMLElement.prototype.focus = function() {
    oo = !0, o.apply(this, arguments);
  }, a.addEventListener("keydown", Ci, !0), a.addEventListener("keyup", Ci, !0), a.addEventListener("click", g_, !0), t.addEventListener("focus", h_, !0), t.addEventListener("blur", p_, !1), typeof PointerEvent < "u" ? (a.addEventListener("pointerdown", jt, !0), a.addEventListener("pointermove", jt, !0), a.addEventListener("pointerup", jt, !0)) : process.env.NODE_ENV === "test" && (a.addEventListener("mousedown", jt, !0), a.addEventListener("mousemove", jt, !0), a.addEventListener("mouseup", jt, !0)), t.addEventListener("beforeunload", () => {
    m_(e);
  }, {
    once: !0
  }), En.set(t, {
    focus: o
  });
}
const m_ = (e, t) => {
  const a = pc(e), o = fs(e);
  t && o.removeEventListener("DOMContentLoaded", t), En.has(a) && (a.HTMLElement.prototype.focus = En.get(a).focus, o.removeEventListener("keydown", Ci, !0), o.removeEventListener("keyup", Ci, !0), o.removeEventListener("click", g_, !0), a.removeEventListener("focus", h_, !0), a.removeEventListener("blur", p_, !1), typeof PointerEvent < "u" ? (o.removeEventListener("pointerdown", jt, !0), o.removeEventListener("pointermove", jt, !0), o.removeEventListener("pointerup", jt, !0)) : process.env.NODE_ENV === "test" && (o.removeEventListener("mousedown", jt, !0), o.removeEventListener("mousemove", jt, !0), o.removeEventListener("mouseup", jt, !0)), En.delete(a));
};
function Yj(e) {
  const t = fs(e);
  let a;
  return t.readyState !== "loading" ? Wg(e) : (a = () => {
    Wg(e);
  }, t.addEventListener("DOMContentLoaded", a)), () => m_(e, a);
}
typeof document < "u" && Yj();
Ot(null);
function Xj(e, t = globalThis?.document) {
  const a = Qe(e);
  g.useEffect(() => {
    const o = (n) => {
      n.key === "Escape" && a(n);
    };
    return t.addEventListener("keydown", o, { capture: !0 }), () => t.removeEventListener("keydown", o, { capture: !0 });
  }, [a, t]);
}
var Qj = "DismissableLayer", fc = "dismissableLayer.update", eO = "dismissableLayer.pointerDownOutside", tO = "dismissableLayer.focusOutside", Bg, f_ = g.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Du = g.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: a = !1,
      onEscapeKeyDown: o,
      onPointerDownOutside: n,
      onFocusOutside: r,
      onInteractOutside: i,
      onDismiss: s,
      ...l
    } = e, c = g.useContext(f_), [u, d] = g.useState(null), h = u?.ownerDocument ?? globalThis?.document, [, m] = g.useState({}), f = He(t, ($) => d($)), p = Array.from(c.layers), [b] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), w = p.indexOf(b), _ = u ? p.indexOf(u) : -1, y = c.layersWithOutsidePointerEventsDisabled.size > 0, k = _ >= w, x = oO(($) => {
      const E = $.target, C = [...c.branches].some((j) => j.contains(E));
      !k || C || (n?.($), i?.($), $.defaultPrevented || s?.());
    }, h), S = nO(($) => {
      const E = $.target;
      [...c.branches].some((C) => C.contains(E)) || (r?.($), i?.($), $.defaultPrevented || s?.());
    }, h);
    return Xj(($) => {
      _ === c.layers.size - 1 && (o?.($), !$.defaultPrevented && s && ($.preventDefault(), s()));
    }, h), g.useEffect(() => {
      if (u)
        return a && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (Bg = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(u)), c.layers.add(u), Fg(), () => {
          a && c.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = Bg);
        };
    }, [u, h, a, c]), g.useEffect(() => () => {
      u && (c.layers.delete(u), c.layersWithOutsidePointerEventsDisabled.delete(u), Fg());
    }, [u, c]), g.useEffect(() => {
      const $ = () => m({});
      return document.addEventListener(fc, $), () => document.removeEventListener(fc, $);
    }, []), /* @__PURE__ */ v(
      ze.div,
      {
        ...l,
        ref: f,
        style: {
          pointerEvents: y ? k ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: be(e.onFocusCapture, S.onFocusCapture),
        onBlurCapture: be(e.onBlurCapture, S.onBlurCapture),
        onPointerDownCapture: be(
          e.onPointerDownCapture,
          x.onPointerDownCapture
        )
      }
    );
  }
);
Du.displayName = Qj;
var aO = "DismissableLayerBranch", b_ = g.forwardRef((e, t) => {
  const a = g.useContext(f_), o = g.useRef(null), n = He(t, o);
  return g.useEffect(() => {
    const r = o.current;
    if (r)
      return a.branches.add(r), () => {
        a.branches.delete(r);
      };
  }, [a.branches]), /* @__PURE__ */ v(ze.div, { ...e, ref: n });
});
b_.displayName = aO;
function oO(e, t = globalThis?.document) {
  const a = Qe(e), o = g.useRef(!1), n = g.useRef(() => {
  });
  return g.useEffect(() => {
    const r = (s) => {
      if (s.target && !o.current) {
        let l = function() {
          __(
            eO,
            a,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", n.current), n.current = l, t.addEventListener("click", n.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", n.current);
      o.current = !1;
    }, i = window.setTimeout(() => {
      t.addEventListener("pointerdown", r);
    }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", r), t.removeEventListener("click", n.current);
    };
  }, [t, a]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function nO(e, t = globalThis?.document) {
  const a = Qe(e), o = g.useRef(!1);
  return g.useEffect(() => {
    const n = (r) => {
      r.target && !o.current && __(tO, a, { originalEvent: r }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", n), () => t.removeEventListener("focusin", n);
  }, [t, a]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function Fg() {
  const e = new CustomEvent(fc);
  document.dispatchEvent(e);
}
function __(e, t, a, { discrete: o }) {
  const n = a.originalEvent.target, r = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: a });
  t && n.addEventListener(e, t, { once: !0 }), o ? a_(n, r) : n.dispatchEvent(r);
}
var rO = Du, iO = b_, sO = "Portal", v_ = g.forwardRef((e, t) => {
  const { container: a, ...o } = e, [n, r] = g.useState(!1);
  Da(() => r(!0), []);
  const i = a || n && globalThis?.document?.body;
  return i ? os.createPortal(/* @__PURE__ */ v(ze.div, { ...o, ref: t }), i) : null;
});
v_.displayName = sO;
var ct = function() {
  return ct = Object.assign || function(e) {
    for (var t, a = 1, o = arguments.length; a < o; a++) {
      t = arguments[a];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, ct.apply(this, arguments);
};
function y_(e, t) {
  var a = {};
  for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (a[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, o = Object.getOwnPropertySymbols(e); n < o.length; n++)
      t.indexOf(o[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[n]) && (a[o[n]] = e[o[n]]);
  return a;
}
function lO(e, t, a) {
  for (var o = 0, n = t.length, r; o < n; o++)
    (r || !(o in t)) && (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
  return e.concat(r || Array.prototype.slice.call(t));
}
var dl = "focusScope.autoFocusOnMount", gl = "focusScope.autoFocusOnUnmount", Vg = { bubbles: !1, cancelable: !0 }, cO = "FocusScope", w_ = g.forwardRef((e, t) => {
  const {
    loop: a = !1,
    trapped: o = !1,
    onMountAutoFocus: n,
    onUnmountAutoFocus: r,
    ...i
  } = e, [s, l] = g.useState(null), c = Qe(n), u = Qe(r), d = g.useRef(null), h = He(t, (p) => l(p)), m = g.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  g.useEffect(() => {
    if (o) {
      let p = function(y) {
        if (m.paused || !s) return;
        const k = y.target;
        s.contains(k) ? d.current = k : Ea(d.current, { select: !0 });
      }, b = function(y) {
        if (m.paused || !s) return;
        const k = y.relatedTarget;
        k !== null && (s.contains(k) || Ea(d.current, { select: !0 }));
      }, w = function(y) {
        if (document.activeElement === document.body)
          for (const k of y)
            k.removedNodes.length > 0 && Ea(s);
      };
      document.addEventListener("focusin", p), document.addEventListener("focusout", b);
      const _ = new MutationObserver(w);
      return s && _.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", p), document.removeEventListener("focusout", b), _.disconnect();
      };
    }
  }, [o, s, m.paused]), g.useEffect(() => {
    if (s) {
      qg.add(m);
      const p = document.activeElement;
      if (!s.contains(p)) {
        const b = new CustomEvent(dl, Vg);
        s.addEventListener(dl, c), s.dispatchEvent(b), b.defaultPrevented || (uO(mO(k_(s)), { select: !0 }), document.activeElement === p && Ea(s));
      }
      return () => {
        s.removeEventListener(dl, c), setTimeout(() => {
          const b = new CustomEvent(gl, Vg);
          s.addEventListener(gl, u), s.dispatchEvent(b), b.defaultPrevented || Ea(p ?? document.body, { select: !0 }), s.removeEventListener(gl, u), qg.remove(m);
        }, 0);
      };
    }
  }, [s, c, u, m]);
  const f = g.useCallback(
    (p) => {
      if (!a && !o || m.paused) return;
      const b = p.key === "Tab" && !p.altKey && !p.ctrlKey && !p.metaKey, w = document.activeElement;
      if (b && w) {
        const _ = p.currentTarget, [y, k] = dO(_);
        y && k ? !p.shiftKey && w === k ? (p.preventDefault(), a && Ea(y, { select: !0 })) : p.shiftKey && w === y && (p.preventDefault(), a && Ea(k, { select: !0 })) : w === _ && p.preventDefault();
      }
    },
    [a, o, m.paused]
  );
  return /* @__PURE__ */ v(ze.div, { tabIndex: -1, ...i, ref: h, onKeyDown: f });
});
w_.displayName = cO;
function uO(e, { select: t = !1 } = {}) {
  const a = document.activeElement;
  for (const o of e)
    if (Ea(o, { select: t }), document.activeElement !== a) return;
}
function dO(e) {
  const t = k_(e), a = Ug(t, e), o = Ug(t.reverse(), e);
  return [a, o];
}
function k_(e) {
  const t = [], a = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const n = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || n ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; a.nextNode(); ) t.push(a.currentNode);
  return t;
}
function Ug(e, t) {
  for (const a of e)
    if (!gO(a, { upTo: t })) return a;
}
function gO(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function hO(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Ea(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const a = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== a && hO(e) && t && e.select();
  }
}
var qg = pO();
function pO() {
  let e = [];
  return {
    add(t) {
      const a = e[0];
      t !== a && a?.pause(), e = Hg(e, t), e.unshift(t);
    },
    remove(t) {
      e = Hg(e, t), e[0]?.resume();
    }
  };
}
function Hg(e, t) {
  const a = [...e], o = a.indexOf(t);
  return o !== -1 && a.splice(o, 1), a;
}
function mO(e) {
  return e.filter((t) => t.tagName !== "A");
}
var hl = 0;
function fO() {
  g.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? Gg()), document.body.insertAdjacentElement("beforeend", e[1] ?? Gg()), hl++, () => {
      hl === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), hl--;
    };
  }, []);
}
function Gg() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var ti = "right-scroll-bar-position", ai = "width-before-scroll-bar", bO = "with-scroll-bars-hidden", _O = "--removed-body-scroll-bar-size";
function pl(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function vO(e, t) {
  var a = Pe(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return a.value;
        },
        set current(o) {
          var n = a.value;
          n !== o && (a.value = o, a.callback(o, n));
        }
      }
    };
  })[0];
  return a.callback = t, a.facade;
}
var yO = typeof window < "u" ? g.useLayoutEffect : g.useEffect, Kg = /* @__PURE__ */ new WeakMap();
function wO(e, t) {
  var a = vO(null, function(o) {
    return e.forEach(function(n) {
      return pl(n, o);
    });
  });
  return yO(function() {
    var o = Kg.get(a);
    if (o) {
      var n = new Set(o), r = new Set(e), i = a.current;
      n.forEach(function(s) {
        r.has(s) || pl(s, null);
      }), r.forEach(function(s) {
        n.has(s) || pl(s, i);
      });
    }
    Kg.set(a, e);
  }, [e]), a;
}
function kO(e) {
  return e;
}
function xO(e, t) {
  t === void 0 && (t = kO);
  var a = [], o = !1, n = {
    read: function() {
      if (o)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return a.length ? a[a.length - 1] : e;
    },
    useMedium: function(r) {
      var i = t(r, o);
      return a.push(i), function() {
        a = a.filter(function(s) {
          return s !== i;
        });
      };
    },
    assignSyncMedium: function(r) {
      for (o = !0; a.length; ) {
        var i = a;
        a = [], i.forEach(r);
      }
      a = {
        push: function(s) {
          return r(s);
        },
        filter: function() {
          return a;
        }
      };
    },
    assignMedium: function(r) {
      o = !0;
      var i = [];
      if (a.length) {
        var s = a;
        a = [], s.forEach(r), i = a;
      }
      var l = function() {
        var u = i;
        i = [], u.forEach(r);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), a = {
        push: function(u) {
          i.push(u), c();
        },
        filter: function(u) {
          return i = i.filter(u), a;
        }
      };
    }
  };
  return n;
}
function $O(e) {
  e === void 0 && (e = {});
  var t = xO(null);
  return t.options = ct({ async: !0, ssr: !1 }, e), t;
}
var x_ = function(e) {
  var t = e.sideCar, a = y_(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var o = t.read();
  if (!o)
    throw new Error("Sidecar medium not found");
  return g.createElement(o, ct({}, a));
};
x_.isSideCarExport = !0;
function SO(e, t) {
  return e.useMedium(t), x_;
}
var $_ = $O(), ml = function() {
}, _s = g.forwardRef(function(e, t) {
  var a = g.useRef(null), o = g.useState({
    onScrollCapture: ml,
    onWheelCapture: ml,
    onTouchMoveCapture: ml
  }), n = o[0], r = o[1], i = e.forwardProps, s = e.children, l = e.className, c = e.removeScrollBar, u = e.enabled, d = e.shards, h = e.sideCar, m = e.noIsolation, f = e.inert, p = e.allowPinchZoom, b = e.as, w = b === void 0 ? "div" : b, _ = e.gapMode, y = y_(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), k = h, x = wO([a, t]), S = ct(ct({}, y), n);
  return g.createElement(
    g.Fragment,
    null,
    u && g.createElement(k, { sideCar: $_, removeScrollBar: c, shards: d, noIsolation: m, inert: f, setCallbacks: r, allowPinchZoom: !!p, lockRef: a, gapMode: _ }),
    i ? g.cloneElement(g.Children.only(s), ct(ct({}, S), { ref: x })) : g.createElement(w, ct({}, S, { className: l, ref: x }), s)
  );
});
_s.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
_s.classNames = {
  fullWidth: ai,
  zeroRight: ti
};
var CO = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function EO() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = CO();
  return t && e.setAttribute("nonce", t), e;
}
function jO(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function OO(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var zO = function() {
  var e = 0, t = null;
  return {
    add: function(a) {
      e == 0 && (t = EO()) && (jO(t, a), OO(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, AO = function() {
  var e = zO();
  return function(t, a) {
    g.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && a]);
  };
}, S_ = function() {
  var e = AO(), t = function(a) {
    var o = a.styles, n = a.dynamic;
    return e(o, n), null;
  };
  return t;
}, PO = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, fl = function(e) {
  return parseInt(e || "", 10) || 0;
}, DO = function(e) {
  var t = window.getComputedStyle(document.body), a = t[e === "padding" ? "paddingLeft" : "marginLeft"], o = t[e === "padding" ? "paddingTop" : "marginTop"], n = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [fl(a), fl(o), fl(n)];
}, NO = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return PO;
  var t = DO(e), a = document.documentElement.clientWidth, o = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, o - a + t[2] - t[0])
  };
}, RO = S_(), Bo = "data-scroll-locked", IO = function(e, t, a, o) {
  var n = e.left, r = e.top, i = e.right, s = e.gap;
  return a === void 0 && (a = "margin"), `
  .`.concat(bO, ` {
   overflow: hidden `).concat(o, `;
   padding-right: `).concat(s, "px ").concat(o, `;
  }
  body[`).concat(Bo, `] {
    overflow: hidden `).concat(o, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(o, ";"),
    a === "margin" && `
    padding-left: `.concat(n, `px;
    padding-top: `).concat(r, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(o, `;
    `),
    a === "padding" && "padding-right: ".concat(s, "px ").concat(o, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(ti, ` {
    right: `).concat(s, "px ").concat(o, `;
  }
  
  .`).concat(ai, ` {
    margin-right: `).concat(s, "px ").concat(o, `;
  }
  
  .`).concat(ti, " .").concat(ti, ` {
    right: 0 `).concat(o, `;
  }
  
  .`).concat(ai, " .").concat(ai, ` {
    margin-right: 0 `).concat(o, `;
  }
  
  body[`).concat(Bo, `] {
    `).concat(_O, ": ").concat(s, `px;
  }
`);
}, Jg = function() {
  var e = parseInt(document.body.getAttribute(Bo) || "0", 10);
  return isFinite(e) ? e : 0;
}, TO = function() {
  g.useEffect(function() {
    return document.body.setAttribute(Bo, (Jg() + 1).toString()), function() {
      var e = Jg() - 1;
      e <= 0 ? document.body.removeAttribute(Bo) : document.body.setAttribute(Bo, e.toString());
    };
  }, []);
}, LO = function(e) {
  var t = e.noRelative, a = e.noImportant, o = e.gapMode, n = o === void 0 ? "margin" : o;
  TO();
  var r = g.useMemo(function() {
    return NO(n);
  }, [n]);
  return g.createElement(RO, { styles: IO(r, !t, n, a ? "" : "!important") });
}, bc = !1;
if (typeof window < "u")
  try {
    var $r = Object.defineProperty({}, "passive", {
      get: function() {
        return bc = !0, !0;
      }
    });
    window.addEventListener("test", $r, $r), window.removeEventListener("test", $r, $r);
  } catch {
    bc = !1;
  }
var Co = bc ? { passive: !1 } : !1, MO = function(e) {
  return e.tagName === "TEXTAREA";
}, C_ = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var a = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    a[t] !== "hidden" && // contains scroll inside self
    !(a.overflowY === a.overflowX && !MO(e) && a[t] === "visible")
  );
}, WO = function(e) {
  return C_(e, "overflowY");
}, BO = function(e) {
  return C_(e, "overflowX");
}, Zg = function(e, t) {
  var a = t.ownerDocument, o = t;
  do {
    typeof ShadowRoot < "u" && o instanceof ShadowRoot && (o = o.host);
    var n = E_(e, o);
    if (n) {
      var r = j_(e, o), i = r[1], s = r[2];
      if (i > s)
        return !0;
    }
    o = o.parentNode;
  } while (o && o !== a.body);
  return !1;
}, FO = function(e) {
  var t = e.scrollTop, a = e.scrollHeight, o = e.clientHeight;
  return [
    t,
    a,
    o
  ];
}, VO = function(e) {
  var t = e.scrollLeft, a = e.scrollWidth, o = e.clientWidth;
  return [
    t,
    a,
    o
  ];
}, E_ = function(e, t) {
  return e === "v" ? WO(t) : BO(t);
}, j_ = function(e, t) {
  return e === "v" ? FO(t) : VO(t);
}, UO = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, qO = function(e, t, a, o, n) {
  var r = UO(e, window.getComputedStyle(t).direction), i = r * o, s = a.target, l = t.contains(s), c = !1, u = i > 0, d = 0, h = 0;
  do {
    var m = j_(e, s), f = m[0], p = m[1], b = m[2], w = p - b - r * f;
    (f || w) && E_(e, s) && (d += w, h += f), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (u && Math.abs(d) < 1 || !u && Math.abs(h) < 1) && (c = !0), c;
}, Sr = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Yg = function(e) {
  return [e.deltaX, e.deltaY];
}, Xg = function(e) {
  return e && "current" in e ? e.current : e;
}, HO = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, GO = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, KO = 0, Eo = [];
function JO(e) {
  var t = g.useRef([]), a = g.useRef([0, 0]), o = g.useRef(), n = g.useState(KO++)[0], r = g.useState(S_)[0], i = g.useRef(e);
  g.useEffect(function() {
    i.current = e;
  }, [e]), g.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(n));
      var p = lO([e.lockRef.current], (e.shards || []).map(Xg)).filter(Boolean);
      return p.forEach(function(b) {
        return b.classList.add("allow-interactivity-".concat(n));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(n)), p.forEach(function(b) {
          return b.classList.remove("allow-interactivity-".concat(n));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = g.useCallback(function(p, b) {
    if ("touches" in p && p.touches.length === 2 || p.type === "wheel" && p.ctrlKey)
      return !i.current.allowPinchZoom;
    var w = Sr(p), _ = a.current, y = "deltaX" in p ? p.deltaX : _[0] - w[0], k = "deltaY" in p ? p.deltaY : _[1] - w[1], x, S = p.target, $ = Math.abs(y) > Math.abs(k) ? "h" : "v";
    if ("touches" in p && $ === "h" && S.type === "range")
      return !1;
    var E = Zg($, S);
    if (!E)
      return !0;
    if (E ? x = $ : (x = $ === "v" ? "h" : "v", E = Zg($, S)), !E)
      return !1;
    if (!o.current && "changedTouches" in p && (y || k) && (o.current = x), !x)
      return !0;
    var C = o.current || x;
    return qO(C, b, p, C === "h" ? y : k);
  }, []), l = g.useCallback(function(p) {
    var b = p;
    if (!(!Eo.length || Eo[Eo.length - 1] !== r)) {
      var w = "deltaY" in b ? Yg(b) : Sr(b), _ = t.current.filter(function(x) {
        return x.name === b.type && (x.target === b.target || b.target === x.shadowParent) && HO(x.delta, w);
      })[0];
      if (_ && _.should) {
        b.cancelable && b.preventDefault();
        return;
      }
      if (!_) {
        var y = (i.current.shards || []).map(Xg).filter(Boolean).filter(function(x) {
          return x.contains(b.target);
        }), k = y.length > 0 ? s(b, y[0]) : !i.current.noIsolation;
        k && b.cancelable && b.preventDefault();
      }
    }
  }, []), c = g.useCallback(function(p, b, w, _) {
    var y = { name: p, delta: b, target: w, should: _, shadowParent: ZO(w) };
    t.current.push(y), setTimeout(function() {
      t.current = t.current.filter(function(k) {
        return k !== y;
      });
    }, 1);
  }, []), u = g.useCallback(function(p) {
    a.current = Sr(p), o.current = void 0;
  }, []), d = g.useCallback(function(p) {
    c(p.type, Yg(p), p.target, s(p, e.lockRef.current));
  }, []), h = g.useCallback(function(p) {
    c(p.type, Sr(p), p.target, s(p, e.lockRef.current));
  }, []);
  g.useEffect(function() {
    return Eo.push(r), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", l, Co), document.addEventListener("touchmove", l, Co), document.addEventListener("touchstart", u, Co), function() {
      Eo = Eo.filter(function(p) {
        return p !== r;
      }), document.removeEventListener("wheel", l, Co), document.removeEventListener("touchmove", l, Co), document.removeEventListener("touchstart", u, Co);
    };
  }, []);
  var m = e.removeScrollBar, f = e.inert;
  return g.createElement(
    g.Fragment,
    null,
    f ? g.createElement(r, { styles: GO(n) }) : null,
    m ? g.createElement(LO, { gapMode: e.gapMode }) : null
  );
}
function ZO(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const YO = SO($_, JO);
var O_ = g.forwardRef(function(e, t) {
  return g.createElement(_s, ct({}, e, { ref: t, sideCar: YO }));
});
O_.classNames = _s.classNames;
var XO = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, jo = /* @__PURE__ */ new WeakMap(), Cr = /* @__PURE__ */ new WeakMap(), Er = {}, bl = 0, z_ = function(e) {
  return e && (e.host || z_(e.parentNode));
}, QO = function(e, t) {
  return t.map(function(a) {
    if (e.contains(a))
      return a;
    var o = z_(a);
    return o && e.contains(o) ? o : (console.error("aria-hidden", a, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(a) {
    return !!a;
  });
}, ez = function(e, t, a, o) {
  var n = QO(t, Array.isArray(e) ? e : [e]);
  Er[a] || (Er[a] = /* @__PURE__ */ new WeakMap());
  var r = Er[a], i = [], s = /* @__PURE__ */ new Set(), l = new Set(n), c = function(d) {
    !d || s.has(d) || (s.add(d), c(d.parentNode));
  };
  n.forEach(c);
  var u = function(d) {
    !d || l.has(d) || Array.prototype.forEach.call(d.children, function(h) {
      if (s.has(h))
        u(h);
      else
        try {
          var m = h.getAttribute(o), f = m !== null && m !== "false", p = (jo.get(h) || 0) + 1, b = (r.get(h) || 0) + 1;
          jo.set(h, p), r.set(h, b), i.push(h), p === 1 && f && Cr.set(h, !0), b === 1 && h.setAttribute(a, "true"), f || h.setAttribute(o, "true");
        } catch (w) {
          console.error("aria-hidden: cannot operate on ", h, w);
        }
    });
  };
  return u(t), s.clear(), bl++, function() {
    i.forEach(function(d) {
      var h = jo.get(d) - 1, m = r.get(d) - 1;
      jo.set(d, h), r.set(d, m), h || (Cr.has(d) || d.removeAttribute(o), Cr.delete(d)), m || d.removeAttribute(a);
    }), bl--, bl || (jo = /* @__PURE__ */ new WeakMap(), jo = /* @__PURE__ */ new WeakMap(), Cr = /* @__PURE__ */ new WeakMap(), Er = {});
  };
}, tz = function(e, t, a) {
  a === void 0 && (a = "data-aria-hidden");
  var o = Array.from(Array.isArray(e) ? e : [e]), n = XO(e);
  return n ? (o.push.apply(o, Array.from(n.querySelectorAll("[aria-live]"))), ez(o, n, a, "aria-hidden")) : function() {
    return null;
  };
}, A_ = "Dialog", [P_, zrt] = _o(A_), [Art, ea] = P_(A_), D_ = "DialogTrigger", az = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, ...o } = e, n = ea(D_, a), r = He(t, n.triggerRef);
    return /* @__PURE__ */ v(
      ze.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": n.open,
        "aria-controls": n.contentId,
        "data-state": Ru(n.open),
        ...o,
        ref: r,
        onClick: be(e.onClick, n.onOpenToggle)
      }
    );
  }
);
az.displayName = D_;
var oz = "DialogPortal", [Prt, N_] = P_(oz, {
  forceMount: void 0
}), Ei = "DialogOverlay", nz = g.forwardRef(
  (e, t) => {
    const a = N_(Ei, e.__scopeDialog), { forceMount: o = a.forceMount, ...n } = e, r = ea(Ei, e.__scopeDialog);
    return r.modal ? /* @__PURE__ */ v(_a, { present: o || r.open, children: /* @__PURE__ */ v(iz, { ...n, ref: t }) }) : null;
  }
);
nz.displayName = Ei;
var rz = /* @__PURE__ */ $i("DialogOverlay.RemoveScroll"), iz = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, ...o } = e, n = ea(Ei, a);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ v(O_, { as: rz, allowPinchZoom: !0, shards: [n.contentRef], children: /* @__PURE__ */ v(
        ze.div,
        {
          "data-state": Ru(n.open),
          ...o,
          ref: t,
          style: { pointerEvents: "auto", ...o.style }
        }
      ) })
    );
  }
), no = "DialogContent", sz = g.forwardRef(
  (e, t) => {
    const a = N_(no, e.__scopeDialog), { forceMount: o = a.forceMount, ...n } = e, r = ea(no, e.__scopeDialog);
    return /* @__PURE__ */ v(_a, { present: o || r.open, children: r.modal ? /* @__PURE__ */ v(lz, { ...n, ref: t }) : /* @__PURE__ */ v(cz, { ...n, ref: t }) });
  }
);
sz.displayName = no;
var lz = g.forwardRef(
  (e, t) => {
    const a = ea(no, e.__scopeDialog), o = g.useRef(null), n = He(t, a.contentRef, o);
    return g.useEffect(() => {
      const r = o.current;
      if (r) return tz(r);
    }, []), /* @__PURE__ */ v(
      R_,
      {
        ...e,
        ref: n,
        trapFocus: a.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: be(e.onCloseAutoFocus, (r) => {
          r.preventDefault(), a.triggerRef.current?.focus();
        }),
        onPointerDownOutside: be(e.onPointerDownOutside, (r) => {
          const i = r.detail.originalEvent, s = i.button === 0 && i.ctrlKey === !0;
          (i.button === 2 || s) && r.preventDefault();
        }),
        onFocusOutside: be(
          e.onFocusOutside,
          (r) => r.preventDefault()
        )
      }
    );
  }
), cz = g.forwardRef(
  (e, t) => {
    const a = ea(no, e.__scopeDialog), o = g.useRef(!1), n = g.useRef(!1);
    return /* @__PURE__ */ v(
      R_,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (r) => {
          e.onCloseAutoFocus?.(r), r.defaultPrevented || (o.current || a.triggerRef.current?.focus(), r.preventDefault()), o.current = !1, n.current = !1;
        },
        onInteractOutside: (r) => {
          e.onInteractOutside?.(r), r.defaultPrevented || (o.current = !0, r.detail.originalEvent.type === "pointerdown" && (n.current = !0));
          const i = r.target;
          a.triggerRef.current?.contains(i) && r.preventDefault(), r.detail.originalEvent.type === "focusin" && n.current && r.preventDefault();
        }
      }
    );
  }
), R_ = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, trapFocus: o, onOpenAutoFocus: n, onCloseAutoFocus: r, ...i } = e, s = ea(no, a), l = g.useRef(null), c = He(t, l);
    return fO(), /* @__PURE__ */ T(De, { children: [
      /* @__PURE__ */ v(
        w_,
        {
          asChild: !0,
          loop: !0,
          trapped: o,
          onMountAutoFocus: n,
          onUnmountAutoFocus: r,
          children: /* @__PURE__ */ v(
            Du,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": Ru(s.open),
              ...i,
              ref: c,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ T(De, { children: [
        /* @__PURE__ */ v(hz, { titleId: s.titleId }),
        /* @__PURE__ */ v(mz, { contentRef: l, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), Nu = "DialogTitle", uz = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, ...o } = e, n = ea(Nu, a);
    return /* @__PURE__ */ v(ze.h2, { id: n.titleId, ...o, ref: t });
  }
);
uz.displayName = Nu;
var I_ = "DialogDescription", dz = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, ...o } = e, n = ea(I_, a);
    return /* @__PURE__ */ v(ze.p, { id: n.descriptionId, ...o, ref: t });
  }
);
dz.displayName = I_;
var T_ = "DialogClose", gz = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, ...o } = e, n = ea(T_, a);
    return /* @__PURE__ */ v(
      ze.button,
      {
        type: "button",
        ...o,
        ref: t,
        onClick: be(e.onClick, () => n.onOpenChange(!1))
      }
    );
  }
);
gz.displayName = T_;
function Ru(e) {
  return e ? "open" : "closed";
}
var L_ = "DialogTitleWarning", [Drt, M_] = YE(L_, {
  contentName: no,
  titleName: Nu,
  docsSlug: "dialog"
}), hz = ({ titleId: e }) => {
  const t = M_(L_), a = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return g.useEffect(() => {
    e && (document.getElementById(e) || console.error(a));
  }, [a, e]), null;
}, pz = "DialogDescriptionWarning", mz = ({ contentRef: e, descriptionId: t }) => {
  const a = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${M_(pz).contentName}}.`;
  return g.useEffect(() => {
    const o = e.current?.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(a));
  }, [a, e, t]), null;
};
function fz(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function da(e, t) {
  if (e == null) return {};
  var a = {};
  for (var o in e) if ({}.hasOwnProperty.call(e, o)) {
    if (t.indexOf(o) !== -1) continue;
    a[o] = e[o];
  }
  return a;
}
function pe() {
  return pe = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];
      for (var o in a) ({}).hasOwnProperty.call(a, o) && (e[o] = a[o]);
    }
    return e;
  }, pe.apply(null, arguments);
}
function _c(e, t) {
  return _c = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(a, o) {
    return a.__proto__ = o, a;
  }, _c(e, t);
}
function bz(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, _c(e, t);
}
var jr = { exports: {} }, _l = { exports: {} }, ke = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Qg;
function _z() {
  if (Qg) return ke;
  Qg = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, a = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, n = e ? Symbol.for("react.strict_mode") : 60108, r = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, f = e ? Symbol.for("react.lazy") : 60116, p = e ? Symbol.for("react.block") : 60121, b = e ? Symbol.for("react.fundamental") : 60117, w = e ? Symbol.for("react.responder") : 60118, _ = e ? Symbol.for("react.scope") : 60119;
  function y(x) {
    if (typeof x == "object" && x !== null) {
      var S = x.$$typeof;
      switch (S) {
        case t:
          switch (x = x.type, x) {
            case l:
            case c:
            case o:
            case r:
            case n:
            case d:
              return x;
            default:
              switch (x = x && x.$$typeof, x) {
                case s:
                case u:
                case f:
                case m:
                case i:
                  return x;
                default:
                  return S;
              }
          }
        case a:
          return S;
      }
    }
  }
  function k(x) {
    return y(x) === c;
  }
  return ke.AsyncMode = l, ke.ConcurrentMode = c, ke.ContextConsumer = s, ke.ContextProvider = i, ke.Element = t, ke.ForwardRef = u, ke.Fragment = o, ke.Lazy = f, ke.Memo = m, ke.Portal = a, ke.Profiler = r, ke.StrictMode = n, ke.Suspense = d, ke.isAsyncMode = function(x) {
    return k(x) || y(x) === l;
  }, ke.isConcurrentMode = k, ke.isContextConsumer = function(x) {
    return y(x) === s;
  }, ke.isContextProvider = function(x) {
    return y(x) === i;
  }, ke.isElement = function(x) {
    return typeof x == "object" && x !== null && x.$$typeof === t;
  }, ke.isForwardRef = function(x) {
    return y(x) === u;
  }, ke.isFragment = function(x) {
    return y(x) === o;
  }, ke.isLazy = function(x) {
    return y(x) === f;
  }, ke.isMemo = function(x) {
    return y(x) === m;
  }, ke.isPortal = function(x) {
    return y(x) === a;
  }, ke.isProfiler = function(x) {
    return y(x) === r;
  }, ke.isStrictMode = function(x) {
    return y(x) === n;
  }, ke.isSuspense = function(x) {
    return y(x) === d;
  }, ke.isValidElementType = function(x) {
    return typeof x == "string" || typeof x == "function" || x === o || x === c || x === r || x === n || x === d || x === h || typeof x == "object" && x !== null && (x.$$typeof === f || x.$$typeof === m || x.$$typeof === i || x.$$typeof === s || x.$$typeof === u || x.$$typeof === b || x.$$typeof === w || x.$$typeof === _ || x.$$typeof === p);
  }, ke.typeOf = y, ke;
}
var Ee = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var eh;
function vz() {
  return eh || (eh = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, a = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, n = e ? Symbol.for("react.strict_mode") : 60108, r = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, f = e ? Symbol.for("react.lazy") : 60116, p = e ? Symbol.for("react.block") : 60121, b = e ? Symbol.for("react.fundamental") : 60117, w = e ? Symbol.for("react.responder") : 60118, _ = e ? Symbol.for("react.scope") : 60119;
    function y(V) {
      return typeof V == "string" || typeof V == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      V === o || V === c || V === r || V === n || V === d || V === h || typeof V == "object" && V !== null && (V.$$typeof === f || V.$$typeof === m || V.$$typeof === i || V.$$typeof === s || V.$$typeof === u || V.$$typeof === b || V.$$typeof === w || V.$$typeof === _ || V.$$typeof === p);
    }
    function k(V) {
      if (typeof V == "object" && V !== null) {
        var fe = V.$$typeof;
        switch (fe) {
          case t:
            var X = V.type;
            switch (X) {
              case l:
              case c:
              case o:
              case r:
              case n:
              case d:
                return X;
              default:
                var Ye = X && X.$$typeof;
                switch (Ye) {
                  case s:
                  case u:
                  case f:
                  case m:
                  case i:
                    return Ye;
                  default:
                    return fe;
                }
            }
          case a:
            return fe;
        }
      }
    }
    var x = l, S = c, $ = s, E = i, C = t, j = u, R = o, H = f, L = m, O = a, U = r, I = n, K = d, q = !1;
    function te(V) {
      return q || (q = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), A(V) || k(V) === l;
    }
    function A(V) {
      return k(V) === c;
    }
    function z(V) {
      return k(V) === s;
    }
    function N(V) {
      return k(V) === i;
    }
    function B(V) {
      return typeof V == "object" && V !== null && V.$$typeof === t;
    }
    function W(V) {
      return k(V) === u;
    }
    function Z(V) {
      return k(V) === o;
    }
    function ee(V) {
      return k(V) === f;
    }
    function M(V) {
      return k(V) === m;
    }
    function Y(V) {
      return k(V) === a;
    }
    function Q(V) {
      return k(V) === r;
    }
    function J(V) {
      return k(V) === n;
    }
    function ae(V) {
      return k(V) === d;
    }
    Ee.AsyncMode = x, Ee.ConcurrentMode = S, Ee.ContextConsumer = $, Ee.ContextProvider = E, Ee.Element = C, Ee.ForwardRef = j, Ee.Fragment = R, Ee.Lazy = H, Ee.Memo = L, Ee.Portal = O, Ee.Profiler = U, Ee.StrictMode = I, Ee.Suspense = K, Ee.isAsyncMode = te, Ee.isConcurrentMode = A, Ee.isContextConsumer = z, Ee.isContextProvider = N, Ee.isElement = B, Ee.isForwardRef = W, Ee.isFragment = Z, Ee.isLazy = ee, Ee.isMemo = M, Ee.isPortal = Y, Ee.isProfiler = Q, Ee.isStrictMode = J, Ee.isSuspense = ae, Ee.isValidElementType = y, Ee.typeOf = k;
  }()), Ee;
}
var th;
function W_() {
  return th || (th = 1, process.env.NODE_ENV === "production" ? _l.exports = _z() : _l.exports = vz()), _l.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var vl, ah;
function yz() {
  if (ah) return vl;
  ah = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, a = Object.prototype.propertyIsEnumerable;
  function o(r) {
    if (r == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(r);
  }
  function n() {
    try {
      if (!Object.assign)
        return !1;
      var r = new String("abc");
      if (r[5] = "de", Object.getOwnPropertyNames(r)[0] === "5")
        return !1;
      for (var i = {}, s = 0; s < 10; s++)
        i["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(i).map(function(u) {
        return i[u];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        c[u] = u;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return vl = n() ? Object.assign : function(r, i) {
    for (var s, l = o(r), c, u = 1; u < arguments.length; u++) {
      s = Object(arguments[u]);
      for (var d in s)
        t.call(s, d) && (l[d] = s[d]);
      if (e) {
        c = e(s);
        for (var h = 0; h < c.length; h++)
          a.call(s, c[h]) && (l[c[h]] = s[c[h]]);
      }
    }
    return l;
  }, vl;
}
var yl, oh;
function Iu() {
  if (oh) return yl;
  oh = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return yl = e, yl;
}
var nh, rh;
function B_() {
  return rh || (rh = 1, nh = Function.call.bind(Object.prototype.hasOwnProperty)), nh;
}
var wl, ih;
function wz() {
  if (ih) return wl;
  ih = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ Iu(), a = {}, o = /* @__PURE__ */ B_();
    e = function(r) {
      var i = "Warning: " + r;
      typeof console < "u" && console.error(i);
      try {
        throw new Error(i);
      } catch {
      }
    };
  }
  function n(r, i, s, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in r)
        if (o(r, u)) {
          var d;
          try {
            if (typeof r[u] != "function") {
              var h = Error(
                (l || "React class") + ": " + s + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw h.name = "Invariant Violation", h;
            }
            d = r[u](i, u, l, s, null, t);
          } catch (f) {
            d = f;
          }
          if (d && !(d instanceof Error) && e(
            (l || "React class") + ": type specification of " + s + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in a)) {
            a[d.message] = !0;
            var m = c ? c() : "";
            e(
              "Failed " + s + " type: " + d.message + (m ?? "")
            );
          }
        }
    }
  }
  return n.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (a = {});
  }, wl = n, wl;
}
var kl, sh;
function kz() {
  if (sh) return kl;
  sh = 1;
  var e = W_(), t = yz(), a = /* @__PURE__ */ Iu(), o = /* @__PURE__ */ B_(), n = /* @__PURE__ */ wz(), r = function() {
  };
  process.env.NODE_ENV !== "production" && (r = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function i() {
    return null;
  }
  return kl = function(s, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function d(A) {
      var z = A && (c && A[c] || A[u]);
      if (typeof z == "function")
        return z;
    }
    var h = "<<anonymous>>", m = {
      array: w("array"),
      bigint: w("bigint"),
      bool: w("boolean"),
      func: w("function"),
      number: w("number"),
      object: w("object"),
      string: w("string"),
      symbol: w("symbol"),
      any: _(),
      arrayOf: y,
      element: k(),
      elementType: x(),
      instanceOf: S,
      node: j(),
      objectOf: E,
      oneOf: $,
      oneOfType: C,
      shape: H,
      exact: L
    };
    function f(A, z) {
      return A === z ? A !== 0 || 1 / A === 1 / z : A !== A && z !== z;
    }
    function p(A, z) {
      this.message = A, this.data = z && typeof z == "object" ? z : {}, this.stack = "";
    }
    p.prototype = Error.prototype;
    function b(A) {
      if (process.env.NODE_ENV !== "production")
        var z = {}, N = 0;
      function B(Z, ee, M, Y, Q, J, ae) {
        if (Y = Y || h, J = J || M, ae !== a) {
          if (l) {
            var V = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw V.name = "Invariant Violation", V;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var fe = Y + ":" + M;
            !z[fe] && // Avoid spamming the console because they are often not actionable except for lib authors
            N < 3 && (r(
              "You are manually calling a React.PropTypes validation function for the `" + J + "` prop on `" + Y + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), z[fe] = !0, N++);
          }
        }
        return ee[M] == null ? Z ? ee[M] === null ? new p("The " + Q + " `" + J + "` is marked as required " + ("in `" + Y + "`, but its value is `null`.")) : new p("The " + Q + " `" + J + "` is marked as required in " + ("`" + Y + "`, but its value is `undefined`.")) : null : A(ee, M, Y, Q, J);
      }
      var W = B.bind(null, !1);
      return W.isRequired = B.bind(null, !0), W;
    }
    function w(A) {
      function z(N, B, W, Z, ee, M) {
        var Y = N[B], Q = I(Y);
        if (Q !== A) {
          var J = K(Y);
          return new p(
            "Invalid " + Z + " `" + ee + "` of type " + ("`" + J + "` supplied to `" + W + "`, expected ") + ("`" + A + "`."),
            { expectedType: A }
          );
        }
        return null;
      }
      return b(z);
    }
    function _() {
      return b(i);
    }
    function y(A) {
      function z(N, B, W, Z, ee) {
        if (typeof A != "function")
          return new p("Property `" + ee + "` of component `" + W + "` has invalid PropType notation inside arrayOf.");
        var M = N[B];
        if (!Array.isArray(M)) {
          var Y = I(M);
          return new p("Invalid " + Z + " `" + ee + "` of type " + ("`" + Y + "` supplied to `" + W + "`, expected an array."));
        }
        for (var Q = 0; Q < M.length; Q++) {
          var J = A(M, Q, W, Z, ee + "[" + Q + "]", a);
          if (J instanceof Error)
            return J;
        }
        return null;
      }
      return b(z);
    }
    function k() {
      function A(z, N, B, W, Z) {
        var ee = z[N];
        if (!s(ee)) {
          var M = I(ee);
          return new p("Invalid " + W + " `" + Z + "` of type " + ("`" + M + "` supplied to `" + B + "`, expected a single ReactElement."));
        }
        return null;
      }
      return b(A);
    }
    function x() {
      function A(z, N, B, W, Z) {
        var ee = z[N];
        if (!e.isValidElementType(ee)) {
          var M = I(ee);
          return new p("Invalid " + W + " `" + Z + "` of type " + ("`" + M + "` supplied to `" + B + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return b(A);
    }
    function S(A) {
      function z(N, B, W, Z, ee) {
        if (!(N[B] instanceof A)) {
          var M = A.name || h, Y = te(N[B]);
          return new p("Invalid " + Z + " `" + ee + "` of type " + ("`" + Y + "` supplied to `" + W + "`, expected ") + ("instance of `" + M + "`."));
        }
        return null;
      }
      return b(z);
    }
    function $(A) {
      if (!Array.isArray(A))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? r(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : r("Invalid argument supplied to oneOf, expected an array.")), i;
      function z(N, B, W, Z, ee) {
        for (var M = N[B], Y = 0; Y < A.length; Y++)
          if (f(M, A[Y]))
            return null;
        var Q = JSON.stringify(A, function(J, ae) {
          var V = K(ae);
          return V === "symbol" ? String(ae) : ae;
        });
        return new p("Invalid " + Z + " `" + ee + "` of value `" + String(M) + "` " + ("supplied to `" + W + "`, expected one of " + Q + "."));
      }
      return b(z);
    }
    function E(A) {
      function z(N, B, W, Z, ee) {
        if (typeof A != "function")
          return new p("Property `" + ee + "` of component `" + W + "` has invalid PropType notation inside objectOf.");
        var M = N[B], Y = I(M);
        if (Y !== "object")
          return new p("Invalid " + Z + " `" + ee + "` of type " + ("`" + Y + "` supplied to `" + W + "`, expected an object."));
        for (var Q in M)
          if (o(M, Q)) {
            var J = A(M, Q, W, Z, ee + "." + Q, a);
            if (J instanceof Error)
              return J;
          }
        return null;
      }
      return b(z);
    }
    function C(A) {
      if (!Array.isArray(A))
        return process.env.NODE_ENV !== "production" && r("Invalid argument supplied to oneOfType, expected an instance of array."), i;
      for (var z = 0; z < A.length; z++) {
        var N = A[z];
        if (typeof N != "function")
          return r(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + q(N) + " at index " + z + "."
          ), i;
      }
      function B(W, Z, ee, M, Y) {
        for (var Q = [], J = 0; J < A.length; J++) {
          var ae = A[J], V = ae(W, Z, ee, M, Y, a);
          if (V == null)
            return null;
          V.data && o(V.data, "expectedType") && Q.push(V.data.expectedType);
        }
        var fe = Q.length > 0 ? ", expected one of type [" + Q.join(", ") + "]" : "";
        return new p("Invalid " + M + " `" + Y + "` supplied to " + ("`" + ee + "`" + fe + "."));
      }
      return b(B);
    }
    function j() {
      function A(z, N, B, W, Z) {
        return O(z[N]) ? null : new p("Invalid " + W + " `" + Z + "` supplied to " + ("`" + B + "`, expected a ReactNode."));
      }
      return b(A);
    }
    function R(A, z, N, B, W) {
      return new p(
        (A || "React class") + ": " + z + " type `" + N + "." + B + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + W + "`."
      );
    }
    function H(A) {
      function z(N, B, W, Z, ee) {
        var M = N[B], Y = I(M);
        if (Y !== "object")
          return new p("Invalid " + Z + " `" + ee + "` of type `" + Y + "` " + ("supplied to `" + W + "`, expected `object`."));
        for (var Q in A) {
          var J = A[Q];
          if (typeof J != "function")
            return R(W, Z, ee, Q, K(J));
          var ae = J(M, Q, W, Z, ee + "." + Q, a);
          if (ae)
            return ae;
        }
        return null;
      }
      return b(z);
    }
    function L(A) {
      function z(N, B, W, Z, ee) {
        var M = N[B], Y = I(M);
        if (Y !== "object")
          return new p("Invalid " + Z + " `" + ee + "` of type `" + Y + "` " + ("supplied to `" + W + "`, expected `object`."));
        var Q = t({}, N[B], A);
        for (var J in Q) {
          var ae = A[J];
          if (o(A, J) && typeof ae != "function")
            return R(W, Z, ee, J, K(ae));
          if (!ae)
            return new p(
              "Invalid " + Z + " `" + ee + "` key `" + J + "` supplied to `" + W + "`.\nBad object: " + JSON.stringify(N[B], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(A), null, "  ")
            );
          var V = ae(M, J, W, Z, ee + "." + J, a);
          if (V)
            return V;
        }
        return null;
      }
      return b(z);
    }
    function O(A) {
      switch (typeof A) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !A;
        case "object":
          if (Array.isArray(A))
            return A.every(O);
          if (A === null || s(A))
            return !0;
          var z = d(A);
          if (z) {
            var N = z.call(A), B;
            if (z !== A.entries) {
              for (; !(B = N.next()).done; )
                if (!O(B.value))
                  return !1;
            } else
              for (; !(B = N.next()).done; ) {
                var W = B.value;
                if (W && !O(W[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function U(A, z) {
      return A === "symbol" ? !0 : z ? z["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && z instanceof Symbol : !1;
    }
    function I(A) {
      var z = typeof A;
      return Array.isArray(A) ? "array" : A instanceof RegExp ? "object" : U(z, A) ? "symbol" : z;
    }
    function K(A) {
      if (typeof A > "u" || A === null)
        return "" + A;
      var z = I(A);
      if (z === "object") {
        if (A instanceof Date)
          return "date";
        if (A instanceof RegExp)
          return "regexp";
      }
      return z;
    }
    function q(A) {
      var z = K(A);
      switch (z) {
        case "array":
        case "object":
          return "an " + z;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + z;
        default:
          return z;
      }
    }
    function te(A) {
      return !A.constructor || !A.constructor.name ? h : A.constructor.name;
    }
    return m.checkPropTypes = n, m.resetWarningCache = n.resetWarningCache, m.PropTypes = m, m;
  }, kl;
}
var xl, lh;
function xz() {
  if (lh) return xl;
  lh = 1;
  var e = /* @__PURE__ */ Iu();
  function t() {
  }
  function a() {
  }
  return a.resetWarningCache = t, xl = function() {
    function o(i, s, l, c, u, d) {
      if (d !== e) {
        var h = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw h.name = "Invariant Violation", h;
      }
    }
    o.isRequired = o;
    function n() {
      return o;
    }
    var r = {
      array: o,
      bigint: o,
      bool: o,
      func: o,
      number: o,
      object: o,
      string: o,
      symbol: o,
      any: o,
      arrayOf: n,
      element: o,
      elementType: o,
      instanceOf: n,
      node: o,
      objectOf: n,
      oneOf: n,
      oneOfType: n,
      shape: n,
      exact: n,
      checkPropTypes: a,
      resetWarningCache: t
    };
    return r.PropTypes = r, r;
  }, xl;
}
var ch;
function $z() {
  if (ch) return jr.exports;
  if (ch = 1, process.env.NODE_ENV !== "production") {
    var e = W_(), t = !0;
    jr.exports = /* @__PURE__ */ kz()(e.isElement, t);
  } else
    jr.exports = /* @__PURE__ */ xz()();
  return jr.exports;
}
var Sz = /* @__PURE__ */ $z();
const G = /* @__PURE__ */ fz(Sz);
var $l = { exports: {} }, xe = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var uh;
function Cz() {
  if (uh) return xe;
  uh = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), n = Symbol.for("react.profiler"), r = Symbol.for("react.provider"), i = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), f;
  f = Symbol.for("react.module.reference");
  function p(b) {
    if (typeof b == "object" && b !== null) {
      var w = b.$$typeof;
      switch (w) {
        case e:
          switch (b = b.type, b) {
            case a:
            case n:
            case o:
            case c:
            case u:
              return b;
            default:
              switch (b = b && b.$$typeof, b) {
                case s:
                case i:
                case l:
                case h:
                case d:
                case r:
                  return b;
                default:
                  return w;
              }
          }
        case t:
          return w;
      }
    }
  }
  return xe.ContextConsumer = i, xe.ContextProvider = r, xe.Element = e, xe.ForwardRef = l, xe.Fragment = a, xe.Lazy = h, xe.Memo = d, xe.Portal = t, xe.Profiler = n, xe.StrictMode = o, xe.Suspense = c, xe.SuspenseList = u, xe.isAsyncMode = function() {
    return !1;
  }, xe.isConcurrentMode = function() {
    return !1;
  }, xe.isContextConsumer = function(b) {
    return p(b) === i;
  }, xe.isContextProvider = function(b) {
    return p(b) === r;
  }, xe.isElement = function(b) {
    return typeof b == "object" && b !== null && b.$$typeof === e;
  }, xe.isForwardRef = function(b) {
    return p(b) === l;
  }, xe.isFragment = function(b) {
    return p(b) === a;
  }, xe.isLazy = function(b) {
    return p(b) === h;
  }, xe.isMemo = function(b) {
    return p(b) === d;
  }, xe.isPortal = function(b) {
    return p(b) === t;
  }, xe.isProfiler = function(b) {
    return p(b) === n;
  }, xe.isStrictMode = function(b) {
    return p(b) === o;
  }, xe.isSuspense = function(b) {
    return p(b) === c;
  }, xe.isSuspenseList = function(b) {
    return p(b) === u;
  }, xe.isValidElementType = function(b) {
    return typeof b == "string" || typeof b == "function" || b === a || b === n || b === o || b === c || b === u || b === m || typeof b == "object" && b !== null && (b.$$typeof === h || b.$$typeof === d || b.$$typeof === r || b.$$typeof === i || b.$$typeof === l || b.$$typeof === f || b.getModuleId !== void 0);
  }, xe.typeOf = p, xe;
}
var je = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var dh;
function Ez() {
  return dh || (dh = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), n = Symbol.for("react.profiler"), r = Symbol.for("react.provider"), i = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), f = !1, p = !1, b = !1, w = !1, _ = !1, y;
    y = Symbol.for("react.module.reference");
    function k(X) {
      return !!(typeof X == "string" || typeof X == "function" || X === a || X === n || _ || X === o || X === c || X === u || w || X === m || f || p || b || typeof X == "object" && X !== null && (X.$$typeof === h || X.$$typeof === d || X.$$typeof === r || X.$$typeof === i || X.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      X.$$typeof === y || X.getModuleId !== void 0));
    }
    function x(X) {
      if (typeof X == "object" && X !== null) {
        var Ye = X.$$typeof;
        switch (Ye) {
          case e:
            var Ve = X.type;
            switch (Ve) {
              case a:
              case n:
              case o:
              case c:
              case u:
                return Ve;
              default:
                var Ft = Ve && Ve.$$typeof;
                switch (Ft) {
                  case s:
                  case i:
                  case l:
                  case h:
                  case d:
                  case r:
                    return Ft;
                  default:
                    return Ye;
                }
            }
          case t:
            return Ye;
        }
      }
    }
    var S = i, $ = r, E = e, C = l, j = a, R = h, H = d, L = t, O = n, U = o, I = c, K = u, q = !1, te = !1;
    function A(X) {
      return q || (q = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function z(X) {
      return te || (te = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function N(X) {
      return x(X) === i;
    }
    function B(X) {
      return x(X) === r;
    }
    function W(X) {
      return typeof X == "object" && X !== null && X.$$typeof === e;
    }
    function Z(X) {
      return x(X) === l;
    }
    function ee(X) {
      return x(X) === a;
    }
    function M(X) {
      return x(X) === h;
    }
    function Y(X) {
      return x(X) === d;
    }
    function Q(X) {
      return x(X) === t;
    }
    function J(X) {
      return x(X) === n;
    }
    function ae(X) {
      return x(X) === o;
    }
    function V(X) {
      return x(X) === c;
    }
    function fe(X) {
      return x(X) === u;
    }
    je.ContextConsumer = S, je.ContextProvider = $, je.Element = E, je.ForwardRef = C, je.Fragment = j, je.Lazy = R, je.Memo = H, je.Portal = L, je.Profiler = O, je.StrictMode = U, je.Suspense = I, je.SuspenseList = K, je.isAsyncMode = A, je.isConcurrentMode = z, je.isContextConsumer = N, je.isContextProvider = B, je.isElement = W, je.isForwardRef = Z, je.isFragment = ee, je.isLazy = M, je.isMemo = Y, je.isPortal = Q, je.isProfiler = J, je.isStrictMode = ae, je.isSuspense = V, je.isSuspenseList = fe, je.isValidElementType = k, je.typeOf = x;
  }()), je;
}
var gh;
function jz() {
  return gh || (gh = 1, process.env.NODE_ENV === "production" ? $l.exports = Cz() : $l.exports = Ez()), $l.exports;
}
var hh = jz();
const ph = (e) => typeof e == "object" && e != null && e.nodeType === 1, mh = (e, t) => (!t || e !== "hidden") && e !== "visible" && e !== "clip", Or = (e, t) => {
  if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
    const a = getComputedStyle(e, null);
    return mh(a.overflowY, t) || mh(a.overflowX, t) || ((o) => {
      const n = ((r) => {
        if (!r.ownerDocument || !r.ownerDocument.defaultView) return null;
        try {
          return r.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      })(o);
      return !!n && (n.clientHeight < o.scrollHeight || n.clientWidth < o.scrollWidth);
    })(e);
  }
  return !1;
}, zr = (e, t, a, o, n, r, i, s) => r < e && i > t || r > e && i < t ? 0 : r <= e && s <= a || i >= t && s >= a ? r - e - o : i > t && s < a || r < e && s > a ? i - t + n : 0, Oz = (e) => e.parentElement ?? (e.getRootNode().host || null), zz = (e, t) => {
  var a, o, n, r;
  if (typeof document > "u") return [];
  const { inline: i, boundary: s, skipOverflowHiddenElements: l } = t, c = typeof s == "function" ? s : (L) => L !== s;
  if (!ph(e)) throw new TypeError("Invalid target");
  const u = document.scrollingElement || document.documentElement, d = [];
  let h = e;
  for (; ph(h) && c(h); ) {
    if (h = Oz(h), h === u) {
      d.push(h);
      break;
    }
    h != null && h === document.body && Or(h) && !Or(document.documentElement) || h != null && Or(h, l) && d.push(h);
  }
  const m = (o = (a = window.visualViewport) == null ? void 0 : a.width) != null ? o : innerWidth, f = (r = (n = window.visualViewport) == null ? void 0 : n.height) != null ? r : innerHeight, { scrollX: p, scrollY: b } = window, { height: w, width: _, top: y, right: k, bottom: x, left: S } = e.getBoundingClientRect(), { top: $, right: E, left: C } = ((L) => {
    const O = window.getComputedStyle(L);
    return { top: parseFloat(O.scrollMarginTop) || 0, right: parseFloat(O.scrollMarginRight) || 0, bottom: parseFloat(O.scrollMarginBottom) || 0, left: parseFloat(O.scrollMarginLeft) || 0 };
  })(e);
  let j = y - $, R = i === "center" ? S + _ / 2 - C + E : i === "end" ? k + E : S - C;
  const H = [];
  for (let L = 0; L < d.length; L++) {
    const O = d[L], { height: U, width: I, top: K, right: q, bottom: te, left: A } = O.getBoundingClientRect();
    if (y >= 0 && S >= 0 && x <= f && k <= m && (O === u && !Or(O) || y >= K && x <= te && S >= A && k <= q)) return H;
    const z = getComputedStyle(O), N = parseInt(z.borderLeftWidth, 10), B = parseInt(z.borderTopWidth, 10), W = parseInt(z.borderRightWidth, 10), Z = parseInt(z.borderBottomWidth, 10);
    let ee = 0, M = 0;
    const Y = "offsetWidth" in O ? O.offsetWidth - O.clientWidth - N - W : 0, Q = "offsetHeight" in O ? O.offsetHeight - O.clientHeight - B - Z : 0, J = "offsetWidth" in O ? O.offsetWidth === 0 ? 0 : I / O.offsetWidth : 0, ae = "offsetHeight" in O ? O.offsetHeight === 0 ? 0 : U / O.offsetHeight : 0;
    if (u === O) ee = zr(b, b + f, f, B, Z, b + j, b + j + w, w), M = i === "start" ? R : i === "center" ? R - m / 2 : i === "end" ? R - m : zr(p, p + m, m, N, W, p + R, p + R + _, _), ee = Math.max(0, ee + b), M = Math.max(0, M + p);
    else {
      ee = zr(K, te, U, B, Z + Q, j, j + w, w), M = i === "start" ? R - A - N : i === "center" ? R - (A + I / 2) + Y / 2 : i === "end" ? R - q + W + Y : zr(A, q, I, N, W + Y, R, R + _, _);
      const { scrollLeft: V, scrollTop: fe } = O;
      ee = ae === 0 ? 0 : Math.max(0, Math.min(fe + ee / ae, O.scrollHeight - U / ae + Q)), M = J === 0 ? 0 : Math.max(0, Math.min(V + M / J, O.scrollWidth - I / J + Y)), j += fe - ee, R += V - M;
    }
    H.push({ el: O, top: ee, left: M });
  }
  return H;
};
var Az = 0;
function fh(e) {
  return typeof e == "function" ? e : yt;
}
function yt() {
}
function F_(e, t) {
  if (e) {
    var a = zz(e, {
      boundary: t
    });
    a.forEach(function(o) {
      var n = o.el, r = o.top, i = o.left;
      n.scrollTop = r, n.scrollLeft = i;
    });
  }
}
function bh(e, t, a) {
  var o = e === t || t instanceof a.Node && e.contains && e.contains(t);
  return o;
}
function Tu(e, t) {
  var a;
  function o() {
    a && clearTimeout(a);
  }
  function n() {
    for (var r = arguments.length, i = new Array(r), s = 0; s < r; s++)
      i[s] = arguments[s];
    o(), a = setTimeout(function() {
      a = null, e.apply(void 0, i);
    }, t);
  }
  return n.cancel = o, n;
}
function Ke() {
  for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++)
    t[a] = arguments[a];
  return function(o) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
      r[i - 1] = arguments[i];
    return t.some(function(s) {
      return s && s.apply(void 0, [o].concat(r)), o.preventDownshiftDefault || o.hasOwnProperty("nativeEvent") && o.nativeEvent.preventDownshiftDefault;
    });
  };
}
function Lo() {
  for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++)
    t[a] = arguments[a];
  return function(o) {
    t.forEach(function(n) {
      typeof n == "function" ? n(o) : n && (n.current = o);
    });
  };
}
function V_() {
  return String(Az++);
}
function Pz(e) {
  var t = e.isOpen, a = e.resultCount, o = e.previousResultCount;
  return t ? a ? a !== o ? a + " result" + (a === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter key to select." : "" : "No results are available." : "";
}
function _h(e, t) {
  return e = Array.isArray(e) ? (
    /* istanbul ignore next (preact) */
    e[0]
  ) : e, !e && t ? t : e;
}
function U_(e) {
  return typeof e.type == "string";
}
function q_(e) {
  return e.props;
}
function Dz(e, t) {
  console.error('The property "' + t + '" is required in "' + e + '"');
}
var Nz = ["highlightedIndex", "inputValue", "isOpen", "selectedItem", "type"];
function Ar(e) {
  e === void 0 && (e = {});
  var t = {};
  return Nz.forEach(function(a) {
    e.hasOwnProperty(a) && (t[a] = e[a]);
  }), t;
}
function ji(e, t) {
  return !e || !t ? e : Object.keys(e).reduce(function(a, o) {
    return a[o] = Oi(t, o) ? t[o] : e[o], a;
  }, {});
}
function Oi(e, t) {
  return e[t] !== void 0;
}
function vc(e) {
  var t = e.key, a = e.keyCode;
  return a >= 37 && a <= 40 && t.indexOf("Arrow") !== 0 ? "Arrow" + t : t;
}
function Rz(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Ga(e, t, a, o, n) {
  var r = a.length;
  if (r === 0)
    return -1;
  var i = r - 1;
  (typeof e != "number" || e < 0 || e > i) && (e = t > 0 ? -1 : i + 1);
  var s = e + t;
  s < 0 ? s = i : s > i && (s = 0);
  var l = Yo(s, t < 0, a, o, n);
  return l === -1 ? e >= r ? -1 : e : l;
}
function Yo(e, t, a, o, n) {
  n === void 0 && (n = !1);
  var r = a.length;
  if (t) {
    for (var i = e; i >= 0; i--)
      if (!o(a[i], i))
        return i;
  } else
    for (var s = e; s < r; s++)
      if (!o(a[s], s))
        return s;
  return n ? Yo(t ? r - 1 : 0, t, a, o) : -1;
}
function zi(e, t, a, o) {
  return o === void 0 && (o = !0), a && t.some(function(n) {
    return n && (bh(n, e, a) || o && bh(n, a.document.activeElement, a));
  });
}
var Lu = yt;
process.env.NODE_ENV !== "production" && (Lu = function(e, t, a) {
  var o = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
  Object.keys(e).forEach(function(n) {
    t[n] !== void 0 && a[n] === void 0 ? console.error('downshift: A component has changed the controlled prop "' + n + '" to be uncontrolled. ' + o) : t[n] === void 0 && a[n] !== void 0 && console.error('downshift: A component has changed the uncontrolled prop "' + n + '" to be controlled. ' + o);
  });
});
var Iz = Tu(function(e) {
  H_(e).textContent = "";
}, 500);
function H_(e) {
  var t = e.getElementById("a11y-status-message");
  return t || (t = e.createElement("div"), t.setAttribute("id", "a11y-status-message"), t.setAttribute("role", "status"), t.setAttribute("aria-live", "polite"), t.setAttribute("aria-relevant", "additions text"), Object.assign(t.style, {
    border: "0",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    width: "1px"
  }), e.body.appendChild(t), t);
}
function G_(e, t) {
  if (!(!e || !t)) {
    var a = H_(t);
    a.textContent = e, Iz(t);
  }
}
function Tz(e) {
  var t = e?.getElementById("a11y-status-message");
  t && t.remove();
}
var K_ = process.env.NODE_ENV !== "production" ? "__autocomplete_unknown__" : 0, J_ = process.env.NODE_ENV !== "production" ? "__autocomplete_mouseup__" : 1, Z_ = process.env.NODE_ENV !== "production" ? "__autocomplete_item_mouseenter__" : 2, oi = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_up__" : 3, ni = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_down__" : 4, Y_ = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_escape__" : 5, X_ = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_enter__" : 6, Q_ = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_home__" : 7, ev = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_end__" : 8, tv = process.env.NODE_ENV !== "production" ? "__autocomplete_click_item__" : 9, av = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_input__" : 10, ov = process.env.NODE_ENV !== "production" ? "__autocomplete_change_input__" : 11, nv = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_space_button__" : 12, yc = process.env.NODE_ENV !== "production" ? "__autocomplete_click_button__" : 13, rv = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_button__" : 14, iv = process.env.NODE_ENV !== "production" ? "__autocomplete_controlled_prop_updated_selected_item__" : 15, sv = process.env.NODE_ENV !== "production" ? "__autocomplete_touchend__" : 16, Lz = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blurButton: rv,
  blurInput: av,
  changeInput: ov,
  clickButton: yc,
  clickItem: tv,
  controlledPropUpdatedSelectedItem: iv,
  itemMouseEnter: Z_,
  keyDownArrowDown: ni,
  keyDownArrowUp: oi,
  keyDownEnd: ev,
  keyDownEnter: X_,
  keyDownEscape: Y_,
  keyDownHome: Q_,
  keyDownSpaceButton: nv,
  mouseUp: J_,
  touchEnd: sv,
  unknown: K_
}), Mz = ["refKey", "ref"], Wz = ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"], Bz = ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"], Fz = ["refKey", "ref"], Vz = ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"], Uz = /* @__PURE__ */ function() {
  var e = /* @__PURE__ */ function(t) {
    function a(n) {
      var r;
      r = t.call(this, n) || this, r.id = r.props.id || "downshift-" + V_(), r.menuId = r.props.menuId || r.id + "-menu", r.labelId = r.props.labelId || r.id + "-label", r.inputId = r.props.inputId || r.id + "-input", r.getItemId = r.props.getItemId || function(_) {
        return r.id + "-item-" + _;
      }, r.items = [], r.itemCount = null, r.previousResultCount = 0, r.timeoutIds = [], r.internalSetTimeout = function(_, y) {
        var k = setTimeout(function() {
          r.timeoutIds = r.timeoutIds.filter(function(x) {
            return x !== k;
          }), _();
        }, y);
        r.timeoutIds.push(k);
      }, r.setItemCount = function(_) {
        r.itemCount = _;
      }, r.unsetItemCount = function() {
        r.itemCount = null;
      }, r.isItemDisabled = function(_, y) {
        var k = r.getItemNodeFromIndex(y);
        return k && k.hasAttribute("disabled");
      }, r.setHighlightedIndex = function(_, y) {
        _ === void 0 && (_ = r.props.defaultHighlightedIndex), y === void 0 && (y = {}), y = Ar(y), r.internalSetState(pe({
          highlightedIndex: _
        }, y));
      }, r.clearSelection = function(_) {
        r.internalSetState({
          selectedItem: null,
          inputValue: "",
          highlightedIndex: r.props.defaultHighlightedIndex,
          isOpen: r.props.defaultIsOpen
        }, _);
      }, r.selectItem = function(_, y, k) {
        y = Ar(y), r.internalSetState(pe({
          isOpen: r.props.defaultIsOpen,
          highlightedIndex: r.props.defaultHighlightedIndex,
          selectedItem: _,
          inputValue: r.props.itemToString(_)
        }, y), k);
      }, r.selectItemAtIndex = function(_, y, k) {
        var x = r.items[_];
        x != null && r.selectItem(x, y, k);
      }, r.selectHighlightedItem = function(_, y) {
        return r.selectItemAtIndex(r.getState().highlightedIndex, _, y);
      }, r.internalSetState = function(_, y) {
        var k, x, S = {}, $ = typeof _ == "function";
        return !$ && _.hasOwnProperty("inputValue") && r.props.onInputValueChange(_.inputValue, pe({}, r.getStateAndHelpers(), _)), r.setState(function(E) {
          var C;
          E = r.getState(E);
          var j = $ ? _(E) : _;
          j = r.props.stateReducer(E, j), k = j.hasOwnProperty("selectedItem");
          var R = {};
          return k && j.selectedItem !== E.selectedItem && (x = j.selectedItem), (C = j).type || (C.type = K_), Object.keys(j).forEach(function(H) {
            E[H] !== j[H] && (S[H] = j[H]), H !== "type" && (j[H], Oi(r.props, H) || (R[H] = j[H]));
          }), $ && j.hasOwnProperty("inputValue") && r.props.onInputValueChange(j.inputValue, pe({}, r.getStateAndHelpers(), j)), R;
        }, function() {
          fh(y)();
          var E = Object.keys(S).length > 1;
          E && r.props.onStateChange(S, r.getStateAndHelpers()), k && r.props.onSelect(_.selectedItem, r.getStateAndHelpers()), x !== void 0 && r.props.onChange(x, r.getStateAndHelpers()), r.props.onUserAction(S, r.getStateAndHelpers());
        });
      }, r.rootRef = function(_) {
        return r._rootNode = _;
      }, r.getRootProps = function(_, y) {
        var k, x = _ === void 0 ? {} : _, S = x.refKey, $ = S === void 0 ? "ref" : S, E = x.ref, C = da(x, Mz), j = y === void 0 ? {} : y, R = j.suppressRefError, H = R === void 0 ? !1 : R;
        r.getRootProps.called = !0, r.getRootProps.refKey = $, r.getRootProps.suppressRefError = H;
        var L = r.getState(), O = L.isOpen;
        return pe((k = {}, k[$] = Lo(E, r.rootRef), k.role = "combobox", k["aria-expanded"] = O, k["aria-haspopup"] = "listbox", k["aria-owns"] = O ? r.menuId : void 0, k["aria-labelledby"] = r.labelId, k), C);
      }, r.keyDownHandlers = {
        ArrowDown: function(_) {
          var y = this;
          if (_.preventDefault(), this.getState().isOpen) {
            var k = _.shiftKey ? 5 : 1;
            this.moveHighlightedIndex(k, {
              type: ni
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: ni
            }, function() {
              var x = y.getItemCount();
              if (x > 0) {
                var S = y.getState(), $ = S.highlightedIndex, E = Ga($, 1, {
                  length: x
                }, y.isItemDisabled, !0);
                y.setHighlightedIndex(E, {
                  type: ni
                });
              }
            });
        },
        ArrowUp: function(_) {
          var y = this;
          if (_.preventDefault(), this.getState().isOpen) {
            var k = _.shiftKey ? -5 : -1;
            this.moveHighlightedIndex(k, {
              type: oi
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: oi
            }, function() {
              var x = y.getItemCount();
              if (x > 0) {
                var S = y.getState(), $ = S.highlightedIndex, E = Ga($, -1, {
                  length: x
                }, y.isItemDisabled, !0);
                y.setHighlightedIndex(E, {
                  type: oi
                });
              }
            });
        },
        Enter: function(_) {
          if (_.which !== 229) {
            var y = this.getState(), k = y.isOpen, x = y.highlightedIndex;
            if (k && x != null) {
              _.preventDefault();
              var S = this.items[x], $ = this.getItemNodeFromIndex(x);
              if (S == null || $ && $.hasAttribute("disabled"))
                return;
              this.selectHighlightedItem({
                type: X_
              });
            }
          }
        },
        Escape: function(_) {
          _.preventDefault(), this.reset(pe({
            type: Y_
          }, !this.state.isOpen && {
            selectedItem: null,
            inputValue: ""
          }));
        }
      }, r.buttonKeyDownHandlers = pe({}, r.keyDownHandlers, {
        " ": function(_) {
          _.preventDefault(), this.toggleMenu({
            type: nv
          });
        }
      }), r.inputKeyDownHandlers = pe({}, r.keyDownHandlers, {
        Home: function(_) {
          var y = this.getState(), k = y.isOpen;
          if (k) {
            _.preventDefault();
            var x = this.getItemCount();
            if (!(x <= 0 || !k)) {
              var S = Yo(0, !1, {
                length: x
              }, this.isItemDisabled);
              this.setHighlightedIndex(S, {
                type: Q_
              });
            }
          }
        },
        End: function(_) {
          var y = this.getState(), k = y.isOpen;
          if (k) {
            _.preventDefault();
            var x = this.getItemCount();
            if (!(x <= 0 || !k)) {
              var S = Yo(x - 1, !0, {
                length: x
              }, this.isItemDisabled);
              this.setHighlightedIndex(S, {
                type: ev
              });
            }
          }
        }
      }), r.getToggleButtonProps = function(_) {
        var y = _ === void 0 ? {} : _, k = y.onClick;
        y.onPress;
        var x = y.onKeyDown, S = y.onKeyUp, $ = y.onBlur, E = da(y, Wz), C = r.getState(), j = C.isOpen, R = {
          onClick: Ke(k, r.buttonHandleClick),
          onKeyDown: Ke(x, r.buttonHandleKeyDown),
          onKeyUp: Ke(S, r.buttonHandleKeyUp),
          onBlur: Ke($, r.buttonHandleBlur)
        }, H = E.disabled ? {} : R;
        return pe({
          type: "button",
          role: "button",
          "aria-label": j ? "close menu" : "open menu",
          "aria-haspopup": !0,
          "data-toggle": !0
        }, H, E);
      }, r.buttonHandleKeyUp = function(_) {
        _.preventDefault();
      }, r.buttonHandleKeyDown = function(_) {
        var y = vc(_);
        r.buttonKeyDownHandlers[y] && r.buttonKeyDownHandlers[y].call(r, _);
      }, r.buttonHandleClick = function(_) {
        if (_.preventDefault(), r.props.environment) {
          var y = r.props.environment.document, k = y.body, x = y.activeElement;
          k && k === x && _.target.focus();
        }
        process.env.NODE_ENV === "test" ? r.toggleMenu({
          type: yc
        }) : r.internalSetTimeout(function() {
          return r.toggleMenu({
            type: yc
          });
        });
      }, r.buttonHandleBlur = function(_) {
        var y = _.target;
        r.internalSetTimeout(function() {
          if (!(r.isMouseDown || !r.props.environment)) {
            var k = r.props.environment.document.activeElement;
            (k == null || k.id !== r.inputId) && k !== y && r.reset({
              type: rv
            });
          }
        });
      }, r.getLabelProps = function(_) {
        return pe({
          htmlFor: r.inputId,
          id: r.labelId
        }, _);
      }, r.getInputProps = function(_) {
        var y = _ === void 0 ? {} : _, k = y.onKeyDown, x = y.onBlur, S = y.onChange, $ = y.onInput;
        y.onChangeText;
        var E = da(y, Bz), C, j = {};
        C = "onChange";
        var R = r.getState(), H = R.inputValue, L = R.isOpen, O = R.highlightedIndex;
        if (!E.disabled) {
          var U;
          j = (U = {}, U[C] = Ke(S, $, r.inputHandleChange), U.onKeyDown = Ke(k, r.inputHandleKeyDown), U.onBlur = Ke(x, r.inputHandleBlur), U);
        }
        return pe({
          "aria-autocomplete": "list",
          "aria-activedescendant": L && typeof O == "number" && O >= 0 ? r.getItemId(O) : void 0,
          "aria-controls": L ? r.menuId : void 0,
          "aria-labelledby": E && E["aria-label"] ? void 0 : r.labelId,
          // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
          // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
          autoComplete: "off",
          value: H,
          id: r.inputId
        }, j, E);
      }, r.inputHandleKeyDown = function(_) {
        var y = vc(_);
        y && r.inputKeyDownHandlers[y] && r.inputKeyDownHandlers[y].call(r, _);
      }, r.inputHandleChange = function(_) {
        r.internalSetState({
          type: ov,
          isOpen: !0,
          inputValue: _.target.value,
          highlightedIndex: r.props.defaultHighlightedIndex
        });
      }, r.inputHandleBlur = function() {
        r.internalSetTimeout(function() {
          var _;
          if (!(r.isMouseDown || !r.props.environment)) {
            var y = r.props.environment.document.activeElement, k = (y == null || (_ = y.dataset) == null ? void 0 : _.toggle) && r._rootNode && r._rootNode.contains(y);
            k || r.reset({
              type: av
            });
          }
        });
      }, r.menuRef = function(_) {
        r._menuNode = _;
      }, r.getMenuProps = function(_, y) {
        var k, x = _ === void 0 ? {} : _, S = x.refKey, $ = S === void 0 ? "ref" : S, E = x.ref, C = da(x, Fz), j = y === void 0 ? {} : y, R = j.suppressRefError, H = R === void 0 ? !1 : R;
        return r.getMenuProps.called = !0, r.getMenuProps.refKey = $, r.getMenuProps.suppressRefError = H, pe((k = {}, k[$] = Lo(E, r.menuRef), k.role = "listbox", k["aria-labelledby"] = C && C["aria-label"] ? void 0 : r.labelId, k.id = r.menuId, k), C);
      }, r.getItemProps = function(_) {
        var y, k = _ === void 0 ? {} : _, x = k.onMouseMove, S = k.onMouseDown, $ = k.onClick;
        k.onPress;
        var E = k.index, C = k.item, j = C === void 0 ? process.env.NODE_ENV === "production" ? (
          /* istanbul ignore next */
          void 0
        ) : Dz("getItemProps", "item") : C, R = da(k, Vz);
        E === void 0 ? (r.items.push(j), E = r.items.indexOf(j)) : r.items[E] = j;
        var H = "onClick", L = $, O = (y = {
          // onMouseMove is used over onMouseEnter here. onMouseMove
          // is only triggered on actual mouse movement while onMouseEnter
          // can fire on DOM changes, interrupting keyboard navigation
          onMouseMove: Ke(x, function() {
            E !== r.getState().highlightedIndex && (r.setHighlightedIndex(E, {
              type: Z_
            }), r.avoidScrolling = !0, r.internalSetTimeout(function() {
              return r.avoidScrolling = !1;
            }, 250));
          }),
          onMouseDown: Ke(S, function(I) {
            I.preventDefault();
          })
        }, y[H] = Ke(L, function() {
          r.selectItemAtIndex(E, {
            type: tv
          });
        }), y), U = R.disabled ? {
          onMouseDown: O.onMouseDown
        } : O;
        return pe({
          id: r.getItemId(E),
          role: "option",
          "aria-selected": r.getState().highlightedIndex === E
        }, U, R);
      }, r.clearItems = function() {
        r.items = [];
      }, r.reset = function(_, y) {
        _ === void 0 && (_ = {}), _ = Ar(_), r.internalSetState(function(k) {
          var x = k.selectedItem;
          return pe({
            isOpen: r.props.defaultIsOpen,
            highlightedIndex: r.props.defaultHighlightedIndex,
            inputValue: r.props.itemToString(x)
          }, _);
        }, y);
      }, r.toggleMenu = function(_, y) {
        _ === void 0 && (_ = {}), _ = Ar(_), r.internalSetState(function(k) {
          var x = k.isOpen;
          return pe({
            isOpen: !x
          }, x && {
            highlightedIndex: r.props.defaultHighlightedIndex
          }, _);
        }, function() {
          var k = r.getState(), x = k.isOpen, S = k.highlightedIndex;
          x && r.getItemCount() > 0 && typeof S == "number" && r.setHighlightedIndex(S, _), fh(y)();
        });
      }, r.openMenu = function(_) {
        r.internalSetState({
          isOpen: !0
        }, _);
      }, r.closeMenu = function(_) {
        r.internalSetState({
          isOpen: !1
        }, _);
      }, r.updateStatus = Tu(function() {
        var _;
        if ((_ = r.props) != null && (_ = _.environment) != null && _.document) {
          var y = r.getState(), k = r.items[y.highlightedIndex], x = r.getItemCount(), S = r.props.getA11yStatusMessage(pe({
            itemToString: r.props.itemToString,
            previousResultCount: r.previousResultCount,
            resultCount: x,
            highlightedItem: k
          }, y));
          r.previousResultCount = x, G_(S, r.props.environment.document);
        }
      }, 200);
      var i = r.props, s = i.defaultHighlightedIndex, l = i.initialHighlightedIndex, c = l === void 0 ? s : l, u = i.defaultIsOpen, d = i.initialIsOpen, h = d === void 0 ? u : d, m = i.initialInputValue, f = m === void 0 ? "" : m, p = i.initialSelectedItem, b = p === void 0 ? null : p, w = r.getState({
        highlightedIndex: c,
        isOpen: h,
        inputValue: f,
        selectedItem: b
      });
      return w.selectedItem != null && r.props.initialInputValue === void 0 && (w.inputValue = r.props.itemToString(w.selectedItem)), r.state = w, r;
    }
    bz(a, t);
    var o = a.prototype;
    return o.internalClearTimeouts = function() {
      this.timeoutIds.forEach(function(n) {
        clearTimeout(n);
      }), this.timeoutIds = [];
    }, o.getState = function(n) {
      return n === void 0 && (n = this.state), ji(n, this.props);
    }, o.getItemCount = function() {
      var n = this.items.length;
      return this.itemCount != null ? n = this.itemCount : this.props.itemCount !== void 0 && (n = this.props.itemCount), n;
    }, o.getItemNodeFromIndex = function(n) {
      return this.props.environment ? this.props.environment.document.getElementById(this.getItemId(n)) : null;
    }, o.scrollHighlightedItemIntoView = function() {
      {
        var n = this.getItemNodeFromIndex(this.getState().highlightedIndex);
        this.props.scrollIntoView(n, this._menuNode);
      }
    }, o.moveHighlightedIndex = function(n, r) {
      var i = this.getItemCount(), s = this.getState(), l = s.highlightedIndex;
      if (i > 0) {
        var c = Ga(l, n, {
          length: i
        }, this.isItemDisabled, !0);
        this.setHighlightedIndex(c, r);
      }
    }, o.getStateAndHelpers = function() {
      var n = this.getState(), r = n.highlightedIndex, i = n.inputValue, s = n.selectedItem, l = n.isOpen, c = this.props.itemToString, u = this.id, d = this.getRootProps, h = this.getToggleButtonProps, m = this.getLabelProps, f = this.getMenuProps, p = this.getInputProps, b = this.getItemProps, w = this.openMenu, _ = this.closeMenu, y = this.toggleMenu, k = this.selectItem, x = this.selectItemAtIndex, S = this.selectHighlightedItem, $ = this.setHighlightedIndex, E = this.clearSelection, C = this.clearItems, j = this.reset, R = this.setItemCount, H = this.unsetItemCount, L = this.internalSetState;
      return {
        // prop getters
        getRootProps: d,
        getToggleButtonProps: h,
        getLabelProps: m,
        getMenuProps: f,
        getInputProps: p,
        getItemProps: b,
        // actions
        reset: j,
        openMenu: w,
        closeMenu: _,
        toggleMenu: y,
        selectItem: k,
        selectItemAtIndex: x,
        selectHighlightedItem: S,
        setHighlightedIndex: $,
        clearSelection: E,
        clearItems: C,
        setItemCount: R,
        unsetItemCount: H,
        setState: L,
        // props
        itemToString: c,
        // derived
        id: u,
        // state
        highlightedIndex: r,
        inputValue: i,
        isOpen: l,
        selectedItem: s
      };
    }, o.componentDidMount = function() {
      var n = this;
      if (process.env.NODE_ENV !== "production" && this.getMenuProps.called && !this.getMenuProps.suppressRefError && vh(this._menuNode, this.getMenuProps), !this.props.environment)
        this.cleanup = function() {
          n.internalClearTimeouts();
        };
      else {
        var r = function() {
          n.isMouseDown = !0;
        }, i = function(d) {
          n.isMouseDown = !1;
          var h = zi(d.target, [n._rootNode, n._menuNode], n.props.environment);
          !h && n.getState().isOpen && n.reset({
            type: J_
          }, function() {
            return n.props.onOuterClick(n.getStateAndHelpers());
          });
        }, s = function() {
          n.isTouchMove = !1;
        }, l = function() {
          n.isTouchMove = !0;
        }, c = function(d) {
          var h = zi(d.target, [n._rootNode, n._menuNode], n.props.environment, !1);
          !n.isTouchMove && !h && n.getState().isOpen && n.reset({
            type: sv
          }, function() {
            return n.props.onOuterClick(n.getStateAndHelpers());
          });
        }, u = this.props.environment;
        u.addEventListener("mousedown", r), u.addEventListener("mouseup", i), u.addEventListener("touchstart", s), u.addEventListener("touchmove", l), u.addEventListener("touchend", c), this.cleanup = function() {
          n.internalClearTimeouts(), n.updateStatus.cancel(), u.removeEventListener("mousedown", r), u.removeEventListener("mouseup", i), u.removeEventListener("touchstart", s), u.removeEventListener("touchmove", l), u.removeEventListener("touchend", c);
        };
      }
    }, o.shouldScroll = function(n, r) {
      var i = this.props.highlightedIndex === void 0 ? this.getState() : this.props, s = i.highlightedIndex, l = r.highlightedIndex === void 0 ? n : r, c = l.highlightedIndex, u = s && this.getState().isOpen && !n.isOpen, d = s !== c;
      return u || d;
    }, o.componentDidUpdate = function(n, r) {
      process.env.NODE_ENV !== "production" && (Lu(this.state, n, this.props), this.getMenuProps.called && !this.getMenuProps.suppressRefError && vh(this._menuNode, this.getMenuProps)), Oi(this.props, "selectedItem") && this.props.selectedItemChanged(n.selectedItem, this.props.selectedItem) && this.internalSetState({
        type: iv,
        inputValue: this.props.itemToString(this.props.selectedItem)
      }), !this.avoidScrolling && this.shouldScroll(r, n) && this.scrollHighlightedItemIntoView(), this.updateStatus();
    }, o.componentWillUnmount = function() {
      this.cleanup();
    }, o.render = function() {
      var n = _h(this.props.children, yt);
      this.clearItems(), this.getRootProps.called = !1, this.getRootProps.refKey = void 0, this.getRootProps.suppressRefError = void 0, this.getMenuProps.called = !1, this.getMenuProps.refKey = void 0, this.getMenuProps.suppressRefError = void 0, this.getLabelProps.called = !1, this.getInputProps.called = !1;
      var r = _h(n(this.getStateAndHelpers()));
      if (!r)
        return null;
      if (this.getRootProps.called || this.props.suppressRefError)
        return process.env.NODE_ENV !== "production" && !this.getRootProps.suppressRefError && !this.props.suppressRefError && qz(r, this.getRootProps), r;
      if (U_(r))
        return /* @__PURE__ */ Gm(r, this.getRootProps(q_(r)));
      if (process.env.NODE_ENV !== "production")
        throw new Error("downshift: If you return a non-DOM element, you must apply the getRootProps function");
    }, a;
  }(px);
  return e.defaultProps = {
    defaultHighlightedIndex: null,
    defaultIsOpen: !1,
    getA11yStatusMessage: Pz,
    itemToString: function(t) {
      return t == null ? "" : (process.env.NODE_ENV !== "production" && Rz(t) && !t.hasOwnProperty("toString") && console.warn("downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.", "The object that was passed:", t), String(t));
    },
    onStateChange: yt,
    onInputValueChange: yt,
    onUserAction: yt,
    onChange: yt,
    onSelect: yt,
    onOuterClick: yt,
    selectedItemChanged: function(t, a) {
      return t !== a;
    },
    environment: (
      /* istanbul ignore next (ssr) */
      typeof window > "u" ? void 0 : window
    ),
    stateReducer: function(t, a) {
      return a;
    },
    suppressRefError: !1,
    scrollIntoView: F_
  }, e.stateChangeTypes = Lz, e;
}();
process.env.NODE_ENV !== "production" && (Uz.propTypes = {
  children: G.func,
  defaultHighlightedIndex: G.number,
  defaultIsOpen: G.bool,
  initialHighlightedIndex: G.number,
  initialSelectedItem: G.any,
  initialInputValue: G.string,
  initialIsOpen: G.bool,
  getA11yStatusMessage: G.func,
  itemToString: G.func,
  onChange: G.func,
  onSelect: G.func,
  onStateChange: G.func,
  onInputValueChange: G.func,
  onUserAction: G.func,
  onOuterClick: G.func,
  selectedItemChanged: G.func,
  stateReducer: G.func,
  itemCount: G.number,
  id: G.string,
  environment: G.shape({
    addEventListener: G.func.isRequired,
    removeEventListener: G.func.isRequired,
    document: G.shape({
      createElement: G.func.isRequired,
      getElementById: G.func.isRequired,
      activeElement: G.any.isRequired,
      body: G.any.isRequired
    }).isRequired,
    Node: G.func.isRequired
  }),
  suppressRefError: G.bool,
  scrollIntoView: G.func,
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components
  /* eslint-disable react/no-unused-prop-types */
  selectedItem: G.any,
  isOpen: G.bool,
  inputValue: G.string,
  highlightedIndex: G.number,
  labelId: G.string,
  inputId: G.string,
  menuId: G.string,
  getItemId: G.func
  /* eslint-enable react/no-unused-prop-types */
});
function vh(e, t) {
  var a = t.refKey;
  e || console.error('downshift: The ref prop "' + a + '" from getMenuProps was not applied correctly on your menu element.');
}
function qz(e, t) {
  var a = t.refKey, o = a !== "ref", n = !U_(e);
  n && !o && !hh.isForwardRef(e) ? console.error("downshift: You returned a non-DOM element. You must specify a refKey in getRootProps") : !n && o && console.error('downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified "' + a + '"'), !hh.isForwardRef(e) && !q_(e)[a] && console.error('downshift: You must apply the ref prop "' + a + '" from getRootProps onto your root element.');
}
var lv = {
  highlightedIndex: -1,
  isOpen: !1,
  selectedItem: null,
  inputValue: ""
};
function Hz(e, t, a) {
  var o = e.props, n = e.type, r = {};
  Object.keys(t).forEach(function(i) {
    Gz(i, e, t, a), a[i] !== t[i] && (r[i] = a[i]);
  }), o.onStateChange && Object.keys(r).length && o.onStateChange(pe({
    type: n
  }, r));
}
function Gz(e, t, a, o) {
  var n = t.props, r = t.type, i = "on" + Mu(e) + "Change";
  n[i] && o[e] !== void 0 && o[e] !== a[e] && n[i](pe({
    type: r
  }, o));
}
function Kz(e, t) {
  return t.changes;
}
var yh = Tu(function(e, t) {
  G_(e, t);
}, 200), Jz = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? Km : Ce, Zz = "useId" in ne ? function(e) {
  var t = e.id, a = e.labelId, o = e.menuId, n = e.getItemId, r = e.toggleButtonId, i = e.inputId, s = "downshift-" + ne.useId();
  t || (t = s);
  var l = Ie({
    labelId: a || t + "-label",
    menuId: o || t + "-menu",
    getItemId: n || function(c) {
      return t + "-item-" + c;
    },
    toggleButtonId: r || t + "-toggle-button",
    inputId: i || t + "-input"
  });
  return l.current;
} : function(e) {
  var t = e.id, a = t === void 0 ? "downshift-" + V_() : t, o = e.labelId, n = e.menuId, r = e.getItemId, i = e.toggleButtonId, s = e.inputId, l = Ie({
    labelId: o || a + "-label",
    menuId: n || a + "-menu",
    getItemId: r || function(c) {
      return a + "-item-" + c;
    },
    toggleButtonId: i || a + "-toggle-button",
    inputId: s || a + "-input"
  });
  return l.current;
};
function Yz(e, t, a, o) {
  var n, r;
  if (e === void 0) {
    if (t === void 0)
      throw new Error(o);
    n = a[t], r = t;
  } else
    r = t === void 0 ? a.indexOf(e) : t, n = e;
  return [n, r];
}
function Mu(e) {
  return "" + e.slice(0, 1).toUpperCase() + e.slice(1);
}
function cv(e) {
  var t = Ie(e);
  return t.current = e, t;
}
function Xz(e, t, a, o) {
  var n = Ie(), r = Ie(), i = Le(function(m, f) {
    r.current = f, m = ji(m, f.props);
    var p = e(m, f), b = f.props.stateReducer(m, pe({}, f, {
      changes: p
    }));
    return b;
  }, [e]), s = hx(i, t, a), l = s[0], c = s[1], u = cv(t), d = Le(function(m) {
    return c(pe({
      props: u.current
    }, m));
  }, [u]), h = r.current;
  return Ce(function() {
    var m = ji(n.current, h?.props), f = h && n.current && !o(m, l);
    f && Hz(h, m, l), n.current = l;
  }, [l, h, o]), [l, d];
}
var jn = {
  itemToString: function(e) {
    return e ? String(e) : "";
  },
  itemToKey: function(e) {
    return e;
  },
  stateReducer: Kz,
  scrollIntoView: F_,
  environment: (
    /* istanbul ignore next (ssr) */
    typeof window > "u" ? void 0 : window
  )
};
function Pa(e, t, a) {
  a === void 0 && (a = lv);
  var o = e["default" + Mu(t)];
  return o !== void 0 ? o : a[t];
}
function On(e, t, a) {
  a === void 0 && (a = lv);
  var o = e[t];
  if (o !== void 0)
    return o;
  var n = e["initial" + Mu(t)];
  return n !== void 0 ? n : Pa(e, t, a);
}
function Qz(e) {
  var t = On(e, "selectedItem"), a = On(e, "isOpen"), o = nA(e), n = On(e, "inputValue");
  return {
    highlightedIndex: o < 0 && t && a ? e.items.findIndex(function(r) {
      return e.itemToKey(r) === e.itemToKey(t);
    }) : o,
    isOpen: a,
    selectedItem: t,
    inputValue: n
  };
}
function zn(e, t, a) {
  var o = e.items, n = e.initialHighlightedIndex, r = e.defaultHighlightedIndex, i = e.isItemDisabled, s = e.itemToKey, l = t.selectedItem, c = t.highlightedIndex;
  return o.length === 0 ? -1 : n !== void 0 && c === n && !i(o[n], n) ? n : r !== void 0 && !i(o[r], r) ? r : l ? o.findIndex(function(u) {
    return s(l) === s(u);
  }) : a < 0 && !i(o[o.length - 1], o.length - 1) ? o.length - 1 : a > 0 && !i(o[0], 0) ? 0 : -1;
}
function eA(e, t, a) {
  var o = Ie({
    isMouseDown: !1,
    isTouchMove: !1,
    isTouchEnd: !1
  });
  return Ce(function() {
    if (!e)
      return yt;
    var n = a.map(function(u) {
      return u.current;
    });
    function r() {
      o.current.isTouchEnd = !1, o.current.isMouseDown = !0;
    }
    function i(u) {
      o.current.isMouseDown = !1, zi(u.target, n, e) || t();
    }
    function s() {
      o.current.isTouchEnd = !1, o.current.isTouchMove = !1;
    }
    function l() {
      o.current.isTouchMove = !0;
    }
    function c(u) {
      o.current.isTouchEnd = !0, !o.current.isTouchMove && !zi(u.target, n, e, !1) && t();
    }
    return e.addEventListener("mousedown", r), e.addEventListener("mouseup", i), e.addEventListener("touchstart", s), e.addEventListener("touchmove", l), e.addEventListener("touchend", c), function() {
      e.removeEventListener("mousedown", r), e.removeEventListener("mouseup", i), e.removeEventListener("touchstart", s), e.removeEventListener("touchmove", l), e.removeEventListener("touchend", c);
    };
  }, [a, e, t]), o.current;
}
var uv = function() {
  return yt;
};
process.env.NODE_ENV !== "production" && (uv = function() {
  for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++)
    t[a] = arguments[a];
  var o = Ie(t.reduce(function(r, i) {
    return r[i] = {}, r;
  }, {}));
  Ce(function() {
    Object.keys(o.current).forEach(function(r) {
      var i = o.current[r];
      if (!Object.keys(i).length) {
        console.error("downshift: You forgot to call the " + r + " getter function on your component / element.");
        return;
      }
      var s = i.suppressRefError, l = i.refKey, c = i.elementRef;
      s || c != null && c.current || console.error('downshift: The ref prop "' + l + '" from ' + r + " was not applied correctly on your element.");
    });
  }, []);
  var n = Le(function(r, i, s, l) {
    o.current[r] = {
      suppressRefError: i,
      refKey: s,
      elementRef: l
    };
  }, []);
  return n;
});
function tA(e, t, a, o) {
  o === void 0 && (o = {});
  var n = o.document, r = vs();
  Ce(function() {
    if (!(!e || r || !n)) {
      var i = e(t);
      yh(i, n);
    }
  }, a), Ce(function() {
    return function() {
      yh.cancel(), Tz(n);
    };
  }, [n]);
}
function aA(e) {
  var t = e.highlightedIndex, a = e.isOpen, o = e.itemRefs, n = e.getItemNodeFromIndex, r = e.menuElement, i = e.scrollIntoView, s = Ie(!0);
  return Jz(function() {
    t < 0 || !a || !Object.keys(o.current).length || (s.current === !1 ? s.current = !0 : i(n(t), r));
  }, [t]), s;
}
var dv = yt;
process.env.NODE_ENV !== "production" && (dv = function(e) {
  var t = e.props, a = e.state, o = Ie(t), n = vs();
  Ce(function() {
    n || (Lu(a, o.current, t), o.current = t);
  }, [a, t, n]);
});
function wh(e, t, a) {
  var o;
  a === void 0 && (a = !0);
  var n = ((o = e.items) == null ? void 0 : o.length) && t >= 0;
  return pe({
    isOpen: !1,
    highlightedIndex: -1
  }, n && pe({
    selectedItem: e.items[t],
    isOpen: Pa(e, "isOpen"),
    highlightedIndex: Pa(e, "highlightedIndex")
  }, a && {
    inputValue: e.itemToString(e.items[t])
  }));
}
function oA(e, t) {
  return e.isOpen === t.isOpen && e.inputValue === t.inputValue && e.highlightedIndex === t.highlightedIndex && e.selectedItem === t.selectedItem;
}
function vs() {
  var e = ne.useRef(!0);
  return ne.useEffect(function() {
    return e.current = !1, function() {
      e.current = !0;
    };
  }, []), e.current;
}
function wc(e) {
  var t = Pa(e, "highlightedIndex");
  return t > -1 && e.isItemDisabled(e.items[t], t) ? -1 : t;
}
function nA(e) {
  var t = On(e, "highlightedIndex");
  return t > -1 && e.isItemDisabled(e.items[t], t) ? -1 : t;
}
var ri = {
  environment: G.shape({
    addEventListener: G.func.isRequired,
    removeEventListener: G.func.isRequired,
    document: G.shape({
      createElement: G.func.isRequired,
      getElementById: G.func.isRequired,
      activeElement: G.any.isRequired,
      body: G.any.isRequired
    }).isRequired,
    Node: G.func.isRequired
  }),
  itemToString: G.func,
  itemToKey: G.func,
  stateReducer: G.func
}, gv = pe({}, ri, {
  getA11yStatusMessage: G.func,
  highlightedIndex: G.number,
  defaultHighlightedIndex: G.number,
  initialHighlightedIndex: G.number,
  isOpen: G.bool,
  defaultIsOpen: G.bool,
  initialIsOpen: G.bool,
  selectedItem: G.any,
  initialSelectedItem: G.any,
  defaultSelectedItem: G.any,
  id: G.string,
  labelId: G.string,
  menuId: G.string,
  getItemId: G.func,
  toggleButtonId: G.string,
  onSelectedItemChange: G.func,
  onHighlightedIndexChange: G.func,
  onStateChange: G.func,
  onIsOpenChange: G.func,
  scrollIntoView: G.func
});
function rA(e, t, a) {
  var o = t.type, n = t.props, r;
  switch (o) {
    case a.ItemMouseMove:
      r = {
        highlightedIndex: t.disabled ? -1 : t.index
      };
      break;
    case a.MenuMouseLeave:
      r = {
        highlightedIndex: -1
      };
      break;
    case a.ToggleButtonClick:
    case a.FunctionToggleMenu:
      r = {
        isOpen: !e.isOpen,
        highlightedIndex: e.isOpen ? -1 : zn(n, e, 0)
      };
      break;
    case a.FunctionOpenMenu:
      r = {
        isOpen: !0,
        highlightedIndex: zn(n, e, 0)
      };
      break;
    case a.FunctionCloseMenu:
      r = {
        isOpen: !1
      };
      break;
    case a.FunctionSetHighlightedIndex:
      r = {
        highlightedIndex: n.isItemDisabled(n.items[t.highlightedIndex], t.highlightedIndex) ? -1 : t.highlightedIndex
      };
      break;
    case a.FunctionSetInputValue:
      r = {
        inputValue: t.inputValue
      };
      break;
    case a.FunctionReset:
      r = {
        highlightedIndex: wc(n),
        isOpen: Pa(n, "isOpen"),
        selectedItem: Pa(n, "selectedItem"),
        inputValue: Pa(n, "inputValue")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return pe({}, e, r);
}
ct(ct({}, gv), { items: G.array.isRequired, isItemDisabled: G.func });
ct(ct({}, jn), { isItemDisabled: function() {
  return !1;
} });
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
var Wu = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_down__" : 0, Bu = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_up__" : 1, Fu = process.env.NODE_ENV !== "production" ? "__input_keydown_escape__" : 2, Vu = process.env.NODE_ENV !== "production" ? "__input_keydown_home__" : 3, Uu = process.env.NODE_ENV !== "production" ? "__input_keydown_end__" : 4, qu = process.env.NODE_ENV !== "production" ? "__input_keydown_page_up__" : 5, Hu = process.env.NODE_ENV !== "production" ? "__input_keydown_page_down__" : 6, Gu = process.env.NODE_ENV !== "production" ? "__input_keydown_enter__" : 7, Ku = process.env.NODE_ENV !== "production" ? "__input_change__" : 8, Ai = process.env.NODE_ENV !== "production" ? "__input_blur__" : 9, Ju = process.env.NODE_ENV !== "production" ? "__input_click__" : 10, hv = process.env.NODE_ENV !== "production" ? "__menu_mouse_leave__" : 11, pv = process.env.NODE_ENV !== "production" ? "__item_mouse_move__" : 12, Zu = process.env.NODE_ENV !== "production" ? "__item_click__" : 13, mv = process.env.NODE_ENV !== "production" ? "__togglebutton_click__" : 14, fv = process.env.NODE_ENV !== "production" ? "__function_toggle_menu__" : 15, bv = process.env.NODE_ENV !== "production" ? "__function_open_menu__" : 16, _v = process.env.NODE_ENV !== "production" ? "__function_close_menu__" : 17, vv = process.env.NODE_ENV !== "production" ? "__function_set_highlighted_index__" : 18, Yu = process.env.NODE_ENV !== "production" ? "__function_select_item__" : 19, yv = process.env.NODE_ENV !== "production" ? "__function_set_input_value__" : 20, wv = process.env.NODE_ENV !== "production" ? "__function_reset__" : 21, Xu = process.env.NODE_ENV !== "production" ? "__controlled_prop_updated_selected_item__" : 22, kv = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ControlledPropUpdatedSelectedItem: Xu,
  FunctionCloseMenu: _v,
  FunctionOpenMenu: bv,
  FunctionReset: wv,
  FunctionSelectItem: Yu,
  FunctionSetHighlightedIndex: vv,
  FunctionSetInputValue: yv,
  FunctionToggleMenu: fv,
  InputBlur: Ai,
  InputChange: Ku,
  InputClick: Ju,
  InputKeyDownArrowDown: Wu,
  InputKeyDownArrowUp: Bu,
  InputKeyDownEnd: Uu,
  InputKeyDownEnter: Gu,
  InputKeyDownEscape: Fu,
  InputKeyDownHome: Vu,
  InputKeyDownPageDown: Hu,
  InputKeyDownPageUp: qu,
  ItemClick: Zu,
  ItemMouseMove: pv,
  MenuMouseLeave: hv,
  ToggleButtonClick: mv
});
function iA(e) {
  var t = Qz(e), a = t.selectedItem, o = t.inputValue;
  return o === "" && a && e.defaultInputValue === void 0 && e.initialInputValue === void 0 && e.inputValue === void 0 && (o = e.itemToString(a)), pe({}, t, {
    inputValue: o
  });
}
var sA = pe({}, gv, {
  items: G.array.isRequired,
  isItemDisabled: G.func,
  inputValue: G.string,
  defaultInputValue: G.string,
  initialInputValue: G.string,
  inputId: G.string,
  onInputValueChange: G.func
});
function lA(e, t, a, o) {
  var n = Ie(), r = Xz(e, t, a, o), i = r[0], s = r[1], l = vs();
  return Ce(function() {
    if (Oi(t, "selectedItem")) {
      if (!l) {
        var c = t.itemToKey(t.selectedItem) !== t.itemToKey(n.current);
        c && s({
          type: Xu,
          inputValue: t.itemToString(t.selectedItem)
        });
      }
      n.current = i.selectedItem === n.current ? t.selectedItem : i.selectedItem;
    }
  }, [i.selectedItem, t.selectedItem]), [ji(i, t), s];
}
var xv = yt;
process.env.NODE_ENV !== "production" && (xv = function(e, t) {
  G.checkPropTypes(sA, e, "prop", t.name);
});
var cA = pe({}, jn, {
  isItemDisabled: function() {
    return !1;
  }
});
function uA(e, t) {
  var a, o = t.type, n = t.props, r = t.altKey, i;
  switch (o) {
    case Zu:
      i = {
        isOpen: Pa(n, "isOpen"),
        highlightedIndex: wc(n),
        selectedItem: n.items[t.index],
        inputValue: n.itemToString(n.items[t.index])
      };
      break;
    case Wu:
      e.isOpen ? i = {
        highlightedIndex: Ga(e.highlightedIndex, 1, n.items, n.isItemDisabled, !0)
      } : i = {
        highlightedIndex: r && e.selectedItem == null ? -1 : zn(n, e, 1),
        isOpen: n.items.length >= 0
      };
      break;
    case Bu:
      e.isOpen ? r ? i = wh(n, e.highlightedIndex) : i = {
        highlightedIndex: Ga(e.highlightedIndex, -1, n.items, n.isItemDisabled, !0)
      } : i = {
        highlightedIndex: zn(n, e, -1),
        isOpen: n.items.length >= 0
      };
      break;
    case Gu:
      i = wh(n, e.highlightedIndex);
      break;
    case Fu:
      i = pe({
        isOpen: !1,
        highlightedIndex: -1
      }, !e.isOpen && {
        selectedItem: null,
        inputValue: ""
      });
      break;
    case qu:
      i = {
        highlightedIndex: Ga(e.highlightedIndex, -10, n.items, n.isItemDisabled, !0)
      };
      break;
    case Hu:
      i = {
        highlightedIndex: Ga(e.highlightedIndex, 10, n.items, n.isItemDisabled, !0)
      };
      break;
    case Vu:
      i = {
        highlightedIndex: Yo(0, !1, n.items, n.isItemDisabled)
      };
      break;
    case Uu:
      i = {
        highlightedIndex: Yo(n.items.length - 1, !0, n.items, n.isItemDisabled)
      };
      break;
    case Ai:
      i = pe({
        isOpen: !1,
        highlightedIndex: -1
      }, e.highlightedIndex >= 0 && ((a = n.items) == null ? void 0 : a.length) && t.selectItem && {
        selectedItem: n.items[e.highlightedIndex],
        inputValue: n.itemToString(n.items[e.highlightedIndex])
      });
      break;
    case Ku:
      i = {
        isOpen: !0,
        highlightedIndex: wc(n),
        inputValue: t.inputValue
      };
      break;
    case Ju:
      i = {
        isOpen: !e.isOpen,
        highlightedIndex: e.isOpen ? -1 : zn(n, e, 0)
      };
      break;
    case Yu:
      i = {
        selectedItem: t.selectedItem,
        inputValue: n.itemToString(t.selectedItem)
      };
      break;
    case Xu:
      i = {
        inputValue: t.inputValue
      };
      break;
    default:
      return rA(e, t, kv);
  }
  return pe({}, e, i);
}
var dA = ["onMouseLeave", "refKey", "ref"], gA = ["item", "index", "refKey", "ref", "onMouseMove", "onMouseDown", "onClick", "onPress", "disabled"], hA = ["onClick", "onPress", "refKey", "ref"], pA = ["onKeyDown", "onChange", "onInput", "onBlur", "onChangeText", "onClick", "refKey", "ref"];
Qu.stateChangeTypes = kv;
function Qu(e) {
  e === void 0 && (e = {}), xv(e, Qu);
  var t = pe({}, cA, e), a = t.items, o = t.scrollIntoView, n = t.environment, r = t.getA11yStatusMessage, i = lA(uA, t, iA, oA), s = i[0], l = i[1], c = s.isOpen, u = s.highlightedIndex, d = s.selectedItem, h = s.inputValue, m = Ie(null), f = Ie({}), p = Ie(null), b = Ie(null), w = vs(), _ = Zz(t), y = Ie(), k = cv({
    state: s,
    props: t
  }), x = Le(function(N) {
    return f.current[_.getItemId(N)];
  }, [_]);
  tA(r, s, [c, u, d, h], n);
  var S = aA({
    menuElement: m.current,
    highlightedIndex: u,
    isOpen: c,
    itemRefs: f,
    scrollIntoView: o,
    getItemNodeFromIndex: x
  });
  dv({
    props: t,
    state: s
  }), Ce(function() {
    var N = On(t, "isOpen");
    N && p.current && p.current.focus();
  }, []), Ce(function() {
    w || (y.current = a.length);
  });
  var $ = eA(n, Le(function() {
    k.current.state.isOpen && l({
      type: Ai,
      selectItem: !1
    });
  }, [l, k]), Ho(function() {
    return [m, b, p];
  }, [m.current, b.current, p.current])), E = uv("getInputProps", "getMenuProps");
  Ce(function() {
    c || (f.current = {});
  }, [c]), Ce(function() {
    var N;
    !c || !(n != null && n.document) || !(p != null && (N = p.current) != null && N.focus) || n.document.activeElement !== p.current && p.current.focus();
  }, [c, n]);
  var C = Ho(function() {
    return {
      ArrowDown: function(N) {
        N.preventDefault(), l({
          type: Wu,
          altKey: N.altKey
        });
      },
      ArrowUp: function(N) {
        N.preventDefault(), l({
          type: Bu,
          altKey: N.altKey
        });
      },
      Home: function(N) {
        k.current.state.isOpen && (N.preventDefault(), l({
          type: Vu
        }));
      },
      End: function(N) {
        k.current.state.isOpen && (N.preventDefault(), l({
          type: Uu
        }));
      },
      Escape: function(N) {
        var B = k.current.state;
        (B.isOpen || B.inputValue || B.selectedItem || B.highlightedIndex > -1) && (N.preventDefault(), l({
          type: Fu
        }));
      },
      Enter: function(N) {
        var B = k.current.state;
        !B.isOpen || N.which === 229 || (N.preventDefault(), l({
          type: Gu
        }));
      },
      PageUp: function(N) {
        k.current.state.isOpen && (N.preventDefault(), l({
          type: qu
        }));
      },
      PageDown: function(N) {
        k.current.state.isOpen && (N.preventDefault(), l({
          type: Hu
        }));
      }
    };
  }, [l, k]), j = Le(function(N) {
    return pe({
      id: _.labelId,
      htmlFor: _.inputId
    }, N);
  }, [_]), R = Le(function(N, B) {
    var W, Z = N === void 0 ? {} : N, ee = Z.onMouseLeave, M = Z.refKey, Y = M === void 0 ? "ref" : M, Q = Z.ref, J = da(Z, dA), ae = B === void 0 ? {} : B, V = ae.suppressRefError, fe = V === void 0 ? !1 : V;
    return E("getMenuProps", fe, Y, m), pe((W = {}, W[Y] = Lo(Q, function(X) {
      m.current = X;
    }), W.id = _.menuId, W.role = "listbox", W["aria-labelledby"] = J && J["aria-label"] ? void 0 : "" + _.labelId, W.onMouseLeave = Ke(ee, function() {
      l({
        type: hv
      });
    }), W), J);
  }, [l, E, _]), H = Le(function(N) {
    var B, W, Z = N === void 0 ? {} : N, ee = Z.item, M = Z.index, Y = Z.refKey, Q = Y === void 0 ? "ref" : Y, J = Z.ref, ae = Z.onMouseMove, V = Z.onMouseDown, fe = Z.onClick;
    Z.onPress;
    var X = Z.disabled, Ye = da(Z, gA);
    X !== void 0 && console.warn('Passing "disabled" as an argument to getItemProps is not supported anymore. Please use the isItemDisabled prop from useCombobox.');
    var Ve = k.current, Ft = Ve.props, ft = Ve.state, Ba = Yz(ee, M, Ft.items, "Pass either item or index to getItemProps!"), Fa = Ba[0], $t = Ba[1], ia = Ft.isItemDisabled(Fa, $t), ka = "onClick", Va = fe, we = function() {
      $.isTouchEnd || $t === ft.highlightedIndex || (S.current = !1, l({
        type: pv,
        index: $t,
        disabled: ia
      }));
    }, bt = function() {
      l({
        type: Zu,
        index: $t
      });
    }, oe = function(Ua) {
      return Ua.preventDefault();
    };
    return pe((B = {}, B[Q] = Lo(J, function(Ua) {
      Ua && (f.current[_.getItemId($t)] = Ua);
    }), B["aria-disabled"] = ia, B["aria-selected"] = $t === ft.highlightedIndex, B.id = _.getItemId($t), B.role = "option", B), !ia && (W = {}, W[ka] = Ke(Va, bt), W), {
      onMouseMove: Ke(ae, we),
      onMouseDown: Ke(V, oe)
    }, Ye);
  }, [l, _, k, $, S]), L = Le(function(N) {
    var B, W = N === void 0 ? {} : N, Z = W.onClick;
    W.onPress;
    var ee = W.refKey, M = ee === void 0 ? "ref" : ee, Y = W.ref, Q = da(W, hA), J = k.current.state, ae = function() {
      l({
        type: mv
      });
    };
    return pe((B = {}, B[M] = Lo(Y, function(V) {
      b.current = V;
    }), B["aria-controls"] = _.menuId, B["aria-expanded"] = J.isOpen, B.id = _.toggleButtonId, B.tabIndex = -1, B), !Q.disabled && pe({}, {
      onClick: Ke(Z, ae)
    }), Q);
  }, [l, k, _]), O = Le(function(N, B) {
    var W, Z = N === void 0 ? {} : N, ee = Z.onKeyDown, M = Z.onChange, Y = Z.onInput, Q = Z.onBlur;
    Z.onChangeText;
    var J = Z.onClick, ae = Z.refKey, V = ae === void 0 ? "ref" : ae, fe = Z.ref, X = da(Z, pA), Ye = B === void 0 ? {} : B, Ve = Ye.suppressRefError, Ft = Ve === void 0 ? !1 : Ve;
    E("getInputProps", Ft, V, p);
    var ft = k.current.state, Ba = function(bt) {
      var oe = vc(bt);
      oe && C[oe] && C[oe](bt);
    }, Fa = function(bt) {
      l({
        type: Ku,
        inputValue: bt.target.value
      });
    }, $t = function(bt) {
      if (n != null && n.document && ft.isOpen && !$.isMouseDown) {
        var oe = bt.relatedTarget === null && n.document.activeElement !== n.document.body;
        l({
          type: Ai,
          selectItem: !oe
        });
      }
    }, ia = function() {
      l({
        type: Ju
      });
    }, ka = "onChange", Va = {};
    if (!X.disabled) {
      var we;
      Va = (we = {}, we[ka] = Ke(M, Y, Fa), we.onKeyDown = Ke(ee, Ba), we.onBlur = Ke(Q, $t), we.onClick = Ke(J, ia), we);
    }
    return pe((W = {}, W[V] = Lo(fe, function(bt) {
      p.current = bt;
    }), W["aria-activedescendant"] = ft.isOpen && ft.highlightedIndex > -1 ? _.getItemId(ft.highlightedIndex) : "", W["aria-autocomplete"] = "list", W["aria-controls"] = _.menuId, W["aria-expanded"] = ft.isOpen, W["aria-labelledby"] = X && X["aria-label"] ? void 0 : _.labelId, W.autoComplete = "off", W.id = _.inputId, W.role = "combobox", W.value = ft.inputValue, W), Va, X);
  }, [l, _, n, C, k, $, E]), U = Le(function() {
    l({
      type: fv
    });
  }, [l]), I = Le(function() {
    l({
      type: _v
    });
  }, [l]), K = Le(function() {
    l({
      type: bv
    });
  }, [l]), q = Le(function(N) {
    l({
      type: vv,
      highlightedIndex: N
    });
  }, [l]), te = Le(function(N) {
    l({
      type: Yu,
      selectedItem: N
    });
  }, [l]), A = Le(function(N) {
    l({
      type: yv,
      inputValue: N
    });
  }, [l]), z = Le(function() {
    l({
      type: wv
    });
  }, [l]);
  return {
    // prop getters.
    getItemProps: H,
    getLabelProps: j,
    getMenuProps: R,
    getInputProps: O,
    getToggleButtonProps: L,
    // actions.
    toggleMenu: U,
    openMenu: K,
    closeMenu: I,
    setHighlightedIndex: q,
    setInputValue: A,
    selectItem: te,
    reset: z,
    // state.
    highlightedIndex: u,
    isOpen: c,
    selectedItem: d,
    inputValue: h
  };
}
ri.stateReducer, ri.itemToKey, ri.environment, G.array, G.array, G.array, G.func, G.number, G.number, G.number, G.func, G.func, G.string, G.string;
jn.itemToKey, jn.stateReducer, jn.environment;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
const mA = "_autocomplete_olk74_29", fA = "_suggestion_olk74_87", bA = "_highlight_olk74_107", $a = {
  autocomplete: mA,
  "autocomplete-container": "_autocomplete-container_olk74_38",
  "input-button-container": "_input-button-container_olk74_43",
  "autocomplete-input": "_autocomplete-input_olk74_49",
  "autocomplete-button": "_autocomplete-button_olk74_63",
  "suggestions-container": "_suggestions-container_olk74_87",
  suggestion: fA,
  highlight: bA
};
function _A({
  id: e,
  placeholder: t,
  value: a,
  onChange: o,
  suggestions: n = [],
  buttonText: r,
  onSubmit: i,
  hideButtonText: s,
  className: l,
  ...c
}) {
  const { isOpen: u, getLabelProps: d, getMenuProps: h, getInputProps: m, highlightedIndex: f, getItemProps: p, selectedItem: b } = Qu({
    id: e,
    onInputValueChange({ inputValue: y }) {
      o && o(y ?? "");
    },
    items: n,
    itemToString(y) {
      return y?.value ?? "";
    }
  }), w = ao($a.autocomplete, l);
  function _(y) {
    y.preventDefault(), i && i(y, b ?? void 0);
  }
  return /* @__PURE__ */ T("div", { className: w, ...c, children: [
    /* @__PURE__ */ v("form", { className: $a["autocomplete-container"], onSubmit: _, children: /* @__PURE__ */ T("div", { className: $a["input-button-container"], children: [
      /* @__PURE__ */ v("label", { ...d(), hidden: !0, children: t }),
      /* @__PURE__ */ v(
        "input",
        {
          className: $a["autocomplete-input"],
          type: "text",
          placeholder: t,
          value: a,
          ...m()
        }
      ),
      /* @__PURE__ */ T("button", { "aria-label": r, className: $a["autocomplete-button"], children: [
        /* @__PURE__ */ v(In, { name: "search" }),
        !s && r
      ] })
    ] }) }),
    /* @__PURE__ */ v("ul", { className: $a["suggestions-container"], ...h(), "data-test": u, "aria-busy": !u, children: u && n.map((y, k) => /* @__PURE__ */ v(
      "li",
      {
        className: `${$a.suggestion} ${f === k ? $a.highlight : ""}`,
        ...p({ item: y, index: k }),
        children: y.value
      },
      y.id
    )) })
  ] });
}
function vA(e, [t, a]) {
  return Math.min(a, Math.max(t, e));
}
var ys = "Switch", [yA, Nrt] = _o(ys), [wA, kA] = yA(ys), xA = g.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: a,
      name: o,
      checked: n,
      defaultChecked: r,
      required: i,
      disabled: s,
      value: l = "on",
      onCheckedChange: c,
      form: u,
      ...d
    } = e, [h, m] = g.useState(null), f = He(t, (y) => m(y)), p = g.useRef(!1), b = h ? u || !!h.closest("form") : !0, [w, _] = ms({
      prop: n,
      defaultProp: r ?? !1,
      onChange: c,
      caller: ys
    });
    return /* @__PURE__ */ T(wA, { scope: a, checked: w, disabled: s, children: [
      /* @__PURE__ */ v(
        ze.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": w,
          "aria-required": i,
          "data-state": Cv(w),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: l,
          ...d,
          ref: f,
          onClick: be(e.onClick, (y) => {
            _((k) => !k), b && (p.current = y.isPropagationStopped(), p.current || y.stopPropagation());
          })
        }
      ),
      b && /* @__PURE__ */ v(
        Sv,
        {
          control: h,
          bubbles: !p.current,
          name: o,
          value: l,
          checked: w,
          required: i,
          disabled: s,
          form: u,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
xA.displayName = ys;
var $v = "SwitchThumb", $A = g.forwardRef(
  (e, t) => {
    const { __scopeSwitch: a, ...o } = e, n = kA($v, a);
    return /* @__PURE__ */ v(
      ze.span,
      {
        "data-state": Cv(n.checked),
        "data-disabled": n.disabled ? "" : void 0,
        ...o,
        ref: t
      }
    );
  }
);
$A.displayName = $v;
var SA = "SwitchBubbleInput", Sv = g.forwardRef(
  ({
    __scopeSwitch: e,
    control: t,
    checked: a,
    bubbles: o = !0,
    ...n
  }, r) => {
    const i = g.useRef(null), s = He(i, r), l = $j(a), c = xj(t);
    return g.useEffect(() => {
      const u = i.current;
      if (!u) return;
      const d = window.HTMLInputElement.prototype, h = Object.getOwnPropertyDescriptor(
        d,
        "checked"
      ).set;
      if (l !== a && h) {
        const m = new Event("click", { bubbles: o });
        h.call(u, a), u.dispatchEvent(m);
      }
    }, [l, a, o]), /* @__PURE__ */ v(
      "input",
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: a,
        ...n,
        tabIndex: -1,
        ref: s,
        style: {
          ...n.style,
          ...c,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
Sv.displayName = SA;
function Cv(e) {
  return e ? "checked" : "unchecked";
}
function CA(e, t) {
  return g.useReducer((a, o) => t[a][o] ?? a, e);
}
var ed = "ScrollArea", [Ev, Rrt] = _o(ed), [EA, Pt] = Ev(ed), jA = g.forwardRef(
  (e, t) => {
    const {
      __scopeScrollArea: a,
      type: o = "hover",
      dir: n,
      scrollHideDelay: r = 600,
      ...i
    } = e, [s, l] = g.useState(null), [c, u] = g.useState(null), [d, h] = g.useState(null), [m, f] = g.useState(null), [p, b] = g.useState(null), [w, _] = g.useState(0), [y, k] = g.useState(0), [x, S] = g.useState(!1), [$, E] = g.useState(!1), C = He(t, (R) => l(R)), j = Ou(n);
    return /* @__PURE__ */ v(
      EA,
      {
        scope: a,
        type: o,
        dir: j,
        scrollHideDelay: r,
        scrollArea: s,
        viewport: c,
        onViewportChange: u,
        content: d,
        onContentChange: h,
        scrollbarX: m,
        onScrollbarXChange: f,
        scrollbarXEnabled: x,
        onScrollbarXEnabledChange: S,
        scrollbarY: p,
        onScrollbarYChange: b,
        scrollbarYEnabled: $,
        onScrollbarYEnabledChange: E,
        onCornerWidthChange: _,
        onCornerHeightChange: k,
        children: /* @__PURE__ */ v(
          ze.div,
          {
            dir: j,
            ...i,
            ref: C,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": w + "px",
              "--radix-scroll-area-corner-height": y + "px",
              ...e.style
            }
          }
        )
      }
    );
  }
);
jA.displayName = ed;
var jv = "ScrollAreaViewport", OA = g.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: a, children: o, nonce: n, ...r } = e, i = Pt(jv, a), s = g.useRef(null), l = He(t, s, i.onViewportChange);
    return /* @__PURE__ */ T(De, { children: [
      /* @__PURE__ */ v(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: n
        }
      ),
      /* @__PURE__ */ v(
        ze.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...r,
          ref: l,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: i.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: i.scrollbarYEnabled ? "scroll" : "hidden",
            ...e.style
          },
          children: /* @__PURE__ */ v("div", { ref: i.onContentChange, style: { minWidth: "100%", display: "table" }, children: o })
        }
      )
    ] });
  }
);
OA.displayName = jv;
var ta = "ScrollAreaScrollbar", zA = g.forwardRef(
  (e, t) => {
    const { forceMount: a, ...o } = e, n = Pt(ta, e.__scopeScrollArea), { onScrollbarXEnabledChange: r, onScrollbarYEnabledChange: i } = n, s = e.orientation === "horizontal";
    return g.useEffect(() => (s ? r(!0) : i(!0), () => {
      s ? r(!1) : i(!1);
    }), [s, r, i]), n.type === "hover" ? /* @__PURE__ */ v(AA, { ...o, ref: t, forceMount: a }) : n.type === "scroll" ? /* @__PURE__ */ v(PA, { ...o, ref: t, forceMount: a }) : n.type === "auto" ? /* @__PURE__ */ v(Ov, { ...o, ref: t, forceMount: a }) : n.type === "always" ? /* @__PURE__ */ v(td, { ...o, ref: t }) : null;
  }
);
zA.displayName = ta;
var AA = g.forwardRef((e, t) => {
  const { forceMount: a, ...o } = e, n = Pt(ta, e.__scopeScrollArea), [r, i] = g.useState(!1);
  return g.useEffect(() => {
    const s = n.scrollArea;
    let l = 0;
    if (s) {
      const c = () => {
        window.clearTimeout(l), i(!0);
      }, u = () => {
        l = window.setTimeout(() => i(!1), n.scrollHideDelay);
      };
      return s.addEventListener("pointerenter", c), s.addEventListener("pointerleave", u), () => {
        window.clearTimeout(l), s.removeEventListener("pointerenter", c), s.removeEventListener("pointerleave", u);
      };
    }
  }, [n.scrollArea, n.scrollHideDelay]), /* @__PURE__ */ v(_a, { present: a || r, children: /* @__PURE__ */ v(
    Ov,
    {
      "data-state": r ? "visible" : "hidden",
      ...o,
      ref: t
    }
  ) });
}), PA = g.forwardRef((e, t) => {
  const { forceMount: a, ...o } = e, n = Pt(ta, e.__scopeScrollArea), r = e.orientation === "horizontal", i = ks(() => l("SCROLL_END"), 100), [s, l] = CA("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return g.useEffect(() => {
    if (s === "idle") {
      const c = window.setTimeout(() => l("HIDE"), n.scrollHideDelay);
      return () => window.clearTimeout(c);
    }
  }, [s, n.scrollHideDelay, l]), g.useEffect(() => {
    const c = n.viewport, u = r ? "scrollLeft" : "scrollTop";
    if (c) {
      let d = c[u];
      const h = () => {
        const m = c[u];
        d !== m && (l("SCROLL"), i()), d = m;
      };
      return c.addEventListener("scroll", h), () => c.removeEventListener("scroll", h);
    }
  }, [n.viewport, r, l, i]), /* @__PURE__ */ v(_a, { present: a || s !== "hidden", children: /* @__PURE__ */ v(
    td,
    {
      "data-state": s === "hidden" ? "hidden" : "visible",
      ...o,
      ref: t,
      onPointerEnter: be(e.onPointerEnter, () => l("POINTER_ENTER")),
      onPointerLeave: be(e.onPointerLeave, () => l("POINTER_LEAVE"))
    }
  ) });
}), Ov = g.forwardRef((e, t) => {
  const a = Pt(ta, e.__scopeScrollArea), { forceMount: o, ...n } = e, [r, i] = g.useState(!1), s = e.orientation === "horizontal", l = ks(() => {
    if (a.viewport) {
      const c = a.viewport.offsetWidth < a.viewport.scrollWidth, u = a.viewport.offsetHeight < a.viewport.scrollHeight;
      i(s ? c : u);
    }
  }, 10);
  return Xo(a.viewport, l), Xo(a.content, l), /* @__PURE__ */ v(_a, { present: o || r, children: /* @__PURE__ */ v(
    td,
    {
      "data-state": r ? "visible" : "hidden",
      ...n,
      ref: t
    }
  ) });
}), td = g.forwardRef((e, t) => {
  const { orientation: a = "vertical", ...o } = e, n = Pt(ta, e.__scopeScrollArea), r = g.useRef(null), i = g.useRef(0), [s, l] = g.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), c = Pv(s.viewport, s.content), u = {
    ...o,
    sizes: s,
    onSizesChange: l,
    hasThumb: c > 0 && c < 1,
    onThumbChange: (h) => r.current = h,
    onThumbPointerUp: () => i.current = 0,
    onThumbPointerDown: (h) => i.current = h
  };
  function d(h, m) {
    return WA(h, i.current, s, m);
  }
  return a === "horizontal" ? /* @__PURE__ */ v(
    DA,
    {
      ...u,
      ref: t,
      onThumbPositionChange: () => {
        if (n.viewport && r.current) {
          const h = n.viewport.scrollLeft, m = kh(h, s, n.dir);
          r.current.style.transform = `translate3d(${m}px, 0, 0)`;
        }
      },
      onWheelScroll: (h) => {
        n.viewport && (n.viewport.scrollLeft = h);
      },
      onDragScroll: (h) => {
        n.viewport && (n.viewport.scrollLeft = d(h, n.dir));
      }
    }
  ) : a === "vertical" ? /* @__PURE__ */ v(
    NA,
    {
      ...u,
      ref: t,
      onThumbPositionChange: () => {
        if (n.viewport && r.current) {
          const h = n.viewport.scrollTop, m = kh(h, s);
          r.current.style.transform = `translate3d(0, ${m}px, 0)`;
        }
      },
      onWheelScroll: (h) => {
        n.viewport && (n.viewport.scrollTop = h);
      },
      onDragScroll: (h) => {
        n.viewport && (n.viewport.scrollTop = d(h));
      }
    }
  ) : null;
}), DA = g.forwardRef((e, t) => {
  const { sizes: a, onSizesChange: o, ...n } = e, r = Pt(ta, e.__scopeScrollArea), [i, s] = g.useState(), l = g.useRef(null), c = He(t, l, r.onScrollbarXChange);
  return g.useEffect(() => {
    l.current && s(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ v(
    Av,
    {
      "data-orientation": "horizontal",
      ...n,
      ref: c,
      sizes: a,
      style: {
        bottom: 0,
        left: r.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: r.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": ws(a) + "px",
        ...e.style
      },
      onThumbPointerDown: (u) => e.onThumbPointerDown(u.x),
      onDragScroll: (u) => e.onDragScroll(u.x),
      onWheelScroll: (u, d) => {
        if (r.viewport) {
          const h = r.viewport.scrollLeft + u.deltaX;
          e.onWheelScroll(h), Nv(h, d) && u.preventDefault();
        }
      },
      onResize: () => {
        l.current && r.viewport && i && o({
          content: r.viewport.scrollWidth,
          viewport: r.viewport.offsetWidth,
          scrollbar: {
            size: l.current.clientWidth,
            paddingStart: Di(i.paddingLeft),
            paddingEnd: Di(i.paddingRight)
          }
        });
      }
    }
  );
}), NA = g.forwardRef((e, t) => {
  const { sizes: a, onSizesChange: o, ...n } = e, r = Pt(ta, e.__scopeScrollArea), [i, s] = g.useState(), l = g.useRef(null), c = He(t, l, r.onScrollbarYChange);
  return g.useEffect(() => {
    l.current && s(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ v(
    Av,
    {
      "data-orientation": "vertical",
      ...n,
      ref: c,
      sizes: a,
      style: {
        top: 0,
        right: r.dir === "ltr" ? 0 : void 0,
        left: r.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": ws(a) + "px",
        ...e.style
      },
      onThumbPointerDown: (u) => e.onThumbPointerDown(u.y),
      onDragScroll: (u) => e.onDragScroll(u.y),
      onWheelScroll: (u, d) => {
        if (r.viewport) {
          const h = r.viewport.scrollTop + u.deltaY;
          e.onWheelScroll(h), Nv(h, d) && u.preventDefault();
        }
      },
      onResize: () => {
        l.current && r.viewport && i && o({
          content: r.viewport.scrollHeight,
          viewport: r.viewport.offsetHeight,
          scrollbar: {
            size: l.current.clientHeight,
            paddingStart: Di(i.paddingTop),
            paddingEnd: Di(i.paddingBottom)
          }
        });
      }
    }
  );
}), [RA, zv] = Ev(ta), Av = g.forwardRef((e, t) => {
  const {
    __scopeScrollArea: a,
    sizes: o,
    hasThumb: n,
    onThumbChange: r,
    onThumbPointerUp: i,
    onThumbPointerDown: s,
    onThumbPositionChange: l,
    onDragScroll: c,
    onWheelScroll: u,
    onResize: d,
    ...h
  } = e, m = Pt(ta, a), [f, p] = g.useState(null), b = He(t, (C) => p(C)), w = g.useRef(null), _ = g.useRef(""), y = m.viewport, k = o.content - o.viewport, x = Qe(u), S = Qe(l), $ = ks(d, 10);
  function E(C) {
    if (w.current) {
      const j = C.clientX - w.current.left, R = C.clientY - w.current.top;
      c({ x: j, y: R });
    }
  }
  return g.useEffect(() => {
    const C = (j) => {
      const R = j.target;
      f?.contains(R) && x(j, k);
    };
    return document.addEventListener("wheel", C, { passive: !1 }), () => document.removeEventListener("wheel", C, { passive: !1 });
  }, [y, f, k, x]), g.useEffect(S, [o, S]), Xo(f, $), Xo(m.content, $), /* @__PURE__ */ v(
    RA,
    {
      scope: a,
      scrollbar: f,
      hasThumb: n,
      onThumbChange: Qe(r),
      onThumbPointerUp: Qe(i),
      onThumbPositionChange: S,
      onThumbPointerDown: Qe(s),
      children: /* @__PURE__ */ v(
        ze.div,
        {
          ...h,
          ref: b,
          style: { position: "absolute", ...h.style },
          onPointerDown: be(e.onPointerDown, (C) => {
            C.button === 0 && (C.target.setPointerCapture(C.pointerId), w.current = f.getBoundingClientRect(), _.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", m.viewport && (m.viewport.style.scrollBehavior = "auto"), E(C));
          }),
          onPointerMove: be(e.onPointerMove, E),
          onPointerUp: be(e.onPointerUp, (C) => {
            const j = C.target;
            j.hasPointerCapture(C.pointerId) && j.releasePointerCapture(C.pointerId), document.body.style.webkitUserSelect = _.current, m.viewport && (m.viewport.style.scrollBehavior = ""), w.current = null;
          })
        }
      )
    }
  );
}), Pi = "ScrollAreaThumb", IA = g.forwardRef(
  (e, t) => {
    const { forceMount: a, ...o } = e, n = zv(Pi, e.__scopeScrollArea);
    return /* @__PURE__ */ v(_a, { present: a || n.hasThumb, children: /* @__PURE__ */ v(TA, { ref: t, ...o }) });
  }
), TA = g.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: a, style: o, ...n } = e, r = Pt(Pi, a), i = zv(Pi, a), { onThumbPositionChange: s } = i, l = He(
      t,
      (d) => i.onThumbChange(d)
    ), c = g.useRef(void 0), u = ks(() => {
      c.current && (c.current(), c.current = void 0);
    }, 100);
    return g.useEffect(() => {
      const d = r.viewport;
      if (d) {
        const h = () => {
          if (u(), !c.current) {
            const m = BA(d, s);
            c.current = m, s();
          }
        };
        return s(), d.addEventListener("scroll", h), () => d.removeEventListener("scroll", h);
      }
    }, [r.viewport, u, s]), /* @__PURE__ */ v(
      ze.div,
      {
        "data-state": i.hasThumb ? "visible" : "hidden",
        ...n,
        ref: l,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...o
        },
        onPointerDownCapture: be(e.onPointerDownCapture, (d) => {
          const h = d.target.getBoundingClientRect(), m = d.clientX - h.left, f = d.clientY - h.top;
          i.onThumbPointerDown({ x: m, y: f });
        }),
        onPointerUp: be(e.onPointerUp, i.onThumbPointerUp)
      }
    );
  }
);
IA.displayName = Pi;
var ad = "ScrollAreaCorner", LA = g.forwardRef(
  (e, t) => {
    const a = Pt(ad, e.__scopeScrollArea), o = !!(a.scrollbarX && a.scrollbarY);
    return a.type !== "scroll" && o ? /* @__PURE__ */ v(MA, { ...e, ref: t }) : null;
  }
);
LA.displayName = ad;
var MA = g.forwardRef((e, t) => {
  const { __scopeScrollArea: a, ...o } = e, n = Pt(ad, a), [r, i] = g.useState(0), [s, l] = g.useState(0), c = !!(r && s);
  return Xo(n.scrollbarX, () => {
    const u = n.scrollbarX?.offsetHeight || 0;
    n.onCornerHeightChange(u), l(u);
  }), Xo(n.scrollbarY, () => {
    const u = n.scrollbarY?.offsetWidth || 0;
    n.onCornerWidthChange(u), i(u);
  }), c ? /* @__PURE__ */ v(
    ze.div,
    {
      ...o,
      ref: t,
      style: {
        width: r,
        height: s,
        position: "absolute",
        right: n.dir === "ltr" ? 0 : void 0,
        left: n.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...e.style
      }
    }
  ) : null;
});
function Di(e) {
  return e ? parseInt(e, 10) : 0;
}
function Pv(e, t) {
  const a = e / t;
  return isNaN(a) ? 0 : a;
}
function ws(e) {
  const t = Pv(e.viewport, e.content), a = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, o = (e.scrollbar.size - a) * t;
  return Math.max(o, 18);
}
function WA(e, t, a, o = "ltr") {
  const n = ws(a), r = n / 2, i = t || r, s = n - i, l = a.scrollbar.paddingStart + i, c = a.scrollbar.size - a.scrollbar.paddingEnd - s, u = a.content - a.viewport, d = o === "ltr" ? [0, u] : [u * -1, 0];
  return Dv([l, c], d)(e);
}
function kh(e, t, a = "ltr") {
  const o = ws(t), n = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, r = t.scrollbar.size - n, i = t.content - t.viewport, s = r - o, l = a === "ltr" ? [0, i] : [i * -1, 0], c = vA(e, l);
  return Dv([0, i], [0, s])(c);
}
function Dv(e, t) {
  return (a) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const o = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + o * (a - e[0]);
  };
}
function Nv(e, t) {
  return e > 0 && e < t;
}
var BA = (e, t = () => {
}) => {
  let a = { left: e.scrollLeft, top: e.scrollTop }, o = 0;
  return function n() {
    const r = { left: e.scrollLeft, top: e.scrollTop }, i = a.left !== r.left, s = a.top !== r.top;
    (i || s) && t(), a = r, o = window.requestAnimationFrame(n);
  }(), () => window.cancelAnimationFrame(o);
};
function ks(e, t) {
  const a = Qe(e), o = g.useRef(0);
  return g.useEffect(() => () => window.clearTimeout(o.current), []), g.useCallback(() => {
    window.clearTimeout(o.current), o.current = window.setTimeout(a, t);
  }, [a, t]);
}
function Xo(e, t) {
  const a = Qe(t);
  Da(() => {
    let o = 0;
    if (e) {
      const n = new ResizeObserver(() => {
        cancelAnimationFrame(o), o = window.requestAnimationFrame(a);
      });
      return n.observe(e), () => {
        window.cancelAnimationFrame(o), n.unobserve(e);
      };
    }
  }, [e, a]);
}
var FA = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), VA = "VisuallyHidden", od = g.forwardRef(
  (e, t) => /* @__PURE__ */ v(
    ze.span,
    {
      ...e,
      ref: t,
      style: { ...FA, ...e.style }
    }
  )
);
od.displayName = VA;
var xs = "Tabs", [UA, Irt] = _o(xs, [
  i_
]), Rv = i_(), [qA, nd] = UA(xs), HA = g.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: a,
      value: o,
      onValueChange: n,
      defaultValue: r,
      orientation: i = "horizontal",
      dir: s,
      activationMode: l = "automatic",
      ...c
    } = e, u = Ou(s), [d, h] = ms({
      prop: o,
      onChange: n,
      defaultProp: r ?? "",
      caller: xs
    });
    return /* @__PURE__ */ v(
      qA,
      {
        scope: a,
        baseId: n_(),
        value: d,
        onValueChange: h,
        orientation: i,
        dir: u,
        activationMode: l,
        children: /* @__PURE__ */ v(
          ze.div,
          {
            dir: u,
            "data-orientation": i,
            ...c,
            ref: t
          }
        )
      }
    );
  }
);
HA.displayName = xs;
var Iv = "TabsList", GA = g.forwardRef(
  (e, t) => {
    const { __scopeTabs: a, loop: o = !0, ...n } = e, r = nd(Iv, a), i = Rv(a);
    return /* @__PURE__ */ v(
      wj,
      {
        asChild: !0,
        ...i,
        orientation: r.orientation,
        dir: r.dir,
        loop: o,
        children: /* @__PURE__ */ v(
          ze.div,
          {
            role: "tablist",
            "aria-orientation": r.orientation,
            ...n,
            ref: t
          }
        )
      }
    );
  }
);
GA.displayName = Iv;
var Tv = "TabsTrigger", KA = g.forwardRef(
  (e, t) => {
    const { __scopeTabs: a, value: o, disabled: n = !1, ...r } = e, i = nd(Tv, a), s = Rv(a), l = Mv(i.baseId, o), c = Wv(i.baseId, o), u = o === i.value;
    return /* @__PURE__ */ v(
      kj,
      {
        asChild: !0,
        ...s,
        focusable: !n,
        active: u,
        children: /* @__PURE__ */ v(
          ze.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": u,
            "aria-controls": c,
            "data-state": u ? "active" : "inactive",
            "data-disabled": n ? "" : void 0,
            disabled: n,
            id: l,
            ...r,
            ref: t,
            onMouseDown: be(e.onMouseDown, (d) => {
              !n && d.button === 0 && d.ctrlKey === !1 ? i.onValueChange(o) : d.preventDefault();
            }),
            onKeyDown: be(e.onKeyDown, (d) => {
              [" ", "Enter"].includes(d.key) && i.onValueChange(o);
            }),
            onFocus: be(e.onFocus, () => {
              const d = i.activationMode !== "manual";
              !u && !n && d && i.onValueChange(o);
            })
          }
        )
      }
    );
  }
);
KA.displayName = Tv;
var Lv = "TabsContent", JA = g.forwardRef(
  (e, t) => {
    const { __scopeTabs: a, value: o, forceMount: n, children: r, ...i } = e, s = nd(Lv, a), l = Mv(s.baseId, o), c = Wv(s.baseId, o), u = o === s.value, d = g.useRef(u);
    return g.useEffect(() => {
      const h = requestAnimationFrame(() => d.current = !1);
      return () => cancelAnimationFrame(h);
    }, []), /* @__PURE__ */ v(_a, { present: n || u, children: ({ present: h }) => /* @__PURE__ */ v(
      ze.div,
      {
        "data-state": u ? "active" : "inactive",
        "data-orientation": s.orientation,
        role: "tabpanel",
        "aria-labelledby": l,
        hidden: !h,
        id: c,
        tabIndex: 0,
        ...i,
        ref: t,
        style: {
          ...e.style,
          animationDuration: d.current ? "0s" : void 0
        },
        children: h && r
      }
    ) });
  }
);
JA.displayName = Lv;
function Mv(e, t) {
  return `${e}-trigger-${t}`;
}
function Wv(e, t) {
  return `${e}-content-${t}`;
}
var ZA = "ToastProvider", [Bv, YA, XA] = o_("Toast"), [Fv, Trt] = _o("Toast", [XA]), [Lrt, $s] = Fv(ZA), Vv = "ToastViewport", QA = ["F8"], kc = "toast.viewportPause", xc = "toast.viewportResume", eP = g.forwardRef(
  (e, t) => {
    const {
      __scopeToast: a,
      hotkey: o = QA,
      label: n = "Notifications ({hotkey})",
      ...r
    } = e, i = $s(Vv, a), s = YA(a), l = g.useRef(null), c = g.useRef(null), u = g.useRef(null), d = g.useRef(null), h = He(t, d, i.onViewportChange), m = o.join("+").replace(/Key/g, "").replace(/Digit/g, ""), f = i.toastCount > 0;
    g.useEffect(() => {
      const b = (w) => {
        o.length !== 0 && o.every((_) => w[_] || w.code === _) && d.current?.focus();
      };
      return document.addEventListener("keydown", b), () => document.removeEventListener("keydown", b);
    }, [o]), g.useEffect(() => {
      const b = l.current, w = d.current;
      if (f && b && w) {
        const _ = () => {
          if (!i.isClosePausedRef.current) {
            const S = new CustomEvent(kc);
            w.dispatchEvent(S), i.isClosePausedRef.current = !0;
          }
        }, y = () => {
          if (i.isClosePausedRef.current) {
            const S = new CustomEvent(xc);
            w.dispatchEvent(S), i.isClosePausedRef.current = !1;
          }
        }, k = (S) => {
          !b.contains(S.relatedTarget) && y();
        }, x = () => {
          b.contains(document.activeElement) || y();
        };
        return b.addEventListener("focusin", _), b.addEventListener("focusout", k), b.addEventListener("pointermove", _), b.addEventListener("pointerleave", x), window.addEventListener("blur", _), window.addEventListener("focus", y), () => {
          b.removeEventListener("focusin", _), b.removeEventListener("focusout", k), b.removeEventListener("pointermove", _), b.removeEventListener("pointerleave", x), window.removeEventListener("blur", _), window.removeEventListener("focus", y);
        };
      }
    }, [f, i.isClosePausedRef]);
    const p = g.useCallback(
      ({ tabbingDirection: b }) => {
        const w = s().map((_) => {
          const y = _.ref.current, k = [y, ...bP(y)];
          return b === "forwards" ? k : k.reverse();
        });
        return (b === "forwards" ? w.reverse() : w).flat();
      },
      [s]
    );
    return g.useEffect(() => {
      const b = d.current;
      if (b) {
        const w = (_) => {
          const y = _.altKey || _.ctrlKey || _.metaKey;
          if (_.key === "Tab" && !y) {
            const k = document.activeElement, x = _.shiftKey;
            if (_.target === b && x) {
              c.current?.focus();
              return;
            }
            const S = p({ tabbingDirection: x ? "backwards" : "forwards" }), $ = S.findIndex((E) => E === k);
            Sl(S.slice($ + 1)) ? _.preventDefault() : x ? c.current?.focus() : u.current?.focus();
          }
        };
        return b.addEventListener("keydown", w), () => b.removeEventListener("keydown", w);
      }
    }, [s, p]), /* @__PURE__ */ T(
      iO,
      {
        ref: l,
        role: "region",
        "aria-label": n.replace("{hotkey}", m),
        tabIndex: -1,
        style: { pointerEvents: f ? void 0 : "none" },
        children: [
          f && /* @__PURE__ */ v(
            $c,
            {
              ref: c,
              onFocusFromOutsideViewport: () => {
                const b = p({
                  tabbingDirection: "forwards"
                });
                Sl(b);
              }
            }
          ),
          /* @__PURE__ */ v(Bv.Slot, { scope: a, children: /* @__PURE__ */ v(ze.ol, { tabIndex: -1, ...r, ref: h }) }),
          f && /* @__PURE__ */ v(
            $c,
            {
              ref: u,
              onFocusFromOutsideViewport: () => {
                const b = p({
                  tabbingDirection: "backwards"
                });
                Sl(b);
              }
            }
          )
        ]
      }
    );
  }
);
eP.displayName = Vv;
var Uv = "ToastFocusProxy", $c = g.forwardRef(
  (e, t) => {
    const { __scopeToast: a, onFocusFromOutsideViewport: o, ...n } = e, r = $s(Uv, a);
    return /* @__PURE__ */ v(
      od,
      {
        tabIndex: 0,
        ...n,
        ref: t,
        style: { position: "fixed" },
        onFocus: (i) => {
          const s = i.relatedTarget;
          !r.viewport?.contains(s) && o();
        }
      }
    );
  }
);
$c.displayName = Uv;
var ar = "Toast", tP = "toast.swipeStart", aP = "toast.swipeMove", oP = "toast.swipeCancel", nP = "toast.swipeEnd", rP = g.forwardRef(
  (e, t) => {
    const { forceMount: a, open: o, defaultOpen: n, onOpenChange: r, ...i } = e, [s, l] = ms({
      prop: o,
      defaultProp: n ?? !0,
      onChange: r,
      caller: ar
    });
    return /* @__PURE__ */ v(_a, { present: a || s, children: /* @__PURE__ */ v(
      lP,
      {
        open: s,
        ...i,
        ref: t,
        onClose: () => l(!1),
        onPause: Qe(e.onPause),
        onResume: Qe(e.onResume),
        onSwipeStart: be(e.onSwipeStart, (c) => {
          c.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: be(e.onSwipeMove, (c) => {
          const { x: u, y: d } = c.detail.delta;
          c.currentTarget.setAttribute("data-swipe", "move"), c.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${u}px`), c.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${d}px`);
        }),
        onSwipeCancel: be(e.onSwipeCancel, (c) => {
          c.currentTarget.setAttribute("data-swipe", "cancel"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), c.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), c.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: be(e.onSwipeEnd, (c) => {
          const { x: u, y: d } = c.detail.delta;
          c.currentTarget.setAttribute("data-swipe", "end"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), c.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${u}px`), c.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${d}px`), l(!1);
        })
      }
    ) });
  }
);
rP.displayName = ar;
var [iP, sP] = Fv(ar, {
  onClose() {
  }
}), lP = g.forwardRef(
  (e, t) => {
    const {
      __scopeToast: a,
      type: o = "foreground",
      duration: n,
      open: r,
      onClose: i,
      onEscapeKeyDown: s,
      onPause: l,
      onResume: c,
      onSwipeStart: u,
      onSwipeMove: d,
      onSwipeCancel: h,
      onSwipeEnd: m,
      ...f
    } = e, p = $s(ar, a), [b, w] = g.useState(null), _ = He(t, (O) => w(O)), y = g.useRef(null), k = g.useRef(null), x = n || p.duration, S = g.useRef(0), $ = g.useRef(x), E = g.useRef(0), { onToastAdd: C, onToastRemove: j } = p, R = Qe(() => {
      b?.contains(document.activeElement) && p.viewport?.focus(), i();
    }), H = g.useCallback(
      (O) => {
        !O || O === 1 / 0 || (window.clearTimeout(E.current), S.current = (/* @__PURE__ */ new Date()).getTime(), E.current = window.setTimeout(R, O));
      },
      [R]
    );
    g.useEffect(() => {
      const O = p.viewport;
      if (O) {
        const U = () => {
          H($.current), c?.();
        }, I = () => {
          const K = (/* @__PURE__ */ new Date()).getTime() - S.current;
          $.current = $.current - K, window.clearTimeout(E.current), l?.();
        };
        return O.addEventListener(kc, I), O.addEventListener(xc, U), () => {
          O.removeEventListener(kc, I), O.removeEventListener(xc, U);
        };
      }
    }, [p.viewport, x, l, c, H]), g.useEffect(() => {
      r && !p.isClosePausedRef.current && H(x);
    }, [r, x, p.isClosePausedRef, H]), g.useEffect(() => (C(), () => j()), [C, j]);
    const L = g.useMemo(() => b ? Jv(b) : null, [b]);
    return p.viewport ? /* @__PURE__ */ T(De, { children: [
      L && /* @__PURE__ */ v(
        cP,
        {
          __scopeToast: a,
          role: "status",
          "aria-live": o === "foreground" ? "assertive" : "polite",
          children: L
        }
      ),
      /* @__PURE__ */ v(iP, { scope: a, onClose: R, children: po.createPortal(
        /* @__PURE__ */ v(Bv.ItemSlot, { scope: a, children: /* @__PURE__ */ v(
          rO,
          {
            asChild: !0,
            onEscapeKeyDown: be(s, () => {
              p.isFocusedToastEscapeKeyDownRef.current || R(), p.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: /* @__PURE__ */ v(
              ze.li,
              {
                tabIndex: 0,
                "data-state": r ? "open" : "closed",
                "data-swipe-direction": p.swipeDirection,
                ...f,
                ref: _,
                style: { userSelect: "none", touchAction: "none", ...e.style },
                onKeyDown: be(e.onKeyDown, (O) => {
                  O.key === "Escape" && (s?.(O.nativeEvent), O.nativeEvent.defaultPrevented || (p.isFocusedToastEscapeKeyDownRef.current = !0, R()));
                }),
                onPointerDown: be(e.onPointerDown, (O) => {
                  O.button === 0 && (y.current = { x: O.clientX, y: O.clientY });
                }),
                onPointerMove: be(e.onPointerMove, (O) => {
                  if (!y.current) return;
                  const U = O.clientX - y.current.x, I = O.clientY - y.current.y, K = !!k.current, q = ["left", "right"].includes(p.swipeDirection), te = ["left", "up"].includes(p.swipeDirection) ? Math.min : Math.max, A = q ? te(0, U) : 0, z = q ? 0 : te(0, I), N = O.pointerType === "touch" ? 10 : 2, B = { x: A, y: z }, W = { originalEvent: O, delta: B };
                  K ? (k.current = B, Pr(aP, d, W, {
                    discrete: !1
                  })) : xh(B, p.swipeDirection, N) ? (k.current = B, Pr(tP, u, W, {
                    discrete: !1
                  }), O.target.setPointerCapture(O.pointerId)) : (Math.abs(U) > N || Math.abs(I) > N) && (y.current = null);
                }),
                onPointerUp: be(e.onPointerUp, (O) => {
                  const U = k.current, I = O.target;
                  if (I.hasPointerCapture(O.pointerId) && I.releasePointerCapture(O.pointerId), k.current = null, y.current = null, U) {
                    const K = O.currentTarget, q = { originalEvent: O, delta: U };
                    xh(U, p.swipeDirection, p.swipeThreshold) ? Pr(nP, m, q, {
                      discrete: !0
                    }) : Pr(
                      oP,
                      h,
                      q,
                      {
                        discrete: !0
                      }
                    ), K.addEventListener("click", (te) => te.preventDefault(), {
                      once: !0
                    });
                  }
                })
              }
            )
          }
        ) }),
        p.viewport
      ) })
    ] }) : null;
  }
), cP = (e) => {
  const { __scopeToast: t, children: a, ...o } = e, n = $s(ar, t), [r, i] = g.useState(!1), [s, l] = g.useState(!1);
  return mP(() => i(!0)), g.useEffect(() => {
    const c = window.setTimeout(() => l(!0), 1e3);
    return () => window.clearTimeout(c);
  }, []), s ? null : /* @__PURE__ */ v(v_, { asChild: !0, children: /* @__PURE__ */ v(od, { ...o, children: r && /* @__PURE__ */ T(De, { children: [
    n.label,
    " ",
    a
  ] }) }) });
}, uP = "ToastTitle", dP = g.forwardRef(
  (e, t) => {
    const { __scopeToast: a, ...o } = e;
    return /* @__PURE__ */ v(ze.div, { ...o, ref: t });
  }
);
dP.displayName = uP;
var gP = "ToastDescription", hP = g.forwardRef(
  (e, t) => {
    const { __scopeToast: a, ...o } = e;
    return /* @__PURE__ */ v(ze.div, { ...o, ref: t });
  }
);
hP.displayName = gP;
var qv = "ToastAction", pP = g.forwardRef(
  (e, t) => {
    const { altText: a, ...o } = e;
    return a.trim() ? /* @__PURE__ */ v(Kv, { altText: a, asChild: !0, children: /* @__PURE__ */ v(Gv, { ...o, ref: t }) }) : (console.error(
      `Invalid prop \`altText\` supplied to \`${qv}\`. Expected non-empty \`string\`.`
    ), null);
  }
);
pP.displayName = qv;
var Hv = "ToastClose", Gv = g.forwardRef(
  (e, t) => {
    const { __scopeToast: a, ...o } = e, n = sP(Hv, a);
    return /* @__PURE__ */ v(Kv, { asChild: !0, children: /* @__PURE__ */ v(
      ze.button,
      {
        type: "button",
        ...o,
        ref: t,
        onClick: be(e.onClick, n.onClose)
      }
    ) });
  }
);
Gv.displayName = Hv;
var Kv = g.forwardRef((e, t) => {
  const { __scopeToast: a, altText: o, ...n } = e;
  return /* @__PURE__ */ v(
    ze.div,
    {
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": o || void 0,
      ...n,
      ref: t
    }
  );
});
function Jv(e) {
  const t = [];
  return Array.from(e.childNodes).forEach((a) => {
    if (a.nodeType === a.TEXT_NODE && a.textContent && t.push(a.textContent), fP(a)) {
      const o = a.ariaHidden || a.hidden || a.style.display === "none", n = a.dataset.radixToastAnnounceExclude === "";
      if (!o)
        if (n) {
          const r = a.dataset.radixToastAnnounceAlt;
          r && t.push(r);
        } else
          t.push(...Jv(a));
    }
  }), t;
}
function Pr(e, t, a, { discrete: o }) {
  const n = a.originalEvent.currentTarget, r = new CustomEvent(e, { bubbles: !0, cancelable: !0, detail: a });
  t && n.addEventListener(e, t, { once: !0 }), o ? a_(n, r) : n.dispatchEvent(r);
}
var xh = (e, t, a = 0) => {
  const o = Math.abs(e.x), n = Math.abs(e.y), r = o > n;
  return t === "left" || t === "right" ? r && o > a : !r && n > a;
};
function mP(e = () => {
}) {
  const t = Qe(e);
  Da(() => {
    let a = 0, o = 0;
    return a = window.requestAnimationFrame(() => o = window.requestAnimationFrame(t)), () => {
      window.cancelAnimationFrame(a), window.cancelAnimationFrame(o);
    };
  }, [t]);
}
function fP(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function bP(e) {
  const t = [], a = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const n = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || n ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; a.nextNode(); ) t.push(a.currentNode);
  return t;
}
function Sl(e) {
  const t = document.activeElement;
  return e.some((a) => a === t ? !0 : (a.focus(), document.activeElement !== t));
}
function _P(e, t = 500) {
  const [a, o] = Pe(e);
  return Ce(() => {
    const n = setTimeout(() => o(e), t);
    return () => {
      clearTimeout(n);
    };
  }, [e, t]), a;
}
const vP = Ot(void 0);
function yP({ children: e, config: t }) {
  const { apiUrl: a } = t;
  bE(a);
  const o = {
    apiUrl: "",
    locale: "fr"
  }, [n, r] = Pe({
    ...o,
    ...t
  }), i = {
    config: n,
    setConfig: r
  };
  return /* @__PURE__ */ v(vP.Provider, { value: i, children: e });
}
Ot(void 0);
function et(e, t) {
  if (e === !1 || e === null || typeof e > "u")
    throw new Error(t);
}
function ma(e, t) {
  if (!e) {
    typeof console < "u" && console.warn(t);
    try {
      throw new Error(t);
    } catch {
    }
  }
}
function Sc({
  pathname: e = "/",
  search: t = "",
  hash: a = ""
}) {
  return t && t !== "?" && (e += t.charAt(0) === "?" ? t : "?" + t), a && a !== "#" && (e += a.charAt(0) === "#" ? a : "#" + a), e;
}
function rd(e) {
  let t = {};
  if (e) {
    let a = e.indexOf("#");
    a >= 0 && (t.hash = e.substring(a), e = e.substring(0, a));
    let o = e.indexOf("?");
    o >= 0 && (t.search = e.substring(o), e = e.substring(0, o)), e && (t.pathname = e);
  }
  return t;
}
function Zv(e, t, a = "/") {
  return wP(e, t, a, !1);
}
function wP(e, t, a, o) {
  let n = typeof t == "string" ? rd(t) : t, r = Na(n.pathname || "/", a);
  if (r == null)
    return null;
  let i = Yv(e);
  kP(i);
  let s = null;
  for (let l = 0; s == null && l < i.length; ++l) {
    let c = DP(r);
    s = AP(
      i[l],
      c,
      o
    );
  }
  return s;
}
function Yv(e, t = [], a = [], o = "", n = !1) {
  let r = (i, s, l = n, c) => {
    let u = {
      relativePath: c === void 0 ? i.path || "" : c,
      caseSensitive: i.caseSensitive === !0,
      childrenIndex: s,
      route: i
    };
    if (u.relativePath.startsWith("/")) {
      if (!u.relativePath.startsWith(o) && l)
        return;
      et(
        u.relativePath.startsWith(o),
        `Absolute route path "${u.relativePath}" nested under path "${o}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`
      ), u.relativePath = u.relativePath.slice(o.length);
    }
    let d = ga([o, u.relativePath]), h = a.concat(u);
    i.children && i.children.length > 0 && (et(
      // Our types know better, but runtime JS may not!
      // @ts-expect-error
      i.index !== !0,
      `Index routes must not have child routes. Please remove all child routes from route path "${d}".`
    ), Yv(
      i.children,
      t,
      h,
      d,
      l
    )), !(i.path == null && !i.index) && t.push({
      path: d,
      score: OP(d, i.index),
      routesMeta: h
    });
  };
  return e.forEach((i, s) => {
    if (i.path === "" || !i.path?.includes("?"))
      r(i, s);
    else
      for (let l of Xv(i.path))
        r(i, s, !0, l);
  }), t;
}
function Xv(e) {
  let t = e.split("/");
  if (t.length === 0) return [];
  let [a, ...o] = t, n = a.endsWith("?"), r = a.replace(/\?$/, "");
  if (o.length === 0)
    return n ? [r, ""] : [r];
  let i = Xv(o.join("/")), s = [];
  return s.push(
    ...i.map(
      (l) => l === "" ? r : [r, l].join("/")
    )
  ), n && s.push(...i), s.map(
    (l) => e.startsWith("/") && l === "" ? "/" : l
  );
}
function kP(e) {
  e.sort(
    (t, a) => t.score !== a.score ? a.score - t.score : zP(
      t.routesMeta.map((o) => o.childrenIndex),
      a.routesMeta.map((o) => o.childrenIndex)
    )
  );
}
var xP = /^:[\w-]+$/, $P = 3, SP = 2, CP = 1, EP = 10, jP = -2, $h = (e) => e === "*";
function OP(e, t) {
  let a = e.split("/"), o = a.length;
  return a.some($h) && (o += jP), t && (o += SP), a.filter((n) => !$h(n)).reduce(
    (n, r) => n + (xP.test(r) ? $P : r === "" ? CP : EP),
    o
  );
}
function zP(e, t) {
  return e.length === t.length && e.slice(0, -1).every((a, o) => a === t[o]) ? (
    // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    e[e.length - 1] - t[t.length - 1]
  ) : (
    // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0
  );
}
function AP(e, t, a = !1) {
  let { routesMeta: o } = e, n = {}, r = "/", i = [];
  for (let s = 0; s < o.length; ++s) {
    let l = o[s], c = s === o.length - 1, u = r === "/" ? t : t.slice(r.length) || "/", d = Ni(
      { path: l.relativePath, caseSensitive: l.caseSensitive, end: c },
      u
    ), h = l.route;
    if (!d && c && a && !o[o.length - 1].route.index && (d = Ni(
      {
        path: l.relativePath,
        caseSensitive: l.caseSensitive,
        end: !1
      },
      u
    )), !d)
      return null;
    Object.assign(n, d.params), i.push({
      // TODO: Can this as be avoided?
      params: n,
      pathname: ga([r, d.pathname]),
      pathnameBase: TP(
        ga([r, d.pathnameBase])
      ),
      route: h
    }), d.pathnameBase !== "/" && (r = ga([r, d.pathnameBase]));
  }
  return i;
}
function Ni(e, t) {
  typeof e == "string" && (e = { path: e, caseSensitive: !1, end: !0 });
  let [a, o] = PP(
    e.path,
    e.caseSensitive,
    e.end
  ), n = t.match(a);
  if (!n) return null;
  let r = n[0], i = r.replace(/(.)\/+$/, "$1"), s = n.slice(1);
  return {
    params: o.reduce(
      (l, { paramName: c, isOptional: u }, d) => {
        if (c === "*") {
          let m = s[d] || "";
          i = r.slice(0, r.length - m.length).replace(/(.)\/+$/, "$1");
        }
        const h = s[d];
        return u && !h ? l[c] = void 0 : l[c] = (h || "").replace(/%2F/g, "/"), l;
      },
      {}
    ),
    pathname: r,
    pathnameBase: i,
    pattern: e
  };
}
function PP(e, t = !1, a = !0) {
  ma(
    e === "*" || !e.endsWith("*") || e.endsWith("/*"),
    `Route path "${e}" will be treated as if it were "${e.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${e.replace(/\*$/, "/*")}".`
  );
  let o = [], n = "^" + e.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(
    /\/:([\w-]+)(\?)?/g,
    (r, i, s) => (o.push({ paramName: i, isOptional: s != null }), s ? "/?([^\\/]+)?" : "/([^\\/]+)")
  ).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
  return e.endsWith("*") ? (o.push({ paramName: "*" }), n += e === "*" || e === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$") : a ? n += "\\/*$" : e !== "" && e !== "/" && (n += "(?:(?=\\/|$))"), [new RegExp(n, t ? void 0 : "i"), o];
}
function DP(e) {
  try {
    return e.split("/").map((t) => decodeURIComponent(t).replace(/\//g, "%2F")).join("/");
  } catch (t) {
    return ma(
      !1,
      `The URL path "${e}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${t}).`
    ), e;
  }
}
function Na(e, t) {
  if (t === "/") return e;
  if (!e.toLowerCase().startsWith(t.toLowerCase()))
    return null;
  let a = t.endsWith("/") ? t.length - 1 : t.length, o = e.charAt(a);
  return o && o !== "/" ? null : e.slice(a) || "/";
}
function NP(e, t = "/") {
  let {
    pathname: a,
    search: o = "",
    hash: n = ""
  } = typeof e == "string" ? rd(e) : e;
  return {
    pathname: a ? a.startsWith("/") ? a : RP(a, t) : t,
    search: LP(o),
    hash: MP(n)
  };
}
function RP(e, t) {
  let a = t.replace(/\/+$/, "").split("/");
  return e.split("/").forEach((o) => {
    o === ".." ? a.length > 1 && a.pop() : o !== "." && a.push(o);
  }), a.length > 1 ? a.join("/") : "/";
}
function Cl(e, t, a, o) {
  return `Cannot include a '${e}' character in a manually specified \`to.${t}\` field [${JSON.stringify(
    o
  )}].  Please separate it out to the \`to.${a}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function IP(e) {
  return e.filter(
    (t, a) => a === 0 || t.route.path && t.route.path.length > 0
  );
}
function Qv(e) {
  let t = IP(e);
  return t.map(
    (a, o) => o === t.length - 1 ? a.pathname : a.pathnameBase
  );
}
function ey(e, t, a, o = !1) {
  let n;
  typeof e == "string" ? n = rd(e) : (n = { ...e }, et(
    !n.pathname || !n.pathname.includes("?"),
    Cl("?", "pathname", "search", n)
  ), et(
    !n.pathname || !n.pathname.includes("#"),
    Cl("#", "pathname", "hash", n)
  ), et(
    !n.search || !n.search.includes("#"),
    Cl("#", "search", "hash", n)
  ));
  let r = e === "" || n.pathname === "", i = r ? "/" : n.pathname, s;
  if (i == null)
    s = a;
  else {
    let d = t.length - 1;
    if (!o && i.startsWith("..")) {
      let h = i.split("/");
      for (; h[0] === ".."; )
        h.shift(), d -= 1;
      n.pathname = h.join("/");
    }
    s = d >= 0 ? t[d] : "/";
  }
  let l = NP(n, s), c = i && i !== "/" && i.endsWith("/"), u = (r || i === ".") && a.endsWith("/");
  return !l.pathname.endsWith("/") && (c || u) && (l.pathname += "/"), l;
}
var ga = (e) => e.join("/").replace(/\/\/+/g, "/"), TP = (e) => e.replace(/\/+$/, "").replace(/^\/*/, "/"), LP = (e) => !e || e === "?" ? "" : e.startsWith("?") ? e : "?" + e, MP = (e) => !e || e === "#" ? "" : e.startsWith("#") ? e : "#" + e;
function WP(e) {
  return e != null && typeof e.status == "number" && typeof e.statusText == "string" && typeof e.internal == "boolean" && "data" in e;
}
var ty = [
  "POST",
  "PUT",
  "PATCH",
  "DELETE"
];
new Set(
  ty
);
var BP = [
  "GET",
  ...ty
];
new Set(BP);
var rn = g.createContext(null);
rn.displayName = "DataRouter";
var Ss = g.createContext(null);
Ss.displayName = "DataRouterState";
g.createContext(!1);
var ay = g.createContext({
  isTransitioning: !1
});
ay.displayName = "ViewTransition";
var FP = g.createContext(
  /* @__PURE__ */ new Map()
);
FP.displayName = "Fetchers";
var VP = g.createContext(null);
VP.displayName = "Await";
var ya = g.createContext(
  null
);
ya.displayName = "Navigation";
var Cs = g.createContext(
  null
);
Cs.displayName = "Location";
var wa = g.createContext({
  outlet: null,
  matches: [],
  isDataRoute: !1
});
wa.displayName = "Route";
var id = g.createContext(null);
id.displayName = "RouteError";
function UP(e, { relative: t } = {}) {
  et(
    Es(),
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useHref() may be used only in the context of a <Router> component."
  );
  let { basename: a, navigator: o } = g.useContext(ya), { hash: n, pathname: r, search: i } = or(e, { relative: t }), s = r;
  return a !== "/" && (s = r === "/" ? a : ga([a, r])), o.createHref({ pathname: s, search: i, hash: n });
}
function Es() {
  return g.useContext(Cs) != null;
}
function vo() {
  return et(
    Es(),
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useLocation() may be used only in the context of a <Router> component."
  ), g.useContext(Cs).location;
}
var oy = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
function ny(e) {
  g.useContext(ya).static || g.useLayoutEffect(e);
}
function qP() {
  let { isDataRoute: e } = g.useContext(wa);
  return e ? nD() : HP();
}
function HP() {
  et(
    Es(),
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useNavigate() may be used only in the context of a <Router> component."
  );
  let e = g.useContext(rn), { basename: t, navigator: a } = g.useContext(ya), { matches: o } = g.useContext(wa), { pathname: n } = vo(), r = JSON.stringify(Qv(o)), i = g.useRef(!1);
  return ny(() => {
    i.current = !0;
  }), g.useCallback(
    (s, l = {}) => {
      if (ma(i.current, oy), !i.current) return;
      if (typeof s == "number") {
        a.go(s);
        return;
      }
      let c = ey(
        s,
        JSON.parse(r),
        n,
        l.relative === "path"
      );
      e == null && t !== "/" && (c.pathname = c.pathname === "/" ? t : ga([t, c.pathname])), (l.replace ? a.replace : a.push)(
        c,
        l.state,
        l
      );
    },
    [
      t,
      a,
      r,
      n,
      e
    ]
  );
}
g.createContext(null);
function or(e, { relative: t } = {}) {
  let { matches: a } = g.useContext(wa), { pathname: o } = vo(), n = JSON.stringify(Qv(a));
  return g.useMemo(
    () => ey(
      e,
      JSON.parse(n),
      o,
      t === "path"
    ),
    [e, n, o, t]
  );
}
function GP(e, t, a, o, n) {
  et(
    Es(),
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useRoutes() may be used only in the context of a <Router> component."
  );
  let { navigator: r } = g.useContext(ya), { matches: i } = g.useContext(wa), s = i[i.length - 1], l = s ? s.params : {}, c = s ? s.pathname : "/", u = s ? s.pathnameBase : "/", d = s && s.route;
  {
    let _ = d && d.path || "";
    ry(
      c,
      !d || _.endsWith("*") || _.endsWith("*?"),
      `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${c}" (under <Route path="${_}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${_}"> to <Route path="${_ === "/" ? "*" : `${_}/*`}">.`
    );
  }
  let h = vo(), m;
  m = h;
  let f = m.pathname || "/", p = f;
  if (u !== "/") {
    let _ = u.replace(/^\//, "").split("/");
    p = "/" + f.replace(/^\//, "").split("/").slice(_.length).join("/");
  }
  let b = Zv(e, { pathname: p });
  ma(
    d || b != null,
    `No routes matched location "${m.pathname}${m.search}${m.hash}" `
  ), ma(
    b == null || b[b.length - 1].route.element !== void 0 || b[b.length - 1].route.Component !== void 0 || b[b.length - 1].route.lazy !== void 0,
    `Matched leaf route at location "${m.pathname}${m.search}${m.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`
  );
  let w = XP(
    b && b.map(
      (_) => Object.assign({}, _, {
        params: Object.assign({}, l, _.params),
        pathname: ga([
          u,
          // Re-encode pathnames that were decoded inside matchRoutes.
          // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
          // `new URL()` internally and we need to prevent it from treating
          // them as separators
          r.encodeLocation ? r.encodeLocation(
            _.pathname.replace(/\?/g, "%3F").replace(/#/g, "%23")
          ).pathname : _.pathname
        ]),
        pathnameBase: _.pathnameBase === "/" ? u : ga([
          u,
          // Re-encode pathnames that were decoded inside matchRoutes
          // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
          // `new URL()` internally and we need to prevent it from treating
          // them as separators
          r.encodeLocation ? r.encodeLocation(
            _.pathnameBase.replace(/\?/g, "%3F").replace(/#/g, "%23")
          ).pathname : _.pathnameBase
        ])
      })
    ),
    i,
    a,
    o,
    n
  );
  return t && w ? /* @__PURE__ */ g.createElement(
    Cs.Provider,
    {
      value: {
        location: {
          pathname: "/",
          search: "",
          hash: "",
          state: null,
          key: "default",
          ...m
        },
        navigationType: "POP"
        /* Pop */
      }
    },
    w
  ) : w;
}
function KP() {
  let e = oD(), t = WP(e) ? `${e.status} ${e.statusText}` : e instanceof Error ? e.message : JSON.stringify(e), a = e instanceof Error ? e.stack : null, o = "rgba(200,200,200, 0.5)", n = { padding: "0.5rem", backgroundColor: o }, r = { padding: "2px 4px", backgroundColor: o }, i = null;
  return console.error(
    "Error handled by React Router default ErrorBoundary:",
    e
  ), i = /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement("p", null, "💿 Hey developer 👋"), /* @__PURE__ */ g.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ g.createElement("code", { style: r }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ g.createElement("code", { style: r }, "errorElement"), " prop on your route.")), /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ g.createElement("h3", { style: { fontStyle: "italic" } }, t), a ? /* @__PURE__ */ g.createElement("pre", { style: n }, a) : null, i);
}
var JP = /* @__PURE__ */ g.createElement(KP, null), ZP = class extends g.Component {
  constructor(t) {
    super(t), this.state = {
      location: t.location,
      revalidation: t.revalidation,
      error: t.error
    };
  }
  static getDerivedStateFromError(t) {
    return { error: t };
  }
  static getDerivedStateFromProps(t, a) {
    return a.location !== t.location || a.revalidation !== "idle" && t.revalidation === "idle" ? {
      error: t.error,
      location: t.location,
      revalidation: t.revalidation
    } : {
      error: t.error !== void 0 ? t.error : a.error,
      location: a.location,
      revalidation: t.revalidation || a.revalidation
    };
  }
  componentDidCatch(t, a) {
    this.props.unstable_onError ? this.props.unstable_onError(t, a) : console.error(
      "React Router caught the following error during render",
      t
    );
  }
  render() {
    return this.state.error !== void 0 ? /* @__PURE__ */ g.createElement(wa.Provider, { value: this.props.routeContext }, /* @__PURE__ */ g.createElement(
      id.Provider,
      {
        value: this.state.error,
        children: this.props.component
      }
    )) : this.props.children;
  }
};
function YP({ routeContext: e, match: t, children: a }) {
  let o = g.useContext(rn);
  return o && o.static && o.staticContext && (t.route.errorElement || t.route.ErrorBoundary) && (o.staticContext._deepestRenderedBoundaryId = t.route.id), /* @__PURE__ */ g.createElement(wa.Provider, { value: e }, a);
}
function XP(e, t = [], a = null, o = null, n = null) {
  if (e == null) {
    if (!a)
      return null;
    if (a.errors)
      e = a.matches;
    else if (t.length === 0 && !a.initialized && a.matches.length > 0)
      e = a.matches;
    else
      return null;
  }
  let r = e, i = a?.errors;
  if (i != null) {
    let c = r.findIndex(
      (u) => u.route.id && i?.[u.route.id] !== void 0
    );
    et(
      c >= 0,
      `Could not find a matching route for errors on route IDs: ${Object.keys(
        i
      ).join(",")}`
    ), r = r.slice(
      0,
      Math.min(r.length, c + 1)
    );
  }
  let s = !1, l = -1;
  if (a)
    for (let c = 0; c < r.length; c++) {
      let u = r[c];
      if ((u.route.HydrateFallback || u.route.hydrateFallbackElement) && (l = c), u.route.id) {
        let { loaderData: d, errors: h } = a, m = u.route.loader && !d.hasOwnProperty(u.route.id) && (!h || h[u.route.id] === void 0);
        if (u.route.lazy || m) {
          s = !0, l >= 0 ? r = r.slice(0, l + 1) : r = [r[0]];
          break;
        }
      }
    }
  return r.reduceRight(
    (c, u, d) => {
      let h, m = !1, f = null, p = null;
      a && (h = i && u.route.id ? i[u.route.id] : void 0, f = u.route.errorElement || JP, s && (l < 0 && d === 0 ? (ry(
        "route-fallback",
        !1,
        "No `HydrateFallback` element provided to render during initial hydration"
      ), m = !0, p = null) : l === d && (m = !0, p = u.route.hydrateFallbackElement || null)));
      let b = t.concat(r.slice(0, d + 1)), w = () => {
        let _;
        return h ? _ = f : m ? _ = p : u.route.Component ? _ = /* @__PURE__ */ g.createElement(u.route.Component, null) : u.route.element ? _ = u.route.element : _ = c, /* @__PURE__ */ g.createElement(
          YP,
          {
            match: u,
            routeContext: {
              outlet: c,
              matches: b,
              isDataRoute: a != null
            },
            children: _
          }
        );
      };
      return a && (u.route.ErrorBoundary || u.route.errorElement || d === 0) ? /* @__PURE__ */ g.createElement(
        ZP,
        {
          location: a.location,
          revalidation: a.revalidation,
          component: f,
          error: h,
          children: w(),
          routeContext: { outlet: null, matches: b, isDataRoute: !0 },
          unstable_onError: o
        }
      ) : w();
    },
    null
  );
}
function sd(e) {
  return `${e} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function QP(e) {
  let t = g.useContext(rn);
  return et(t, sd(e)), t;
}
function eD(e) {
  let t = g.useContext(Ss);
  return et(t, sd(e)), t;
}
function tD(e) {
  let t = g.useContext(wa);
  return et(t, sd(e)), t;
}
function ld(e) {
  let t = tD(e), a = t.matches[t.matches.length - 1];
  return et(
    a.route.id,
    `${e} can only be used on routes that contain a unique "id"`
  ), a.route.id;
}
function aD() {
  return ld(
    "useRouteId"
    /* UseRouteId */
  );
}
function oD() {
  let e = g.useContext(id), t = eD(
    "useRouteError"
    /* UseRouteError */
  ), a = ld(
    "useRouteError"
    /* UseRouteError */
  );
  return e !== void 0 ? e : t.errors?.[a];
}
function nD() {
  let { router: e } = QP(
    "useNavigate"
    /* UseNavigateStable */
  ), t = ld(
    "useNavigate"
    /* UseNavigateStable */
  ), a = g.useRef(!1);
  return ny(() => {
    a.current = !0;
  }), g.useCallback(
    async (o, n = {}) => {
      ma(a.current, oy), a.current && (typeof o == "number" ? e.navigate(o) : await e.navigate(o, { fromRouteId: t, ...n }));
    },
    [e, t]
  );
}
var Sh = {};
function ry(e, t, a) {
  !t && !Sh[e] && (Sh[e] = !0, ma(!1, a));
}
g.memo(rD);
function rD({
  routes: e,
  future: t,
  state: a,
  unstable_onError: o
}) {
  return GP(e, void 0, a, o, t);
}
var ii = "get", si = "application/x-www-form-urlencoded";
function js(e) {
  return e != null && typeof e.tagName == "string";
}
function iD(e) {
  return js(e) && e.tagName.toLowerCase() === "button";
}
function sD(e) {
  return js(e) && e.tagName.toLowerCase() === "form";
}
function lD(e) {
  return js(e) && e.tagName.toLowerCase() === "input";
}
function cD(e) {
  return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
}
function uD(e, t) {
  return e.button === 0 && // Ignore everything but left clicks
  (!t || t === "_self") && // Let browser handle "target=_blank" etc.
  !cD(e);
}
var Dr = null;
function dD() {
  if (Dr === null)
    try {
      new FormData(
        document.createElement("form"),
        // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0
      ), Dr = !1;
    } catch {
      Dr = !0;
    }
  return Dr;
}
var gD = /* @__PURE__ */ new Set([
  "application/x-www-form-urlencoded",
  "multipart/form-data",
  "text/plain"
]);
function El(e) {
  return e != null && !gD.has(e) ? (ma(
    !1,
    `"${e}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${si}"`
  ), null) : e;
}
function hD(e, t) {
  let a, o, n, r, i;
  if (sD(e)) {
    let s = e.getAttribute("action");
    o = s ? Na(s, t) : null, a = e.getAttribute("method") || ii, n = El(e.getAttribute("enctype")) || si, r = new FormData(e);
  } else if (iD(e) || lD(e) && (e.type === "submit" || e.type === "image")) {
    let s = e.form;
    if (s == null)
      throw new Error(
        'Cannot submit a <button> or <input type="submit"> without a <form>'
      );
    let l = e.getAttribute("formaction") || s.getAttribute("action");
    if (o = l ? Na(l, t) : null, a = e.getAttribute("formmethod") || s.getAttribute("method") || ii, n = El(e.getAttribute("formenctype")) || El(s.getAttribute("enctype")) || si, r = new FormData(s, e), !dD()) {
      let { name: c, type: u, value: d } = e;
      if (u === "image") {
        let h = c ? `${c}.` : "";
        r.append(`${h}x`, "0"), r.append(`${h}y`, "0");
      } else c && r.append(c, d);
    }
  } else {
    if (js(e))
      throw new Error(
        'Cannot submit element that is not <form>, <button>, or <input type="submit|image">'
      );
    a = ii, o = null, n = si, i = e;
  }
  return r && n === "text/plain" && (i = r, r = void 0), { action: o, method: a.toLowerCase(), encType: n, formData: r, body: i };
}
Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function cd(e, t) {
  if (e === !1 || e === null || typeof e > "u")
    throw new Error(t);
}
function pD(e, t, a) {
  let o = typeof e == "string" ? new URL(
    e,
    // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window > "u" ? "server://singlefetch/" : window.location.origin
  ) : e;
  return o.pathname === "/" ? o.pathname = `_root.${a}` : t && Na(o.pathname, t) === "/" ? o.pathname = `${t.replace(/\/$/, "")}/_root.${a}` : o.pathname = `${o.pathname.replace(/\/$/, "")}.${a}`, o;
}
async function mD(e, t) {
  if (e.id in t)
    return t[e.id];
  try {
    let a = await import(
      /* @vite-ignore */
      /* webpackIgnore: true */
      e.module
    );
    return t[e.id] = a, a;
  } catch (a) {
    return console.error(
      `Error loading route module \`${e.module}\`, reloading page...`
    ), console.error(a), window.__reactRouterContext && window.__reactRouterContext.isSpaMode, window.location.reload(), new Promise(() => {
    });
  }
}
function fD(e) {
  return e == null ? !1 : e.href == null ? e.rel === "preload" && typeof e.imageSrcSet == "string" && typeof e.imageSizes == "string" : typeof e.rel == "string" && typeof e.href == "string";
}
async function bD(e, t, a) {
  let o = await Promise.all(
    e.map(async (n) => {
      let r = t.routes[n.route.id];
      if (r) {
        let i = await mD(r, a);
        return i.links ? i.links() : [];
      }
      return [];
    })
  );
  return wD(
    o.flat(1).filter(fD).filter((n) => n.rel === "stylesheet" || n.rel === "preload").map(
      (n) => n.rel === "stylesheet" ? { ...n, rel: "prefetch", as: "style" } : { ...n, rel: "prefetch" }
    )
  );
}
function Ch(e, t, a, o, n, r) {
  let i = (l, c) => a[c] ? l.route.id !== a[c].route.id : !0, s = (l, c) => (
    // param change, /users/123 -> /users/456
    a[c].pathname !== l.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    a[c].route.path?.endsWith("*") && a[c].params["*"] !== l.params["*"]
  );
  return r === "assets" ? t.filter(
    (l, c) => i(l, c) || s(l, c)
  ) : r === "data" ? t.filter((l, c) => {
    let u = o.routes[l.route.id];
    if (!u || !u.hasLoader)
      return !1;
    if (i(l, c) || s(l, c))
      return !0;
    if (l.route.shouldRevalidate) {
      let d = l.route.shouldRevalidate({
        currentUrl: new URL(
          n.pathname + n.search + n.hash,
          window.origin
        ),
        currentParams: a[0]?.params || {},
        nextUrl: new URL(e, window.origin),
        nextParams: l.params,
        defaultShouldRevalidate: !0
      });
      if (typeof d == "boolean")
        return d;
    }
    return !0;
  }) : [];
}
function _D(e, t, { includeHydrateFallback: a } = {}) {
  return vD(
    e.map((o) => {
      let n = t.routes[o.route.id];
      if (!n) return [];
      let r = [n.module];
      return n.clientActionModule && (r = r.concat(n.clientActionModule)), n.clientLoaderModule && (r = r.concat(n.clientLoaderModule)), a && n.hydrateFallbackModule && (r = r.concat(n.hydrateFallbackModule)), n.imports && (r = r.concat(n.imports)), r;
    }).flat(1)
  );
}
function vD(e) {
  return [...new Set(e)];
}
function yD(e) {
  let t = {}, a = Object.keys(e).sort();
  for (let o of a)
    t[o] = e[o];
  return t;
}
function wD(e, t) {
  let a = /* @__PURE__ */ new Set();
  return new Set(t), e.reduce((o, n) => {
    let r = JSON.stringify(yD(n));
    return a.has(r) || (a.add(r), o.push({ key: r, link: n })), o;
  }, []);
}
function iy() {
  let e = g.useContext(rn);
  return cd(
    e,
    "You must render this element inside a <DataRouterContext.Provider> element"
  ), e;
}
function kD() {
  let e = g.useContext(Ss);
  return cd(
    e,
    "You must render this element inside a <DataRouterStateContext.Provider> element"
  ), e;
}
var ud = g.createContext(void 0);
ud.displayName = "FrameworkContext";
function sy() {
  let e = g.useContext(ud);
  return cd(
    e,
    "You must render this element inside a <HydratedRouter> element"
  ), e;
}
function xD(e, t) {
  let a = g.useContext(ud), [o, n] = g.useState(!1), [r, i] = g.useState(!1), { onFocus: s, onBlur: l, onMouseEnter: c, onMouseLeave: u, onTouchStart: d } = t, h = g.useRef(null);
  g.useEffect(() => {
    if (e === "render" && i(!0), e === "viewport") {
      let p = (w) => {
        w.forEach((_) => {
          i(_.isIntersecting);
        });
      }, b = new IntersectionObserver(p, { threshold: 0.5 });
      return h.current && b.observe(h.current), () => {
        b.disconnect();
      };
    }
  }, [e]), g.useEffect(() => {
    if (o) {
      let p = setTimeout(() => {
        i(!0);
      }, 100);
      return () => {
        clearTimeout(p);
      };
    }
  }, [o]);
  let m = () => {
    n(!0);
  }, f = () => {
    n(!1), i(!1);
  };
  return a ? e !== "intent" ? [r, h, {}] : [
    r,
    h,
    {
      onFocus: _n(s, m),
      onBlur: _n(l, f),
      onMouseEnter: _n(c, m),
      onMouseLeave: _n(u, f),
      onTouchStart: _n(d, m)
    }
  ] : [!1, h, {}];
}
function _n(e, t) {
  return (a) => {
    e && e(a), a.defaultPrevented || t(a);
  };
}
function $D({ page: e, ...t }) {
  let { router: a } = iy(), o = g.useMemo(
    () => Zv(a.routes, e, a.basename),
    [a.routes, e, a.basename]
  );
  return o ? /* @__PURE__ */ g.createElement(CD, { page: e, matches: o, ...t }) : null;
}
function SD(e) {
  let { manifest: t, routeModules: a } = sy(), [o, n] = g.useState([]);
  return g.useEffect(() => {
    let r = !1;
    return bD(e, t, a).then(
      (i) => {
        r || n(i);
      }
    ), () => {
      r = !0;
    };
  }, [e, t, a]), o;
}
function CD({
  page: e,
  matches: t,
  ...a
}) {
  let o = vo(), { manifest: n, routeModules: r } = sy(), { basename: i } = iy(), { loaderData: s, matches: l } = kD(), c = g.useMemo(
    () => Ch(
      e,
      t,
      l,
      n,
      o,
      "data"
    ),
    [e, t, l, n, o]
  ), u = g.useMemo(
    () => Ch(
      e,
      t,
      l,
      n,
      o,
      "assets"
    ),
    [e, t, l, n, o]
  ), d = g.useMemo(() => {
    if (e === o.pathname + o.search + o.hash)
      return [];
    let f = /* @__PURE__ */ new Set(), p = !1;
    if (t.forEach((w) => {
      let _ = n.routes[w.route.id];
      !_ || !_.hasLoader || (!c.some((y) => y.route.id === w.route.id) && w.route.id in s && r[w.route.id]?.shouldRevalidate || _.hasClientLoader ? p = !0 : f.add(w.route.id));
    }), f.size === 0)
      return [];
    let b = pD(e, i, "data");
    return p && f.size > 0 && b.searchParams.set(
      "_routes",
      t.filter((w) => f.has(w.route.id)).map((w) => w.route.id).join(",")
    ), [b.pathname + b.search];
  }, [
    i,
    s,
    o,
    n,
    c,
    t,
    e,
    r
  ]), h = g.useMemo(
    () => _D(u, n),
    [u, n]
  ), m = SD(u);
  return /* @__PURE__ */ g.createElement(g.Fragment, null, d.map((f) => /* @__PURE__ */ g.createElement("link", { key: f, rel: "prefetch", as: "fetch", href: f, ...a })), h.map((f) => /* @__PURE__ */ g.createElement("link", { key: f, rel: "modulepreload", href: f, ...a })), m.map(({ key: f, link: p }) => (
    // these don't spread `linkProps` because they are full link descriptors
    // already with their own props
    /* @__PURE__ */ g.createElement("link", { key: f, nonce: a.nonce, ...p })
  )));
}
function ED(...e) {
  return (t) => {
    e.forEach((a) => {
      typeof a == "function" ? a(t) : a != null && (a.current = t);
    });
  };
}
var ly = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
try {
  ly && (window.__reactRouterVersion = // @ts-expect-error
  "7.9.3");
} catch {
}
var cy = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i, uy = g.forwardRef(
  function({
    onClick: e,
    discover: t = "render",
    prefetch: a = "none",
    relative: o,
    reloadDocument: n,
    replace: r,
    state: i,
    target: s,
    to: l,
    preventScrollReset: c,
    viewTransition: u,
    ...d
  }, h) {
    let { basename: m } = g.useContext(ya), f = typeof l == "string" && cy.test(l), p, b = !1;
    if (typeof l == "string" && f && (p = l, ly))
      try {
        let E = new URL(window.location.href), C = l.startsWith("//") ? new URL(E.protocol + l) : new URL(l), j = Na(C.pathname, m);
        C.origin === E.origin && j != null ? l = j + C.search + C.hash : b = !0;
      } catch {
        ma(
          !1,
          `<Link to="${l}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`
        );
      }
    let w = UP(l, { relative: o }), [_, y, k] = xD(
      a,
      d
    ), x = AD(l, {
      replace: r,
      state: i,
      target: s,
      preventScrollReset: c,
      relative: o,
      viewTransition: u
    });
    function S(E) {
      e && e(E), E.defaultPrevented || x(E);
    }
    let $ = (
      // eslint-disable-next-line jsx-a11y/anchor-has-content
      /* @__PURE__ */ g.createElement(
        "a",
        {
          ...d,
          ...k,
          href: p || w,
          onClick: b || n ? e : S,
          ref: ED(h, y),
          target: s,
          "data-discover": !f && t === "render" ? "true" : void 0
        }
      )
    );
    return _ && !f ? /* @__PURE__ */ g.createElement(g.Fragment, null, $, /* @__PURE__ */ g.createElement($D, { page: w })) : $;
  }
);
uy.displayName = "Link";
var jD = g.forwardRef(
  function({
    "aria-current": e = "page",
    caseSensitive: t = !1,
    className: a = "",
    end: o = !1,
    style: n,
    to: r,
    viewTransition: i,
    children: s,
    ...l
  }, c) {
    let u = or(r, { relative: l.relative }), d = vo(), h = g.useContext(Ss), { navigator: m, basename: f } = g.useContext(ya), p = h != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    ID(u) && i === !0, b = m.encodeLocation ? m.encodeLocation(u).pathname : u.pathname, w = d.pathname, _ = h && h.navigation && h.navigation.location ? h.navigation.location.pathname : null;
    t || (w = w.toLowerCase(), _ = _ ? _.toLowerCase() : null, b = b.toLowerCase()), _ && f && (_ = Na(_, f) || _);
    const y = b !== "/" && b.endsWith("/") ? b.length - 1 : b.length;
    let k = w === b || !o && w.startsWith(b) && w.charAt(y) === "/", x = _ != null && (_ === b || !o && _.startsWith(b) && _.charAt(b.length) === "/"), S = {
      isActive: k,
      isPending: x,
      isTransitioning: p
    }, $ = k ? e : void 0, E;
    typeof a == "function" ? E = a(S) : E = [
      a,
      k ? "active" : null,
      x ? "pending" : null,
      p ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let C = typeof n == "function" ? n(S) : n;
    return /* @__PURE__ */ g.createElement(
      uy,
      {
        ...l,
        "aria-current": $,
        className: E,
        ref: c,
        style: C,
        to: r,
        viewTransition: i
      },
      typeof s == "function" ? s(S) : s
    );
  }
);
jD.displayName = "NavLink";
var OD = g.forwardRef(
  ({
    discover: e = "render",
    fetcherKey: t,
    navigate: a,
    reloadDocument: o,
    replace: n,
    state: r,
    method: i = ii,
    action: s,
    onSubmit: l,
    relative: c,
    preventScrollReset: u,
    viewTransition: d,
    ...h
  }, m) => {
    let f = ND(), p = RD(s, { relative: c }), b = i.toLowerCase() === "get" ? "get" : "post", w = typeof s == "string" && cy.test(s), _ = (y) => {
      if (l && l(y), y.defaultPrevented) return;
      y.preventDefault();
      let k = y.nativeEvent.submitter, x = k?.getAttribute("formmethod") || i;
      f(k || y.currentTarget, {
        fetcherKey: t,
        method: x,
        navigate: a,
        replace: n,
        state: r,
        relative: c,
        preventScrollReset: u,
        viewTransition: d
      });
    };
    return /* @__PURE__ */ g.createElement(
      "form",
      {
        ref: m,
        method: b,
        action: p,
        onSubmit: o ? l : _,
        ...h,
        "data-discover": !w && e === "render" ? "true" : void 0
      }
    );
  }
);
OD.displayName = "Form";
function zD(e) {
  return `${e} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function dy(e) {
  let t = g.useContext(rn);
  return et(t, zD(e)), t;
}
function AD(e, {
  target: t,
  replace: a,
  state: o,
  preventScrollReset: n,
  relative: r,
  viewTransition: i
} = {}) {
  let s = qP(), l = vo(), c = or(e, { relative: r });
  return g.useCallback(
    (u) => {
      if (uD(u, t)) {
        u.preventDefault();
        let d = a !== void 0 ? a : Sc(l) === Sc(c);
        s(e, {
          replace: d,
          state: o,
          preventScrollReset: n,
          relative: r,
          viewTransition: i
        });
      }
    },
    [
      l,
      s,
      c,
      a,
      o,
      t,
      e,
      n,
      r,
      i
    ]
  );
}
var PD = 0, DD = () => `__${String(++PD)}__`;
function ND() {
  let { router: e } = dy(
    "useSubmit"
    /* UseSubmit */
  ), { basename: t } = g.useContext(ya), a = aD();
  return g.useCallback(
    async (o, n = {}) => {
      let { action: r, method: i, encType: s, formData: l, body: c } = hD(
        o,
        t
      );
      if (n.navigate === !1) {
        let u = n.fetcherKey || DD();
        await e.fetch(u, a, n.action || r, {
          preventScrollReset: n.preventScrollReset,
          formData: l,
          body: c,
          formMethod: n.method || i,
          formEncType: n.encType || s,
          flushSync: n.flushSync
        });
      } else
        await e.navigate(n.action || r, {
          preventScrollReset: n.preventScrollReset,
          formData: l,
          body: c,
          formMethod: n.method || i,
          formEncType: n.encType || s,
          replace: n.replace,
          state: n.state,
          fromRouteId: a,
          flushSync: n.flushSync,
          viewTransition: n.viewTransition
        });
    },
    [e, t, a]
  );
}
function RD(e, { relative: t } = {}) {
  let { basename: a } = g.useContext(ya), o = g.useContext(wa);
  et(o, "useFormAction must be used inside a RouteContext");
  let [n] = o.matches.slice(-1), r = { ...or(e || ".", { relative: t }) }, i = vo();
  if (e == null) {
    r.search = i.search;
    let s = new URLSearchParams(r.search), l = s.getAll("index");
    if (l.some((c) => c === "")) {
      s.delete("index"), l.filter((u) => u).forEach((u) => s.append("index", u));
      let c = s.toString();
      r.search = c ? `?${c}` : "";
    }
  }
  return (!e || e === ".") && n.route.index && (r.search = r.search ? r.search.replace(/^\?/, "?index&") : "?index"), a !== "/" && (r.pathname = r.pathname === "/" ? a : ga([a, r.pathname])), Sc(r);
}
function ID(e, { relative: t } = {}) {
  let a = g.useContext(ay);
  et(
    a != null,
    "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?"
  );
  let { basename: o } = dy(
    "useViewTransitionState"
    /* useViewTransitionState */
  ), n = or(e, { relative: t });
  if (!a.isTransitioning)
    return !1;
  let r = Na(a.currentLocation.pathname, o) || a.currentLocation.pathname, i = Na(a.nextLocation.pathname, o) || a.nextLocation.pathname;
  return Ni(n.pathname, i) != null || Ni(n.pathname, r) != null;
}
function gy(e) {
  var t, a, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var n = e.length;
    for (t = 0; t < n; t++) e[t] && (a = gy(e[t])) && (o && (o += " "), o += a);
  } else for (a in e) e[a] && (o && (o += " "), o += a);
  return o;
}
function TD() {
  for (var e, t, a = 0, o = "", n = arguments.length; a < n; a++) (e = arguments[a]) && (t = gy(e)) && (o && (o += " "), o += t);
  return o;
}
const LD = [
  "accessible-bathroom",
  "accessible-bedroom",
  "ac",
  "ambassador_sidebar",
  "animals-card",
  "angle-left",
  "angle-left-rounded",
  "angle-right",
  "angle-right-rounded",
  "anywhere-in-the-world",
  "arrow-thin",
  "arrow-thin-right",
  "available-exchange-type",
  "average-reactivity",
  "baby-bed",
  "baby-gear",
  "baby-gear-old",
  "baby-sitter",
  "balcony-terrace",
  "bathroom",
  "bathtub",
  "bbq",
  "bedroom",
  "beds",
  "bicycle",
  "briefcase3",
  "button-power",
  "cancel",
  "calendar",
  "car",
  "cat-to-feed",
  "chat-lock",
  "check",
  "checkbox-fill",
  "children-welcome",
  "circle-close",
  "circle-help",
  "circle-left-arrow",
  "circle-right-arrow",
  "cities",
  "cleaning-person",
  "clock",
  "computer",
  "cook",
  "corona-virus",
  "countryside",
  "credit-card",
  "dashboard-saved-search",
  "dedicated-work-space",
  "disabled-access",
  "dishwasher",
  "docs",
  "dog-to-feed",
  "dollar",
  "doorman",
  "double-bed",
  "double-bed-up",
  "dryer",
  "easy-navigation",
  "electric-car",
  "electric-car-plug",
  "elevator",
  "error",
  "error-regular",
  "error-warning-fill",
  "excellent-reactivity",
  "eye",
  "eye-slash",
  "eye-slash-back",
  "facebook",
  "filter-picture",
  "fireplace",
  "flag",
  "flat",
  "folk",
  "freezer",
  "fridge",
  "garden",
  "gift",
  "gp",
  "great-reactivity",
  "guarantees",
  "guestpoint-exchange-type",
  "guestpoints",
  "guide",
  "gym",
  "header-help",
  "header-message-new",
  "header-message-read",
  "header-profile-home",
  "header-profile-profile",
  "header-profile-settings",
  "header-profile-they-love-my-home",
  "heart",
  "heart-fill",
  "heating-system",
  "high-speed-connection",
  "home-bin",
  "home-camera",
  "home-cinema",
  "home-exchange",
  "home-panel",
  "house",
  "ic-compass",
  "ic-flip-left",
  "ic-flip-right",
  "ic-location",
  "ic-move",
  "ic-shelter",
  "ic-transfer",
  "icon_facebook",
  "icon_gmail",
  "icon_messanger",
  "icon_outlook",
  "id",
  "information-circle",
  "information-circle-regular",
  "instagram",
  "internet",
  "isolated",
  "island",
  "jacuzzi",
  "key",
  "keys",
  "kids-playground",
  "kids-toys",
  "lakes",
  "lifebuoy",
  "linkedin",
  "location",
  "lock",
  "lock-credit-card",
  "low-consumption-machines",
  "marker-home",
  "marker-home-favorite",
  "marker-home-selected",
  "marker-home-selected-favorite",
  "marker-home-unavailable",
  "marker-home-unavailable-favorite",
  "low-reactivity",
  "map-1",
  "megaphone",
  "membership",
  "messenger",
  "microwave-oven",
  "minus",
  "moonplus",
  "more-filter",
  "motorboat",
  "motorcycle",
  "motor-scooter",
  "mountains",
  "my-family",
  "new-tab",
  "notification",
  "noun-loyalty-card",
  "number-eight",
  "number-five",
  "number-four",
  "number-nine",
  "number-one",
  "number-seven",
  "number-six",
  "number-three",
  "number-two",
  "ok",
  "oven",
  "parking-space",
  "pencil",
  "people",
  "pets-welcome",
  "phone",
  "piano",
  "ping-pong-table",
  "pin",
  "plants-to-water",
  "playground",
  "plus",
  "plus-sign",
  "pool-table",
  "preferred-destinations",
  "primary-home",
  "private-room",
  "public-transit-access",
  "rabbit",
  "raw",
  "reciprocal-exchange-type",
  "remove",
  "renewable-energy-provider",
  "river",
  "rooms",
  "sailboat",
  "satellite-cable",
  "sauna",
  "search",
  "search-location-pin",
  "seaside",
  "secondary-home",
  "secured-swimming-pool",
  "selective-waste-sorting",
  "shape-close",
  "share-fat",
  "simple-bed",
  "simple-bed-up",
  "size",
  "smart-tv",
  "smokers-welcome",
  "solar-panels",
  "sort-order",
  "sponsor-hand-icon",
  "star-black",
  "star-full",
  "step-free-entry",
  "sugesstion",
  "sun",
  "swimming-pool",
  "tennis-court",
  "tiktok",
  "triangle-warning",
  "tv",
  "tv-icon",
  "twitter",
  "types_of_exchanges",
  "unavailable",
  "up-arrow",
  "upload",
  "user",
  "vegetable-garden",
  "verification-check",
  "verification-check-regular",
  "video-game-console",
  "villages",
  "warning",
  "warning-regular",
  "washing-machine",
  "wide-angle",
  "wide-doors",
  "wifi",
  "youtube"
], MD = {
  "marker-home-favorite": 3,
  "marker-home": 2,
  "marker-home-selected-favorite": 3,
  "marker-home-selected": 2,
  "marker-home-unavailable-favorite": 3,
  "marker-home-unavailable": 2,
  icon_facebook: 2,
  icon_gmail: 5
}, WD = LD.map((e) => ({
  name: e,
  class: `icon-${e}`,
  paths: MD[e]
})), BD = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, FD = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl",
  "8xl": "is-8xl",
  "9xl": "is-9xl",
  "10xl": "is-10xl"
};
function VD(e = 0) {
  const t = [];
  for (let a = 0; a < e; a++)
    t[a] = `path${a + 1}`;
  return t.map((a) => /* @__PURE__ */ v("span", { className: a }, a));
}
const UD = mt(
  ({ name: e, size: t = "medium", color: a = "base", className: o = "", ...n }, r) => {
    const i = WD.find((l) => l.name === e), s = TD("icon", `ds-${i?.class}`, FD[t], BD[a], o);
    return /* @__PURE__ */ v("i", { className: s, ...n, ref: r, children: VD(i?.paths) });
  }
);
UD.displayName = "Icon";
Ot({
  locale: "en"
});
function qD(e, t) {
  const [a, o] = Pe(e), n = _P(a, 500), [r, i] = Pe([]);
  Ce(() => {
    n.length > 3 && wE(n, t).then((l) => {
      const c = l?.features.map((u) => ({ value: u.properties.label, id: u.properties.gid }));
      i(c);
    });
  }, [n, t]);
  const s = n.length > 2 ? r ?? [] : [];
  return { value: a, setValue: o, suggestedDestinations: s };
}
function HD() {
  return Le((e, t) => {
    let a;
    t ? a = `${t.value}?location_id=${t.id}&provider=Jawg` : a = "everywhere", window !== void 0 && (window.location.href = `/search-v2/${a}`);
  }, []);
}
function GD({
  placeholder: e,
  buttonText: t,
  id: a,
  className: o,
  locale: n,
  ...r
}) {
  const { setValue: i, suggestedDestinations: s } = qD("", n), l = HD();
  return /* @__PURE__ */ v(
    _A,
    {
      className: o,
      id: a || "search-bar",
      placeholder: e || "Search destinations",
      suggestions: s,
      onChange: i,
      onSubmit: l,
      buttonText: t || "Search",
      ...r
    }
  );
}
function KD({
  config: e,
  placeholder: t = "Search destinations",
  buttonText: a = "Search",
  id: o,
  className: n,
  ...r
}) {
  return /* @__PURE__ */ v(yP, { config: e, children: /* @__PURE__ */ v(
    GD,
    {
      placeholder: t,
      buttonText: a,
      id: o,
      className: n,
      locale: e.locale,
      ...r
    }
  ) });
}
Ot();
const se = (e) => typeof e == "string", vn = () => {
  let e, t;
  const a = new Promise((o, n) => {
    e = o, t = n;
  });
  return a.resolve = e, a.reject = t, a;
}, Eh = (e) => e == null ? "" : "" + e, JD = (e, t, a) => {
  e.forEach((o) => {
    t[o] && (a[o] = t[o]);
  });
}, ZD = /###/g, jh = (e) => e && e.indexOf("###") > -1 ? e.replace(ZD, ".") : e, Oh = (e) => !e || se(e), An = (e, t, a) => {
  const o = se(t) ? t.split(".") : t;
  let n = 0;
  for (; n < o.length - 1; ) {
    if (Oh(e)) return {};
    const r = jh(o[n]);
    !e[r] && a && (e[r] = new a()), Object.prototype.hasOwnProperty.call(e, r) ? e = e[r] : e = {}, ++n;
  }
  return Oh(e) ? {} : {
    obj: e,
    k: jh(o[n])
  };
}, zh = (e, t, a) => {
  const {
    obj: o,
    k: n
  } = An(e, t, Object);
  if (o !== void 0 || t.length === 1) {
    o[n] = a;
    return;
  }
  let r = t[t.length - 1], i = t.slice(0, t.length - 1), s = An(e, i, Object);
  for (; s.obj === void 0 && i.length; )
    r = `${i[i.length - 1]}.${r}`, i = i.slice(0, i.length - 1), s = An(e, i, Object), s?.obj && typeof s.obj[`${s.k}.${r}`] < "u" && (s.obj = void 0);
  s.obj[`${s.k}.${r}`] = a;
}, YD = (e, t, a, o) => {
  const {
    obj: n,
    k: r
  } = An(e, t, Object);
  n[r] = n[r] || [], n[r].push(a);
}, Ri = (e, t) => {
  const {
    obj: a,
    k: o
  } = An(e, t);
  if (a && Object.prototype.hasOwnProperty.call(a, o))
    return a[o];
}, XD = (e, t, a) => {
  const o = Ri(e, a);
  return o !== void 0 ? o : Ri(t, a);
}, hy = (e, t, a) => {
  for (const o in t)
    o !== "__proto__" && o !== "constructor" && (o in e ? se(e[o]) || e[o] instanceof String || se(t[o]) || t[o] instanceof String ? a && (e[o] = t[o]) : hy(e[o], t[o], a) : e[o] = t[o]);
  return e;
}, Oo = (e) => e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var QD = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const eN = (e) => se(e) ? e.replace(/[&<>"'\/]/g, (t) => QD[t]) : e;
let tN = class {
  constructor(t) {
    this.capacity = t, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(t) {
    const a = this.regExpMap.get(t);
    if (a !== void 0)
      return a;
    const o = new RegExp(t);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(t, o), this.regExpQueue.push(t), o;
  }
};
const aN = [" ", ",", "?", "!", ";"], oN = new tN(20), nN = (e, t, a) => {
  t = t || "", a = a || "";
  const o = aN.filter((i) => t.indexOf(i) < 0 && a.indexOf(i) < 0);
  if (o.length === 0) return !0;
  const n = oN.getRegExp(`(${o.map((i) => i === "?" ? "\\?" : i).join("|")})`);
  let r = !n.test(e);
  if (!r) {
    const i = e.indexOf(a);
    i > 0 && !n.test(e.substring(0, i)) && (r = !0);
  }
  return r;
}, Cc = (e, t, a = ".") => {
  if (!e) return;
  if (e[t])
    return Object.prototype.hasOwnProperty.call(e, t) ? e[t] : void 0;
  const o = t.split(a);
  let n = e;
  for (let r = 0; r < o.length; ) {
    if (!n || typeof n != "object")
      return;
    let i, s = "";
    for (let l = r; l < o.length; ++l)
      if (l !== r && (s += a), s += o[l], i = n[s], i !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof i) > -1 && l < o.length - 1)
          continue;
        r += l - r + 1;
        break;
      }
    n = i;
  }
  return n;
}, Tn = (e) => e?.replace("_", "-"), rN = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, t) {
    console?.[e]?.apply?.(console, t);
  }
};
let iN = class Ec {
  constructor(t, a = {}) {
    this.init(t, a);
  }
  init(t, a = {}) {
    this.prefix = a.prefix || "i18next:", this.logger = t || rN, this.options = a, this.debug = a.debug;
  }
  log(...t) {
    return this.forward(t, "log", "", !0);
  }
  warn(...t) {
    return this.forward(t, "warn", "", !0);
  }
  error(...t) {
    return this.forward(t, "error", "");
  }
  deprecate(...t) {
    return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(t, a, o, n) {
    return n && !this.debug ? null : (se(t[0]) && (t[0] = `${o}${this.prefix} ${t[0]}`), this.logger[a](t));
  }
  create(t) {
    return new Ec(this.logger, {
      prefix: `${this.prefix}:${t}:`,
      ...this.options
    });
  }
  clone(t) {
    return t = t || this.options, t.prefix = t.prefix || this.prefix, new Ec(this.logger, t);
  }
};
var Kt = new iN();
let Os = class {
  constructor() {
    this.observers = {};
  }
  on(t, a) {
    return t.split(" ").forEach((o) => {
      this.observers[o] || (this.observers[o] = /* @__PURE__ */ new Map());
      const n = this.observers[o].get(a) || 0;
      this.observers[o].set(a, n + 1);
    }), this;
  }
  off(t, a) {
    if (this.observers[t]) {
      if (!a) {
        delete this.observers[t];
        return;
      }
      this.observers[t].delete(a);
    }
  }
  emit(t, ...a) {
    this.observers[t] && Array.from(this.observers[t].entries()).forEach(([o, n]) => {
      for (let r = 0; r < n; r++)
        o(...a);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach(([o, n]) => {
      for (let r = 0; r < n; r++)
        o.apply(o, [t, ...a]);
    });
  }
};
class Ah extends Os {
  constructor(t, a = {
    ns: ["translation"],
    defaultNS: "translation"
  }) {
    super(), this.data = t || {}, this.options = a, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(t) {
    this.options.ns.indexOf(t) < 0 && this.options.ns.push(t);
  }
  removeNamespaces(t) {
    const a = this.options.ns.indexOf(t);
    a > -1 && this.options.ns.splice(a, 1);
  }
  getResource(t, a, o, n = {}) {
    const r = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, i = n.ignoreJSONStructure !== void 0 ? n.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let s;
    t.indexOf(".") > -1 ? s = t.split(".") : (s = [t, a], o && (Array.isArray(o) ? s.push(...o) : se(o) && r ? s.push(...o.split(r)) : s.push(o)));
    const l = Ri(this.data, s);
    return !l && !a && !o && t.indexOf(".") > -1 && (t = s[0], a = s[1], o = s.slice(2).join(".")), l || !i || !se(o) ? l : Cc(this.data?.[t]?.[a], o, r);
  }
  addResource(t, a, o, n, r = {
    silent: !1
  }) {
    const i = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator;
    let s = [t, a];
    o && (s = s.concat(i ? o.split(i) : o)), t.indexOf(".") > -1 && (s = t.split("."), n = a, a = s[1]), this.addNamespaces(a), zh(this.data, s, n), r.silent || this.emit("added", t, a, o, n);
  }
  addResources(t, a, o, n = {
    silent: !1
  }) {
    for (const r in o)
      (se(o[r]) || Array.isArray(o[r])) && this.addResource(t, a, r, o[r], {
        silent: !0
      });
    n.silent || this.emit("added", t, a, o);
  }
  addResourceBundle(t, a, o, n, r, i = {
    silent: !1,
    skipCopy: !1
  }) {
    let s = [t, a];
    t.indexOf(".") > -1 && (s = t.split("."), n = o, o = a, a = s[1]), this.addNamespaces(a);
    let l = Ri(this.data, s) || {};
    i.skipCopy || (o = JSON.parse(JSON.stringify(o))), n ? hy(l, o, r) : l = {
      ...l,
      ...o
    }, zh(this.data, s, l), i.silent || this.emit("added", t, a, o);
  }
  removeResourceBundle(t, a) {
    this.hasResourceBundle(t, a) && delete this.data[t][a], this.removeNamespaces(a), this.emit("removed", t, a);
  }
  hasResourceBundle(t, a) {
    return this.getResource(t, a) !== void 0;
  }
  getResourceBundle(t, a) {
    return a || (a = this.options.defaultNS), this.getResource(t, a);
  }
  getDataByLanguage(t) {
    return this.data[t];
  }
  hasLanguageSomeTranslations(t) {
    const a = this.getDataByLanguage(t);
    return !!(a && Object.keys(a) || []).find((o) => a[o] && Object.keys(a[o]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var py = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, t, a, o, n) {
    return e.forEach((r) => {
      t = this.processors[r]?.process(t, a, o, n) ?? t;
    }), t;
  }
};
const my = Symbol("i18next/PATH_KEY");
function sN() {
  const e = [], t = /* @__PURE__ */ Object.create(null);
  let a;
  return t.get = (o, n) => (a?.revoke?.(), n === my ? e : (e.push(n), a = Proxy.revocable(o, t), a.proxy)), Proxy.revocable(/* @__PURE__ */ Object.create(null), t).proxy;
}
function jc(e, t) {
  const {
    [my]: a
  } = e(sN());
  return a.join(t?.keySeparator ?? ".");
}
const Ph = {}, Dh = (e) => !se(e) && typeof e != "boolean" && typeof e != "number";
let Nh = class fy extends Os {
  constructor(t, a = {}) {
    super(), JD(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], t, this), this.options = a, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = Kt.create("translator");
  }
  changeLanguage(t) {
    t && (this.language = t);
  }
  exists(t, a = {
    interpolation: {}
  }) {
    const o = {
      ...a
    };
    return t == null ? !1 : this.resolve(t, o)?.res !== void 0;
  }
  extractFromKey(t, a) {
    let o = a.nsSeparator !== void 0 ? a.nsSeparator : this.options.nsSeparator;
    o === void 0 && (o = ":");
    const n = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator;
    let r = a.ns || this.options.defaultNS || [];
    const i = o && t.indexOf(o) > -1, s = !this.options.userDefinedKeySeparator && !a.keySeparator && !this.options.userDefinedNsSeparator && !a.nsSeparator && !nN(t, o, n);
    if (i && !s) {
      const l = t.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: t,
          namespaces: se(r) ? [r] : r
        };
      const c = t.split(o);
      (o !== n || o === n && this.options.ns.indexOf(c[0]) > -1) && (r = c.shift()), t = c.join(n);
    }
    return {
      key: t,
      namespaces: se(r) ? [r] : r
    };
  }
  translate(t, a, o) {
    let n = typeof a == "object" ? {
      ...a
    } : a;
    if (typeof n != "object" && this.options.overloadTranslationOptionHandler && (n = this.options.overloadTranslationOptionHandler(arguments)), typeof n == "object" && (n = {
      ...n
    }), n || (n = {}), t == null) return "";
    typeof t == "function" && (t = jc(t, {
      ...this.options,
      ...n
    })), Array.isArray(t) || (t = [String(t)]);
    const r = n.returnDetails !== void 0 ? n.returnDetails : this.options.returnDetails, i = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, {
      key: s,
      namespaces: l
    } = this.extractFromKey(t[t.length - 1], n), c = l[l.length - 1];
    let u = n.nsSeparator !== void 0 ? n.nsSeparator : this.options.nsSeparator;
    u === void 0 && (u = ":");
    const d = n.lng || this.language, h = n.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (d?.toLowerCase() === "cimode")
      return h ? r ? {
        res: `${c}${u}${s}`,
        usedKey: s,
        exactUsedKey: s,
        usedLng: d,
        usedNS: c,
        usedParams: this.getUsedParamsDetails(n)
      } : `${c}${u}${s}` : r ? {
        res: s,
        usedKey: s,
        exactUsedKey: s,
        usedLng: d,
        usedNS: c,
        usedParams: this.getUsedParamsDetails(n)
      } : s;
    const m = this.resolve(t, n);
    let f = m?.res;
    const p = m?.usedKey || s, b = m?.exactUsedKey || s, w = ["[object Number]", "[object Function]", "[object RegExp]"], _ = n.joinArrays !== void 0 ? n.joinArrays : this.options.joinArrays, y = !this.i18nFormat || this.i18nFormat.handleAsObject, k = n.count !== void 0 && !se(n.count), x = fy.hasDefaultValue(n), S = k ? this.pluralResolver.getSuffix(d, n.count, n) : "", $ = n.ordinal && k ? this.pluralResolver.getSuffix(d, n.count, {
      ordinal: !1
    }) : "", E = k && !n.ordinal && n.count === 0, C = E && n[`defaultValue${this.options.pluralSeparator}zero`] || n[`defaultValue${S}`] || n[`defaultValue${$}`] || n.defaultValue;
    let j = f;
    y && !f && x && (j = C);
    const R = Dh(j), H = Object.prototype.toString.apply(j);
    if (y && j && R && w.indexOf(H) < 0 && !(se(_) && Array.isArray(j))) {
      if (!n.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const L = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(p, j, {
          ...n,
          ns: l
        }) : `key '${s} (${this.language})' returned an object instead of string.`;
        return r ? (m.res = L, m.usedParams = this.getUsedParamsDetails(n), m) : L;
      }
      if (i) {
        const L = Array.isArray(j), O = L ? [] : {}, U = L ? b : p;
        for (const I in j)
          if (Object.prototype.hasOwnProperty.call(j, I)) {
            const K = `${U}${i}${I}`;
            x && !f ? O[I] = this.translate(K, {
              ...n,
              defaultValue: Dh(C) ? C[I] : void 0,
              joinArrays: !1,
              ns: l
            }) : O[I] = this.translate(K, {
              ...n,
              joinArrays: !1,
              ns: l
            }), O[I] === K && (O[I] = j[I]);
          }
        f = O;
      }
    } else if (y && se(_) && Array.isArray(f))
      f = f.join(_), f && (f = this.extendTranslation(f, t, n, o));
    else {
      let L = !1, O = !1;
      !this.isValidLookup(f) && x && (L = !0, f = C), this.isValidLookup(f) || (O = !0, f = s);
      const U = (n.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && O ? void 0 : f, I = x && C !== f && this.options.updateMissing;
      if (O || L || I) {
        if (this.logger.log(I ? "updateKey" : "missingKey", d, c, s, I ? C : f), i) {
          const A = this.resolve(s, {
            ...n,
            keySeparator: !1
          });
          A && A.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let K = [];
        const q = this.languageUtils.getFallbackCodes(this.options.fallbackLng, n.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && q && q[0])
          for (let A = 0; A < q.length; A++)
            K.push(q[A]);
        else this.options.saveMissingTo === "all" ? K = this.languageUtils.toResolveHierarchy(n.lng || this.language) : K.push(n.lng || this.language);
        const te = (A, z, N) => {
          const B = x && N !== f ? N : U;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(A, c, z, B, I, n) : this.backendConnector?.saveMissing && this.backendConnector.saveMissing(A, c, z, B, I, n), this.emit("missingKey", A, c, z, f);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && k ? K.forEach((A) => {
          const z = this.pluralResolver.getSuffixes(A, n);
          E && n[`defaultValue${this.options.pluralSeparator}zero`] && z.indexOf(`${this.options.pluralSeparator}zero`) < 0 && z.push(`${this.options.pluralSeparator}zero`), z.forEach((N) => {
            te([A], s + N, n[`defaultValue${N}`] || C);
          });
        }) : te(K, s, C));
      }
      f = this.extendTranslation(f, t, n, m, o), O && f === s && this.options.appendNamespaceToMissingKey && (f = `${c}${u}${s}`), (O || L) && this.options.parseMissingKeyHandler && (f = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${c}${u}${s}` : s, L ? f : void 0, n));
    }
    return r ? (m.res = f, m.usedParams = this.getUsedParamsDetails(n), m) : f;
  }
  extendTranslation(t, a, o, n, r) {
    if (this.i18nFormat?.parse)
      t = this.i18nFormat.parse(t, {
        ...this.options.interpolation.defaultVariables,
        ...o
      }, o.lng || this.language || n.usedLng, n.usedNS, n.usedKey, {
        resolved: n
      });
    else if (!o.skipInterpolation) {
      o.interpolation && this.interpolator.init({
        ...o,
        interpolation: {
          ...this.options.interpolation,
          ...o.interpolation
        }
      });
      const l = se(t) && (o?.interpolation?.skipOnVariables !== void 0 ? o.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let c;
      if (l) {
        const d = t.match(this.interpolator.nestingRegexp);
        c = d && d.length;
      }
      let u = o.replace && !se(o.replace) ? o.replace : o;
      if (this.options.interpolation.defaultVariables && (u = {
        ...this.options.interpolation.defaultVariables,
        ...u
      }), t = this.interpolator.interpolate(t, u, o.lng || this.language || n.usedLng, o), l) {
        const d = t.match(this.interpolator.nestingRegexp), h = d && d.length;
        c < h && (o.nest = !1);
      }
      !o.lng && n && n.res && (o.lng = this.language || n.usedLng), o.nest !== !1 && (t = this.interpolator.nest(t, (...d) => r?.[0] === d[0] && !o.context ? (this.logger.warn(`It seems you are nesting recursively key: ${d[0]} in key: ${a[0]}`), null) : this.translate(...d, a), o)), o.interpolation && this.interpolator.reset();
    }
    const i = o.postProcess || this.options.postProcess, s = se(i) ? [i] : i;
    return t != null && s?.length && o.applyPostProcessor !== !1 && (t = py.handle(s, t, a, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...n,
        usedParams: this.getUsedParamsDetails(o)
      },
      ...o
    } : o, this)), t;
  }
  resolve(t, a = {}) {
    let o, n, r, i, s;
    return se(t) && (t = [t]), t.forEach((l) => {
      if (this.isValidLookup(o)) return;
      const c = this.extractFromKey(l, a), u = c.key;
      n = u;
      let d = c.namespaces;
      this.options.fallbackNS && (d = d.concat(this.options.fallbackNS));
      const h = a.count !== void 0 && !se(a.count), m = h && !a.ordinal && a.count === 0, f = a.context !== void 0 && (se(a.context) || typeof a.context == "number") && a.context !== "", p = a.lngs ? a.lngs : this.languageUtils.toResolveHierarchy(a.lng || this.language, a.fallbackLng);
      d.forEach((b) => {
        this.isValidLookup(o) || (s = b, !Ph[`${p[0]}-${b}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(s) && (Ph[`${p[0]}-${b}`] = !0, this.logger.warn(`key "${n}" for languages "${p.join(", ")}" won't get resolved as namespace "${s}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), p.forEach((w) => {
          if (this.isValidLookup(o)) return;
          i = w;
          const _ = [u];
          if (this.i18nFormat?.addLookupKeys)
            this.i18nFormat.addLookupKeys(_, u, w, b, a);
          else {
            let k;
            h && (k = this.pluralResolver.getSuffix(w, a.count, a));
            const x = `${this.options.pluralSeparator}zero`, S = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (h && (a.ordinal && k.indexOf(S) === 0 && _.push(u + k.replace(S, this.options.pluralSeparator)), _.push(u + k), m && _.push(u + x)), f) {
              const $ = `${u}${this.options.contextSeparator || "_"}${a.context}`;
              _.push($), h && (a.ordinal && k.indexOf(S) === 0 && _.push($ + k.replace(S, this.options.pluralSeparator)), _.push($ + k), m && _.push($ + x));
            }
          }
          let y;
          for (; y = _.pop(); )
            this.isValidLookup(o) || (r = y, o = this.getResource(w, b, y, a));
        }));
      });
    }), {
      res: o,
      usedKey: n,
      exactUsedKey: r,
      usedLng: i,
      usedNS: s
    };
  }
  isValidLookup(t) {
    return t !== void 0 && !(!this.options.returnNull && t === null) && !(!this.options.returnEmptyString && t === "");
  }
  getResource(t, a, o, n = {}) {
    return this.i18nFormat?.getResource ? this.i18nFormat.getResource(t, a, o, n) : this.resourceStore.getResource(t, a, o, n);
  }
  getUsedParamsDetails(t = {}) {
    const a = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], o = t.replace && !se(t.replace);
    let n = o ? t.replace : t;
    if (o && typeof t.count < "u" && (n.count = t.count), this.options.interpolation.defaultVariables && (n = {
      ...this.options.interpolation.defaultVariables,
      ...n
    }), !o) {
      n = {
        ...n
      };
      for (const r of a)
        delete n[r];
    }
    return n;
  }
  static hasDefaultValue(t) {
    const a = "defaultValue";
    for (const o in t)
      if (Object.prototype.hasOwnProperty.call(t, o) && a === o.substring(0, a.length) && t[o] !== void 0)
        return !0;
    return !1;
  }
};
class Rh {
  constructor(t) {
    this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Kt.create("languageUtils");
  }
  getScriptPartFromCode(t) {
    if (t = Tn(t), !t || t.indexOf("-") < 0) return null;
    const a = t.split("-");
    return a.length === 2 || (a.pop(), a[a.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(a.join("-"));
  }
  getLanguagePartFromCode(t) {
    if (t = Tn(t), !t || t.indexOf("-") < 0) return t;
    const a = t.split("-");
    return this.formatLanguageCode(a[0]);
  }
  formatLanguageCode(t) {
    if (se(t) && t.indexOf("-") > -1) {
      let a;
      try {
        a = Intl.getCanonicalLocales(t)[0];
      } catch {
      }
      return a && this.options.lowerCaseLng && (a = a.toLowerCase()), a || (this.options.lowerCaseLng ? t.toLowerCase() : t);
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? t.toLowerCase() : t;
  }
  isSupportedCode(t) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (t = this.getLanguagePartFromCode(t)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(t) > -1;
  }
  getBestMatchFromCodes(t) {
    if (!t) return null;
    let a;
    return t.forEach((o) => {
      if (a) return;
      const n = this.formatLanguageCode(o);
      (!this.options.supportedLngs || this.isSupportedCode(n)) && (a = n);
    }), !a && this.options.supportedLngs && t.forEach((o) => {
      if (a) return;
      const n = this.getScriptPartFromCode(o);
      if (this.isSupportedCode(n)) return a = n;
      const r = this.getLanguagePartFromCode(o);
      if (this.isSupportedCode(r)) return a = r;
      a = this.options.supportedLngs.find((i) => {
        if (i === r || !(i.indexOf("-") < 0 && r.indexOf("-") < 0) && (i.indexOf("-") > 0 && r.indexOf("-") < 0 && i.substring(0, i.indexOf("-")) === r || i.indexOf(r) === 0 && r.length > 1))
          return i;
      });
    }), a || (a = this.getFallbackCodes(this.options.fallbackLng)[0]), a;
  }
  getFallbackCodes(t, a) {
    if (!t) return [];
    if (typeof t == "function" && (t = t(a)), se(t) && (t = [t]), Array.isArray(t)) return t;
    if (!a) return t.default || [];
    let o = t[a];
    return o || (o = t[this.getScriptPartFromCode(a)]), o || (o = t[this.formatLanguageCode(a)]), o || (o = t[this.getLanguagePartFromCode(a)]), o || (o = t.default), o || [];
  }
  toResolveHierarchy(t, a) {
    const o = this.getFallbackCodes((a === !1 ? [] : a) || this.options.fallbackLng || [], t), n = [], r = (i) => {
      i && (this.isSupportedCode(i) ? n.push(i) : this.logger.warn(`rejecting language code not found in supportedLngs: ${i}`));
    };
    return se(t) && (t.indexOf("-") > -1 || t.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && r(this.formatLanguageCode(t)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && r(this.getScriptPartFromCode(t)), this.options.load !== "currentOnly" && r(this.getLanguagePartFromCode(t))) : se(t) && r(this.formatLanguageCode(t)), o.forEach((i) => {
      n.indexOf(i) < 0 && r(this.formatLanguageCode(i));
    }), n;
  }
}
const Ih = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, Th = {
  select: (e) => e === 1 ? "one" : "other",
  resolvedOptions: () => ({
    pluralCategories: ["one", "other"]
  })
};
let lN = class {
  constructor(t, a = {}) {
    this.languageUtils = t, this.options = a, this.logger = Kt.create("pluralResolver"), this.pluralRulesCache = {};
  }
  addRule(t, a) {
    this.rules[t] = a;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(t, a = {}) {
    const o = Tn(t === "dev" ? "en" : t), n = a.ordinal ? "ordinal" : "cardinal", r = JSON.stringify({
      cleanedCode: o,
      type: n
    });
    if (r in this.pluralRulesCache)
      return this.pluralRulesCache[r];
    let i;
    try {
      i = new Intl.PluralRules(o, {
        type: n
      });
    } catch {
      if (!Intl)
        return this.logger.error("No Intl support, please use an Intl polyfill!"), Th;
      if (!t.match(/-|_/)) return Th;
      const s = this.languageUtils.getLanguagePartFromCode(t);
      i = this.getRule(s, a);
    }
    return this.pluralRulesCache[r] = i, i;
  }
  needsPlural(t, a = {}) {
    let o = this.getRule(t, a);
    return o || (o = this.getRule("dev", a)), o?.resolvedOptions().pluralCategories.length > 1;
  }
  getPluralFormsOfKey(t, a, o = {}) {
    return this.getSuffixes(t, o).map((n) => `${a}${n}`);
  }
  getSuffixes(t, a = {}) {
    let o = this.getRule(t, a);
    return o || (o = this.getRule("dev", a)), o ? o.resolvedOptions().pluralCategories.sort((n, r) => Ih[n] - Ih[r]).map((n) => `${this.options.prepend}${a.ordinal ? `ordinal${this.options.prepend}` : ""}${n}`) : [];
  }
  getSuffix(t, a, o = {}) {
    const n = this.getRule(t, o);
    return n ? `${this.options.prepend}${o.ordinal ? `ordinal${this.options.prepend}` : ""}${n.select(a)}` : (this.logger.warn(`no plural rule found for: ${t}`), this.getSuffix("dev", a, o));
  }
};
const Lh = (e, t, a, o = ".", n = !0) => {
  let r = XD(e, t, a);
  return !r && n && se(a) && (r = Cc(e, a, o), r === void 0 && (r = Cc(t, a, o))), r;
}, jl = (e) => e.replace(/\$/g, "$$$$");
let cN = class {
  constructor(t = {}) {
    this.logger = Kt.create("interpolator"), this.options = t, this.format = t?.interpolation?.format || ((a) => a), this.init(t);
  }
  init(t = {}) {
    t.interpolation || (t.interpolation = {
      escapeValue: !0
    });
    const {
      escape: a,
      escapeValue: o,
      useRawValueToEscape: n,
      prefix: r,
      prefixEscaped: i,
      suffix: s,
      suffixEscaped: l,
      formatSeparator: c,
      unescapeSuffix: u,
      unescapePrefix: d,
      nestingPrefix: h,
      nestingPrefixEscaped: m,
      nestingSuffix: f,
      nestingSuffixEscaped: p,
      nestingOptionsSeparator: b,
      maxReplaces: w,
      alwaysFormat: _
    } = t.interpolation;
    this.escape = a !== void 0 ? a : eN, this.escapeValue = o !== void 0 ? o : !0, this.useRawValueToEscape = n !== void 0 ? n : !1, this.prefix = r ? Oo(r) : i || "{{", this.suffix = s ? Oo(s) : l || "}}", this.formatSeparator = c || ",", this.unescapePrefix = u ? "" : d || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u || "", this.nestingPrefix = h ? Oo(h) : m || Oo("$t("), this.nestingSuffix = f ? Oo(f) : p || Oo(")"), this.nestingOptionsSeparator = b || ",", this.maxReplaces = w || 1e3, this.alwaysFormat = _ !== void 0 ? _ : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const t = (a, o) => a?.source === o ? (a.lastIndex = 0, a) : new RegExp(o, "g");
    this.regexp = t(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = t(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = t(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
  }
  interpolate(t, a, o, n) {
    let r, i, s;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, c = (h) => {
      if (h.indexOf(this.formatSeparator) < 0) {
        const b = Lh(a, l, h, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(b, void 0, o, {
          ...n,
          ...a,
          interpolationkey: h
        }) : b;
      }
      const m = h.split(this.formatSeparator), f = m.shift().trim(), p = m.join(this.formatSeparator).trim();
      return this.format(Lh(a, l, f, this.options.keySeparator, this.options.ignoreJSONStructure), p, o, {
        ...n,
        ...a,
        interpolationkey: f
      });
    };
    this.resetRegExp();
    const u = n?.missingInterpolationHandler || this.options.missingInterpolationHandler, d = n?.interpolation?.skipOnVariables !== void 0 ? n.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (h) => jl(h)
    }, {
      regex: this.regexp,
      safeValue: (h) => this.escapeValue ? jl(this.escape(h)) : jl(h)
    }].forEach((h) => {
      for (s = 0; r = h.regex.exec(t); ) {
        const m = r[1].trim();
        if (i = c(m), i === void 0)
          if (typeof u == "function") {
            const p = u(t, r, n);
            i = se(p) ? p : "";
          } else if (n && Object.prototype.hasOwnProperty.call(n, m))
            i = "";
          else if (d) {
            i = r[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${m} for interpolating ${t}`), i = "";
        else !se(i) && !this.useRawValueToEscape && (i = Eh(i));
        const f = h.safeValue(i);
        if (t = t.replace(r[0], f), d ? (h.regex.lastIndex += i.length, h.regex.lastIndex -= r[0].length) : h.regex.lastIndex = 0, s++, s >= this.maxReplaces)
          break;
      }
    }), t;
  }
  nest(t, a, o = {}) {
    let n, r, i;
    const s = (l, c) => {
      const u = this.nestingOptionsSeparator;
      if (l.indexOf(u) < 0) return l;
      const d = l.split(new RegExp(`${u}[ ]*{`));
      let h = `{${d[1]}`;
      l = d[0], h = this.interpolate(h, i);
      const m = h.match(/'/g), f = h.match(/"/g);
      ((m?.length ?? 0) % 2 === 0 && !f || f.length % 2 !== 0) && (h = h.replace(/'/g, '"'));
      try {
        i = JSON.parse(h), c && (i = {
          ...c,
          ...i
        });
      } catch (p) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, p), `${l}${u}${h}`;
      }
      return i.defaultValue && i.defaultValue.indexOf(this.prefix) > -1 && delete i.defaultValue, l;
    };
    for (; n = this.nestingRegexp.exec(t); ) {
      let l = [];
      i = {
        ...o
      }, i = i.replace && !se(i.replace) ? i.replace : i, i.applyPostProcessor = !1, delete i.defaultValue;
      const c = /{.*}/.test(n[1]) ? n[1].lastIndexOf("}") + 1 : n[1].indexOf(this.formatSeparator);
      if (c !== -1 && (l = n[1].slice(c).split(this.formatSeparator).map((u) => u.trim()).filter(Boolean), n[1] = n[1].slice(0, c)), r = a(s.call(this, n[1].trim(), i), i), r && n[0] === t && !se(r)) return r;
      se(r) || (r = Eh(r)), r || (this.logger.warn(`missed to resolve ${n[1]} for nesting ${t}`), r = ""), l.length && (r = l.reduce((u, d) => this.format(u, d, o.lng, {
        ...o,
        interpolationkey: n[1].trim()
      }), r.trim())), t = t.replace(n[0], r), this.regexp.lastIndex = 0;
    }
    return t;
  }
};
const uN = (e) => {
  let t = e.toLowerCase().trim();
  const a = {};
  if (e.indexOf("(") > -1) {
    const o = e.split("(");
    t = o[0].toLowerCase().trim();
    const n = o[1].substring(0, o[1].length - 1);
    t === "currency" && n.indexOf(":") < 0 ? a.currency || (a.currency = n.trim()) : t === "relativetime" && n.indexOf(":") < 0 ? a.range || (a.range = n.trim()) : n.split(";").forEach((r) => {
      if (r) {
        const [i, ...s] = r.split(":"), l = s.join(":").trim().replace(/^'+|'+$/g, ""), c = i.trim();
        a[c] || (a[c] = l), l === "false" && (a[c] = !1), l === "true" && (a[c] = !0), isNaN(l) || (a[c] = parseInt(l, 10));
      }
    });
  }
  return {
    formatName: t,
    formatOptions: a
  };
}, Mh = (e) => {
  const t = {};
  return (a, o, n) => {
    let r = n;
    n && n.interpolationkey && n.formatParams && n.formatParams[n.interpolationkey] && n[n.interpolationkey] && (r = {
      ...r,
      [n.interpolationkey]: void 0
    });
    const i = o + JSON.stringify(r);
    let s = t[i];
    return s || (s = e(Tn(o), n), t[i] = s), s(a);
  };
}, dN = (e) => (t, a, o) => e(Tn(a), o)(t);
let gN = class {
  constructor(t = {}) {
    this.logger = Kt.create("formatter"), this.options = t, this.init(t);
  }
  init(t, a = {
    interpolation: {}
  }) {
    this.formatSeparator = a.interpolation.formatSeparator || ",";
    const o = a.cacheInBuiltFormats ? Mh : dN;
    this.formats = {
      number: o((n, r) => {
        const i = new Intl.NumberFormat(n, {
          ...r
        });
        return (s) => i.format(s);
      }),
      currency: o((n, r) => {
        const i = new Intl.NumberFormat(n, {
          ...r,
          style: "currency"
        });
        return (s) => i.format(s);
      }),
      datetime: o((n, r) => {
        const i = new Intl.DateTimeFormat(n, {
          ...r
        });
        return (s) => i.format(s);
      }),
      relativetime: o((n, r) => {
        const i = new Intl.RelativeTimeFormat(n, {
          ...r
        });
        return (s) => i.format(s, r.range || "day");
      }),
      list: o((n, r) => {
        const i = new Intl.ListFormat(n, {
          ...r
        });
        return (s) => i.format(s);
      })
    };
  }
  add(t, a) {
    this.formats[t.toLowerCase().trim()] = a;
  }
  addCached(t, a) {
    this.formats[t.toLowerCase().trim()] = Mh(a);
  }
  format(t, a, o, n = {}) {
    const r = a.split(this.formatSeparator);
    if (r.length > 1 && r[0].indexOf("(") > 1 && r[0].indexOf(")") < 0 && r.find((i) => i.indexOf(")") > -1)) {
      const i = r.findIndex((s) => s.indexOf(")") > -1);
      r[0] = [r[0], ...r.splice(1, i)].join(this.formatSeparator);
    }
    return r.reduce((i, s) => {
      const {
        formatName: l,
        formatOptions: c
      } = uN(s);
      if (this.formats[l]) {
        let u = i;
        try {
          const d = n?.formatParams?.[n.interpolationkey] || {}, h = d.locale || d.lng || n.locale || n.lng || o;
          u = this.formats[l](i, h, {
            ...c,
            ...n,
            ...d
          });
        } catch (d) {
          this.logger.warn(d);
        }
        return u;
      } else
        this.logger.warn(`there was no format function for ${l}`);
      return i;
    }, t);
  }
};
const hN = (e, t) => {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
};
let pN = class extends Os {
  constructor(t, a, o, n = {}) {
    super(), this.backend = t, this.store = a, this.services = o, this.languageUtils = o.languageUtils, this.options = n, this.logger = Kt.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = n.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = n.maxRetries >= 0 ? n.maxRetries : 5, this.retryTimeout = n.retryTimeout >= 1 ? n.retryTimeout : 350, this.state = {}, this.queue = [], this.backend?.init?.(o, n.backend, n);
  }
  queueLoad(t, a, o, n) {
    const r = {}, i = {}, s = {}, l = {};
    return t.forEach((c) => {
      let u = !0;
      a.forEach((d) => {
        const h = `${c}|${d}`;
        !o.reload && this.store.hasResourceBundle(c, d) ? this.state[h] = 2 : this.state[h] < 0 || (this.state[h] === 1 ? i[h] === void 0 && (i[h] = !0) : (this.state[h] = 1, u = !1, i[h] === void 0 && (i[h] = !0), r[h] === void 0 && (r[h] = !0), l[d] === void 0 && (l[d] = !0)));
      }), u || (s[c] = !0);
    }), (Object.keys(r).length || Object.keys(i).length) && this.queue.push({
      pending: i,
      pendingCount: Object.keys(i).length,
      loaded: {},
      errors: [],
      callback: n
    }), {
      toLoad: Object.keys(r),
      pending: Object.keys(i),
      toLoadLanguages: Object.keys(s),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(t, a, o) {
    const n = t.split("|"), r = n[0], i = n[1];
    a && this.emit("failedLoading", r, i, a), !a && o && this.store.addResourceBundle(r, i, o, void 0, void 0, {
      skipCopy: !0
    }), this.state[t] = a ? -1 : 2, a && o && (this.state[t] = 0);
    const s = {};
    this.queue.forEach((l) => {
      YD(l.loaded, [r], i), hN(l, t), a && l.errors.push(a), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((c) => {
        s[c] || (s[c] = {});
        const u = l.loaded[c];
        u.length && u.forEach((d) => {
          s[c][d] === void 0 && (s[c][d] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", s), this.queue = this.queue.filter((l) => !l.done);
  }
  read(t, a, o, n = 0, r = this.retryTimeout, i) {
    if (!t.length) return i(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: t,
        ns: a,
        fcName: o,
        tried: n,
        wait: r,
        callback: i
      });
      return;
    }
    this.readingCalls++;
    const s = (c, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const d = this.waitingReads.shift();
        this.read(d.lng, d.ns, d.fcName, d.tried, d.wait, d.callback);
      }
      if (c && u && n < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, t, a, o, n + 1, r * 2, i);
        }, r);
        return;
      }
      i(c, u);
    }, l = this.backend[o].bind(this.backend);
    if (l.length === 2) {
      try {
        const c = l(t, a);
        c && typeof c.then == "function" ? c.then((u) => s(null, u)).catch(s) : s(null, c);
      } catch (c) {
        s(c);
      }
      return;
    }
    return l(t, a, s);
  }
  prepareLoading(t, a, o = {}, n) {
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), n && n();
    se(t) && (t = this.languageUtils.toResolveHierarchy(t)), se(a) && (a = [a]);
    const r = this.queueLoad(t, a, o, n);
    if (!r.toLoad.length)
      return r.pending.length || n(), null;
    r.toLoad.forEach((i) => {
      this.loadOne(i);
    });
  }
  load(t, a, o) {
    this.prepareLoading(t, a, {}, o);
  }
  reload(t, a, o) {
    this.prepareLoading(t, a, {
      reload: !0
    }, o);
  }
  loadOne(t, a = "") {
    const o = t.split("|"), n = o[0], r = o[1];
    this.read(n, r, "read", void 0, void 0, (i, s) => {
      i && this.logger.warn(`${a}loading namespace ${r} for language ${n} failed`, i), !i && s && this.logger.log(`${a}loaded namespace ${r} for language ${n}`, s), this.loaded(t, i, s);
    });
  }
  saveMissing(t, a, o, n, r, i = {}, s = () => {
  }) {
    if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(a)) {
      this.logger.warn(`did not save key "${o}" as the namespace "${a}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(o == null || o === "")) {
      if (this.backend?.create) {
        const l = {
          ...i,
          isUpdate: r
        }, c = this.backend.create.bind(this.backend);
        if (c.length < 6)
          try {
            let u;
            c.length === 5 ? u = c(t, a, o, n, l) : u = c(t, a, o, n), u && typeof u.then == "function" ? u.then((d) => s(null, d)).catch(s) : s(null, u);
          } catch (u) {
            s(u);
          }
        else
          c(t, a, o, n, s, l);
      }
      !t || !t[0] || this.store.addResource(t[0], a, o, n);
    }
  }
};
const Wh = () => ({
  debug: !1,
  initAsync: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (e) => {
    let t = {};
    if (typeof e[1] == "object" && (t = e[1]), se(e[1]) && (t.defaultValue = e[1]), se(e[2]) && (t.tDescription = e[2]), typeof e[2] == "object" || typeof e[3] == "object") {
      const a = e[3] || e[2];
      Object.keys(a).forEach((o) => {
        t[o] = a[o];
      });
    }
    return t;
  },
  interpolation: {
    escapeValue: !0,
    format: (e) => e,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  },
  cacheInBuiltFormats: !0
}), Bh = (e) => (se(e.ns) && (e.ns = [e.ns]), se(e.fallbackLng) && (e.fallbackLng = [e.fallbackLng]), se(e.fallbackNS) && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs?.indexOf?.("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), typeof e.initImmediate == "boolean" && (e.initAsync = e.initImmediate), e), Nr = () => {
}, mN = (e) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((t) => {
    typeof e[t] == "function" && (e[t] = e[t].bind(e));
  });
};
class Ln extends Os {
  constructor(t = {}, a) {
    if (super(), this.options = Bh(t), this.services = {}, this.logger = Kt, this.modules = {
      external: []
    }, mN(this), a && !this.isInitialized && !t.isClone) {
      if (!this.options.initAsync)
        return this.init(t, a), this;
      setTimeout(() => {
        this.init(t, a);
      }, 0);
    }
  }
  init(t = {}, a) {
    this.isInitializing = !0, typeof t == "function" && (a = t, t = {}), t.defaultNS == null && t.ns && (se(t.ns) ? t.defaultNS = t.ns : t.ns.indexOf("translation") < 0 && (t.defaultNS = t.ns[0]));
    const o = Wh();
    this.options = {
      ...o,
      ...this.options,
      ...Bh(t)
    }, this.options.interpolation = {
      ...o.interpolation,
      ...this.options.interpolation
    }, t.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = t.keySeparator), t.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = t.nsSeparator);
    const n = (s) => s ? typeof s == "function" ? new s() : s : null;
    if (!this.options.isClone) {
      this.modules.logger ? Kt.init(n(this.modules.logger), this.options) : Kt.init(null, this.options);
      let s;
      this.modules.formatter ? s = this.modules.formatter : s = gN;
      const l = new Rh(this.options);
      this.store = new Ah(this.options.resources, this.options);
      const c = this.services;
      c.logger = Kt, c.resourceStore = this.store, c.languageUtils = l, c.pluralResolver = new lN(l, {
        prepend: this.options.pluralSeparator,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), this.options.interpolation.format && this.options.interpolation.format !== o.interpolation.format && this.logger.deprecate("init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting"), s && (!this.options.interpolation.format || this.options.interpolation.format === o.interpolation.format) && (c.formatter = n(s), c.formatter.init && c.formatter.init(c, this.options), this.options.interpolation.format = c.formatter.format.bind(c.formatter)), c.interpolator = new cN(this.options), c.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, c.backendConnector = new pN(n(this.modules.backend), c.resourceStore, c, this.options), c.backendConnector.on("*", (u, ...d) => {
        this.emit(u, ...d);
      }), this.modules.languageDetector && (c.languageDetector = n(this.modules.languageDetector), c.languageDetector.init && c.languageDetector.init(c, this.options.detection, this.options)), this.modules.i18nFormat && (c.i18nFormat = n(this.modules.i18nFormat), c.i18nFormat.init && c.i18nFormat.init(this)), this.translator = new Nh(this.services, this.options), this.translator.on("*", (u, ...d) => {
        this.emit(u, ...d);
      }), this.modules.external.forEach((u) => {
        u.init && u.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, a || (a = Nr), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const s = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      s.length > 0 && s[0] !== "dev" && (this.options.lng = s[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((s) => {
      this[s] = (...l) => this.store[s](...l);
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((s) => {
      this[s] = (...l) => (this.store[s](...l), this);
    });
    const r = vn(), i = () => {
      const s = (l, c) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), r.resolve(c), a(l, c);
      };
      if (this.languages && !this.isInitialized) return s(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, s);
    };
    return this.options.resources || !this.options.initAsync ? i() : setTimeout(i, 0), r;
  }
  loadResources(t, a = Nr) {
    let o = a;
    const n = se(t) ? t : this.language;
    if (typeof t == "function" && (o = t), !this.options.resources || this.options.partialBundledLanguages) {
      if (n?.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return o();
      const r = [], i = (s) => {
        !s || s === "cimode" || this.services.languageUtils.toResolveHierarchy(s).forEach((l) => {
          l !== "cimode" && r.indexOf(l) < 0 && r.push(l);
        });
      };
      n ? i(n) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((s) => i(s)), this.options.preload?.forEach?.((s) => i(s)), this.services.backendConnector.load(r, this.options.ns, (s) => {
        !s && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), o(s);
      });
    } else
      o(null);
  }
  reloadResources(t, a, o) {
    const n = vn();
    return typeof t == "function" && (o = t, t = void 0), typeof a == "function" && (o = a, a = void 0), t || (t = this.languages), a || (a = this.options.ns), o || (o = Nr), this.services.backendConnector.reload(t, a, (r) => {
      n.resolve(), o(r);
    }), n;
  }
  use(t) {
    if (!t) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!t.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return t.type === "backend" && (this.modules.backend = t), (t.type === "logger" || t.log && t.warn && t.error) && (this.modules.logger = t), t.type === "languageDetector" && (this.modules.languageDetector = t), t.type === "i18nFormat" && (this.modules.i18nFormat = t), t.type === "postProcessor" && py.addPostProcessor(t), t.type === "formatter" && (this.modules.formatter = t), t.type === "3rdParty" && this.modules.external.push(t), this;
  }
  setResolvedLanguage(t) {
    if (!(!t || !this.languages) && !(["cimode", "dev"].indexOf(t) > -1)) {
      for (let a = 0; a < this.languages.length; a++) {
        const o = this.languages[a];
        if (!(["cimode", "dev"].indexOf(o) > -1) && this.store.hasLanguageSomeTranslations(o)) {
          this.resolvedLanguage = o;
          break;
        }
      }
      !this.resolvedLanguage && this.languages.indexOf(t) < 0 && this.store.hasLanguageSomeTranslations(t) && (this.resolvedLanguage = t, this.languages.unshift(t));
    }
  }
  changeLanguage(t, a) {
    this.isLanguageChangingTo = t;
    const o = vn();
    this.emit("languageChanging", t);
    const n = (s) => {
      this.language = s, this.languages = this.services.languageUtils.toResolveHierarchy(s), this.resolvedLanguage = void 0, this.setResolvedLanguage(s);
    }, r = (s, l) => {
      l ? this.isLanguageChangingTo === t && (n(l), this.translator.changeLanguage(l), this.isLanguageChangingTo = void 0, this.emit("languageChanged", l), this.logger.log("languageChanged", l)) : this.isLanguageChangingTo = void 0, o.resolve((...c) => this.t(...c)), a && a(s, (...c) => this.t(...c));
    }, i = (s) => {
      !t && !s && this.services.languageDetector && (s = []);
      const l = se(s) ? s : s && s[0], c = this.store.hasLanguageSomeTranslations(l) ? l : this.services.languageUtils.getBestMatchFromCodes(se(s) ? [s] : s);
      c && (this.language || n(c), this.translator.language || this.translator.changeLanguage(c), this.services.languageDetector?.cacheUserLanguage?.(c)), this.loadResources(c, (u) => {
        r(u, c);
      });
    };
    return !t && this.services.languageDetector && !this.services.languageDetector.async ? i(this.services.languageDetector.detect()) : !t && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(i) : this.services.languageDetector.detect(i) : i(t), o;
  }
  getFixedT(t, a, o) {
    const n = (r, i, ...s) => {
      let l;
      typeof i != "object" ? l = this.options.overloadTranslationOptionHandler([r, i].concat(s)) : l = {
        ...i
      }, l.lng = l.lng || n.lng, l.lngs = l.lngs || n.lngs, l.ns = l.ns || n.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || o || n.keyPrefix);
      const c = this.options.keySeparator || ".";
      let u;
      return l.keyPrefix && Array.isArray(r) ? u = r.map((d) => (typeof d == "function" && (d = jc(d, {
        ...this.options,
        ...i
      })), `${l.keyPrefix}${c}${d}`)) : (typeof r == "function" && (r = jc(r, {
        ...this.options,
        ...i
      })), u = l.keyPrefix ? `${l.keyPrefix}${c}${r}` : r), this.t(u, l);
    };
    return se(t) ? n.lng = t : n.lngs = t, n.ns = a, n.keyPrefix = o, n;
  }
  t(...t) {
    return this.translator?.translate(...t);
  }
  exists(...t) {
    return this.translator?.exists(...t);
  }
  setDefaultNamespace(t) {
    this.options.defaultNS = t;
  }
  hasLoadedNamespace(t, a = {}) {
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const o = a.lng || this.resolvedLanguage || this.languages[0], n = this.options ? this.options.fallbackLng : !1, r = this.languages[this.languages.length - 1];
    if (o.toLowerCase() === "cimode") return !0;
    const i = (s, l) => {
      const c = this.services.backendConnector.state[`${s}|${l}`];
      return c === -1 || c === 0 || c === 2;
    };
    if (a.precheck) {
      const s = a.precheck(this, i);
      if (s !== void 0) return s;
    }
    return !!(this.hasResourceBundle(o, t) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || i(o, t) && (!n || i(r, t)));
  }
  loadNamespaces(t, a) {
    const o = vn();
    return this.options.ns ? (se(t) && (t = [t]), t.forEach((n) => {
      this.options.ns.indexOf(n) < 0 && this.options.ns.push(n);
    }), this.loadResources((n) => {
      o.resolve(), a && a(n);
    }), o) : (a && a(), Promise.resolve());
  }
  loadLanguages(t, a) {
    const o = vn();
    se(t) && (t = [t]);
    const n = this.options.preload || [], r = t.filter((i) => n.indexOf(i) < 0 && this.services.languageUtils.isSupportedCode(i));
    return r.length ? (this.options.preload = n.concat(r), this.loadResources((i) => {
      o.resolve(), a && a(i);
    }), o) : (a && a(), Promise.resolve());
  }
  dir(t) {
    if (t || (t = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language)), !t) return "rtl";
    try {
      const n = new Intl.Locale(t);
      if (n && n.getTextInfo) {
        const r = n.getTextInfo();
        if (r && r.direction) return r.direction;
      }
    } catch {
    }
    const a = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], o = this.services?.languageUtils || new Rh(Wh());
    return t.toLowerCase().indexOf("-latn") > 1 ? "ltr" : a.indexOf(o.getLanguagePartFromCode(t)) > -1 || t.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance(t = {}, a) {
    return new Ln(t, a);
  }
  cloneInstance(t = {}, a = Nr) {
    const o = t.forkResourceStore;
    o && delete t.forkResourceStore;
    const n = {
      ...this.options,
      ...t,
      isClone: !0
    }, r = new Ln(n);
    if ((t.debug !== void 0 || t.prefix !== void 0) && (r.logger = r.logger.clone(t)), ["store", "services", "language"].forEach((i) => {
      r[i] = this[i];
    }), r.services = {
      ...this.services
    }, r.services.utils = {
      hasLoadedNamespace: r.hasLoadedNamespace.bind(r)
    }, o) {
      const i = Object.keys(this.store.data).reduce((s, l) => (s[l] = {
        ...this.store.data[l]
      }, s[l] = Object.keys(s[l]).reduce((c, u) => (c[u] = {
        ...s[l][u]
      }, c), s[l]), s), {});
      r.store = new Ah(i, n), r.services.resourceStore = r.store;
    }
    return r.translator = new Nh(r.services, n), r.translator.on("*", (i, ...s) => {
      r.emit(i, ...s);
    }), r.init(n, a), r.translator.options = n, r.translator.backendConnector.services.utils = {
      hasLoadedNamespace: r.hasLoadedNamespace.bind(r)
    }, r;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const rt = Ln.createInstance();
rt.createInstance = Ln.createInstance;
const fN = rt.createInstance;
rt.dir;
rt.init;
rt.loadResources;
rt.reloadResources;
rt.use;
rt.changeLanguage;
rt.getFixedT;
rt.t;
rt.exists;
rt.setDefaultNamespace;
rt.hasLoadedNamespace;
rt.loadNamespaces;
rt.loadLanguages;
const bN = "Studio", _N = "{{count}} soveværelse", vN = "{{count}} soveværelser", yN = "", wN = "{{count}} seng", kN = "{{count}} senge", xN = "Voksne", $N = "Babyer", SN = "Din kalender er blevet opdateret.", CN = "En måned", EN = "Præcise datoer", jN = "Uge", ON = "", zN = "", AN = "", PN = "", DN = "To uger", NN = "Annuller", RN = "Børn", IN = "Datoer", TN = "Slet", LN = "Beskrivelse", MN = "Destination", WN = "Sådan!", BN = "Rediger", FN = "Enhver form for udveksling", VN = "Badekar", UN = "Grill", qN = "Cykel", HN = "Bil", GN = "Kat", KN = "By", JN = "På landet", ZN = "Opvaskemaskine", YN = "Hund", XN = "Tørretumbler", QN = "Elevator", eR = "Favoritboliger", tR = "Pejs/brændeovn", aR = "Lejlighed", oR = "Privat have", nR = "under {{max}} GP", rR = "fra {{min}} GP", iR = "Mellem {{min}} og {{max}} GP", sR = "Privat fitnessrum", lR = "Hus", cR = "En Ø", uR = "Isoleret", dR = "Jacuzzi", gR = "Søer", hR = "Collection-hjem", pR = "Bjerge", mR = "{{count}} badeværelser", fR = "Andre dyr", bR = "Klaver", _R = "Legeplads", vR = "Primære bolig", yR = "Gensifig udveksling", wR = "Omvendt søgning", kR = "Flod", xR = "Kystnær", $R = "Feriebolig", SR = "TV", CR = "Landsby", ER = "Wi-Fi", jR = "Filtre", OR = "Faste datoer", zR = "En måned i {{date}}", AR = "En weekend i {{date}}", PR = "En uge i {{date}}", DR = "To uger i {{date}}", NR = "Fleksible datoer", RR = "Gæster", IR = "boliger", TR = "Sidste minut", LR = "Lokation", MR = "Rediger", WR = "Navn", BR = "Næste", FR = "", VR = "", UR = "{{count}} voksne", qR = "", HR = "", GR = "{{count}} babyer", KR = "", JR = "", ZR = "{{count}} børn", YR = "", XR = "{{count}} gæst", QR = "{{count}} gæster", eI = "Telefonnummerets format er ikke gyldigt.", tI = "Modtag e-mailnotifikationer", aI = "Gem", oI = "Ingen lokationer fundet", nI = "Flere beskeder", rI = "Rejseliste", iI = "", sI = "valgfrit", lI = {
  "autocomplete.button": "Søg",
  "autocomplete.placeholder": "Hvor skal du hen ?",
  bedroomsNumbers_zero: bN,
  bedroomsNumbers_one: _N,
  bedroomsNumbers_other: vN,
  beds_zero: yN,
  beds_one: wN,
  beds_other: kN,
  "button.free-signup": "Tilmeld dig gratis",
  "button.validate": "Bekræft",
  "common.try-again": "Prøv igen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Må ikke overstige {{limit}} tegn",
  "error.reload": "Opdater siden",
  "error.return-homepage": "Tilbage til startsiden",
  "error.subtitle": "Denne side kan desværre ikke nås..",
  "error.title": "Der opstod en fejl på siden",
  "errors.unable_to_submit.subtitle": '"Din formular kunne desværre ikke \\nindsendes lige nu. Prøv igen \\nsenere."',
  "errors.unable_to_submit.title": "Ups, vi løb ind i et problem",
  "global.back": "Tilbage",
  "global.cancel": "Annuller",
  "global.collection.browsehomes": "Se boliger",
  "global.collection.contactus": "Kontakt os",
  "global.confirm": "Bekræft",
  "global.continue": "Fortsæt",
  "global.getStarted": "Kom godt i gang",
  "global.login": "Log ind",
  "global.select": "Vælg",
  global_adults: xN,
  global_babies: $N,
  global_calendarUpdated_toast: SN,
  global_calendar_aMonth: CN,
  global_calendar_exactDates: EN,
  global_calendar_oneWeek: jN,
  global_calendar_oneWeekend: ON,
  global_calendar_plusMinusDay_zero: zN,
  global_calendar_plusMinusDay_one: AN,
  global_calendar_plusMinusDay_other: PN,
  global_calendar_twoWeeks: DN,
  global_cancel: NN,
  global_children: RN,
  global_dates: IN,
  global_delete: TN,
  global_description: LN,
  global_destination: MN,
  global_done: WN,
  global_edit: BN,
  "global_filter_a-c": "Klimaanlæg",
  global_filter_available: FN,
  "global_filter_baby-bed": "Babysenge",
  "global_filter_baby-gear": "Babyudstyr",
  "global_filter_balcony-terrace": "Altan/terrasse",
  global_filter_bathtub: VN,
  global_filter_bbq: UN,
  global_filter_bicycle: qN,
  global_filter_car: HN,
  global_filter_cat: GN,
  "global_filter_children-welcome": "Børn velkomne",
  global_filter_cities: KN,
  "global_filter_cleaning-person": "Rengøringsperson",
  global_filter_countryside: JN,
  "global_filter_dedicated-workspace": "Arbejdsområde",
  "global_filter_disabled-access": "Handicapvenlig bolig",
  global_filter_dishwasher: ZN,
  global_filter_dog: YN,
  global_filter_dryer: XN,
  "global_filter_eco-level": "Kun bæredygtige boliger",
  "global_filter_electric-car-plug": "Stik til elbil",
  global_filter_elevator: QN,
  global_filter_favorite: eR,
  global_filter_fireplace: tR,
  global_filter_flat: aR,
  global_filter_garden: oR,
  "global_filter_guest-wanted": "GuestPoints bytte",
  global_filter_guestPointsMax: nR,
  global_filter_guestPointsMin: rR,
  global_filter_guestPointsMinMax: iR,
  global_filter_gym: sR,
  "global_filter_heating-system": "Varmeanlæg",
  "global_filter_high-speed-connexion": "Hurtigt internet",
  global_filter_home: lR,
  "global_filter_home-verified": "Godkendte boliger",
  global_filter_island: cR,
  global_filter_isolated: uR,
  global_filter_jacuzzi: dR,
  "global_filter_kids-toys": "Legetøj til børn",
  global_filter_lakes: gR,
  global_filter_luxury: hR,
  global_filter_mountains: pR,
  "global_filter_no-bed-up": "Ingen midlertidige senge",
  global_filter_numOfBathrooms: mR,
  global_filter_other: fR,
  "global_filter_parking-space": "Privat parkeringsplads",
  "global_filter_pets-welcome": "Kæledyr er velkomne",
  global_filter_piano: bR,
  global_filter_playground: _R,
  global_filter_primary: vR,
  "global_filter_public-transit-access": "Adgang til offentlig transport",
  global_filter_reciprocal: yR,
  "global_filter_response-rate-above-threshold": "Svarprocent ≥ Gennemsnitlig",
  global_filter_reverse: wR,
  global_filter_river: kR,
  global_filter_seaside: xR,
  global_filter_secondary: $R,
  "global_filter_secured-pool": "Sikret pool",
  "global_filter_smokers-welcome": "Rygere er velkomne",
  "global_filter_swimming-pool": "Pool",
  global_filter_tv: SR,
  global_filter_villages: CR,
  "global_filter_washing-machine": "Vaskemaskine",
  "global_filter_whole-unit": "Hele enheden",
  global_filter_wifi: ER,
  global_filters: jR,
  global_fixDates: OR,
  global_flexDates_aMonth: zR,
  global_flexDates_aWeekend: AR,
  global_flexDates_oneWeek: PR,
  global_flexDates_twoWeek: DR,
  global_flexibleDates: NR,
  global_guests: RR,
  global_homes: IR,
  global_lastMinute: TR,
  global_location: LR,
  global_modify: MR,
  global_name: WR,
  global_next: BR,
  global_numberOfAdults_zero: FR,
  global_numberOfAdults_one: VR,
  global_numberOfAdults_other: UR,
  global_numberOfBabies_zero: qR,
  global_numberOfBabies_one: HR,
  global_numberOfBabies_other: GR,
  global_numberOfChildren_zero: KR,
  global_numberOfChildren_one: JR,
  global_numberOfChildren_other: ZR,
  global_numberOfGuests_zero: YR,
  global_numberOfGuests_one: XR,
  global_numberOfGuests_other: QR,
  global_phoneNumber_notValid: eI,
  global_receiveEmailAlerts: tI,
  global_save: aI,
  global_searchBar_noLocationFound: oI,
  global_seeMore_link: nI,
  global_travelWishlist: rI,
  "modal.error-occured.content": "Vi beklager ulejligheden, men prøv \\nvenligst igen.",
  "modal.error-occured.title": "Åh nej, der er opstået en fejl!",
  no_result: iI,
  optional: sI,
  "privacy-policy": "Privatpolitik"
}, cI = "https://www.homeexchange.com/blog/", uI = "/p/general-terms-of-use", dI = "https://www.homeexchange.com/da/p/community-da", gI = "https://homeexchangehelp.zendesk.com/hc/en-us", hI = "", pI = "https://www.homeexchange.com/da/p/service-homeexchange-da", mI = "https://www.homeexchange.com/da/p/guestpoints-da", fI = "https://www.homeexchange.com/da/p/press-da", bI = "https://www.homeexchange.com/p/fortalt-af-medlemmerne", _I = "", vI = "", yI = "https://www.homeexchange.com/da/p/hvor-velkomsten-virkelig-begynder", wI = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/da/p/about-us-da",
  blog: cI,
  cgu: uI,
  community: dI,
  "contact-us": "https://www.homeexchange.com/da/kontakt-os-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: gI,
  forum: hI,
  guarantees: pI,
  guestpoints: mI,
  "happiness-team": "https://www.homeexchange.com/da/p/happiness-team-da",
  "how-it-works": "https://www.homeexchange.com/da/p/hvordan-virker-det",
  "join-us": "https://www.homeexchange.com/da/p/join-us-da",
  "legal-notice": "/p/juridiske-vilkaar",
  "mobile-app": "https://www.homeexchange.com/da/p/mobil-app",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: fI,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/da/p/subscription-homeexchange-da",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: bI,
  travelWishlist_faq_links: _I,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: vI,
  values: yI
}, kI = "Fornavn", xI = "Efternavn", $I = "Tilføj til din rejseliste", SI = "En opdateret rejseliste giver dig mulighed for at modtage flere anmodninger om gensidige boligbytninger.", CI = "Er du sikker på, at du vil slette {{fullAddress}}?", EI = "Dette er de filtre, du har valgt. Hvis du har skiftet mening, kan du slette nogle af dem nedenfor. Men hvis du gerne vil tilføje flere, skal du starte en ny søgning (selvom dette snart ændrer sig... vi giver dig besked)!", jI = "Dette kan være et land, by eller en hel region. Hvis du vælger en bred lokation, er dine resultater muligvis mindre nøjagtige.", OI = "Indtast et land, by eller region", zI = "Se ledige boliger", AI = "Når boliger med tilgængelighed matcher dine rejseplaner.", PI = "Tilføj til din rejseliste", DI = "{{fullAddress}} er blevet slettet fra din rejseliste.", NI = "Vælg dine ideelle rejsedatoer (fleksible eller faste).", RI = "Tilføj detaljer, der hjælper andre, som bruger den omvendte søgefunktion, med at se, hvorfor du er interesseret i deres lokation.", II = "Angiv, hvor mange personer der rejser sammen med dig under denne tur.", TI = "Hovsa! {{fullAddress}} kunne ikke gemmes til din rejseliste af en uventet årsag.", LI = "Fortæl os, hvornår og hvorhen du ønsker at rejse for at modtage bytteanmodninger og notifikationer, så snart passende boliger bliver tilgængelige. Vi gemmer dine søgninger i din rejseliste!", MI = "Er der andre rejseeventyr, du vil gå i gang med at planlægge?", WI = "<updateDates>Opdater dine datoer</updateDates> for at fortsætte med at modtage relevante e-mailnotifikationer eller <delete>slet denne destination</delete> fra din rejseliste, hvis du ikke længere overvejer den.", BI = "Disse datoer er i fortiden", FI = "{{fullAddress}} er blevet tilføjet til din rejseliste!", VI = "{{fullAddress}} er blevet opdateret.", UI = "Din søgning er gemt, og din kalender er blevet opdateret!", qI = "Din søgning er blevet gemt. Du finder den i din rejseliste.", HI = "Lær mere om rejselister", GI = {
  firstname: kI,
  lastname: xI,
  modal_travelWishlist_addNew_title: $I,
  modal_travelWishlist_delete_body: SI,
  modal_travelWishlist_delete_title: CI,
  modal_travelWishlist_filtersApplied_helper: EI,
  modal_travelWishlist_location_helper: jI,
  modal_travelWishlist_searchBar_placeholder: OI,
  page_travelWishlist_card_cta: zI,
  page_travelWishlist_card_emailAlerts_helper: AI,
  page_travelWishlist_cta: PI,
  page_travelWishlist_deleted_toast: DI,
  page_travelWishlist_edit_dates_helper: NI,
  page_travelWishlist_edit_description_helper: RI,
  page_travelWishlist_edit_guests_helper: II,
  page_travelWishlist_error_toast: TI,
  page_travelWishlist_none_body: LI,
  page_travelWishlist_none_subheader: MI,
  page_travelWishlist_pastDates_desc: WI,
  page_travelWishlist_pastDates_title: BI,
  page_travelWishlist_saved_toast: FI,
  page_travelWishlist_updated_toast: VI,
  search_travelWishlist_calendarUpdated_toast: UI,
  search_travelWishlist_saved_toast: qI,
  travelWishlist_faq: HI
}, KI = "Studio", JI = "{{count}} schlafzimmer", ZI = "{{count}} schlafzimmer", YI = "", XI = "{{count}} Bett", QI = "{{count}} Betten", eT = "Erwachsene", tT = "Babys", aT = "Ihr Kalender wurde aktualisiert.", oT = "Ein Monat", nT = "Genaue Daten", rT = "Eine Woche", iT = "Ein Wochenende", sT = "", lT = "{{count}} Tag", cT = "{{count}} Tage", uT = "Zwei Wochen", dT = "Abbrechen", gT = "Kinder", hT = "Daten", pT = "Löschen", mT = "Beschreibung", fT = "Reiseziel", bT = "Fertig!", _T = "Bearbeiten", vT = "Jede Tauschanfrage", yT = "Badewanne", wT = "Grill", kT = "Fahrrad", xT = "Auto", $T = "Katze", ST = "Stadt", CT = "Auf dem Land", ET = "Geschirrspüler", jT = "Hund", OT = "Trockner", zT = "Aufzug", AT = "Lieblingshäuser", PT = "Kamin", DT = "Apartment", NT = "Privater Garten", RT = "weniger als {{max}} GP", IT = "von {{min}} GP", TT = "Zwischen {{min}} und {{max}} GP", LT = "Privater Fitnessraum", MT = "Haus", WT = "Insel", BT = "Abgelegen", FT = "Whirlpool", VT = "See", UT = "Häuser der Collection", qT = "Berge", HT = "{{count}} Badezimmer", GT = "Andere Tiere", KT = "Klavier", JT = "Spielplatz", ZT = "Hauptwohnung", YT = "Gegenseitiger Austausch", XT = "Umgekehrte Suche", QT = "Fluss", eL = "An der Küste", tL = "Zweitwohnung", aL = "Fernseher", oL = "Dorf", nL = "WLAN", rL = "Filter", iL = "Feste Daten", sL = "Eine Woche im {{date}}", lL = "Ein Wochenende im {{date}}", cL = "Eine Woche im {{date}}", uL = "Zwei Wochen im {{date}}", dL = "Flexible Daten", gL = "Gäste", hL = "Unterkünfte", pL = "Last Minute", mL = "Ort", fL = "Ändern", bL = "Name", _L = "Weiter", vL = "", yL = "{{count}} Erwachsener", wL = "{{count}} Erwachsene", kL = "", xL = "{{count}} Baby", $L = "{{count}} Babys", SL = "", CL = "{{count}} Kind", EL = "{{count}} Kinder", jL = "", OL = "{{count}} Gast", zL = "{{count}} Gäste", AL = "Das Format der Telefonnummer ist ungültig.", PL = "Benachrichtigungen per E-Mail erhalten", DL = "Speichern", NL = "Kein Reiseziel gefunden", RL = "Mehr anzeigen", IL = "Reiseprojekte", TL = "", LL = "optional", ML = {
  "autocomplete.button": "Suchen",
  "autocomplete.placeholder": "Wo gehst du hin ?",
  bedroomsNumbers_zero: KI,
  bedroomsNumbers_one: JI,
  bedroomsNumbers_other: ZI,
  beds_zero: YI,
  beds_one: XI,
  beds_other: QI,
  "button.free-signup": "Kostenlos anmelden",
  "button.validate": "Bestätigen",
  "common.try-again": "Erneut versuchen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Darf {{limit}} Zeichen nicht überschreiten",
  "error.reload": "Aktualisieren Sie diese Seite",
  "error.return-homepage": "Zurück zur Startseite",
  "error.subtitle": "Leider ist diese Seite nicht erreichbar.",
  "error.title": "Es ist ein Fehler auf der Seite aufgetreten.",
  "errors.unable_to_submit.subtitle": "Leider konnte Ihr Formular im Moment nicht abgeschickt werden. Bitte versuchen Sie es später noch einmal.",
  "errors.unable_to_submit.title": "Hoppla, wir haben ein Problem",
  "global.back": "Zurück",
  "global.cancel": "Abbrechen",
  "global.collection.browsehomes": "Unterkünfte durchstöbern",
  "global.collection.contactus": "Kontaktieren Sie uns",
  "global.confirm": "Bestätigen",
  "global.continue": "Weiter",
  "global.getStarted": "Los geht's",
  "global.login": "Anmelden",
  "global.select": "Auswählen",
  global_adults: eT,
  global_babies: tT,
  global_calendarUpdated_toast: aT,
  global_calendar_aMonth: oT,
  global_calendar_exactDates: nT,
  global_calendar_oneWeek: rT,
  global_calendar_oneWeekend: iT,
  global_calendar_plusMinusDay_zero: sT,
  global_calendar_plusMinusDay_one: lT,
  global_calendar_plusMinusDay_other: cT,
  global_calendar_twoWeeks: uT,
  global_cancel: dT,
  global_children: gT,
  global_dates: hT,
  global_delete: pT,
  global_description: mT,
  global_destination: fT,
  global_done: bT,
  global_edit: _T,
  "global_filter_a-c": "Klimaanlage",
  global_filter_available: vT,
  "global_filter_baby-bed": "Babybetten",
  "global_filter_baby-gear": "Babyausstattung",
  "global_filter_balcony-terrace": "Balkon / Terrasse",
  global_filter_bathtub: yT,
  global_filter_bbq: wT,
  global_filter_bicycle: kT,
  global_filter_car: xT,
  global_filter_cat: $T,
  "global_filter_children-welcome": "Kinder willkommen",
  global_filter_cities: ST,
  "global_filter_cleaning-person": "Reinigungskraft",
  global_filter_countryside: CT,
  "global_filter_dedicated-workspace": "Spezieller Arbeitsbereich",
  "global_filter_disabled-access": "Barrierefreie Unterkunft",
  global_filter_dishwasher: ET,
  global_filter_dog: jT,
  global_filter_dryer: OT,
  "global_filter_eco-level": "Nur nachhaltige Häuser",
  "global_filter_electric-car-plug": "Steckdose für Elektroautos",
  global_filter_elevator: zT,
  global_filter_favorite: AT,
  global_filter_fireplace: PT,
  global_filter_flat: DT,
  global_filter_garden: NT,
  "global_filter_guest-wanted": "Austausch gegen GuestPoints",
  global_filter_guestPointsMax: RT,
  global_filter_guestPointsMin: IT,
  global_filter_guestPointsMinMax: TT,
  global_filter_gym: LT,
  "global_filter_heating-system": "Heizung",
  "global_filter_high-speed-connexion": "Hochgeschwindigkeitsverbindung",
  global_filter_home: MT,
  "global_filter_home-verified": "Verifizierte Unterkünfte",
  global_filter_island: WT,
  global_filter_isolated: BT,
  global_filter_jacuzzi: FT,
  "global_filter_kids-toys": "Kinderspielzeug",
  global_filter_lakes: VT,
  global_filter_luxury: UT,
  global_filter_mountains: qT,
  "global_filter_no-bed-up": "Keine Zustellbetten",
  global_filter_numOfBathrooms: HT,
  global_filter_other: GT,
  "global_filter_parking-space": "Privater Parkplatz",
  "global_filter_pets-welcome": "Haustiere willkommen",
  global_filter_piano: KT,
  global_filter_playground: JT,
  global_filter_primary: ZT,
  "global_filter_public-transit-access": "Zugang zu öffentlichen Verkehrsmitteln",
  global_filter_reciprocal: YT,
  "global_filter_response-rate-above-threshold": "Antwortrate ≥ Mittel",
  global_filter_reverse: XT,
  global_filter_river: QT,
  global_filter_seaside: eL,
  global_filter_secondary: tL,
  "global_filter_secured-pool": "Gesicherter Pool",
  "global_filter_smokers-welcome": "Rauchen erlaubt",
  "global_filter_swimming-pool": "Swimmingpool",
  global_filter_tv: aL,
  global_filter_villages: oL,
  "global_filter_washing-machine": "Waschmaschine",
  "global_filter_whole-unit": "Die ganze Wohnung",
  global_filter_wifi: nL,
  global_filters: rL,
  global_fixDates: iL,
  global_flexDates_aMonth: sL,
  global_flexDates_aWeekend: lL,
  global_flexDates_oneWeek: cL,
  global_flexDates_twoWeek: uL,
  global_flexibleDates: dL,
  global_guests: gL,
  global_homes: hL,
  global_lastMinute: pL,
  global_location: mL,
  global_modify: fL,
  global_name: bL,
  global_next: _L,
  global_numberOfAdults_zero: vL,
  global_numberOfAdults_one: yL,
  global_numberOfAdults_other: wL,
  global_numberOfBabies_zero: kL,
  global_numberOfBabies_one: xL,
  global_numberOfBabies_other: $L,
  global_numberOfChildren_zero: SL,
  global_numberOfChildren_one: CL,
  global_numberOfChildren_other: EL,
  global_numberOfGuests_zero: jL,
  global_numberOfGuests_one: OL,
  global_numberOfGuests_other: zL,
  global_phoneNumber_notValid: AL,
  global_receiveEmailAlerts: PL,
  global_save: DL,
  global_searchBar_noLocationFound: NL,
  global_seeMore_link: RL,
  global_travelWishlist: IL,
  "modal.error-occured.content": "Wir entschuldigen uns für die Unannehmlichkeiten, bitte versuchen Sie es noch einmal.",
  "modal.error-occured.title": "Oh nein, es ist ein Fehler aufgetreten!",
  no_result: TL,
  optional: LL,
  "privacy-policy": "Datenschutz"
}, WL = "https://www.homeexchange.com/de/blog/", BL = "/de/p/homeexchangenutzungsbedingungen", FL = "https://www.homeexchange.com/de/p/our-community-de", VL = "https://homeexchangehelp.zendesk.com/hc/de", UL = "", qL = "https://www.homeexchange.com/de/p/service-homeexchange-de", HL = "https://www.homeexchange.com/de/p/guestpoints-de", GL = "https://www.homeexchange.com/de/p/press-de", KL = "https://www.homeexchange.com/p/worte-homeexchanger", JL = "https://help.homeexchange.com/hc/de/articles/360000623717-Bevorzugte-Tausch-Destinationen", ZL = "", YL = "https://www.homeexchange.com/de/p/wo-die-begrubung-wirklich-beginnt", XL = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/de/p/about-us-de",
  blog: WL,
  cgu: BL,
  community: FL,
  "contact-us": "https://www.homeexchange.com/de/kontakt-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/HomeExchangeDE/",
  faq: VL,
  forum: UL,
  guarantees: qL,
  guestpoints: HL,
  "happiness-team": "https://www.homeexchange.com/de/p/happiness-team-de",
  "how-it-works": "https://www.homeexchange.com/de/p/so-funktioniert-es-de",
  "join-us": "https://www.homeexchange.com/de/p/join-us-de",
  "legal-notice": "/p/impressum",
  "mobile-app": "https://www.homeexchange.com/de/p/homeexchange-mobile-app",
  "our-team": "https://www.homeexchange.com/de/p/unser-team",
  press: GL,
  "privacy-policy": "/p/homeexchange-datenschutz",
  "subscription-cost": "https://www.homeexchange.com/de/p/subscription-homeexchange-de",
  "term-of-use": "/p/homeexchangenutzungsbedingungen",
  testimonials: KL,
  travelWishlist_faq_links: JL,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: ZL,
  values: YL
}, QL = "Vorname", eM = "Nachname", tM = "Zu den Reiseprojekten hinzufügen", aM = "Aktualisierte Reiseprojekte ermöglichen es Ihnen, mehr gegenseitige Tauschanfragen zu erhalten.", oM = "Sind Sie sicher, dass Sie {{fullAddress}} löschen möchten?", nM = "Dies sind die Filter, die Sie ausgewählt haben. Wenn Sie Ihre Meinung geändert haben, können Sie einige von ihnen löschen. Wenn Sie jedoch weitere Filter hinzufügen möchten, müssen Sie eine neue Suche starten (dies wird sich jedoch bald ändern... bleiben Sie dran)!", rM = "Dies kann ein Land, eine Stadt oder eine ganze Region sein. Wenn Sie einen großen Bereich auswählen, sind Ihre Ergebnisse möglicherweise weniger genau.", iM = "Geben Sie ein Land, eine Stadt oder eine Region ein", sM = "Verfügbare Häuser anzeigen", lM = "Falls Unterkünfte mit Verfügbarkeit mit Ihren Reiseplänen übereinstimmen.", cM = "Zu den Reiseprojekten hinzufügen", uM = "{{fullAddress}} wurde aus Ihren Reiseprojekten gelöscht.", dM = "Wählen Sie Ihre idealen Reisedaten (flexibel oder fest).", gM = "Fügen Sie Details hinzu, damit andere, die die Umgekehrte Suche verwenden, erkennen können, warum Sie an ihrem Standort interessiert sind.", hM = "Geben Sie an, wie viele Personen Sie auf dieser Reise begleiten werden.", pM = "Hoppla! {{fullAddress}} konnte aus einem unerwarteten Grund nicht in Ihren Reiseprojekten gespeichert werden.", mM = "Teilen Sie uns mit, wann und wohin Sie reisen möchten, um Tauschanfragen und Benachrichtigungen zu erhalten, sobald passende Häuser verfügbar sind. Wir speichern Ihre Suchanfragen in Ihren Reiseprojekten!", fM = "Gibt es Reisen, die Sie planen möchten?", bM = "<updateDates>Aktualisieren Sie Ihre Daten</updateDates>, um weiterhin relevante E-Mail-Benachrichtigungen zu erhalten oder <delete>löschen Sie dieses Reiseziel</delete> aus Ihren Reiseprojekten, wenn Sie es nicht mehr in Betracht ziehen.", _M = "Diese Daten liegen in der Vergangenheit", vM = "{{fullAddress}} wurde zu Ihren Reiseprojekten hinzugefügt!", yM = "{{fullAddress}} wurde erfolgreich aktualisiert.", wM = "Ihre Suche wurde gespeichert und Ihr Kalender aktualisiert!", kM = "Ihre Suche wurde gespeichert. Finden Sie sie in Ihren Reiseprojekten.", xM = "Erfahren Sie mehr über Reiseprojekte", $M = {
  firstname: QL,
  lastname: eM,
  modal_travelWishlist_addNew_title: tM,
  modal_travelWishlist_delete_body: aM,
  modal_travelWishlist_delete_title: oM,
  modal_travelWishlist_filtersApplied_helper: nM,
  modal_travelWishlist_location_helper: rM,
  modal_travelWishlist_searchBar_placeholder: iM,
  page_travelWishlist_card_cta: sM,
  page_travelWishlist_card_emailAlerts_helper: lM,
  page_travelWishlist_cta: cM,
  page_travelWishlist_deleted_toast: uM,
  page_travelWishlist_edit_dates_helper: dM,
  page_travelWishlist_edit_description_helper: gM,
  page_travelWishlist_edit_guests_helper: hM,
  page_travelWishlist_error_toast: pM,
  page_travelWishlist_none_body: mM,
  page_travelWishlist_none_subheader: fM,
  page_travelWishlist_pastDates_desc: bM,
  page_travelWishlist_pastDates_title: _M,
  page_travelWishlist_saved_toast: vM,
  page_travelWishlist_updated_toast: yM,
  search_travelWishlist_calendarUpdated_toast: wM,
  search_travelWishlist_saved_toast: kM,
  travelWishlist_faq: xM
}, SM = "Studio", CM = "{{count}} bedroom", EM = "{{count}} bedrooms", jM = "", OM = "{{count}} bed", zM = "{{count}} beds", AM = "Adults", PM = "Babies", DM = "Your calendar has been updated.", NM = "A month", RM = "Exact dates", IM = "One week", TM = "One weekend", LM = "", MM = "± {{count}} day", WM = "± {{count}} days", BM = "Two weeks", FM = "Cancel", VM = "Children", UM = "Dates", qM = "Delete", HM = "Description", GM = "Destination", KM = "Done!", JM = "Edit", ZM = "Any type of exchange", YM = "Bathtub", XM = "BBQ", QM = "Bicycle", eW = "Car", tW = "Cat", aW = "City", oW = "Countryside", nW = "Dishwasher", rW = "Dog", iW = "Dryer", sW = "Elevator", lW = "Favorite homes", cW = "Fireplace", uW = "Apartment", dW = "Private backyard", gW = "less than {{max}} GP", hW = "from {{min}} GP", pW = "Between {{min}} and {{max}} GP", mW = "Private gym", fW = "House", bW = "Island", _W = "Isolated", vW = "Jacuzzi", yW = "Lake", wW = "Collection homes", kW = "Mountain", xW = "{{count}} bathrooms", $W = "Other animals", SW = "Piano", CW = "Kid's playground", EW = "Primary", jW = "Reciprocal exchange", OW = "Reverse search", zW = "River", AW = "Coastal", PW = "Secondary", DW = "TV", NW = "Village", RW = "WiFi", IW = "Filters", TW = "Fixed dates", LW = "A month in {{date}}", MW = "A Week-end in {{date}}", WW = "One week in {{date}}", BW = "Two weeks in {{date}}", FW = "Flexible dates", VW = "Guests", UW = "homes", qW = "Last minute", HW = "Location", GW = "Modify", KW = "Name", JW = "Next", ZW = "", YW = "{{count}} adult", XW = "{{count}} adults", QW = "", e2 = "{{count}} baby", t2 = "{{count}} babies", a2 = "", o2 = "{{count}} child", n2 = "{{count}} children", r2 = "{{count}} guest", i2 = "{{count}} guest", s2 = "{{count}} guests", l2 = "The phone number format is not valid", c2 = "Receive email alerts", u2 = "Save", d2 = "No locations found", g2 = "See more", h2 = "Travel wishlist", p2 = "No result", m2 = "optional", f2 = {
  "autocomplete.button": "Search",
  "autocomplete.placeholder": "Where are you going ?",
  bedroomsNumbers_zero: SM,
  bedroomsNumbers_one: CM,
  bedroomsNumbers_other: EM,
  beds_zero: jM,
  beds_one: OM,
  beds_other: zM,
  "button.free-signup": "Sign up for free",
  "button.validate": "Validate",
  "common.try-again": "Try again",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Must not exceed {{limit}} characters",
  "error.reload": "Refresh this page",
  "error.return-homepage": "Return to home page",
  "error.subtitle": "Unfortunately this page can't be reached.",
  "error.title": "An error occurred on the page",
  "errors.unable_to_submit.subtitle": "Unfortunately your form couldn't be submitted right now. Please try again later.",
  "errors.unable_to_submit.title": "Oops, we've hit a problem",
  "global.back": "Back",
  "global.cancel": "Cancel",
  "global.collection.browsehomes": "Browse Homes",
  "global.collection.contactus": "Contact us",
  "global.confirm": "Confirm",
  "global.continue": "Continue",
  "global.getStarted": "Get started",
  "global.login": "Log in",
  "global.select": "Select",
  global_adults: AM,
  global_babies: PM,
  global_calendarUpdated_toast: DM,
  global_calendar_aMonth: NM,
  global_calendar_exactDates: RM,
  global_calendar_oneWeek: IM,
  global_calendar_oneWeekend: TM,
  global_calendar_plusMinusDay_zero: LM,
  global_calendar_plusMinusDay_one: MM,
  global_calendar_plusMinusDay_other: WM,
  global_calendar_twoWeeks: BM,
  global_cancel: FM,
  global_children: VM,
  global_dates: UM,
  global_delete: qM,
  global_description: HM,
  global_destination: GM,
  global_done: KM,
  global_edit: JM,
  "global_filter_a-c": "A/C",
  global_filter_available: ZM,
  "global_filter_baby-bed": "Baby cribs",
  "global_filter_baby-gear": "Baby gear",
  "global_filter_balcony-terrace": "Balcony/Terrace",
  global_filter_bathtub: YM,
  global_filter_bbq: XM,
  global_filter_bicycle: QM,
  global_filter_car: eW,
  global_filter_cat: tW,
  "global_filter_children-welcome": "Children welcome",
  global_filter_cities: aW,
  "global_filter_cleaning-person": "Cleaning person",
  global_filter_countryside: oW,
  "global_filter_dedicated-workspace": "Dedicated workspace",
  "global_filter_disabled-access": "Accessible home",
  global_filter_dishwasher: nW,
  global_filter_dog: rW,
  global_filter_dryer: iW,
  "global_filter_eco-level": "Only sustainable homes",
  "global_filter_electric-car-plug": "Electric car plug",
  global_filter_elevator: sW,
  global_filter_favorite: lW,
  global_filter_fireplace: cW,
  global_filter_flat: uW,
  global_filter_garden: dW,
  "global_filter_guest-wanted": "GuestPoints exchange",
  global_filter_guestPointsMax: gW,
  global_filter_guestPointsMin: hW,
  global_filter_guestPointsMinMax: pW,
  global_filter_gym: mW,
  "global_filter_heating-system": "Heating system",
  "global_filter_high-speed-connexion": "High speed connection",
  global_filter_home: fW,
  "global_filter_home-verified": "Verified homes",
  global_filter_island: bW,
  global_filter_isolated: _W,
  global_filter_jacuzzi: vW,
  "global_filter_kids-toys": "Kids toys",
  global_filter_lakes: yW,
  global_filter_luxury: wW,
  global_filter_mountains: kW,
  "global_filter_no-bed-up": "No temporary beds",
  global_filter_numOfBathrooms: xW,
  global_filter_other: $W,
  "global_filter_parking-space": "Private parking space",
  "global_filter_pets-welcome": "Pets welcome",
  global_filter_piano: SW,
  global_filter_playground: CW,
  global_filter_primary: EW,
  "global_filter_public-transit-access": "Public transport access",
  global_filter_reciprocal: jW,
  "global_filter_response-rate-above-threshold": "Response rate ≥ Average",
  global_filter_reverse: OW,
  global_filter_river: zW,
  global_filter_seaside: AW,
  global_filter_secondary: PW,
  "global_filter_secured-pool": "Secured pool",
  "global_filter_smokers-welcome": "Smokers welcome",
  "global_filter_swimming-pool": "Pool",
  global_filter_tv: DW,
  global_filter_villages: NW,
  "global_filter_washing-machine": "Washing machine",
  "global_filter_whole-unit": "Entire home",
  global_filter_wifi: RW,
  global_filters: IW,
  global_fixDates: TW,
  global_flexDates_aMonth: LW,
  global_flexDates_aWeekend: MW,
  global_flexDates_oneWeek: WW,
  global_flexDates_twoWeek: BW,
  global_flexibleDates: FW,
  global_guests: VW,
  global_homes: UW,
  global_lastMinute: qW,
  global_location: HW,
  global_modify: GW,
  global_name: KW,
  global_next: JW,
  global_numberOfAdults_zero: ZW,
  global_numberOfAdults_one: YW,
  global_numberOfAdults_other: XW,
  global_numberOfBabies_zero: QW,
  global_numberOfBabies_one: e2,
  global_numberOfBabies_other: t2,
  global_numberOfChildren_zero: a2,
  global_numberOfChildren_one: o2,
  global_numberOfChildren_other: n2,
  global_numberOfGuests_zero: r2,
  global_numberOfGuests_one: i2,
  global_numberOfGuests_other: s2,
  global_phoneNumber_notValid: l2,
  global_receiveEmailAlerts: c2,
  global_save: u2,
  global_searchBar_noLocationFound: d2,
  global_seeMore_link: g2,
  global_travelWishlist: h2,
  "modal.error-occured.content": "We're so sorry for the inconvenience, but please do try again.",
  "modal.error-occured.title": "Oh no, an error has occurred!",
  no_result: p2,
  optional: m2,
  "privacy-policy": "Privacy Policy"
}, b2 = "https://www.homeexchange.com/blog/", _2 = "/p/general-terms-of-use", v2 = "https://www.homeexchange.com/p/community", y2 = "https://homeexchangehelp.zendesk.com/hc/en-us", w2 = "https://forum.homeexchange.com/c/english/20", k2 = "https://www.homeexchange.com/p/service-homeexchange-en", x2 = "https://www.homeexchange.com/p/guestpoints-en", $2 = "https://www.homeexchange.com/p/press", S2 = "https://www.homeexchange.com/p/words-of-homeexchanges", C2 = "https://help.homeexchange.com/hc/en-us/articles/360000623717-What-are-My-Preferred-Destinations-and-how-do-I-use-them", E2 = "https://www.homeexchange.com/p/where-the-welcome-really-begins", j2 = "https://www.homeexchange.com/p/where-the-welcome-really-begins", O2 = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/p/about-us",
  blog: b2,
  cgu: _2,
  community: v2,
  "contact-us": "https://www.homeexchange.com/contact-us-homeexchange",
  "cookie-policy": "/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: y2,
  forum: w2,
  guarantees: k2,
  guestpoints: x2,
  "happiness-team": "https://www.homeexchange.com/p/happiness-team",
  "how-it-works": "https://www.homeexchange.com/p/how-it-works-en",
  "join-us": "https://www.homeexchange.com/p/join-us",
  "legal-notice": "/p/legal-notice",
  "mobile-app": "https://www.homeexchange.com/p/mobile-apps",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: $2,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/p/subscription-homeexchange",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: S2,
  travelWishlist_faq_links: C2,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: E2,
  values: j2
}, z2 = "First name", A2 = "Last name", P2 = "Add to your travel wishlist", D2 = "An updated travel wishlist will enable you to receive more reciprocal exchange requests.", N2 = "Are you sure you want to delete {{fullAddress}}?", R2 = "These are the filters you've selected. If you've changed your mind, you can delete some of them below. But if you'd like to add additional ones, you'll need to start a new search (though this will change soon... stay tuned)!", I2 = "This could be a country, city or a whole region. If you pick a broad location, your results might be less accurate.", T2 = "Type a country, city, or region", L2 = "View available homes", M2 = "When homes with availability match your travel plans.", W2 = "Add to your travel wishlist", B2 = "{{fullAddress}} has been deleted from your travel wishlist.", F2 = "Select your ideal travel dates (flexible or fixed).", V2 = "Add details to help others using the reverse search feature see why you’re interested in their location.", U2 = "Specify how many people will be traveling with you for this trip.", q2 = "Oops! {{fullAddress}} couldn't be saved to your travel wishlist for an unexpected reason.", H2 = "Let us know when and where you'd like to travel to receive exchange requests and alerts as soon as suitable homes become available. We'll save your searches to your travel wishlist!", G2 = "Any travel adventures you'd like to start planning?", K2 = "<updateDates>Update your dates</updateDates> to keep receiving relevant email alerts or <delete>delete this destination</delete> from your travel wishlist if you're no longer considering it.", J2 = "These dates are in the past", Z2 = "{{fullAddress}} has been added to your travel wishlist!", Y2 = "{{fullAddress}} has been successfully updated.", X2 = "Your search has been saved, and your calendar has been updated!", Q2 = "Your search has been saved. Find it in your travel wishlist.", eB = "Learn more about travel wishlists", tB = {
  firstname: z2,
  lastname: A2,
  modal_travelWishlist_addNew_title: P2,
  modal_travelWishlist_delete_body: D2,
  modal_travelWishlist_delete_title: N2,
  modal_travelWishlist_filtersApplied_helper: R2,
  modal_travelWishlist_location_helper: I2,
  modal_travelWishlist_searchBar_placeholder: T2,
  page_travelWishlist_card_cta: L2,
  page_travelWishlist_card_emailAlerts_helper: M2,
  page_travelWishlist_cta: W2,
  page_travelWishlist_deleted_toast: B2,
  page_travelWishlist_edit_dates_helper: F2,
  page_travelWishlist_edit_description_helper: V2,
  page_travelWishlist_edit_guests_helper: U2,
  page_travelWishlist_error_toast: q2,
  page_travelWishlist_none_body: H2,
  page_travelWishlist_none_subheader: G2,
  page_travelWishlist_pastDates_desc: K2,
  page_travelWishlist_pastDates_title: J2,
  page_travelWishlist_saved_toast: Z2,
  page_travelWishlist_updated_toast: Y2,
  search_travelWishlist_calendarUpdated_toast: X2,
  search_travelWishlist_saved_toast: Q2,
  travelWishlist_faq: eB
}, aB = "Estudio", oB = "{{count}} dormitorio", nB = "{{count}} dormitorios", rB = "", iB = "{{count}} cama", sB = "{{count}} camas", lB = "", cB = "", uB = "Tu calendario ha sido actualizado.", dB = "Un mes", gB = "Fechas exactas", hB = "Una semana", pB = "Un fin de semana", mB = "", fB = "± 1:{{count}} día", bB = "± 1:{{count}} días", _B = "Dos semanas", vB = "Cancelar", yB = "", wB = "Fechas", kB = "Eliminar", xB = "Descripción", $B = "Destino", SB = "¡Listo!", CB = "Editar", EB = "Cualquier tipo de intercambio", jB = "Bañera", OB = "Barbacoa", zB = "Bicicleta", AB = "Coche", PB = "Gato", DB = "Ciudad", NB = "Campo", RB = "Lavavajillas", IB = "Perro", TB = "Secadora", LB = "Ascensor", MB = "Casas favoritas", WB = "Chimenea", BB = "Piso", FB = "Patio privado", VB = "", UB = "", qB = "", HB = "", GB = "Casa", KB = "Isla", JB = "Aislado", ZB = "Jacuzzi", YB = "Lagos", XB = "Casas Collection", QB = "", eF = "{{count}} baños", tF = "Otros animales", aF = "Piano", oF = "Columpios", nF = "Principal", rF = "Intercambio recíproco", iF = "Búsqueda inversa", sF = "Río", lF = "En la costa", cF = "Secundaria", uF = "TV", dF = "Pueblo", gF = "WiFi", hF = "Filtros", pF = "Fechas fijas", mF = "Un mes en {{date}}", fF = "Un fin de semana en {{date}}", bF = "Una semana en {{date}}", _F = "Dos semanas en {{date}}", vF = "Fechas flexibles", yF = "Invitados", wF = "casas", kF = "Último minuto", xF = "Ubicación", $F = "Modificar", SF = "Nombre", CF = "Siguiente", EF = "", jF = "{{count}} adulto", OF = "{{count}} adultos", zF = "", AF = "{{count}} bebé", PF = "bebé", DF = "", NF = "{{count}} niño/a", RF = "{{count}} niños", IF = "", TF = "{{count}} invitado/a", LF = "{{count}} invitados", MF = "El formato del número de teléfono no es válido.", WF = "Recibir notificaciones por correo electrónico", BF = "Guardar", FF = "No encontramos este lugar", VF = "Ver más", UF = "Proyectos de viaje", qF = "", HF = "opcional", GF = {
  "autocomplete.button": "Buscar",
  "autocomplete.placeholder": "¿Adónde vas?",
  bedroomsNumbers_zero: aB,
  bedroomsNumbers_one: oB,
  bedroomsNumbers_other: nB,
  beds_zero: rB,
  beds_one: iB,
  beds_other: sB,
  "button.free-signup": "Regístrate gratis",
  "button.validate": "Validar",
  "common.try-again": "",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "No puedes superar los {{limit}} caracteres",
  "error.reload": "Actualizar esta página",
  "error.return-homepage": "Volver a la página de inicio",
  "error.subtitle": "Lo sentimos, pero no se puede acceder a esta página.",
  "error.title": "Se ha producido un error en la página",
  "errors.unable_to_submit.subtitle": "Lo sentimos, se ha producido un error al enviar el formulario. Por favor, vuelve a intentarlo más tarde.",
  "errors.unable_to_submit.title": "¡Vaya! Algo ha fallado.",
  "global.back": "",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "Continuar",
  "global.getStarted": "",
  "global.login": "Iniciar sesión",
  "global.select": "Selecciona",
  global_adults: lB,
  global_babies: cB,
  global_calendarUpdated_toast: uB,
  global_calendar_aMonth: dB,
  global_calendar_exactDates: gB,
  global_calendar_oneWeek: hB,
  global_calendar_oneWeekend: pB,
  global_calendar_plusMinusDay_zero: mB,
  global_calendar_plusMinusDay_one: fB,
  global_calendar_plusMinusDay_other: bB,
  global_calendar_twoWeeks: _B,
  global_cancel: vB,
  global_children: yB,
  global_dates: wB,
  global_delete: kB,
  global_description: xB,
  global_destination: $B,
  global_done: SB,
  global_edit: CB,
  "global_filter_a-c": "Aire acondicionado",
  global_filter_available: EB,
  "global_filter_baby-bed": "",
  "global_filter_baby-gear": "Equipamiento para bebés",
  "global_filter_balcony-terrace": "Balcón/Terraza",
  global_filter_bathtub: jB,
  global_filter_bbq: OB,
  global_filter_bicycle: zB,
  global_filter_car: AB,
  global_filter_cat: PB,
  "global_filter_children-welcome": "Niños bienvenidos",
  global_filter_cities: DB,
  "global_filter_cleaning-person": "Señor/a de la limpieza",
  global_filter_countryside: NB,
  "global_filter_dedicated-workspace": "Escritorio para trabajar",
  "global_filter_disabled-access": "Casas accesibles",
  global_filter_dishwasher: RB,
  global_filter_dog: IB,
  global_filter_dryer: TB,
  "global_filter_eco-level": "Solo viviendas sostenibles",
  "global_filter_electric-car-plug": "Enchufe para coches eléctricos",
  global_filter_elevator: LB,
  global_filter_favorite: MB,
  global_filter_fireplace: WB,
  global_filter_flat: BB,
  global_filter_garden: FB,
  "global_filter_guest-wanted": "Intercambio con GuestPoints",
  global_filter_guestPointsMax: VB,
  global_filter_guestPointsMin: UB,
  global_filter_guestPointsMinMax: qB,
  global_filter_gym: HB,
  "global_filter_heating-system": "Calefacción",
  "global_filter_high-speed-connexion": "Conexión de alta velocidad",
  global_filter_home: GB,
  "global_filter_home-verified": "Casas verificadas",
  global_filter_island: KB,
  global_filter_isolated: JB,
  global_filter_jacuzzi: ZB,
  "global_filter_kids-toys": "",
  global_filter_lakes: YB,
  global_filter_luxury: XB,
  global_filter_mountains: QB,
  "global_filter_no-bed-up": "Sin camas provisionales",
  global_filter_numOfBathrooms: eF,
  global_filter_other: tF,
  "global_filter_parking-space": "",
  "global_filter_pets-welcome": "Mascotas bienvenidas",
  global_filter_piano: aF,
  global_filter_playground: oF,
  global_filter_primary: nF,
  "global_filter_public-transit-access": "",
  global_filter_reciprocal: rF,
  "global_filter_response-rate-above-threshold": "",
  global_filter_reverse: iF,
  global_filter_river: sF,
  global_filter_seaside: lF,
  global_filter_secondary: cF,
  "global_filter_secured-pool": "Piscina segura",
  "global_filter_smokers-welcome": "Fumadores bienvenidos",
  "global_filter_swimming-pool": "Piscina",
  global_filter_tv: uF,
  global_filter_villages: dF,
  "global_filter_washing-machine": "Lavadora",
  "global_filter_whole-unit": "",
  global_filter_wifi: gF,
  global_filters: hF,
  global_fixDates: pF,
  global_flexDates_aMonth: mF,
  global_flexDates_aWeekend: fF,
  global_flexDates_oneWeek: bF,
  global_flexDates_twoWeek: _F,
  global_flexibleDates: vF,
  global_guests: yF,
  global_homes: wF,
  global_lastMinute: kF,
  global_location: xF,
  global_modify: $F,
  global_name: SF,
  global_next: CF,
  global_numberOfAdults_zero: EF,
  global_numberOfAdults_one: jF,
  global_numberOfAdults_other: OF,
  global_numberOfBabies_zero: zF,
  global_numberOfBabies_one: AF,
  global_numberOfBabies_other: PF,
  global_numberOfChildren_zero: DF,
  global_numberOfChildren_one: NF,
  global_numberOfChildren_other: RF,
  global_numberOfGuests_zero: IF,
  global_numberOfGuests_one: TF,
  global_numberOfGuests_other: LF,
  global_phoneNumber_notValid: MF,
  global_receiveEmailAlerts: WF,
  global_save: BF,
  global_searchBar_noLocationFound: FF,
  global_seeMore_link: VF,
  global_travelWishlist: UF,
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: qF,
  optional: HF,
  "privacy-policy": "Política de Privacidad"
}, KF = "https://www.homeexchange.com/es/blog/", JF = "/es/p/homeexchange-condiciones-de-uso", ZF = "https://www.homeexchange.com/es/p/nuestra-comunidad-es", YF = "https://homeexchangehelp.zendesk.com/hc/es", XF = "https://forum.homeexchange.com/c/espanol/22", QF = "https://www.homeexchange.com/es/p/service-homeexchange-es", eV = "https://www.homeexchange.com/es/p/los-guestpoints", tV = "https://www.homeexchange.com/es/p/prensa", aV = "https://www.homeexchange.com/p/palabra-de-homeexchanger", oV = "", nV = "https://www.homeexchange.com/es/p/principios-intercambio-casa", rV = "https://www.homeexchange.com/es/p/principios-intercambio-casa", iV = {
  "about-calendar": "https://help.homeexchange.com/hc/es/articles/360007584998-Todo-lo-que-necesitas-saber-sobre-el-calendario",
  "about-us": "https://www.homeexchange.com/es/p/about-us-es",
  blog: KF,
  cgu: JF,
  community: ZF,
  "contact-us": "https://www.homeexchange.com/es/contacto-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/HomeExchangeES/",
  faq: YF,
  forum: XF,
  guarantees: QF,
  guestpoints: eV,
  "happiness-team": "https://www.homeexchange.com/es/p/happiness-team-es",
  "how-it-works": "https://www.homeexchange.com/es/p/como-funciona-es",
  "join-us": "https://www.homeexchange.com/es/p/join-us-es",
  "legal-notice": "/p/menciones-legales",
  "mobile-app": "https://www.homeexchange.com/es/p/aplicacion-movil",
  "our-team": "https://www.homeexchange.com/es/p/nuestro-equipo",
  press: tV,
  "privacy-policy": "/p/homeexchange-politica-privacidad",
  "subscription-cost": "https://www.homeexchange.com/es/p/subscription-homeexchange-es",
  "term-of-use": "/p/homeexchange-condiciones-de-uso",
  testimonials: aV,
  travelWishlist_faq_links: oV,
  "twitter-page": "https://twitter.com/HomeExchangeES",
  value: nV,
  values: rV
}, sV = "", lV = "", cV = "Crear nuevo proyecto de viaje", uV = "Tener tus proyectos de viaje actualizados te permitirá recibir más solicitudes de intercambio recíproco.", dV = "¿Seguro que quieres eliminar {{fullAddress}}?", gV = "Estos son los filtros que has seleccionado. Si has cambiado de opinión, puedes eliminar algunos de ellos a continuación. Pero si quieres añadir otros, tendrás que iniciar una nueva búsqueda (aunque esto cambiará pronto... ¡tendrás noticias!)", hV = "Puede ser un país, una ciudad o una región entera. Si eliges una ubicación general, los resultados pueden ser menos precisos.", pV = "Introduce un país, ciudad o región", mV = "Ver casas disponibles", fV = "Cuando haya casas disponibles que coincidan con tus proyectos de viaje.", bV = "Crear nuevo proyecto de viaje", _V = "{{fullAddress}} se ha eliminado de tus proyectos de viaje.", vV = "Selecciona tus fechas ideales de viaje (flexibles o fijas).", yV = "Añade detalles para ayudar a otras personas que utilicen la función de búsqueda inversa a entender por qué te interesa su región.", wV = "Especifica cuántas personas viajarán contigo.", kV = "¡Vaya! {{fullAddress}} no se ha guardado en tus proyectos de viaje por un motivo desconocido.", xV = "Indícanos cuándo y dónde te gustaría viajar para recibir solicitudes de intercambio y notificaciones cuando haya casas disponibles. Guardaremos tus búsquedas en tus proyectos de viaje.", $V = "¿Te apetece empezar a planear alguna aventura?", SV = "<updateDates>Actualiza la fecha</updateDates> para seguir recibiendo notificaciones por correo electrónico o <delete>elimina este destino</delete>  de tus proyectos de viaje si ya no lo tienes en mente.", CV = "Esta fecha ya ha pasado", EV = "{{fullAddress}} se ha añadido a tus proyectos de viaje", jV = "{{fullAddress}} se ha actualizado correctamente.", OV = "¡Tu búsqueda se ha guardado y tu calendario se ha actualizado!", zV = "Tu búsqueda se ha guardado. Podrás verla en tus proyectos de viaje.", AV = "Saber más sobre los proyectos de viaje", PV = {
  firstname: sV,
  lastname: lV,
  modal_travelWishlist_addNew_title: cV,
  modal_travelWishlist_delete_body: uV,
  modal_travelWishlist_delete_title: dV,
  modal_travelWishlist_filtersApplied_helper: gV,
  modal_travelWishlist_location_helper: hV,
  modal_travelWishlist_searchBar_placeholder: pV,
  page_travelWishlist_card_cta: mV,
  page_travelWishlist_card_emailAlerts_helper: fV,
  page_travelWishlist_cta: bV,
  page_travelWishlist_deleted_toast: _V,
  page_travelWishlist_edit_dates_helper: vV,
  page_travelWishlist_edit_description_helper: yV,
  page_travelWishlist_edit_guests_helper: wV,
  page_travelWishlist_error_toast: kV,
  page_travelWishlist_none_body: xV,
  page_travelWishlist_none_subheader: $V,
  page_travelWishlist_pastDates_desc: SV,
  page_travelWishlist_pastDates_title: CV,
  page_travelWishlist_saved_toast: EV,
  page_travelWishlist_updated_toast: jV,
  search_travelWishlist_calendarUpdated_toast: OV,
  search_travelWishlist_saved_toast: zV,
  travelWishlist_faq: AV
}, DV = "Studio", NV = "{{count}} chambre", RV = "{{count}} chambres", IV = "", TV = "{{count}} lit", LV = "{{count}} lits", MV = "Adultes", WV = "Bébés", BV = "Votre calendrier a été mis à jour.", FV = "Un mois", VV = "Dates exactes", UV = "Une semaine", qV = "Un week-end", HV = "Vide", GV = "± {{count}} jour", KV = "± {{count}} jours", JV = "Deux semaines", ZV = "Annuler", YV = "Enfants", XV = "Dates", QV = "Supprimer", e3 = "Description", t3 = "Destination", a3 = "C'est prêt !", o3 = "Modifier", n3 = "Tout type d'échange", r3 = "Baignoire", i3 = "Barbecue", s3 = "Vélo", l3 = "Voiture", c3 = "Chat", u3 = "Ville", d3 = "Campagne", g3 = "Lave-vaisselle", h3 = "Chien", p3 = "Sèche linge", m3 = "Ascenseur", f3 = "Maisons favorites", b3 = "Cheminée", _3 = "Appartement", v3 = "Jardin privé", y3 = "moins de {{max}} GP", w3 = "à partir de {{min}} GP", k3 = "Entre {{min}} et {{max}} GP", x3 = "Salle de sport privée", $3 = "Maison", S3 = "Île", C3 = "Isolé", E3 = "Jacuzzi", j3 = "Lac", O3 = "Maisons Collection", z3 = "Montagne", A3 = "{{count}} salles de bain", P3 = "Autre", D3 = "Piano", N3 = "Aire de jeux", R3 = "Principale", I3 = "Échange réciproque", T3 = "Recherche inversée", L3 = "Rivière", M3 = "Bord de mer", W3 = "Secondaire", B3 = "TV", F3 = "Village", V3 = "WiFi", U3 = "Filtres", q3 = "Dates fixes", H3 = "Un mois en {{date}}", G3 = "Un week-end en {{date}}", K3 = "Une semaine en {{date}}", J3 = "Deux semaines en {{date}}", Z3 = "Dates flexibles", Y3 = "Personnes", X3 = "maisons", Q3 = "Dernière minute", e4 = "Lieu", t4 = "Modifier", a4 = "Titre", o4 = "Suivant", n4 = "Vide", r4 = "{{count}} adulte", i4 = "{{count}} adultes", s4 = "Vide", l4 = "{{count}} bébé", c4 = "{{count}} bébés", u4 = "Vide", d4 = "{{count}} enfant", g4 = "{{count}} enfants", h4 = "{{count}} personne", p4 = "{{count}} personne", m4 = "{{count}} personnes", f4 = "Le format du numéro de téléphone est invalide.", b4 = "Recevoir des alertes par email", _4 = "Enregistrer", v4 = "Aucun lieu trouvé", y4 = "Voir plus", w4 = "Projets de voyage", k4 = "", x4 = "facultatif", $4 = {
  "autocomplete.button": "Rechercher",
  "autocomplete.placeholder": "Où allez-vous ?",
  bedroomsNumbers_zero: DV,
  bedroomsNumbers_one: NV,
  bedroomsNumbers_other: RV,
  beds_zero: IV,
  beds_one: TV,
  beds_other: LV,
  "button.free-signup": "Inscrivez-vous gratuitement",
  "button.validate": "Valider",
  "common.try-again": "Compris !",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Ne doit pas dépasser {{limit}} caractères",
  "error.reload": "Actualiser la page",
  "error.return-homepage": "Retour à la page d'accueil",
  "error.subtitle": "Malheureusement, il y a un problème avec cette page.",
  "error.title": "Une erreur s'est produite sur la page",
  "errors.unable_to_submit.subtitle": "Malheureusement, votre réponse n'a pas pu être enregistrée. Merci de réessayer plus tard !",
  "errors.unable_to_submit.title": "Oups, on dirait bien qu'il y a un problème !",
  "global.back": "Retour",
  "global.cancel": "Annuler",
  "global.collection.browsehomes": "Découvrir les maisons",
  "global.collection.contactus": "Nous contacter",
  "global.confirm": "Confirmer",
  "global.continue": "Continuer",
  "global.getStarted": "Commencer",
  "global.login": "Se connecter",
  "global.select": "Sélectionner",
  global_adults: MV,
  global_babies: WV,
  global_calendarUpdated_toast: BV,
  global_calendar_aMonth: FV,
  global_calendar_exactDates: VV,
  global_calendar_oneWeek: UV,
  global_calendar_oneWeekend: qV,
  global_calendar_plusMinusDay_zero: HV,
  global_calendar_plusMinusDay_one: GV,
  global_calendar_plusMinusDay_other: KV,
  global_calendar_twoWeeks: JV,
  global_cancel: ZV,
  global_children: YV,
  global_dates: XV,
  global_delete: QV,
  global_description: e3,
  global_destination: t3,
  global_done: a3,
  global_edit: o3,
  "global_filter_a-c": "Air conditionné",
  global_filter_available: n3,
  "global_filter_baby-bed": "Lits bébé",
  "global_filter_baby-gear": "Équipements bébé",
  "global_filter_balcony-terrace": "Balcon / Terrasse",
  global_filter_bathtub: r3,
  global_filter_bbq: i3,
  global_filter_bicycle: s3,
  global_filter_car: l3,
  global_filter_cat: c3,
  "global_filter_children-welcome": "Les enfants sont les bienvenus",
  global_filter_cities: u3,
  "global_filter_cleaning-person": "Service de ménage",
  global_filter_countryside: d3,
  "global_filter_dedicated-workspace": "Espace de travail dédié",
  "global_filter_disabled-access": "Logement adapté",
  global_filter_dishwasher: g3,
  global_filter_dog: h3,
  global_filter_dryer: p3,
  "global_filter_eco-level": "Uniquement des maisons durables",
  "global_filter_electric-car-plug": "Prise pour voiture électrique",
  global_filter_elevator: m3,
  global_filter_favorite: f3,
  global_filter_fireplace: b3,
  global_filter_flat: _3,
  global_filter_garden: v3,
  "global_filter_guest-wanted": "Échange contre GuestPoints",
  global_filter_guestPointsMax: y3,
  global_filter_guestPointsMin: w3,
  global_filter_guestPointsMinMax: k3,
  global_filter_gym: x3,
  "global_filter_heating-system": "Chauffage",
  "global_filter_high-speed-connexion": "Connexion haut débit",
  global_filter_home: $3,
  "global_filter_home-verified": "Logements vérifiés",
  global_filter_island: S3,
  global_filter_isolated: C3,
  global_filter_jacuzzi: E3,
  "global_filter_kids-toys": "Jouets pour enfants",
  global_filter_lakes: j3,
  global_filter_luxury: O3,
  global_filter_mountains: z3,
  "global_filter_no-bed-up": "Pas de lit d'appoint",
  global_filter_numOfBathrooms: A3,
  global_filter_other: P3,
  "global_filter_parking-space": "Place de parking privé",
  "global_filter_pets-welcome": "Les animaux sont les bienvenus",
  global_filter_piano: D3,
  global_filter_playground: N3,
  global_filter_primary: R3,
  "global_filter_public-transit-access": "Accès aux transports publics",
  global_filter_reciprocal: I3,
  "global_filter_response-rate-above-threshold": "Réactivité ≥ Moyenne",
  global_filter_reverse: T3,
  global_filter_river: L3,
  global_filter_seaside: M3,
  global_filter_secondary: W3,
  "global_filter_secured-pool": "Piscine sécurisée",
  "global_filter_smokers-welcome": "Fumeurs bienvenus",
  "global_filter_swimming-pool": "Piscine",
  global_filter_tv: B3,
  global_filter_villages: F3,
  "global_filter_washing-machine": "Lave linge",
  "global_filter_whole-unit": "L'intégralité du logement",
  global_filter_wifi: V3,
  global_filters: U3,
  global_fixDates: q3,
  global_flexDates_aMonth: H3,
  global_flexDates_aWeekend: G3,
  global_flexDates_oneWeek: K3,
  global_flexDates_twoWeek: J3,
  global_flexibleDates: Z3,
  global_guests: Y3,
  global_homes: X3,
  global_lastMinute: Q3,
  global_location: e4,
  global_modify: t4,
  global_name: a4,
  global_next: o4,
  global_numberOfAdults_zero: n4,
  global_numberOfAdults_one: r4,
  global_numberOfAdults_other: i4,
  global_numberOfBabies_zero: s4,
  global_numberOfBabies_one: l4,
  global_numberOfBabies_other: c4,
  global_numberOfChildren_zero: u4,
  global_numberOfChildren_one: d4,
  global_numberOfChildren_other: g4,
  global_numberOfGuests_zero: h4,
  global_numberOfGuests_one: p4,
  global_numberOfGuests_other: m4,
  global_phoneNumber_notValid: f4,
  global_receiveEmailAlerts: b4,
  global_save: _4,
  global_searchBar_noLocationFound: v4,
  global_seeMore_link: y4,
  global_travelWishlist: w4,
  "modal.error-occured.content": "Toutes nos excuses : quelque chose ne s'est pas passé comme prévu, il va falloir que vous retentiez votre chance !",
  "modal.error-occured.title": "Une erreur s'est produite",
  no_result: k4,
  optional: x4,
  "privacy-policy": "Charte de vie privée"
}, S4 = "https://www.homeexchange.fr/blog/", C4 = "/p/conditions-generale-d-utilisation", E4 = "https://www.homeexchange.fr/p/communaute", j4 = "https://homeexchangehelp.zendesk.com/hc/fr", O4 = "https://forum.homeexchange.com/c/francais/21", z4 = "https://www.homeexchange.fr/p/service-homeexchange-fr", A4 = "https://www.homeexchange.fr/p/comment-fonctionnent-les-gp", P4 = "https://www.homeexchange.fr/p/presse", D4 = "https://www.homeexchange.com/p/paroles-homeexchangers", N4 = "https://help.homeexchange.com/hc/fr/articles/360000623717-Que-sont-Mes-destinations-pr%C3%A9f%C3%A9r%C3%A9es-et-comment-les-utiliser", R4 = "https://www.homeexchange.fr/p/les-fondamentaux ", I4 = "https://www.homeexchange.fr/p/les-fondamentaux", T4 = {
  "about-calendar": "https://help.homeexchange.com/hc/fr/articles/360007584998-Tout-ce-que-vous-devez-savoir-sur-le-calendrier",
  "about-us": "https://www.homeexchange.fr/p/qui-sommes-nous",
  blog: S4,
  cgu: C4,
  community: E4,
  "contact-us": "https://www.homeexchange.fr/contactez-nous-homeexchange",
  "cookie-policy": "/p/nos-cookies",
  "facebook-page": "https://www.facebook.com/HomeExchangeFR/",
  faq: j4,
  forum: O4,
  guarantees: z4,
  guestpoints: A4,
  "happiness-team": "https://www.homeexchange.fr/p/happiness-team-fr",
  "how-it-works": "https://www.homeexchange.fr/p/comment-ca-marche-fr",
  "join-us": "https://www.homeexchange.fr/p/recrutement",
  "legal-notice": "/p/mentions-legales",
  "mobile-app": "https://www.homeexchange.fr/p/applications-mobile",
  "our-team": "https://www.homeexchange.fr/p/notre-equipe",
  press: P4,
  "privacy-policy": "/p/charte-vie-privee",
  "subscription-cost": "https://www.homeexchange.fr/p/subscription-homeexchange-fr",
  "term-of-use": "/p/conditions-generale-d-utilisation",
  testimonials: D4,
  travelWishlist_faq_links: N4,
  "twitter-page": "https://twitter.com/HomeExchangeFR",
  value: R4,
  values: I4
}, L4 = "Prénom", M4 = "Nom", W4 = "Ajouter un projet de voyage", B4 = "Garder vos projets de voyage à jour vous permet de recevoir davantage de demandes d'échange réciproques.", F4 = "Voulez-vous vraiment supprimer {{fullAddress}} ?", V4 = "Ce sont les filtres que vous avez sélectionnés lors de votre recherche enregistrée : vous pouvez en supprimer mais si vous souhaitez en ajouter, vous devrez lancer une nouvelle recherche (mais plus pour très longtemps... on vous tiendra au courant !).", U4 = "Vous pouvez indiquer un pays, une région ou une ville. Si vous visez large, les résultats seront peut-être moins précis.", q4 = "Entrez un pays, une ville ou une région", H4 = "Voir les maisons disponibles", G4 = "Lorsque des logements correspondant à vos critères ont de nouvelles disponibilités", K4 = "Ajouter un projet de voyage", J4 = "Nous avons bien supprimé {{fullAddress}} de vos projets de voyage.", Z4 = "Indiquez vos dates de voyage estimées (qu'elles soient flexibles ou fixes).", Y4 = "Ajoutez des détails pour aider les membres utilisant la recherche inversée à savoir ce qui vous intéresse dans leur région.", X4 = "Indiquez combien de personnes voyageront avec vous cette fois-ci.", Q4 = "Oups ! Pour une raison inattendue, nous n'avons pas pu ajouter {{fullAddress}} à vos projets de voyage.", eU = "Indiquez où et quand vous aimeriez partir pour recevoir des demandes d'échange adaptées ainsi que des alertes dès que des logements correspondent à vos critères. Chaque recherche sera enregistrée dans vos projets de voyage.", tU = "Des envies de voyage en tête ?", aU = "<updateDates>Mettez à jour vos dates</updateDates> pour continuer à recevoir des alertes email pertinentes ou <delete>supprimez cette destination</delete> de vos projets de voyage si elle n'est plus d'actualité.", oU = "Ces dates sont passées", nU = "Nous avons bien ajouté {{fullAddress}} à vos projets de voyage.", rU = "Nous avons bien mis à jour les informations pour {{fullAddress}}", iU = "Votre recherche a bien été enregistrée et votre calendrier a été mis à jour.", sU = "Votre recherche a bien été enregistrée. Retrouvez-la dans vos projets de voyage.", lU = "En savoir plus sur les projets de voyage", cU = {
  firstname: L4,
  lastname: M4,
  modal_travelWishlist_addNew_title: W4,
  modal_travelWishlist_delete_body: B4,
  modal_travelWishlist_delete_title: F4,
  modal_travelWishlist_filtersApplied_helper: V4,
  modal_travelWishlist_location_helper: U4,
  modal_travelWishlist_searchBar_placeholder: q4,
  page_travelWishlist_card_cta: H4,
  page_travelWishlist_card_emailAlerts_helper: G4,
  page_travelWishlist_cta: K4,
  page_travelWishlist_deleted_toast: J4,
  page_travelWishlist_edit_dates_helper: Z4,
  page_travelWishlist_edit_description_helper: Y4,
  page_travelWishlist_edit_guests_helper: X4,
  page_travelWishlist_error_toast: Q4,
  page_travelWishlist_none_body: eU,
  page_travelWishlist_none_subheader: tU,
  page_travelWishlist_pastDates_desc: aU,
  page_travelWishlist_pastDates_title: oU,
  page_travelWishlist_saved_toast: nU,
  page_travelWishlist_updated_toast: rU,
  search_travelWishlist_calendarUpdated_toast: iU,
  search_travelWishlist_saved_toast: sU,
  travelWishlist_faq: lU
}, uU = "Studio", dU = "{{count}} soba", gU = "{{count}} sobe", hU = "{{count}} sobe", pU = "", mU = "{{count}} krevet", fU = "{{count}} kreveti", bU = "{{count}} kreveti", _U = "Odrasle osobe", vU = "Bebe", yU = "Vaš je kalendar ažuriran.", wU = "Mjesec", kU = "Točni datumi", xU = "Jedan tjedan", $U = "Jedan vikend", SU = "dana", CU = "dan", EU = "dana", jU = "± {{count}} dan", OU = "Dva tjedna", zU = "Odustani", AU = "Djeca", PU = "Datumi", DU = "Izbrišite", NU = "Opis", RU = "Odredište", IU = "Gotovo!", TU = "Uredite", LU = "Sve vrste zamjene", MU = "Kada", WU = "Roštilj", BU = "Bicikl", FU = "Automobil", VU = "Mačka", UU = "Grad", qU = "Ruralno", HU = "Perilica suđa", GU = "Pas", KU = "Sušilica", JU = "Dizalo", ZU = "Favoriti", YU = "Kamin", XU = "Stan", QU = "Privatno dvorište", eq = "manje od {{max}} GP", tq = "od {{min}} GP", aq = "Između {{min}} i {{max}} GP", oq = "Privatna teretana", nq = "Kuća", rq = "Otok", iq = "Izoliran", sq = "Jacuzzi", lq = "Jezera", cq = "Domove iz Collectiona", uq = "Planine", dq = "broj kupanica: %{count}", gq = "Ostale životinje", hq = "Glasovir", pq = "Dječje igralište", mq = "Moj dom", fq = "Recipročna zamjena", bq = "Obrnuta pretraga", _q = "Rijeka", vq = "Na obali", yq = "Drugi", wq = "TV", kq = "Selo", xq = "WiFi", $q = "Filtri", Sq = "Fiksni datumi", Cq = "{{date}}: jedan mjesec", Eq = "{{date}}: jedan vikend", jq = "{{date}}: jedan tjedan", Oq = "{{date}}: dva tjedna", zq = "Fleksibilni datumi", Aq = "Gosti", Pq = "domova", Dq = "U zadnji tren", Nq = "Lokacija", Rq = "Uredi", Iq = "", Tq = "Dalje", Lq = "odraslih osoba", Mq = "odrasla osoba", Wq = "odrasle osobe", Bq = "odraslih osoba", Fq = "beba", Vq = "beba", Uq = "bebe", qq = "beba", Hq = "djece", Gq = "dijete", Kq = "djeteta", Jq = "djece", Zq = "gostiju", Yq = "gost", Xq = "gosta", Qq = "gostiju", eH = "Format telefonskog broja nije valjan.", tH = "Primajte obavijesti e-poštom", aH = "Spremi", oH = "Nema pronađenih lokacija", nH = "Saznajte više", rH = "Planovi putovanja", iH = "", sH = "nije obavezno", lH = {
  "autocomplete.button": "Pretražite",
  "autocomplete.placeholder": "Gdje ideš ?",
  bedroomsNumbers_zero: uU,
  bedroomsNumbers_one: dU,
  bedroomsNumbers_few: gU,
  bedroomsNumbers_other: hU,
  beds_zero: pU,
  beds_one: mU,
  beds_few: fU,
  beds_other: bU,
  "button.free-signup": "Prijavite se besplatno",
  "button.validate": "Potvrdite",
  "common.try-again": "Pokušajte ponovno",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Ne smije biti dulje od {{limit}} znakova",
  "error.reload": "Osvježite stranicu",
  "error.return-homepage": "Vratite se na početnu stranicu",
  "error.subtitle": "Nažalost ne može se pristupiti ovoj stranici.",
  "error.title": "Došlo je do greške na stranici.",
  "errors.unable_to_submit.subtitle": "Nažalost, Vaš obrazac trenutačno ne može biti predan. Molimo da kasnije pokušate ponovno.",
  "errors.unable_to_submit.title": "Ups, imamo problem",
  "global.back": "Natrag",
  "global.cancel": "Odustani",
  "global.collection.browsehomes": "Pretražujte domove",
  "global.collection.contactus": "Kontaktirajte nas",
  "global.confirm": "Potvrdi",
  "global.continue": "Nastavite",
  "global.getStarted": "Započnite",
  "global.login": "Prijava",
  "global.select": "Odaberi",
  global_adults: _U,
  global_babies: vU,
  global_calendarUpdated_toast: yU,
  global_calendar_aMonth: wU,
  global_calendar_exactDates: kU,
  global_calendar_oneWeek: xU,
  global_calendar_oneWeekend: $U,
  global_calendar_plusMinusDay_zero: SU,
  global_calendar_plusMinusDay_one: CU,
  global_calendar_plusMinusDay_few: EU,
  global_calendar_plusMinusDay_other: jU,
  global_calendar_twoWeeks: OU,
  global_cancel: zU,
  global_children: AU,
  global_dates: PU,
  global_delete: DU,
  global_description: NU,
  global_destination: RU,
  global_done: IU,
  global_edit: TU,
  "global_filter_a-c": "Klima uređaj",
  global_filter_available: LU,
  "global_filter_baby-bed": "Kreveti za bebe",
  "global_filter_baby-gear": "Oprema za bebe",
  "global_filter_balcony-terrace": "Balkon/terasa",
  global_filter_bathtub: MU,
  global_filter_bbq: WU,
  global_filter_bicycle: BU,
  global_filter_car: FU,
  global_filter_cat: VU,
  "global_filter_children-welcome": "Djeca su dobrodošla",
  global_filter_cities: UU,
  "global_filter_cleaning-person": "Čistačica",
  global_filter_countryside: qU,
  "global_filter_dedicated-workspace": "Zaseban radni prostor",
  "global_filter_disabled-access": "Pristupačan dom",
  global_filter_dishwasher: HU,
  global_filter_dog: GU,
  global_filter_dryer: KU,
  "global_filter_eco-level": "Samo održivi domovi",
  "global_filter_electric-car-plug": "Utikač za električni automobil",
  global_filter_elevator: JU,
  global_filter_favorite: ZU,
  global_filter_fireplace: YU,
  global_filter_flat: XU,
  global_filter_garden: QU,
  "global_filter_guest-wanted": "Zamjena sa GuestPoints bodovima",
  global_filter_guestPointsMax: eq,
  global_filter_guestPointsMin: tq,
  global_filter_guestPointsMinMax: aq,
  global_filter_gym: oq,
  "global_filter_heating-system": "Sustav grijanja",
  "global_filter_high-speed-connexion": "Velika brzina veze",
  global_filter_home: nq,
  "global_filter_home-verified": "Provjereni domovi ",
  global_filter_island: rq,
  global_filter_isolated: iq,
  global_filter_jacuzzi: sq,
  "global_filter_kids-toys": "Dječje igračke",
  global_filter_lakes: lq,
  global_filter_luxury: cq,
  global_filter_mountains: uq,
  "global_filter_no-bed-up": "Nema privremenih kreveta",
  global_filter_numOfBathrooms: dq,
  global_filter_other: gq,
  "global_filter_parking-space": "Privatno parkirno mjesto",
  "global_filter_pets-welcome": "Kućni ljubimci su dobrodošli",
  global_filter_piano: hq,
  global_filter_playground: pq,
  global_filter_primary: mq,
  "global_filter_public-transit-access": "Pristup javnim prijevozom",
  global_filter_reciprocal: fq,
  "global_filter_response-rate-above-threshold": "Stopa odgovora ≥ Prosječno",
  global_filter_reverse: bq,
  global_filter_river: _q,
  global_filter_seaside: vq,
  global_filter_secondary: yq,
  "global_filter_secured-pool": "Osiguran bazen",
  "global_filter_smokers-welcome": "Dozvoljeno pušenje",
  "global_filter_swimming-pool": "Bazen",
  global_filter_tv: wq,
  global_filter_villages: kq,
  "global_filter_washing-machine": "Perilica rublja",
  "global_filter_whole-unit": "Cijela jedinica",
  global_filter_wifi: xq,
  global_filters: $q,
  global_fixDates: Sq,
  global_flexDates_aMonth: Cq,
  global_flexDates_aWeekend: Eq,
  global_flexDates_oneWeek: jq,
  global_flexDates_twoWeek: Oq,
  global_flexibleDates: zq,
  global_guests: Aq,
  global_homes: Pq,
  global_lastMinute: Dq,
  global_location: Nq,
  global_modify: Rq,
  global_name: Iq,
  global_next: Tq,
  global_numberOfAdults_zero: Lq,
  global_numberOfAdults_one: Mq,
  global_numberOfAdults_few: Wq,
  global_numberOfAdults_other: Bq,
  global_numberOfBabies_zero: Fq,
  global_numberOfBabies_one: Vq,
  global_numberOfBabies_few: Uq,
  global_numberOfBabies_other: qq,
  global_numberOfChildren_zero: Hq,
  global_numberOfChildren_one: Gq,
  global_numberOfChildren_few: Kq,
  global_numberOfChildren_other: Jq,
  global_numberOfGuests_zero: Zq,
  global_numberOfGuests_one: Yq,
  global_numberOfGuests_few: Xq,
  global_numberOfGuests_other: Qq,
  global_phoneNumber_notValid: eH,
  global_receiveEmailAlerts: tH,
  global_save: aH,
  global_searchBar_noLocationFound: oH,
  global_seeMore_link: nH,
  global_travelWishlist: rH,
  "modal.error-occured.content": "Žao nam je zbog neugodnosti, ali pokušajte ponovno.",
  "modal.error-occured.title": "Došlo je do pogreške.",
  no_result: iH,
  optional: sH,
  "privacy-policy": "Pravila o privatnosti"
}, cH = "https://www.homeexchange.com/blog/", uH = "/p/general-terms-of-use", dH = "https://www.homeexchange.com/hr/p/zajednica", gH = "https://homeexchangehelp.zendesk.com/hc/en-us", hH = "", pH = "https://www.homeexchange.com/hr/p/service-homeexchange-hr", mH = "https://www.homeexchange.com/hr/p/guestpoints-hr", fH = "https://www.homeexchange.com/hr/p/press-hr", bH = "https://www.homeexchange.com/p/rijeci-homeexchange", _H = "", vH = "https://www.homeexchange.com/hr/p/gdje-dobrodoslica-stvarno-pocinje", yH = "https://www.homeexchange.com/hr/p/gdje-dobrodoslica-stvarno-pocinje", wH = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/hr/p/about-us-hr",
  blog: cH,
  cgu: uH,
  community: dH,
  "contact-us": "https://www.homeexchange.com/hr/kontaktirajte-nas-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: gH,
  forum: hH,
  guarantees: pH,
  guestpoints: mH,
  "happiness-team": "https://www.homeexchange.com/hr/p/happiness-team-hr",
  "how-it-works": "https://www.homeexchange.com/hr/p/kako-to-funkcionira-hr",
  "join-us": "https://www.homeexchange.com/hr/p/join-us-hr",
  "legal-notice": "/p/pravna-napomena",
  "mobile-app": "https://www.homeexchange.com/hr/p/mobilna-aplikacija",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: fH,
  "privacy-policy": "/p/privacy-policy-hr",
  "subscription-cost": "https://www.homeexchange.com/hr/p/subscription-homeexchange-hr",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: bH,
  travelWishlist_faq_links: _H,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: vH,
  values: yH
}, kH = "Ime", xH = "Prezime", $H = "Dodajte u svoje planove putovanja", SH = "Ažurirani planovi putovanja će Vam omogućiti da dobivate više zahtjeva za recipročne zamjene.", CH = "Jeste li sigurni da želite obrisati lokaciju {{fullAddress}}?", EH = "Ovo su filtri koji ste odabrali. Ako ste se predomislili, možete obrisati neke od njih. Ali ako želite dodati neke druge, morate započeti novo pretraživanje (iako će se ovo uskoro promijeniti... pratite obavijesti)!", jH = "Ovo može biti neka zemlja, grad ili cijela regija. Ako odaberete jako široku lokaciju, Vaši bi rezultati mogli biti manje točni.", OH = "Upišite zemlju, grad ili regiju", zH = "Pogledajte dostupne domove", AH = "Kada domovi s dostupnošću odgovaraju Vašim planovima putovanja.", PH = "Izradite novi plan putovanja", DH = "Lokacija {{fullAddress}} je obrisana iz Vaših planova putovanja.", NH = "Odaberite svoje idealne datume putovanja (fleksibilne ili fiksne).", RH = "Dodajte detalje kako biste pomogli drugima koji koriste značajku obrnutog pretraživanja da vide zašto Vas zanima njihova lokacija.", IH = "Navedite koliko će ljudi putovati s Vama na ovom putovanju.", TH = "Ups! Lokacija {{fullAddress}} nije mogla biti spremljena u Vaše planove putovanja zbog neočekivanog razloga.", LH = "Recite nam kada i kamo biste željeli otputovati kako biste dobivali zahtjeve za zamjene i obavijesti čim odgovarajući domovi postanu dostupni. Spremit ćemo Vaše pretraživanje u Vaše planove putovanja!", MH = "Postoje li neke pustolovine za putovanja koje biste voljeli početi planirati?", WH = "<updateDates>Ažurirajte svoje datume</updateDates> kako biste i dalje dobivali odgovarajuće obavijesti preko e-poruka ili <delete>obrišite ovo odredište</delete> iz svojih planova putovanja ako više ne razmišljate o njemu.", BH = "Ovi datumi su u prošlosti", FH = "Lokacija {{fullAddress}} je dodana u Vaše planove putovanja!", VH = "{{fullAddress}} je uspješno ažurirana.", UH = "Vaše je pretraživanje spremljeno i Vaš je kalendar ažuriran!", qH = "Vaše je pretraživanje spremljeno. Pronađite ga u svojim planovima putovanja.", HH = "Saznajte više o planovima putovanja", GH = {
  firstname: kH,
  lastname: xH,
  modal_travelWishlist_addNew_title: $H,
  modal_travelWishlist_delete_body: SH,
  modal_travelWishlist_delete_title: CH,
  modal_travelWishlist_filtersApplied_helper: EH,
  modal_travelWishlist_location_helper: jH,
  modal_travelWishlist_searchBar_placeholder: OH,
  page_travelWishlist_card_cta: zH,
  page_travelWishlist_card_emailAlerts_helper: AH,
  page_travelWishlist_cta: PH,
  page_travelWishlist_deleted_toast: DH,
  page_travelWishlist_edit_dates_helper: NH,
  page_travelWishlist_edit_description_helper: RH,
  page_travelWishlist_edit_guests_helper: IH,
  page_travelWishlist_error_toast: TH,
  page_travelWishlist_none_body: LH,
  page_travelWishlist_none_subheader: MH,
  page_travelWishlist_pastDates_desc: WH,
  page_travelWishlist_pastDates_title: BH,
  page_travelWishlist_saved_toast: FH,
  page_travelWishlist_updated_toast: VH,
  search_travelWishlist_calendarUpdated_toast: UH,
  search_travelWishlist_saved_toast: qH,
  travelWishlist_faq: HH
}, KH = "Monolocale", JH = "{{count}} camera da letto", ZH = "{{count}} camere da letto", YH = "", XH = "{{count}} letto", QH = "{{count}} letti", e6 = "Adulti", t6 = "Neonati", a6 = "Il tuo calendario è stato aggiornato.", o6 = "Un mese", n6 = "Date esatte", r6 = "Una settimana", i6 = "", s6 = "", l6 = "", c6 = "", u6 = "Due settimane", d6 = "Annulla", g6 = "Bambini", h6 = "Date", p6 = "Elimina", m6 = "Descrizione", f6 = "Destinazione", b6 = "Fatto!", _6 = "Modifica", v6 = "Qualsiasi tipo di scambio", y6 = "Vasca da bagno", w6 = "Barbecue", k6 = "Bicicletta", x6 = "Automobile", $6 = "Gatto", S6 = "Città", C6 = "Campagna", E6 = "Lavastoviglie", j6 = "Cane", O6 = "Asciugatrice", z6 = "Ascensore", A6 = "Case preferite", P6 = "Camino", D6 = "Appartamento", N6 = "Cortile privato", R6 = "Meno di {{max}} GP", I6 = "da {{min}} GP", T6 = "Tra {{min}} e {{max}} GP", L6 = "Palestra privata", M6 = "Casa", W6 = "Isola o penisola", B6 = "Isolata", F6 = "Idromassaggio", V6 = "Lago", U6 = "Case Collection", q6 = "Montagna", H6 = "{{count}} bagni", G6 = "Altri animali", K6 = "Pianoforte", J6 = "Zona giochi per bambini", Z6 = "Prima", Y6 = "Scambio reciproco", X6 = "Ricerca inversa", Q6 = "Fiume", eG = "Sulla costa", tG = "Seconda", aG = "TV", oG = "Paese", nG = "WiFi", rG = "Filtri", iG = "Date esatte", sG = "Un mese in {{date}}", lG = "Un fine settimana in {{date}}", cG = "Una settimana in {{date}}", uG = "Due settimane in {{date}}", dG = "Date flessibili", gG = "Ospiti", hG = "case", pG = "Ultimo minuto", mG = "Posizione", fG = "Modifica", bG = "Nome", _G = "Avanti", vG = "Zero", yG = "Uno", wG = "Altro", kG = "Zero", xG = "Uno", $G = "Altro", SG = "Zero", CG = "Uno", EG = "Altro", jG = "Zero", OG = "Uno", zG = "Altro", AG = "Il formato del numero di telefono non è valido.", PG = "Ricevi avvisi via email", DG = "Salva", NG = "Nessuna posizione trovata", RG = "Vedere di più", IG = "Lista dei progetti di viaggio", TG = "", LG = "facoltativo", MG = {
  "autocomplete.button": "Ricerca",
  "autocomplete.placeholder": "Dove stai andando?",
  bedroomsNumbers_zero: KH,
  bedroomsNumbers_one: JH,
  bedroomsNumbers_other: ZH,
  beds_zero: YH,
  beds_one: XH,
  beds_other: QH,
  "button.free-signup": "Iscriviti gratis",
  "button.validate": "Convalida",
  "common.try-again": "Prova ancora",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Non deve superare i {{limit}} caratteri",
  "error.reload": "Aggiorna la pagina",
  "error.return-homepage": "Ritorna alla home page",
  "error.subtitle": "Si è verificato un errore e non è stato possibile caricare questa pagina.",
  "error.title": "Si è verificato un errore nella pagina",
  "errors.unable_to_submit.subtitle": "Errore durante l'invio del modulo. Per favore riprova più tardi.",
  "errors.unable_to_submit.title": "Errore: è impossibile inviare",
  "global.back": "Indietro",
  "global.cancel": "Annulla",
  "global.collection.browsehomes": "Sfoglia le case",
  "global.collection.contactus": "Contattaci",
  "global.confirm": "Conferma",
  "global.continue": "Continua",
  "global.getStarted": "Cominciare",
  "global.login": "Accedi",
  "global.select": "Seleziona",
  global_adults: e6,
  global_babies: t6,
  global_calendarUpdated_toast: a6,
  global_calendar_aMonth: o6,
  global_calendar_exactDates: n6,
  global_calendar_oneWeek: r6,
  global_calendar_oneWeekend: i6,
  global_calendar_plusMinusDay_zero: s6,
  global_calendar_plusMinusDay_one: l6,
  global_calendar_plusMinusDay_other: c6,
  global_calendar_twoWeeks: u6,
  global_cancel: d6,
  global_children: g6,
  global_dates: h6,
  global_delete: p6,
  global_description: m6,
  global_destination: f6,
  global_done: b6,
  global_edit: _6,
  "global_filter_a-c": "Aria condizionata",
  global_filter_available: v6,
  "global_filter_baby-bed": "Lettini per bambini",
  "global_filter_baby-gear": "Attrezzature per neonato",
  "global_filter_balcony-terrace": "Balcone/Terrazza",
  global_filter_bathtub: y6,
  global_filter_bbq: w6,
  global_filter_bicycle: k6,
  global_filter_car: x6,
  global_filter_cat: $6,
  "global_filter_children-welcome": "Bambini benvenuti",
  global_filter_cities: S6,
  "global_filter_cleaning-person": "Donna delle pulizie",
  global_filter_countryside: C6,
  "global_filter_dedicated-workspace": "Spazio di lavoro dedicato",
  "global_filter_disabled-access": "Casa accessibile alle sedie a rotelle",
  global_filter_dishwasher: E6,
  global_filter_dog: j6,
  global_filter_dryer: O6,
  "global_filter_eco-level": "Solo case sostenibili",
  "global_filter_electric-car-plug": "Presa per auto elettrica",
  global_filter_elevator: z6,
  global_filter_favorite: A6,
  global_filter_fireplace: P6,
  global_filter_flat: D6,
  global_filter_garden: N6,
  "global_filter_guest-wanted": "Scambio con GuestPoints",
  global_filter_guestPointsMax: R6,
  global_filter_guestPointsMin: I6,
  global_filter_guestPointsMinMax: T6,
  global_filter_gym: L6,
  "global_filter_heating-system": "Sistema di riscaldamento",
  "global_filter_high-speed-connexion": "Connessione ad alta velocità",
  global_filter_home: M6,
  "global_filter_home-verified": "Case verificate",
  global_filter_island: W6,
  global_filter_isolated: B6,
  global_filter_jacuzzi: F6,
  "global_filter_kids-toys": "Giocattoli per bambini",
  global_filter_lakes: V6,
  global_filter_luxury: U6,
  global_filter_mountains: q6,
  "global_filter_no-bed-up": "Nessun letto temporaneo",
  global_filter_numOfBathrooms: H6,
  global_filter_other: G6,
  "global_filter_parking-space": "Posto auto privato",
  "global_filter_pets-welcome": "Animali domestici ammessi",
  global_filter_piano: K6,
  global_filter_playground: J6,
  global_filter_primary: Z6,
  "global_filter_public-transit-access": "Accesso ai trasporti pubblici",
  global_filter_reciprocal: Y6,
  "global_filter_response-rate-above-threshold": "Tasso di risposta ≥ Nella media",
  global_filter_reverse: X6,
  global_filter_river: Q6,
  global_filter_seaside: eG,
  global_filter_secondary: tG,
  "global_filter_secured-pool": "Piscina protetta",
  "global_filter_smokers-welcome": "I fumatori sono i benvenuti",
  "global_filter_swimming-pool": "Piscina",
  global_filter_tv: aG,
  global_filter_villages: oG,
  "global_filter_washing-machine": "Lavatrice",
  "global_filter_whole-unit": "L'intera unità",
  global_filter_wifi: nG,
  global_filters: rG,
  global_fixDates: iG,
  global_flexDates_aMonth: sG,
  global_flexDates_aWeekend: lG,
  global_flexDates_oneWeek: cG,
  global_flexDates_twoWeek: uG,
  global_flexibleDates: dG,
  global_guests: gG,
  global_homes: hG,
  global_lastMinute: pG,
  global_location: mG,
  global_modify: fG,
  global_name: bG,
  global_next: _G,
  global_numberOfAdults_zero: vG,
  global_numberOfAdults_one: yG,
  global_numberOfAdults_other: wG,
  global_numberOfBabies_zero: kG,
  global_numberOfBabies_one: xG,
  global_numberOfBabies_other: $G,
  global_numberOfChildren_zero: SG,
  global_numberOfChildren_one: CG,
  global_numberOfChildren_other: EG,
  global_numberOfGuests_zero: jG,
  global_numberOfGuests_one: OG,
  global_numberOfGuests_other: zG,
  global_phoneNumber_notValid: AG,
  global_receiveEmailAlerts: PG,
  global_save: DG,
  global_searchBar_noLocationFound: NG,
  global_seeMore_link: RG,
  global_travelWishlist: IG,
  "modal.error-occured.content": "Ci spiace davvero per l'inconveniente, ti chiediamo di riprovare.",
  "modal.error-occured.title": "Oh no, si è verificato un errore!",
  no_result: TG,
  optional: LG,
  "privacy-policy": "Informativa sulla privacy"
}, WG = "https://www.homeexchange.it/blog/", BG = "/p/homeexchange-condizioni-di-uso", FG = "https://www.homeexchange.it/p/comunita", VG = "https://homeexchangehelp.zendesk.com/hc/it", UG = "", qG = "https://www.homeexchange.it/p/service-homeexchange-it", HG = "https://www.homeexchange.it/p/guestpoints-it", GG = "https://www.homeexchange.it/p/stampa", KG = "https://www.homeexchange.com/p/racconti-homeexchangers", JG = "https://help.homeexchange.com/hc/it/articles/360000623717-Cosa-sono-le-mie-destinazioni-preferite-e-a-cosa-servono", ZG = "", YG = "https://www.homeexchange.it/p/la-dove-accoglienza-inizia-davvero", XG = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.it/p/about-us-it",
  blog: WG,
  cgu: BG,
  community: FG,
  "contact-us": "https://www.homeexchange.it/contattaci-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/HomeExchangeIT/",
  faq: VG,
  forum: UG,
  guarantees: qG,
  guestpoints: HG,
  "happiness-team": "https://www.homeexchange.it/p/happiness-team-it",
  "how-it-works": "https://www.homeexchange.it/p/come-funziona-it",
  "join-us": "https://www.homeexchange.it/p/join-us-it",
  "legal-notice": "/p/avviso-legale",
  "mobile-app": "https://www.homeexchange.it/p/app-mobile",
  "our-team": "https://www.homeexchange.it/p/nostro-team",
  press: GG,
  "privacy-policy": "/p/homeexchange-informativa-privacy",
  "subscription-cost": "https://www.homeexchange.it/p/subscription-homeexchange-it",
  "term-of-use": "/p/homeexchange-condizioni-di-uso",
  testimonials: KG,
  travelWishlist_faq_links: JG,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: ZG,
  values: YG
}, QG = "Nome", eK = "Cognome", tK = "Aggiungi ai progetti di viaggio", aK = "Una lista dei tuoi progetti di viaggio aggiornata ti consentirà di ricevere più richieste di scambio reciproco.", oK = "Vuoi davvero eliminare {{fullAddress}}?", nK = "Hai selezionato questi filtri. Se hai cambiato idea, puoi eliminarne alcuni qui sotto. Se invece desideri aggiungerne altri, dovrai avviare una nuova ricerca (ma presto non sarà più così... non perderti gli aggiornamenti)!", rK = "Potrebbe trattarsi di un paese, una città o un'intera regione. Se scegli una zona ampia, i risultati potrebbero essere meno accurati.", iK = "Digita un paese, una città o una regione", sK = "Vedi le case disponibili", lK = "Quando le case disponibili corrispondono ai tuoi progetti di viaggio.", cK = "Aggiungi ai progetti di viaggio", uK = "{{fullAddress}} è stato eliminato dai tuoi progetti di viaggio.", dK = "Seleziona le date di viaggio ideali (flessibili o fisse).", gK = "Aggiungi dei dettagli per aiutare gli altri utenti che utilizzano la funzione di ricerca inversa a capire perché ti interessa la loro zona.", hK = "Specifica quante persone viaggeranno con te.", pK = "Ops! {{fullAddress}} non è stato salvato nella lista dei tuoi progetti di viaggio per un motivo imprevisto.", mK = "Facci sapere quando e dove vorresti viaggiare per ricevere richieste di scambio e avvisi non appena saranno disponibili delle case adatte. Salveremo le tue ricerche nella lista dei tuoi progetti di viaggio!", fK = "Ci sono nuove avventure che vorresti iniziare a pianificare?", bK = "<updateDates>Aggiorna le tue date</updateDates> per continuare a ricevere gli avvisi pertinenti via mail oppure <delete>elimina questa destinazione</delete> dalla lista dei tuoi progetti di viaggio se hai cambiato idea.", _K = "Queste date sono già passate", vK = "{{fullAddress}} è stato aggiunto alla lista dei tuoi progetti di viaggio!", yK = "{{fullAddress}} è stato aggiornato correttamente.", wK = "La tua ricerca è stata salvata e il tuo calendario è aggiornato!", kK = "La tua ricerca è stata salvata. La trovi nella lista dei tuoi progetti di viaggio.", xK = "Scopri di più sulle liste per i progetti di viaggio", $K = {
  firstname: QG,
  lastname: eK,
  modal_travelWishlist_addNew_title: tK,
  modal_travelWishlist_delete_body: aK,
  modal_travelWishlist_delete_title: oK,
  modal_travelWishlist_filtersApplied_helper: nK,
  modal_travelWishlist_location_helper: rK,
  modal_travelWishlist_searchBar_placeholder: iK,
  page_travelWishlist_card_cta: sK,
  page_travelWishlist_card_emailAlerts_helper: lK,
  page_travelWishlist_cta: cK,
  page_travelWishlist_deleted_toast: uK,
  page_travelWishlist_edit_dates_helper: dK,
  page_travelWishlist_edit_description_helper: gK,
  page_travelWishlist_edit_guests_helper: hK,
  page_travelWishlist_error_toast: pK,
  page_travelWishlist_none_body: mK,
  page_travelWishlist_none_subheader: fK,
  page_travelWishlist_pastDates_desc: bK,
  page_travelWishlist_pastDates_title: _K,
  page_travelWishlist_saved_toast: vK,
  page_travelWishlist_updated_toast: yK,
  search_travelWishlist_calendarUpdated_toast: wK,
  search_travelWishlist_saved_toast: kK,
  travelWishlist_faq: xK
}, SK = "Studio", CK = "{{count}} soverom", EK = "{{count}} soverom", jK = "", OK = "{{count}} seng", zK = "{{count}} senger", AK = "Voksne", PK = "Babyer", DK = "", NK = "En måned", RK = "Nøyaktige datoer", IK = "Uke", TK = "", LK = "", MK = "", WK = "", BK = "To uker", FK = "", VK = "Barn", UK = "Datoer", qK = "", HK = "Beskrivelse", GK = "Reisemål", KK = "", JK = "", ZK = "alle typer boligbytter", YK = "Badekar", XK = "Grill", QK = "Sykkel", e5 = "Bil", t5 = "Katt", a5 = "By", o5 = "Landlig", n5 = "Oppvaskmaskin", r5 = "Hund", i5 = "Tørketrommel", s5 = "Heis", l5 = "Favoritthjem", c5 = "Peis", u5 = "Leilighet", d5 = "", g5 = "mindre enn {{max}} GP", h5 = "fra {{min}} GP", p5 = "Mellom {{min}} og {{max}} GP", m5 = "Privat treningsrom", f5 = "Hus", b5 = "Øy", _5 = "Isolert", v5 = "Jacuzzi", y5 = "Innsjøer", w5 = "Collection-hjem", k5 = "Fjell", x5 = "", $5 = "Andre dyr", S5 = "Piano", C5 = "", E5 = "Primær", j5 = "Gjensidig boligbytte", O5 = "Omvendt søk", z5 = "Elv", A5 = "", P5 = "Sekundær", D5 = "TV", N5 = "Landsbygd", R5 = "WiFi", I5 = "Filtrer", T5 = "Nøyaktige datoer", L5 = "", M5 = "", W5 = "", B5 = "", F5 = "Fleksible datoer", V5 = "Gjester", U5 = "", q5 = "Siste øyeblikk", H5 = "Beliggenhet", G5 = "", K5 = "", J5 = "", Z5 = "", Y5 = "", X5 = "", Q5 = "", e9 = "", t9 = "", a9 = "", o9 = "", n9 = "", r9 = "", i9 = "", s9 = "", l9 = "", c9 = "", u9 = "Lagre", d9 = "", g9 = "Se mer", h9 = "", p9 = "", m9 = "", f9 = {
  "autocomplete.button": "Søk",
  "autocomplete.placeholder": "Hvor skal du ?",
  bedroomsNumbers_zero: SK,
  bedroomsNumbers_one: CK,
  bedroomsNumbers_other: EK,
  beds_zero: jK,
  beds_one: OK,
  beds_other: zK,
  "button.free-signup": "Registrer deg gratis",
  "button.validate": "Bekreft",
  "common.try-again": "",
  "contact-tech-email": "contact@homeexchange.com",
  "error.characters_max_limit": "Kan ikke overstige {{limit}} tegn",
  "error.reload": "Oppdater siden",
  "error.return-homepage": "Gå tilbake til startsiden",
  "error.subtitle": "Denne siden kan dessverre ikke nås.",
  "error.title": "En feil har oppstått på siden",
  "errors.unable_to_submit.subtitle": "Skjemaet ditt kunne dessverre ikke sendes inn akkurat nå. Vennligst prøv igjen senere.",
  "errors.unable_to_submit.title": "Oops, det har oppstått et problem",
  "global.back": "Tilbake",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "Fortsett",
  "global.getStarted": "",
  "global.login": "",
  "global.select": "",
  global_adults: AK,
  global_babies: PK,
  global_calendarUpdated_toast: DK,
  global_calendar_aMonth: NK,
  global_calendar_exactDates: RK,
  global_calendar_oneWeek: IK,
  global_calendar_oneWeekend: TK,
  global_calendar_plusMinusDay_zero: LK,
  global_calendar_plusMinusDay_one: MK,
  global_calendar_plusMinusDay_other: WK,
  global_calendar_twoWeeks: BK,
  global_cancel: FK,
  global_children: VK,
  global_dates: UK,
  global_delete: qK,
  global_description: HK,
  global_destination: GK,
  global_done: KK,
  global_edit: JK,
  "global_filter_a-c": "Klimaanlegg",
  global_filter_available: ZK,
  "global_filter_baby-bed": "Sprinkelsenger",
  "global_filter_baby-gear": "Babyutstyr",
  "global_filter_balcony-terrace": "",
  global_filter_bathtub: YK,
  global_filter_bbq: XK,
  global_filter_bicycle: QK,
  global_filter_car: e5,
  global_filter_cat: t5,
  "global_filter_children-welcome": "Barn velkommen",
  global_filter_cities: a5,
  "global_filter_cleaning-person": "Rengjøringsperson",
  global_filter_countryside: o5,
  "global_filter_dedicated-workspace": "",
  "global_filter_disabled-access": "Tilgjengelig for funksjonshemmede",
  global_filter_dishwasher: n5,
  global_filter_dog: r5,
  global_filter_dryer: i5,
  "global_filter_eco-level": "Bare bærekraftige hjem",
  "global_filter_electric-car-plug": "Elektrisk bilplugg",
  global_filter_elevator: s5,
  global_filter_favorite: l5,
  global_filter_fireplace: c5,
  global_filter_flat: u5,
  global_filter_garden: d5,
  "global_filter_guest-wanted": "Boligbytte med GuestPoints",
  global_filter_guestPointsMax: g5,
  global_filter_guestPointsMin: h5,
  global_filter_guestPointsMinMax: p5,
  global_filter_gym: m5,
  "global_filter_heating-system": "Oppvarming",
  "global_filter_high-speed-connexion": "Høyhastighets tilkobling",
  global_filter_home: f5,
  "global_filter_home-verified": "Verifiserte hjem",
  global_filter_island: b5,
  global_filter_isolated: _5,
  global_filter_jacuzzi: v5,
  "global_filter_kids-toys": "Barneleker",
  global_filter_lakes: y5,
  global_filter_luxury: w5,
  global_filter_mountains: k5,
  "global_filter_no-bed-up": "",
  global_filter_numOfBathrooms: x5,
  global_filter_other: $5,
  "global_filter_parking-space": "Privat parkering",
  "global_filter_pets-welcome": "Kjæledyr velkommen",
  global_filter_piano: S5,
  global_filter_playground: C5,
  global_filter_primary: E5,
  "global_filter_public-transit-access": "Tilgang til offentlig transport",
  global_filter_reciprocal: j5,
  "global_filter_response-rate-above-threshold": "",
  global_filter_reverse: O5,
  global_filter_river: z5,
  global_filter_seaside: A5,
  global_filter_secondary: P5,
  "global_filter_secured-pool": "Sikret badebasseng",
  "global_filter_smokers-welcome": "Røykere velkommen",
  "global_filter_swimming-pool": "Svømmebasseng",
  global_filter_tv: D5,
  global_filter_villages: N5,
  "global_filter_washing-machine": "Vaskemaskin",
  "global_filter_whole-unit": "Hele boligen",
  global_filter_wifi: R5,
  global_filters: I5,
  global_fixDates: T5,
  global_flexDates_aMonth: L5,
  global_flexDates_aWeekend: M5,
  global_flexDates_oneWeek: W5,
  global_flexDates_twoWeek: B5,
  global_flexibleDates: F5,
  global_guests: V5,
  global_homes: U5,
  global_lastMinute: q5,
  global_location: H5,
  global_modify: G5,
  global_name: K5,
  global_next: J5,
  global_numberOfAdults_zero: Z5,
  global_numberOfAdults_one: Y5,
  global_numberOfAdults_other: X5,
  global_numberOfBabies_zero: Q5,
  global_numberOfBabies_one: e9,
  global_numberOfBabies_other: t9,
  global_numberOfChildren_zero: a9,
  global_numberOfChildren_one: o9,
  global_numberOfChildren_other: n9,
  global_numberOfGuests_zero: r9,
  global_numberOfGuests_one: i9,
  global_numberOfGuests_other: s9,
  global_phoneNumber_notValid: l9,
  global_receiveEmailAlerts: c9,
  global_save: u9,
  global_searchBar_noLocationFound: d9,
  global_seeMore_link: g9,
  global_travelWishlist: h9,
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: p9,
  optional: m9,
  "privacy-policy": "Personvernpolicy"
}, b9 = "https://www.homeexchange.com/blog/", _9 = "/p/general-terms-of-use", v9 = "https://www.homeexchange.com/nb/p/nettverk", y9 = "https://homeexchangehelp.zendesk.com/hc/pt", w9 = "", k9 = "https://www.homeexchange.com/nb/p/service-homeexchange-no", x9 = "https://www.homeexchange.com/nb/p/guestpoints-no", $9 = "https://www.homeexchange.com/nb/p/press-no", S9 = "https://www.homeexchange.com/p/ifolge-homeexchangers", C9 = "", E9 = "", j9 = "https://www.homeexchange.com/nb/p/der-velkomsten-virkelig-starter", O9 = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/nb/p/about-us-no",
  blog: b9,
  cgu: _9,
  community: v9,
  "contact-us": "https://www.homeexchange.com/nb/p/kontact-oss-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: y9,
  forum: w9,
  guarantees: k9,
  guestpoints: x9,
  "happiness-team": "https://www.homeexchange.com/nb/p/happiness-team-no",
  "how-it-works": "https://www.homeexchange.com/nb/p/hvordan-fungerer-det-no",
  "join-us": "https://www.homeexchange.com/nb/p/join-us-no",
  "legal-notice": "/p/legal-notice-no",
  "mobile-app": "https://www.homeexchange.com/nb/p/mobile-app",
  "our-team": "https://www.homeexchange.com/nb/p/teamet-vart",
  press: $9,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/nb/p/subscription-homeexchange-no",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: S9,
  travelWishlist_faq_links: C9,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: E9,
  values: j9
}, z9 = "Fornavn", A9 = "Etternavn", P9 = "", D9 = "", N9 = "", R9 = "", I9 = "", T9 = "", L9 = "Se tilgjengelige hjem", M9 = "", W9 = "", B9 = "", F9 = "", V9 = "", U9 = "", q9 = "", H9 = "", G9 = "", K9 = "", J9 = "", Z9 = "", Y9 = "", X9 = "", Q9 = "", e8 = "", t8 = {
  firstname: z9,
  lastname: A9,
  modal_travelWishlist_addNew_title: P9,
  modal_travelWishlist_delete_body: D9,
  modal_travelWishlist_delete_title: N9,
  modal_travelWishlist_filtersApplied_helper: R9,
  modal_travelWishlist_location_helper: I9,
  modal_travelWishlist_searchBar_placeholder: T9,
  page_travelWishlist_card_cta: L9,
  page_travelWishlist_card_emailAlerts_helper: M9,
  page_travelWishlist_cta: W9,
  page_travelWishlist_deleted_toast: B9,
  page_travelWishlist_edit_dates_helper: F9,
  page_travelWishlist_edit_description_helper: V9,
  page_travelWishlist_edit_guests_helper: U9,
  page_travelWishlist_error_toast: q9,
  page_travelWishlist_none_body: H9,
  page_travelWishlist_none_subheader: G9,
  page_travelWishlist_pastDates_desc: K9,
  page_travelWishlist_pastDates_title: J9,
  page_travelWishlist_saved_toast: Z9,
  page_travelWishlist_updated_toast: Y9,
  search_travelWishlist_calendarUpdated_toast: X9,
  search_travelWishlist_saved_toast: Q9,
  travelWishlist_faq: e8
}, a8 = "Studio", o8 = "{{count}} slaapkamer", n8 = "{{count}} slaapkamers", r8 = "", i8 = "{{count}} bed", s8 = "{{count}} bedden", l8 = "Volwassenen", c8 = "Baby's", u8 = "Je kalender is bijgewerkt.", d8 = "Een maand", g8 = "Exacte data", h8 = "Een week", p8 = "Een weekend", m8 = "", f8 = "", b8 = "± {{count}} dagen", _8 = "Twee weken", v8 = "Annuleren", y8 = "Kinderen", w8 = "Data", k8 = "Verwijderen", x8 = "Beschrijving", $8 = "Bestemming", S8 = "Klaar!", C8 = "Bewerken", E8 = "Elk type ruil", j8 = "Bad", O8 = "BBQ", z8 = "Fiets", A8 = "Auto", P8 = "Kat", D8 = "De stad", N8 = "Het platteland", R8 = "Vaatwasmachine", I8 = "Hond", T8 = "Droger", L8 = "Lift", M8 = "Favoriete huizen", W8 = "Open haard", B8 = "Appartement", F8 = "Privétuin", V8 = "Minder dan {{max}} GP", U8 = "vanaf {{min}} GP", q8 = "Tussen {{min}} en {{max}} GP", H8 = "Privésportzaal", G8 = "Huis", K8 = "Een eiland", J8 = "Geïsoleerd", Z8 = "Jacuzzi", Y8 = "Een meer", X8 = "Collection-huizen", Q8 = "De bergen", e7 = "{{count}} badkamers", t7 = "Andere dieren", a7 = "", o7 = "Speeltuin", n7 = "Eerste", r7 = "Wederzijdse huizenruil", i7 = "Omgekeerd zoeken", s7 = "Rivier", l7 = "Kust", c7 = "Vakantiehuis", u7 = "TV", d7 = "Dorp", g7 = "WiFi", h7 = "Filters", p7 = "Vaste data", m7 = "Een maand in {{date}}", f7 = "Een weekend in {{date}}", b7 = "Een week in {{date}}", _7 = "Twee weken in {{date}}", v7 = "Flexibele data", y7 = "Gasten", w7 = "huizen", k7 = "Last minute", x7 = "Locatie", $7 = "Wijzigen", S7 = "Naam", C7 = "Volgende", E7 = "", j7 = "{{count}} volwassene", O7 = "{{count}} volwassenen", z7 = "", A7 = "{{count}} baby", P7 = "{{count}} baby's", D7 = "", N7 = "{{count}} kind", R7 = "{{count}} kinderen", I7 = "", T7 = "{{count}} gast", L7 = "{{count}} gasten", M7 = "De indeling van het telefoonnummer is niet geldig.", W7 = "E-mailmeldingen ontvangen", B7 = "Opslaan", F7 = "Geen locaties gevonden", V7 = "Bekijk meer", U7 = "Reisplannen", q7 = "Geen resultaat", H7 = "optioneel", G7 = {
  "autocomplete.button": "Zoeken",
  "autocomplete.placeholder": "Waar ga je naar toe ?",
  bedroomsNumbers_zero: a8,
  bedroomsNumbers_one: o8,
  bedroomsNumbers_other: n8,
  beds_zero: r8,
  beds_one: i8,
  beds_other: s8,
  "button.free-signup": "Meld je gratis aan",
  "button.validate": "Bevestigen",
  "common.try-again": "Opnieuw proberen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Mag de {{limit}} karakters niet overschrijden",
  "error.reload": "Deze pagina vernieuwen ",
  "error.return-homepage": "Terug naar de startpagina",
  "error.subtitle": "Helaas kon deze pagina niet gevonden worden.",
  "error.title": "Er is een fout opgetreden op de pagina",
  "errors.unable_to_submit.subtitle": "Helaas kon het formulier niet verzonden worden. Probeer het later nog eens.",
  "errors.unable_to_submit.title": "Oeps... het is niet gelukt om het formulier te verzenden.",
  "global.back": "Terug",
  "global.cancel": "Annuleren",
  "global.collection.browsehomes": "Blader door huizen",
  "global.collection.contactus": "Neem contact met ons op",
  "global.confirm": "Bevestigen",
  "global.continue": "Doorgaan",
  "global.getStarted": "Ga van start",
  "global.login": "Inloggen",
  "global.select": "Selecteren",
  global_adults: l8,
  global_babies: c8,
  global_calendarUpdated_toast: u8,
  global_calendar_aMonth: d8,
  global_calendar_exactDates: g8,
  global_calendar_oneWeek: h8,
  global_calendar_oneWeekend: p8,
  global_calendar_plusMinusDay_zero: m8,
  global_calendar_plusMinusDay_one: f8,
  global_calendar_plusMinusDay_other: b8,
  global_calendar_twoWeeks: _8,
  global_cancel: v8,
  global_children: y8,
  global_dates: w8,
  global_delete: k8,
  global_description: x8,
  global_destination: $8,
  global_done: S8,
  global_edit: C8,
  "global_filter_a-c": "Airco",
  global_filter_available: E8,
  "global_filter_baby-bed": "Babybedden",
  "global_filter_baby-gear": "Baby spullen",
  "global_filter_balcony-terrace": "",
  global_filter_bathtub: j8,
  global_filter_bbq: O8,
  global_filter_bicycle: z8,
  global_filter_car: A8,
  global_filter_cat: P8,
  "global_filter_children-welcome": "Kinderen welkom",
  global_filter_cities: D8,
  "global_filter_cleaning-person": "Schoonmaakster",
  global_filter_countryside: N8,
  "global_filter_dedicated-workspace": "Toegewijde werkruimte",
  "global_filter_disabled-access": "Toegankelijk voor invaliden",
  global_filter_dishwasher: R8,
  global_filter_dog: I8,
  global_filter_dryer: T8,
  "global_filter_eco-level": "Alleen duurzame woningen",
  "global_filter_electric-car-plug": "Elektrische auto stekker",
  global_filter_elevator: L8,
  global_filter_favorite: M8,
  global_filter_fireplace: W8,
  global_filter_flat: B8,
  global_filter_garden: F8,
  "global_filter_guest-wanted": "Ruil tegen GuestPoints",
  global_filter_guestPointsMax: V8,
  global_filter_guestPointsMin: U8,
  global_filter_guestPointsMinMax: q8,
  global_filter_gym: H8,
  "global_filter_heating-system": "Verwarming",
  "global_filter_high-speed-connexion": "Snelle verbinding",
  global_filter_home: G8,
  "global_filter_home-verified": "Geverifieerde huizen",
  global_filter_island: K8,
  global_filter_isolated: J8,
  global_filter_jacuzzi: Z8,
  "global_filter_kids-toys": "Kinderen speelgoed",
  global_filter_lakes: Y8,
  global_filter_luxury: X8,
  global_filter_mountains: Q8,
  "global_filter_no-bed-up": "Geen tijdelijke bedden",
  global_filter_numOfBathrooms: e7,
  global_filter_other: t7,
  "global_filter_parking-space": "Privé parkeerplaats",
  "global_filter_pets-welcome": "Huisdieren toegestaan ",
  global_filter_piano: a7,
  global_filter_playground: o7,
  global_filter_primary: n7,
  "global_filter_public-transit-access": "Toegang tot het openbaar vervoer",
  global_filter_reciprocal: r7,
  "global_filter_response-rate-above-threshold": "Responspercentage ≥ Gemiddeld",
  global_filter_reverse: i7,
  global_filter_river: s7,
  global_filter_seaside: l7,
  global_filter_secondary: c7,
  "global_filter_secured-pool": "Beveiligd zwembad",
  "global_filter_smokers-welcome": "Roken toegestaan ",
  "global_filter_swimming-pool": "Zwembad",
  global_filter_tv: u7,
  global_filter_villages: d7,
  "global_filter_washing-machine": "Wasmachine",
  "global_filter_whole-unit": "De hele woning",
  global_filter_wifi: g7,
  global_filters: h7,
  global_fixDates: p7,
  global_flexDates_aMonth: m7,
  global_flexDates_aWeekend: f7,
  global_flexDates_oneWeek: b7,
  global_flexDates_twoWeek: _7,
  global_flexibleDates: v7,
  global_guests: y7,
  global_homes: w7,
  global_lastMinute: k7,
  global_location: x7,
  global_modify: $7,
  global_name: S7,
  global_next: C7,
  global_numberOfAdults_zero: E7,
  global_numberOfAdults_one: j7,
  global_numberOfAdults_other: O7,
  global_numberOfBabies_zero: z7,
  global_numberOfBabies_one: A7,
  global_numberOfBabies_other: P7,
  global_numberOfChildren_zero: D7,
  global_numberOfChildren_one: N7,
  global_numberOfChildren_other: R7,
  global_numberOfGuests_zero: I7,
  global_numberOfGuests_one: T7,
  global_numberOfGuests_other: L7,
  global_phoneNumber_notValid: M7,
  global_receiveEmailAlerts: W7,
  global_save: B7,
  global_searchBar_noLocationFound: F7,
  global_seeMore_link: V7,
  global_travelWishlist: U7,
  "modal.error-occured.content": "Onze excuses voor het ongemak, probeer het alsjeblieft opnieuw.",
  "modal.error-occured.title": "Oh nee, er is een fout opgetreden!",
  no_result: q7,
  optional: H7,
  "privacy-policy": "Privacy"
}, K7 = "https://www.homeexchange.com/nl/blog/", J7 = "/nl/p/homeexchangegebruiksvoorwaarden", Z7 = "https://www.homeexchange.com/nl/p/gemeenschap", Y7 = "https://homeexchangehelp.zendesk.com/hc/en-us", X7 = "https://forum.homeexchange.com/c/english/20", Q7 = "https://www.homeexchange.com/nl/p/service-homeexchange-nl", eJ = "https://www.homeexchange.com/nl/p/guestpoints-nl", tJ = "https://www.homeexchange.com/nl/p/pers", aJ = "https://www.homeexchange.com/p/wordsonhomeexchange", oJ = "https://help.homeexchange.com/hc/nl/articles/360000623717-Wat-zijn-Mijn-voorkeursbestemmingen-en-hoe-gebruik-ik-ze", nJ = "https://www.homeexchange.com/nl/p/where-the-welcome-really-begins", rJ = "https://www.guesttoguest.com/nl/p/waar-het-welkom-echt-begint", iJ = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/nl/p/about-us-nl",
  blog: K7,
  cgu: J7,
  community: Z7,
  "contact-us": "https://www.homeexchange.com/nl/contact-op-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: Y7,
  forum: X7,
  guarantees: Q7,
  guestpoints: eJ,
  "happiness-team": "https://www.homeexchange.com/nl/p/happiness-team-nl",
  "how-it-works": "https://www.homeexchange.com/nl/p/hoe-werkt-het-nl",
  "join-us": "https://www.homeexchange.com/nl/p/join-us-nl",
  "legal-notice": "/p/wettelijke-vermeldingen",
  "mobile-app": "https://www.homeexchange.com/nl/p/mobiele-app",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: tJ,
  "privacy-policy": "/p/homeexchange-privacy",
  "subscription-cost": "https://www.homeexchange.com/nl/p/subscription-homeexchange-nl",
  "term-of-use": "/p/homeexchangegebruiksvoorwaarden",
  testimonials: aJ,
  travelWishlist_faq_links: oJ,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: nJ,
  values: rJ
}, sJ = "Voornaam", lJ = "Achternaam", cJ = "Een nieuw reisplan toevoegen", uJ = "Met bijgewerkte reisplannen kun je meer wederzijdse uitwisselingsverzoeken ontvangen.", dJ = "Weet je zeker dat je {{fullAddress}} wilt verwijderen?", gJ = "Dit zijn de filters die je hebt geselecteerd. Als je van gedachten bent veranderd, kun je er hieronder een paar verwijderen. Maar als je extra filters wilt toevoegen, moet je een nieuwe zoekopdracht starten (dit zal binnenkort veranderen...hou het in de gaten)!", hJ = "Dit kan een land, stad of een hele regio zijn. Als je een brede locatie kiest, zijn je resultaten mogelijk minder nauwkeurig.", pJ = "Typ een land, stad of regio", mJ = "Bekijk beschikbare huizen", fJ = "Als er beschikbare huizen zijn die overeenkomen met je reisplannen.", bJ = "Een nieuw reisplan toevoegen", _J = "{{fullAddress}} is verwijderd uit je reisplannen.", vJ = "Selecteer je ideale reisdata (flexibel of vast).", yJ = "Voeg details toe zodat anderen die de omgekeerde zoekfunctie gebruiken kunnen zien waarom je geïnteresseerd bent in hun locatie.", wJ = "Geef aan hoeveel mensen met je meereizen voor deze reis.", kJ = "Oeps! {{fullAddress}} kon om een onverwachte reden niet worden opgeslagen in je reisplannen.", xJ = "Laat ons weten wanneer en waar je naartoe wilt reizen en ontvang uitwisselingsverzoeken en meldingen zodra er geschikte huizen beschikbaar zijn. We slaan je zoekopdrachten op in je reisplannen!", $J = "Zijn er nog reisavonturen die je wilt plannen?", SJ = "<updateDates>Werk je data</updateDates> bij om relevante e-mailmeldingen te blijven ontvangen of <delete>verwijder deze bestemming</delete> uit je reisplannen als je het niet langer overweegt.", CJ = "Deze data liggen in het verleden", EJ = "{{fullAddress}} is toegevoegd aan je reisplannen!", jJ = "{{fullAddress}} is succesvol bijgewerkt.", OJ = "Je zoekopdracht is opgeslagen en je kalender is bijgewerkt!", zJ = "Je zoekopdracht is opgeslagen. Je vindt hem in je reisplannen.", AJ = "Meer informatie over reisplannen", PJ = {
  firstname: sJ,
  lastname: lJ,
  modal_travelWishlist_addNew_title: cJ,
  modal_travelWishlist_delete_body: uJ,
  modal_travelWishlist_delete_title: dJ,
  modal_travelWishlist_filtersApplied_helper: gJ,
  modal_travelWishlist_location_helper: hJ,
  modal_travelWishlist_searchBar_placeholder: pJ,
  page_travelWishlist_card_cta: mJ,
  page_travelWishlist_card_emailAlerts_helper: fJ,
  page_travelWishlist_cta: bJ,
  page_travelWishlist_deleted_toast: _J,
  page_travelWishlist_edit_dates_helper: vJ,
  page_travelWishlist_edit_description_helper: yJ,
  page_travelWishlist_edit_guests_helper: wJ,
  page_travelWishlist_error_toast: kJ,
  page_travelWishlist_none_body: xJ,
  page_travelWishlist_none_subheader: $J,
  page_travelWishlist_pastDates_desc: SJ,
  page_travelWishlist_pastDates_title: CJ,
  page_travelWishlist_saved_toast: EJ,
  page_travelWishlist_updated_toast: jJ,
  search_travelWishlist_calendarUpdated_toast: OJ,
  search_travelWishlist_saved_toast: zJ,
  travelWishlist_faq: AJ
}, DJ = "Studio", NJ = "{{count}} quarto", RJ = "{{count}} quartos", IJ = "", TJ = "{{count}} cama", LJ = "{{count}} camas", MJ = "", WJ = "", BJ = "O seu calendário foi atualizado.", FJ = "Um mês", VJ = "Datas exatas", UJ = "Uma semana", qJ = "Um fim de semana", HJ = "", GJ = "± 1:{{count}} dia", KJ = "± {{count]] dias", JJ = "Duas semanas", ZJ = "Cancelar", YJ = "", XJ = "Datas", QJ = "Eliminar", eZ = "Descrição", tZ = "Destino", aZ = "Feito!", oZ = "Editar", nZ = "Qualquer tipo de pedido de Troca", rZ = "Banheiro", iZ = "BBQ", sZ = "Bicicleta", lZ = "Carro", cZ = "Gato", uZ = "Cidade", dZ = "Campo", gZ = "Lavadora de louças", hZ = "Cão", pZ = "Secadora", mZ = "Elevador", fZ = "Casas favoritas", bZ = "Lareira", _Z = "Apartamento", vZ = "Quintal privado", yZ = "", wZ = "", kZ = "", xZ = "", $Z = "Casa", SZ = "Ilha", CZ = "Isolada", EZ = "Jacuzzi", jZ = "Lagos", OZ = "Casas Collection", zZ = "", AZ = "{{count}} casas de banho", PZ = "Outros animais", DZ = "Piano", NZ = "Parque infantil", RZ = "Principal", IZ = "Troca Reciproca", TZ = "Busca invertida", LZ = "Rio", MZ = "Litoral", WZ = "Secundária", BZ = "TV", FZ = "Aldeia", VZ = "WiFi", UZ = "Filtros", qZ = "Datas fixas", HZ = "Um mês em {{date}}", GZ = "Um fim de semana em {{date}}", KZ = "Uma semana em {{date}}", JZ = "Duas semanas em {{date}}", ZZ = "Datas flexíveis", YZ = "Convidados", XZ = "casas", QZ = "Última hora", eY = "Localização", tY = "Modificar", aY = "Nome", oY = "Seguinte", nY = "", rY = "{{count}} adulto", iY = "{{count}} adultos", sY = "", lY = "{{count}} bebé", cY = "{{count}} bebés", uY = "", dY = "{{count}} criança", gY = "{{count}} crianças", hY = "", pY = "{{count}} convidado", mY = "{{count}} convidados", fY = "O formato do número de telefone não é válido.", bY = "Receber alertas por e-mail", _Y = "Guardar", vY = "Não foram encontradas localizações", yY = "Ver mais", wY = "Ideias de viagens", kY = "", xY = "", $Y = {
  "autocomplete.button": "Procurar",
  "autocomplete.placeholder": "Para onde vai ?",
  bedroomsNumbers_zero: DJ,
  bedroomsNumbers_one: NJ,
  bedroomsNumbers_other: RJ,
  beds_zero: IJ,
  beds_one: TJ,
  beds_other: LJ,
  "button.free-signup": "Filie-se gratuitamente",
  "button.validate": "Validar",
  "common.try-again": "",
  "contact-tech-email": "",
  "error.characters_max_limit": "Não deve ser superior a {{limit}} caracteres",
  "error.reload": "Atualizar esta página",
  "error.return-homepage": "Voltar à página inicial",
  "error.subtitle": "Infelizmente, não foi possível aceder a esta página.",
  "error.title": "Ocorreu um erro na página",
  "errors.unable_to_submit.subtitle": "Infelizmente, não foi possível submeter o formulário. Tente novamente mais tarde.",
  "errors.unable_to_submit.title": "Ups, ocorreu um problema!",
  "global.back": "",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "",
  "global.getStarted": "",
  "global.login": "",
  "global.select": "",
  global_adults: MJ,
  global_babies: WJ,
  global_calendarUpdated_toast: BJ,
  global_calendar_aMonth: FJ,
  global_calendar_exactDates: VJ,
  global_calendar_oneWeek: UJ,
  global_calendar_oneWeekend: qJ,
  global_calendar_plusMinusDay_zero: HJ,
  global_calendar_plusMinusDay_one: GJ,
  global_calendar_plusMinusDay_other: KJ,
  global_calendar_twoWeeks: JJ,
  global_cancel: ZJ,
  global_children: YJ,
  global_dates: XJ,
  global_delete: QJ,
  global_description: eZ,
  global_destination: tZ,
  global_done: aZ,
  global_edit: oZ,
  "global_filter_a-c": "A/C",
  global_filter_available: nZ,
  "global_filter_baby-bed": "",
  "global_filter_baby-gear": "Equipamento para bebês",
  "global_filter_balcony-terrace": "Varanda/Terraço",
  global_filter_bathtub: rZ,
  global_filter_bbq: iZ,
  global_filter_bicycle: sZ,
  global_filter_car: lZ,
  global_filter_cat: cZ,
  "global_filter_children-welcome": "Crianças bem vindas",
  global_filter_cities: uZ,
  "global_filter_cleaning-person": "Faxineiro",
  global_filter_countryside: dZ,
  "global_filter_dedicated-workspace": "Espaço de trabalho dedicado",
  "global_filter_disabled-access": "Casa acessível",
  global_filter_dishwasher: gZ,
  global_filter_dog: hZ,
  global_filter_dryer: pZ,
  "global_filter_eco-level": "Só casas sustentáveis",
  "global_filter_electric-car-plug": "Tomada para carro elétrico",
  global_filter_elevator: mZ,
  global_filter_favorite: fZ,
  global_filter_fireplace: bZ,
  global_filter_flat: _Z,
  global_filter_garden: vZ,
  "global_filter_guest-wanted": "Troca por GuestPoints",
  global_filter_guestPointsMax: yZ,
  global_filter_guestPointsMin: wZ,
  global_filter_guestPointsMinMax: kZ,
  global_filter_gym: xZ,
  "global_filter_heating-system": "Sistema de aquecimento",
  "global_filter_high-speed-connexion": "Wi-fi de alta velocidade",
  global_filter_home: $Z,
  "global_filter_home-verified": "Casas verificadas",
  global_filter_island: SZ,
  global_filter_isolated: CZ,
  global_filter_jacuzzi: EZ,
  "global_filter_kids-toys": "",
  global_filter_lakes: jZ,
  global_filter_luxury: OZ,
  global_filter_mountains: zZ,
  "global_filter_no-bed-up": "Sem camas temporárias",
  global_filter_numOfBathrooms: AZ,
  global_filter_other: PZ,
  "global_filter_parking-space": "",
  "global_filter_pets-welcome": "Animais de estimação bem-vindos",
  global_filter_piano: DZ,
  global_filter_playground: NZ,
  global_filter_primary: RZ,
  "global_filter_public-transit-access": "",
  global_filter_reciprocal: IZ,
  "global_filter_response-rate-above-threshold": "",
  global_filter_reverse: TZ,
  global_filter_river: LZ,
  global_filter_seaside: MZ,
  global_filter_secondary: WZ,
  "global_filter_secured-pool": "Piscina protegida",
  "global_filter_smokers-welcome": "Fumantes bem-vindos",
  "global_filter_swimming-pool": "Piscina",
  global_filter_tv: BZ,
  global_filter_villages: FZ,
  "global_filter_washing-machine": "Máquina de lavar",
  "global_filter_whole-unit": "",
  global_filter_wifi: VZ,
  global_filters: UZ,
  global_fixDates: qZ,
  global_flexDates_aMonth: HZ,
  global_flexDates_aWeekend: GZ,
  global_flexDates_oneWeek: KZ,
  global_flexDates_twoWeek: JZ,
  global_flexibleDates: ZZ,
  global_guests: YZ,
  global_homes: XZ,
  global_lastMinute: QZ,
  global_location: eY,
  global_modify: tY,
  global_name: aY,
  global_next: oY,
  global_numberOfAdults_zero: nY,
  global_numberOfAdults_one: rY,
  global_numberOfAdults_other: iY,
  global_numberOfBabies_zero: sY,
  global_numberOfBabies_one: lY,
  global_numberOfBabies_other: cY,
  global_numberOfChildren_zero: uY,
  global_numberOfChildren_one: dY,
  global_numberOfChildren_other: gY,
  global_numberOfGuests_zero: hY,
  global_numberOfGuests_one: pY,
  global_numberOfGuests_other: mY,
  global_phoneNumber_notValid: fY,
  global_receiveEmailAlerts: bY,
  global_save: _Y,
  global_searchBar_noLocationFound: vY,
  global_seeMore_link: yY,
  global_travelWishlist: wY,
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: kY,
  optional: xY,
  "privacy-policy": "Privacidade"
}, SY = "https://www.homeexchange.com/pt/blog/", CY = "/p/general-terms-of-use", EY = "https://www.homeexchange.com/pt/p/a-nossa-comunidade-pt", jY = "https://homeexchangehelp.zendesk.com/hc/en-us", OY = "", zY = "https://www.homeexchange.com/pt/p/service-homeexchange-pt", AY = "https://www.homeexchange.com/pt/p/os-guestpoints", PY = "https://www.homeexchange.com/pt/p/press-pt", DY = "https://www.homeexchange.com/p/palavras-de-homeexchangers", NY = "", RY = "", IY = "https://www.homeexchange.com/pt/p/onde-as-boas-vindas-comecam", TY = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/pt/p/about-us-pt",
  blog: SY,
  cgu: CY,
  community: EY,
  "contact-us": "https://www.homeexchange.com/pt/contactos-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: jY,
  forum: OY,
  guarantees: zY,
  guestpoints: AY,
  "happiness-team": "https://www.homeexchange.com/pt/p/happiness-team-pt",
  "how-it-works": "https://www.homeexchange.com/pt/p/como-funciona-homeexchange",
  "join-us": "https://www.homeexchange.com/pt/p/join-us-pt",
  "legal-notice": "/p/mencoes-legais",
  "mobile-app": "https://www.homeexchange.com/pt/p/app-homeexchange",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: PY,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/pt/p/subscription-homeexchange-pt",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: DY,
  travelWishlist_faq_links: NY,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: RY,
  values: IY
}, LY = "", MY = "", WY = "Criar nova ideia de viagem", BY = "As ideias de viagens atualizadas permitem-lhe receber mais pedidos de trocas recíprocas.", FY = "Tem a certeza de que pretende eliminar {{fullAddress}}?", VY = "Estes são os filtros que selecionou. Se tiver mudado de ideias, pode eliminar alguns deles abaixo. Contudo, se quiser adicionar outros filtros, terá de iniciar uma nova pesquisa (contudo, isto será alterado em breve... mantenha-se a par)!", UY = "Pode ser um país, cidade ou região. Se optar por uma localização mais ampla, os resultados podem ser menos precisos.", qY = "Escreva um país, cidade ou região", HY = "Ver casas disponíveis", GY = "Quando existirem casas com disponibilidade correspondentes aos seus planos de viagem.", KY = "Criar nova ideia de viagem", JY = "{{fullAddress}} foi eliminada das suas ideias de viagens.", ZY = "Selecione as suas datas de viagem ideais (flexíveis ou fixas).", YY = "Adicione detalhes, para ajudar as pessoas que utilizam a funcionalidade de busca invertida a perceber porque tem interesse na respetiva região.", XY = "Especifique quantas pessoas vão viajar consigo.", QY = "Ups! Não foi possível guardar {{fullAddress}} nas suas ideias de viagens devido a um motivo inesperado.", eX = "Diga-nos para onde e quando quer viajar para receber pedidos de troca e alertas quando se tornarem disponíveis casas correspondentes. Vamos guardar estas pesquisas nas suas ideias de viagens!", tX = "Existem aventuras de viagens que queira começar a planear?", aX = "<updateDates>Atualize as datas</updateDates> para continuar a receber alertas relevantes por e-mail ou <delete>elimine este destino</delete> das suas ideias de viagens se já não está a considerá-lo.", oX = "Estas datas já passaram", nX = "{{fullAddress}} foi adicionada às suas ideias de viagens!", rX = "{{fullAddress}} foi atualizada com sucesso.", iX = "A sua pesquisa foi guardada e o calendário foi atualizado!", sX = "A sua pesquisa foi guardada. Encontre-a nas suas ideias de viagens.", lX = "Saiba mais sobre as ideias de viagens", cX = {
  firstname: LY,
  lastname: MY,
  modal_travelWishlist_addNew_title: WY,
  modal_travelWishlist_delete_body: BY,
  modal_travelWishlist_delete_title: FY,
  modal_travelWishlist_filtersApplied_helper: VY,
  modal_travelWishlist_location_helper: UY,
  modal_travelWishlist_searchBar_placeholder: qY,
  page_travelWishlist_card_cta: HY,
  page_travelWishlist_card_emailAlerts_helper: GY,
  page_travelWishlist_cta: KY,
  page_travelWishlist_deleted_toast: JY,
  page_travelWishlist_edit_dates_helper: ZY,
  page_travelWishlist_edit_description_helper: YY,
  page_travelWishlist_edit_guests_helper: XY,
  page_travelWishlist_error_toast: QY,
  page_travelWishlist_none_body: eX,
  page_travelWishlist_none_subheader: tX,
  page_travelWishlist_pastDates_desc: aX,
  page_travelWishlist_pastDates_title: oX,
  page_travelWishlist_saved_toast: nX,
  page_travelWishlist_updated_toast: rX,
  search_travelWishlist_calendarUpdated_toast: iX,
  search_travelWishlist_saved_toast: sX,
  travelWishlist_faq: lX
}, uX = "Studio", dX = "{{count}} sovrum", gX = "{{count}} sovrum", hX = "", pX = "{{count}} säng", mX = "{{count}} sängar", fX = "Vuxna", bX = "Småbarn", _X = "Din kalender har uppdaterats.", vX = "En månad", yX = "Exakta datum", wX = "En vecka", kX = "En helg", xX = "", $X = "± {{count}} dag", SX = "± {{count}} dagar", CX = "Två veckor", EX = "Avbryt", jX = "Barn", OX = "Datum", zX = "Ta bort", AX = "Beskrivning", PX = "Resmål", DX = "Klart!", NX = "Ändra", RX = "Alla typer av hembyten", IX = "Badkar", TX = "Grill", LX = "Cykel", MX = "Bil", WX = "Katt", BX = "Stad", FX = "Landsbygd", VX = "Diskmaskin", UX = "Hund", qX = "Torktumlare", HX = "Hiss", GX = "Favorithem", KX = "Eldstad", JX = "Lägenhet", ZX = "Privat trädgård", YX = "Mindre än {{max}} GP", XX = "från {{min}} GP", QX = "Mellan {{min}} och {{max}} GuestPoints", eQ = "Hemmagym", tQ = "Hus", aQ = "Ö", oQ = "Isolerat", nQ = "Jacuzzi", rQ = "Sjö", iQ = "Collection-hem", sQ = "Berg", lQ = "{{count}} badrum", cQ = "Andra djur", uQ = "Piano", dQ = "Lekplats för barn", gQ = "Primärt", hQ = "Ömsesidigt hembyte", pQ = "Omvänd sökning", mQ = "Älv", fQ = "Kustnära", bQ = "Sekundärt", _Q = "TV", vQ = "By", yQ = "WiFi", wQ = "Filter", kQ = "Fasta datum", xQ = "En månad i {{date}}", $Q = "En helg i {{date}}", SQ = "En vecka i {{date}}", CQ = "Två veckor i {{date}}", EQ = "Flexibla datum", jQ = "Gäster", OQ = "hem", zQ = "Sista minuten", AQ = "Plats", PQ = "Ändra", DQ = "Namn", NQ = "Nästa", RQ = "", IQ = "{{count}} vuxen", TQ = "{{count}} vuxna", LQ = "", MQ = "{{count}} bebis", WQ = "{{count}} bebisar", BQ = "", FQ = "{{count}} barn", VQ = "{{count}} barn", UQ = "", qQ = "{{count}} gäst", HQ = "{{count}} gäster", GQ = "Telefonnumrets format är inte giltigt.", KQ = "Få e-postaviseringar", JQ = "Spara", ZQ = "Inga resmål hittades", YQ = "Se mer", XQ = "Reselista", QQ = "", eee = "valfritt", tee = {
  "autocomplete.button": "Sök",
  "autocomplete.placeholder": "Vart ska du ?",
  bedroomsNumbers_zero: uX,
  bedroomsNumbers_one: dX,
  bedroomsNumbers_other: gX,
  beds_zero: hX,
  beds_one: pX,
  beds_other: mX,
  "button.free-signup": "Registrera dig gratis",
  "button.validate": "Godkänn",
  "common.try-again": "Försök igen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Får inte överskrida {{limit}} tecken",
  "error.reload": "Ladda om sidan",
  "error.return-homepage": "Gå tillbaka till startsidan",
  "error.subtitle": "Tyvärr kan inte den här sidan nås.",
  "error.title": "Ett fel uppstod på sidan",
  "errors.unable_to_submit.subtitle": "Tyvärr kunde inte ditt formulär skickas in just nu. Vänligen försök igen senare.",
  "errors.unable_to_submit.title": "Hoppsan, vi har stött på ett problem",
  "global.back": "Tillbaka",
  "global.cancel": "Avbryt",
  "global.collection.browsehomes": "Se fler hem",
  "global.collection.contactus": "Kontakta oss",
  "global.confirm": "Bekräfta",
  "global.continue": "Fortsätt",
  "global.getStarted": "Kom igång",
  "global.login": "Logga in",
  "global.select": "Välj",
  global_adults: fX,
  global_babies: bX,
  global_calendarUpdated_toast: _X,
  global_calendar_aMonth: vX,
  global_calendar_exactDates: yX,
  global_calendar_oneWeek: wX,
  global_calendar_oneWeekend: kX,
  global_calendar_plusMinusDay_zero: xX,
  global_calendar_plusMinusDay_one: $X,
  global_calendar_plusMinusDay_other: SX,
  global_calendar_twoWeeks: CX,
  global_cancel: EX,
  global_children: jX,
  global_dates: OX,
  global_delete: zX,
  global_description: AX,
  global_destination: PX,
  global_done: DX,
  global_edit: NX,
  "global_filter_a-c": "Luftkonditionering",
  global_filter_available: RX,
  "global_filter_baby-bed": "Bebissäng",
  "global_filter_baby-gear": "Barnutrustning",
  "global_filter_balcony-terrace": "Balkong/terrass",
  global_filter_bathtub: IX,
  global_filter_bbq: TX,
  global_filter_bicycle: LX,
  global_filter_car: MX,
  global_filter_cat: WX,
  "global_filter_children-welcome": "Barn är välkomna",
  global_filter_cities: BX,
  "global_filter_cleaning-person": "Städare",
  global_filter_countryside: FX,
  "global_filter_dedicated-workspace": "Kontor",
  "global_filter_disabled-access": "Tillgängligt hem",
  global_filter_dishwasher: VX,
  global_filter_dog: UX,
  global_filter_dryer: qX,
  "global_filter_eco-level": "Endast hållbara hem",
  "global_filter_electric-car-plug": "Elbilsladdare",
  global_filter_elevator: HX,
  global_filter_favorite: GX,
  global_filter_fireplace: KX,
  global_filter_flat: JX,
  global_filter_garden: ZX,
  "global_filter_guest-wanted": "Hembyte för GuestPoints",
  global_filter_guestPointsMax: YX,
  global_filter_guestPointsMin: XX,
  global_filter_guestPointsMinMax: QX,
  global_filter_gym: eQ,
  "global_filter_heating-system": "Värmesystem",
  "global_filter_high-speed-connexion": "Bredband med hög hastighet",
  global_filter_home: tQ,
  "global_filter_home-verified": "Verifierade hem",
  global_filter_island: aQ,
  global_filter_isolated: oQ,
  global_filter_jacuzzi: nQ,
  "global_filter_kids-toys": "Barnleksaker",
  global_filter_lakes: rQ,
  global_filter_luxury: iQ,
  global_filter_mountains: sQ,
  "global_filter_no-bed-up": "Inga tillfälliga sängar",
  global_filter_numOfBathrooms: lQ,
  global_filter_other: cQ,
  "global_filter_parking-space": "Privat parkeringsplats",
  "global_filter_pets-welcome": "Husdjur är välkomna",
  global_filter_piano: uQ,
  global_filter_playground: dQ,
  global_filter_primary: gQ,
  "global_filter_public-transit-access": "Tillgång till kollektivtrafik",
  global_filter_reciprocal: hQ,
  "global_filter_response-rate-above-threshold": "Svarsprocent ≥ Genomsnittlig",
  global_filter_reverse: pQ,
  global_filter_river: mQ,
  global_filter_seaside: fQ,
  global_filter_secondary: bQ,
  "global_filter_secured-pool": "Säker pool",
  "global_filter_smokers-welcome": "Rökning tillåtet",
  "global_filter_swimming-pool": "Pool",
  global_filter_tv: _Q,
  global_filter_villages: vQ,
  "global_filter_washing-machine": "Tvättmaskin",
  "global_filter_whole-unit": "Hela hemmet",
  global_filter_wifi: yQ,
  global_filters: wQ,
  global_fixDates: kQ,
  global_flexDates_aMonth: xQ,
  global_flexDates_aWeekend: $Q,
  global_flexDates_oneWeek: SQ,
  global_flexDates_twoWeek: CQ,
  global_flexibleDates: EQ,
  global_guests: jQ,
  global_homes: OQ,
  global_lastMinute: zQ,
  global_location: AQ,
  global_modify: PQ,
  global_name: DQ,
  global_next: NQ,
  global_numberOfAdults_zero: RQ,
  global_numberOfAdults_one: IQ,
  global_numberOfAdults_other: TQ,
  global_numberOfBabies_zero: LQ,
  global_numberOfBabies_one: MQ,
  global_numberOfBabies_other: WQ,
  global_numberOfChildren_zero: BQ,
  global_numberOfChildren_one: FQ,
  global_numberOfChildren_other: VQ,
  global_numberOfGuests_zero: UQ,
  global_numberOfGuests_one: qQ,
  global_numberOfGuests_other: HQ,
  global_phoneNumber_notValid: GQ,
  global_receiveEmailAlerts: KQ,
  global_save: JQ,
  global_searchBar_noLocationFound: ZQ,
  global_seeMore_link: YQ,
  global_travelWishlist: XQ,
  "modal.error-occured.content": "Vi ber om ursäkt för det, men försök gärna igen.",
  "modal.error-occured.title": "Hoppsan, ett fel uppstod!",
  no_result: QQ,
  optional: eee,
  "privacy-policy": "Sekretesspolicy"
}, aee = "https://www.homeexchange.com/blog/", oee = "/p/general-terms-of-use", nee = "https://www.homeexchange.com/sv/p/natverket", ree = "https://homeexchangehelp.zendesk.com/hc/es", iee = "", see = "https://www.homeexchange.com/sv/p/service-homeexchange-sv", lee = "https://www.homeexchange.com/sv/p/guestpoints-sv", cee = "https://www.homeexchange.com/sv/p/press-sv", uee = "https://www.homeexchange.com/p/medlemmarna-har-ordet", dee = "", gee = "", hee = "https://www.homeexchange.com/sv/p/dar-valkomnandet-borjar", pee = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/sv/p/about-us-sv",
  blog: aee,
  cgu: oee,
  community: nee,
  "contact-us": "https://www.homeexchange.com/sv/kontakta-oss-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: ree,
  forum: iee,
  guarantees: see,
  guestpoints: lee,
  "happiness-team": "https://www.homeexchange.com/sv/p/happiness-team-sv",
  "how-it-works": "https://www.homeexchange.com/sv/p/hur-fungerar-det-sv",
  "join-us": "https://www.homeexchange.com/sv/p/join-us-sv",
  "legal-notice": "/p/juridisk-information",
  "mobile-app": "https://www.homeexchange.com/sv/p/app-mobil",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: cee,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/sv/p/subscription-homeexchange-sv",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: uee,
  travelWishlist_faq_links: dee,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: gee,
  values: hee
}, mee = "Förnamn", fee = "Efternamn", bee = "Skapa din reselista", _ee = "En uppdaterad reselista gör att du kan få fler ömsesidiga hembytesförslag.", vee = "Är du säker på att du vill radera {{fullAddress}}?", yee = "Det här är filtren du har valt. Om du har ändrat dig kan du ta bort några av dem nedan. Men om du vill lägga till fler måste du starta en ny sökning (detta kommer dock snart att ändras... håll utkik)!", wee = "Det kan vara ett land, en stad eller en hel region. Om du väljer en bred plats kan dina resultat bli mindre exakta.", kee = "Ange ett land, en stad eller en region", xee = "Visa tillgängliga hem", $ee = "När hem med tillgänglighet matchar dina resplaner.", See = "Skapa din reselista", Cee = "{{fullAddress}} har tagits bort från din reselista.", Eee = "Välj dina ideala resedatum (flexibla eller fasta).", jee = "Lägg till detaljer för att hjälpa andra som använder funktionen för omvänd sökning att se varför du är intresserad av deras ställe.", Oee = "Ange hur många personer som följer med dig på den här resan.", zee = "Hoppsan! {{fullAddress}} kunde inte sparas i din reselista av en oväntad anledning.", Aee = "Meddela oss när och vart du vill resa för att få hembytesförslag och aviseringar så snart passande hem blir tillgängliga. Vi sparar dina sökningar i din reselista!", Pee = "Har du några reseäventyr du vill börja planera?", Dee = "<updateDates>Uppdatera dina datum</updateDates> för att fortsätta få relevanta mejl eller <delete>ta bort det här resmålet</delete>från din reselista om du inte längre vill resa dit.", Nee = "Dessa datum har redan varit", Ree = "{{fullAddress}} har lagts till i din reselista!", Iee = "{{fullAddress}} har uppdaterats.", Tee = "Din sökning har sparats och din kalender har uppdaterats!", Lee = "Din sökning har sparats. Se den i din reselista.", Mee = "Läs mer om reselistor", Wee = {
  firstname: mee,
  lastname: fee,
  modal_travelWishlist_addNew_title: bee,
  modal_travelWishlist_delete_body: _ee,
  modal_travelWishlist_delete_title: vee,
  modal_travelWishlist_filtersApplied_helper: yee,
  modal_travelWishlist_location_helper: wee,
  modal_travelWishlist_searchBar_placeholder: kee,
  page_travelWishlist_card_cta: xee,
  page_travelWishlist_card_emailAlerts_helper: $ee,
  page_travelWishlist_cta: See,
  page_travelWishlist_deleted_toast: Cee,
  page_travelWishlist_edit_dates_helper: Eee,
  page_travelWishlist_edit_description_helper: jee,
  page_travelWishlist_edit_guests_helper: Oee,
  page_travelWishlist_error_toast: zee,
  page_travelWishlist_none_body: Aee,
  page_travelWishlist_none_subheader: Pee,
  page_travelWishlist_pastDates_desc: Dee,
  page_travelWishlist_pastDates_title: Nee,
  page_travelWishlist_saved_toast: Ree,
  page_travelWishlist_updated_toast: Iee,
  search_travelWishlist_calendarUpdated_toast: Tee,
  search_travelWishlist_saved_toast: Lee,
  travelWishlist_faq: Mee
}, Bee = "en", by = fN({
  fallbackLng: Bee,
  debug: !1,
  interpolation: {
    escapeValue: !1
  },
  returnEmptyString: !1,
  postProcess: ["newlineHandler"],
  resources: {
    da: {
      common: lI,
      user: GI,
      links: wI
    },
    de: {
      common: ML,
      user: $M,
      links: XL
    },
    en: {
      common: f2,
      user: tB,
      links: O2
    },
    es: {
      common: GF,
      user: PV,
      links: iV
    },
    fr: {
      common: $4,
      user: cU,
      links: T4
    },
    hr: {
      common: lH,
      user: GH,
      links: wH
    },
    it: {
      common: MG,
      user: $K,
      links: XG
    },
    nb: {
      common: f9,
      user: t8,
      links: O9
    },
    nl: {
      common: G7,
      user: PJ,
      links: iJ
    },
    pt: {
      common: $Y,
      user: cX,
      links: TY
    },
    sv: {
      common: tee,
      user: Wee,
      links: pee
    }
  }
});
by.use({
  name: "newlineHandler",
  type: "postProcessor",
  process: (e) => e.replace(/\\n/g, "")
});
by.init();
function Fee() {
  const [e, t] = Pe({
    width: typeof window > "u" ? void 0 : window.innerWidth,
    height: typeof window > "u" ? void 0 : window.innerHeight
  });
  return Ce(() => {
    function a() {
      t({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    return window.addEventListener("resize", a), a(), () => window.removeEventListener("resize", a);
  }, []), e;
}
function Vee() {
  const { width: e } = Fee();
  let t = "desktop";
  return e && e <= Gd.MOBILE ? t = "mobile" : e && e <= Gd.TABLET && (t = "tablet"), {
    currentWidth: e,
    currentDevice: t,
    isMobile: t === "mobile",
    isTablet: t === "tablet",
    isDesktop: t === "desktop",
    isReady: typeof window < "u"
  };
}
function Uee(e, t, a) {
  Ce(() => {
    if (window)
      return window.addEventListener(e, t, a), () => {
        window.removeEventListener(e, t, a);
      };
  }, [e, t, a]);
}
const Fh = (e) => {
  let t;
  const a = /* @__PURE__ */ new Set(), o = (c, u) => {
    const d = typeof c == "function" ? c(t) : c;
    if (!Object.is(d, t)) {
      const h = t;
      t = u ?? (typeof d != "object" || d === null) ? d : Object.assign({}, t, d), a.forEach((m) => m(t, h));
    }
  }, n = () => t, s = { setState: o, getState: n, getInitialState: () => l, subscribe: (c) => (a.add(c), () => a.delete(c)) }, l = t = e(o, n, s);
  return s;
}, _y = (e) => e ? Fh(e) : Fh, qee = (e) => e;
function vy(e, t = qee) {
  const a = ne.useSyncExternalStore(
    e.subscribe,
    ne.useCallback(() => t(e.getState()), [e, t]),
    ne.useCallback(() => t(e.getInitialState()), [e, t])
  );
  return ne.useDebugValue(a), a;
}
function Hee(e) {
  const t = {
    conversations: void 0,
    userInfos: void 0,
    apiUrl: "",
    assetsUrl: ""
  };
  return _y((a) => ({
    ...t,
    ...e,
    setNavigationBarData: (o) => a({
      conversations: o.conversations,
      userInfos: o.userInfos
    }),
    setConversations: (o) => a({ conversations: o }),
    setUserInfos: (o) => a({ userInfos: o }),
    setApiUrl: (o) => a({ apiUrl: o }),
    setAssetsUrl: (o) => a({ assetsUrl: o }),
    clear: () => a({
      conversations: void 0,
      userInfos: void 0
    })
  }));
}
const yy = Ot(void 0);
function Gee({ children: e, ...t }) {
  const a = Ie(null);
  return a.current || (a.current = Hee(t)), /* @__PURE__ */ v(yy.Provider, { value: a.current, children: e });
}
const Vh = (e) => Symbol.iterator in e, Uh = (e) => (
  // HACK: avoid checking entries type
  "entries" in e
), qh = (e, t) => {
  const a = e instanceof Map ? e : new Map(e.entries()), o = t instanceof Map ? t : new Map(t.entries());
  if (a.size !== o.size)
    return !1;
  for (const [n, r] of a)
    if (!o.has(n) || !Object.is(r, o.get(n)))
      return !1;
  return !0;
}, Kee = (e, t) => {
  const a = e[Symbol.iterator](), o = t[Symbol.iterator]();
  let n = a.next(), r = o.next();
  for (; !n.done && !r.done; ) {
    if (!Object.is(n.value, r.value))
      return !1;
    n = a.next(), r = o.next();
  }
  return !!n.done && !!r.done;
};
function Jee(e, t) {
  return Object.is(e, t) ? !0 : typeof e != "object" || e === null || typeof t != "object" || t === null || Object.getPrototypeOf(e) !== Object.getPrototypeOf(t) ? !1 : Vh(e) && Vh(t) ? Uh(e) && Uh(t) ? qh(e, t) : Kee(e, t) : qh(
    { entries: () => Object.entries(e) },
    { entries: () => Object.entries(t) }
  );
}
function wy(e) {
  const t = ne.useRef(void 0);
  return (a) => {
    const o = e(a);
    return Jee(t.current, o) ? t.current : t.current = o;
  };
}
function ro(e) {
  const t = ho(yy);
  if (!t) throw new Error("Missing NavigationContext.Provider in the tree");
  return vy(t, wy(e));
}
const ky = Ot(void 0);
function zs(e) {
  const t = ho(ky);
  if (!t) throw new Error("Missing UserContext.Provider in the tree");
  return vy(t, wy(e));
}
function Zee(e) {
  const t = {
    isSignedIn: !1
  };
  return _y((a) => ({
    ...t,
    ...e,
    setIsSignedIn: (o) => a({ isSignedIn: o }),
    signout: () => a({ isSignedIn: !1 })
  }));
}
function Yee({ children: e, ...t }) {
  const a = Ie(null);
  return a.current || (a.current = Zee(t)), /* @__PURE__ */ v(ky.Provider, { value: a.current, children: e });
}
const le = (e) => typeof e == "string", yn = () => {
  let e, t;
  const a = new Promise((o, n) => {
    e = o, t = n;
  });
  return a.resolve = e, a.reject = t, a;
}, Hh = (e) => e == null ? "" : "" + e, Xee = (e, t, a) => {
  e.forEach((o) => {
    t[o] && (a[o] = t[o]);
  });
}, Qee = /###/g, Gh = (e) => e && e.indexOf("###") > -1 ? e.replace(Qee, ".") : e, Kh = (e) => !e || le(e), Pn = (e, t, a) => {
  const o = le(t) ? t.split(".") : t;
  let n = 0;
  for (; n < o.length - 1; ) {
    if (Kh(e)) return {};
    const r = Gh(o[n]);
    !e[r] && a && (e[r] = new a()), Object.prototype.hasOwnProperty.call(e, r) ? e = e[r] : e = {}, ++n;
  }
  return Kh(e) ? {} : {
    obj: e,
    k: Gh(o[n])
  };
}, Jh = (e, t, a) => {
  const {
    obj: o,
    k: n
  } = Pn(e, t, Object);
  if (o !== void 0 || t.length === 1) {
    o[n] = a;
    return;
  }
  let r = t[t.length - 1], i = t.slice(0, t.length - 1), s = Pn(e, i, Object);
  for (; s.obj === void 0 && i.length; )
    r = `${i[i.length - 1]}.${r}`, i = i.slice(0, i.length - 1), s = Pn(e, i, Object), s?.obj && typeof s.obj[`${s.k}.${r}`] < "u" && (s.obj = void 0);
  s.obj[`${s.k}.${r}`] = a;
}, ete = (e, t, a, o) => {
  const {
    obj: n,
    k: r
  } = Pn(e, t, Object);
  n[r] = n[r] || [], n[r].push(a);
}, Ii = (e, t) => {
  const {
    obj: a,
    k: o
  } = Pn(e, t);
  if (a && Object.prototype.hasOwnProperty.call(a, o))
    return a[o];
}, tte = (e, t, a) => {
  const o = Ii(e, a);
  return o !== void 0 ? o : Ii(t, a);
}, xy = (e, t, a) => {
  for (const o in t)
    o !== "__proto__" && o !== "constructor" && (o in e ? le(e[o]) || e[o] instanceof String || le(t[o]) || t[o] instanceof String ? a && (e[o] = t[o]) : xy(e[o], t[o], a) : e[o] = t[o]);
  return e;
}, zo = (e) => e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var ate = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const ote = (e) => le(e) ? e.replace(/[&<>"'\/]/g, (t) => ate[t]) : e;
class nte {
  constructor(t) {
    this.capacity = t, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(t) {
    const a = this.regExpMap.get(t);
    if (a !== void 0)
      return a;
    const o = new RegExp(t);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(t, o), this.regExpQueue.push(t), o;
  }
}
const rte = [" ", ",", "?", "!", ";"], ite = new nte(20), ste = (e, t, a) => {
  t = t || "", a = a || "";
  const o = rte.filter((i) => t.indexOf(i) < 0 && a.indexOf(i) < 0);
  if (o.length === 0) return !0;
  const n = ite.getRegExp(`(${o.map((i) => i === "?" ? "\\?" : i).join("|")})`);
  let r = !n.test(e);
  if (!r) {
    const i = e.indexOf(a);
    i > 0 && !n.test(e.substring(0, i)) && (r = !0);
  }
  return r;
}, Oc = (e, t, a = ".") => {
  if (!e) return;
  if (e[t])
    return Object.prototype.hasOwnProperty.call(e, t) ? e[t] : void 0;
  const o = t.split(a);
  let n = e;
  for (let r = 0; r < o.length; ) {
    if (!n || typeof n != "object")
      return;
    let i, s = "";
    for (let l = r; l < o.length; ++l)
      if (l !== r && (s += a), s += o[l], i = n[s], i !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof i) > -1 && l < o.length - 1)
          continue;
        r += l - r + 1;
        break;
      }
    n = i;
  }
  return n;
}, Mn = (e) => e?.replace("_", "-"), lte = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, t) {
    console?.[e]?.apply?.(console, t);
  }
};
class Ti {
  constructor(t, a = {}) {
    this.init(t, a);
  }
  init(t, a = {}) {
    this.prefix = a.prefix || "i18next:", this.logger = t || lte, this.options = a, this.debug = a.debug;
  }
  log(...t) {
    return this.forward(t, "log", "", !0);
  }
  warn(...t) {
    return this.forward(t, "warn", "", !0);
  }
  error(...t) {
    return this.forward(t, "error", "");
  }
  deprecate(...t) {
    return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(t, a, o, n) {
    return n && !this.debug ? null : (le(t[0]) && (t[0] = `${o}${this.prefix} ${t[0]}`), this.logger[a](t));
  }
  create(t) {
    return new Ti(this.logger, {
      prefix: `${this.prefix}:${t}:`,
      ...this.options
    });
  }
  clone(t) {
    return t = t || this.options, t.prefix = t.prefix || this.prefix, new Ti(this.logger, t);
  }
}
var Jt = new Ti();
class As {
  constructor() {
    this.observers = {};
  }
  on(t, a) {
    return t.split(" ").forEach((o) => {
      this.observers[o] || (this.observers[o] = /* @__PURE__ */ new Map());
      const n = this.observers[o].get(a) || 0;
      this.observers[o].set(a, n + 1);
    }), this;
  }
  off(t, a) {
    if (this.observers[t]) {
      if (!a) {
        delete this.observers[t];
        return;
      }
      this.observers[t].delete(a);
    }
  }
  emit(t, ...a) {
    this.observers[t] && Array.from(this.observers[t].entries()).forEach(([n, r]) => {
      for (let i = 0; i < r; i++)
        n(...a);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach(([n, r]) => {
      for (let i = 0; i < r; i++)
        n.apply(n, [t, ...a]);
    });
  }
}
class Zh extends As {
  constructor(t, a = {
    ns: ["translation"],
    defaultNS: "translation"
  }) {
    super(), this.data = t || {}, this.options = a, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(t) {
    this.options.ns.indexOf(t) < 0 && this.options.ns.push(t);
  }
  removeNamespaces(t) {
    const a = this.options.ns.indexOf(t);
    a > -1 && this.options.ns.splice(a, 1);
  }
  getResource(t, a, o, n = {}) {
    const r = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, i = n.ignoreJSONStructure !== void 0 ? n.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let s;
    t.indexOf(".") > -1 ? s = t.split(".") : (s = [t, a], o && (Array.isArray(o) ? s.push(...o) : le(o) && r ? s.push(...o.split(r)) : s.push(o)));
    const l = Ii(this.data, s);
    return !l && !a && !o && t.indexOf(".") > -1 && (t = s[0], a = s[1], o = s.slice(2).join(".")), l || !i || !le(o) ? l : Oc(this.data?.[t]?.[a], o, r);
  }
  addResource(t, a, o, n, r = {
    silent: !1
  }) {
    const i = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator;
    let s = [t, a];
    o && (s = s.concat(i ? o.split(i) : o)), t.indexOf(".") > -1 && (s = t.split("."), n = a, a = s[1]), this.addNamespaces(a), Jh(this.data, s, n), r.silent || this.emit("added", t, a, o, n);
  }
  addResources(t, a, o, n = {
    silent: !1
  }) {
    for (const r in o)
      (le(o[r]) || Array.isArray(o[r])) && this.addResource(t, a, r, o[r], {
        silent: !0
      });
    n.silent || this.emit("added", t, a, o);
  }
  addResourceBundle(t, a, o, n, r, i = {
    silent: !1,
    skipCopy: !1
  }) {
    let s = [t, a];
    t.indexOf(".") > -1 && (s = t.split("."), n = o, o = a, a = s[1]), this.addNamespaces(a);
    let l = Ii(this.data, s) || {};
    i.skipCopy || (o = JSON.parse(JSON.stringify(o))), n ? xy(l, o, r) : l = {
      ...l,
      ...o
    }, Jh(this.data, s, l), i.silent || this.emit("added", t, a, o);
  }
  removeResourceBundle(t, a) {
    this.hasResourceBundle(t, a) && delete this.data[t][a], this.removeNamespaces(a), this.emit("removed", t, a);
  }
  hasResourceBundle(t, a) {
    return this.getResource(t, a) !== void 0;
  }
  getResourceBundle(t, a) {
    return a || (a = this.options.defaultNS), this.getResource(t, a);
  }
  getDataByLanguage(t) {
    return this.data[t];
  }
  hasLanguageSomeTranslations(t) {
    const a = this.getDataByLanguage(t);
    return !!(a && Object.keys(a) || []).find((n) => a[n] && Object.keys(a[n]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var $y = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, t, a, o, n) {
    return e.forEach((r) => {
      t = this.processors[r]?.process(t, a, o, n) ?? t;
    }), t;
  }
};
const Sy = Symbol("i18next/PATH_KEY");
function cte() {
  const e = [], t = /* @__PURE__ */ Object.create(null);
  let a;
  return t.get = (o, n) => (a?.revoke?.(), n === Sy ? e : (e.push(n), a = Proxy.revocable(o, t), a.proxy)), Proxy.revocable(/* @__PURE__ */ Object.create(null), t).proxy;
}
function zc(e, t) {
  const {
    [Sy]: a
  } = e(cte());
  return a.join(t?.keySeparator ?? ".");
}
const Yh = {}, Xh = (e) => !le(e) && typeof e != "boolean" && typeof e != "number";
class Li extends As {
  constructor(t, a = {}) {
    super(), Xee(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], t, this), this.options = a, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = Jt.create("translator");
  }
  changeLanguage(t) {
    t && (this.language = t);
  }
  exists(t, a = {
    interpolation: {}
  }) {
    const o = {
      ...a
    };
    return t == null ? !1 : this.resolve(t, o)?.res !== void 0;
  }
  extractFromKey(t, a) {
    let o = a.nsSeparator !== void 0 ? a.nsSeparator : this.options.nsSeparator;
    o === void 0 && (o = ":");
    const n = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator;
    let r = a.ns || this.options.defaultNS || [];
    const i = o && t.indexOf(o) > -1, s = !this.options.userDefinedKeySeparator && !a.keySeparator && !this.options.userDefinedNsSeparator && !a.nsSeparator && !ste(t, o, n);
    if (i && !s) {
      const l = t.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: t,
          namespaces: le(r) ? [r] : r
        };
      const c = t.split(o);
      (o !== n || o === n && this.options.ns.indexOf(c[0]) > -1) && (r = c.shift()), t = c.join(n);
    }
    return {
      key: t,
      namespaces: le(r) ? [r] : r
    };
  }
  translate(t, a, o) {
    let n = typeof a == "object" ? {
      ...a
    } : a;
    if (typeof n != "object" && this.options.overloadTranslationOptionHandler && (n = this.options.overloadTranslationOptionHandler(arguments)), typeof n == "object" && (n = {
      ...n
    }), n || (n = {}), t == null) return "";
    typeof t == "function" && (t = zc(t, {
      ...this.options,
      ...n
    })), Array.isArray(t) || (t = [String(t)]);
    const r = n.returnDetails !== void 0 ? n.returnDetails : this.options.returnDetails, i = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, {
      key: s,
      namespaces: l
    } = this.extractFromKey(t[t.length - 1], n), c = l[l.length - 1];
    let u = n.nsSeparator !== void 0 ? n.nsSeparator : this.options.nsSeparator;
    u === void 0 && (u = ":");
    const d = n.lng || this.language, h = n.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (d?.toLowerCase() === "cimode")
      return h ? r ? {
        res: `${c}${u}${s}`,
        usedKey: s,
        exactUsedKey: s,
        usedLng: d,
        usedNS: c,
        usedParams: this.getUsedParamsDetails(n)
      } : `${c}${u}${s}` : r ? {
        res: s,
        usedKey: s,
        exactUsedKey: s,
        usedLng: d,
        usedNS: c,
        usedParams: this.getUsedParamsDetails(n)
      } : s;
    const m = this.resolve(t, n);
    let f = m?.res;
    const p = m?.usedKey || s, b = m?.exactUsedKey || s, w = ["[object Number]", "[object Function]", "[object RegExp]"], _ = n.joinArrays !== void 0 ? n.joinArrays : this.options.joinArrays, y = !this.i18nFormat || this.i18nFormat.handleAsObject, k = n.count !== void 0 && !le(n.count), x = Li.hasDefaultValue(n), S = k ? this.pluralResolver.getSuffix(d, n.count, n) : "", $ = n.ordinal && k ? this.pluralResolver.getSuffix(d, n.count, {
      ordinal: !1
    }) : "", E = k && !n.ordinal && n.count === 0, C = E && n[`defaultValue${this.options.pluralSeparator}zero`] || n[`defaultValue${S}`] || n[`defaultValue${$}`] || n.defaultValue;
    let j = f;
    y && !f && x && (j = C);
    const R = Xh(j), H = Object.prototype.toString.apply(j);
    if (y && j && R && w.indexOf(H) < 0 && !(le(_) && Array.isArray(j))) {
      if (!n.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const L = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(p, j, {
          ...n,
          ns: l
        }) : `key '${s} (${this.language})' returned an object instead of string.`;
        return r ? (m.res = L, m.usedParams = this.getUsedParamsDetails(n), m) : L;
      }
      if (i) {
        const L = Array.isArray(j), O = L ? [] : {}, U = L ? b : p;
        for (const I in j)
          if (Object.prototype.hasOwnProperty.call(j, I)) {
            const K = `${U}${i}${I}`;
            x && !f ? O[I] = this.translate(K, {
              ...n,
              defaultValue: Xh(C) ? C[I] : void 0,
              joinArrays: !1,
              ns: l
            }) : O[I] = this.translate(K, {
              ...n,
              joinArrays: !1,
              ns: l
            }), O[I] === K && (O[I] = j[I]);
          }
        f = O;
      }
    } else if (y && le(_) && Array.isArray(f))
      f = f.join(_), f && (f = this.extendTranslation(f, t, n, o));
    else {
      let L = !1, O = !1;
      !this.isValidLookup(f) && x && (L = !0, f = C), this.isValidLookup(f) || (O = !0, f = s);
      const I = (n.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && O ? void 0 : f, K = x && C !== f && this.options.updateMissing;
      if (O || L || K) {
        if (this.logger.log(K ? "updateKey" : "missingKey", d, c, s, K ? C : f), i) {
          const z = this.resolve(s, {
            ...n,
            keySeparator: !1
          });
          z && z.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let q = [];
        const te = this.languageUtils.getFallbackCodes(this.options.fallbackLng, n.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && te && te[0])
          for (let z = 0; z < te.length; z++)
            q.push(te[z]);
        else this.options.saveMissingTo === "all" ? q = this.languageUtils.toResolveHierarchy(n.lng || this.language) : q.push(n.lng || this.language);
        const A = (z, N, B) => {
          const W = x && B !== f ? B : I;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(z, c, N, W, K, n) : this.backendConnector?.saveMissing && this.backendConnector.saveMissing(z, c, N, W, K, n), this.emit("missingKey", z, c, N, f);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && k ? q.forEach((z) => {
          const N = this.pluralResolver.getSuffixes(z, n);
          E && n[`defaultValue${this.options.pluralSeparator}zero`] && N.indexOf(`${this.options.pluralSeparator}zero`) < 0 && N.push(`${this.options.pluralSeparator}zero`), N.forEach((B) => {
            A([z], s + B, n[`defaultValue${B}`] || C);
          });
        }) : A(q, s, C));
      }
      f = this.extendTranslation(f, t, n, m, o), O && f === s && this.options.appendNamespaceToMissingKey && (f = `${c}${u}${s}`), (O || L) && this.options.parseMissingKeyHandler && (f = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${c}${u}${s}` : s, L ? f : void 0, n));
    }
    return r ? (m.res = f, m.usedParams = this.getUsedParamsDetails(n), m) : f;
  }
  extendTranslation(t, a, o, n, r) {
    if (this.i18nFormat?.parse)
      t = this.i18nFormat.parse(t, {
        ...this.options.interpolation.defaultVariables,
        ...o
      }, o.lng || this.language || n.usedLng, n.usedNS, n.usedKey, {
        resolved: n
      });
    else if (!o.skipInterpolation) {
      o.interpolation && this.interpolator.init({
        ...o,
        interpolation: {
          ...this.options.interpolation,
          ...o.interpolation
        }
      });
      const l = le(t) && (o?.interpolation?.skipOnVariables !== void 0 ? o.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let c;
      if (l) {
        const d = t.match(this.interpolator.nestingRegexp);
        c = d && d.length;
      }
      let u = o.replace && !le(o.replace) ? o.replace : o;
      if (this.options.interpolation.defaultVariables && (u = {
        ...this.options.interpolation.defaultVariables,
        ...u
      }), t = this.interpolator.interpolate(t, u, o.lng || this.language || n.usedLng, o), l) {
        const d = t.match(this.interpolator.nestingRegexp), h = d && d.length;
        c < h && (o.nest = !1);
      }
      !o.lng && n && n.res && (o.lng = this.language || n.usedLng), o.nest !== !1 && (t = this.interpolator.nest(t, (...d) => r?.[0] === d[0] && !o.context ? (this.logger.warn(`It seems you are nesting recursively key: ${d[0]} in key: ${a[0]}`), null) : this.translate(...d, a), o)), o.interpolation && this.interpolator.reset();
    }
    const i = o.postProcess || this.options.postProcess, s = le(i) ? [i] : i;
    return t != null && s?.length && o.applyPostProcessor !== !1 && (t = $y.handle(s, t, a, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...n,
        usedParams: this.getUsedParamsDetails(o)
      },
      ...o
    } : o, this)), t;
  }
  resolve(t, a = {}) {
    let o, n, r, i, s;
    return le(t) && (t = [t]), t.forEach((l) => {
      if (this.isValidLookup(o)) return;
      const c = this.extractFromKey(l, a), u = c.key;
      n = u;
      let d = c.namespaces;
      this.options.fallbackNS && (d = d.concat(this.options.fallbackNS));
      const h = a.count !== void 0 && !le(a.count), m = h && !a.ordinal && a.count === 0, f = a.context !== void 0 && (le(a.context) || typeof a.context == "number") && a.context !== "", p = a.lngs ? a.lngs : this.languageUtils.toResolveHierarchy(a.lng || this.language, a.fallbackLng);
      d.forEach((b) => {
        this.isValidLookup(o) || (s = b, !Yh[`${p[0]}-${b}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(s) && (Yh[`${p[0]}-${b}`] = !0, this.logger.warn(`key "${n}" for languages "${p.join(", ")}" won't get resolved as namespace "${s}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), p.forEach((w) => {
          if (this.isValidLookup(o)) return;
          i = w;
          const _ = [u];
          if (this.i18nFormat?.addLookupKeys)
            this.i18nFormat.addLookupKeys(_, u, w, b, a);
          else {
            let k;
            h && (k = this.pluralResolver.getSuffix(w, a.count, a));
            const x = `${this.options.pluralSeparator}zero`, S = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (h && (a.ordinal && k.indexOf(S) === 0 && _.push(u + k.replace(S, this.options.pluralSeparator)), _.push(u + k), m && _.push(u + x)), f) {
              const $ = `${u}${this.options.contextSeparator || "_"}${a.context}`;
              _.push($), h && (a.ordinal && k.indexOf(S) === 0 && _.push($ + k.replace(S, this.options.pluralSeparator)), _.push($ + k), m && _.push($ + x));
            }
          }
          let y;
          for (; y = _.pop(); )
            this.isValidLookup(o) || (r = y, o = this.getResource(w, b, y, a));
        }));
      });
    }), {
      res: o,
      usedKey: n,
      exactUsedKey: r,
      usedLng: i,
      usedNS: s
    };
  }
  isValidLookup(t) {
    return t !== void 0 && !(!this.options.returnNull && t === null) && !(!this.options.returnEmptyString && t === "");
  }
  getResource(t, a, o, n = {}) {
    return this.i18nFormat?.getResource ? this.i18nFormat.getResource(t, a, o, n) : this.resourceStore.getResource(t, a, o, n);
  }
  getUsedParamsDetails(t = {}) {
    const a = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], o = t.replace && !le(t.replace);
    let n = o ? t.replace : t;
    if (o && typeof t.count < "u" && (n.count = t.count), this.options.interpolation.defaultVariables && (n = {
      ...this.options.interpolation.defaultVariables,
      ...n
    }), !o) {
      n = {
        ...n
      };
      for (const r of a)
        delete n[r];
    }
    return n;
  }
  static hasDefaultValue(t) {
    const a = "defaultValue";
    for (const o in t)
      if (Object.prototype.hasOwnProperty.call(t, o) && a === o.substring(0, a.length) && t[o] !== void 0)
        return !0;
    return !1;
  }
}
class Qh {
  constructor(t) {
    this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Jt.create("languageUtils");
  }
  getScriptPartFromCode(t) {
    if (t = Mn(t), !t || t.indexOf("-") < 0) return null;
    const a = t.split("-");
    return a.length === 2 || (a.pop(), a[a.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(a.join("-"));
  }
  getLanguagePartFromCode(t) {
    if (t = Mn(t), !t || t.indexOf("-") < 0) return t;
    const a = t.split("-");
    return this.formatLanguageCode(a[0]);
  }
  formatLanguageCode(t) {
    if (le(t) && t.indexOf("-") > -1) {
      let a;
      try {
        a = Intl.getCanonicalLocales(t)[0];
      } catch {
      }
      return a && this.options.lowerCaseLng && (a = a.toLowerCase()), a || (this.options.lowerCaseLng ? t.toLowerCase() : t);
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? t.toLowerCase() : t;
  }
  isSupportedCode(t) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (t = this.getLanguagePartFromCode(t)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(t) > -1;
  }
  getBestMatchFromCodes(t) {
    if (!t) return null;
    let a;
    return t.forEach((o) => {
      if (a) return;
      const n = this.formatLanguageCode(o);
      (!this.options.supportedLngs || this.isSupportedCode(n)) && (a = n);
    }), !a && this.options.supportedLngs && t.forEach((o) => {
      if (a) return;
      const n = this.getScriptPartFromCode(o);
      if (this.isSupportedCode(n)) return a = n;
      const r = this.getLanguagePartFromCode(o);
      if (this.isSupportedCode(r)) return a = r;
      a = this.options.supportedLngs.find((i) => {
        if (i === r) return i;
        if (!(i.indexOf("-") < 0 && r.indexOf("-") < 0) && (i.indexOf("-") > 0 && r.indexOf("-") < 0 && i.substring(0, i.indexOf("-")) === r || i.indexOf(r) === 0 && r.length > 1))
          return i;
      });
    }), a || (a = this.getFallbackCodes(this.options.fallbackLng)[0]), a;
  }
  getFallbackCodes(t, a) {
    if (!t) return [];
    if (typeof t == "function" && (t = t(a)), le(t) && (t = [t]), Array.isArray(t)) return t;
    if (!a) return t.default || [];
    let o = t[a];
    return o || (o = t[this.getScriptPartFromCode(a)]), o || (o = t[this.formatLanguageCode(a)]), o || (o = t[this.getLanguagePartFromCode(a)]), o || (o = t.default), o || [];
  }
  toResolveHierarchy(t, a) {
    const o = this.getFallbackCodes((a === !1 ? [] : a) || this.options.fallbackLng || [], t), n = [], r = (i) => {
      i && (this.isSupportedCode(i) ? n.push(i) : this.logger.warn(`rejecting language code not found in supportedLngs: ${i}`));
    };
    return le(t) && (t.indexOf("-") > -1 || t.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && r(this.formatLanguageCode(t)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && r(this.getScriptPartFromCode(t)), this.options.load !== "currentOnly" && r(this.getLanguagePartFromCode(t))) : le(t) && r(this.formatLanguageCode(t)), o.forEach((i) => {
      n.indexOf(i) < 0 && r(this.formatLanguageCode(i));
    }), n;
  }
}
const ep = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, tp = {
  select: (e) => e === 1 ? "one" : "other",
  resolvedOptions: () => ({
    pluralCategories: ["one", "other"]
  })
};
class ute {
  constructor(t, a = {}) {
    this.languageUtils = t, this.options = a, this.logger = Jt.create("pluralResolver"), this.pluralRulesCache = {};
  }
  addRule(t, a) {
    this.rules[t] = a;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(t, a = {}) {
    const o = Mn(t === "dev" ? "en" : t), n = a.ordinal ? "ordinal" : "cardinal", r = JSON.stringify({
      cleanedCode: o,
      type: n
    });
    if (r in this.pluralRulesCache)
      return this.pluralRulesCache[r];
    let i;
    try {
      i = new Intl.PluralRules(o, {
        type: n
      });
    } catch {
      if (!Intl)
        return this.logger.error("No Intl support, please use an Intl polyfill!"), tp;
      if (!t.match(/-|_/)) return tp;
      const l = this.languageUtils.getLanguagePartFromCode(t);
      i = this.getRule(l, a);
    }
    return this.pluralRulesCache[r] = i, i;
  }
  needsPlural(t, a = {}) {
    let o = this.getRule(t, a);
    return o || (o = this.getRule("dev", a)), o?.resolvedOptions().pluralCategories.length > 1;
  }
  getPluralFormsOfKey(t, a, o = {}) {
    return this.getSuffixes(t, o).map((n) => `${a}${n}`);
  }
  getSuffixes(t, a = {}) {
    let o = this.getRule(t, a);
    return o || (o = this.getRule("dev", a)), o ? o.resolvedOptions().pluralCategories.sort((n, r) => ep[n] - ep[r]).map((n) => `${this.options.prepend}${a.ordinal ? `ordinal${this.options.prepend}` : ""}${n}`) : [];
  }
  getSuffix(t, a, o = {}) {
    const n = this.getRule(t, o);
    return n ? `${this.options.prepend}${o.ordinal ? `ordinal${this.options.prepend}` : ""}${n.select(a)}` : (this.logger.warn(`no plural rule found for: ${t}`), this.getSuffix("dev", a, o));
  }
}
const ap = (e, t, a, o = ".", n = !0) => {
  let r = tte(e, t, a);
  return !r && n && le(a) && (r = Oc(e, a, o), r === void 0 && (r = Oc(t, a, o))), r;
}, Ol = (e) => e.replace(/\$/g, "$$$$");
class dte {
  constructor(t = {}) {
    this.logger = Jt.create("interpolator"), this.options = t, this.format = t?.interpolation?.format || ((a) => a), this.init(t);
  }
  init(t = {}) {
    t.interpolation || (t.interpolation = {
      escapeValue: !0
    });
    const {
      escape: a,
      escapeValue: o,
      useRawValueToEscape: n,
      prefix: r,
      prefixEscaped: i,
      suffix: s,
      suffixEscaped: l,
      formatSeparator: c,
      unescapeSuffix: u,
      unescapePrefix: d,
      nestingPrefix: h,
      nestingPrefixEscaped: m,
      nestingSuffix: f,
      nestingSuffixEscaped: p,
      nestingOptionsSeparator: b,
      maxReplaces: w,
      alwaysFormat: _
    } = t.interpolation;
    this.escape = a !== void 0 ? a : ote, this.escapeValue = o !== void 0 ? o : !0, this.useRawValueToEscape = n !== void 0 ? n : !1, this.prefix = r ? zo(r) : i || "{{", this.suffix = s ? zo(s) : l || "}}", this.formatSeparator = c || ",", this.unescapePrefix = u ? "" : d || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u || "", this.nestingPrefix = h ? zo(h) : m || zo("$t("), this.nestingSuffix = f ? zo(f) : p || zo(")"), this.nestingOptionsSeparator = b || ",", this.maxReplaces = w || 1e3, this.alwaysFormat = _ !== void 0 ? _ : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const t = (a, o) => a?.source === o ? (a.lastIndex = 0, a) : new RegExp(o, "g");
    this.regexp = t(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = t(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = t(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
  }
  interpolate(t, a, o, n) {
    let r, i, s;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, c = (m) => {
      if (m.indexOf(this.formatSeparator) < 0) {
        const w = ap(a, l, m, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(w, void 0, o, {
          ...n,
          ...a,
          interpolationkey: m
        }) : w;
      }
      const f = m.split(this.formatSeparator), p = f.shift().trim(), b = f.join(this.formatSeparator).trim();
      return this.format(ap(a, l, p, this.options.keySeparator, this.options.ignoreJSONStructure), b, o, {
        ...n,
        ...a,
        interpolationkey: p
      });
    };
    this.resetRegExp();
    const u = n?.missingInterpolationHandler || this.options.missingInterpolationHandler, d = n?.interpolation?.skipOnVariables !== void 0 ? n.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (m) => Ol(m)
    }, {
      regex: this.regexp,
      safeValue: (m) => this.escapeValue ? Ol(this.escape(m)) : Ol(m)
    }].forEach((m) => {
      for (s = 0; r = m.regex.exec(t); ) {
        const f = r[1].trim();
        if (i = c(f), i === void 0)
          if (typeof u == "function") {
            const b = u(t, r, n);
            i = le(b) ? b : "";
          } else if (n && Object.prototype.hasOwnProperty.call(n, f))
            i = "";
          else if (d) {
            i = r[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${f} for interpolating ${t}`), i = "";
        else !le(i) && !this.useRawValueToEscape && (i = Hh(i));
        const p = m.safeValue(i);
        if (t = t.replace(r[0], p), d ? (m.regex.lastIndex += i.length, m.regex.lastIndex -= r[0].length) : m.regex.lastIndex = 0, s++, s >= this.maxReplaces)
          break;
      }
    }), t;
  }
  nest(t, a, o = {}) {
    let n, r, i;
    const s = (l, c) => {
      const u = this.nestingOptionsSeparator;
      if (l.indexOf(u) < 0) return l;
      const d = l.split(new RegExp(`${u}[ ]*{`));
      let h = `{${d[1]}`;
      l = d[0], h = this.interpolate(h, i);
      const m = h.match(/'/g), f = h.match(/"/g);
      ((m?.length ?? 0) % 2 === 0 && !f || f.length % 2 !== 0) && (h = h.replace(/'/g, '"'));
      try {
        i = JSON.parse(h), c && (i = {
          ...c,
          ...i
        });
      } catch (p) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, p), `${l}${u}${h}`;
      }
      return i.defaultValue && i.defaultValue.indexOf(this.prefix) > -1 && delete i.defaultValue, l;
    };
    for (; n = this.nestingRegexp.exec(t); ) {
      let l = [];
      i = {
        ...o
      }, i = i.replace && !le(i.replace) ? i.replace : i, i.applyPostProcessor = !1, delete i.defaultValue;
      const c = /{.*}/.test(n[1]) ? n[1].lastIndexOf("}") + 1 : n[1].indexOf(this.formatSeparator);
      if (c !== -1 && (l = n[1].slice(c).split(this.formatSeparator).map((u) => u.trim()).filter(Boolean), n[1] = n[1].slice(0, c)), r = a(s.call(this, n[1].trim(), i), i), r && n[0] === t && !le(r)) return r;
      le(r) || (r = Hh(r)), r || (this.logger.warn(`missed to resolve ${n[1]} for nesting ${t}`), r = ""), l.length && (r = l.reduce((u, d) => this.format(u, d, o.lng, {
        ...o,
        interpolationkey: n[1].trim()
      }), r.trim())), t = t.replace(n[0], r), this.regexp.lastIndex = 0;
    }
    return t;
  }
}
const gte = (e) => {
  let t = e.toLowerCase().trim();
  const a = {};
  if (e.indexOf("(") > -1) {
    const o = e.split("(");
    t = o[0].toLowerCase().trim();
    const n = o[1].substring(0, o[1].length - 1);
    t === "currency" && n.indexOf(":") < 0 ? a.currency || (a.currency = n.trim()) : t === "relativetime" && n.indexOf(":") < 0 ? a.range || (a.range = n.trim()) : n.split(";").forEach((i) => {
      if (i) {
        const [s, ...l] = i.split(":"), c = l.join(":").trim().replace(/^'+|'+$/g, ""), u = s.trim();
        a[u] || (a[u] = c), c === "false" && (a[u] = !1), c === "true" && (a[u] = !0), isNaN(c) || (a[u] = parseInt(c, 10));
      }
    });
  }
  return {
    formatName: t,
    formatOptions: a
  };
}, op = (e) => {
  const t = {};
  return (a, o, n) => {
    let r = n;
    n && n.interpolationkey && n.formatParams && n.formatParams[n.interpolationkey] && n[n.interpolationkey] && (r = {
      ...r,
      [n.interpolationkey]: void 0
    });
    const i = o + JSON.stringify(r);
    let s = t[i];
    return s || (s = e(Mn(o), n), t[i] = s), s(a);
  };
}, hte = (e) => (t, a, o) => e(Mn(a), o)(t);
class pte {
  constructor(t = {}) {
    this.logger = Jt.create("formatter"), this.options = t, this.init(t);
  }
  init(t, a = {
    interpolation: {}
  }) {
    this.formatSeparator = a.interpolation.formatSeparator || ",";
    const o = a.cacheInBuiltFormats ? op : hte;
    this.formats = {
      number: o((n, r) => {
        const i = new Intl.NumberFormat(n, {
          ...r
        });
        return (s) => i.format(s);
      }),
      currency: o((n, r) => {
        const i = new Intl.NumberFormat(n, {
          ...r,
          style: "currency"
        });
        return (s) => i.format(s);
      }),
      datetime: o((n, r) => {
        const i = new Intl.DateTimeFormat(n, {
          ...r
        });
        return (s) => i.format(s);
      }),
      relativetime: o((n, r) => {
        const i = new Intl.RelativeTimeFormat(n, {
          ...r
        });
        return (s) => i.format(s, r.range || "day");
      }),
      list: o((n, r) => {
        const i = new Intl.ListFormat(n, {
          ...r
        });
        return (s) => i.format(s);
      })
    };
  }
  add(t, a) {
    this.formats[t.toLowerCase().trim()] = a;
  }
  addCached(t, a) {
    this.formats[t.toLowerCase().trim()] = op(a);
  }
  format(t, a, o, n = {}) {
    const r = a.split(this.formatSeparator);
    if (r.length > 1 && r[0].indexOf("(") > 1 && r[0].indexOf(")") < 0 && r.find((s) => s.indexOf(")") > -1)) {
      const s = r.findIndex((l) => l.indexOf(")") > -1);
      r[0] = [r[0], ...r.splice(1, s)].join(this.formatSeparator);
    }
    return r.reduce((s, l) => {
      const {
        formatName: c,
        formatOptions: u
      } = gte(l);
      if (this.formats[c]) {
        let d = s;
        try {
          const h = n?.formatParams?.[n.interpolationkey] || {}, m = h.locale || h.lng || n.locale || n.lng || o;
          d = this.formats[c](s, m, {
            ...u,
            ...n,
            ...h
          });
        } catch (h) {
          this.logger.warn(h);
        }
        return d;
      } else
        this.logger.warn(`there was no format function for ${c}`);
      return s;
    }, t);
  }
}
const mte = (e, t) => {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
};
class fte extends As {
  constructor(t, a, o, n = {}) {
    super(), this.backend = t, this.store = a, this.services = o, this.languageUtils = o.languageUtils, this.options = n, this.logger = Jt.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = n.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = n.maxRetries >= 0 ? n.maxRetries : 5, this.retryTimeout = n.retryTimeout >= 1 ? n.retryTimeout : 350, this.state = {}, this.queue = [], this.backend?.init?.(o, n.backend, n);
  }
  queueLoad(t, a, o, n) {
    const r = {}, i = {}, s = {}, l = {};
    return t.forEach((c) => {
      let u = !0;
      a.forEach((d) => {
        const h = `${c}|${d}`;
        !o.reload && this.store.hasResourceBundle(c, d) ? this.state[h] = 2 : this.state[h] < 0 || (this.state[h] === 1 ? i[h] === void 0 && (i[h] = !0) : (this.state[h] = 1, u = !1, i[h] === void 0 && (i[h] = !0), r[h] === void 0 && (r[h] = !0), l[d] === void 0 && (l[d] = !0)));
      }), u || (s[c] = !0);
    }), (Object.keys(r).length || Object.keys(i).length) && this.queue.push({
      pending: i,
      pendingCount: Object.keys(i).length,
      loaded: {},
      errors: [],
      callback: n
    }), {
      toLoad: Object.keys(r),
      pending: Object.keys(i),
      toLoadLanguages: Object.keys(s),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(t, a, o) {
    const n = t.split("|"), r = n[0], i = n[1];
    a && this.emit("failedLoading", r, i, a), !a && o && this.store.addResourceBundle(r, i, o, void 0, void 0, {
      skipCopy: !0
    }), this.state[t] = a ? -1 : 2, a && o && (this.state[t] = 0);
    const s = {};
    this.queue.forEach((l) => {
      ete(l.loaded, [r], i), mte(l, t), a && l.errors.push(a), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((c) => {
        s[c] || (s[c] = {});
        const u = l.loaded[c];
        u.length && u.forEach((d) => {
          s[c][d] === void 0 && (s[c][d] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", s), this.queue = this.queue.filter((l) => !l.done);
  }
  read(t, a, o, n = 0, r = this.retryTimeout, i) {
    if (!t.length) return i(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: t,
        ns: a,
        fcName: o,
        tried: n,
        wait: r,
        callback: i
      });
      return;
    }
    this.readingCalls++;
    const s = (c, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const d = this.waitingReads.shift();
        this.read(d.lng, d.ns, d.fcName, d.tried, d.wait, d.callback);
      }
      if (c && u && n < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, t, a, o, n + 1, r * 2, i);
        }, r);
        return;
      }
      i(c, u);
    }, l = this.backend[o].bind(this.backend);
    if (l.length === 2) {
      try {
        const c = l(t, a);
        c && typeof c.then == "function" ? c.then((u) => s(null, u)).catch(s) : s(null, c);
      } catch (c) {
        s(c);
      }
      return;
    }
    return l(t, a, s);
  }
  prepareLoading(t, a, o = {}, n) {
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), n && n();
    le(t) && (t = this.languageUtils.toResolveHierarchy(t)), le(a) && (a = [a]);
    const r = this.queueLoad(t, a, o, n);
    if (!r.toLoad.length)
      return r.pending.length || n(), null;
    r.toLoad.forEach((i) => {
      this.loadOne(i);
    });
  }
  load(t, a, o) {
    this.prepareLoading(t, a, {}, o);
  }
  reload(t, a, o) {
    this.prepareLoading(t, a, {
      reload: !0
    }, o);
  }
  loadOne(t, a = "") {
    const o = t.split("|"), n = o[0], r = o[1];
    this.read(n, r, "read", void 0, void 0, (i, s) => {
      i && this.logger.warn(`${a}loading namespace ${r} for language ${n} failed`, i), !i && s && this.logger.log(`${a}loaded namespace ${r} for language ${n}`, s), this.loaded(t, i, s);
    });
  }
  saveMissing(t, a, o, n, r, i = {}, s = () => {
  }) {
    if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(a)) {
      this.logger.warn(`did not save key "${o}" as the namespace "${a}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(o == null || o === "")) {
      if (this.backend?.create) {
        const l = {
          ...i,
          isUpdate: r
        }, c = this.backend.create.bind(this.backend);
        if (c.length < 6)
          try {
            let u;
            c.length === 5 ? u = c(t, a, o, n, l) : u = c(t, a, o, n), u && typeof u.then == "function" ? u.then((d) => s(null, d)).catch(s) : s(null, u);
          } catch (u) {
            s(u);
          }
        else
          c(t, a, o, n, s, l);
      }
      !t || !t[0] || this.store.addResource(t[0], a, o, n);
    }
  }
}
const np = () => ({
  debug: !1,
  initAsync: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (e) => {
    let t = {};
    if (typeof e[1] == "object" && (t = e[1]), le(e[1]) && (t.defaultValue = e[1]), le(e[2]) && (t.tDescription = e[2]), typeof e[2] == "object" || typeof e[3] == "object") {
      const a = e[3] || e[2];
      Object.keys(a).forEach((o) => {
        t[o] = a[o];
      });
    }
    return t;
  },
  interpolation: {
    escapeValue: !0,
    format: (e) => e,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  },
  cacheInBuiltFormats: !0
}), rp = (e) => (le(e.ns) && (e.ns = [e.ns]), le(e.fallbackLng) && (e.fallbackLng = [e.fallbackLng]), le(e.fallbackNS) && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs?.indexOf?.("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), typeof e.initImmediate == "boolean" && (e.initAsync = e.initImmediate), e), Rr = () => {
}, bte = (e) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((a) => {
    typeof e[a] == "function" && (e[a] = e[a].bind(e));
  });
};
class Wn extends As {
  constructor(t = {}, a) {
    if (super(), this.options = rp(t), this.services = {}, this.logger = Jt, this.modules = {
      external: []
    }, bte(this), a && !this.isInitialized && !t.isClone) {
      if (!this.options.initAsync)
        return this.init(t, a), this;
      setTimeout(() => {
        this.init(t, a);
      }, 0);
    }
  }
  init(t = {}, a) {
    this.isInitializing = !0, typeof t == "function" && (a = t, t = {}), t.defaultNS == null && t.ns && (le(t.ns) ? t.defaultNS = t.ns : t.ns.indexOf("translation") < 0 && (t.defaultNS = t.ns[0]));
    const o = np();
    this.options = {
      ...o,
      ...this.options,
      ...rp(t)
    }, this.options.interpolation = {
      ...o.interpolation,
      ...this.options.interpolation
    }, t.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = t.keySeparator), t.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = t.nsSeparator);
    const n = (c) => c ? typeof c == "function" ? new c() : c : null;
    if (!this.options.isClone) {
      this.modules.logger ? Jt.init(n(this.modules.logger), this.options) : Jt.init(null, this.options);
      let c;
      this.modules.formatter ? c = this.modules.formatter : c = pte;
      const u = new Qh(this.options);
      this.store = new Zh(this.options.resources, this.options);
      const d = this.services;
      d.logger = Jt, d.resourceStore = this.store, d.languageUtils = u, d.pluralResolver = new ute(u, {
        prepend: this.options.pluralSeparator,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), this.options.interpolation.format && this.options.interpolation.format !== o.interpolation.format && this.logger.deprecate("init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting"), c && (!this.options.interpolation.format || this.options.interpolation.format === o.interpolation.format) && (d.formatter = n(c), d.formatter.init && d.formatter.init(d, this.options), this.options.interpolation.format = d.formatter.format.bind(d.formatter)), d.interpolator = new dte(this.options), d.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, d.backendConnector = new fte(n(this.modules.backend), d.resourceStore, d, this.options), d.backendConnector.on("*", (m, ...f) => {
        this.emit(m, ...f);
      }), this.modules.languageDetector && (d.languageDetector = n(this.modules.languageDetector), d.languageDetector.init && d.languageDetector.init(d, this.options.detection, this.options)), this.modules.i18nFormat && (d.i18nFormat = n(this.modules.i18nFormat), d.i18nFormat.init && d.i18nFormat.init(this)), this.translator = new Li(this.services, this.options), this.translator.on("*", (m, ...f) => {
        this.emit(m, ...f);
      }), this.modules.external.forEach((m) => {
        m.init && m.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, a || (a = Rr), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const c = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      c.length > 0 && c[0] !== "dev" && (this.options.lng = c[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((c) => {
      this[c] = (...u) => this.store[c](...u);
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((c) => {
      this[c] = (...u) => (this.store[c](...u), this);
    });
    const s = yn(), l = () => {
      const c = (u, d) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), s.resolve(d), a(u, d);
      };
      if (this.languages && !this.isInitialized) return c(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, c);
    };
    return this.options.resources || !this.options.initAsync ? l() : setTimeout(l, 0), s;
  }
  loadResources(t, a = Rr) {
    let o = a;
    const n = le(t) ? t : this.language;
    if (typeof t == "function" && (o = t), !this.options.resources || this.options.partialBundledLanguages) {
      if (n?.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return o();
      const r = [], i = (s) => {
        if (!s || s === "cimode") return;
        this.services.languageUtils.toResolveHierarchy(s).forEach((c) => {
          c !== "cimode" && r.indexOf(c) < 0 && r.push(c);
        });
      };
      n ? i(n) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((l) => i(l)), this.options.preload?.forEach?.((s) => i(s)), this.services.backendConnector.load(r, this.options.ns, (s) => {
        !s && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), o(s);
      });
    } else
      o(null);
  }
  reloadResources(t, a, o) {
    const n = yn();
    return typeof t == "function" && (o = t, t = void 0), typeof a == "function" && (o = a, a = void 0), t || (t = this.languages), a || (a = this.options.ns), o || (o = Rr), this.services.backendConnector.reload(t, a, (r) => {
      n.resolve(), o(r);
    }), n;
  }
  use(t) {
    if (!t) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!t.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return t.type === "backend" && (this.modules.backend = t), (t.type === "logger" || t.log && t.warn && t.error) && (this.modules.logger = t), t.type === "languageDetector" && (this.modules.languageDetector = t), t.type === "i18nFormat" && (this.modules.i18nFormat = t), t.type === "postProcessor" && $y.addPostProcessor(t), t.type === "formatter" && (this.modules.formatter = t), t.type === "3rdParty" && this.modules.external.push(t), this;
  }
  setResolvedLanguage(t) {
    if (!(!t || !this.languages) && !(["cimode", "dev"].indexOf(t) > -1)) {
      for (let a = 0; a < this.languages.length; a++) {
        const o = this.languages[a];
        if (!(["cimode", "dev"].indexOf(o) > -1) && this.store.hasLanguageSomeTranslations(o)) {
          this.resolvedLanguage = o;
          break;
        }
      }
      !this.resolvedLanguage && this.languages.indexOf(t) < 0 && this.store.hasLanguageSomeTranslations(t) && (this.resolvedLanguage = t, this.languages.unshift(t));
    }
  }
  changeLanguage(t, a) {
    this.isLanguageChangingTo = t;
    const o = yn();
    this.emit("languageChanging", t);
    const n = (s) => {
      this.language = s, this.languages = this.services.languageUtils.toResolveHierarchy(s), this.resolvedLanguage = void 0, this.setResolvedLanguage(s);
    }, r = (s, l) => {
      l ? this.isLanguageChangingTo === t && (n(l), this.translator.changeLanguage(l), this.isLanguageChangingTo = void 0, this.emit("languageChanged", l), this.logger.log("languageChanged", l)) : this.isLanguageChangingTo = void 0, o.resolve((...c) => this.t(...c)), a && a(s, (...c) => this.t(...c));
    }, i = (s) => {
      !t && !s && this.services.languageDetector && (s = []);
      const l = le(s) ? s : s && s[0], c = this.store.hasLanguageSomeTranslations(l) ? l : this.services.languageUtils.getBestMatchFromCodes(le(s) ? [s] : s);
      c && (this.language || n(c), this.translator.language || this.translator.changeLanguage(c), this.services.languageDetector?.cacheUserLanguage?.(c)), this.loadResources(c, (u) => {
        r(u, c);
      });
    };
    return !t && this.services.languageDetector && !this.services.languageDetector.async ? i(this.services.languageDetector.detect()) : !t && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(i) : this.services.languageDetector.detect(i) : i(t), o;
  }
  getFixedT(t, a, o) {
    const n = (r, i, ...s) => {
      let l;
      typeof i != "object" ? l = this.options.overloadTranslationOptionHandler([r, i].concat(s)) : l = {
        ...i
      }, l.lng = l.lng || n.lng, l.lngs = l.lngs || n.lngs, l.ns = l.ns || n.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || o || n.keyPrefix);
      const c = this.options.keySeparator || ".";
      let u;
      return l.keyPrefix && Array.isArray(r) ? u = r.map((d) => (typeof d == "function" && (d = zc(d, {
        ...this.options,
        ...i
      })), `${l.keyPrefix}${c}${d}`)) : (typeof r == "function" && (r = zc(r, {
        ...this.options,
        ...i
      })), u = l.keyPrefix ? `${l.keyPrefix}${c}${r}` : r), this.t(u, l);
    };
    return le(t) ? n.lng = t : n.lngs = t, n.ns = a, n.keyPrefix = o, n;
  }
  t(...t) {
    return this.translator?.translate(...t);
  }
  exists(...t) {
    return this.translator?.exists(...t);
  }
  setDefaultNamespace(t) {
    this.options.defaultNS = t;
  }
  hasLoadedNamespace(t, a = {}) {
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const o = a.lng || this.resolvedLanguage || this.languages[0], n = this.options ? this.options.fallbackLng : !1, r = this.languages[this.languages.length - 1];
    if (o.toLowerCase() === "cimode") return !0;
    const i = (s, l) => {
      const c = this.services.backendConnector.state[`${s}|${l}`];
      return c === -1 || c === 0 || c === 2;
    };
    if (a.precheck) {
      const s = a.precheck(this, i);
      if (s !== void 0) return s;
    }
    return !!(this.hasResourceBundle(o, t) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || i(o, t) && (!n || i(r, t)));
  }
  loadNamespaces(t, a) {
    const o = yn();
    return this.options.ns ? (le(t) && (t = [t]), t.forEach((n) => {
      this.options.ns.indexOf(n) < 0 && this.options.ns.push(n);
    }), this.loadResources((n) => {
      o.resolve(), a && a(n);
    }), o) : (a && a(), Promise.resolve());
  }
  loadLanguages(t, a) {
    const o = yn();
    le(t) && (t = [t]);
    const n = this.options.preload || [], r = t.filter((i) => n.indexOf(i) < 0 && this.services.languageUtils.isSupportedCode(i));
    return r.length ? (this.options.preload = n.concat(r), this.loadResources((i) => {
      o.resolve(), a && a(i);
    }), o) : (a && a(), Promise.resolve());
  }
  dir(t) {
    if (t || (t = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language)), !t) return "rtl";
    try {
      const n = new Intl.Locale(t);
      if (n && n.getTextInfo) {
        const r = n.getTextInfo();
        if (r && r.direction) return r.direction;
      }
    } catch {
    }
    const a = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], o = this.services?.languageUtils || new Qh(np());
    return t.toLowerCase().indexOf("-latn") > 1 ? "ltr" : a.indexOf(o.getLanguagePartFromCode(t)) > -1 || t.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance(t = {}, a) {
    return new Wn(t, a);
  }
  cloneInstance(t = {}, a = Rr) {
    const o = t.forkResourceStore;
    o && delete t.forkResourceStore;
    const n = {
      ...this.options,
      ...t,
      isClone: !0
    }, r = new Wn(n);
    if ((t.debug !== void 0 || t.prefix !== void 0) && (r.logger = r.logger.clone(t)), ["store", "services", "language"].forEach((s) => {
      r[s] = this[s];
    }), r.services = {
      ...this.services
    }, r.services.utils = {
      hasLoadedNamespace: r.hasLoadedNamespace.bind(r)
    }, o) {
      const s = Object.keys(this.store.data).reduce((l, c) => (l[c] = {
        ...this.store.data[c]
      }, l[c] = Object.keys(l[c]).reduce((u, d) => (u[d] = {
        ...l[c][d]
      }, u), l[c]), l), {});
      r.store = new Zh(s, n), r.services.resourceStore = r.store;
    }
    return r.translator = new Li(r.services, n), r.translator.on("*", (s, ...l) => {
      r.emit(s, ...l);
    }), r.init(n, a), r.translator.options = n, r.translator.backendConnector.services.utils = {
      hasLoadedNamespace: r.hasLoadedNamespace.bind(r)
    }, r;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const it = Wn.createInstance();
it.createInstance = Wn.createInstance;
const _te = it.createInstance;
it.dir;
it.init;
it.loadResources;
it.reloadResources;
it.use;
it.changeLanguage;
it.getFixedT;
it.t;
it.exists;
it.setDefaultNamespace;
it.hasLoadedNamespace;
it.loadNamespaces;
it.loadLanguages;
const vte = "Studio", yte = "{{count}} soveværelse", wte = "{{count}} soveværelser", kte = "", xte = "{{count}} seng", $te = "{{count}} senge", Ste = "Voksne", Cte = "Babyer", Ete = "Din kalender er blevet opdateret.", jte = "En måned", Ote = "Præcise datoer", zte = "Uge", Ate = "", Pte = "", Dte = "", Nte = "", Rte = "To uger", Ite = "Annuller", Tte = "Børn", Lte = "Datoer", Mte = "Slet", Wte = "Beskrivelse", Bte = "Destination", Fte = "Sådan!", Vte = "Rediger", Ute = "Enhver form for udveksling", qte = "Badekar", Hte = "Grill", Gte = "Cykel", Kte = "Bil", Jte = "Kat", Zte = "By", Yte = "På landet", Xte = "Opvaskemaskine", Qte = "Hund", eae = "Tørretumbler", tae = "Elevator", aae = "Favoritboliger", oae = "Pejs/brændeovn", nae = "Lejlighed", rae = "Privat have", iae = "under {{max}} GP", sae = "fra {{min}} GP", lae = "Mellem {{min}} og {{max}} GP", cae = "Privat fitnessrum", uae = "Hus", dae = "En Ø", gae = "Isoleret", hae = "Jacuzzi", pae = "Søer", mae = "Collection-hjem", fae = "Bjerge", bae = "{{count}} badeværelser", _ae = "Andre dyr", vae = "Klaver", yae = "Legeplads", wae = "Primære bolig", kae = "Gensifig udveksling", xae = "Omvendt søgning", $ae = "Flod", Sae = "Kystnær", Cae = "Feriebolig", Eae = "TV", jae = "Landsby", Oae = "Wi-Fi", zae = "Filtre", Aae = "Faste datoer", Pae = "En måned i {{date}}", Dae = "En weekend i {{date}}", Nae = "En uge i {{date}}", Rae = "To uger i {{date}}", Iae = "Fleksible datoer", Tae = "Gæster", Lae = "boliger", Mae = "Sidste minut", Wae = "Lokation", Bae = "Rediger", Fae = "Navn", Vae = "Næste", Uae = "", qae = "", Hae = "{{count}} voksne", Gae = "", Kae = "", Jae = "{{count}} babyer", Zae = "", Yae = "", Xae = "{{count}} børn", Qae = "", eoe = "{{count}} gæst", toe = "{{count}} gæster", aoe = "Telefonnummerets format er ikke gyldigt.", ooe = "Modtag e-mailnotifikationer", noe = "Gem", roe = "Ingen lokationer fundet", ioe = "Flere beskeder", soe = "Rejseliste", loe = "", coe = "valgfrit", uoe = {
  "autocomplete.button": "Søg",
  "autocomplete.placeholder": "Hvor skal du hen ?",
  bedroomsNumbers_zero: vte,
  bedroomsNumbers_one: yte,
  bedroomsNumbers_other: wte,
  beds_zero: kte,
  beds_one: xte,
  beds_other: $te,
  "button.free-signup": "Tilmeld dig gratis",
  "button.validate": "Bekræft",
  "common.try-again": "Prøv igen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Må ikke overstige {{limit}} tegn",
  "error.reload": "Opdater siden",
  "error.return-homepage": "Tilbage til startsiden",
  "error.subtitle": "Denne side kan desværre ikke nås..",
  "error.title": "Der opstod en fejl på siden",
  "errors.unable_to_submit.subtitle": '"Din formular kunne desværre ikke \\nindsendes lige nu. Prøv igen \\nsenere."',
  "errors.unable_to_submit.title": "Ups, vi løb ind i et problem",
  "global.back": "Tilbage",
  "global.cancel": "Annuller",
  "global.collection.browsehomes": "Se boliger",
  "global.collection.contactus": "Kontakt os",
  "global.confirm": "Bekræft",
  "global.continue": "Fortsæt",
  "global.getStarted": "Kom godt i gang",
  "global.login": "Log ind",
  "global.select": "Vælg",
  global_adults: Ste,
  global_babies: Cte,
  global_calendarUpdated_toast: Ete,
  global_calendar_aMonth: jte,
  global_calendar_exactDates: Ote,
  global_calendar_oneWeek: zte,
  global_calendar_oneWeekend: Ate,
  global_calendar_plusMinusDay_zero: Pte,
  global_calendar_plusMinusDay_one: Dte,
  global_calendar_plusMinusDay_other: Nte,
  global_calendar_twoWeeks: Rte,
  global_cancel: Ite,
  global_children: Tte,
  global_dates: Lte,
  global_delete: Mte,
  global_description: Wte,
  global_destination: Bte,
  global_done: Fte,
  global_edit: Vte,
  "global_filter_a-c": "Klimaanlæg",
  global_filter_available: Ute,
  "global_filter_baby-bed": "Babysenge",
  "global_filter_baby-gear": "Babyudstyr",
  "global_filter_balcony-terrace": "Altan/terrasse",
  global_filter_bathtub: qte,
  global_filter_bbq: Hte,
  global_filter_bicycle: Gte,
  global_filter_car: Kte,
  global_filter_cat: Jte,
  "global_filter_children-welcome": "Børn velkomne",
  global_filter_cities: Zte,
  "global_filter_cleaning-person": "Rengøringsperson",
  global_filter_countryside: Yte,
  "global_filter_dedicated-workspace": "Arbejdsområde",
  "global_filter_disabled-access": "Handicapvenlig bolig",
  global_filter_dishwasher: Xte,
  global_filter_dog: Qte,
  global_filter_dryer: eae,
  "global_filter_eco-level": "Kun bæredygtige boliger",
  "global_filter_electric-car-plug": "Stik til elbil",
  global_filter_elevator: tae,
  global_filter_favorite: aae,
  global_filter_fireplace: oae,
  global_filter_flat: nae,
  global_filter_garden: rae,
  "global_filter_guest-wanted": "GuestPoints bytte",
  global_filter_guestPointsMax: iae,
  global_filter_guestPointsMin: sae,
  global_filter_guestPointsMinMax: lae,
  global_filter_gym: cae,
  "global_filter_heating-system": "Varmeanlæg",
  "global_filter_high-speed-connexion": "Hurtigt internet",
  global_filter_home: uae,
  "global_filter_home-verified": "Godkendte boliger",
  global_filter_island: dae,
  global_filter_isolated: gae,
  global_filter_jacuzzi: hae,
  "global_filter_kids-toys": "Legetøj til børn",
  global_filter_lakes: pae,
  global_filter_luxury: mae,
  global_filter_mountains: fae,
  "global_filter_no-bed-up": "Ingen midlertidige senge",
  global_filter_numOfBathrooms: bae,
  global_filter_other: _ae,
  "global_filter_parking-space": "Privat parkeringsplads",
  "global_filter_pets-welcome": "Kæledyr er velkomne",
  global_filter_piano: vae,
  global_filter_playground: yae,
  global_filter_primary: wae,
  "global_filter_public-transit-access": "Adgang til offentlig transport",
  global_filter_reciprocal: kae,
  "global_filter_response-rate-above-threshold": "Svarprocent ≥ Gennemsnitlig",
  global_filter_reverse: xae,
  global_filter_river: $ae,
  global_filter_seaside: Sae,
  global_filter_secondary: Cae,
  "global_filter_secured-pool": "Sikret pool",
  "global_filter_smokers-welcome": "Rygere er velkomne",
  "global_filter_swimming-pool": "Pool",
  global_filter_tv: Eae,
  global_filter_villages: jae,
  "global_filter_washing-machine": "Vaskemaskine",
  "global_filter_whole-unit": "Hele enheden",
  global_filter_wifi: Oae,
  global_filters: zae,
  global_fixDates: Aae,
  global_flexDates_aMonth: Pae,
  global_flexDates_aWeekend: Dae,
  global_flexDates_oneWeek: Nae,
  global_flexDates_twoWeek: Rae,
  global_flexibleDates: Iae,
  global_guests: Tae,
  global_homes: Lae,
  global_lastMinute: Mae,
  global_location: Wae,
  global_modify: Bae,
  global_name: Fae,
  global_next: Vae,
  global_numberOfAdults_zero: Uae,
  global_numberOfAdults_one: qae,
  global_numberOfAdults_other: Hae,
  global_numberOfBabies_zero: Gae,
  global_numberOfBabies_one: Kae,
  global_numberOfBabies_other: Jae,
  global_numberOfChildren_zero: Zae,
  global_numberOfChildren_one: Yae,
  global_numberOfChildren_other: Xae,
  global_numberOfGuests_zero: Qae,
  global_numberOfGuests_one: eoe,
  global_numberOfGuests_other: toe,
  global_phoneNumber_notValid: aoe,
  global_receiveEmailAlerts: ooe,
  global_save: noe,
  global_searchBar_noLocationFound: roe,
  global_seeMore_link: ioe,
  global_travelWishlist: soe,
  "modal.error-occured.content": "Vi beklager ulejligheden, men prøv \\nvenligst igen.",
  "modal.error-occured.title": "Åh nej, der er opstået en fejl!",
  no_result: loe,
  optional: coe,
  "privacy-policy": "Privatpolitik"
}, doe = "Kontakt os", goe = "FAQ", hoe = "Garantier", poe = "GuestPoints", moe = "Hjælp", foe = "Log out", boe = "Messages", _oe = "Settings", voe = {
  "about-the-calendar": "Kalenderen",
  "add-home": "Add a home",
  contact: doe,
  faq: goe,
  guarantees: hoe,
  guestpoints: poe,
  help: moe,
  "how-it-works": "Hvordan virker det?",
  "how-much-does-it-cost": "Hvor meget koster det?",
  logout: foe,
  messages: boe,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "",
  "notification.home.complete_home_first_time": "",
  "notification.home.empty_calendar": "",
  "notification.home.new_calendar_type": "",
  "notification.home.offline": "",
  "notification.membership.expired": "",
  "notification.membership.lead": "",
  "notification.user_profile.incomplete": "",
  "notification.user_profile.motivate_incomplete": "",
  "refer-your-friends": "Refer your friends",
  settings: _oe,
  "sign-in": "Log ind",
  "sign-up": "Tilmeld dig",
  "sign-up-for-free": "Tilmeld dig gratis",
  "signin.modal.apple-button": "Log ind med Apple",
  "signin.modal.facebook-button": "Log ind med Facebook",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, yoe = "https://www.homeexchange.com/blog/", woe = "/p/general-terms-of-use", koe = "https://www.homeexchange.com/da/p/community-da", xoe = "https://homeexchangehelp.zendesk.com/hc/en-us", $oe = "", Soe = "https://www.homeexchange.com/da/p/service-homeexchange-da", Coe = "https://www.homeexchange.com/da/p/guestpoints-da", Eoe = "https://www.homeexchange.com/da/p/press-da", joe = "https://www.homeexchange.com/p/fortalt-af-medlemmerne", Ooe = "", zoe = "", Aoe = "https://www.homeexchange.com/da/p/hvor-velkomsten-virkelig-begynder", Poe = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/da/p/about-us-da",
  blog: yoe,
  cgu: woe,
  community: koe,
  "contact-us": "https://www.homeexchange.com/da/kontakt-os-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: xoe,
  forum: $oe,
  guarantees: Soe,
  guestpoints: Coe,
  "happiness-team": "https://www.homeexchange.com/da/p/happiness-team-da",
  "how-it-works": "https://www.homeexchange.com/da/p/hvordan-virker-det",
  "join-us": "https://www.homeexchange.com/da/p/join-us-da",
  "legal-notice": "/p/juridiske-vilkaar",
  "mobile-app": "https://www.homeexchange.com/da/p/mobil-app",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: Eoe,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/da/p/subscription-homeexchange-da",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: joe,
  travelWishlist_faq_links: Ooe,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: zoe,
  values: Aoe
}, Doe = "Studio", Noe = "{{count}} schlafzimmer", Roe = "{{count}} schlafzimmer", Ioe = "", Toe = "{{count}} Bett", Loe = "{{count}} Betten", Moe = "Erwachsene", Woe = "Babys", Boe = "Ihr Kalender wurde aktualisiert.", Foe = "Ein Monat", Voe = "Genaue Daten", Uoe = "Eine Woche", qoe = "Ein Wochenende", Hoe = "", Goe = "{{count}} Tag", Koe = "{{count}} Tage", Joe = "Zwei Wochen", Zoe = "Abbrechen", Yoe = "Kinder", Xoe = "Daten", Qoe = "Löschen", ene = "Beschreibung", tne = "Reiseziel", ane = "Fertig!", one = "Bearbeiten", nne = "Jede Tauschanfrage", rne = "Badewanne", ine = "Grill", sne = "Fahrrad", lne = "Auto", cne = "Katze", une = "Stadt", dne = "Auf dem Land", gne = "Geschirrspüler", hne = "Hund", pne = "Trockner", mne = "Aufzug", fne = "Lieblingshäuser", bne = "Kamin", _ne = "Apartment", vne = "Privater Garten", yne = "weniger als {{max}} GP", wne = "von {{min}} GP", kne = "Zwischen {{min}} und {{max}} GP", xne = "Privater Fitnessraum", $ne = "Haus", Sne = "Insel", Cne = "Abgelegen", Ene = "Whirlpool", jne = "See", One = "Häuser der Collection", zne = "Berge", Ane = "{{count}} Badezimmer", Pne = "Andere Tiere", Dne = "Klavier", Nne = "Spielplatz", Rne = "Hauptwohnung", Ine = "Gegenseitiger Austausch", Tne = "Umgekehrte Suche", Lne = "Fluss", Mne = "An der Küste", Wne = "Zweitwohnung", Bne = "Fernseher", Fne = "Dorf", Vne = "WLAN", Une = "Filter", qne = "Feste Daten", Hne = "Eine Woche im {{date}}", Gne = "Ein Wochenende im {{date}}", Kne = "Eine Woche im {{date}}", Jne = "Zwei Wochen im {{date}}", Zne = "Flexible Daten", Yne = "Gäste", Xne = "Unterkünfte", Qne = "Last Minute", ere = "Ort", tre = "Ändern", are = "Name", ore = "Weiter", nre = "", rre = "{{count}} Erwachsener", ire = "{{count}} Erwachsene", sre = "", lre = "{{count}} Baby", cre = "{{count}} Babys", ure = "", dre = "{{count}} Kind", gre = "{{count}} Kinder", hre = "", pre = "{{count}} Gast", mre = "{{count}} Gäste", fre = "Das Format der Telefonnummer ist ungültig.", bre = "Benachrichtigungen per E-Mail erhalten", _re = "Speichern", vre = "Kein Reiseziel gefunden", yre = "Mehr anzeigen", wre = "Reiseprojekte", kre = "", xre = "optional", $re = {
  "autocomplete.button": "Suchen",
  "autocomplete.placeholder": "Wo gehst du hin ?",
  bedroomsNumbers_zero: Doe,
  bedroomsNumbers_one: Noe,
  bedroomsNumbers_other: Roe,
  beds_zero: Ioe,
  beds_one: Toe,
  beds_other: Loe,
  "button.free-signup": "Kostenlos anmelden",
  "button.validate": "Bestätigen",
  "common.try-again": "Erneut versuchen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Darf {{limit}} Zeichen nicht überschreiten",
  "error.reload": "Aktualisieren Sie diese Seite",
  "error.return-homepage": "Zurück zur Startseite",
  "error.subtitle": "Leider ist diese Seite nicht erreichbar.",
  "error.title": "Es ist ein Fehler auf der Seite aufgetreten.",
  "errors.unable_to_submit.subtitle": "Leider konnte Ihr Formular im Moment nicht abgeschickt werden. Bitte versuchen Sie es später noch einmal.",
  "errors.unable_to_submit.title": "Hoppla, wir haben ein Problem",
  "global.back": "Zurück",
  "global.cancel": "Abbrechen",
  "global.collection.browsehomes": "Unterkünfte durchstöbern",
  "global.collection.contactus": "Kontaktieren Sie uns",
  "global.confirm": "Bestätigen",
  "global.continue": "Weiter",
  "global.getStarted": "Los geht's",
  "global.login": "Anmelden",
  "global.select": "Auswählen",
  global_adults: Moe,
  global_babies: Woe,
  global_calendarUpdated_toast: Boe,
  global_calendar_aMonth: Foe,
  global_calendar_exactDates: Voe,
  global_calendar_oneWeek: Uoe,
  global_calendar_oneWeekend: qoe,
  global_calendar_plusMinusDay_zero: Hoe,
  global_calendar_plusMinusDay_one: Goe,
  global_calendar_plusMinusDay_other: Koe,
  global_calendar_twoWeeks: Joe,
  global_cancel: Zoe,
  global_children: Yoe,
  global_dates: Xoe,
  global_delete: Qoe,
  global_description: ene,
  global_destination: tne,
  global_done: ane,
  global_edit: one,
  "global_filter_a-c": "Klimaanlage",
  global_filter_available: nne,
  "global_filter_baby-bed": "Babybetten",
  "global_filter_baby-gear": "Babyausstattung",
  "global_filter_balcony-terrace": "Balkon / Terrasse",
  global_filter_bathtub: rne,
  global_filter_bbq: ine,
  global_filter_bicycle: sne,
  global_filter_car: lne,
  global_filter_cat: cne,
  "global_filter_children-welcome": "Kinder willkommen",
  global_filter_cities: une,
  "global_filter_cleaning-person": "Reinigungskraft",
  global_filter_countryside: dne,
  "global_filter_dedicated-workspace": "Spezieller Arbeitsbereich",
  "global_filter_disabled-access": "Barrierefreie Unterkunft",
  global_filter_dishwasher: gne,
  global_filter_dog: hne,
  global_filter_dryer: pne,
  "global_filter_eco-level": "Nur nachhaltige Häuser",
  "global_filter_electric-car-plug": "Steckdose für Elektroautos",
  global_filter_elevator: mne,
  global_filter_favorite: fne,
  global_filter_fireplace: bne,
  global_filter_flat: _ne,
  global_filter_garden: vne,
  "global_filter_guest-wanted": "Austausch gegen GuestPoints",
  global_filter_guestPointsMax: yne,
  global_filter_guestPointsMin: wne,
  global_filter_guestPointsMinMax: kne,
  global_filter_gym: xne,
  "global_filter_heating-system": "Heizung",
  "global_filter_high-speed-connexion": "Hochgeschwindigkeitsverbindung",
  global_filter_home: $ne,
  "global_filter_home-verified": "Verifizierte Unterkünfte",
  global_filter_island: Sne,
  global_filter_isolated: Cne,
  global_filter_jacuzzi: Ene,
  "global_filter_kids-toys": "Kinderspielzeug",
  global_filter_lakes: jne,
  global_filter_luxury: One,
  global_filter_mountains: zne,
  "global_filter_no-bed-up": "Keine Zustellbetten",
  global_filter_numOfBathrooms: Ane,
  global_filter_other: Pne,
  "global_filter_parking-space": "Privater Parkplatz",
  "global_filter_pets-welcome": "Haustiere willkommen",
  global_filter_piano: Dne,
  global_filter_playground: Nne,
  global_filter_primary: Rne,
  "global_filter_public-transit-access": "Zugang zu öffentlichen Verkehrsmitteln",
  global_filter_reciprocal: Ine,
  "global_filter_response-rate-above-threshold": "Antwortrate ≥ Mittel",
  global_filter_reverse: Tne,
  global_filter_river: Lne,
  global_filter_seaside: Mne,
  global_filter_secondary: Wne,
  "global_filter_secured-pool": "Gesicherter Pool",
  "global_filter_smokers-welcome": "Rauchen erlaubt",
  "global_filter_swimming-pool": "Swimmingpool",
  global_filter_tv: Bne,
  global_filter_villages: Fne,
  "global_filter_washing-machine": "Waschmaschine",
  "global_filter_whole-unit": "Die ganze Wohnung",
  global_filter_wifi: Vne,
  global_filters: Une,
  global_fixDates: qne,
  global_flexDates_aMonth: Hne,
  global_flexDates_aWeekend: Gne,
  global_flexDates_oneWeek: Kne,
  global_flexDates_twoWeek: Jne,
  global_flexibleDates: Zne,
  global_guests: Yne,
  global_homes: Xne,
  global_lastMinute: Qne,
  global_location: ere,
  global_modify: tre,
  global_name: are,
  global_next: ore,
  global_numberOfAdults_zero: nre,
  global_numberOfAdults_one: rre,
  global_numberOfAdults_other: ire,
  global_numberOfBabies_zero: sre,
  global_numberOfBabies_one: lre,
  global_numberOfBabies_other: cre,
  global_numberOfChildren_zero: ure,
  global_numberOfChildren_one: dre,
  global_numberOfChildren_other: gre,
  global_numberOfGuests_zero: hre,
  global_numberOfGuests_one: pre,
  global_numberOfGuests_other: mre,
  global_phoneNumber_notValid: fre,
  global_receiveEmailAlerts: bre,
  global_save: _re,
  global_searchBar_noLocationFound: vre,
  global_seeMore_link: yre,
  global_travelWishlist: wre,
  "modal.error-occured.content": "Wir entschuldigen uns für die Unannehmlichkeiten, bitte versuchen Sie es noch einmal.",
  "modal.error-occured.title": "Oh nein, es ist ein Fehler aufgetreten!",
  no_result: kre,
  optional: xre,
  "privacy-policy": "Datenschutz"
}, Sre = "Kontaktieren Sie uns", Cre = "FAQ", Ere = "Garantien", jre = "GuestPoints", Ore = "Hilfe", zre = "Log out", Are = "Messages", Pre = "Settings", Dre = {
  "about-the-calendar": "Kalender",
  "add-home": "Add a home",
  contact: Sre,
  faq: Cre,
  guarantees: Ere,
  guestpoints: jre,
  help: Ore,
  "how-it-works": "Wie funktioniert es?",
  "how-much-does-it-cost": "Wieviel kostet es?",
  logout: zre,
  messages: Are,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "",
  "notification.home.complete_home_first_time": "",
  "notification.home.empty_calendar": "",
  "notification.home.new_calendar_type": "",
  "notification.home.offline": "",
  "notification.membership.expired": "",
  "notification.membership.lead": "",
  "notification.user_profile.incomplete": "",
  "notification.user_profile.motivate_incomplete": "",
  "refer-your-friends": "Refer your friends",
  settings: Pre,
  "sign-in": "Einloggen",
  "sign-up": "Anmelden",
  "sign-up-for-free": "Kostenlos anmelden",
  "signin.modal.apple-button": "Melden Sie sich mit Apple an",
  "signin.modal.facebook-button": "Mit Facebook anmelden",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, Nre = "https://www.homeexchange.com/de/blog/", Rre = "/de/p/homeexchangenutzungsbedingungen", Ire = "https://www.homeexchange.com/de/p/our-community-de", Tre = "https://homeexchangehelp.zendesk.com/hc/de", Lre = "", Mre = "https://www.homeexchange.com/de/p/service-homeexchange-de", Wre = "https://www.homeexchange.com/de/p/guestpoints-de", Bre = "https://www.homeexchange.com/de/p/press-de", Fre = "https://www.homeexchange.com/p/worte-homeexchanger", Vre = "https://help.homeexchange.com/hc/de/articles/360000623717-Bevorzugte-Tausch-Destinationen", Ure = "", qre = "https://www.homeexchange.com/de/p/wo-die-begrubung-wirklich-beginnt", Hre = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/de/p/about-us-de",
  blog: Nre,
  cgu: Rre,
  community: Ire,
  "contact-us": "https://www.homeexchange.com/de/kontakt-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/HomeExchangeDE/",
  faq: Tre,
  forum: Lre,
  guarantees: Mre,
  guestpoints: Wre,
  "happiness-team": "https://www.homeexchange.com/de/p/happiness-team-de",
  "how-it-works": "https://www.homeexchange.com/de/p/so-funktioniert-es-de",
  "join-us": "https://www.homeexchange.com/de/p/join-us-de",
  "legal-notice": "/p/impressum",
  "mobile-app": "https://www.homeexchange.com/de/p/homeexchange-mobile-app",
  "our-team": "https://www.homeexchange.com/de/p/unser-team",
  press: Bre,
  "privacy-policy": "/p/homeexchange-datenschutz",
  "subscription-cost": "https://www.homeexchange.com/de/p/subscription-homeexchange-de",
  "term-of-use": "/p/homeexchangenutzungsbedingungen",
  testimonials: Fre,
  travelWishlist_faq_links: Vre,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: Ure,
  values: qre
}, Gre = "Studio", Kre = "{{count}} bedroom", Jre = "{{count}} bedrooms", Zre = "", Yre = "{{count}} bed", Xre = "{{count}} beds", Qre = "Adults", eie = "Babies", tie = "Your calendar has been updated.", aie = "A month", oie = "Exact dates", nie = "One week", rie = "One weekend", iie = "", sie = "± {{count}} day", lie = "± {{count}} days", cie = "Two weeks", uie = "Cancel", die = "Children", gie = "Dates", hie = "Delete", pie = "Description", mie = "Destination", fie = "Done!", bie = "Edit", _ie = "Any type of exchange", vie = "Bathtub", yie = "BBQ", wie = "Bicycle", kie = "Car", xie = "Cat", $ie = "City", Sie = "Countryside", Cie = "Dishwasher", Eie = "Dog", jie = "Dryer", Oie = "Elevator", zie = "Favorite homes", Aie = "Fireplace", Pie = "Apartment", Die = "Private backyard", Nie = "less than {{max}} GP", Rie = "from {{min}} GP", Iie = "Between {{min}} and {{max}} GP", Tie = "Private gym", Lie = "House", Mie = "Island", Wie = "Isolated", Bie = "Jacuzzi", Fie = "Lake", Vie = "Collection homes", Uie = "Mountain", qie = "{{count}} bathrooms", Hie = "Other animals", Gie = "Piano", Kie = "Kid's playground", Jie = "Primary", Zie = "Reciprocal exchange", Yie = "Reverse search", Xie = "River", Qie = "Coastal", ese = "Secondary", tse = "TV", ase = "Village", ose = "WiFi", nse = "Filters", rse = "Fixed dates", ise = "A month in {{date}}", sse = "A Week-end in {{date}}", lse = "One week in {{date}}", cse = "Two weeks in {{date}}", use = "Flexible dates", dse = "Guests", gse = "homes", hse = "Last minute", pse = "Location", mse = "Modify", fse = "Name", bse = "Next", _se = "", vse = "{{count}} adult", yse = "{{count}} adults", wse = "", kse = "{{count}} baby", xse = "{{count}} babies", $se = "", Sse = "{{count}} child", Cse = "{{count}} children", Ese = "{{count}} guest", jse = "{{count}} guest", Ose = "{{count}} guests", zse = "The phone number format is not valid", Ase = "Receive email alerts", Pse = "Save", Dse = "No locations found", Nse = "See more", Rse = "Travel wishlist", Ise = "No result", Tse = "optional", Lse = {
  "autocomplete.button": "Search",
  "autocomplete.placeholder": "Where are you going ?",
  bedroomsNumbers_zero: Gre,
  bedroomsNumbers_one: Kre,
  bedroomsNumbers_other: Jre,
  beds_zero: Zre,
  beds_one: Yre,
  beds_other: Xre,
  "button.free-signup": "Sign up for free",
  "button.validate": "Validate",
  "common.try-again": "Try again",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Must not exceed {{limit}} characters",
  "error.reload": "Refresh this page",
  "error.return-homepage": "Return to home page",
  "error.subtitle": "Unfortunately this page can't be reached.",
  "error.title": "An error occurred on the page",
  "errors.unable_to_submit.subtitle": "Unfortunately your form couldn't be submitted right now. Please try again later.",
  "errors.unable_to_submit.title": "Oops, we've hit a problem",
  "global.back": "Back",
  "global.cancel": "Cancel",
  "global.collection.browsehomes": "Browse Homes",
  "global.collection.contactus": "Contact us",
  "global.confirm": "Confirm",
  "global.continue": "Continue",
  "global.getStarted": "Get started",
  "global.login": "Log in",
  "global.select": "Select",
  global_adults: Qre,
  global_babies: eie,
  global_calendarUpdated_toast: tie,
  global_calendar_aMonth: aie,
  global_calendar_exactDates: oie,
  global_calendar_oneWeek: nie,
  global_calendar_oneWeekend: rie,
  global_calendar_plusMinusDay_zero: iie,
  global_calendar_plusMinusDay_one: sie,
  global_calendar_plusMinusDay_other: lie,
  global_calendar_twoWeeks: cie,
  global_cancel: uie,
  global_children: die,
  global_dates: gie,
  global_delete: hie,
  global_description: pie,
  global_destination: mie,
  global_done: fie,
  global_edit: bie,
  "global_filter_a-c": "A/C",
  global_filter_available: _ie,
  "global_filter_baby-bed": "Baby cribs",
  "global_filter_baby-gear": "Baby gear",
  "global_filter_balcony-terrace": "Balcony/Terrace",
  global_filter_bathtub: vie,
  global_filter_bbq: yie,
  global_filter_bicycle: wie,
  global_filter_car: kie,
  global_filter_cat: xie,
  "global_filter_children-welcome": "Children welcome",
  global_filter_cities: $ie,
  "global_filter_cleaning-person": "Cleaning person",
  global_filter_countryside: Sie,
  "global_filter_dedicated-workspace": "Dedicated workspace",
  "global_filter_disabled-access": "Accessible home",
  global_filter_dishwasher: Cie,
  global_filter_dog: Eie,
  global_filter_dryer: jie,
  "global_filter_eco-level": "Only sustainable homes",
  "global_filter_electric-car-plug": "Electric car plug",
  global_filter_elevator: Oie,
  global_filter_favorite: zie,
  global_filter_fireplace: Aie,
  global_filter_flat: Pie,
  global_filter_garden: Die,
  "global_filter_guest-wanted": "GuestPoints exchange",
  global_filter_guestPointsMax: Nie,
  global_filter_guestPointsMin: Rie,
  global_filter_guestPointsMinMax: Iie,
  global_filter_gym: Tie,
  "global_filter_heating-system": "Heating system",
  "global_filter_high-speed-connexion": "High speed connection",
  global_filter_home: Lie,
  "global_filter_home-verified": "Verified homes",
  global_filter_island: Mie,
  global_filter_isolated: Wie,
  global_filter_jacuzzi: Bie,
  "global_filter_kids-toys": "Kids toys",
  global_filter_lakes: Fie,
  global_filter_luxury: Vie,
  global_filter_mountains: Uie,
  "global_filter_no-bed-up": "No temporary beds",
  global_filter_numOfBathrooms: qie,
  global_filter_other: Hie,
  "global_filter_parking-space": "Private parking space",
  "global_filter_pets-welcome": "Pets welcome",
  global_filter_piano: Gie,
  global_filter_playground: Kie,
  global_filter_primary: Jie,
  "global_filter_public-transit-access": "Public transport access",
  global_filter_reciprocal: Zie,
  "global_filter_response-rate-above-threshold": "Response rate ≥ Average",
  global_filter_reverse: Yie,
  global_filter_river: Xie,
  global_filter_seaside: Qie,
  global_filter_secondary: ese,
  "global_filter_secured-pool": "Secured pool",
  "global_filter_smokers-welcome": "Smokers welcome",
  "global_filter_swimming-pool": "Pool",
  global_filter_tv: tse,
  global_filter_villages: ase,
  "global_filter_washing-machine": "Washing machine",
  "global_filter_whole-unit": "Entire home",
  global_filter_wifi: ose,
  global_filters: nse,
  global_fixDates: rse,
  global_flexDates_aMonth: ise,
  global_flexDates_aWeekend: sse,
  global_flexDates_oneWeek: lse,
  global_flexDates_twoWeek: cse,
  global_flexibleDates: use,
  global_guests: dse,
  global_homes: gse,
  global_lastMinute: hse,
  global_location: pse,
  global_modify: mse,
  global_name: fse,
  global_next: bse,
  global_numberOfAdults_zero: _se,
  global_numberOfAdults_one: vse,
  global_numberOfAdults_other: yse,
  global_numberOfBabies_zero: wse,
  global_numberOfBabies_one: kse,
  global_numberOfBabies_other: xse,
  global_numberOfChildren_zero: $se,
  global_numberOfChildren_one: Sse,
  global_numberOfChildren_other: Cse,
  global_numberOfGuests_zero: Ese,
  global_numberOfGuests_one: jse,
  global_numberOfGuests_other: Ose,
  global_phoneNumber_notValid: zse,
  global_receiveEmailAlerts: Ase,
  global_save: Pse,
  global_searchBar_noLocationFound: Dse,
  global_seeMore_link: Nse,
  global_travelWishlist: Rse,
  "modal.error-occured.content": "We're so sorry for the inconvenience, but please do try again.",
  "modal.error-occured.title": "Oh no, an error has occurred!",
  no_result: Ise,
  optional: Tse,
  "privacy-policy": "Privacy Policy"
}, Mse = "Contact us", Wse = "FAQ", Bse = "Guarantees", Fse = "GuestPoints", Vse = "Help", Use = "Log out", qse = "Messages", Hse = "Settings", Gse = {
  "about-the-calendar": "Calendar",
  "add-home": "Add a home",
  contact: Mse,
  faq: Wse,
  guarantees: Bse,
  guestpoints: Fse,
  help: Vse,
  "how-it-works": "How does it work?",
  "how-much-does-it-cost": "How much does it cost?",
  logout: Use,
  messages: qse,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "Complete your home!",
  "notification.home.complete_home_first_time": "Complete your home and earn {{gp}} GuestPoints!",
  "notification.home.empty_calendar": "Add availability to your calendar for the coming year",
  "notification.home.new_calendar_type": "New calendar!",
  "notification.home.offline": "Publish your home!",
  "notification.membership.expired": "Membership expired",
  "notification.membership.lead": "Activate your membership and receive {{gp}} GuestPoints",
  "notification.user_profile.incomplete": "Complete your profile!",
  "notification.user_profile.motivate_incomplete": "Complete your profile and earn {{gp}} GuestPoints!",
  "refer-your-friends": "Refer your friends",
  settings: Hse,
  "sign-in": "Sign in",
  "sign-up": "Sign up",
  "sign-up-for-free": "Sign up for free",
  "signin.modal.apple-button": "Sign in with Apple",
  "signin.modal.facebook-button": "Sign in with Facebook",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, Kse = "https://www.homeexchange.com/blog/", Jse = "/p/general-terms-of-use", Zse = "https://www.homeexchange.com/p/community", Yse = "https://homeexchangehelp.zendesk.com/hc/en-us", Xse = "https://forum.homeexchange.com/c/english/20", Qse = "https://www.homeexchange.com/p/service-homeexchange-en", ele = "https://www.homeexchange.com/p/guestpoints-en", tle = "https://www.homeexchange.com/p/press", ale = "https://www.homeexchange.com/p/words-of-homeexchanges", ole = "https://help.homeexchange.com/hc/en-us/articles/360000623717-What-are-My-Preferred-Destinations-and-how-do-I-use-them", nle = "https://www.homeexchange.com/p/where-the-welcome-really-begins", rle = "https://www.homeexchange.com/p/where-the-welcome-really-begins", ile = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/p/about-us",
  blog: Kse,
  cgu: Jse,
  community: Zse,
  "contact-us": "https://www.homeexchange.com/contact-us-homeexchange",
  "cookie-policy": "/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: Yse,
  forum: Xse,
  guarantees: Qse,
  guestpoints: ele,
  "happiness-team": "https://www.homeexchange.com/p/happiness-team",
  "how-it-works": "https://www.homeexchange.com/p/how-it-works-en",
  "join-us": "https://www.homeexchange.com/p/join-us",
  "legal-notice": "/p/legal-notice",
  "mobile-app": "https://www.homeexchange.com/p/mobile-apps",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: tle,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/p/subscription-homeexchange",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: ale,
  travelWishlist_faq_links: ole,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: nle,
  values: rle
}, sle = "Estudio", lle = "{{count}} dormitorio", cle = "{{count}} dormitorios", ule = "", dle = "{{count}} cama", gle = "{{count}} camas", hle = "", ple = "", mle = "Tu calendario ha sido actualizado.", fle = "Un mes", ble = "Fechas exactas", _le = "Una semana", vle = "Un fin de semana", yle = "", wle = "± 1:{{count}} día", kle = "± 1:{{count}} días", xle = "Dos semanas", $le = "Cancelar", Sle = "", Cle = "Fechas", Ele = "Eliminar", jle = "Descripción", Ole = "Destino", zle = "¡Listo!", Ale = "Editar", Ple = "Cualquier tipo de intercambio", Dle = "Bañera", Nle = "Barbacoa", Rle = "Bicicleta", Ile = "Coche", Tle = "Gato", Lle = "Ciudad", Mle = "Campo", Wle = "Lavavajillas", Ble = "Perro", Fle = "Secadora", Vle = "Ascensor", Ule = "Casas favoritas", qle = "Chimenea", Hle = "Piso", Gle = "Patio privado", Kle = "", Jle = "", Zle = "", Yle = "", Xle = "Casa", Qle = "Isla", ece = "Aislado", tce = "Jacuzzi", ace = "Lagos", oce = "Casas Collection", nce = "", rce = "{{count}} baños", ice = "Otros animales", sce = "Piano", lce = "Columpios", cce = "Principal", uce = "Intercambio recíproco", dce = "Búsqueda inversa", gce = "Río", hce = "En la costa", pce = "Secundaria", mce = "TV", fce = "Pueblo", bce = "WiFi", _ce = "Filtros", vce = "Fechas fijas", yce = "Un mes en {{date}}", wce = "Un fin de semana en {{date}}", kce = "Una semana en {{date}}", xce = "Dos semanas en {{date}}", $ce = "Fechas flexibles", Sce = "Invitados", Cce = "casas", Ece = "Último minuto", jce = "Ubicación", Oce = "Modificar", zce = "Nombre", Ace = "Siguiente", Pce = "", Dce = "{{count}} adulto", Nce = "{{count}} adultos", Rce = "", Ice = "{{count}} bebé", Tce = "bebé", Lce = "", Mce = "{{count}} niño/a", Wce = "{{count}} niños", Bce = "", Fce = "{{count}} invitado/a", Vce = "{{count}} invitados", Uce = "El formato del número de teléfono no es válido.", qce = "Recibir notificaciones por correo electrónico", Hce = "Guardar", Gce = "No encontramos este lugar", Kce = "Ver más", Jce = "Proyectos de viaje", Zce = "", Yce = "opcional", Xce = {
  "autocomplete.button": "Buscar",
  "autocomplete.placeholder": "¿Adónde vas?",
  bedroomsNumbers_zero: sle,
  bedroomsNumbers_one: lle,
  bedroomsNumbers_other: cle,
  beds_zero: ule,
  beds_one: dle,
  beds_other: gle,
  "button.free-signup": "Regístrate gratis",
  "button.validate": "Validar",
  "common.try-again": "",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "No puedes superar los {{limit}} caracteres",
  "error.reload": "Actualizar esta página",
  "error.return-homepage": "Volver a la página de inicio",
  "error.subtitle": "Lo sentimos, pero no se puede acceder a esta página.",
  "error.title": "Se ha producido un error en la página",
  "errors.unable_to_submit.subtitle": "Lo sentimos, se ha producido un error al enviar el formulario. Por favor, vuelve a intentarlo más tarde.",
  "errors.unable_to_submit.title": "¡Vaya! Algo ha fallado.",
  "global.back": "",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "Continuar",
  "global.getStarted": "",
  "global.login": "Iniciar sesión",
  "global.select": "Selecciona",
  global_adults: hle,
  global_babies: ple,
  global_calendarUpdated_toast: mle,
  global_calendar_aMonth: fle,
  global_calendar_exactDates: ble,
  global_calendar_oneWeek: _le,
  global_calendar_oneWeekend: vle,
  global_calendar_plusMinusDay_zero: yle,
  global_calendar_plusMinusDay_one: wle,
  global_calendar_plusMinusDay_other: kle,
  global_calendar_twoWeeks: xle,
  global_cancel: $le,
  global_children: Sle,
  global_dates: Cle,
  global_delete: Ele,
  global_description: jle,
  global_destination: Ole,
  global_done: zle,
  global_edit: Ale,
  "global_filter_a-c": "Aire acondicionado",
  global_filter_available: Ple,
  "global_filter_baby-bed": "",
  "global_filter_baby-gear": "Equipamiento para bebés",
  "global_filter_balcony-terrace": "Balcón/Terraza",
  global_filter_bathtub: Dle,
  global_filter_bbq: Nle,
  global_filter_bicycle: Rle,
  global_filter_car: Ile,
  global_filter_cat: Tle,
  "global_filter_children-welcome": "Niños bienvenidos",
  global_filter_cities: Lle,
  "global_filter_cleaning-person": "Señor/a de la limpieza",
  global_filter_countryside: Mle,
  "global_filter_dedicated-workspace": "Escritorio para trabajar",
  "global_filter_disabled-access": "Casas accesibles",
  global_filter_dishwasher: Wle,
  global_filter_dog: Ble,
  global_filter_dryer: Fle,
  "global_filter_eco-level": "Solo viviendas sostenibles",
  "global_filter_electric-car-plug": "Enchufe para coches eléctricos",
  global_filter_elevator: Vle,
  global_filter_favorite: Ule,
  global_filter_fireplace: qle,
  global_filter_flat: Hle,
  global_filter_garden: Gle,
  "global_filter_guest-wanted": "Intercambio con GuestPoints",
  global_filter_guestPointsMax: Kle,
  global_filter_guestPointsMin: Jle,
  global_filter_guestPointsMinMax: Zle,
  global_filter_gym: Yle,
  "global_filter_heating-system": "Calefacción",
  "global_filter_high-speed-connexion": "Conexión de alta velocidad",
  global_filter_home: Xle,
  "global_filter_home-verified": "Casas verificadas",
  global_filter_island: Qle,
  global_filter_isolated: ece,
  global_filter_jacuzzi: tce,
  "global_filter_kids-toys": "",
  global_filter_lakes: ace,
  global_filter_luxury: oce,
  global_filter_mountains: nce,
  "global_filter_no-bed-up": "Sin camas provisionales",
  global_filter_numOfBathrooms: rce,
  global_filter_other: ice,
  "global_filter_parking-space": "",
  "global_filter_pets-welcome": "Mascotas bienvenidas",
  global_filter_piano: sce,
  global_filter_playground: lce,
  global_filter_primary: cce,
  "global_filter_public-transit-access": "",
  global_filter_reciprocal: uce,
  "global_filter_response-rate-above-threshold": "",
  global_filter_reverse: dce,
  global_filter_river: gce,
  global_filter_seaside: hce,
  global_filter_secondary: pce,
  "global_filter_secured-pool": "Piscina segura",
  "global_filter_smokers-welcome": "Fumadores bienvenidos",
  "global_filter_swimming-pool": "Piscina",
  global_filter_tv: mce,
  global_filter_villages: fce,
  "global_filter_washing-machine": "Lavadora",
  "global_filter_whole-unit": "",
  global_filter_wifi: bce,
  global_filters: _ce,
  global_fixDates: vce,
  global_flexDates_aMonth: yce,
  global_flexDates_aWeekend: wce,
  global_flexDates_oneWeek: kce,
  global_flexDates_twoWeek: xce,
  global_flexibleDates: $ce,
  global_guests: Sce,
  global_homes: Cce,
  global_lastMinute: Ece,
  global_location: jce,
  global_modify: Oce,
  global_name: zce,
  global_next: Ace,
  global_numberOfAdults_zero: Pce,
  global_numberOfAdults_one: Dce,
  global_numberOfAdults_other: Nce,
  global_numberOfBabies_zero: Rce,
  global_numberOfBabies_one: Ice,
  global_numberOfBabies_other: Tce,
  global_numberOfChildren_zero: Lce,
  global_numberOfChildren_one: Mce,
  global_numberOfChildren_other: Wce,
  global_numberOfGuests_zero: Bce,
  global_numberOfGuests_one: Fce,
  global_numberOfGuests_other: Vce,
  global_phoneNumber_notValid: Uce,
  global_receiveEmailAlerts: qce,
  global_save: Hce,
  global_searchBar_noLocationFound: Gce,
  global_seeMore_link: Kce,
  global_travelWishlist: Jce,
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: Zce,
  optional: Yce,
  "privacy-policy": "Política de Privacidad"
}, Qce = "Contacte con nosotros", eue = "Preguntas frecuentes", tue = "Guarantías", aue = "GuestPoints", oue = "Ayuda", nue = "Log out", rue = "Messages", iue = "Settings", sue = {
  "about-the-calendar": "Calendario",
  "add-home": "Add a home",
  contact: Qce,
  faq: eue,
  guarantees: tue,
  guestpoints: aue,
  help: oue,
  "how-it-works": "¿Cómo funciona?",
  "how-much-does-it-cost": "¿Cuánto cuesta?",
  logout: nue,
  messages: rue,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "",
  "notification.home.complete_home_first_time": "",
  "notification.home.empty_calendar": "",
  "notification.home.new_calendar_type": "",
  "notification.home.offline": "",
  "notification.membership.expired": "",
  "notification.membership.lead": "",
  "notification.user_profile.incomplete": "",
  "notification.user_profile.motivate_incomplete": "",
  "refer-your-friends": "Refer your friends",
  settings: iue,
  "sign-in": "Inicia sesión",
  "sign-up": "Regístrate",
  "sign-up-for-free": "Regístrate gratis",
  "signin.modal.apple-button": "Inicia sesión con Apple",
  "signin.modal.facebook-button": "Inicia sesión con Facebook",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, lue = "https://www.homeexchange.com/es/blog/", cue = "/es/p/homeexchange-condiciones-de-uso", uue = "https://www.homeexchange.com/es/p/nuestra-comunidad-es", due = "https://homeexchangehelp.zendesk.com/hc/es", gue = "https://forum.homeexchange.com/c/espanol/22", hue = "https://www.homeexchange.com/es/p/service-homeexchange-es", pue = "https://www.homeexchange.com/es/p/los-guestpoints", mue = "https://www.homeexchange.com/es/p/prensa", fue = "https://www.homeexchange.com/p/palabra-de-homeexchanger", bue = "", _ue = "https://www.homeexchange.com/es/p/principios-intercambio-casa", vue = "https://www.homeexchange.com/es/p/principios-intercambio-casa", yue = {
  "about-calendar": "https://help.homeexchange.com/hc/es/articles/360007584998-Todo-lo-que-necesitas-saber-sobre-el-calendario",
  "about-us": "https://www.homeexchange.com/es/p/about-us-es",
  blog: lue,
  cgu: cue,
  community: uue,
  "contact-us": "https://www.homeexchange.com/es/contacto-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/HomeExchangeES/",
  faq: due,
  forum: gue,
  guarantees: hue,
  guestpoints: pue,
  "happiness-team": "https://www.homeexchange.com/es/p/happiness-team-es",
  "how-it-works": "https://www.homeexchange.com/es/p/como-funciona-es",
  "join-us": "https://www.homeexchange.com/es/p/join-us-es",
  "legal-notice": "/p/menciones-legales",
  "mobile-app": "https://www.homeexchange.com/es/p/aplicacion-movil",
  "our-team": "https://www.homeexchange.com/es/p/nuestro-equipo",
  press: mue,
  "privacy-policy": "/p/homeexchange-politica-privacidad",
  "subscription-cost": "https://www.homeexchange.com/es/p/subscription-homeexchange-es",
  "term-of-use": "/p/homeexchange-condiciones-de-uso",
  testimonials: fue,
  travelWishlist_faq_links: bue,
  "twitter-page": "https://twitter.com/HomeExchangeES",
  value: _ue,
  values: vue
}, wue = "Studio", kue = "{{count}} chambre", xue = "{{count}} chambres", $ue = "", Sue = "{{count}} lit", Cue = "{{count}} lits", Eue = "Adultes", jue = "Bébés", Oue = "Votre calendrier a été mis à jour.", zue = "Un mois", Aue = "Dates exactes", Pue = "Une semaine", Due = "Un week-end", Nue = "Vide", Rue = "± {{count}} jour", Iue = "± {{count}} jours", Tue = "Deux semaines", Lue = "Annuler", Mue = "Enfants", Wue = "Dates", Bue = "Supprimer", Fue = "Description", Vue = "Destination", Uue = "C'est prêt !", que = "Modifier", Hue = "Tout type d'échange", Gue = "Baignoire", Kue = "Barbecue", Jue = "Vélo", Zue = "Voiture", Yue = "Chat", Xue = "Ville", Que = "Campagne", ede = "Lave-vaisselle", tde = "Chien", ade = "Sèche linge", ode = "Ascenseur", nde = "Maisons favorites", rde = "Cheminée", ide = "Appartement", sde = "Jardin privé", lde = "moins de {{max}} GP", cde = "à partir de {{min}} GP", ude = "Entre {{min}} et {{max}} GP", dde = "Salle de sport privée", gde = "Maison", hde = "Île", pde = "Isolé", mde = "Jacuzzi", fde = "Lac", bde = "Maisons Collection", _de = "Montagne", vde = "{{count}} salles de bain", yde = "Autre", wde = "Piano", kde = "Aire de jeux", xde = "Principale", $de = "Échange réciproque", Sde = "Recherche inversée", Cde = "Rivière", Ede = "Bord de mer", jde = "Secondaire", Ode = "TV", zde = "Village", Ade = "WiFi", Pde = "Filtres", Dde = "Dates fixes", Nde = "Un mois en {{date}}", Rde = "Un week-end en {{date}}", Ide = "Une semaine en {{date}}", Tde = "Deux semaines en {{date}}", Lde = "Dates flexibles", Mde = "Personnes", Wde = "maisons", Bde = "Dernière minute", Fde = "Lieu", Vde = "Modifier", Ude = "Titre", qde = "Suivant", Hde = "Vide", Gde = "{{count}} adulte", Kde = "{{count}} adultes", Jde = "Vide", Zde = "{{count}} bébé", Yde = "{{count}} bébés", Xde = "Vide", Qde = "{{count}} enfant", ege = "{{count}} enfants", tge = "{{count}} personne", age = "{{count}} personne", oge = "{{count}} personnes", nge = "Le format du numéro de téléphone est invalide.", rge = "Recevoir des alertes par email", ige = "Enregistrer", sge = "Aucun lieu trouvé", lge = "Voir plus", cge = "Projets de voyage", uge = "", dge = "facultatif", gge = {
  "autocomplete.button": "Rechercher",
  "autocomplete.placeholder": "Où allez-vous ?",
  bedroomsNumbers_zero: wue,
  bedroomsNumbers_one: kue,
  bedroomsNumbers_other: xue,
  beds_zero: $ue,
  beds_one: Sue,
  beds_other: Cue,
  "button.free-signup": "Inscrivez-vous gratuitement",
  "button.validate": "Valider",
  "common.try-again": "Compris !",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Ne doit pas dépasser {{limit}} caractères",
  "error.reload": "Actualiser la page",
  "error.return-homepage": "Retour à la page d'accueil",
  "error.subtitle": "Malheureusement, il y a un problème avec cette page.",
  "error.title": "Une erreur s'est produite sur la page",
  "errors.unable_to_submit.subtitle": "Malheureusement, votre réponse n'a pas pu être enregistrée. Merci de réessayer plus tard !",
  "errors.unable_to_submit.title": "Oups, on dirait bien qu'il y a un problème !",
  "global.back": "Retour",
  "global.cancel": "Annuler",
  "global.collection.browsehomes": "Découvrir les maisons",
  "global.collection.contactus": "Nous contacter",
  "global.confirm": "Confirmer",
  "global.continue": "Continuer",
  "global.getStarted": "Commencer",
  "global.login": "Se connecter",
  "global.select": "Sélectionner",
  global_adults: Eue,
  global_babies: jue,
  global_calendarUpdated_toast: Oue,
  global_calendar_aMonth: zue,
  global_calendar_exactDates: Aue,
  global_calendar_oneWeek: Pue,
  global_calendar_oneWeekend: Due,
  global_calendar_plusMinusDay_zero: Nue,
  global_calendar_plusMinusDay_one: Rue,
  global_calendar_plusMinusDay_other: Iue,
  global_calendar_twoWeeks: Tue,
  global_cancel: Lue,
  global_children: Mue,
  global_dates: Wue,
  global_delete: Bue,
  global_description: Fue,
  global_destination: Vue,
  global_done: Uue,
  global_edit: que,
  "global_filter_a-c": "Air conditionné",
  global_filter_available: Hue,
  "global_filter_baby-bed": "Lits bébé",
  "global_filter_baby-gear": "Équipements bébé",
  "global_filter_balcony-terrace": "Balcon / Terrasse",
  global_filter_bathtub: Gue,
  global_filter_bbq: Kue,
  global_filter_bicycle: Jue,
  global_filter_car: Zue,
  global_filter_cat: Yue,
  "global_filter_children-welcome": "Les enfants sont les bienvenus",
  global_filter_cities: Xue,
  "global_filter_cleaning-person": "Service de ménage",
  global_filter_countryside: Que,
  "global_filter_dedicated-workspace": "Espace de travail dédié",
  "global_filter_disabled-access": "Logement adapté",
  global_filter_dishwasher: ede,
  global_filter_dog: tde,
  global_filter_dryer: ade,
  "global_filter_eco-level": "Uniquement des maisons durables",
  "global_filter_electric-car-plug": "Prise pour voiture électrique",
  global_filter_elevator: ode,
  global_filter_favorite: nde,
  global_filter_fireplace: rde,
  global_filter_flat: ide,
  global_filter_garden: sde,
  "global_filter_guest-wanted": "Échange contre GuestPoints",
  global_filter_guestPointsMax: lde,
  global_filter_guestPointsMin: cde,
  global_filter_guestPointsMinMax: ude,
  global_filter_gym: dde,
  "global_filter_heating-system": "Chauffage",
  "global_filter_high-speed-connexion": "Connexion haut débit",
  global_filter_home: gde,
  "global_filter_home-verified": "Logements vérifiés",
  global_filter_island: hde,
  global_filter_isolated: pde,
  global_filter_jacuzzi: mde,
  "global_filter_kids-toys": "Jouets pour enfants",
  global_filter_lakes: fde,
  global_filter_luxury: bde,
  global_filter_mountains: _de,
  "global_filter_no-bed-up": "Pas de lit d'appoint",
  global_filter_numOfBathrooms: vde,
  global_filter_other: yde,
  "global_filter_parking-space": "Place de parking privé",
  "global_filter_pets-welcome": "Les animaux sont les bienvenus",
  global_filter_piano: wde,
  global_filter_playground: kde,
  global_filter_primary: xde,
  "global_filter_public-transit-access": "Accès aux transports publics",
  global_filter_reciprocal: $de,
  "global_filter_response-rate-above-threshold": "Réactivité ≥ Moyenne",
  global_filter_reverse: Sde,
  global_filter_river: Cde,
  global_filter_seaside: Ede,
  global_filter_secondary: jde,
  "global_filter_secured-pool": "Piscine sécurisée",
  "global_filter_smokers-welcome": "Fumeurs bienvenus",
  "global_filter_swimming-pool": "Piscine",
  global_filter_tv: Ode,
  global_filter_villages: zde,
  "global_filter_washing-machine": "Lave linge",
  "global_filter_whole-unit": "L'intégralité du logement",
  global_filter_wifi: Ade,
  global_filters: Pde,
  global_fixDates: Dde,
  global_flexDates_aMonth: Nde,
  global_flexDates_aWeekend: Rde,
  global_flexDates_oneWeek: Ide,
  global_flexDates_twoWeek: Tde,
  global_flexibleDates: Lde,
  global_guests: Mde,
  global_homes: Wde,
  global_lastMinute: Bde,
  global_location: Fde,
  global_modify: Vde,
  global_name: Ude,
  global_next: qde,
  global_numberOfAdults_zero: Hde,
  global_numberOfAdults_one: Gde,
  global_numberOfAdults_other: Kde,
  global_numberOfBabies_zero: Jde,
  global_numberOfBabies_one: Zde,
  global_numberOfBabies_other: Yde,
  global_numberOfChildren_zero: Xde,
  global_numberOfChildren_one: Qde,
  global_numberOfChildren_other: ege,
  global_numberOfGuests_zero: tge,
  global_numberOfGuests_one: age,
  global_numberOfGuests_other: oge,
  global_phoneNumber_notValid: nge,
  global_receiveEmailAlerts: rge,
  global_save: ige,
  global_searchBar_noLocationFound: sge,
  global_seeMore_link: lge,
  global_travelWishlist: cge,
  "modal.error-occured.content": "Toutes nos excuses : quelque chose ne s'est pas passé comme prévu, il va falloir que vous retentiez votre chance !",
  "modal.error-occured.title": "Une erreur s'est produite",
  no_result: uge,
  optional: dge,
  "privacy-policy": "Charte de vie privée"
}, hge = "Contact", pge = "FAQ", mge = "Garanties", fge = "GuestPoints", bge = "Aide", _ge = "Log out", vge = "Messages", yge = "Settings", wge = {
  "about-the-calendar": "Calendrier",
  "add-home": "Add a home",
  contact: hge,
  faq: pge,
  guarantees: mge,
  guestpoints: fge,
  help: bge,
  "how-it-works": "Comment ça marche ?",
  "how-much-does-it-cost": "Combien ça coûte ?",
  logout: _ge,
  messages: vge,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "",
  "notification.home.complete_home_first_time": "",
  "notification.home.empty_calendar": "",
  "notification.home.new_calendar_type": "",
  "notification.home.offline": "",
  "notification.membership.expired": "",
  "notification.membership.lead": "",
  "notification.user_profile.incomplete": "",
  "notification.user_profile.motivate_incomplete": "",
  "refer-your-friends": "Refer your friends",
  settings: yge,
  "sign-in": "Se connecter",
  "sign-up": "S'inscrire",
  "sign-up-for-free": "Inscrivez-vous gratuitement",
  "signin.modal.apple-button": "Se connecter avec Apple",
  "signin.modal.facebook-button": "Se connecter avec Facebook",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, kge = "https://www.homeexchange.fr/blog/", xge = "/p/conditions-generale-d-utilisation", $ge = "https://www.homeexchange.fr/p/communaute", Sge = "https://homeexchangehelp.zendesk.com/hc/fr", Cge = "https://forum.homeexchange.com/c/francais/21", Ege = "https://www.homeexchange.fr/p/service-homeexchange-fr", jge = "https://www.homeexchange.fr/p/comment-fonctionnent-les-gp", Oge = "https://www.homeexchange.fr/p/presse", zge = "https://www.homeexchange.com/p/paroles-homeexchangers", Age = "https://help.homeexchange.com/hc/fr/articles/360000623717-Que-sont-Mes-destinations-pr%C3%A9f%C3%A9r%C3%A9es-et-comment-les-utiliser", Pge = "https://www.homeexchange.fr/p/les-fondamentaux ", Dge = "https://www.homeexchange.fr/p/les-fondamentaux", Nge = {
  "about-calendar": "https://help.homeexchange.com/hc/fr/articles/360007584998-Tout-ce-que-vous-devez-savoir-sur-le-calendrier",
  "about-us": "https://www.homeexchange.fr/p/qui-sommes-nous",
  blog: kge,
  cgu: xge,
  community: $ge,
  "contact-us": "https://www.homeexchange.fr/contactez-nous-homeexchange",
  "cookie-policy": "/p/nos-cookies",
  "facebook-page": "https://www.facebook.com/HomeExchangeFR/",
  faq: Sge,
  forum: Cge,
  guarantees: Ege,
  guestpoints: jge,
  "happiness-team": "https://www.homeexchange.fr/p/happiness-team-fr",
  "how-it-works": "https://www.homeexchange.fr/p/comment-ca-marche-fr",
  "join-us": "https://www.homeexchange.fr/p/recrutement",
  "legal-notice": "/p/mentions-legales",
  "mobile-app": "https://www.homeexchange.fr/p/applications-mobile",
  "our-team": "https://www.homeexchange.fr/p/notre-equipe",
  press: Oge,
  "privacy-policy": "/p/charte-vie-privee",
  "subscription-cost": "https://www.homeexchange.fr/p/subscription-homeexchange-fr",
  "term-of-use": "/p/conditions-generale-d-utilisation",
  testimonials: zge,
  travelWishlist_faq_links: Age,
  "twitter-page": "https://twitter.com/HomeExchangeFR",
  value: Pge,
  values: Dge
}, Rge = "Studio", Ige = "{{count}} soba", Tge = "{{count}} sobe", Lge = "{{count}} sobe", Mge = "", Wge = "{{count}} krevet", Bge = "{{count}} kreveti", Fge = "{{count}} kreveti", Vge = "Odrasle osobe", Uge = "Bebe", qge = "Vaš je kalendar ažuriran.", Hge = "Mjesec", Gge = "Točni datumi", Kge = "Jedan tjedan", Jge = "Jedan vikend", Zge = "dana", Yge = "dan", Xge = "dana", Qge = "± {{count}} dan", ehe = "Dva tjedna", the = "Odustani", ahe = "Djeca", ohe = "Datumi", nhe = "Izbrišite", rhe = "Opis", ihe = "Odredište", she = "Gotovo!", lhe = "Uredite", che = "Sve vrste zamjene", uhe = "Kada", dhe = "Roštilj", ghe = "Bicikl", hhe = "Automobil", phe = "Mačka", mhe = "Grad", fhe = "Ruralno", bhe = "Perilica suđa", _he = "Pas", vhe = "Sušilica", yhe = "Dizalo", whe = "Favoriti", khe = "Kamin", xhe = "Stan", $he = "Privatno dvorište", She = "manje od {{max}} GP", Che = "od {{min}} GP", Ehe = "Između {{min}} i {{max}} GP", jhe = "Privatna teretana", Ohe = "Kuća", zhe = "Otok", Ahe = "Izoliran", Phe = "Jacuzzi", Dhe = "Jezera", Nhe = "Domove iz Collectiona", Rhe = "Planine", Ihe = "broj kupanica: %{count}", The = "Ostale životinje", Lhe = "Glasovir", Mhe = "Dječje igralište", Whe = "Moj dom", Bhe = "Recipročna zamjena", Fhe = "Obrnuta pretraga", Vhe = "Rijeka", Uhe = "Na obali", qhe = "Drugi", Hhe = "TV", Ghe = "Selo", Khe = "WiFi", Jhe = "Filtri", Zhe = "Fiksni datumi", Yhe = "{{date}}: jedan mjesec", Xhe = "{{date}}: jedan vikend", Qhe = "{{date}}: jedan tjedan", epe = "{{date}}: dva tjedna", tpe = "Fleksibilni datumi", ape = "Gosti", ope = "domova", npe = "U zadnji tren", rpe = "Lokacija", ipe = "Uredi", spe = "", lpe = "Dalje", cpe = "odraslih osoba", upe = "odrasla osoba", dpe = "odrasle osobe", gpe = "odraslih osoba", hpe = "beba", ppe = "beba", mpe = "bebe", fpe = "beba", bpe = "djece", _pe = "dijete", vpe = "djeteta", ype = "djece", wpe = "gostiju", kpe = "gost", xpe = "gosta", $pe = "gostiju", Spe = "Format telefonskog broja nije valjan.", Cpe = "Primajte obavijesti e-poštom", Epe = "Spremi", jpe = "Nema pronađenih lokacija", Ope = "Saznajte više", zpe = "Planovi putovanja", Ape = "", Ppe = "nije obavezno", Dpe = {
  "autocomplete.button": "Pretražite",
  "autocomplete.placeholder": "Gdje ideš ?",
  bedroomsNumbers_zero: Rge,
  bedroomsNumbers_one: Ige,
  bedroomsNumbers_few: Tge,
  bedroomsNumbers_other: Lge,
  beds_zero: Mge,
  beds_one: Wge,
  beds_few: Bge,
  beds_other: Fge,
  "button.free-signup": "Prijavite se besplatno",
  "button.validate": "Potvrdite",
  "common.try-again": "Pokušajte ponovno",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Ne smije biti dulje od {{limit}} znakova",
  "error.reload": "Osvježite stranicu",
  "error.return-homepage": "Vratite se na početnu stranicu",
  "error.subtitle": "Nažalost ne može se pristupiti ovoj stranici.",
  "error.title": "Došlo je do greške na stranici.",
  "errors.unable_to_submit.subtitle": "Nažalost, Vaš obrazac trenutačno ne može biti predan. Molimo da kasnije pokušate ponovno.",
  "errors.unable_to_submit.title": "Ups, imamo problem",
  "global.back": "Natrag",
  "global.cancel": "Odustani",
  "global.collection.browsehomes": "Pretražujte domove",
  "global.collection.contactus": "Kontaktirajte nas",
  "global.confirm": "Potvrdi",
  "global.continue": "Nastavite",
  "global.getStarted": "Započnite",
  "global.login": "Prijava",
  "global.select": "Odaberi",
  global_adults: Vge,
  global_babies: Uge,
  global_calendarUpdated_toast: qge,
  global_calendar_aMonth: Hge,
  global_calendar_exactDates: Gge,
  global_calendar_oneWeek: Kge,
  global_calendar_oneWeekend: Jge,
  global_calendar_plusMinusDay_zero: Zge,
  global_calendar_plusMinusDay_one: Yge,
  global_calendar_plusMinusDay_few: Xge,
  global_calendar_plusMinusDay_other: Qge,
  global_calendar_twoWeeks: ehe,
  global_cancel: the,
  global_children: ahe,
  global_dates: ohe,
  global_delete: nhe,
  global_description: rhe,
  global_destination: ihe,
  global_done: she,
  global_edit: lhe,
  "global_filter_a-c": "Klima uređaj",
  global_filter_available: che,
  "global_filter_baby-bed": "Kreveti za bebe",
  "global_filter_baby-gear": "Oprema za bebe",
  "global_filter_balcony-terrace": "Balkon/terasa",
  global_filter_bathtub: uhe,
  global_filter_bbq: dhe,
  global_filter_bicycle: ghe,
  global_filter_car: hhe,
  global_filter_cat: phe,
  "global_filter_children-welcome": "Djeca su dobrodošla",
  global_filter_cities: mhe,
  "global_filter_cleaning-person": "Čistačica",
  global_filter_countryside: fhe,
  "global_filter_dedicated-workspace": "Zaseban radni prostor",
  "global_filter_disabled-access": "Pristupačan dom",
  global_filter_dishwasher: bhe,
  global_filter_dog: _he,
  global_filter_dryer: vhe,
  "global_filter_eco-level": "Samo održivi domovi",
  "global_filter_electric-car-plug": "Utikač za električni automobil",
  global_filter_elevator: yhe,
  global_filter_favorite: whe,
  global_filter_fireplace: khe,
  global_filter_flat: xhe,
  global_filter_garden: $he,
  "global_filter_guest-wanted": "Zamjena sa GuestPoints bodovima",
  global_filter_guestPointsMax: She,
  global_filter_guestPointsMin: Che,
  global_filter_guestPointsMinMax: Ehe,
  global_filter_gym: jhe,
  "global_filter_heating-system": "Sustav grijanja",
  "global_filter_high-speed-connexion": "Velika brzina veze",
  global_filter_home: Ohe,
  "global_filter_home-verified": "Provjereni domovi ",
  global_filter_island: zhe,
  global_filter_isolated: Ahe,
  global_filter_jacuzzi: Phe,
  "global_filter_kids-toys": "Dječje igračke",
  global_filter_lakes: Dhe,
  global_filter_luxury: Nhe,
  global_filter_mountains: Rhe,
  "global_filter_no-bed-up": "Nema privremenih kreveta",
  global_filter_numOfBathrooms: Ihe,
  global_filter_other: The,
  "global_filter_parking-space": "Privatno parkirno mjesto",
  "global_filter_pets-welcome": "Kućni ljubimci su dobrodošli",
  global_filter_piano: Lhe,
  global_filter_playground: Mhe,
  global_filter_primary: Whe,
  "global_filter_public-transit-access": "Pristup javnim prijevozom",
  global_filter_reciprocal: Bhe,
  "global_filter_response-rate-above-threshold": "Stopa odgovora ≥ Prosječno",
  global_filter_reverse: Fhe,
  global_filter_river: Vhe,
  global_filter_seaside: Uhe,
  global_filter_secondary: qhe,
  "global_filter_secured-pool": "Osiguran bazen",
  "global_filter_smokers-welcome": "Dozvoljeno pušenje",
  "global_filter_swimming-pool": "Bazen",
  global_filter_tv: Hhe,
  global_filter_villages: Ghe,
  "global_filter_washing-machine": "Perilica rublja",
  "global_filter_whole-unit": "Cijela jedinica",
  global_filter_wifi: Khe,
  global_filters: Jhe,
  global_fixDates: Zhe,
  global_flexDates_aMonth: Yhe,
  global_flexDates_aWeekend: Xhe,
  global_flexDates_oneWeek: Qhe,
  global_flexDates_twoWeek: epe,
  global_flexibleDates: tpe,
  global_guests: ape,
  global_homes: ope,
  global_lastMinute: npe,
  global_location: rpe,
  global_modify: ipe,
  global_name: spe,
  global_next: lpe,
  global_numberOfAdults_zero: cpe,
  global_numberOfAdults_one: upe,
  global_numberOfAdults_few: dpe,
  global_numberOfAdults_other: gpe,
  global_numberOfBabies_zero: hpe,
  global_numberOfBabies_one: ppe,
  global_numberOfBabies_few: mpe,
  global_numberOfBabies_other: fpe,
  global_numberOfChildren_zero: bpe,
  global_numberOfChildren_one: _pe,
  global_numberOfChildren_few: vpe,
  global_numberOfChildren_other: ype,
  global_numberOfGuests_zero: wpe,
  global_numberOfGuests_one: kpe,
  global_numberOfGuests_few: xpe,
  global_numberOfGuests_other: $pe,
  global_phoneNumber_notValid: Spe,
  global_receiveEmailAlerts: Cpe,
  global_save: Epe,
  global_searchBar_noLocationFound: jpe,
  global_seeMore_link: Ope,
  global_travelWishlist: zpe,
  "modal.error-occured.content": "Žao nam je zbog neugodnosti, ali pokušajte ponovno.",
  "modal.error-occured.title": "Došlo je do pogreške.",
  no_result: Ape,
  optional: Ppe,
  "privacy-policy": "Pravila o privatnosti"
}, Npe = "Kontaktirajte nas", Rpe = "FAQ", Ipe = "Garancije", Tpe = "GuestPoints", Lpe = "Pomoć", Mpe = "Log out", Wpe = "Messages", Bpe = "Settings", Fpe = {
  "about-the-calendar": "Kalendar",
  "add-home": "Add a home",
  contact: Npe,
  faq: Rpe,
  guarantees: Ipe,
  guestpoints: Tpe,
  help: Lpe,
  "how-it-works": "Kako funkcionira?",
  "how-much-does-it-cost": "Koliko košta?",
  logout: Mpe,
  messages: Wpe,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "",
  "notification.home.complete_home_first_time": "",
  "notification.home.empty_calendar": "",
  "notification.home.new_calendar_type": "",
  "notification.home.offline": "",
  "notification.membership.expired": "",
  "notification.membership.lead": "",
  "notification.user_profile.incomplete": "",
  "notification.user_profile.motivate_incomplete": "",
  "refer-your-friends": "Refer your friends",
  settings: Bpe,
  "sign-in": "Prijavite se",
  "sign-up": "Registrirajte se",
  "sign-up-for-free": "Prijavite se besplatno",
  "signin.modal.apple-button": "Prijavite se s Apple ID-om",
  "signin.modal.facebook-button": "Prijavite se putem Facebooka",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, Vpe = "https://www.homeexchange.com/blog/", Upe = "/p/general-terms-of-use", qpe = "https://www.homeexchange.com/hr/p/zajednica", Hpe = "https://homeexchangehelp.zendesk.com/hc/en-us", Gpe = "", Kpe = "https://www.homeexchange.com/hr/p/service-homeexchange-hr", Jpe = "https://www.homeexchange.com/hr/p/guestpoints-hr", Zpe = "https://www.homeexchange.com/hr/p/press-hr", Ype = "https://www.homeexchange.com/p/rijeci-homeexchange", Xpe = "", Qpe = "https://www.homeexchange.com/hr/p/gdje-dobrodoslica-stvarno-pocinje", eme = "https://www.homeexchange.com/hr/p/gdje-dobrodoslica-stvarno-pocinje", tme = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/hr/p/about-us-hr",
  blog: Vpe,
  cgu: Upe,
  community: qpe,
  "contact-us": "https://www.homeexchange.com/hr/kontaktirajte-nas-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: Hpe,
  forum: Gpe,
  guarantees: Kpe,
  guestpoints: Jpe,
  "happiness-team": "https://www.homeexchange.com/hr/p/happiness-team-hr",
  "how-it-works": "https://www.homeexchange.com/hr/p/kako-to-funkcionira-hr",
  "join-us": "https://www.homeexchange.com/hr/p/join-us-hr",
  "legal-notice": "/p/pravna-napomena",
  "mobile-app": "https://www.homeexchange.com/hr/p/mobilna-aplikacija",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: Zpe,
  "privacy-policy": "/p/privacy-policy-hr",
  "subscription-cost": "https://www.homeexchange.com/hr/p/subscription-homeexchange-hr",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: Ype,
  travelWishlist_faq_links: Xpe,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: Qpe,
  values: eme
}, ame = "Monolocale", ome = "{{count}} camera da letto", nme = "{{count}} camere da letto", rme = "", ime = "{{count}} letto", sme = "{{count}} letti", lme = "Adulti", cme = "Neonati", ume = "Il tuo calendario è stato aggiornato.", dme = "Un mese", gme = "Date esatte", hme = "Una settimana", pme = "", mme = "", fme = "", bme = "", _me = "Due settimane", vme = "Annulla", yme = "Bambini", wme = "Date", kme = "Elimina", xme = "Descrizione", $me = "Destinazione", Sme = "Fatto!", Cme = "Modifica", Eme = "Qualsiasi tipo di scambio", jme = "Vasca da bagno", Ome = "Barbecue", zme = "Bicicletta", Ame = "Automobile", Pme = "Gatto", Dme = "Città", Nme = "Campagna", Rme = "Lavastoviglie", Ime = "Cane", Tme = "Asciugatrice", Lme = "Ascensore", Mme = "Case preferite", Wme = "Camino", Bme = "Appartamento", Fme = "Cortile privato", Vme = "Meno di {{max}} GP", Ume = "da {{min}} GP", qme = "Tra {{min}} e {{max}} GP", Hme = "Palestra privata", Gme = "Casa", Kme = "Isola o penisola", Jme = "Isolata", Zme = "Idromassaggio", Yme = "Lago", Xme = "Case Collection", Qme = "Montagna", efe = "{{count}} bagni", tfe = "Altri animali", afe = "Pianoforte", ofe = "Zona giochi per bambini", nfe = "Prima", rfe = "Scambio reciproco", ife = "Ricerca inversa", sfe = "Fiume", lfe = "Sulla costa", cfe = "Seconda", ufe = "TV", dfe = "Paese", gfe = "WiFi", hfe = "Filtri", pfe = "Date esatte", mfe = "Un mese in {{date}}", ffe = "Un fine settimana in {{date}}", bfe = "Una settimana in {{date}}", _fe = "Due settimane in {{date}}", vfe = "Date flessibili", yfe = "Ospiti", wfe = "case", kfe = "Ultimo minuto", xfe = "Posizione", $fe = "Modifica", Sfe = "Nome", Cfe = "Avanti", Efe = "Zero", jfe = "Uno", Ofe = "Altro", zfe = "Zero", Afe = "Uno", Pfe = "Altro", Dfe = "Zero", Nfe = "Uno", Rfe = "Altro", Ife = "Zero", Tfe = "Uno", Lfe = "Altro", Mfe = "Il formato del numero di telefono non è valido.", Wfe = "Ricevi avvisi via email", Bfe = "Salva", Ffe = "Nessuna posizione trovata", Vfe = "Vedere di più", Ufe = "Lista dei progetti di viaggio", qfe = "", Hfe = "facoltativo", Gfe = {
  "autocomplete.button": "Ricerca",
  "autocomplete.placeholder": "Dove stai andando?",
  bedroomsNumbers_zero: ame,
  bedroomsNumbers_one: ome,
  bedroomsNumbers_other: nme,
  beds_zero: rme,
  beds_one: ime,
  beds_other: sme,
  "button.free-signup": "Iscriviti gratis",
  "button.validate": "Convalida",
  "common.try-again": "Prova ancora",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Non deve superare i {{limit}} caratteri",
  "error.reload": "Aggiorna la pagina",
  "error.return-homepage": "Ritorna alla home page",
  "error.subtitle": "Si è verificato un errore e non è stato possibile caricare questa pagina.",
  "error.title": "Si è verificato un errore nella pagina",
  "errors.unable_to_submit.subtitle": "Errore durante l'invio del modulo. Per favore riprova più tardi.",
  "errors.unable_to_submit.title": "Errore: è impossibile inviare",
  "global.back": "Indietro",
  "global.cancel": "Annulla",
  "global.collection.browsehomes": "Sfoglia le case",
  "global.collection.contactus": "Contattaci",
  "global.confirm": "Conferma",
  "global.continue": "Continua",
  "global.getStarted": "Cominciare",
  "global.login": "Accedi",
  "global.select": "Seleziona",
  global_adults: lme,
  global_babies: cme,
  global_calendarUpdated_toast: ume,
  global_calendar_aMonth: dme,
  global_calendar_exactDates: gme,
  global_calendar_oneWeek: hme,
  global_calendar_oneWeekend: pme,
  global_calendar_plusMinusDay_zero: mme,
  global_calendar_plusMinusDay_one: fme,
  global_calendar_plusMinusDay_other: bme,
  global_calendar_twoWeeks: _me,
  global_cancel: vme,
  global_children: yme,
  global_dates: wme,
  global_delete: kme,
  global_description: xme,
  global_destination: $me,
  global_done: Sme,
  global_edit: Cme,
  "global_filter_a-c": "Aria condizionata",
  global_filter_available: Eme,
  "global_filter_baby-bed": "Lettini per bambini",
  "global_filter_baby-gear": "Attrezzature per neonato",
  "global_filter_balcony-terrace": "Balcone/Terrazza",
  global_filter_bathtub: jme,
  global_filter_bbq: Ome,
  global_filter_bicycle: zme,
  global_filter_car: Ame,
  global_filter_cat: Pme,
  "global_filter_children-welcome": "Bambini benvenuti",
  global_filter_cities: Dme,
  "global_filter_cleaning-person": "Donna delle pulizie",
  global_filter_countryside: Nme,
  "global_filter_dedicated-workspace": "Spazio di lavoro dedicato",
  "global_filter_disabled-access": "Casa accessibile alle sedie a rotelle",
  global_filter_dishwasher: Rme,
  global_filter_dog: Ime,
  global_filter_dryer: Tme,
  "global_filter_eco-level": "Solo case sostenibili",
  "global_filter_electric-car-plug": "Presa per auto elettrica",
  global_filter_elevator: Lme,
  global_filter_favorite: Mme,
  global_filter_fireplace: Wme,
  global_filter_flat: Bme,
  global_filter_garden: Fme,
  "global_filter_guest-wanted": "Scambio con GuestPoints",
  global_filter_guestPointsMax: Vme,
  global_filter_guestPointsMin: Ume,
  global_filter_guestPointsMinMax: qme,
  global_filter_gym: Hme,
  "global_filter_heating-system": "Sistema di riscaldamento",
  "global_filter_high-speed-connexion": "Connessione ad alta velocità",
  global_filter_home: Gme,
  "global_filter_home-verified": "Case verificate",
  global_filter_island: Kme,
  global_filter_isolated: Jme,
  global_filter_jacuzzi: Zme,
  "global_filter_kids-toys": "Giocattoli per bambini",
  global_filter_lakes: Yme,
  global_filter_luxury: Xme,
  global_filter_mountains: Qme,
  "global_filter_no-bed-up": "Nessun letto temporaneo",
  global_filter_numOfBathrooms: efe,
  global_filter_other: tfe,
  "global_filter_parking-space": "Posto auto privato",
  "global_filter_pets-welcome": "Animali domestici ammessi",
  global_filter_piano: afe,
  global_filter_playground: ofe,
  global_filter_primary: nfe,
  "global_filter_public-transit-access": "Accesso ai trasporti pubblici",
  global_filter_reciprocal: rfe,
  "global_filter_response-rate-above-threshold": "Tasso di risposta ≥ Nella media",
  global_filter_reverse: ife,
  global_filter_river: sfe,
  global_filter_seaside: lfe,
  global_filter_secondary: cfe,
  "global_filter_secured-pool": "Piscina protetta",
  "global_filter_smokers-welcome": "I fumatori sono i benvenuti",
  "global_filter_swimming-pool": "Piscina",
  global_filter_tv: ufe,
  global_filter_villages: dfe,
  "global_filter_washing-machine": "Lavatrice",
  "global_filter_whole-unit": "L'intera unità",
  global_filter_wifi: gfe,
  global_filters: hfe,
  global_fixDates: pfe,
  global_flexDates_aMonth: mfe,
  global_flexDates_aWeekend: ffe,
  global_flexDates_oneWeek: bfe,
  global_flexDates_twoWeek: _fe,
  global_flexibleDates: vfe,
  global_guests: yfe,
  global_homes: wfe,
  global_lastMinute: kfe,
  global_location: xfe,
  global_modify: $fe,
  global_name: Sfe,
  global_next: Cfe,
  global_numberOfAdults_zero: Efe,
  global_numberOfAdults_one: jfe,
  global_numberOfAdults_other: Ofe,
  global_numberOfBabies_zero: zfe,
  global_numberOfBabies_one: Afe,
  global_numberOfBabies_other: Pfe,
  global_numberOfChildren_zero: Dfe,
  global_numberOfChildren_one: Nfe,
  global_numberOfChildren_other: Rfe,
  global_numberOfGuests_zero: Ife,
  global_numberOfGuests_one: Tfe,
  global_numberOfGuests_other: Lfe,
  global_phoneNumber_notValid: Mfe,
  global_receiveEmailAlerts: Wfe,
  global_save: Bfe,
  global_searchBar_noLocationFound: Ffe,
  global_seeMore_link: Vfe,
  global_travelWishlist: Ufe,
  "modal.error-occured.content": "Ci spiace davvero per l'inconveniente, ti chiediamo di riprovare.",
  "modal.error-occured.title": "Oh no, si è verificato un errore!",
  no_result: qfe,
  optional: Hfe,
  "privacy-policy": "Informativa sulla privacy"
}, Kfe = "Contatti", Jfe = "Domande frequenti", Zfe = "Garanzie", Yfe = "GuestPoints", Xfe = "Aiuto", Qfe = "Log out", ebe = "Messages", tbe = "Settings", abe = {
  "about-the-calendar": "Calendario",
  "add-home": "Add a home",
  contact: Kfe,
  faq: Jfe,
  guarantees: Zfe,
  guestpoints: Yfe,
  help: Xfe,
  "how-it-works": "Come funziona?",
  "how-much-does-it-cost": "Quanto costa?",
  logout: Qfe,
  messages: ebe,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "",
  "notification.home.complete_home_first_time": "",
  "notification.home.empty_calendar": "",
  "notification.home.new_calendar_type": "",
  "notification.home.offline": "",
  "notification.membership.expired": "",
  "notification.membership.lead": "",
  "notification.user_profile.incomplete": "",
  "notification.user_profile.motivate_incomplete": "",
  "refer-your-friends": "Refer your friends",
  settings: tbe,
  "sign-in": "Accedi",
  "sign-up": "Registrati",
  "sign-up-for-free": "Iscriviti gratis",
  "signin.modal.apple-button": "Accedi con Apple",
  "signin.modal.facebook-button": "Accedi tramite Facebook",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, obe = "https://www.homeexchange.it/blog/", nbe = "/p/homeexchange-condizioni-di-uso", rbe = "https://www.homeexchange.it/p/comunita", ibe = "https://homeexchangehelp.zendesk.com/hc/it", sbe = "", lbe = "https://www.homeexchange.it/p/service-homeexchange-it", cbe = "https://www.homeexchange.it/p/guestpoints-it", ube = "https://www.homeexchange.it/p/stampa", dbe = "https://www.homeexchange.com/p/racconti-homeexchangers", gbe = "https://help.homeexchange.com/hc/it/articles/360000623717-Cosa-sono-le-mie-destinazioni-preferite-e-a-cosa-servono", hbe = "", pbe = "https://www.homeexchange.it/p/la-dove-accoglienza-inizia-davvero", mbe = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.it/p/about-us-it",
  blog: obe,
  cgu: nbe,
  community: rbe,
  "contact-us": "https://www.homeexchange.it/contattaci-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/HomeExchangeIT/",
  faq: ibe,
  forum: sbe,
  guarantees: lbe,
  guestpoints: cbe,
  "happiness-team": "https://www.homeexchange.it/p/happiness-team-it",
  "how-it-works": "https://www.homeexchange.it/p/come-funziona-it",
  "join-us": "https://www.homeexchange.it/p/join-us-it",
  "legal-notice": "/p/avviso-legale",
  "mobile-app": "https://www.homeexchange.it/p/app-mobile",
  "our-team": "https://www.homeexchange.it/p/nostro-team",
  press: ube,
  "privacy-policy": "/p/homeexchange-informativa-privacy",
  "subscription-cost": "https://www.homeexchange.it/p/subscription-homeexchange-it",
  "term-of-use": "/p/homeexchange-condizioni-di-uso",
  testimonials: dbe,
  travelWishlist_faq_links: gbe,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: hbe,
  values: pbe
}, fbe = "Studio", bbe = "{{count}} soverom", _be = "{{count}} soverom", vbe = "", ybe = "{{count}} seng", wbe = "{{count}} senger", kbe = "Voksne", xbe = "Babyer", $be = "", Sbe = "En måned", Cbe = "Nøyaktige datoer", Ebe = "Uke", jbe = "", Obe = "", zbe = "", Abe = "", Pbe = "To uker", Dbe = "", Nbe = "Barn", Rbe = "Datoer", Ibe = "", Tbe = "Beskrivelse", Lbe = "Reisemål", Mbe = "", Wbe = "", Bbe = "alle typer boligbytter", Fbe = "Badekar", Vbe = "Grill", Ube = "Sykkel", qbe = "Bil", Hbe = "Katt", Gbe = "By", Kbe = "Landlig", Jbe = "Oppvaskmaskin", Zbe = "Hund", Ybe = "Tørketrommel", Xbe = "Heis", Qbe = "Favoritthjem", e_e = "Peis", t_e = "Leilighet", a_e = "", o_e = "mindre enn {{max}} GP", n_e = "fra {{min}} GP", r_e = "Mellom {{min}} og {{max}} GP", i_e = "Privat treningsrom", s_e = "Hus", l_e = "Øy", c_e = "Isolert", u_e = "Jacuzzi", d_e = "Innsjøer", g_e = "Collection-hjem", h_e = "Fjell", p_e = "", m_e = "Andre dyr", f_e = "Piano", b_e = "", __e = "Primær", v_e = "Gjensidig boligbytte", y_e = "Omvendt søk", w_e = "Elv", k_e = "", x_e = "Sekundær", $_e = "TV", S_e = "Landsbygd", C_e = "WiFi", E_e = "Filtrer", j_e = "Nøyaktige datoer", O_e = "", z_e = "", A_e = "", P_e = "", D_e = "Fleksible datoer", N_e = "Gjester", R_e = "", I_e = "Siste øyeblikk", T_e = "Beliggenhet", L_e = "", M_e = "", W_e = "", B_e = "", F_e = "", V_e = "", U_e = "", q_e = "", H_e = "", G_e = "", K_e = "", J_e = "", Z_e = "", Y_e = "", X_e = "", Q_e = "", eve = "", tve = "Lagre", ave = "", ove = "Se mer", nve = "", rve = "", ive = "", sve = {
  "autocomplete.button": "Søk",
  "autocomplete.placeholder": "Hvor skal du ?",
  bedroomsNumbers_zero: fbe,
  bedroomsNumbers_one: bbe,
  bedroomsNumbers_other: _be,
  beds_zero: vbe,
  beds_one: ybe,
  beds_other: wbe,
  "button.free-signup": "Registrer deg gratis",
  "button.validate": "Bekreft",
  "common.try-again": "",
  "contact-tech-email": "contact@homeexchange.com",
  "error.characters_max_limit": "Kan ikke overstige {{limit}} tegn",
  "error.reload": "Oppdater siden",
  "error.return-homepage": "Gå tilbake til startsiden",
  "error.subtitle": "Denne siden kan dessverre ikke nås.",
  "error.title": "En feil har oppstått på siden",
  "errors.unable_to_submit.subtitle": "Skjemaet ditt kunne dessverre ikke sendes inn akkurat nå. Vennligst prøv igjen senere.",
  "errors.unable_to_submit.title": "Oops, det har oppstått et problem",
  "global.back": "Tilbake",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "Fortsett",
  "global.getStarted": "",
  "global.login": "",
  "global.select": "",
  global_adults: kbe,
  global_babies: xbe,
  global_calendarUpdated_toast: $be,
  global_calendar_aMonth: Sbe,
  global_calendar_exactDates: Cbe,
  global_calendar_oneWeek: Ebe,
  global_calendar_oneWeekend: jbe,
  global_calendar_plusMinusDay_zero: Obe,
  global_calendar_plusMinusDay_one: zbe,
  global_calendar_plusMinusDay_other: Abe,
  global_calendar_twoWeeks: Pbe,
  global_cancel: Dbe,
  global_children: Nbe,
  global_dates: Rbe,
  global_delete: Ibe,
  global_description: Tbe,
  global_destination: Lbe,
  global_done: Mbe,
  global_edit: Wbe,
  "global_filter_a-c": "Klimaanlegg",
  global_filter_available: Bbe,
  "global_filter_baby-bed": "Sprinkelsenger",
  "global_filter_baby-gear": "Babyutstyr",
  "global_filter_balcony-terrace": "",
  global_filter_bathtub: Fbe,
  global_filter_bbq: Vbe,
  global_filter_bicycle: Ube,
  global_filter_car: qbe,
  global_filter_cat: Hbe,
  "global_filter_children-welcome": "Barn velkommen",
  global_filter_cities: Gbe,
  "global_filter_cleaning-person": "Rengjøringsperson",
  global_filter_countryside: Kbe,
  "global_filter_dedicated-workspace": "",
  "global_filter_disabled-access": "Tilgjengelig for funksjonshemmede",
  global_filter_dishwasher: Jbe,
  global_filter_dog: Zbe,
  global_filter_dryer: Ybe,
  "global_filter_eco-level": "Bare bærekraftige hjem",
  "global_filter_electric-car-plug": "Elektrisk bilplugg",
  global_filter_elevator: Xbe,
  global_filter_favorite: Qbe,
  global_filter_fireplace: e_e,
  global_filter_flat: t_e,
  global_filter_garden: a_e,
  "global_filter_guest-wanted": "Boligbytte med GuestPoints",
  global_filter_guestPointsMax: o_e,
  global_filter_guestPointsMin: n_e,
  global_filter_guestPointsMinMax: r_e,
  global_filter_gym: i_e,
  "global_filter_heating-system": "Oppvarming",
  "global_filter_high-speed-connexion": "Høyhastighets tilkobling",
  global_filter_home: s_e,
  "global_filter_home-verified": "Verifiserte hjem",
  global_filter_island: l_e,
  global_filter_isolated: c_e,
  global_filter_jacuzzi: u_e,
  "global_filter_kids-toys": "Barneleker",
  global_filter_lakes: d_e,
  global_filter_luxury: g_e,
  global_filter_mountains: h_e,
  "global_filter_no-bed-up": "",
  global_filter_numOfBathrooms: p_e,
  global_filter_other: m_e,
  "global_filter_parking-space": "Privat parkering",
  "global_filter_pets-welcome": "Kjæledyr velkommen",
  global_filter_piano: f_e,
  global_filter_playground: b_e,
  global_filter_primary: __e,
  "global_filter_public-transit-access": "Tilgang til offentlig transport",
  global_filter_reciprocal: v_e,
  "global_filter_response-rate-above-threshold": "",
  global_filter_reverse: y_e,
  global_filter_river: w_e,
  global_filter_seaside: k_e,
  global_filter_secondary: x_e,
  "global_filter_secured-pool": "Sikret badebasseng",
  "global_filter_smokers-welcome": "Røykere velkommen",
  "global_filter_swimming-pool": "Svømmebasseng",
  global_filter_tv: $_e,
  global_filter_villages: S_e,
  "global_filter_washing-machine": "Vaskemaskin",
  "global_filter_whole-unit": "Hele boligen",
  global_filter_wifi: C_e,
  global_filters: E_e,
  global_fixDates: j_e,
  global_flexDates_aMonth: O_e,
  global_flexDates_aWeekend: z_e,
  global_flexDates_oneWeek: A_e,
  global_flexDates_twoWeek: P_e,
  global_flexibleDates: D_e,
  global_guests: N_e,
  global_homes: R_e,
  global_lastMinute: I_e,
  global_location: T_e,
  global_modify: L_e,
  global_name: M_e,
  global_next: W_e,
  global_numberOfAdults_zero: B_e,
  global_numberOfAdults_one: F_e,
  global_numberOfAdults_other: V_e,
  global_numberOfBabies_zero: U_e,
  global_numberOfBabies_one: q_e,
  global_numberOfBabies_other: H_e,
  global_numberOfChildren_zero: G_e,
  global_numberOfChildren_one: K_e,
  global_numberOfChildren_other: J_e,
  global_numberOfGuests_zero: Z_e,
  global_numberOfGuests_one: Y_e,
  global_numberOfGuests_other: X_e,
  global_phoneNumber_notValid: Q_e,
  global_receiveEmailAlerts: eve,
  global_save: tve,
  global_searchBar_noLocationFound: ave,
  global_seeMore_link: ove,
  global_travelWishlist: nve,
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: rve,
  optional: ive,
  "privacy-policy": "Personvernpolicy"
}, lve = "Kontakt oss", cve = "FAQ", uve = "Garantier", dve = "About the Guestpoints", gve = "Hjelp", hve = "Log out", pve = "Messages", mve = "Settings", fve = {
  "about-the-calendar": "About the calendar",
  "add-home": "Add a home",
  contact: lve,
  faq: cve,
  guarantees: uve,
  guestpoints: dve,
  help: gve,
  "how-it-works": "Hvordan virker det?",
  "how-much-does-it-cost": "Hvor mye koster det?",
  logout: hve,
  messages: pve,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "",
  "notification.home.complete_home_first_time": "",
  "notification.home.empty_calendar": "",
  "notification.home.new_calendar_type": "",
  "notification.home.offline": "",
  "notification.membership.expired": "",
  "notification.membership.lead": "",
  "notification.user_profile.incomplete": "",
  "notification.user_profile.motivate_incomplete": "",
  "refer-your-friends": "Refer your friends",
  settings: mve,
  "sign-in": "Logg inn",
  "sign-up": "Registrer deg",
  "sign-up-for-free": "Registrer deg gratis",
  "signin.modal.apple-button": "Logg inn med Apple",
  "signin.modal.facebook-button": "Logg inn med Facebook",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, bve = "https://www.homeexchange.com/blog/", _ve = "/p/general-terms-of-use", vve = "https://www.homeexchange.com/nb/p/nettverk", yve = "https://homeexchangehelp.zendesk.com/hc/pt", wve = "", kve = "https://www.homeexchange.com/nb/p/service-homeexchange-no", xve = "https://www.homeexchange.com/nb/p/guestpoints-no", $ve = "https://www.homeexchange.com/nb/p/press-no", Sve = "https://www.homeexchange.com/p/ifolge-homeexchangers", Cve = "", Eve = "", jve = "https://www.homeexchange.com/nb/p/der-velkomsten-virkelig-starter", Ove = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/nb/p/about-us-no",
  blog: bve,
  cgu: _ve,
  community: vve,
  "contact-us": "https://www.homeexchange.com/nb/p/kontact-oss-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: yve,
  forum: wve,
  guarantees: kve,
  guestpoints: xve,
  "happiness-team": "https://www.homeexchange.com/nb/p/happiness-team-no",
  "how-it-works": "https://www.homeexchange.com/nb/p/hvordan-fungerer-det-no",
  "join-us": "https://www.homeexchange.com/nb/p/join-us-no",
  "legal-notice": "/p/legal-notice-no",
  "mobile-app": "https://www.homeexchange.com/nb/p/mobile-app",
  "our-team": "https://www.homeexchange.com/nb/p/teamet-vart",
  press: $ve,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/nb/p/subscription-homeexchange-no",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: Sve,
  travelWishlist_faq_links: Cve,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: Eve,
  values: jve
}, zve = "Studio", Ave = "{{count}} slaapkamer", Pve = "{{count}} slaapkamers", Dve = "", Nve = "{{count}} bed", Rve = "{{count}} bedden", Ive = "Volwassenen", Tve = "Baby's", Lve = "Je kalender is bijgewerkt.", Mve = "Een maand", Wve = "Exacte data", Bve = "Een week", Fve = "Een weekend", Vve = "", Uve = "", qve = "± {{count}} dagen", Hve = "Twee weken", Gve = "Annuleren", Kve = "Kinderen", Jve = "Data", Zve = "Verwijderen", Yve = "Beschrijving", Xve = "Bestemming", Qve = "Klaar!", eye = "Bewerken", tye = "Elk type ruil", aye = "Bad", oye = "BBQ", nye = "Fiets", rye = "Auto", iye = "Kat", sye = "De stad", lye = "Het platteland", cye = "Vaatwasmachine", uye = "Hond", dye = "Droger", gye = "Lift", hye = "Favoriete huizen", pye = "Open haard", mye = "Appartement", fye = "Privétuin", bye = "Minder dan {{max}} GP", _ye = "vanaf {{min}} GP", vye = "Tussen {{min}} en {{max}} GP", yye = "Privésportzaal", wye = "Huis", kye = "Een eiland", xye = "Geïsoleerd", $ye = "Jacuzzi", Sye = "Een meer", Cye = "Collection-huizen", Eye = "De bergen", jye = "{{count}} badkamers", Oye = "Andere dieren", zye = "", Aye = "Speeltuin", Pye = "Eerste", Dye = "Wederzijdse huizenruil", Nye = "Omgekeerd zoeken", Rye = "Rivier", Iye = "Kust", Tye = "Vakantiehuis", Lye = "TV", Mye = "Dorp", Wye = "WiFi", Bye = "Filters", Fye = "Vaste data", Vye = "Een maand in {{date}}", Uye = "Een weekend in {{date}}", qye = "Een week in {{date}}", Hye = "Twee weken in {{date}}", Gye = "Flexibele data", Kye = "Gasten", Jye = "huizen", Zye = "Last minute", Yye = "Locatie", Xye = "Wijzigen", Qye = "Naam", ewe = "Volgende", twe = "", awe = "{{count}} volwassene", owe = "{{count}} volwassenen", nwe = "", rwe = "{{count}} baby", iwe = "{{count}} baby's", swe = "", lwe = "{{count}} kind", cwe = "{{count}} kinderen", uwe = "", dwe = "{{count}} gast", gwe = "{{count}} gasten", hwe = "De indeling van het telefoonnummer is niet geldig.", pwe = "E-mailmeldingen ontvangen", mwe = "Opslaan", fwe = "Geen locaties gevonden", bwe = "Bekijk meer", _we = "Reisplannen", vwe = "Geen resultaat", ywe = "optioneel", wwe = {
  "autocomplete.button": "Zoeken",
  "autocomplete.placeholder": "Waar ga je naar toe ?",
  bedroomsNumbers_zero: zve,
  bedroomsNumbers_one: Ave,
  bedroomsNumbers_other: Pve,
  beds_zero: Dve,
  beds_one: Nve,
  beds_other: Rve,
  "button.free-signup": "Meld je gratis aan",
  "button.validate": "Bevestigen",
  "common.try-again": "Opnieuw proberen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Mag de {{limit}} karakters niet overschrijden",
  "error.reload": "Deze pagina vernieuwen ",
  "error.return-homepage": "Terug naar de startpagina",
  "error.subtitle": "Helaas kon deze pagina niet gevonden worden.",
  "error.title": "Er is een fout opgetreden op de pagina",
  "errors.unable_to_submit.subtitle": "Helaas kon het formulier niet verzonden worden. Probeer het later nog eens.",
  "errors.unable_to_submit.title": "Oeps... het is niet gelukt om het formulier te verzenden.",
  "global.back": "Terug",
  "global.cancel": "Annuleren",
  "global.collection.browsehomes": "Blader door huizen",
  "global.collection.contactus": "Neem contact met ons op",
  "global.confirm": "Bevestigen",
  "global.continue": "Doorgaan",
  "global.getStarted": "Ga van start",
  "global.login": "Inloggen",
  "global.select": "Selecteren",
  global_adults: Ive,
  global_babies: Tve,
  global_calendarUpdated_toast: Lve,
  global_calendar_aMonth: Mve,
  global_calendar_exactDates: Wve,
  global_calendar_oneWeek: Bve,
  global_calendar_oneWeekend: Fve,
  global_calendar_plusMinusDay_zero: Vve,
  global_calendar_plusMinusDay_one: Uve,
  global_calendar_plusMinusDay_other: qve,
  global_calendar_twoWeeks: Hve,
  global_cancel: Gve,
  global_children: Kve,
  global_dates: Jve,
  global_delete: Zve,
  global_description: Yve,
  global_destination: Xve,
  global_done: Qve,
  global_edit: eye,
  "global_filter_a-c": "Airco",
  global_filter_available: tye,
  "global_filter_baby-bed": "Babybedden",
  "global_filter_baby-gear": "Baby spullen",
  "global_filter_balcony-terrace": "",
  global_filter_bathtub: aye,
  global_filter_bbq: oye,
  global_filter_bicycle: nye,
  global_filter_car: rye,
  global_filter_cat: iye,
  "global_filter_children-welcome": "Kinderen welkom",
  global_filter_cities: sye,
  "global_filter_cleaning-person": "Schoonmaakster",
  global_filter_countryside: lye,
  "global_filter_dedicated-workspace": "Toegewijde werkruimte",
  "global_filter_disabled-access": "Toegankelijk voor invaliden",
  global_filter_dishwasher: cye,
  global_filter_dog: uye,
  global_filter_dryer: dye,
  "global_filter_eco-level": "Alleen duurzame woningen",
  "global_filter_electric-car-plug": "Elektrische auto stekker",
  global_filter_elevator: gye,
  global_filter_favorite: hye,
  global_filter_fireplace: pye,
  global_filter_flat: mye,
  global_filter_garden: fye,
  "global_filter_guest-wanted": "Ruil tegen GuestPoints",
  global_filter_guestPointsMax: bye,
  global_filter_guestPointsMin: _ye,
  global_filter_guestPointsMinMax: vye,
  global_filter_gym: yye,
  "global_filter_heating-system": "Verwarming",
  "global_filter_high-speed-connexion": "Snelle verbinding",
  global_filter_home: wye,
  "global_filter_home-verified": "Geverifieerde huizen",
  global_filter_island: kye,
  global_filter_isolated: xye,
  global_filter_jacuzzi: $ye,
  "global_filter_kids-toys": "Kinderen speelgoed",
  global_filter_lakes: Sye,
  global_filter_luxury: Cye,
  global_filter_mountains: Eye,
  "global_filter_no-bed-up": "Geen tijdelijke bedden",
  global_filter_numOfBathrooms: jye,
  global_filter_other: Oye,
  "global_filter_parking-space": "Privé parkeerplaats",
  "global_filter_pets-welcome": "Huisdieren toegestaan ",
  global_filter_piano: zye,
  global_filter_playground: Aye,
  global_filter_primary: Pye,
  "global_filter_public-transit-access": "Toegang tot het openbaar vervoer",
  global_filter_reciprocal: Dye,
  "global_filter_response-rate-above-threshold": "Responspercentage ≥ Gemiddeld",
  global_filter_reverse: Nye,
  global_filter_river: Rye,
  global_filter_seaside: Iye,
  global_filter_secondary: Tye,
  "global_filter_secured-pool": "Beveiligd zwembad",
  "global_filter_smokers-welcome": "Roken toegestaan ",
  "global_filter_swimming-pool": "Zwembad",
  global_filter_tv: Lye,
  global_filter_villages: Mye,
  "global_filter_washing-machine": "Wasmachine",
  "global_filter_whole-unit": "De hele woning",
  global_filter_wifi: Wye,
  global_filters: Bye,
  global_fixDates: Fye,
  global_flexDates_aMonth: Vye,
  global_flexDates_aWeekend: Uye,
  global_flexDates_oneWeek: qye,
  global_flexDates_twoWeek: Hye,
  global_flexibleDates: Gye,
  global_guests: Kye,
  global_homes: Jye,
  global_lastMinute: Zye,
  global_location: Yye,
  global_modify: Xye,
  global_name: Qye,
  global_next: ewe,
  global_numberOfAdults_zero: twe,
  global_numberOfAdults_one: awe,
  global_numberOfAdults_other: owe,
  global_numberOfBabies_zero: nwe,
  global_numberOfBabies_one: rwe,
  global_numberOfBabies_other: iwe,
  global_numberOfChildren_zero: swe,
  global_numberOfChildren_one: lwe,
  global_numberOfChildren_other: cwe,
  global_numberOfGuests_zero: uwe,
  global_numberOfGuests_one: dwe,
  global_numberOfGuests_other: gwe,
  global_phoneNumber_notValid: hwe,
  global_receiveEmailAlerts: pwe,
  global_save: mwe,
  global_searchBar_noLocationFound: fwe,
  global_seeMore_link: bwe,
  global_travelWishlist: _we,
  "modal.error-occured.content": "Onze excuses voor het ongemak, probeer het alsjeblieft opnieuw.",
  "modal.error-occured.title": "Oh nee, er is een fout opgetreden!",
  no_result: vwe,
  optional: ywe,
  "privacy-policy": "Privacy"
}, kwe = "Neem contact met ons op", xwe = "FAQ", $we = "Garanties", Swe = "GuestPoints", Cwe = "Help", Ewe = "Log out", jwe = "Messages", Owe = "Settings", zwe = {
  "about-the-calendar": "Kalender",
  "add-home": "Add a home",
  contact: kwe,
  faq: xwe,
  guarantees: $we,
  guestpoints: Swe,
  help: Cwe,
  "how-it-works": "Hoe werkt het?",
  "how-much-does-it-cost": "Hoeveel kost het?",
  logout: Ewe,
  messages: jwe,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "Voltooi de advertentie van je woning!",
  "notification.home.complete_home_first_time": "Voltooi de advertentie van je huis en ontvang {{gp}} GuestPoints!",
  "notification.home.empty_calendar": "Voeg beschikbaarheid toe aan je kalender voor het komende jaar",
  "notification.home.new_calendar_type": "Nieuwe kalender!",
  "notification.home.offline": "Publiceer je huis!",
  "notification.membership.expired": "Lidmaatschap verlopen",
  "notification.membership.lead": "Activeer je lidmaatschap en ontvang {{gp}} GuestPoints",
  "notification.user_profile.incomplete": "Voltooi je profiel",
  "notification.user_profile.motivate_incomplete": "Voltooi je profiel en ontvang {{gp}} GuestPoints",
  "refer-your-friends": "Refer your friends",
  settings: Owe,
  "sign-in": "Inloggen",
  "sign-up": "Inschrijven",
  "sign-up-for-free": "Meld je gratis aan",
  "signin.modal.apple-button": "Inloggen met Apple",
  "signin.modal.facebook-button": "Meld je aan met Facebook",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, Awe = "https://www.homeexchange.com/nl/blog/", Pwe = "/nl/p/homeexchangegebruiksvoorwaarden", Dwe = "https://www.homeexchange.com/nl/p/gemeenschap", Nwe = "https://homeexchangehelp.zendesk.com/hc/en-us", Rwe = "https://forum.homeexchange.com/c/english/20", Iwe = "https://www.homeexchange.com/nl/p/service-homeexchange-nl", Twe = "https://www.homeexchange.com/nl/p/guestpoints-nl", Lwe = "https://www.homeexchange.com/nl/p/pers", Mwe = "https://www.homeexchange.com/p/wordsonhomeexchange", Wwe = "https://help.homeexchange.com/hc/nl/articles/360000623717-Wat-zijn-Mijn-voorkeursbestemmingen-en-hoe-gebruik-ik-ze", Bwe = "https://www.homeexchange.com/nl/p/where-the-welcome-really-begins", Fwe = "https://www.guesttoguest.com/nl/p/waar-het-welkom-echt-begint", Vwe = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/nl/p/about-us-nl",
  blog: Awe,
  cgu: Pwe,
  community: Dwe,
  "contact-us": "https://www.homeexchange.com/nl/contact-op-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: Nwe,
  forum: Rwe,
  guarantees: Iwe,
  guestpoints: Twe,
  "happiness-team": "https://www.homeexchange.com/nl/p/happiness-team-nl",
  "how-it-works": "https://www.homeexchange.com/nl/p/hoe-werkt-het-nl",
  "join-us": "https://www.homeexchange.com/nl/p/join-us-nl",
  "legal-notice": "/p/wettelijke-vermeldingen",
  "mobile-app": "https://www.homeexchange.com/nl/p/mobiele-app",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: Lwe,
  "privacy-policy": "/p/homeexchange-privacy",
  "subscription-cost": "https://www.homeexchange.com/nl/p/subscription-homeexchange-nl",
  "term-of-use": "/p/homeexchangegebruiksvoorwaarden",
  testimonials: Mwe,
  travelWishlist_faq_links: Wwe,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: Bwe,
  values: Fwe
}, Uwe = "Studio", qwe = "{{count}} quarto", Hwe = "{{count}} quartos", Gwe = "", Kwe = "{{count}} cama", Jwe = "{{count}} camas", Zwe = "", Ywe = "", Xwe = "O seu calendário foi atualizado.", Qwe = "Um mês", eke = "Datas exatas", tke = "Uma semana", ake = "Um fim de semana", oke = "", nke = "± 1:{{count}} dia", rke = "± {{count]] dias", ike = "Duas semanas", ske = "Cancelar", lke = "", cke = "Datas", uke = "Eliminar", dke = "Descrição", gke = "Destino", hke = "Feito!", pke = "Editar", mke = "Qualquer tipo de pedido de Troca", fke = "Banheiro", bke = "BBQ", _ke = "Bicicleta", vke = "Carro", yke = "Gato", wke = "Cidade", kke = "Campo", xke = "Lavadora de louças", $ke = "Cão", Ske = "Secadora", Cke = "Elevador", Eke = "Casas favoritas", jke = "Lareira", Oke = "Apartamento", zke = "Quintal privado", Ake = "", Pke = "", Dke = "", Nke = "", Rke = "Casa", Ike = "Ilha", Tke = "Isolada", Lke = "Jacuzzi", Mke = "Lagos", Wke = "Casas Collection", Bke = "", Fke = "{{count}} casas de banho", Vke = "Outros animais", Uke = "Piano", qke = "Parque infantil", Hke = "Principal", Gke = "Troca Reciproca", Kke = "Busca invertida", Jke = "Rio", Zke = "Litoral", Yke = "Secundária", Xke = "TV", Qke = "Aldeia", exe = "WiFi", txe = "Filtros", axe = "Datas fixas", oxe = "Um mês em {{date}}", nxe = "Um fim de semana em {{date}}", rxe = "Uma semana em {{date}}", ixe = "Duas semanas em {{date}}", sxe = "Datas flexíveis", lxe = "Convidados", cxe = "casas", uxe = "Última hora", dxe = "Localização", gxe = "Modificar", hxe = "Nome", pxe = "Seguinte", mxe = "", fxe = "{{count}} adulto", bxe = "{{count}} adultos", _xe = "", vxe = "{{count}} bebé", yxe = "{{count}} bebés", wxe = "", kxe = "{{count}} criança", xxe = "{{count}} crianças", $xe = "", Sxe = "{{count}} convidado", Cxe = "{{count}} convidados", Exe = "O formato do número de telefone não é válido.", jxe = "Receber alertas por e-mail", Oxe = "Guardar", zxe = "Não foram encontradas localizações", Axe = "Ver mais", Pxe = "Ideias de viagens", Dxe = "", Nxe = "", Rxe = {
  "autocomplete.button": "Procurar",
  "autocomplete.placeholder": "Para onde vai ?",
  bedroomsNumbers_zero: Uwe,
  bedroomsNumbers_one: qwe,
  bedroomsNumbers_other: Hwe,
  beds_zero: Gwe,
  beds_one: Kwe,
  beds_other: Jwe,
  "button.free-signup": "Filie-se gratuitamente",
  "button.validate": "Validar",
  "common.try-again": "",
  "contact-tech-email": "",
  "error.characters_max_limit": "Não deve ser superior a {{limit}} caracteres",
  "error.reload": "Atualizar esta página",
  "error.return-homepage": "Voltar à página inicial",
  "error.subtitle": "Infelizmente, não foi possível aceder a esta página.",
  "error.title": "Ocorreu um erro na página",
  "errors.unable_to_submit.subtitle": "Infelizmente, não foi possível submeter o formulário. Tente novamente mais tarde.",
  "errors.unable_to_submit.title": "Ups, ocorreu um problema!",
  "global.back": "",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "",
  "global.getStarted": "",
  "global.login": "",
  "global.select": "",
  global_adults: Zwe,
  global_babies: Ywe,
  global_calendarUpdated_toast: Xwe,
  global_calendar_aMonth: Qwe,
  global_calendar_exactDates: eke,
  global_calendar_oneWeek: tke,
  global_calendar_oneWeekend: ake,
  global_calendar_plusMinusDay_zero: oke,
  global_calendar_plusMinusDay_one: nke,
  global_calendar_plusMinusDay_other: rke,
  global_calendar_twoWeeks: ike,
  global_cancel: ske,
  global_children: lke,
  global_dates: cke,
  global_delete: uke,
  global_description: dke,
  global_destination: gke,
  global_done: hke,
  global_edit: pke,
  "global_filter_a-c": "A/C",
  global_filter_available: mke,
  "global_filter_baby-bed": "",
  "global_filter_baby-gear": "Equipamento para bebês",
  "global_filter_balcony-terrace": "Varanda/Terraço",
  global_filter_bathtub: fke,
  global_filter_bbq: bke,
  global_filter_bicycle: _ke,
  global_filter_car: vke,
  global_filter_cat: yke,
  "global_filter_children-welcome": "Crianças bem vindas",
  global_filter_cities: wke,
  "global_filter_cleaning-person": "Faxineiro",
  global_filter_countryside: kke,
  "global_filter_dedicated-workspace": "Espaço de trabalho dedicado",
  "global_filter_disabled-access": "Casa acessível",
  global_filter_dishwasher: xke,
  global_filter_dog: $ke,
  global_filter_dryer: Ske,
  "global_filter_eco-level": "Só casas sustentáveis",
  "global_filter_electric-car-plug": "Tomada para carro elétrico",
  global_filter_elevator: Cke,
  global_filter_favorite: Eke,
  global_filter_fireplace: jke,
  global_filter_flat: Oke,
  global_filter_garden: zke,
  "global_filter_guest-wanted": "Troca por GuestPoints",
  global_filter_guestPointsMax: Ake,
  global_filter_guestPointsMin: Pke,
  global_filter_guestPointsMinMax: Dke,
  global_filter_gym: Nke,
  "global_filter_heating-system": "Sistema de aquecimento",
  "global_filter_high-speed-connexion": "Wi-fi de alta velocidade",
  global_filter_home: Rke,
  "global_filter_home-verified": "Casas verificadas",
  global_filter_island: Ike,
  global_filter_isolated: Tke,
  global_filter_jacuzzi: Lke,
  "global_filter_kids-toys": "",
  global_filter_lakes: Mke,
  global_filter_luxury: Wke,
  global_filter_mountains: Bke,
  "global_filter_no-bed-up": "Sem camas temporárias",
  global_filter_numOfBathrooms: Fke,
  global_filter_other: Vke,
  "global_filter_parking-space": "",
  "global_filter_pets-welcome": "Animais de estimação bem-vindos",
  global_filter_piano: Uke,
  global_filter_playground: qke,
  global_filter_primary: Hke,
  "global_filter_public-transit-access": "",
  global_filter_reciprocal: Gke,
  "global_filter_response-rate-above-threshold": "",
  global_filter_reverse: Kke,
  global_filter_river: Jke,
  global_filter_seaside: Zke,
  global_filter_secondary: Yke,
  "global_filter_secured-pool": "Piscina protegida",
  "global_filter_smokers-welcome": "Fumantes bem-vindos",
  "global_filter_swimming-pool": "Piscina",
  global_filter_tv: Xke,
  global_filter_villages: Qke,
  "global_filter_washing-machine": "Máquina de lavar",
  "global_filter_whole-unit": "",
  global_filter_wifi: exe,
  global_filters: txe,
  global_fixDates: axe,
  global_flexDates_aMonth: oxe,
  global_flexDates_aWeekend: nxe,
  global_flexDates_oneWeek: rxe,
  global_flexDates_twoWeek: ixe,
  global_flexibleDates: sxe,
  global_guests: lxe,
  global_homes: cxe,
  global_lastMinute: uxe,
  global_location: dxe,
  global_modify: gxe,
  global_name: hxe,
  global_next: pxe,
  global_numberOfAdults_zero: mxe,
  global_numberOfAdults_one: fxe,
  global_numberOfAdults_other: bxe,
  global_numberOfBabies_zero: _xe,
  global_numberOfBabies_one: vxe,
  global_numberOfBabies_other: yxe,
  global_numberOfChildren_zero: wxe,
  global_numberOfChildren_one: kxe,
  global_numberOfChildren_other: xxe,
  global_numberOfGuests_zero: $xe,
  global_numberOfGuests_one: Sxe,
  global_numberOfGuests_other: Cxe,
  global_phoneNumber_notValid: Exe,
  global_receiveEmailAlerts: jxe,
  global_save: Oxe,
  global_searchBar_noLocationFound: zxe,
  global_seeMore_link: Axe,
  global_travelWishlist: Pxe,
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: Dxe,
  optional: Nxe,
  "privacy-policy": "Privacidade"
}, Ixe = "Contacte-nos", Txe = "Perguntas frequentes", Lxe = "Guarantias", Mxe = "GuestPoints", Wxe = "Ajuda", Bxe = "Log out", Fxe = "Messages", Vxe = "Settings", Uxe = {
  "about-the-calendar": "Calendário",
  "add-home": "Add a home",
  contact: Ixe,
  faq: Txe,
  guarantees: Lxe,
  guestpoints: Mxe,
  help: Wxe,
  "how-it-works": "Como funciona?",
  "how-much-does-it-cost": "Quanto custa?",
  logout: Bxe,
  messages: Fxe,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "",
  "notification.home.complete_home_first_time": "",
  "notification.home.empty_calendar": "",
  "notification.home.new_calendar_type": "",
  "notification.home.offline": "",
  "notification.membership.expired": "",
  "notification.membership.lead": "",
  "notification.user_profile.incomplete": "",
  "notification.user_profile.motivate_incomplete": "",
  "refer-your-friends": "Refer your friends",
  settings: Vxe,
  "sign-in": "Iniciar sessão",
  "sign-up": "Inscreva-se",
  "sign-up-for-free": "Filie-se gratuitamente",
  "signin.modal.apple-button": "Iniciar sessão com a Apple",
  "signin.modal.facebook-button": "Iniciar sessão com o Facebook",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, qxe = "https://www.homeexchange.com/pt/blog/", Hxe = "/p/general-terms-of-use", Gxe = "https://www.homeexchange.com/pt/p/a-nossa-comunidade-pt", Kxe = "https://homeexchangehelp.zendesk.com/hc/en-us", Jxe = "", Zxe = "https://www.homeexchange.com/pt/p/service-homeexchange-pt", Yxe = "https://www.homeexchange.com/pt/p/os-guestpoints", Xxe = "https://www.homeexchange.com/pt/p/press-pt", Qxe = "https://www.homeexchange.com/p/palavras-de-homeexchangers", e1e = "", t1e = "", a1e = "https://www.homeexchange.com/pt/p/onde-as-boas-vindas-comecam", o1e = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/pt/p/about-us-pt",
  blog: qxe,
  cgu: Hxe,
  community: Gxe,
  "contact-us": "https://www.homeexchange.com/pt/contactos-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: Kxe,
  forum: Jxe,
  guarantees: Zxe,
  guestpoints: Yxe,
  "happiness-team": "https://www.homeexchange.com/pt/p/happiness-team-pt",
  "how-it-works": "https://www.homeexchange.com/pt/p/como-funciona-homeexchange",
  "join-us": "https://www.homeexchange.com/pt/p/join-us-pt",
  "legal-notice": "/p/mencoes-legais",
  "mobile-app": "https://www.homeexchange.com/pt/p/app-homeexchange",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: Xxe,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/pt/p/subscription-homeexchange-pt",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: Qxe,
  travelWishlist_faq_links: e1e,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: t1e,
  values: a1e
}, n1e = "Studio", r1e = "{{count}} sovrum", i1e = "{{count}} sovrum", s1e = "", l1e = "{{count}} säng", c1e = "{{count}} sängar", u1e = "Vuxna", d1e = "Småbarn", g1e = "Din kalender har uppdaterats.", h1e = "En månad", p1e = "Exakta datum", m1e = "En vecka", f1e = "En helg", b1e = "", _1e = "± {{count}} dag", v1e = "± {{count}} dagar", y1e = "Två veckor", w1e = "Avbryt", k1e = "Barn", x1e = "Datum", $1e = "Ta bort", S1e = "Beskrivning", C1e = "Resmål", E1e = "Klart!", j1e = "Ändra", O1e = "Alla typer av hembyten", z1e = "Badkar", A1e = "Grill", P1e = "Cykel", D1e = "Bil", N1e = "Katt", R1e = "Stad", I1e = "Landsbygd", T1e = "Diskmaskin", L1e = "Hund", M1e = "Torktumlare", W1e = "Hiss", B1e = "Favorithem", F1e = "Eldstad", V1e = "Lägenhet", U1e = "Privat trädgård", q1e = "Mindre än {{max}} GP", H1e = "från {{min}} GP", G1e = "Mellan {{min}} och {{max}} GuestPoints", K1e = "Hemmagym", J1e = "Hus", Z1e = "Ö", Y1e = "Isolerat", X1e = "Jacuzzi", Q1e = "Sjö", e$e = "Collection-hem", t$e = "Berg", a$e = "{{count}} badrum", o$e = "Andra djur", n$e = "Piano", r$e = "Lekplats för barn", i$e = "Primärt", s$e = "Ömsesidigt hembyte", l$e = "Omvänd sökning", c$e = "Älv", u$e = "Kustnära", d$e = "Sekundärt", g$e = "TV", h$e = "By", p$e = "WiFi", m$e = "Filter", f$e = "Fasta datum", b$e = "En månad i {{date}}", _$e = "En helg i {{date}}", v$e = "En vecka i {{date}}", y$e = "Två veckor i {{date}}", w$e = "Flexibla datum", k$e = "Gäster", x$e = "hem", $$e = "Sista minuten", S$e = "Plats", C$e = "Ändra", E$e = "Namn", j$e = "Nästa", O$e = "", z$e = "{{count}} vuxen", A$e = "{{count}} vuxna", P$e = "", D$e = "{{count}} bebis", N$e = "{{count}} bebisar", R$e = "", I$e = "{{count}} barn", T$e = "{{count}} barn", L$e = "", M$e = "{{count}} gäst", W$e = "{{count}} gäster", B$e = "Telefonnumrets format är inte giltigt.", F$e = "Få e-postaviseringar", V$e = "Spara", U$e = "Inga resmål hittades", q$e = "Se mer", H$e = "Reselista", G$e = "", K$e = "valfritt", J$e = {
  "autocomplete.button": "Sök",
  "autocomplete.placeholder": "Vart ska du ?",
  bedroomsNumbers_zero: n1e,
  bedroomsNumbers_one: r1e,
  bedroomsNumbers_other: i1e,
  beds_zero: s1e,
  beds_one: l1e,
  beds_other: c1e,
  "button.free-signup": "Registrera dig gratis",
  "button.validate": "Godkänn",
  "common.try-again": "Försök igen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Får inte överskrida {{limit}} tecken",
  "error.reload": "Ladda om sidan",
  "error.return-homepage": "Gå tillbaka till startsidan",
  "error.subtitle": "Tyvärr kan inte den här sidan nås.",
  "error.title": "Ett fel uppstod på sidan",
  "errors.unable_to_submit.subtitle": "Tyvärr kunde inte ditt formulär skickas in just nu. Vänligen försök igen senare.",
  "errors.unable_to_submit.title": "Hoppsan, vi har stött på ett problem",
  "global.back": "Tillbaka",
  "global.cancel": "Avbryt",
  "global.collection.browsehomes": "Se fler hem",
  "global.collection.contactus": "Kontakta oss",
  "global.confirm": "Bekräfta",
  "global.continue": "Fortsätt",
  "global.getStarted": "Kom igång",
  "global.login": "Logga in",
  "global.select": "Välj",
  global_adults: u1e,
  global_babies: d1e,
  global_calendarUpdated_toast: g1e,
  global_calendar_aMonth: h1e,
  global_calendar_exactDates: p1e,
  global_calendar_oneWeek: m1e,
  global_calendar_oneWeekend: f1e,
  global_calendar_plusMinusDay_zero: b1e,
  global_calendar_plusMinusDay_one: _1e,
  global_calendar_plusMinusDay_other: v1e,
  global_calendar_twoWeeks: y1e,
  global_cancel: w1e,
  global_children: k1e,
  global_dates: x1e,
  global_delete: $1e,
  global_description: S1e,
  global_destination: C1e,
  global_done: E1e,
  global_edit: j1e,
  "global_filter_a-c": "Luftkonditionering",
  global_filter_available: O1e,
  "global_filter_baby-bed": "Bebissäng",
  "global_filter_baby-gear": "Barnutrustning",
  "global_filter_balcony-terrace": "Balkong/terrass",
  global_filter_bathtub: z1e,
  global_filter_bbq: A1e,
  global_filter_bicycle: P1e,
  global_filter_car: D1e,
  global_filter_cat: N1e,
  "global_filter_children-welcome": "Barn är välkomna",
  global_filter_cities: R1e,
  "global_filter_cleaning-person": "Städare",
  global_filter_countryside: I1e,
  "global_filter_dedicated-workspace": "Kontor",
  "global_filter_disabled-access": "Tillgängligt hem",
  global_filter_dishwasher: T1e,
  global_filter_dog: L1e,
  global_filter_dryer: M1e,
  "global_filter_eco-level": "Endast hållbara hem",
  "global_filter_electric-car-plug": "Elbilsladdare",
  global_filter_elevator: W1e,
  global_filter_favorite: B1e,
  global_filter_fireplace: F1e,
  global_filter_flat: V1e,
  global_filter_garden: U1e,
  "global_filter_guest-wanted": "Hembyte för GuestPoints",
  global_filter_guestPointsMax: q1e,
  global_filter_guestPointsMin: H1e,
  global_filter_guestPointsMinMax: G1e,
  global_filter_gym: K1e,
  "global_filter_heating-system": "Värmesystem",
  "global_filter_high-speed-connexion": "Bredband med hög hastighet",
  global_filter_home: J1e,
  "global_filter_home-verified": "Verifierade hem",
  global_filter_island: Z1e,
  global_filter_isolated: Y1e,
  global_filter_jacuzzi: X1e,
  "global_filter_kids-toys": "Barnleksaker",
  global_filter_lakes: Q1e,
  global_filter_luxury: e$e,
  global_filter_mountains: t$e,
  "global_filter_no-bed-up": "Inga tillfälliga sängar",
  global_filter_numOfBathrooms: a$e,
  global_filter_other: o$e,
  "global_filter_parking-space": "Privat parkeringsplats",
  "global_filter_pets-welcome": "Husdjur är välkomna",
  global_filter_piano: n$e,
  global_filter_playground: r$e,
  global_filter_primary: i$e,
  "global_filter_public-transit-access": "Tillgång till kollektivtrafik",
  global_filter_reciprocal: s$e,
  "global_filter_response-rate-above-threshold": "Svarsprocent ≥ Genomsnittlig",
  global_filter_reverse: l$e,
  global_filter_river: c$e,
  global_filter_seaside: u$e,
  global_filter_secondary: d$e,
  "global_filter_secured-pool": "Säker pool",
  "global_filter_smokers-welcome": "Rökning tillåtet",
  "global_filter_swimming-pool": "Pool",
  global_filter_tv: g$e,
  global_filter_villages: h$e,
  "global_filter_washing-machine": "Tvättmaskin",
  "global_filter_whole-unit": "Hela hemmet",
  global_filter_wifi: p$e,
  global_filters: m$e,
  global_fixDates: f$e,
  global_flexDates_aMonth: b$e,
  global_flexDates_aWeekend: _$e,
  global_flexDates_oneWeek: v$e,
  global_flexDates_twoWeek: y$e,
  global_flexibleDates: w$e,
  global_guests: k$e,
  global_homes: x$e,
  global_lastMinute: $$e,
  global_location: S$e,
  global_modify: C$e,
  global_name: E$e,
  global_next: j$e,
  global_numberOfAdults_zero: O$e,
  global_numberOfAdults_one: z$e,
  global_numberOfAdults_other: A$e,
  global_numberOfBabies_zero: P$e,
  global_numberOfBabies_one: D$e,
  global_numberOfBabies_other: N$e,
  global_numberOfChildren_zero: R$e,
  global_numberOfChildren_one: I$e,
  global_numberOfChildren_other: T$e,
  global_numberOfGuests_zero: L$e,
  global_numberOfGuests_one: M$e,
  global_numberOfGuests_other: W$e,
  global_phoneNumber_notValid: B$e,
  global_receiveEmailAlerts: F$e,
  global_save: V$e,
  global_searchBar_noLocationFound: U$e,
  global_seeMore_link: q$e,
  global_travelWishlist: H$e,
  "modal.error-occured.content": "Vi ber om ursäkt för det, men försök gärna igen.",
  "modal.error-occured.title": "Hoppsan, ett fel uppstod!",
  no_result: G$e,
  optional: K$e,
  "privacy-policy": "Sekretesspolicy"
}, Z$e = "Kontakta oss", Y$e = "FAQ", X$e = "Garantier", Q$e = "GuestPoints", eSe = "Hjälp", tSe = "Log out", aSe = "Messages", oSe = "Settings", nSe = {
  "about-the-calendar": "Kalender",
  "add-home": "Add a home",
  contact: Z$e,
  faq: Y$e,
  guarantees: X$e,
  guestpoints: Q$e,
  help: eSe,
  "how-it-works": "Hur fungerar det?",
  "how-much-does-it-cost": "Hur mycket kostar det?",
  logout: tSe,
  messages: aSe,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "",
  "notification.home.complete_home_first_time": "",
  "notification.home.empty_calendar": "",
  "notification.home.new_calendar_type": "",
  "notification.home.offline": "",
  "notification.membership.expired": "",
  "notification.membership.lead": "",
  "notification.user_profile.incomplete": "",
  "notification.user_profile.motivate_incomplete": "",
  "refer-your-friends": "Refer your friends",
  settings: oSe,
  "sign-in": "Logga in",
  "sign-up": "Registrera dig",
  "sign-up-for-free": "Registrera dig gratis",
  "signin.modal.apple-button": "Logga in med Apple",
  "signin.modal.facebook-button": "Logga in med Facebook",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, rSe = "https://www.homeexchange.com/blog/", iSe = "/p/general-terms-of-use", sSe = "https://www.homeexchange.com/sv/p/natverket", lSe = "https://homeexchangehelp.zendesk.com/hc/es", cSe = "", uSe = "https://www.homeexchange.com/sv/p/service-homeexchange-sv", dSe = "https://www.homeexchange.com/sv/p/guestpoints-sv", gSe = "https://www.homeexchange.com/sv/p/press-sv", hSe = "https://www.homeexchange.com/p/medlemmarna-har-ordet", pSe = "", mSe = "", fSe = "https://www.homeexchange.com/sv/p/dar-valkomnandet-borjar", bSe = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/sv/p/about-us-sv",
  blog: rSe,
  cgu: iSe,
  community: sSe,
  "contact-us": "https://www.homeexchange.com/sv/kontakta-oss-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: lSe,
  forum: cSe,
  guarantees: uSe,
  guestpoints: dSe,
  "happiness-team": "https://www.homeexchange.com/sv/p/happiness-team-sv",
  "how-it-works": "https://www.homeexchange.com/sv/p/hur-fungerar-det-sv",
  "join-us": "https://www.homeexchange.com/sv/p/join-us-sv",
  "legal-notice": "/p/juridisk-information",
  "mobile-app": "https://www.homeexchange.com/sv/p/app-mobil",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: gSe,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/sv/p/subscription-homeexchange-sv",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: hSe,
  travelWishlist_faq_links: pSe,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: mSe,
  values: fSe
}, _Se = "en", Cy = _te({
  fallbackLng: _Se,
  debug: !1,
  interpolation: {
    escapeValue: !1
  },
  returnEmptyString: !1,
  resources: {
    da: {
      common: uoe,
      links: Poe,
      header: voe
    },
    de: {
      common: $re,
      links: Hre,
      header: Dre
    },
    en: {
      common: Lse,
      links: ile,
      header: Gse
    },
    es: {
      common: Xce,
      links: yue,
      header: sue
    },
    fr: {
      common: gge,
      links: Nge,
      header: wge
    },
    hr: {
      common: Dpe,
      links: tme,
      header: Fpe
    },
    it: {
      common: Gfe,
      links: mbe,
      header: abe
    },
    nb: {
      common: sve,
      links: Ove,
      header: fve
    },
    nl: {
      common: wwe,
      links: Vwe,
      header: zwe
    },
    pt: {
      common: Rxe,
      links: o1e,
      header: Uxe
    },
    sv: {
      common: J$e,
      links: bSe,
      header: nSe
    }
  }
});
Cy.init();
const ip = Cy;
var vSe = /(%?)(%([sdijo]))/g;
function ySe(e, t) {
  switch (t) {
    case "s":
      return e;
    case "d":
    case "i":
      return Number(e);
    case "j":
      return JSON.stringify(e);
    case "o": {
      if (typeof e == "string")
        return e;
      const a = JSON.stringify(e);
      return a === "{}" || a === "[]" || /^\[object .+?\]$/.test(a) ? e : a;
    }
  }
}
function dd(e, ...t) {
  if (t.length === 0)
    return e;
  let a = 0, o = e.replace(
    vSe,
    (n, r, i, s) => {
      const l = t[a], c = ySe(l, s);
      return r ? n : (a++, c);
    }
  );
  return a < t.length && (o += ` ${t.slice(a).join(" ")}`), o = o.replace(/%{2,2}/g, "%"), o;
}
var wSe = 2;
function kSe(e) {
  if (!e.stack)
    return;
  const t = e.stack.split(`
`);
  t.splice(1, wSe), e.stack = t.join(`
`);
}
var xSe = class extends Error {
  constructor(t, ...a) {
    super(t), this.message = t, this.name = "Invariant Violation", this.message = dd(t, ...a), kSe(this);
  }
}, gd = (e, t, ...a) => {
  if (!e)
    throw new xSe(t, ...a);
};
gd.as = (e, t, a, ...o) => {
  if (!t) {
    const n = o.length === 0 ? a : dd(a, ...o);
    let r;
    try {
      r = Reflect.construct(e, [
        n
      ]);
    } catch {
      r = e(n);
    }
    throw r;
  }
};
const $Se = "[MSW]";
function hd(e, ...t) {
  const a = dd(e, ...t);
  return `${$Se} ${a}`;
}
function SSe(e, ...t) {
  console.warn(hd(e, ...t));
}
function CSe(e, ...t) {
  console.error(hd(e, ...t));
}
const Ac = {
  formatMessage: hd,
  warn: SSe,
  error: CSe
};
function ESe() {
  gd(
    typeof URL < "u",
    Ac.formatMessage(
      `Global "URL" class is not defined. This likely means that you're running MSW in an environment that doesn't support all Node.js standard API (e.g. React Native). If that's the case, please use an appropriate polyfill for the "URL" class, like "react-native-url-polyfill".`
    )
  );
}
const jSe = /[/\\]msw[/\\]src[/\\](.+)/, OSe = /(node_modules)?[/\\]lib[/\\](core|browser|node|native|iife)[/\\]|^[^/\\]*$/;
function zSe(e) {
  const t = e.stack;
  if (!t)
    return;
  const a = t.split(`
`).slice(1).find((o) => !(jSe.test(o) || OSe.test(o)));
  return a ? a.replace(/\s*at [^()]*\(([^)]+)\)/, "$1").replace(/^@/, "") : void 0;
}
function ASe(e) {
  return e ? Reflect.has(e, Symbol.iterator) || Reflect.has(e, Symbol.asyncIterator) : !1;
}
class Mi {
  static cache = /* @__PURE__ */ new WeakMap();
  __kind;
  info;
  /**
   * Indicates whether this request handler has been used
   * (its resolver has successfully executed).
   */
  isUsed;
  resolver;
  resolverIterator;
  resolverIteratorResult;
  options;
  constructor(t) {
    this.resolver = t.resolver, this.options = t.options;
    const a = zSe(new Error());
    this.info = {
      ...t.info,
      callFrame: a
    }, this.isUsed = !1, this.__kind = "RequestHandler";
  }
  /**
   * Parse the intercepted request to extract additional information from it.
   * Parsed result is then exposed to other methods of this request handler.
   */
  async parse(t) {
    return {};
  }
  /**
   * Test if this handler matches the given request.
   *
   * This method is not used internally but is exposed
   * as a convenience method for consumers writing custom
   * handlers.
   */
  async test(t) {
    const a = await this.parse({
      request: t.request,
      resolutionContext: t.resolutionContext
    });
    return this.predicate({
      request: t.request,
      parsedResult: a,
      resolutionContext: t.resolutionContext
    });
  }
  extendResolverArgs(t) {
    return {};
  }
  // Clone the request instance before it's passed to the handler phases
  // and the response resolver so we can always read it for logging.
  // We only clone it once per request to avoid unnecessary overhead.
  cloneRequestOrGetFromCache(t) {
    const a = Mi.cache.get(t);
    if (typeof a < "u")
      return a;
    const o = t.clone();
    return Mi.cache.set(t, o), o;
  }
  /**
   * Execute this request handler and produce a mocked response
   * using the given resolver function.
   */
  async run(t) {
    if (this.isUsed && this.options?.once)
      return null;
    const a = this.cloneRequestOrGetFromCache(t.request), o = await this.parse({
      request: t.request,
      resolutionContext: t.resolutionContext
    });
    if (!await this.predicate({
      request: t.request,
      parsedResult: o,
      resolutionContext: t.resolutionContext
    }) || this.isUsed && this.options?.once)
      return null;
    this.isUsed = !0;
    const n = this.wrapResolver(this.resolver), r = this.extendResolverArgs({
      request: t.request,
      parsedResult: o
    }), i = await n({
      ...r,
      requestId: t.requestId,
      request: t.request
    }).catch((s) => {
      if (s instanceof Response)
        return s;
      throw s;
    });
    return this.createExecutionResult({
      // Pass the cloned request to the result so that logging
      // and other consumers could read its body once more.
      request: a,
      requestId: t.requestId,
      response: i,
      parsedResult: o
    });
  }
  wrapResolver(t) {
    return async (a) => {
      if (!this.resolverIterator) {
        const i = await t(a);
        if (!ASe(i))
          return i;
        this.resolverIterator = Symbol.iterator in i ? i[Symbol.iterator]() : i[Symbol.asyncIterator]();
      }
      this.isUsed = !1;
      const { done: o, value: n } = await this.resolverIterator.next(), r = await n;
      return r && (this.resolverIteratorResult = r.clone()), o ? (this.isUsed = !0, this.resolverIteratorResult?.clone()) : r;
    };
  }
  createExecutionResult(t) {
    return {
      handler: this,
      request: t.request,
      requestId: t.requestId,
      response: t.response,
      parsedResult: t.parsedResult
    };
  }
}
function PSe(e, t) {
  return e.toLowerCase() === t.toLowerCase();
}
function DSe(e) {
  return e < 300 ? "#69AB32" : e < 400 ? "#F0BB4B" : "#E95F5D";
}
function NSe(e) {
  const t = /* @__PURE__ */ new Date();
  return `${t.getHours().toString().padStart(2, "0")}:${t.getMinutes().toString().padStart(2, "0")}:${t.getSeconds().toString().padStart(2, "0")}`;
}
async function RSe(e) {
  const t = await e.clone().text();
  return {
    url: new URL(e.url),
    method: e.method,
    headers: Object.fromEntries(e.headers.entries()),
    body: t
  };
}
var ISe = Object.create, Ey = Object.defineProperty, TSe = Object.getOwnPropertyDescriptor, jy = Object.getOwnPropertyNames, LSe = Object.getPrototypeOf, MSe = Object.prototype.hasOwnProperty, Oy = (e, t) => function() {
  return t || (0, e[jy(e)[0]])((t = { exports: {} }).exports, t), t.exports;
}, WSe = (e, t, a, o) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let n of jy(t))
      !MSe.call(e, n) && n !== a && Ey(e, n, { get: () => t[n], enumerable: !(o = TSe(t, n)) || o.enumerable });
  return e;
}, BSe = (e, t, a) => (a = e != null ? ISe(LSe(e)) : {}, WSe(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  Ey(a, "default", { value: e, enumerable: !0 }),
  e
)), FSe = Oy({
  "node_modules/statuses/codes.json"(e, t) {
    t.exports = {
      100: "Continue",
      101: "Switching Protocols",
      102: "Processing",
      103: "Early Hints",
      200: "OK",
      201: "Created",
      202: "Accepted",
      203: "Non-Authoritative Information",
      204: "No Content",
      205: "Reset Content",
      206: "Partial Content",
      207: "Multi-Status",
      208: "Already Reported",
      226: "IM Used",
      300: "Multiple Choices",
      301: "Moved Permanently",
      302: "Found",
      303: "See Other",
      304: "Not Modified",
      305: "Use Proxy",
      307: "Temporary Redirect",
      308: "Permanent Redirect",
      400: "Bad Request",
      401: "Unauthorized",
      402: "Payment Required",
      403: "Forbidden",
      404: "Not Found",
      405: "Method Not Allowed",
      406: "Not Acceptable",
      407: "Proxy Authentication Required",
      408: "Request Timeout",
      409: "Conflict",
      410: "Gone",
      411: "Length Required",
      412: "Precondition Failed",
      413: "Payload Too Large",
      414: "URI Too Long",
      415: "Unsupported Media Type",
      416: "Range Not Satisfiable",
      417: "Expectation Failed",
      418: "I'm a Teapot",
      421: "Misdirected Request",
      422: "Unprocessable Entity",
      423: "Locked",
      424: "Failed Dependency",
      425: "Too Early",
      426: "Upgrade Required",
      428: "Precondition Required",
      429: "Too Many Requests",
      431: "Request Header Fields Too Large",
      451: "Unavailable For Legal Reasons",
      500: "Internal Server Error",
      501: "Not Implemented",
      502: "Bad Gateway",
      503: "Service Unavailable",
      504: "Gateway Timeout",
      505: "HTTP Version Not Supported",
      506: "Variant Also Negotiates",
      507: "Insufficient Storage",
      508: "Loop Detected",
      509: "Bandwidth Limit Exceeded",
      510: "Not Extended",
      511: "Network Authentication Required"
    };
  }
}), VSe = Oy({
  "node_modules/statuses/index.js"(e, t) {
    var a = FSe();
    t.exports = s, s.message = a, s.code = o(a), s.codes = n(a), s.redirect = {
      300: !0,
      301: !0,
      302: !0,
      303: !0,
      305: !0,
      307: !0,
      308: !0
    }, s.empty = {
      204: !0,
      205: !0,
      304: !0
    }, s.retry = {
      502: !0,
      503: !0,
      504: !0
    };
    function o(l) {
      var c = {};
      return Object.keys(l).forEach(function(u) {
        var d = l[u], h = Number(u);
        c[d.toLowerCase()] = h;
      }), c;
    }
    function n(l) {
      return Object.keys(l).map(function(c) {
        return Number(c);
      });
    }
    function r(l) {
      var c = l.toLowerCase();
      if (!Object.prototype.hasOwnProperty.call(s.code, c))
        throw new Error('invalid status message: "' + l + '"');
      return s.code[c];
    }
    function i(l) {
      if (!Object.prototype.hasOwnProperty.call(s.message, l))
        throw new Error("invalid status code: " + l);
      return s.message[l];
    }
    function s(l) {
      if (typeof l == "number")
        return i(l);
      if (typeof l != "string")
        throw new TypeError("code must be a number or string");
      var c = parseInt(l, 10);
      return isNaN(c) ? r(l) : i(c);
    }
  }
}), USe = BSe(VSe()), zy = USe.default;
/*! Bundled license information:

statuses/index.js:
  (*!
   * statuses
   * Copyright(c) 2014 Jonathan Ong
   * Copyright(c) 2016 Douglas Christopher Wilson
   * MIT Licensed
   *)
*/
const { message: qSe } = zy;
async function HSe(e) {
  const t = e.clone(), a = await t.text(), o = t.status || 200, n = t.statusText || qSe[o] || "OK";
  return {
    status: o,
    statusText: n,
    headers: Object.fromEntries(t.headers.entries()),
    body: a
  };
}
function GSe(e) {
  for (var t = [], a = 0; a < e.length; ) {
    var o = e[a];
    if (o === "*" || o === "+" || o === "?") {
      t.push({ type: "MODIFIER", index: a, value: e[a++] });
      continue;
    }
    if (o === "\\") {
      t.push({ type: "ESCAPED_CHAR", index: a++, value: e[a++] });
      continue;
    }
    if (o === "{") {
      t.push({ type: "OPEN", index: a, value: e[a++] });
      continue;
    }
    if (o === "}") {
      t.push({ type: "CLOSE", index: a, value: e[a++] });
      continue;
    }
    if (o === ":") {
      for (var n = "", r = a + 1; r < e.length; ) {
        var i = e.charCodeAt(r);
        if (
          // `0-9`
          i >= 48 && i <= 57 || // `A-Z`
          i >= 65 && i <= 90 || // `a-z`
          i >= 97 && i <= 122 || // `_`
          i === 95
        ) {
          n += e[r++];
          continue;
        }
        break;
      }
      if (!n)
        throw new TypeError("Missing parameter name at ".concat(a));
      t.push({ type: "NAME", index: a, value: n }), a = r;
      continue;
    }
    if (o === "(") {
      var s = 1, l = "", r = a + 1;
      if (e[r] === "?")
        throw new TypeError('Pattern cannot start with "?" at '.concat(r));
      for (; r < e.length; ) {
        if (e[r] === "\\") {
          l += e[r++] + e[r++];
          continue;
        }
        if (e[r] === ")") {
          if (s--, s === 0) {
            r++;
            break;
          }
        } else if (e[r] === "(" && (s++, e[r + 1] !== "?"))
          throw new TypeError("Capturing groups are not allowed at ".concat(r));
        l += e[r++];
      }
      if (s)
        throw new TypeError("Unbalanced pattern at ".concat(a));
      if (!l)
        throw new TypeError("Missing pattern at ".concat(a));
      t.push({ type: "PATTERN", index: a, value: l }), a = r;
      continue;
    }
    t.push({ type: "CHAR", index: a, value: e[a++] });
  }
  return t.push({ type: "END", index: a, value: "" }), t;
}
function KSe(e, t) {
  t === void 0 && (t = {});
  for (var a = GSe(e), o = t.prefixes, n = o === void 0 ? "./" : o, r = t.delimiter, i = r === void 0 ? "/#?" : r, s = [], l = 0, c = 0, u = "", d = function(C) {
    if (c < a.length && a[c].type === C)
      return a[c++].value;
  }, h = function(C) {
    var j = d(C);
    if (j !== void 0)
      return j;
    var R = a[c], H = R.type, L = R.index;
    throw new TypeError("Unexpected ".concat(H, " at ").concat(L, ", expected ").concat(C));
  }, m = function() {
    for (var C = "", j; j = d("CHAR") || d("ESCAPED_CHAR"); )
      C += j;
    return C;
  }, f = function(C) {
    for (var j = 0, R = i; j < R.length; j++) {
      var H = R[j];
      if (C.indexOf(H) > -1)
        return !0;
    }
    return !1;
  }, p = function(C) {
    var j = s[s.length - 1], R = C || (j && typeof j == "string" ? j : "");
    if (j && !R)
      throw new TypeError('Must have text between two parameters, missing text after "'.concat(j.name, '"'));
    return !R || f(R) ? "[^".concat(Aa(i), "]+?") : "(?:(?!".concat(Aa(R), ")[^").concat(Aa(i), "])+?");
  }; c < a.length; ) {
    var b = d("CHAR"), w = d("NAME"), _ = d("PATTERN");
    if (w || _) {
      var y = b || "";
      n.indexOf(y) === -1 && (u += y, y = ""), u && (s.push(u), u = ""), s.push({
        name: w || l++,
        prefix: y,
        suffix: "",
        pattern: _ || p(y),
        modifier: d("MODIFIER") || ""
      });
      continue;
    }
    var k = b || d("ESCAPED_CHAR");
    if (k) {
      u += k;
      continue;
    }
    u && (s.push(u), u = "");
    var x = d("OPEN");
    if (x) {
      var y = m(), S = d("NAME") || "", $ = d("PATTERN") || "", E = m();
      h("CLOSE"), s.push({
        name: S || ($ ? l++ : ""),
        pattern: S && !$ ? p(y) : $,
        prefix: y,
        suffix: E,
        modifier: d("MODIFIER") || ""
      });
      continue;
    }
    h("END");
  }
  return s;
}
function JSe(e, t) {
  var a = [], o = Py(e, a, t);
  return ZSe(o, a, t);
}
function ZSe(e, t, a) {
  a === void 0 && (a = {});
  var o = a.decode, n = o === void 0 ? function(r) {
    return r;
  } : o;
  return function(r) {
    var i = e.exec(r);
    if (!i)
      return !1;
    for (var s = i[0], l = i.index, c = /* @__PURE__ */ Object.create(null), u = function(h) {
      if (i[h] === void 0)
        return "continue";
      var m = t[h - 1];
      m.modifier === "*" || m.modifier === "+" ? c[m.name] = i[h].split(m.prefix + m.suffix).map(function(f) {
        return n(f, m);
      }) : c[m.name] = n(i[h], m);
    }, d = 1; d < i.length; d++)
      u(d);
    return { path: s, index: l, params: c };
  };
}
function Aa(e) {
  return e.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
function Ay(e) {
  return e && e.sensitive ? "" : "i";
}
function YSe(e, t) {
  if (!t)
    return e;
  for (var a = /\((?:\?<(.*?)>)?(?!\?)/g, o = 0, n = a.exec(e.source); n; )
    t.push({
      // Use parenthesized substring match if available, index otherwise
      name: n[1] || o++,
      prefix: "",
      suffix: "",
      modifier: "",
      pattern: ""
    }), n = a.exec(e.source);
  return e;
}
function XSe(e, t, a) {
  var o = e.map(function(n) {
    return Py(n, t, a).source;
  });
  return new RegExp("(?:".concat(o.join("|"), ")"), Ay(a));
}
function QSe(e, t, a) {
  return e0e(KSe(e, a), t, a);
}
function e0e(e, t, a) {
  a === void 0 && (a = {});
  for (var o = a.strict, n = o === void 0 ? !1 : o, r = a.start, i = r === void 0 ? !0 : r, s = a.end, l = s === void 0 ? !0 : s, c = a.encode, u = c === void 0 ? function(j) {
    return j;
  } : c, d = a.delimiter, h = d === void 0 ? "/#?" : d, m = a.endsWith, f = m === void 0 ? "" : m, p = "[".concat(Aa(f), "]|$"), b = "[".concat(Aa(h), "]"), w = i ? "^" : "", _ = 0, y = e; _ < y.length; _++) {
    var k = y[_];
    if (typeof k == "string")
      w += Aa(u(k));
    else {
      var x = Aa(u(k.prefix)), S = Aa(u(k.suffix));
      if (k.pattern)
        if (t && t.push(k), x || S)
          if (k.modifier === "+" || k.modifier === "*") {
            var $ = k.modifier === "*" ? "?" : "";
            w += "(?:".concat(x, "((?:").concat(k.pattern, ")(?:").concat(S).concat(x, "(?:").concat(k.pattern, "))*)").concat(S, ")").concat($);
          } else
            w += "(?:".concat(x, "(").concat(k.pattern, ")").concat(S, ")").concat(k.modifier);
        else {
          if (k.modifier === "+" || k.modifier === "*")
            throw new TypeError('Can not repeat "'.concat(k.name, '" without a prefix and suffix'));
          w += "(".concat(k.pattern, ")").concat(k.modifier);
        }
      else
        w += "(?:".concat(x).concat(S, ")").concat(k.modifier);
    }
  }
  if (l)
    n || (w += "".concat(b, "?")), w += a.endsWith ? "(?=".concat(p, ")") : "$";
  else {
    var E = e[e.length - 1], C = typeof E == "string" ? b.indexOf(E[E.length - 1]) > -1 : E === void 0;
    n || (w += "(?:".concat(b, "(?=").concat(p, "))?")), C || (w += "(?=".concat(b, "|").concat(p, ")"));
  }
  return new RegExp(w, Ay(a));
}
function Py(e, t, a) {
  return e instanceof RegExp ? YSe(e, t) : Array.isArray(e) ? XSe(e, t, a) : QSe(e, t, a);
}
new TextEncoder();
function t0e(e) {
  try {
    return new URL(e), !0;
  } catch {
    return !1;
  }
}
function sp(e, t) {
  const a = Object.getOwnPropertySymbols(t).find((o) => o.description === e);
  if (a)
    return Reflect.get(t, a);
}
var Io = class extends Response {
  static isConfigurableStatusCode(e) {
    return e >= 200 && e <= 599;
  }
  static isRedirectResponse(e) {
    return Io.STATUS_CODES_WITH_REDIRECT.includes(e);
  }
  /**
   * Returns a boolean indicating whether the given response status
   * code represents a response that can have a body.
   */
  static isResponseWithBody(e) {
    return !Io.STATUS_CODES_WITHOUT_BODY.includes(e);
  }
  static setUrl(e, t) {
    if (!e || e === "about:" || !t0e(e))
      return;
    const a = sp("state", t);
    a ? a.urlList.push(new URL(e)) : Object.defineProperty(t, "url", {
      value: e,
      enumerable: !0,
      configurable: !0,
      writable: !1
    });
  }
  /**
   * Parses the given raw HTTP headers into a Fetch API `Headers` instance.
   */
  static parseRawHeaders(e) {
    const t = new Headers();
    for (let a = 0; a < e.length; a += 2)
      t.append(e[a], e[a + 1]);
    return t;
  }
  constructor(e, t = {}) {
    var a;
    const o = (a = t.status) != null ? a : 200, n = Io.isConfigurableStatusCode(o) ? o : 200, r = Io.isResponseWithBody(o) ? e : null;
    if (super(r, {
      status: n,
      statusText: t.statusText,
      headers: t.headers
    }), o !== n) {
      const i = sp("state", this);
      i ? i.status = o : Object.defineProperty(this, "status", {
        value: o,
        enumerable: !0,
        configurable: !0,
        writable: !1
      });
    }
    Io.setUrl(t.url, this);
  }
}, Dy = Io;
Dy.STATUS_CODES_WITHOUT_BODY = [101, 103, 204, 205, 304];
Dy.STATUS_CODES_WITH_REDIRECT = [301, 302, 303, 307, 308];
function Ny() {
  if (typeof navigator < "u" && navigator.product === "ReactNative")
    return !0;
  if (typeof process < "u") {
    const e = process.type;
    return e === "renderer" || e === "worker" ? !1 : !!(process.versions && process.versions.node);
  }
  return !1;
}
var a0e = Object.defineProperty, o0e = (e, t) => {
  for (var a in t)
    a0e(e, a, { get: t[a], enumerable: !0 });
}, n0e = {};
o0e(n0e, {
  blue: () => i0e,
  gray: () => s0e,
  green: () => c0e,
  red: () => l0e,
  yellow: () => r0e
});
function r0e(e) {
  return `\x1B[33m${e}\x1B[0m`;
}
function i0e(e) {
  return `\x1B[34m${e}\x1B[0m`;
}
function s0e(e) {
  return `\x1B[90m${e}\x1B[0m`;
}
function l0e(e) {
  return `\x1B[31m${e}\x1B[0m`;
}
function c0e(e) {
  return `\x1B[32m${e}\x1B[0m`;
}
Ny();
function u0e(e, t = !0) {
  return [t && e.origin, e.pathname].filter(Boolean).join("");
}
const d0e = /[?|#].*$/g;
function g0e(e) {
  return new URL(`/${e}`, "http://localhost").searchParams;
}
function Ry(e) {
  return e.endsWith("?") ? e : e.replace(d0e, "");
}
function h0e(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function p0e(e, t) {
  if (h0e(e) || e.startsWith("*"))
    return e;
  const a = t || typeof location < "u" && location.href;
  return a ? (
    // Encode and decode the path to preserve escaped characters.
    decodeURI(new URL(encodeURI(e), a).href)
  ) : e;
}
function m0e(e, t) {
  if (e instanceof RegExp)
    return e;
  const a = p0e(e, t);
  return Ry(a);
}
function f0e(e) {
  return e.replace(
    /([:a-zA-Z_-]*)(\*{1,2})+/g,
    (t, a, o) => {
      const n = "(.*)";
      return a ? a.startsWith(":") ? `${a}${o}` : `${a}${n}` : n;
    }
  ).replace(/([^/])(:)(?=\d+)/, "$1\\$2").replace(/^([^/]+)(:)(?=\/\/)/, "$1\\$2");
}
function b0e(e, t, a) {
  const o = m0e(t, a), n = typeof o == "string" ? f0e(o) : o, r = u0e(e), i = JSe(n, { decode: decodeURIComponent })(r), s = i && i.params || {};
  return {
    matches: i !== !1,
    params: s
  };
}
function _0e(e) {
  if (typeof location > "u")
    return e.toString();
  const t = e instanceof URL ? e : new URL(e);
  return t.origin === location.origin ? t.pathname : t.origin + t.pathname;
}
var v0e = Object.create, Iy = Object.defineProperty, y0e = Object.getOwnPropertyDescriptor, Ty = Object.getOwnPropertyNames, w0e = Object.getPrototypeOf, k0e = Object.prototype.hasOwnProperty, x0e = (e, t) => function() {
  return t || (0, e[Ty(e)[0]])((t = { exports: {} }).exports, t), t.exports;
}, $0e = (e, t, a, o) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let n of Ty(t))
      !k0e.call(e, n) && n !== a && Iy(e, n, { get: () => t[n], enumerable: !(o = y0e(t, n)) || o.enumerable });
  return e;
}, S0e = (e, t, a) => (a = e != null ? v0e(w0e(e)) : {}, $0e(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  Iy(a, "default", { value: e, enumerable: !0 }),
  e
)), C0e = x0e({
  "node_modules/cookie/index.js"(e) {
    e.parse = s, e.serialize = u;
    var t = Object.prototype.toString, a = Object.prototype.hasOwnProperty, o = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/, n = /^("?)[\u0021\u0023-\u002B\u002D-\u003A\u003C-\u005B\u005D-\u007E]*\1$/, r = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i, i = /^[\u0020-\u003A\u003D-\u007E]*$/;
    function s(f, p) {
      if (typeof f != "string")
        throw new TypeError("argument str must be a string");
      var b = {}, w = f.length;
      if (w < 2) return b;
      var _ = p && p.decode || d, y = 0, k = 0, x = 0;
      do {
        if (k = f.indexOf("=", y), k === -1) break;
        if (x = f.indexOf(";", y), x === -1)
          x = w;
        else if (k > x) {
          y = f.lastIndexOf(";", k - 1) + 1;
          continue;
        }
        var S = l(f, y, k), $ = c(f, k, S), E = f.slice(S, $);
        if (!a.call(b, E)) {
          var C = l(f, k + 1, x), j = c(f, x, C);
          f.charCodeAt(C) === 34 && f.charCodeAt(j - 1) === 34 && (C++, j--);
          var R = f.slice(C, j);
          b[E] = m(R, _);
        }
        y = x + 1;
      } while (y < w);
      return b;
    }
    function l(f, p, b) {
      do {
        var w = f.charCodeAt(p);
        if (w !== 32 && w !== 9) return p;
      } while (++p < b);
      return b;
    }
    function c(f, p, b) {
      for (; p > b; ) {
        var w = f.charCodeAt(--p);
        if (w !== 32 && w !== 9) return p + 1;
      }
      return b;
    }
    function u(f, p, b) {
      var w = b && b.encode || encodeURIComponent;
      if (typeof w != "function")
        throw new TypeError("option encode is invalid");
      if (!o.test(f))
        throw new TypeError("argument name is invalid");
      var _ = w(p);
      if (!n.test(_))
        throw new TypeError("argument val is invalid");
      var y = f + "=" + _;
      if (!b) return y;
      if (b.maxAge != null) {
        var k = Math.floor(b.maxAge);
        if (!isFinite(k))
          throw new TypeError("option maxAge is invalid");
        y += "; Max-Age=" + k;
      }
      if (b.domain) {
        if (!r.test(b.domain))
          throw new TypeError("option domain is invalid");
        y += "; Domain=" + b.domain;
      }
      if (b.path) {
        if (!i.test(b.path))
          throw new TypeError("option path is invalid");
        y += "; Path=" + b.path;
      }
      if (b.expires) {
        var x = b.expires;
        if (!h(x) || isNaN(x.valueOf()))
          throw new TypeError("option expires is invalid");
        y += "; Expires=" + x.toUTCString();
      }
      if (b.httpOnly && (y += "; HttpOnly"), b.secure && (y += "; Secure"), b.partitioned && (y += "; Partitioned"), b.priority) {
        var S = typeof b.priority == "string" ? b.priority.toLowerCase() : b.priority;
        switch (S) {
          case "low":
            y += "; Priority=Low";
            break;
          case "medium":
            y += "; Priority=Medium";
            break;
          case "high":
            y += "; Priority=High";
            break;
          default:
            throw new TypeError("option priority is invalid");
        }
      }
      if (b.sameSite) {
        var $ = typeof b.sameSite == "string" ? b.sameSite.toLowerCase() : b.sameSite;
        switch ($) {
          case !0:
            y += "; SameSite=Strict";
            break;
          case "lax":
            y += "; SameSite=Lax";
            break;
          case "strict":
            y += "; SameSite=Strict";
            break;
          case "none":
            y += "; SameSite=None";
            break;
          default:
            throw new TypeError("option sameSite is invalid");
        }
      }
      return y;
    }
    function d(f) {
      return f.indexOf("%") !== -1 ? decodeURIComponent(f) : f;
    }
    function h(f) {
      return t.call(f) === "[object Date]";
    }
    function m(f, p) {
      try {
        return p(f);
      } catch {
        return f;
      }
    }
  }
}), E0e = S0e(C0e()), Ly = E0e.default;
/*! Bundled license information:

cookie/index.js:
  (*!
   * cookie
   * Copyright(c) 2012-2014 Roman Shtylman
   * Copyright(c) 2015 Douglas Christopher Wilson
   * MIT Licensed
   *)
*/
function j0e(e, t) {
  return e.endsWith(t) ? e.length === t.length || e[e.length - t.length - 1] === "." : !1;
}
function O0e(e, t) {
  const a = e.length - t.length - 2, o = e.lastIndexOf(".", a);
  return o === -1 ? e : e.slice(o + 1);
}
function z0e(e, t, a) {
  if (a.validHosts !== null) {
    const n = a.validHosts;
    for (const r of n)
      if (
        /*@__INLINE__*/
        j0e(t, r)
      )
        return r;
  }
  let o = 0;
  if (t.startsWith("."))
    for (; o < t.length && t[o] === "."; )
      o += 1;
  return e.length === t.length - o ? null : (
    /*@__INLINE__*/
    O0e(t, e)
  );
}
function lp(e, t) {
  let a = 0, o = e.length, n = !1;
  if (!t) {
    if (e.startsWith("data:"))
      return null;
    for (; a < e.length && e.charCodeAt(a) <= 32; )
      a += 1;
    for (; o > a + 1 && e.charCodeAt(o - 1) <= 32; )
      o -= 1;
    if (e.charCodeAt(a) === 47 && e.charCodeAt(a + 1) === 47)
      a += 2;
    else {
      const c = e.indexOf(":/", a);
      if (c !== -1) {
        const u = c - a, d = e.charCodeAt(a), h = e.charCodeAt(a + 1), m = e.charCodeAt(a + 2), f = e.charCodeAt(a + 3), p = e.charCodeAt(a + 4);
        if (!(u === 5 && d === 104 && h === 116 && m === 116 && f === 112 && p === 115) && !(u === 4 && d === 104 && h === 116 && m === 116 && f === 112) && !(u === 3 && d === 119 && h === 115 && m === 115) && !(u === 2 && d === 119 && h === 115))
          for (let b = a; b < c; b += 1) {
            const w = e.charCodeAt(b) | 32;
            if (!(w >= 97 && w <= 122 || // [a, z]
            w >= 48 && w <= 57 || // [0, 9]
            w === 46 || // '.'
            w === 45 || // '-'
            w === 43))
              return null;
          }
        for (a = c + 2; e.charCodeAt(a) === 47; )
          a += 1;
      }
    }
    let i = -1, s = -1, l = -1;
    for (let c = a; c < o; c += 1) {
      const u = e.charCodeAt(c);
      if (u === 35 || // '#'
      u === 47 || // '/'
      u === 63) {
        o = c;
        break;
      } else u === 64 ? i = c : u === 93 ? s = c : u === 58 ? l = c : u >= 65 && u <= 90 && (n = !0);
    }
    if (i !== -1 && i > a && i < o && (a = i + 1), e.charCodeAt(a) === 91)
      return s !== -1 ? e.slice(a + 1, s).toLowerCase() : null;
    l !== -1 && l > a && l < o && (o = l);
  }
  for (; o > a + 1 && e.charCodeAt(o - 1) === 46; )
    o -= 1;
  const r = a !== 0 || o !== e.length ? e.slice(a, o) : e;
  return n ? r.toLowerCase() : r;
}
function A0e(e) {
  if (e.length < 7 || e.length > 15)
    return !1;
  let t = 0;
  for (let a = 0; a < e.length; a += 1) {
    const o = e.charCodeAt(a);
    if (o === 46)
      t += 1;
    else if (o < 48 || o > 57)
      return !1;
  }
  return t === 3 && e.charCodeAt(0) !== 46 && e.charCodeAt(e.length - 1) !== 46;
}
function P0e(e) {
  if (e.length < 3)
    return !1;
  let t = e.startsWith("[") ? 1 : 0, a = e.length;
  if (e[a - 1] === "]" && (a -= 1), a - t > 39)
    return !1;
  let o = !1;
  for (; t < a; t += 1) {
    const n = e.charCodeAt(t);
    if (n === 58)
      o = !0;
    else if (!(n >= 48 && n <= 57 || // 0-9
    n >= 97 && n <= 102 || // a-f
    n >= 65 && n <= 90))
      return !1;
  }
  return o;
}
function D0e(e) {
  return P0e(e) || A0e(e);
}
function cp(e) {
  return e >= 97 && e <= 122 || e >= 48 && e <= 57 || e > 127;
}
function up(e) {
  if (e.length > 255 || e.length === 0 || /*@__INLINE__*/
  !cp(e.charCodeAt(0)) && e.charCodeAt(0) !== 46 && // '.' (dot)
  e.charCodeAt(0) !== 95)
    return !1;
  let t = -1, a = -1;
  const o = e.length;
  for (let n = 0; n < o; n += 1) {
    const r = e.charCodeAt(n);
    if (r === 46) {
      if (
        // Check that previous label is < 63 bytes long (64 = 63 + '.')
        n - t > 64 || // Check that previous character was not already a '.'
        a === 46 || // Check that the previous label does not end with a '-' (dash)
        a === 45 || // Check that the previous label does not end with a '_' (underscore)
        a === 95
      )
        return !1;
      t = n;
    } else if (!/*@__INLINE__*/
    (cp(r) || r === 45 || r === 95))
      return !1;
    a = r;
  }
  return (
    // Check that last label is shorter than 63 chars
    o - t - 1 <= 63 && // Check that the last character is an allowed trailing label character.
    // Since we already checked that the char is a valid hostname character,
    // we only need to check that it's different from '-'.
    a !== 45
  );
}
function My({ allowIcannDomains: e = !0, allowPrivateDomains: t = !1, detectIp: a = !0, extractHostname: o = !0, mixedInputs: n = !0, validHosts: r = null, validateHostname: i = !0 }) {
  return {
    allowIcannDomains: e,
    allowPrivateDomains: t,
    detectIp: a,
    extractHostname: o,
    mixedInputs: n,
    validHosts: r,
    validateHostname: i
  };
}
const N0e = (
  /*@__INLINE__*/
  My({})
);
function R0e(e) {
  return e === void 0 ? N0e : (
    /*@__INLINE__*/
    My(e)
  );
}
function I0e() {
  return {
    domain: null,
    domainWithoutSuffix: null,
    hostname: null,
    isIcann: null,
    isIp: null,
    isPrivate: null,
    publicSuffix: null,
    subdomain: null
  };
}
function T0e(e) {
  e.domain = null, e.domainWithoutSuffix = null, e.hostname = null, e.isIcann = null, e.isIp = null, e.isPrivate = null, e.publicSuffix = null, e.subdomain = null;
}
function L0e(e, t, a, o, n) {
  const r = (
    /*@__INLINE__*/
    R0e(o)
  );
  return typeof e != "string" || (r.extractHostname ? r.mixedInputs ? n.hostname = lp(e, up(e)) : n.hostname = lp(e, !1) : n.hostname = e, r.detectIp && n.hostname !== null && (n.isIp = D0e(n.hostname), n.isIp)) ? n : r.validateHostname && r.extractHostname && n.hostname !== null && !up(n.hostname) ? (n.hostname = null, n) : (n.hostname === null || (a(n.hostname, r, n), n.publicSuffix === null) || (n.domain = z0e(n.publicSuffix, n.hostname, r)), n);
}
function M0e(e, t, a) {
  if (!t.allowPrivateDomains && e.length > 3) {
    const o = e.length - 1, n = e.charCodeAt(o), r = e.charCodeAt(o - 1), i = e.charCodeAt(o - 2), s = e.charCodeAt(o - 3);
    if (n === 109 && r === 111 && i === 99 && s === 46)
      return a.isIcann = !0, a.isPrivate = !1, a.publicSuffix = "com", !0;
    if (n === 103 && r === 114 && i === 111 && s === 46)
      return a.isIcann = !0, a.isPrivate = !1, a.publicSuffix = "org", !0;
    if (n === 117 && r === 100 && i === 101 && s === 46)
      return a.isIcann = !0, a.isPrivate = !1, a.publicSuffix = "edu", !0;
    if (n === 118 && r === 111 && i === 103 && s === 46)
      return a.isIcann = !0, a.isPrivate = !1, a.publicSuffix = "gov", !0;
    if (n === 116 && r === 101 && i === 110 && s === 46)
      return a.isIcann = !0, a.isPrivate = !1, a.publicSuffix = "net", !0;
    if (n === 101 && r === 100 && i === 46)
      return a.isIcann = !0, a.isPrivate = !1, a.publicSuffix = "de", !0;
  }
  return !1;
}
const W0e = /* @__PURE__ */ function() {
  const e = [1, {}], t = [0, { city: e }];
  return [0, { ck: [0, { www: e }], jp: [0, { kawasaki: t, kitakyushu: t, kobe: t, nagoya: t, sapporo: t, sendai: t, yokohama: t }] }];
}(), B0e = /* @__PURE__ */ function() {
  const e = [1, {}], t = [2, {}], a = [1, { com: e, edu: e, gov: e, net: e, org: e }], o = [1, { com: e, edu: e, gov: e, mil: e, net: e, org: e }], n = [0, { "*": t }], r = [2, { s: n }], i = [0, { relay: t }], s = [2, { id: t }], l = [1, { gov: e }], c = [2, { vps: t }], u = [0, { airflow: n, "transfer-webapp": t }], d = [0, { "transfer-webapp": t, "transfer-webapp-fips": t }], h = [0, { notebook: t, studio: t }], m = [0, { labeling: t, notebook: t, studio: t }], f = [0, { notebook: t }], p = [0, { labeling: t, notebook: t, "notebook-fips": t, studio: t }], b = [0, { notebook: t, "notebook-fips": t, studio: t, "studio-fips": t }], w = [0, { shop: t }], _ = [0, { "*": e }], y = [1, { co: t }], k = [0, { objects: t }], x = [2, { nodes: t }], S = [0, { my: t }], $ = [0, { s3: t, "s3-accesspoint": t, "s3-website": t }], E = [0, { s3: t, "s3-accesspoint": t }], C = [0, { direct: t }], j = [0, { "webview-assets": t }], R = [0, { vfs: t, "webview-assets": t }], H = [0, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: $, s3: t, "s3-accesspoint": t, "s3-object-lambda": t, "s3-website": t, "aws-cloud9": j, cloud9: R }], L = [0, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: E, s3: t, "s3-accesspoint": t, "s3-object-lambda": t, "s3-website": t, "aws-cloud9": j, cloud9: R }], O = [0, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: $, s3: t, "s3-accesspoint": t, "s3-object-lambda": t, "s3-website": t, "analytics-gateway": t, "aws-cloud9": j, cloud9: R }], U = [0, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: $, s3: t, "s3-accesspoint": t, "s3-object-lambda": t, "s3-website": t }], I = [0, { s3: t, "s3-accesspoint": t, "s3-accesspoint-fips": t, "s3-fips": t, "s3-website": t }], K = [0, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: I, s3: t, "s3-accesspoint": t, "s3-accesspoint-fips": t, "s3-fips": t, "s3-object-lambda": t, "s3-website": t, "aws-cloud9": j, cloud9: R }], q = [0, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: I, s3: t, "s3-accesspoint": t, "s3-accesspoint-fips": t, "s3-deprecated": t, "s3-fips": t, "s3-object-lambda": t, "s3-website": t, "analytics-gateway": t, "aws-cloud9": j, cloud9: R }], te = [0, { s3: t, "s3-accesspoint": t, "s3-accesspoint-fips": t, "s3-fips": t }], A = [0, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: te, s3: t, "s3-accesspoint": t, "s3-accesspoint-fips": t, "s3-fips": t, "s3-object-lambda": t, "s3-website": t }], z = [0, { auth: t }], N = [0, { auth: t, "auth-fips": t }], B = [0, { "auth-fips": t }], W = [0, { apps: t }], Z = [0, { paas: t }], ee = [2, { eu: t }], M = [0, { app: t }], Y = [0, { site: t }], Q = [1, { com: e, edu: e, net: e, org: e }], J = [0, { j: t }], ae = [0, { dyn: t }], V = [2, { web: t }], fe = [1, { co: e, com: e, edu: e, gov: e, net: e, org: e }], X = [0, { p: t }], Ye = [0, { user: t }], Ve = [0, { cdn: t }], Ft = [2, { raw: n }], ft = [0, { cust: t, reservd: t }], Ba = [0, { cust: t }], Fa = [0, { s3: t }], $t = [1, { biz: e, com: e, edu: e, gov: e, info: e, net: e, org: e }], ia = [0, { ipfs: t }], ka = [1, { framer: t }], Va = [0, { forgot: t }], we = [1, { gs: e }], bt = [0, { nes: e }], oe = [1, { k12: e, cc: e, lib: e }], Ua = [1, { cc: e }], gr = [1, { cc: e, lib: e }];
  return [0, { ac: [1, { com: e, edu: e, gov: e, mil: e, net: e, org: e, drr: t, feedback: t, forms: t }], ad: e, ae: [1, { ac: e, co: e, gov: e, mil: e, net: e, org: e, sch: e }], aero: [1, { airline: e, airport: e, "accident-investigation": e, "accident-prevention": e, aerobatic: e, aeroclub: e, aerodrome: e, agents: e, "air-surveillance": e, "air-traffic-control": e, aircraft: e, airtraffic: e, ambulance: e, association: e, author: e, ballooning: e, broker: e, caa: e, cargo: e, catering: e, certification: e, championship: e, charter: e, civilaviation: e, club: e, conference: e, consultant: e, consulting: e, control: e, council: e, crew: e, design: e, dgca: e, educator: e, emergency: e, engine: e, engineer: e, entertainment: e, equipment: e, exchange: e, express: e, federation: e, flight: e, freight: e, fuel: e, gliding: e, government: e, groundhandling: e, group: e, hanggliding: e, homebuilt: e, insurance: e, journal: e, journalist: e, leasing: e, logistics: e, magazine: e, maintenance: e, marketplace: e, media: e, microlight: e, modelling: e, navigation: e, parachuting: e, paragliding: e, "passenger-association": e, pilot: e, press: e, production: e, recreation: e, repbody: e, res: e, research: e, rotorcraft: e, safety: e, scientist: e, services: e, show: e, skydiving: e, software: e, student: e, taxi: e, trader: e, trading: e, trainer: e, union: e, workinggroup: e, works: e }], af: a, ag: [1, { co: e, com: e, net: e, nom: e, org: e, obj: t }], ai: [1, { com: e, net: e, off: e, org: e, uwu: t, framer: t }], al: o, am: [1, { co: e, com: e, commune: e, net: e, org: e, radio: t }], ao: [1, { co: e, ed: e, edu: e, gov: e, gv: e, it: e, og: e, org: e, pb: e }], aq: e, ar: [1, { bet: e, com: e, coop: e, edu: e, gob: e, gov: e, int: e, mil: e, musica: e, mutual: e, net: e, org: e, seg: e, senasa: e, tur: e }], arpa: [1, { e164: e, home: e, "in-addr": e, ip6: e, iris: e, uri: e, urn: e }], as: l, asia: [1, { cloudns: t, daemon: t, dix: t }], at: [1, { 4: t, ac: [1, { sth: e }], co: e, gv: e, or: e, funkfeuer: [0, { wien: t }], futurecms: [0, { "*": t, ex: n, in: n }], futurehosting: t, futuremailing: t, ortsinfo: [0, { ex: n, kunden: n }], biz: t, info: t, "123webseite": t, priv: t, my: t, myspreadshop: t, "12hp": t, "2ix": t, "4lima": t, "lima-city": t }], au: [1, { asn: e, com: [1, { cloudlets: [0, { mel: t }], myspreadshop: t }], edu: [1, { act: e, catholic: e, nsw: e, nt: e, qld: e, sa: e, tas: e, vic: e, wa: e }], gov: [1, { qld: e, sa: e, tas: e, vic: e, wa: e }], id: e, net: e, org: e, conf: e, oz: e, act: e, nsw: e, nt: e, qld: e, sa: e, tas: e, vic: e, wa: e, hrsn: c }], aw: [1, { com: e }], ax: e, az: [1, { biz: e, co: e, com: e, edu: e, gov: e, info: e, int: e, mil: e, name: e, net: e, org: e, pp: e, pro: e }], ba: [1, { com: e, edu: e, gov: e, mil: e, net: e, org: e, brendly: w, rs: t }], bb: [1, { biz: e, co: e, com: e, edu: e, gov: e, info: e, net: e, org: e, store: e, tv: e }], bd: _, be: [1, { ac: e, cloudns: t, webhosting: t, interhostsolutions: [0, { cloud: t }], kuleuven: [0, { ezproxy: t }], "123website": t, myspreadshop: t, transurl: n }], bf: l, bg: [1, { 0: e, 1: e, 2: e, 3: e, 4: e, 5: e, 6: e, 7: e, 8: e, 9: e, a: e, b: e, c: e, d: e, e, f: e, g: e, h: e, i: e, j: e, k: e, l: e, m: e, n: e, o: e, p: e, q: e, r: e, s: e, t: e, u: e, v: e, w: e, x: e, y: e, z: e, barsy: t }], bh: a, bi: [1, { co: e, com: e, edu: e, or: e, org: e }], biz: [1, { activetrail: t, "cloud-ip": t, cloudns: t, jozi: t, dyndns: t, "for-better": t, "for-more": t, "for-some": t, "for-the": t, selfip: t, webhop: t, orx: t, mmafan: t, myftp: t, "no-ip": t, dscloud: t }], bj: [1, { africa: e, agro: e, architectes: e, assur: e, avocats: e, co: e, com: e, eco: e, econo: e, edu: e, info: e, loisirs: e, money: e, net: e, org: e, ote: e, restaurant: e, resto: e, tourism: e, univ: e }], bm: a, bn: [1, { com: e, edu: e, gov: e, net: e, org: e, co: t }], bo: [1, { com: e, edu: e, gob: e, int: e, mil: e, net: e, org: e, tv: e, web: e, academia: e, agro: e, arte: e, blog: e, bolivia: e, ciencia: e, cooperativa: e, democracia: e, deporte: e, ecologia: e, economia: e, empresa: e, indigena: e, industria: e, info: e, medicina: e, movimiento: e, musica: e, natural: e, nombre: e, noticias: e, patria: e, plurinacional: e, politica: e, profesional: e, pueblo: e, revista: e, salud: e, tecnologia: e, tksat: e, transporte: e, wiki: e }], br: [1, { "9guacu": e, abc: e, adm: e, adv: e, agr: e, aju: e, am: e, anani: e, aparecida: e, api: e, app: e, arq: e, art: e, ato: e, b: e, barueri: e, belem: e, bet: e, bhz: e, bib: e, bio: e, blog: e, bmd: e, boavista: e, bsb: e, campinagrande: e, campinas: e, caxias: e, cim: e, cng: e, cnt: e, com: [1, { simplesite: t }], contagem: e, coop: e, coz: e, cri: e, cuiaba: e, curitiba: e, def: e, des: e, det: e, dev: e, ecn: e, eco: e, edu: e, emp: e, enf: e, eng: e, esp: e, etc: e, eti: e, far: e, feira: e, flog: e, floripa: e, fm: e, fnd: e, fortal: e, fot: e, foz: e, fst: e, g12: e, geo: e, ggf: e, goiania: e, gov: [1, { ac: e, al: e, am: e, ap: e, ba: e, ce: e, df: e, es: e, go: e, ma: e, mg: e, ms: e, mt: e, pa: e, pb: e, pe: e, pi: e, pr: e, rj: e, rn: e, ro: e, rr: e, rs: e, sc: e, se: e, sp: e, to: e }], gru: e, ia: e, imb: e, ind: e, inf: e, jab: e, jampa: e, jdf: e, joinville: e, jor: e, jus: e, leg: [1, { ac: t, al: t, am: t, ap: t, ba: t, ce: t, df: t, es: t, go: t, ma: t, mg: t, ms: t, mt: t, pa: t, pb: t, pe: t, pi: t, pr: t, rj: t, rn: t, ro: t, rr: t, rs: t, sc: t, se: t, sp: t, to: t }], leilao: e, lel: e, log: e, londrina: e, macapa: e, maceio: e, manaus: e, maringa: e, mat: e, med: e, mil: e, morena: e, mp: e, mus: e, natal: e, net: e, niteroi: e, nom: _, not: e, ntr: e, odo: e, ong: e, org: e, osasco: e, palmas: e, poa: e, ppg: e, pro: e, psc: e, psi: e, pvh: e, qsl: e, radio: e, rec: e, recife: e, rep: e, ribeirao: e, rio: e, riobranco: e, riopreto: e, salvador: e, sampa: e, santamaria: e, santoandre: e, saobernardo: e, saogonca: e, seg: e, sjc: e, slg: e, slz: e, social: e, sorocaba: e, srv: e, taxi: e, tc: e, tec: e, teo: e, the: e, tmp: e, trd: e, tur: e, tv: e, udi: e, vet: e, vix: e, vlog: e, wiki: e, xyz: e, zlg: e, tche: t }], bs: [1, { com: e, edu: e, gov: e, net: e, org: e, we: t }], bt: a, bv: e, bw: [1, { ac: e, co: e, gov: e, net: e, org: e }], by: [1, { gov: e, mil: e, com: e, of: e, mediatech: t }], bz: [1, { co: e, com: e, edu: e, gov: e, net: e, org: e, za: t, mydns: t, gsj: t }], ca: [1, { ab: e, bc: e, mb: e, nb: e, nf: e, nl: e, ns: e, nt: e, nu: e, on: e, pe: e, qc: e, sk: e, yk: e, gc: e, barsy: t, awdev: n, co: t, "no-ip": t, onid: t, myspreadshop: t, box: t }], cat: e, cc: [1, { cleverapps: t, cloudns: t, ftpaccess: t, "game-server": t, myphotos: t, scrapping: t, twmail: t, csx: t, fantasyleague: t, spawn: [0, { instances: t }] }], cd: l, cf: e, cg: e, ch: [1, { square7: t, cloudns: t, cloudscale: [0, { cust: t, lpg: k, rma: k }], objectstorage: [0, { lpg: t, rma: t }], flow: [0, { ae: [0, { alp1: t }], appengine: t }], "linkyard-cloud": t, gotdns: t, dnsking: t, "123website": t, myspreadshop: t, firenet: [0, { "*": t, svc: n }], "12hp": t, "2ix": t, "4lima": t, "lima-city": t }], ci: [1, { ac: e, "xn--aroport-bya": e, aéroport: e, asso: e, co: e, com: e, ed: e, edu: e, go: e, gouv: e, int: e, net: e, or: e, org: e }], ck: _, cl: [1, { co: e, gob: e, gov: e, mil: e, cloudns: t }], cm: [1, { co: e, com: e, gov: e, net: e }], cn: [1, { ac: e, com: [1, { amazonaws: [0, { "cn-north-1": [0, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: $, s3: t, "s3-accesspoint": t, "s3-deprecated": t, "s3-object-lambda": t, "s3-website": t }], "cn-northwest-1": [0, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: E, s3: t, "s3-accesspoint": t, "s3-object-lambda": t, "s3-website": t }], compute: n, airflow: [0, { "cn-north-1": n, "cn-northwest-1": n }], eb: [0, { "cn-north-1": t, "cn-northwest-1": t }], elb: n }], amazonwebservices: [0, { on: [0, { "cn-north-1": u, "cn-northwest-1": u }] }], sagemaker: [0, { "cn-north-1": h, "cn-northwest-1": h }] }], edu: e, gov: e, mil: e, net: e, org: e, "xn--55qx5d": e, 公司: e, "xn--od0alg": e, 網絡: e, "xn--io0a7i": e, 网络: e, ah: e, bj: e, cq: e, fj: e, gd: e, gs: e, gx: e, gz: e, ha: e, hb: e, he: e, hi: e, hk: e, hl: e, hn: e, jl: e, js: e, jx: e, ln: e, mo: e, nm: e, nx: e, qh: e, sc: e, sd: e, sh: [1, { as: t }], sn: e, sx: e, tj: e, tw: e, xj: e, xz: e, yn: e, zj: e, "canva-apps": t, canvasite: S, myqnapcloud: t, quickconnect: C }], co: [1, { com: e, edu: e, gov: e, mil: e, net: e, nom: e, org: e, carrd: t, crd: t, otap: n, hidns: t, leadpages: t, lpages: t, mypi: t, xmit: n, firewalledreplit: s, repl: s, supabase: [2, { realtime: t, storage: t }] }], com: [1, { a2hosted: t, cpserver: t, adobeaemcloud: [2, { dev: n }], africa: t, airkitapps: t, "airkitapps-au": t, aivencloud: t, alibabacloudcs: t, kasserver: t, amazonaws: [0, { "af-south-1": H, "ap-east-1": L, "ap-northeast-1": O, "ap-northeast-2": O, "ap-northeast-3": H, "ap-south-1": O, "ap-south-2": U, "ap-southeast-1": O, "ap-southeast-2": O, "ap-southeast-3": U, "ap-southeast-4": U, "ap-southeast-5": [0, { "execute-api": t, dualstack: $, s3: t, "s3-accesspoint": t, "s3-deprecated": t, "s3-object-lambda": t, "s3-website": t }], "ca-central-1": K, "ca-west-1": [0, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: I, s3: t, "s3-accesspoint": t, "s3-accesspoint-fips": t, "s3-fips": t, "s3-object-lambda": t, "s3-website": t }], "eu-central-1": O, "eu-central-2": U, "eu-north-1": L, "eu-south-1": H, "eu-south-2": U, "eu-west-1": [0, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: $, s3: t, "s3-accesspoint": t, "s3-deprecated": t, "s3-object-lambda": t, "s3-website": t, "analytics-gateway": t, "aws-cloud9": j, cloud9: R }], "eu-west-2": L, "eu-west-3": H, "il-central-1": [0, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: $, s3: t, "s3-accesspoint": t, "s3-object-lambda": t, "s3-website": t, "aws-cloud9": j, cloud9: [0, { vfs: t }] }], "me-central-1": U, "me-south-1": L, "sa-east-1": H, "us-east-1": [2, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: I, s3: t, "s3-accesspoint": t, "s3-accesspoint-fips": t, "s3-deprecated": t, "s3-fips": t, "s3-object-lambda": t, "s3-website": t, "analytics-gateway": t, "aws-cloud9": j, cloud9: R }], "us-east-2": q, "us-gov-east-1": A, "us-gov-west-1": A, "us-west-1": K, "us-west-2": q, compute: n, "compute-1": n, airflow: [0, { "af-south-1": n, "ap-east-1": n, "ap-northeast-1": n, "ap-northeast-2": n, "ap-northeast-3": n, "ap-south-1": n, "ap-south-2": n, "ap-southeast-1": n, "ap-southeast-2": n, "ap-southeast-3": n, "ap-southeast-4": n, "ap-southeast-5": n, "ca-central-1": n, "ca-west-1": n, "eu-central-1": n, "eu-central-2": n, "eu-north-1": n, "eu-south-1": n, "eu-south-2": n, "eu-west-1": n, "eu-west-2": n, "eu-west-3": n, "il-central-1": n, "me-central-1": n, "me-south-1": n, "sa-east-1": n, "us-east-1": n, "us-east-2": n, "us-west-1": n, "us-west-2": n }], s3: t, "s3-1": t, "s3-ap-east-1": t, "s3-ap-northeast-1": t, "s3-ap-northeast-2": t, "s3-ap-northeast-3": t, "s3-ap-south-1": t, "s3-ap-southeast-1": t, "s3-ap-southeast-2": t, "s3-ca-central-1": t, "s3-eu-central-1": t, "s3-eu-north-1": t, "s3-eu-west-1": t, "s3-eu-west-2": t, "s3-eu-west-3": t, "s3-external-1": t, "s3-fips-us-gov-east-1": t, "s3-fips-us-gov-west-1": t, "s3-global": [0, { accesspoint: [0, { mrap: t }] }], "s3-me-south-1": t, "s3-sa-east-1": t, "s3-us-east-2": t, "s3-us-gov-east-1": t, "s3-us-gov-west-1": t, "s3-us-west-1": t, "s3-us-west-2": t, "s3-website-ap-northeast-1": t, "s3-website-ap-southeast-1": t, "s3-website-ap-southeast-2": t, "s3-website-eu-west-1": t, "s3-website-sa-east-1": t, "s3-website-us-east-1": t, "s3-website-us-gov-west-1": t, "s3-website-us-west-1": t, "s3-website-us-west-2": t, elb: n }], amazoncognito: [0, { "af-south-1": z, "ap-east-1": z, "ap-northeast-1": z, "ap-northeast-2": z, "ap-northeast-3": z, "ap-south-1": z, "ap-south-2": z, "ap-southeast-1": z, "ap-southeast-2": z, "ap-southeast-3": z, "ap-southeast-4": z, "ap-southeast-5": z, "ap-southeast-7": z, "ca-central-1": z, "ca-west-1": z, "eu-central-1": z, "eu-central-2": z, "eu-north-1": z, "eu-south-1": z, "eu-south-2": z, "eu-west-1": z, "eu-west-2": z, "eu-west-3": z, "il-central-1": z, "me-central-1": z, "me-south-1": z, "mx-central-1": z, "sa-east-1": z, "us-east-1": N, "us-east-2": N, "us-gov-east-1": B, "us-gov-west-1": B, "us-west-1": N, "us-west-2": N }], amplifyapp: t, awsapprunner: n, awsapps: t, elasticbeanstalk: [2, { "af-south-1": t, "ap-east-1": t, "ap-northeast-1": t, "ap-northeast-2": t, "ap-northeast-3": t, "ap-south-1": t, "ap-southeast-1": t, "ap-southeast-2": t, "ap-southeast-3": t, "ca-central-1": t, "eu-central-1": t, "eu-north-1": t, "eu-south-1": t, "eu-west-1": t, "eu-west-2": t, "eu-west-3": t, "il-central-1": t, "me-south-1": t, "sa-east-1": t, "us-east-1": t, "us-east-2": t, "us-gov-east-1": t, "us-gov-west-1": t, "us-west-1": t, "us-west-2": t }], awsglobalaccelerator: t, siiites: t, appspacehosted: t, appspaceusercontent: t, "on-aptible": t, myasustor: t, "balena-devices": t, boutir: t, bplaced: t, cafjs: t, "canva-apps": t, "cdn77-storage": t, br: t, cn: t, de: t, eu: t, jpn: t, mex: t, ru: t, sa: t, uk: t, us: t, za: t, "clever-cloud": [0, { services: n }], dnsabr: t, "ip-ddns": t, jdevcloud: t, wpdevcloud: t, "cf-ipfs": t, "cloudflare-ipfs": t, trycloudflare: t, co: t, devinapps: n, builtwithdark: t, datadetect: [0, { demo: t, instance: t }], dattolocal: t, dattorelay: t, dattoweb: t, mydatto: t, digitaloceanspaces: n, discordsays: t, discordsez: t, drayddns: t, dreamhosters: t, durumis: t, blogdns: t, cechire: t, dnsalias: t, dnsdojo: t, doesntexist: t, dontexist: t, doomdns: t, "dyn-o-saur": t, dynalias: t, "dyndns-at-home": t, "dyndns-at-work": t, "dyndns-blog": t, "dyndns-free": t, "dyndns-home": t, "dyndns-ip": t, "dyndns-mail": t, "dyndns-office": t, "dyndns-pics": t, "dyndns-remote": t, "dyndns-server": t, "dyndns-web": t, "dyndns-wiki": t, "dyndns-work": t, "est-a-la-maison": t, "est-a-la-masion": t, "est-le-patron": t, "est-mon-blogueur": t, "from-ak": t, "from-al": t, "from-ar": t, "from-ca": t, "from-ct": t, "from-dc": t, "from-de": t, "from-fl": t, "from-ga": t, "from-hi": t, "from-ia": t, "from-id": t, "from-il": t, "from-in": t, "from-ks": t, "from-ky": t, "from-ma": t, "from-md": t, "from-mi": t, "from-mn": t, "from-mo": t, "from-ms": t, "from-mt": t, "from-nc": t, "from-nd": t, "from-ne": t, "from-nh": t, "from-nj": t, "from-nm": t, "from-nv": t, "from-oh": t, "from-ok": t, "from-or": t, "from-pa": t, "from-pr": t, "from-ri": t, "from-sc": t, "from-sd": t, "from-tn": t, "from-tx": t, "from-ut": t, "from-va": t, "from-vt": t, "from-wa": t, "from-wi": t, "from-wv": t, "from-wy": t, getmyip: t, gotdns: t, "hobby-site": t, homelinux: t, homeunix: t, iamallama: t, "is-a-anarchist": t, "is-a-blogger": t, "is-a-bookkeeper": t, "is-a-bulls-fan": t, "is-a-caterer": t, "is-a-chef": t, "is-a-conservative": t, "is-a-cpa": t, "is-a-cubicle-slave": t, "is-a-democrat": t, "is-a-designer": t, "is-a-doctor": t, "is-a-financialadvisor": t, "is-a-geek": t, "is-a-green": t, "is-a-guru": t, "is-a-hard-worker": t, "is-a-hunter": t, "is-a-landscaper": t, "is-a-lawyer": t, "is-a-liberal": t, "is-a-libertarian": t, "is-a-llama": t, "is-a-musician": t, "is-a-nascarfan": t, "is-a-nurse": t, "is-a-painter": t, "is-a-personaltrainer": t, "is-a-photographer": t, "is-a-player": t, "is-a-republican": t, "is-a-rockstar": t, "is-a-socialist": t, "is-a-student": t, "is-a-teacher": t, "is-a-techie": t, "is-a-therapist": t, "is-an-accountant": t, "is-an-actor": t, "is-an-actress": t, "is-an-anarchist": t, "is-an-artist": t, "is-an-engineer": t, "is-an-entertainer": t, "is-certified": t, "is-gone": t, "is-into-anime": t, "is-into-cars": t, "is-into-cartoons": t, "is-into-games": t, "is-leet": t, "is-not-certified": t, "is-slick": t, "is-uberleet": t, "is-with-theband": t, "isa-geek": t, "isa-hockeynut": t, issmarterthanyou: t, "likes-pie": t, likescandy: t, "neat-url": t, "saves-the-whales": t, selfip: t, "sells-for-less": t, "sells-for-u": t, servebbs: t, "simple-url": t, "space-to-rent": t, "teaches-yoga": t, writesthisblog: t, ddnsfree: t, ddnsgeek: t, giize: t, gleeze: t, kozow: t, loseyourip: t, ooguy: t, theworkpc: t, mytuleap: t, "tuleap-partners": t, encoreapi: t, evennode: [0, { "eu-1": t, "eu-2": t, "eu-3": t, "eu-4": t, "us-1": t, "us-2": t, "us-3": t, "us-4": t }], onfabrica: t, "fastly-edge": t, "fastly-terrarium": t, "fastvps-server": t, mydobiss: t, firebaseapp: t, fldrv: t, forgeblocks: t, framercanvas: t, "freebox-os": t, freeboxos: t, freemyip: t, aliases121: t, gentapps: t, gentlentapis: t, githubusercontent: t, "0emm": n, appspot: [2, { r: n }], blogspot: t, codespot: t, googleapis: t, googlecode: t, pagespeedmobilizer: t, withgoogle: t, withyoutube: t, grayjayleagues: t, hatenablog: t, hatenadiary: t, herokuapp: t, gr: t, smushcdn: t, wphostedmail: t, wpmucdn: t, pixolino: t, "apps-1and1": t, "live-website": t, "webspace-host": t, dopaas: t, "hosted-by-previder": Z, hosteur: [0, { "rag-cloud": t, "rag-cloud-ch": t }], "ik-server": [0, { jcloud: t, "jcloud-ver-jpc": t }], jelastic: [0, { demo: t }], massivegrid: Z, wafaicloud: [0, { jed: t, ryd: t }], webadorsite: t, joyent: [0, { cns: n }], "on-forge": t, "on-vapor": t, lpusercontent: t, linode: [0, { members: t, nodebalancer: n }], linodeobjects: n, linodeusercontent: [0, { ip: t }], localtonet: t, lovableproject: t, barsycenter: t, barsyonline: t, lutrausercontent: n, modelscape: t, mwcloudnonprod: t, polyspace: t, mazeplay: t, miniserver: t, atmeta: t, fbsbx: W, meteorapp: ee, routingthecloud: t, "same-app": t, "same-preview": t, mydbserver: t, hostedpi: t, "mythic-beasts": [0, { caracal: t, customer: t, fentiger: t, lynx: t, ocelot: t, oncilla: t, onza: t, sphinx: t, vs: t, x: t, yali: t }], nospamproxy: [0, { cloud: [2, { o365: t }] }], "4u": t, nfshost: t, "3utilities": t, blogsyte: t, ciscofreak: t, damnserver: t, ddnsking: t, ditchyourip: t, dnsiskinky: t, dynns: t, geekgalaxy: t, "health-carereform": t, homesecuritymac: t, homesecuritypc: t, myactivedirectory: t, mysecuritycamera: t, myvnc: t, "net-freaks": t, onthewifi: t, point2this: t, quicksytes: t, securitytactics: t, servebeer: t, servecounterstrike: t, serveexchange: t, serveftp: t, servegame: t, servehalflife: t, servehttp: t, servehumour: t, serveirc: t, servemp3: t, servep2p: t, servepics: t, servequake: t, servesarcasm: t, stufftoread: t, unusualperson: t, workisboring: t, myiphost: t, observableusercontent: [0, { static: t }], simplesite: t, oaiusercontent: n, orsites: t, operaunite: t, "customer-oci": [0, { "*": t, oci: n, ocp: n, ocs: n }], oraclecloudapps: n, oraclegovcloudapps: n, "authgear-staging": t, authgearapps: t, skygearapp: t, outsystemscloud: t, ownprovider: t, pgfog: t, pagexl: t, gotpantheon: t, paywhirl: n, upsunapp: t, "postman-echo": t, prgmr: [0, { xen: t }], "project-study": [0, { dev: t }], pythonanywhere: ee, qa2: t, "alpha-myqnapcloud": t, "dev-myqnapcloud": t, mycloudnas: t, mynascloud: t, myqnapcloud: t, qualifioapp: t, ladesk: t, qualyhqpartner: n, qualyhqportal: n, qbuser: t, quipelements: n, rackmaze: t, "readthedocs-hosted": t, rhcloud: t, onrender: t, render: M, "subsc-pay": t, "180r": t, dojin: t, sakuratan: t, sakuraweb: t, x0: t, code: [0, { builder: n, "dev-builder": n, "stg-builder": n }], salesforce: [0, { platform: [0, { "code-builder-stg": [0, { test: [0, { "001": n }] }] }] }], logoip: t, scrysec: t, "firewall-gateway": t, myshopblocks: t, myshopify: t, shopitsite: t, "1kapp": t, appchizi: t, applinzi: t, sinaapp: t, vipsinaapp: t, streamlitapp: t, "try-snowplow": t, "playstation-cloud": t, myspreadshop: t, "w-corp-staticblitz": t, "w-credentialless-staticblitz": t, "w-staticblitz": t, "stackhero-network": t, stdlib: [0, { api: t }], strapiapp: [2, { media: t }], "streak-link": t, streaklinks: t, streakusercontent: t, "temp-dns": t, dsmynas: t, familyds: t, mytabit: t, taveusercontent: t, "tb-hosting": Y, reservd: t, thingdustdata: t, "townnews-staging": t, typeform: [0, { pro: t }], hk: t, it: t, "deus-canvas": t, vultrobjects: n, wafflecell: t, hotelwithflight: t, "reserve-online": t, cprapid: t, pleskns: t, remotewd: t, wiardweb: [0, { pages: t }], wixsite: t, wixstudio: t, messwithdns: t, "woltlab-demo": t, wpenginepowered: [2, { js: t }], xnbay: [2, { u2: t, "u2-local": t }], yolasite: t }], coop: e, cr: [1, { ac: e, co: e, ed: e, fi: e, go: e, or: e, sa: e }], cu: [1, { com: e, edu: e, gob: e, inf: e, nat: e, net: e, org: e }], cv: [1, { com: e, edu: e, id: e, int: e, net: e, nome: e, org: e, publ: e }], cw: Q, cx: [1, { gov: e, cloudns: t, ath: t, info: t, assessments: t, calculators: t, funnels: t, paynow: t, quizzes: t, researched: t, tests: t }], cy: [1, { ac: e, biz: e, com: [1, { scaleforce: J }], ekloges: e, gov: e, ltd: e, mil: e, net: e, org: e, press: e, pro: e, tm: e }], cz: [1, { gov: e, contentproxy9: [0, { rsc: t }], realm: t, e4: t, co: t, metacentrum: [0, { cloud: n, custom: t }], muni: [0, { cloud: [0, { flt: t, usr: t }] }] }], de: [1, { bplaced: t, square7: t, com: t, cosidns: ae, dnsupdater: t, "dynamisches-dns": t, "internet-dns": t, "l-o-g-i-n": t, ddnss: [2, { dyn: t, dyndns: t }], "dyn-ip24": t, dyndns1: t, "home-webserver": [2, { dyn: t }], "myhome-server": t, dnshome: t, fuettertdasnetz: t, isteingeek: t, istmein: t, lebtimnetz: t, leitungsen: t, traeumtgerade: t, frusky: n, goip: t, "xn--gnstigbestellen-zvb": t, günstigbestellen: t, "xn--gnstigliefern-wob": t, günstigliefern: t, "hs-heilbronn": [0, { it: [0, { pages: t, "pages-research": t }] }], "dyn-berlin": t, "in-berlin": t, "in-brb": t, "in-butter": t, "in-dsl": t, "in-vpn": t, iservschule: t, "mein-iserv": t, schuldock: t, schulplattform: t, schulserver: t, "test-iserv": t, keymachine: t, co: t, "git-repos": t, "lcube-server": t, "svn-repos": t, barsy: t, webspaceconfig: t, "123webseite": t, rub: t, "ruhr-uni-bochum": [2, { noc: [0, { io: t }] }], logoip: t, "firewall-gateway": t, "my-gateway": t, "my-router": t, spdns: t, my: t, speedpartner: [0, { customer: t }], myspreadshop: t, "taifun-dns": t, "12hp": t, "2ix": t, "4lima": t, "lima-city": t, "dd-dns": t, "dray-dns": t, draydns: t, "dyn-vpn": t, dynvpn: t, "mein-vigor": t, "my-vigor": t, "my-wan": t, "syno-ds": t, "synology-diskstation": t, "synology-ds": t, "virtual-user": t, virtualuser: t, "community-pro": t, diskussionsbereich: t }], dj: e, dk: [1, { biz: t, co: t, firm: t, reg: t, store: t, "123hjemmeside": t, myspreadshop: t }], dm: fe, do: [1, { art: e, com: e, edu: e, gob: e, gov: e, mil: e, net: e, org: e, sld: e, web: e }], dz: [1, { art: e, asso: e, com: e, edu: e, gov: e, net: e, org: e, pol: e, soc: e, tm: e }], ec: [1, { abg: e, adm: e, agron: e, arqt: e, art: e, bar: e, chef: e, com: e, cont: e, cpa: e, cue: e, dent: e, dgn: e, disco: e, doc: e, edu: e, eng: e, esm: e, fin: e, fot: e, gal: e, gob: e, gov: e, gye: e, ibr: e, info: e, k12: e, lat: e, loj: e, med: e, mil: e, mktg: e, mon: e, net: e, ntr: e, odont: e, org: e, pro: e, prof: e, psic: e, psiq: e, pub: e, rio: e, rrpp: e, sal: e, tech: e, tul: e, tur: e, uio: e, vet: e, xxx: e, base: t, official: t }], edu: [1, { rit: [0, { "git-pages": t }] }], ee: [1, { aip: e, com: e, edu: e, fie: e, gov: e, lib: e, med: e, org: e, pri: e, riik: e }], eg: [1, { ac: e, com: e, edu: e, eun: e, gov: e, info: e, me: e, mil: e, name: e, net: e, org: e, sci: e, sport: e, tv: e }], er: _, es: [1, { com: e, edu: e, gob: e, nom: e, org: e, "123miweb": t, myspreadshop: t }], et: [1, { biz: e, com: e, edu: e, gov: e, info: e, name: e, net: e, org: e }], eu: [1, { airkitapps: t, cloudns: t, dogado: [0, { jelastic: t }], barsy: t, spdns: t, nxa: n, transurl: n, diskstation: t }], fi: [1, { aland: e, dy: t, "xn--hkkinen-5wa": t, häkkinen: t, iki: t, cloudplatform: [0, { fi: t }], datacenter: [0, { demo: t, paas: t }], kapsi: t, "123kotisivu": t, myspreadshop: t }], fj: [1, { ac: e, biz: e, com: e, gov: e, info: e, mil: e, name: e, net: e, org: e, pro: e }], fk: _, fm: [1, { com: e, edu: e, net: e, org: e, radio: t, user: n }], fo: e, fr: [1, { asso: e, com: e, gouv: e, nom: e, prd: e, tm: e, avoues: e, cci: e, greta: e, "huissier-justice": e, "en-root": t, "fbx-os": t, fbxos: t, "freebox-os": t, freeboxos: t, goupile: t, "123siteweb": t, "on-web": t, "chirurgiens-dentistes-en-france": t, dedibox: t, aeroport: t, avocat: t, chambagri: t, "chirurgiens-dentistes": t, "experts-comptables": t, medecin: t, notaires: t, pharmacien: t, port: t, veterinaire: t, myspreadshop: t, ynh: t }], ga: e, gb: e, gd: [1, { edu: e, gov: e }], ge: [1, { com: e, edu: e, gov: e, net: e, org: e, pvt: e, school: e }], gf: e, gg: [1, { co: e, net: e, org: e, botdash: t, kaas: t, stackit: t, panel: [2, { daemon: t }] }], gh: [1, { biz: e, com: e, edu: e, gov: e, mil: e, net: e, org: e }], gi: [1, { com: e, edu: e, gov: e, ltd: e, mod: e, org: e }], gl: [1, { co: e, com: e, edu: e, net: e, org: e }], gm: e, gn: [1, { ac: e, com: e, edu: e, gov: e, net: e, org: e }], gov: e, gp: [1, { asso: e, com: e, edu: e, mobi: e, net: e, org: e }], gq: e, gr: [1, { com: e, edu: e, gov: e, net: e, org: e, barsy: t, simplesite: t }], gs: e, gt: [1, { com: e, edu: e, gob: e, ind: e, mil: e, net: e, org: e }], gu: [1, { com: e, edu: e, gov: e, guam: e, info: e, net: e, org: e, web: e }], gw: [1, { nx: t }], gy: fe, hk: [1, { com: e, edu: e, gov: e, idv: e, net: e, org: e, "xn--ciqpn": e, 个人: e, "xn--gmqw5a": e, 個人: e, "xn--55qx5d": e, 公司: e, "xn--mxtq1m": e, 政府: e, "xn--lcvr32d": e, 敎育: e, "xn--wcvs22d": e, 教育: e, "xn--gmq050i": e, 箇人: e, "xn--uc0atv": e, 組織: e, "xn--uc0ay4a": e, 組织: e, "xn--od0alg": e, 網絡: e, "xn--zf0avx": e, 網络: e, "xn--mk0axi": e, 组織: e, "xn--tn0ag": e, 组织: e, "xn--od0aq3b": e, 网絡: e, "xn--io0a7i": e, 网络: e, inc: t, ltd: t }], hm: e, hn: [1, { com: e, edu: e, gob: e, mil: e, net: e, org: e }], hr: [1, { com: e, from: e, iz: e, name: e, brendly: w }], ht: [1, { adult: e, art: e, asso: e, com: e, coop: e, edu: e, firm: e, gouv: e, info: e, med: e, net: e, org: e, perso: e, pol: e, pro: e, rel: e, shop: e, rt: t }], hu: [1, { 2e3: e, agrar: e, bolt: e, casino: e, city: e, co: e, erotica: e, erotika: e, film: e, forum: e, games: e, hotel: e, info: e, ingatlan: e, jogasz: e, konyvelo: e, lakas: e, media: e, news: e, org: e, priv: e, reklam: e, sex: e, shop: e, sport: e, suli: e, szex: e, tm: e, tozsde: e, utazas: e, video: e }], id: [1, { ac: e, biz: e, co: e, desa: e, go: e, kop: e, mil: e, my: e, net: e, or: e, ponpes: e, sch: e, web: e, zone: t }], ie: [1, { gov: e, myspreadshop: t }], il: [1, { ac: e, co: [1, { ravpage: t, mytabit: t, tabitorder: t }], gov: e, idf: e, k12: e, muni: e, net: e, org: e }], "xn--4dbrk0ce": [1, { "xn--4dbgdty6c": e, "xn--5dbhl8d": e, "xn--8dbq2a": e, "xn--hebda8b": e }], ישראל: [1, { אקדמיה: e, ישוב: e, צהל: e, ממשל: e }], im: [1, { ac: e, co: [1, { ltd: e, plc: e }], com: e, net: e, org: e, tt: e, tv: e }], in: [1, { "5g": e, "6g": e, ac: e, ai: e, am: e, bihar: e, biz: e, business: e, ca: e, cn: e, co: e, com: e, coop: e, cs: e, delhi: e, dr: e, edu: e, er: e, firm: e, gen: e, gov: e, gujarat: e, ind: e, info: e, int: e, internet: e, io: e, me: e, mil: e, net: e, nic: e, org: e, pg: e, post: e, pro: e, res: e, travel: e, tv: e, uk: e, up: e, us: e, cloudns: t, barsy: t, web: t, supabase: t }], info: [1, { cloudns: t, "dynamic-dns": t, "barrel-of-knowledge": t, "barrell-of-knowledge": t, dyndns: t, "for-our": t, "groks-the": t, "groks-this": t, "here-for-more": t, knowsitall: t, selfip: t, webhop: t, barsy: t, mayfirst: t, mittwald: t, mittwaldserver: t, typo3server: t, dvrcam: t, ilovecollege: t, "no-ip": t, forumz: t, nsupdate: t, dnsupdate: t, "v-info": t }], int: [1, { eu: e }], io: [1, { 2038: t, co: e, com: e, edu: e, gov: e, mil: e, net: e, nom: e, org: e, "on-acorn": n, myaddr: t, apigee: t, "b-data": t, beagleboard: t, bitbucket: t, bluebite: t, boxfuse: t, brave: r, browsersafetymark: t, bubble: Ve, bubbleapps: t, bigv: [0, { uk0: t }], cleverapps: t, cloudbeesusercontent: t, dappnode: [0, { dyndns: t }], darklang: t, definima: t, dedyn: t, icp0: Ft, icp1: Ft, qzz: t, "fh-muenster": t, shw: t, forgerock: [0, { id: t }], github: t, gitlab: t, lolipop: t, "hasura-app": t, hostyhosting: t, hypernode: t, moonscale: n, beebyte: Z, beebyteapp: [0, { sekd1: t }], jele: t, webthings: t, loginline: t, barsy: t, azurecontainer: n, ngrok: [2, { ap: t, au: t, eu: t, in: t, jp: t, sa: t, us: t }], nodeart: [0, { stage: t }], pantheonsite: t, pstmn: [2, { mock: t }], protonet: t, qcx: [2, { sys: n }], qoto: t, vaporcloud: t, myrdbx: t, "rb-hosting": Y, "on-k3s": n, "on-rio": n, readthedocs: t, resindevice: t, resinstaging: [0, { devices: t }], hzc: t, sandcats: t, scrypted: [0, { client: t }], "mo-siemens": t, lair: W, stolos: n, musician: t, utwente: t, edugit: t, telebit: t, thingdust: [0, { dev: ft, disrec: ft, prod: Ba, testing: ft }], tickets: t, webflow: t, webflowtest: t, editorx: t, wixstudio: t, basicserver: t, virtualserver: t }], iq: o, ir: [1, { ac: e, co: e, gov: e, id: e, net: e, org: e, sch: e, "xn--mgba3a4f16a": e, ایران: e, "xn--mgba3a4fra": e, ايران: e, arvanedge: t, vistablog: t }], is: e, it: [1, { edu: e, gov: e, abr: e, abruzzo: e, "aosta-valley": e, aostavalley: e, bas: e, basilicata: e, cal: e, calabria: e, cam: e, campania: e, "emilia-romagna": e, emiliaromagna: e, emr: e, "friuli-v-giulia": e, "friuli-ve-giulia": e, "friuli-vegiulia": e, "friuli-venezia-giulia": e, "friuli-veneziagiulia": e, "friuli-vgiulia": e, "friuliv-giulia": e, "friulive-giulia": e, friulivegiulia: e, "friulivenezia-giulia": e, friuliveneziagiulia: e, friulivgiulia: e, fvg: e, laz: e, lazio: e, lig: e, liguria: e, lom: e, lombardia: e, lombardy: e, lucania: e, mar: e, marche: e, mol: e, molise: e, piedmont: e, piemonte: e, pmn: e, pug: e, puglia: e, sar: e, sardegna: e, sardinia: e, sic: e, sicilia: e, sicily: e, taa: e, tos: e, toscana: e, "trentin-sud-tirol": e, "xn--trentin-sd-tirol-rzb": e, "trentin-süd-tirol": e, "trentin-sudtirol": e, "xn--trentin-sdtirol-7vb": e, "trentin-südtirol": e, "trentin-sued-tirol": e, "trentin-suedtirol": e, trentino: e, "trentino-a-adige": e, "trentino-aadige": e, "trentino-alto-adige": e, "trentino-altoadige": e, "trentino-s-tirol": e, "trentino-stirol": e, "trentino-sud-tirol": e, "xn--trentino-sd-tirol-c3b": e, "trentino-süd-tirol": e, "trentino-sudtirol": e, "xn--trentino-sdtirol-szb": e, "trentino-südtirol": e, "trentino-sued-tirol": e, "trentino-suedtirol": e, "trentinoa-adige": e, trentinoaadige: e, "trentinoalto-adige": e, trentinoaltoadige: e, "trentinos-tirol": e, trentinostirol: e, "trentinosud-tirol": e, "xn--trentinosd-tirol-rzb": e, "trentinosüd-tirol": e, trentinosudtirol: e, "xn--trentinosdtirol-7vb": e, trentinosüdtirol: e, "trentinosued-tirol": e, trentinosuedtirol: e, "trentinsud-tirol": e, "xn--trentinsd-tirol-6vb": e, "trentinsüd-tirol": e, trentinsudtirol: e, "xn--trentinsdtirol-nsb": e, trentinsüdtirol: e, "trentinsued-tirol": e, trentinsuedtirol: e, tuscany: e, umb: e, umbria: e, "val-d-aosta": e, "val-daosta": e, "vald-aosta": e, valdaosta: e, "valle-aosta": e, "valle-d-aosta": e, "valle-daosta": e, valleaosta: e, "valled-aosta": e, valledaosta: e, "vallee-aoste": e, "xn--valle-aoste-ebb": e, "vallée-aoste": e, "vallee-d-aoste": e, "xn--valle-d-aoste-ehb": e, "vallée-d-aoste": e, valleeaoste: e, "xn--valleaoste-e7a": e, valléeaoste: e, valleedaoste: e, "xn--valledaoste-ebb": e, valléedaoste: e, vao: e, vda: e, ven: e, veneto: e, ag: e, agrigento: e, al: e, alessandria: e, "alto-adige": e, altoadige: e, an: e, ancona: e, "andria-barletta-trani": e, "andria-trani-barletta": e, andriabarlettatrani: e, andriatranibarletta: e, ao: e, aosta: e, aoste: e, ap: e, aq: e, aquila: e, ar: e, arezzo: e, "ascoli-piceno": e, ascolipiceno: e, asti: e, at: e, av: e, avellino: e, ba: e, balsan: e, "balsan-sudtirol": e, "xn--balsan-sdtirol-nsb": e, "balsan-südtirol": e, "balsan-suedtirol": e, bari: e, "barletta-trani-andria": e, barlettatraniandria: e, belluno: e, benevento: e, bergamo: e, bg: e, bi: e, biella: e, bl: e, bn: e, bo: e, bologna: e, bolzano: e, "bolzano-altoadige": e, bozen: e, "bozen-sudtirol": e, "xn--bozen-sdtirol-2ob": e, "bozen-südtirol": e, "bozen-suedtirol": e, br: e, brescia: e, brindisi: e, bs: e, bt: e, bulsan: e, "bulsan-sudtirol": e, "xn--bulsan-sdtirol-nsb": e, "bulsan-südtirol": e, "bulsan-suedtirol": e, bz: e, ca: e, cagliari: e, caltanissetta: e, "campidano-medio": e, campidanomedio: e, campobasso: e, "carbonia-iglesias": e, carboniaiglesias: e, "carrara-massa": e, carraramassa: e, caserta: e, catania: e, catanzaro: e, cb: e, ce: e, "cesena-forli": e, "xn--cesena-forl-mcb": e, "cesena-forlì": e, cesenaforli: e, "xn--cesenaforl-i8a": e, cesenaforlì: e, ch: e, chieti: e, ci: e, cl: e, cn: e, co: e, como: e, cosenza: e, cr: e, cremona: e, crotone: e, cs: e, ct: e, cuneo: e, cz: e, "dell-ogliastra": e, dellogliastra: e, en: e, enna: e, fc: e, fe: e, fermo: e, ferrara: e, fg: e, fi: e, firenze: e, florence: e, fm: e, foggia: e, "forli-cesena": e, "xn--forl-cesena-fcb": e, "forlì-cesena": e, forlicesena: e, "xn--forlcesena-c8a": e, forlìcesena: e, fr: e, frosinone: e, ge: e, genoa: e, genova: e, go: e, gorizia: e, gr: e, grosseto: e, "iglesias-carbonia": e, iglesiascarbonia: e, im: e, imperia: e, is: e, isernia: e, kr: e, "la-spezia": e, laquila: e, laspezia: e, latina: e, lc: e, le: e, lecce: e, lecco: e, li: e, livorno: e, lo: e, lodi: e, lt: e, lu: e, lucca: e, macerata: e, mantova: e, "massa-carrara": e, massacarrara: e, matera: e, mb: e, mc: e, me: e, "medio-campidano": e, mediocampidano: e, messina: e, mi: e, milan: e, milano: e, mn: e, mo: e, modena: e, monza: e, "monza-brianza": e, "monza-e-della-brianza": e, monzabrianza: e, monzaebrianza: e, monzaedellabrianza: e, ms: e, mt: e, na: e, naples: e, napoli: e, no: e, novara: e, nu: e, nuoro: e, og: e, ogliastra: e, "olbia-tempio": e, olbiatempio: e, or: e, oristano: e, ot: e, pa: e, padova: e, padua: e, palermo: e, parma: e, pavia: e, pc: e, pd: e, pe: e, perugia: e, "pesaro-urbino": e, pesarourbino: e, pescara: e, pg: e, pi: e, piacenza: e, pisa: e, pistoia: e, pn: e, po: e, pordenone: e, potenza: e, pr: e, prato: e, pt: e, pu: e, pv: e, pz: e, ra: e, ragusa: e, ravenna: e, rc: e, re: e, "reggio-calabria": e, "reggio-emilia": e, reggiocalabria: e, reggioemilia: e, rg: e, ri: e, rieti: e, rimini: e, rm: e, rn: e, ro: e, roma: e, rome: e, rovigo: e, sa: e, salerno: e, sassari: e, savona: e, si: e, siena: e, siracusa: e, so: e, sondrio: e, sp: e, sr: e, ss: e, "xn--sdtirol-n2a": e, südtirol: e, suedtirol: e, sv: e, ta: e, taranto: e, te: e, "tempio-olbia": e, tempioolbia: e, teramo: e, terni: e, tn: e, to: e, torino: e, tp: e, tr: e, "trani-andria-barletta": e, "trani-barletta-andria": e, traniandriabarletta: e, tranibarlettaandria: e, trapani: e, trento: e, treviso: e, trieste: e, ts: e, turin: e, tv: e, ud: e, udine: e, "urbino-pesaro": e, urbinopesaro: e, va: e, varese: e, vb: e, vc: e, ve: e, venezia: e, venice: e, verbania: e, vercelli: e, verona: e, vi: e, "vibo-valentia": e, vibovalentia: e, vicenza: e, viterbo: e, vr: e, vs: e, vt: e, vv: e, "12chars": t, ibxos: t, iliadboxos: t, neen: [0, { jc: t }], "123homepage": t, "16-b": t, "32-b": t, "64-b": t, myspreadshop: t, syncloud: t }], je: [1, { co: e, net: e, org: e, of: t }], jm: _, jo: [1, { agri: e, ai: e, com: e, edu: e, eng: e, fm: e, gov: e, mil: e, net: e, org: e, per: e, phd: e, sch: e, tv: e }], jobs: e, jp: [1, { ac: e, ad: e, co: e, ed: e, go: e, gr: e, lg: e, ne: [1, { aseinet: Ye, gehirn: t, ivory: t, "mail-box": t, mints: t, mokuren: t, opal: t, sakura: t, sumomo: t, topaz: t }], or: e, aichi: [1, { aisai: e, ama: e, anjo: e, asuke: e, chiryu: e, chita: e, fuso: e, gamagori: e, handa: e, hazu: e, hekinan: e, higashiura: e, ichinomiya: e, inazawa: e, inuyama: e, isshiki: e, iwakura: e, kanie: e, kariya: e, kasugai: e, kira: e, kiyosu: e, komaki: e, konan: e, kota: e, mihama: e, miyoshi: e, nishio: e, nisshin: e, obu: e, oguchi: e, oharu: e, okazaki: e, owariasahi: e, seto: e, shikatsu: e, shinshiro: e, shitara: e, tahara: e, takahama: e, tobishima: e, toei: e, togo: e, tokai: e, tokoname: e, toyoake: e, toyohashi: e, toyokawa: e, toyone: e, toyota: e, tsushima: e, yatomi: e }], akita: [1, { akita: e, daisen: e, fujisato: e, gojome: e, hachirogata: e, happou: e, higashinaruse: e, honjo: e, honjyo: e, ikawa: e, kamikoani: e, kamioka: e, katagami: e, kazuno: e, kitaakita: e, kosaka: e, kyowa: e, misato: e, mitane: e, moriyoshi: e, nikaho: e, noshiro: e, odate: e, oga: e, ogata: e, semboku: e, yokote: e, yurihonjo: e }], aomori: [1, { aomori: e, gonohe: e, hachinohe: e, hashikami: e, hiranai: e, hirosaki: e, itayanagi: e, kuroishi: e, misawa: e, mutsu: e, nakadomari: e, noheji: e, oirase: e, owani: e, rokunohe: e, sannohe: e, shichinohe: e, shingo: e, takko: e, towada: e, tsugaru: e, tsuruta: e }], chiba: [1, { abiko: e, asahi: e, chonan: e, chosei: e, choshi: e, chuo: e, funabashi: e, futtsu: e, hanamigawa: e, ichihara: e, ichikawa: e, ichinomiya: e, inzai: e, isumi: e, kamagaya: e, kamogawa: e, kashiwa: e, katori: e, katsuura: e, kimitsu: e, kisarazu: e, kozaki: e, kujukuri: e, kyonan: e, matsudo: e, midori: e, mihama: e, minamiboso: e, mobara: e, mutsuzawa: e, nagara: e, nagareyama: e, narashino: e, narita: e, noda: e, oamishirasato: e, omigawa: e, onjuku: e, otaki: e, sakae: e, sakura: e, shimofusa: e, shirako: e, shiroi: e, shisui: e, sodegaura: e, sosa: e, tako: e, tateyama: e, togane: e, tohnosho: e, tomisato: e, urayasu: e, yachimata: e, yachiyo: e, yokaichiba: e, yokoshibahikari: e, yotsukaido: e }], ehime: [1, { ainan: e, honai: e, ikata: e, imabari: e, iyo: e, kamijima: e, kihoku: e, kumakogen: e, masaki: e, matsuno: e, matsuyama: e, namikata: e, niihama: e, ozu: e, saijo: e, seiyo: e, shikokuchuo: e, tobe: e, toon: e, uchiko: e, uwajima: e, yawatahama: e }], fukui: [1, { echizen: e, eiheiji: e, fukui: e, ikeda: e, katsuyama: e, mihama: e, minamiechizen: e, obama: e, ohi: e, ono: e, sabae: e, sakai: e, takahama: e, tsuruga: e, wakasa: e }], fukuoka: [1, { ashiya: e, buzen: e, chikugo: e, chikuho: e, chikujo: e, chikushino: e, chikuzen: e, chuo: e, dazaifu: e, fukuchi: e, hakata: e, higashi: e, hirokawa: e, hisayama: e, iizuka: e, inatsuki: e, kaho: e, kasuga: e, kasuya: e, kawara: e, keisen: e, koga: e, kurate: e, kurogi: e, kurume: e, minami: e, miyako: e, miyama: e, miyawaka: e, mizumaki: e, munakata: e, nakagawa: e, nakama: e, nishi: e, nogata: e, ogori: e, okagaki: e, okawa: e, oki: e, omuta: e, onga: e, onojo: e, oto: e, saigawa: e, sasaguri: e, shingu: e, shinyoshitomi: e, shonai: e, soeda: e, sue: e, tachiarai: e, tagawa: e, takata: e, toho: e, toyotsu: e, tsuiki: e, ukiha: e, umi: e, usui: e, yamada: e, yame: e, yanagawa: e, yukuhashi: e }], fukushima: [1, { aizubange: e, aizumisato: e, aizuwakamatsu: e, asakawa: e, bandai: e, date: e, fukushima: e, furudono: e, futaba: e, hanawa: e, higashi: e, hirata: e, hirono: e, iitate: e, inawashiro: e, ishikawa: e, iwaki: e, izumizaki: e, kagamiishi: e, kaneyama: e, kawamata: e, kitakata: e, kitashiobara: e, koori: e, koriyama: e, kunimi: e, miharu: e, mishima: e, namie: e, nango: e, nishiaizu: e, nishigo: e, okuma: e, omotego: e, ono: e, otama: e, samegawa: e, shimogo: e, shirakawa: e, showa: e, soma: e, sukagawa: e, taishin: e, tamakawa: e, tanagura: e, tenei: e, yabuki: e, yamato: e, yamatsuri: e, yanaizu: e, yugawa: e }], gifu: [1, { anpachi: e, ena: e, gifu: e, ginan: e, godo: e, gujo: e, hashima: e, hichiso: e, hida: e, higashishirakawa: e, ibigawa: e, ikeda: e, kakamigahara: e, kani: e, kasahara: e, kasamatsu: e, kawaue: e, kitagata: e, mino: e, minokamo: e, mitake: e, mizunami: e, motosu: e, nakatsugawa: e, ogaki: e, sakahogi: e, seki: e, sekigahara: e, shirakawa: e, tajimi: e, takayama: e, tarui: e, toki: e, tomika: e, wanouchi: e, yamagata: e, yaotsu: e, yoro: e }], gunma: [1, { annaka: e, chiyoda: e, fujioka: e, higashiagatsuma: e, isesaki: e, itakura: e, kanna: e, kanra: e, katashina: e, kawaba: e, kiryu: e, kusatsu: e, maebashi: e, meiwa: e, midori: e, minakami: e, naganohara: e, nakanojo: e, nanmoku: e, numata: e, oizumi: e, ora: e, ota: e, shibukawa: e, shimonita: e, shinto: e, showa: e, takasaki: e, takayama: e, tamamura: e, tatebayashi: e, tomioka: e, tsukiyono: e, tsumagoi: e, ueno: e, yoshioka: e }], hiroshima: [1, { asaminami: e, daiwa: e, etajima: e, fuchu: e, fukuyama: e, hatsukaichi: e, higashihiroshima: e, hongo: e, jinsekikogen: e, kaita: e, kui: e, kumano: e, kure: e, mihara: e, miyoshi: e, naka: e, onomichi: e, osakikamijima: e, otake: e, saka: e, sera: e, seranishi: e, shinichi: e, shobara: e, takehara: e }], hokkaido: [1, { abashiri: e, abira: e, aibetsu: e, akabira: e, akkeshi: e, asahikawa: e, ashibetsu: e, ashoro: e, assabu: e, atsuma: e, bibai: e, biei: e, bifuka: e, bihoro: e, biratori: e, chippubetsu: e, chitose: e, date: e, ebetsu: e, embetsu: e, eniwa: e, erimo: e, esan: e, esashi: e, fukagawa: e, fukushima: e, furano: e, furubira: e, haboro: e, hakodate: e, hamatonbetsu: e, hidaka: e, higashikagura: e, higashikawa: e, hiroo: e, hokuryu: e, hokuto: e, honbetsu: e, horokanai: e, horonobe: e, ikeda: e, imakane: e, ishikari: e, iwamizawa: e, iwanai: e, kamifurano: e, kamikawa: e, kamishihoro: e, kamisunagawa: e, kamoenai: e, kayabe: e, kembuchi: e, kikonai: e, kimobetsu: e, kitahiroshima: e, kitami: e, kiyosato: e, koshimizu: e, kunneppu: e, kuriyama: e, kuromatsunai: e, kushiro: e, kutchan: e, kyowa: e, mashike: e, matsumae: e, mikasa: e, minamifurano: e, mombetsu: e, moseushi: e, mukawa: e, muroran: e, naie: e, nakagawa: e, nakasatsunai: e, nakatombetsu: e, nanae: e, nanporo: e, nayoro: e, nemuro: e, niikappu: e, niki: e, nishiokoppe: e, noboribetsu: e, numata: e, obihiro: e, obira: e, oketo: e, okoppe: e, otaru: e, otobe: e, otofuke: e, otoineppu: e, oumu: e, ozora: e, pippu: e, rankoshi: e, rebun: e, rikubetsu: e, rishiri: e, rishirifuji: e, saroma: e, sarufutsu: e, shakotan: e, shari: e, shibecha: e, shibetsu: e, shikabe: e, shikaoi: e, shimamaki: e, shimizu: e, shimokawa: e, shinshinotsu: e, shintoku: e, shiranuka: e, shiraoi: e, shiriuchi: e, sobetsu: e, sunagawa: e, taiki: e, takasu: e, takikawa: e, takinoue: e, teshikaga: e, tobetsu: e, tohma: e, tomakomai: e, tomari: e, toya: e, toyako: e, toyotomi: e, toyoura: e, tsubetsu: e, tsukigata: e, urakawa: e, urausu: e, uryu: e, utashinai: e, wakkanai: e, wassamu: e, yakumo: e, yoichi: e }], hyogo: [1, { aioi: e, akashi: e, ako: e, amagasaki: e, aogaki: e, asago: e, ashiya: e, awaji: e, fukusaki: e, goshiki: e, harima: e, himeji: e, ichikawa: e, inagawa: e, itami: e, kakogawa: e, kamigori: e, kamikawa: e, kasai: e, kasuga: e, kawanishi: e, miki: e, minamiawaji: e, nishinomiya: e, nishiwaki: e, ono: e, sanda: e, sannan: e, sasayama: e, sayo: e, shingu: e, shinonsen: e, shiso: e, sumoto: e, taishi: e, taka: e, takarazuka: e, takasago: e, takino: e, tamba: e, tatsuno: e, toyooka: e, yabu: e, yashiro: e, yoka: e, yokawa: e }], ibaraki: [1, { ami: e, asahi: e, bando: e, chikusei: e, daigo: e, fujishiro: e, hitachi: e, hitachinaka: e, hitachiomiya: e, hitachiota: e, ibaraki: e, ina: e, inashiki: e, itako: e, iwama: e, joso: e, kamisu: e, kasama: e, kashima: e, kasumigaura: e, koga: e, miho: e, mito: e, moriya: e, naka: e, namegata: e, oarai: e, ogawa: e, omitama: e, ryugasaki: e, sakai: e, sakuragawa: e, shimodate: e, shimotsuma: e, shirosato: e, sowa: e, suifu: e, takahagi: e, tamatsukuri: e, tokai: e, tomobe: e, tone: e, toride: e, tsuchiura: e, tsukuba: e, uchihara: e, ushiku: e, yachiyo: e, yamagata: e, yawara: e, yuki: e }], ishikawa: [1, { anamizu: e, hakui: e, hakusan: e, kaga: e, kahoku: e, kanazawa: e, kawakita: e, komatsu: e, nakanoto: e, nanao: e, nomi: e, nonoichi: e, noto: e, shika: e, suzu: e, tsubata: e, tsurugi: e, uchinada: e, wajima: e }], iwate: [1, { fudai: e, fujisawa: e, hanamaki: e, hiraizumi: e, hirono: e, ichinohe: e, ichinoseki: e, iwaizumi: e, iwate: e, joboji: e, kamaishi: e, kanegasaki: e, karumai: e, kawai: e, kitakami: e, kuji: e, kunohe: e, kuzumaki: e, miyako: e, mizusawa: e, morioka: e, ninohe: e, noda: e, ofunato: e, oshu: e, otsuchi: e, rikuzentakata: e, shiwa: e, shizukuishi: e, sumita: e, tanohata: e, tono: e, yahaba: e, yamada: e }], kagawa: [1, { ayagawa: e, higashikagawa: e, kanonji: e, kotohira: e, manno: e, marugame: e, mitoyo: e, naoshima: e, sanuki: e, tadotsu: e, takamatsu: e, tonosho: e, uchinomi: e, utazu: e, zentsuji: e }], kagoshima: [1, { akune: e, amami: e, hioki: e, isa: e, isen: e, izumi: e, kagoshima: e, kanoya: e, kawanabe: e, kinko: e, kouyama: e, makurazaki: e, matsumoto: e, minamitane: e, nakatane: e, nishinoomote: e, satsumasendai: e, soo: e, tarumizu: e, yusui: e }], kanagawa: [1, { aikawa: e, atsugi: e, ayase: e, chigasaki: e, ebina: e, fujisawa: e, hadano: e, hakone: e, hiratsuka: e, isehara: e, kaisei: e, kamakura: e, kiyokawa: e, matsuda: e, minamiashigara: e, miura: e, nakai: e, ninomiya: e, odawara: e, oi: e, oiso: e, sagamihara: e, samukawa: e, tsukui: e, yamakita: e, yamato: e, yokosuka: e, yugawara: e, zama: e, zushi: e }], kochi: [1, { aki: e, geisei: e, hidaka: e, higashitsuno: e, ino: e, kagami: e, kami: e, kitagawa: e, kochi: e, mihara: e, motoyama: e, muroto: e, nahari: e, nakamura: e, nankoku: e, nishitosa: e, niyodogawa: e, ochi: e, okawa: e, otoyo: e, otsuki: e, sakawa: e, sukumo: e, susaki: e, tosa: e, tosashimizu: e, toyo: e, tsuno: e, umaji: e, yasuda: e, yusuhara: e }], kumamoto: [1, { amakusa: e, arao: e, aso: e, choyo: e, gyokuto: e, kamiamakusa: e, kikuchi: e, kumamoto: e, mashiki: e, mifune: e, minamata: e, minamioguni: e, nagasu: e, nishihara: e, oguni: e, ozu: e, sumoto: e, takamori: e, uki: e, uto: e, yamaga: e, yamato: e, yatsushiro: e }], kyoto: [1, { ayabe: e, fukuchiyama: e, higashiyama: e, ide: e, ine: e, joyo: e, kameoka: e, kamo: e, kita: e, kizu: e, kumiyama: e, kyotamba: e, kyotanabe: e, kyotango: e, maizuru: e, minami: e, minamiyamashiro: e, miyazu: e, muko: e, nagaokakyo: e, nakagyo: e, nantan: e, oyamazaki: e, sakyo: e, seika: e, tanabe: e, uji: e, ujitawara: e, wazuka: e, yamashina: e, yawata: e }], mie: [1, { asahi: e, inabe: e, ise: e, kameyama: e, kawagoe: e, kiho: e, kisosaki: e, kiwa: e, komono: e, kumano: e, kuwana: e, matsusaka: e, meiwa: e, mihama: e, minamiise: e, misugi: e, miyama: e, nabari: e, shima: e, suzuka: e, tado: e, taiki: e, taki: e, tamaki: e, toba: e, tsu: e, udono: e, ureshino: e, watarai: e, yokkaichi: e }], miyagi: [1, { furukawa: e, higashimatsushima: e, ishinomaki: e, iwanuma: e, kakuda: e, kami: e, kawasaki: e, marumori: e, matsushima: e, minamisanriku: e, misato: e, murata: e, natori: e, ogawara: e, ohira: e, onagawa: e, osaki: e, rifu: e, semine: e, shibata: e, shichikashuku: e, shikama: e, shiogama: e, shiroishi: e, tagajo: e, taiwa: e, tome: e, tomiya: e, wakuya: e, watari: e, yamamoto: e, zao: e }], miyazaki: [1, { aya: e, ebino: e, gokase: e, hyuga: e, kadogawa: e, kawaminami: e, kijo: e, kitagawa: e, kitakata: e, kitaura: e, kobayashi: e, kunitomi: e, kushima: e, mimata: e, miyakonojo: e, miyazaki: e, morotsuka: e, nichinan: e, nishimera: e, nobeoka: e, saito: e, shiiba: e, shintomi: e, takaharu: e, takanabe: e, takazaki: e, tsuno: e }], nagano: [1, { achi: e, agematsu: e, anan: e, aoki: e, asahi: e, azumino: e, chikuhoku: e, chikuma: e, chino: e, fujimi: e, hakuba: e, hara: e, hiraya: e, iida: e, iijima: e, iiyama: e, iizuna: e, ikeda: e, ikusaka: e, ina: e, karuizawa: e, kawakami: e, kiso: e, kisofukushima: e, kitaaiki: e, komagane: e, komoro: e, matsukawa: e, matsumoto: e, miasa: e, minamiaiki: e, minamimaki: e, minamiminowa: e, minowa: e, miyada: e, miyota: e, mochizuki: e, nagano: e, nagawa: e, nagiso: e, nakagawa: e, nakano: e, nozawaonsen: e, obuse: e, ogawa: e, okaya: e, omachi: e, omi: e, ookuwa: e, ooshika: e, otaki: e, otari: e, sakae: e, sakaki: e, saku: e, sakuho: e, shimosuwa: e, shinanomachi: e, shiojiri: e, suwa: e, suzaka: e, takagi: e, takamori: e, takayama: e, tateshina: e, tatsuno: e, togakushi: e, togura: e, tomi: e, ueda: e, wada: e, yamagata: e, yamanouchi: e, yasaka: e, yasuoka: e }], nagasaki: [1, { chijiwa: e, futsu: e, goto: e, hasami: e, hirado: e, iki: e, isahaya: e, kawatana: e, kuchinotsu: e, matsuura: e, nagasaki: e, obama: e, omura: e, oseto: e, saikai: e, sasebo: e, seihi: e, shimabara: e, shinkamigoto: e, togitsu: e, tsushima: e, unzen: e }], nara: [1, { ando: e, gose: e, heguri: e, higashiyoshino: e, ikaruga: e, ikoma: e, kamikitayama: e, kanmaki: e, kashiba: e, kashihara: e, katsuragi: e, kawai: e, kawakami: e, kawanishi: e, koryo: e, kurotaki: e, mitsue: e, miyake: e, nara: e, nosegawa: e, oji: e, ouda: e, oyodo: e, sakurai: e, sango: e, shimoichi: e, shimokitayama: e, shinjo: e, soni: e, takatori: e, tawaramoto: e, tenkawa: e, tenri: e, uda: e, yamatokoriyama: e, yamatotakada: e, yamazoe: e, yoshino: e }], niigata: [1, { aga: e, agano: e, gosen: e, itoigawa: e, izumozaki: e, joetsu: e, kamo: e, kariwa: e, kashiwazaki: e, minamiuonuma: e, mitsuke: e, muika: e, murakami: e, myoko: e, nagaoka: e, niigata: e, ojiya: e, omi: e, sado: e, sanjo: e, seiro: e, seirou: e, sekikawa: e, shibata: e, tagami: e, tainai: e, tochio: e, tokamachi: e, tsubame: e, tsunan: e, uonuma: e, yahiko: e, yoita: e, yuzawa: e }], oita: [1, { beppu: e, bungoono: e, bungotakada: e, hasama: e, hiji: e, himeshima: e, hita: e, kamitsue: e, kokonoe: e, kuju: e, kunisaki: e, kusu: e, oita: e, saiki: e, taketa: e, tsukumi: e, usa: e, usuki: e, yufu: e }], okayama: [1, { akaiwa: e, asakuchi: e, bizen: e, hayashima: e, ibara: e, kagamino: e, kasaoka: e, kibichuo: e, kumenan: e, kurashiki: e, maniwa: e, misaki: e, nagi: e, niimi: e, nishiawakura: e, okayama: e, satosho: e, setouchi: e, shinjo: e, shoo: e, soja: e, takahashi: e, tamano: e, tsuyama: e, wake: e, yakage: e }], okinawa: [1, { aguni: e, ginowan: e, ginoza: e, gushikami: e, haebaru: e, higashi: e, hirara: e, iheya: e, ishigaki: e, ishikawa: e, itoman: e, izena: e, kadena: e, kin: e, kitadaito: e, kitanakagusuku: e, kumejima: e, kunigami: e, minamidaito: e, motobu: e, nago: e, naha: e, nakagusuku: e, nakijin: e, nanjo: e, nishihara: e, ogimi: e, okinawa: e, onna: e, shimoji: e, taketomi: e, tarama: e, tokashiki: e, tomigusuku: e, tonaki: e, urasoe: e, uruma: e, yaese: e, yomitan: e, yonabaru: e, yonaguni: e, zamami: e }], osaka: [1, { abeno: e, chihayaakasaka: e, chuo: e, daito: e, fujiidera: e, habikino: e, hannan: e, higashiosaka: e, higashisumiyoshi: e, higashiyodogawa: e, hirakata: e, ibaraki: e, ikeda: e, izumi: e, izumiotsu: e, izumisano: e, kadoma: e, kaizuka: e, kanan: e, kashiwara: e, katano: e, kawachinagano: e, kishiwada: e, kita: e, kumatori: e, matsubara: e, minato: e, minoh: e, misaki: e, moriguchi: e, neyagawa: e, nishi: e, nose: e, osakasayama: e, sakai: e, sayama: e, sennan: e, settsu: e, shijonawate: e, shimamoto: e, suita: e, tadaoka: e, taishi: e, tajiri: e, takaishi: e, takatsuki: e, tondabayashi: e, toyonaka: e, toyono: e, yao: e }], saga: [1, { ariake: e, arita: e, fukudomi: e, genkai: e, hamatama: e, hizen: e, imari: e, kamimine: e, kanzaki: e, karatsu: e, kashima: e, kitagata: e, kitahata: e, kiyama: e, kouhoku: e, kyuragi: e, nishiarita: e, ogi: e, omachi: e, ouchi: e, saga: e, shiroishi: e, taku: e, tara: e, tosu: e, yoshinogari: e }], saitama: [1, { arakawa: e, asaka: e, chichibu: e, fujimi: e, fujimino: e, fukaya: e, hanno: e, hanyu: e, hasuda: e, hatogaya: e, hatoyama: e, hidaka: e, higashichichibu: e, higashimatsuyama: e, honjo: e, ina: e, iruma: e, iwatsuki: e, kamiizumi: e, kamikawa: e, kamisato: e, kasukabe: e, kawagoe: e, kawaguchi: e, kawajima: e, kazo: e, kitamoto: e, koshigaya: e, kounosu: e, kuki: e, kumagaya: e, matsubushi: e, minano: e, misato: e, miyashiro: e, miyoshi: e, moroyama: e, nagatoro: e, namegawa: e, niiza: e, ogano: e, ogawa: e, ogose: e, okegawa: e, omiya: e, otaki: e, ranzan: e, ryokami: e, saitama: e, sakado: e, satte: e, sayama: e, shiki: e, shiraoka: e, soka: e, sugito: e, toda: e, tokigawa: e, tokorozawa: e, tsurugashima: e, urawa: e, warabi: e, yashio: e, yokoze: e, yono: e, yorii: e, yoshida: e, yoshikawa: e, yoshimi: e }], shiga: [1, { aisho: e, gamo: e, higashiomi: e, hikone: e, koka: e, konan: e, kosei: e, koto: e, kusatsu: e, maibara: e, moriyama: e, nagahama: e, nishiazai: e, notogawa: e, omihachiman: e, otsu: e, ritto: e, ryuoh: e, takashima: e, takatsuki: e, torahime: e, toyosato: e, yasu: e }], shimane: [1, { akagi: e, ama: e, gotsu: e, hamada: e, higashiizumo: e, hikawa: e, hikimi: e, izumo: e, kakinoki: e, masuda: e, matsue: e, misato: e, nishinoshima: e, ohda: e, okinoshima: e, okuizumo: e, shimane: e, tamayu: e, tsuwano: e, unnan: e, yakumo: e, yasugi: e, yatsuka: e }], shizuoka: [1, { arai: e, atami: e, fuji: e, fujieda: e, fujikawa: e, fujinomiya: e, fukuroi: e, gotemba: e, haibara: e, hamamatsu: e, higashiizu: e, ito: e, iwata: e, izu: e, izunokuni: e, kakegawa: e, kannami: e, kawanehon: e, kawazu: e, kikugawa: e, kosai: e, makinohara: e, matsuzaki: e, minamiizu: e, mishima: e, morimachi: e, nishiizu: e, numazu: e, omaezaki: e, shimada: e, shimizu: e, shimoda: e, shizuoka: e, susono: e, yaizu: e, yoshida: e }], tochigi: [1, { ashikaga: e, bato: e, haga: e, ichikai: e, iwafune: e, kaminokawa: e, kanuma: e, karasuyama: e, kuroiso: e, mashiko: e, mibu: e, moka: e, motegi: e, nasu: e, nasushiobara: e, nikko: e, nishikata: e, nogi: e, ohira: e, ohtawara: e, oyama: e, sakura: e, sano: e, shimotsuke: e, shioya: e, takanezawa: e, tochigi: e, tsuga: e, ujiie: e, utsunomiya: e, yaita: e }], tokushima: [1, { aizumi: e, anan: e, ichiba: e, itano: e, kainan: e, komatsushima: e, matsushige: e, mima: e, minami: e, miyoshi: e, mugi: e, nakagawa: e, naruto: e, sanagochi: e, shishikui: e, tokushima: e, wajiki: e }], tokyo: [1, { adachi: e, akiruno: e, akishima: e, aogashima: e, arakawa: e, bunkyo: e, chiyoda: e, chofu: e, chuo: e, edogawa: e, fuchu: e, fussa: e, hachijo: e, hachioji: e, hamura: e, higashikurume: e, higashimurayama: e, higashiyamato: e, hino: e, hinode: e, hinohara: e, inagi: e, itabashi: e, katsushika: e, kita: e, kiyose: e, kodaira: e, koganei: e, kokubunji: e, komae: e, koto: e, kouzushima: e, kunitachi: e, machida: e, meguro: e, minato: e, mitaka: e, mizuho: e, musashimurayama: e, musashino: e, nakano: e, nerima: e, ogasawara: e, okutama: e, ome: e, oshima: e, ota: e, setagaya: e, shibuya: e, shinagawa: e, shinjuku: e, suginami: e, sumida: e, tachikawa: e, taito: e, tama: e, toshima: e }], tottori: [1, { chizu: e, hino: e, kawahara: e, koge: e, kotoura: e, misasa: e, nanbu: e, nichinan: e, sakaiminato: e, tottori: e, wakasa: e, yazu: e, yonago: e }], toyama: [1, { asahi: e, fuchu: e, fukumitsu: e, funahashi: e, himi: e, imizu: e, inami: e, johana: e, kamiichi: e, kurobe: e, nakaniikawa: e, namerikawa: e, nanto: e, nyuzen: e, oyabe: e, taira: e, takaoka: e, tateyama: e, toga: e, tonami: e, toyama: e, unazuki: e, uozu: e, yamada: e }], wakayama: [1, { arida: e, aridagawa: e, gobo: e, hashimoto: e, hidaka: e, hirogawa: e, inami: e, iwade: e, kainan: e, kamitonda: e, katsuragi: e, kimino: e, kinokawa: e, kitayama: e, koya: e, koza: e, kozagawa: e, kudoyama: e, kushimoto: e, mihama: e, misato: e, nachikatsuura: e, shingu: e, shirahama: e, taiji: e, tanabe: e, wakayama: e, yuasa: e, yura: e }], yamagata: [1, { asahi: e, funagata: e, higashine: e, iide: e, kahoku: e, kaminoyama: e, kaneyama: e, kawanishi: e, mamurogawa: e, mikawa: e, murayama: e, nagai: e, nakayama: e, nanyo: e, nishikawa: e, obanazawa: e, oe: e, oguni: e, ohkura: e, oishida: e, sagae: e, sakata: e, sakegawa: e, shinjo: e, shirataka: e, shonai: e, takahata: e, tendo: e, tozawa: e, tsuruoka: e, yamagata: e, yamanobe: e, yonezawa: e, yuza: e }], yamaguchi: [1, { abu: e, hagi: e, hikari: e, hofu: e, iwakuni: e, kudamatsu: e, mitou: e, nagato: e, oshima: e, shimonoseki: e, shunan: e, tabuse: e, tokuyama: e, toyota: e, ube: e, yuu: e }], yamanashi: [1, { chuo: e, doshi: e, fuefuki: e, fujikawa: e, fujikawaguchiko: e, fujiyoshida: e, hayakawa: e, hokuto: e, ichikawamisato: e, kai: e, kofu: e, koshu: e, kosuge: e, "minami-alps": e, minobu: e, nakamichi: e, nanbu: e, narusawa: e, nirasaki: e, nishikatsura: e, oshino: e, otsuki: e, showa: e, tabayama: e, tsuru: e, uenohara: e, yamanakako: e, yamanashi: e }], "xn--ehqz56n": e, 三重: e, "xn--1lqs03n": e, 京都: e, "xn--qqqt11m": e, 佐賀: e, "xn--f6qx53a": e, 兵庫: e, "xn--djrs72d6uy": e, 北海道: e, "xn--mkru45i": e, 千葉: e, "xn--0trq7p7nn": e, 和歌山: e, "xn--5js045d": e, 埼玉: e, "xn--kbrq7o": e, 大分: e, "xn--pssu33l": e, 大阪: e, "xn--ntsq17g": e, 奈良: e, "xn--uisz3g": e, 宮城: e, "xn--6btw5a": e, 宮崎: e, "xn--1ctwo": e, 富山: e, "xn--6orx2r": e, 山口: e, "xn--rht61e": e, 山形: e, "xn--rht27z": e, 山梨: e, "xn--nit225k": e, 岐阜: e, "xn--rht3d": e, 岡山: e, "xn--djty4k": e, 岩手: e, "xn--klty5x": e, 島根: e, "xn--kltx9a": e, 広島: e, "xn--kltp7d": e, 徳島: e, "xn--c3s14m": e, 愛媛: e, "xn--vgu402c": e, 愛知: e, "xn--efvn9s": e, 新潟: e, "xn--1lqs71d": e, 東京: e, "xn--4pvxs": e, 栃木: e, "xn--uuwu58a": e, 沖縄: e, "xn--zbx025d": e, 滋賀: e, "xn--8pvr4u": e, 熊本: e, "xn--5rtp49c": e, 石川: e, "xn--ntso0iqx3a": e, 神奈川: e, "xn--elqq16h": e, 福井: e, "xn--4it168d": e, 福岡: e, "xn--klt787d": e, 福島: e, "xn--rny31h": e, 秋田: e, "xn--7t0a264c": e, 群馬: e, "xn--uist22h": e, 茨城: e, "xn--8ltr62k": e, 長崎: e, "xn--2m4a15e": e, 長野: e, "xn--32vp30h": e, 青森: e, "xn--4it797k": e, 静岡: e, "xn--5rtq34k": e, 香川: e, "xn--k7yn95e": e, 高知: e, "xn--tor131o": e, 鳥取: e, "xn--d5qv7z876c": e, 鹿児島: e, kawasaki: _, kitakyushu: _, kobe: _, nagoya: _, sapporo: _, sendai: _, yokohama: _, buyshop: t, fashionstore: t, handcrafted: t, kawaiishop: t, supersale: t, theshop: t, "0am": t, "0g0": t, "0j0": t, "0t0": t, mydns: t, pgw: t, wjg: t, usercontent: t, angry: t, babyblue: t, babymilk: t, backdrop: t, bambina: t, bitter: t, blush: t, boo: t, boy: t, boyfriend: t, but: t, candypop: t, capoo: t, catfood: t, cheap: t, chicappa: t, chillout: t, chips: t, chowder: t, chu: t, ciao: t, cocotte: t, coolblog: t, cranky: t, cutegirl: t, daa: t, deca: t, deci: t, digick: t, egoism: t, fakefur: t, fem: t, flier: t, floppy: t, fool: t, frenchkiss: t, girlfriend: t, girly: t, gloomy: t, gonna: t, greater: t, hacca: t, heavy: t, her: t, hiho: t, hippy: t, holy: t, hungry: t, icurus: t, itigo: t, jellybean: t, kikirara: t, kill: t, kilo: t, kuron: t, littlestar: t, lolipopmc: t, lolitapunk: t, lomo: t, lovepop: t, lovesick: t, main: t, mods: t, mond: t, mongolian: t, moo: t, namaste: t, nikita: t, nobushi: t, noor: t, oops: t, parallel: t, parasite: t, pecori: t, peewee: t, penne: t, pepper: t, perma: t, pigboat: t, pinoko: t, punyu: t, pupu: t, pussycat: t, pya: t, raindrop: t, readymade: t, sadist: t, schoolbus: t, secret: t, staba: t, stripper: t, sub: t, sunnyday: t, thick: t, tonkotsu: t, under: t, upper: t, velvet: t, verse: t, versus: t, vivian: t, watson: t, weblike: t, whitesnow: t, zombie: t, hateblo: t, hatenablog: t, hatenadiary: t, "2-d": t, bona: t, crap: t, daynight: t, eek: t, flop: t, halfmoon: t, jeez: t, matrix: t, mimoza: t, netgamers: t, nyanta: t, o0o0: t, rdy: t, rgr: t, rulez: t, sakurastorage: [0, { isk01: Fa, isk02: Fa }], saloon: t, sblo: t, skr: t, tank: t, "uh-oh": t, undo: t, webaccel: [0, { rs: t, user: t }], websozai: t, xii: t }], ke: [1, { ac: e, co: e, go: e, info: e, me: e, mobi: e, ne: e, or: e, sc: e }], kg: [1, { com: e, edu: e, gov: e, mil: e, net: e, org: e, us: t, xx: t }], kh: _, ki: $t, km: [1, { ass: e, com: e, edu: e, gov: e, mil: e, nom: e, org: e, prd: e, tm: e, asso: e, coop: e, gouv: e, medecin: e, notaires: e, pharmaciens: e, presse: e, veterinaire: e }], kn: [1, { edu: e, gov: e, net: e, org: e }], kp: [1, { com: e, edu: e, gov: e, org: e, rep: e, tra: e }], kr: [1, { ac: e, ai: e, co: e, es: e, go: e, hs: e, io: e, it: e, kg: e, me: e, mil: e, ms: e, ne: e, or: e, pe: e, re: e, sc: e, busan: e, chungbuk: e, chungnam: e, daegu: e, daejeon: e, gangwon: e, gwangju: e, gyeongbuk: e, gyeonggi: e, gyeongnam: e, incheon: e, jeju: e, jeonbuk: e, jeonnam: e, seoul: e, ulsan: e, c01: t, "eliv-cdn": t, "eliv-dns": t, mmv: t, vki: t }], kw: [1, { com: e, edu: e, emb: e, gov: e, ind: e, net: e, org: e }], ky: Q, kz: [1, { com: e, edu: e, gov: e, mil: e, net: e, org: e, jcloud: t }], la: [1, { com: e, edu: e, gov: e, info: e, int: e, net: e, org: e, per: e, bnr: t }], lb: a, lc: [1, { co: e, com: e, edu: e, gov: e, net: e, org: e, oy: t }], li: e, lk: [1, { ac: e, assn: e, com: e, edu: e, gov: e, grp: e, hotel: e, int: e, ltd: e, net: e, ngo: e, org: e, sch: e, soc: e, web: e }], lr: a, ls: [1, { ac: e, biz: e, co: e, edu: e, gov: e, info: e, net: e, org: e, sc: e }], lt: l, lu: [1, { "123website": t }], lv: [1, { asn: e, com: e, conf: e, edu: e, gov: e, id: e, mil: e, net: e, org: e }], ly: [1, { com: e, edu: e, gov: e, id: e, med: e, net: e, org: e, plc: e, sch: e }], ma: [1, { ac: e, co: e, gov: e, net: e, org: e, press: e }], mc: [1, { asso: e, tm: e }], md: [1, { ir: t }], me: [1, { ac: e, co: e, edu: e, gov: e, its: e, net: e, org: e, priv: e, c66: t, craft: t, edgestack: t, filegear: t, "filegear-sg": t, lohmus: t, barsy: t, mcdir: t, brasilia: t, ddns: t, dnsfor: t, hopto: t, loginto: t, noip: t, webhop: t, soundcast: t, tcp4: t, vp4: t, diskstation: t, dscloud: t, i234: t, myds: t, synology: t, transip: Y, nohost: t }], mg: [1, { co: e, com: e, edu: e, gov: e, mil: e, nom: e, org: e, prd: e }], mh: e, mil: e, mk: [1, { com: e, edu: e, gov: e, inf: e, name: e, net: e, org: e }], ml: [1, { ac: e, art: e, asso: e, com: e, edu: e, gouv: e, gov: e, info: e, inst: e, net: e, org: e, pr: e, presse: e }], mm: _, mn: [1, { edu: e, gov: e, org: e, nyc: t }], mo: a, mobi: [1, { barsy: t, dscloud: t }], mp: [1, { ju: t }], mq: e, mr: l, ms: [1, { com: e, edu: e, gov: e, net: e, org: e, minisite: t }], mt: Q, mu: [1, { ac: e, co: e, com: e, gov: e, net: e, or: e, org: e }], museum: e, mv: [1, { aero: e, biz: e, com: e, coop: e, edu: e, gov: e, info: e, int: e, mil: e, museum: e, name: e, net: e, org: e, pro: e }], mw: [1, { ac: e, biz: e, co: e, com: e, coop: e, edu: e, gov: e, int: e, net: e, org: e }], mx: [1, { com: e, edu: e, gob: e, net: e, org: e }], my: [1, { biz: e, com: e, edu: e, gov: e, mil: e, name: e, net: e, org: e }], mz: [1, { ac: e, adv: e, co: e, edu: e, gov: e, mil: e, net: e, org: e }], na: [1, { alt: e, co: e, com: e, gov: e, net: e, org: e }], name: [1, { her: Va, his: Va }], nc: [1, { asso: e, nom: e }], ne: e, net: [1, { adobeaemcloud: t, "adobeio-static": t, adobeioruntime: t, akadns: t, akamai: t, "akamai-staging": t, akamaiedge: t, "akamaiedge-staging": t, akamaihd: t, "akamaihd-staging": t, akamaiorigin: t, "akamaiorigin-staging": t, akamaized: t, "akamaized-staging": t, edgekey: t, "edgekey-staging": t, edgesuite: t, "edgesuite-staging": t, alwaysdata: t, myamaze: t, cloudfront: t, appudo: t, "atlassian-dev": [0, { prod: Ve }], myfritz: t, onavstack: t, shopselect: t, blackbaudcdn: t, boomla: t, bplaced: t, square7: t, cdn77: [0, { r: t }], "cdn77-ssl": t, gb: t, hu: t, jp: t, se: t, uk: t, clickrising: t, "ddns-ip": t, "dns-cloud": t, "dns-dynamic": t, cloudaccess: t, cloudflare: [2, { cdn: t }], cloudflareanycast: Ve, cloudflarecn: Ve, cloudflareglobal: Ve, ctfcloud: t, "feste-ip": t, "knx-server": t, "static-access": t, cryptonomic: n, dattolocal: t, mydatto: t, debian: t, definima: t, deno: t, icp: n, "at-band-camp": t, blogdns: t, "broke-it": t, buyshouses: t, dnsalias: t, dnsdojo: t, "does-it": t, dontexist: t, dynalias: t, dynathome: t, endofinternet: t, "from-az": t, "from-co": t, "from-la": t, "from-ny": t, "gets-it": t, "ham-radio-op": t, homeftp: t, homeip: t, homelinux: t, homeunix: t, "in-the-band": t, "is-a-chef": t, "is-a-geek": t, "isa-geek": t, "kicks-ass": t, "office-on-the": t, podzone: t, "scrapper-site": t, selfip: t, "sells-it": t, servebbs: t, serveftp: t, thruhere: t, webhop: t, casacam: t, dynu: t, dynv6: t, twmail: t, ru: t, channelsdvr: [2, { u: t }], fastly: [0, { freetls: t, map: t, prod: [0, { a: t, global: t }], ssl: [0, { a: t, b: t, global: t }] }], fastlylb: [2, { map: t }], edgeapp: t, "keyword-on": t, "live-on": t, "server-on": t, "cdn-edges": t, heteml: t, cloudfunctions: t, "grafana-dev": t, iobb: t, moonscale: t, "in-dsl": t, "in-vpn": t, oninferno: t, botdash: t, "apps-1and1": t, ipifony: t, cloudjiffy: [2, { "fra1-de": t, "west1-us": t }], elastx: [0, { "jls-sto1": t, "jls-sto2": t, "jls-sto3": t }], massivegrid: [0, { paas: [0, { "fr-1": t, "lon-1": t, "lon-2": t, "ny-1": t, "ny-2": t, "sg-1": t }] }], saveincloud: [0, { jelastic: t, "nordeste-idc": t }], scaleforce: J, kinghost: t, uni5: t, krellian: t, ggff: t, localcert: t, localto: n, barsy: t, luyani: t, memset: t, "azure-api": t, "azure-mobile": t, azureedge: t, azurefd: t, azurestaticapps: [2, { 1: t, 2: t, 3: t, 4: t, 5: t, 6: t, 7: t, centralus: t, eastasia: t, eastus2: t, westeurope: t, westus2: t }], azurewebsites: t, cloudapp: t, trafficmanager: t, windows: [0, { core: [0, { blob: t }], servicebus: t }], mynetname: [0, { sn: t }], routingthecloud: t, bounceme: t, ddns: t, "eating-organic": t, mydissent: t, myeffect: t, mymediapc: t, mypsx: t, mysecuritycamera: t, nhlfan: t, "no-ip": t, pgafan: t, privatizehealthinsurance: t, redirectme: t, serveblog: t, serveminecraft: t, sytes: t, dnsup: t, hicam: t, "now-dns": t, ownip: t, vpndns: t, cloudycluster: t, ovh: [0, { hosting: n, webpaas: n }], rackmaze: t, myradweb: t, in: t, "subsc-pay": t, squares: t, schokokeks: t, "firewall-gateway": t, seidat: t, senseering: t, siteleaf: t, mafelo: t, myspreadshop: t, "vps-host": [2, { jelastic: [0, { atl: t, njs: t, ric: t }] }], srcf: [0, { soc: t, user: t }], supabase: t, dsmynas: t, familyds: t, ts: [2, { c: n }], torproject: [2, { pages: t }], vusercontent: t, "reserve-online": t, "community-pro": t, meinforum: t, yandexcloud: [2, { storage: t, website: t }], za: t, zabc: t }], nf: [1, { arts: e, com: e, firm: e, info: e, net: e, other: e, per: e, rec: e, store: e, web: e }], ng: [1, { com: e, edu: e, gov: e, i: e, mil: e, mobi: e, name: e, net: e, org: e, sch: e, biz: [2, { co: t, dl: t, go: t, lg: t, on: t }], col: t, firm: t, gen: t, ltd: t, ngo: t, plc: t }], ni: [1, { ac: e, biz: e, co: e, com: e, edu: e, gob: e, in: e, info: e, int: e, mil: e, net: e, nom: e, org: e, web: e }], nl: [1, { co: t, "hosting-cluster": t, gov: t, khplay: t, "123website": t, myspreadshop: t, transurl: n, cistron: t, demon: t }], no: [1, { fhs: e, folkebibl: e, fylkesbibl: e, idrett: e, museum: e, priv: e, vgs: e, dep: e, herad: e, kommune: e, mil: e, stat: e, aa: we, ah: we, bu: we, fm: we, hl: we, hm: we, "jan-mayen": we, mr: we, nl: we, nt: we, of: we, ol: we, oslo: we, rl: we, sf: we, st: we, svalbard: we, tm: we, tr: we, va: we, vf: we, akrehamn: e, "xn--krehamn-dxa": e, åkrehamn: e, algard: e, "xn--lgrd-poac": e, ålgård: e, arna: e, bronnoysund: e, "xn--brnnysund-m8ac": e, brønnøysund: e, brumunddal: e, bryne: e, drobak: e, "xn--drbak-wua": e, drøbak: e, egersund: e, fetsund: e, floro: e, "xn--flor-jra": e, florø: e, fredrikstad: e, hokksund: e, honefoss: e, "xn--hnefoss-q1a": e, hønefoss: e, jessheim: e, jorpeland: e, "xn--jrpeland-54a": e, jørpeland: e, kirkenes: e, kopervik: e, krokstadelva: e, langevag: e, "xn--langevg-jxa": e, langevåg: e, leirvik: e, mjondalen: e, "xn--mjndalen-64a": e, mjøndalen: e, "mo-i-rana": e, mosjoen: e, "xn--mosjen-eya": e, mosjøen: e, nesoddtangen: e, orkanger: e, osoyro: e, "xn--osyro-wua": e, osøyro: e, raholt: e, "xn--rholt-mra": e, råholt: e, sandnessjoen: e, "xn--sandnessjen-ogb": e, sandnessjøen: e, skedsmokorset: e, slattum: e, spjelkavik: e, stathelle: e, stavern: e, stjordalshalsen: e, "xn--stjrdalshalsen-sqb": e, stjørdalshalsen: e, tananger: e, tranby: e, vossevangen: e, aarborte: e, aejrie: e, afjord: e, "xn--fjord-lra": e, åfjord: e, agdenes: e, akershus: bt, aknoluokta: e, "xn--koluokta-7ya57h": e, ákŋoluokta: e, al: e, "xn--l-1fa": e, ål: e, alaheadju: e, "xn--laheadju-7ya": e, álaheadju: e, alesund: e, "xn--lesund-hua": e, ålesund: e, alstahaug: e, alta: e, "xn--lt-liac": e, áltá: e, alvdal: e, amli: e, "xn--mli-tla": e, åmli: e, amot: e, "xn--mot-tla": e, åmot: e, andasuolo: e, andebu: e, andoy: e, "xn--andy-ira": e, andøy: e, ardal: e, "xn--rdal-poa": e, årdal: e, aremark: e, arendal: e, "xn--s-1fa": e, ås: e, aseral: e, "xn--seral-lra": e, åseral: e, asker: e, askim: e, askoy: e, "xn--asky-ira": e, askøy: e, askvoll: e, asnes: e, "xn--snes-poa": e, åsnes: e, audnedaln: e, aukra: e, aure: e, aurland: e, "aurskog-holand": e, "xn--aurskog-hland-jnb": e, "aurskog-høland": e, austevoll: e, austrheim: e, averoy: e, "xn--avery-yua": e, averøy: e, badaddja: e, "xn--bdddj-mrabd": e, bådåddjå: e, "xn--brum-voa": e, bærum: e, bahcavuotna: e, "xn--bhcavuotna-s4a": e, báhcavuotna: e, bahccavuotna: e, "xn--bhccavuotna-k7a": e, báhccavuotna: e, baidar: e, "xn--bidr-5nac": e, báidár: e, bajddar: e, "xn--bjddar-pta": e, bájddar: e, balat: e, "xn--blt-elab": e, bálát: e, balestrand: e, ballangen: e, balsfjord: e, bamble: e, bardu: e, barum: e, batsfjord: e, "xn--btsfjord-9za": e, båtsfjord: e, bearalvahki: e, "xn--bearalvhki-y4a": e, bearalváhki: e, beardu: e, beiarn: e, berg: e, bergen: e, berlevag: e, "xn--berlevg-jxa": e, berlevåg: e, bievat: e, "xn--bievt-0qa": e, bievát: e, bindal: e, birkenes: e, bjarkoy: e, "xn--bjarky-fya": e, bjarkøy: e, bjerkreim: e, bjugn: e, bodo: e, "xn--bod-2na": e, bodø: e, bokn: e, bomlo: e, "xn--bmlo-gra": e, bømlo: e, bremanger: e, bronnoy: e, "xn--brnny-wuac": e, brønnøy: e, budejju: e, buskerud: bt, bygland: e, bykle: e, cahcesuolo: e, "xn--hcesuolo-7ya35b": e, čáhcesuolo: e, davvenjarga: e, "xn--davvenjrga-y4a": e, davvenjárga: e, davvesiida: e, deatnu: e, dielddanuorri: e, divtasvuodna: e, divttasvuotna: e, donna: e, "xn--dnna-gra": e, dønna: e, dovre: e, drammen: e, drangedal: e, dyroy: e, "xn--dyry-ira": e, dyrøy: e, eid: e, eidfjord: e, eidsberg: e, eidskog: e, eidsvoll: e, eigersund: e, elverum: e, enebakk: e, engerdal: e, etne: e, etnedal: e, evenassi: e, "xn--eveni-0qa01ga": e, evenášši: e, evenes: e, "evje-og-hornnes": e, farsund: e, fauske: e, fedje: e, fet: e, finnoy: e, "xn--finny-yua": e, finnøy: e, fitjar: e, fjaler: e, fjell: e, fla: e, "xn--fl-zia": e, flå: e, flakstad: e, flatanger: e, flekkefjord: e, flesberg: e, flora: e, folldal: e, forde: e, "xn--frde-gra": e, førde: e, forsand: e, fosnes: e, "xn--frna-woa": e, fræna: e, frana: e, frei: e, frogn: e, froland: e, frosta: e, froya: e, "xn--frya-hra": e, frøya: e, fuoisku: e, fuossko: e, fusa: e, fyresdal: e, gaivuotna: e, "xn--givuotna-8ya": e, gáivuotna: e, galsa: e, "xn--gls-elac": e, gálsá: e, gamvik: e, gangaviika: e, "xn--ggaviika-8ya47h": e, gáŋgaviika: e, gaular: e, gausdal: e, giehtavuoatna: e, gildeskal: e, "xn--gildeskl-g0a": e, gildeskål: e, giske: e, gjemnes: e, gjerdrum: e, gjerstad: e, gjesdal: e, gjovik: e, "xn--gjvik-wua": e, gjøvik: e, gloppen: e, gol: e, gran: e, grane: e, granvin: e, gratangen: e, grimstad: e, grong: e, grue: e, gulen: e, guovdageaidnu: e, ha: e, "xn--h-2fa": e, hå: e, habmer: e, "xn--hbmer-xqa": e, hábmer: e, hadsel: e, "xn--hgebostad-g3a": e, hægebostad: e, hagebostad: e, halden: e, halsa: e, hamar: e, hamaroy: e, hammarfeasta: e, "xn--hmmrfeasta-s4ac": e, hámmárfeasta: e, hammerfest: e, hapmir: e, "xn--hpmir-xqa": e, hápmir: e, haram: e, hareid: e, harstad: e, hasvik: e, hattfjelldal: e, haugesund: e, hedmark: [0, { os: e, valer: e, "xn--vler-qoa": e, våler: e }], hemne: e, hemnes: e, hemsedal: e, hitra: e, hjartdal: e, hjelmeland: e, hobol: e, "xn--hobl-ira": e, hobøl: e, hof: e, hol: e, hole: e, holmestrand: e, holtalen: e, "xn--holtlen-hxa": e, holtålen: e, hordaland: [0, { os: e }], hornindal: e, horten: e, hoyanger: e, "xn--hyanger-q1a": e, høyanger: e, hoylandet: e, "xn--hylandet-54a": e, høylandet: e, hurdal: e, hurum: e, hvaler: e, hyllestad: e, ibestad: e, inderoy: e, "xn--indery-fya": e, inderøy: e, iveland: e, ivgu: e, jevnaker: e, jolster: e, "xn--jlster-bya": e, jølster: e, jondal: e, kafjord: e, "xn--kfjord-iua": e, kåfjord: e, karasjohka: e, "xn--krjohka-hwab49j": e, kárášjohka: e, karasjok: e, karlsoy: e, karmoy: e, "xn--karmy-yua": e, karmøy: e, kautokeino: e, klabu: e, "xn--klbu-woa": e, klæbu: e, klepp: e, kongsberg: e, kongsvinger: e, kraanghke: e, "xn--kranghke-b0a": e, kråanghke: e, kragero: e, "xn--krager-gya": e, kragerø: e, kristiansand: e, kristiansund: e, krodsherad: e, "xn--krdsherad-m8a": e, krødsherad: e, "xn--kvfjord-nxa": e, kvæfjord: e, "xn--kvnangen-k0a": e, kvænangen: e, kvafjord: e, kvalsund: e, kvam: e, kvanangen: e, kvinesdal: e, kvinnherad: e, kviteseid: e, kvitsoy: e, "xn--kvitsy-fya": e, kvitsøy: e, laakesvuemie: e, "xn--lrdal-sra": e, lærdal: e, lahppi: e, "xn--lhppi-xqa": e, láhppi: e, lardal: e, larvik: e, lavagis: e, lavangen: e, leangaviika: e, "xn--leagaviika-52b": e, leaŋgaviika: e, lebesby: e, leikanger: e, leirfjord: e, leka: e, leksvik: e, lenvik: e, lerdal: e, lesja: e, levanger: e, lier: e, lierne: e, lillehammer: e, lillesand: e, lindas: e, "xn--linds-pra": e, lindås: e, lindesnes: e, loabat: e, "xn--loabt-0qa": e, loabát: e, lodingen: e, "xn--ldingen-q1a": e, lødingen: e, lom: e, loppa: e, lorenskog: e, "xn--lrenskog-54a": e, lørenskog: e, loten: e, "xn--lten-gra": e, løten: e, lund: e, lunner: e, luroy: e, "xn--lury-ira": e, lurøy: e, luster: e, lyngdal: e, lyngen: e, malatvuopmi: e, "xn--mlatvuopmi-s4a": e, málatvuopmi: e, malselv: e, "xn--mlselv-iua": e, målselv: e, malvik: e, mandal: e, marker: e, marnardal: e, masfjorden: e, masoy: e, "xn--msy-ula0h": e, måsøy: e, "matta-varjjat": e, "xn--mtta-vrjjat-k7af": e, "mátta-várjjat": e, meland: e, meldal: e, melhus: e, meloy: e, "xn--mely-ira": e, meløy: e, meraker: e, "xn--merker-kua": e, meråker: e, midsund: e, "midtre-gauldal": e, moareke: e, "xn--moreke-jua": e, moåreke: e, modalen: e, modum: e, molde: e, "more-og-romsdal": [0, { heroy: e, sande: e }], "xn--mre-og-romsdal-qqb": [0, { "xn--hery-ira": e, sande: e }], "møre-og-romsdal": [0, { herøy: e, sande: e }], moskenes: e, moss: e, mosvik: e, muosat: e, "xn--muost-0qa": e, muosát: e, naamesjevuemie: e, "xn--nmesjevuemie-tcba": e, nååmesjevuemie: e, "xn--nry-yla5g": e, nærøy: e, namdalseid: e, namsos: e, namsskogan: e, nannestad: e, naroy: e, narviika: e, narvik: e, naustdal: e, navuotna: e, "xn--nvuotna-hwa": e, návuotna: e, "nedre-eiker": e, nesna: e, nesodden: e, nesseby: e, nesset: e, nissedal: e, nittedal: e, "nord-aurdal": e, "nord-fron": e, "nord-odal": e, norddal: e, nordkapp: e, nordland: [0, { bo: e, "xn--b-5ga": e, bø: e, heroy: e, "xn--hery-ira": e, herøy: e }], "nordre-land": e, nordreisa: e, "nore-og-uvdal": e, notodden: e, notteroy: e, "xn--nttery-byae": e, nøtterøy: e, odda: e, oksnes: e, "xn--ksnes-uua": e, øksnes: e, omasvuotna: e, oppdal: e, oppegard: e, "xn--oppegrd-ixa": e, oppegård: e, orkdal: e, orland: e, "xn--rland-uua": e, ørland: e, orskog: e, "xn--rskog-uua": e, ørskog: e, orsta: e, "xn--rsta-fra": e, ørsta: e, osen: e, osteroy: e, "xn--ostery-fya": e, osterøy: e, ostfold: [0, { valer: e }], "xn--stfold-9xa": [0, { "xn--vler-qoa": e }], østfold: [0, { våler: e }], "ostre-toten": e, "xn--stre-toten-zcb": e, "østre-toten": e, overhalla: e, "ovre-eiker": e, "xn--vre-eiker-k8a": e, "øvre-eiker": e, oyer: e, "xn--yer-zna": e, øyer: e, oygarden: e, "xn--ygarden-p1a": e, øygarden: e, "oystre-slidre": e, "xn--ystre-slidre-ujb": e, "øystre-slidre": e, porsanger: e, porsangu: e, "xn--porsgu-sta26f": e, porsáŋgu: e, porsgrunn: e, rade: e, "xn--rde-ula": e, råde: e, radoy: e, "xn--rady-ira": e, radøy: e, "xn--rlingen-mxa": e, rælingen: e, rahkkeravju: e, "xn--rhkkervju-01af": e, ráhkkerávju: e, raisa: e, "xn--risa-5na": e, ráisa: e, rakkestad: e, ralingen: e, rana: e, randaberg: e, rauma: e, rendalen: e, rennebu: e, rennesoy: e, "xn--rennesy-v1a": e, rennesøy: e, rindal: e, ringebu: e, ringerike: e, ringsaker: e, risor: e, "xn--risr-ira": e, risør: e, rissa: e, roan: e, rodoy: e, "xn--rdy-0nab": e, rødøy: e, rollag: e, romsa: e, romskog: e, "xn--rmskog-bya": e, rømskog: e, roros: e, "xn--rros-gra": e, røros: e, rost: e, "xn--rst-0na": e, røst: e, royken: e, "xn--ryken-vua": e, røyken: e, royrvik: e, "xn--ryrvik-bya": e, røyrvik: e, ruovat: e, rygge: e, salangen: e, salat: e, "xn--slat-5na": e, sálat: e, "xn--slt-elab": e, sálát: e, saltdal: e, samnanger: e, sandefjord: e, sandnes: e, sandoy: e, "xn--sandy-yua": e, sandøy: e, sarpsborg: e, sauda: e, sauherad: e, sel: e, selbu: e, selje: e, seljord: e, siellak: e, sigdal: e, siljan: e, sirdal: e, skanit: e, "xn--sknit-yqa": e, skánit: e, skanland: e, "xn--sknland-fxa": e, skånland: e, skaun: e, skedsmo: e, ski: e, skien: e, skierva: e, "xn--skierv-uta": e, skiervá: e, skiptvet: e, skjak: e, "xn--skjk-soa": e, skjåk: e, skjervoy: e, "xn--skjervy-v1a": e, skjervøy: e, skodje: e, smola: e, "xn--smla-hra": e, smøla: e, snaase: e, "xn--snase-nra": e, snåase: e, snasa: e, "xn--snsa-roa": e, snåsa: e, snillfjord: e, snoasa: e, sogndal: e, sogne: e, "xn--sgne-gra": e, søgne: e, sokndal: e, sola: e, solund: e, somna: e, "xn--smna-gra": e, sømna: e, "sondre-land": e, "xn--sndre-land-0cb": e, "søndre-land": e, songdalen: e, "sor-aurdal": e, "xn--sr-aurdal-l8a": e, "sør-aurdal": e, "sor-fron": e, "xn--sr-fron-q1a": e, "sør-fron": e, "sor-odal": e, "xn--sr-odal-q1a": e, "sør-odal": e, "sor-varanger": e, "xn--sr-varanger-ggb": e, "sør-varanger": e, sorfold: e, "xn--srfold-bya": e, sørfold: e, sorreisa: e, "xn--srreisa-q1a": e, sørreisa: e, sortland: e, sorum: e, "xn--srum-gra": e, sørum: e, spydeberg: e, stange: e, stavanger: e, steigen: e, steinkjer: e, stjordal: e, "xn--stjrdal-s1a": e, stjørdal: e, stokke: e, "stor-elvdal": e, stord: e, stordal: e, storfjord: e, strand: e, stranda: e, stryn: e, sula: e, suldal: e, sund: e, sunndal: e, surnadal: e, sveio: e, svelvik: e, sykkylven: e, tana: e, telemark: [0, { bo: e, "xn--b-5ga": e, bø: e }], time: e, tingvoll: e, tinn: e, tjeldsund: e, tjome: e, "xn--tjme-hra": e, tjøme: e, tokke: e, tolga: e, tonsberg: e, "xn--tnsberg-q1a": e, tønsberg: e, torsken: e, "xn--trna-woa": e, træna: e, trana: e, tranoy: e, "xn--trany-yua": e, tranøy: e, troandin: e, trogstad: e, "xn--trgstad-r1a": e, trøgstad: e, tromsa: e, tromso: e, "xn--troms-zua": e, tromsø: e, trondheim: e, trysil: e, tvedestrand: e, tydal: e, tynset: e, tysfjord: e, tysnes: e, "xn--tysvr-vra": e, tysvær: e, tysvar: e, ullensaker: e, ullensvang: e, ulvik: e, unjarga: e, "xn--unjrga-rta": e, unjárga: e, utsira: e, vaapste: e, vadso: e, "xn--vads-jra": e, vadsø: e, "xn--vry-yla5g": e, værøy: e, vaga: e, "xn--vg-yiab": e, vågå: e, vagan: e, "xn--vgan-qoa": e, vågan: e, vagsoy: e, "xn--vgsy-qoa0j": e, vågsøy: e, vaksdal: e, valle: e, vang: e, vanylven: e, vardo: e, "xn--vard-jra": e, vardø: e, varggat: e, "xn--vrggt-xqad": e, várggát: e, varoy: e, vefsn: e, vega: e, vegarshei: e, "xn--vegrshei-c0a": e, vegårshei: e, vennesla: e, verdal: e, verran: e, vestby: e, vestfold: [0, { sande: e }], vestnes: e, "vestre-slidre": e, "vestre-toten": e, vestvagoy: e, "xn--vestvgy-ixa6o": e, vestvågøy: e, vevelstad: e, vik: e, vikna: e, vindafjord: e, voagat: e, volda: e, voss: e, co: t, "123hjemmeside": t, myspreadshop: t }], np: _, nr: $t, nu: [1, { merseine: t, mine: t, shacknet: t, enterprisecloud: t }], nz: [1, { ac: e, co: e, cri: e, geek: e, gen: e, govt: e, health: e, iwi: e, kiwi: e, maori: e, "xn--mori-qsa": e, māori: e, mil: e, net: e, org: e, parliament: e, school: e, cloudns: t }], om: [1, { co: e, com: e, edu: e, gov: e, med: e, museum: e, net: e, org: e, pro: e }], onion: e, org: [1, { altervista: t, pimienta: t, poivron: t, potager: t, sweetpepper: t, cdn77: [0, { c: t, rsc: t }], "cdn77-secure": [0, { origin: [0, { ssl: t }] }], ae: t, cloudns: t, "ip-dynamic": t, ddnss: t, dpdns: t, duckdns: t, tunk: t, blogdns: t, blogsite: t, boldlygoingnowhere: t, dnsalias: t, dnsdojo: t, doesntexist: t, dontexist: t, doomdns: t, dvrdns: t, dynalias: t, dyndns: [2, { go: t, home: t }], endofinternet: t, endoftheinternet: t, "from-me": t, "game-host": t, gotdns: t, "hobby-site": t, homedns: t, homeftp: t, homelinux: t, homeunix: t, "is-a-bruinsfan": t, "is-a-candidate": t, "is-a-celticsfan": t, "is-a-chef": t, "is-a-geek": t, "is-a-knight": t, "is-a-linux-user": t, "is-a-patsfan": t, "is-a-soxfan": t, "is-found": t, "is-lost": t, "is-saved": t, "is-very-bad": t, "is-very-evil": t, "is-very-good": t, "is-very-nice": t, "is-very-sweet": t, "isa-geek": t, "kicks-ass": t, misconfused: t, podzone: t, readmyblog: t, selfip: t, sellsyourhome: t, servebbs: t, serveftp: t, servegame: t, "stuff-4-sale": t, webhop: t, accesscam: t, camdvr: t, freeddns: t, mywire: t, webredirect: t, twmail: t, eu: [2, { al: t, asso: t, at: t, au: t, be: t, bg: t, ca: t, cd: t, ch: t, cn: t, cy: t, cz: t, de: t, dk: t, edu: t, ee: t, es: t, fi: t, fr: t, gr: t, hr: t, hu: t, ie: t, il: t, in: t, int: t, is: t, it: t, jp: t, kr: t, lt: t, lu: t, lv: t, me: t, mk: t, mt: t, my: t, net: t, ng: t, nl: t, no: t, nz: t, pl: t, pt: t, ro: t, ru: t, se: t, si: t, sk: t, tr: t, uk: t, us: t }], fedorainfracloud: t, fedorapeople: t, fedoraproject: [0, { cloud: t, os: M, stg: [0, { os: M }] }], freedesktop: t, hatenadiary: t, hepforge: t, "in-dsl": t, "in-vpn": t, js: t, barsy: t, mayfirst: t, routingthecloud: t, bmoattachments: t, "cable-modem": t, collegefan: t, couchpotatofries: t, hopto: t, mlbfan: t, myftp: t, mysecuritycamera: t, nflfan: t, "no-ip": t, "read-books": t, ufcfan: t, zapto: t, dynserv: t, "now-dns": t, "is-local": t, httpbin: t, pubtls: t, jpn: t, "my-firewall": t, myfirewall: t, spdns: t, "small-web": t, dsmynas: t, familyds: t, teckids: Fa, tuxfamily: t, diskstation: t, hk: t, us: t, toolforge: t, wmcloud: [2, { beta: t }], wmflabs: t, za: t }], pa: [1, { abo: e, ac: e, com: e, edu: e, gob: e, ing: e, med: e, net: e, nom: e, org: e, sld: e }], pe: [1, { com: e, edu: e, gob: e, mil: e, net: e, nom: e, org: e }], pf: [1, { com: e, edu: e, org: e }], pg: _, ph: [1, { com: e, edu: e, gov: e, i: e, mil: e, net: e, ngo: e, org: e, cloudns: t }], pk: [1, { ac: e, biz: e, com: e, edu: e, fam: e, gkp: e, gob: e, gog: e, gok: e, gop: e, gos: e, gov: e, net: e, org: e, web: e }], pl: [1, { com: e, net: e, org: e, agro: e, aid: e, atm: e, auto: e, biz: e, edu: e, gmina: e, gsm: e, info: e, mail: e, media: e, miasta: e, mil: e, nieruchomosci: e, nom: e, pc: e, powiat: e, priv: e, realestate: e, rel: e, sex: e, shop: e, sklep: e, sos: e, szkola: e, targi: e, tm: e, tourism: e, travel: e, turystyka: e, gov: [1, { ap: e, griw: e, ic: e, is: e, kmpsp: e, konsulat: e, kppsp: e, kwp: e, kwpsp: e, mup: e, mw: e, oia: e, oirm: e, oke: e, oow: e, oschr: e, oum: e, pa: e, pinb: e, piw: e, po: e, pr: e, psp: e, psse: e, pup: e, rzgw: e, sa: e, sdn: e, sko: e, so: e, sr: e, starostwo: e, ug: e, ugim: e, um: e, umig: e, upow: e, uppo: e, us: e, uw: e, uzs: e, wif: e, wiih: e, winb: e, wios: e, witd: e, wiw: e, wkz: e, wsa: e, wskr: e, wsse: e, wuoz: e, wzmiuw: e, zp: e, zpisdn: e }], augustow: e, "babia-gora": e, bedzin: e, beskidy: e, bialowieza: e, bialystok: e, bielawa: e, bieszczady: e, boleslawiec: e, bydgoszcz: e, bytom: e, cieszyn: e, czeladz: e, czest: e, dlugoleka: e, elblag: e, elk: e, glogow: e, gniezno: e, gorlice: e, grajewo: e, ilawa: e, jaworzno: e, "jelenia-gora": e, jgora: e, kalisz: e, karpacz: e, kartuzy: e, kaszuby: e, katowice: e, "kazimierz-dolny": e, kepno: e, ketrzyn: e, klodzko: e, kobierzyce: e, kolobrzeg: e, konin: e, konskowola: e, kutno: e, lapy: e, lebork: e, legnica: e, lezajsk: e, limanowa: e, lomza: e, lowicz: e, lubin: e, lukow: e, malbork: e, malopolska: e, mazowsze: e, mazury: e, mielec: e, mielno: e, mragowo: e, naklo: e, nowaruda: e, nysa: e, olawa: e, olecko: e, olkusz: e, olsztyn: e, opoczno: e, opole: e, ostroda: e, ostroleka: e, ostrowiec: e, ostrowwlkp: e, pila: e, pisz: e, podhale: e, podlasie: e, polkowice: e, pomorskie: e, pomorze: e, prochowice: e, pruszkow: e, przeworsk: e, pulawy: e, radom: e, "rawa-maz": e, rybnik: e, rzeszow: e, sanok: e, sejny: e, skoczow: e, slask: e, slupsk: e, sosnowiec: e, "stalowa-wola": e, starachowice: e, stargard: e, suwalki: e, swidnica: e, swiebodzin: e, swinoujscie: e, szczecin: e, szczytno: e, tarnobrzeg: e, tgory: e, turek: e, tychy: e, ustka: e, walbrzych: e, warmia: e, warszawa: e, waw: e, wegrow: e, wielun: e, wlocl: e, wloclawek: e, wodzislaw: e, wolomin: e, wroclaw: e, zachpomor: e, zagan: e, zarow: e, zgora: e, zgorzelec: e, art: t, gliwice: t, krakow: t, poznan: t, wroc: t, zakopane: t, beep: t, "ecommerce-shop": t, cfolks: t, dfirma: t, dkonto: t, you2: t, shoparena: t, homesklep: t, sdscloud: t, unicloud: t, lodz: t, pabianice: t, plock: t, sieradz: t, skierniewice: t, zgierz: t, krasnik: t, leczna: t, lubartow: t, lublin: t, poniatowa: t, swidnik: t, co: t, torun: t, simplesite: t, myspreadshop: t, gda: t, gdansk: t, gdynia: t, med: t, sopot: t, bielsko: t }], pm: [1, { own: t, name: t }], pn: [1, { co: e, edu: e, gov: e, net: e, org: e }], post: e, pr: [1, { biz: e, com: e, edu: e, gov: e, info: e, isla: e, name: e, net: e, org: e, pro: e, ac: e, est: e, prof: e }], pro: [1, { aaa: e, aca: e, acct: e, avocat: e, bar: e, cpa: e, eng: e, jur: e, law: e, med: e, recht: e, "12chars": t, cloudns: t, barsy: t, ngrok: t }], ps: [1, { com: e, edu: e, gov: e, net: e, org: e, plo: e, sec: e }], pt: [1, { com: e, edu: e, gov: e, int: e, net: e, nome: e, org: e, publ: e, "123paginaweb": t }], pw: [1, { gov: e, cloudns: t, x443: t }], py: [1, { com: e, coop: e, edu: e, gov: e, mil: e, net: e, org: e }], qa: [1, { com: e, edu: e, gov: e, mil: e, name: e, net: e, org: e, sch: e }], re: [1, { asso: e, com: e, netlib: t, can: t }], ro: [1, { arts: e, com: e, firm: e, info: e, nom: e, nt: e, org: e, rec: e, store: e, tm: e, www: e, co: t, shop: t, barsy: t }], rs: [1, { ac: e, co: e, edu: e, gov: e, in: e, org: e, brendly: w, barsy: t, ox: t }], ru: [1, { ac: t, edu: t, gov: t, int: t, mil: t, eurodir: t, adygeya: t, bashkiria: t, bir: t, cbg: t, com: t, dagestan: t, grozny: t, kalmykia: t, kustanai: t, marine: t, mordovia: t, msk: t, mytis: t, nalchik: t, nov: t, pyatigorsk: t, spb: t, vladikavkaz: t, vladimir: t, na4u: t, mircloud: t, myjino: [2, { hosting: n, landing: n, spectrum: n, vps: n }], cldmail: [0, { hb: t }], mcdir: c, mcpre: t, net: t, org: t, pp: t, lk3: t, ras: t }], rw: [1, { ac: e, co: e, coop: e, gov: e, mil: e, net: e, org: e }], sa: [1, { com: e, edu: e, gov: e, med: e, net: e, org: e, pub: e, sch: e }], sb: a, sc: a, sd: [1, { com: e, edu: e, gov: e, info: e, med: e, net: e, org: e, tv: e }], se: [1, { a: e, ac: e, b: e, bd: e, brand: e, c: e, d: e, e, f: e, fh: e, fhsk: e, fhv: e, g: e, h: e, i: e, k: e, komforb: e, kommunalforbund: e, komvux: e, l: e, lanbib: e, m: e, n: e, naturbruksgymn: e, o: e, org: e, p: e, parti: e, pp: e, press: e, r: e, s: e, t: e, tm: e, u: e, w: e, x: e, y: e, z: e, com: t, iopsys: t, "123minsida": t, itcouldbewor: t, myspreadshop: t }], sg: [1, { com: e, edu: e, gov: e, net: e, org: e, enscaled: t }], sh: [1, { com: e, gov: e, mil: e, net: e, org: e, hashbang: t, botda: t, lovable: t, platform: [0, { ent: t, eu: t, us: t }], now: t }], si: [1, { f5: t, gitapp: t, gitpage: t }], sj: e, sk: e, sl: a, sm: e, sn: [1, { art: e, com: e, edu: e, gouv: e, org: e, perso: e, univ: e }], so: [1, { com: e, edu: e, gov: e, me: e, net: e, org: e, surveys: t }], sr: e, ss: [1, { biz: e, co: e, com: e, edu: e, gov: e, me: e, net: e, org: e, sch: e }], st: [1, { co: e, com: e, consulado: e, edu: e, embaixada: e, mil: e, net: e, org: e, principe: e, saotome: e, store: e, helioho: t, kirara: t, noho: t }], su: [1, { abkhazia: t, adygeya: t, aktyubinsk: t, arkhangelsk: t, armenia: t, ashgabad: t, azerbaijan: t, balashov: t, bashkiria: t, bryansk: t, bukhara: t, chimkent: t, dagestan: t, "east-kazakhstan": t, exnet: t, georgia: t, grozny: t, ivanovo: t, jambyl: t, kalmykia: t, kaluga: t, karacol: t, karaganda: t, karelia: t, khakassia: t, krasnodar: t, kurgan: t, kustanai: t, lenug: t, mangyshlak: t, mordovia: t, msk: t, murmansk: t, nalchik: t, navoi: t, "north-kazakhstan": t, nov: t, obninsk: t, penza: t, pokrovsk: t, sochi: t, spb: t, tashkent: t, termez: t, togliatti: t, troitsk: t, tselinograd: t, tula: t, tuva: t, vladikavkaz: t, vladimir: t, vologda: t }], sv: [1, { com: e, edu: e, gob: e, org: e, red: e }], sx: l, sy: o, sz: [1, { ac: e, co: e, org: e }], tc: e, td: e, tel: e, tf: [1, { sch: t }], tg: e, th: [1, { ac: e, co: e, go: e, in: e, mi: e, net: e, or: e, online: t, shop: t }], tj: [1, { ac: e, biz: e, co: e, com: e, edu: e, go: e, gov: e, int: e, mil: e, name: e, net: e, nic: e, org: e, test: e, web: e }], tk: e, tl: l, tm: [1, { co: e, com: e, edu: e, gov: e, mil: e, net: e, nom: e, org: e }], tn: [1, { com: e, ens: e, fin: e, gov: e, ind: e, info: e, intl: e, mincom: e, nat: e, net: e, org: e, perso: e, tourism: e, orangecloud: t }], to: [1, { 611: t, com: e, edu: e, gov: e, mil: e, net: e, org: e, oya: t, x0: t, quickconnect: C, vpnplus: t }], tr: [1, { av: e, bbs: e, bel: e, biz: e, com: e, dr: e, edu: e, gen: e, gov: e, info: e, k12: e, kep: e, mil: e, name: e, net: e, org: e, pol: e, tel: e, tsk: e, tv: e, web: e, nc: l }], tt: [1, { biz: e, co: e, com: e, edu: e, gov: e, info: e, mil: e, name: e, net: e, org: e, pro: e }], tv: [1, { "better-than": t, dyndns: t, "on-the-web": t, "worse-than": t, from: t, sakura: t }], tw: [1, { club: e, com: [1, { mymailer: t }], ebiz: e, edu: e, game: e, gov: e, idv: e, mil: e, net: e, org: e, url: t, mydns: t }], tz: [1, { ac: e, co: e, go: e, hotel: e, info: e, me: e, mil: e, mobi: e, ne: e, or: e, sc: e, tv: e }], ua: [1, { com: e, edu: e, gov: e, in: e, net: e, org: e, cherkassy: e, cherkasy: e, chernigov: e, chernihiv: e, chernivtsi: e, chernovtsy: e, ck: e, cn: e, cr: e, crimea: e, cv: e, dn: e, dnepropetrovsk: e, dnipropetrovsk: e, donetsk: e, dp: e, if: e, "ivano-frankivsk": e, kh: e, kharkiv: e, kharkov: e, kherson: e, khmelnitskiy: e, khmelnytskyi: e, kiev: e, kirovograd: e, km: e, kr: e, kropyvnytskyi: e, krym: e, ks: e, kv: e, kyiv: e, lg: e, lt: e, lugansk: e, luhansk: e, lutsk: e, lv: e, lviv: e, mk: e, mykolaiv: e, nikolaev: e, od: e, odesa: e, odessa: e, pl: e, poltava: e, rivne: e, rovno: e, rv: e, sb: e, sebastopol: e, sevastopol: e, sm: e, sumy: e, te: e, ternopil: e, uz: e, uzhgorod: e, uzhhorod: e, vinnica: e, vinnytsia: e, vn: e, volyn: e, yalta: e, zakarpattia: e, zaporizhzhe: e, zaporizhzhia: e, zhitomir: e, zhytomyr: e, zp: e, zt: e, cc: t, inf: t, ltd: t, cx: t, biz: t, co: t, pp: t, v: t }], ug: [1, { ac: e, co: e, com: e, edu: e, go: e, gov: e, mil: e, ne: e, or: e, org: e, sc: e, us: e }], uk: [1, { ac: e, co: [1, { bytemark: [0, { dh: t, vm: t }], layershift: J, barsy: t, barsyonline: t, retrosnub: Ba, "nh-serv": t, "no-ip": t, adimo: t, myspreadshop: t }], gov: [1, { api: t, campaign: t, service: t }], ltd: e, me: e, net: e, nhs: e, org: [1, { glug: t, lug: t, lugs: t, affinitylottery: t, raffleentry: t, weeklylottery: t }], plc: e, police: e, sch: _, conn: t, copro: t, hosp: t, "independent-commission": t, "independent-inquest": t, "independent-inquiry": t, "independent-panel": t, "independent-review": t, "public-inquiry": t, "royal-commission": t, pymnt: t, barsy: t, nimsite: t, oraclegovcloudapps: n }], us: [1, { dni: e, isa: e, nsn: e, ak: oe, al: oe, ar: oe, as: oe, az: oe, ca: oe, co: oe, ct: oe, dc: oe, de: Ua, fl: oe, ga: oe, gu: oe, hi: gr, ia: oe, id: oe, il: oe, in: oe, ks: oe, ky: oe, la: oe, ma: [1, { k12: [1, { chtr: e, paroch: e, pvt: e }], cc: e, lib: e }], md: oe, me: oe, mi: [1, { k12: e, cc: e, lib: e, "ann-arbor": e, cog: e, dst: e, eaton: e, gen: e, mus: e, tec: e, washtenaw: e }], mn: oe, mo: oe, ms: [1, { k12: e, cc: e }], mt: oe, nc: oe, nd: gr, ne: oe, nh: oe, nj: oe, nm: oe, nv: oe, ny: oe, oh: oe, ok: oe, or: oe, pa: oe, pr: oe, ri: gr, sc: oe, sd: gr, tn: oe, tx: oe, ut: oe, va: oe, vi: oe, vt: oe, wa: oe, wi: oe, wv: Ua, wy: oe, cloudns: t, "is-by": t, "land-4-sale": t, "stuff-4-sale": t, heliohost: t, enscaled: [0, { phx: t }], mircloud: t, ngo: t, golffan: t, noip: t, pointto: t, freeddns: t, srv: [2, { gh: t, gl: t }], platterp: t, servername: t }], uy: [1, { com: e, edu: e, gub: e, mil: e, net: e, org: e }], uz: [1, { co: e, com: e, net: e, org: e }], va: e, vc: [1, { com: e, edu: e, gov: e, mil: e, net: e, org: e, gv: [2, { d: t }], "0e": n, mydns: t }], ve: [1, { arts: e, bib: e, co: e, com: e, e12: e, edu: e, emprende: e, firm: e, gob: e, gov: e, info: e, int: e, mil: e, net: e, nom: e, org: e, rar: e, rec: e, store: e, tec: e, web: e }], vg: [1, { edu: e }], vi: [1, { co: e, com: e, k12: e, net: e, org: e }], vn: [1, { ac: e, ai: e, biz: e, com: e, edu: e, gov: e, health: e, id: e, info: e, int: e, io: e, name: e, net: e, org: e, pro: e, angiang: e, bacgiang: e, backan: e, baclieu: e, bacninh: e, "baria-vungtau": e, bentre: e, binhdinh: e, binhduong: e, binhphuoc: e, binhthuan: e, camau: e, cantho: e, caobang: e, daklak: e, daknong: e, danang: e, dienbien: e, dongnai: e, dongthap: e, gialai: e, hagiang: e, haiduong: e, haiphong: e, hanam: e, hanoi: e, hatinh: e, haugiang: e, hoabinh: e, hungyen: e, khanhhoa: e, kiengiang: e, kontum: e, laichau: e, lamdong: e, langson: e, laocai: e, longan: e, namdinh: e, nghean: e, ninhbinh: e, ninhthuan: e, phutho: e, phuyen: e, quangbinh: e, quangnam: e, quangngai: e, quangninh: e, quangtri: e, soctrang: e, sonla: e, tayninh: e, thaibinh: e, thainguyen: e, thanhhoa: e, thanhphohochiminh: e, thuathienhue: e, tiengiang: e, travinh: e, tuyenquang: e, vinhlong: e, vinhphuc: e, yenbai: e }], vu: Q, wf: [1, { biz: t, sch: t }], ws: [1, { com: e, edu: e, gov: e, net: e, org: e, advisor: n, cloud66: t, dyndns: t, mypets: t }], yt: [1, { org: t }], "xn--mgbaam7a8h": e, امارات: e, "xn--y9a3aq": e, հայ: e, "xn--54b7fta0cc": e, বাংলা: e, "xn--90ae": e, бг: e, "xn--mgbcpq6gpa1a": e, البحرين: e, "xn--90ais": e, бел: e, "xn--fiqs8s": e, 中国: e, "xn--fiqz9s": e, 中國: e, "xn--lgbbat1ad8j": e, الجزائر: e, "xn--wgbh1c": e, مصر: e, "xn--e1a4c": e, ею: e, "xn--qxa6a": e, ευ: e, "xn--mgbah1a3hjkrd": e, موريتانيا: e, "xn--node": e, გე: e, "xn--qxam": e, ελ: e, "xn--j6w193g": [1, { "xn--gmqw5a": e, "xn--55qx5d": e, "xn--mxtq1m": e, "xn--wcvs22d": e, "xn--uc0atv": e, "xn--od0alg": e }], 香港: [1, { 個人: e, 公司: e, 政府: e, 教育: e, 組織: e, 網絡: e }], "xn--2scrj9c": e, ಭಾರತ: e, "xn--3hcrj9c": e, ଭାରତ: e, "xn--45br5cyl": e, ভাৰত: e, "xn--h2breg3eve": e, भारतम्: e, "xn--h2brj9c8c": e, भारोत: e, "xn--mgbgu82a": e, ڀارت: e, "xn--rvc1e0am3e": e, ഭാരതം: e, "xn--h2brj9c": e, भारत: e, "xn--mgbbh1a": e, بارت: e, "xn--mgbbh1a71e": e, بھارت: e, "xn--fpcrj9c3d": e, భారత్: e, "xn--gecrj9c": e, ભારત: e, "xn--s9brj9c": e, ਭਾਰਤ: e, "xn--45brj9c": e, ভারত: e, "xn--xkc2dl3a5ee0h": e, இந்தியா: e, "xn--mgba3a4f16a": e, ایران: e, "xn--mgba3a4fra": e, ايران: e, "xn--mgbtx2b": e, عراق: e, "xn--mgbayh7gpa": e, الاردن: e, "xn--3e0b707e": e, 한국: e, "xn--80ao21a": e, қаз: e, "xn--q7ce6a": e, ລາວ: e, "xn--fzc2c9e2c": e, ලංකා: e, "xn--xkc2al3hye2a": e, இலங்கை: e, "xn--mgbc0a9azcg": e, المغرب: e, "xn--d1alf": e, мкд: e, "xn--l1acc": e, мон: e, "xn--mix891f": e, 澳門: e, "xn--mix082f": e, 澳门: e, "xn--mgbx4cd0ab": e, مليسيا: e, "xn--mgb9awbf": e, عمان: e, "xn--mgbai9azgqp6j": e, پاکستان: e, "xn--mgbai9a5eva00b": e, پاكستان: e, "xn--ygbi2ammx": e, فلسطين: e, "xn--90a3ac": [1, { "xn--80au": e, "xn--90azh": e, "xn--d1at": e, "xn--c1avg": e, "xn--o1ac": e, "xn--o1ach": e }], срб: [1, { ак: e, обр: e, од: e, орг: e, пр: e, упр: e }], "xn--p1ai": e, рф: e, "xn--wgbl6a": e, قطر: e, "xn--mgberp4a5d4ar": e, السعودية: e, "xn--mgberp4a5d4a87g": e, السعودیة: e, "xn--mgbqly7c0a67fbc": e, السعودیۃ: e, "xn--mgbqly7cvafr": e, السعوديه: e, "xn--mgbpl2fh": e, سودان: e, "xn--yfro4i67o": e, 新加坡: e, "xn--clchc0ea0b2g2a9gcd": e, சிங்கப்பூர்: e, "xn--ogbpf8fl": e, سورية: e, "xn--mgbtf8fl": e, سوريا: e, "xn--o3cw4h": [1, { "xn--o3cyx2a": e, "xn--12co0c3b4eva": e, "xn--m3ch0j3a": e, "xn--h3cuzk1di": e, "xn--12c1fe0br": e, "xn--12cfi8ixb8l": e }], ไทย: [1, { ทหาร: e, ธุรกิจ: e, เน็ต: e, รัฐบาล: e, ศึกษา: e, องค์กร: e }], "xn--pgbs0dh": e, تونس: e, "xn--kpry57d": e, 台灣: e, "xn--kprw13d": e, 台湾: e, "xn--nnx388a": e, 臺灣: e, "xn--j1amh": e, укр: e, "xn--mgb2ddes": e, اليمن: e, xxx: e, ye: o, za: [0, { ac: e, agric: e, alt: e, co: e, edu: e, gov: e, grondar: e, law: e, mil: e, net: e, ngo: e, nic: e, nis: e, nom: e, org: e, school: e, tm: e, web: e }], zm: [1, { ac: e, biz: e, co: e, com: e, edu: e, gov: e, info: e, mil: e, net: e, org: e, sch: e }], zw: [1, { ac: e, co: e, gov: e, mil: e, org: e }], aaa: e, aarp: e, abb: e, abbott: e, abbvie: e, abc: e, able: e, abogado: e, abudhabi: e, academy: [1, { official: t }], accenture: e, accountant: e, accountants: e, aco: e, actor: e, ads: e, adult: e, aeg: e, aetna: e, afl: e, africa: e, agakhan: e, agency: e, aig: e, airbus: e, airforce: e, airtel: e, akdn: e, alibaba: e, alipay: e, allfinanz: e, allstate: e, ally: e, alsace: e, alstom: e, amazon: e, americanexpress: e, americanfamily: e, amex: e, amfam: e, amica: e, amsterdam: e, analytics: e, android: e, anquan: e, anz: e, aol: e, apartments: e, app: [1, { adaptable: t, aiven: t, beget: n, brave: r, clerk: t, clerkstage: t, wnext: t, csb: [2, { preview: t }], convex: t, deta: t, ondigitalocean: t, easypanel: t, encr: [2, { frontend: t }], evervault: i, expo: [2, { staging: t }], edgecompute: t, "on-fleek": t, flutterflow: t, e2b: t, framer: t, github: t, hosted: n, run: [0, { "*": t, mtls: n }], web: t, hackclub: t, hasura: t, botdash: t, loginline: t, lovable: t, luyani: t, medusajs: t, messerli: t, netfy: t, netlify: t, ngrok: t, "ngrok-free": t, developer: n, noop: t, northflank: n, upsun: n, railway: [0, { up: t }], replit: s, nyat: t, snowflake: [0, { "*": t, privatelink: n }], streamlit: t, storipress: t, telebit: t, typedream: t, vercel: t, wal: t, bookonline: t, wdh: t, windsurf: t, zeabur: t, zerops: n }], apple: e, aquarelle: e, arab: e, aramco: e, archi: e, army: e, art: e, arte: e, asda: e, associates: e, athleta: e, attorney: e, auction: e, audi: e, audible: e, audio: e, auspost: e, author: e, auto: e, autos: e, aws: [1, { on: [0, { "af-south-1": u, "ap-east-1": u, "ap-northeast-1": u, "ap-northeast-2": u, "ap-northeast-3": u, "ap-south-1": u, "ap-south-2": u, "ap-southeast-1": u, "ap-southeast-2": u, "ap-southeast-3": u, "ap-southeast-4": u, "ap-southeast-5": u, "ca-central-1": u, "ca-west-1": u, "eu-central-1": u, "eu-central-2": u, "eu-north-1": u, "eu-south-1": u, "eu-south-2": u, "eu-west-1": u, "eu-west-2": u, "eu-west-3": u, "il-central-1": u, "me-central-1": u, "me-south-1": u, "sa-east-1": u, "us-east-1": u, "us-east-2": u, "us-west-1": u, "us-west-2": u, "us-gov-east-1": d, "us-gov-west-1": d }], sagemaker: [0, { "ap-northeast-1": m, "ap-northeast-2": m, "ap-south-1": m, "ap-southeast-1": m, "ap-southeast-2": m, "ca-central-1": p, "eu-central-1": m, "eu-west-1": m, "eu-west-2": m, "us-east-1": p, "us-east-2": p, "us-west-2": p, "af-south-1": h, "ap-east-1": h, "ap-northeast-3": h, "ap-south-2": f, "ap-southeast-3": h, "ap-southeast-4": f, "ca-west-1": [0, { notebook: t, "notebook-fips": t }], "eu-central-2": h, "eu-north-1": h, "eu-south-1": h, "eu-south-2": h, "eu-west-3": h, "il-central-1": h, "me-central-1": h, "me-south-1": h, "sa-east-1": h, "us-gov-east-1": b, "us-gov-west-1": b, "us-west-1": [0, { notebook: t, "notebook-fips": t, studio: t }], experiments: n }], repost: [0, { private: n }] }], axa: e, azure: e, baby: e, baidu: e, banamex: e, band: e, bank: e, bar: e, barcelona: e, barclaycard: e, barclays: e, barefoot: e, bargains: e, baseball: e, basketball: [1, { aus: t, nz: t }], bauhaus: e, bayern: e, bbc: e, bbt: e, bbva: e, bcg: e, bcn: e, beats: e, beauty: e, beer: e, berlin: e, best: e, bestbuy: e, bet: e, bharti: e, bible: e, bid: e, bike: e, bing: e, bingo: e, bio: e, black: e, blackfriday: e, blockbuster: e, blog: e, bloomberg: e, blue: e, bms: e, bmw: e, bnpparibas: e, boats: e, boehringer: e, bofa: e, bom: e, bond: e, boo: e, book: e, booking: e, bosch: e, bostik: e, boston: e, bot: e, boutique: e, box: e, bradesco: e, bridgestone: e, broadway: e, broker: e, brother: e, brussels: e, build: [1, { v0: t, windsurf: t }], builders: [1, { cloudsite: t }], business: y, buy: e, buzz: e, bzh: e, cab: e, cafe: e, cal: e, call: e, calvinklein: e, cam: e, camera: e, camp: [1, { emf: [0, { at: t }] }], canon: e, capetown: e, capital: e, capitalone: e, car: e, caravan: e, cards: e, care: e, career: e, careers: e, cars: e, casa: [1, { nabu: [0, { ui: t }] }], case: e, cash: e, casino: e, catering: e, catholic: e, cba: e, cbn: e, cbre: e, center: e, ceo: e, cern: e, cfa: e, cfd: e, chanel: e, channel: e, charity: e, chase: e, chat: e, cheap: e, chintai: e, christmas: e, chrome: e, church: e, cipriani: e, circle: e, cisco: e, citadel: e, citi: e, citic: e, city: e, claims: e, cleaning: e, click: e, clinic: e, clinique: e, clothing: e, cloud: [1, { convex: t, elementor: t, encoway: [0, { eu: t }], statics: n, ravendb: t, axarnet: [0, { "es-1": t }], diadem: t, jelastic: [0, { vip: t }], jele: t, "jenv-aruba": [0, { aruba: [0, { eur: [0, { it1: t }] }], it1: t }], keliweb: [2, { cs: t }], oxa: [2, { tn: t, uk: t }], primetel: [2, { uk: t }], reclaim: [0, { ca: t, uk: t, us: t }], trendhosting: [0, { ch: t, de: t }], jote: t, jotelulu: t, kuleuven: t, laravel: t, linkyard: t, magentosite: n, matlab: t, observablehq: t, perspecta: t, vapor: t, "on-rancher": n, scw: [0, { baremetal: [0, { "fr-par-1": t, "fr-par-2": t, "nl-ams-1": t }], "fr-par": [0, { cockpit: t, ddl: t, dtwh: t, fnc: [2, { functions: t }], ifr: t, k8s: x, kafk: t, mgdb: t, rdb: t, s3: t, "s3-website": t, scbl: t, whm: t }], instances: [0, { priv: t, pub: t }], k8s: t, "nl-ams": [0, { cockpit: t, ddl: t, dtwh: t, ifr: t, k8s: x, kafk: t, mgdb: t, rdb: t, s3: t, "s3-website": t, scbl: t, whm: t }], "pl-waw": [0, { cockpit: t, ddl: t, dtwh: t, ifr: t, k8s: x, kafk: t, mgdb: t, rdb: t, s3: t, "s3-website": t, scbl: t }], scalebook: t, smartlabeling: t }], servebolt: t, onstackit: [0, { runs: t }], trafficplex: t, "unison-services": t, urown: t, voorloper: t, zap: t }], club: [1, { cloudns: t, jele: t, barsy: t }], clubmed: e, coach: e, codes: [1, { owo: n }], coffee: e, college: e, cologne: e, commbank: e, community: [1, { nog: t, ravendb: t, myforum: t }], company: e, compare: e, computer: e, comsec: e, condos: e, construction: e, consulting: e, contact: e, contractors: e, cooking: e, cool: [1, { elementor: t, de: t }], corsica: e, country: e, coupon: e, coupons: e, courses: e, cpa: e, credit: e, creditcard: e, creditunion: e, cricket: e, crown: e, crs: e, cruise: e, cruises: e, cuisinella: e, cymru: e, cyou: e, dad: e, dance: e, data: e, date: e, dating: e, datsun: e, day: e, dclk: e, dds: e, deal: e, dealer: e, deals: e, degree: e, delivery: e, dell: e, deloitte: e, delta: e, democrat: e, dental: e, dentist: e, desi: e, design: [1, { graphic: t, bss: t }], dev: [1, { "12chars": t, myaddr: t, panel: t, lcl: n, lclstage: n, stg: n, stgstage: n, pages: t, r2: t, workers: t, deno: t, "deno-staging": t, deta: t, lp: [2, { api: t, objects: t }], evervault: i, fly: t, githubpreview: t, gateway: n, botdash: t, inbrowser: n, "is-a-good": t, "is-a": t, iserv: t, runcontainers: t, localcert: [0, { user: n }], loginline: t, barsy: t, mediatech: t, modx: t, ngrok: t, "ngrok-free": t, "is-a-fullstack": t, "is-cool": t, "is-not-a": t, localplayer: t, xmit: t, "platter-app": t, replit: [2, { archer: t, bones: t, canary: t, global: t, hacker: t, id: t, janeway: t, kim: t, kira: t, kirk: t, odo: t, paris: t, picard: t, pike: t, prerelease: t, reed: t, riker: t, sisko: t, spock: t, staging: t, sulu: t, tarpit: t, teams: t, tucker: t, wesley: t, worf: t }], crm: [0, { d: n, w: n, wa: n, wb: n, wc: n, wd: n, we: n, wf: n }], erp: V, vercel: t, webhare: n, hrsn: t }], dhl: e, diamonds: e, diet: e, digital: [1, { cloudapps: [2, { london: t }] }], direct: [1, { libp2p: t }], directory: e, discount: e, discover: e, dish: e, diy: e, dnp: e, docs: e, doctor: e, dog: e, domains: e, dot: e, download: e, drive: e, dtv: e, dubai: e, dunlop: e, dupont: e, durban: e, dvag: e, dvr: e, earth: e, eat: e, eco: e, edeka: e, education: y, email: [1, { crisp: [0, { on: t }], tawk: X, tawkto: X }], emerck: e, energy: e, engineer: e, engineering: e, enterprises: e, epson: e, equipment: e, ericsson: e, erni: e, esq: e, estate: [1, { compute: n }], eurovision: e, eus: [1, { party: Ye }], events: [1, { koobin: t, co: t }], exchange: e, expert: e, exposed: e, express: e, extraspace: e, fage: e, fail: e, fairwinds: e, faith: e, family: e, fan: e, fans: e, farm: [1, { storj: t }], farmers: e, fashion: e, fast: e, fedex: e, feedback: e, ferrari: e, ferrero: e, fidelity: e, fido: e, film: e, final: e, finance: e, financial: y, fire: e, firestone: e, firmdale: e, fish: e, fishing: e, fit: e, fitness: e, flickr: e, flights: e, flir: e, florist: e, flowers: e, fly: e, foo: e, food: e, football: e, ford: e, forex: e, forsale: e, forum: e, foundation: e, fox: e, free: e, fresenius: e, frl: e, frogans: e, frontier: e, ftr: e, fujitsu: e, fun: e, fund: e, furniture: e, futbol: e, fyi: e, gal: e, gallery: e, gallo: e, gallup: e, game: e, games: [1, { pley: t, sheezy: t }], gap: e, garden: e, gay: [1, { pages: t }], gbiz: e, gdn: [1, { cnpy: t }], gea: e, gent: e, genting: e, george: e, ggee: e, gift: e, gifts: e, gives: e, giving: e, glass: e, gle: e, global: [1, { appwrite: t }], globo: e, gmail: e, gmbh: e, gmo: e, gmx: e, godaddy: e, gold: e, goldpoint: e, golf: e, goo: e, goodyear: e, goog: [1, { cloud: t, translate: t, usercontent: n }], google: e, gop: e, got: e, grainger: e, graphics: e, gratis: e, green: e, gripe: e, grocery: e, group: [1, { discourse: t }], gucci: e, guge: e, guide: e, guitars: e, guru: e, hair: e, hamburg: e, hangout: e, haus: e, hbo: e, hdfc: e, hdfcbank: e, health: [1, { hra: t }], healthcare: e, help: e, helsinki: e, here: e, hermes: e, hiphop: e, hisamitsu: e, hitachi: e, hiv: e, hkt: e, hockey: e, holdings: e, holiday: e, homedepot: e, homegoods: e, homes: e, homesense: e, honda: e, horse: e, hospital: e, host: [1, { cloudaccess: t, freesite: t, easypanel: t, fastvps: t, myfast: t, tempurl: t, wpmudev: t, iserv: t, jele: t, mircloud: t, wp2: t, half: t }], hosting: [1, { opencraft: t }], hot: e, hotel: e, hotels: e, hotmail: e, house: e, how: e, hsbc: e, hughes: e, hyatt: e, hyundai: e, ibm: e, icbc: e, ice: e, icu: e, ieee: e, ifm: e, ikano: e, imamat: e, imdb: e, immo: e, immobilien: e, inc: e, industries: e, infiniti: e, ing: e, ink: e, institute: e, insurance: e, insure: e, international: e, intuit: e, investments: e, ipiranga: e, irish: e, ismaili: e, ist: e, istanbul: e, itau: e, itv: e, jaguar: e, java: e, jcb: e, jeep: e, jetzt: e, jewelry: e, jio: e, jll: e, jmp: e, jnj: e, joburg: e, jot: e, joy: e, jpmorgan: e, jprs: e, juegos: e, juniper: e, kaufen: e, kddi: e, kerryhotels: e, kerryproperties: e, kfh: e, kia: e, kids: e, kim: e, kindle: e, kitchen: e, kiwi: e, koeln: e, komatsu: e, kosher: e, kpmg: e, kpn: e, krd: [1, { co: t, edu: t }], kred: e, kuokgroup: e, kyoto: e, lacaixa: e, lamborghini: e, lamer: e, land: e, landrover: e, lanxess: e, lasalle: e, lat: e, latino: e, latrobe: e, law: e, lawyer: e, lds: e, lease: e, leclerc: e, lefrak: e, legal: e, lego: e, lexus: e, lgbt: e, lidl: e, life: e, lifeinsurance: e, lifestyle: e, lighting: e, like: e, lilly: e, limited: e, limo: e, lincoln: e, link: [1, { myfritz: t, cyon: t, dweb: n, inbrowser: n, nftstorage: ia, mypep: t, storacha: ia, w3s: ia }], live: [1, { aem: t, hlx: t, ewp: n }], living: e, llc: e, llp: e, loan: e, loans: e, locker: e, locus: e, lol: [1, { omg: t }], london: e, lotte: e, lotto: e, love: e, lpl: e, lplfinancial: e, ltd: e, ltda: e, lundbeck: e, luxe: e, luxury: e, madrid: e, maif: e, maison: e, makeup: e, man: e, management: e, mango: e, map: e, market: e, marketing: e, markets: e, marriott: e, marshalls: e, mattel: e, mba: e, mckinsey: e, med: e, media: ka, meet: e, melbourne: e, meme: e, memorial: e, men: e, menu: [1, { barsy: t, barsyonline: t }], merck: e, merckmsd: e, miami: e, microsoft: e, mini: e, mint: e, mit: e, mitsubishi: e, mlb: e, mls: e, mma: e, mobile: e, moda: e, moe: e, moi: e, mom: e, monash: e, money: e, monster: e, mormon: e, mortgage: e, moscow: e, moto: e, motorcycles: e, mov: e, movie: e, msd: e, mtn: e, mtr: e, music: e, nab: e, nagoya: e, navy: e, nba: e, nec: e, netbank: e, netflix: e, network: [1, { aem: t, alces: n, co: t, arvo: t, azimuth: t, tlon: t }], neustar: e, new: e, news: [1, { noticeable: t }], next: e, nextdirect: e, nexus: e, nfl: e, ngo: e, nhk: e, nico: e, nike: e, nikon: e, ninja: e, nissan: e, nissay: e, nokia: e, norton: e, now: e, nowruz: e, nowtv: e, nra: e, nrw: e, ntt: e, nyc: e, obi: e, observer: e, office: e, okinawa: e, olayan: e, olayangroup: e, ollo: e, omega: e, one: [1, { kin: n, service: t }], ong: [1, { obl: t }], onl: e, online: [1, { eero: t, "eero-stage": t, websitebuilder: t, barsy: t }], ooo: e, open: e, oracle: e, orange: [1, { tech: t }], organic: e, origins: e, osaka: e, otsuka: e, ott: e, ovh: [1, { nerdpol: t }], page: [1, { aem: t, hlx: t, translated: t, codeberg: t, heyflow: t, prvcy: t, rocky: t, pdns: t, plesk: t }], panasonic: e, paris: e, pars: e, partners: e, parts: e, party: e, pay: e, pccw: e, pet: e, pfizer: e, pharmacy: e, phd: e, philips: e, phone: e, photo: e, photography: e, photos: ka, physio: e, pics: e, pictet: e, pictures: [1, { 1337: t }], pid: e, pin: e, ping: e, pink: e, pioneer: e, pizza: [1, { ngrok: t }], place: y, play: e, playstation: e, plumbing: e, plus: e, pnc: e, pohl: e, poker: e, politie: e, porn: e, praxi: e, press: e, prime: e, prod: e, productions: e, prof: e, progressive: e, promo: e, properties: e, property: e, protection: e, pru: e, prudential: e, pub: [1, { id: n, kin: n, barsy: t }], pwc: e, qpon: e, quebec: e, quest: e, racing: e, radio: e, read: e, realestate: e, realtor: e, realty: e, recipes: e, red: e, redumbrella: e, rehab: e, reise: e, reisen: e, reit: e, reliance: e, ren: e, rent: e, rentals: e, repair: e, report: e, republican: e, rest: e, restaurant: e, review: e, reviews: [1, { aem: t }], rexroth: e, rich: e, richardli: e, ricoh: e, ril: e, rio: e, rip: [1, { clan: t }], rocks: [1, { myddns: t, stackit: t, "lima-city": t, webspace: t }], rodeo: e, rogers: e, room: e, rsvp: e, rugby: e, ruhr: e, run: [1, { appwrite: n, development: t, ravendb: t, liara: [2, { iran: t }], lovable: t, build: n, code: n, database: n, migration: n, onporter: t, repl: t, stackit: t, val: V, vercel: t, wix: t }], rwe: e, ryukyu: e, saarland: e, safe: e, safety: e, sakura: e, sale: e, salon: e, samsclub: e, samsung: e, sandvik: e, sandvikcoromant: e, sanofi: e, sap: e, sarl: e, sas: e, save: e, saxo: e, sbi: e, sbs: e, scb: e, schaeffler: e, schmidt: e, scholarships: e, school: e, schule: e, schwarz: e, science: e, scot: [1, { gov: [2, { service: t }] }], search: e, seat: e, secure: e, security: e, seek: e, select: e, sener: e, services: [1, { loginline: t }], seven: e, sew: e, sex: e, sexy: e, sfr: e, shangrila: e, sharp: e, shell: e, shia: e, shiksha: e, shoes: e, shop: [1, { base: t, hoplix: t, barsy: t, barsyonline: t, shopware: t }], shopping: e, shouji: e, show: e, silk: e, sina: e, singles: e, site: [1, { square: t, canva: S, cloudera: n, convex: t, cyon: t, caffeine: t, fastvps: t, figma: t, preview: t, heyflow: t, jele: t, jouwweb: t, loginline: t, barsy: t, notion: t, omniwe: t, opensocial: t, madethis: t, platformsh: n, tst: n, byen: t, srht: t, novecore: t, cpanel: t, wpsquared: t, sourcecraft: t }], ski: e, skin: e, sky: e, skype: e, sling: e, smart: e, smile: e, sncf: e, soccer: e, social: e, softbank: e, software: e, sohu: e, solar: e, solutions: e, song: e, sony: e, soy: e, spa: e, space: [1, { myfast: t, heiyu: t, hf: [2, { static: t }], "app-ionos": t, project: t, uber: t, xs4all: t }], sport: e, spot: e, srl: e, stada: e, staples: e, star: e, statebank: e, statefarm: e, stc: e, stcgroup: e, stockholm: e, storage: e, store: [1, { barsy: t, sellfy: t, shopware: t, storebase: t }], stream: e, studio: e, study: e, style: e, sucks: e, supplies: e, supply: e, support: [1, { barsy: t }], surf: e, surgery: e, suzuki: e, swatch: e, swiss: e, sydney: e, systems: [1, { knightpoint: t }], tab: e, taipei: e, talk: e, taobao: e, target: e, tatamotors: e, tatar: e, tattoo: e, tax: e, taxi: e, tci: e, tdk: e, team: [1, { discourse: t, jelastic: t }], tech: [1, { cleverapps: t }], technology: y, temasek: e, tennis: e, teva: e, thd: e, theater: e, theatre: e, tiaa: e, tickets: e, tienda: e, tips: e, tires: e, tirol: e, tjmaxx: e, tjx: e, tkmaxx: e, tmall: e, today: [1, { prequalifyme: t }], tokyo: e, tools: [1, { addr: ae, myaddr: t }], top: [1, { ntdll: t, wadl: n }], toray: e, toshiba: e, total: e, tours: e, town: e, toyota: e, toys: e, trade: e, trading: e, training: e, travel: e, travelers: e, travelersinsurance: e, trust: e, trv: e, tube: e, tui: e, tunes: e, tushu: e, tvs: e, ubank: e, ubs: e, unicom: e, university: e, uno: e, uol: e, ups: e, vacations: e, vana: e, vanguard: e, vegas: e, ventures: e, verisign: e, versicherung: e, vet: e, viajes: e, video: e, vig: e, viking: e, villas: e, vin: e, vip: [1, { hidns: t }], virgin: e, visa: e, vision: e, viva: e, vivo: e, vlaanderen: e, vodka: e, volvo: e, vote: e, voting: e, voto: e, voyage: e, wales: e, walmart: e, walter: e, wang: e, wanggou: e, watch: e, watches: e, weather: e, weatherchannel: e, webcam: e, weber: e, website: ka, wed: e, wedding: e, weibo: e, weir: e, whoswho: e, wien: e, wiki: ka, williamhill: e, win: e, windows: e, wine: e, winners: e, wme: e, wolterskluwer: e, woodside: e, work: e, works: e, world: e, wow: e, wtc: e, wtf: e, xbox: e, xerox: e, xihuan: e, xin: e, "xn--11b4c3d": e, कॉम: e, "xn--1ck2e1b": e, セール: e, "xn--1qqw23a": e, 佛山: e, "xn--30rr7y": e, 慈善: e, "xn--3bst00m": e, 集团: e, "xn--3ds443g": e, 在线: e, "xn--3pxu8k": e, 点看: e, "xn--42c2d9a": e, คอม: e, "xn--45q11c": e, 八卦: e, "xn--4gbrim": e, موقع: e, "xn--55qw42g": e, 公益: e, "xn--55qx5d": e, 公司: e, "xn--5su34j936bgsg": e, 香格里拉: e, "xn--5tzm5g": e, 网站: e, "xn--6frz82g": e, 移动: e, "xn--6qq986b3xl": e, 我爱你: e, "xn--80adxhks": e, москва: e, "xn--80aqecdr1a": e, католик: e, "xn--80asehdb": e, онлайн: e, "xn--80aswg": e, сайт: e, "xn--8y0a063a": e, 联通: e, "xn--9dbq2a": e, קום: e, "xn--9et52u": e, 时尚: e, "xn--9krt00a": e, 微博: e, "xn--b4w605ferd": e, 淡马锡: e, "xn--bck1b9a5dre4c": e, ファッション: e, "xn--c1avg": e, орг: e, "xn--c2br7g": e, नेट: e, "xn--cck2b3b": e, ストア: e, "xn--cckwcxetd": e, アマゾン: e, "xn--cg4bki": e, 삼성: e, "xn--czr694b": e, 商标: e, "xn--czrs0t": e, 商店: e, "xn--czru2d": e, 商城: e, "xn--d1acj3b": e, дети: e, "xn--eckvdtc9d": e, ポイント: e, "xn--efvy88h": e, 新闻: e, "xn--fct429k": e, 家電: e, "xn--fhbei": e, كوم: e, "xn--fiq228c5hs": e, 中文网: e, "xn--fiq64b": e, 中信: e, "xn--fjq720a": e, 娱乐: e, "xn--flw351e": e, 谷歌: e, "xn--fzys8d69uvgm": e, 電訊盈科: e, "xn--g2xx48c": e, 购物: e, "xn--gckr3f0f": e, クラウド: e, "xn--gk3at1e": e, 通販: e, "xn--hxt814e": e, 网店: e, "xn--i1b6b1a6a2e": e, संगठन: e, "xn--imr513n": e, 餐厅: e, "xn--io0a7i": e, 网络: e, "xn--j1aef": e, ком: e, "xn--jlq480n2rg": e, 亚马逊: e, "xn--jvr189m": e, 食品: e, "xn--kcrx77d1x4a": e, 飞利浦: e, "xn--kput3i": e, 手机: e, "xn--mgba3a3ejt": e, ارامكو: e, "xn--mgba7c0bbn0a": e, العليان: e, "xn--mgbab2bd": e, بازار: e, "xn--mgbca7dzdo": e, ابوظبي: e, "xn--mgbi4ecexp": e, كاثوليك: e, "xn--mgbt3dhd": e, همراه: e, "xn--mk1bu44c": e, 닷컴: e, "xn--mxtq1m": e, 政府: e, "xn--ngbc5azd": e, شبكة: e, "xn--ngbe9e0a": e, بيتك: e, "xn--ngbrx": e, عرب: e, "xn--nqv7f": e, 机构: e, "xn--nqv7fs00ema": e, 组织机构: e, "xn--nyqy26a": e, 健康: e, "xn--otu796d": e, 招聘: e, "xn--p1acf": [1, { "xn--90amc": t, "xn--j1aef": t, "xn--j1ael8b": t, "xn--h1ahn": t, "xn--j1adp": t, "xn--c1avg": t, "xn--80aaa0cvac": t, "xn--h1aliz": t, "xn--90a1af": t, "xn--41a": t }], рус: [1, { биз: t, ком: t, крым: t, мир: t, мск: t, орг: t, самара: t, сочи: t, спб: t, я: t }], "xn--pssy2u": e, 大拿: e, "xn--q9jyb4c": e, みんな: e, "xn--qcka1pmc": e, グーグル: e, "xn--rhqv96g": e, 世界: e, "xn--rovu88b": e, 書籍: e, "xn--ses554g": e, 网址: e, "xn--t60b56a": e, 닷넷: e, "xn--tckwe": e, コム: e, "xn--tiq49xqyj": e, 天主教: e, "xn--unup4y": e, 游戏: e, "xn--vermgensberater-ctb": e, vermögensberater: e, "xn--vermgensberatung-pwb": e, vermögensberatung: e, "xn--vhquv": e, 企业: e, "xn--vuq861b": e, 信息: e, "xn--w4r85el8fhu5dnra": e, 嘉里大酒店: e, "xn--w4rs40l": e, 嘉里: e, "xn--xhq521b": e, 广东: e, "xn--zfr164b": e, 政务: e, xyz: [1, { botdash: t, telebit: n }], yachts: e, yahoo: e, yamaxun: e, yandex: e, yodobashi: e, yoga: e, yokohama: e, you: e, youtube: e, yun: e, zappos: e, zara: e, zero: e, zip: e, zone: [1, { triton: n, stackit: t, lima: t }], zuerich: e }];
}();
function dp(e, t, a, o) {
  let n = null, r = t;
  for (; r !== void 0 && ((r[0] & o) !== 0 && (n = {
    index: a + 1,
    isIcann: r[0] === 1,
    isPrivate: r[0] === 2
  }), a !== -1); ) {
    const i = r[1];
    r = Object.prototype.hasOwnProperty.call(i, e[a]) ? i[e[a]] : i["*"], a -= 1;
  }
  return n;
}
function F0e(e, t, a) {
  var o;
  if (M0e(e, t, a))
    return;
  const n = e.split("."), r = (t.allowPrivateDomains ? 2 : 0) | (t.allowIcannDomains ? 1 : 0), i = dp(n, W0e, n.length - 1, r);
  if (i !== null) {
    a.isIcann = i.isIcann, a.isPrivate = i.isPrivate, a.publicSuffix = n.slice(i.index + 1).join(".");
    return;
  }
  const s = dp(n, B0e, n.length - 1, r);
  if (s !== null) {
    a.isIcann = s.isIcann, a.isPrivate = s.isPrivate, a.publicSuffix = n.slice(s.index).join(".");
    return;
  }
  a.isIcann = !1, a.isPrivate = !1, a.publicSuffix = (o = n[n.length - 1]) !== null && o !== void 0 ? o : null;
}
const gp = I0e();
function V0e(e, t = {}) {
  return T0e(gp), L0e(e, 3, F0e, t, gp).domain;
}
function Wy(e, t) {
  return !!(t === e || e.indexOf(t) === 0 && (t[t.length - 1] === "/" || e.startsWith(t) && e[t.length] === "/"));
}
var hp = ["local", "example", "invalid", "localhost", "test"], U0e = ["localhost", "invalid"], q0e = {
  allowSpecialUseDomain: !1,
  ignoreError: !1
};
function pd(e, t = {}) {
  t = { ...q0e, ...t };
  const a = e.split("."), o = a[a.length - 1], n = !!t.allowSpecialUseDomain, r = !!t.ignoreError;
  if (n && o !== void 0 && hp.includes(o)) {
    if (a.length > 1)
      return `${a[a.length - 2]}.${o}`;
    if (U0e.includes(o))
      return o;
  }
  if (!r && o !== void 0 && hp.includes(o))
    throw new Error(
      `Cookie has domain set to the public suffix "${o}" which is a special use domain. To allow this, configure your CookieJar with {allowSpecialUseDomain: true, rejectPublicSuffixes: false}.`
    );
  const i = V0e(e, {
    allowIcannDomains: !0,
    allowPrivateDomains: !0
  });
  if (i) return i;
}
function H0e(e, t) {
  const a = pd(e, {
    allowSpecialUseDomain: t
  });
  if (!a)
    return;
  if (a == e)
    return [e];
  e.slice(-1) == "." && (e = e.slice(0, -1));
  const o = e.slice(0, -(a.length + 1)).split(".").reverse();
  let n = a;
  const r = [n];
  for (; o.length; )
    n = `${o.shift()}.${n}`, r.push(n);
  return r;
}
var By = class {
  constructor() {
    this.synchronous = !1;
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  findCookie(t, a, o, n) {
    throw new Error("findCookie is not implemented");
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  findCookies(t, a, o = !1, n) {
    throw new Error("findCookies is not implemented");
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  putCookie(t, a) {
    throw new Error("putCookie is not implemented");
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  updateCookie(t, a, o) {
    throw new Error("updateCookie is not implemented");
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  removeCookie(t, a, o, n) {
    throw new Error("removeCookie is not implemented");
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  removeCookies(t, a, o) {
    throw new Error("removeCookies is not implemented");
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  removeAllCookies(t) {
    throw new Error("removeAllCookies is not implemented");
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  getAllCookies(t) {
    throw new Error(
      "getAllCookies is not implemented (therefore jar cannot be serialized)"
    );
  }
}, md = (e) => Object.prototype.toString.call(e), G0e = (e, t) => typeof e.join != "function" ? md(e) : (t.add(e), e.map(
  (a) => a == null || t.has(a) ? "" : Fy(a, t)
).join()), Fy = (e, t = /* @__PURE__ */ new WeakSet()) => typeof e != "object" || e === null ? String(e) : typeof e.toString == "function" ? Array.isArray(e) ? (
  // Arrays have a weird custom toString that we need to replicate
  G0e(e, t)
) : (
  // eslint-disable-next-line @typescript-eslint/no-base-to-string
  String(e)
) : md(e), Pc = (e) => Fy(e);
function nt(e) {
  let t, a, o;
  const n = new Promise((r, i) => {
    a = r, o = i;
  });
  return typeof e == "function" ? t = (r, i) => {
    try {
      r ? e(r) : e(null, i);
    } catch (s) {
      o(s instanceof Error ? s : new Error());
    }
  } : t = (r, i) => {
    try {
      r ? o(r) : a(i);
    } catch (s) {
      o(s instanceof Error ? s : new Error());
    }
  }, {
    promise: n,
    callback: t,
    resolve: (r) => (t(null, r), n),
    reject: (r) => (t(r), n)
  };
}
function Dn(e, t) {
  return e in t;
}
var Vy = class extends By {
  /**
   * Create a new {@link MemoryCookieStore}.
   */
  constructor() {
    super(), this.synchronous = !0, this.idx = /* @__PURE__ */ Object.create(null);
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  findCookie(t, a, o, n) {
    const r = nt(n);
    if (t == null || a == null || o == null)
      return r.resolve(void 0);
    const i = this.idx[t]?.[a]?.[o];
    return r.resolve(i);
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  findCookies(t, a, o = !1, n) {
    typeof o == "function" && (n = o, o = !0);
    const r = [], i = nt(n);
    if (!t)
      return i.resolve([]);
    let s;
    a ? s = function(u) {
      for (const d in u)
        if (Wy(a, d)) {
          const h = u[d];
          for (const m in h) {
            const f = h[m];
            f && r.push(f);
          }
        }
    } : s = function(u) {
      for (const d in u) {
        const h = u[d];
        for (const m in h) {
          const f = h[m];
          f && r.push(f);
        }
      }
    };
    const l = H0e(t, o) || [t], c = this.idx;
    return l.forEach((u) => {
      const d = c[u];
      d && s(d);
    }), i.resolve(r);
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  putCookie(t, a) {
    const o = nt(a), { domain: n, path: r, key: i } = t;
    if (n == null || r == null || i == null)
      return o.resolve(void 0);
    const s = this.idx[n] ?? /* @__PURE__ */ Object.create(null);
    this.idx[n] = s;
    const l = s[r] ?? /* @__PURE__ */ Object.create(null);
    return s[r] = l, l[i] = t, o.resolve(void 0);
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  updateCookie(t, a, o) {
    if (o) this.putCookie(a, o);
    else return this.putCookie(a);
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  removeCookie(t, a, o, n) {
    const r = nt(n);
    return delete this.idx[t]?.[a]?.[o], r.resolve(void 0);
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  removeCookies(t, a, o) {
    const n = nt(o), r = this.idx[t];
    return r && (a ? delete r[a] : delete this.idx[t]), n.resolve(void 0);
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  removeAllCookies(t) {
    const a = nt(t);
    return this.idx = /* @__PURE__ */ Object.create(null), a.resolve(void 0);
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  getAllCookies(t) {
    const a = nt(t), o = [], n = this.idx;
    return Object.keys(n).forEach((r) => {
      const i = n[r] ?? {};
      Object.keys(i).forEach((s) => {
        const l = i[s] ?? {};
        Object.keys(l).forEach((c) => {
          const u = l[c];
          u != null && o.push(u);
        });
      });
    }), o.sort((r, i) => (r.creationIndex || 0) - (i.creationIndex || 0)), a.resolve(o);
  }
};
function zl(e) {
  return Uy(e) && e !== "";
}
function fd(e) {
  return e === "" || e instanceof String && e.toString() === "";
}
function Uy(e) {
  return typeof e == "string" || e instanceof String;
}
function li(e) {
  return md(e) === "[object Object]";
}
function wn(e, t, a) {
  if (e) return;
  const o = typeof t == "function" ? t : void 0;
  let n = typeof t == "function" ? a : t;
  li(n) || (n = "[object Object]");
  const r = new qy(Pc(n));
  if (o) o(r);
  else throw r;
}
var qy = class extends Error {
}, K0e = "6.0.0", Ka = {
  SILENT: "silent",
  STRICT: "strict",
  DISABLED: "unsafe-disabled"
};
Object.freeze(Ka);
var J0e = `
\\[?(?:
(?:[a-fA-F\\d]{1,4}:){7}(?:[a-fA-F\\d]{1,4}|:)|
(?:[a-fA-F\\d]{1,4}:){6}(?:(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}|:[a-fA-F\\d]{1,4}|:)|
(?:[a-fA-F\\d]{1,4}:){5}(?::(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}|(?::[a-fA-F\\d]{1,4}){1,2}|:)|
(?:[a-fA-F\\d]{1,4}:){4}(?:(?::[a-fA-F\\d]{1,4}){0,1}:(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}|(?::[a-fA-F\\d]{1,4}){1,3}|:)|
(?:[a-fA-F\\d]{1,4}:){3}(?:(?::[a-fA-F\\d]{1,4}){0,2}:(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}|(?::[a-fA-F\\d]{1,4}){1,4}|:)|
(?:[a-fA-F\\d]{1,4}:){2}(?:(?::[a-fA-F\\d]{1,4}){0,3}:(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}|(?::[a-fA-F\\d]{1,4}){1,5}|:)|
(?:[a-fA-F\\d]{1,4}:){1}(?:(?::[a-fA-F\\d]{1,4}){0,4}:(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}|(?::[a-fA-F\\d]{1,4}){1,6}|:)|
(?::(?:(?::[a-fA-F\\d]{1,4}){0,5}:(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}|(?::[a-fA-F\\d]{1,4}){1,7}|:))
)(?:%[0-9a-zA-Z]{1,})?\\]?
`.replace(/\s*\/\/.*$/gm, "").replace(/\n/g, "").trim(), bd = new RegExp(`^${J0e}$`), Z0e = "(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])", Y0e = new RegExp(`^${Z0e}$`);
function pp(e) {
  return new URL(`http://${e}`).hostname;
}
function Wi(e) {
  if (e == null)
    return;
  let t = e.trim().replace(/^\./, "");
  return bd.test(t) ? (t.startsWith("[") || (t = "[" + t), t.endsWith("]") || (t = t + "]"), pp(t).slice(1, -1)) : /[^\u0001-\u007f]/.test(t) ? pp(t) : t.toLowerCase();
}
function X0e(e) {
  return e.toUTCString();
}
var Q0e = /[\x09\x20-\x2F\x3B-\x40\x5B-\x60\x7B-\x7E]/, Ct = {
  jan: 0,
  feb: 1,
  mar: 2,
  apr: 3,
  may: 4,
  jun: 5,
  jul: 6,
  aug: 7,
  sep: 8,
  oct: 9,
  nov: 10,
  dec: 11
};
function Dc(e, t, a, o) {
  let n = 0;
  for (; n < e.length; ) {
    const r = e.charCodeAt(n);
    if (r <= 47 || r >= 58)
      break;
    n++;
  }
  if (!(n < t || n > a) && !(!o && n != e.length))
    return parseInt(e.slice(0, n), 10);
}
function eCe(e) {
  const t = e.split(":"), a = [0, 0, 0];
  if (t.length === 3) {
    for (let o = 0; o < 3; o++) {
      const n = o == 2, r = t[o];
      if (r === void 0)
        return;
      const i = Dc(r, 1, 2, n);
      if (i === void 0)
        return;
      a[o] = i;
    }
    return a;
  }
}
function tCe(e) {
  switch (e = String(e).slice(0, 3).toLowerCase(), e) {
    case "jan":
      return Ct.jan;
    case "feb":
      return Ct.feb;
    case "mar":
      return Ct.mar;
    case "apr":
      return Ct.apr;
    case "may":
      return Ct.may;
    case "jun":
      return Ct.jun;
    case "jul":
      return Ct.jul;
    case "aug":
      return Ct.aug;
    case "sep":
      return Ct.sep;
    case "oct":
      return Ct.oct;
    case "nov":
      return Ct.nov;
    case "dec":
      return Ct.dec;
    default:
      return;
  }
}
function Nc(e) {
  if (!e)
    return;
  const t = e.split(Q0e);
  let a, o, n, r, i, s;
  for (let l = 0; l < t.length; l++) {
    const c = (t[l] ?? "").trim();
    if (c.length) {
      if (n === void 0) {
        const u = eCe(c);
        if (u) {
          a = u[0], o = u[1], n = u[2];
          continue;
        }
      }
      if (r === void 0) {
        const u = Dc(c, 1, 2, !0);
        if (u !== void 0) {
          r = u;
          continue;
        }
      }
      if (i === void 0) {
        const u = tCe(c);
        if (u !== void 0) {
          i = u;
          continue;
        }
      }
      if (s === void 0) {
        const u = Dc(c, 2, 4, !0);
        u !== void 0 && (s = u, s >= 70 && s <= 99 ? s += 1900 : s >= 0 && s <= 69 && (s += 2e3));
      }
    }
  }
  if (!(r === void 0 || i === void 0 || s === void 0 || a === void 0 || o === void 0 || n === void 0 || r < 1 || r > 31 || s < 1601 || a > 23 || o > 59 || n > 59))
    return new Date(Date.UTC(s, i, r, a, o, n));
}
var aCe = /^[\x21\x23-\x2B\x2D-\x3A\x3C-\x5B\x5D-\x7E]+$/, oCe = /[\x20-\x3A\x3C-\x7E]+/, mp = /[\x00-\x1F]/, fp = [`
`, "\r", "\0"];
function nCe(e) {
  if (fd(e)) return e;
  for (let t = 0; t < fp.length; t++) {
    const a = fp[t], o = a ? e.indexOf(a) : -1;
    o !== -1 && (e = e.slice(0, o));
  }
  return e;
}
function rCe(e, t) {
  e = nCe(e);
  let a = e.indexOf("=");
  if (t)
    a === 0 && (e = e.substring(1), a = e.indexOf("="));
  else if (a <= 0)
    return;
  let o, n;
  if (a <= 0 ? (o = "", n = e.trim()) : (o = e.slice(0, a).trim(), n = e.slice(a + 1).trim()), mp.test(o) || mp.test(n))
    return;
  const r = new vt();
  return r.key = o, r.value = n, r;
}
function iCe(e, t) {
  if (fd(e) || !Uy(e))
    return;
  e = e.trim();
  const a = e.indexOf(";"), o = a === -1 ? e : e.slice(0, a), n = rCe(o, t?.loose ?? !1);
  if (!n)
    return;
  if (a === -1)
    return n;
  const r = e.slice(a + 1).trim();
  if (r.length === 0)
    return n;
  const i = r.split(";");
  for (; i.length; ) {
    const s = (i.shift() ?? "").trim();
    if (s.length === 0)
      continue;
    const l = s.indexOf("=");
    let c, u;
    switch (l === -1 ? (c = s, u = null) : (c = s.slice(0, l), u = s.slice(l + 1)), c = c.trim().toLowerCase(), u && (u = u.trim()), c) {
      case "expires":
        if (u) {
          const d = Nc(u);
          d && (n.expires = d);
        }
        break;
      case "max-age":
        if (u && /^-?[0-9]+$/.test(u)) {
          const d = parseInt(u, 10);
          n.setMaxAge(d);
        }
        break;
      case "domain":
        if (u) {
          const d = u.trim().replace(/^\./, "");
          d && (n.domain = d.toLowerCase());
        }
        break;
      case "path":
        n.path = u && u[0] === "/" ? u : null;
        break;
      case "secure":
        n.secure = !0;
        break;
      case "httponly":
        n.httpOnly = !0;
        break;
      case "samesite":
        switch (u ? u.toLowerCase() : "") {
          case "strict":
            n.sameSite = "strict";
            break;
          case "lax":
            n.sameSite = "lax";
            break;
          case "none":
            n.sameSite = "none";
            break;
          default:
            n.sameSite = void 0;
            break;
        }
        break;
      default:
        n.extensions = n.extensions || [], n.extensions.push(s);
        break;
    }
  }
  return n;
}
function bp(e) {
  if (!e || fd(e))
    return;
  let t;
  if (typeof e == "string")
    try {
      t = JSON.parse(e);
    } catch {
      return;
    }
  else
    t = e;
  const a = new vt();
  return vt.serializableProperties.forEach((o) => {
    if (t && typeof t == "object" && Dn(o, t)) {
      const n = t[o];
      if (n === void 0 || Dn(o, Xe) && n === Xe[o])
        return;
      switch (o) {
        case "key":
        case "value":
        case "sameSite":
          typeof n == "string" && (a[o] = n);
          break;
        case "expires":
        case "creation":
        case "lastAccessed":
          typeof n == "number" || typeof n == "string" || n instanceof Date ? a[o] = t[o] == "Infinity" ? "Infinity" : new Date(n) : n === null && (a[o] = null);
          break;
        case "maxAge":
          (typeof n == "number" || n === "Infinity" || n === "-Infinity") && (a[o] = n);
          break;
        case "domain":
        case "path":
          (typeof n == "string" || n === null) && (a[o] = n);
          break;
        case "secure":
        case "httpOnly":
          typeof n == "boolean" && (a[o] = n);
          break;
        case "extensions":
          Array.isArray(n) && n.every((r) => typeof r == "string") && (a[o] = n);
          break;
        case "hostOnly":
        case "pathIsDefault":
          (typeof n == "boolean" || n === null) && (a[o] = n);
          break;
      }
    }
  }), a;
}
var Xe = {
  // the order in which the RFC has them:
  key: "",
  value: "",
  expires: "Infinity",
  maxAge: null,
  domain: null,
  path: null,
  secure: !1,
  httpOnly: !1,
  extensions: null,
  // set by the CookieJar:
  hostOnly: null,
  pathIsDefault: null,
  creation: null,
  lastAccessed: null,
  sameSite: void 0
}, nr = class ja {
  /**
   * Create a new Cookie instance.
   * @public
   * @param options - The attributes to set on the cookie
   */
  constructor(t = {}) {
    this.key = t.key ?? Xe.key, this.value = t.value ?? Xe.value, this.expires = t.expires ?? Xe.expires, this.maxAge = t.maxAge ?? Xe.maxAge, this.domain = t.domain ?? Xe.domain, this.path = t.path ?? Xe.path, this.secure = t.secure ?? Xe.secure, this.httpOnly = t.httpOnly ?? Xe.httpOnly, this.extensions = t.extensions ?? Xe.extensions, this.creation = t.creation ?? Xe.creation, this.hostOnly = t.hostOnly ?? Xe.hostOnly, this.pathIsDefault = t.pathIsDefault ?? Xe.pathIsDefault, this.lastAccessed = t.lastAccessed ?? Xe.lastAccessed, this.sameSite = t.sameSite ?? Xe.sameSite, this.creation = t.creation ?? /* @__PURE__ */ new Date(), Object.defineProperty(this, "creationIndex", {
      configurable: !1,
      enumerable: !1,
      // important for assert.deepEqual checks
      writable: !0,
      value: ++ja.cookiesCreated
    }), this.creationIndex = ja.cookiesCreated;
  }
  [Symbol.for("nodejs.util.inspect.custom")]() {
    const t = Date.now(), a = this.hostOnly != null ? this.hostOnly.toString() : "?", o = this.creation && this.creation !== "Infinity" ? `${String(t - this.creation.getTime())}ms` : "?", n = this.lastAccessed && this.lastAccessed !== "Infinity" ? `${String(t - this.lastAccessed.getTime())}ms` : "?";
    return `Cookie="${this.toString()}; hostOnly=${a}; aAge=${n}; cAge=${o}"`;
  }
  /**
   * For convenience in using `JSON.stringify(cookie)`. Returns a plain-old Object that can be JSON-serialized.
   *
   * @remarks
   * - Any `Date` properties (such as {@link Cookie.expires}, {@link Cookie.creation}, and {@link Cookie.lastAccessed}) are exported in ISO format (`Date.toISOString()`).
   *
   *  - Custom Cookie properties are discarded. In tough-cookie 1.x, since there was no {@link Cookie.toJSON} method explicitly defined, all enumerable properties were captured.
   *      If you want a property to be serialized, add the property name to {@link Cookie.serializableProperties}.
   */
  toJSON() {
    const t = {};
    for (const a of ja.serializableProperties) {
      const o = this[a];
      if (o !== Xe[a])
        switch (a) {
          case "key":
          case "value":
          case "sameSite":
            typeof o == "string" && (t[a] = o);
            break;
          case "expires":
          case "creation":
          case "lastAccessed":
            typeof o == "number" || typeof o == "string" || o instanceof Date ? t[a] = o == "Infinity" ? "Infinity" : new Date(o).toISOString() : o === null && (t[a] = null);
            break;
          case "maxAge":
            (typeof o == "number" || o === "Infinity" || o === "-Infinity") && (t[a] = o);
            break;
          case "domain":
          case "path":
            (typeof o == "string" || o === null) && (t[a] = o);
            break;
          case "secure":
          case "httpOnly":
            typeof o == "boolean" && (t[a] = o);
            break;
          case "extensions":
            Array.isArray(o) && (t[a] = o);
            break;
          case "hostOnly":
          case "pathIsDefault":
            (typeof o == "boolean" || o === null) && (t[a] = o);
            break;
        }
    }
    return t;
  }
  /**
   * Does a deep clone of this cookie, implemented exactly as `Cookie.fromJSON(cookie.toJSON())`.
   * @public
   */
  clone() {
    return bp(this.toJSON());
  }
  /**
   * Validates cookie attributes for semantic correctness. Useful for "lint" checking any `Set-Cookie` headers you generate.
   * For now, it returns a boolean, but eventually could return a reason string.
   *
   * @remarks
   * Works for a few things, but is by no means comprehensive.
   *
   * @beta
   */
  validate() {
    if (!this.value || !aCe.test(this.value) || this.expires != "Infinity" && !(this.expires instanceof Date) && !Nc(this.expires) || this.maxAge != null && this.maxAge !== "Infinity" && (this.maxAge === "-Infinity" || this.maxAge <= 0) || this.path != null && !oCe.test(this.path))
      return !1;
    const t = this.cdomain();
    return !(t && (t.match(/\.$/) || pd(t) == null));
  }
  /**
   * Sets the 'Expires' attribute on a cookie.
   *
   * @remarks
   * When given a `string` value it will be parsed with {@link parseDate}. If the value can't be parsed as a cookie date
   * then the 'Expires' attribute will be set to `"Infinity"`.
   *
   * @param exp - the new value for the 'Expires' attribute of the cookie.
   */
  setExpires(t) {
    t instanceof Date ? this.expires = t : this.expires = Nc(t) || "Infinity";
  }
  /**
   * Sets the 'Max-Age' attribute (in seconds) on a cookie.
   *
   * @remarks
   * Coerces `-Infinity` to `"-Infinity"` and `Infinity` to `"Infinity"` so it can be serialized to JSON.
   *
   * @param age - the new value for the 'Max-Age' attribute (in seconds).
   */
  setMaxAge(t) {
    t === 1 / 0 ? this.maxAge = "Infinity" : t === -1 / 0 ? this.maxAge = "-Infinity" : this.maxAge = t;
  }
  /**
   * Encodes to a `Cookie` header value (specifically, the {@link Cookie.key} and {@link Cookie.value} properties joined with "=").
   * @public
   */
  cookieString() {
    const t = this.value || "";
    return this.key ? `${this.key}=${t}` : t;
  }
  /**
   * Encodes to a `Set-Cookie header` value.
   * @public
   */
  toString() {
    let t = this.cookieString();
    return this.expires != "Infinity" && this.expires instanceof Date && (t += `; Expires=${X0e(this.expires)}`), this.maxAge != null && this.maxAge != 1 / 0 && (t += `; Max-Age=${String(this.maxAge)}`), this.domain && !this.hostOnly && (t += `; Domain=${this.domain}`), this.path && (t += `; Path=${this.path}`), this.secure && (t += "; Secure"), this.httpOnly && (t += "; HttpOnly"), this.sameSite && this.sameSite !== "none" && (this.sameSite.toLowerCase() === ja.sameSiteCanonical.lax.toLowerCase() ? t += `; SameSite=${ja.sameSiteCanonical.lax}` : this.sameSite.toLowerCase() === ja.sameSiteCanonical.strict.toLowerCase() ? t += `; SameSite=${ja.sameSiteCanonical.strict}` : t += `; SameSite=${this.sameSite}`), this.extensions && this.extensions.forEach((a) => {
      t += `; ${a}`;
    }), t;
  }
  /**
   * Computes the TTL relative to now (milliseconds).
   *
   * @remarks
   * - `Infinity` is returned for cookies without an explicit expiry
   *
   * - `0` is returned if the cookie is expired.
   *
   * - Otherwise a time-to-live in milliseconds is returned.
   *
   * @param now - passing an explicit value is mostly used for testing purposes since this defaults to the `Date.now()`
   * @public
   */
  TTL(t = Date.now()) {
    if (this.maxAge != null && typeof this.maxAge == "number")
      return this.maxAge <= 0 ? 0 : this.maxAge * 1e3;
    const a = this.expires;
    return a === "Infinity" ? 1 / 0 : (a?.getTime() ?? t) - (t || Date.now());
  }
  /**
   * Computes the absolute unix-epoch milliseconds that this cookie expires.
   *
   * The "Max-Age" attribute takes precedence over "Expires" (as per the RFC). The {@link Cookie.lastAccessed} attribute
   * (or the `now` parameter if given) is used to offset the {@link Cookie.maxAge} attribute.
   *
   * If Expires ({@link Cookie.expires}) is set, that's returned.
   *
   * @param now - can be used to provide a time offset (instead of {@link Cookie.lastAccessed}) to use when calculating the "Max-Age" value
   */
  expiryTime(t) {
    if (this.maxAge != null) {
      const a = t || this.lastAccessed || /* @__PURE__ */ new Date(), o = typeof this.maxAge == "number" ? this.maxAge : -1 / 0, n = o <= 0 ? -1 / 0 : o * 1e3;
      return a === "Infinity" ? 1 / 0 : a.getTime() + n;
    }
    return this.expires == "Infinity" ? 1 / 0 : this.expires ? this.expires.getTime() : void 0;
  }
  /**
   * Similar to {@link Cookie.expiryTime}, computes the absolute unix-epoch milliseconds that this cookie expires and returns it as a Date.
   *
   * The "Max-Age" attribute takes precedence over "Expires" (as per the RFC). The {@link Cookie.lastAccessed} attribute
   * (or the `now` parameter if given) is used to offset the {@link Cookie.maxAge} attribute.
   *
   * If Expires ({@link Cookie.expires}) is set, that's returned.
   *
   * @param now - can be used to provide a time offset (instead of {@link Cookie.lastAccessed}) to use when calculating the "Max-Age" value
   */
  expiryDate(t) {
    const a = this.expiryTime(t);
    return a == 1 / 0 ? /* @__PURE__ */ new Date(2147483647e3) : a == -1 / 0 ? /* @__PURE__ */ new Date(0) : a == null ? void 0 : new Date(a);
  }
  /**
   * Indicates if the cookie has been persisted to a store or not.
   * @public
   */
  isPersistent() {
    return this.maxAge != null || this.expires != "Infinity";
  }
  /**
   * Calls {@link canonicalDomain} with the {@link Cookie.domain} property.
   * @public
   */
  canonicalizedDomain() {
    return Wi(this.domain);
  }
  /**
   * Alias for {@link Cookie.canonicalizedDomain}
   * @public
   */
  cdomain() {
    return Wi(this.domain);
  }
  /**
   * Parses a string into a Cookie object.
   *
   * @remarks
   * Note: when parsing a `Cookie` header it must be split by ';' before each Cookie string can be parsed.
   *
   * @example
   * ```
   * // parse a `Set-Cookie` header
   * const setCookieHeader = 'a=bcd; Expires=Tue, 18 Oct 2011 07:05:03 GMT'
   * const cookie = Cookie.parse(setCookieHeader)
   * cookie.key === 'a'
   * cookie.value === 'bcd'
   * cookie.expires === new Date(Date.parse('Tue, 18 Oct 2011 07:05:03 GMT'))
   * ```
   *
   * @example
   * ```
   * // parse a `Cookie` header
   * const cookieHeader = 'name=value; name2=value2; name3=value3'
   * const cookies = cookieHeader.split(';').map(Cookie.parse)
   * cookies[0].name === 'name'
   * cookies[0].value === 'value'
   * cookies[1].name === 'name2'
   * cookies[1].value === 'value2'
   * cookies[2].name === 'name3'
   * cookies[2].value === 'value3'
   * ```
   *
   * @param str - The `Set-Cookie` header or a Cookie string to parse.
   * @param options - Configures `strict` or `loose` mode for cookie parsing
   */
  static parse(t, a) {
    return iCe(t, a);
  }
  /**
   * Does the reverse of {@link Cookie.toJSON}.
   *
   * @remarks
   * Any Date properties (such as .expires, .creation, and .lastAccessed) are parsed via Date.parse, not tough-cookie's parseDate, since ISO timestamps are being handled at this layer.
   *
   * @example
   * ```
   * const json = JSON.stringify({
   *   key: 'alpha',
   *   value: 'beta',
   *   domain: 'example.com',
   *   path: '/foo',
   *   expires: '2038-01-19T03:14:07.000Z',
   * })
   * const cookie = Cookie.fromJSON(json)
   * cookie.key === 'alpha'
   * cookie.value === 'beta'
   * cookie.domain === 'example.com'
   * cookie.path === '/foo'
   * cookie.expires === new Date(Date.parse('2038-01-19T03:14:07.000Z'))
   * ```
   *
   * @param str - An unparsed JSON string or a value that has already been parsed as JSON
   */
  static fromJSON(t) {
    return bp(t);
  }
};
nr.cookiesCreated = 0;
nr.sameSiteLevel = {
  strict: 3,
  lax: 2,
  none: 1
};
nr.sameSiteCanonical = {
  strict: "Strict",
  lax: "Lax"
};
nr.serializableProperties = [
  "key",
  "value",
  "expires",
  "maxAge",
  "domain",
  "path",
  "secure",
  "httpOnly",
  "extensions",
  "hostOnly",
  "pathIsDefault",
  "creation",
  "lastAccessed",
  "sameSite"
];
var vt = nr, _p = 2147483647e3;
function vp(e, t) {
  let a;
  const o = e.path ? e.path.length : 0;
  if (a = (t.path ? t.path.length : 0) - o, a !== 0)
    return a;
  const n = e.creation && e.creation instanceof Date ? e.creation.getTime() : _p, r = t.creation && t.creation instanceof Date ? t.creation.getTime() : _p;
  return a = n - r, a !== 0 || (a = (e.creationIndex || 0) - (t.creationIndex || 0)), a;
}
function sCe(e) {
  if (!e || e.slice(0, 1) !== "/")
    return "/";
  if (e === "/")
    return e;
  const t = e.lastIndexOf("/");
  return t === 0 ? "/" : e.slice(0, t);
}
var lCe = /(?:^(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}$)|(?:^(?:(?:[a-f\d]{1,4}:){7}(?:[a-f\d]{1,4}|:)|(?:[a-f\d]{1,4}:){6}(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|:[a-f\d]{1,4}|:)|(?:[a-f\d]{1,4}:){5}(?::(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-f\d]{1,4}){1,2}|:)|(?:[a-f\d]{1,4}:){4}(?:(?::[a-f\d]{1,4}){0,1}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-f\d]{1,4}){1,3}|:)|(?:[a-f\d]{1,4}:){3}(?:(?::[a-f\d]{1,4}){0,2}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-f\d]{1,4}){1,4}|:)|(?:[a-f\d]{1,4}:){2}(?:(?::[a-f\d]{1,4}){0,3}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-f\d]{1,4}){1,5}|:)|(?:[a-f\d]{1,4}:){1}(?:(?::[a-f\d]{1,4}){0,4}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-f\d]{1,4}){1,6}|:)|(?::(?:(?::[a-f\d]{1,4}){0,5}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-f\d]{1,4}){1,7}|:)))$)/;
function yp(e, t, a) {
  if (e == null || t == null)
    return;
  let o, n;
  if (o = e, n = t, o == null || n == null)
    return;
  if (o == n)
    return !0;
  const r = o.lastIndexOf(n);
  return r <= 0 || o.length !== n.length + r || o.substring(r - 1, r) !== "." ? !1 : !lCe.test(o);
}
function cCe(e) {
  const t = e.split(".");
  return t.length === 4 && t[0] !== void 0 && parseInt(t[0], 10) === 127;
}
function uCe(e) {
  return e === "::1";
}
function dCe(e) {
  return e.endsWith(".localhost");
}
function gCe(e) {
  const t = e.toLowerCase();
  return t === "localhost" || dCe(t);
}
function hCe(e) {
  return e.length >= 2 && e.startsWith("[") && e.endsWith("]") ? e.substring(1, e.length - 1) : e;
}
function pCe(e, t = !0) {
  let a;
  if (typeof e == "string")
    try {
      a = new URL(e);
    } catch {
      return !1;
    }
  else
    a = e;
  const o = a.protocol.replace(":", "").toLowerCase(), n = hCe(a.hostname).replace(/\.+$/, "");
  return o === "https" || o === "wss" ? !0 : t ? Y0e.test(n) ? cCe(n) : bd.test(n) ? uCe(n) : gCe(n) : !1;
}
var mCe = {
  loose: !1,
  sameSiteContext: void 0,
  ignoreError: !1,
  http: !0
}, wp = {
  http: !0,
  expire: !0,
  allPaths: !1,
  sameSiteContext: void 0,
  sort: void 0
}, Al = 'Invalid sameSiteContext option for getCookies(); expected one of "strict", "lax", or "none"';
function kp(e) {
  if (e && typeof e == "object" && "hostname" in e && typeof e.hostname == "string" && "pathname" in e && typeof e.pathname == "string" && "protocol" in e && typeof e.protocol == "string")
    return {
      hostname: e.hostname,
      pathname: e.pathname,
      protocol: e.protocol
    };
  if (typeof e == "string")
    try {
      return new URL(decodeURI(e));
    } catch {
      return new URL(e);
    }
  else
    throw new qy("`url` argument is not a string or URL.");
}
function xp(e) {
  const t = String(e).toLowerCase();
  if (t === "none" || t === "lax" || t === "strict")
    return t;
}
function fCe(e) {
  return !(typeof e.key == "string" && e.key.startsWith("__Secure-")) || e.secure;
}
function bCe(e) {
  return !(typeof e.key == "string" && e.key.startsWith("__Host-")) || !!(e.secure && e.hostOnly && e.path != null && e.path === "/");
}
function Ir(e) {
  const t = e.toLowerCase();
  switch (t) {
    case Ka.STRICT:
    case Ka.SILENT:
    case Ka.DISABLED:
      return t;
    default:
      return Ka.SILENT;
  }
}
var _Ce = class $n {
  /**
   * Creates a new `CookieJar` instance.
   *
   * @remarks
   * - If a custom store is not passed to the constructor, an in-memory store ({@link MemoryCookieStore} will be created and used.
   * - If a boolean value is passed as the `options` parameter, this is equivalent to passing `{ rejectPublicSuffixes: <value> }`
   *
   * @param store - a custom {@link Store} implementation (defaults to {@link MemoryCookieStore})
   * @param options - configures how cookies are processed by the cookie jar
   */
  constructor(t, a) {
    typeof a == "boolean" && (a = { rejectPublicSuffixes: a }), this.rejectPublicSuffixes = a?.rejectPublicSuffixes ?? !0, this.enableLooseMode = a?.looseMode ?? !1, this.allowSpecialUseDomain = a?.allowSpecialUseDomain ?? !0, this.allowSecureOnLocal = a?.allowSecureOnLocal ?? !0, this.prefixSecurity = Ir(
      a?.prefixSecurity ?? "silent"
    ), this.store = t ?? new Vy();
  }
  callSync(t) {
    if (!this.store.synchronous)
      throw new Error(
        "CookieJar store is not synchronous; use async API instead."
      );
    let a = null, o;
    try {
      t.call(this, (n, r) => {
        a = n, o = r;
      });
    } catch (n) {
      a = n;
    }
    if (a) throw a;
    return o;
  }
  /**
   * @internal No doc because this is the overload implementation
   */
  setCookie(t, a, o, n) {
    typeof o == "function" && (n = o, o = void 0);
    const r = nt(n), i = r.callback;
    let s;
    try {
      if (typeof a == "string" && wn(
        zl(a),
        n,
        Pc(o)
      ), s = kp(a), typeof a == "function")
        return r.reject(new Error("No URL was specified"));
      if (typeof o == "function" && (o = mCe), wn(typeof i == "function", i), !zl(t) && !li(t) && t instanceof String && t.length == 0)
        return r.resolve(void 0);
    } catch (p) {
      return r.reject(p);
    }
    const l = Wi(s.hostname) ?? null, c = o?.loose || this.enableLooseMode;
    let u = null;
    if (o?.sameSiteContext && (u = xp(o.sameSiteContext), !u))
      return r.reject(new Error(Al));
    if (typeof t == "string" || t instanceof String) {
      const p = vt.parse(t.toString(), { loose: c });
      if (!p) {
        const b = new Error("Cookie failed to parse");
        return o?.ignoreError ? r.resolve(void 0) : r.reject(b);
      }
      t = p;
    } else if (!(t instanceof vt)) {
      const p = new Error(
        "First argument to setCookie must be a Cookie object or string"
      );
      return o?.ignoreError ? r.resolve(void 0) : r.reject(p);
    }
    const d = o?.now || /* @__PURE__ */ new Date();
    if (this.rejectPublicSuffixes && t.domain)
      try {
        const p = t.cdomain();
        if ((typeof p == "string" ? pd(p, {
          allowSpecialUseDomain: this.allowSpecialUseDomain,
          ignoreError: o?.ignoreError
        }) : null) == null && !bd.test(t.domain)) {
          const b = new Error("Cookie has domain set to a public suffix");
          return o?.ignoreError ? r.resolve(void 0) : r.reject(b);
        }
      } catch (p) {
        return o?.ignoreError ? r.resolve(void 0) : (
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          r.reject(p)
        );
      }
    if (t.domain) {
      if (!yp(l ?? void 0, t.cdomain() ?? void 0)) {
        const p = new Error(
          `Cookie not in this host's domain. Cookie:${t.cdomain() ?? "null"} Request:${l ?? "null"}`
        );
        return o?.ignoreError ? r.resolve(void 0) : r.reject(p);
      }
      t.hostOnly == null && (t.hostOnly = !1);
    } else
      t.hostOnly = !0, t.domain = l;
    if ((!t.path || t.path[0] !== "/") && (t.path = sCe(s.pathname), t.pathIsDefault = !0), o?.http === !1 && t.httpOnly) {
      const p = new Error("Cookie is HttpOnly and this isn't an HTTP API");
      return o.ignoreError ? r.resolve(void 0) : r.reject(p);
    }
    if (t.sameSite !== "none" && t.sameSite !== void 0 && u && u === "none") {
      const p = new Error(
        "Cookie is SameSite but this is a cross-origin request"
      );
      return o?.ignoreError ? r.resolve(void 0) : r.reject(p);
    }
    const h = this.prefixSecurity === Ka.SILENT;
    if (this.prefixSecurity !== Ka.DISABLED) {
      let p = !1, b;
      if (fCe(t) ? bCe(t) || (p = !0, b = "Cookie has __Host prefix but either Secure or HostOnly attribute is not set or Path is not '/'") : (p = !0, b = "Cookie has __Secure prefix but Secure attribute is not set"), p)
        return o?.ignoreError || h ? r.resolve(void 0) : r.reject(new Error(b));
    }
    const m = this.store;
    m.updateCookie || (m.updateCookie = async function(p, b, w) {
      return this.putCookie(b).then(
        () => w?.(null),
        (_) => w?.(_)
      );
    });
    const f = function(p, b) {
      if (p) {
        i(p);
        return;
      }
      const w = function(_) {
        _ ? i(_) : typeof t == "string" ? i(null, void 0) : i(null, t);
      };
      if (b) {
        if (o && "http" in o && o.http === !1 && b.httpOnly) {
          p = new Error("old Cookie is HttpOnly and this isn't an HTTP API"), o.ignoreError ? i(null, void 0) : i(p);
          return;
        }
        t instanceof vt && (t.creation = b.creation, t.creationIndex = b.creationIndex, t.lastAccessed = d, m.updateCookie(b, t, w));
      } else
        t instanceof vt && (t.creation = t.lastAccessed = d, m.putCookie(t, w));
    };
    return m.findCookie(t.domain, t.path, t.key, f), r.promise;
  }
  /**
   * Synchronously attempt to set the {@link Cookie} in the {@link CookieJar}.
   *
   * <strong>Note:</strong> Only works if the configured {@link Store} is also synchronous.
   *
   * @remarks
   * - If successfully persisted, the {@link Cookie} will have updated
   *     {@link Cookie.creation}, {@link Cookie.lastAccessed} and {@link Cookie.hostOnly}
   *     properties.
   *
   * - As per the RFC, the {@link Cookie.hostOnly} flag is set if there was no `Domain={value}`
   *     attribute on the cookie string. The {@link Cookie.domain} property is set to the
   *     fully-qualified hostname of `currentUrl` in this case. Matching this cookie requires an
   *     exact hostname match (not a {@link domainMatch} as per usual)
   *
   * @param cookie - The cookie object or cookie string to store. A string value will be parsed into a cookie using {@link Cookie.parse}.
   * @param url - The domain to store the cookie with.
   * @param options - Configuration settings to use when storing the cookie.
   * @public
   */
  setCookieSync(t, a, o) {
    const n = o ? this.setCookie.bind(this, t, a, o) : this.setCookie.bind(this, t, a);
    return this.callSync(n);
  }
  /**
   * @internal No doc because this is the overload implementation
   */
  getCookies(t, a, o) {
    typeof a == "function" ? (o = a, a = wp) : a === void 0 && (a = wp);
    const n = nt(o), r = n.callback;
    let i;
    try {
      typeof t == "string" && wn(zl(t), r, t), i = kp(t), wn(
        li(a),
        r,
        Pc(a)
      ), wn(typeof r == "function", r);
    } catch (w) {
      return n.reject(w);
    }
    const s = Wi(i.hostname), l = i.pathname || "/", c = pCe(
      t,
      this.allowSecureOnLocal
    );
    let u = 0;
    if (a.sameSiteContext) {
      const w = xp(a.sameSiteContext);
      if (w == null)
        return n.reject(new Error(Al));
      if (u = vt.sameSiteLevel[w], !u)
        return n.reject(new Error(Al));
    }
    const d = a.http ?? !0, h = Date.now(), m = a.expire ?? !0, f = a.allPaths ?? !1, p = this.store;
    function b(w) {
      if (w.hostOnly) {
        if (w.domain != s)
          return !1;
      } else if (!yp(s ?? void 0, w.domain ?? void 0))
        return !1;
      if (!f && typeof w.path == "string" && !Wy(l, w.path) || w.secure && !c || w.httpOnly && !d)
        return !1;
      if (u) {
        let y;
        if (w.sameSite === "lax" ? y = vt.sameSiteLevel.lax : w.sameSite === "strict" ? y = vt.sameSiteLevel.strict : y = vt.sameSiteLevel.none, y > u)
          return !1;
      }
      const _ = w.expiryTime();
      return m && _ != null && _ <= h ? (p.removeCookie(w.domain, w.path, w.key, () => {
      }), !1) : !0;
    }
    return p.findCookies(
      s,
      f ? null : l,
      this.allowSpecialUseDomain,
      (w, _) => {
        if (w) {
          r(w);
          return;
        }
        if (_ == null) {
          r(null, []);
          return;
        }
        _ = _.filter(b), "sort" in a && a.sort !== !1 && (_ = _.sort(vp));
        const y = /* @__PURE__ */ new Date();
        for (const k of _)
          k.lastAccessed = y;
        r(null, _);
      }
    ), n.promise;
  }
  /**
   * Synchronously retrieve the list of cookies that can be sent in a Cookie header for the
   * current URL.
   *
   * <strong>Note</strong>: Only works if the configured Store is also synchronous.
   *
   * @remarks
   * - The array of cookies returned will be sorted according to {@link cookieCompare}.
   *
   * - The {@link Cookie.lastAccessed} property will be updated on all returned cookies.
   *
   * @param url - The domain to store the cookie with.
   * @param options - Configuration settings to use when retrieving the cookies.
   */
  getCookiesSync(t, a) {
    return this.callSync(this.getCookies.bind(this, t, a)) ?? [];
  }
  /**
   * @internal No doc because this is the overload implementation
   */
  getCookieString(t, a, o) {
    typeof a == "function" && (o = a, a = void 0);
    const n = nt(o), r = function(i, s) {
      i ? n.callback(i) : n.callback(
        null,
        s?.sort(vp).map((l) => l.cookieString()).join("; ")
      );
    };
    return this.getCookies(t, a, r), n.promise;
  }
  /**
   * Synchronous version of `.getCookieString()`. Accepts the same options as `.getCookies()` but returns a string suitable for a
   * `Cookie` header rather than an Array.
   *
   * <strong>Note</strong>: Only works if the configured Store is also synchronous.
   *
   * @param url - The domain to store the cookie with.
   * @param options - Configuration settings to use when retrieving the cookies.
   */
  getCookieStringSync(t, a) {
    return this.callSync(
      a ? this.getCookieString.bind(this, t, a) : this.getCookieString.bind(this, t)
    ) ?? "";
  }
  /**
   * @internal No doc because this is the overload implementation
   */
  getSetCookieStrings(t, a, o) {
    typeof a == "function" && (o = a, a = void 0);
    const n = nt(
      o
    ), r = function(i, s) {
      i ? n.callback(i) : n.callback(
        null,
        s?.map((l) => l.toString())
      );
    };
    return this.getCookies(t, a, r), n.promise;
  }
  /**
   * Synchronous version of `.getSetCookieStrings()`. Returns an array of strings suitable for `Set-Cookie` headers.
   * Accepts the same options as `.getCookies()`.
   *
   * <strong>Note</strong>: Only works if the configured Store is also synchronous.
   *
   * @param url - The domain to store the cookie with.
   * @param options - Configuration settings to use when retrieving the cookies.
   */
  getSetCookieStringsSync(t, a = {}) {
    return this.callSync(this.getSetCookieStrings.bind(this, t, a)) ?? [];
  }
  /**
   * @internal No doc because this is the overload implementation
   */
  serialize(t) {
    const a = nt(t);
    let o = this.store.constructor.name;
    li(o) && (o = null);
    const n = {
      // The version of tough-cookie that serialized this jar. Generally a good
      // practice since future versions can make data import decisions based on
      // known past behavior. When/if this matters, use `semver`.
      version: `tough-cookie@${K0e}`,
      // add the store type, to make humans happy:
      storeType: o,
      // CookieJar configuration:
      rejectPublicSuffixes: this.rejectPublicSuffixes,
      enableLooseMode: this.enableLooseMode,
      allowSpecialUseDomain: this.allowSpecialUseDomain,
      prefixSecurity: Ir(this.prefixSecurity),
      // this gets filled from getAllCookies:
      cookies: []
    };
    return typeof this.store.getAllCookies != "function" ? a.reject(
      new Error(
        "store does not support getAllCookies and cannot be serialized"
      )
    ) : (this.store.getAllCookies((r, i) => {
      if (r) {
        a.callback(r);
        return;
      }
      if (i == null) {
        a.callback(null, n);
        return;
      }
      n.cookies = i.map((s) => {
        const l = s.toJSON();
        return delete l.creationIndex, l;
      }), a.callback(null, n);
    }), a.promise);
  }
  /**
   * Serialize the CookieJar if the underlying store supports `.getAllCookies`.
   *
   * <strong>Note</strong>: Only works if the configured Store is also synchronous.
   */
  serializeSync() {
    return this.callSync((t) => {
      this.serialize(t);
    });
  }
  /**
   * Alias of {@link CookieJar.serializeSync}. Allows the cookie to be serialized
   * with `JSON.stringify(cookieJar)`.
   */
  toJSON() {
    return this.serializeSync();
  }
  /**
   * Use the class method CookieJar.deserialize instead of calling this directly
   * @internal
   */
  _importCookies(t, a) {
    let o;
    if (t && typeof t == "object" && Dn("cookies", t) && Array.isArray(t.cookies) && (o = t.cookies), !o) {
      a(new Error("serialized jar has no cookies array"), void 0);
      return;
    }
    o = o.slice();
    const n = (r) => {
      if (r) {
        a(r, void 0);
        return;
      }
      if (Array.isArray(o)) {
        if (!o.length) {
          a(r, this);
          return;
        }
        let i;
        try {
          i = vt.fromJSON(o.shift());
        } catch (s) {
          a(s instanceof Error ? s : new Error(), void 0);
          return;
        }
        if (i === void 0) {
          n(null);
          return;
        }
        this.store.putCookie(i, n);
      }
    };
    n(null);
  }
  /**
   * @internal
   */
  _importCookiesSync(t) {
    this.callSync(this._importCookies.bind(this, t));
  }
  /**
   * @internal No doc because this is the overload implementation
   */
  clone(t, a) {
    typeof t == "function" && (a = t, t = void 0);
    const o = nt(a), n = o.callback;
    return this.serialize((r, i) => r ? o.reject(r) : $n.deserialize(i ?? "", t, n)), o.promise;
  }
  /**
   * @internal
   */
  _cloneSync(t) {
    const a = t && typeof t != "function" ? this.clone.bind(this, t) : this.clone.bind(this);
    return this.callSync((o) => {
      a(o);
    });
  }
  /**
   * Produces a deep clone of this CookieJar. Modifications to the original do
   * not affect the clone, and vice versa.
   *
   * <strong>Note</strong>: Only works if both the configured Store and destination
   * Store are synchronous.
   *
   * @remarks
   * - When no {@link Store} is provided, a new {@link MemoryCookieStore} will be used.
   *
   * - Transferring between store types is supported so long as the source
   *     implements `.getAllCookies()` and the destination implements `.putCookie()`.
   *
   * @param newStore - The target {@link Store} to clone cookies into.
   */
  cloneSync(t) {
    if (!t)
      return this._cloneSync();
    if (!t.synchronous)
      throw new Error(
        "CookieJar clone destination store is not synchronous; use async API instead."
      );
    return this._cloneSync(t);
  }
  /**
   * @internal No doc because this is the overload implementation
   */
  removeAllCookies(t) {
    const a = nt(t), o = a.callback, n = this.store;
    return typeof n.removeAllCookies == "function" && n.removeAllCookies !== By.prototype.removeAllCookies ? (n.removeAllCookies(o), a.promise) : (n.getAllCookies((r, i) => {
      if (r) {
        o(r);
        return;
      }
      if (i || (i = []), i.length === 0) {
        o(null, void 0);
        return;
      }
      let s = 0;
      const l = [], c = function(u) {
        if (u && l.push(u), s++, s === i.length) {
          l[0] ? o(l[0]) : o(null, void 0);
          return;
        }
      };
      i.forEach((u) => {
        n.removeCookie(
          u.domain,
          u.path,
          u.key,
          c
        );
      });
    }), a.promise);
  }
  /**
   * Removes all cookies from the CookieJar.
   *
   * <strong>Note</strong>: Only works if the configured Store is also synchronous.
   *
   * @remarks
   * - This is a new backwards-compatible feature of tough-cookie version 2.5,
   *     so not all Stores will implement it efficiently. For Stores that do not
   *     implement `removeAllCookies`, the fallback is to call `removeCookie` after
   *     `getAllCookies`.
   *
   * - If `getAllCookies` fails or isn't implemented in the Store, an error is returned.
   *
   * - If one or more of the `removeCookie` calls fail, only the first error is returned.
   */
  removeAllCookiesSync() {
    this.callSync((t) => {
      this.removeAllCookies(t);
    });
  }
  /**
   * @internal No doc because this is the overload implementation
   */
  static deserialize(t, a, o) {
    typeof a == "function" && (o = a, a = void 0);
    const n = nt(o);
    let r;
    if (typeof t == "string")
      try {
        r = JSON.parse(t);
      } catch (u) {
        return n.reject(u instanceof Error ? u : new Error());
      }
    else
      r = t;
    const i = (u) => r && typeof r == "object" && Dn(u, r) ? r[u] : void 0, s = (u) => {
      const d = i(u);
      return typeof d == "boolean" ? d : void 0;
    }, l = (u) => {
      const d = i(u);
      return typeof d == "string" ? d : void 0;
    }, c = new $n(a, {
      rejectPublicSuffixes: s("rejectPublicSuffixes"),
      looseMode: s("enableLooseMode"),
      allowSpecialUseDomain: s("allowSpecialUseDomain"),
      prefixSecurity: Ir(
        l("prefixSecurity") ?? "silent"
      )
    });
    return c._importCookies(r, (u) => {
      if (u) {
        n.callback(u);
        return;
      }
      n.callback(null, c);
    }), n.promise;
  }
  /**
   * A new CookieJar is created and the serialized {@link Cookie} values are added to
   * the underlying store. Each {@link Cookie} is added via `store.putCookie(...)` in
   * the order in which they appear in the serialization.
   *
   * <strong>Note</strong>: Only works if the configured Store is also synchronous.
   *
   * @remarks
   * - When no {@link Store} is provided, a new {@link MemoryCookieStore} will be used.
   *
   * - As a convenience, if `strOrObj` is a string, it is passed through `JSON.parse` first.
   *
   * @param strOrObj - A JSON string or object representing the deserialized cookies.
   * @param store - The underlying store to persist the deserialized cookies into.
   */
  static deserializeSync(t, a) {
    const o = typeof t == "string" ? JSON.parse(t) : t, n = (l) => o && typeof o == "object" && Dn(l, o) ? o[l] : void 0, r = (l) => {
      const c = n(l);
      return typeof c == "boolean" ? c : void 0;
    }, i = (l) => {
      const c = n(l);
      return typeof c == "string" ? c : void 0;
    }, s = new $n(a, {
      rejectPublicSuffixes: r("rejectPublicSuffixes"),
      looseMode: r("enableLooseMode"),
      allowSpecialUseDomain: r("allowSpecialUseDomain"),
      prefixSecurity: Ir(
        i("prefixSecurity") ?? "silent"
      )
    });
    if (!s.store.synchronous)
      throw new Error(
        "CookieJar store is not synchronous; use async API instead."
      );
    return s._importCookiesSync(o), s;
  }
  /**
   * Alias of {@link CookieJar.deserializeSync}.
   *
   * @remarks
   * - When no {@link Store} is provided, a new {@link MemoryCookieStore} will be used.
   *
   * - As a convenience, if `strOrObj` is a string, it is passed through `JSON.parse` first.
   *
   * @param jsonString - A JSON string or object representing the deserialized cookies.
   * @param store - The underlying store to persist the deserialized cookies into.
   */
  static fromJSON(t, a) {
    return $n.deserializeSync(t, a);
  }
};
/*!
 * Copyright (c) 2015-2020, Salesforce.com, Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice,
 * this list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 * this list of conditions and the following disclaimer in the documentation
 * and/or other materials provided with the distribution.
 *
 * 3. Neither the name of Salesforce.com nor the names of its contributors may
 * be used to endorse or promote products derived from this software without
 * specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */
function vCe(e) {
  try {
    return JSON.parse(e);
  } catch {
    return;
  }
}
let yCe = class {
  #a = "__msw-cookie-store__";
  #t;
  #e;
  constructor() {
    Ny() || gd(
      typeof localStorage < "u",
      "Failed to create a CookieStore: `localStorage` is not available in this environment. This is likely an issue with your environment, which has been detected as browser (or browser-like) environment and must implement global browser APIs correctly."
    ), this.#e = new Vy(), this.#e.idx = this.getCookieStoreIndex(), this.#t = new _Ce(this.#e);
  }
  getCookies(t) {
    return this.#t.getCookiesSync(t);
  }
  async setCookie(t, a) {
    await this.#t.setCookie(t, a), this.persist();
  }
  getCookieStoreIndex() {
    if (typeof localStorage > "u")
      return {};
    const t = localStorage.getItem(this.#a);
    if (t == null)
      return {};
    const a = vCe(t);
    if (a == null)
      return {};
    const o = {};
    for (const n of a) {
      const r = vt.fromJSON(n);
      r != null && r.domain != null && r.path != null && (o[r.domain] ||= {}, o[r.domain][r.path] ||= {}, o[r.domain][r.path][r.key] = r);
    }
    return o;
  }
  persist() {
    if (typeof localStorage > "u")
      return;
    const t = [], { idx: a } = this.#e;
    for (const o in a)
      for (const n in a[o])
        for (const r in a[o][n])
          t.push(a[o][n][r].toJSON());
    localStorage.setItem(this.#a, JSON.stringify(t));
  }
};
const wCe = new yCe();
function Hy(e) {
  const t = Ly.parse(e), a = {};
  for (const o in t)
    typeof t[o] < "u" && (a[o] = t[o]);
  return a;
}
function $p() {
  return Hy(document.cookie);
}
function kCe(e) {
  if (typeof document > "u" || typeof location > "u")
    return {};
  switch (e.credentials) {
    case "same-origin": {
      const t = new URL(e.url);
      return location.origin === t.origin ? $p() : {};
    }
    case "include":
      return $p();
    default:
      return {};
  }
}
function xCe(e) {
  const t = e.headers.get("cookie"), a = t ? Hy(t) : {}, o = kCe(e);
  for (const i in o)
    e.headers.append(
      "cookie",
      Ly.serialize(i, o[i])
    );
  const n = wCe.getCookies(e.url), r = Object.fromEntries(
    n.map((i) => [i.key, i.value])
  );
  for (const i of n)
    e.headers.append("cookie", i.toString());
  return {
    ...o,
    ...r,
    ...a
  };
}
var Oa = /* @__PURE__ */ ((e) => (e.HEAD = "HEAD", e.GET = "GET", e.POST = "POST", e.PUT = "PUT", e.PATCH = "PATCH", e.OPTIONS = "OPTIONS", e.DELETE = "DELETE", e))(Oa || {});
let $Ce = class extends Mi {
  constructor(t, a, o, n) {
    const r = typeof a == "function" ? "[custom predicate]" : a;
    super({
      info: {
        header: `${t}${r ? ` ${r}` : ""}`,
        path: a,
        method: t
      },
      resolver: o,
      options: n
    }), this.checkRedundantQueryParameters();
  }
  checkRedundantQueryParameters() {
    const { method: t, path: a } = this.info;
    !a || a instanceof RegExp || typeof a == "function" || Ry(a) === a || (g0e(a).forEach((o, n) => {
    }), Ac.warn(
      `Found a redundant usage of query parameters in the request handler URL for "${t} ${a}". Please match against a path instead and access query parameters using "new URL(request.url).searchParams" instead. Learn more: https://mswjs.io/docs/http/intercepting-requests#querysearch-parameters`
    ));
  }
  async parse(t) {
    const a = new URL(t.request.url), o = xCe(t.request);
    if (typeof this.info.path == "function") {
      const n = await this.info.path({
        request: t.request,
        cookies: o
      });
      return {
        match: typeof n == "boolean" ? {
          matches: n,
          params: {}
        } : n,
        cookies: o
      };
    }
    return {
      match: this.info.path ? b0e(a, this.info.path, t.resolutionContext?.baseUrl) : { matches: !1, params: {} },
      cookies: o
    };
  }
  async predicate(t) {
    const a = this.matchMethod(t.request.method), o = t.parsedResult.match.matches;
    return a && o;
  }
  matchMethod(t) {
    return this.info.method instanceof RegExp ? this.info.method.test(t) : PSe(this.info.method, t);
  }
  extendResolverArgs(t) {
    return {
      params: t.parsedResult.match?.params || {},
      cookies: t.parsedResult.cookies
    };
  }
  async log(t) {
    const a = _0e(t.request.url), o = await RSe(t.request), n = await HSe(t.response), r = DSe(n.status);
    console.groupCollapsed(
      Ac.formatMessage(
        `${NSe()} ${t.request.method} ${a} (%c${n.status} ${n.statusText}%c)`
      ),
      `color:${r}`,
      "color:inherit"
    ), console.log("Request", o), console.log("Handler:", this), console.log("Response", n), console.groupEnd();
  }
};
function qa(e) {
  return (t, a, o = {}) => new $Ce(e, t, a, o);
}
qa(Oa.HEAD), qa(Oa.GET), qa(Oa.POST), qa(Oa.PUT), qa(Oa.DELETE), qa(Oa.PATCH), qa(Oa.OPTIONS);
var SCe = Object.create, Gy = Object.defineProperty, CCe = Object.getOwnPropertyDescriptor, Ky = Object.getOwnPropertyNames, ECe = Object.getPrototypeOf, jCe = Object.prototype.hasOwnProperty, OCe = (e, t) => function() {
  return t || (0, e[Ky(e)[0]])((t = { exports: {} }).exports, t), t.exports;
}, zCe = (e, t, a, o) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let n of Ky(t))
      !jCe.call(e, n) && n !== a && Gy(e, n, { get: () => t[n], enumerable: !(o = CCe(t, n)) || o.enumerable });
  return e;
}, ACe = (e, t, a) => (a = e != null ? SCe(ECe(e)) : {}, zCe(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  !e || !e.__esModule ? Gy(a, "default", { value: e, enumerable: !0 }) : a,
  e
)), PCe = OCe({
  "node_modules/set-cookie-parser/lib/set-cookie.js"(e, t) {
    var a = {
      decodeValues: !0,
      map: !1,
      silent: !1
    };
    function o(l) {
      return typeof l == "string" && !!l.trim();
    }
    function n(l, c) {
      var u = l.split(";").filter(o), d = u.shift(), h = r(d), m = h.name, f = h.value;
      c = c ? Object.assign({}, a, c) : a;
      try {
        f = c.decodeValues ? decodeURIComponent(f) : f;
      } catch (b) {
        console.error(
          "set-cookie-parser encountered an error while decoding a cookie with value '" + f + "'. Set options.decodeValues to false to disable this feature.",
          b
        );
      }
      var p = {
        name: m,
        value: f
      };
      return u.forEach(function(b) {
        var w = b.split("="), _ = w.shift().trimLeft().toLowerCase(), y = w.join("=");
        _ === "expires" ? p.expires = new Date(y) : _ === "max-age" ? p.maxAge = parseInt(y, 10) : _ === "secure" ? p.secure = !0 : _ === "httponly" ? p.httpOnly = !0 : _ === "samesite" ? p.sameSite = y : p[_] = y;
      }), p;
    }
    function r(l) {
      var c = "", u = "", d = l.split("=");
      return d.length > 1 ? (c = d.shift(), u = d.join("=")) : u = l, { name: c, value: u };
    }
    function i(l, c) {
      if (c = c ? Object.assign({}, a, c) : a, !l)
        return c.map ? {} : [];
      if (l.headers)
        if (typeof l.headers.getSetCookie == "function")
          l = l.headers.getSetCookie();
        else if (l.headers["set-cookie"])
          l = l.headers["set-cookie"];
        else {
          var u = l.headers[Object.keys(l.headers).find(function(h) {
            return h.toLowerCase() === "set-cookie";
          })];
          !u && l.headers.cookie && !c.silent && console.warn(
            "Warning: set-cookie-parser appears to have been called on a request object. It is designed to parse Set-Cookie headers from responses, not Cookie headers from requests. Set the option {silent: true} to suppress this warning."
          ), l = u;
        }
      if (Array.isArray(l) || (l = [l]), c = c ? Object.assign({}, a, c) : a, c.map) {
        var d = {};
        return l.filter(o).reduce(function(h, m) {
          var f = n(m, c);
          return h[f.name] = f, h;
        }, d);
      } else
        return l.filter(o).map(function(h) {
          return n(h, c);
        });
    }
    function s(l) {
      if (Array.isArray(l))
        return l;
      if (typeof l != "string")
        return [];
      var c = [], u = 0, d, h, m, f, p;
      function b() {
        for (; u < l.length && /\s/.test(l.charAt(u)); )
          u += 1;
        return u < l.length;
      }
      function w() {
        return h = l.charAt(u), h !== "=" && h !== ";" && h !== ",";
      }
      for (; u < l.length; ) {
        for (d = u, p = !1; b(); )
          if (h = l.charAt(u), h === ",") {
            for (m = u, u += 1, b(), f = u; u < l.length && w(); )
              u += 1;
            u < l.length && l.charAt(u) === "=" ? (p = !0, u = f, c.push(l.substring(d, m)), d = u) : u = m + 1;
          } else
            u += 1;
        (!p || u >= l.length) && c.push(l.substring(d, l.length));
      }
      return c;
    }
    t.exports = i, t.exports.parse = i, t.exports.parseString = n, t.exports.splitCookiesString = s;
  }
});
ACe(PCe());
const { message: Yrt } = zy;
ESe();
async function DCe() {
  return vw.post("/legacy-auth/logout");
}
class Sp extends Error {
  code;
  errorData;
  constructor(t, a, o) {
    super(t), this.name = "HeError", this.code = a, this.errorData = o;
  }
}
function Jy(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: NCe } = Object.prototype, { getPrototypeOf: _d } = Object, { iterator: Ps, toStringTag: Zy } = Symbol, Ds = /* @__PURE__ */ ((e) => (t) => {
  const a = NCe.call(t);
  return e[a] || (e[a] = a.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Bt = (e) => (e = e.toLowerCase(), (t) => Ds(t) === e), Ns = (e) => (t) => typeof t === e, { isArray: sn } = Array, Qo = Ns("undefined");
function rr(e) {
  return e !== null && !Qo(e) && e.constructor !== null && !Qo(e.constructor) && ht(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Yy = Bt("ArrayBuffer");
function RCe(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Yy(e.buffer), t;
}
const ICe = Ns("string"), ht = Ns("function"), Xy = Ns("number"), ir = (e) => e !== null && typeof e == "object", TCe = (e) => e === !0 || e === !1, ci = (e) => {
  if (Ds(e) !== "object")
    return !1;
  const t = _d(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Zy in e) && !(Ps in e);
}, LCe = (e) => {
  if (!ir(e) || rr(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, MCe = Bt("Date"), WCe = Bt("File"), BCe = Bt("Blob"), FCe = Bt("FileList"), VCe = (e) => ir(e) && ht(e.pipe), UCe = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || ht(e.append) && ((t = Ds(e)) === "formdata" || // detect form-data instance
  t === "object" && ht(e.toString) && e.toString() === "[object FormData]"));
}, qCe = Bt("URLSearchParams"), [HCe, GCe, KCe, JCe] = ["ReadableStream", "Request", "Response", "Headers"].map(Bt), ZCe = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function sr(e, t, { allOwnKeys: a = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let o, n;
  if (typeof e != "object" && (e = [e]), sn(e))
    for (o = 0, n = e.length; o < n; o++)
      t.call(null, e[o], o, e);
  else {
    if (rr(e))
      return;
    const r = a ? Object.getOwnPropertyNames(e) : Object.keys(e), i = r.length;
    let s;
    for (o = 0; o < i; o++)
      s = r[o], t.call(null, e[s], s, e);
  }
}
function Qy(e, t) {
  if (rr(e))
    return null;
  t = t.toLowerCase();
  const a = Object.keys(e);
  let o = a.length, n;
  for (; o-- > 0; )
    if (n = a[o], t === n.toLowerCase())
      return n;
  return null;
}
const Ja = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, ew = (e) => !Qo(e) && e !== Ja;
function Rc() {
  const { caseless: e, skipUndefined: t } = ew(this) && this || {}, a = {}, o = (n, r) => {
    const i = e && Qy(a, r) || r;
    ci(a[i]) && ci(n) ? a[i] = Rc(a[i], n) : ci(n) ? a[i] = Rc({}, n) : sn(n) ? a[i] = n.slice() : (!t || !Qo(n)) && (a[i] = n);
  };
  for (let n = 0, r = arguments.length; n < r; n++)
    arguments[n] && sr(arguments[n], o);
  return a;
}
const YCe = (e, t, a, { allOwnKeys: o } = {}) => (sr(t, (n, r) => {
  a && ht(n) ? e[r] = Jy(n, a) : e[r] = n;
}, { allOwnKeys: o }), e), XCe = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), QCe = (e, t, a, o) => {
  e.prototype = Object.create(t.prototype, o), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), a && Object.assign(e.prototype, a);
}, eEe = (e, t, a, o) => {
  let n, r, i;
  const s = {};
  if (t = t || {}, e == null) return t;
  do {
    for (n = Object.getOwnPropertyNames(e), r = n.length; r-- > 0; )
      i = n[r], (!o || o(i, e, t)) && !s[i] && (t[i] = e[i], s[i] = !0);
    e = a !== !1 && _d(e);
  } while (e && (!a || a(e, t)) && e !== Object.prototype);
  return t;
}, tEe = (e, t, a) => {
  e = String(e), (a === void 0 || a > e.length) && (a = e.length), a -= t.length;
  const o = e.indexOf(t, a);
  return o !== -1 && o === a;
}, aEe = (e) => {
  if (!e) return null;
  if (sn(e)) return e;
  let t = e.length;
  if (!Xy(t)) return null;
  const a = new Array(t);
  for (; t-- > 0; )
    a[t] = e[t];
  return a;
}, oEe = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && _d(Uint8Array)), nEe = (e, t) => {
  const a = (e && e[Ps]).call(e);
  let o;
  for (; (o = a.next()) && !o.done; ) {
    const n = o.value;
    t.call(e, n[0], n[1]);
  }
}, rEe = (e, t) => {
  let a;
  const o = [];
  for (; (a = e.exec(t)) !== null; )
    o.push(a);
  return o;
}, iEe = Bt("HTMLFormElement"), sEe = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(t, a, o) {
    return a.toUpperCase() + o;
  }
), Cp = (({ hasOwnProperty: e }) => (t, a) => e.call(t, a))(Object.prototype), lEe = Bt("RegExp"), tw = (e, t) => {
  const a = Object.getOwnPropertyDescriptors(e), o = {};
  sr(a, (n, r) => {
    let i;
    (i = t(n, r, e)) !== !1 && (o[r] = i || n);
  }), Object.defineProperties(e, o);
}, cEe = (e) => {
  tw(e, (t, a) => {
    if (ht(e) && ["arguments", "caller", "callee"].indexOf(a) !== -1)
      return !1;
    const o = e[a];
    if (ht(o)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + a + "'");
      });
    }
  });
}, uEe = (e, t) => {
  const a = {}, o = (n) => {
    n.forEach((r) => {
      a[r] = !0;
    });
  };
  return sn(e) ? o(e) : o(String(e).split(t)), a;
}, dEe = () => {
}, gEe = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function hEe(e) {
  return !!(e && ht(e.append) && e[Zy] === "FormData" && e[Ps]);
}
const pEe = (e) => {
  const t = new Array(10), a = (o, n) => {
    if (ir(o)) {
      if (t.indexOf(o) >= 0)
        return;
      if (rr(o))
        return o;
      if (!("toJSON" in o)) {
        t[n] = o;
        const r = sn(o) ? [] : {};
        return sr(o, (i, s) => {
          const l = a(i, n + 1);
          !Qo(l) && (r[s] = l);
        }), t[n] = void 0, r;
      }
    }
    return o;
  };
  return a(e, 0);
}, mEe = Bt("AsyncFunction"), fEe = (e) => e && (ir(e) || ht(e)) && ht(e.then) && ht(e.catch), aw = ((e, t) => e ? setImmediate : t ? ((a, o) => (Ja.addEventListener("message", ({ source: n, data: r }) => {
  n === Ja && r === a && o.length && o.shift()();
}, !1), (n) => {
  o.push(n), Ja.postMessage(a, "*");
}))(`axios@${Math.random()}`, []) : (a) => setTimeout(a))(
  typeof setImmediate == "function",
  ht(Ja.postMessage)
), bEe = typeof queueMicrotask < "u" ? queueMicrotask.bind(Ja) : typeof process < "u" && process.nextTick || aw, _Ee = (e) => e != null && ht(e[Ps]), D = {
  isArray: sn,
  isArrayBuffer: Yy,
  isBuffer: rr,
  isFormData: UCe,
  isArrayBufferView: RCe,
  isString: ICe,
  isNumber: Xy,
  isBoolean: TCe,
  isObject: ir,
  isPlainObject: ci,
  isEmptyObject: LCe,
  isReadableStream: HCe,
  isRequest: GCe,
  isResponse: KCe,
  isHeaders: JCe,
  isUndefined: Qo,
  isDate: MCe,
  isFile: WCe,
  isBlob: BCe,
  isRegExp: lEe,
  isFunction: ht,
  isStream: VCe,
  isURLSearchParams: qCe,
  isTypedArray: oEe,
  isFileList: FCe,
  forEach: sr,
  merge: Rc,
  extend: YCe,
  trim: ZCe,
  stripBOM: XCe,
  inherits: QCe,
  toFlatObject: eEe,
  kindOf: Ds,
  kindOfTest: Bt,
  endsWith: tEe,
  toArray: aEe,
  forEachEntry: nEe,
  matchAll: rEe,
  isHTMLForm: iEe,
  hasOwnProperty: Cp,
  hasOwnProp: Cp,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: tw,
  freezeMethods: cEe,
  toObjectSet: uEe,
  toCamelCase: sEe,
  noop: dEe,
  toFiniteNumber: gEe,
  findKey: Qy,
  global: Ja,
  isContextDefined: ew,
  isSpecCompliantForm: hEe,
  toJSONObject: pEe,
  isAsyncFn: mEe,
  isThenable: fEe,
  setImmediate: aw,
  asap: bEe,
  isIterable: _Ee
};
function he(e, t, a, o, n) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), a && (this.config = a), o && (this.request = o), n && (this.response = n, this.status = n.status ? n.status : null);
}
D.inherits(he, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: D.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const ow = he.prototype, nw = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  nw[e] = { value: e };
});
Object.defineProperties(he, nw);
Object.defineProperty(ow, "isAxiosError", { value: !0 });
he.from = (e, t, a, o, n, r) => {
  const i = Object.create(ow);
  D.toFlatObject(e, i, function(c) {
    return c !== Error.prototype;
  }, (c) => c !== "isAxiosError");
  const s = e && e.message ? e.message : "Error", l = t == null && e ? e.code : t;
  return he.call(i, s, l, a, o, n), e && i.cause == null && Object.defineProperty(i, "cause", { value: e, configurable: !0 }), i.name = e && e.name || "Error", r && Object.assign(i, r), i;
};
const vEe = null;
function Ic(e) {
  return D.isPlainObject(e) || D.isArray(e);
}
function rw(e) {
  return D.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Ep(e, t, a) {
  return e ? e.concat(t).map(function(o, n) {
    return o = rw(o), !a && n ? "[" + o + "]" : o;
  }).join(a ? "." : "") : t;
}
function yEe(e) {
  return D.isArray(e) && !e.some(Ic);
}
const wEe = D.toFlatObject(D, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function Rs(e, t, a) {
  if (!D.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), a = D.toFlatObject(a, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(m, f) {
    return !D.isUndefined(f[m]);
  });
  const o = a.metaTokens, n = a.visitor || c, r = a.dots, i = a.indexes, s = (a.Blob || typeof Blob < "u" && Blob) && D.isSpecCompliantForm(t);
  if (!D.isFunction(n))
    throw new TypeError("visitor must be a function");
  function l(m) {
    if (m === null) return "";
    if (D.isDate(m))
      return m.toISOString();
    if (D.isBoolean(m))
      return m.toString();
    if (!s && D.isBlob(m))
      throw new he("Blob is not supported. Use a Buffer instead.");
    return D.isArrayBuffer(m) || D.isTypedArray(m) ? s && typeof Blob == "function" ? new Blob([m]) : Buffer.from(m) : m;
  }
  function c(m, f, p) {
    let b = m;
    if (m && !p && typeof m == "object") {
      if (D.endsWith(f, "{}"))
        f = o ? f : f.slice(0, -2), m = JSON.stringify(m);
      else if (D.isArray(m) && yEe(m) || (D.isFileList(m) || D.endsWith(f, "[]")) && (b = D.toArray(m)))
        return f = rw(f), b.forEach(function(w, _) {
          !(D.isUndefined(w) || w === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            i === !0 ? Ep([f], _, r) : i === null ? f : f + "[]",
            l(w)
          );
        }), !1;
    }
    return Ic(m) ? !0 : (t.append(Ep(p, f, r), l(m)), !1);
  }
  const u = [], d = Object.assign(wEe, {
    defaultVisitor: c,
    convertValue: l,
    isVisitable: Ic
  });
  function h(m, f) {
    if (!D.isUndefined(m)) {
      if (u.indexOf(m) !== -1)
        throw Error("Circular reference detected in " + f.join("."));
      u.push(m), D.forEach(m, function(p, b) {
        (!(D.isUndefined(p) || p === null) && n.call(
          t,
          p,
          D.isString(b) ? b.trim() : b,
          f,
          d
        )) === !0 && h(p, f ? f.concat(b) : [b]);
      }), u.pop();
    }
  }
  if (!D.isObject(e))
    throw new TypeError("data must be an object");
  return h(e), t;
}
function jp(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(a) {
    return t[a];
  });
}
function vd(e, t) {
  this._pairs = [], e && Rs(e, this, t);
}
const iw = vd.prototype;
iw.append = function(e, t) {
  this._pairs.push([e, t]);
};
iw.toString = function(e) {
  const t = e ? function(a) {
    return e.call(this, a, jp);
  } : jp;
  return this._pairs.map(function(a) {
    return t(a[0]) + "=" + t(a[1]);
  }, "").join("&");
};
function kEe(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function sw(e, t, a) {
  if (!t)
    return e;
  const o = a && a.encode || kEe;
  D.isFunction(a) && (a = {
    serialize: a
  });
  const n = a && a.serialize;
  let r;
  if (n ? r = n(t, a) : r = D.isURLSearchParams(t) ? t.toString() : new vd(t, a).toString(o), r) {
    const i = e.indexOf("#");
    i !== -1 && (e = e.slice(0, i)), e += (e.indexOf("?") === -1 ? "?" : "&") + r;
  }
  return e;
}
let Op = class {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, a, o) {
    return this.handlers.push({
      fulfilled: t,
      rejected: a,
      synchronous: o ? o.synchronous : !1,
      runWhen: o ? o.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    D.forEach(this.handlers, function(a) {
      a !== null && t(a);
    });
  }
};
const lw = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, xEe = typeof URLSearchParams < "u" ? URLSearchParams : vd, $Ee = typeof FormData < "u" ? FormData : null, SEe = typeof Blob < "u" ? Blob : null, CEe = {
  isBrowser: !0,
  classes: {
    URLSearchParams: xEe,
    FormData: $Ee,
    Blob: SEe
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, yd = typeof window < "u" && typeof document < "u", Tc = typeof navigator == "object" && navigator || void 0, EEe = yd && (!Tc || ["ReactNative", "NativeScript", "NS"].indexOf(Tc.product) < 0), jEe = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", OEe = yd && window.location.href || "http://localhost", zEe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: yd,
  hasStandardBrowserEnv: EEe,
  hasStandardBrowserWebWorkerEnv: jEe,
  navigator: Tc,
  origin: OEe
}, Symbol.toStringTag, { value: "Module" })), at = {
  ...zEe,
  ...CEe
};
function AEe(e, t) {
  return Rs(e, new at.classes.URLSearchParams(), {
    visitor: function(a, o, n, r) {
      return at.isNode && D.isBuffer(a) ? (this.append(o, a.toString("base64")), !1) : r.defaultVisitor.apply(this, arguments);
    },
    ...t
  });
}
function PEe(e) {
  return D.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function DEe(e) {
  const t = {}, a = Object.keys(e);
  let o;
  const n = a.length;
  let r;
  for (o = 0; o < n; o++)
    r = a[o], t[r] = e[r];
  return t;
}
function cw(e) {
  function t(a, o, n, r) {
    let i = a[r++];
    if (i === "__proto__") return !0;
    const s = Number.isFinite(+i), l = r >= a.length;
    return i = !i && D.isArray(n) ? n.length : i, l ? (D.hasOwnProp(n, i) ? n[i] = [n[i], o] : n[i] = o, !s) : ((!n[i] || !D.isObject(n[i])) && (n[i] = []), t(a, o, n[i], r) && D.isArray(n[i]) && (n[i] = DEe(n[i])), !s);
  }
  if (D.isFormData(e) && D.isFunction(e.entries)) {
    const a = {};
    return D.forEachEntry(e, (o, n) => {
      t(PEe(o), n, a, 0);
    }), a;
  }
  return null;
}
function NEe(e, t, a) {
  if (D.isString(e))
    try {
      return (t || JSON.parse)(e), D.trim(e);
    } catch (o) {
      if (o.name !== "SyntaxError")
        throw o;
    }
  return (a || JSON.stringify)(e);
}
const lr = {
  transitional: lw,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, t) {
    const a = t.getContentType() || "", o = a.indexOf("application/json") > -1, n = D.isObject(e);
    if (n && D.isHTMLForm(e) && (e = new FormData(e)), D.isFormData(e))
      return o ? JSON.stringify(cw(e)) : e;
    if (D.isArrayBuffer(e) || D.isBuffer(e) || D.isStream(e) || D.isFile(e) || D.isBlob(e) || D.isReadableStream(e))
      return e;
    if (D.isArrayBufferView(e))
      return e.buffer;
    if (D.isURLSearchParams(e))
      return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let r;
    if (n) {
      if (a.indexOf("application/x-www-form-urlencoded") > -1)
        return AEe(e, this.formSerializer).toString();
      if ((r = D.isFileList(e)) || a.indexOf("multipart/form-data") > -1) {
        const i = this.env && this.env.FormData;
        return Rs(
          r ? { "files[]": e } : e,
          i && new i(),
          this.formSerializer
        );
      }
    }
    return n || o ? (t.setContentType("application/json", !1), NEe(e)) : e;
  }],
  transformResponse: [function(e) {
    const t = this.transitional || lr.transitional, a = t && t.forcedJSONParsing, o = this.responseType === "json";
    if (D.isResponse(e) || D.isReadableStream(e))
      return e;
    if (e && D.isString(e) && (a && !this.responseType || o)) {
      const n = !(t && t.silentJSONParsing) && o;
      try {
        return JSON.parse(e, this.parseReviver);
      } catch (r) {
        if (n)
          throw r.name === "SyntaxError" ? he.from(r, he.ERR_BAD_RESPONSE, this, null, this.response) : r;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: at.classes.FormData,
    Blob: at.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
D.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  lr.headers[e] = {};
});
const REe = D.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), IEe = (e) => {
  const t = {};
  let a, o, n;
  return e && e.split(`
`).forEach(function(r) {
    n = r.indexOf(":"), a = r.substring(0, n).trim().toLowerCase(), o = r.substring(n + 1).trim(), !(!a || t[a] && REe[a]) && (a === "set-cookie" ? t[a] ? t[a].push(o) : t[a] = [o] : t[a] = t[a] ? t[a] + ", " + o : o);
  }), t;
}, zp = Symbol("internals");
function kn(e) {
  return e && String(e).trim().toLowerCase();
}
function ui(e) {
  return e === !1 || e == null ? e : D.isArray(e) ? e.map(ui) : String(e);
}
function TEe(e) {
  const t = /* @__PURE__ */ Object.create(null), a = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let o;
  for (; o = a.exec(e); )
    t[o[1]] = o[2];
  return t;
}
const LEe = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Pl(e, t, a, o, n) {
  if (D.isFunction(o))
    return o.call(this, t, a);
  if (n && (t = a), !!D.isString(t)) {
    if (D.isString(o))
      return t.indexOf(o) !== -1;
    if (D.isRegExp(o))
      return o.test(t);
  }
}
function MEe(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, a, o) => a.toUpperCase() + o);
}
function WEe(e, t) {
  const a = D.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((o) => {
    Object.defineProperty(e, o + a, {
      value: function(n, r, i) {
        return this[o].call(this, t, n, r, i);
      },
      configurable: !0
    });
  });
}
let pt = class {
  constructor(e) {
    e && this.set(e);
  }
  set(e, t, a) {
    const o = this;
    function n(i, s, l) {
      const c = kn(s);
      if (!c)
        throw new Error("header name must be a non-empty string");
      const u = D.findKey(o, c);
      (!u || o[u] === void 0 || l === !0 || l === void 0 && o[u] !== !1) && (o[u || s] = ui(i));
    }
    const r = (i, s) => D.forEach(i, (l, c) => n(l, c, s));
    if (D.isPlainObject(e) || e instanceof this.constructor)
      r(e, t);
    else if (D.isString(e) && (e = e.trim()) && !LEe(e))
      r(IEe(e), t);
    else if (D.isObject(e) && D.isIterable(e)) {
      let i = {}, s, l;
      for (const c of e) {
        if (!D.isArray(c))
          throw TypeError("Object iterator must return a key-value pair");
        i[l = c[0]] = (s = i[l]) ? D.isArray(s) ? [...s, c[1]] : [s, c[1]] : c[1];
      }
      r(i, t);
    } else
      e != null && n(t, e, a);
    return this;
  }
  get(e, t) {
    if (e = kn(e), e) {
      const a = D.findKey(this, e);
      if (a) {
        const o = this[a];
        if (!t)
          return o;
        if (t === !0)
          return TEe(o);
        if (D.isFunction(t))
          return t.call(this, o, a);
        if (D.isRegExp(t))
          return t.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, t) {
    if (e = kn(e), e) {
      const a = D.findKey(this, e);
      return !!(a && this[a] !== void 0 && (!t || Pl(this, this[a], a, t)));
    }
    return !1;
  }
  delete(e, t) {
    const a = this;
    let o = !1;
    function n(r) {
      if (r = kn(r), r) {
        const i = D.findKey(a, r);
        i && (!t || Pl(a, a[i], i, t)) && (delete a[i], o = !0);
      }
    }
    return D.isArray(e) ? e.forEach(n) : n(e), o;
  }
  clear(e) {
    const t = Object.keys(this);
    let a = t.length, o = !1;
    for (; a--; ) {
      const n = t[a];
      (!e || Pl(this, this[n], n, e, !0)) && (delete this[n], o = !0);
    }
    return o;
  }
  normalize(e) {
    const t = this, a = {};
    return D.forEach(this, (o, n) => {
      const r = D.findKey(a, n);
      if (r) {
        t[r] = ui(o), delete t[n];
        return;
      }
      const i = e ? MEe(n) : String(n).trim();
      i !== n && delete t[n], t[i] = ui(o), a[i] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const t = /* @__PURE__ */ Object.create(null);
    return D.forEach(this, (a, o) => {
      a != null && a !== !1 && (t[o] = e && D.isArray(a) ? a.join(", ") : a);
    }), t;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, t]) => e + ": " + t).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...t) {
    const a = new this(e);
    return t.forEach((o) => a.set(o)), a;
  }
  static accessor(e) {
    const t = (this[zp] = this[zp] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function o(n) {
      const r = kn(n);
      t[r] || (WEe(a, n), t[r] = !0);
    }
    return D.isArray(e) ? e.forEach(o) : o(e), this;
  }
};
pt.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
D.reduceDescriptors(pt.prototype, ({ value: e }, t) => {
  let a = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(o) {
      this[a] = o;
    }
  };
});
D.freezeMethods(pt);
function Dl(e, t) {
  const a = this || lr, o = t || a, n = pt.from(o.headers);
  let r = o.data;
  return D.forEach(e, function(i) {
    r = i.call(a, r, n.normalize(), t ? t.status : void 0);
  }), n.normalize(), r;
}
function uw(e) {
  return !!(e && e.__CANCEL__);
}
function ln(e, t, a) {
  he.call(this, e ?? "canceled", he.ERR_CANCELED, t, a), this.name = "CanceledError";
}
D.inherits(ln, he, {
  __CANCEL__: !0
});
function dw(e, t, a) {
  const o = a.config.validateStatus;
  !a.status || !o || o(a.status) ? e(a) : t(new he(
    "Request failed with status code " + a.status,
    [he.ERR_BAD_REQUEST, he.ERR_BAD_RESPONSE][Math.floor(a.status / 100) - 4],
    a.config,
    a.request,
    a
  ));
}
function BEe(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function FEe(e, t) {
  e = e || 10;
  const a = new Array(e), o = new Array(e);
  let n = 0, r = 0, i;
  return t = t !== void 0 ? t : 1e3, function(s) {
    const l = Date.now(), c = o[r];
    i || (i = l), a[n] = s, o[n] = l;
    let u = r, d = 0;
    for (; u !== n; )
      d += a[u++], u = u % e;
    if (n = (n + 1) % e, n === r && (r = (r + 1) % e), l - i < t)
      return;
    const h = c && l - c;
    return h ? Math.round(d * 1e3 / h) : void 0;
  };
}
function VEe(e, t) {
  let a = 0, o = 1e3 / t, n, r;
  const i = (s, l = Date.now()) => {
    a = l, n = null, r && (clearTimeout(r), r = null), e(...s);
  };
  return [(...s) => {
    const l = Date.now(), c = l - a;
    c >= o ? i(s, l) : (n = s, r || (r = setTimeout(() => {
      r = null, i(n);
    }, o - c)));
  }, () => n && i(n)];
}
const Bi = (e, t, a = 3) => {
  let o = 0;
  const n = FEe(50, 250);
  return VEe((r) => {
    const i = r.loaded, s = r.lengthComputable ? r.total : void 0, l = i - o, c = n(l), u = i <= s;
    o = i;
    const d = {
      loaded: i,
      total: s,
      progress: s ? i / s : void 0,
      bytes: l,
      rate: c || void 0,
      estimated: c && s && u ? (s - i) / c : void 0,
      event: r,
      lengthComputable: s != null,
      [t ? "download" : "upload"]: !0
    };
    e(d);
  }, a);
}, Ap = (e, t) => {
  const a = e != null;
  return [(o) => t[0]({
    lengthComputable: a,
    total: e,
    loaded: o
  }), t[1]];
}, Pp = (e) => (...t) => D.asap(() => e(...t)), UEe = at.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (a) => (a = new URL(a, at.origin), e.protocol === a.protocol && e.host === a.host && (t || e.port === a.port)))(
  new URL(at.origin),
  at.navigator && /(msie|trident)/i.test(at.navigator.userAgent)
) : () => !0, qEe = at.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, a, o, n, r) {
      const i = [e + "=" + encodeURIComponent(t)];
      D.isNumber(a) && i.push("expires=" + new Date(a).toGMTString()), D.isString(o) && i.push("path=" + o), D.isString(n) && i.push("domain=" + n), r === !0 && i.push("secure"), document.cookie = i.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function HEe(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function GEe(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function gw(e, t, a) {
  let o = !HEe(t);
  return e && (o || a == !1) ? GEe(e, t) : t;
}
const Dp = (e) => e instanceof pt ? { ...e } : e;
function io(e, t) {
  t = t || {};
  const a = {};
  function o(c, u, d, h) {
    return D.isPlainObject(c) && D.isPlainObject(u) ? D.merge.call({ caseless: h }, c, u) : D.isPlainObject(u) ? D.merge({}, u) : D.isArray(u) ? u.slice() : u;
  }
  function n(c, u, d, h) {
    if (D.isUndefined(u)) {
      if (!D.isUndefined(c))
        return o(void 0, c, d, h);
    } else return o(c, u, d, h);
  }
  function r(c, u) {
    if (!D.isUndefined(u))
      return o(void 0, u);
  }
  function i(c, u) {
    if (D.isUndefined(u)) {
      if (!D.isUndefined(c))
        return o(void 0, c);
    } else return o(void 0, u);
  }
  function s(c, u, d) {
    if (d in t)
      return o(c, u);
    if (d in e)
      return o(void 0, c);
  }
  const l = {
    url: r,
    method: r,
    data: r,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    withXSRFToken: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: s,
    headers: (c, u, d) => n(Dp(c), Dp(u), d, !0)
  };
  return D.forEach(Object.keys({ ...e, ...t }), function(c) {
    const u = l[c] || n, d = u(e[c], t[c], c);
    D.isUndefined(d) && u !== s || (a[c] = d);
  }), a;
}
const hw = (e) => {
  const t = io({}, e);
  let { data: a, withXSRFToken: o, xsrfHeaderName: n, xsrfCookieName: r, headers: i, auth: s } = t;
  if (t.headers = i = pt.from(i), t.url = sw(gw(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), s && i.set(
    "Authorization",
    "Basic " + btoa((s.username || "") + ":" + (s.password ? unescape(encodeURIComponent(s.password)) : ""))
  ), D.isFormData(a)) {
    if (at.hasStandardBrowserEnv || at.hasStandardBrowserWebWorkerEnv)
      i.setContentType(void 0);
    else if (D.isFunction(a.getHeaders)) {
      const l = a.getHeaders(), c = ["content-type", "content-length"];
      Object.entries(l).forEach(([u, d]) => {
        c.includes(u.toLowerCase()) && i.set(u, d);
      });
    }
  }
  if (at.hasStandardBrowserEnv && (o && D.isFunction(o) && (o = o(t)), o || o !== !1 && UEe(t.url))) {
    const l = n && r && qEe.read(r);
    l && i.set(n, l);
  }
  return t;
}, KEe = typeof XMLHttpRequest < "u", JEe = KEe && function(e) {
  return new Promise(function(t, a) {
    const o = hw(e);
    let n = o.data;
    const r = pt.from(o.headers).normalize();
    let { responseType: i, onUploadProgress: s, onDownloadProgress: l } = o, c, u, d, h, m;
    function f() {
      h && h(), m && m(), o.cancelToken && o.cancelToken.unsubscribe(c), o.signal && o.signal.removeEventListener("abort", c);
    }
    let p = new XMLHttpRequest();
    p.open(o.method.toUpperCase(), o.url, !0), p.timeout = o.timeout;
    function b() {
      if (!p)
        return;
      const _ = pt.from(
        "getAllResponseHeaders" in p && p.getAllResponseHeaders()
      ), y = {
        data: !i || i === "text" || i === "json" ? p.responseText : p.response,
        status: p.status,
        statusText: p.statusText,
        headers: _,
        config: e,
        request: p
      };
      dw(function(k) {
        t(k), f();
      }, function(k) {
        a(k), f();
      }, y), p = null;
    }
    "onloadend" in p ? p.onloadend = b : p.onreadystatechange = function() {
      !p || p.readyState !== 4 || p.status === 0 && !(p.responseURL && p.responseURL.indexOf("file:") === 0) || setTimeout(b);
    }, p.onabort = function() {
      p && (a(new he("Request aborted", he.ECONNABORTED, e, p)), p = null);
    }, p.onerror = function(_) {
      const y = _ && _.message ? _.message : "Network Error", k = new he(y, he.ERR_NETWORK, e, p);
      k.event = _ || null, a(k), p = null;
    }, p.ontimeout = function() {
      let _ = o.timeout ? "timeout of " + o.timeout + "ms exceeded" : "timeout exceeded";
      const y = o.transitional || lw;
      o.timeoutErrorMessage && (_ = o.timeoutErrorMessage), a(new he(
        _,
        y.clarifyTimeoutError ? he.ETIMEDOUT : he.ECONNABORTED,
        e,
        p
      )), p = null;
    }, n === void 0 && r.setContentType(null), "setRequestHeader" in p && D.forEach(r.toJSON(), function(_, y) {
      p.setRequestHeader(y, _);
    }), D.isUndefined(o.withCredentials) || (p.withCredentials = !!o.withCredentials), i && i !== "json" && (p.responseType = o.responseType), l && ([d, m] = Bi(l, !0), p.addEventListener("progress", d)), s && p.upload && ([u, h] = Bi(s), p.upload.addEventListener("progress", u), p.upload.addEventListener("loadend", h)), (o.cancelToken || o.signal) && (c = (_) => {
      p && (a(!_ || _.type ? new ln(null, e, p) : _), p.abort(), p = null);
    }, o.cancelToken && o.cancelToken.subscribe(c), o.signal && (o.signal.aborted ? c() : o.signal.addEventListener("abort", c)));
    const w = BEe(o.url);
    if (w && at.protocols.indexOf(w) === -1) {
      a(new he("Unsupported protocol " + w + ":", he.ERR_BAD_REQUEST, e));
      return;
    }
    p.send(n || null);
  });
}, ZEe = (e, t) => {
  const { length: a } = e = e ? e.filter(Boolean) : [];
  if (t || a) {
    let o = new AbortController(), n;
    const r = function(c) {
      if (!n) {
        n = !0, s();
        const u = c instanceof Error ? c : this.reason;
        o.abort(u instanceof he ? u : new ln(u instanceof Error ? u.message : u));
      }
    };
    let i = t && setTimeout(() => {
      i = null, r(new he(`timeout ${t} of ms exceeded`, he.ETIMEDOUT));
    }, t);
    const s = () => {
      e && (i && clearTimeout(i), i = null, e.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(r) : c.removeEventListener("abort", r);
      }), e = null);
    };
    e.forEach((c) => c.addEventListener("abort", r));
    const { signal: l } = o;
    return l.unsubscribe = () => D.asap(s), l;
  }
}, YEe = function* (e, t) {
  let a = e.byteLength;
  if (a < t) {
    yield e;
    return;
  }
  let o = 0, n;
  for (; o < a; )
    n = o + t, yield e.slice(o, n), o = n;
}, XEe = async function* (e, t) {
  for await (const a of QEe(e))
    yield* YEe(a, t);
}, QEe = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: a, value: o } = await t.read();
      if (a)
        break;
      yield o;
    }
  } finally {
    await t.cancel();
  }
}, Np = (e, t, a, o) => {
  const n = XEe(e, t);
  let r = 0, i, s = (l) => {
    i || (i = !0, o && o(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: c, value: u } = await n.next();
        if (c) {
          s(), l.close();
          return;
        }
        let d = u.byteLength;
        if (a) {
          let h = r += d;
          a(h);
        }
        l.enqueue(new Uint8Array(u));
      } catch (c) {
        throw s(c), c;
      }
    },
    cancel(l) {
      return s(l), n.return();
    }
  }, {
    highWaterMark: 2
  });
}, Rp = 64 * 1024, { isFunction: Tr } = D, eje = (({ Request: e, Response: t }) => ({
  Request: e,
  Response: t
}))(D.global), {
  ReadableStream: Ip,
  TextEncoder: Tp
} = D.global, Lp = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, tje = (e) => {
  e = D.merge.call({
    skipUndefined: !0
  }, eje, e);
  const { fetch: t, Request: a, Response: o } = e, n = t ? Tr(t) : typeof fetch == "function", r = Tr(a), i = Tr(o);
  if (!n)
    return !1;
  const s = n && Tr(Ip), l = n && (typeof Tp == "function" ? /* @__PURE__ */ ((f) => (p) => f.encode(p))(new Tp()) : async (f) => new Uint8Array(await new a(f).arrayBuffer())), c = r && s && Lp(() => {
    let f = !1;
    const p = new a(at.origin, {
      body: new Ip(),
      method: "POST",
      get duplex() {
        return f = !0, "half";
      }
    }).headers.has("Content-Type");
    return f && !p;
  }), u = i && s && Lp(() => D.isReadableStream(new o("").body)), d = {
    stream: u && ((f) => f.body)
  };
  n && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((f) => {
    !d[f] && (d[f] = (p, b) => {
      let w = p && p[f];
      if (w)
        return w.call(p);
      throw new he(`Response type '${f}' is not supported`, he.ERR_NOT_SUPPORT, b);
    });
  });
  const h = async (f) => {
    if (f == null)
      return 0;
    if (D.isBlob(f))
      return f.size;
    if (D.isSpecCompliantForm(f))
      return (await new a(at.origin, {
        method: "POST",
        body: f
      }).arrayBuffer()).byteLength;
    if (D.isArrayBufferView(f) || D.isArrayBuffer(f))
      return f.byteLength;
    if (D.isURLSearchParams(f) && (f = f + ""), D.isString(f))
      return (await l(f)).byteLength;
  }, m = async (f, p) => D.toFiniteNumber(f.getContentLength()) ?? h(p);
  return async (f) => {
    let {
      url: p,
      method: b,
      data: w,
      signal: _,
      cancelToken: y,
      timeout: k,
      onDownloadProgress: x,
      onUploadProgress: S,
      responseType: $,
      headers: E,
      withCredentials: C = "same-origin",
      fetchOptions: j
    } = hw(f), R = t || fetch;
    $ = $ ? ($ + "").toLowerCase() : "text";
    let H = ZEe([_, y && y.toAbortSignal()], k), L = null;
    const O = H && H.unsubscribe && (() => {
      H.unsubscribe();
    });
    let U;
    try {
      if (S && c && b !== "get" && b !== "head" && (U = await m(E, w)) !== 0) {
        let z = new a(p, {
          method: "POST",
          body: w,
          duplex: "half"
        }), N;
        if (D.isFormData(w) && (N = z.headers.get("content-type")) && E.setContentType(N), z.body) {
          const [B, W] = Ap(
            U,
            Bi(Pp(S))
          );
          w = Np(z.body, Rp, B, W);
        }
      }
      D.isString(C) || (C = C ? "include" : "omit");
      const I = r && "credentials" in a.prototype, K = {
        ...j,
        signal: H,
        method: b.toUpperCase(),
        headers: E.normalize().toJSON(),
        body: w,
        duplex: "half",
        credentials: I ? C : void 0
      };
      L = r && new a(p, K);
      let q = await (r ? R(L, j) : R(p, K));
      const te = u && ($ === "stream" || $ === "response");
      if (u && (x || te && O)) {
        const z = {};
        ["status", "statusText", "headers"].forEach((Z) => {
          z[Z] = q[Z];
        });
        const N = D.toFiniteNumber(q.headers.get("content-length")), [B, W] = x && Ap(
          N,
          Bi(Pp(x), !0)
        ) || [];
        q = new o(
          Np(q.body, Rp, B, () => {
            W && W(), O && O();
          }),
          z
        );
      }
      $ = $ || "text";
      let A = await d[D.findKey(d, $) || "text"](q, f);
      return !te && O && O(), await new Promise((z, N) => {
        dw(z, N, {
          data: A,
          headers: pt.from(q.headers),
          status: q.status,
          statusText: q.statusText,
          config: f,
          request: L
        });
      });
    } catch (I) {
      throw O && O(), I && I.name === "TypeError" && /Load failed|fetch/i.test(I.message) ? Object.assign(
        new he("Network Error", he.ERR_NETWORK, f, L),
        {
          cause: I.cause || I
        }
      ) : he.from(I, I && I.code, f, L);
    }
  };
}, aje = /* @__PURE__ */ new Map(), pw = (e) => {
  let t = e ? e.env : {};
  const { fetch: a, Request: o, Response: n } = t, r = [
    o,
    n,
    a
  ];
  let i = r.length, s = i, l, c, u = aje;
  for (; s--; )
    l = r[s], c = u.get(l), c === void 0 && u.set(l, c = s ? /* @__PURE__ */ new Map() : tje(t)), u = c;
  return c;
};
pw();
const Lc = {
  http: vEe,
  xhr: JEe,
  fetch: {
    get: pw
  }
};
D.forEach(Lc, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Mp = (e) => `- ${e}`, oje = (e) => D.isFunction(e) || e === null || e === !1, mw = {
  getAdapter: (e, t) => {
    e = D.isArray(e) ? e : [e];
    const { length: a } = e;
    let o, n;
    const r = {};
    for (let i = 0; i < a; i++) {
      o = e[i];
      let s;
      if (n = o, !oje(o) && (n = Lc[(s = String(o)).toLowerCase()], n === void 0))
        throw new he(`Unknown adapter '${s}'`);
      if (n && (D.isFunction(n) || (n = n.get(t))))
        break;
      r[s || "#" + i] = n;
    }
    if (!n) {
      const i = Object.entries(r).map(
        ([l, c]) => `adapter ${l} ` + (c === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let s = a ? i.length > 1 ? `since :
` + i.map(Mp).join(`
`) : " " + Mp(i[0]) : "as no adapter specified";
      throw new he(
        "There is no suitable adapter to dispatch the request " + s,
        "ERR_NOT_SUPPORT"
      );
    }
    return n;
  },
  adapters: Lc
};
function Nl(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new ln(null, e);
}
function Wp(e) {
  return Nl(e), e.headers = pt.from(e.headers), e.data = Dl.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), mw.getAdapter(e.adapter || lr.adapter, e)(e).then(function(t) {
    return Nl(e), t.data = Dl.call(
      e,
      e.transformResponse,
      t
    ), t.headers = pt.from(t.headers), t;
  }, function(t) {
    return uw(t) || (Nl(e), t && t.response && (t.response.data = Dl.call(
      e,
      e.transformResponse,
      t.response
    ), t.response.headers = pt.from(t.response.headers))), Promise.reject(t);
  });
}
const fw = "1.12.2", Is = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Is[e] = function(a) {
    return typeof a === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Bp = {};
Is.transitional = function(e, t, a) {
  function o(n, r) {
    return "[Axios v" + fw + "] Transitional option '" + n + "'" + r + (a ? ". " + a : "");
  }
  return (n, r, i) => {
    if (e === !1)
      throw new he(
        o(r, " has been removed" + (t ? " in " + t : "")),
        he.ERR_DEPRECATED
      );
    return t && !Bp[r] && (Bp[r] = !0, console.warn(
      o(
        r,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), e ? e(n, r, i) : !0;
  };
};
Is.spelling = function(e) {
  return (t, a) => (console.warn(`${a} is likely a misspelling of ${e}`), !0);
};
function nje(e, t, a) {
  if (typeof e != "object")
    throw new he("options must be an object", he.ERR_BAD_OPTION_VALUE);
  const o = Object.keys(e);
  let n = o.length;
  for (; n-- > 0; ) {
    const r = o[n], i = t[r];
    if (i) {
      const s = e[r], l = s === void 0 || i(s, r, e);
      if (l !== !0)
        throw new he("option " + r + " must be " + l, he.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (a !== !0)
      throw new he("Unknown option " + r, he.ERR_BAD_OPTION);
  }
}
const di = {
  assertOptions: nje,
  validators: Is
}, qt = di.validators;
let Qa = class {
  constructor(e) {
    this.defaults = e || {}, this.interceptors = {
      request: new Op(),
      response: new Op()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, t) {
    try {
      return await this._request(e, t);
    } catch (a) {
      if (a instanceof Error) {
        let o = {};
        Error.captureStackTrace ? Error.captureStackTrace(o) : o = new Error();
        const n = o.stack ? o.stack.replace(/^.+\n/, "") : "";
        try {
          a.stack ? n && !String(a.stack).endsWith(n.replace(/^.+\n.+\n/, "")) && (a.stack += `
` + n) : a.stack = n;
        } catch {
        }
      }
      throw a;
    }
  }
  _request(e, t) {
    typeof e == "string" ? (t = t || {}, t.url = e) : t = e || {}, t = io(this.defaults, t);
    const { transitional: a, paramsSerializer: o, headers: n } = t;
    a !== void 0 && di.assertOptions(a, {
      silentJSONParsing: qt.transitional(qt.boolean),
      forcedJSONParsing: qt.transitional(qt.boolean),
      clarifyTimeoutError: qt.transitional(qt.boolean)
    }, !1), o != null && (D.isFunction(o) ? t.paramsSerializer = {
      serialize: o
    } : di.assertOptions(o, {
      encode: qt.function,
      serialize: qt.function
    }, !0)), t.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? t.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : t.allowAbsoluteUrls = !0), di.assertOptions(t, {
      baseUrl: qt.spelling("baseURL"),
      withXsrfToken: qt.spelling("withXSRFToken")
    }, !0), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let r = n && D.merge(
      n.common,
      n[t.method]
    );
    n && D.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (m) => {
        delete n[m];
      }
    ), t.headers = pt.concat(r, n);
    const i = [];
    let s = !0;
    this.interceptors.request.forEach(function(m) {
      typeof m.runWhen == "function" && m.runWhen(t) === !1 || (s = s && m.synchronous, i.unshift(m.fulfilled, m.rejected));
    });
    const l = [];
    this.interceptors.response.forEach(function(m) {
      l.push(m.fulfilled, m.rejected);
    });
    let c, u = 0, d;
    if (!s) {
      const m = [Wp.bind(this), void 0];
      for (m.unshift(...i), m.push(...l), d = m.length, c = Promise.resolve(t); u < d; )
        c = c.then(m[u++], m[u++]);
      return c;
    }
    d = i.length;
    let h = t;
    for (; u < d; ) {
      const m = i[u++], f = i[u++];
      try {
        h = m(h);
      } catch (p) {
        f.call(this, p);
        break;
      }
    }
    try {
      c = Wp.call(this, h);
    } catch (m) {
      return Promise.reject(m);
    }
    for (u = 0, d = l.length; u < d; )
      c = c.then(l[u++], l[u++]);
    return c;
  }
  getUri(e) {
    e = io(this.defaults, e);
    const t = gw(e.baseURL, e.url, e.allowAbsoluteUrls);
    return sw(t, e.params, e.paramsSerializer);
  }
};
D.forEach(["delete", "get", "head", "options"], function(e) {
  Qa.prototype[e] = function(t, a) {
    return this.request(io(a || {}, {
      method: e,
      url: t,
      data: (a || {}).data
    }));
  };
});
D.forEach(["post", "put", "patch"], function(e) {
  function t(a) {
    return function(o, n, r) {
      return this.request(io(r || {}, {
        method: e,
        headers: a ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: n
      }));
    };
  }
  Qa.prototype[e] = t(), Qa.prototype[e + "Form"] = t(!0);
});
let rje = class bw {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let a;
    this.promise = new Promise(function(n) {
      a = n;
    });
    const o = this;
    this.promise.then((n) => {
      if (!o._listeners) return;
      let r = o._listeners.length;
      for (; r-- > 0; )
        o._listeners[r](n);
      o._listeners = null;
    }), this.promise.then = (n) => {
      let r;
      const i = new Promise((s) => {
        o.subscribe(s), r = s;
      }).then(n);
      return i.cancel = function() {
        o.unsubscribe(r);
      }, i;
    }, t(function(n, r, i) {
      o.reason || (o.reason = new ln(n, r, i), a(o.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const a = this._listeners.indexOf(t);
    a !== -1 && this._listeners.splice(a, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), a = (o) => {
      t.abort(o);
    };
    return this.subscribe(a), t.signal.unsubscribe = () => this.unsubscribe(a), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new bw(function(a) {
        t = a;
      }),
      cancel: t
    };
  }
};
function ije(e) {
  return function(t) {
    return e.apply(null, t);
  };
}
function sje(e) {
  return D.isObject(e) && e.isAxiosError === !0;
}
const Mc = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Mc).forEach(([e, t]) => {
  Mc[t] = e;
});
function _w(e) {
  const t = new Qa(e), a = Jy(Qa.prototype.request, t);
  return D.extend(a, Qa.prototype, t, { allOwnKeys: !0 }), D.extend(a, t, null, { allOwnKeys: !0 }), a.create = function(o) {
    return _w(io(e, o));
  }, a;
}
const Fe = _w(lr);
Fe.Axios = Qa;
Fe.CanceledError = ln;
Fe.CancelToken = rje;
Fe.isCancel = uw;
Fe.VERSION = fw;
Fe.toFormData = Rs;
Fe.AxiosError = he;
Fe.Cancel = Fe.CanceledError;
Fe.all = function(e) {
  return Promise.all(e);
};
Fe.spread = ije;
Fe.isAxiosError = sje;
Fe.mergeConfig = io;
Fe.AxiosHeaders = pt;
Fe.formToJSON = (e) => cw(D.isHTMLForm(e) ? new FormData(e) : e);
Fe.getAdapter = mw.getAdapter;
Fe.HttpStatusCode = Mc;
Fe.default = Fe;
const {
  Axios: Qrt,
  AxiosError: lje,
  CanceledError: eit,
  isCancel: tit,
  CancelToken: ait,
  VERSION: oit,
  all: nit,
  Cancel: rit,
  isAxiosError: iit,
  spread: sit,
  toFormData: lit,
  AxiosHeaders: cit,
  HttpStatusCode: uit,
  formToJSON: dit,
  getAdapter: git,
  mergeConfig: hit
} = Fe, cje = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_,+.~#?&/=]*)$/;
class uje {
  baseUrl;
  headers;
  constructor(t, a = {}) {
    this.baseUrl = t, this.headers = a?.headers || {};
  }
  async fetch(t, a = "GET", o = {}) {
    if (!this.baseUrl)
      throw new Error("No base URL set");
    const n = cje.test(t) ? t : `${this.baseUrl}${t}`;
    n.includes(this.baseUrl) && (o.withCredentials = !0);
    try {
      return (await Fe(n, {
        ...o,
        method: a,
        data: o.data,
        headers: { ...this.headers, ...o.headers },
        withCredentials: o.withCredentials
      })).data;
    } catch (r) {
      throw r instanceof lje ? new Sp(`${r.code} - ${r.status} - ${n}`, r.status, r.response?.data) : new Sp("An error occured while fetching");
    }
  }
  getBaseUrl() {
    return this.baseUrl;
  }
  setBaseUrl(t) {
    this.baseUrl = t;
  }
  async get(t, a = {}) {
    return this.fetch(t, "GET", a);
  }
  async post(t, a = {}) {
    return this.fetch(t, "POST", {
      ...a,
      headers: {
        "Content-Type": "application/json",
        ...a.headers
      }
    });
  }
  async put(t, a = {}) {
    return this.fetch(t, "PUT", {
      ...a,
      headers: {
        "Content-Type": "application/json",
        ...a.headers
      }
    });
  }
  async delete(t, a = {}) {
    return this.fetch(t, "DELETE", a);
  }
  async patch(t, a = {}) {
    return this.fetch(t, "PATCH", {
      ...a,
      headers: {
        "Content-Type": "application/json",
        ...a.headers
      }
    });
  }
}
let vw;
function dje(e, t = {}) {
  vw = new uje(e, t);
}
Ot();
function yw(e) {
  var t, a, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var n = e.length;
    for (t = 0; t < n; t++) e[t] && (a = yw(e[t])) && (o && (o += " "), o += a);
  } else for (a in e) e[a] && (o && (o += " "), o += a);
  return o;
}
function It() {
  for (var e, t, a = 0, o = "", n = arguments.length; a < n; a++) (e = arguments[a]) && (t = yw(e)) && (o && (o += " "), o += t);
  return o;
}
const gje = [
  "accessible-bathroom",
  "accessible-bedroom",
  "ac",
  "ambassador_sidebar",
  "animals-card",
  "angle-left",
  "angle-left-rounded",
  "angle-right",
  "angle-right-rounded",
  "anywhere-in-the-world",
  "arrow-thin",
  "arrow-thin-right",
  "available-exchange-type",
  "average-reactivity",
  "baby-bed",
  "baby-gear",
  "baby-gear-old",
  "baby-sitter",
  "balcony-terrace",
  "bathroom",
  "bathtub",
  "bbq",
  "bedroom",
  "beds",
  "bicycle",
  "briefcase3",
  "button-power",
  "cancel",
  "calendar",
  "car",
  "cat-to-feed",
  "chat-lock",
  "check",
  "checkbox-fill",
  "children-welcome",
  "circle-close",
  "circle-help",
  "circle-left-arrow",
  "circle-right-arrow",
  "cities",
  "cleaning-person",
  "clock",
  "computer",
  "cook",
  "corona-virus",
  "countryside",
  "credit-card",
  "dashboard-saved-search",
  "dedicated-work-space",
  "disabled-access",
  "dishwasher",
  "docs",
  "dog-to-feed",
  "dollar",
  "doorman",
  "double-bed",
  "double-bed-up",
  "dryer",
  "easy-navigation",
  "electric-car",
  "electric-car-plug",
  "elevator",
  "error",
  "error-regular",
  "error-warning-fill",
  "excellent-reactivity",
  "eye",
  "eye-slash",
  "eye-slash-back",
  "facebook",
  "filter-picture",
  "fireplace",
  "flag",
  "flat",
  "folk",
  "freezer",
  "fridge",
  "garden",
  "gift",
  "gp",
  "great-reactivity",
  "guarantees",
  "guestpoint-exchange-type",
  "guestpoints",
  "guide",
  "gym",
  "header-help",
  "header-message-new",
  "header-message-read",
  "header-profile-home",
  "header-profile-profile",
  "header-profile-settings",
  "header-profile-they-love-my-home",
  "heart",
  "heart-fill",
  "heating-system",
  "high-speed-connection",
  "home-bin",
  "home-camera",
  "home-cinema",
  "home-exchange",
  "home-panel",
  "house",
  "ic-compass",
  "ic-flip-left",
  "ic-flip-right",
  "ic-location",
  "ic-move",
  "ic-shelter",
  "ic-transfer",
  "icon_facebook",
  "icon_gmail",
  "icon_messanger",
  "icon_outlook",
  "id",
  "information-circle",
  "information-circle-regular",
  "instagram",
  "internet",
  "isolated",
  "island",
  "jacuzzi",
  "key",
  "keys",
  "kids-playground",
  "kids-toys",
  "lakes",
  "lifebuoy",
  "linkedin",
  "location",
  "lock",
  "lock-credit-card",
  "low-consumption-machines",
  "marker-home",
  "marker-home-favorite",
  "marker-home-selected",
  "marker-home-selected-favorite",
  "marker-home-unavailable",
  "marker-home-unavailable-favorite",
  "low-reactivity",
  "map-1",
  "megaphone",
  "membership",
  "messenger",
  "microwave-oven",
  "minus",
  "moonplus",
  "more-filter",
  "motorboat",
  "motorcycle",
  "motor-scooter",
  "mountains",
  "my-family",
  "new-tab",
  "notification",
  "noun-loyalty-card",
  "number-eight",
  "number-five",
  "number-four",
  "number-nine",
  "number-one",
  "number-seven",
  "number-six",
  "number-three",
  "number-two",
  "ok",
  "oven",
  "parking-space",
  "pencil",
  "people",
  "pets-welcome",
  "phone",
  "piano",
  "ping-pong-table",
  "pin",
  "plants-to-water",
  "playground",
  "plus",
  "plus-sign",
  "pool-table",
  "preferred-destinations",
  "primary-home",
  "private-room",
  "public-transit-access",
  "rabbit",
  "raw",
  "reciprocal-exchange-type",
  "remove",
  "renewable-energy-provider",
  "river",
  "rooms",
  "sailboat",
  "satellite-cable",
  "sauna",
  "search",
  "search-location-pin",
  "seaside",
  "secondary-home",
  "secured-swimming-pool",
  "selective-waste-sorting",
  "shape-close",
  "share-fat",
  "simple-bed",
  "simple-bed-up",
  "size",
  "smart-tv",
  "smokers-welcome",
  "solar-panels",
  "sort-order",
  "sponsor-hand-icon",
  "star-black",
  "star-full",
  "step-free-entry",
  "sugesstion",
  "sun",
  "swimming-pool",
  "tennis-court",
  "tiktok",
  "triangle-warning",
  "tv",
  "tv-icon",
  "twitter",
  "types_of_exchanges",
  "unavailable",
  "up-arrow",
  "upload",
  "user",
  "vegetable-garden",
  "verification-check",
  "verification-check-regular",
  "video-game-console",
  "villages",
  "warning",
  "warning-regular",
  "washing-machine",
  "wide-angle",
  "wide-doors",
  "wifi",
  "youtube"
], hje = {
  "marker-home-favorite": 3,
  "marker-home": 2,
  "marker-home-selected-favorite": 3,
  "marker-home-selected": 2,
  "marker-home-unavailable-favorite": 3,
  "marker-home-unavailable": 2,
  icon_facebook: 2,
  icon_gmail: 5
}, pje = gje.map((e) => ({
  name: e,
  class: `icon-${e}`,
  paths: hje[e]
})), mje = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, fje = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl",
  "8xl": "is-8xl",
  "9xl": "is-9xl",
  "10xl": "is-10xl"
};
function bje(e = 0) {
  const t = [];
  for (let a = 0; a < e; a++)
    t[a] = `path${a + 1}`;
  return t.map((a) => /* @__PURE__ */ v("span", { className: a }, a));
}
const Bn = mt(
  ({ name: e, size: t = "medium", color: a = "base", className: o = "", ...n }, r) => {
    const i = pje.find((l) => l.name === e), s = It("icon", `ds-${i?.class}`, fje[t], mje[a], o);
    return /* @__PURE__ */ v("i", { className: s, ...n, ref: r, children: bje(i?.paths) });
  }
);
Bn.displayName = "Icon";
const _je = "_loader_1ksyv_29", vje = "_circle_1ksyv_41", Ao = {
  loader: _je,
  "is-small": "_is-small_1ksyv_29",
  "is-medium": "_is-medium_1ksyv_33",
  "is-large": "_is-large_1ksyv_37",
  circle: vje,
  "moving-element": "_moving-element_1ksyv_44",
  "on-dark": "_on-dark_1ksyv_47",
  "is-secondary": "_is-secondary_1ksyv_53",
  "dialog-overlay-show": "_dialog-overlay-show_1ksyv_1",
  "dialog-content-show": "_dialog-content-show_1ksyv_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1ksyv_1"
}, yje = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large"
}, wje = {
  primary: "is-primary",
  secondary: "is-secondary"
};
function kje({ onDark: e, size: t = "medium", color: a = "primary", className: o }) {
  return /* @__PURE__ */ T(
    "svg",
    {
      className: It(
        Ao.loader,
        Ao[yje[t]],
        Ao[wje[a]],
        e && Ao["on-dark"],
        o
      ),
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      children: [
        /* @__PURE__ */ v("rect", { width: "100", height: "100", fill: "none", className: "bk" }),
        /* @__PURE__ */ v("circle", { className: Ao.circle, cx: "50", cy: "50", r: "40", fill: "none", strokeWidth: "10", strokeLinecap: "round" }),
        /* @__PURE__ */ T(
          "circle",
          {
            className: Ao["moving-element"],
            cx: "50",
            cy: "50",
            r: "40",
            fill: "none",
            strokeWidth: "6",
            strokeLinecap: "round",
            children: [
              /* @__PURE__ */ v("animate", { attributeName: "stroke-dashoffset", dur: "2s", repeatCount: "indefinite", from: "502", to: "0" }),
              /* @__PURE__ */ v(
                "animate",
                {
                  attributeName: "stroke-dasharray",
                  dur: "2s",
                  repeatCount: "indefinite",
                  values: "150.6 100.4;1 250;150.6 100.4"
                }
              )
            ]
          }
        )
      ]
    }
  );
}
const xje = "_button_z1os6_29", $je = "_disabled_z1os6_43", Sje = "_loader_z1os6_263", ca = {
  button: xje,
  disabled: $je,
  "is-primary": "_is-primary_z1os6_51",
  "is-contrasted": "_is-contrasted_z1os6_65",
  "is-secondary": "_is-secondary_z1os6_74",
  "is-tertiary": "_is-tertiary_z1os6_97",
  "is-eco-green": "_is-eco-green_z1os6_120",
  "is-ghost": "_is-ghost_z1os6_134",
  "is-destructive": "_is-destructive_z1os6_157",
  "is-hollow": "_is-hollow_z1os6_171",
  "is-destructive-ghost": "_is-destructive-ghost_z1os6_189",
  "is-facebook": "_is-facebook_z1os6_203",
  "is-apple": "_is-apple_z1os6_217",
  "is-google": "_is-google_z1os6_231",
  "is-regular": "_is-regular_z1os6_245",
  "is-medium": "_is-medium_z1os6_248",
  "is-small": "_is-small_z1os6_251",
  "is-full-width": "_is-full-width_z1os6_254",
  "is-loading": "_is-loading_z1os6_257",
  loader: Sje,
  "dialog-overlay-show": "_dialog-overlay-show_z1os6_1",
  "dialog-content-show": "_dialog-content-show_z1os6_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_z1os6_1"
}, Cje = mt(
  ({
    text: e,
    color: t = "primary",
    size: a = "medium",
    isFullWidth: o = !1,
    icon: n,
    iconPosition: r = "left",
    isLoading: i = !1,
    iconSize: s = "medium",
    isContrasted: l = !1,
    disabled: c = !1,
    className: u,
    children: d,
    ...h
  }, m) => {
    const f = It(
      ca.button,
      ca[Eje[t]],
      ca[jje[a]],
      o && ca["is-full-width"],
      c && ca.disabled,
      r === "right" && ca["has-icon-right"],
      l && ca["is-contrasted"],
      i && ca["is-loading"],
      u
    ), p = /* @__PURE__ */ T(De, { children: [
      i && /* @__PURE__ */ v(kje, { className: ca.loader, onDark: !0, size: "small" }),
      n && r === "left" && /* @__PURE__ */ v(Bn, { color: "inherit", size: s, name: n }),
      d ?? e,
      n && r === "right" && /* @__PURE__ */ v(Bn, { color: "inherit", size: s, name: n })
    ] });
    if (Oje(h))
      return /* @__PURE__ */ v(
        "a",
        {
          ...h,
          href: c ? void 0 : h.href,
          className: f,
          target: h.target,
          ref: m,
          children: p
        }
      );
    if (zje(h))
      return /* @__PURE__ */ v(
        "button",
        {
          disabled: i || c,
          ...h,
          className: f,
          ref: m,
          children: p
        }
      );
  }
);
Cje.displayName = "Button";
const Eje = {
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  "eco-green": "is-eco-green",
  ghost: "is-ghost",
  "destructive-ghost": "is-destructive-ghost",
  destructive: "is-destructive",
  hollow: "is-hollow",
  facebook: "is-facebook",
  apple: "is-apple",
  google: "is-google"
}, jje = {
  small: "is-small",
  medium: "is-medium",
  regular: "is-regular"
};
function Oje(e) {
  return "href" in e && typeof e.href == "string";
}
function zje(e) {
  return !("href" in e);
}
const Aje = 0;
function Pje(e, t, a, o) {
  const [n, r] = Pe(!1), i = n ? e : t, [s, l] = Pe(i ? i.length : Aje), [c, u] = Pe(!1);
  return {
    valueCounter: s,
    isOnBlur: c,
    handleBlur: () => {
      u(!0), o && o();
    },
    handleChange: (d) => {
      r(!0), l(d.target.value.length), a && a(d), u(!1);
    }
  };
}
const Fp = {
  warning: {
    name: "warning",
    color: "warning"
  },
  success: {
    name: "verification-check",
    color: "success"
  },
  error: {
    name: "notification",
    color: "error"
  }
}, Rl = {
  warning: "is-warning",
  success: "is-success",
  error: "is-error"
}, Dje = "_input_s9iwc_29", Nje = "_filled_s9iwc_48", Rje = "_error_s9iwc_154", Ije = "_counter_s9iwc_174", _t = {
  input: Dje,
  "group-label": "_group-label_s9iwc_29",
  filled: Nje,
  "is-error": "_is-error_s9iwc_51",
  "is-success": "_is-success_s9iwc_54",
  "is-warning": "_is-warning_s9iwc_57",
  "helper-text": "_helper-text_s9iwc_60",
  "is-disabled": "_is-disabled_s9iwc_86",
  "is-full-width": "_is-full-width_s9iwc_101",
  "container-counter-icon": "_container-counter-icon_s9iwc_148",
  error: Rje,
  "container-icon": "_container-icon_s9iwc_157",
  counter: Ije,
  "dialog-overlay-show": "_dialog-overlay-show_s9iwc_1",
  "dialog-content-show": "_dialog-content-show_s9iwc_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_s9iwc_1"
}, Tje = mt(
  ({
    className: e,
    type: t = "text",
    value: a,
    message: o,
    status: n,
    placeholder: r,
    onChange: i,
    onBlur: s,
    disabled: l,
    label: c,
    helperText: u,
    name: d,
    isFullWidth: h,
    defaultValue: m,
    id: f,
    optionalMessage: p,
    maxLength: b,
    ...w
  }, _) => {
    const {
      valueCounter: y,
      handleBlur: k,
      handleChange: x
    } = Pje(
      a?.toString(),
      m?.toString(),
      i,
      s ? () => s({}) : void 0
    ), S = It(
      _t.input,
      n && _t[Rl[n]],
      l && _t["is-disabled"],
      h && _t["is-full-width"],
      e
    );
    return /* @__PURE__ */ T("div", { className: S, children: [
      /* @__PURE__ */ T("div", { className: _t["group-label"], children: [
        /* @__PURE__ */ T("div", { children: [
          c && /* @__PURE__ */ v("label", { className: It(n && _t[n]), children: c }),
          p && /* @__PURE__ */ v("span", { children: p })
        ] }),
        u && /* @__PURE__ */ v("div", { className: _t["helper-text"], children: u })
      ] }),
      /* @__PURE__ */ v(
        "input",
        {
          id: f,
          ref: _,
          value: a,
          className: It(n && !l && _t[Rl[n]]),
          type: t,
          placeholder: r,
          onChange: x,
          onBlur: k,
          name: d,
          defaultValue: m,
          "aria-label": c,
          disabled: l,
          ...w
        }
      ),
      (o && n && !l || b) && /* @__PURE__ */ T("div", { className: _t["container-counter-icon"], children: [
        o && n && !l && /* @__PURE__ */ T("div", { className: _t["container-icon"], children: [
          /* @__PURE__ */ v(Bn, { name: Fp[n].name, size: "medium", color: Fp[n].color }),
          /* @__PURE__ */ v("span", { className: _t[Rl[n]], children: o })
        ] }),
        b && /* @__PURE__ */ T("div", { className: It(_t.counter, y > b && _t.error), children: [
          y,
          "/",
          b
        ] })
      ] })
    ] });
  }
);
Tje.displayName = "Input";
const Lje = "_container_1iybi_29", Mje = "_message_1iybi_33", Wje = "_error_1iybi_39", Bje = "_disabled_1iybi_49", ua = {
  container: Lje,
  message: Mje,
  error: Wje,
  "input-container": "_input-container_1iybi_43",
  disabled: Bje,
  "checkbox-input": "_checkbox-input_1iybi_52",
  "label-container": "_label-container_1iybi_99"
}, Fje = mt(
  ({ label: e, value: t, onChange: a, name: o, message: n, hasError: r, disabled: i, checked: s }, l) => {
    const c = It(ua["checkbox-input"], r && ua.error, i && ua.disabled);
    return /* @__PURE__ */ T("div", { className: ua.container, children: [
      /* @__PURE__ */ T("label", { className: It(ua["input-container"], i && ua.disabled), children: [
        /* @__PURE__ */ v(
          "input",
          {
            type: "checkbox",
            className: c,
            name: o,
            value: t,
            onChange: a,
            disabled: i,
            checked: s,
            ref: l
          }
        ),
        /* @__PURE__ */ v("div", { className: ua["label-container"], children: e })
      ] }),
      n && /* @__PURE__ */ v("span", { className: It(ua.message, r && ua.error), children: n })
    ] });
  }
);
Fje.displayName = "Checkbox";
function ve(e, t, { checkForDefaultPrevented: a = !0 } = {}) {
  return function(o) {
    if (e?.(o), a === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
var ot = globalThis?.document ? g.useLayoutEffect : () => {
};
function Vp(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function ww(...e) {
  return (t) => {
    let a = !1;
    const o = e.map((n) => {
      const r = Vp(n, t);
      return !a && typeof r == "function" && (a = !0), r;
    });
    if (a)
      return () => {
        for (let n = 0; n < o.length; n++) {
          const r = o[n];
          typeof r == "function" ? r() : Vp(e[n], null);
        }
      };
  };
}
function Ne(...e) {
  return g.useCallback(ww(...e), e);
}
function Vje(e, t) {
  const a = g.createContext(t), o = (r) => {
    const { children: i, ...s } = r, l = g.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ v(a.Provider, { value: l, children: i });
  };
  o.displayName = e + "Provider";
  function n(r) {
    const i = g.useContext(a);
    if (i) return i;
    if (t !== void 0) return t;
    throw new Error(`\`${r}\` must be used within \`${e}\``);
  }
  return [o, n];
}
function cr(e, t = []) {
  let a = [];
  function o(r, i) {
    const s = g.createContext(i), l = a.length;
    a = [...a, i];
    const c = (d) => {
      const { scope: h, children: m, ...f } = d, p = h?.[e]?.[l] || s, b = g.useMemo(() => f, Object.values(f));
      return /* @__PURE__ */ v(p.Provider, { value: b, children: m });
    };
    c.displayName = r + "Provider";
    function u(d, h) {
      const m = h?.[e]?.[l] || s, f = g.useContext(m);
      if (f) return f;
      if (i !== void 0) return i;
      throw new Error(`\`${d}\` must be used within \`${r}\``);
    }
    return [c, u];
  }
  const n = () => {
    const r = a.map((i) => g.createContext(i));
    return function(i) {
      const s = i?.[e] || r;
      return g.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: s } }),
        [i, s]
      );
    };
  };
  return n.scopeName = e, [o, Uje(n, ...t)];
}
function Uje(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const a = () => {
    const o = e.map((n) => ({
      useScope: n(),
      scopeName: n.scopeName
    }));
    return function(n) {
      const r = o.reduce((i, { useScope: s, scopeName: l }) => {
        const c = s(n)[`__scope${l}`];
        return { ...i, ...c };
      }, {});
      return g.useMemo(() => ({ [`__scope${t.scopeName}`]: r }), [r]);
    };
  };
  return a.scopeName = t.scopeName, a;
}
// @__NO_SIDE_EFFECTS__
function Fn(e) {
  const t = /* @__PURE__ */ qje(e), a = g.forwardRef((o, n) => {
    const { children: r, ...i } = o, s = g.Children.toArray(r), l = s.find(Gje);
    if (l) {
      const c = l.props.children, u = s.map((d) => d === l ? g.Children.count(c) > 1 ? g.Children.only(null) : g.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ v(t, { ...i, ref: n, children: g.isValidElement(c) ? g.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ v(t, { ...i, ref: n, children: r });
  });
  return a.displayName = `${e}.Slot`, a;
}
// @__NO_SIDE_EFFECTS__
function qje(e) {
  const t = g.forwardRef((a, o) => {
    const { children: n, ...r } = a;
    if (g.isValidElement(n)) {
      const i = Jje(n), s = Kje(r, n.props);
      return n.type !== g.Fragment && (s.ref = o ? ww(o, i) : i), g.cloneElement(n, s);
    }
    return g.Children.count(n) > 1 ? g.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Hje = Symbol("radix.slottable");
function Gje(e) {
  return g.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Hje;
}
function Kje(e, t) {
  const a = { ...t };
  for (const o in t) {
    const n = e[o], r = t[o];
    /^on[A-Z]/.test(o) ? n && r ? a[o] = (...i) => {
      const s = r(...i);
      return n(...i), s;
    } : n && (a[o] = n) : o === "style" ? a[o] = { ...n, ...r } : o === "className" && (a[o] = [n, r].filter(Boolean).join(" "));
  }
  return { ...e, ...a };
}
function Jje(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, a = t && "isReactWarning" in t && t.isReactWarning;
  return a ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, a = t && "isReactWarning" in t && t.isReactWarning, a ? e.props.ref : e.props.ref || e.ref);
}
var Zje = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], ye = Zje.reduce((e, t) => {
  const a = /* @__PURE__ */ Fn(`Primitive.${t}`), o = g.forwardRef((n, r) => {
    const { asChild: i, ...s } = n, l = i ? a : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ v(l, { ...s, ref: r });
  });
  return o.displayName = `Primitive.${t}`, { ...e, [t]: o };
}, {});
function Yje(e, t) {
  e && po.flushSync(() => e.dispatchEvent(t));
}
var Xje = g.createContext(void 0);
function Qje(e) {
  const t = g.useContext(Xje);
  return e || t || "ltr";
}
function eOe(e) {
  const t = e + "CollectionProvider", [a, o] = cr(t), [n, r] = a(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (p) => {
    const { scope: b, children: w } = p, _ = ne.useRef(null), y = ne.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ v(n, { scope: b, itemMap: y, collectionRef: _, children: w });
  };
  i.displayName = t;
  const s = e + "CollectionSlot", l = /* @__PURE__ */ Fn(s), c = ne.forwardRef(
    (p, b) => {
      const { scope: w, children: _ } = p, y = r(s, w), k = Ne(b, y.collectionRef);
      return /* @__PURE__ */ v(l, { ref: k, children: _ });
    }
  );
  c.displayName = s;
  const u = e + "CollectionItemSlot", d = "data-radix-collection-item", h = /* @__PURE__ */ Fn(u), m = ne.forwardRef(
    (p, b) => {
      const { scope: w, children: _, ...y } = p, k = ne.useRef(null), x = Ne(b, k), S = r(u, w);
      return ne.useEffect(() => (S.itemMap.set(k, { ref: k, ...y }), () => void S.itemMap.delete(k))), /* @__PURE__ */ v(h, { [d]: "", ref: x, children: _ });
    }
  );
  m.displayName = u;
  function f(p) {
    const b = r(e + "CollectionConsumer", p);
    return ne.useCallback(() => {
      const w = b.collectionRef.current;
      if (!w) return [];
      const _ = Array.from(w.querySelectorAll(`[${d}]`));
      return Array.from(b.itemMap.values()).sort(
        (y, k) => _.indexOf(y.ref.current) - _.indexOf(k.ref.current)
      );
    }, [b.collectionRef, b.itemMap]);
  }
  return [
    { Provider: i, Slot: c, ItemSlot: m },
    f,
    o
  ];
}
var tOe = g[" useId ".trim().toString()] || (() => {
}), aOe = 0;
function kw(e) {
  const [t, a] = g.useState(tOe());
  return ot(() => {
    a((o) => o ?? String(aOe++));
  }, [e]), t ? `radix-${t}` : "";
}
function oOe(e, t) {
  return g.useReducer((a, o) => t[a][o] ?? a, e);
}
var yo = (e) => {
  const { present: t, children: a } = e, o = nOe(t), n = typeof a == "function" ? a({ present: o.isPresent }) : g.Children.only(a), r = Ne(o.ref, rOe(n));
  return typeof a == "function" || o.isPresent ? g.cloneElement(n, { ref: r }) : null;
};
yo.displayName = "Presence";
function nOe(e) {
  const [t, a] = g.useState(), o = g.useRef(null), n = g.useRef(e), r = g.useRef("none"), i = e ? "mounted" : "unmounted", [s, l] = oOe(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return g.useEffect(() => {
    const c = Lr(o.current);
    r.current = s === "mounted" ? c : "none";
  }, [s]), ot(() => {
    const c = o.current, u = n.current;
    if (u !== e) {
      const d = r.current, h = Lr(c);
      e ? l("MOUNT") : h === "none" || c?.display === "none" ? l("UNMOUNT") : l(u && d !== h ? "ANIMATION_OUT" : "UNMOUNT"), n.current = e;
    }
  }, [e, l]), ot(() => {
    if (t) {
      let c;
      const u = t.ownerDocument.defaultView ?? window, d = (m) => {
        const f = Lr(o.current).includes(CSS.escape(m.animationName));
        if (m.target === t && f && (l("ANIMATION_END"), !n.current)) {
          const p = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", c = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = p);
          });
        }
      }, h = (m) => {
        m.target === t && (r.current = Lr(o.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        u.clearTimeout(c), t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: g.useCallback((c) => {
      o.current = c ? getComputedStyle(c) : null, a(c);
    }, [])
  };
}
function Lr(e) {
  return e?.animationName || "none";
}
function rOe(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, a = t && "isReactWarning" in t && t.isReactWarning;
  return a ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, a = t && "isReactWarning" in t && t.isReactWarning, a ? e.props.ref : e.props.ref || e.ref);
}
function ut(e) {
  const t = g.useRef(e);
  return g.useEffect(() => {
    t.current = e;
  }), g.useMemo(() => (...a) => t.current?.(...a), []);
}
function iOe(e) {
  const [t, a] = g.useState(void 0);
  return ot(() => {
    if (e) {
      a({ width: e.offsetWidth, height: e.offsetHeight });
      const o = new ResizeObserver((n) => {
        if (!Array.isArray(n) || !n.length)
          return;
        const r = n[0];
        let i, s;
        if ("borderBoxSize" in r) {
          const l = r.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          i = c.inlineSize, s = c.blockSize;
        } else
          i = e.offsetWidth, s = e.offsetHeight;
        a({ width: i, height: s });
      });
      return o.observe(e, { box: "border-box" }), () => o.unobserve(e);
    } else
      a(void 0);
  }, [e]), t;
}
function sOe(e) {
  const t = g.useRef({ value: e, previous: e });
  return g.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
const lOe = ({
  initialPhoneNumber: e = "",
  initialCountry: t = "",
  onChangePhoneNumber: a,
  onChangeCountry: o
}) => {
  const [n, r] = Pe(e), [i, s] = Pe(t);
  return {
    phoneNumber: n,
    country: i,
    handlePhoneNumberChange: (l) => {
      r(l), a?.(l);
    },
    handleCountryChange: (l) => {
      s(l), o?.(l);
    }
  };
}, cOe = {
  ad: "Andorra",
  ae: "De Forenede Arabiske Emirater",
  af: "Afghanistan",
  ag: "Antigua og Barbuda",
  ai: "Anguilla",
  al: "Albanien",
  am: "Armenien",
  ao: "Angola",
  ar: "Argentina",
  as: "Amerikansk Samoa",
  at: "Østrig",
  au: "Australien",
  aw: "Aruba",
  ax: "Åland",
  az: "Aserbajdsjan",
  ba: "Bosnien-Hercegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgien",
  bf: "Burkina Faso",
  bg: "Bulgarien",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "Saint Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "De tidligere Nederlandske Antiller",
  br: "Brasilien",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Hviderusland",
  bz: "Belize",
  ca: "Canada",
  cc: "Cocosøerne",
  cd: "Congo-Kinshasa",
  cf: "Den Centralafrikanske Republik",
  cg: "Congo-Brazzaville",
  ch: "Schweiz",
  ci: "Elfenbenskysten",
  ck: "Cookøerne",
  cl: "Chile",
  cm: "Cameroun",
  cn: "Kina",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Kap Verde",
  cw: "Curaçao",
  cx: "Juleøen",
  cy: "Cypern",
  cz: "Tjekkiet",
  de: "Tyskland",
  dj: "Djibouti",
  dk: "Danmark",
  dm: "Dominica",
  do: "Den Dominikanske Republik",
  dz: "Algeriet",
  ec: "Ecuador",
  ee: "Estland",
  eg: "Egypten",
  eh: "Vestsahara",
  er: "Eritrea",
  es: "Spanien",
  et: "Etiopien",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falklandsøerne",
  fm: "Mikronesien",
  fo: "Færøerne",
  fr: "Frankrig",
  ga: "Gabon",
  gb: "Storbritannien",
  gd: "Grenada",
  ge: "Georgien",
  gf: "Fransk Guyana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Grønland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Ækvatorialguinea",
  gr: "Grækenland",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "SAR Hongkong",
  hn: "Honduras",
  hr: "Kroatien",
  ht: "Haiti",
  hu: "Ungarn",
  id: "Indonesien",
  ie: "Irland",
  il: "Israel",
  im: "Isle of Man",
  in: "Indien",
  io: "Det Britiske Territorium i Det Indiske Ocean",
  iq: "Irak",
  ir: "Iran",
  is: "Island",
  it: "Italien",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordan",
  jp: "Japan",
  ke: "Kenya",
  kg: "Kirgisistan",
  kh: "Cambodja",
  ki: "Kiribati",
  km: "Comorerne",
  kn: "Saint Kitts og Nevis",
  kp: "Nordkorea",
  kr: "Sydkorea",
  kw: "Kuwait",
  ky: "Caymanøerne",
  kz: "Kasakhstan",
  la: "Laos",
  lb: "Libanon",
  lc: "Saint Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Litauen",
  lu: "Luxembourg",
  lv: "Letland",
  ly: "Libyen",
  ma: "Marokko",
  mc: "Monaco",
  md: "Moldova",
  me: "Montenegro",
  mf: "Saint Martin",
  mg: "Madagaskar",
  mh: "Marshalløerne",
  mk: "Nordmakedonien",
  ml: "Mali",
  mm: "Myanmar (Burma)",
  mn: "Mongoliet",
  mo: "SAR Macao",
  mp: "Nordmarianerne",
  mq: "Martinique",
  mr: "Mauretanien",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldiverne",
  mw: "Malawi",
  mx: "Mexico",
  my: "Malaysia",
  mz: "Mozambique",
  na: "Namibia",
  nc: "Ny Kaledonien",
  ne: "Niger",
  nf: "Norfolk Island",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Holland",
  no: "Norge",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "New Zealand",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Fransk Polynesien",
  pg: "Papua Ny Guinea",
  ph: "Filippinerne",
  pk: "Pakistan",
  pl: "Polen",
  pm: "Saint Pierre og Miquelon",
  pr: "Puerto Rico",
  ps: "De palæstinensiske områder",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Rumænien",
  rs: "Serbien",
  ru: "Rusland",
  rw: "Rwanda",
  sa: "Saudi-Arabien",
  sb: "Salomonøerne",
  sc: "Seychellerne",
  sd: "Sudan",
  se: "Sverige",
  sg: "Singapore",
  sh: "St. Helena",
  si: "Slovenien",
  sj: "Svalbard og Jan Mayen",
  sk: "Slovakiet",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Surinam",
  ss: "Sydsudan",
  st: "São Tomé og Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syrien",
  sz: "Eswatini",
  tc: "Turks- og Caicosøerne",
  td: "Tchad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tadsjikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunesien",
  to: "Tonga",
  tr: "Tyrkiet",
  tt: "Trinidad og Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ukraine",
  ug: "Uganda",
  us: "USA",
  uy: "Uruguay",
  uz: "Usbekistan",
  va: "Vatikanstaten",
  vc: "Saint Vincent og Grenadinerne",
  ve: "Venezuela",
  vg: "De Britiske Jomfruøer",
  vi: "De Amerikanske Jomfruøer",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis og Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "Sydafrika",
  zm: "Zambia",
  zw: "Zimbabwe"
}, uOe = {
  selectedCountryAriaLabel: "Valgt land",
  noCountrySelected: "Intet land er valgt",
  countryListAriaLabel: "Liste over lande",
  searchPlaceholder: "Søg",
  zeroSearchResults: "Ingen resultater fundet",
  oneSearchResult: "1 resultat fundet",
  multipleSearchResults: "${count} resultater fundet",
  // additional countries (not supported by country-list library)
  ac: "Ascension",
  xk: "Kosovo"
}, dOe = { ...cOe, ...uOe }, gOe = {
  ad: "Andorra",
  ae: "Vereinigte Arabische Emirate",
  af: "Afghanistan",
  ag: "Antigua und Barbuda",
  ai: "Anguilla",
  al: "Albanien",
  am: "Armenien",
  ao: "Angola",
  ar: "Argentinien",
  as: "Amerikanisch-Samoa",
  at: "Österreich",
  au: "Australien",
  aw: "Aruba",
  ax: "Ålandinseln",
  az: "Aserbaidschan",
  ba: "Bosnien und Herzegowina",
  bb: "Barbados",
  bd: "Bangladesch",
  be: "Belgien",
  bf: "Burkina Faso",
  bg: "Bulgarien",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "St. Barthélemy",
  bm: "Bermuda",
  bn: "Brunei Darussalam",
  bo: "Bolivien",
  bq: "Bonaire, Sint Eustatius und Saba",
  br: "Brasilien",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botsuana",
  by: "Belarus",
  bz: "Belize",
  ca: "Kanada",
  cc: "Kokosinseln",
  cd: "Kongo-Kinshasa",
  cf: "Zentralafrikanische Republik",
  cg: "Kongo-Brazzaville",
  ch: "Schweiz",
  ci: "Côte d’Ivoire",
  ck: "Cookinseln",
  cl: "Chile",
  cm: "Kamerun",
  cn: "China",
  co: "Kolumbien",
  cr: "Costa Rica",
  cu: "Kuba",
  cv: "Cabo Verde",
  cw: "Curaçao",
  cx: "Weihnachtsinsel",
  cy: "Zypern",
  cz: "Tschechien",
  de: "Deutschland",
  dj: "Dschibuti",
  dk: "Dänemark",
  dm: "Dominica",
  do: "Dominikanische Republik",
  dz: "Algerien",
  ec: "Ecuador",
  ee: "Estland",
  eg: "Ägypten",
  eh: "Westsahara",
  er: "Eritrea",
  es: "Spanien",
  et: "Äthiopien",
  fi: "Finnland",
  fj: "Fidschi",
  fk: "Falklandinseln",
  fm: "Mikronesien",
  fo: "Färöer",
  fr: "Frankreich",
  ga: "Gabun",
  gb: "Vereinigtes Königreich",
  gd: "Grenada",
  ge: "Georgien",
  gf: "Französisch-Guayana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Grönland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Äquatorialguinea",
  gr: "Griechenland",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "Sonderverwaltungsregion Hongkong",
  hn: "Honduras",
  hr: "Kroatien",
  ht: "Haiti",
  hu: "Ungarn",
  id: "Indonesien",
  ie: "Irland",
  il: "Israel",
  im: "Isle of Man",
  in: "Indien",
  io: "Britisches Territorium im Indischen Ozean",
  iq: "Irak",
  ir: "Iran",
  is: "Island",
  it: "Italien",
  je: "Jersey",
  jm: "Jamaika",
  jo: "Jordanien",
  jp: "Japan",
  ke: "Kenia",
  kg: "Kirgisistan",
  kh: "Kambodscha",
  ki: "Kiribati",
  km: "Komoren",
  kn: "St. Kitts und Nevis",
  kp: "Nordkorea",
  kr: "Südkorea",
  kw: "Kuwait",
  ky: "Kaimaninseln",
  kz: "Kasachstan",
  la: "Laos",
  lb: "Libanon",
  lc: "St. Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Litauen",
  lu: "Luxemburg",
  lv: "Lettland",
  ly: "Libyen",
  ma: "Marokko",
  mc: "Monaco",
  md: "Republik Moldau",
  me: "Montenegro",
  mf: "St. Martin",
  mg: "Madagaskar",
  mh: "Marshallinseln",
  mk: "Nordmazedonien",
  ml: "Mali",
  mm: "Myanmar",
  mn: "Mongolei",
  mo: "Sonderverwaltungsregion Macau",
  mp: "Nördliche Marianen",
  mq: "Martinique",
  mr: "Mauretanien",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Malediven",
  mw: "Malawi",
  mx: "Mexiko",
  my: "Malaysia",
  mz: "Mosambik",
  na: "Namibia",
  nc: "Neukaledonien",
  ne: "Niger",
  nf: "Norfolkinsel",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Niederlande",
  no: "Norwegen",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Neuseeland",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Französisch-Polynesien",
  pg: "Papua-Neuguinea",
  ph: "Philippinen",
  pk: "Pakistan",
  pl: "Polen",
  pm: "St. Pierre und Miquelon",
  pr: "Puerto Rico",
  ps: "Palästinensische Autonomiegebiete",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Katar",
  re: "Réunion",
  ro: "Rumänien",
  rs: "Serbien",
  ru: "Russland",
  rw: "Ruanda",
  sa: "Saudi-Arabien",
  sb: "Salomonen",
  sc: "Seychellen",
  sd: "Sudan",
  se: "Schweden",
  sg: "Singapur",
  sh: "St. Helena",
  si: "Slowenien",
  sj: "Spitzbergen und Jan Mayen",
  sk: "Slowakei",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Suriname",
  ss: "Südsudan",
  st: "São Tomé und Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syrien",
  sz: "Eswatini",
  tc: "Turks- und Caicosinseln",
  td: "Tschad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tadschikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunesien",
  to: "Tonga",
  tr: "Türkei",
  tt: "Trinidad und Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tansania",
  ua: "Ukraine",
  ug: "Uganda",
  us: "Vereinigte Staaten",
  uy: "Uruguay",
  uz: "Usbekistan",
  va: "Vatikanstadt",
  vc: "St. Vincent und die Grenadinen",
  ve: "Venezuela",
  vg: "Britische Jungferninseln",
  vi: "Amerikanische Jungferninseln",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis und Futuna",
  ws: "Samoa",
  ye: "Jemen",
  yt: "Mayotte",
  za: "Südafrika",
  zm: "Sambia",
  zw: "Simbabwe"
}, hOe = {
  selectedCountryAriaLabel: "Ausgewähltes Land",
  noCountrySelected: "Kein Land ausgewählt",
  countryListAriaLabel: "Liste der Länder",
  searchPlaceholder: "Suchen",
  zeroSearchResults: "Keine Suchergebnisse",
  oneSearchResult: "1 Suchergebnis",
  multipleSearchResults: "${count} Suchergebnisse",
  // additional countries (not supported by country-list library)
  ac: "Ascension-Insel",
  xk: "Kosovo"
}, pOe = { ...gOe, ...hOe }, mOe = {
  ad: "Andorra",
  ae: "United Arab Emirates",
  af: "Afghanistan",
  ag: "Antigua & Barbuda",
  ai: "Anguilla",
  al: "Albania",
  am: "Armenia",
  ao: "Angola",
  ar: "Argentina",
  as: "American Samoa",
  at: "Austria",
  au: "Australia",
  aw: "Aruba",
  ax: "Åland Islands",
  az: "Azerbaijan",
  ba: "Bosnia & Herzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgium",
  bf: "Burkina Faso",
  bg: "Bulgaria",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "St. Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Caribbean Netherlands",
  br: "Brazil",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Belarus",
  bz: "Belize",
  ca: "Canada",
  cc: "Cocos (Keeling) Islands",
  cd: "Congo - Kinshasa",
  cf: "Central African Republic",
  cg: "Congo - Brazzaville",
  ch: "Switzerland",
  ci: "Côte d’Ivoire",
  ck: "Cook Islands",
  cl: "Chile",
  cm: "Cameroon",
  cn: "China",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cape Verde",
  cw: "Curaçao",
  cx: "Christmas Island",
  cy: "Cyprus",
  cz: "Czechia",
  de: "Germany",
  dj: "Djibouti",
  dk: "Denmark",
  dm: "Dominica",
  do: "Dominican Republic",
  dz: "Algeria",
  ec: "Ecuador",
  ee: "Estonia",
  eg: "Egypt",
  eh: "Western Sahara",
  er: "Eritrea",
  es: "Spain",
  et: "Ethiopia",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falkland Islands",
  fm: "Micronesia",
  fo: "Faroe Islands",
  fr: "France",
  ga: "Gabon",
  gb: "United Kingdom",
  gd: "Grenada",
  ge: "Georgia",
  gf: "French Guiana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Greenland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Equatorial Guinea",
  gr: "Greece",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "Hong Kong SAR China",
  hn: "Honduras",
  hr: "Croatia",
  ht: "Haiti",
  hu: "Hungary",
  id: "Indonesia",
  ie: "Ireland",
  il: "Israel",
  im: "Isle of Man",
  in: "India",
  io: "British Indian Ocean Territory",
  iq: "Iraq",
  ir: "Iran",
  is: "Iceland",
  it: "Italy",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordan",
  jp: "Japan",
  ke: "Kenya",
  kg: "Kyrgyzstan",
  kh: "Cambodia",
  ki: "Kiribati",
  km: "Comoros",
  kn: "St. Kitts & Nevis",
  kp: "North Korea",
  kr: "South Korea",
  kw: "Kuwait",
  ky: "Cayman Islands",
  kz: "Kazakhstan",
  la: "Laos",
  lb: "Lebanon",
  lc: "St. Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Lithuania",
  lu: "Luxembourg",
  lv: "Latvia",
  ly: "Libya",
  ma: "Morocco",
  mc: "Monaco",
  md: "Moldova",
  me: "Montenegro",
  mf: "St. Martin",
  mg: "Madagascar",
  mh: "Marshall Islands",
  mk: "North Macedonia",
  ml: "Mali",
  mm: "Myanmar (Burma)",
  mn: "Mongolia",
  mo: "Macao SAR China",
  mp: "Northern Mariana Islands",
  mq: "Martinique",
  mr: "Mauritania",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldives",
  mw: "Malawi",
  mx: "Mexico",
  my: "Malaysia",
  mz: "Mozambique",
  na: "Namibia",
  nc: "New Caledonia",
  ne: "Niger",
  nf: "Norfolk Island",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Netherlands",
  no: "Norway",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "New Zealand",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "French Polynesia",
  pg: "Papua New Guinea",
  ph: "Philippines",
  pk: "Pakistan",
  pl: "Poland",
  pm: "St. Pierre & Miquelon",
  pr: "Puerto Rico",
  ps: "Palestinian Territories",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Romania",
  rs: "Serbia",
  ru: "Russia",
  rw: "Rwanda",
  sa: "Saudi Arabia",
  sb: "Solomon Islands",
  sc: "Seychelles",
  sd: "Sudan",
  se: "Sweden",
  sg: "Singapore",
  sh: "St. Helena",
  si: "Slovenia",
  sj: "Svalbard & Jan Mayen",
  sk: "Slovakia",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Suriname",
  ss: "South Sudan",
  st: "São Tomé & Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syria",
  sz: "Eswatini",
  tc: "Turks & Caicos Islands",
  td: "Chad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tajikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunisia",
  to: "Tonga",
  tr: "Turkey",
  tt: "Trinidad & Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ukraine",
  ug: "Uganda",
  us: "United States",
  uy: "Uruguay",
  uz: "Uzbekistan",
  va: "Vatican City",
  vc: "St. Vincent & Grenadines",
  ve: "Venezuela",
  vg: "British Virgin Islands",
  vi: "U.S. Virgin Islands",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis & Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "South Africa",
  zm: "Zambia",
  zw: "Zimbabwe"
}, fOe = {
  selectedCountryAriaLabel: "Change country, selected ${countryName} (${dialCode})",
  noCountrySelected: "Select country",
  countryListAriaLabel: "List of countries",
  searchPlaceholder: "Search",
  clearSearchAriaLabel: "Clear search",
  zeroSearchResults: "No results found",
  oneSearchResult: "1 result found",
  multipleSearchResults: "${count} results found",
  // additional countries (not supported by country-list library)
  ac: "Ascension Island",
  xk: "Kosovo"
}, bOe = { ...mOe, ...fOe }, _Oe = {
  ad: "Andorra",
  ae: "Emiratos Árabes Unidos",
  af: "Afganistán",
  ag: "Antigua y Barbuda",
  ai: "Anguila",
  al: "Albania",
  am: "Armenia",
  ao: "Angola",
  ar: "Argentina",
  as: "Samoa Americana",
  at: "Austria",
  au: "Australia",
  aw: "Aruba",
  ax: "Islas Åland",
  az: "Azerbaiyán",
  ba: "Bosnia y Herzegovina",
  bb: "Barbados",
  bd: "Bangladés",
  be: "Bélgica",
  bf: "Burkina Faso",
  bg: "Bulgaria",
  bh: "Baréin",
  bi: "Burundi",
  bj: "Benín",
  bl: "San Bartolomé",
  bm: "Bermudas",
  bn: "Brunéi",
  bo: "Bolivia",
  bq: "Caribe neerlandés",
  br: "Brasil",
  bs: "Bahamas",
  bt: "Bután",
  bw: "Botsuana",
  by: "Bielorrusia",
  bz: "Belice",
  ca: "Canadá",
  cc: "Islas Cocos",
  cd: "República Democrática del Congo",
  cf: "República Centroafricana",
  cg: "Congo",
  ch: "Suiza",
  ci: "Côte d’Ivoire",
  ck: "Islas Cook",
  cl: "Chile",
  cm: "Camerún",
  cn: "China",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cabo Verde",
  cw: "Curazao",
  cx: "Isla de Navidad",
  cy: "Chipre",
  cz: "Chequia",
  de: "Alemania",
  dj: "Yibuti",
  dk: "Dinamarca",
  dm: "Dominica",
  do: "República Dominicana",
  dz: "Argelia",
  ec: "Ecuador",
  ee: "Estonia",
  eg: "Egipto",
  eh: "Sáhara Occidental",
  er: "Eritrea",
  es: "España",
  et: "Etiopía",
  fi: "Finlandia",
  fj: "Fiyi",
  fk: "Islas Malvinas",
  fm: "Micronesia",
  fo: "Islas Feroe",
  fr: "Francia",
  ga: "Gabón",
  gb: "Reino Unido",
  gd: "Granada",
  ge: "Georgia",
  gf: "Guayana Francesa",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Groenlandia",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadalupe",
  gq: "Guinea Ecuatorial",
  gr: "Grecia",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bisáu",
  gy: "Guyana",
  hk: "RAE de Hong Kong (China)",
  hn: "Honduras",
  hr: "Croacia",
  ht: "Haití",
  hu: "Hungría",
  id: "Indonesia",
  ie: "Irlanda",
  il: "Israel",
  im: "Isla de Man",
  in: "India",
  io: "Territorio Británico del Océano Índico",
  iq: "Irak",
  ir: "Irán",
  is: "Islandia",
  it: "Italia",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordania",
  jp: "Japón",
  ke: "Kenia",
  kg: "Kirguistán",
  kh: "Camboya",
  ki: "Kiribati",
  km: "Comoras",
  kn: "San Cristóbal y Nieves",
  kp: "Corea del Norte",
  kr: "Corea del Sur",
  kw: "Kuwait",
  ky: "Islas Caimán",
  kz: "Kazajistán",
  la: "Laos",
  lb: "Líbano",
  lc: "Santa Lucía",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesoto",
  lt: "Lituania",
  lu: "Luxemburgo",
  lv: "Letonia",
  ly: "Libia",
  ma: "Marruecos",
  mc: "Mónaco",
  md: "Moldavia",
  me: "Montenegro",
  mf: "San Martín",
  mg: "Madagascar",
  mh: "Islas Marshall",
  mk: "Macedonia del Norte",
  ml: "Mali",
  mm: "Myanmar (Birmania)",
  mn: "Mongolia",
  mo: "RAE de Macao (China)",
  mp: "Islas Marianas del Norte",
  mq: "Martinica",
  mr: "Mauritania",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauricio",
  mv: "Maldivas",
  mw: "Malaui",
  mx: "México",
  my: "Malasia",
  mz: "Mozambique",
  na: "Namibia",
  nc: "Nueva Caledonia",
  ne: "Níger",
  nf: "Isla Norfolk",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Países Bajos",
  no: "Noruega",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nueva Zelanda",
  om: "Omán",
  pa: "Panamá",
  pe: "Perú",
  pf: "Polinesia Francesa",
  pg: "Papúa Nueva Guinea",
  ph: "Filipinas",
  pk: "Pakistán",
  pl: "Polonia",
  pm: "San Pedro y Miquelón",
  pr: "Puerto Rico",
  ps: "Territorios Palestinos",
  pt: "Portugal",
  pw: "Palaos",
  py: "Paraguay",
  qa: "Catar",
  re: "Reunión",
  ro: "Rumanía",
  rs: "Serbia",
  ru: "Rusia",
  rw: "Ruanda",
  sa: "Arabia Saudí",
  sb: "Islas Salomón",
  sc: "Seychelles",
  sd: "Sudán",
  se: "Suecia",
  sg: "Singapur",
  sh: "Santa Elena",
  si: "Eslovenia",
  sj: "Svalbard y Jan Mayen",
  sk: "Eslovaquia",
  sl: "Sierra Leona",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Surinam",
  ss: "Sudán del Sur",
  st: "Santo Tomé y Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Siria",
  sz: "Esuatini",
  tc: "Islas Turcas y Caicos",
  td: "Chad",
  tg: "Togo",
  th: "Tailandia",
  tj: "Tayikistán",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistán",
  tn: "Túnez",
  to: "Tonga",
  tr: "Turquía",
  tt: "Trinidad y Tobago",
  tv: "Tuvalu",
  tw: "Taiwán",
  tz: "Tanzania",
  ua: "Ucrania",
  ug: "Uganda",
  us: "Estados Unidos",
  uy: "Uruguay",
  uz: "Uzbekistán",
  va: "Ciudad del Vaticano",
  vc: "San Vicente y las Granadinas",
  ve: "Venezuela",
  vg: "Islas Vírgenes Británicas",
  vi: "Islas Vírgenes de EE. UU.",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis y Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "Sudáfrica",
  zm: "Zambia",
  zw: "Zimbabue"
}, vOe = {
  selectedCountryAriaLabel: "País seleccionado",
  noCountrySelected: "Ningún país seleccionado",
  countryListAriaLabel: "Lista de países",
  searchPlaceholder: "Buscar",
  zeroSearchResults: "No se han encontrado resultados",
  oneSearchResult: "1 resultado encontrado",
  multipleSearchResults: "${count} resultados encontrados",
  // additional countries (not supported by country-list library)
  ac: "isla Ascencion",
  xk: "Kosovo"
}, yOe = { ..._Oe, ...vOe }, wOe = {
  ad: "Andorre",
  ae: "Émirats arabes unis",
  af: "Afghanistan",
  ag: "Antigua-et-Barbuda",
  ai: "Anguilla",
  al: "Albanie",
  am: "Arménie",
  ao: "Angola",
  ar: "Argentine",
  as: "Samoa américaines",
  at: "Autriche",
  au: "Australie",
  aw: "Aruba",
  ax: "Îles Åland",
  az: "Azerbaïdjan",
  ba: "Bosnie-Herzégovine",
  bb: "Barbade",
  bd: "Bangladesh",
  be: "Belgique",
  bf: "Burkina Faso",
  bg: "Bulgarie",
  bh: "Bahreïn",
  bi: "Burundi",
  bj: "Bénin",
  bl: "Saint-Barthélemy",
  bm: "Bermudes",
  bn: "Brunéi Darussalam",
  bo: "Bolivie",
  bq: "Pays-Bas caribéens",
  br: "Brésil",
  bs: "Bahamas",
  bt: "Bhoutan",
  bw: "Botswana",
  by: "Biélorussie",
  bz: "Belize",
  ca: "Canada",
  cc: "Îles Cocos",
  cd: "Congo-Kinshasa",
  cf: "République centrafricaine",
  cg: "Congo-Brazzaville",
  ch: "Suisse",
  ci: "Côte d’Ivoire",
  ck: "Îles Cook",
  cl: "Chili",
  cm: "Cameroun",
  cn: "Chine",
  co: "Colombie",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cap-Vert",
  cw: "Curaçao",
  cx: "Île Christmas",
  cy: "Chypre",
  cz: "Tchéquie",
  de: "Allemagne",
  dj: "Djibouti",
  dk: "Danemark",
  dm: "Dominique",
  do: "République dominicaine",
  dz: "Algérie",
  ec: "Équateur",
  ee: "Estonie",
  eg: "Égypte",
  eh: "Sahara occidental",
  er: "Érythrée",
  es: "Espagne",
  et: "Éthiopie",
  fi: "Finlande",
  fj: "Fidji",
  fk: "Îles Malouines",
  fm: "États fédérés de Micronésie",
  fo: "Îles Féroé",
  fr: "France",
  ga: "Gabon",
  gb: "Royaume-Uni",
  gd: "Grenade",
  ge: "Géorgie",
  gf: "Guyane française",
  gg: "Guernesey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Groenland",
  gm: "Gambie",
  gn: "Guinée",
  gp: "Guadeloupe",
  gq: "Guinée équatoriale",
  gr: "Grèce",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinée-Bissau",
  gy: "Guyana",
  hk: "R.A.S. chinoise de Hong Kong",
  hn: "Honduras",
  hr: "Croatie",
  ht: "Haïti",
  hu: "Hongrie",
  id: "Indonésie",
  ie: "Irlande",
  il: "Israël",
  im: "Île de Man",
  in: "Inde",
  io: "Territoire britannique de l’océan Indien",
  iq: "Irak",
  ir: "Iran",
  is: "Islande",
  it: "Italie",
  je: "Jersey",
  jm: "Jamaïque",
  jo: "Jordanie",
  jp: "Japon",
  ke: "Kenya",
  kg: "Kirghizistan",
  kh: "Cambodge",
  ki: "Kiribati",
  km: "Comores",
  kn: "Saint-Christophe-et-Niévès",
  kp: "Corée du Nord",
  kr: "Corée du Sud",
  kw: "Koweït",
  ky: "Îles Caïmans",
  kz: "Kazakhstan",
  la: "Laos",
  lb: "Liban",
  lc: "Sainte-Lucie",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Libéria",
  ls: "Lesotho",
  lt: "Lituanie",
  lu: "Luxembourg",
  lv: "Lettonie",
  ly: "Libye",
  ma: "Maroc",
  mc: "Monaco",
  md: "Moldavie",
  me: "Monténégro",
  mf: "Saint-Martin",
  mg: "Madagascar",
  mh: "Îles Marshall",
  mk: "Macédoine du Nord",
  ml: "Mali",
  mm: "Myanmar (Birmanie)",
  mn: "Mongolie",
  mo: "R.A.S. chinoise de Macao",
  mp: "Îles Mariannes du Nord",
  mq: "Martinique",
  mr: "Mauritanie",
  ms: "Montserrat",
  mt: "Malte",
  mu: "Maurice",
  mv: "Maldives",
  mw: "Malawi",
  mx: "Mexique",
  my: "Malaisie",
  mz: "Mozambique",
  na: "Namibie",
  nc: "Nouvelle-Calédonie",
  ne: "Niger",
  nf: "Île Norfolk",
  ng: "Nigéria",
  ni: "Nicaragua",
  nl: "Pays-Bas",
  no: "Norvège",
  np: "Népal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nouvelle-Zélande",
  om: "Oman",
  pa: "Panama",
  pe: "Pérou",
  pf: "Polynésie française",
  pg: "Papouasie-Nouvelle-Guinée",
  ph: "Philippines",
  pk: "Pakistan",
  pl: "Pologne",
  pm: "Saint-Pierre-et-Miquelon",
  pr: "Porto Rico",
  ps: "Territoires palestiniens",
  pt: "Portugal",
  pw: "Palaos",
  py: "Paraguay",
  qa: "Qatar",
  re: "La Réunion",
  ro: "Roumanie",
  rs: "Serbie",
  ru: "Russie",
  rw: "Rwanda",
  sa: "Arabie saoudite",
  sb: "Îles Salomon",
  sc: "Seychelles",
  sd: "Soudan",
  se: "Suède",
  sg: "Singapour",
  sh: "Sainte-Hélène",
  si: "Slovénie",
  sj: "Svalbard et Jan Mayen",
  sk: "Slovaquie",
  sl: "Sierra Leone",
  sm: "Saint-Marin",
  sn: "Sénégal",
  so: "Somalie",
  sr: "Suriname",
  ss: "Soudan du Sud",
  st: "Sao Tomé-et-Principe",
  sv: "Salvador",
  sx: "Saint-Martin (partie néerlandaise)",
  sy: "Syrie",
  sz: "Eswatini",
  tc: "Îles Turques-et-Caïques",
  td: "Tchad",
  tg: "Togo",
  th: "Thaïlande",
  tj: "Tadjikistan",
  tk: "Tokelau",
  tl: "Timor oriental",
  tm: "Turkménistan",
  tn: "Tunisie",
  to: "Tonga",
  tr: "Turquie",
  tt: "Trinité-et-Tobago",
  tv: "Tuvalu",
  tw: "Taïwan",
  tz: "Tanzanie",
  ua: "Ukraine",
  ug: "Ouganda",
  us: "États-Unis",
  uy: "Uruguay",
  uz: "Ouzbékistan",
  va: "État de la Cité du Vatican",
  vc: "Saint-Vincent-et-les-Grenadines",
  ve: "Venezuela",
  vg: "Îles Vierges britanniques",
  vi: "Îles Vierges des États-Unis",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis-et-Futuna",
  ws: "Samoa",
  ye: "Yémen",
  yt: "Mayotte",
  za: "Afrique du Sud",
  zm: "Zambie",
  zw: "Zimbabwe"
}, kOe = {
  selectedCountryAriaLabel: "Pays sélectionné",
  noCountrySelected: "Aucun pays sélectionné",
  countryListAriaLabel: "Liste des pays",
  searchPlaceholder: "Recherche",
  zeroSearchResults: "Aucun résultat trouvé",
  oneSearchResult: "1 résultat trouvé",
  multipleSearchResults: "${count} résultats trouvés",
  // additional countries (not supported by country-list library)
  ac: "Île de l'Ascension",
  xk: "Kosovo"
}, xOe = { ...wOe, ...kOe }, $Oe = {
  ad: "Andora",
  ae: "Ujedinjeni Arapski Emirati",
  af: "Afganistan",
  ag: "Antigva i Barbuda",
  ai: "Angvila",
  al: "Albanija",
  am: "Armenija",
  ao: "Angola",
  ar: "Argentina",
  as: "Američka Samoa",
  at: "Austrija",
  au: "Australija",
  aw: "Aruba",
  ax: "Ålandski otoci",
  az: "Azerbajdžan",
  ba: "Bosna i Hercegovina",
  bb: "Barbados",
  bd: "Bangladeš",
  be: "Belgija",
  bf: "Burkina Faso",
  bg: "Bugarska",
  bh: "Bahrein",
  bi: "Burundi",
  bj: "Benin",
  bl: "Saint Barthélemy",
  bm: "Bermudi",
  bn: "Brunej",
  bo: "Bolivija",
  bq: "Karipski otoci Nizozemske",
  br: "Brazil",
  bs: "Bahami",
  bt: "Butan",
  bw: "Bocvana",
  by: "Bjelorusija",
  bz: "Belize",
  ca: "Kanada",
  cc: "Kokosovi (Keelingovi) otoci",
  cd: "Kongo - Kinshasa",
  cf: "Srednjoafrička Republika",
  cg: "Kongo - Brazzaville",
  ch: "Švicarska",
  ci: "Obala Bjelokosti",
  ck: "Cookovi Otoci",
  cl: "Čile",
  cm: "Kamerun",
  cn: "Kina",
  co: "Kolumbija",
  cr: "Kostarika",
  cu: "Kuba",
  cv: "Zelenortska Republika",
  cw: "Curaçao",
  cx: "Božićni otok",
  cy: "Cipar",
  cz: "Češka",
  de: "Njemačka",
  dj: "Džibuti",
  dk: "Danska",
  dm: "Dominika",
  do: "Dominikanska Republika",
  dz: "Alžir",
  ec: "Ekvador",
  ee: "Estonija",
  eg: "Egipat",
  eh: "Zapadna Sahara",
  er: "Eritreja",
  es: "Španjolska",
  et: "Etiopija",
  fi: "Finska",
  fj: "Fidži",
  fk: "Falklandski otoci",
  fm: "Mikronezija",
  fo: "Farski otoci",
  fr: "Francuska",
  ga: "Gabon",
  gb: "Ujedinjeno Kraljevstvo",
  gd: "Grenada",
  ge: "Gruzija",
  gf: "Francuska Gijana",
  gg: "Guernsey",
  gh: "Gana",
  gi: "Gibraltar",
  gl: "Grenland",
  gm: "Gambija",
  gn: "Gvineja",
  gp: "Guadalupe",
  gq: "Ekvatorska Gvineja",
  gr: "Grčka",
  gt: "Gvatemala",
  gu: "Guam",
  gw: "Gvineja Bisau",
  gy: "Gvajana",
  hk: "PUP Hong Kong Kina",
  hn: "Honduras",
  hr: "Hrvatska",
  ht: "Haiti",
  hu: "Mađarska",
  id: "Indonezija",
  ie: "Irska",
  il: "Izrael",
  im: "Otok Man",
  in: "Indija",
  io: "Britanski Indijskooceanski teritorij",
  iq: "Irak",
  ir: "Iran",
  is: "Island",
  it: "Italija",
  je: "Jersey",
  jm: "Jamajka",
  jo: "Jordan",
  jp: "Japan",
  ke: "Kenija",
  kg: "Kirgistan",
  kh: "Kambodža",
  ki: "Kiribati",
  km: "Komori",
  kn: "Sveti Kristofor i Nevis",
  kp: "Sjeverna Koreja",
  kr: "Južna Koreja",
  kw: "Kuvajt",
  ky: "Kajmanski otoci",
  kz: "Kazahstan",
  la: "Laos",
  lb: "Libanon",
  lc: "Sveta Lucija",
  li: "Lihtenštajn",
  lk: "Šri Lanka",
  lr: "Liberija",
  ls: "Lesoto",
  lt: "Litva",
  lu: "Luksemburg",
  lv: "Latvija",
  ly: "Libija",
  ma: "Maroko",
  mc: "Monako",
  md: "Moldavija",
  me: "Crna Gora",
  mf: "Saint Martin",
  mg: "Madagaskar",
  mh: "Maršalovi Otoci",
  mk: "Sjeverna Makedonija",
  ml: "Mali",
  mm: "Mjanmar (Burma)",
  mn: "Mongolija",
  mo: "PUP Makao Kina",
  mp: "Sjevernomarijanski otoci",
  mq: "Martinique",
  mr: "Mauretanija",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauricijus",
  mv: "Maldivi",
  mw: "Malavi",
  mx: "Meksiko",
  my: "Malezija",
  mz: "Mozambik",
  na: "Namibija",
  nc: "Nova Kaledonija",
  ne: "Niger",
  nf: "Otok Norfolk",
  ng: "Nigerija",
  ni: "Nikaragva",
  nl: "Nizozemska",
  no: "Norveška",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Novi Zeland",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Francuska Polinezija",
  pg: "Papua Nova Gvineja",
  ph: "Filipini",
  pk: "Pakistan",
  pl: "Poljska",
  pm: "Saint-Pierre-et-Miquelon",
  pr: "Portoriko",
  ps: "Palestinsko područje",
  pt: "Portugal",
  pw: "Palau",
  py: "Paragvaj",
  qa: "Katar",
  re: "Réunion",
  ro: "Rumunjska",
  rs: "Srbija",
  ru: "Rusija",
  rw: "Ruanda",
  sa: "Saudijska Arabija",
  sb: "Salomonski Otoci",
  sc: "Sejšeli",
  sd: "Sudan",
  se: "Švedska",
  sg: "Singapur",
  sh: "Sveta Helena",
  si: "Slovenija",
  sj: "Svalbard i Jan Mayen",
  sk: "Slovačka",
  sl: "Sijera Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalija",
  sr: "Surinam",
  ss: "Južni Sudan",
  st: "Sveti Toma i Princip",
  sv: "Salvador",
  sx: "Sint Maarten",
  sy: "Sirija",
  sz: "Esvatini",
  tc: "Otoci Turks i Caicos",
  td: "Čad",
  tg: "Togo",
  th: "Tajland",
  tj: "Tadžikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunis",
  to: "Tonga",
  tr: "Turska",
  tt: "Trinidad i Tobago",
  tv: "Tuvalu",
  tw: "Tajvan",
  tz: "Tanzanija",
  ua: "Ukrajina",
  ug: "Uganda",
  us: "Sjedinjene Američke Države",
  uy: "Urugvaj",
  uz: "Uzbekistan",
  va: "Vatikanski Grad",
  vc: "Sveti Vincent i Grenadini",
  ve: "Venezuela",
  vg: "Britanski Djevičanski otoci",
  vi: "Američki Djevičanski otoci",
  vn: "Vijetnam",
  vu: "Vanuatu",
  wf: "Wallis i Futuna",
  ws: "Samoa",
  ye: "Jemen",
  yt: "Mayotte",
  za: "Južnoafrička Republika",
  zm: "Zambija",
  zw: "Zimbabve"
}, SOe = {
  selectedCountryAriaLabel: "Odabrana zemlja",
  noCountrySelected: "Zemlja nije odabrana",
  countryListAriaLabel: "Lista zemalja",
  searchPlaceholder: "Pretraži",
  zeroSearchResults: "Nema pronađenih rezultata",
  oneSearchResult: "Pronađen 1 rezultat",
  multipleSearchResults: "${count} rezultata pronađeno",
  // additional countries (not supported by country-list library)
  ac: "Ascension",
  xk: "Kosovo"
}, COe = { ...$Oe, ...SOe }, EOe = {
  ad: "Andorra",
  ae: "Emirati Arabi Uniti",
  af: "Afghanistan",
  ag: "Antigua e Barbuda",
  ai: "Anguilla",
  al: "Albania",
  am: "Armenia",
  ao: "Angola",
  ar: "Argentina",
  as: "Samoa americane",
  at: "Austria",
  au: "Australia",
  aw: "Aruba",
  ax: "Isole Åland",
  az: "Azerbaigian",
  ba: "Bosnia ed Erzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgio",
  bf: "Burkina Faso",
  bg: "Bulgaria",
  bh: "Bahrein",
  bi: "Burundi",
  bj: "Benin",
  bl: "Saint-Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Caraibi olandesi",
  br: "Brasile",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Bielorussia",
  bz: "Belize",
  ca: "Canada",
  cc: "Isole Cocos (Keeling)",
  cd: "Congo - Kinshasa",
  cf: "Repubblica Centrafricana",
  cg: "Congo-Brazzaville",
  ch: "Svizzera",
  ci: "Costa d’Avorio",
  ck: "Isole Cook",
  cl: "Cile",
  cm: "Camerun",
  cn: "Cina",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Capo Verde",
  cw: "Curaçao",
  cx: "Isola Christmas",
  cy: "Cipro",
  cz: "Cechia",
  de: "Germania",
  dj: "Gibuti",
  dk: "Danimarca",
  dm: "Dominica",
  do: "Repubblica Dominicana",
  dz: "Algeria",
  ec: "Ecuador",
  ee: "Estonia",
  eg: "Egitto",
  eh: "Sahara occidentale",
  er: "Eritrea",
  es: "Spagna",
  et: "Etiopia",
  fi: "Finlandia",
  fj: "Figi",
  fk: "Isole Falkland",
  fm: "Micronesia",
  fo: "Isole Fær Øer",
  fr: "Francia",
  ga: "Gabon",
  gb: "Regno Unito",
  gd: "Grenada",
  ge: "Georgia",
  gf: "Guyana francese",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibilterra",
  gl: "Groenlandia",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadalupa",
  gq: "Guinea Equatoriale",
  gr: "Grecia",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "RAS di Hong Kong",
  hn: "Honduras",
  hr: "Croazia",
  ht: "Haiti",
  hu: "Ungheria",
  id: "Indonesia",
  ie: "Irlanda",
  il: "Israele",
  im: "Isola di Man",
  in: "India",
  io: "Territorio britannico dell’Oceano Indiano",
  iq: "Iraq",
  ir: "Iran",
  is: "Islanda",
  it: "Italia",
  je: "Jersey",
  jm: "Giamaica",
  jo: "Giordania",
  jp: "Giappone",
  ke: "Kenya",
  kg: "Kirghizistan",
  kh: "Cambogia",
  ki: "Kiribati",
  km: "Comore",
  kn: "Saint Kitts e Nevis",
  kp: "Corea del Nord",
  kr: "Corea del Sud",
  kw: "Kuwait",
  ky: "Isole Cayman",
  kz: "Kazakistan",
  la: "Laos",
  lb: "Libano",
  lc: "Saint Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Lituania",
  lu: "Lussemburgo",
  lv: "Lettonia",
  ly: "Libia",
  ma: "Marocco",
  mc: "Monaco",
  md: "Moldavia",
  me: "Montenegro",
  mf: "Saint Martin",
  mg: "Madagascar",
  mh: "Isole Marshall",
  mk: "Macedonia del Nord",
  ml: "Mali",
  mm: "Myanmar (Birmania)",
  mn: "Mongolia",
  mo: "RAS di Macao",
  mp: "Isole Marianne settentrionali",
  mq: "Martinica",
  mr: "Mauritania",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldive",
  mw: "Malawi",
  mx: "Messico",
  my: "Malaysia",
  mz: "Mozambico",
  na: "Namibia",
  nc: "Nuova Caledonia",
  ne: "Niger",
  nf: "Isola Norfolk",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Paesi Bassi",
  no: "Norvegia",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nuova Zelanda",
  om: "Oman",
  pa: "Panamá",
  pe: "Perù",
  pf: "Polinesia francese",
  pg: "Papua Nuova Guinea",
  ph: "Filippine",
  pk: "Pakistan",
  pl: "Polonia",
  pm: "Saint-Pierre e Miquelon",
  pr: "Portorico",
  ps: "Territori palestinesi",
  pt: "Portogallo",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Riunione",
  ro: "Romania",
  rs: "Serbia",
  ru: "Russia",
  rw: "Ruanda",
  sa: "Arabia Saudita",
  sb: "Isole Salomone",
  sc: "Seychelles",
  sd: "Sudan",
  se: "Svezia",
  sg: "Singapore",
  sh: "Sant’Elena",
  si: "Slovenia",
  sj: "Svalbard e Jan Mayen",
  sk: "Slovacchia",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Suriname",
  ss: "Sud Sudan",
  st: "São Tomé e Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Siria",
  sz: "Swaziland",
  tc: "Isole Turks e Caicos",
  td: "Ciad",
  tg: "Togo",
  th: "Thailandia",
  tj: "Tagikistan",
  tk: "Tokelau",
  tl: "Timor Est",
  tm: "Turkmenistan",
  tn: "Tunisia",
  to: "Tonga",
  tr: "Turchia",
  tt: "Trinidad e Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ucraina",
  ug: "Uganda",
  us: "Stati Uniti",
  uy: "Uruguay",
  uz: "Uzbekistan",
  va: "Città del Vaticano",
  vc: "Saint Vincent e Grenadine",
  ve: "Venezuela",
  vg: "Isole Vergini Britanniche",
  vi: "Isole Vergini Americane",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis e Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "Sudafrica",
  zm: "Zambia",
  zw: "Zimbabwe"
}, jOe = {
  selectedCountryAriaLabel: "Paese selezionato",
  noCountrySelected: "Nessun paese selezionato",
  countryListAriaLabel: "Elenco dei paesi",
  searchPlaceholder: "Ricerca",
  zeroSearchResults: "Nessun risultato trovato",
  oneSearchResult: "1 risultato trovato",
  multipleSearchResults: "${count} risultati trovati",
  // additional countries (not supported by country-list library)
  ac: "Isola di Ascensione",
  xk: "Kosovo"
}, OOe = { ...EOe, ...jOe }, zOe = {
  ad: "Andorra",
  ae: "Verenigde Arabische Emiraten",
  af: "Afghanistan",
  ag: "Antigua en Barbuda",
  ai: "Anguilla",
  al: "Albanië",
  am: "Armenië",
  ao: "Angola",
  ar: "Argentinië",
  as: "Amerikaans-Samoa",
  at: "Oostenrijk",
  au: "Australië",
  aw: "Aruba",
  ax: "Åland",
  az: "Azerbeidzjan",
  ba: "Bosnië en Herzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "België",
  bf: "Burkina Faso",
  bg: "Bulgarije",
  bh: "Bahrein",
  bi: "Burundi",
  bj: "Benin",
  bl: "Saint-Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Caribisch Nederland",
  br: "Brazilië",
  bs: "Bahama’s",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Belarus",
  bz: "Belize",
  ca: "Canada",
  cc: "Cocoseilanden",
  cd: "Congo-Kinshasa",
  cf: "Centraal-Afrikaanse Republiek",
  cg: "Congo-Brazzaville",
  ch: "Zwitserland",
  ci: "Ivoorkust",
  ck: "Cookeilanden",
  cl: "Chili",
  cm: "Kameroen",
  cn: "China",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Kaapverdië",
  cw: "Curaçao",
  cx: "Christmaseiland",
  cy: "Cyprus",
  cz: "Tsjechië",
  de: "Duitsland",
  dj: "Djibouti",
  dk: "Denemarken",
  dm: "Dominica",
  do: "Dominicaanse Republiek",
  dz: "Algerije",
  ec: "Ecuador",
  ee: "Estland",
  eg: "Egypte",
  eh: "Westelijke Sahara",
  er: "Eritrea",
  es: "Spanje",
  et: "Ethiopië",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falklandeilanden",
  fm: "Micronesia",
  fo: "Faeröer",
  fr: "Frankrijk",
  ga: "Gabon",
  gb: "Verenigd Koninkrijk",
  gd: "Grenada",
  ge: "Georgië",
  gf: "Frans-Guyana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Groenland",
  gm: "Gambia",
  gn: "Guinee",
  gp: "Guadeloupe",
  gq: "Equatoriaal-Guinea",
  gr: "Griekenland",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinee-Bissau",
  gy: "Guyana",
  hk: "Hongkong SAR van China",
  hn: "Honduras",
  hr: "Kroatië",
  ht: "Haïti",
  hu: "Hongarije",
  id: "Indonesië",
  ie: "Ierland",
  il: "Israël",
  im: "Isle of Man",
  in: "India",
  io: "Brits Indische Oceaanterritorium",
  iq: "Irak",
  ir: "Iran",
  is: "IJsland",
  it: "Italië",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordanië",
  jp: "Japan",
  ke: "Kenia",
  kg: "Kirgizië",
  kh: "Cambodja",
  ki: "Kiribati",
  km: "Comoren",
  kn: "Saint Kitts en Nevis",
  kp: "Noord-Korea",
  kr: "Zuid-Korea",
  kw: "Koeweit",
  ky: "Kaaimaneilanden",
  kz: "Kazachstan",
  la: "Laos",
  lb: "Libanon",
  lc: "Saint Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Litouwen",
  lu: "Luxemburg",
  lv: "Letland",
  ly: "Libië",
  ma: "Marokko",
  mc: "Monaco",
  md: "Moldavië",
  me: "Montenegro",
  mf: "Saint-Martin",
  mg: "Madagaskar",
  mh: "Marshalleilanden",
  mk: "Noord-Macedonië",
  ml: "Mali",
  mm: "Myanmar (Birma)",
  mn: "Mongolië",
  mo: "Macau SAR van China",
  mp: "Noordelijke Marianen",
  mq: "Martinique",
  mr: "Mauritanië",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldiven",
  mw: "Malawi",
  mx: "Mexico",
  my: "Maleisië",
  mz: "Mozambique",
  na: "Namibië",
  nc: "Nieuw-Caledonië",
  ne: "Niger",
  nf: "Norfolk",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Nederland",
  no: "Noorwegen",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nieuw-Zeeland",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Frans-Polynesië",
  pg: "Papoea-Nieuw-Guinea",
  ph: "Filipijnen",
  pk: "Pakistan",
  pl: "Polen",
  pm: "Saint-Pierre en Miquelon",
  pr: "Puerto Rico",
  ps: "Palestijnse gebieden",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Roemenië",
  rs: "Servië",
  ru: "Rusland",
  rw: "Rwanda",
  sa: "Saoedi-Arabië",
  sb: "Salomonseilanden",
  sc: "Seychellen",
  sd: "Soedan",
  se: "Zweden",
  sg: "Singapore",
  sh: "Sint-Helena",
  si: "Slovenië",
  sj: "Spitsbergen en Jan Mayen",
  sk: "Slowakije",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalië",
  sr: "Suriname",
  ss: "Zuid-Soedan",
  st: "Sao Tomé en Principe",
  sv: "El Salvador",
  sx: "Sint-Maarten",
  sy: "Syrië",
  sz: "eSwatini",
  tc: "Turks- en Caicoseilanden",
  td: "Tsjaad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tadzjikistan",
  tk: "Tokelau",
  tl: "Oost-Timor",
  tm: "Turkmenistan",
  tn: "Tunesië",
  to: "Tonga",
  tr: "Turkije",
  tt: "Trinidad en Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Oekraïne",
  ug: "Oeganda",
  us: "Verenigde Staten",
  uy: "Uruguay",
  uz: "Oezbekistan",
  va: "Vaticaanstad",
  vc: "Saint Vincent en de Grenadines",
  ve: "Venezuela",
  vg: "Britse Maagdeneilanden",
  vi: "Amerikaanse Maagdeneilanden",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis en Futuna",
  ws: "Samoa",
  ye: "Jemen",
  yt: "Mayotte",
  za: "Zuid-Afrika",
  zm: "Zambia",
  zw: "Zimbabwe"
}, AOe = {
  selectedCountryAriaLabel: "Geselecteerd land",
  noCountrySelected: "Geen land geselecteerd",
  countryListAriaLabel: "Lijst met landen",
  searchPlaceholder: "Zoekopdracht",
  zeroSearchResults: "Geen resultaten gevonden",
  oneSearchResult: "1 resultaat gevonden",
  multipleSearchResults: "${count} resultaten gevonden",
  // additional countries (not supported by country-list library)
  ac: "Ascension-eiland",
  xk: "Kosovo"
}, Up = { ...zOe, ...AOe }, POe = {
  ad: "Andorra",
  ae: "Emirados Árabes Unidos",
  af: "Afeganistão",
  ag: "Antígua e Barbuda",
  ai: "Anguila",
  al: "Albânia",
  am: "Armênia",
  ao: "Angola",
  ar: "Argentina",
  as: "Samoa Americana",
  at: "Áustria",
  au: "Austrália",
  aw: "Aruba",
  ax: "Ilhas Aland",
  az: "Azerbaijão",
  ba: "Bósnia e Herzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Bélgica",
  bf: "Burquina Faso",
  bg: "Bulgária",
  bh: "Bahrein",
  bi: "Burundi",
  bj: "Benin",
  bl: "São Bartolomeu",
  bm: "Bermudas",
  bn: "Brunei",
  bo: "Bolívia",
  bq: "Países Baixos Caribenhos",
  br: "Brasil",
  bs: "Bahamas",
  bt: "Butão",
  bw: "Botsuana",
  by: "Bielorrússia",
  bz: "Belize",
  ca: "Canadá",
  cc: "Ilhas Cocos (Keeling)",
  cd: "Congo - Kinshasa",
  cf: "República Centro-Africana",
  cg: "República do Congo",
  ch: "Suíça",
  ci: "Costa do Marfim",
  ck: "Ilhas Cook",
  cl: "Chile",
  cm: "Camarões",
  cn: "China",
  co: "Colômbia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cabo Verde",
  cw: "Curaçao",
  cx: "Ilha Christmas",
  cy: "Chipre",
  cz: "Tchéquia",
  de: "Alemanha",
  dj: "Djibuti",
  dk: "Dinamarca",
  dm: "Dominica",
  do: "República Dominicana",
  dz: "Argélia",
  ec: "Equador",
  ee: "Estônia",
  eg: "Egito",
  eh: "Saara Ocidental",
  er: "Eritreia",
  es: "Espanha",
  et: "Etiópia",
  fi: "Finlândia",
  fj: "Fiji",
  fk: "Ilhas Malvinas",
  fm: "Micronésia",
  fo: "Ilhas Faroe",
  fr: "França",
  ga: "Gabão",
  gb: "Reino Unido",
  gd: "Granada",
  ge: "Geórgia",
  gf: "Guiana Francesa",
  gg: "Guernsey",
  gh: "Gana",
  gi: "Gibraltar",
  gl: "Groenlândia",
  gm: "Gâmbia",
  gn: "Guiné",
  gp: "Guadalupe",
  gq: "Guiné Equatorial",
  gr: "Grécia",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guiné-Bissau",
  gy: "Guiana",
  hk: "Hong Kong, RAE da China",
  hn: "Honduras",
  hr: "Croácia",
  ht: "Haiti",
  hu: "Hungria",
  id: "Indonésia",
  ie: "Irlanda",
  il: "Israel",
  im: "Ilha de Man",
  in: "Índia",
  io: "Território Britânico do Oceano Índico",
  iq: "Iraque",
  ir: "Irã",
  is: "Islândia",
  it: "Itália",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordânia",
  jp: "Japão",
  ke: "Quênia",
  kg: "Quirguistão",
  kh: "Camboja",
  ki: "Quiribati",
  km: "Comores",
  kn: "São Cristóvão e Névis",
  kp: "Coreia do Norte",
  kr: "Coreia do Sul",
  kw: "Kuwait",
  ky: "Ilhas Cayman",
  kz: "Cazaquistão",
  la: "Laos",
  lb: "Líbano",
  lc: "Santa Lúcia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Libéria",
  ls: "Lesoto",
  lt: "Lituânia",
  lu: "Luxemburgo",
  lv: "Letônia",
  ly: "Líbia",
  ma: "Marrocos",
  mc: "Mônaco",
  md: "Moldova",
  me: "Montenegro",
  mf: "São Martinho",
  mg: "Madagascar",
  mh: "Ilhas Marshall",
  mk: "Macedônia do Norte",
  ml: "Mali",
  mm: "Mianmar (Birmânia)",
  mn: "Mongólia",
  mo: "Macau, RAE da China",
  mp: "Ilhas Marianas do Norte",
  mq: "Martinica",
  mr: "Mauritânia",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Maurício",
  mv: "Maldivas",
  mw: "Malaui",
  mx: "México",
  my: "Malásia",
  mz: "Moçambique",
  na: "Namíbia",
  nc: "Nova Caledônia",
  ne: "Níger",
  nf: "Ilha Norfolk",
  ng: "Nigéria",
  ni: "Nicarágua",
  nl: "Países Baixos",
  no: "Noruega",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nova Zelândia",
  om: "Omã",
  pa: "Panamá",
  pe: "Peru",
  pf: "Polinésia Francesa",
  pg: "Papua-Nova Guiné",
  ph: "Filipinas",
  pk: "Paquistão",
  pl: "Polônia",
  pm: "São Pedro e Miquelão",
  pr: "Porto Rico",
  ps: "Territórios palestinos",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguai",
  qa: "Catar",
  re: "Reunião",
  ro: "Romênia",
  rs: "Sérvia",
  ru: "Rússia",
  rw: "Ruanda",
  sa: "Arábia Saudita",
  sb: "Ilhas Salomão",
  sc: "Seicheles",
  sd: "Sudão",
  se: "Suécia",
  sg: "Singapura",
  sh: "Santa Helena",
  si: "Eslovênia",
  sj: "Svalbard e Jan Mayen",
  sk: "Eslováquia",
  sl: "Serra Leoa",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somália",
  sr: "Suriname",
  ss: "Sudão do Sul",
  st: "São Tomé e Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Síria",
  sz: "Essuatíni",
  tc: "Ilhas Turcas e Caicos",
  td: "Chade",
  tg: "Togo",
  th: "Tailândia",
  tj: "Tadjiquistão",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turcomenistão",
  tn: "Tunísia",
  to: "Tonga",
  tr: "Turquia",
  tt: "Trinidad e Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzânia",
  ua: "Ucrânia",
  ug: "Uganda",
  us: "Estados Unidos",
  uy: "Uruguai",
  uz: "Uzbequistão",
  va: "Cidade do Vaticano",
  vc: "São Vicente e Granadinas",
  ve: "Venezuela",
  vg: "Ilhas Virgens Britânicas",
  vi: "Ilhas Virgens Americanas",
  vn: "Vietnã",
  vu: "Vanuatu",
  wf: "Wallis e Futuna",
  ws: "Samoa",
  ye: "Iêmen",
  yt: "Mayotte",
  za: "África do Sul",
  zm: "Zâmbia",
  zw: "Zimbábue"
}, DOe = {
  selectedCountryAriaLabel: "País selecionado",
  noCountrySelected: "Nenhum país selecionado",
  countryListAriaLabel: "Lista de países",
  searchPlaceholder: "Procurar",
  zeroSearchResults: "Nenhum resultado encontrado",
  oneSearchResult: "1 resultado encontrado",
  multipleSearchResults: "${count} resultados encontrados",
  // additional countries (not supported by country-list library)
  ac: "Ilha de Ascensão",
  xk: "Kosovo"
}, NOe = { ...POe, ...DOe }, ROe = {
  ad: "Andorra",
  ae: "Förenade Arabemiraten",
  af: "Afghanistan",
  ag: "Antigua och Barbuda",
  ai: "Anguilla",
  al: "Albanien",
  am: "Armenien",
  ao: "Angola",
  ar: "Argentina",
  as: "Amerikanska Samoa",
  at: "Österrike",
  au: "Australien",
  aw: "Aruba",
  ax: "Åland",
  az: "Azerbajdzjan",
  ba: "Bosnien och Hercegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgien",
  bf: "Burkina Faso",
  bg: "Bulgarien",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "S:t Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Karibiska Nederländerna",
  br: "Brasilien",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Vitryssland",
  bz: "Belize",
  ca: "Kanada",
  cc: "Kokosöarna",
  cd: "Kongo-Kinshasa",
  cf: "Centralafrikanska republiken",
  cg: "Kongo-Brazzaville",
  ch: "Schweiz",
  ci: "Côte d’Ivoire",
  ck: "Cooköarna",
  cl: "Chile",
  cm: "Kamerun",
  cn: "Kina",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Kuba",
  cv: "Kap Verde",
  cw: "Curaçao",
  cx: "Julön",
  cy: "Cypern",
  cz: "Tjeckien",
  de: "Tyskland",
  dj: "Djibouti",
  dk: "Danmark",
  dm: "Dominica",
  do: "Dominikanska republiken",
  dz: "Algeriet",
  ec: "Ecuador",
  ee: "Estland",
  eg: "Egypten",
  eh: "Västsahara",
  er: "Eritrea",
  es: "Spanien",
  et: "Etiopien",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falklandsöarna",
  fm: "Mikronesien",
  fo: "Färöarna",
  fr: "Frankrike",
  ga: "Gabon",
  gb: "Storbritannien",
  gd: "Grenada",
  ge: "Georgien",
  gf: "Franska Guyana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Grönland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Ekvatorialguinea",
  gr: "Grekland",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "Hongkong",
  hn: "Honduras",
  hr: "Kroatien",
  ht: "Haiti",
  hu: "Ungern",
  id: "Indonesien",
  ie: "Irland",
  il: "Israel",
  im: "Isle of Man",
  in: "Indien",
  io: "Brittiska territoriet i Indiska oceanen",
  iq: "Irak",
  ir: "Iran",
  is: "Island",
  it: "Italien",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordanien",
  jp: "Japan",
  ke: "Kenya",
  kg: "Kirgizistan",
  kh: "Kambodja",
  ki: "Kiribati",
  km: "Komorerna",
  kn: "S:t Kitts och Nevis",
  kp: "Nordkorea",
  kr: "Sydkorea",
  kw: "Kuwait",
  ky: "Caymanöarna",
  kz: "Kazakstan",
  la: "Laos",
  lb: "Libanon",
  lc: "S:t Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Litauen",
  lu: "Luxemburg",
  lv: "Lettland",
  ly: "Libyen",
  ma: "Marocko",
  mc: "Monaco",
  md: "Moldavien",
  me: "Montenegro",
  mf: "Saint-Martin",
  mg: "Madagaskar",
  mh: "Marshallöarna",
  mk: "Nordmakedonien",
  ml: "Mali",
  mm: "Myanmar (Burma)",
  mn: "Mongoliet",
  mo: "Macao",
  mp: "Nordmarianerna",
  mq: "Martinique",
  mr: "Mauretanien",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldiverna",
  mw: "Malawi",
  mx: "Mexiko",
  my: "Malaysia",
  mz: "Moçambique",
  na: "Namibia",
  nc: "Nya Kaledonien",
  ne: "Niger",
  nf: "Norfolkön",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Nederländerna",
  no: "Norge",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nya Zeeland",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Franska Polynesien",
  pg: "Papua Nya Guinea",
  ph: "Filippinerna",
  pk: "Pakistan",
  pl: "Polen",
  pm: "S:t Pierre och Miquelon",
  pr: "Puerto Rico",
  ps: "Palestinska territorierna",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Rumänien",
  rs: "Serbien",
  ru: "Ryssland",
  rw: "Rwanda",
  sa: "Saudiarabien",
  sb: "Salomonöarna",
  sc: "Seychellerna",
  sd: "Sudan",
  se: "Sverige",
  sg: "Singapore",
  sh: "S:t Helena",
  si: "Slovenien",
  sj: "Svalbard och Jan Mayen",
  sk: "Slovakien",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Surinam",
  ss: "Sydsudan",
  st: "São Tomé och Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syrien",
  sz: "Swaziland",
  tc: "Turks- och Caicosöarna",
  td: "Tchad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tadzjikistan",
  tk: "Tokelau",
  tl: "Östtimor",
  tm: "Turkmenistan",
  tn: "Tunisien",
  to: "Tonga",
  tr: "Turkiet",
  tt: "Trinidad och Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ukraina",
  ug: "Uganda",
  us: "USA",
  uy: "Uruguay",
  uz: "Uzbekistan",
  va: "Vatikanstaten",
  vc: "S:t Vincent och Grenadinerna",
  ve: "Venezuela",
  vg: "Brittiska Jungfruöarna",
  vi: "Amerikanska Jungfruöarna",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis- och Futunaöarna",
  ws: "Samoa",
  ye: "Jemen",
  yt: "Mayotte",
  za: "Sydafrika",
  zm: "Zambia",
  zw: "Zimbabwe"
}, IOe = {
  selectedCountryAriaLabel: "Valt land",
  noCountrySelected: "Inget land valt",
  countryListAriaLabel: "Lista över länder",
  searchPlaceholder: "Sök",
  zeroSearchResults: "Inga resultat hittades",
  oneSearchResult: "1 resultat hittades",
  multipleSearchResults: "${count} resultat hittades",
  // additional countries (not supported by country-list library)
  ac: "Ascension",
  xk: "Kosovo"
}, TOe = { ...ROe, ...IOe }, LOe = {
  en: bOe,
  fr: xOe,
  it: OOe,
  es: yOe,
  de: pOe,
  da: dOe,
  hr: COe,
  nb: Up,
  nl: Up,
  pt: NOe,
  sv: TOe
}, qp = {
  error: "is-error"
}, Hp = {
  error: {
    name: "error-warning-fill",
    color: "error"
  }
};
var MOe = [
  [
    "af",
    // Afghanistan
    "93"
  ],
  [
    "ax",
    // Åland Islands
    "358",
    1
  ],
  [
    "al",
    // Albania
    "355"
  ],
  [
    "dz",
    // Algeria
    "213"
  ],
  [
    "as",
    // American Samoa
    "1",
    5,
    ["684"]
  ],
  [
    "ad",
    // Andorra
    "376"
  ],
  [
    "ao",
    // Angola
    "244"
  ],
  [
    "ai",
    // Anguilla
    "1",
    6,
    ["264"]
  ],
  [
    "ag",
    // Antigua and Barbuda
    "1",
    7,
    ["268"]
  ],
  [
    "ar",
    // Argentina
    "54"
  ],
  [
    "am",
    // Armenia
    "374"
  ],
  [
    "aw",
    // Aruba
    "297"
  ],
  [
    "ac",
    // Ascension Island
    "247"
  ],
  [
    "au",
    // Australia
    "61",
    0,
    null,
    "0"
  ],
  [
    "at",
    // Austria
    "43"
  ],
  [
    "az",
    // Azerbaijan
    "994"
  ],
  [
    "bs",
    // Bahamas
    "1",
    8,
    ["242"]
  ],
  [
    "bh",
    // Bahrain
    "973"
  ],
  [
    "bd",
    // Bangladesh
    "880"
  ],
  [
    "bb",
    // Barbados
    "1",
    9,
    ["246"]
  ],
  [
    "by",
    // Belarus
    "375"
  ],
  [
    "be",
    // Belgium
    "32"
  ],
  [
    "bz",
    // Belize
    "501"
  ],
  [
    "bj",
    // Benin
    "229"
  ],
  [
    "bm",
    // Bermuda
    "1",
    10,
    ["441"]
  ],
  [
    "bt",
    // Bhutan
    "975"
  ],
  [
    "bo",
    // Bolivia
    "591"
  ],
  [
    "ba",
    // Bosnia and Herzegovina
    "387"
  ],
  [
    "bw",
    // Botswana
    "267"
  ],
  [
    "br",
    // Brazil
    "55"
  ],
  [
    "io",
    // British Indian Ocean Territory
    "246"
  ],
  [
    "vg",
    // British Virgin Islands
    "1",
    11,
    ["284"]
  ],
  [
    "bn",
    // Brunei
    "673"
  ],
  [
    "bg",
    // Bulgaria
    "359"
  ],
  [
    "bf",
    // Burkina Faso
    "226"
  ],
  [
    "bi",
    // Burundi
    "257"
  ],
  [
    "kh",
    // Cambodia
    "855"
  ],
  [
    "cm",
    // Cameroon
    "237"
  ],
  [
    "ca",
    // Canada
    "1",
    1,
    ["204", "226", "236", "249", "250", "263", "289", "306", "343", "354", "365", "367", "368", "382", "387", "403", "416", "418", "428", "431", "437", "438", "450", "584", "468", "474", "506", "514", "519", "548", "579", "581", "584", "587", "604", "613", "639", "647", "672", "683", "705", "709", "742", "753", "778", "780", "782", "807", "819", "825", "867", "873", "879", "902", "905"]
  ],
  [
    "cv",
    // Cape Verde
    "238"
  ],
  [
    "bq",
    // Caribbean Netherlands
    "599",
    1,
    ["3", "4", "7"]
  ],
  [
    "ky",
    // Cayman Islands
    "1",
    12,
    ["345"]
  ],
  [
    "cf",
    // Central African Republic
    "236"
  ],
  [
    "td",
    // Chad
    "235"
  ],
  [
    "cl",
    // Chile
    "56"
  ],
  [
    "cn",
    // China
    "86"
  ],
  [
    "cx",
    // Christmas Island
    "61",
    2,
    ["89164"],
    "0"
  ],
  [
    "cc",
    // Cocos (Keeling) Islands
    "61",
    1,
    ["89162"],
    "0"
  ],
  [
    "co",
    // Colombia
    "57"
  ],
  [
    "km",
    // Comoros
    "269"
  ],
  [
    "cg",
    // Congo (Brazzaville)
    "242"
  ],
  [
    "cd",
    // Congo (Kinshasa)
    "243"
  ],
  [
    "ck",
    // Cook Islands
    "682"
  ],
  [
    "cr",
    // Costa Rica
    "506"
  ],
  [
    "ci",
    // Côte d'Ivoire
    "225"
  ],
  [
    "hr",
    // Croatia
    "385"
  ],
  [
    "cu",
    // Cuba
    "53"
  ],
  [
    "cw",
    // Curaçao
    "599",
    0
  ],
  [
    "cy",
    // Cyprus
    "357"
  ],
  [
    "cz",
    // Czech Republic
    "420"
  ],
  [
    "dk",
    // Denmark
    "45"
  ],
  [
    "dj",
    // Djibouti
    "253"
  ],
  [
    "dm",
    // Dominica
    "1",
    13,
    ["767"]
  ],
  [
    "do",
    // Dominican Republic
    "1",
    2,
    ["809", "829", "849"]
  ],
  [
    "ec",
    // Ecuador
    "593"
  ],
  [
    "eg",
    // Egypt
    "20"
  ],
  [
    "sv",
    // El Salvador
    "503"
  ],
  [
    "gq",
    // Equatorial Guinea
    "240"
  ],
  [
    "er",
    // Eritrea
    "291"
  ],
  [
    "ee",
    // Estonia
    "372"
  ],
  [
    "sz",
    // Eswatini
    "268"
  ],
  [
    "et",
    // Ethiopia
    "251"
  ],
  [
    "fk",
    // Falkland Islands (Malvinas)
    "500"
  ],
  [
    "fo",
    // Faroe Islands
    "298"
  ],
  [
    "fj",
    // Fiji
    "679"
  ],
  [
    "fi",
    // Finland
    "358",
    0
  ],
  [
    "fr",
    // France
    "33"
  ],
  [
    "gf",
    // French Guiana
    "594"
  ],
  [
    "pf",
    // French Polynesia
    "689"
  ],
  [
    "ga",
    // Gabon
    "241"
  ],
  [
    "gm",
    // Gambia
    "220"
  ],
  [
    "ge",
    // Georgia
    "995"
  ],
  [
    "de",
    // Germany
    "49"
  ],
  [
    "gh",
    // Ghana
    "233"
  ],
  [
    "gi",
    // Gibraltar
    "350"
  ],
  [
    "gr",
    // Greece
    "30"
  ],
  [
    "gl",
    // Greenland
    "299"
  ],
  [
    "gd",
    // Grenada
    "1",
    14,
    ["473"]
  ],
  [
    "gp",
    // Guadeloupe
    "590",
    0
  ],
  [
    "gu",
    // Guam
    "1",
    15,
    ["671"]
  ],
  [
    "gt",
    // Guatemala
    "502"
  ],
  [
    "gg",
    // Guernsey
    "44",
    1,
    ["1481", "7781", "7839", "7911"],
    "0"
  ],
  [
    "gn",
    // Guinea
    "224"
  ],
  [
    "gw",
    // Guinea-Bissau
    "245"
  ],
  [
    "gy",
    // Guyana
    "592"
  ],
  [
    "ht",
    // Haiti
    "509"
  ],
  [
    "hn",
    // Honduras
    "504"
  ],
  [
    "hk",
    // Hong Kong SAR China
    "852"
  ],
  [
    "hu",
    // Hungary
    "36"
  ],
  [
    "is",
    // Iceland
    "354"
  ],
  [
    "in",
    // India
    "91"
  ],
  [
    "id",
    // Indonesia
    "62"
  ],
  [
    "ir",
    // Iran
    "98"
  ],
  [
    "iq",
    // Iraq
    "964"
  ],
  [
    "ie",
    // Ireland
    "353"
  ],
  [
    "im",
    // Isle of Man
    "44",
    2,
    ["1624", "74576", "7524", "7924", "7624"],
    "0"
  ],
  [
    "il",
    // Israel
    "972"
  ],
  [
    "it",
    // Italy
    "39",
    0
  ],
  [
    "jm",
    // Jamaica
    "1",
    4,
    ["876", "658"]
  ],
  [
    "jp",
    // Japan
    "81"
  ],
  [
    "je",
    // Jersey
    "44",
    3,
    ["1534", "7509", "7700", "7797", "7829", "7937"],
    "0"
  ],
  [
    "jo",
    // Jordan
    "962"
  ],
  [
    "kz",
    // Kazakhstan
    "7",
    1,
    ["33", "7"],
    "8"
  ],
  [
    "ke",
    // Kenya
    "254"
  ],
  [
    "ki",
    // Kiribati
    "686"
  ],
  [
    "xk",
    // Kosovo
    "383"
  ],
  [
    "kw",
    // Kuwait
    "965"
  ],
  [
    "kg",
    // Kyrgyzstan
    "996"
  ],
  [
    "la",
    // Laos
    "856"
  ],
  [
    "lv",
    // Latvia
    "371"
  ],
  [
    "lb",
    // Lebanon
    "961"
  ],
  [
    "ls",
    // Lesotho
    "266"
  ],
  [
    "lr",
    // Liberia
    "231"
  ],
  [
    "ly",
    // Libya
    "218"
  ],
  [
    "li",
    // Liechtenstein
    "423"
  ],
  [
    "lt",
    // Lithuania
    "370"
  ],
  [
    "lu",
    // Luxembourg
    "352"
  ],
  [
    "mo",
    // Macao SAR China
    "853"
  ],
  [
    "mg",
    // Madagascar
    "261"
  ],
  [
    "mw",
    // Malawi
    "265"
  ],
  [
    "my",
    // Malaysia
    "60"
  ],
  [
    "mv",
    // Maldives
    "960"
  ],
  [
    "ml",
    // Mali
    "223"
  ],
  [
    "mt",
    // Malta
    "356"
  ],
  [
    "mh",
    // Marshall Islands
    "692"
  ],
  [
    "mq",
    // Martinique
    "596"
  ],
  [
    "mr",
    // Mauritania
    "222"
  ],
  [
    "mu",
    // Mauritius
    "230"
  ],
  [
    "yt",
    // Mayotte
    "262",
    1,
    ["269", "639"],
    "0"
  ],
  [
    "mx",
    // Mexico
    "52"
  ],
  [
    "fm",
    // Micronesia
    "691"
  ],
  [
    "md",
    // Moldova
    "373"
  ],
  [
    "mc",
    // Monaco
    "377"
  ],
  [
    "mn",
    // Mongolia
    "976"
  ],
  [
    "me",
    // Montenegro
    "382"
  ],
  [
    "ms",
    // Montserrat
    "1",
    16,
    ["664"]
  ],
  [
    "ma",
    // Morocco
    "212",
    0,
    null,
    "0"
  ],
  [
    "mz",
    // Mozambique
    "258"
  ],
  [
    "mm",
    // Myanmar (Burma)
    "95"
  ],
  [
    "na",
    // Namibia
    "264"
  ],
  [
    "nr",
    // Nauru
    "674"
  ],
  [
    "np",
    // Nepal
    "977"
  ],
  [
    "nl",
    // Netherlands
    "31"
  ],
  [
    "nc",
    // New Caledonia
    "687"
  ],
  [
    "nz",
    // New Zealand
    "64"
  ],
  [
    "ni",
    // Nicaragua
    "505"
  ],
  [
    "ne",
    // Niger
    "227"
  ],
  [
    "ng",
    // Nigeria
    "234"
  ],
  [
    "nu",
    // Niue
    "683"
  ],
  [
    "nf",
    // Norfolk Island
    "672"
  ],
  [
    "kp",
    // North Korea
    "850"
  ],
  [
    "mk",
    // North Macedonia
    "389"
  ],
  [
    "mp",
    // Northern Mariana Islands
    "1",
    17,
    ["670"]
  ],
  [
    "no",
    // Norway
    "47",
    0
  ],
  [
    "om",
    // Oman
    "968"
  ],
  [
    "pk",
    // Pakistan
    "92"
  ],
  [
    "pw",
    // Palau
    "680"
  ],
  [
    "ps",
    // Palestinian Territories
    "970"
  ],
  [
    "pa",
    // Panama
    "507"
  ],
  [
    "pg",
    // Papua New Guinea
    "675"
  ],
  [
    "py",
    // Paraguay
    "595"
  ],
  [
    "pe",
    // Peru
    "51"
  ],
  [
    "ph",
    // Philippines
    "63"
  ],
  [
    "pl",
    // Poland
    "48"
  ],
  [
    "pt",
    // Portugal
    "351"
  ],
  [
    "pr",
    // Puerto Rico
    "1",
    3,
    ["787", "939"]
  ],
  [
    "qa",
    // Qatar
    "974"
  ],
  [
    "re",
    // Réunion
    "262",
    0,
    null,
    "0"
  ],
  [
    "ro",
    // Romania
    "40"
  ],
  [
    "ru",
    // Russia
    "7",
    0,
    null,
    "8"
  ],
  [
    "rw",
    // Rwanda
    "250"
  ],
  [
    "ws",
    // Samoa
    "685"
  ],
  [
    "sm",
    // San Marino
    "378"
  ],
  [
    "st",
    // São Tomé & Príncipe
    "239"
  ],
  [
    "sa",
    // Saudi Arabia
    "966"
  ],
  [
    "sn",
    // Senegal
    "221"
  ],
  [
    "rs",
    // Serbia
    "381"
  ],
  [
    "sc",
    // Seychelles
    "248"
  ],
  [
    "sl",
    // Sierra Leone
    "232"
  ],
  [
    "sg",
    // Singapore
    "65"
  ],
  [
    "sx",
    // Sint Maarten
    "1",
    21,
    ["721"]
  ],
  [
    "sk",
    // Slovakia
    "421"
  ],
  [
    "si",
    // Slovenia
    "386"
  ],
  [
    "sb",
    // Solomon Islands
    "677"
  ],
  [
    "so",
    // Somalia
    "252"
  ],
  [
    "za",
    // South Africa
    "27"
  ],
  [
    "kr",
    // South Korea
    "82"
  ],
  [
    "ss",
    // South Sudan
    "211"
  ],
  [
    "es",
    // Spain
    "34"
  ],
  [
    "lk",
    // Sri Lanka
    "94"
  ],
  [
    "bl",
    // St. Barthélemy
    "590",
    1
  ],
  [
    "sh",
    // St. Helena
    "290"
  ],
  [
    "kn",
    // St. Kitts & Nevis
    "1",
    18,
    ["869"]
  ],
  [
    "lc",
    // St. Lucia
    "1",
    19,
    ["758"]
  ],
  [
    "mf",
    // St. Martin
    "590",
    2
  ],
  [
    "pm",
    // St. Pierre & Miquelon
    "508"
  ],
  [
    "vc",
    // St. Vincent & Grenadines
    "1",
    20,
    ["784"]
  ],
  [
    "sd",
    // Sudan
    "249"
  ],
  [
    "sr",
    // Suriname
    "597"
  ],
  [
    "sj",
    // Svalbard & Jan Mayen
    "47",
    1,
    ["79"]
  ],
  [
    "se",
    // Sweden
    "46"
  ],
  [
    "ch",
    // Switzerland
    "41"
  ],
  [
    "sy",
    // Syria
    "963"
  ],
  [
    "tw",
    // Taiwan
    "886"
  ],
  [
    "tj",
    // Tajikistan
    "992"
  ],
  [
    "tz",
    // Tanzania
    "255"
  ],
  [
    "th",
    // Thailand
    "66"
  ],
  [
    "tl",
    // Timor-Leste
    "670"
  ],
  [
    "tg",
    // Togo
    "228"
  ],
  [
    "tk",
    // Tokelau
    "690"
  ],
  [
    "to",
    // Tonga
    "676"
  ],
  [
    "tt",
    // Trinidad & Tobago
    "1",
    22,
    ["868"]
  ],
  [
    "tn",
    // Tunisia
    "216"
  ],
  [
    "tr",
    // Turkey
    "90"
  ],
  [
    "tm",
    // Turkmenistan
    "993"
  ],
  [
    "tc",
    // Turks & Caicos Islands
    "1",
    23,
    ["649"]
  ],
  [
    "tv",
    // Tuvalu
    "688"
  ],
  [
    "vi",
    // U.S. Virgin Islands
    "1",
    24,
    ["340"]
  ],
  [
    "ug",
    // Uganda
    "256"
  ],
  [
    "ua",
    // Ukraine
    "380"
  ],
  [
    "ae",
    // United Arab Emirates
    "971"
  ],
  [
    "gb",
    // United Kingdom
    "44",
    0,
    null,
    "0"
  ],
  [
    "us",
    // United States
    "1",
    0
  ],
  [
    "uy",
    // Uruguay
    "598"
  ],
  [
    "uz",
    // Uzbekistan
    "998"
  ],
  [
    "vu",
    // Vanuatu
    "678"
  ],
  [
    "va",
    // Vatican City
    "39",
    1,
    ["06698"]
  ],
  [
    "ve",
    // Venezuela
    "58"
  ],
  [
    "vn",
    // Vietnam
    "84"
  ],
  [
    "wf",
    // Wallis & Futuna
    "681"
  ],
  [
    "eh",
    // Western Sahara
    "212",
    1,
    ["5288", "5289"],
    "0"
  ],
  [
    "ye",
    // Yemen
    "967"
  ],
  [
    "zm",
    // Zambia
    "260"
  ],
  [
    "zw",
    // Zimbabwe
    "263"
  ]
], xw = [];
for (const e of MOe)
  xw.push({
    name: "",
    // populated in the plugin
    iso2: e[0],
    dialCode: e[1],
    priority: e[2] || 0,
    areaCodes: e[3] || null,
    nodeById: {},
    // populated by the plugin
    nationalPrefix: e[4] || null
  });
var Fo = xw, WOe = {
  ad: "Andorra",
  ae: "United Arab Emirates",
  af: "Afghanistan",
  ag: "Antigua & Barbuda",
  ai: "Anguilla",
  al: "Albania",
  am: "Armenia",
  ao: "Angola",
  ar: "Argentina",
  as: "American Samoa",
  at: "Austria",
  au: "Australia",
  aw: "Aruba",
  ax: "Åland Islands",
  az: "Azerbaijan",
  ba: "Bosnia & Herzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgium",
  bf: "Burkina Faso",
  bg: "Bulgaria",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "St. Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Caribbean Netherlands",
  br: "Brazil",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Belarus",
  bz: "Belize",
  ca: "Canada",
  cc: "Cocos (Keeling) Islands",
  cd: "Congo - Kinshasa",
  cf: "Central African Republic",
  cg: "Congo - Brazzaville",
  ch: "Switzerland",
  ci: "Côte d’Ivoire",
  ck: "Cook Islands",
  cl: "Chile",
  cm: "Cameroon",
  cn: "China",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cape Verde",
  cw: "Curaçao",
  cx: "Christmas Island",
  cy: "Cyprus",
  cz: "Czechia",
  de: "Germany",
  dj: "Djibouti",
  dk: "Denmark",
  dm: "Dominica",
  do: "Dominican Republic",
  dz: "Algeria",
  ec: "Ecuador",
  ee: "Estonia",
  eg: "Egypt",
  eh: "Western Sahara",
  er: "Eritrea",
  es: "Spain",
  et: "Ethiopia",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falkland Islands",
  fm: "Micronesia",
  fo: "Faroe Islands",
  fr: "France",
  ga: "Gabon",
  gb: "United Kingdom",
  gd: "Grenada",
  ge: "Georgia",
  gf: "French Guiana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Greenland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Equatorial Guinea",
  gr: "Greece",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "Hong Kong SAR China",
  hn: "Honduras",
  hr: "Croatia",
  ht: "Haiti",
  hu: "Hungary",
  id: "Indonesia",
  ie: "Ireland",
  il: "Israel",
  im: "Isle of Man",
  in: "India",
  io: "British Indian Ocean Territory",
  iq: "Iraq",
  ir: "Iran",
  is: "Iceland",
  it: "Italy",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordan",
  jp: "Japan",
  ke: "Kenya",
  kg: "Kyrgyzstan",
  kh: "Cambodia",
  ki: "Kiribati",
  km: "Comoros",
  kn: "St. Kitts & Nevis",
  kp: "North Korea",
  kr: "South Korea",
  kw: "Kuwait",
  ky: "Cayman Islands",
  kz: "Kazakhstan",
  la: "Laos",
  lb: "Lebanon",
  lc: "St. Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Lithuania",
  lu: "Luxembourg",
  lv: "Latvia",
  ly: "Libya",
  ma: "Morocco",
  mc: "Monaco",
  md: "Moldova",
  me: "Montenegro",
  mf: "St. Martin",
  mg: "Madagascar",
  mh: "Marshall Islands",
  mk: "North Macedonia",
  ml: "Mali",
  mm: "Myanmar (Burma)",
  mn: "Mongolia",
  mo: "Macao SAR China",
  mp: "Northern Mariana Islands",
  mq: "Martinique",
  mr: "Mauritania",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldives",
  mw: "Malawi",
  mx: "Mexico",
  my: "Malaysia",
  mz: "Mozambique",
  na: "Namibia",
  nc: "New Caledonia",
  ne: "Niger",
  nf: "Norfolk Island",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Netherlands",
  no: "Norway",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "New Zealand",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "French Polynesia",
  pg: "Papua New Guinea",
  ph: "Philippines",
  pk: "Pakistan",
  pl: "Poland",
  pm: "St. Pierre & Miquelon",
  pr: "Puerto Rico",
  ps: "Palestinian Territories",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Romania",
  rs: "Serbia",
  ru: "Russia",
  rw: "Rwanda",
  sa: "Saudi Arabia",
  sb: "Solomon Islands",
  sc: "Seychelles",
  sd: "Sudan",
  se: "Sweden",
  sg: "Singapore",
  sh: "St. Helena",
  si: "Slovenia",
  sj: "Svalbard & Jan Mayen",
  sk: "Slovakia",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Suriname",
  ss: "South Sudan",
  st: "São Tomé & Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syria",
  sz: "Eswatini",
  tc: "Turks & Caicos Islands",
  td: "Chad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tajikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunisia",
  to: "Tonga",
  tr: "Turkey",
  tt: "Trinidad & Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ukraine",
  ug: "Uganda",
  us: "United States",
  uy: "Uruguay",
  uz: "Uzbekistan",
  va: "Vatican City",
  vc: "St. Vincent & Grenadines",
  ve: "Venezuela",
  vg: "British Virgin Islands",
  vi: "U.S. Virgin Islands",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis & Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "South Africa",
  zm: "Zambia",
  zw: "Zimbabwe"
}, BOe = WOe, FOe = {
  selectedCountryAriaLabel: "Change country, selected ${countryName} (${dialCode})",
  noCountrySelected: "Select country",
  countryListAriaLabel: "List of countries",
  searchPlaceholder: "Search",
  clearSearchAriaLabel: "Clear search",
  zeroSearchResults: "No results found",
  oneSearchResult: "1 result found",
  multipleSearchResults: "${count} results found",
  // additional countries (not supported by country-list library)
  ac: "Ascension Island",
  xk: "Kosovo"
}, VOe = FOe, UOe = { ...BOe, ...VOe }, $w = UOe, Il = (e) => typeof window < "u" && typeof window.matchMedia == "function" && window.matchMedia(e).matches, qOe = () => {
  if (typeof navigator < "u" && typeof window < "u") {
    const e = /Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent), t = Il("(max-width: 500px)"), a = Il("(max-height: 600px)"), o = Il("(pointer: coarse)");
    return e || t || o && a;
  }
  return !1;
}, Sw = {
  // Allow alphanumeric "phonewords" (e.g. +1 800 FLOWERS) as valid numbers
  allowPhonewords: !1,
  //* Whether or not to allow the dropdown.
  allowDropdown: !0,
  //* Add a placeholder in the input with an example number for the selected country.
  autoPlaceholder: "polite",
  //* Modify the parentClass.
  containerClass: "",
  //* The order of the countries in the dropdown. Defaults to alphabetical.
  countryOrder: null,
  //* Add a country search input at the top of the dropdown.
  countrySearch: !0,
  //* Modify the auto placeholder.
  customPlaceholder: null,
  //* Append menu to specified element.
  dropdownContainer: null,
  //* Don't display these countries.
  excludeCountries: [],
  //* Fix the dropdown width to the input width (rather than being as wide as the longest country name).
  fixDropdownWidth: !0,
  //* Format the number as the user types
  formatAsYouType: !0,
  //* Format the input value during initialisation and on setNumber.
  formatOnDisplay: !0,
  //* geoIp lookup function.
  geoIpLookup: null,
  //* Inject a hidden input with the name returned from this function, and on submit, populate it with the result of getNumber.
  hiddenInput: null,
  //* Internationalise the plugin text e.g. search input placeholder, country names.
  i18n: {},
  //* Initial country.
  initialCountry: "",
  //* A function to load the utils script.
  loadUtils: null,
  //* National vs international formatting for numbers e.g. placeholders and displaying existing numbers.
  nationalMode: !0,
  //* Display only these countries.
  onlyCountries: [],
  //* Number type to use for placeholders.
  placeholderNumberType: "MOBILE",
  //* Show flags - for both the selected country, and in the country dropdown
  showFlags: !0,
  //* Display the international dial code next to the selected flag.
  separateDialCode: !1,
  //* Only allow certain chars e.g. a plus followed by numeric digits, and cap at max valid length.
  strictMode: !1,
  //* Use full screen popup instead of dropdown for country list.
  useFullscreenPopup: qOe(),
  //* The number type to enforce during validation.
  validationNumberTypes: ["MOBILE"]
};
function HOe(e) {
  e.useFullscreenPopup && (e.fixDropdownWidth = !1), e.onlyCountries.length === 1 && (e.initialCountry = e.onlyCountries[0]), e.separateDialCode && (e.nationalMode = !1), e.allowDropdown && !e.showFlags && !e.separateDialCode && (e.nationalMode = !1), e.useFullscreenPopup && !e.dropdownContainer && (e.dropdownContainer = document.body), e.i18n = { ...$w, ...e.i18n };
}
var gi = (e) => e.replace(/\D/g, ""), Cw = (e = "") => e.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase(), Ue = (e, t, a) => {
  const o = document.createElement(e);
  return t && Object.entries(t).forEach(([n, r]) => o.setAttribute(n, r)), a && a.appendChild(o), o;
};
function GOe(e) {
  const { onlyCountries: t, excludeCountries: a } = e;
  if (t.length) {
    const o = t.map((n) => n.toLowerCase());
    return Fo.filter((n) => o.includes(n.iso2));
  } else if (a.length) {
    const o = a.map((n) => n.toLowerCase());
    return Fo.filter((n) => !o.includes(n.iso2));
  }
  return Fo;
}
function KOe(e, t) {
  for (const a of e) {
    const o = a.iso2.toLowerCase();
    t.i18n[o] && (a.name = t.i18n[o]);
  }
}
function JOe(e, t) {
  const a = /* @__PURE__ */ new Set();
  let o = 0;
  const n = {}, r = (i, s, l) => {
    if (!i || !s)
      return;
    s.length > o && (o = s.length), n.hasOwnProperty(s) || (n[s] = []);
    const c = n[s];
    if (c.includes(i))
      return;
    const u = l !== void 0 ? l : c.length;
    c[u] = i;
  };
  for (const i of e)
    a.has(i.dialCode) || a.add(i.dialCode), r(i.iso2, i.dialCode, i.priority);
  (t.onlyCountries.length || t.excludeCountries.length) && a.forEach((i) => {
    n[i] = n[i].filter(Boolean);
  });
  for (const i of e)
    if (i.areaCodes) {
      const s = n[i.dialCode][0];
      for (const l of i.areaCodes) {
        for (let c = 1; c < l.length; c++) {
          const u = l.substring(0, c), d = i.dialCode + u;
          r(s, d), r(i.iso2, d);
        }
        r(i.iso2, i.dialCode + l);
      }
    }
  return { dialCodes: a, dialCodeMaxLen: o, dialCodeToIso2Map: n };
}
function ZOe(e, t) {
  t.countryOrder && (t.countryOrder = t.countryOrder.map((a) => a.toLowerCase())), e.sort((a, o) => {
    const { countryOrder: n } = t;
    if (n) {
      const r = n.indexOf(a.iso2), i = n.indexOf(o.iso2), s = r > -1, l = i > -1;
      if (s || l)
        return s && l ? r - i : s ? -1 : 1;
    }
    return a.name.localeCompare(o.name);
  });
}
function YOe(e) {
  for (const t of e)
    t.normalisedName = Cw(t.name), t.initials = t.name.split(/[^a-zA-ZÀ-ÿа-яА-Я]/).map((a) => a[0]).join("").toLowerCase(), t.dialCodePlus = `+${t.dialCode}`;
}
function XOe(e, t, a, o) {
  let n = e;
  if (a && t) {
    t = `+${o.dialCode}`;
    const r = n[t.length] === " " || n[t.length] === "-" ? t.length + 1 : t.length;
    n = n.substring(r);
  }
  return n;
}
function QOe(e, t, a, o, n) {
  const r = a ? a.formatNumberAsYouType(e, o.iso2) : e, { dialCode: i } = o;
  return n && t.charAt(0) !== "+" && r.includes(`+${i}`) ? (r.split(`+${i}`)[1] || "").trim() : r;
}
function eze(e, t, a, o) {
  if (a === 0 && !o)
    return 0;
  let n = 0;
  for (let r = 0; r < t.length; r++) {
    if (/[+0-9]/.test(t[r]) && n++, n === e && !o)
      return r + 1;
    if (o && n === e + 1)
      return r;
  }
  return t.length;
}
var tze = [
  "800",
  "822",
  "833",
  "844",
  "855",
  "866",
  "877",
  "880",
  "881",
  "882",
  "883",
  "884",
  "885",
  "886",
  "887",
  "888",
  "889"
], Gp = (e) => {
  const t = gi(e);
  if (t.charAt(0) === "1") {
    const a = t.substring(1, 4);
    return tze.includes(a);
  }
  return !1;
};
for (const e of Fo)
  e.name = $w[e.iso2];
var aze = 0, oze = new Set(Fo.map((e) => e.iso2)), Tl = (e) => oze.has(e), Nn = (e, ...t) => {
  const { instances: a } = ie;
  Object.values(a).forEach((o) => o[e](...t));
}, nze = class Wc {
  /**
   * Build a space-delimited class string from an object map of className -> truthy/falsey.
   * Only keys with truthy values are included.
   */
  static _buildClassNames(t) {
    return Object.keys(t).filter((a) => !!t[a]).join(" ");
  }
  constructor(t, a = {}) {
    this.id = aze++, this.telInput = t, this.highlightedItem = null, this.options = Object.assign({}, Sw, a), this.hadInitialPlaceholder = !!t.getAttribute("placeholder");
  }
  _detectEnvironmentAndLayout() {
    this.isAndroid = typeof navigator < "u" ? /Android/i.test(navigator.userAgent) : !1, this.isRTL = !!this.telInput.closest("[dir=rtl]"), this.telInput.dir = "ltr";
    const t = this.options.allowDropdown || this.options.separateDialCode;
    this.showSelectedCountryOnLeft = this.isRTL ? !t : t, this.options.separateDialCode && (this.isRTL ? this.originalPaddingRight = this.telInput.style.paddingRight : this.originalPaddingLeft = this.telInput.style.paddingLeft);
  }
  _createInitPromises() {
    const t = new Promise((o, n) => {
      this.resolveAutoCountryPromise = o, this.rejectAutoCountryPromise = n;
    }), a = new Promise((o, n) => {
      this.resolveUtilsScriptPromise = o, this.rejectUtilsScriptPromise = n;
    });
    this.promise = Promise.all([t, a]);
  }
  //* Can't be private as it's called from intlTelInput convenience wrapper.
  _init() {
    HOe(this.options), this._detectEnvironmentAndLayout(), this._createInitPromises(), this.selectedCountryData = {}, this._processCountryData(), this._generateMarkup(), this._setInitialState(), this._initListeners(), this._initRequests();
  }
  //********************
  //*  PRIVATE METHODS
  //********************
  //* Prepare all of the country data, including onlyCountries, excludeCountries, countryOrder options.
  _processCountryData() {
    this.countries = GOe(this.options);
    const t = JOe(this.countries, this.options);
    this.dialCodes = t.dialCodes, this.dialCodeMaxLen = t.dialCodeMaxLen, this.dialCodeToIso2Map = t.dialCodeToIso2Map, KOe(this.countries, this.options), ZOe(this.countries, this.options), this.countryByIso2 = new Map(this.countries.map((a) => [a.iso2, a])), YOe(this.countries);
  }
  //* Generate all of the markup for the plugin: the selected country overlay, and the dropdown.
  _generateMarkup() {
    this._prepareTelInput();
    const t = this._createWrapperAndInsert();
    this._maybeBuildCountryContainer(t), t.appendChild(this.telInput), this._maybeUpdateInputPaddingAndReveal(), this._maybeBuildHiddenInputs(t);
  }
  _prepareTelInput() {
    this.telInput.classList.add("iti__tel-input"), !this.telInput.hasAttribute("autocomplete") && !(this.telInput.form && this.telInput.form.hasAttribute("autocomplete")) && this.telInput.setAttribute("autocomplete", "off");
  }
  _createWrapperAndInsert() {
    const {
      allowDropdown: t,
      showFlags: a,
      containerClass: o,
      useFullscreenPopup: n
    } = this.options, r = Wc._buildClassNames({
      iti: !0,
      "iti--allow-dropdown": t,
      "iti--show-flags": a,
      "iti--inline-dropdown": !n,
      [o]: !!o
    }), i = Ue("div", { class: r });
    return this.telInput.parentNode?.insertBefore(i, this.telInput), i;
  }
  _maybeBuildCountryContainer(t) {
    const {
      allowDropdown: a,
      separateDialCode: o,
      showFlags: n
    } = this.options;
    if (a || n || o) {
      this.countryContainer = Ue(
        "div",
        // visibly hidden until we measure it's width to set the input padding correctly
        { class: "iti__country-container iti__v-hide" },
        t
      ), this.showSelectedCountryOnLeft ? this.countryContainer.style.left = "0px" : this.countryContainer.style.right = "0px", a ? (this.selectedCountry = Ue(
        "button",
        {
          type: "button",
          class: "iti__selected-country",
          "aria-expanded": "false",
          "aria-label": this.options.i18n.noCountrySelected,
          "aria-haspopup": "dialog",
          "aria-controls": `iti-${this.id}__dropdown-content`
        },
        this.countryContainer
      ), this.telInput.disabled && this.selectedCountry.setAttribute("disabled", "true")) : this.selectedCountry = Ue(
        "div",
        { class: "iti__selected-country" },
        this.countryContainer
      );
      const r = Ue(
        "div",
        { class: "iti__selected-country-primary" },
        this.selectedCountry
      );
      this.selectedCountryInner = Ue(
        "div",
        { class: "iti__flag" },
        r
      ), a && (this.dropdownArrow = Ue(
        "div",
        { class: "iti__arrow", "aria-hidden": "true" },
        r
      )), o && (this.selectedDialCode = Ue(
        "div",
        { class: "iti__selected-dial-code", dir: "ltr" },
        this.selectedCountry
      )), a && this._buildDropdownContent();
    }
  }
  _buildDropdownContent() {
    const {
      fixDropdownWidth: t,
      useFullscreenPopup: a,
      countrySearch: o,
      i18n: n,
      dropdownContainer: r,
      containerClass: i
    } = this.options, s = t ? "" : "iti--flexible-dropdown-width";
    if (this.dropdownContent = Ue("div", {
      id: `iti-${this.id}__dropdown-content`,
      class: `iti__dropdown-content iti__hide ${s}`,
      role: "dialog",
      "aria-modal": "true"
    }), o && this._buildSearchUI(), this.countryList = Ue(
      "ul",
      {
        class: "iti__country-list",
        id: `iti-${this.id}__country-listbox`,
        role: "listbox",
        "aria-label": n.countryListAriaLabel
      },
      this.dropdownContent
    ), this._appendListItems(), o && this._updateSearchResultsA11yText(), r) {
      const l = Wc._buildClassNames({
        iti: !0,
        "iti--container": !0,
        "iti--fullscreen-popup": a,
        "iti--inline-dropdown": !a,
        [i]: !!i
      });
      this.dropdown = Ue("div", { class: l }), this.dropdown.appendChild(this.dropdownContent);
    } else
      this.countryContainer.appendChild(this.dropdownContent);
  }
  _buildSearchUI() {
    const { i18n: t } = this.options, a = Ue(
      "div",
      { class: "iti__search-input-wrapper" },
      this.dropdownContent
    );
    this.searchIcon = Ue(
      "span",
      {
        class: "iti__search-icon",
        "aria-hidden": "true"
      },
      a
    ), this.searchIcon.innerHTML = `
      <svg class="iti__search-icon-svg" width="14" height="14" viewBox="0 0 24 24" focusable="false" aria-hidden="true">
        <circle cx="11" cy="11" r="7" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>`, this.searchInput = Ue(
      "input",
      {
        id: `iti-${this.id}__search-input`,
        // Chrome says inputs need either a name or an id
        type: "search",
        class: "iti__search-input",
        placeholder: t.searchPlaceholder,
        // role=combobox + aria-autocomplete=list + aria-activedescendant allows maintaining focus on the search input while allowing users to navigate search results with up/down keyboard keys
        role: "combobox",
        "aria-expanded": "true",
        "aria-label": t.searchPlaceholder,
        "aria-controls": `iti-${this.id}__country-listbox`,
        "aria-autocomplete": "list",
        autocomplete: "off"
      },
      a
    ), this.searchClearButton = Ue(
      "button",
      {
        type: "button",
        class: "iti__search-clear iti__hide",
        "aria-label": t.clearSearchAriaLabel,
        tabindex: "-1"
      },
      a
    );
    const o = `iti-${this.id}-clear-mask`;
    this.searchClearButton.innerHTML = `
      <svg class="iti__search-clear-svg" width="12" height="12" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
        <mask id="${o}" maskUnits="userSpaceOnUse">
          <rect width="16" height="16" fill="white" />
          <path d="M5.2 5.2 L10.8 10.8 M10.8 5.2 L5.2 10.8" stroke="black" stroke-linecap="round" class="iti__search-clear-x" />
        </mask>
        <circle cx="8" cy="8" r="8" class="iti__search-clear-bg" mask="url(#${o})" />
      </svg>`, this.searchResultsA11yText = Ue(
      "span",
      { class: "iti__a11y-text" },
      this.dropdownContent
    ), this.searchNoResults = Ue(
      "div",
      {
        class: "iti__no-results iti__hide",
        "aria-hidden": "true"
        // all a11y messaging happens in this.searchResultsA11yText
      },
      this.dropdownContent
    ), this.searchNoResults.textContent = t.zeroSearchResults;
  }
  _maybeUpdateInputPaddingAndReveal() {
    this.countryContainer && (this._updateInputPadding(), this.countryContainer.classList.remove("iti__v-hide"));
  }
  _maybeBuildHiddenInputs(t) {
    const { hiddenInput: a } = this.options;
    if (a) {
      const o = this.telInput.getAttribute("name") || "", n = a(o);
      if (n.phone) {
        const r = this.telInput.form?.querySelector(`input[name="${n.phone}"]`);
        r ? this.hiddenInput = r : (this.hiddenInput = Ue("input", {
          type: "hidden",
          name: n.phone
        }), t.appendChild(this.hiddenInput));
      }
      if (n.country) {
        const r = this.telInput.form?.querySelector(`input[name="${n.country}"]`);
        r ? this.hiddenInputCountry = r : (this.hiddenInputCountry = Ue("input", {
          type: "hidden",
          name: n.country
        }), t.appendChild(this.hiddenInputCountry));
      }
    }
  }
  //* For each country: add a country list item <li> to the countryList <ul> container.
  _appendListItems() {
    for (let t = 0; t < this.countries.length; t++) {
      const a = this.countries[t], o = t === 0 ? "iti__highlight" : "", n = Ue(
        "li",
        {
          id: `iti-${this.id}__item-${a.iso2}`,
          class: `iti__country ${o}`,
          tabindex: "-1",
          role: "option",
          "data-dial-code": a.dialCode,
          "data-country-code": a.iso2,
          "aria-selected": "false"
        },
        this.countryList
      );
      a.nodeById[this.id] = n;
      let r = "";
      this.options.showFlags && (r += `<div class='iti__flag iti__${a.iso2}'></div>`), r += `<span class='iti__country-name'>${a.name}</span>`, r += `<span class='iti__dial-code' dir='ltr'>+${a.dialCode}</span>`, n.insertAdjacentHTML("beforeend", r);
    }
  }
  //* Set the initial state of the input value and the selected country by:
  //* 1. Extracting a dial code from the given number
  //* 2. Using explicit initialCountry
  _setInitialState(t = !1) {
    const a = this.telInput.getAttribute("value"), o = this.telInput.value, n = a && a.charAt(0) === "+" && (!o || o.charAt(0) !== "+") ? a : o, r = this._getDialCode(n), i = Gp(n), { initialCountry: s, geoIpLookup: l } = this.options, c = s === "auto" && l;
    if (r && !i)
      this._updateCountryFromNumber(n);
    else if (!c || t) {
      const u = s ? s.toLowerCase() : "";
      Tl(u) ? this._setCountry(u) : r && i ? this._setCountry("us") : this._setCountry("");
    }
    n && this._updateValFromNumber(n);
  }
  //* Initialise the main event listeners: input keyup, and click selected country.
  _initListeners() {
    this._initTelInputListeners(), this.options.allowDropdown && this._initDropdownListeners(), (this.hiddenInput || this.hiddenInputCountry) && this.telInput.form && this._initHiddenInputListener();
  }
  //* Update hidden input on form submit.
  _initHiddenInputListener() {
    this._handleHiddenInputSubmit = () => {
      this.hiddenInput && (this.hiddenInput.value = this.getNumber()), this.hiddenInputCountry && (this.hiddenInputCountry.value = this.getSelectedCountryData().iso2 || "");
    }, this.telInput.form?.addEventListener(
      "submit",
      this._handleHiddenInputSubmit
    );
  }
  //* initialise the dropdown listeners.
  _initDropdownListeners() {
    this._handleLabelClick = (a) => {
      this.dropdownContent.classList.contains("iti__hide") ? this.telInput.focus() : a.preventDefault();
    };
    const t = this.telInput.closest("label");
    t && t.addEventListener("click", this._handleLabelClick), this._handleClickSelectedCountry = () => {
      this.dropdownContent.classList.contains("iti__hide") && !this.telInput.disabled && !this.telInput.readOnly && this._openDropdown();
    }, this.selectedCountry.addEventListener("click", this._handleClickSelectedCountry), this._handleCountryContainerKeydown = (a) => {
      this.dropdownContent.classList.contains("iti__hide") && ["ArrowUp", "ArrowDown", " ", "Enter"].includes(a.key) && (a.preventDefault(), a.stopPropagation(), this._openDropdown()), a.key === "Tab" && this._closeDropdown();
    }, this.countryContainer.addEventListener(
      "keydown",
      this._handleCountryContainerKeydown
    );
  }
  //* Init many requests: utils script / geo ip lookup.
  _initRequests() {
    let { loadUtils: t, initialCountry: a, geoIpLookup: o } = this.options;
    t && !ie.utils ? (this._doAttachUtils = () => {
      ie.attachUtils(t)?.catch(() => {
      });
    }, ie.documentReady() ? this._doAttachUtils() : (this._handlePageLoad = () => {
      this._doAttachUtils();
    }, window.addEventListener("load", this._handlePageLoad))) : this.resolveUtilsScriptPromise(), a === "auto" && o && !this.selectedCountryData.iso2 ? this._loadAutoCountry() : this.resolveAutoCountryPromise();
  }
  //* Perform the geo ip lookup.
  _loadAutoCountry() {
    ie.autoCountry ? this.handleAutoCountry() : ie.startedLoadingAutoCountry || (ie.startedLoadingAutoCountry = !0, typeof this.options.geoIpLookup == "function" && this.options.geoIpLookup(
      (t = "") => {
        const a = t.toLowerCase();
        Tl(a) ? (ie.autoCountry = a, setTimeout(() => Nn("handleAutoCountry"))) : (this._setInitialState(!0), Nn("rejectAutoCountryPromise"));
      },
      () => {
        this._setInitialState(!0), Nn("rejectAutoCountryPromise");
      }
    ));
  }
  _openDropdownWithPlus() {
    this._openDropdown(), this.searchInput.value = "+", this._filterCountries("");
  }
  //* Initialize the tel input listeners.
  _initTelInputListeners() {
    this._bindInputListener(), this._maybeBindKeydownListener(), this._maybeBindPasteListener();
  }
  _bindInputListener() {
    const { strictMode: t, formatAsYouType: a, separateDialCode: o, allowDropdown: n, countrySearch: r } = this.options;
    let i = !1;
    new RegExp("\\p{L}", "u").test(this.telInput.value) && (i = !0), this._handleInputEvent = (s) => {
      if (this.isAndroid && s?.data === "+" && o && n && r) {
        const d = this.telInput.selectionStart || 0, h = this.telInput.value.substring(0, d - 1), m = this.telInput.value.substring(d);
        this.telInput.value = h + m, this._openDropdownWithPlus();
        return;
      }
      this._updateCountryFromNumber(this.telInput.value) && this._triggerCountryChange();
      const l = s?.data && /[^+0-9]/.test(s.data), c = s?.inputType === "insertFromPaste" && this.telInput.value;
      l || c && !t ? i = !0 : /[^+0-9]/.test(this.telInput.value) || (i = !1);
      const u = s?.detail && s.detail.isSetNumber;
      if (a && !i && !u) {
        const d = this.telInput.selectionStart || 0, h = this.telInput.value.substring(0, d).replace(/[^+0-9]/g, "").length, m = s?.inputType === "deleteContentForward", f = this._getFullNumber(), p = QOe(
          f,
          this.telInput.value,
          ie.utils,
          this.selectedCountryData,
          this.options.separateDialCode
        ), b = eze(h, p, d, m);
        this.telInput.value = p, this.telInput.setSelectionRange(b, b);
      }
    }, this.telInput.addEventListener("input", this._handleInputEvent);
  }
  _maybeBindKeydownListener() {
    const { strictMode: t, separateDialCode: a, allowDropdown: o, countrySearch: n } = this.options;
    (t || a) && (this._handleKeydownEvent = (r) => {
      if (r.key && r.key.length === 1 && !r.altKey && !r.ctrlKey && !r.metaKey) {
        if (a && o && n && r.key === "+") {
          r.preventDefault(), this._openDropdownWithPlus();
          return;
        }
        if (t) {
          const i = this.telInput.value, s = i.charAt(0) !== "+" && this.telInput.selectionStart === 0 && r.key === "+", l = /^[0-9]$/.test(r.key), c = a ? l : s || l, u = i.slice(0, this.telInput.selectionStart) + r.key + i.slice(this.telInput.selectionEnd), d = this._getFullNumber(u), h = ie.utils.getCoreNumber(d, this.selectedCountryData.iso2), m = this.maxCoreNumberLength && h.length > this.maxCoreNumberLength, f = this._getNewCountryFromNumber(d) !== null;
          (!c || m && !f && !s) && r.preventDefault();
        }
      }
    }, this.telInput.addEventListener("keydown", this._handleKeydownEvent));
  }
  _maybeBindPasteListener() {
    this.options.strictMode && (this._handlePasteEvent = (t) => {
      t.preventDefault();
      const a = this.telInput, o = a.selectionStart, n = a.selectionEnd, r = a.value.slice(0, o), i = a.value.slice(n), s = this.selectedCountryData.iso2, l = t.clipboardData.getData("text"), c = o === 0 && n > 0, u = !a.value.startsWith("+") || c, d = l.replace(/[^0-9+]/g, ""), h = d.startsWith("+"), m = d.replace(/\+/g, ""), f = h && u ? `+${m}` : m;
      let p = r + f + i, b = ie.utils.getCoreNumber(p, s);
      for (; b.length === 0 && p.length > 0; )
        p = p.slice(0, -1), b = ie.utils.getCoreNumber(p, s);
      if (!b)
        return;
      if (this.maxCoreNumberLength && b.length > this.maxCoreNumberLength)
        if (a.selectionEnd === a.value.length) {
          const _ = b.length - this.maxCoreNumberLength;
          p = p.slice(0, p.length - _);
        } else
          return;
      a.value = p;
      const w = o + f.length;
      a.setSelectionRange(w, w), a.dispatchEvent(new InputEvent("input", { bubbles: !0 }));
    }, this.telInput.addEventListener("paste", this._handlePasteEvent));
  }
  //* Adhere to the input's maxlength attr.
  _cap(t) {
    const a = parseInt(this.telInput.getAttribute("maxlength") || "", 10);
    return a && t.length > a ? t.substring(0, a) : t;
  }
  //* Trigger a custom event on the input.
  _trigger(t, a = {}) {
    const o = new CustomEvent(t, {
      bubbles: !0,
      cancelable: !0,
      detail: a
    });
    this.telInput.dispatchEvent(o);
  }
  //* Open the dropdown.
  _openDropdown() {
    const { fixDropdownWidth: t, countrySearch: a } = this.options;
    if (t && (this.dropdownContent.style.width = `${this.telInput.offsetWidth}px`), this.dropdownContent.classList.remove("iti__hide"), this.selectedCountry.setAttribute("aria-expanded", "true"), this._setDropdownPosition(), a) {
      const o = this.countryList.firstElementChild;
      o && (this._highlightListItem(o, !1), this.countryList.scrollTop = 0), this.searchInput.focus();
    }
    this._bindDropdownListeners(), this.dropdownArrow.classList.add("iti__arrow--up"), this._trigger("open:countrydropdown");
  }
  //* Set the dropdown position
  _setDropdownPosition() {
    if (this.options.dropdownContainer && this.options.dropdownContainer.appendChild(this.dropdown), !this.options.useFullscreenPopup) {
      const t = this.telInput.getBoundingClientRect(), a = this.telInput.offsetHeight;
      this.options.dropdownContainer && (this.dropdown.style.top = `${t.top + a}px`, this.dropdown.style.left = `${t.left}px`, this._handleWindowScroll = () => this._closeDropdown(), window.addEventListener("scroll", this._handleWindowScroll));
    }
  }
  //* We only bind dropdown listeners when the dropdown is open.
  _bindDropdownListeners() {
    this._handleMouseoverCountryList = (o) => {
      const n = o.target?.closest(".iti__country");
      n && this._highlightListItem(n, !1);
    }, this.countryList.addEventListener(
      "mouseover",
      this._handleMouseoverCountryList
    ), this._handleClickCountryList = (o) => {
      const n = o.target?.closest(".iti__country");
      n && this._selectListItem(n);
    }, this.countryList.addEventListener("click", this._handleClickCountryList), this._handleClickOffToClose = (o) => {
      o.target.closest(`#iti-${this.id}__dropdown-content`) || this._closeDropdown();
    }, setTimeout(() => {
      document.documentElement.addEventListener(
        "click",
        this._handleClickOffToClose
      );
    }, 0);
    let t = "", a = null;
    if (this._handleKeydownOnDropdown = (o) => {
      ["ArrowUp", "ArrowDown", "Enter", "Escape"].includes(o.key) && (o.preventDefault(), o.stopPropagation(), o.key === "ArrowUp" || o.key === "ArrowDown" ? this._handleUpDownKey(o.key) : o.key === "Enter" ? this._handleEnterKey() : o.key === "Escape" && this._closeDropdown()), !this.options.countrySearch && /^[a-zA-ZÀ-ÿа-яА-Я ]$/.test(o.key) && (o.stopPropagation(), a && clearTimeout(a), t += o.key.toLowerCase(), this._searchForCountry(t), a = setTimeout(() => {
        t = "";
      }, 1e3));
    }, document.addEventListener("keydown", this._handleKeydownOnDropdown), this.options.countrySearch) {
      const o = () => {
        const r = this.searchInput.value.trim();
        this._filterCountries(r), this.searchInput.value ? this.searchClearButton.classList.remove("iti__hide") : this.searchClearButton.classList.add("iti__hide");
      };
      let n = null;
      this._handleSearchChange = () => {
        n && clearTimeout(n), n = setTimeout(() => {
          o(), n = null;
        }, 100);
      }, this.searchInput.addEventListener("input", this._handleSearchChange), this._handleSearchClear = () => {
        this.searchInput.value = "", this.searchInput.focus(), o();
      }, this.searchClearButton.addEventListener("click", this._handleSearchClear);
    }
  }
  //* Hidden search (countrySearch disabled): Find the first list item whose name starts with the query string.
  _searchForCountry(t) {
    for (const a of this.countries)
      if (a.name.substring(0, t.length).toLowerCase() === t) {
        const o = a.nodeById[this.id];
        this._highlightListItem(o, !1), this._scrollTo(o);
        break;
      }
  }
  //* Country search enabled: Filter the countries according to the search query.
  _filterCountries(t) {
    this.countryList.innerHTML = "";
    let a;
    t === "" ? a = this.countries : a = this._getMatchedCountries(t);
    let o = !0;
    for (const n of a) {
      const r = n.nodeById[this.id];
      r && (this.countryList.appendChild(r), o && (this._highlightListItem(r, !1), o = !1));
    }
    o ? (this._highlightListItem(null, !1), this.searchNoResults && this.searchNoResults.classList.remove("iti__hide")) : this.searchNoResults && this.searchNoResults.classList.add("iti__hide"), this.countryList.scrollTop = 0, this._updateSearchResultsA11yText();
  }
  _getMatchedCountries(t) {
    const a = Cw(t), o = [], n = [], r = [], i = [], s = [], l = [];
    for (const c of this.countries)
      c.iso2 === a ? o.push(c) : c.normalisedName.startsWith(a) ? n.push(c) : c.normalisedName.includes(a) ? r.push(c) : a === c.dialCode || a === c.dialCodePlus ? i.push(c) : c.dialCodePlus.includes(a) ? s.push(c) : c.initials.includes(a) && l.push(c);
    return [
      ...o.sort((c, u) => c.priority - u.priority),
      ...n.sort((c, u) => c.priority - u.priority),
      ...r.sort((c, u) => c.priority - u.priority),
      ...i.sort((c, u) => c.priority - u.priority),
      ...s.sort((c, u) => c.priority - u.priority),
      ...l.sort((c, u) => c.priority - u.priority)
    ];
  }
  //* Update search results text (for a11y).
  _updateSearchResultsA11yText() {
    const { i18n: t } = this.options, a = this.countryList.childElementCount;
    let o;
    a === 0 ? o = t.zeroSearchResults : t.searchResultsText ? o = t.searchResultsText(a) : a === 1 ? o = t.oneSearchResult : o = t.multipleSearchResults.replace("${count}", a.toString()), this.searchResultsA11yText.textContent = o;
  }
  //* Highlight the next/prev item in the list (and ensure it is visible).
  _handleUpDownKey(t) {
    let a = t === "ArrowUp" ? this.highlightedItem?.previousElementSibling : this.highlightedItem?.nextElementSibling;
    !a && this.countryList.childElementCount > 1 && (a = t === "ArrowUp" ? this.countryList.lastElementChild : this.countryList.firstElementChild), a && (this._scrollTo(a), this._highlightListItem(a, !1));
  }
  //* Select the currently highlighted item.
  _handleEnterKey() {
    this.highlightedItem && this._selectListItem(this.highlightedItem);
  }
  //* Update the input's value to the given val (format first if possible)
  //* NOTE: this is called from _setInitialState, handleUtils and setNumber.
  _updateValFromNumber(t) {
    let a = t;
    if (this.options.formatOnDisplay && ie.utils && this.selectedCountryData) {
      const o = this.options.nationalMode || a.charAt(0) !== "+" && !this.options.separateDialCode, { NATIONAL: n, INTERNATIONAL: r } = ie.utils.numberFormat, i = o ? n : r;
      a = ie.utils.formatNumber(
        a,
        this.selectedCountryData.iso2,
        i
      );
    }
    a = this._beforeSetNumber(a), this.telInput.value = a;
  }
  //* Check if need to select a new country based on the given number
  //* Note: called from _setInitialState, keyup handler, setNumber.
  _updateCountryFromNumber(t) {
    const a = this._getNewCountryFromNumber(t);
    return a !== null ? this._setCountry(a) : !1;
  }
  _ensureHasDialCode(t) {
    const { dialCode: a, nationalPrefix: o } = this.selectedCountryData;
    if (t.charAt(0) === "+" || !a)
      return t;
    const n = o && t.charAt(0) === o && !this.options.separateDialCode ? t.substring(1) : t;
    return `+${a}${n}`;
  }
  // Get the country ISO2 code from the given number
  // BUT ONLY IF ITS CHANGED FROM THE CURRENTLY SELECTED COUNTRY
  // NOTE: consider refactoring this to be more clear
  _getNewCountryFromNumber(t) {
    const a = t.indexOf("+");
    let o = a ? t.substring(a) : t;
    const n = this.selectedCountryData.iso2, r = this.selectedCountryData.dialCode;
    o = this._ensureHasDialCode(o);
    const i = this._getDialCode(o, !0), s = gi(o);
    if (i) {
      const l = gi(i), c = this.dialCodeToIso2Map[l];
      if (c.length === 1)
        return c[0] === n ? null : c[0];
      if (!n && this.defaultCountry && c.includes(this.defaultCountry))
        return this.defaultCountry;
      if (r === "1" && Gp(s))
        return null;
      const u = this.selectedCountryData.areaCodes && s.length > l.length;
      if (!(n && c.includes(n) && !u))
        return c[0];
    } else {
      if (o.charAt(0) === "+" && s.length)
        return "";
      if ((!o || o === "+") && !n)
        return this.defaultCountry;
    }
    return null;
  }
  //* Remove highlighting from other list items and highlight the given item.
  _highlightListItem(t, a) {
    const o = this.highlightedItem;
    if (o && (o.classList.remove("iti__highlight"), o.setAttribute("aria-selected", "false")), this.highlightedItem = t, this.highlightedItem && (this.highlightedItem.classList.add("iti__highlight"), this.highlightedItem.setAttribute("aria-selected", "true"), this.options.countrySearch)) {
      const n = this.highlightedItem.getAttribute("id") || "";
      this.searchInput.setAttribute("aria-activedescendant", n);
    }
    a && this.highlightedItem.focus();
  }
  //* Update the selected country, dial code (if separateDialCode), placeholder, title, and active list item.
  //* Note: called from _setInitialState, _updateCountryFromNumber, _selectListItem, setCountry.
  _setCountry(t) {
    const { separateDialCode: a, showFlags: o, i18n: n } = this.options, r = this.selectedCountryData.iso2 || "";
    if (this.selectedCountryData = t ? this.countryByIso2.get(t) : {}, this.selectedCountryData.iso2 && (this.defaultCountry = this.selectedCountryData.iso2), this.selectedCountry) {
      const i = t && o ? `iti__flag iti__${t}` : "iti__flag iti__globe";
      let s, l;
      if (t) {
        const { name: c, dialCode: u } = this.selectedCountryData;
        l = c, s = n.selectedCountryAriaLabel.replace("${countryName}", c).replace("${dialCode}", `+${u}`);
      } else
        l = n.noCountrySelected, s = n.noCountrySelected;
      this.selectedCountryInner.className = i, this.selectedCountry.setAttribute("title", l), this.selectedCountry.setAttribute("aria-label", s);
    }
    if (a) {
      const i = this.selectedCountryData.dialCode ? `+${this.selectedCountryData.dialCode}` : "";
      this.selectedDialCode.innerHTML = i, this._updateInputPadding();
    }
    return this._updatePlaceholder(), this._updateMaxLength(), r !== t;
  }
  //* Update the input padding to make space for the selected country/dial code.
  _updateInputPadding() {
    if (this.selectedCountry) {
      const t = this.options.separateDialCode ? 78 : 42, a = (this.selectedCountry.offsetWidth || this._getHiddenSelectedCountryWidth() || t) + 6;
      this.showSelectedCountryOnLeft ? this.telInput.style.paddingLeft = `${a}px` : this.telInput.style.paddingRight = `${a}px`;
    }
  }
  //* Update the maximum valid number length for the currently selected country.
  _updateMaxLength() {
    const { strictMode: t, placeholderNumberType: a, validationNumberTypes: o } = this.options, { iso2: n } = this.selectedCountryData;
    if (t && ie.utils)
      if (n) {
        const r = ie.utils.numberType[a];
        let i = ie.utils.getExampleNumber(
          n,
          !1,
          r,
          !0
        ), s = i;
        for (; ie.utils.isPossibleNumber(i, n, o); )
          s = i, i += "0";
        const l = ie.utils.getCoreNumber(s, n);
        this.maxCoreNumberLength = l.length, n === "by" && (this.maxCoreNumberLength = l.length + 1);
      } else
        this.maxCoreNumberLength = null;
  }
  //* When input is in a hidden container during init, we cannot calculate the selected country width.
  //* Fix: clone the markup, make it invisible, add it to the end of the DOM, and then measure it's width.
  //* To get the right styling to apply, all we need is a shallow clone of the container,
  //* and then to inject a deep clone of the selectedCountry element.
  _getHiddenSelectedCountryWidth() {
    if (this.telInput.parentNode) {
      let t;
      try {
        t = window.top.document.body;
      } catch {
        t = document.body;
      }
      const a = this.telInput.parentNode.cloneNode(!1);
      a.style.visibility = "hidden", t.appendChild(a);
      const o = this.countryContainer.cloneNode();
      a.appendChild(o);
      const n = this.selectedCountry.cloneNode(!0);
      o.appendChild(n);
      const r = n.offsetWidth;
      return t.removeChild(a), r;
    }
    return 0;
  }
  //* Update the input placeholder to an example number from the currently selected country.
  _updatePlaceholder() {
    const {
      autoPlaceholder: t,
      placeholderNumberType: a,
      nationalMode: o,
      customPlaceholder: n
    } = this.options, r = t === "aggressive" || !this.hadInitialPlaceholder && t === "polite";
    if (ie.utils && r) {
      const i = ie.utils.numberType[a];
      let s = this.selectedCountryData.iso2 ? ie.utils.getExampleNumber(
        this.selectedCountryData.iso2,
        o,
        i
      ) : "";
      s = this._beforeSetNumber(s), typeof n == "function" && (s = n(s, this.selectedCountryData)), this.telInput.setAttribute("placeholder", s);
    }
  }
  //* Called when the user selects a list item from the dropdown.
  _selectListItem(t) {
    const a = t.getAttribute("data-country-code"), o = this._setCountry(a);
    this._closeDropdown();
    const n = t.getAttribute("data-dial-code");
    this._updateDialCode(n), this.options.formatOnDisplay && this._updateValFromNumber(this.telInput.value), this.telInput.focus(), o && this._triggerCountryChange();
  }
  //* Close the dropdown and unbind any listeners.
  _closeDropdown() {
    this.dropdownContent.classList.add("iti__hide"), this.selectedCountry.setAttribute("aria-expanded", "false"), this.highlightedItem && this.highlightedItem.setAttribute("aria-selected", "false"), this.options.countrySearch && this.searchInput.removeAttribute("aria-activedescendant"), this.dropdownArrow.classList.remove("iti__arrow--up"), this.options.countrySearch && (this.searchInput.removeEventListener("input", this._handleSearchChange), this.searchClearButton.removeEventListener("click", this._handleSearchClear)), document.removeEventListener("keydown", this._handleKeydownOnDropdown), document.documentElement.removeEventListener(
      "click",
      this._handleClickOffToClose
    ), this.countryList.removeEventListener(
      "mouseover",
      this._handleMouseoverCountryList
    ), this.countryList.removeEventListener("click", this._handleClickCountryList), this.options.dropdownContainer && (this.options.useFullscreenPopup || window.removeEventListener("scroll", this._handleWindowScroll), this.dropdown.parentNode && this.dropdown.parentNode.removeChild(this.dropdown)), this._trigger("close:countrydropdown");
  }
  //* Check if an element is visible within it's container, else scroll until it is.
  _scrollTo(t) {
    const a = this.countryList, o = document.documentElement.scrollTop, n = a.offsetHeight, r = a.getBoundingClientRect().top + o, i = r + n, s = t.offsetHeight, l = t.getBoundingClientRect().top + o, c = l + s, u = l - r + a.scrollTop;
    if (l < r)
      a.scrollTop = u;
    else if (c > i) {
      const d = n - s;
      a.scrollTop = u - d;
    }
  }
  //* Replace any existing dial code with the new one
  //* Note: called from _selectListItem and setCountry
  _updateDialCode(t) {
    const a = this.telInput.value, o = `+${t}`;
    let n;
    if (a.charAt(0) === "+") {
      const r = this._getDialCode(a);
      r ? n = a.replace(r, o) : n = o, this.telInput.value = n;
    }
  }
  //* Try and extract a valid international dial code from a full telephone number.
  //* Note: returns the raw string inc plus character and any whitespace/dots etc.
  _getDialCode(t, a) {
    let o = "";
    if (t.charAt(0) === "+") {
      let n = "";
      for (let r = 0; r < t.length; r++) {
        const i = t.charAt(r);
        if (/[0-9]/.test(i)) {
          if (n += i, a)
            this.dialCodeToIso2Map[n] && (o = t.substring(0, r + 1));
          else if (this.dialCodes.has(n)) {
            o = t.substring(0, r + 1);
            break;
          }
          if (n.length === this.dialCodeMaxLen)
            break;
        }
      }
    }
    return o;
  }
  //* Get the input val, adding the dial code if separateDialCode is enabled.
  _getFullNumber(t) {
    const a = t || this.telInput.value.trim(), { dialCode: o } = this.selectedCountryData;
    let n;
    const r = gi(a);
    return this.options.separateDialCode && a.charAt(0) !== "+" && o && r ? n = `+${o}` : n = "", n + a;
  }
  //* Remove the dial code if separateDialCode is enabled also cap the length if the input has a maxlength attribute
  _beforeSetNumber(t) {
    const a = this._getDialCode(t), o = XOe(
      t,
      a,
      this.options.separateDialCode,
      this.selectedCountryData
    );
    return this._cap(o);
  }
  //* Trigger the 'countrychange' event.
  _triggerCountryChange() {
    this._trigger("countrychange");
  }
  //**************************
  //*  SECRET PUBLIC METHODS
  //**************************
  //* This is called when the geoip call returns.
  handleAutoCountry() {
    this.options.initialCountry === "auto" && ie.autoCountry && (this.defaultCountry = ie.autoCountry, this.selectedCountryData.iso2 || this.selectedCountryInner.classList.contains("iti__globe") || this.setCountry(this.defaultCountry), this.resolveAutoCountryPromise());
  }
  //* This is called when the utils request completes.
  handleUtils() {
    ie.utils && (this.telInput.value && this._updateValFromNumber(this.telInput.value), this.selectedCountryData.iso2 && (this._updatePlaceholder(), this._updateMaxLength())), this.resolveUtilsScriptPromise();
  }
  //********************
  //*  PUBLIC METHODS
  //********************
  //* Remove plugin.
  destroy() {
    this.telInput.iti = void 0;
    const { allowDropdown: t, separateDialCode: a } = this.options;
    if (t) {
      this._closeDropdown(), this.selectedCountry.removeEventListener(
        "click",
        this._handleClickSelectedCountry
      ), this.countryContainer.removeEventListener(
        "keydown",
        this._handleCountryContainerKeydown
      );
      const r = this.telInput.closest("label");
      r && r.removeEventListener("click", this._handleLabelClick);
    }
    const { form: o } = this.telInput;
    this._handleHiddenInputSubmit && o && o.removeEventListener("submit", this._handleHiddenInputSubmit), this.telInput.removeEventListener("input", this._handleInputEvent), this._handleKeydownEvent && this.telInput.removeEventListener("keydown", this._handleKeydownEvent), this._handlePasteEvent && this.telInput.removeEventListener("paste", this._handlePasteEvent), this._handlePageLoad && window.removeEventListener("load", this._handlePageLoad), this.telInput.removeAttribute("data-intl-tel-input-id"), a && (this.isRTL ? this.telInput.style.paddingRight = this.originalPaddingRight : this.telInput.style.paddingLeft = this.originalPaddingLeft);
    const n = this.telInput.parentNode;
    n?.parentNode?.insertBefore(this.telInput, n), n?.parentNode?.removeChild(n), delete ie.instances[this.id];
  }
  //* Get the extension from the current number.
  getExtension() {
    return ie.utils ? ie.utils.getExtension(
      this._getFullNumber(),
      this.selectedCountryData.iso2
    ) : "";
  }
  //* Format the number to the given format.
  getNumber(t) {
    if (ie.utils) {
      const { iso2: a } = this.selectedCountryData;
      return ie.utils.formatNumber(
        this._getFullNumber(),
        a,
        t
      );
    }
    return "";
  }
  //* Get the type of the entered number e.g. landline/mobile.
  getNumberType() {
    return ie.utils ? ie.utils.getNumberType(
      this._getFullNumber(),
      this.selectedCountryData.iso2
    ) : -99;
  }
  //* Get the country data for the currently selected country.
  getSelectedCountryData() {
    return this.selectedCountryData;
  }
  //* Get the validation error.
  getValidationError() {
    if (ie.utils) {
      const { iso2: t } = this.selectedCountryData;
      return ie.utils.getValidationError(this._getFullNumber(), t);
    }
    return -99;
  }
  //* Validate the input val (with precise=false)
  isValidNumber() {
    return this._validateNumber(!1);
  }
  //* Validate the input val (with precise=true)
  isValidNumberPrecise() {
    return this._validateNumber(!0);
  }
  _utilsIsPossibleNumber(t) {
    return ie.utils ? ie.utils.isPossibleNumber(t, this.selectedCountryData.iso2, this.options.validationNumberTypes) : null;
  }
  //* Shared internal validation logic to handle alpha character extension rules.
  _validateNumber(t) {
    if (!this.selectedCountryData.iso2)
      return !1;
    const a = (r) => t ? this._utilsIsValidNumber(r) : this._utilsIsPossibleNumber(r), o = this._getFullNumber(), n = o.search(new RegExp("\\p{L}", "u"));
    if (n > -1 && !this.options.allowPhonewords) {
      const r = o.substring(0, n), i = a(r), s = a(o);
      return i && s;
    }
    return a(o);
  }
  _utilsIsValidNumber(t) {
    return ie.utils ? ie.utils.isValidNumber(t, this.selectedCountryData.iso2, this.options.validationNumberTypes) : null;
  }
  //* Update the selected country, and update the input val accordingly.
  setCountry(t) {
    const a = t?.toLowerCase();
    if (!Tl(a))
      throw new Error(`Invalid country code: '${a}'`);
    const o = this.selectedCountryData.iso2;
    (t && a !== o || !t && o) && (this._setCountry(a), this._updateDialCode(this.selectedCountryData.dialCode), this.options.formatOnDisplay && this._updateValFromNumber(this.telInput.value), this._triggerCountryChange());
  }
  //* Set the input value and update the country.
  setNumber(t) {
    const a = this._updateCountryFromNumber(t);
    this._updateValFromNumber(t), a && this._triggerCountryChange(), this._trigger("input", { isSetNumber: !0 });
  }
  //* Set the placeholder number typ
  setPlaceholderNumberType(t) {
    this.options.placeholderNumberType = t, this._updatePlaceholder();
  }
  setDisabled(t) {
    this.telInput.disabled = t, t ? this.selectedCountry.setAttribute("disabled", "true") : this.selectedCountry.removeAttribute("disabled");
  }
}, rze = (e) => {
  if (!ie.utils && !ie.startedLoadingUtilsScript) {
    let t;
    if (typeof e == "function")
      try {
        t = Promise.resolve(e());
      } catch (a) {
        return Promise.reject(a);
      }
    else
      return Promise.reject(new TypeError(`The argument passed to attachUtils must be a function that returns a promise for the utilities module, not ${typeof e}`));
    return ie.startedLoadingUtilsScript = !0, t.then((a) => {
      const o = a?.default;
      if (!o || typeof o != "object")
        throw new TypeError("The loader function passed to attachUtils did not resolve to a module object with utils as its default export.");
      return ie.utils = o, Nn("handleUtils"), !0;
    }).catch((a) => {
      throw Nn("rejectUtilsScriptPromise", a), a;
    });
  }
  return null;
}, ie = Object.assign(
  (e, t) => {
    const a = new nze(e, t);
    return a._init(), e.setAttribute("data-intl-tel-input-id", a.id.toString()), ie.instances[a.id] = a, e.iti = a, a;
  },
  {
    defaults: Sw,
    //* Using a static var like this allows us to mock it in the tests.
    documentReady: () => document.readyState === "complete",
    //* Get the country data object.
    getCountryData: () => Fo,
    //* A getter for the plugin instance.
    getInstance: (e) => {
      const t = e.getAttribute("data-intl-tel-input-id");
      return t ? ie.instances[t] : null;
    },
    //* A map from instance ID to instance object.
    instances: {},
    attachUtils: rze,
    startedLoadingUtilsScript: !1,
    startedLoadingAutoCountry: !1,
    version: "25.10.10"
  }
), ize = ie, sze = mt(function({
  initialValue: e = "",
  onChangeNumber: t = () => {
  },
  onChangeCountry: a = () => {
  },
  onChangeValidity: o = () => {
  },
  onChangeErrorCode: n = () => {
  },
  usePreciseValidation: r = !1,
  initOptions: i = {},
  inputProps: s = {},
  disabled: l = void 0
}, c) {
  const u = Ie(null), d = Ie(null);
  mx(c, () => ({
    getInstance: () => d.current,
    getInput: () => u.current
  }));
  const h = Le(() => {
    const m = d.current?.getNumber() || "", f = d.current?.getSelectedCountryData().iso2 || "";
    if (t(m), a(f), d.current)
      if (r ? d.current.isValidNumberPrecise() : d.current.isValidNumber())
        o(!0), n(null);
      else {
        const p = d.current.getValidationError();
        o(!1), n(p);
      }
  }, [a, n, t, o, r]);
  return Ce(() => (u.current && (d.current = ize(u.current, i)), () => {
    d.current?.destroy();
  }), []), Ce(() => {
    const m = u.current;
    return m && (m.addEventListener("countrychange", h), d.current.promise.then(h)), () => {
      m && m.removeEventListener("countrychange", h);
    };
  }, [h]), Ce(() => {
    d.current && l !== void 0 && d.current.setDisabled(l);
  }, [l]), /* @__PURE__ */ ne.createElement(
    "input",
    {
      type: "tel",
      ref: u,
      onInput: h,
      defaultValue: e,
      ...s
    }
  );
}), lze = sze;
const Sa = {
  "phone-number": "_phone-number_1ni27_30",
  "is-full-width": "_is-full-width_1ni27_41",
  "group-label": "_group-label_1ni27_44",
  "helper-text": "_helper-text_1ni27_53",
  "is-disabled": "_is-disabled_1ni27_58",
  "is-error": "_is-error_1ni27_73",
  "is-success": "_is-success_1ni27_144",
  "container-icon": "_container-icon_1ni27_166",
  "dialog-overlay-show": "_dialog-overlay-show_1ni27_1",
  "dialog-content-show": "_dialog-content-show_1ni27_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1ni27_1"
};
mt(
  ({
    label: e,
    helperText: t,
    initialPhoneNumber: a,
    onChangePhoneNumber: o,
    initialCountry: n,
    onChangeCountry: r,
    locale: i = "en",
    message: s,
    status: l,
    disabled: c,
    isFullWidth: u,
    inputProps: d,
    setErrorCode: h,
    setIsValidPhoneNumber: m
  }, f) => {
    const { phoneNumber: p, country: b, handlePhoneNumberChange: w, handleCountryChange: _ } = lOe({
      initialPhoneNumber: a,
      initialCountry: n,
      onChangePhoneNumber: o,
      onChangeCountry: r
    }), y = It(
      Sa["phone-number"],
      c && Sa["is-disabled"],
      l && Sa[qp[l]],
      u && Sa["is-full-width"]
    );
    return /* @__PURE__ */ T("div", { className: y, children: [
      /* @__PURE__ */ T("div", { className: Sa["group-label"], children: [
        e && /* @__PURE__ */ v("label", { children: e }),
        t && /* @__PURE__ */ v("div", { className: Sa["helper-text"], children: t })
      ] }),
      /* @__PURE__ */ v(
        lze,
        {
          initialValue: p,
          onChangeErrorCode: h,
          onChangeValidity: m,
          onChangeCountry: _,
          onChangeNumber: w,
          inputProps: {
            disabled: c,
            "aria-label": d?.["aria-label"] || e,
            ...d
          },
          ref: f,
          initOptions: {
            strictMode: !0,
            initialCountry: b,
            i18n: LOe[i],
            useFullscreenPopup: !1,
            // Manually load the utils to prevent issues on SSR pages
            loadUtils: () => import("./utils-CJDvlpOH-DLsHHipy-DtXQX1OX.js")
          }
        }
      ),
      s && l && !c && /* @__PURE__ */ T("div", { className: Sa["container-icon"], children: [
        /* @__PURE__ */ v(Bn, { name: Hp[l].name, size: "medium", color: Hp[l].color }),
        /* @__PURE__ */ v("span", { className: Sa[qp[l]], children: s })
      ] })
    ] });
  }
);
function cze(e, t = globalThis?.document) {
  const a = ut(e);
  g.useEffect(() => {
    const o = (n) => {
      n.key === "Escape" && a(n);
    };
    return t.addEventListener("keydown", o, { capture: !0 }), () => t.removeEventListener("keydown", o, { capture: !0 });
  }, [a, t]);
}
var uze = "DismissableLayer", Bc = "dismissableLayer.update", dze = "dismissableLayer.pointerDownOutside", gze = "dismissableLayer.focusOutside", Kp, Ew = g.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), wd = g.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: a = !1,
      onEscapeKeyDown: o,
      onPointerDownOutside: n,
      onFocusOutside: r,
      onInteractOutside: i,
      onDismiss: s,
      ...l
    } = e, c = g.useContext(Ew), [u, d] = g.useState(null), h = u?.ownerDocument ?? globalThis?.document, [, m] = g.useState({}), f = Ne(t, ($) => d($)), p = Array.from(c.layers), [b] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), w = p.indexOf(b), _ = u ? p.indexOf(u) : -1, y = c.layersWithOutsidePointerEventsDisabled.size > 0, k = _ >= w, x = mze(($) => {
      const E = $.target, C = [...c.branches].some((j) => j.contains(E));
      !k || C || (n?.($), i?.($), $.defaultPrevented || s?.());
    }, h), S = fze(($) => {
      const E = $.target;
      [...c.branches].some((C) => C.contains(E)) || (r?.($), i?.($), $.defaultPrevented || s?.());
    }, h);
    return cze(($) => {
      _ === c.layers.size - 1 && (o?.($), !$.defaultPrevented && s && ($.preventDefault(), s()));
    }, h), g.useEffect(() => {
      if (u)
        return a && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (Kp = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(u)), c.layers.add(u), Jp(), () => {
          a && c.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = Kp);
        };
    }, [u, h, a, c]), g.useEffect(() => () => {
      u && (c.layers.delete(u), c.layersWithOutsidePointerEventsDisabled.delete(u), Jp());
    }, [u, c]), g.useEffect(() => {
      const $ = () => m({});
      return document.addEventListener(Bc, $), () => document.removeEventListener(Bc, $);
    }, []), /* @__PURE__ */ v(
      ye.div,
      {
        ...l,
        ref: f,
        style: {
          pointerEvents: y ? k ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: ve(e.onFocusCapture, S.onFocusCapture),
        onBlurCapture: ve(e.onBlurCapture, S.onBlurCapture),
        onPointerDownCapture: ve(
          e.onPointerDownCapture,
          x.onPointerDownCapture
        )
      }
    );
  }
);
wd.displayName = uze;
var hze = "DismissableLayerBranch", pze = g.forwardRef((e, t) => {
  const a = g.useContext(Ew), o = g.useRef(null), n = Ne(t, o);
  return g.useEffect(() => {
    const r = o.current;
    if (r)
      return a.branches.add(r), () => {
        a.branches.delete(r);
      };
  }, [a.branches]), /* @__PURE__ */ v(ye.div, { ...e, ref: n });
});
pze.displayName = hze;
function mze(e, t = globalThis?.document) {
  const a = ut(e), o = g.useRef(!1), n = g.useRef(() => {
  });
  return g.useEffect(() => {
    const r = (s) => {
      if (s.target && !o.current) {
        let l = function() {
          jw(
            dze,
            a,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", n.current), n.current = l, t.addEventListener("click", n.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", n.current);
      o.current = !1;
    }, i = window.setTimeout(() => {
      t.addEventListener("pointerdown", r);
    }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", r), t.removeEventListener("click", n.current);
    };
  }, [t, a]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function fze(e, t = globalThis?.document) {
  const a = ut(e), o = g.useRef(!1);
  return g.useEffect(() => {
    const n = (r) => {
      r.target && !o.current && jw(gze, a, { originalEvent: r }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", n), () => t.removeEventListener("focusin", n);
  }, [t, a]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function Jp() {
  const e = new CustomEvent(Bc);
  document.dispatchEvent(e);
}
function jw(e, t, a, { discrete: o }) {
  const n = a.originalEvent.target, r = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: a });
  t && n.addEventListener(e, t, { once: !0 }), o ? Yje(n, r) : n.dispatchEvent(r);
}
var bze = "Portal", _ze = g.forwardRef((e, t) => {
  const { container: a, ...o } = e, [n, r] = g.useState(!1);
  ot(() => r(!0), []);
  const i = a || n && globalThis?.document?.body;
  return i ? os.createPortal(/* @__PURE__ */ v(ye.div, { ...o, ref: t }), i) : null;
});
_ze.displayName = bze;
var Gt = function() {
  return Gt = Object.assign || function(e) {
    for (var t, a = 1, o = arguments.length; a < o; a++) {
      t = arguments[a];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, Gt.apply(this, arguments);
};
function Ow(e, t) {
  var a = {};
  for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (a[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, o = Object.getOwnPropertySymbols(e); n < o.length; n++)
      t.indexOf(o[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[n]) && (a[o[n]] = e[o[n]]);
  return a;
}
function vze(e, t, a) {
  for (var o = 0, n = t.length, r; o < n; o++)
    (r || !(o in t)) && (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
  return e.concat(r || Array.prototype.slice.call(t));
}
var Ll = "focusScope.autoFocusOnMount", Ml = "focusScope.autoFocusOnUnmount", Zp = { bubbles: !1, cancelable: !0 }, yze = "FocusScope", kd = g.forwardRef((e, t) => {
  const {
    loop: a = !1,
    trapped: o = !1,
    onMountAutoFocus: n,
    onUnmountAutoFocus: r,
    ...i
  } = e, [s, l] = g.useState(null), c = ut(n), u = ut(r), d = g.useRef(null), h = Ne(t, (p) => l(p)), m = g.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  g.useEffect(() => {
    if (o) {
      let p = function(y) {
        if (m.paused || !s) return;
        const k = y.target;
        s.contains(k) ? d.current = k : za(d.current, { select: !0 });
      }, b = function(y) {
        if (m.paused || !s) return;
        const k = y.relatedTarget;
        k !== null && (s.contains(k) || za(d.current, { select: !0 }));
      }, w = function(y) {
        if (document.activeElement === document.body)
          for (const k of y)
            k.removedNodes.length > 0 && za(s);
      };
      document.addEventListener("focusin", p), document.addEventListener("focusout", b);
      const _ = new MutationObserver(w);
      return s && _.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", p), document.removeEventListener("focusout", b), _.disconnect();
      };
    }
  }, [o, s, m.paused]), g.useEffect(() => {
    if (s) {
      Xp.add(m);
      const p = document.activeElement;
      if (!s.contains(p)) {
        const b = new CustomEvent(Ll, Zp);
        s.addEventListener(Ll, c), s.dispatchEvent(b), b.defaultPrevented || (wze(Cze(zw(s)), { select: !0 }), document.activeElement === p && za(s));
      }
      return () => {
        s.removeEventListener(Ll, c), setTimeout(() => {
          const b = new CustomEvent(Ml, Zp);
          s.addEventListener(Ml, u), s.dispatchEvent(b), b.defaultPrevented || za(p ?? document.body, { select: !0 }), s.removeEventListener(Ml, u), Xp.remove(m);
        }, 0);
      };
    }
  }, [s, c, u, m]);
  const f = g.useCallback(
    (p) => {
      if (!a && !o || m.paused) return;
      const b = p.key === "Tab" && !p.altKey && !p.ctrlKey && !p.metaKey, w = document.activeElement;
      if (b && w) {
        const _ = p.currentTarget, [y, k] = kze(_);
        y && k ? !p.shiftKey && w === k ? (p.preventDefault(), a && za(y, { select: !0 })) : p.shiftKey && w === y && (p.preventDefault(), a && za(k, { select: !0 })) : w === _ && p.preventDefault();
      }
    },
    [a, o, m.paused]
  );
  return /* @__PURE__ */ v(ye.div, { tabIndex: -1, ...i, ref: h, onKeyDown: f });
});
kd.displayName = yze;
function wze(e, { select: t = !1 } = {}) {
  const a = document.activeElement;
  for (const o of e)
    if (za(o, { select: t }), document.activeElement !== a) return;
}
function kze(e) {
  const t = zw(e), a = Yp(t, e), o = Yp(t.reverse(), e);
  return [a, o];
}
function zw(e) {
  const t = [], a = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const n = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || n ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; a.nextNode(); ) t.push(a.currentNode);
  return t;
}
function Yp(e, t) {
  for (const a of e)
    if (!xze(a, { upTo: t })) return a;
}
function xze(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function $ze(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function za(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const a = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== a && $ze(e) && t && e.select();
  }
}
var Xp = Sze();
function Sze() {
  let e = [];
  return {
    add(t) {
      const a = e[0];
      t !== a && a?.pause(), e = Qp(e, t), e.unshift(t);
    },
    remove(t) {
      e = Qp(e, t), e[0]?.resume();
    }
  };
}
function Qp(e, t) {
  const a = [...e], o = a.indexOf(t);
  return o !== -1 && a.splice(o, 1), a;
}
function Cze(e) {
  return e.filter((t) => t.tagName !== "A");
}
var Wl = 0;
function Aw() {
  g.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? em()), document.body.insertAdjacentElement("beforeend", e[1] ?? em()), Wl++, () => {
      Wl === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Wl--;
    };
  }, []);
}
function em() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var hi = "right-scroll-bar-position", pi = "width-before-scroll-bar", Eze = "with-scroll-bars-hidden", jze = "--removed-body-scroll-bar-size";
function Bl(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Oze(e, t) {
  var a = Pe(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return a.value;
        },
        set current(o) {
          var n = a.value;
          n !== o && (a.value = o, a.callback(o, n));
        }
      }
    };
  })[0];
  return a.callback = t, a.facade;
}
var zze = typeof window < "u" ? g.useLayoutEffect : g.useEffect, tm = /* @__PURE__ */ new WeakMap();
function Aze(e, t) {
  var a = Oze(null, function(o) {
    return e.forEach(function(n) {
      return Bl(n, o);
    });
  });
  return zze(function() {
    var o = tm.get(a);
    if (o) {
      var n = new Set(o), r = new Set(e), i = a.current;
      n.forEach(function(s) {
        r.has(s) || Bl(s, null);
      }), r.forEach(function(s) {
        n.has(s) || Bl(s, i);
      });
    }
    tm.set(a, e);
  }, [e]), a;
}
function Pze(e) {
  return e;
}
function Dze(e, t) {
  t === void 0 && (t = Pze);
  var a = [], o = !1, n = {
    read: function() {
      if (o)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return a.length ? a[a.length - 1] : e;
    },
    useMedium: function(r) {
      var i = t(r, o);
      return a.push(i), function() {
        a = a.filter(function(s) {
          return s !== i;
        });
      };
    },
    assignSyncMedium: function(r) {
      for (o = !0; a.length; ) {
        var i = a;
        a = [], i.forEach(r);
      }
      a = {
        push: function(s) {
          return r(s);
        },
        filter: function() {
          return a;
        }
      };
    },
    assignMedium: function(r) {
      o = !0;
      var i = [];
      if (a.length) {
        var s = a;
        a = [], s.forEach(r), i = a;
      }
      var l = function() {
        var u = i;
        i = [], u.forEach(r);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), a = {
        push: function(u) {
          i.push(u), c();
        },
        filter: function(u) {
          return i = i.filter(u), a;
        }
      };
    }
  };
  return n;
}
function Nze(e) {
  e === void 0 && (e = {});
  var t = Dze(null);
  return t.options = Gt({ async: !0, ssr: !1 }, e), t;
}
var Pw = function(e) {
  var t = e.sideCar, a = Ow(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var o = t.read();
  if (!o)
    throw new Error("Sidecar medium not found");
  return g.createElement(o, Gt({}, a));
};
Pw.isSideCarExport = !0;
function Rze(e, t) {
  return e.useMedium(t), Pw;
}
var Dw = Nze(), Fl = function() {
}, Ts = g.forwardRef(function(e, t) {
  var a = g.useRef(null), o = g.useState({
    onScrollCapture: Fl,
    onWheelCapture: Fl,
    onTouchMoveCapture: Fl
  }), n = o[0], r = o[1], i = e.forwardProps, s = e.children, l = e.className, c = e.removeScrollBar, u = e.enabled, d = e.shards, h = e.sideCar, m = e.noIsolation, f = e.inert, p = e.allowPinchZoom, b = e.as, w = b === void 0 ? "div" : b, _ = e.gapMode, y = Ow(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), k = h, x = Aze([a, t]), S = Gt(Gt({}, y), n);
  return g.createElement(
    g.Fragment,
    null,
    u && g.createElement(k, { sideCar: Dw, removeScrollBar: c, shards: d, noIsolation: m, inert: f, setCallbacks: r, allowPinchZoom: !!p, lockRef: a, gapMode: _ }),
    i ? g.cloneElement(g.Children.only(s), Gt(Gt({}, S), { ref: x })) : g.createElement(w, Gt({}, S, { className: l, ref: x }), s)
  );
});
Ts.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Ts.classNames = {
  fullWidth: pi,
  zeroRight: hi
};
var Ize = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Tze() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Ize();
  return t && e.setAttribute("nonce", t), e;
}
function Lze(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Mze(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var Wze = function() {
  var e = 0, t = null;
  return {
    add: function(a) {
      e == 0 && (t = Tze()) && (Lze(t, a), Mze(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Bze = function() {
  var e = Wze();
  return function(t, a) {
    g.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && a]);
  };
}, Nw = function() {
  var e = Bze(), t = function(a) {
    var o = a.styles, n = a.dynamic;
    return e(o, n), null;
  };
  return t;
}, Fze = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Vl = function(e) {
  return parseInt(e || "", 10) || 0;
}, Vze = function(e) {
  var t = window.getComputedStyle(document.body), a = t[e === "padding" ? "paddingLeft" : "marginLeft"], o = t[e === "padding" ? "paddingTop" : "marginTop"], n = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Vl(a), Vl(o), Vl(n)];
}, Uze = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return Fze;
  var t = Vze(e), a = document.documentElement.clientWidth, o = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, o - a + t[2] - t[0])
  };
}, qze = Nw(), Vo = "data-scroll-locked", Hze = function(e, t, a, o) {
  var n = e.left, r = e.top, i = e.right, s = e.gap;
  return a === void 0 && (a = "margin"), `
  .`.concat(Eze, ` {
   overflow: hidden `).concat(o, `;
   padding-right: `).concat(s, "px ").concat(o, `;
  }
  body[`).concat(Vo, `] {
    overflow: hidden `).concat(o, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(o, ";"),
    a === "margin" && `
    padding-left: `.concat(n, `px;
    padding-top: `).concat(r, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(o, `;
    `),
    a === "padding" && "padding-right: ".concat(s, "px ").concat(o, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(hi, ` {
    right: `).concat(s, "px ").concat(o, `;
  }
  
  .`).concat(pi, ` {
    margin-right: `).concat(s, "px ").concat(o, `;
  }
  
  .`).concat(hi, " .").concat(hi, ` {
    right: 0 `).concat(o, `;
  }
  
  .`).concat(pi, " .").concat(pi, ` {
    margin-right: 0 `).concat(o, `;
  }
  
  body[`).concat(Vo, `] {
    `).concat(jze, ": ").concat(s, `px;
  }
`);
}, am = function() {
  var e = parseInt(document.body.getAttribute(Vo) || "0", 10);
  return isFinite(e) ? e : 0;
}, Gze = function() {
  g.useEffect(function() {
    return document.body.setAttribute(Vo, (am() + 1).toString()), function() {
      var e = am() - 1;
      e <= 0 ? document.body.removeAttribute(Vo) : document.body.setAttribute(Vo, e.toString());
    };
  }, []);
}, Kze = function(e) {
  var t = e.noRelative, a = e.noImportant, o = e.gapMode, n = o === void 0 ? "margin" : o;
  Gze();
  var r = g.useMemo(function() {
    return Uze(n);
  }, [n]);
  return g.createElement(qze, { styles: Hze(r, !t, n, a ? "" : "!important") });
}, Fc = !1;
if (typeof window < "u")
  try {
    var Mr = Object.defineProperty({}, "passive", {
      get: function() {
        return Fc = !0, !0;
      }
    });
    window.addEventListener("test", Mr, Mr), window.removeEventListener("test", Mr, Mr);
  } catch {
    Fc = !1;
  }
var Po = Fc ? { passive: !1 } : !1, Jze = function(e) {
  return e.tagName === "TEXTAREA";
}, Rw = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var a = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    a[t] !== "hidden" && // contains scroll inside self
    !(a.overflowY === a.overflowX && !Jze(e) && a[t] === "visible")
  );
}, Zze = function(e) {
  return Rw(e, "overflowY");
}, Yze = function(e) {
  return Rw(e, "overflowX");
}, om = function(e, t) {
  var a = t.ownerDocument, o = t;
  do {
    typeof ShadowRoot < "u" && o instanceof ShadowRoot && (o = o.host);
    var n = Iw(e, o);
    if (n) {
      var r = Tw(e, o), i = r[1], s = r[2];
      if (i > s)
        return !0;
    }
    o = o.parentNode;
  } while (o && o !== a.body);
  return !1;
}, Xze = function(e) {
  var t = e.scrollTop, a = e.scrollHeight, o = e.clientHeight;
  return [
    t,
    a,
    o
  ];
}, Qze = function(e) {
  var t = e.scrollLeft, a = e.scrollWidth, o = e.clientWidth;
  return [
    t,
    a,
    o
  ];
}, Iw = function(e, t) {
  return e === "v" ? Zze(t) : Yze(t);
}, Tw = function(e, t) {
  return e === "v" ? Xze(t) : Qze(t);
}, eAe = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, tAe = function(e, t, a, o, n) {
  var r = eAe(e, window.getComputedStyle(t).direction), i = r * o, s = a.target, l = t.contains(s), c = !1, u = i > 0, d = 0, h = 0;
  do {
    var m = Tw(e, s), f = m[0], p = m[1], b = m[2], w = p - b - r * f;
    (f || w) && Iw(e, s) && (d += w, h += f), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (u && Math.abs(d) < 1 || !u && Math.abs(h) < 1) && (c = !0), c;
}, Wr = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, nm = function(e) {
  return [e.deltaX, e.deltaY];
}, rm = function(e) {
  return e && "current" in e ? e.current : e;
}, aAe = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, oAe = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, nAe = 0, Do = [];
function rAe(e) {
  var t = g.useRef([]), a = g.useRef([0, 0]), o = g.useRef(), n = g.useState(nAe++)[0], r = g.useState(Nw)[0], i = g.useRef(e);
  g.useEffect(function() {
    i.current = e;
  }, [e]), g.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(n));
      var p = vze([e.lockRef.current], (e.shards || []).map(rm)).filter(Boolean);
      return p.forEach(function(b) {
        return b.classList.add("allow-interactivity-".concat(n));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(n)), p.forEach(function(b) {
          return b.classList.remove("allow-interactivity-".concat(n));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = g.useCallback(function(p, b) {
    if ("touches" in p && p.touches.length === 2 || p.type === "wheel" && p.ctrlKey)
      return !i.current.allowPinchZoom;
    var w = Wr(p), _ = a.current, y = "deltaX" in p ? p.deltaX : _[0] - w[0], k = "deltaY" in p ? p.deltaY : _[1] - w[1], x, S = p.target, $ = Math.abs(y) > Math.abs(k) ? "h" : "v";
    if ("touches" in p && $ === "h" && S.type === "range")
      return !1;
    var E = om($, S);
    if (!E)
      return !0;
    if (E ? x = $ : (x = $ === "v" ? "h" : "v", E = om($, S)), !E)
      return !1;
    if (!o.current && "changedTouches" in p && (y || k) && (o.current = x), !x)
      return !0;
    var C = o.current || x;
    return tAe(C, b, p, C === "h" ? y : k);
  }, []), l = g.useCallback(function(p) {
    var b = p;
    if (!(!Do.length || Do[Do.length - 1] !== r)) {
      var w = "deltaY" in b ? nm(b) : Wr(b), _ = t.current.filter(function(x) {
        return x.name === b.type && (x.target === b.target || b.target === x.shadowParent) && aAe(x.delta, w);
      })[0];
      if (_ && _.should) {
        b.cancelable && b.preventDefault();
        return;
      }
      if (!_) {
        var y = (i.current.shards || []).map(rm).filter(Boolean).filter(function(x) {
          return x.contains(b.target);
        }), k = y.length > 0 ? s(b, y[0]) : !i.current.noIsolation;
        k && b.cancelable && b.preventDefault();
      }
    }
  }, []), c = g.useCallback(function(p, b, w, _) {
    var y = { name: p, delta: b, target: w, should: _, shadowParent: iAe(w) };
    t.current.push(y), setTimeout(function() {
      t.current = t.current.filter(function(k) {
        return k !== y;
      });
    }, 1);
  }, []), u = g.useCallback(function(p) {
    a.current = Wr(p), o.current = void 0;
  }, []), d = g.useCallback(function(p) {
    c(p.type, nm(p), p.target, s(p, e.lockRef.current));
  }, []), h = g.useCallback(function(p) {
    c(p.type, Wr(p), p.target, s(p, e.lockRef.current));
  }, []);
  g.useEffect(function() {
    return Do.push(r), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", l, Po), document.addEventListener("touchmove", l, Po), document.addEventListener("touchstart", u, Po), function() {
      Do = Do.filter(function(p) {
        return p !== r;
      }), document.removeEventListener("wheel", l, Po), document.removeEventListener("touchmove", l, Po), document.removeEventListener("touchstart", u, Po);
    };
  }, []);
  var m = e.removeScrollBar, f = e.inert;
  return g.createElement(
    g.Fragment,
    null,
    f ? g.createElement(r, { styles: oAe(n) }) : null,
    m ? g.createElement(Kze, { gapMode: e.gapMode }) : null
  );
}
function iAe(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const sAe = Rze(Dw, rAe);
var xd = g.forwardRef(function(e, t) {
  return g.createElement(Ts, Gt({}, e, { ref: t, sideCar: sAe }));
});
xd.classNames = Ts.classNames;
var lAe = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, No = /* @__PURE__ */ new WeakMap(), Br = /* @__PURE__ */ new WeakMap(), Fr = {}, Ul = 0, Lw = function(e) {
  return e && (e.host || Lw(e.parentNode));
}, cAe = function(e, t) {
  return t.map(function(a) {
    if (e.contains(a))
      return a;
    var o = Lw(a);
    return o && e.contains(o) ? o : (console.error("aria-hidden", a, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(a) {
    return !!a;
  });
}, uAe = function(e, t, a, o) {
  var n = cAe(t, Array.isArray(e) ? e : [e]);
  Fr[a] || (Fr[a] = /* @__PURE__ */ new WeakMap());
  var r = Fr[a], i = [], s = /* @__PURE__ */ new Set(), l = new Set(n), c = function(d) {
    !d || s.has(d) || (s.add(d), c(d.parentNode));
  };
  n.forEach(c);
  var u = function(d) {
    !d || l.has(d) || Array.prototype.forEach.call(d.children, function(h) {
      if (s.has(h))
        u(h);
      else
        try {
          var m = h.getAttribute(o), f = m !== null && m !== "false", p = (No.get(h) || 0) + 1, b = (r.get(h) || 0) + 1;
          No.set(h, p), r.set(h, b), i.push(h), p === 1 && f && Br.set(h, !0), b === 1 && h.setAttribute(a, "true"), f || h.setAttribute(o, "true");
        } catch (w) {
          console.error("aria-hidden: cannot operate on ", h, w);
        }
    });
  };
  return u(t), s.clear(), Ul++, function() {
    i.forEach(function(d) {
      var h = No.get(d) - 1, m = r.get(d) - 1;
      No.set(d, h), r.set(d, m), h || (Br.has(d) || d.removeAttribute(o), Br.delete(d)), m || d.removeAttribute(a);
    }), Ul--, Ul || (No = /* @__PURE__ */ new WeakMap(), No = /* @__PURE__ */ new WeakMap(), Br = /* @__PURE__ */ new WeakMap(), Fr = {});
  };
}, Mw = function(e, t, a) {
  a === void 0 && (a = "data-aria-hidden");
  var o = Array.from(Array.isArray(e) ? e : [e]), n = lAe(e);
  return n ? (o.push.apply(o, Array.from(n.querySelectorAll("[aria-live]"))), uAe(o, n, a, "aria-hidden")) : function() {
    return null;
  };
}, Ww = "Dialog", [Bw, pit] = cr(Ww), [mit, aa] = Bw(Ww), Fw = "DialogTrigger", dAe = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, ...o } = e, n = aa(Fw, a), r = Ne(t, n.triggerRef);
    return /* @__PURE__ */ v(
      ye.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": n.open,
        "aria-controls": n.contentId,
        "data-state": Sd(n.open),
        ...o,
        ref: r,
        onClick: ve(e.onClick, n.onOpenToggle)
      }
    );
  }
);
dAe.displayName = Fw;
var gAe = "DialogPortal", [fit, Vw] = Bw(gAe, {
  forceMount: void 0
}), Fi = "DialogOverlay", hAe = g.forwardRef(
  (e, t) => {
    const a = Vw(Fi, e.__scopeDialog), { forceMount: o = a.forceMount, ...n } = e, r = aa(Fi, e.__scopeDialog);
    return r.modal ? /* @__PURE__ */ v(yo, { present: o || r.open, children: /* @__PURE__ */ v(mAe, { ...n, ref: t }) }) : null;
  }
);
hAe.displayName = Fi;
var pAe = /* @__PURE__ */ Fn("DialogOverlay.RemoveScroll"), mAe = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, ...o } = e, n = aa(Fi, a);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ v(xd, { as: pAe, allowPinchZoom: !0, shards: [n.contentRef], children: /* @__PURE__ */ v(
        ye.div,
        {
          "data-state": Sd(n.open),
          ...o,
          ref: t,
          style: { pointerEvents: "auto", ...o.style }
        }
      ) })
    );
  }
), so = "DialogContent", fAe = g.forwardRef(
  (e, t) => {
    const a = Vw(so, e.__scopeDialog), { forceMount: o = a.forceMount, ...n } = e, r = aa(so, e.__scopeDialog);
    return /* @__PURE__ */ v(yo, { present: o || r.open, children: r.modal ? /* @__PURE__ */ v(bAe, { ...n, ref: t }) : /* @__PURE__ */ v(_Ae, { ...n, ref: t }) });
  }
);
fAe.displayName = so;
var bAe = g.forwardRef(
  (e, t) => {
    const a = aa(so, e.__scopeDialog), o = g.useRef(null), n = Ne(t, a.contentRef, o);
    return g.useEffect(() => {
      const r = o.current;
      if (r) return Mw(r);
    }, []), /* @__PURE__ */ v(
      Uw,
      {
        ...e,
        ref: n,
        trapFocus: a.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: ve(e.onCloseAutoFocus, (r) => {
          r.preventDefault(), a.triggerRef.current?.focus();
        }),
        onPointerDownOutside: ve(e.onPointerDownOutside, (r) => {
          const i = r.detail.originalEvent, s = i.button === 0 && i.ctrlKey === !0;
          (i.button === 2 || s) && r.preventDefault();
        }),
        onFocusOutside: ve(
          e.onFocusOutside,
          (r) => r.preventDefault()
        )
      }
    );
  }
), _Ae = g.forwardRef(
  (e, t) => {
    const a = aa(so, e.__scopeDialog), o = g.useRef(!1), n = g.useRef(!1);
    return /* @__PURE__ */ v(
      Uw,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (r) => {
          e.onCloseAutoFocus?.(r), r.defaultPrevented || (o.current || a.triggerRef.current?.focus(), r.preventDefault()), o.current = !1, n.current = !1;
        },
        onInteractOutside: (r) => {
          e.onInteractOutside?.(r), r.defaultPrevented || (o.current = !0, r.detail.originalEvent.type === "pointerdown" && (n.current = !0));
          const i = r.target;
          a.triggerRef.current?.contains(i) && r.preventDefault(), r.detail.originalEvent.type === "focusin" && n.current && r.preventDefault();
        }
      }
    );
  }
), Uw = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, trapFocus: o, onOpenAutoFocus: n, onCloseAutoFocus: r, ...i } = e, s = aa(so, a), l = g.useRef(null), c = Ne(t, l);
    return Aw(), /* @__PURE__ */ T(De, { children: [
      /* @__PURE__ */ v(
        kd,
        {
          asChild: !0,
          loop: !0,
          trapped: o,
          onMountAutoFocus: n,
          onUnmountAutoFocus: r,
          children: /* @__PURE__ */ v(
            wd,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": Sd(s.open),
              ...i,
              ref: c,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ T(De, { children: [
        /* @__PURE__ */ v(kAe, { titleId: s.titleId }),
        /* @__PURE__ */ v($Ae, { contentRef: l, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), $d = "DialogTitle", vAe = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, ...o } = e, n = aa($d, a);
    return /* @__PURE__ */ v(ye.h2, { id: n.titleId, ...o, ref: t });
  }
);
vAe.displayName = $d;
var qw = "DialogDescription", yAe = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, ...o } = e, n = aa(qw, a);
    return /* @__PURE__ */ v(ye.p, { id: n.descriptionId, ...o, ref: t });
  }
);
yAe.displayName = qw;
var Hw = "DialogClose", wAe = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, ...o } = e, n = aa(Hw, a);
    return /* @__PURE__ */ v(
      ye.button,
      {
        type: "button",
        ...o,
        ref: t,
        onClick: ve(e.onClick, () => n.onOpenChange(!1))
      }
    );
  }
);
wAe.displayName = Hw;
function Sd(e) {
  return e ? "open" : "closed";
}
var Gw = "DialogTitleWarning", [bit, Kw] = Vje(Gw, {
  contentName: so,
  titleName: $d,
  docsSlug: "dialog"
}), kAe = ({ titleId: e }) => {
  const t = Kw(Gw), a = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return g.useEffect(() => {
    e && (document.getElementById(e) || console.error(a));
  }, [a, e]), null;
}, xAe = "DialogDescriptionWarning", $Ae = ({ contentRef: e, descriptionId: t }) => {
  const a = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Kw(xAe).contentName}}.`;
  return g.useEffect(() => {
    const o = e.current?.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(a));
  }, [a, e, t]), null;
};
function Vc(e, [t, a]) {
  return Math.min(a, Math.max(t, e));
}
function SAe(e, t) {
  return g.useReducer((a, o) => t[a][o] ?? a, e);
}
var Cd = "ScrollArea", [Jw, _it] = cr(Cd), [CAe, Dt] = Jw(Cd), EAe = g.forwardRef(
  (e, t) => {
    const {
      __scopeScrollArea: a,
      type: o = "hover",
      dir: n,
      scrollHideDelay: r = 600,
      ...i
    } = e, [s, l] = g.useState(null), [c, u] = g.useState(null), [d, h] = g.useState(null), [m, f] = g.useState(null), [p, b] = g.useState(null), [w, _] = g.useState(0), [y, k] = g.useState(0), [x, S] = g.useState(!1), [$, E] = g.useState(!1), C = Ne(t, (R) => l(R)), j = Qje(n);
    return /* @__PURE__ */ v(
      CAe,
      {
        scope: a,
        type: o,
        dir: j,
        scrollHideDelay: r,
        scrollArea: s,
        viewport: c,
        onViewportChange: u,
        content: d,
        onContentChange: h,
        scrollbarX: m,
        onScrollbarXChange: f,
        scrollbarXEnabled: x,
        onScrollbarXEnabledChange: S,
        scrollbarY: p,
        onScrollbarYChange: b,
        scrollbarYEnabled: $,
        onScrollbarYEnabledChange: E,
        onCornerWidthChange: _,
        onCornerHeightChange: k,
        children: /* @__PURE__ */ v(
          ye.div,
          {
            dir: j,
            ...i,
            ref: C,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": w + "px",
              "--radix-scroll-area-corner-height": y + "px",
              ...e.style
            }
          }
        )
      }
    );
  }
);
EAe.displayName = Cd;
var Zw = "ScrollAreaViewport", jAe = g.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: a, children: o, nonce: n, ...r } = e, i = Dt(Zw, a), s = g.useRef(null), l = Ne(t, s, i.onViewportChange);
    return /* @__PURE__ */ T(De, { children: [
      /* @__PURE__ */ v(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: n
        }
      ),
      /* @__PURE__ */ v(
        ye.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...r,
          ref: l,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: i.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: i.scrollbarYEnabled ? "scroll" : "hidden",
            ...e.style
          },
          children: /* @__PURE__ */ v("div", { ref: i.onContentChange, style: { minWidth: "100%", display: "table" }, children: o })
        }
      )
    ] });
  }
);
jAe.displayName = Zw;
var oa = "ScrollAreaScrollbar", OAe = g.forwardRef(
  (e, t) => {
    const { forceMount: a, ...o } = e, n = Dt(oa, e.__scopeScrollArea), { onScrollbarXEnabledChange: r, onScrollbarYEnabledChange: i } = n, s = e.orientation === "horizontal";
    return g.useEffect(() => (s ? r(!0) : i(!0), () => {
      s ? r(!1) : i(!1);
    }), [s, r, i]), n.type === "hover" ? /* @__PURE__ */ v(zAe, { ...o, ref: t, forceMount: a }) : n.type === "scroll" ? /* @__PURE__ */ v(AAe, { ...o, ref: t, forceMount: a }) : n.type === "auto" ? /* @__PURE__ */ v(Yw, { ...o, ref: t, forceMount: a }) : n.type === "always" ? /* @__PURE__ */ v(Ed, { ...o, ref: t }) : null;
  }
);
OAe.displayName = oa;
var zAe = g.forwardRef((e, t) => {
  const { forceMount: a, ...o } = e, n = Dt(oa, e.__scopeScrollArea), [r, i] = g.useState(!1);
  return g.useEffect(() => {
    const s = n.scrollArea;
    let l = 0;
    if (s) {
      const c = () => {
        window.clearTimeout(l), i(!0);
      }, u = () => {
        l = window.setTimeout(() => i(!1), n.scrollHideDelay);
      };
      return s.addEventListener("pointerenter", c), s.addEventListener("pointerleave", u), () => {
        window.clearTimeout(l), s.removeEventListener("pointerenter", c), s.removeEventListener("pointerleave", u);
      };
    }
  }, [n.scrollArea, n.scrollHideDelay]), /* @__PURE__ */ v(yo, { present: a || r, children: /* @__PURE__ */ v(
    Yw,
    {
      "data-state": r ? "visible" : "hidden",
      ...o,
      ref: t
    }
  ) });
}), AAe = g.forwardRef((e, t) => {
  const { forceMount: a, ...o } = e, n = Dt(oa, e.__scopeScrollArea), r = e.orientation === "horizontal", i = Ms(() => l("SCROLL_END"), 100), [s, l] = SAe("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return g.useEffect(() => {
    if (s === "idle") {
      const c = window.setTimeout(() => l("HIDE"), n.scrollHideDelay);
      return () => window.clearTimeout(c);
    }
  }, [s, n.scrollHideDelay, l]), g.useEffect(() => {
    const c = n.viewport, u = r ? "scrollLeft" : "scrollTop";
    if (c) {
      let d = c[u];
      const h = () => {
        const m = c[u];
        d !== m && (l("SCROLL"), i()), d = m;
      };
      return c.addEventListener("scroll", h), () => c.removeEventListener("scroll", h);
    }
  }, [n.viewport, r, l, i]), /* @__PURE__ */ v(yo, { present: a || s !== "hidden", children: /* @__PURE__ */ v(
    Ed,
    {
      "data-state": s === "hidden" ? "hidden" : "visible",
      ...o,
      ref: t,
      onPointerEnter: ve(e.onPointerEnter, () => l("POINTER_ENTER")),
      onPointerLeave: ve(e.onPointerLeave, () => l("POINTER_LEAVE"))
    }
  ) });
}), Yw = g.forwardRef((e, t) => {
  const a = Dt(oa, e.__scopeScrollArea), { forceMount: o, ...n } = e, [r, i] = g.useState(!1), s = e.orientation === "horizontal", l = Ms(() => {
    if (a.viewport) {
      const c = a.viewport.offsetWidth < a.viewport.scrollWidth, u = a.viewport.offsetHeight < a.viewport.scrollHeight;
      i(s ? c : u);
    }
  }, 10);
  return en(a.viewport, l), en(a.content, l), /* @__PURE__ */ v(yo, { present: o || r, children: /* @__PURE__ */ v(
    Ed,
    {
      "data-state": r ? "visible" : "hidden",
      ...n,
      ref: t
    }
  ) });
}), Ed = g.forwardRef((e, t) => {
  const { orientation: a = "vertical", ...o } = e, n = Dt(oa, e.__scopeScrollArea), r = g.useRef(null), i = g.useRef(0), [s, l] = g.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), c = ek(s.viewport, s.content), u = {
    ...o,
    sizes: s,
    onSizesChange: l,
    hasThumb: c > 0 && c < 1,
    onThumbChange: (h) => r.current = h,
    onThumbPointerUp: () => i.current = 0,
    onThumbPointerDown: (h) => i.current = h
  };
  function d(h, m) {
    return MAe(h, i.current, s, m);
  }
  return a === "horizontal" ? /* @__PURE__ */ v(
    PAe,
    {
      ...u,
      ref: t,
      onThumbPositionChange: () => {
        if (n.viewport && r.current) {
          const h = n.viewport.scrollLeft, m = im(h, s, n.dir);
          r.current.style.transform = `translate3d(${m}px, 0, 0)`;
        }
      },
      onWheelScroll: (h) => {
        n.viewport && (n.viewport.scrollLeft = h);
      },
      onDragScroll: (h) => {
        n.viewport && (n.viewport.scrollLeft = d(h, n.dir));
      }
    }
  ) : a === "vertical" ? /* @__PURE__ */ v(
    DAe,
    {
      ...u,
      ref: t,
      onThumbPositionChange: () => {
        if (n.viewport && r.current) {
          const h = n.viewport.scrollTop, m = im(h, s);
          r.current.style.transform = `translate3d(0, ${m}px, 0)`;
        }
      },
      onWheelScroll: (h) => {
        n.viewport && (n.viewport.scrollTop = h);
      },
      onDragScroll: (h) => {
        n.viewport && (n.viewport.scrollTop = d(h));
      }
    }
  ) : null;
}), PAe = g.forwardRef((e, t) => {
  const { sizes: a, onSizesChange: o, ...n } = e, r = Dt(oa, e.__scopeScrollArea), [i, s] = g.useState(), l = g.useRef(null), c = Ne(t, l, r.onScrollbarXChange);
  return g.useEffect(() => {
    l.current && s(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ v(
    Qw,
    {
      "data-orientation": "horizontal",
      ...n,
      ref: c,
      sizes: a,
      style: {
        bottom: 0,
        left: r.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: r.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": Ls(a) + "px",
        ...e.style
      },
      onThumbPointerDown: (u) => e.onThumbPointerDown(u.x),
      onDragScroll: (u) => e.onDragScroll(u.x),
      onWheelScroll: (u, d) => {
        if (r.viewport) {
          const h = r.viewport.scrollLeft + u.deltaX;
          e.onWheelScroll(h), ak(h, d) && u.preventDefault();
        }
      },
      onResize: () => {
        l.current && r.viewport && i && o({
          content: r.viewport.scrollWidth,
          viewport: r.viewport.offsetWidth,
          scrollbar: {
            size: l.current.clientWidth,
            paddingStart: Ui(i.paddingLeft),
            paddingEnd: Ui(i.paddingRight)
          }
        });
      }
    }
  );
}), DAe = g.forwardRef((e, t) => {
  const { sizes: a, onSizesChange: o, ...n } = e, r = Dt(oa, e.__scopeScrollArea), [i, s] = g.useState(), l = g.useRef(null), c = Ne(t, l, r.onScrollbarYChange);
  return g.useEffect(() => {
    l.current && s(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ v(
    Qw,
    {
      "data-orientation": "vertical",
      ...n,
      ref: c,
      sizes: a,
      style: {
        top: 0,
        right: r.dir === "ltr" ? 0 : void 0,
        left: r.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": Ls(a) + "px",
        ...e.style
      },
      onThumbPointerDown: (u) => e.onThumbPointerDown(u.y),
      onDragScroll: (u) => e.onDragScroll(u.y),
      onWheelScroll: (u, d) => {
        if (r.viewport) {
          const h = r.viewport.scrollTop + u.deltaY;
          e.onWheelScroll(h), ak(h, d) && u.preventDefault();
        }
      },
      onResize: () => {
        l.current && r.viewport && i && o({
          content: r.viewport.scrollHeight,
          viewport: r.viewport.offsetHeight,
          scrollbar: {
            size: l.current.clientHeight,
            paddingStart: Ui(i.paddingTop),
            paddingEnd: Ui(i.paddingBottom)
          }
        });
      }
    }
  );
}), [NAe, Xw] = Jw(oa), Qw = g.forwardRef((e, t) => {
  const {
    __scopeScrollArea: a,
    sizes: o,
    hasThumb: n,
    onThumbChange: r,
    onThumbPointerUp: i,
    onThumbPointerDown: s,
    onThumbPositionChange: l,
    onDragScroll: c,
    onWheelScroll: u,
    onResize: d,
    ...h
  } = e, m = Dt(oa, a), [f, p] = g.useState(null), b = Ne(t, (C) => p(C)), w = g.useRef(null), _ = g.useRef(""), y = m.viewport, k = o.content - o.viewport, x = ut(u), S = ut(l), $ = Ms(d, 10);
  function E(C) {
    if (w.current) {
      const j = C.clientX - w.current.left, R = C.clientY - w.current.top;
      c({ x: j, y: R });
    }
  }
  return g.useEffect(() => {
    const C = (j) => {
      const R = j.target;
      f?.contains(R) && x(j, k);
    };
    return document.addEventListener("wheel", C, { passive: !1 }), () => document.removeEventListener("wheel", C, { passive: !1 });
  }, [y, f, k, x]), g.useEffect(S, [o, S]), en(f, $), en(m.content, $), /* @__PURE__ */ v(
    NAe,
    {
      scope: a,
      scrollbar: f,
      hasThumb: n,
      onThumbChange: ut(r),
      onThumbPointerUp: ut(i),
      onThumbPositionChange: S,
      onThumbPointerDown: ut(s),
      children: /* @__PURE__ */ v(
        ye.div,
        {
          ...h,
          ref: b,
          style: { position: "absolute", ...h.style },
          onPointerDown: ve(e.onPointerDown, (C) => {
            C.button === 0 && (C.target.setPointerCapture(C.pointerId), w.current = f.getBoundingClientRect(), _.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", m.viewport && (m.viewport.style.scrollBehavior = "auto"), E(C));
          }),
          onPointerMove: ve(e.onPointerMove, E),
          onPointerUp: ve(e.onPointerUp, (C) => {
            const j = C.target;
            j.hasPointerCapture(C.pointerId) && j.releasePointerCapture(C.pointerId), document.body.style.webkitUserSelect = _.current, m.viewport && (m.viewport.style.scrollBehavior = ""), w.current = null;
          })
        }
      )
    }
  );
}), Vi = "ScrollAreaThumb", RAe = g.forwardRef(
  (e, t) => {
    const { forceMount: a, ...o } = e, n = Xw(Vi, e.__scopeScrollArea);
    return /* @__PURE__ */ v(yo, { present: a || n.hasThumb, children: /* @__PURE__ */ v(IAe, { ref: t, ...o }) });
  }
), IAe = g.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: a, style: o, ...n } = e, r = Dt(Vi, a), i = Xw(Vi, a), { onThumbPositionChange: s } = i, l = Ne(
      t,
      (d) => i.onThumbChange(d)
    ), c = g.useRef(void 0), u = Ms(() => {
      c.current && (c.current(), c.current = void 0);
    }, 100);
    return g.useEffect(() => {
      const d = r.viewport;
      if (d) {
        const h = () => {
          if (u(), !c.current) {
            const m = WAe(d, s);
            c.current = m, s();
          }
        };
        return s(), d.addEventListener("scroll", h), () => d.removeEventListener("scroll", h);
      }
    }, [r.viewport, u, s]), /* @__PURE__ */ v(
      ye.div,
      {
        "data-state": i.hasThumb ? "visible" : "hidden",
        ...n,
        ref: l,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...o
        },
        onPointerDownCapture: ve(e.onPointerDownCapture, (d) => {
          const h = d.target.getBoundingClientRect(), m = d.clientX - h.left, f = d.clientY - h.top;
          i.onThumbPointerDown({ x: m, y: f });
        }),
        onPointerUp: ve(e.onPointerUp, i.onThumbPointerUp)
      }
    );
  }
);
RAe.displayName = Vi;
var jd = "ScrollAreaCorner", TAe = g.forwardRef(
  (e, t) => {
    const a = Dt(jd, e.__scopeScrollArea), o = !!(a.scrollbarX && a.scrollbarY);
    return a.type !== "scroll" && o ? /* @__PURE__ */ v(LAe, { ...e, ref: t }) : null;
  }
);
TAe.displayName = jd;
var LAe = g.forwardRef((e, t) => {
  const { __scopeScrollArea: a, ...o } = e, n = Dt(jd, a), [r, i] = g.useState(0), [s, l] = g.useState(0), c = !!(r && s);
  return en(n.scrollbarX, () => {
    const u = n.scrollbarX?.offsetHeight || 0;
    n.onCornerHeightChange(u), l(u);
  }), en(n.scrollbarY, () => {
    const u = n.scrollbarY?.offsetWidth || 0;
    n.onCornerWidthChange(u), i(u);
  }), c ? /* @__PURE__ */ v(
    ye.div,
    {
      ...o,
      ref: t,
      style: {
        width: r,
        height: s,
        position: "absolute",
        right: n.dir === "ltr" ? 0 : void 0,
        left: n.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...e.style
      }
    }
  ) : null;
});
function Ui(e) {
  return e ? parseInt(e, 10) : 0;
}
function ek(e, t) {
  const a = e / t;
  return isNaN(a) ? 0 : a;
}
function Ls(e) {
  const t = ek(e.viewport, e.content), a = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, o = (e.scrollbar.size - a) * t;
  return Math.max(o, 18);
}
function MAe(e, t, a, o = "ltr") {
  const n = Ls(a), r = n / 2, i = t || r, s = n - i, l = a.scrollbar.paddingStart + i, c = a.scrollbar.size - a.scrollbar.paddingEnd - s, u = a.content - a.viewport, d = o === "ltr" ? [0, u] : [u * -1, 0];
  return tk([l, c], d)(e);
}
function im(e, t, a = "ltr") {
  const o = Ls(t), n = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, r = t.scrollbar.size - n, i = t.content - t.viewport, s = r - o, l = a === "ltr" ? [0, i] : [i * -1, 0], c = Vc(e, l);
  return tk([0, i], [0, s])(c);
}
function tk(e, t) {
  return (a) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const o = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + o * (a - e[0]);
  };
}
function ak(e, t) {
  return e > 0 && e < t;
}
var WAe = (e, t = () => {
}) => {
  let a = { left: e.scrollLeft, top: e.scrollTop }, o = 0;
  return function n() {
    const r = { left: e.scrollLeft, top: e.scrollTop }, i = a.left !== r.left, s = a.top !== r.top;
    (i || s) && t(), a = r, o = window.requestAnimationFrame(n);
  }(), () => window.cancelAnimationFrame(o);
};
function Ms(e, t) {
  const a = ut(e), o = g.useRef(0);
  return g.useEffect(() => () => window.clearTimeout(o.current), []), g.useCallback(() => {
    window.clearTimeout(o.current), o.current = window.setTimeout(a, t);
  }, [a, t]);
}
function en(e, t) {
  const a = ut(t);
  ot(() => {
    let o = 0;
    if (e) {
      const n = new ResizeObserver(() => {
        cancelAnimationFrame(o), o = window.requestAnimationFrame(a);
      });
      return n.observe(e), () => {
        window.cancelAnimationFrame(o), n.unobserve(e);
      };
    }
  }, [e, a]);
}
const BAe = ["top", "right", "bottom", "left"], Ra = Math.min, wt = Math.max, qi = Math.round, Vr = Math.floor, Yt = (e) => ({
  x: e,
  y: e
}), FAe = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, VAe = {
  start: "end",
  end: "start"
};
function Uc(e, t, a) {
  return wt(e, Ra(t, a));
}
function fa(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ba(e) {
  return e.split("-")[0];
}
function cn(e) {
  return e.split("-")[1];
}
function Od(e) {
  return e === "x" ? "y" : "x";
}
function zd(e) {
  return e === "y" ? "height" : "width";
}
function ha(e) {
  return ["top", "bottom"].includes(ba(e)) ? "y" : "x";
}
function Ad(e) {
  return Od(ha(e));
}
function UAe(e, t, a) {
  a === void 0 && (a = !1);
  const o = cn(e), n = Ad(e), r = zd(n);
  let i = n === "x" ? o === (a ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[r] > t.floating[r] && (i = Hi(i)), [i, Hi(i)];
}
function qAe(e) {
  const t = Hi(e);
  return [qc(e), t, qc(t)];
}
function qc(e) {
  return e.replace(/start|end/g, (t) => VAe[t]);
}
function HAe(e, t, a) {
  const o = ["left", "right"], n = ["right", "left"], r = ["top", "bottom"], i = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return a ? t ? n : o : t ? o : n;
    case "left":
    case "right":
      return t ? r : i;
    default:
      return [];
  }
}
function GAe(e, t, a, o) {
  const n = cn(e);
  let r = HAe(ba(e), a === "start", o);
  return n && (r = r.map((i) => i + "-" + n), t && (r = r.concat(r.map(qc)))), r;
}
function Hi(e) {
  return e.replace(/left|right|bottom|top/g, (t) => FAe[t]);
}
function KAe(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function ok(e) {
  return typeof e != "number" ? KAe(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Gi(e) {
  const {
    x: t,
    y: a,
    width: o,
    height: n
  } = e;
  return {
    width: o,
    height: n,
    top: a,
    left: t,
    right: t + o,
    bottom: a + n,
    x: t,
    y: a
  };
}
function sm(e, t, a) {
  let {
    reference: o,
    floating: n
  } = e;
  const r = ha(t), i = Ad(t), s = zd(i), l = ba(t), c = r === "y", u = o.x + o.width / 2 - n.width / 2, d = o.y + o.height / 2 - n.height / 2, h = o[s] / 2 - n[s] / 2;
  let m;
  switch (l) {
    case "top":
      m = {
        x: u,
        y: o.y - n.height
      };
      break;
    case "bottom":
      m = {
        x: u,
        y: o.y + o.height
      };
      break;
    case "right":
      m = {
        x: o.x + o.width,
        y: d
      };
      break;
    case "left":
      m = {
        x: o.x - n.width,
        y: d
      };
      break;
    default:
      m = {
        x: o.x,
        y: o.y
      };
  }
  switch (cn(t)) {
    case "start":
      m[i] -= h * (a && c ? -1 : 1);
      break;
    case "end":
      m[i] += h * (a && c ? -1 : 1);
      break;
  }
  return m;
}
const JAe = async (e, t, a) => {
  const {
    placement: o = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: i
  } = a, s = r.filter(Boolean), l = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let c = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: n
  }), {
    x: u,
    y: d
  } = sm(c, o, l), h = o, m = {}, f = 0;
  for (let p = 0; p < s.length; p++) {
    const {
      name: b,
      fn: w
    } = s[p], {
      x: _,
      y,
      data: k,
      reset: x
    } = await w({
      x: u,
      y: d,
      initialPlacement: o,
      placement: h,
      strategy: n,
      middlewareData: m,
      rects: c,
      platform: i,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = _ ?? u, d = y ?? d, m = {
      ...m,
      [b]: {
        ...m[b],
        ...k
      }
    }, x && f <= 50 && (f++, typeof x == "object" && (x.placement && (h = x.placement), x.rects && (c = x.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: n
    }) : x.rects), {
      x: u,
      y: d
    } = sm(c, h, l)), p = -1);
  }
  return {
    x: u,
    y: d,
    placement: h,
    strategy: n,
    middlewareData: m
  };
};
async function Vn(e, t) {
  var a;
  t === void 0 && (t = {});
  const {
    x: o,
    y: n,
    platform: r,
    rects: i,
    elements: s,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: h = !1,
    padding: m = 0
  } = fa(t, e), f = ok(m), p = s[h ? d === "floating" ? "reference" : "floating" : d], b = Gi(await r.getClippingRect({
    element: (a = await (r.isElement == null ? void 0 : r.isElement(p))) == null || a ? p : p.contextElement || await (r.getDocumentElement == null ? void 0 : r.getDocumentElement(s.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), w = d === "floating" ? {
    x: o,
    y: n,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, _ = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(s.floating)), y = await (r.isElement == null ? void 0 : r.isElement(_)) ? await (r.getScale == null ? void 0 : r.getScale(_)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, k = Gi(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: w,
    offsetParent: _,
    strategy: l
  }) : w);
  return {
    top: (b.top - k.top + f.top) / y.y,
    bottom: (k.bottom - b.bottom + f.bottom) / y.y,
    left: (b.left - k.left + f.left) / y.x,
    right: (k.right - b.right + f.right) / y.x
  };
}
const ZAe = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: a,
      y: o,
      placement: n,
      rects: r,
      platform: i,
      elements: s,
      middlewareData: l
    } = t, {
      element: c,
      padding: u = 0
    } = fa(e, t) || {};
    if (c == null)
      return {};
    const d = ok(u), h = {
      x: a,
      y: o
    }, m = Ad(n), f = zd(m), p = await i.getDimensions(c), b = m === "y", w = b ? "top" : "left", _ = b ? "bottom" : "right", y = b ? "clientHeight" : "clientWidth", k = r.reference[f] + r.reference[m] - h[m] - r.floating[f], x = h[m] - r.reference[m], S = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(c));
    let $ = S ? S[y] : 0;
    (!$ || !await (i.isElement == null ? void 0 : i.isElement(S))) && ($ = s.floating[y] || r.floating[f]);
    const E = k / 2 - x / 2, C = $ / 2 - p[f] / 2 - 1, j = Ra(d[w], C), R = Ra(d[_], C), H = j, L = $ - p[f] - R, O = $ / 2 - p[f] / 2 + E, U = Uc(H, O, L), I = !l.arrow && cn(n) != null && O !== U && r.reference[f] / 2 - (O < H ? j : R) - p[f] / 2 < 0, K = I ? O < H ? O - H : O - L : 0;
    return {
      [m]: h[m] + K,
      data: {
        [m]: U,
        centerOffset: O - U - K,
        ...I && {
          alignmentOffset: K
        }
      },
      reset: I
    };
  }
}), YAe = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var a, o;
      const {
        placement: n,
        middlewareData: r,
        rects: i,
        initialPlacement: s,
        platform: l,
        elements: c
      } = t, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: h,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: f = "none",
        flipAlignment: p = !0,
        ...b
      } = fa(e, t);
      if ((a = r.arrow) != null && a.alignmentOffset)
        return {};
      const w = ba(n), _ = ha(s), y = ba(s) === s, k = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), x = h || (y || !p ? [Hi(s)] : qAe(s)), S = f !== "none";
      !h && S && x.push(...GAe(s, p, f, k));
      const $ = [s, ...x], E = await Vn(t, b), C = [];
      let j = ((o = r.flip) == null ? void 0 : o.overflows) || [];
      if (u && C.push(E[w]), d) {
        const U = UAe(n, i, k);
        C.push(E[U[0]], E[U[1]]);
      }
      if (j = [...j, {
        placement: n,
        overflows: C
      }], !C.every((U) => U <= 0)) {
        var R, H;
        const U = (((R = r.flip) == null ? void 0 : R.index) || 0) + 1, I = $[U];
        if (I) {
          var L;
          const q = d === "alignment" ? _ !== ha(I) : !1, te = ((L = j[0]) == null ? void 0 : L.overflows[0]) > 0;
          if (!q || te)
            return {
              data: {
                index: U,
                overflows: j
              },
              reset: {
                placement: I
              }
            };
        }
        let K = (H = j.filter((q) => q.overflows[0] <= 0).sort((q, te) => q.overflows[1] - te.overflows[1])[0]) == null ? void 0 : H.placement;
        if (!K)
          switch (m) {
            case "bestFit": {
              var O;
              const q = (O = j.filter((te) => {
                if (S) {
                  const A = ha(te.placement);
                  return A === _ || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  A === "y";
                }
                return !0;
              }).map((te) => [te.placement, te.overflows.filter((A) => A > 0).reduce((A, z) => A + z, 0)]).sort((te, A) => te[1] - A[1])[0]) == null ? void 0 : O[0];
              q && (K = q);
              break;
            }
            case "initialPlacement":
              K = s;
              break;
          }
        if (n !== K)
          return {
            reset: {
              placement: K
            }
          };
      }
      return {};
    }
  };
};
function lm(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function cm(e) {
  return BAe.some((t) => e[t] >= 0);
}
const XAe = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: a
      } = t, {
        strategy: o = "referenceHidden",
        ...n
      } = fa(e, t);
      switch (o) {
        case "referenceHidden": {
          const r = await Vn(t, {
            ...n,
            elementContext: "reference"
          }), i = lm(r, a.reference);
          return {
            data: {
              referenceHiddenOffsets: i,
              referenceHidden: cm(i)
            }
          };
        }
        case "escaped": {
          const r = await Vn(t, {
            ...n,
            altBoundary: !0
          }), i = lm(r, a.floating);
          return {
            data: {
              escapedOffsets: i,
              escaped: cm(i)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function QAe(e, t) {
  const {
    placement: a,
    platform: o,
    elements: n
  } = e, r = await (o.isRTL == null ? void 0 : o.isRTL(n.floating)), i = ba(a), s = cn(a), l = ha(a) === "y", c = ["left", "top"].includes(i) ? -1 : 1, u = r && l ? -1 : 1, d = fa(t, e);
  let {
    mainAxis: h,
    crossAxis: m,
    alignmentAxis: f
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return s && typeof f == "number" && (m = s === "end" ? f * -1 : f), l ? {
    x: m * u,
    y: h * c
  } : {
    x: h * c,
    y: m * u
  };
}
const ePe = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var a, o;
      const {
        x: n,
        y: r,
        placement: i,
        middlewareData: s
      } = t, l = await QAe(t, e);
      return i === ((a = s.offset) == null ? void 0 : a.placement) && (o = s.arrow) != null && o.alignmentOffset ? {} : {
        x: n + l.x,
        y: r + l.y,
        data: {
          ...l,
          placement: i
        }
      };
    }
  };
}, tPe = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: a,
        y: o,
        placement: n
      } = t, {
        mainAxis: r = !0,
        crossAxis: i = !1,
        limiter: s = {
          fn: (b) => {
            let {
              x: w,
              y: _
            } = b;
            return {
              x: w,
              y: _
            };
          }
        },
        ...l
      } = fa(e, t), c = {
        x: a,
        y: o
      }, u = await Vn(t, l), d = ha(ba(n)), h = Od(d);
      let m = c[h], f = c[d];
      if (r) {
        const b = h === "y" ? "top" : "left", w = h === "y" ? "bottom" : "right", _ = m + u[b], y = m - u[w];
        m = Uc(_, m, y);
      }
      if (i) {
        const b = d === "y" ? "top" : "left", w = d === "y" ? "bottom" : "right", _ = f + u[b], y = f - u[w];
        f = Uc(_, f, y);
      }
      const p = s.fn({
        ...t,
        [h]: m,
        [d]: f
      });
      return {
        ...p,
        data: {
          x: p.x - a,
          y: p.y - o,
          enabled: {
            [h]: r,
            [d]: i
          }
        }
      };
    }
  };
}, aPe = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: a,
        y: o,
        placement: n,
        rects: r,
        middlewareData: i
      } = t, {
        offset: s = 0,
        mainAxis: l = !0,
        crossAxis: c = !0
      } = fa(e, t), u = {
        x: a,
        y: o
      }, d = ha(n), h = Od(d);
      let m = u[h], f = u[d];
      const p = fa(s, t), b = typeof p == "number" ? {
        mainAxis: p,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...p
      };
      if (l) {
        const y = h === "y" ? "height" : "width", k = r.reference[h] - r.floating[y] + b.mainAxis, x = r.reference[h] + r.reference[y] - b.mainAxis;
        m < k ? m = k : m > x && (m = x);
      }
      if (c) {
        var w, _;
        const y = h === "y" ? "width" : "height", k = ["top", "left"].includes(ba(n)), x = r.reference[d] - r.floating[y] + (k && ((w = i.offset) == null ? void 0 : w[d]) || 0) + (k ? 0 : b.crossAxis), S = r.reference[d] + r.reference[y] + (k ? 0 : ((_ = i.offset) == null ? void 0 : _[d]) || 0) - (k ? b.crossAxis : 0);
        f < x ? f = x : f > S && (f = S);
      }
      return {
        [h]: m,
        [d]: f
      };
    }
  };
}, oPe = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var a, o;
      const {
        placement: n,
        rects: r,
        platform: i,
        elements: s
      } = t, {
        apply: l = () => {
        },
        ...c
      } = fa(e, t), u = await Vn(t, c), d = ba(n), h = cn(n), m = ha(n) === "y", {
        width: f,
        height: p
      } = r.floating;
      let b, w;
      d === "top" || d === "bottom" ? (b = d, w = h === (await (i.isRTL == null ? void 0 : i.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (w = d, b = h === "end" ? "top" : "bottom");
      const _ = p - u.top - u.bottom, y = f - u.left - u.right, k = Ra(p - u[b], _), x = Ra(f - u[w], y), S = !t.middlewareData.shift;
      let $ = k, E = x;
      if ((a = t.middlewareData.shift) != null && a.enabled.x && (E = y), (o = t.middlewareData.shift) != null && o.enabled.y && ($ = _), S && !h) {
        const j = wt(u.left, 0), R = wt(u.right, 0), H = wt(u.top, 0), L = wt(u.bottom, 0);
        m ? E = f - 2 * (j !== 0 || R !== 0 ? j + R : wt(u.left, u.right)) : $ = p - 2 * (H !== 0 || L !== 0 ? H + L : wt(u.top, u.bottom));
      }
      await l({
        ...t,
        availableWidth: E,
        availableHeight: $
      });
      const C = await i.getDimensions(s.floating);
      return f !== C.width || p !== C.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Ws() {
  return typeof window < "u";
}
function un(e) {
  return nk(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function kt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function na(e) {
  var t;
  return (t = (nk(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function nk(e) {
  return Ws() ? e instanceof Node || e instanceof kt(e).Node : !1;
}
function Tt(e) {
  return Ws() ? e instanceof Element || e instanceof kt(e).Element : !1;
}
function Xt(e) {
  return Ws() ? e instanceof HTMLElement || e instanceof kt(e).HTMLElement : !1;
}
function um(e) {
  return !Ws() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof kt(e).ShadowRoot;
}
function ur(e) {
  const {
    overflow: t,
    overflowX: a,
    overflowY: o,
    display: n
  } = Lt(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + a) && !["inline", "contents"].includes(n);
}
function nPe(e) {
  return ["table", "td", "th"].includes(un(e));
}
function Bs(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function Pd(e) {
  const t = Dd(), a = Tt(e) ? Lt(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((o) => a[o] ? a[o] !== "none" : !1) || (a.containerType ? a.containerType !== "normal" : !1) || !t && (a.backdropFilter ? a.backdropFilter !== "none" : !1) || !t && (a.filter ? a.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((o) => (a.willChange || "").includes(o)) || ["paint", "layout", "strict", "content"].some((o) => (a.contain || "").includes(o));
}
function rPe(e) {
  let t = Ia(e);
  for (; Xt(t) && !tn(t); ) {
    if (Pd(t))
      return t;
    if (Bs(t))
      return null;
    t = Ia(t);
  }
  return null;
}
function Dd() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function tn(e) {
  return ["html", "body", "#document"].includes(un(e));
}
function Lt(e) {
  return kt(e).getComputedStyle(e);
}
function Fs(e) {
  return Tt(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Ia(e) {
  if (un(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    um(e) && e.host || // Fallback.
    na(e)
  );
  return um(t) ? t.host : t;
}
function rk(e) {
  const t = Ia(e);
  return tn(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Xt(t) && ur(t) ? t : rk(t);
}
function Un(e, t, a) {
  var o;
  t === void 0 && (t = []), a === void 0 && (a = !0);
  const n = rk(e), r = n === ((o = e.ownerDocument) == null ? void 0 : o.body), i = kt(n);
  if (r) {
    const s = Hc(i);
    return t.concat(i, i.visualViewport || [], ur(n) ? n : [], s && a ? Un(s) : []);
  }
  return t.concat(n, Un(n, [], a));
}
function Hc(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function ik(e) {
  const t = Lt(e);
  let a = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const n = Xt(e), r = n ? e.offsetWidth : a, i = n ? e.offsetHeight : o, s = qi(a) !== r || qi(o) !== i;
  return s && (a = r, o = i), {
    width: a,
    height: o,
    $: s
  };
}
function Nd(e) {
  return Tt(e) ? e : e.contextElement;
}
function Uo(e) {
  const t = Nd(e);
  if (!Xt(t))
    return Yt(1);
  const a = t.getBoundingClientRect(), {
    width: o,
    height: n,
    $: r
  } = ik(t);
  let i = (r ? qi(a.width) : a.width) / o, s = (r ? qi(a.height) : a.height) / n;
  return (!i || !Number.isFinite(i)) && (i = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: i,
    y: s
  };
}
const iPe = /* @__PURE__ */ Yt(0);
function sk(e) {
  const t = kt(e);
  return !Dd() || !t.visualViewport ? iPe : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function sPe(e, t, a) {
  return t === void 0 && (t = !1), !a || t && a !== kt(e) ? !1 : t;
}
function lo(e, t, a, o) {
  t === void 0 && (t = !1), a === void 0 && (a = !1);
  const n = e.getBoundingClientRect(), r = Nd(e);
  let i = Yt(1);
  t && (o ? Tt(o) && (i = Uo(o)) : i = Uo(e));
  const s = sPe(r, a, o) ? sk(r) : Yt(0);
  let l = (n.left + s.x) / i.x, c = (n.top + s.y) / i.y, u = n.width / i.x, d = n.height / i.y;
  if (r) {
    const h = kt(r), m = o && Tt(o) ? kt(o) : o;
    let f = h, p = Hc(f);
    for (; p && o && m !== f; ) {
      const b = Uo(p), w = p.getBoundingClientRect(), _ = Lt(p), y = w.left + (p.clientLeft + parseFloat(_.paddingLeft)) * b.x, k = w.top + (p.clientTop + parseFloat(_.paddingTop)) * b.y;
      l *= b.x, c *= b.y, u *= b.x, d *= b.y, l += y, c += k, f = kt(p), p = Hc(f);
    }
  }
  return Gi({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
function Rd(e, t) {
  const a = Fs(e).scrollLeft;
  return t ? t.left + a : lo(na(e)).left + a;
}
function lk(e, t, a) {
  a === void 0 && (a = !1);
  const o = e.getBoundingClientRect(), n = o.left + t.scrollLeft - (a ? 0 : (
    // RTL <body> scrollbar.
    Rd(e, o)
  )), r = o.top + t.scrollTop;
  return {
    x: n,
    y: r
  };
}
function lPe(e) {
  let {
    elements: t,
    rect: a,
    offsetParent: o,
    strategy: n
  } = e;
  const r = n === "fixed", i = na(o), s = t ? Bs(t.floating) : !1;
  if (o === i || s && r)
    return a;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = Yt(1);
  const u = Yt(0), d = Xt(o);
  if ((d || !d && !r) && ((un(o) !== "body" || ur(i)) && (l = Fs(o)), Xt(o))) {
    const m = lo(o);
    c = Uo(o), u.x = m.x + o.clientLeft, u.y = m.y + o.clientTop;
  }
  const h = i && !d && !r ? lk(i, l, !0) : Yt(0);
  return {
    width: a.width * c.x,
    height: a.height * c.y,
    x: a.x * c.x - l.scrollLeft * c.x + u.x + h.x,
    y: a.y * c.y - l.scrollTop * c.y + u.y + h.y
  };
}
function cPe(e) {
  return Array.from(e.getClientRects());
}
function uPe(e) {
  const t = na(e), a = Fs(e), o = e.ownerDocument.body, n = wt(t.scrollWidth, t.clientWidth, o.scrollWidth, o.clientWidth), r = wt(t.scrollHeight, t.clientHeight, o.scrollHeight, o.clientHeight);
  let i = -a.scrollLeft + Rd(e);
  const s = -a.scrollTop;
  return Lt(o).direction === "rtl" && (i += wt(t.clientWidth, o.clientWidth) - n), {
    width: n,
    height: r,
    x: i,
    y: s
  };
}
function dPe(e, t) {
  const a = kt(e), o = na(e), n = a.visualViewport;
  let r = o.clientWidth, i = o.clientHeight, s = 0, l = 0;
  if (n) {
    r = n.width, i = n.height;
    const c = Dd();
    (!c || c && t === "fixed") && (s = n.offsetLeft, l = n.offsetTop);
  }
  return {
    width: r,
    height: i,
    x: s,
    y: l
  };
}
function gPe(e, t) {
  const a = lo(e, !0, t === "fixed"), o = a.top + e.clientTop, n = a.left + e.clientLeft, r = Xt(e) ? Uo(e) : Yt(1), i = e.clientWidth * r.x, s = e.clientHeight * r.y, l = n * r.x, c = o * r.y;
  return {
    width: i,
    height: s,
    x: l,
    y: c
  };
}
function dm(e, t, a) {
  let o;
  if (t === "viewport")
    o = dPe(e, a);
  else if (t === "document")
    o = uPe(na(e));
  else if (Tt(t))
    o = gPe(t, a);
  else {
    const n = sk(e);
    o = {
      x: t.x - n.x,
      y: t.y - n.y,
      width: t.width,
      height: t.height
    };
  }
  return Gi(o);
}
function ck(e, t) {
  const a = Ia(e);
  return a === t || !Tt(a) || tn(a) ? !1 : Lt(a).position === "fixed" || ck(a, t);
}
function hPe(e, t) {
  const a = t.get(e);
  if (a)
    return a;
  let o = Un(e, [], !1).filter((s) => Tt(s) && un(s) !== "body"), n = null;
  const r = Lt(e).position === "fixed";
  let i = r ? Ia(e) : e;
  for (; Tt(i) && !tn(i); ) {
    const s = Lt(i), l = Pd(i);
    !l && s.position === "fixed" && (n = null), (r ? !l && !n : !l && s.position === "static" && n && ["absolute", "fixed"].includes(n.position) || ur(i) && !l && ck(e, i)) ? o = o.filter((c) => c !== i) : n = s, i = Ia(i);
  }
  return t.set(e, o), o;
}
function pPe(e) {
  let {
    element: t,
    boundary: a,
    rootBoundary: o,
    strategy: n
  } = e;
  const r = [...a === "clippingAncestors" ? Bs(t) ? [] : hPe(t, this._c) : [].concat(a), o], i = r[0], s = r.reduce((l, c) => {
    const u = dm(t, c, n);
    return l.top = wt(u.top, l.top), l.right = Ra(u.right, l.right), l.bottom = Ra(u.bottom, l.bottom), l.left = wt(u.left, l.left), l;
  }, dm(t, i, n));
  return {
    width: s.right - s.left,
    height: s.bottom - s.top,
    x: s.left,
    y: s.top
  };
}
function mPe(e) {
  const {
    width: t,
    height: a
  } = ik(e);
  return {
    width: t,
    height: a
  };
}
function fPe(e, t, a) {
  const o = Xt(t), n = na(t), r = a === "fixed", i = lo(e, !0, r, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Yt(0);
  function c() {
    l.x = Rd(n);
  }
  if (o || !o && !r)
    if ((un(t) !== "body" || ur(n)) && (s = Fs(t)), o) {
      const m = lo(t, !0, r, t);
      l.x = m.x + t.clientLeft, l.y = m.y + t.clientTop;
    } else n && c();
  r && !o && n && c();
  const u = n && !o && !r ? lk(n, s) : Yt(0), d = i.left + s.scrollLeft - l.x - u.x, h = i.top + s.scrollTop - l.y - u.y;
  return {
    x: d,
    y: h,
    width: i.width,
    height: i.height
  };
}
function ql(e) {
  return Lt(e).position === "static";
}
function gm(e, t) {
  if (!Xt(e) || Lt(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let a = e.offsetParent;
  return na(e) === a && (a = a.ownerDocument.body), a;
}
function uk(e, t) {
  const a = kt(e);
  if (Bs(e))
    return a;
  if (!Xt(e)) {
    let n = Ia(e);
    for (; n && !tn(n); ) {
      if (Tt(n) && !ql(n))
        return n;
      n = Ia(n);
    }
    return a;
  }
  let o = gm(e, t);
  for (; o && nPe(o) && ql(o); )
    o = gm(o, t);
  return o && tn(o) && ql(o) && !Pd(o) ? a : o || rPe(e) || a;
}
const bPe = async function(e) {
  const t = this.getOffsetParent || uk, a = this.getDimensions, o = await a(e.floating);
  return {
    reference: fPe(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function _Pe(e) {
  return Lt(e).direction === "rtl";
}
const vPe = {
  convertOffsetParentRelativeRectToViewportRelativeRect: lPe,
  getDocumentElement: na,
  getClippingRect: pPe,
  getOffsetParent: uk,
  getElementRects: bPe,
  getClientRects: cPe,
  getDimensions: mPe,
  getScale: Uo,
  isElement: Tt,
  isRTL: _Pe
};
function dk(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function yPe(e, t) {
  let a = null, o;
  const n = na(e);
  function r() {
    var s;
    clearTimeout(o), (s = a) == null || s.disconnect(), a = null;
  }
  function i(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), r();
    const c = e.getBoundingClientRect(), {
      left: u,
      top: d,
      width: h,
      height: m
    } = c;
    if (s || t(), !h || !m)
      return;
    const f = Vr(d), p = Vr(n.clientWidth - (u + h)), b = Vr(n.clientHeight - (d + m)), w = Vr(u), _ = {
      rootMargin: -f + "px " + -p + "px " + -b + "px " + -w + "px",
      threshold: wt(0, Ra(1, l)) || 1
    };
    let y = !0;
    function k(x) {
      const S = x[0].intersectionRatio;
      if (S !== l) {
        if (!y)
          return i();
        S ? i(!1, S) : o = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      S === 1 && !dk(c, e.getBoundingClientRect()) && i(), y = !1;
    }
    try {
      a = new IntersectionObserver(k, {
        ..._,
        // Handle <iframe>s
        root: n.ownerDocument
      });
    } catch {
      a = new IntersectionObserver(k, _);
    }
    a.observe(e);
  }
  return i(!0), r;
}
function wPe(e, t, a, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: n = !0,
    ancestorResize: r = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = o, c = Nd(e), u = n || r ? [...c ? Un(c) : [], ...Un(t)] : [];
  u.forEach((w) => {
    n && w.addEventListener("scroll", a, {
      passive: !0
    }), r && w.addEventListener("resize", a);
  });
  const d = c && s ? yPe(c, a) : null;
  let h = -1, m = null;
  i && (m = new ResizeObserver((w) => {
    let [_] = w;
    _ && _.target === c && m && (m.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var y;
      (y = m) == null || y.observe(t);
    })), a();
  }), c && !l && m.observe(c), m.observe(t));
  let f, p = l ? lo(e) : null;
  l && b();
  function b() {
    const w = lo(e);
    p && !dk(p, w) && a(), p = w, f = requestAnimationFrame(b);
  }
  return a(), () => {
    var w;
    u.forEach((_) => {
      n && _.removeEventListener("scroll", a), r && _.removeEventListener("resize", a);
    }), d?.(), (w = m) == null || w.disconnect(), m = null, l && cancelAnimationFrame(f);
  };
}
const kPe = ePe, xPe = tPe, $Pe = YAe, SPe = oPe, CPe = XAe, hm = ZAe, EPe = aPe, jPe = (e, t, a) => {
  const o = /* @__PURE__ */ new Map(), n = {
    platform: vPe,
    ...a
  }, r = {
    ...n.platform,
    _c: o
  };
  return JAe(e, t, {
    ...n,
    platform: r
  });
};
var mi = typeof document < "u" ? Km : Ce;
function Ki(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let a, o, n;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (a = e.length, a !== t.length) return !1;
      for (o = a; o-- !== 0; )
        if (!Ki(e[o], t[o]))
          return !1;
      return !0;
    }
    if (n = Object.keys(e), a = n.length, a !== Object.keys(t).length)
      return !1;
    for (o = a; o-- !== 0; )
      if (!{}.hasOwnProperty.call(t, n[o]))
        return !1;
    for (o = a; o-- !== 0; ) {
      const r = n[o];
      if (!(r === "_owner" && e.$$typeof) && !Ki(e[r], t[r]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function gk(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function pm(e, t) {
  const a = gk(e);
  return Math.round(t * a) / a;
}
function Hl(e) {
  const t = g.useRef(e);
  return mi(() => {
    t.current = e;
  }), t;
}
function OPe(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: a = "absolute",
    middleware: o = [],
    platform: n,
    elements: {
      reference: r,
      floating: i
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: c
  } = e, [u, d] = g.useState({
    x: 0,
    y: 0,
    strategy: a,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [h, m] = g.useState(o);
  Ki(h, o) || m(o);
  const [f, p] = g.useState(null), [b, w] = g.useState(null), _ = g.useCallback((q) => {
    q !== S.current && (S.current = q, p(q));
  }, []), y = g.useCallback((q) => {
    q !== $.current && ($.current = q, w(q));
  }, []), k = r || f, x = i || b, S = g.useRef(null), $ = g.useRef(null), E = g.useRef(u), C = l != null, j = Hl(l), R = Hl(n), H = Hl(c), L = g.useCallback(() => {
    if (!S.current || !$.current)
      return;
    const q = {
      placement: t,
      strategy: a,
      middleware: h
    };
    R.current && (q.platform = R.current), jPe(S.current, $.current, q).then((te) => {
      const A = {
        ...te,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: H.current !== !1
      };
      O.current && !Ki(E.current, A) && (E.current = A, po.flushSync(() => {
        d(A);
      }));
    });
  }, [h, t, a, R, H]);
  mi(() => {
    c === !1 && E.current.isPositioned && (E.current.isPositioned = !1, d((q) => ({
      ...q,
      isPositioned: !1
    })));
  }, [c]);
  const O = g.useRef(!1);
  mi(() => (O.current = !0, () => {
    O.current = !1;
  }), []), mi(() => {
    if (k && (S.current = k), x && ($.current = x), k && x) {
      if (j.current)
        return j.current(k, x, L);
      L();
    }
  }, [k, x, L, j, C]);
  const U = g.useMemo(() => ({
    reference: S,
    floating: $,
    setReference: _,
    setFloating: y
  }), [_, y]), I = g.useMemo(() => ({
    reference: k,
    floating: x
  }), [k, x]), K = g.useMemo(() => {
    const q = {
      position: a,
      left: 0,
      top: 0
    };
    if (!I.floating)
      return q;
    const te = pm(I.floating, u.x), A = pm(I.floating, u.y);
    return s ? {
      ...q,
      transform: "translate(" + te + "px, " + A + "px)",
      ...gk(I.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: a,
      left: te,
      top: A
    };
  }, [a, s, I.floating, u.x, u.y]);
  return g.useMemo(() => ({
    ...u,
    update: L,
    refs: U,
    elements: I,
    floatingStyles: K
  }), [u, L, U, I, K]);
}
const zPe = (e) => {
  function t(a) {
    return {}.hasOwnProperty.call(a, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(a) {
      const {
        element: o,
        padding: n
      } = typeof e == "function" ? e(a) : e;
      return o && t(o) ? o.current != null ? hm({
        element: o.current,
        padding: n
      }).fn(a) : {} : o ? hm({
        element: o,
        padding: n
      }).fn(a) : {};
    }
  };
}, APe = (e, t) => ({
  ...kPe(e),
  options: [e, t]
}), PPe = (e, t) => ({
  ...xPe(e),
  options: [e, t]
}), DPe = (e, t) => ({
  ...EPe(e),
  options: [e, t]
}), NPe = (e, t) => ({
  ...$Pe(e),
  options: [e, t]
}), RPe = (e, t) => ({
  ...SPe(e),
  options: [e, t]
}), IPe = (e, t) => ({
  ...CPe(e),
  options: [e, t]
}), TPe = (e, t) => ({
  ...zPe(e),
  options: [e, t]
});
var LPe = "Arrow", hk = g.forwardRef((e, t) => {
  const { children: a, width: o = 10, height: n = 5, ...r } = e;
  return /* @__PURE__ */ v(
    ye.svg,
    {
      ...r,
      ref: t,
      width: o,
      height: n,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? a : /* @__PURE__ */ v("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
hk.displayName = LPe;
var MPe = hk, pk = "Popper", [mk, fk] = cr(pk), [vit, bk] = mk(pk), _k = "PopperAnchor", vk = g.forwardRef(
  (e, t) => {
    const { __scopePopper: a, virtualRef: o, ...n } = e, r = bk(_k, a), i = g.useRef(null), s = Ne(t, i), l = g.useRef(null);
    return g.useEffect(() => {
      const c = l.current;
      l.current = o?.current || i.current, c !== l.current && r.onAnchorChange(l.current);
    }), o ? null : /* @__PURE__ */ v(ye.div, { ...n, ref: s });
  }
);
vk.displayName = _k;
var Id = "PopperContent", [WPe, BPe] = mk(Id), yk = g.forwardRef(
  (e, t) => {
    const {
      __scopePopper: a,
      side: o = "bottom",
      sideOffset: n = 0,
      align: r = "center",
      alignOffset: i = 0,
      arrowPadding: s = 0,
      avoidCollisions: l = !0,
      collisionBoundary: c = [],
      collisionPadding: u = 0,
      sticky: d = "partial",
      hideWhenDetached: h = !1,
      updatePositionStrategy: m = "optimized",
      onPlaced: f,
      ...p
    } = e, b = bk(Id, a), [w, _] = g.useState(null), y = Ne(t, (M) => _(M)), [k, x] = g.useState(null), S = iOe(k), $ = S?.width ?? 0, E = S?.height ?? 0, C = o + (r !== "center" ? "-" + r : ""), j = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, R = Array.isArray(c) ? c : [c], H = R.length > 0, L = {
      padding: j,
      boundary: R.filter(VPe),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: H
    }, { refs: O, floatingStyles: U, placement: I, isPositioned: K, middlewareData: q } = OPe({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: C,
      whileElementsMounted: (...M) => wPe(...M, {
        animationFrame: m === "always"
      }),
      elements: {
        reference: b.anchor
      },
      middleware: [
        APe({ mainAxis: n + E, alignmentAxis: i }),
        l && PPe({
          mainAxis: !0,
          crossAxis: !1,
          limiter: d === "partial" ? DPe() : void 0,
          ...L
        }),
        l && NPe({ ...L }),
        RPe({
          ...L,
          apply: ({ elements: M, rects: Y, availableWidth: Q, availableHeight: J }) => {
            const { width: ae, height: V } = Y.reference, fe = M.floating.style;
            fe.setProperty("--radix-popper-available-width", `${Q}px`), fe.setProperty("--radix-popper-available-height", `${J}px`), fe.setProperty("--radix-popper-anchor-width", `${ae}px`), fe.setProperty("--radix-popper-anchor-height", `${V}px`);
          }
        }),
        k && TPe({ element: k, padding: s }),
        UPe({ arrowWidth: $, arrowHeight: E }),
        h && IPe({ strategy: "referenceHidden", ...L })
      ]
    }), [te, A] = xk(I), z = ut(f);
    ot(() => {
      K && z?.();
    }, [K, z]);
    const N = q.arrow?.x, B = q.arrow?.y, W = q.arrow?.centerOffset !== 0, [Z, ee] = g.useState();
    return ot(() => {
      w && ee(window.getComputedStyle(w).zIndex);
    }, [w]), /* @__PURE__ */ v(
      "div",
      {
        ref: O.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...U,
          transform: K ? U.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: Z,
          "--radix-popper-transform-origin": [
            q.transformOrigin?.x,
            q.transformOrigin?.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...q.hide?.referenceHidden && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ v(
          WPe,
          {
            scope: a,
            placedSide: te,
            onArrowChange: x,
            arrowX: N,
            arrowY: B,
            shouldHideArrow: W,
            children: /* @__PURE__ */ v(
              ye.div,
              {
                "data-side": te,
                "data-align": A,
                ...p,
                ref: y,
                style: {
                  ...p.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: K ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
yk.displayName = Id;
var wk = "PopperArrow", FPe = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, kk = g.forwardRef(function(e, t) {
  const { __scopePopper: a, ...o } = e, n = BPe(wk, a), r = FPe[n.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ v(
      "span",
      {
        ref: n.onArrowChange,
        style: {
          position: "absolute",
          left: n.arrowX,
          top: n.arrowY,
          [r]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[n.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[n.placedSide],
          visibility: n.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ v(
          MPe,
          {
            ...o,
            ref: t,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
kk.displayName = wk;
function VPe(e) {
  return e !== null;
}
var UPe = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    const { placement: a, rects: o, middlewareData: n } = t, r = n.arrow?.centerOffset !== 0, i = r ? 0 : e.arrowWidth, s = r ? 0 : e.arrowHeight, [l, c] = xk(a), u = { start: "0%", center: "50%", end: "100%" }[c], d = (n.arrow?.x ?? 0) + i / 2, h = (n.arrow?.y ?? 0) + s / 2;
    let m = "", f = "";
    return l === "bottom" ? (m = r ? u : `${d}px`, f = `${-s}px`) : l === "top" ? (m = r ? u : `${d}px`, f = `${o.floating.height + s}px`) : l === "right" ? (m = `${-s}px`, f = r ? u : `${h}px`) : l === "left" && (m = `${o.floating.width + s}px`, f = r ? u : `${h}px`), { data: { x: m, y: f } };
  }
});
function xk(e) {
  const [t, a = "center"] = e.split("-");
  return [t, a];
}
var qPe = vk, HPe = yk, GPe = kk, $k = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), KPe = "VisuallyHidden", JPe = g.forwardRef(
  (e, t) => /* @__PURE__ */ v(
    ye.span,
    {
      ...e,
      ref: t,
      style: { ...$k, ...e.style }
    }
  )
);
JPe.displayName = KPe;
var ZPe = [" ", "Enter", "ArrowUp", "ArrowDown"], YPe = [" ", "Enter"], Vs = "Select", [Td, Us, XPe] = eOe(Vs), [dn, yit] = cr(Vs, [
  XPe,
  fk
]), Ld = fk(), [wit, Ta] = dn(Vs), [kit, QPe] = dn(Vs), Sk = "SelectTrigger", eDe = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: a, disabled: o = !1, ...n } = e, r = Ld(a), i = Ta(Sk, a), s = i.disabled || o, l = Ne(t, i.onTriggerChange), c = Us(a), u = g.useRef("touch"), [d, h, m] = Ik((p) => {
      const b = c().filter((y) => !y.disabled), w = b.find((y) => y.value === i.value), _ = Tk(b, p, w);
      _ !== void 0 && i.onValueChange(_.value);
    }), f = (p) => {
      s || (i.onOpenChange(!0), m()), p && (i.triggerPointerDownPosRef.current = {
        x: Math.round(p.pageX),
        y: Math.round(p.pageY)
      });
    };
    return /* @__PURE__ */ v(qPe, { asChild: !0, ...r, children: /* @__PURE__ */ v(
      ye.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": i.contentId,
        "aria-expanded": i.open,
        "aria-required": i.required,
        "aria-autocomplete": "none",
        dir: i.dir,
        "data-state": i.open ? "open" : "closed",
        disabled: s,
        "data-disabled": s ? "" : void 0,
        "data-placeholder": Rk(i.value) ? "" : void 0,
        ...n,
        ref: l,
        onClick: ve(n.onClick, (p) => {
          p.currentTarget.focus(), u.current !== "mouse" && f(p);
        }),
        onPointerDown: ve(n.onPointerDown, (p) => {
          u.current = p.pointerType;
          const b = p.target;
          b.hasPointerCapture(p.pointerId) && b.releasePointerCapture(p.pointerId), p.button === 0 && p.ctrlKey === !1 && p.pointerType === "mouse" && (f(p), p.preventDefault());
        }),
        onKeyDown: ve(n.onKeyDown, (p) => {
          const b = d.current !== "";
          !(p.ctrlKey || p.altKey || p.metaKey) && p.key.length === 1 && h(p.key), !(b && p.key === " ") && ZPe.includes(p.key) && (f(), p.preventDefault());
        })
      }
    ) });
  }
);
eDe.displayName = Sk;
var Ck = "SelectValue", tDe = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: a, className: o, style: n, children: r, placeholder: i = "", ...s } = e, l = Ta(Ck, a), { onValueNodeHasChildrenChange: c } = l, u = r !== void 0, d = Ne(t, l.onValueNodeChange);
    return ot(() => {
      c(u);
    }, [c, u]), /* @__PURE__ */ v(
      ye.span,
      {
        ...s,
        ref: d,
        style: { pointerEvents: "none" },
        children: Rk(l.value) ? /* @__PURE__ */ v(De, { children: i }) : r
      }
    );
  }
);
tDe.displayName = Ck;
var aDe = "SelectIcon", oDe = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: a, children: o, ...n } = e;
    return /* @__PURE__ */ v(ye.span, { "aria-hidden": !0, ...n, ref: t, children: o || "▼" });
  }
);
oDe.displayName = aDe;
var co = "SelectContent", nDe = g.forwardRef(
  (e, t) => {
    const a = Ta(co, e.__scopeSelect), [o, n] = g.useState();
    if (ot(() => {
      n(new DocumentFragment());
    }, []), !a.open) {
      const r = o;
      return r ? po.createPortal(
        /* @__PURE__ */ v(Ek, { scope: e.__scopeSelect, children: /* @__PURE__ */ v(Td.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ v("div", { children: e.children }) }) }),
        r
      ) : null;
    }
    return /* @__PURE__ */ v(jk, { ...e, ref: t });
  }
);
nDe.displayName = co;
var Rt = 10, [Ek, La] = dn(co), rDe = "SelectContentImpl", iDe = /* @__PURE__ */ Fn("SelectContent.RemoveScroll"), jk = g.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: a,
      position: o = "item-aligned",
      onCloseAutoFocus: n,
      onEscapeKeyDown: r,
      onPointerDownOutside: i,
      //
      // PopperContent props
      side: s,
      sideOffset: l,
      align: c,
      alignOffset: u,
      arrowPadding: d,
      collisionBoundary: h,
      collisionPadding: m,
      sticky: f,
      hideWhenDetached: p,
      avoidCollisions: b,
      //
      ...w
    } = e, _ = Ta(co, a), [y, k] = g.useState(null), [x, S] = g.useState(null), $ = Ne(t, (M) => k(M)), [E, C] = g.useState(null), [j, R] = g.useState(
      null
    ), H = Us(a), [L, O] = g.useState(!1), U = g.useRef(!1);
    g.useEffect(() => {
      if (y) return Mw(y);
    }, [y]), Aw();
    const I = g.useCallback(
      (M) => {
        const [Y, ...Q] = H().map((V) => V.ref.current), [J] = Q.slice(-1), ae = document.activeElement;
        for (const V of M)
          if (V === ae || (V?.scrollIntoView({ block: "nearest" }), V === Y && x && (x.scrollTop = 0), V === J && x && (x.scrollTop = x.scrollHeight), V?.focus(), document.activeElement !== ae)) return;
      },
      [H, x]
    ), K = g.useCallback(
      () => I([E, y]),
      [I, E, y]
    );
    g.useEffect(() => {
      L && K();
    }, [L, K]);
    const { onOpenChange: q, triggerPointerDownPosRef: te } = _;
    g.useEffect(() => {
      if (y) {
        let M = { x: 0, y: 0 };
        const Y = (J) => {
          M = {
            x: Math.abs(Math.round(J.pageX) - (te.current?.x ?? 0)),
            y: Math.abs(Math.round(J.pageY) - (te.current?.y ?? 0))
          };
        }, Q = (J) => {
          M.x <= 10 && M.y <= 10 ? J.preventDefault() : y.contains(J.target) || q(!1), document.removeEventListener("pointermove", Y), te.current = null;
        };
        return te.current !== null && (document.addEventListener("pointermove", Y), document.addEventListener("pointerup", Q, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", Y), document.removeEventListener("pointerup", Q, { capture: !0 });
        };
      }
    }, [y, q, te]), g.useEffect(() => {
      const M = () => q(!1);
      return window.addEventListener("blur", M), window.addEventListener("resize", M), () => {
        window.removeEventListener("blur", M), window.removeEventListener("resize", M);
      };
    }, [q]);
    const [A, z] = Ik((M) => {
      const Y = H().filter((ae) => !ae.disabled), Q = Y.find((ae) => ae.ref.current === document.activeElement), J = Tk(Y, M, Q);
      J && setTimeout(() => J.ref.current.focus());
    }), N = g.useCallback(
      (M, Y, Q) => {
        const J = !U.current && !Q;
        (_.value !== void 0 && _.value === Y || J) && (C(M), J && (U.current = !0));
      },
      [_.value]
    ), B = g.useCallback(() => y?.focus(), [y]), W = g.useCallback(
      (M, Y, Q) => {
        const J = !U.current && !Q;
        (_.value !== void 0 && _.value === Y || J) && R(M);
      },
      [_.value]
    ), Z = o === "popper" ? Gc : Ok, ee = Z === Gc ? {
      side: s,
      sideOffset: l,
      align: c,
      alignOffset: u,
      arrowPadding: d,
      collisionBoundary: h,
      collisionPadding: m,
      sticky: f,
      hideWhenDetached: p,
      avoidCollisions: b
    } : {};
    return /* @__PURE__ */ v(
      Ek,
      {
        scope: a,
        content: y,
        viewport: x,
        onViewportChange: S,
        itemRefCallback: N,
        selectedItem: E,
        onItemLeave: B,
        itemTextRefCallback: W,
        focusSelectedItem: K,
        selectedItemText: j,
        position: o,
        isPositioned: L,
        searchRef: A,
        children: /* @__PURE__ */ v(xd, { as: iDe, allowPinchZoom: !0, children: /* @__PURE__ */ v(
          kd,
          {
            asChild: !0,
            trapped: _.open,
            onMountAutoFocus: (M) => {
              M.preventDefault();
            },
            onUnmountAutoFocus: ve(n, (M) => {
              _.trigger?.focus({ preventScroll: !0 }), M.preventDefault();
            }),
            children: /* @__PURE__ */ v(
              wd,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: r,
                onPointerDownOutside: i,
                onFocusOutside: (M) => M.preventDefault(),
                onDismiss: () => _.onOpenChange(!1),
                children: /* @__PURE__ */ v(
                  Z,
                  {
                    role: "listbox",
                    id: _.contentId,
                    "data-state": _.open ? "open" : "closed",
                    dir: _.dir,
                    onContextMenu: (M) => M.preventDefault(),
                    ...w,
                    ...ee,
                    onPlaced: () => O(!0),
                    ref: $,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...w.style
                    },
                    onKeyDown: ve(w.onKeyDown, (M) => {
                      const Y = M.ctrlKey || M.altKey || M.metaKey;
                      if (M.key === "Tab" && M.preventDefault(), !Y && M.key.length === 1 && z(M.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(M.key)) {
                        let Q = H().filter((J) => !J.disabled).map((J) => J.ref.current);
                        if (["ArrowUp", "End"].includes(M.key) && (Q = Q.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(M.key)) {
                          const J = M.target, ae = Q.indexOf(J);
                          Q = Q.slice(ae + 1);
                        }
                        setTimeout(() => I(Q)), M.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
jk.displayName = rDe;
var sDe = "SelectItemAlignedPosition", Ok = g.forwardRef((e, t) => {
  const { __scopeSelect: a, onPlaced: o, ...n } = e, r = Ta(co, a), i = La(co, a), [s, l] = g.useState(null), [c, u] = g.useState(null), d = Ne(t, ($) => u($)), h = Us(a), m = g.useRef(!1), f = g.useRef(!0), { viewport: p, selectedItem: b, selectedItemText: w, focusSelectedItem: _ } = i, y = g.useCallback(() => {
    if (r.trigger && r.valueNode && s && c && p && b && w) {
      const $ = r.trigger.getBoundingClientRect(), E = c.getBoundingClientRect(), C = r.valueNode.getBoundingClientRect(), j = w.getBoundingClientRect();
      if (r.dir !== "rtl") {
        const J = j.left - E.left, ae = C.left - J, V = $.left - ae, fe = $.width + V, X = Math.max(fe, E.width), Ye = window.innerWidth - Rt, Ve = Vc(ae, [
          Rt,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(Rt, Ye - X)
        ]);
        s.style.minWidth = fe + "px", s.style.left = Ve + "px";
      } else {
        const J = E.right - j.right, ae = window.innerWidth - C.right - J, V = window.innerWidth - $.right - ae, fe = $.width + V, X = Math.max(fe, E.width), Ye = window.innerWidth - Rt, Ve = Vc(ae, [
          Rt,
          Math.max(Rt, Ye - X)
        ]);
        s.style.minWidth = fe + "px", s.style.right = Ve + "px";
      }
      const R = h(), H = window.innerHeight - Rt * 2, L = p.scrollHeight, O = window.getComputedStyle(c), U = parseInt(O.borderTopWidth, 10), I = parseInt(O.paddingTop, 10), K = parseInt(O.borderBottomWidth, 10), q = parseInt(O.paddingBottom, 10), te = U + I + L + q + K, A = Math.min(b.offsetHeight * 5, te), z = window.getComputedStyle(p), N = parseInt(z.paddingTop, 10), B = parseInt(z.paddingBottom, 10), W = $.top + $.height / 2 - Rt, Z = H - W, ee = b.offsetHeight / 2, M = b.offsetTop + ee, Y = U + I + M, Q = te - Y;
      if (Y <= W) {
        const J = R.length > 0 && b === R[R.length - 1].ref.current;
        s.style.bottom = "0px";
        const ae = c.clientHeight - p.offsetTop - p.offsetHeight, V = Math.max(
          Z,
          ee + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (J ? B : 0) + ae + K
        ), fe = Y + V;
        s.style.height = fe + "px";
      } else {
        const J = R.length > 0 && b === R[0].ref.current;
        s.style.top = "0px";
        const ae = Math.max(
          W,
          U + p.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (J ? N : 0) + ee
        ) + Q;
        s.style.height = ae + "px", p.scrollTop = Y - W + p.offsetTop;
      }
      s.style.margin = `${Rt}px 0`, s.style.minHeight = A + "px", s.style.maxHeight = H + "px", o?.(), requestAnimationFrame(() => m.current = !0);
    }
  }, [
    h,
    r.trigger,
    r.valueNode,
    s,
    c,
    p,
    b,
    w,
    r.dir,
    o
  ]);
  ot(() => y(), [y]);
  const [k, x] = g.useState();
  ot(() => {
    c && x(window.getComputedStyle(c).zIndex);
  }, [c]);
  const S = g.useCallback(
    ($) => {
      $ && f.current === !0 && (y(), _?.(), f.current = !1);
    },
    [y, _]
  );
  return /* @__PURE__ */ v(
    cDe,
    {
      scope: a,
      contentWrapper: s,
      shouldExpandOnScrollRef: m,
      onScrollButtonChange: S,
      children: /* @__PURE__ */ v(
        "div",
        {
          ref: l,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: k
          },
          children: /* @__PURE__ */ v(
            ye.div,
            {
              ...n,
              ref: d,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...n.style
              }
            }
          )
        }
      )
    }
  );
});
Ok.displayName = sDe;
var lDe = "SelectPopperPosition", Gc = g.forwardRef((e, t) => {
  const {
    __scopeSelect: a,
    align: o = "start",
    collisionPadding: n = Rt,
    ...r
  } = e, i = Ld(a);
  return /* @__PURE__ */ v(
    HPe,
    {
      ...i,
      ...r,
      ref: t,
      align: o,
      collisionPadding: n,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...r.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Gc.displayName = lDe;
var [cDe, Md] = dn(co, {}), Kc = "SelectViewport", uDe = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: a, nonce: o, ...n } = e, r = La(Kc, a), i = Md(Kc, a), s = Ne(t, r.onViewportChange), l = g.useRef(0);
    return /* @__PURE__ */ T(De, { children: [
      /* @__PURE__ */ v(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: o
        }
      ),
      /* @__PURE__ */ v(Td.Slot, { scope: a, children: /* @__PURE__ */ v(
        ye.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...n,
          ref: s,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...n.style
          },
          onScroll: ve(n.onScroll, (c) => {
            const u = c.currentTarget, { contentWrapper: d, shouldExpandOnScrollRef: h } = i;
            if (h?.current && d) {
              const m = Math.abs(l.current - u.scrollTop);
              if (m > 0) {
                const f = window.innerHeight - Rt * 2, p = parseFloat(d.style.minHeight), b = parseFloat(d.style.height), w = Math.max(p, b);
                if (w < f) {
                  const _ = w + m, y = Math.min(f, _), k = _ - y;
                  d.style.height = y + "px", d.style.bottom === "0px" && (u.scrollTop = k > 0 ? k : 0, d.style.justifyContent = "flex-end");
                }
              }
            }
            l.current = u.scrollTop;
          })
        }
      ) })
    ] });
  }
);
uDe.displayName = Kc;
var zk = "SelectGroup", [dDe, gDe] = dn(zk), hDe = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: a, ...o } = e, n = kw();
    return /* @__PURE__ */ v(dDe, { scope: a, id: n, children: /* @__PURE__ */ v(ye.div, { role: "group", "aria-labelledby": n, ...o, ref: t }) });
  }
);
hDe.displayName = zk;
var Ak = "SelectLabel", pDe = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: a, ...o } = e, n = gDe(Ak, a);
    return /* @__PURE__ */ v(ye.div, { id: n.id, ...o, ref: t });
  }
);
pDe.displayName = Ak;
var Ji = "SelectItem", [mDe, Pk] = dn(Ji), fDe = g.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: a,
      value: o,
      disabled: n = !1,
      textValue: r,
      ...i
    } = e, s = Ta(Ji, a), l = La(Ji, a), c = s.value === o, [u, d] = g.useState(r ?? ""), [h, m] = g.useState(!1), f = Ne(
      t,
      (_) => l.itemRefCallback?.(_, o, n)
    ), p = kw(), b = g.useRef("touch"), w = () => {
      n || (s.onValueChange(o), s.onOpenChange(!1));
    };
    if (o === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ v(
      mDe,
      {
        scope: a,
        value: o,
        disabled: n,
        textId: p,
        isSelected: c,
        onItemTextChange: g.useCallback((_) => {
          d((y) => y || (_?.textContent ?? "").trim());
        }, []),
        children: /* @__PURE__ */ v(
          Td.ItemSlot,
          {
            scope: a,
            value: o,
            disabled: n,
            textValue: u,
            children: /* @__PURE__ */ v(
              ye.div,
              {
                role: "option",
                "aria-labelledby": p,
                "data-highlighted": h ? "" : void 0,
                "aria-selected": c && h,
                "data-state": c ? "checked" : "unchecked",
                "aria-disabled": n || void 0,
                "data-disabled": n ? "" : void 0,
                tabIndex: n ? void 0 : -1,
                ...i,
                ref: f,
                onFocus: ve(i.onFocus, () => m(!0)),
                onBlur: ve(i.onBlur, () => m(!1)),
                onClick: ve(i.onClick, () => {
                  b.current !== "mouse" && w();
                }),
                onPointerUp: ve(i.onPointerUp, () => {
                  b.current === "mouse" && w();
                }),
                onPointerDown: ve(i.onPointerDown, (_) => {
                  b.current = _.pointerType;
                }),
                onPointerMove: ve(i.onPointerMove, (_) => {
                  b.current = _.pointerType, n ? l.onItemLeave?.() : b.current === "mouse" && _.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: ve(i.onPointerLeave, (_) => {
                  _.currentTarget === document.activeElement && l.onItemLeave?.();
                }),
                onKeyDown: ve(i.onKeyDown, (_) => {
                  l.searchRef?.current !== "" && _.key === " " || (YPe.includes(_.key) && w(), _.key === " " && _.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
fDe.displayName = Ji;
var Sn = "SelectItemText", bDe = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: a, className: o, style: n, ...r } = e, i = Ta(Sn, a), s = La(Sn, a), l = Pk(Sn, a), c = QPe(Sn, a), [u, d] = g.useState(null), h = Ne(
      t,
      (w) => d(w),
      l.onItemTextChange,
      (w) => s.itemTextRefCallback?.(w, l.value, l.disabled)
    ), m = u?.textContent, f = g.useMemo(
      () => /* @__PURE__ */ v("option", { value: l.value, disabled: l.disabled, children: m }, l.value),
      [l.disabled, l.value, m]
    ), { onNativeOptionAdd: p, onNativeOptionRemove: b } = c;
    return ot(() => (p(f), () => b(f)), [p, b, f]), /* @__PURE__ */ T(De, { children: [
      /* @__PURE__ */ v(ye.span, { id: l.textId, ...r, ref: h }),
      l.isSelected && i.valueNode && !i.valueNodeHasChildren ? po.createPortal(r.children, i.valueNode) : null
    ] });
  }
);
bDe.displayName = Sn;
var Dk = "SelectItemIndicator", _De = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: a, ...o } = e;
    return Pk(Dk, a).isSelected ? /* @__PURE__ */ v(ye.span, { "aria-hidden": !0, ...o, ref: t }) : null;
  }
);
_De.displayName = Dk;
var Jc = "SelectScrollUpButton", vDe = g.forwardRef((e, t) => {
  const a = La(Jc, e.__scopeSelect), o = Md(Jc, e.__scopeSelect), [n, r] = g.useState(!1), i = Ne(t, o.onScrollButtonChange);
  return ot(() => {
    if (a.viewport && a.isPositioned) {
      let s = function() {
        const c = l.scrollTop > 0;
        r(c);
      };
      const l = a.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [a.viewport, a.isPositioned]), n ? /* @__PURE__ */ v(
    Nk,
    {
      ...e,
      ref: i,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: l } = a;
        s && l && (s.scrollTop = s.scrollTop - l.offsetHeight);
      }
    }
  ) : null;
});
vDe.displayName = Jc;
var Zc = "SelectScrollDownButton", yDe = g.forwardRef((e, t) => {
  const a = La(Zc, e.__scopeSelect), o = Md(Zc, e.__scopeSelect), [n, r] = g.useState(!1), i = Ne(t, o.onScrollButtonChange);
  return ot(() => {
    if (a.viewport && a.isPositioned) {
      let s = function() {
        const c = l.scrollHeight - l.clientHeight, u = Math.ceil(l.scrollTop) < c;
        r(u);
      };
      const l = a.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [a.viewport, a.isPositioned]), n ? /* @__PURE__ */ v(
    Nk,
    {
      ...e,
      ref: i,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: l } = a;
        s && l && (s.scrollTop = s.scrollTop + l.offsetHeight);
      }
    }
  ) : null;
});
yDe.displayName = Zc;
var Nk = g.forwardRef((e, t) => {
  const { __scopeSelect: a, onAutoScroll: o, ...n } = e, r = La("SelectScrollButton", a), i = g.useRef(null), s = Us(a), l = g.useCallback(() => {
    i.current !== null && (window.clearInterval(i.current), i.current = null);
  }, []);
  return g.useEffect(() => () => l(), [l]), ot(() => {
    s().find((c) => c.ref.current === document.activeElement)?.ref.current?.scrollIntoView({ block: "nearest" });
  }, [s]), /* @__PURE__ */ v(
    ye.div,
    {
      "aria-hidden": !0,
      ...n,
      ref: t,
      style: { flexShrink: 0, ...n.style },
      onPointerDown: ve(n.onPointerDown, () => {
        i.current === null && (i.current = window.setInterval(o, 50));
      }),
      onPointerMove: ve(n.onPointerMove, () => {
        r.onItemLeave?.(), i.current === null && (i.current = window.setInterval(o, 50));
      }),
      onPointerLeave: ve(n.onPointerLeave, () => {
        l();
      })
    }
  );
}), wDe = "SelectSeparator", kDe = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: a, ...o } = e;
    return /* @__PURE__ */ v(ye.div, { "aria-hidden": !0, ...o, ref: t });
  }
);
kDe.displayName = wDe;
var Yc = "SelectArrow", xDe = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: a, ...o } = e, n = Ld(a), r = Ta(Yc, a), i = La(Yc, a);
    return r.open && i.position === "popper" ? /* @__PURE__ */ v(GPe, { ...n, ...o, ref: t }) : null;
  }
);
xDe.displayName = Yc;
var $De = "SelectBubbleInput", SDe = g.forwardRef(
  ({ __scopeSelect: e, value: t, ...a }, o) => {
    const n = g.useRef(null), r = Ne(o, n), i = sOe(t);
    return g.useEffect(() => {
      const s = n.current;
      if (!s) return;
      const l = window.HTMLSelectElement.prototype, c = Object.getOwnPropertyDescriptor(
        l,
        "value"
      ).set;
      if (i !== t && c) {
        const u = new Event("change", { bubbles: !0 });
        c.call(s, t), s.dispatchEvent(u);
      }
    }, [i, t]), /* @__PURE__ */ v(
      ye.select,
      {
        ...a,
        style: { ...$k, ...a.style },
        ref: r,
        defaultValue: t
      }
    );
  }
);
SDe.displayName = $De;
function Rk(e) {
  return e === "" || e === void 0;
}
function Ik(e) {
  const t = ut(e), a = g.useRef(""), o = g.useRef(0), n = g.useCallback(
    (i) => {
      const s = a.current + i;
      t(s), function l(c) {
        a.current = c, window.clearTimeout(o.current), c !== "" && (o.current = window.setTimeout(() => l(""), 1e3));
      }(s);
    },
    [t]
  ), r = g.useCallback(() => {
    a.current = "", window.clearTimeout(o.current);
  }, []);
  return g.useEffect(() => () => window.clearTimeout(o.current), []), [a, n, r];
}
function Tk(e, t, a) {
  const o = t.length > 1 && Array.from(t).every((s) => s === t[0]) ? t[0] : t, n = a ? e.indexOf(a) : -1;
  let r = CDe(e, Math.max(n, 0));
  o.length === 1 && (r = r.filter((s) => s !== a));
  const i = r.find(
    (s) => s.textValue.toLowerCase().startsWith(o.toLowerCase())
  );
  return i !== a ? i : void 0;
}
function CDe(e, t) {
  return e.map((a, o) => e[(t + o) % e.length]);
}
const EDe = Ot(void 0), mm = (e) => {
  let t;
  const a = /* @__PURE__ */ new Set(), o = (s, l) => {
    const c = typeof s == "function" ? s(t) : s;
    if (!Object.is(c, t)) {
      const u = t;
      t = l ?? (typeof c != "object" || c === null) ? c : Object.assign({}, t, c), a.forEach((d) => d(t, u));
    }
  }, n = () => t, r = { setState: o, getState: n, getInitialState: () => i, subscribe: (s) => (a.add(s), () => a.delete(s)) }, i = t = e(o, n, r);
  return r;
}, jDe = (e) => e ? mm(e) : mm;
function ODe(e) {
  const t = {
    config: {
      apiUrl: "",
      assetsUrl: "",
      clients: {
        regular: "",
        collection: ""
      }
    }
  };
  return jDe((a) => ({
    ...t,
    ...e,
    setConfig: (o) => a({ config: o })
  }));
}
function zDe({ children: e, ...t }) {
  const a = Ie(null);
  return a.current || (a.current = ODe(t)), /* @__PURE__ */ v(EDe.Provider, { value: a.current, children: e });
}
const ce = (e) => typeof e == "string", xn = () => {
  let e, t;
  const a = new Promise((o, n) => {
    e = o, t = n;
  });
  return a.resolve = e, a.reject = t, a;
}, fm = (e) => e == null ? "" : "" + e, ADe = (e, t, a) => {
  e.forEach((o) => {
    t[o] && (a[o] = t[o]);
  });
}, PDe = /###/g, bm = (e) => e && e.indexOf("###") > -1 ? e.replace(PDe, ".") : e, _m = (e) => !e || ce(e), Rn = (e, t, a) => {
  const o = ce(t) ? t.split(".") : t;
  let n = 0;
  for (; n < o.length - 1; ) {
    if (_m(e)) return {};
    const r = bm(o[n]);
    !e[r] && a && (e[r] = new a()), Object.prototype.hasOwnProperty.call(e, r) ? e = e[r] : e = {}, ++n;
  }
  return _m(e) ? {} : {
    obj: e,
    k: bm(o[n])
  };
}, vm = (e, t, a) => {
  const {
    obj: o,
    k: n
  } = Rn(e, t, Object);
  if (o !== void 0 || t.length === 1) {
    o[n] = a;
    return;
  }
  let r = t[t.length - 1], i = t.slice(0, t.length - 1), s = Rn(e, i, Object);
  for (; s.obj === void 0 && i.length; )
    r = `${i[i.length - 1]}.${r}`, i = i.slice(0, i.length - 1), s = Rn(e, i, Object), s?.obj && typeof s.obj[`${s.k}.${r}`] < "u" && (s.obj = void 0);
  s.obj[`${s.k}.${r}`] = a;
}, DDe = (e, t, a, o) => {
  const {
    obj: n,
    k: r
  } = Rn(e, t, Object);
  n[r] = n[r] || [], n[r].push(a);
}, Zi = (e, t) => {
  const {
    obj: a,
    k: o
  } = Rn(e, t);
  if (a && Object.prototype.hasOwnProperty.call(a, o))
    return a[o];
}, NDe = (e, t, a) => {
  const o = Zi(e, a);
  return o !== void 0 ? o : Zi(t, a);
}, Lk = (e, t, a) => {
  for (const o in t)
    o !== "__proto__" && o !== "constructor" && (o in e ? ce(e[o]) || e[o] instanceof String || ce(t[o]) || t[o] instanceof String ? a && (e[o] = t[o]) : Lk(e[o], t[o], a) : e[o] = t[o]);
  return e;
}, Ro = (e) => e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var RDe = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const IDe = (e) => ce(e) ? e.replace(/[&<>"'\/]/g, (t) => RDe[t]) : e;
class TDe {
  constructor(t) {
    this.capacity = t, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(t) {
    const a = this.regExpMap.get(t);
    if (a !== void 0)
      return a;
    const o = new RegExp(t);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(t, o), this.regExpQueue.push(t), o;
  }
}
const LDe = [" ", ",", "?", "!", ";"], MDe = new TDe(20), WDe = (e, t, a) => {
  t = t || "", a = a || "";
  const o = LDe.filter((i) => t.indexOf(i) < 0 && a.indexOf(i) < 0);
  if (o.length === 0) return !0;
  const n = MDe.getRegExp(`(${o.map((i) => i === "?" ? "\\?" : i).join("|")})`);
  let r = !n.test(e);
  if (!r) {
    const i = e.indexOf(a);
    i > 0 && !n.test(e.substring(0, i)) && (r = !0);
  }
  return r;
}, Xc = (e, t, a = ".") => {
  if (!e) return;
  if (e[t])
    return Object.prototype.hasOwnProperty.call(e, t) ? e[t] : void 0;
  const o = t.split(a);
  let n = e;
  for (let r = 0; r < o.length; ) {
    if (!n || typeof n != "object")
      return;
    let i, s = "";
    for (let l = r; l < o.length; ++l)
      if (l !== r && (s += a), s += o[l], i = n[s], i !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof i) > -1 && l < o.length - 1)
          continue;
        r += l - r + 1;
        break;
      }
    n = i;
  }
  return n;
}, qn = (e) => e?.replace("_", "-"), BDe = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, t) {
    console?.[e]?.apply?.(console, t);
  }
};
class Yi {
  constructor(t, a = {}) {
    this.init(t, a);
  }
  init(t, a = {}) {
    this.prefix = a.prefix || "i18next:", this.logger = t || BDe, this.options = a, this.debug = a.debug;
  }
  log(...t) {
    return this.forward(t, "log", "", !0);
  }
  warn(...t) {
    return this.forward(t, "warn", "", !0);
  }
  error(...t) {
    return this.forward(t, "error", "");
  }
  deprecate(...t) {
    return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(t, a, o, n) {
    return n && !this.debug ? null : (ce(t[0]) && (t[0] = `${o}${this.prefix} ${t[0]}`), this.logger[a](t));
  }
  create(t) {
    return new Yi(this.logger, {
      prefix: `${this.prefix}:${t}:`,
      ...this.options
    });
  }
  clone(t) {
    return t = t || this.options, t.prefix = t.prefix || this.prefix, new Yi(this.logger, t);
  }
}
var Zt = new Yi();
class qs {
  constructor() {
    this.observers = {};
  }
  on(t, a) {
    return t.split(" ").forEach((o) => {
      this.observers[o] || (this.observers[o] = /* @__PURE__ */ new Map());
      const n = this.observers[o].get(a) || 0;
      this.observers[o].set(a, n + 1);
    }), this;
  }
  off(t, a) {
    if (this.observers[t]) {
      if (!a) {
        delete this.observers[t];
        return;
      }
      this.observers[t].delete(a);
    }
  }
  emit(t, ...a) {
    this.observers[t] && Array.from(this.observers[t].entries()).forEach(([o, n]) => {
      for (let r = 0; r < n; r++)
        o(...a);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach(([o, n]) => {
      for (let r = 0; r < n; r++)
        o.apply(o, [t, ...a]);
    });
  }
}
class ym extends qs {
  constructor(t, a = {
    ns: ["translation"],
    defaultNS: "translation"
  }) {
    super(), this.data = t || {}, this.options = a, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(t) {
    this.options.ns.indexOf(t) < 0 && this.options.ns.push(t);
  }
  removeNamespaces(t) {
    const a = this.options.ns.indexOf(t);
    a > -1 && this.options.ns.splice(a, 1);
  }
  getResource(t, a, o, n = {}) {
    const r = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, i = n.ignoreJSONStructure !== void 0 ? n.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let s;
    t.indexOf(".") > -1 ? s = t.split(".") : (s = [t, a], o && (Array.isArray(o) ? s.push(...o) : ce(o) && r ? s.push(...o.split(r)) : s.push(o)));
    const l = Zi(this.data, s);
    return !l && !a && !o && t.indexOf(".") > -1 && (t = s[0], a = s[1], o = s.slice(2).join(".")), l || !i || !ce(o) ? l : Xc(this.data?.[t]?.[a], o, r);
  }
  addResource(t, a, o, n, r = {
    silent: !1
  }) {
    const i = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator;
    let s = [t, a];
    o && (s = s.concat(i ? o.split(i) : o)), t.indexOf(".") > -1 && (s = t.split("."), n = a, a = s[1]), this.addNamespaces(a), vm(this.data, s, n), r.silent || this.emit("added", t, a, o, n);
  }
  addResources(t, a, o, n = {
    silent: !1
  }) {
    for (const r in o)
      (ce(o[r]) || Array.isArray(o[r])) && this.addResource(t, a, r, o[r], {
        silent: !0
      });
    n.silent || this.emit("added", t, a, o);
  }
  addResourceBundle(t, a, o, n, r, i = {
    silent: !1,
    skipCopy: !1
  }) {
    let s = [t, a];
    t.indexOf(".") > -1 && (s = t.split("."), n = o, o = a, a = s[1]), this.addNamespaces(a);
    let l = Zi(this.data, s) || {};
    i.skipCopy || (o = JSON.parse(JSON.stringify(o))), n ? Lk(l, o, r) : l = {
      ...l,
      ...o
    }, vm(this.data, s, l), i.silent || this.emit("added", t, a, o);
  }
  removeResourceBundle(t, a) {
    this.hasResourceBundle(t, a) && delete this.data[t][a], this.removeNamespaces(a), this.emit("removed", t, a);
  }
  hasResourceBundle(t, a) {
    return this.getResource(t, a) !== void 0;
  }
  getResourceBundle(t, a) {
    return a || (a = this.options.defaultNS), this.getResource(t, a);
  }
  getDataByLanguage(t) {
    return this.data[t];
  }
  hasLanguageSomeTranslations(t) {
    const a = this.getDataByLanguage(t);
    return !!(a && Object.keys(a) || []).find((o) => a[o] && Object.keys(a[o]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var Mk = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, t, a, o, n) {
    return e.forEach((r) => {
      t = this.processors[r]?.process(t, a, o, n) ?? t;
    }), t;
  }
};
const Wk = Symbol("i18next/PATH_KEY");
function FDe() {
  const e = [], t = /* @__PURE__ */ Object.create(null);
  let a;
  return t.get = (o, n) => (a?.revoke?.(), n === Wk ? e : (e.push(n), a = Proxy.revocable(o, t), a.proxy)), Proxy.revocable(/* @__PURE__ */ Object.create(null), t).proxy;
}
function Qc(e, t) {
  const {
    [Wk]: a
  } = e(FDe());
  return a.join(t?.keySeparator ?? ".");
}
const wm = {}, km = (e) => !ce(e) && typeof e != "boolean" && typeof e != "number";
class Xi extends qs {
  constructor(t, a = {}) {
    super(), ADe(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], t, this), this.options = a, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = Zt.create("translator");
  }
  changeLanguage(t) {
    t && (this.language = t);
  }
  exists(t, a = {
    interpolation: {}
  }) {
    const o = {
      ...a
    };
    return t == null ? !1 : this.resolve(t, o)?.res !== void 0;
  }
  extractFromKey(t, a) {
    let o = a.nsSeparator !== void 0 ? a.nsSeparator : this.options.nsSeparator;
    o === void 0 && (o = ":");
    const n = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator;
    let r = a.ns || this.options.defaultNS || [];
    const i = o && t.indexOf(o) > -1, s = !this.options.userDefinedKeySeparator && !a.keySeparator && !this.options.userDefinedNsSeparator && !a.nsSeparator && !WDe(t, o, n);
    if (i && !s) {
      const l = t.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: t,
          namespaces: ce(r) ? [r] : r
        };
      const c = t.split(o);
      (o !== n || o === n && this.options.ns.indexOf(c[0]) > -1) && (r = c.shift()), t = c.join(n);
    }
    return {
      key: t,
      namespaces: ce(r) ? [r] : r
    };
  }
  translate(t, a, o) {
    let n = typeof a == "object" ? {
      ...a
    } : a;
    if (typeof n != "object" && this.options.overloadTranslationOptionHandler && (n = this.options.overloadTranslationOptionHandler(arguments)), typeof n == "object" && (n = {
      ...n
    }), n || (n = {}), t == null) return "";
    typeof t == "function" && (t = Qc(t, {
      ...this.options,
      ...n
    })), Array.isArray(t) || (t = [String(t)]);
    const r = n.returnDetails !== void 0 ? n.returnDetails : this.options.returnDetails, i = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, {
      key: s,
      namespaces: l
    } = this.extractFromKey(t[t.length - 1], n), c = l[l.length - 1];
    let u = n.nsSeparator !== void 0 ? n.nsSeparator : this.options.nsSeparator;
    u === void 0 && (u = ":");
    const d = n.lng || this.language, h = n.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (d?.toLowerCase() === "cimode")
      return h ? r ? {
        res: `${c}${u}${s}`,
        usedKey: s,
        exactUsedKey: s,
        usedLng: d,
        usedNS: c,
        usedParams: this.getUsedParamsDetails(n)
      } : `${c}${u}${s}` : r ? {
        res: s,
        usedKey: s,
        exactUsedKey: s,
        usedLng: d,
        usedNS: c,
        usedParams: this.getUsedParamsDetails(n)
      } : s;
    const m = this.resolve(t, n);
    let f = m?.res;
    const p = m?.usedKey || s, b = m?.exactUsedKey || s, w = ["[object Number]", "[object Function]", "[object RegExp]"], _ = n.joinArrays !== void 0 ? n.joinArrays : this.options.joinArrays, y = !this.i18nFormat || this.i18nFormat.handleAsObject, k = n.count !== void 0 && !ce(n.count), x = Xi.hasDefaultValue(n), S = k ? this.pluralResolver.getSuffix(d, n.count, n) : "", $ = n.ordinal && k ? this.pluralResolver.getSuffix(d, n.count, {
      ordinal: !1
    }) : "", E = k && !n.ordinal && n.count === 0, C = E && n[`defaultValue${this.options.pluralSeparator}zero`] || n[`defaultValue${S}`] || n[`defaultValue${$}`] || n.defaultValue;
    let j = f;
    y && !f && x && (j = C);
    const R = km(j), H = Object.prototype.toString.apply(j);
    if (y && j && R && w.indexOf(H) < 0 && !(ce(_) && Array.isArray(j))) {
      if (!n.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const L = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(p, j, {
          ...n,
          ns: l
        }) : `key '${s} (${this.language})' returned an object instead of string.`;
        return r ? (m.res = L, m.usedParams = this.getUsedParamsDetails(n), m) : L;
      }
      if (i) {
        const L = Array.isArray(j), O = L ? [] : {}, U = L ? b : p;
        for (const I in j)
          if (Object.prototype.hasOwnProperty.call(j, I)) {
            const K = `${U}${i}${I}`;
            x && !f ? O[I] = this.translate(K, {
              ...n,
              defaultValue: km(C) ? C[I] : void 0,
              joinArrays: !1,
              ns: l
            }) : O[I] = this.translate(K, {
              ...n,
              joinArrays: !1,
              ns: l
            }), O[I] === K && (O[I] = j[I]);
          }
        f = O;
      }
    } else if (y && ce(_) && Array.isArray(f))
      f = f.join(_), f && (f = this.extendTranslation(f, t, n, o));
    else {
      let L = !1, O = !1;
      !this.isValidLookup(f) && x && (L = !0, f = C), this.isValidLookup(f) || (O = !0, f = s);
      const U = (n.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && O ? void 0 : f, I = x && C !== f && this.options.updateMissing;
      if (O || L || I) {
        if (this.logger.log(I ? "updateKey" : "missingKey", d, c, s, I ? C : f), i) {
          const A = this.resolve(s, {
            ...n,
            keySeparator: !1
          });
          A && A.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let K = [];
        const q = this.languageUtils.getFallbackCodes(this.options.fallbackLng, n.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && q && q[0])
          for (let A = 0; A < q.length; A++)
            K.push(q[A]);
        else this.options.saveMissingTo === "all" ? K = this.languageUtils.toResolveHierarchy(n.lng || this.language) : K.push(n.lng || this.language);
        const te = (A, z, N) => {
          const B = x && N !== f ? N : U;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(A, c, z, B, I, n) : this.backendConnector?.saveMissing && this.backendConnector.saveMissing(A, c, z, B, I, n), this.emit("missingKey", A, c, z, f);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && k ? K.forEach((A) => {
          const z = this.pluralResolver.getSuffixes(A, n);
          E && n[`defaultValue${this.options.pluralSeparator}zero`] && z.indexOf(`${this.options.pluralSeparator}zero`) < 0 && z.push(`${this.options.pluralSeparator}zero`), z.forEach((N) => {
            te([A], s + N, n[`defaultValue${N}`] || C);
          });
        }) : te(K, s, C));
      }
      f = this.extendTranslation(f, t, n, m, o), O && f === s && this.options.appendNamespaceToMissingKey && (f = `${c}${u}${s}`), (O || L) && this.options.parseMissingKeyHandler && (f = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${c}${u}${s}` : s, L ? f : void 0, n));
    }
    return r ? (m.res = f, m.usedParams = this.getUsedParamsDetails(n), m) : f;
  }
  extendTranslation(t, a, o, n, r) {
    if (this.i18nFormat?.parse)
      t = this.i18nFormat.parse(t, {
        ...this.options.interpolation.defaultVariables,
        ...o
      }, o.lng || this.language || n.usedLng, n.usedNS, n.usedKey, {
        resolved: n
      });
    else if (!o.skipInterpolation) {
      o.interpolation && this.interpolator.init({
        ...o,
        interpolation: {
          ...this.options.interpolation,
          ...o.interpolation
        }
      });
      const l = ce(t) && (o?.interpolation?.skipOnVariables !== void 0 ? o.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let c;
      if (l) {
        const d = t.match(this.interpolator.nestingRegexp);
        c = d && d.length;
      }
      let u = o.replace && !ce(o.replace) ? o.replace : o;
      if (this.options.interpolation.defaultVariables && (u = {
        ...this.options.interpolation.defaultVariables,
        ...u
      }), t = this.interpolator.interpolate(t, u, o.lng || this.language || n.usedLng, o), l) {
        const d = t.match(this.interpolator.nestingRegexp), h = d && d.length;
        c < h && (o.nest = !1);
      }
      !o.lng && n && n.res && (o.lng = this.language || n.usedLng), o.nest !== !1 && (t = this.interpolator.nest(t, (...d) => r?.[0] === d[0] && !o.context ? (this.logger.warn(`It seems you are nesting recursively key: ${d[0]} in key: ${a[0]}`), null) : this.translate(...d, a), o)), o.interpolation && this.interpolator.reset();
    }
    const i = o.postProcess || this.options.postProcess, s = ce(i) ? [i] : i;
    return t != null && s?.length && o.applyPostProcessor !== !1 && (t = Mk.handle(s, t, a, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...n,
        usedParams: this.getUsedParamsDetails(o)
      },
      ...o
    } : o, this)), t;
  }
  resolve(t, a = {}) {
    let o, n, r, i, s;
    return ce(t) && (t = [t]), t.forEach((l) => {
      if (this.isValidLookup(o)) return;
      const c = this.extractFromKey(l, a), u = c.key;
      n = u;
      let d = c.namespaces;
      this.options.fallbackNS && (d = d.concat(this.options.fallbackNS));
      const h = a.count !== void 0 && !ce(a.count), m = h && !a.ordinal && a.count === 0, f = a.context !== void 0 && (ce(a.context) || typeof a.context == "number") && a.context !== "", p = a.lngs ? a.lngs : this.languageUtils.toResolveHierarchy(a.lng || this.language, a.fallbackLng);
      d.forEach((b) => {
        this.isValidLookup(o) || (s = b, !wm[`${p[0]}-${b}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(s) && (wm[`${p[0]}-${b}`] = !0, this.logger.warn(`key "${n}" for languages "${p.join(", ")}" won't get resolved as namespace "${s}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), p.forEach((w) => {
          if (this.isValidLookup(o)) return;
          i = w;
          const _ = [u];
          if (this.i18nFormat?.addLookupKeys)
            this.i18nFormat.addLookupKeys(_, u, w, b, a);
          else {
            let k;
            h && (k = this.pluralResolver.getSuffix(w, a.count, a));
            const x = `${this.options.pluralSeparator}zero`, S = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (h && (a.ordinal && k.indexOf(S) === 0 && _.push(u + k.replace(S, this.options.pluralSeparator)), _.push(u + k), m && _.push(u + x)), f) {
              const $ = `${u}${this.options.contextSeparator || "_"}${a.context}`;
              _.push($), h && (a.ordinal && k.indexOf(S) === 0 && _.push($ + k.replace(S, this.options.pluralSeparator)), _.push($ + k), m && _.push($ + x));
            }
          }
          let y;
          for (; y = _.pop(); )
            this.isValidLookup(o) || (r = y, o = this.getResource(w, b, y, a));
        }));
      });
    }), {
      res: o,
      usedKey: n,
      exactUsedKey: r,
      usedLng: i,
      usedNS: s
    };
  }
  isValidLookup(t) {
    return t !== void 0 && !(!this.options.returnNull && t === null) && !(!this.options.returnEmptyString && t === "");
  }
  getResource(t, a, o, n = {}) {
    return this.i18nFormat?.getResource ? this.i18nFormat.getResource(t, a, o, n) : this.resourceStore.getResource(t, a, o, n);
  }
  getUsedParamsDetails(t = {}) {
    const a = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], o = t.replace && !ce(t.replace);
    let n = o ? t.replace : t;
    if (o && typeof t.count < "u" && (n.count = t.count), this.options.interpolation.defaultVariables && (n = {
      ...this.options.interpolation.defaultVariables,
      ...n
    }), !o) {
      n = {
        ...n
      };
      for (const r of a)
        delete n[r];
    }
    return n;
  }
  static hasDefaultValue(t) {
    const a = "defaultValue";
    for (const o in t)
      if (Object.prototype.hasOwnProperty.call(t, o) && a === o.substring(0, a.length) && t[o] !== void 0)
        return !0;
    return !1;
  }
}
class xm {
  constructor(t) {
    this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Zt.create("languageUtils");
  }
  getScriptPartFromCode(t) {
    if (t = qn(t), !t || t.indexOf("-") < 0) return null;
    const a = t.split("-");
    return a.length === 2 || (a.pop(), a[a.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(a.join("-"));
  }
  getLanguagePartFromCode(t) {
    if (t = qn(t), !t || t.indexOf("-") < 0) return t;
    const a = t.split("-");
    return this.formatLanguageCode(a[0]);
  }
  formatLanguageCode(t) {
    if (ce(t) && t.indexOf("-") > -1) {
      let a;
      try {
        a = Intl.getCanonicalLocales(t)[0];
      } catch {
      }
      return a && this.options.lowerCaseLng && (a = a.toLowerCase()), a || (this.options.lowerCaseLng ? t.toLowerCase() : t);
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? t.toLowerCase() : t;
  }
  isSupportedCode(t) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (t = this.getLanguagePartFromCode(t)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(t) > -1;
  }
  getBestMatchFromCodes(t) {
    if (!t) return null;
    let a;
    return t.forEach((o) => {
      if (a) return;
      const n = this.formatLanguageCode(o);
      (!this.options.supportedLngs || this.isSupportedCode(n)) && (a = n);
    }), !a && this.options.supportedLngs && t.forEach((o) => {
      if (a) return;
      const n = this.getScriptPartFromCode(o);
      if (this.isSupportedCode(n)) return a = n;
      const r = this.getLanguagePartFromCode(o);
      if (this.isSupportedCode(r)) return a = r;
      a = this.options.supportedLngs.find((i) => {
        if (i === r || !(i.indexOf("-") < 0 && r.indexOf("-") < 0) && (i.indexOf("-") > 0 && r.indexOf("-") < 0 && i.substring(0, i.indexOf("-")) === r || i.indexOf(r) === 0 && r.length > 1))
          return i;
      });
    }), a || (a = this.getFallbackCodes(this.options.fallbackLng)[0]), a;
  }
  getFallbackCodes(t, a) {
    if (!t) return [];
    if (typeof t == "function" && (t = t(a)), ce(t) && (t = [t]), Array.isArray(t)) return t;
    if (!a) return t.default || [];
    let o = t[a];
    return o || (o = t[this.getScriptPartFromCode(a)]), o || (o = t[this.formatLanguageCode(a)]), o || (o = t[this.getLanguagePartFromCode(a)]), o || (o = t.default), o || [];
  }
  toResolveHierarchy(t, a) {
    const o = this.getFallbackCodes((a === !1 ? [] : a) || this.options.fallbackLng || [], t), n = [], r = (i) => {
      i && (this.isSupportedCode(i) ? n.push(i) : this.logger.warn(`rejecting language code not found in supportedLngs: ${i}`));
    };
    return ce(t) && (t.indexOf("-") > -1 || t.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && r(this.formatLanguageCode(t)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && r(this.getScriptPartFromCode(t)), this.options.load !== "currentOnly" && r(this.getLanguagePartFromCode(t))) : ce(t) && r(this.formatLanguageCode(t)), o.forEach((i) => {
      n.indexOf(i) < 0 && r(this.formatLanguageCode(i));
    }), n;
  }
}
const $m = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, Sm = {
  select: (e) => e === 1 ? "one" : "other",
  resolvedOptions: () => ({
    pluralCategories: ["one", "other"]
  })
};
class VDe {
  constructor(t, a = {}) {
    this.languageUtils = t, this.options = a, this.logger = Zt.create("pluralResolver"), this.pluralRulesCache = {};
  }
  addRule(t, a) {
    this.rules[t] = a;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(t, a = {}) {
    const o = qn(t === "dev" ? "en" : t), n = a.ordinal ? "ordinal" : "cardinal", r = JSON.stringify({
      cleanedCode: o,
      type: n
    });
    if (r in this.pluralRulesCache)
      return this.pluralRulesCache[r];
    let i;
    try {
      i = new Intl.PluralRules(o, {
        type: n
      });
    } catch {
      if (!Intl)
        return this.logger.error("No Intl support, please use an Intl polyfill!"), Sm;
      if (!t.match(/-|_/)) return Sm;
      const s = this.languageUtils.getLanguagePartFromCode(t);
      i = this.getRule(s, a);
    }
    return this.pluralRulesCache[r] = i, i;
  }
  needsPlural(t, a = {}) {
    let o = this.getRule(t, a);
    return o || (o = this.getRule("dev", a)), o?.resolvedOptions().pluralCategories.length > 1;
  }
  getPluralFormsOfKey(t, a, o = {}) {
    return this.getSuffixes(t, o).map((n) => `${a}${n}`);
  }
  getSuffixes(t, a = {}) {
    let o = this.getRule(t, a);
    return o || (o = this.getRule("dev", a)), o ? o.resolvedOptions().pluralCategories.sort((n, r) => $m[n] - $m[r]).map((n) => `${this.options.prepend}${a.ordinal ? `ordinal${this.options.prepend}` : ""}${n}`) : [];
  }
  getSuffix(t, a, o = {}) {
    const n = this.getRule(t, o);
    return n ? `${this.options.prepend}${o.ordinal ? `ordinal${this.options.prepend}` : ""}${n.select(a)}` : (this.logger.warn(`no plural rule found for: ${t}`), this.getSuffix("dev", a, o));
  }
}
const Cm = (e, t, a, o = ".", n = !0) => {
  let r = NDe(e, t, a);
  return !r && n && ce(a) && (r = Xc(e, a, o), r === void 0 && (r = Xc(t, a, o))), r;
}, Gl = (e) => e.replace(/\$/g, "$$$$");
class UDe {
  constructor(t = {}) {
    this.logger = Zt.create("interpolator"), this.options = t, this.format = t?.interpolation?.format || ((a) => a), this.init(t);
  }
  init(t = {}) {
    t.interpolation || (t.interpolation = {
      escapeValue: !0
    });
    const {
      escape: a,
      escapeValue: o,
      useRawValueToEscape: n,
      prefix: r,
      prefixEscaped: i,
      suffix: s,
      suffixEscaped: l,
      formatSeparator: c,
      unescapeSuffix: u,
      unescapePrefix: d,
      nestingPrefix: h,
      nestingPrefixEscaped: m,
      nestingSuffix: f,
      nestingSuffixEscaped: p,
      nestingOptionsSeparator: b,
      maxReplaces: w,
      alwaysFormat: _
    } = t.interpolation;
    this.escape = a !== void 0 ? a : IDe, this.escapeValue = o !== void 0 ? o : !0, this.useRawValueToEscape = n !== void 0 ? n : !1, this.prefix = r ? Ro(r) : i || "{{", this.suffix = s ? Ro(s) : l || "}}", this.formatSeparator = c || ",", this.unescapePrefix = u ? "" : d || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u || "", this.nestingPrefix = h ? Ro(h) : m || Ro("$t("), this.nestingSuffix = f ? Ro(f) : p || Ro(")"), this.nestingOptionsSeparator = b || ",", this.maxReplaces = w || 1e3, this.alwaysFormat = _ !== void 0 ? _ : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const t = (a, o) => a?.source === o ? (a.lastIndex = 0, a) : new RegExp(o, "g");
    this.regexp = t(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = t(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = t(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
  }
  interpolate(t, a, o, n) {
    let r, i, s;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, c = (h) => {
      if (h.indexOf(this.formatSeparator) < 0) {
        const b = Cm(a, l, h, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(b, void 0, o, {
          ...n,
          ...a,
          interpolationkey: h
        }) : b;
      }
      const m = h.split(this.formatSeparator), f = m.shift().trim(), p = m.join(this.formatSeparator).trim();
      return this.format(Cm(a, l, f, this.options.keySeparator, this.options.ignoreJSONStructure), p, o, {
        ...n,
        ...a,
        interpolationkey: f
      });
    };
    this.resetRegExp();
    const u = n?.missingInterpolationHandler || this.options.missingInterpolationHandler, d = n?.interpolation?.skipOnVariables !== void 0 ? n.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (h) => Gl(h)
    }, {
      regex: this.regexp,
      safeValue: (h) => this.escapeValue ? Gl(this.escape(h)) : Gl(h)
    }].forEach((h) => {
      for (s = 0; r = h.regex.exec(t); ) {
        const m = r[1].trim();
        if (i = c(m), i === void 0)
          if (typeof u == "function") {
            const p = u(t, r, n);
            i = ce(p) ? p : "";
          } else if (n && Object.prototype.hasOwnProperty.call(n, m))
            i = "";
          else if (d) {
            i = r[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${m} for interpolating ${t}`), i = "";
        else !ce(i) && !this.useRawValueToEscape && (i = fm(i));
        const f = h.safeValue(i);
        if (t = t.replace(r[0], f), d ? (h.regex.lastIndex += i.length, h.regex.lastIndex -= r[0].length) : h.regex.lastIndex = 0, s++, s >= this.maxReplaces)
          break;
      }
    }), t;
  }
  nest(t, a, o = {}) {
    let n, r, i;
    const s = (l, c) => {
      const u = this.nestingOptionsSeparator;
      if (l.indexOf(u) < 0) return l;
      const d = l.split(new RegExp(`${u}[ ]*{`));
      let h = `{${d[1]}`;
      l = d[0], h = this.interpolate(h, i);
      const m = h.match(/'/g), f = h.match(/"/g);
      ((m?.length ?? 0) % 2 === 0 && !f || f.length % 2 !== 0) && (h = h.replace(/'/g, '"'));
      try {
        i = JSON.parse(h), c && (i = {
          ...c,
          ...i
        });
      } catch (p) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, p), `${l}${u}${h}`;
      }
      return i.defaultValue && i.defaultValue.indexOf(this.prefix) > -1 && delete i.defaultValue, l;
    };
    for (; n = this.nestingRegexp.exec(t); ) {
      let l = [];
      i = {
        ...o
      }, i = i.replace && !ce(i.replace) ? i.replace : i, i.applyPostProcessor = !1, delete i.defaultValue;
      const c = /{.*}/.test(n[1]) ? n[1].lastIndexOf("}") + 1 : n[1].indexOf(this.formatSeparator);
      if (c !== -1 && (l = n[1].slice(c).split(this.formatSeparator).map((u) => u.trim()).filter(Boolean), n[1] = n[1].slice(0, c)), r = a(s.call(this, n[1].trim(), i), i), r && n[0] === t && !ce(r)) return r;
      ce(r) || (r = fm(r)), r || (this.logger.warn(`missed to resolve ${n[1]} for nesting ${t}`), r = ""), l.length && (r = l.reduce((u, d) => this.format(u, d, o.lng, {
        ...o,
        interpolationkey: n[1].trim()
      }), r.trim())), t = t.replace(n[0], r), this.regexp.lastIndex = 0;
    }
    return t;
  }
}
const qDe = (e) => {
  let t = e.toLowerCase().trim();
  const a = {};
  if (e.indexOf("(") > -1) {
    const o = e.split("(");
    t = o[0].toLowerCase().trim();
    const n = o[1].substring(0, o[1].length - 1);
    t === "currency" && n.indexOf(":") < 0 ? a.currency || (a.currency = n.trim()) : t === "relativetime" && n.indexOf(":") < 0 ? a.range || (a.range = n.trim()) : n.split(";").forEach((r) => {
      if (r) {
        const [i, ...s] = r.split(":"), l = s.join(":").trim().replace(/^'+|'+$/g, ""), c = i.trim();
        a[c] || (a[c] = l), l === "false" && (a[c] = !1), l === "true" && (a[c] = !0), isNaN(l) || (a[c] = parseInt(l, 10));
      }
    });
  }
  return {
    formatName: t,
    formatOptions: a
  };
}, Em = (e) => {
  const t = {};
  return (a, o, n) => {
    let r = n;
    n && n.interpolationkey && n.formatParams && n.formatParams[n.interpolationkey] && n[n.interpolationkey] && (r = {
      ...r,
      [n.interpolationkey]: void 0
    });
    const i = o + JSON.stringify(r);
    let s = t[i];
    return s || (s = e(qn(o), n), t[i] = s), s(a);
  };
}, HDe = (e) => (t, a, o) => e(qn(a), o)(t);
class GDe {
  constructor(t = {}) {
    this.logger = Zt.create("formatter"), this.options = t, this.init(t);
  }
  init(t, a = {
    interpolation: {}
  }) {
    this.formatSeparator = a.interpolation.formatSeparator || ",";
    const o = a.cacheInBuiltFormats ? Em : HDe;
    this.formats = {
      number: o((n, r) => {
        const i = new Intl.NumberFormat(n, {
          ...r
        });
        return (s) => i.format(s);
      }),
      currency: o((n, r) => {
        const i = new Intl.NumberFormat(n, {
          ...r,
          style: "currency"
        });
        return (s) => i.format(s);
      }),
      datetime: o((n, r) => {
        const i = new Intl.DateTimeFormat(n, {
          ...r
        });
        return (s) => i.format(s);
      }),
      relativetime: o((n, r) => {
        const i = new Intl.RelativeTimeFormat(n, {
          ...r
        });
        return (s) => i.format(s, r.range || "day");
      }),
      list: o((n, r) => {
        const i = new Intl.ListFormat(n, {
          ...r
        });
        return (s) => i.format(s);
      })
    };
  }
  add(t, a) {
    this.formats[t.toLowerCase().trim()] = a;
  }
  addCached(t, a) {
    this.formats[t.toLowerCase().trim()] = Em(a);
  }
  format(t, a, o, n = {}) {
    const r = a.split(this.formatSeparator);
    if (r.length > 1 && r[0].indexOf("(") > 1 && r[0].indexOf(")") < 0 && r.find((i) => i.indexOf(")") > -1)) {
      const i = r.findIndex((s) => s.indexOf(")") > -1);
      r[0] = [r[0], ...r.splice(1, i)].join(this.formatSeparator);
    }
    return r.reduce((i, s) => {
      const {
        formatName: l,
        formatOptions: c
      } = qDe(s);
      if (this.formats[l]) {
        let u = i;
        try {
          const d = n?.formatParams?.[n.interpolationkey] || {}, h = d.locale || d.lng || n.locale || n.lng || o;
          u = this.formats[l](i, h, {
            ...c,
            ...n,
            ...d
          });
        } catch (d) {
          this.logger.warn(d);
        }
        return u;
      } else
        this.logger.warn(`there was no format function for ${l}`);
      return i;
    }, t);
  }
}
const KDe = (e, t) => {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
};
class JDe extends qs {
  constructor(t, a, o, n = {}) {
    super(), this.backend = t, this.store = a, this.services = o, this.languageUtils = o.languageUtils, this.options = n, this.logger = Zt.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = n.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = n.maxRetries >= 0 ? n.maxRetries : 5, this.retryTimeout = n.retryTimeout >= 1 ? n.retryTimeout : 350, this.state = {}, this.queue = [], this.backend?.init?.(o, n.backend, n);
  }
  queueLoad(t, a, o, n) {
    const r = {}, i = {}, s = {}, l = {};
    return t.forEach((c) => {
      let u = !0;
      a.forEach((d) => {
        const h = `${c}|${d}`;
        !o.reload && this.store.hasResourceBundle(c, d) ? this.state[h] = 2 : this.state[h] < 0 || (this.state[h] === 1 ? i[h] === void 0 && (i[h] = !0) : (this.state[h] = 1, u = !1, i[h] === void 0 && (i[h] = !0), r[h] === void 0 && (r[h] = !0), l[d] === void 0 && (l[d] = !0)));
      }), u || (s[c] = !0);
    }), (Object.keys(r).length || Object.keys(i).length) && this.queue.push({
      pending: i,
      pendingCount: Object.keys(i).length,
      loaded: {},
      errors: [],
      callback: n
    }), {
      toLoad: Object.keys(r),
      pending: Object.keys(i),
      toLoadLanguages: Object.keys(s),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(t, a, o) {
    const n = t.split("|"), r = n[0], i = n[1];
    a && this.emit("failedLoading", r, i, a), !a && o && this.store.addResourceBundle(r, i, o, void 0, void 0, {
      skipCopy: !0
    }), this.state[t] = a ? -1 : 2, a && o && (this.state[t] = 0);
    const s = {};
    this.queue.forEach((l) => {
      DDe(l.loaded, [r], i), KDe(l, t), a && l.errors.push(a), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((c) => {
        s[c] || (s[c] = {});
        const u = l.loaded[c];
        u.length && u.forEach((d) => {
          s[c][d] === void 0 && (s[c][d] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", s), this.queue = this.queue.filter((l) => !l.done);
  }
  read(t, a, o, n = 0, r = this.retryTimeout, i) {
    if (!t.length) return i(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: t,
        ns: a,
        fcName: o,
        tried: n,
        wait: r,
        callback: i
      });
      return;
    }
    this.readingCalls++;
    const s = (c, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const d = this.waitingReads.shift();
        this.read(d.lng, d.ns, d.fcName, d.tried, d.wait, d.callback);
      }
      if (c && u && n < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, t, a, o, n + 1, r * 2, i);
        }, r);
        return;
      }
      i(c, u);
    }, l = this.backend[o].bind(this.backend);
    if (l.length === 2) {
      try {
        const c = l(t, a);
        c && typeof c.then == "function" ? c.then((u) => s(null, u)).catch(s) : s(null, c);
      } catch (c) {
        s(c);
      }
      return;
    }
    return l(t, a, s);
  }
  prepareLoading(t, a, o = {}, n) {
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), n && n();
    ce(t) && (t = this.languageUtils.toResolveHierarchy(t)), ce(a) && (a = [a]);
    const r = this.queueLoad(t, a, o, n);
    if (!r.toLoad.length)
      return r.pending.length || n(), null;
    r.toLoad.forEach((i) => {
      this.loadOne(i);
    });
  }
  load(t, a, o) {
    this.prepareLoading(t, a, {}, o);
  }
  reload(t, a, o) {
    this.prepareLoading(t, a, {
      reload: !0
    }, o);
  }
  loadOne(t, a = "") {
    const o = t.split("|"), n = o[0], r = o[1];
    this.read(n, r, "read", void 0, void 0, (i, s) => {
      i && this.logger.warn(`${a}loading namespace ${r} for language ${n} failed`, i), !i && s && this.logger.log(`${a}loaded namespace ${r} for language ${n}`, s), this.loaded(t, i, s);
    });
  }
  saveMissing(t, a, o, n, r, i = {}, s = () => {
  }) {
    if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(a)) {
      this.logger.warn(`did not save key "${o}" as the namespace "${a}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(o == null || o === "")) {
      if (this.backend?.create) {
        const l = {
          ...i,
          isUpdate: r
        }, c = this.backend.create.bind(this.backend);
        if (c.length < 6)
          try {
            let u;
            c.length === 5 ? u = c(t, a, o, n, l) : u = c(t, a, o, n), u && typeof u.then == "function" ? u.then((d) => s(null, d)).catch(s) : s(null, u);
          } catch (u) {
            s(u);
          }
        else
          c(t, a, o, n, s, l);
      }
      !t || !t[0] || this.store.addResource(t[0], a, o, n);
    }
  }
}
const jm = () => ({
  debug: !1,
  initAsync: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (e) => {
    let t = {};
    if (typeof e[1] == "object" && (t = e[1]), ce(e[1]) && (t.defaultValue = e[1]), ce(e[2]) && (t.tDescription = e[2]), typeof e[2] == "object" || typeof e[3] == "object") {
      const a = e[3] || e[2];
      Object.keys(a).forEach((o) => {
        t[o] = a[o];
      });
    }
    return t;
  },
  interpolation: {
    escapeValue: !0,
    format: (e) => e,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  },
  cacheInBuiltFormats: !0
}), Om = (e) => (ce(e.ns) && (e.ns = [e.ns]), ce(e.fallbackLng) && (e.fallbackLng = [e.fallbackLng]), ce(e.fallbackNS) && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs?.indexOf?.("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), typeof e.initImmediate == "boolean" && (e.initAsync = e.initImmediate), e), Ur = () => {
}, ZDe = (e) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((t) => {
    typeof e[t] == "function" && (e[t] = e[t].bind(e));
  });
};
class Hn extends qs {
  constructor(t = {}, a) {
    if (super(), this.options = Om(t), this.services = {}, this.logger = Zt, this.modules = {
      external: []
    }, ZDe(this), a && !this.isInitialized && !t.isClone) {
      if (!this.options.initAsync)
        return this.init(t, a), this;
      setTimeout(() => {
        this.init(t, a);
      }, 0);
    }
  }
  init(t = {}, a) {
    this.isInitializing = !0, typeof t == "function" && (a = t, t = {}), t.defaultNS == null && t.ns && (ce(t.ns) ? t.defaultNS = t.ns : t.ns.indexOf("translation") < 0 && (t.defaultNS = t.ns[0]));
    const o = jm();
    this.options = {
      ...o,
      ...this.options,
      ...Om(t)
    }, this.options.interpolation = {
      ...o.interpolation,
      ...this.options.interpolation
    }, t.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = t.keySeparator), t.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = t.nsSeparator);
    const n = (s) => s ? typeof s == "function" ? new s() : s : null;
    if (!this.options.isClone) {
      this.modules.logger ? Zt.init(n(this.modules.logger), this.options) : Zt.init(null, this.options);
      let s;
      this.modules.formatter ? s = this.modules.formatter : s = GDe;
      const l = new xm(this.options);
      this.store = new ym(this.options.resources, this.options);
      const c = this.services;
      c.logger = Zt, c.resourceStore = this.store, c.languageUtils = l, c.pluralResolver = new VDe(l, {
        prepend: this.options.pluralSeparator,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), this.options.interpolation.format && this.options.interpolation.format !== o.interpolation.format && this.logger.deprecate("init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting"), s && (!this.options.interpolation.format || this.options.interpolation.format === o.interpolation.format) && (c.formatter = n(s), c.formatter.init && c.formatter.init(c, this.options), this.options.interpolation.format = c.formatter.format.bind(c.formatter)), c.interpolator = new UDe(this.options), c.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, c.backendConnector = new JDe(n(this.modules.backend), c.resourceStore, c, this.options), c.backendConnector.on("*", (u, ...d) => {
        this.emit(u, ...d);
      }), this.modules.languageDetector && (c.languageDetector = n(this.modules.languageDetector), c.languageDetector.init && c.languageDetector.init(c, this.options.detection, this.options)), this.modules.i18nFormat && (c.i18nFormat = n(this.modules.i18nFormat), c.i18nFormat.init && c.i18nFormat.init(this)), this.translator = new Xi(this.services, this.options), this.translator.on("*", (u, ...d) => {
        this.emit(u, ...d);
      }), this.modules.external.forEach((u) => {
        u.init && u.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, a || (a = Ur), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const s = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      s.length > 0 && s[0] !== "dev" && (this.options.lng = s[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((s) => {
      this[s] = (...l) => this.store[s](...l);
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((s) => {
      this[s] = (...l) => (this.store[s](...l), this);
    });
    const r = xn(), i = () => {
      const s = (l, c) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), r.resolve(c), a(l, c);
      };
      if (this.languages && !this.isInitialized) return s(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, s);
    };
    return this.options.resources || !this.options.initAsync ? i() : setTimeout(i, 0), r;
  }
  loadResources(t, a = Ur) {
    let o = a;
    const n = ce(t) ? t : this.language;
    if (typeof t == "function" && (o = t), !this.options.resources || this.options.partialBundledLanguages) {
      if (n?.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return o();
      const r = [], i = (s) => {
        !s || s === "cimode" || this.services.languageUtils.toResolveHierarchy(s).forEach((l) => {
          l !== "cimode" && r.indexOf(l) < 0 && r.push(l);
        });
      };
      n ? i(n) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((s) => i(s)), this.options.preload?.forEach?.((s) => i(s)), this.services.backendConnector.load(r, this.options.ns, (s) => {
        !s && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), o(s);
      });
    } else
      o(null);
  }
  reloadResources(t, a, o) {
    const n = xn();
    return typeof t == "function" && (o = t, t = void 0), typeof a == "function" && (o = a, a = void 0), t || (t = this.languages), a || (a = this.options.ns), o || (o = Ur), this.services.backendConnector.reload(t, a, (r) => {
      n.resolve(), o(r);
    }), n;
  }
  use(t) {
    if (!t) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!t.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return t.type === "backend" && (this.modules.backend = t), (t.type === "logger" || t.log && t.warn && t.error) && (this.modules.logger = t), t.type === "languageDetector" && (this.modules.languageDetector = t), t.type === "i18nFormat" && (this.modules.i18nFormat = t), t.type === "postProcessor" && Mk.addPostProcessor(t), t.type === "formatter" && (this.modules.formatter = t), t.type === "3rdParty" && this.modules.external.push(t), this;
  }
  setResolvedLanguage(t) {
    if (!(!t || !this.languages) && !(["cimode", "dev"].indexOf(t) > -1)) {
      for (let a = 0; a < this.languages.length; a++) {
        const o = this.languages[a];
        if (!(["cimode", "dev"].indexOf(o) > -1) && this.store.hasLanguageSomeTranslations(o)) {
          this.resolvedLanguage = o;
          break;
        }
      }
      !this.resolvedLanguage && this.languages.indexOf(t) < 0 && this.store.hasLanguageSomeTranslations(t) && (this.resolvedLanguage = t, this.languages.unshift(t));
    }
  }
  changeLanguage(t, a) {
    this.isLanguageChangingTo = t;
    const o = xn();
    this.emit("languageChanging", t);
    const n = (s) => {
      this.language = s, this.languages = this.services.languageUtils.toResolveHierarchy(s), this.resolvedLanguage = void 0, this.setResolvedLanguage(s);
    }, r = (s, l) => {
      l ? this.isLanguageChangingTo === t && (n(l), this.translator.changeLanguage(l), this.isLanguageChangingTo = void 0, this.emit("languageChanged", l), this.logger.log("languageChanged", l)) : this.isLanguageChangingTo = void 0, o.resolve((...c) => this.t(...c)), a && a(s, (...c) => this.t(...c));
    }, i = (s) => {
      !t && !s && this.services.languageDetector && (s = []);
      const l = ce(s) ? s : s && s[0], c = this.store.hasLanguageSomeTranslations(l) ? l : this.services.languageUtils.getBestMatchFromCodes(ce(s) ? [s] : s);
      c && (this.language || n(c), this.translator.language || this.translator.changeLanguage(c), this.services.languageDetector?.cacheUserLanguage?.(c)), this.loadResources(c, (u) => {
        r(u, c);
      });
    };
    return !t && this.services.languageDetector && !this.services.languageDetector.async ? i(this.services.languageDetector.detect()) : !t && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(i) : this.services.languageDetector.detect(i) : i(t), o;
  }
  getFixedT(t, a, o) {
    const n = (r, i, ...s) => {
      let l;
      typeof i != "object" ? l = this.options.overloadTranslationOptionHandler([r, i].concat(s)) : l = {
        ...i
      }, l.lng = l.lng || n.lng, l.lngs = l.lngs || n.lngs, l.ns = l.ns || n.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || o || n.keyPrefix);
      const c = this.options.keySeparator || ".";
      let u;
      return l.keyPrefix && Array.isArray(r) ? u = r.map((d) => (typeof d == "function" && (d = Qc(d, {
        ...this.options,
        ...i
      })), `${l.keyPrefix}${c}${d}`)) : (typeof r == "function" && (r = Qc(r, {
        ...this.options,
        ...i
      })), u = l.keyPrefix ? `${l.keyPrefix}${c}${r}` : r), this.t(u, l);
    };
    return ce(t) ? n.lng = t : n.lngs = t, n.ns = a, n.keyPrefix = o, n;
  }
  t(...t) {
    return this.translator?.translate(...t);
  }
  exists(...t) {
    return this.translator?.exists(...t);
  }
  setDefaultNamespace(t) {
    this.options.defaultNS = t;
  }
  hasLoadedNamespace(t, a = {}) {
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const o = a.lng || this.resolvedLanguage || this.languages[0], n = this.options ? this.options.fallbackLng : !1, r = this.languages[this.languages.length - 1];
    if (o.toLowerCase() === "cimode") return !0;
    const i = (s, l) => {
      const c = this.services.backendConnector.state[`${s}|${l}`];
      return c === -1 || c === 0 || c === 2;
    };
    if (a.precheck) {
      const s = a.precheck(this, i);
      if (s !== void 0) return s;
    }
    return !!(this.hasResourceBundle(o, t) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || i(o, t) && (!n || i(r, t)));
  }
  loadNamespaces(t, a) {
    const o = xn();
    return this.options.ns ? (ce(t) && (t = [t]), t.forEach((n) => {
      this.options.ns.indexOf(n) < 0 && this.options.ns.push(n);
    }), this.loadResources((n) => {
      o.resolve(), a && a(n);
    }), o) : (a && a(), Promise.resolve());
  }
  loadLanguages(t, a) {
    const o = xn();
    ce(t) && (t = [t]);
    const n = this.options.preload || [], r = t.filter((i) => n.indexOf(i) < 0 && this.services.languageUtils.isSupportedCode(i));
    return r.length ? (this.options.preload = n.concat(r), this.loadResources((i) => {
      o.resolve(), a && a(i);
    }), o) : (a && a(), Promise.resolve());
  }
  dir(t) {
    if (t || (t = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language)), !t) return "rtl";
    try {
      const n = new Intl.Locale(t);
      if (n && n.getTextInfo) {
        const r = n.getTextInfo();
        if (r && r.direction) return r.direction;
      }
    } catch {
    }
    const a = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], o = this.services?.languageUtils || new xm(jm());
    return t.toLowerCase().indexOf("-latn") > 1 ? "ltr" : a.indexOf(o.getLanguagePartFromCode(t)) > -1 || t.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance(t = {}, a) {
    return new Hn(t, a);
  }
  cloneInstance(t = {}, a = Ur) {
    const o = t.forkResourceStore;
    o && delete t.forkResourceStore;
    const n = {
      ...this.options,
      ...t,
      isClone: !0
    }, r = new Hn(n);
    if ((t.debug !== void 0 || t.prefix !== void 0) && (r.logger = r.logger.clone(t)), ["store", "services", "language"].forEach((i) => {
      r[i] = this[i];
    }), r.services = {
      ...this.services
    }, r.services.utils = {
      hasLoadedNamespace: r.hasLoadedNamespace.bind(r)
    }, o) {
      const i = Object.keys(this.store.data).reduce((s, l) => (s[l] = {
        ...this.store.data[l]
      }, s[l] = Object.keys(s[l]).reduce((c, u) => (c[u] = {
        ...s[l][u]
      }, c), s[l]), s), {});
      r.store = new ym(i, n), r.services.resourceStore = r.store;
    }
    return r.translator = new Xi(r.services, n), r.translator.on("*", (i, ...s) => {
      r.emit(i, ...s);
    }), r.init(n, a), r.translator.options = n, r.translator.backendConnector.services.utils = {
      hasLoadedNamespace: r.hasLoadedNamespace.bind(r)
    }, r;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const st = Hn.createInstance();
st.createInstance = Hn.createInstance;
const YDe = st.createInstance;
st.dir;
st.init;
st.loadResources;
st.reloadResources;
st.use;
st.changeLanguage;
st.getFixedT;
st.t;
st.exists;
st.setDefaultNamespace;
st.hasLoadedNamespace;
st.loadNamespaces;
st.loadLanguages;
const XDe = {
  "modal.emailVerif.alreadyVerified.desc": "Din e-mail er klar! Log ind for at fortsætte.",
  "modal.emailVerif.alreadyVerified.title": "Din e-mailadresse er allerede blevet bekræftet",
  "modal.emailVerif.callout": "Vi har sendt en bekræftelsesmail til <b>{{email}}</b>.",
  "modal.emailVerif.desc": "Tjek din indbakke. Linket i denne e-mail udløber om 24 timer.",
  "modal.emailVerif.linkExpired.desc": "Log ind for at modtage et nyt bekræftelseslink i din indbakke.",
  "modal.emailVerif.linkExpired.title": "Dette link er udløbet",
  "modal.emailVerif.resend-email-link": "Send ny bekræftelsesmail",
  "modal.emailVerif.resend-email.rate-limit": "Du har nået grænsen for e-mailanmodninger. Prøv igen om 1 minut.",
  "modal.emailVerif.resend-link": "Send ny bekræftelsesmail.",
  "modal.emailVerif.title": "Bekræft din e-mailadresse",
  "modal.finishCreatingAccount.event": "Til en begivenhed",
  "modal.finishCreatingAccount.everyone_knows_homeexchange": "Alle kender til HomeExchange",
  "modal.finishCreatingAccount.facebook": "Facebook",
  "modal.finishCreatingAccount.firstName.error": "Indtast dit fornavn",
  "modal.finishCreatingAccount.friends_family": "Gennem venner, familie eller bekendte",
  "modal.finishCreatingAccount.hearAboutHE": "Hvor har du hørt om HomeExchange?",
  "modal.finishCreatingAccount.instagram": "Instagram",
  "modal.finishCreatingAccount.lastName.error": "Indtast dit efternavn",
  "modal.finishCreatingAccount.other": "Andet",
  "modal.finishCreatingAccount.phone_number": "Telefonnummer",
  "modal.finishCreatingAccount.phone_number.error": "Indtast dit telefonnummer",
  "modal.finishCreatingAccount.pleaseSpecify": "Angiv venligst",
  "modal.finishCreatingAccount.press": "I pressen",
  "modal.finishCreatingAccount.press_online": "Online",
  "modal.finishCreatingAccount.press_print": "Trykte medier",
  "modal.finishCreatingAccount.radio": "I radioen",
  "modal.finishCreatingAccount.referral": "Henvisningskode",
  "modal.finishCreatingAccount.referralCode.error": "Denne henvisningskode er ugyldig",
  "modal.finishCreatingAccount.search_engine": "På en søgemaskine",
  "modal.finishCreatingAccount.social_media": "Via sociale medier",
  "modal.finishCreatingAccount.social_network_other": "Andre sociale medier (angiv venligst)",
  "modal.finishCreatingAccount.title": "Færdiggør oprettelsen af din konto",
  "modal.finishCreatingAccount.tv": "I fjernsynet",
  "modal.finishCreatingAccount.tv_ad": "I en reklame",
  "modal.finishCreatingAccount.tv_show": "Under et tv-indslag/tv-program",
  "modal.genericError.desc": "Platformen kan være nede, eller der kan være en midlertidig fejl hos os, så prøv venligst igen.<br><br>Vi registrerer automatisk disse fejl, men hvis problemet fortsætter, er du velkommen til at kontakte os på:<br><a>tech@homeexchange.com</a>",
  "modal.genericError.title": "Hov! Der opstod en fejl",
  "modal.noEmailRecieved.desc": "<b>Har du ikke modtaget en e-mail?</b>Tjek din spammappe, og at du har stavet din e-mail korrekt, inden du anmoder om en ny bekræftelsesmail.",
  "modal.noEmailRecieved.error": "Der opstod en fejl. Prøv igen senere.",
  "modal.verifyEmail.emailResent.toast": "Vi har sendt dig en ny bekræftelsesmail til <b>{{email}}</b>.",
  "signin-modal.apple.button": "Log ind med Apple",
  "signin-modal.button": "Log ind",
  "signin-modal.email.button": "Log ind",
  "signin-modal.error.content": "",
  "signin-modal.error.email_no_verified.content": "",
  "signin-modal.error.email_no_verified.title": "",
  "signin-modal.error.title": "",
  "signin-modal.facebook.button": "Log ind med Facebook",
  "signin-modal.no-account": "Nyt medlem?",
  "signin-modal.reset-password": "",
  "signin-modal.title": "",
  "signin.modal.reset-password": "Skift kodeord",
  "signup-modal.accept-cgu": "Ved at oprette en profil accepterer jeg de",
  "signup-modal.apple.button": "Log ind med Apple",
  "signup-modal.button": "Tilmeld dig",
  "signup-modal.cgu.link": "Generelle brugervilkår",
  "signup-modal.description": "Rejs på en ny måde med HomeExchange: Bliv budt velkommen over hele verden og spar penge!",
  "signup-modal.email.button": "Tilmeld dig med din e-mailadresse",
  "signup-modal.email.form.submit": "",
  "signup-modal.error.content": "",
  "signup-modal.error.title": "",
  "signup-modal.facebook.button": "Tilmeld dig med Facebook",
  "signup-modal.have-an-account": "Har du allerede en profil?"
}, QDe = "Studio", eNe = "{{count}} soveværelse", tNe = "{{count}} soveværelser", aNe = "", oNe = "{{count}} seng", nNe = "{{count}} senge", rNe = "Voksne", iNe = "Babyer", sNe = "Din kalender er blevet opdateret.", lNe = "En måned", cNe = "Præcise datoer", uNe = "Uge", dNe = "", gNe = "", hNe = "", pNe = "", mNe = "To uger", fNe = "Annuller", bNe = "Børn", _Ne = "Datoer", vNe = "Slet", yNe = "Beskrivelse", wNe = "Destination", kNe = "Sådan!", xNe = "Rediger", $Ne = "Enhver form for udveksling", SNe = "Badekar", CNe = "Grill", ENe = "Cykel", jNe = "Bil", ONe = "Kat", zNe = "By", ANe = "På landet", PNe = "Opvaskemaskine", DNe = "Hund", NNe = "Tørretumbler", RNe = "Elevator", INe = "Favoritboliger", TNe = "Pejs/brændeovn", LNe = "Lejlighed", MNe = "Privat have", WNe = "under {{max}} GP", BNe = "fra {{min}} GP", FNe = "Mellem {{min}} og {{max}} GP", VNe = "Privat fitnessrum", UNe = "Hus", qNe = "En Ø", HNe = "Isoleret", GNe = "Jacuzzi", KNe = "Søer", JNe = "Collection-hjem", ZNe = "Bjerge", YNe = "{{count}} badeværelser", XNe = "Andre dyr", QNe = "Klaver", eRe = "Legeplads", tRe = "Primære bolig", aRe = "Gensifig udveksling", oRe = "Omvendt søgning", nRe = "Flod", rRe = "Kystnær", iRe = "Feriebolig", sRe = "TV", lRe = "Landsby", cRe = "Wi-Fi", uRe = "Filtre", dRe = "Faste datoer", gRe = "En måned i {{date}}", hRe = "En weekend i {{date}}", pRe = "En uge i {{date}}", mRe = "To uger i {{date}}", fRe = "Fleksible datoer", bRe = "Gæster", _Re = "boliger", vRe = "Sidste minut", yRe = "Lokation", wRe = "Rediger", kRe = "Navn", xRe = "Næste", $Re = "", SRe = "", CRe = "{{count}} voksne", ERe = "", jRe = "", ORe = "{{count}} babyer", zRe = "", ARe = "", PRe = "{{count}} børn", DRe = "", NRe = "{{count}} gæst", RRe = "{{count}} gæster", IRe = "Telefonnummerets format er ikke gyldigt.", TRe = "Modtag e-mailnotifikationer", LRe = "Gem", MRe = "Ingen lokationer fundet", WRe = "Flere beskeder", BRe = "Rejseliste", FRe = "", VRe = "valgfrit", URe = {
  "autocomplete.button": "Søg",
  "autocomplete.placeholder": "Hvor skal du hen ?",
  bedroomsNumbers_zero: QDe,
  bedroomsNumbers_one: eNe,
  bedroomsNumbers_other: tNe,
  beds_zero: aNe,
  beds_one: oNe,
  beds_other: nNe,
  "button.free-signup": "Tilmeld dig gratis",
  "button.validate": "Bekræft",
  "common.try-again": "Prøv igen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Må ikke overstige {{limit}} tegn",
  "error.reload": "Opdater siden",
  "error.return-homepage": "Tilbage til startsiden",
  "error.subtitle": "Denne side kan desværre ikke nås..",
  "error.title": "Der opstod en fejl på siden",
  "errors.unable_to_submit.subtitle": '"Din formular kunne desværre ikke \\nindsendes lige nu. Prøv igen \\nsenere."',
  "errors.unable_to_submit.title": "Ups, vi løb ind i et problem",
  "global.back": "Tilbage",
  "global.cancel": "Annuller",
  "global.collection.browsehomes": "Se boliger",
  "global.collection.contactus": "Kontakt os",
  "global.confirm": "Bekræft",
  "global.continue": "Fortsæt",
  "global.getStarted": "Kom godt i gang",
  "global.login": "Log ind",
  "global.select": "Vælg",
  global_adults: rNe,
  global_babies: iNe,
  global_calendarUpdated_toast: sNe,
  global_calendar_aMonth: lNe,
  global_calendar_exactDates: cNe,
  global_calendar_oneWeek: uNe,
  global_calendar_oneWeekend: dNe,
  global_calendar_plusMinusDay_zero: gNe,
  global_calendar_plusMinusDay_one: hNe,
  global_calendar_plusMinusDay_other: pNe,
  global_calendar_twoWeeks: mNe,
  global_cancel: fNe,
  global_children: bNe,
  global_dates: _Ne,
  global_delete: vNe,
  global_description: yNe,
  global_destination: wNe,
  global_done: kNe,
  global_edit: xNe,
  "global_filter_a-c": "Klimaanlæg",
  global_filter_available: $Ne,
  "global_filter_baby-bed": "Babysenge",
  "global_filter_baby-gear": "Babyudstyr",
  "global_filter_balcony-terrace": "Altan/terrasse",
  global_filter_bathtub: SNe,
  global_filter_bbq: CNe,
  global_filter_bicycle: ENe,
  global_filter_car: jNe,
  global_filter_cat: ONe,
  "global_filter_children-welcome": "Børn velkomne",
  global_filter_cities: zNe,
  "global_filter_cleaning-person": "Rengøringsperson",
  global_filter_countryside: ANe,
  "global_filter_dedicated-workspace": "Arbejdsområde",
  "global_filter_disabled-access": "Handicapvenlig bolig",
  global_filter_dishwasher: PNe,
  global_filter_dog: DNe,
  global_filter_dryer: NNe,
  "global_filter_eco-level": "Kun bæredygtige boliger",
  "global_filter_electric-car-plug": "Stik til elbil",
  global_filter_elevator: RNe,
  global_filter_favorite: INe,
  global_filter_fireplace: TNe,
  global_filter_flat: LNe,
  global_filter_garden: MNe,
  "global_filter_guest-wanted": "GuestPoints bytte",
  global_filter_guestPointsMax: WNe,
  global_filter_guestPointsMin: BNe,
  global_filter_guestPointsMinMax: FNe,
  global_filter_gym: VNe,
  "global_filter_heating-system": "Varmeanlæg",
  "global_filter_high-speed-connexion": "Hurtigt internet",
  global_filter_home: UNe,
  "global_filter_home-verified": "Godkendte boliger",
  global_filter_island: qNe,
  global_filter_isolated: HNe,
  global_filter_jacuzzi: GNe,
  "global_filter_kids-toys": "Legetøj til børn",
  global_filter_lakes: KNe,
  global_filter_luxury: JNe,
  global_filter_mountains: ZNe,
  "global_filter_no-bed-up": "Ingen midlertidige senge",
  global_filter_numOfBathrooms: YNe,
  global_filter_other: XNe,
  "global_filter_parking-space": "Privat parkeringsplads",
  "global_filter_pets-welcome": "Kæledyr er velkomne",
  global_filter_piano: QNe,
  global_filter_playground: eRe,
  global_filter_primary: tRe,
  "global_filter_public-transit-access": "Adgang til offentlig transport",
  global_filter_reciprocal: aRe,
  "global_filter_response-rate-above-threshold": "Svarprocent ≥ Gennemsnitlig",
  global_filter_reverse: oRe,
  global_filter_river: nRe,
  global_filter_seaside: rRe,
  global_filter_secondary: iRe,
  "global_filter_secured-pool": "Sikret pool",
  "global_filter_smokers-welcome": "Rygere er velkomne",
  "global_filter_swimming-pool": "Pool",
  global_filter_tv: sRe,
  global_filter_villages: lRe,
  "global_filter_washing-machine": "Vaskemaskine",
  "global_filter_whole-unit": "Hele enheden",
  global_filter_wifi: cRe,
  global_filters: uRe,
  global_fixDates: dRe,
  global_flexDates_aMonth: gRe,
  global_flexDates_aWeekend: hRe,
  global_flexDates_oneWeek: pRe,
  global_flexDates_twoWeek: mRe,
  global_flexibleDates: fRe,
  global_guests: bRe,
  global_homes: _Re,
  global_lastMinute: vRe,
  global_location: yRe,
  global_modify: wRe,
  global_name: kRe,
  global_next: xRe,
  global_numberOfAdults_zero: $Re,
  global_numberOfAdults_one: SRe,
  global_numberOfAdults_other: CRe,
  global_numberOfBabies_zero: ERe,
  global_numberOfBabies_one: jRe,
  global_numberOfBabies_other: ORe,
  global_numberOfChildren_zero: zRe,
  global_numberOfChildren_one: ARe,
  global_numberOfChildren_other: PRe,
  global_numberOfGuests_zero: DRe,
  global_numberOfGuests_one: NRe,
  global_numberOfGuests_other: RRe,
  global_phoneNumber_notValid: IRe,
  global_receiveEmailAlerts: TRe,
  global_save: LRe,
  global_searchBar_noLocationFound: MRe,
  global_seeMore_link: WRe,
  global_travelWishlist: BRe,
  "modal.error-occured.content": "Vi beklager ulejligheden, men prøv \\nvenligst igen.",
  "modal.error-occured.title": "Åh nej, der er opstået en fejl!",
  no_result: FRe,
  optional: VRe,
  "privacy-policy": "Privatpolitik"
}, qRe = "https://www.homeexchange.com/blog/", HRe = "/p/general-terms-of-use", GRe = "https://www.homeexchange.com/da/p/community-da", KRe = "https://homeexchangehelp.zendesk.com/hc/en-us", JRe = "", ZRe = "https://www.homeexchange.com/da/p/service-homeexchange-da", YRe = "https://www.homeexchange.com/da/p/guestpoints-da", XRe = "https://www.homeexchange.com/da/p/press-da", QRe = "https://www.homeexchange.com/p/fortalt-af-medlemmerne", eIe = "", tIe = "", aIe = "https://www.homeexchange.com/da/p/hvor-velkomsten-virkelig-begynder", oIe = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/da/p/about-us-da",
  blog: qRe,
  cgu: HRe,
  community: GRe,
  "contact-us": "https://www.homeexchange.com/da/kontakt-os-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: KRe,
  forum: JRe,
  guarantees: ZRe,
  guestpoints: YRe,
  "happiness-team": "https://www.homeexchange.com/da/p/happiness-team-da",
  "how-it-works": "https://www.homeexchange.com/da/p/hvordan-virker-det",
  "join-us": "https://www.homeexchange.com/da/p/join-us-da",
  "legal-notice": "/p/juridiske-vilkaar",
  "mobile-app": "https://www.homeexchange.com/da/p/mobil-app",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: XRe,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/da/p/subscription-homeexchange-da",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: QRe,
  travelWishlist_faq_links: eIe,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: tIe,
  values: aIe
}, nIe = "Fornavn", rIe = "Efternavn", iIe = "Tilføj til din rejseliste", sIe = "En opdateret rejseliste giver dig mulighed for at modtage flere anmodninger om gensidige boligbytninger.", lIe = "Er du sikker på, at du vil slette {{fullAddress}}?", cIe = "Dette er de filtre, du har valgt. Hvis du har skiftet mening, kan du slette nogle af dem nedenfor. Men hvis du gerne vil tilføje flere, skal du starte en ny søgning (selvom dette snart ændrer sig... vi giver dig besked)!", uIe = "Dette kan være et land, by eller en hel region. Hvis du vælger en bred lokation, er dine resultater muligvis mindre nøjagtige.", dIe = "Indtast et land, by eller region", gIe = "Se ledige boliger", hIe = "Når boliger med tilgængelighed matcher dine rejseplaner.", pIe = "Tilføj til din rejseliste", mIe = "{{fullAddress}} er blevet slettet fra din rejseliste.", fIe = "Vælg dine ideelle rejsedatoer (fleksible eller faste).", bIe = "Tilføj detaljer, der hjælper andre, som bruger den omvendte søgefunktion, med at se, hvorfor du er interesseret i deres lokation.", _Ie = "Angiv, hvor mange personer der rejser sammen med dig under denne tur.", vIe = "Hovsa! {{fullAddress}} kunne ikke gemmes til din rejseliste af en uventet årsag.", yIe = "Fortæl os, hvornår og hvorhen du ønsker at rejse for at modtage bytteanmodninger og notifikationer, så snart passende boliger bliver tilgængelige. Vi gemmer dine søgninger i din rejseliste!", wIe = "Er der andre rejseeventyr, du vil gå i gang med at planlægge?", kIe = "<updateDates>Opdater dine datoer</updateDates> for at fortsætte med at modtage relevante e-mailnotifikationer eller <delete>slet denne destination</delete> fra din rejseliste, hvis du ikke længere overvejer den.", xIe = "Disse datoer er i fortiden", $Ie = "{{fullAddress}} er blevet tilføjet til din rejseliste!", SIe = "{{fullAddress}} er blevet opdateret.", CIe = "Din søgning er gemt, og din kalender er blevet opdateret!", EIe = "Din søgning er blevet gemt. Du finder den i din rejseliste.", jIe = "Lær mere om rejselister", OIe = {
  firstname: nIe,
  lastname: rIe,
  modal_travelWishlist_addNew_title: iIe,
  modal_travelWishlist_delete_body: sIe,
  modal_travelWishlist_delete_title: lIe,
  modal_travelWishlist_filtersApplied_helper: cIe,
  modal_travelWishlist_location_helper: uIe,
  modal_travelWishlist_searchBar_placeholder: dIe,
  page_travelWishlist_card_cta: gIe,
  page_travelWishlist_card_emailAlerts_helper: hIe,
  page_travelWishlist_cta: pIe,
  page_travelWishlist_deleted_toast: mIe,
  page_travelWishlist_edit_dates_helper: fIe,
  page_travelWishlist_edit_description_helper: bIe,
  page_travelWishlist_edit_guests_helper: _Ie,
  page_travelWishlist_error_toast: vIe,
  page_travelWishlist_none_body: yIe,
  page_travelWishlist_none_subheader: wIe,
  page_travelWishlist_pastDates_desc: kIe,
  page_travelWishlist_pastDates_title: xIe,
  page_travelWishlist_saved_toast: $Ie,
  page_travelWishlist_updated_toast: SIe,
  search_travelWishlist_calendarUpdated_toast: CIe,
  search_travelWishlist_saved_toast: EIe,
  travelWishlist_faq: jIe
}, zIe = {
  "modal.emailVerif.alreadyVerified.desc": "Ihre E-Mail ist fertig! Melden Sie sich an, um fortzufahren.",
  "modal.emailVerif.alreadyVerified.title": "Ihre E-Mail-Adresse wurde bereits verifiziert",
  "modal.emailVerif.callout": "Eine Bestätigungs-E-Mail wurde an <b>{{email}}</b> gesendet.",
  "modal.emailVerif.desc": "Überprüfen Sie Ihren Posteingang. Der Link in dieser E-Mail läuft in 24 Stunden ab.",
  "modal.emailVerif.linkExpired.desc": "Um einen neuen Verifizierungslink per E-Mail zu erhalten, melden Sie sich bitte an.",
  "modal.emailVerif.linkExpired.title": "Dieser Link ist abgelaufen",
  "modal.emailVerif.resend-email-link": "E-Mail zur Verifizierung erneut senden",
  "modal.emailVerif.resend-email.rate-limit": "Sie haben das Limit für E-Mail-Anfragen erreicht. Versuchen Sie es in 1 Minute erneut.",
  "modal.emailVerif.resend-link": "E-Mail zur Verifizierung erneut senden",
  "modal.emailVerif.title": "Verifizieren Sie Ihre E-Mail-Adresse",
  "modal.finishCreatingAccount.event": "Bei einer Veranstaltung",
  "modal.finishCreatingAccount.everyone_knows_homeexchange": "Jeder kennt HomeExchange",
  "modal.finishCreatingAccount.facebook": "Facebook",
  "modal.finishCreatingAccount.firstName.error": "Geben Sie Ihren Vornamen ein",
  "modal.finishCreatingAccount.friends_family": "Durch Freunde, Familie oder Bekannte",
  "modal.finishCreatingAccount.hearAboutHE": "Wie haben Sie von HomeExchange erfahren?",
  "modal.finishCreatingAccount.instagram": "Instagram",
  "modal.finishCreatingAccount.lastName.error": "Geben Sie Ihren Nachnamen ein",
  "modal.finishCreatingAccount.other": "Anderes",
  "modal.finishCreatingAccount.phone_number": "Telefonnummer",
  "modal.finishCreatingAccount.phone_number.error": "Bitte geben Sie ihre Telefonnummer ein",
  "modal.finishCreatingAccount.pleaseSpecify": "Angeben",
  "modal.finishCreatingAccount.press": "In der Presse",
  "modal.finishCreatingAccount.press_online": "Im Internet",
  "modal.finishCreatingAccount.press_print": "Gedruckte Ausgabe",
  "modal.finishCreatingAccount.radio": "Im Radio",
  "modal.finishCreatingAccount.referral": "Empfehlungscode",
  "modal.finishCreatingAccount.referralCode.error": "Dieser Empfehlungscode ist ungültig",
  "modal.finishCreatingAccount.search_engine": "Über eine Suchmaschine",
  "modal.finishCreatingAccount.social_media": "Über soziale Medien",
  "modal.finishCreatingAccount.social_network_other": "Anderes soziales Netzwerk (bitte angeben)",
  "modal.finishCreatingAccount.title": "Schließen Sie die Erstellung Ihres Kontos ab",
  "modal.finishCreatingAccount.tv": "Im Fernsehen",
  "modal.finishCreatingAccount.tv_ad": "In der Werbung",
  "modal.finishCreatingAccount.tv_show": "In einer Reportage / TV-Sendung",
  "modal.genericError.desc": "Die Plattform ist möglicherweise nicht erreichbar oder es liegt ein vorübergehender Fehler auf unserer Seite vor. Bitte versuchen Sie es noch einmal.<br><br>Wir erfassen diese Fehler automatisch, aber wenn das Problem weiterhin besteht, können Sie uns gerne unter <br><a>tech@homeexchange.com</a> kontaktieren.",
  "modal.genericError.title": "Hoppla! Da ist etwas schiefgelaufen",
  "modal.noEmailRecieved.desc": "<b>Sie haben keine E-Mail erhalten?</b>Überprüfen Sie Ihren Spam-Ordner und die Schreibweise Ihrer E-Mail, bevor Sie eine weitere Bestätigungs-E-Mail anfordern.",
  "modal.noEmailRecieved.error": "Etwas ist schiefgelaufen. Bitte versuchen Sie es später noch einmal.",
  "modal.verifyEmail.emailResent.toast": "Wir haben Ihnen eine neue Bestätigungs-E-Mail an <b>{{email}}</b> geschickt.",
  "signin-modal.apple.button": "Mit Google verbinden",
  "signin-modal.button": "Einloggen",
  "signin-modal.email.button": "Einloggen",
  "signin-modal.error.content": "",
  "signin-modal.error.email_no_verified.content": "",
  "signin-modal.error.email_no_verified.title": "",
  "signin-modal.error.title": "",
  "signin-modal.facebook.button": "Mit Facebook verbinden",
  "signin-modal.no-account": "Noch keinen Account?",
  "signin-modal.reset-password": "",
  "signin-modal.title": "",
  "signin.modal.reset-password": "Passwort zurücksetzen",
  "signup-modal.accept-cgu": "Mit der Erstellung des Kontos akzeptiere ich die",
  "signup-modal.apple.button": "Melden Sie sich mit Apple an",
  "signup-modal.button": "Anmelden",
  "signup-modal.cgu.link": "Allgemeine Nutzungsbedingungen",
  "signup-modal.description": "Entdecken Sie dank Wohnungs-und Haustausch eine neue Art des Reisens: Seien Sie auf der ganzen Welt willkommen und sparen Sie Geld!",
  "signup-modal.email.button": "Mit E-Mail-Adresse anmelden",
  "signup-modal.email.form.submit": "",
  "signup-modal.error.content": "",
  "signup-modal.error.title": "",
  "signup-modal.facebook.button": "Mit Facebook anmelden",
  "signup-modal.have-an-account": "Sie haben bereits ein Konto?"
}, AIe = "Studio", PIe = "{{count}} schlafzimmer", DIe = "{{count}} schlafzimmer", NIe = "", RIe = "{{count}} Bett", IIe = "{{count}} Betten", TIe = "Erwachsene", LIe = "Babys", MIe = "Ihr Kalender wurde aktualisiert.", WIe = "Ein Monat", BIe = "Genaue Daten", FIe = "Eine Woche", VIe = "Ein Wochenende", UIe = "", qIe = "{{count}} Tag", HIe = "{{count}} Tage", GIe = "Zwei Wochen", KIe = "Abbrechen", JIe = "Kinder", ZIe = "Daten", YIe = "Löschen", XIe = "Beschreibung", QIe = "Reiseziel", eTe = "Fertig!", tTe = "Bearbeiten", aTe = "Jede Tauschanfrage", oTe = "Badewanne", nTe = "Grill", rTe = "Fahrrad", iTe = "Auto", sTe = "Katze", lTe = "Stadt", cTe = "Auf dem Land", uTe = "Geschirrspüler", dTe = "Hund", gTe = "Trockner", hTe = "Aufzug", pTe = "Lieblingshäuser", mTe = "Kamin", fTe = "Apartment", bTe = "Privater Garten", _Te = "weniger als {{max}} GP", vTe = "von {{min}} GP", yTe = "Zwischen {{min}} und {{max}} GP", wTe = "Privater Fitnessraum", kTe = "Haus", xTe = "Insel", $Te = "Abgelegen", STe = "Whirlpool", CTe = "See", ETe = "Häuser der Collection", jTe = "Berge", OTe = "{{count}} Badezimmer", zTe = "Andere Tiere", ATe = "Klavier", PTe = "Spielplatz", DTe = "Hauptwohnung", NTe = "Gegenseitiger Austausch", RTe = "Umgekehrte Suche", ITe = "Fluss", TTe = "An der Küste", LTe = "Zweitwohnung", MTe = "Fernseher", WTe = "Dorf", BTe = "WLAN", FTe = "Filter", VTe = "Feste Daten", UTe = "Eine Woche im {{date}}", qTe = "Ein Wochenende im {{date}}", HTe = "Eine Woche im {{date}}", GTe = "Zwei Wochen im {{date}}", KTe = "Flexible Daten", JTe = "Gäste", ZTe = "Unterkünfte", YTe = "Last Minute", XTe = "Ort", QTe = "Ändern", eLe = "Name", tLe = "Weiter", aLe = "", oLe = "{{count}} Erwachsener", nLe = "{{count}} Erwachsene", rLe = "", iLe = "{{count}} Baby", sLe = "{{count}} Babys", lLe = "", cLe = "{{count}} Kind", uLe = "{{count}} Kinder", dLe = "", gLe = "{{count}} Gast", hLe = "{{count}} Gäste", pLe = "Das Format der Telefonnummer ist ungültig.", mLe = "Benachrichtigungen per E-Mail erhalten", fLe = "Speichern", bLe = "Kein Reiseziel gefunden", _Le = "Mehr anzeigen", vLe = "Reiseprojekte", yLe = "", wLe = "optional", kLe = {
  "autocomplete.button": "Suchen",
  "autocomplete.placeholder": "Wo gehst du hin ?",
  bedroomsNumbers_zero: AIe,
  bedroomsNumbers_one: PIe,
  bedroomsNumbers_other: DIe,
  beds_zero: NIe,
  beds_one: RIe,
  beds_other: IIe,
  "button.free-signup": "Kostenlos anmelden",
  "button.validate": "Bestätigen",
  "common.try-again": "Erneut versuchen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Darf {{limit}} Zeichen nicht überschreiten",
  "error.reload": "Aktualisieren Sie diese Seite",
  "error.return-homepage": "Zurück zur Startseite",
  "error.subtitle": "Leider ist diese Seite nicht erreichbar.",
  "error.title": "Es ist ein Fehler auf der Seite aufgetreten.",
  "errors.unable_to_submit.subtitle": "Leider konnte Ihr Formular im Moment nicht abgeschickt werden. Bitte versuchen Sie es später noch einmal.",
  "errors.unable_to_submit.title": "Hoppla, wir haben ein Problem",
  "global.back": "Zurück",
  "global.cancel": "Abbrechen",
  "global.collection.browsehomes": "Unterkünfte durchstöbern",
  "global.collection.contactus": "Kontaktieren Sie uns",
  "global.confirm": "Bestätigen",
  "global.continue": "Weiter",
  "global.getStarted": "Los geht's",
  "global.login": "Anmelden",
  "global.select": "Auswählen",
  global_adults: TIe,
  global_babies: LIe,
  global_calendarUpdated_toast: MIe,
  global_calendar_aMonth: WIe,
  global_calendar_exactDates: BIe,
  global_calendar_oneWeek: FIe,
  global_calendar_oneWeekend: VIe,
  global_calendar_plusMinusDay_zero: UIe,
  global_calendar_plusMinusDay_one: qIe,
  global_calendar_plusMinusDay_other: HIe,
  global_calendar_twoWeeks: GIe,
  global_cancel: KIe,
  global_children: JIe,
  global_dates: ZIe,
  global_delete: YIe,
  global_description: XIe,
  global_destination: QIe,
  global_done: eTe,
  global_edit: tTe,
  "global_filter_a-c": "Klimaanlage",
  global_filter_available: aTe,
  "global_filter_baby-bed": "Babybetten",
  "global_filter_baby-gear": "Babyausstattung",
  "global_filter_balcony-terrace": "Balkon / Terrasse",
  global_filter_bathtub: oTe,
  global_filter_bbq: nTe,
  global_filter_bicycle: rTe,
  global_filter_car: iTe,
  global_filter_cat: sTe,
  "global_filter_children-welcome": "Kinder willkommen",
  global_filter_cities: lTe,
  "global_filter_cleaning-person": "Reinigungskraft",
  global_filter_countryside: cTe,
  "global_filter_dedicated-workspace": "Spezieller Arbeitsbereich",
  "global_filter_disabled-access": "Barrierefreie Unterkunft",
  global_filter_dishwasher: uTe,
  global_filter_dog: dTe,
  global_filter_dryer: gTe,
  "global_filter_eco-level": "Nur nachhaltige Häuser",
  "global_filter_electric-car-plug": "Steckdose für Elektroautos",
  global_filter_elevator: hTe,
  global_filter_favorite: pTe,
  global_filter_fireplace: mTe,
  global_filter_flat: fTe,
  global_filter_garden: bTe,
  "global_filter_guest-wanted": "Austausch gegen GuestPoints",
  global_filter_guestPointsMax: _Te,
  global_filter_guestPointsMin: vTe,
  global_filter_guestPointsMinMax: yTe,
  global_filter_gym: wTe,
  "global_filter_heating-system": "Heizung",
  "global_filter_high-speed-connexion": "Hochgeschwindigkeitsverbindung",
  global_filter_home: kTe,
  "global_filter_home-verified": "Verifizierte Unterkünfte",
  global_filter_island: xTe,
  global_filter_isolated: $Te,
  global_filter_jacuzzi: STe,
  "global_filter_kids-toys": "Kinderspielzeug",
  global_filter_lakes: CTe,
  global_filter_luxury: ETe,
  global_filter_mountains: jTe,
  "global_filter_no-bed-up": "Keine Zustellbetten",
  global_filter_numOfBathrooms: OTe,
  global_filter_other: zTe,
  "global_filter_parking-space": "Privater Parkplatz",
  "global_filter_pets-welcome": "Haustiere willkommen",
  global_filter_piano: ATe,
  global_filter_playground: PTe,
  global_filter_primary: DTe,
  "global_filter_public-transit-access": "Zugang zu öffentlichen Verkehrsmitteln",
  global_filter_reciprocal: NTe,
  "global_filter_response-rate-above-threshold": "Antwortrate ≥ Mittel",
  global_filter_reverse: RTe,
  global_filter_river: ITe,
  global_filter_seaside: TTe,
  global_filter_secondary: LTe,
  "global_filter_secured-pool": "Gesicherter Pool",
  "global_filter_smokers-welcome": "Rauchen erlaubt",
  "global_filter_swimming-pool": "Swimmingpool",
  global_filter_tv: MTe,
  global_filter_villages: WTe,
  "global_filter_washing-machine": "Waschmaschine",
  "global_filter_whole-unit": "Die ganze Wohnung",
  global_filter_wifi: BTe,
  global_filters: FTe,
  global_fixDates: VTe,
  global_flexDates_aMonth: UTe,
  global_flexDates_aWeekend: qTe,
  global_flexDates_oneWeek: HTe,
  global_flexDates_twoWeek: GTe,
  global_flexibleDates: KTe,
  global_guests: JTe,
  global_homes: ZTe,
  global_lastMinute: YTe,
  global_location: XTe,
  global_modify: QTe,
  global_name: eLe,
  global_next: tLe,
  global_numberOfAdults_zero: aLe,
  global_numberOfAdults_one: oLe,
  global_numberOfAdults_other: nLe,
  global_numberOfBabies_zero: rLe,
  global_numberOfBabies_one: iLe,
  global_numberOfBabies_other: sLe,
  global_numberOfChildren_zero: lLe,
  global_numberOfChildren_one: cLe,
  global_numberOfChildren_other: uLe,
  global_numberOfGuests_zero: dLe,
  global_numberOfGuests_one: gLe,
  global_numberOfGuests_other: hLe,
  global_phoneNumber_notValid: pLe,
  global_receiveEmailAlerts: mLe,
  global_save: fLe,
  global_searchBar_noLocationFound: bLe,
  global_seeMore_link: _Le,
  global_travelWishlist: vLe,
  "modal.error-occured.content": "Wir entschuldigen uns für die Unannehmlichkeiten, bitte versuchen Sie es noch einmal.",
  "modal.error-occured.title": "Oh nein, es ist ein Fehler aufgetreten!",
  no_result: yLe,
  optional: wLe,
  "privacy-policy": "Datenschutz"
}, xLe = "https://www.homeexchange.com/de/blog/", $Le = "/de/p/homeexchangenutzungsbedingungen", SLe = "https://www.homeexchange.com/de/p/our-community-de", CLe = "https://homeexchangehelp.zendesk.com/hc/de", ELe = "", jLe = "https://www.homeexchange.com/de/p/service-homeexchange-de", OLe = "https://www.homeexchange.com/de/p/guestpoints-de", zLe = "https://www.homeexchange.com/de/p/press-de", ALe = "https://www.homeexchange.com/p/worte-homeexchanger", PLe = "https://help.homeexchange.com/hc/de/articles/360000623717-Bevorzugte-Tausch-Destinationen", DLe = "", NLe = "https://www.homeexchange.com/de/p/wo-die-begrubung-wirklich-beginnt", RLe = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/de/p/about-us-de",
  blog: xLe,
  cgu: $Le,
  community: SLe,
  "contact-us": "https://www.homeexchange.com/de/kontakt-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/HomeExchangeDE/",
  faq: CLe,
  forum: ELe,
  guarantees: jLe,
  guestpoints: OLe,
  "happiness-team": "https://www.homeexchange.com/de/p/happiness-team-de",
  "how-it-works": "https://www.homeexchange.com/de/p/so-funktioniert-es-de",
  "join-us": "https://www.homeexchange.com/de/p/join-us-de",
  "legal-notice": "/p/impressum",
  "mobile-app": "https://www.homeexchange.com/de/p/homeexchange-mobile-app",
  "our-team": "https://www.homeexchange.com/de/p/unser-team",
  press: zLe,
  "privacy-policy": "/p/homeexchange-datenschutz",
  "subscription-cost": "https://www.homeexchange.com/de/p/subscription-homeexchange-de",
  "term-of-use": "/p/homeexchangenutzungsbedingungen",
  testimonials: ALe,
  travelWishlist_faq_links: PLe,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: DLe,
  values: NLe
}, ILe = "Vorname", TLe = "Nachname", LLe = "Zu den Reiseprojekten hinzufügen", MLe = "Aktualisierte Reiseprojekte ermöglichen es Ihnen, mehr gegenseitige Tauschanfragen zu erhalten.", WLe = "Sind Sie sicher, dass Sie {{fullAddress}} löschen möchten?", BLe = "Dies sind die Filter, die Sie ausgewählt haben. Wenn Sie Ihre Meinung geändert haben, können Sie einige von ihnen löschen. Wenn Sie jedoch weitere Filter hinzufügen möchten, müssen Sie eine neue Suche starten (dies wird sich jedoch bald ändern... bleiben Sie dran)!", FLe = "Dies kann ein Land, eine Stadt oder eine ganze Region sein. Wenn Sie einen großen Bereich auswählen, sind Ihre Ergebnisse möglicherweise weniger genau.", VLe = "Geben Sie ein Land, eine Stadt oder eine Region ein", ULe = "Verfügbare Häuser anzeigen", qLe = "Falls Unterkünfte mit Verfügbarkeit mit Ihren Reiseplänen übereinstimmen.", HLe = "Zu den Reiseprojekten hinzufügen", GLe = "{{fullAddress}} wurde aus Ihren Reiseprojekten gelöscht.", KLe = "Wählen Sie Ihre idealen Reisedaten (flexibel oder fest).", JLe = "Fügen Sie Details hinzu, damit andere, die die Umgekehrte Suche verwenden, erkennen können, warum Sie an ihrem Standort interessiert sind.", ZLe = "Geben Sie an, wie viele Personen Sie auf dieser Reise begleiten werden.", YLe = "Hoppla! {{fullAddress}} konnte aus einem unerwarteten Grund nicht in Ihren Reiseprojekten gespeichert werden.", XLe = "Teilen Sie uns mit, wann und wohin Sie reisen möchten, um Tauschanfragen und Benachrichtigungen zu erhalten, sobald passende Häuser verfügbar sind. Wir speichern Ihre Suchanfragen in Ihren Reiseprojekten!", QLe = "Gibt es Reisen, die Sie planen möchten?", eMe = "<updateDates>Aktualisieren Sie Ihre Daten</updateDates>, um weiterhin relevante E-Mail-Benachrichtigungen zu erhalten oder <delete>löschen Sie dieses Reiseziel</delete> aus Ihren Reiseprojekten, wenn Sie es nicht mehr in Betracht ziehen.", tMe = "Diese Daten liegen in der Vergangenheit", aMe = "{{fullAddress}} wurde zu Ihren Reiseprojekten hinzugefügt!", oMe = "{{fullAddress}} wurde erfolgreich aktualisiert.", nMe = "Ihre Suche wurde gespeichert und Ihr Kalender aktualisiert!", rMe = "Ihre Suche wurde gespeichert. Finden Sie sie in Ihren Reiseprojekten.", iMe = "Erfahren Sie mehr über Reiseprojekte", sMe = {
  firstname: ILe,
  lastname: TLe,
  modal_travelWishlist_addNew_title: LLe,
  modal_travelWishlist_delete_body: MLe,
  modal_travelWishlist_delete_title: WLe,
  modal_travelWishlist_filtersApplied_helper: BLe,
  modal_travelWishlist_location_helper: FLe,
  modal_travelWishlist_searchBar_placeholder: VLe,
  page_travelWishlist_card_cta: ULe,
  page_travelWishlist_card_emailAlerts_helper: qLe,
  page_travelWishlist_cta: HLe,
  page_travelWishlist_deleted_toast: GLe,
  page_travelWishlist_edit_dates_helper: KLe,
  page_travelWishlist_edit_description_helper: JLe,
  page_travelWishlist_edit_guests_helper: ZLe,
  page_travelWishlist_error_toast: YLe,
  page_travelWishlist_none_body: XLe,
  page_travelWishlist_none_subheader: QLe,
  page_travelWishlist_pastDates_desc: eMe,
  page_travelWishlist_pastDates_title: tMe,
  page_travelWishlist_saved_toast: aMe,
  page_travelWishlist_updated_toast: oMe,
  search_travelWishlist_calendarUpdated_toast: nMe,
  search_travelWishlist_saved_toast: rMe,
  travelWishlist_faq: iMe
}, lMe = {
  "modal.emailVerif.alreadyVerified.desc": "Your email is ready! Log in to continue.",
  "modal.emailVerif.alreadyVerified.title": "Your email address has already been verified",
  "modal.emailVerif.callout": "A verification email has been sent to <b>{{email}}</b>.",
  "modal.emailVerif.desc": "Check your inbox. The link in this email will expire in 24-hours.",
  "modal.emailVerif.linkExpired.desc": "To receive a new verification link in your inbox, please log in.",
  "modal.emailVerif.linkExpired.title": "This link has expired",
  "modal.emailVerif.resend-email-link": "Resend verification email",
  "modal.emailVerif.resend-email.rate-limit": "You’ve reached the email request limit. Try again in 1 minute.",
  "modal.emailVerif.resend-link": "Resend verification email",
  "modal.emailVerif.title": "Verify your email address",
  "modal.finishCreatingAccount.event": "At an event",
  "modal.finishCreatingAccount.everyone_knows_homeexchange": "Everyone knows HomeExchange",
  "modal.finishCreatingAccount.facebook": "Facebook",
  "modal.finishCreatingAccount.firstName.error": "Enter your first name",
  "modal.finishCreatingAccount.friends_family": "Through friends, family, or acquaintances",
  "modal.finishCreatingAccount.hearAboutHE": "How did you hear about HomeExchange?",
  "modal.finishCreatingAccount.instagram": "Instagram",
  "modal.finishCreatingAccount.lastName.error": "Enter your last name",
  "modal.finishCreatingAccount.other": "Other ",
  "modal.finishCreatingAccount.phone_number": "Phone number",
  "modal.finishCreatingAccount.phone_number.error": "Please enter your phone number",
  "modal.finishCreatingAccount.pleaseSpecify": "Specify",
  "modal.finishCreatingAccount.press": "In the press",
  "modal.finishCreatingAccount.press_online": "Online",
  "modal.finishCreatingAccount.press_print": "Print",
  "modal.finishCreatingAccount.radio": "On the radio",
  "modal.finishCreatingAccount.referral": "Referral code",
  "modal.finishCreatingAccount.referralCode.error": "This referral code is invalid",
  "modal.finishCreatingAccount.search_engine": "On a search engine",
  "modal.finishCreatingAccount.social_media": "Via social media",
  "modal.finishCreatingAccount.social_network_other": "Other social network (please specify)",
  "modal.finishCreatingAccount.title": "Finish creating your account",
  "modal.finishCreatingAccount.tv": "On TV",
  "modal.finishCreatingAccount.tv_ad": "Through an advertisement",
  "modal.finishCreatingAccount.tv_show": "During a report / TV show",
  "modal.genericError.desc": "The platform might be down or there might be a temporary glitch on our side, so please try again.<br><br>We track these errors automatically, but if the problem persists feel free to contact us at:<br><a>tech@homeexchange.com</a>",
  "modal.genericError.title": "Oops! something went wrong",
  "modal.noEmailRecieved.desc": "<b>Didn’t receive an email?</b>Check your spam folder and the spelling of your email before requesting another verification email.",
  "modal.noEmailRecieved.error": "Something went wrong, please try again later",
  "modal.verifyEmail.emailResent.toast": "We've sent you a new verification email to <b>{{email}}</b>.",
  "signin-modal.apple.button": "Connect with Apple",
  "signin-modal.button": "Sign in",
  "signin-modal.email.button": "Sign in",
  "signin-modal.error.content": "An error occured",
  "signin-modal.error.email_no_verified.content": "Email not verified",
  "signin-modal.error.email_no_verified.title": "Error",
  "signin-modal.error.title": "Error",
  "signin-modal.facebook.button": "Connect with Facebook",
  "signin-modal.no-account": "Don't have an account yet?",
  "signin-modal.reset-password": "Reset password",
  "signin-modal.title": "Sign in ",
  "signin.modal.reset-password": "Reset password",
  "signup-modal.accept-cgu": "By creating an account, I accept the",
  "signup-modal.apple.button": "Sign in with Apple",
  "signup-modal.button": "Sign up",
  "signup-modal.cgu.link": "General Terms of Use",
  "signup-modal.description": "Discover a new way of traveling with HomeExchange: Be welcomed all over the world and save money!",
  "signup-modal.email.button": "Sign up with your email address",
  "signup-modal.email.form.submit": "Sign up",
  "signup-modal.error.content": "An error occured",
  "signup-modal.error.title": "Error",
  "signup-modal.facebook.button": "Sign up with Facebook",
  "signup-modal.have-an-account": "Already have an account?"
}, cMe = "Studio", uMe = "{{count}} bedroom", dMe = "{{count}} bedrooms", gMe = "", hMe = "{{count}} bed", pMe = "{{count}} beds", mMe = "Adults", fMe = "Babies", bMe = "Your calendar has been updated.", _Me = "A month", vMe = "Exact dates", yMe = "One week", wMe = "One weekend", kMe = "", xMe = "± {{count}} day", $Me = "± {{count}} days", SMe = "Two weeks", CMe = "Cancel", EMe = "Children", jMe = "Dates", OMe = "Delete", zMe = "Description", AMe = "Destination", PMe = "Done!", DMe = "Edit", NMe = "Any type of exchange", RMe = "Bathtub", IMe = "BBQ", TMe = "Bicycle", LMe = "Car", MMe = "Cat", WMe = "City", BMe = "Countryside", FMe = "Dishwasher", VMe = "Dog", UMe = "Dryer", qMe = "Elevator", HMe = "Favorite homes", GMe = "Fireplace", KMe = "Apartment", JMe = "Private backyard", ZMe = "less than {{max}} GP", YMe = "from {{min}} GP", XMe = "Between {{min}} and {{max}} GP", QMe = "Private gym", eWe = "House", tWe = "Island", aWe = "Isolated", oWe = "Jacuzzi", nWe = "Lake", rWe = "Collection homes", iWe = "Mountain", sWe = "{{count}} bathrooms", lWe = "Other animals", cWe = "Piano", uWe = "Kid's playground", dWe = "Primary", gWe = "Reciprocal exchange", hWe = "Reverse search", pWe = "River", mWe = "Coastal", fWe = "Secondary", bWe = "TV", _We = "Village", vWe = "WiFi", yWe = "Filters", wWe = "Fixed dates", kWe = "A month in {{date}}", xWe = "A Week-end in {{date}}", $We = "One week in {{date}}", SWe = "Two weeks in {{date}}", CWe = "Flexible dates", EWe = "Guests", jWe = "homes", OWe = "Last minute", zWe = "Location", AWe = "Modify", PWe = "Name", DWe = "Next", NWe = "", RWe = "{{count}} adult", IWe = "{{count}} adults", TWe = "", LWe = "{{count}} baby", MWe = "{{count}} babies", WWe = "", BWe = "{{count}} child", FWe = "{{count}} children", VWe = "{{count}} guest", UWe = "{{count}} guest", qWe = "{{count}} guests", HWe = "The phone number format is not valid", GWe = "Receive email alerts", KWe = "Save", JWe = "No locations found", ZWe = "See more", YWe = "Travel wishlist", XWe = "No result", QWe = "optional", e2e = {
  "autocomplete.button": "Search",
  "autocomplete.placeholder": "Where are you going ?",
  bedroomsNumbers_zero: cMe,
  bedroomsNumbers_one: uMe,
  bedroomsNumbers_other: dMe,
  beds_zero: gMe,
  beds_one: hMe,
  beds_other: pMe,
  "button.free-signup": "Sign up for free",
  "button.validate": "Validate",
  "common.try-again": "Try again",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Must not exceed {{limit}} characters",
  "error.reload": "Refresh this page",
  "error.return-homepage": "Return to home page",
  "error.subtitle": "Unfortunately this page can't be reached.",
  "error.title": "An error occurred on the page",
  "errors.unable_to_submit.subtitle": "Unfortunately your form couldn't be submitted right now. Please try again later.",
  "errors.unable_to_submit.title": "Oops, we've hit a problem",
  "global.back": "Back",
  "global.cancel": "Cancel",
  "global.collection.browsehomes": "Browse Homes",
  "global.collection.contactus": "Contact us",
  "global.confirm": "Confirm",
  "global.continue": "Continue",
  "global.getStarted": "Get started",
  "global.login": "Log in",
  "global.select": "Select",
  global_adults: mMe,
  global_babies: fMe,
  global_calendarUpdated_toast: bMe,
  global_calendar_aMonth: _Me,
  global_calendar_exactDates: vMe,
  global_calendar_oneWeek: yMe,
  global_calendar_oneWeekend: wMe,
  global_calendar_plusMinusDay_zero: kMe,
  global_calendar_plusMinusDay_one: xMe,
  global_calendar_plusMinusDay_other: $Me,
  global_calendar_twoWeeks: SMe,
  global_cancel: CMe,
  global_children: EMe,
  global_dates: jMe,
  global_delete: OMe,
  global_description: zMe,
  global_destination: AMe,
  global_done: PMe,
  global_edit: DMe,
  "global_filter_a-c": "A/C",
  global_filter_available: NMe,
  "global_filter_baby-bed": "Baby cribs",
  "global_filter_baby-gear": "Baby gear",
  "global_filter_balcony-terrace": "Balcony/Terrace",
  global_filter_bathtub: RMe,
  global_filter_bbq: IMe,
  global_filter_bicycle: TMe,
  global_filter_car: LMe,
  global_filter_cat: MMe,
  "global_filter_children-welcome": "Children welcome",
  global_filter_cities: WMe,
  "global_filter_cleaning-person": "Cleaning person",
  global_filter_countryside: BMe,
  "global_filter_dedicated-workspace": "Dedicated workspace",
  "global_filter_disabled-access": "Accessible home",
  global_filter_dishwasher: FMe,
  global_filter_dog: VMe,
  global_filter_dryer: UMe,
  "global_filter_eco-level": "Only sustainable homes",
  "global_filter_electric-car-plug": "Electric car plug",
  global_filter_elevator: qMe,
  global_filter_favorite: HMe,
  global_filter_fireplace: GMe,
  global_filter_flat: KMe,
  global_filter_garden: JMe,
  "global_filter_guest-wanted": "GuestPoints exchange",
  global_filter_guestPointsMax: ZMe,
  global_filter_guestPointsMin: YMe,
  global_filter_guestPointsMinMax: XMe,
  global_filter_gym: QMe,
  "global_filter_heating-system": "Heating system",
  "global_filter_high-speed-connexion": "High speed connection",
  global_filter_home: eWe,
  "global_filter_home-verified": "Verified homes",
  global_filter_island: tWe,
  global_filter_isolated: aWe,
  global_filter_jacuzzi: oWe,
  "global_filter_kids-toys": "Kids toys",
  global_filter_lakes: nWe,
  global_filter_luxury: rWe,
  global_filter_mountains: iWe,
  "global_filter_no-bed-up": "No temporary beds",
  global_filter_numOfBathrooms: sWe,
  global_filter_other: lWe,
  "global_filter_parking-space": "Private parking space",
  "global_filter_pets-welcome": "Pets welcome",
  global_filter_piano: cWe,
  global_filter_playground: uWe,
  global_filter_primary: dWe,
  "global_filter_public-transit-access": "Public transport access",
  global_filter_reciprocal: gWe,
  "global_filter_response-rate-above-threshold": "Response rate ≥ Average",
  global_filter_reverse: hWe,
  global_filter_river: pWe,
  global_filter_seaside: mWe,
  global_filter_secondary: fWe,
  "global_filter_secured-pool": "Secured pool",
  "global_filter_smokers-welcome": "Smokers welcome",
  "global_filter_swimming-pool": "Pool",
  global_filter_tv: bWe,
  global_filter_villages: _We,
  "global_filter_washing-machine": "Washing machine",
  "global_filter_whole-unit": "Entire home",
  global_filter_wifi: vWe,
  global_filters: yWe,
  global_fixDates: wWe,
  global_flexDates_aMonth: kWe,
  global_flexDates_aWeekend: xWe,
  global_flexDates_oneWeek: $We,
  global_flexDates_twoWeek: SWe,
  global_flexibleDates: CWe,
  global_guests: EWe,
  global_homes: jWe,
  global_lastMinute: OWe,
  global_location: zWe,
  global_modify: AWe,
  global_name: PWe,
  global_next: DWe,
  global_numberOfAdults_zero: NWe,
  global_numberOfAdults_one: RWe,
  global_numberOfAdults_other: IWe,
  global_numberOfBabies_zero: TWe,
  global_numberOfBabies_one: LWe,
  global_numberOfBabies_other: MWe,
  global_numberOfChildren_zero: WWe,
  global_numberOfChildren_one: BWe,
  global_numberOfChildren_other: FWe,
  global_numberOfGuests_zero: VWe,
  global_numberOfGuests_one: UWe,
  global_numberOfGuests_other: qWe,
  global_phoneNumber_notValid: HWe,
  global_receiveEmailAlerts: GWe,
  global_save: KWe,
  global_searchBar_noLocationFound: JWe,
  global_seeMore_link: ZWe,
  global_travelWishlist: YWe,
  "modal.error-occured.content": "We're so sorry for the inconvenience, but please do try again.",
  "modal.error-occured.title": "Oh no, an error has occurred!",
  no_result: XWe,
  optional: QWe,
  "privacy-policy": "Privacy Policy"
}, t2e = "https://www.homeexchange.com/blog/", a2e = "/p/general-terms-of-use", o2e = "https://www.homeexchange.com/p/community", n2e = "https://homeexchangehelp.zendesk.com/hc/en-us", r2e = "https://forum.homeexchange.com/c/english/20", i2e = "https://www.homeexchange.com/p/service-homeexchange-en", s2e = "https://www.homeexchange.com/p/guestpoints-en", l2e = "https://www.homeexchange.com/p/press", c2e = "https://www.homeexchange.com/p/words-of-homeexchanges", u2e = "https://help.homeexchange.com/hc/en-us/articles/360000623717-What-are-My-Preferred-Destinations-and-how-do-I-use-them", d2e = "https://www.homeexchange.com/p/where-the-welcome-really-begins", g2e = "https://www.homeexchange.com/p/where-the-welcome-really-begins", h2e = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/p/about-us",
  blog: t2e,
  cgu: a2e,
  community: o2e,
  "contact-us": "https://www.homeexchange.com/contact-us-homeexchange",
  "cookie-policy": "/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: n2e,
  forum: r2e,
  guarantees: i2e,
  guestpoints: s2e,
  "happiness-team": "https://www.homeexchange.com/p/happiness-team",
  "how-it-works": "https://www.homeexchange.com/p/how-it-works-en",
  "join-us": "https://www.homeexchange.com/p/join-us",
  "legal-notice": "/p/legal-notice",
  "mobile-app": "https://www.homeexchange.com/p/mobile-apps",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: l2e,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/p/subscription-homeexchange",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: c2e,
  travelWishlist_faq_links: u2e,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: d2e,
  values: g2e
}, p2e = "First name", m2e = "Last name", f2e = "Add to your travel wishlist", b2e = "An updated travel wishlist will enable you to receive more reciprocal exchange requests.", _2e = "Are you sure you want to delete {{fullAddress}}?", v2e = "These are the filters you've selected. If you've changed your mind, you can delete some of them below. But if you'd like to add additional ones, you'll need to start a new search (though this will change soon... stay tuned)!", y2e = "This could be a country, city or a whole region. If you pick a broad location, your results might be less accurate.", w2e = "Type a country, city, or region", k2e = "View available homes", x2e = "When homes with availability match your travel plans.", $2e = "Add to your travel wishlist", S2e = "{{fullAddress}} has been deleted from your travel wishlist.", C2e = "Select your ideal travel dates (flexible or fixed).", E2e = "Add details to help others using the reverse search feature see why you’re interested in their location.", j2e = "Specify how many people will be traveling with you for this trip.", O2e = "Oops! {{fullAddress}} couldn't be saved to your travel wishlist for an unexpected reason.", z2e = "Let us know when and where you'd like to travel to receive exchange requests and alerts as soon as suitable homes become available. We'll save your searches to your travel wishlist!", A2e = "Any travel adventures you'd like to start planning?", P2e = "<updateDates>Update your dates</updateDates> to keep receiving relevant email alerts or <delete>delete this destination</delete> from your travel wishlist if you're no longer considering it.", D2e = "These dates are in the past", N2e = "{{fullAddress}} has been added to your travel wishlist!", R2e = "{{fullAddress}} has been successfully updated.", I2e = "Your search has been saved, and your calendar has been updated!", T2e = "Your search has been saved. Find it in your travel wishlist.", L2e = "Learn more about travel wishlists", M2e = {
  firstname: p2e,
  lastname: m2e,
  modal_travelWishlist_addNew_title: f2e,
  modal_travelWishlist_delete_body: b2e,
  modal_travelWishlist_delete_title: _2e,
  modal_travelWishlist_filtersApplied_helper: v2e,
  modal_travelWishlist_location_helper: y2e,
  modal_travelWishlist_searchBar_placeholder: w2e,
  page_travelWishlist_card_cta: k2e,
  page_travelWishlist_card_emailAlerts_helper: x2e,
  page_travelWishlist_cta: $2e,
  page_travelWishlist_deleted_toast: S2e,
  page_travelWishlist_edit_dates_helper: C2e,
  page_travelWishlist_edit_description_helper: E2e,
  page_travelWishlist_edit_guests_helper: j2e,
  page_travelWishlist_error_toast: O2e,
  page_travelWishlist_none_body: z2e,
  page_travelWishlist_none_subheader: A2e,
  page_travelWishlist_pastDates_desc: P2e,
  page_travelWishlist_pastDates_title: D2e,
  page_travelWishlist_saved_toast: N2e,
  page_travelWishlist_updated_toast: R2e,
  search_travelWishlist_calendarUpdated_toast: I2e,
  search_travelWishlist_saved_toast: T2e,
  travelWishlist_faq: L2e
}, W2e = {
  "modal.emailVerif.alreadyVerified.desc": "¡Tu correo electrónico está listo! Inicia sesión para continuar.",
  "modal.emailVerif.alreadyVerified.title": "Tu dirección de correo ya está verificada",
  "modal.emailVerif.callout": "Te hemos enviado un correo de verificación a <b>{{email}}</b>.",
  "modal.emailVerif.desc": "Comprueba tu bandeja de entrada. El enlace del correo electrónico caduca en 24 horas.",
  "modal.emailVerif.linkExpired.desc": "Inicia sesión para recibir un nuevo enlace de verificación en tu bandeja de entrada.",
  "modal.emailVerif.linkExpired.title": "Este enlace ha caducado",
  "modal.emailVerif.resend-email-link": "Reenviar correo de verificación",
  "modal.emailVerif.resend-email.rate-limit": "",
  "modal.emailVerif.resend-link": "Reenviar correo de verificación",
  "modal.emailVerif.title": "Verifica tu dirección de correo electrónico",
  "modal.finishCreatingAccount.event": "En un evento",
  "modal.finishCreatingAccount.everyone_knows_homeexchange": "Todo el mundo conoce HomeExchange",
  "modal.finishCreatingAccount.facebook": "Facebook",
  "modal.finishCreatingAccount.firstName.error": "Introduce tu nombre.",
  "modal.finishCreatingAccount.friends_family": "Por amigos, familiares o conocidos",
  "modal.finishCreatingAccount.hearAboutHE": "¿Cómo has descubierto HomeExchange?",
  "modal.finishCreatingAccount.instagram": "Instagram",
  "modal.finishCreatingAccount.lastName.error": "Introduce tus apellidos.",
  "modal.finishCreatingAccount.other": "Otros",
  "modal.finishCreatingAccount.phone_number": "Número de teléfono",
  "modal.finishCreatingAccount.phone_number.error": "Introduce tu número de teléfono",
  "modal.finishCreatingAccount.pleaseSpecify": "Especifica",
  "modal.finishCreatingAccount.press": "Por la prensa",
  "modal.finishCreatingAccount.press_online": "Online",
  "modal.finishCreatingAccount.press_print": "Medios impresos",
  "modal.finishCreatingAccount.radio": "Por la radio",
  "modal.finishCreatingAccount.referral": "Código de invitación",
  "modal.finishCreatingAccount.referralCode.error": "Este código de invitación no es válido.",
  "modal.finishCreatingAccount.search_engine": "En un motor de búsqueda",
  "modal.finishCreatingAccount.social_media": "Por las redes sociales",
  "modal.finishCreatingAccount.social_network_other": "Otra red social (especifica cuál)",
  "modal.finishCreatingAccount.title": "Termina de crear tu cuenta",
  "modal.finishCreatingAccount.tv": "En la televisión",
  "modal.finishCreatingAccount.tv_ad": "En un anuncio",
  "modal.finishCreatingAccount.tv_show": "En un reportaje/programa de televisión",
  "modal.genericError.desc": "Es posible que la plataforma esté fuera de servicio o que estemos experimentando un problema técnico temporal, así que vuelve a intentarlo.<br><br>Llevamos un seguimiento automático de estos errores, pero si el problema persiste, no dudes en ponerte en contacto con nosotros en:<br><a>tech@homeexchange.com</a>",
  "modal.genericError.title": "¡Vaya! Algo salió mal...",
  "modal.noEmailRecieved.desc": "<b>¿No has recibido el correo electrónico?</b>Comprueba tu carpeta de spam y asegúrate de que tu dirección esté bien escrita antes de solicitar otro correo de verificación.",
  "modal.noEmailRecieved.error": "Algo salió mal, por favor inténtalo de nuevo más tarde.",
  "modal.verifyEmail.emailResent.toast": "Te hemos enviado un nuevo correo de verificación a <b>{{email}}</b>.",
  "signin-modal.apple.button": "Inicia sesión con Apple",
  "signin-modal.button": "Inicia sesión",
  "signin-modal.email.button": "Inicia sesión",
  "signin-modal.error.content": "",
  "signin-modal.error.email_no_verified.content": "",
  "signin-modal.error.email_no_verified.title": "",
  "signin-modal.error.title": "",
  "signin-modal.facebook.button": "Inicia sesión con Facebook",
  "signin-modal.no-account": "¿Aún no tienes una cuenta?",
  "signin-modal.reset-password": "",
  "signin-modal.title": "",
  "signin.modal.reset-password": "Restablecer la contraseña",
  "signup-modal.accept-cgu": "Al crear una cuenta acepto las",
  "signup-modal.apple.button": "Inicia sesión con Apple",
  "signup-modal.button": "Regístrate",
  "signup-modal.cgu.link": "Condiciones Generales de Uso",
  "signup-modal.description": "Descubre otra forma de viajar con el intercambio de casas: ¡siéntete bienvenido/a en todo el mundo y ahorra en alojamiento!",
  "signup-modal.email.button": "Regístrate con tu correo electrónico",
  "signup-modal.email.form.submit": "",
  "signup-modal.error.content": "",
  "signup-modal.error.title": "",
  "signup-modal.facebook.button": "Regístrate con Facebook",
  "signup-modal.have-an-account": "¿Ya tienes una cuenta?"
}, B2e = "Estudio", F2e = "{{count}} dormitorio", V2e = "{{count}} dormitorios", U2e = "", q2e = "{{count}} cama", H2e = "{{count}} camas", G2e = "", K2e = "", J2e = "Tu calendario ha sido actualizado.", Z2e = "Un mes", Y2e = "Fechas exactas", X2e = "Una semana", Q2e = "Un fin de semana", eBe = "", tBe = "± 1:{{count}} día", aBe = "± 1:{{count}} días", oBe = "Dos semanas", nBe = "Cancelar", rBe = "", iBe = "Fechas", sBe = "Eliminar", lBe = "Descripción", cBe = "Destino", uBe = "¡Listo!", dBe = "Editar", gBe = "Cualquier tipo de intercambio", hBe = "Bañera", pBe = "Barbacoa", mBe = "Bicicleta", fBe = "Coche", bBe = "Gato", _Be = "Ciudad", vBe = "Campo", yBe = "Lavavajillas", wBe = "Perro", kBe = "Secadora", xBe = "Ascensor", $Be = "Casas favoritas", SBe = "Chimenea", CBe = "Piso", EBe = "Patio privado", jBe = "", OBe = "", zBe = "", ABe = "", PBe = "Casa", DBe = "Isla", NBe = "Aislado", RBe = "Jacuzzi", IBe = "Lagos", TBe = "Casas Collection", LBe = "", MBe = "{{count}} baños", WBe = "Otros animales", BBe = "Piano", FBe = "Columpios", VBe = "Principal", UBe = "Intercambio recíproco", qBe = "Búsqueda inversa", HBe = "Río", GBe = "En la costa", KBe = "Secundaria", JBe = "TV", ZBe = "Pueblo", YBe = "WiFi", XBe = "Filtros", QBe = "Fechas fijas", eFe = "Un mes en {{date}}", tFe = "Un fin de semana en {{date}}", aFe = "Una semana en {{date}}", oFe = "Dos semanas en {{date}}", nFe = "Fechas flexibles", rFe = "Invitados", iFe = "casas", sFe = "Último minuto", lFe = "Ubicación", cFe = "Modificar", uFe = "Nombre", dFe = "Siguiente", gFe = "", hFe = "{{count}} adulto", pFe = "{{count}} adultos", mFe = "", fFe = "{{count}} bebé", bFe = "bebé", _Fe = "", vFe = "{{count}} niño/a", yFe = "{{count}} niños", wFe = "", kFe = "{{count}} invitado/a", xFe = "{{count}} invitados", $Fe = "El formato del número de teléfono no es válido.", SFe = "Recibir notificaciones por correo electrónico", CFe = "Guardar", EFe = "No encontramos este lugar", jFe = "Ver más", OFe = "Proyectos de viaje", zFe = "", AFe = "opcional", PFe = {
  "autocomplete.button": "Buscar",
  "autocomplete.placeholder": "¿Adónde vas?",
  bedroomsNumbers_zero: B2e,
  bedroomsNumbers_one: F2e,
  bedroomsNumbers_other: V2e,
  beds_zero: U2e,
  beds_one: q2e,
  beds_other: H2e,
  "button.free-signup": "Regístrate gratis",
  "button.validate": "Validar",
  "common.try-again": "",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "No puedes superar los {{limit}} caracteres",
  "error.reload": "Actualizar esta página",
  "error.return-homepage": "Volver a la página de inicio",
  "error.subtitle": "Lo sentimos, pero no se puede acceder a esta página.",
  "error.title": "Se ha producido un error en la página",
  "errors.unable_to_submit.subtitle": "Lo sentimos, se ha producido un error al enviar el formulario. Por favor, vuelve a intentarlo más tarde.",
  "errors.unable_to_submit.title": "¡Vaya! Algo ha fallado.",
  "global.back": "",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "Continuar",
  "global.getStarted": "",
  "global.login": "Iniciar sesión",
  "global.select": "Selecciona",
  global_adults: G2e,
  global_babies: K2e,
  global_calendarUpdated_toast: J2e,
  global_calendar_aMonth: Z2e,
  global_calendar_exactDates: Y2e,
  global_calendar_oneWeek: X2e,
  global_calendar_oneWeekend: Q2e,
  global_calendar_plusMinusDay_zero: eBe,
  global_calendar_plusMinusDay_one: tBe,
  global_calendar_plusMinusDay_other: aBe,
  global_calendar_twoWeeks: oBe,
  global_cancel: nBe,
  global_children: rBe,
  global_dates: iBe,
  global_delete: sBe,
  global_description: lBe,
  global_destination: cBe,
  global_done: uBe,
  global_edit: dBe,
  "global_filter_a-c": "Aire acondicionado",
  global_filter_available: gBe,
  "global_filter_baby-bed": "",
  "global_filter_baby-gear": "Equipamiento para bebés",
  "global_filter_balcony-terrace": "Balcón/Terraza",
  global_filter_bathtub: hBe,
  global_filter_bbq: pBe,
  global_filter_bicycle: mBe,
  global_filter_car: fBe,
  global_filter_cat: bBe,
  "global_filter_children-welcome": "Niños bienvenidos",
  global_filter_cities: _Be,
  "global_filter_cleaning-person": "Señor/a de la limpieza",
  global_filter_countryside: vBe,
  "global_filter_dedicated-workspace": "Escritorio para trabajar",
  "global_filter_disabled-access": "Casas accesibles",
  global_filter_dishwasher: yBe,
  global_filter_dog: wBe,
  global_filter_dryer: kBe,
  "global_filter_eco-level": "Solo viviendas sostenibles",
  "global_filter_electric-car-plug": "Enchufe para coches eléctricos",
  global_filter_elevator: xBe,
  global_filter_favorite: $Be,
  global_filter_fireplace: SBe,
  global_filter_flat: CBe,
  global_filter_garden: EBe,
  "global_filter_guest-wanted": "Intercambio con GuestPoints",
  global_filter_guestPointsMax: jBe,
  global_filter_guestPointsMin: OBe,
  global_filter_guestPointsMinMax: zBe,
  global_filter_gym: ABe,
  "global_filter_heating-system": "Calefacción",
  "global_filter_high-speed-connexion": "Conexión de alta velocidad",
  global_filter_home: PBe,
  "global_filter_home-verified": "Casas verificadas",
  global_filter_island: DBe,
  global_filter_isolated: NBe,
  global_filter_jacuzzi: RBe,
  "global_filter_kids-toys": "",
  global_filter_lakes: IBe,
  global_filter_luxury: TBe,
  global_filter_mountains: LBe,
  "global_filter_no-bed-up": "Sin camas provisionales",
  global_filter_numOfBathrooms: MBe,
  global_filter_other: WBe,
  "global_filter_parking-space": "",
  "global_filter_pets-welcome": "Mascotas bienvenidas",
  global_filter_piano: BBe,
  global_filter_playground: FBe,
  global_filter_primary: VBe,
  "global_filter_public-transit-access": "",
  global_filter_reciprocal: UBe,
  "global_filter_response-rate-above-threshold": "",
  global_filter_reverse: qBe,
  global_filter_river: HBe,
  global_filter_seaside: GBe,
  global_filter_secondary: KBe,
  "global_filter_secured-pool": "Piscina segura",
  "global_filter_smokers-welcome": "Fumadores bienvenidos",
  "global_filter_swimming-pool": "Piscina",
  global_filter_tv: JBe,
  global_filter_villages: ZBe,
  "global_filter_washing-machine": "Lavadora",
  "global_filter_whole-unit": "",
  global_filter_wifi: YBe,
  global_filters: XBe,
  global_fixDates: QBe,
  global_flexDates_aMonth: eFe,
  global_flexDates_aWeekend: tFe,
  global_flexDates_oneWeek: aFe,
  global_flexDates_twoWeek: oFe,
  global_flexibleDates: nFe,
  global_guests: rFe,
  global_homes: iFe,
  global_lastMinute: sFe,
  global_location: lFe,
  global_modify: cFe,
  global_name: uFe,
  global_next: dFe,
  global_numberOfAdults_zero: gFe,
  global_numberOfAdults_one: hFe,
  global_numberOfAdults_other: pFe,
  global_numberOfBabies_zero: mFe,
  global_numberOfBabies_one: fFe,
  global_numberOfBabies_other: bFe,
  global_numberOfChildren_zero: _Fe,
  global_numberOfChildren_one: vFe,
  global_numberOfChildren_other: yFe,
  global_numberOfGuests_zero: wFe,
  global_numberOfGuests_one: kFe,
  global_numberOfGuests_other: xFe,
  global_phoneNumber_notValid: $Fe,
  global_receiveEmailAlerts: SFe,
  global_save: CFe,
  global_searchBar_noLocationFound: EFe,
  global_seeMore_link: jFe,
  global_travelWishlist: OFe,
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: zFe,
  optional: AFe,
  "privacy-policy": "Política de Privacidad"
}, DFe = "https://www.homeexchange.com/es/blog/", NFe = "/es/p/homeexchange-condiciones-de-uso", RFe = "https://www.homeexchange.com/es/p/nuestra-comunidad-es", IFe = "https://homeexchangehelp.zendesk.com/hc/es", TFe = "https://forum.homeexchange.com/c/espanol/22", LFe = "https://www.homeexchange.com/es/p/service-homeexchange-es", MFe = "https://www.homeexchange.com/es/p/los-guestpoints", WFe = "https://www.homeexchange.com/es/p/prensa", BFe = "https://www.homeexchange.com/p/palabra-de-homeexchanger", FFe = "", VFe = "https://www.homeexchange.com/es/p/principios-intercambio-casa", UFe = "https://www.homeexchange.com/es/p/principios-intercambio-casa", qFe = {
  "about-calendar": "https://help.homeexchange.com/hc/es/articles/360007584998-Todo-lo-que-necesitas-saber-sobre-el-calendario",
  "about-us": "https://www.homeexchange.com/es/p/about-us-es",
  blog: DFe,
  cgu: NFe,
  community: RFe,
  "contact-us": "https://www.homeexchange.com/es/contacto-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/HomeExchangeES/",
  faq: IFe,
  forum: TFe,
  guarantees: LFe,
  guestpoints: MFe,
  "happiness-team": "https://www.homeexchange.com/es/p/happiness-team-es",
  "how-it-works": "https://www.homeexchange.com/es/p/como-funciona-es",
  "join-us": "https://www.homeexchange.com/es/p/join-us-es",
  "legal-notice": "/p/menciones-legales",
  "mobile-app": "https://www.homeexchange.com/es/p/aplicacion-movil",
  "our-team": "https://www.homeexchange.com/es/p/nuestro-equipo",
  press: WFe,
  "privacy-policy": "/p/homeexchange-politica-privacidad",
  "subscription-cost": "https://www.homeexchange.com/es/p/subscription-homeexchange-es",
  "term-of-use": "/p/homeexchange-condiciones-de-uso",
  testimonials: BFe,
  travelWishlist_faq_links: FFe,
  "twitter-page": "https://twitter.com/HomeExchangeES",
  value: VFe,
  values: UFe
}, HFe = "", GFe = "", KFe = "Crear nuevo proyecto de viaje", JFe = "Tener tus proyectos de viaje actualizados te permitirá recibir más solicitudes de intercambio recíproco.", ZFe = "¿Seguro que quieres eliminar {{fullAddress}}?", YFe = "Estos son los filtros que has seleccionado. Si has cambiado de opinión, puedes eliminar algunos de ellos a continuación. Pero si quieres añadir otros, tendrás que iniciar una nueva búsqueda (aunque esto cambiará pronto... ¡tendrás noticias!)", XFe = "Puede ser un país, una ciudad o una región entera. Si eliges una ubicación general, los resultados pueden ser menos precisos.", QFe = "Introduce un país, ciudad o región", eVe = "Ver casas disponibles", tVe = "Cuando haya casas disponibles que coincidan con tus proyectos de viaje.", aVe = "Crear nuevo proyecto de viaje", oVe = "{{fullAddress}} se ha eliminado de tus proyectos de viaje.", nVe = "Selecciona tus fechas ideales de viaje (flexibles o fijas).", rVe = "Añade detalles para ayudar a otras personas que utilicen la función de búsqueda inversa a entender por qué te interesa su región.", iVe = "Especifica cuántas personas viajarán contigo.", sVe = "¡Vaya! {{fullAddress}} no se ha guardado en tus proyectos de viaje por un motivo desconocido.", lVe = "Indícanos cuándo y dónde te gustaría viajar para recibir solicitudes de intercambio y notificaciones cuando haya casas disponibles. Guardaremos tus búsquedas en tus proyectos de viaje.", cVe = "¿Te apetece empezar a planear alguna aventura?", uVe = "<updateDates>Actualiza la fecha</updateDates> para seguir recibiendo notificaciones por correo electrónico o <delete>elimina este destino</delete>  de tus proyectos de viaje si ya no lo tienes en mente.", dVe = "Esta fecha ya ha pasado", gVe = "{{fullAddress}} se ha añadido a tus proyectos de viaje", hVe = "{{fullAddress}} se ha actualizado correctamente.", pVe = "¡Tu búsqueda se ha guardado y tu calendario se ha actualizado!", mVe = "Tu búsqueda se ha guardado. Podrás verla en tus proyectos de viaje.", fVe = "Saber más sobre los proyectos de viaje", bVe = {
  firstname: HFe,
  lastname: GFe,
  modal_travelWishlist_addNew_title: KFe,
  modal_travelWishlist_delete_body: JFe,
  modal_travelWishlist_delete_title: ZFe,
  modal_travelWishlist_filtersApplied_helper: YFe,
  modal_travelWishlist_location_helper: XFe,
  modal_travelWishlist_searchBar_placeholder: QFe,
  page_travelWishlist_card_cta: eVe,
  page_travelWishlist_card_emailAlerts_helper: tVe,
  page_travelWishlist_cta: aVe,
  page_travelWishlist_deleted_toast: oVe,
  page_travelWishlist_edit_dates_helper: nVe,
  page_travelWishlist_edit_description_helper: rVe,
  page_travelWishlist_edit_guests_helper: iVe,
  page_travelWishlist_error_toast: sVe,
  page_travelWishlist_none_body: lVe,
  page_travelWishlist_none_subheader: cVe,
  page_travelWishlist_pastDates_desc: uVe,
  page_travelWishlist_pastDates_title: dVe,
  page_travelWishlist_saved_toast: gVe,
  page_travelWishlist_updated_toast: hVe,
  search_travelWishlist_calendarUpdated_toast: pVe,
  search_travelWishlist_saved_toast: mVe,
  travelWishlist_faq: fVe
}, _Ve = {
  "modal.emailVerif.alreadyVerified.desc": "C'est tout bon ! Connectez-vous pour continuer.",
  "modal.emailVerif.alreadyVerified.title": "Votre adresse email a déjà été vérifiée",
  "modal.emailVerif.callout": "Un email de vérification a été envoyé à l'adresse <b>{{email}}</b>.",
  "modal.emailVerif.desc": "Consultez votre boîte de réception. Le lien inclus dans cet email expirera au bout de 24 heures.",
  "modal.emailVerif.linkExpired.desc": "Connectez-vous pour recevoir un nouveau lien de vérification dans votre boîte de réception.",
  "modal.emailVerif.linkExpired.title": "Ce lien a expiré",
  "modal.emailVerif.resend-email-link": "Renvoyer l'email de vérification",
  "modal.emailVerif.resend-email.rate-limit": "Vous avez atteint la limite de demandes d'envoi d'e-mails. Réessayez dans 1 minute.",
  "modal.emailVerif.resend-link": "Renvoyer l'email de vérification",
  "modal.emailVerif.title": "Confirmez votre adresse email",
  "modal.finishCreatingAccount.event": "Lors d'un événement",
  "modal.finishCreatingAccount.everyone_knows_homeexchange": "Tout le monde connaît HomeExchange",
  "modal.finishCreatingAccount.facebook": "Facebook",
  "modal.finishCreatingAccount.firstName.error": "Merci de saisir votre prénom",
  "modal.finishCreatingAccount.friends_family": "Par l'intermédiaire de proches",
  "modal.finishCreatingAccount.hearAboutHE": "Comment avez-vous entendu parler de HomeExchange ?",
  "modal.finishCreatingAccount.instagram": "Instagram",
  "modal.finishCreatingAccount.lastName.error": "Merci de saisir votre nom de famille",
  "modal.finishCreatingAccount.other": "Autre",
  "modal.finishCreatingAccount.phone_number": "Téléphone",
  "modal.finishCreatingAccount.phone_number.error": "Merci de renseigner votre numéro de téléphone",
  "modal.finishCreatingAccount.pleaseSpecify": "Précisez",
  "modal.finishCreatingAccount.press": "Dans la presse",
  "modal.finishCreatingAccount.press_online": "En ligne",
  "modal.finishCreatingAccount.press_print": "Écrite",
  "modal.finishCreatingAccount.radio": "À la radio",
  "modal.finishCreatingAccount.referral": "Code de parrainage",
  "modal.finishCreatingAccount.referralCode.error": "Ce code de parrainage n'est pas valide",
  "modal.finishCreatingAccount.search_engine": "Sur un moteur de recherche",
  "modal.finishCreatingAccount.social_media": "Sur les réseaux sociaux",
  "modal.finishCreatingAccount.social_network_other": "Autre réseau social (merci de préciser)",
  "modal.finishCreatingAccount.title": "Terminez la création de votre compte",
  "modal.finishCreatingAccount.tv": "À la télévision",
  "modal.finishCreatingAccount.tv_ad": "Dans une publicité",
  "modal.finishCreatingAccount.tv_show": "Dans un reportage/une émission TV",
  "modal.genericError.desc": "Notre plateforme pourrait être indisponible ou victime d'une panne temporaire, il va vous falloir réessayer.<br><br> Nous détectons ces erreurs automatiquement, mais n'hésitez pas à nous contacter à l'adresse suivante si le problème persiste :<br><a> tech@homeexchange.com</a>",
  "modal.genericError.title": "Oups ! Une erreur est survenue",
  "modal.noEmailRecieved.desc": "<b>Vous n'avez pas reçu d'email ?</b> Vérifiez vos spams et l'orthographe de votre adresse email avant de demander l'envoi d'un nouvel email de vérification.",
  "modal.noEmailRecieved.error": "Une erreur est survenue, réessayez plus tard",
  "modal.verifyEmail.emailResent.toast": "Nous vous avons envoyé un nouvel email de vérification à l'adresse <b>{{email}}</b>.",
  "signin-modal.apple.button": "Se connecter avec Google",
  "signin-modal.button": "Se connecter",
  "signin-modal.email.button": "Se connecter",
  "signin-modal.error.content": "",
  "signin-modal.error.email_no_verified.content": "",
  "signin-modal.error.email_no_verified.title": "",
  "signin-modal.error.title": "",
  "signin-modal.facebook.button": "Se connecter avec Facebook",
  "signin-modal.no-account": "Pas encore de compte ?",
  "signin-modal.reset-password": "",
  "signin-modal.title": "",
  "signin.modal.reset-password": "Réinitialiser le mot de passe",
  "signup-modal.accept-cgu": "En créant un compte, j’accepte les",
  "signup-modal.apple.button": "Se connecter avec Apple",
  "signup-modal.button": "S'inscrire",
  "signup-modal.cgu.link": "Conditions Générales d’Utilisation",
  "signup-modal.description": "Découvrez une autre manière de voyager avec l’échange de maison : soyez accueilli(e) partout dans le monde et faites des économies !",
  "signup-modal.email.button": "S’inscrire avec votre adresse email",
  "signup-modal.email.form.submit": "",
  "signup-modal.error.content": "",
  "signup-modal.error.title": "",
  "signup-modal.facebook.button": "S’inscrire avec Facebook",
  "signup-modal.have-an-account": "Vous avez déjà un compte ?"
}, vVe = "Studio", yVe = "{{count}} chambre", wVe = "{{count}} chambres", kVe = "", xVe = "{{count}} lit", $Ve = "{{count}} lits", SVe = "Adultes", CVe = "Bébés", EVe = "Votre calendrier a été mis à jour.", jVe = "Un mois", OVe = "Dates exactes", zVe = "Une semaine", AVe = "Un week-end", PVe = "Vide", DVe = "± {{count}} jour", NVe = "± {{count}} jours", RVe = "Deux semaines", IVe = "Annuler", TVe = "Enfants", LVe = "Dates", MVe = "Supprimer", WVe = "Description", BVe = "Destination", FVe = "C'est prêt !", VVe = "Modifier", UVe = "Tout type d'échange", qVe = "Baignoire", HVe = "Barbecue", GVe = "Vélo", KVe = "Voiture", JVe = "Chat", ZVe = "Ville", YVe = "Campagne", XVe = "Lave-vaisselle", QVe = "Chien", e3e = "Sèche linge", t3e = "Ascenseur", a3e = "Maisons favorites", o3e = "Cheminée", n3e = "Appartement", r3e = "Jardin privé", i3e = "moins de {{max}} GP", s3e = "à partir de {{min}} GP", l3e = "Entre {{min}} et {{max}} GP", c3e = "Salle de sport privée", u3e = "Maison", d3e = "Île", g3e = "Isolé", h3e = "Jacuzzi", p3e = "Lac", m3e = "Maisons Collection", f3e = "Montagne", b3e = "{{count}} salles de bain", _3e = "Autre", v3e = "Piano", y3e = "Aire de jeux", w3e = "Principale", k3e = "Échange réciproque", x3e = "Recherche inversée", $3e = "Rivière", S3e = "Bord de mer", C3e = "Secondaire", E3e = "TV", j3e = "Village", O3e = "WiFi", z3e = "Filtres", A3e = "Dates fixes", P3e = "Un mois en {{date}}", D3e = "Un week-end en {{date}}", N3e = "Une semaine en {{date}}", R3e = "Deux semaines en {{date}}", I3e = "Dates flexibles", T3e = "Personnes", L3e = "maisons", M3e = "Dernière minute", W3e = "Lieu", B3e = "Modifier", F3e = "Titre", V3e = "Suivant", U3e = "Vide", q3e = "{{count}} adulte", H3e = "{{count}} adultes", G3e = "Vide", K3e = "{{count}} bébé", J3e = "{{count}} bébés", Z3e = "Vide", Y3e = "{{count}} enfant", X3e = "{{count}} enfants", Q3e = "{{count}} personne", e4e = "{{count}} personne", t4e = "{{count}} personnes", a4e = "Le format du numéro de téléphone est invalide.", o4e = "Recevoir des alertes par email", n4e = "Enregistrer", r4e = "Aucun lieu trouvé", i4e = "Voir plus", s4e = "Projets de voyage", l4e = "", c4e = "facultatif", u4e = {
  "autocomplete.button": "Rechercher",
  "autocomplete.placeholder": "Où allez-vous ?",
  bedroomsNumbers_zero: vVe,
  bedroomsNumbers_one: yVe,
  bedroomsNumbers_other: wVe,
  beds_zero: kVe,
  beds_one: xVe,
  beds_other: $Ve,
  "button.free-signup": "Inscrivez-vous gratuitement",
  "button.validate": "Valider",
  "common.try-again": "Compris !",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Ne doit pas dépasser {{limit}} caractères",
  "error.reload": "Actualiser la page",
  "error.return-homepage": "Retour à la page d'accueil",
  "error.subtitle": "Malheureusement, il y a un problème avec cette page.",
  "error.title": "Une erreur s'est produite sur la page",
  "errors.unable_to_submit.subtitle": "Malheureusement, votre réponse n'a pas pu être enregistrée. Merci de réessayer plus tard !",
  "errors.unable_to_submit.title": "Oups, on dirait bien qu'il y a un problème !",
  "global.back": "Retour",
  "global.cancel": "Annuler",
  "global.collection.browsehomes": "Découvrir les maisons",
  "global.collection.contactus": "Nous contacter",
  "global.confirm": "Confirmer",
  "global.continue": "Continuer",
  "global.getStarted": "Commencer",
  "global.login": "Se connecter",
  "global.select": "Sélectionner",
  global_adults: SVe,
  global_babies: CVe,
  global_calendarUpdated_toast: EVe,
  global_calendar_aMonth: jVe,
  global_calendar_exactDates: OVe,
  global_calendar_oneWeek: zVe,
  global_calendar_oneWeekend: AVe,
  global_calendar_plusMinusDay_zero: PVe,
  global_calendar_plusMinusDay_one: DVe,
  global_calendar_plusMinusDay_other: NVe,
  global_calendar_twoWeeks: RVe,
  global_cancel: IVe,
  global_children: TVe,
  global_dates: LVe,
  global_delete: MVe,
  global_description: WVe,
  global_destination: BVe,
  global_done: FVe,
  global_edit: VVe,
  "global_filter_a-c": "Air conditionné",
  global_filter_available: UVe,
  "global_filter_baby-bed": "Lits bébé",
  "global_filter_baby-gear": "Équipements bébé",
  "global_filter_balcony-terrace": "Balcon / Terrasse",
  global_filter_bathtub: qVe,
  global_filter_bbq: HVe,
  global_filter_bicycle: GVe,
  global_filter_car: KVe,
  global_filter_cat: JVe,
  "global_filter_children-welcome": "Les enfants sont les bienvenus",
  global_filter_cities: ZVe,
  "global_filter_cleaning-person": "Service de ménage",
  global_filter_countryside: YVe,
  "global_filter_dedicated-workspace": "Espace de travail dédié",
  "global_filter_disabled-access": "Logement adapté",
  global_filter_dishwasher: XVe,
  global_filter_dog: QVe,
  global_filter_dryer: e3e,
  "global_filter_eco-level": "Uniquement des maisons durables",
  "global_filter_electric-car-plug": "Prise pour voiture électrique",
  global_filter_elevator: t3e,
  global_filter_favorite: a3e,
  global_filter_fireplace: o3e,
  global_filter_flat: n3e,
  global_filter_garden: r3e,
  "global_filter_guest-wanted": "Échange contre GuestPoints",
  global_filter_guestPointsMax: i3e,
  global_filter_guestPointsMin: s3e,
  global_filter_guestPointsMinMax: l3e,
  global_filter_gym: c3e,
  "global_filter_heating-system": "Chauffage",
  "global_filter_high-speed-connexion": "Connexion haut débit",
  global_filter_home: u3e,
  "global_filter_home-verified": "Logements vérifiés",
  global_filter_island: d3e,
  global_filter_isolated: g3e,
  global_filter_jacuzzi: h3e,
  "global_filter_kids-toys": "Jouets pour enfants",
  global_filter_lakes: p3e,
  global_filter_luxury: m3e,
  global_filter_mountains: f3e,
  "global_filter_no-bed-up": "Pas de lit d'appoint",
  global_filter_numOfBathrooms: b3e,
  global_filter_other: _3e,
  "global_filter_parking-space": "Place de parking privé",
  "global_filter_pets-welcome": "Les animaux sont les bienvenus",
  global_filter_piano: v3e,
  global_filter_playground: y3e,
  global_filter_primary: w3e,
  "global_filter_public-transit-access": "Accès aux transports publics",
  global_filter_reciprocal: k3e,
  "global_filter_response-rate-above-threshold": "Réactivité ≥ Moyenne",
  global_filter_reverse: x3e,
  global_filter_river: $3e,
  global_filter_seaside: S3e,
  global_filter_secondary: C3e,
  "global_filter_secured-pool": "Piscine sécurisée",
  "global_filter_smokers-welcome": "Fumeurs bienvenus",
  "global_filter_swimming-pool": "Piscine",
  global_filter_tv: E3e,
  global_filter_villages: j3e,
  "global_filter_washing-machine": "Lave linge",
  "global_filter_whole-unit": "L'intégralité du logement",
  global_filter_wifi: O3e,
  global_filters: z3e,
  global_fixDates: A3e,
  global_flexDates_aMonth: P3e,
  global_flexDates_aWeekend: D3e,
  global_flexDates_oneWeek: N3e,
  global_flexDates_twoWeek: R3e,
  global_flexibleDates: I3e,
  global_guests: T3e,
  global_homes: L3e,
  global_lastMinute: M3e,
  global_location: W3e,
  global_modify: B3e,
  global_name: F3e,
  global_next: V3e,
  global_numberOfAdults_zero: U3e,
  global_numberOfAdults_one: q3e,
  global_numberOfAdults_other: H3e,
  global_numberOfBabies_zero: G3e,
  global_numberOfBabies_one: K3e,
  global_numberOfBabies_other: J3e,
  global_numberOfChildren_zero: Z3e,
  global_numberOfChildren_one: Y3e,
  global_numberOfChildren_other: X3e,
  global_numberOfGuests_zero: Q3e,
  global_numberOfGuests_one: e4e,
  global_numberOfGuests_other: t4e,
  global_phoneNumber_notValid: a4e,
  global_receiveEmailAlerts: o4e,
  global_save: n4e,
  global_searchBar_noLocationFound: r4e,
  global_seeMore_link: i4e,
  global_travelWishlist: s4e,
  "modal.error-occured.content": "Toutes nos excuses : quelque chose ne s'est pas passé comme prévu, il va falloir que vous retentiez votre chance !",
  "modal.error-occured.title": "Une erreur s'est produite",
  no_result: l4e,
  optional: c4e,
  "privacy-policy": "Charte de vie privée"
}, d4e = "https://www.homeexchange.fr/blog/", g4e = "/p/conditions-generale-d-utilisation", h4e = "https://www.homeexchange.fr/p/communaute", p4e = "https://homeexchangehelp.zendesk.com/hc/fr", m4e = "https://forum.homeexchange.com/c/francais/21", f4e = "https://www.homeexchange.fr/p/service-homeexchange-fr", b4e = "https://www.homeexchange.fr/p/comment-fonctionnent-les-gp", _4e = "https://www.homeexchange.fr/p/presse", v4e = "https://www.homeexchange.com/p/paroles-homeexchangers", y4e = "https://help.homeexchange.com/hc/fr/articles/360000623717-Que-sont-Mes-destinations-pr%C3%A9f%C3%A9r%C3%A9es-et-comment-les-utiliser", w4e = "https://www.homeexchange.fr/p/les-fondamentaux ", k4e = "https://www.homeexchange.fr/p/les-fondamentaux", x4e = {
  "about-calendar": "https://help.homeexchange.com/hc/fr/articles/360007584998-Tout-ce-que-vous-devez-savoir-sur-le-calendrier",
  "about-us": "https://www.homeexchange.fr/p/qui-sommes-nous",
  blog: d4e,
  cgu: g4e,
  community: h4e,
  "contact-us": "https://www.homeexchange.fr/contactez-nous-homeexchange",
  "cookie-policy": "/p/nos-cookies",
  "facebook-page": "https://www.facebook.com/HomeExchangeFR/",
  faq: p4e,
  forum: m4e,
  guarantees: f4e,
  guestpoints: b4e,
  "happiness-team": "https://www.homeexchange.fr/p/happiness-team-fr",
  "how-it-works": "https://www.homeexchange.fr/p/comment-ca-marche-fr",
  "join-us": "https://www.homeexchange.fr/p/recrutement",
  "legal-notice": "/p/mentions-legales",
  "mobile-app": "https://www.homeexchange.fr/p/applications-mobile",
  "our-team": "https://www.homeexchange.fr/p/notre-equipe",
  press: _4e,
  "privacy-policy": "/p/charte-vie-privee",
  "subscription-cost": "https://www.homeexchange.fr/p/subscription-homeexchange-fr",
  "term-of-use": "/p/conditions-generale-d-utilisation",
  testimonials: v4e,
  travelWishlist_faq_links: y4e,
  "twitter-page": "https://twitter.com/HomeExchangeFR",
  value: w4e,
  values: k4e
}, $4e = "Prénom", S4e = "Nom", C4e = "Ajouter un projet de voyage", E4e = "Garder vos projets de voyage à jour vous permet de recevoir davantage de demandes d'échange réciproques.", j4e = "Voulez-vous vraiment supprimer {{fullAddress}} ?", O4e = "Ce sont les filtres que vous avez sélectionnés lors de votre recherche enregistrée : vous pouvez en supprimer mais si vous souhaitez en ajouter, vous devrez lancer une nouvelle recherche (mais plus pour très longtemps... on vous tiendra au courant !).", z4e = "Vous pouvez indiquer un pays, une région ou une ville. Si vous visez large, les résultats seront peut-être moins précis.", A4e = "Entrez un pays, une ville ou une région", P4e = "Voir les maisons disponibles", D4e = "Lorsque des logements correspondant à vos critères ont de nouvelles disponibilités", N4e = "Ajouter un projet de voyage", R4e = "Nous avons bien supprimé {{fullAddress}} de vos projets de voyage.", I4e = "Indiquez vos dates de voyage estimées (qu'elles soient flexibles ou fixes).", T4e = "Ajoutez des détails pour aider les membres utilisant la recherche inversée à savoir ce qui vous intéresse dans leur région.", L4e = "Indiquez combien de personnes voyageront avec vous cette fois-ci.", M4e = "Oups ! Pour une raison inattendue, nous n'avons pas pu ajouter {{fullAddress}} à vos projets de voyage.", W4e = "Indiquez où et quand vous aimeriez partir pour recevoir des demandes d'échange adaptées ainsi que des alertes dès que des logements correspondent à vos critères. Chaque recherche sera enregistrée dans vos projets de voyage.", B4e = "Des envies de voyage en tête ?", F4e = "<updateDates>Mettez à jour vos dates</updateDates> pour continuer à recevoir des alertes email pertinentes ou <delete>supprimez cette destination</delete> de vos projets de voyage si elle n'est plus d'actualité.", V4e = "Ces dates sont passées", U4e = "Nous avons bien ajouté {{fullAddress}} à vos projets de voyage.", q4e = "Nous avons bien mis à jour les informations pour {{fullAddress}}", H4e = "Votre recherche a bien été enregistrée et votre calendrier a été mis à jour.", G4e = "Votre recherche a bien été enregistrée. Retrouvez-la dans vos projets de voyage.", K4e = "En savoir plus sur les projets de voyage", J4e = {
  firstname: $4e,
  lastname: S4e,
  modal_travelWishlist_addNew_title: C4e,
  modal_travelWishlist_delete_body: E4e,
  modal_travelWishlist_delete_title: j4e,
  modal_travelWishlist_filtersApplied_helper: O4e,
  modal_travelWishlist_location_helper: z4e,
  modal_travelWishlist_searchBar_placeholder: A4e,
  page_travelWishlist_card_cta: P4e,
  page_travelWishlist_card_emailAlerts_helper: D4e,
  page_travelWishlist_cta: N4e,
  page_travelWishlist_deleted_toast: R4e,
  page_travelWishlist_edit_dates_helper: I4e,
  page_travelWishlist_edit_description_helper: T4e,
  page_travelWishlist_edit_guests_helper: L4e,
  page_travelWishlist_error_toast: M4e,
  page_travelWishlist_none_body: W4e,
  page_travelWishlist_none_subheader: B4e,
  page_travelWishlist_pastDates_desc: F4e,
  page_travelWishlist_pastDates_title: V4e,
  page_travelWishlist_saved_toast: U4e,
  page_travelWishlist_updated_toast: q4e,
  search_travelWishlist_calendarUpdated_toast: H4e,
  search_travelWishlist_saved_toast: G4e,
  travelWishlist_faq: K4e
}, Z4e = {
  "modal.emailVerif.alreadyVerified.desc": "Vaša adresa e-pošte je spremna! Prijavite se kako biste nastavili.",
  "modal.emailVerif.alreadyVerified.title": "Ova adresa e-pošte je već potvrđena",
  "modal.emailVerif.callout": "E-poruka s potvrdom je poslana na <b>{{email}}</b>.",
  "modal.emailVerif.desc": "Provjerite svoju dolaznu poštu. Poveznica u ovoj poruci će isteći u roku od 24 sata.",
  "modal.emailVerif.linkExpired.desc": "Ako želite dobiti novu poveznicu s potvrdom, morate se prijaviti.",
  "modal.emailVerif.linkExpired.title": "Ova je poveznica istekla",
  "modal.emailVerif.resend-email-link": "Ponovno pošalji e-poruku s potvrdom",
  "modal.emailVerif.resend-email.rate-limit": "Dosegli ste ograničenje zahtjeva za e-poštu. Pokušajte ponovno za 1 minutu.",
  "modal.emailVerif.resend-link": "Ponovno pošalji e-poruku s potvrdom",
  "modal.emailVerif.title": "Potvrdite adresu e-pošte",
  "modal.finishCreatingAccount.event": "na nekom događaju",
  "modal.finishCreatingAccount.everyone_knows_homeexchange": "svi znaju za HomeExchange",
  "modal.finishCreatingAccount.facebook": "na Facebooku",
  "modal.finishCreatingAccount.firstName.error": "Upišite svoje ime",
  "modal.finishCreatingAccount.friends_family": "preko obitelji, prijatelja ili poznanika",
  "modal.finishCreatingAccount.hearAboutHE": "Kako ste čuli za HomeExchange?",
  "modal.finishCreatingAccount.instagram": "na Instagramu",
  "modal.finishCreatingAccount.lastName.error": "Upišite svoje prezime",
  "modal.finishCreatingAccount.other": "ostalo",
  "modal.finishCreatingAccount.phone_number": "Broj telefona",
  "modal.finishCreatingAccount.phone_number.error": "Molimo unesite svoj broj telefona",
  "modal.finishCreatingAccount.pleaseSpecify": "napišite konkretnije",
  "modal.finishCreatingAccount.press": "u novinama",
  "modal.finishCreatingAccount.press_online": "na internetu",
  "modal.finishCreatingAccount.press_print": "u tiskanim medijima",
  "modal.finishCreatingAccount.radio": "na radiju",
  "modal.finishCreatingAccount.referral": "Kod za preporuku",
  "modal.finishCreatingAccount.referralCode.error": "Ovaj kod za preporuku nije valjan",
  "modal.finishCreatingAccount.search_engine": "u tražilici",
  "modal.finishCreatingAccount.social_media": "na društvenim mrežama",
  "modal.finishCreatingAccount.social_network_other": "na drugoj društvenoj mreži (napišite kojoj)",
  "modal.finishCreatingAccount.title": "Dovršite izradu svojeg računa",
  "modal.finishCreatingAccount.tv": "na televiziji",
  "modal.finishCreatingAccount.tv_ad": "u reklami",
  "modal.finishCreatingAccount.tv_show": "u nekoj reportaži/TV emisiji",
  "modal.genericError.desc": "Platforma možda trenutačno nije dostupna ili možda imamo nekih problema, zbog čega Vas molimo da pokušate ponovno.<br><br>Automatski pratimo ove greške, ali ako i dalje budete nailazili na problem, slobodno nam se javite na:<br><a>tech@homeexchange.com</a>",
  "modal.genericError.title": "Ajoj! Nešto nije u redu",
  "modal.noEmailRecieved.desc": "<b>Niste primili e-poruku?</b>Provjerite svoj pretinac neželjene pošte i jeste li točno upisali svoju adresu e-pošte prije nego što zatražite još jednu e-poruku s potvrdom.",
  "modal.noEmailRecieved.error": "Nešto nije u redu, pokušajte ponovno kasnije",
  "modal.verifyEmail.emailResent.toast": "Poslali smo Vam novu e-poruku s potvrdom na <b>{{email}}</b>.",
  "signin-modal.apple.button": "Prijavite se s Apple ID-om",
  "signin-modal.button": "Prijavite se",
  "signin-modal.email.button": "Prijavite se",
  "signin-modal.error.content": "",
  "signin-modal.error.email_no_verified.content": "",
  "signin-modal.error.email_no_verified.title": "",
  "signin-modal.error.title": "",
  "signin-modal.facebook.button": "Prijavite se putem Facebooka",
  "signin-modal.no-account": "Još nemate račun?",
  "signin-modal.reset-password": "",
  "signin-modal.title": "",
  "signin.modal.reset-password": "Resetirajte lozinku",
  "signup-modal.accept-cgu": "Izradom računa, prihvaćam",
  "signup-modal.apple.button": "Prijavite se s Apple ID-om",
  "signup-modal.button": "Registrirajte se",
  "signup-modal.cgu.link": "Opće Uvjete korištenja",
  "signup-modal.description": "Otkrijte novi način putovanja sa zamjenom domova: odsjedajte svugdje po svijetu i uštedite novac!",
  "signup-modal.email.button": "Registrirajte se sa Vašom email adresom",
  "signup-modal.email.form.submit": "",
  "signup-modal.error.content": "",
  "signup-modal.error.title": "",
  "signup-modal.facebook.button": "Registrirajte se putem Facebooka",
  "signup-modal.have-an-account": "Već imate račun?"
}, Y4e = "Studio", X4e = "{{count}} soba", Q4e = "{{count}} sobe", eUe = "{{count}} sobe", tUe = "", aUe = "{{count}} krevet", oUe = "{{count}} kreveti", nUe = "{{count}} kreveti", rUe = "Odrasle osobe", iUe = "Bebe", sUe = "Vaš je kalendar ažuriran.", lUe = "Mjesec", cUe = "Točni datumi", uUe = "Jedan tjedan", dUe = "Jedan vikend", gUe = "dana", hUe = "dan", pUe = "dana", mUe = "± {{count}} dan", fUe = "Dva tjedna", bUe = "Odustani", _Ue = "Djeca", vUe = "Datumi", yUe = "Izbrišite", wUe = "Opis", kUe = "Odredište", xUe = "Gotovo!", $Ue = "Uredite", SUe = "Sve vrste zamjene", CUe = "Kada", EUe = "Roštilj", jUe = "Bicikl", OUe = "Automobil", zUe = "Mačka", AUe = "Grad", PUe = "Ruralno", DUe = "Perilica suđa", NUe = "Pas", RUe = "Sušilica", IUe = "Dizalo", TUe = "Favoriti", LUe = "Kamin", MUe = "Stan", WUe = "Privatno dvorište", BUe = "manje od {{max}} GP", FUe = "od {{min}} GP", VUe = "Između {{min}} i {{max}} GP", UUe = "Privatna teretana", qUe = "Kuća", HUe = "Otok", GUe = "Izoliran", KUe = "Jacuzzi", JUe = "Jezera", ZUe = "Domove iz Collectiona", YUe = "Planine", XUe = "broj kupanica: %{count}", QUe = "Ostale životinje", eqe = "Glasovir", tqe = "Dječje igralište", aqe = "Moj dom", oqe = "Recipročna zamjena", nqe = "Obrnuta pretraga", rqe = "Rijeka", iqe = "Na obali", sqe = "Drugi", lqe = "TV", cqe = "Selo", uqe = "WiFi", dqe = "Filtri", gqe = "Fiksni datumi", hqe = "{{date}}: jedan mjesec", pqe = "{{date}}: jedan vikend", mqe = "{{date}}: jedan tjedan", fqe = "{{date}}: dva tjedna", bqe = "Fleksibilni datumi", _qe = "Gosti", vqe = "domova", yqe = "U zadnji tren", wqe = "Lokacija", kqe = "Uredi", xqe = "", $qe = "Dalje", Sqe = "odraslih osoba", Cqe = "odrasla osoba", Eqe = "odrasle osobe", jqe = "odraslih osoba", Oqe = "beba", zqe = "beba", Aqe = "bebe", Pqe = "beba", Dqe = "djece", Nqe = "dijete", Rqe = "djeteta", Iqe = "djece", Tqe = "gostiju", Lqe = "gost", Mqe = "gosta", Wqe = "gostiju", Bqe = "Format telefonskog broja nije valjan.", Fqe = "Primajte obavijesti e-poštom", Vqe = "Spremi", Uqe = "Nema pronađenih lokacija", qqe = "Saznajte više", Hqe = "Planovi putovanja", Gqe = "", Kqe = "nije obavezno", Jqe = {
  "autocomplete.button": "Pretražite",
  "autocomplete.placeholder": "Gdje ideš ?",
  bedroomsNumbers_zero: Y4e,
  bedroomsNumbers_one: X4e,
  bedroomsNumbers_few: Q4e,
  bedroomsNumbers_other: eUe,
  beds_zero: tUe,
  beds_one: aUe,
  beds_few: oUe,
  beds_other: nUe,
  "button.free-signup": "Prijavite se besplatno",
  "button.validate": "Potvrdite",
  "common.try-again": "Pokušajte ponovno",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Ne smije biti dulje od {{limit}} znakova",
  "error.reload": "Osvježite stranicu",
  "error.return-homepage": "Vratite se na početnu stranicu",
  "error.subtitle": "Nažalost ne može se pristupiti ovoj stranici.",
  "error.title": "Došlo je do greške na stranici.",
  "errors.unable_to_submit.subtitle": "Nažalost, Vaš obrazac trenutačno ne može biti predan. Molimo da kasnije pokušate ponovno.",
  "errors.unable_to_submit.title": "Ups, imamo problem",
  "global.back": "Natrag",
  "global.cancel": "Odustani",
  "global.collection.browsehomes": "Pretražujte domove",
  "global.collection.contactus": "Kontaktirajte nas",
  "global.confirm": "Potvrdi",
  "global.continue": "Nastavite",
  "global.getStarted": "Započnite",
  "global.login": "Prijava",
  "global.select": "Odaberi",
  global_adults: rUe,
  global_babies: iUe,
  global_calendarUpdated_toast: sUe,
  global_calendar_aMonth: lUe,
  global_calendar_exactDates: cUe,
  global_calendar_oneWeek: uUe,
  global_calendar_oneWeekend: dUe,
  global_calendar_plusMinusDay_zero: gUe,
  global_calendar_plusMinusDay_one: hUe,
  global_calendar_plusMinusDay_few: pUe,
  global_calendar_plusMinusDay_other: mUe,
  global_calendar_twoWeeks: fUe,
  global_cancel: bUe,
  global_children: _Ue,
  global_dates: vUe,
  global_delete: yUe,
  global_description: wUe,
  global_destination: kUe,
  global_done: xUe,
  global_edit: $Ue,
  "global_filter_a-c": "Klima uređaj",
  global_filter_available: SUe,
  "global_filter_baby-bed": "Kreveti za bebe",
  "global_filter_baby-gear": "Oprema za bebe",
  "global_filter_balcony-terrace": "Balkon/terasa",
  global_filter_bathtub: CUe,
  global_filter_bbq: EUe,
  global_filter_bicycle: jUe,
  global_filter_car: OUe,
  global_filter_cat: zUe,
  "global_filter_children-welcome": "Djeca su dobrodošla",
  global_filter_cities: AUe,
  "global_filter_cleaning-person": "Čistačica",
  global_filter_countryside: PUe,
  "global_filter_dedicated-workspace": "Zaseban radni prostor",
  "global_filter_disabled-access": "Pristupačan dom",
  global_filter_dishwasher: DUe,
  global_filter_dog: NUe,
  global_filter_dryer: RUe,
  "global_filter_eco-level": "Samo održivi domovi",
  "global_filter_electric-car-plug": "Utikač za električni automobil",
  global_filter_elevator: IUe,
  global_filter_favorite: TUe,
  global_filter_fireplace: LUe,
  global_filter_flat: MUe,
  global_filter_garden: WUe,
  "global_filter_guest-wanted": "Zamjena sa GuestPoints bodovima",
  global_filter_guestPointsMax: BUe,
  global_filter_guestPointsMin: FUe,
  global_filter_guestPointsMinMax: VUe,
  global_filter_gym: UUe,
  "global_filter_heating-system": "Sustav grijanja",
  "global_filter_high-speed-connexion": "Velika brzina veze",
  global_filter_home: qUe,
  "global_filter_home-verified": "Provjereni domovi ",
  global_filter_island: HUe,
  global_filter_isolated: GUe,
  global_filter_jacuzzi: KUe,
  "global_filter_kids-toys": "Dječje igračke",
  global_filter_lakes: JUe,
  global_filter_luxury: ZUe,
  global_filter_mountains: YUe,
  "global_filter_no-bed-up": "Nema privremenih kreveta",
  global_filter_numOfBathrooms: XUe,
  global_filter_other: QUe,
  "global_filter_parking-space": "Privatno parkirno mjesto",
  "global_filter_pets-welcome": "Kućni ljubimci su dobrodošli",
  global_filter_piano: eqe,
  global_filter_playground: tqe,
  global_filter_primary: aqe,
  "global_filter_public-transit-access": "Pristup javnim prijevozom",
  global_filter_reciprocal: oqe,
  "global_filter_response-rate-above-threshold": "Stopa odgovora ≥ Prosječno",
  global_filter_reverse: nqe,
  global_filter_river: rqe,
  global_filter_seaside: iqe,
  global_filter_secondary: sqe,
  "global_filter_secured-pool": "Osiguran bazen",
  "global_filter_smokers-welcome": "Dozvoljeno pušenje",
  "global_filter_swimming-pool": "Bazen",
  global_filter_tv: lqe,
  global_filter_villages: cqe,
  "global_filter_washing-machine": "Perilica rublja",
  "global_filter_whole-unit": "Cijela jedinica",
  global_filter_wifi: uqe,
  global_filters: dqe,
  global_fixDates: gqe,
  global_flexDates_aMonth: hqe,
  global_flexDates_aWeekend: pqe,
  global_flexDates_oneWeek: mqe,
  global_flexDates_twoWeek: fqe,
  global_flexibleDates: bqe,
  global_guests: _qe,
  global_homes: vqe,
  global_lastMinute: yqe,
  global_location: wqe,
  global_modify: kqe,
  global_name: xqe,
  global_next: $qe,
  global_numberOfAdults_zero: Sqe,
  global_numberOfAdults_one: Cqe,
  global_numberOfAdults_few: Eqe,
  global_numberOfAdults_other: jqe,
  global_numberOfBabies_zero: Oqe,
  global_numberOfBabies_one: zqe,
  global_numberOfBabies_few: Aqe,
  global_numberOfBabies_other: Pqe,
  global_numberOfChildren_zero: Dqe,
  global_numberOfChildren_one: Nqe,
  global_numberOfChildren_few: Rqe,
  global_numberOfChildren_other: Iqe,
  global_numberOfGuests_zero: Tqe,
  global_numberOfGuests_one: Lqe,
  global_numberOfGuests_few: Mqe,
  global_numberOfGuests_other: Wqe,
  global_phoneNumber_notValid: Bqe,
  global_receiveEmailAlerts: Fqe,
  global_save: Vqe,
  global_searchBar_noLocationFound: Uqe,
  global_seeMore_link: qqe,
  global_travelWishlist: Hqe,
  "modal.error-occured.content": "Žao nam je zbog neugodnosti, ali pokušajte ponovno.",
  "modal.error-occured.title": "Došlo je do pogreške.",
  no_result: Gqe,
  optional: Kqe,
  "privacy-policy": "Pravila o privatnosti"
}, Zqe = "https://www.homeexchange.com/blog/", Yqe = "/p/general-terms-of-use", Xqe = "https://www.homeexchange.com/hr/p/zajednica", Qqe = "https://homeexchangehelp.zendesk.com/hc/en-us", eHe = "", tHe = "https://www.homeexchange.com/hr/p/service-homeexchange-hr", aHe = "https://www.homeexchange.com/hr/p/guestpoints-hr", oHe = "https://www.homeexchange.com/hr/p/press-hr", nHe = "https://www.homeexchange.com/p/rijeci-homeexchange", rHe = "", iHe = "https://www.homeexchange.com/hr/p/gdje-dobrodoslica-stvarno-pocinje", sHe = "https://www.homeexchange.com/hr/p/gdje-dobrodoslica-stvarno-pocinje", lHe = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/hr/p/about-us-hr",
  blog: Zqe,
  cgu: Yqe,
  community: Xqe,
  "contact-us": "https://www.homeexchange.com/hr/kontaktirajte-nas-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: Qqe,
  forum: eHe,
  guarantees: tHe,
  guestpoints: aHe,
  "happiness-team": "https://www.homeexchange.com/hr/p/happiness-team-hr",
  "how-it-works": "https://www.homeexchange.com/hr/p/kako-to-funkcionira-hr",
  "join-us": "https://www.homeexchange.com/hr/p/join-us-hr",
  "legal-notice": "/p/pravna-napomena",
  "mobile-app": "https://www.homeexchange.com/hr/p/mobilna-aplikacija",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: oHe,
  "privacy-policy": "/p/privacy-policy-hr",
  "subscription-cost": "https://www.homeexchange.com/hr/p/subscription-homeexchange-hr",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: nHe,
  travelWishlist_faq_links: rHe,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: iHe,
  values: sHe
}, cHe = "Ime", uHe = "Prezime", dHe = "Dodajte u svoje planove putovanja", gHe = "Ažurirani planovi putovanja će Vam omogućiti da dobivate više zahtjeva za recipročne zamjene.", hHe = "Jeste li sigurni da želite obrisati lokaciju {{fullAddress}}?", pHe = "Ovo su filtri koji ste odabrali. Ako ste se predomislili, možete obrisati neke od njih. Ali ako želite dodati neke druge, morate započeti novo pretraživanje (iako će se ovo uskoro promijeniti... pratite obavijesti)!", mHe = "Ovo može biti neka zemlja, grad ili cijela regija. Ako odaberete jako široku lokaciju, Vaši bi rezultati mogli biti manje točni.", fHe = "Upišite zemlju, grad ili regiju", bHe = "Pogledajte dostupne domove", _He = "Kada domovi s dostupnošću odgovaraju Vašim planovima putovanja.", vHe = "Izradite novi plan putovanja", yHe = "Lokacija {{fullAddress}} je obrisana iz Vaših planova putovanja.", wHe = "Odaberite svoje idealne datume putovanja (fleksibilne ili fiksne).", kHe = "Dodajte detalje kako biste pomogli drugima koji koriste značajku obrnutog pretraživanja da vide zašto Vas zanima njihova lokacija.", xHe = "Navedite koliko će ljudi putovati s Vama na ovom putovanju.", $He = "Ups! Lokacija {{fullAddress}} nije mogla biti spremljena u Vaše planove putovanja zbog neočekivanog razloga.", SHe = "Recite nam kada i kamo biste željeli otputovati kako biste dobivali zahtjeve za zamjene i obavijesti čim odgovarajući domovi postanu dostupni. Spremit ćemo Vaše pretraživanje u Vaše planove putovanja!", CHe = "Postoje li neke pustolovine za putovanja koje biste voljeli početi planirati?", EHe = "<updateDates>Ažurirajte svoje datume</updateDates> kako biste i dalje dobivali odgovarajuće obavijesti preko e-poruka ili <delete>obrišite ovo odredište</delete> iz svojih planova putovanja ako više ne razmišljate o njemu.", jHe = "Ovi datumi su u prošlosti", OHe = "Lokacija {{fullAddress}} je dodana u Vaše planove putovanja!", zHe = "{{fullAddress}} je uspješno ažurirana.", AHe = "Vaše je pretraživanje spremljeno i Vaš je kalendar ažuriran!", PHe = "Vaše je pretraživanje spremljeno. Pronađite ga u svojim planovima putovanja.", DHe = "Saznajte više o planovima putovanja", NHe = {
  firstname: cHe,
  lastname: uHe,
  modal_travelWishlist_addNew_title: dHe,
  modal_travelWishlist_delete_body: gHe,
  modal_travelWishlist_delete_title: hHe,
  modal_travelWishlist_filtersApplied_helper: pHe,
  modal_travelWishlist_location_helper: mHe,
  modal_travelWishlist_searchBar_placeholder: fHe,
  page_travelWishlist_card_cta: bHe,
  page_travelWishlist_card_emailAlerts_helper: _He,
  page_travelWishlist_cta: vHe,
  page_travelWishlist_deleted_toast: yHe,
  page_travelWishlist_edit_dates_helper: wHe,
  page_travelWishlist_edit_description_helper: kHe,
  page_travelWishlist_edit_guests_helper: xHe,
  page_travelWishlist_error_toast: $He,
  page_travelWishlist_none_body: SHe,
  page_travelWishlist_none_subheader: CHe,
  page_travelWishlist_pastDates_desc: EHe,
  page_travelWishlist_pastDates_title: jHe,
  page_travelWishlist_saved_toast: OHe,
  page_travelWishlist_updated_toast: zHe,
  search_travelWishlist_calendarUpdated_toast: AHe,
  search_travelWishlist_saved_toast: PHe,
  travelWishlist_faq: DHe
}, RHe = {
  "modal.emailVerif.alreadyVerified.desc": "La tua email è pronta! Accedi per continuare.",
  "modal.emailVerif.alreadyVerified.title": "Il tuo indirizzo email è già stato verificato",
  "modal.emailVerif.callout": "Abbiamo inviato un'email di verifica a <b>{{email}}</b>.",
  "modal.emailVerif.desc": "Controlla la tua casella di posta. Il link all'interno scade dopo 24 ore.",
  "modal.emailVerif.linkExpired.desc": "Per ricevere un nuovo link di verifica alla tua mail, fai l'accesso.",
  "modal.emailVerif.linkExpired.title": "Questo link è scaduto",
  "modal.emailVerif.resend-email-link": "Invia di nuovo l'email di verifica",
  "modal.emailVerif.resend-email.rate-limit": "È stato raggiunto il limite di richieste via e-mail. Riprovare tra 1 minuto.",
  "modal.emailVerif.resend-link": "Invia di nuovo l'email di verifica",
  "modal.emailVerif.title": "Verifica il tuo indirizzo email",
  "modal.finishCreatingAccount.event": "A un evento",
  "modal.finishCreatingAccount.everyone_knows_homeexchange": "Tutti conoscono HomeExchange",
  "modal.finishCreatingAccount.facebook": "Facebook",
  "modal.finishCreatingAccount.firstName.error": "Inserisci il tuo nome",
  "modal.finishCreatingAccount.friends_family": "Tramite amici, parenti o conoscenti",
  "modal.finishCreatingAccount.hearAboutHE": "Come hai scoperto HomeExchange?",
  "modal.finishCreatingAccount.instagram": "Instagram",
  "modal.finishCreatingAccount.lastName.error": "Inserisci il tuo cognome",
  "modal.finishCreatingAccount.other": "Altro",
  "modal.finishCreatingAccount.phone_number": "Numero di telefono",
  "modal.finishCreatingAccount.phone_number.error": "Inserisci il tuo numero di telefono",
  "modal.finishCreatingAccount.pleaseSpecify": "Specifica",
  "modal.finishCreatingAccount.press": "Sulla stampa",
  "modal.finishCreatingAccount.press_online": "Online",
  "modal.finishCreatingAccount.press_print": "Stampa",
  "modal.finishCreatingAccount.radio": "Alla radio",
  "modal.finishCreatingAccount.referral": "Codice invito",
  "modal.finishCreatingAccount.referralCode.error": "Questo codice invito non è valido",
  "modal.finishCreatingAccount.search_engine": "Su un motore di ricerca",
  "modal.finishCreatingAccount.social_media": "Nei social media",
  "modal.finishCreatingAccount.social_network_other": "Altro social network (specificare)",
  "modal.finishCreatingAccount.title": "Completa la creazione del tuo account",
  "modal.finishCreatingAccount.tv": "Alla TV",
  "modal.finishCreatingAccount.tv_ad": "In una pubblicità",
  "modal.finishCreatingAccount.tv_show": "In un reportage / programma televisivo",
  "modal.genericError.desc": "La piattaforma potrebbe essere inattiva o potrebbe esserci un problema temporaneo da parte nostra, quindi riprova. <br> <br>Monitoriamo questi errori automaticamente, ma se il problema persiste non esitare a contattarci all'indirizzo:<br><a>tech@homeexchange.com</a>",
  "modal.genericError.title": "Oops! Qualcosa è andato storto",
  "modal.noEmailRecieved.desc": "<b>Non hai ricevuto l'email?</b>Controlla la cartella spam e l'ortografia della tua email prima di richiedere un'altra email di verifica.",
  "modal.noEmailRecieved.error": "Qualcosa è andato storto, per favore riprova più tardi",
  "modal.verifyEmail.emailResent.toast": "Ti abbiamo inviato una nuova email di verifica a <b>{{email}}</b>.",
  "signin-modal.apple.button": "Accedi tramite Google",
  "signin-modal.button": "Accedi",
  "signin-modal.email.button": "Accedi",
  "signin-modal.error.content": "",
  "signin-modal.error.email_no_verified.content": "",
  "signin-modal.error.email_no_verified.title": "",
  "signin-modal.error.title": "",
  "signin-modal.facebook.button": "Accedi tramite Facebook",
  "signin-modal.no-account": "Non hai ancora un account?",
  "signin-modal.reset-password": "",
  "signin-modal.title": "",
  "signin.modal.reset-password": "Reimposta la password",
  "signup-modal.accept-cgu": "Creando un account, accetto le",
  "signup-modal.apple.button": "Accedi con Apple",
  "signup-modal.button": "Registrati",
  "signup-modal.cgu.link": "Condizioni Generali di Utilizzo",
  "signup-modal.description": "Scopri un nuovo modo di viaggiare con lo scambio casa: lasciati accogliere in tutto il mondo e risparmia!",
  "signup-modal.email.button": "Registrati con il tuo indirizzo email",
  "signup-modal.email.form.submit": "",
  "signup-modal.error.content": "",
  "signup-modal.error.title": "",
  "signup-modal.facebook.button": "Registrati tramite Facebook",
  "signup-modal.have-an-account": "Hai già un account?"
}, IHe = "Monolocale", THe = "{{count}} camera da letto", LHe = "{{count}} camere da letto", MHe = "", WHe = "{{count}} letto", BHe = "{{count}} letti", FHe = "Adulti", VHe = "Neonati", UHe = "Il tuo calendario è stato aggiornato.", qHe = "Un mese", HHe = "Date esatte", GHe = "Una settimana", KHe = "", JHe = "", ZHe = "", YHe = "", XHe = "Due settimane", QHe = "Annulla", e6e = "Bambini", t6e = "Date", a6e = "Elimina", o6e = "Descrizione", n6e = "Destinazione", r6e = "Fatto!", i6e = "Modifica", s6e = "Qualsiasi tipo di scambio", l6e = "Vasca da bagno", c6e = "Barbecue", u6e = "Bicicletta", d6e = "Automobile", g6e = "Gatto", h6e = "Città", p6e = "Campagna", m6e = "Lavastoviglie", f6e = "Cane", b6e = "Asciugatrice", _6e = "Ascensore", v6e = "Case preferite", y6e = "Camino", w6e = "Appartamento", k6e = "Cortile privato", x6e = "Meno di {{max}} GP", $6e = "da {{min}} GP", S6e = "Tra {{min}} e {{max}} GP", C6e = "Palestra privata", E6e = "Casa", j6e = "Isola o penisola", O6e = "Isolata", z6e = "Idromassaggio", A6e = "Lago", P6e = "Case Collection", D6e = "Montagna", N6e = "{{count}} bagni", R6e = "Altri animali", I6e = "Pianoforte", T6e = "Zona giochi per bambini", L6e = "Prima", M6e = "Scambio reciproco", W6e = "Ricerca inversa", B6e = "Fiume", F6e = "Sulla costa", V6e = "Seconda", U6e = "TV", q6e = "Paese", H6e = "WiFi", G6e = "Filtri", K6e = "Date esatte", J6e = "Un mese in {{date}}", Z6e = "Un fine settimana in {{date}}", Y6e = "Una settimana in {{date}}", X6e = "Due settimane in {{date}}", Q6e = "Date flessibili", eGe = "Ospiti", tGe = "case", aGe = "Ultimo minuto", oGe = "Posizione", nGe = "Modifica", rGe = "Nome", iGe = "Avanti", sGe = "Zero", lGe = "Uno", cGe = "Altro", uGe = "Zero", dGe = "Uno", gGe = "Altro", hGe = "Zero", pGe = "Uno", mGe = "Altro", fGe = "Zero", bGe = "Uno", _Ge = "Altro", vGe = "Il formato del numero di telefono non è valido.", yGe = "Ricevi avvisi via email", wGe = "Salva", kGe = "Nessuna posizione trovata", xGe = "Vedere di più", $Ge = "Lista dei progetti di viaggio", SGe = "", CGe = "facoltativo", EGe = {
  "autocomplete.button": "Ricerca",
  "autocomplete.placeholder": "Dove stai andando?",
  bedroomsNumbers_zero: IHe,
  bedroomsNumbers_one: THe,
  bedroomsNumbers_other: LHe,
  beds_zero: MHe,
  beds_one: WHe,
  beds_other: BHe,
  "button.free-signup": "Iscriviti gratis",
  "button.validate": "Convalida",
  "common.try-again": "Prova ancora",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Non deve superare i {{limit}} caratteri",
  "error.reload": "Aggiorna la pagina",
  "error.return-homepage": "Ritorna alla home page",
  "error.subtitle": "Si è verificato un errore e non è stato possibile caricare questa pagina.",
  "error.title": "Si è verificato un errore nella pagina",
  "errors.unable_to_submit.subtitle": "Errore durante l'invio del modulo. Per favore riprova più tardi.",
  "errors.unable_to_submit.title": "Errore: è impossibile inviare",
  "global.back": "Indietro",
  "global.cancel": "Annulla",
  "global.collection.browsehomes": "Sfoglia le case",
  "global.collection.contactus": "Contattaci",
  "global.confirm": "Conferma",
  "global.continue": "Continua",
  "global.getStarted": "Cominciare",
  "global.login": "Accedi",
  "global.select": "Seleziona",
  global_adults: FHe,
  global_babies: VHe,
  global_calendarUpdated_toast: UHe,
  global_calendar_aMonth: qHe,
  global_calendar_exactDates: HHe,
  global_calendar_oneWeek: GHe,
  global_calendar_oneWeekend: KHe,
  global_calendar_plusMinusDay_zero: JHe,
  global_calendar_plusMinusDay_one: ZHe,
  global_calendar_plusMinusDay_other: YHe,
  global_calendar_twoWeeks: XHe,
  global_cancel: QHe,
  global_children: e6e,
  global_dates: t6e,
  global_delete: a6e,
  global_description: o6e,
  global_destination: n6e,
  global_done: r6e,
  global_edit: i6e,
  "global_filter_a-c": "Aria condizionata",
  global_filter_available: s6e,
  "global_filter_baby-bed": "Lettini per bambini",
  "global_filter_baby-gear": "Attrezzature per neonato",
  "global_filter_balcony-terrace": "Balcone/Terrazza",
  global_filter_bathtub: l6e,
  global_filter_bbq: c6e,
  global_filter_bicycle: u6e,
  global_filter_car: d6e,
  global_filter_cat: g6e,
  "global_filter_children-welcome": "Bambini benvenuti",
  global_filter_cities: h6e,
  "global_filter_cleaning-person": "Donna delle pulizie",
  global_filter_countryside: p6e,
  "global_filter_dedicated-workspace": "Spazio di lavoro dedicato",
  "global_filter_disabled-access": "Casa accessibile alle sedie a rotelle",
  global_filter_dishwasher: m6e,
  global_filter_dog: f6e,
  global_filter_dryer: b6e,
  "global_filter_eco-level": "Solo case sostenibili",
  "global_filter_electric-car-plug": "Presa per auto elettrica",
  global_filter_elevator: _6e,
  global_filter_favorite: v6e,
  global_filter_fireplace: y6e,
  global_filter_flat: w6e,
  global_filter_garden: k6e,
  "global_filter_guest-wanted": "Scambio con GuestPoints",
  global_filter_guestPointsMax: x6e,
  global_filter_guestPointsMin: $6e,
  global_filter_guestPointsMinMax: S6e,
  global_filter_gym: C6e,
  "global_filter_heating-system": "Sistema di riscaldamento",
  "global_filter_high-speed-connexion": "Connessione ad alta velocità",
  global_filter_home: E6e,
  "global_filter_home-verified": "Case verificate",
  global_filter_island: j6e,
  global_filter_isolated: O6e,
  global_filter_jacuzzi: z6e,
  "global_filter_kids-toys": "Giocattoli per bambini",
  global_filter_lakes: A6e,
  global_filter_luxury: P6e,
  global_filter_mountains: D6e,
  "global_filter_no-bed-up": "Nessun letto temporaneo",
  global_filter_numOfBathrooms: N6e,
  global_filter_other: R6e,
  "global_filter_parking-space": "Posto auto privato",
  "global_filter_pets-welcome": "Animali domestici ammessi",
  global_filter_piano: I6e,
  global_filter_playground: T6e,
  global_filter_primary: L6e,
  "global_filter_public-transit-access": "Accesso ai trasporti pubblici",
  global_filter_reciprocal: M6e,
  "global_filter_response-rate-above-threshold": "Tasso di risposta ≥ Nella media",
  global_filter_reverse: W6e,
  global_filter_river: B6e,
  global_filter_seaside: F6e,
  global_filter_secondary: V6e,
  "global_filter_secured-pool": "Piscina protetta",
  "global_filter_smokers-welcome": "I fumatori sono i benvenuti",
  "global_filter_swimming-pool": "Piscina",
  global_filter_tv: U6e,
  global_filter_villages: q6e,
  "global_filter_washing-machine": "Lavatrice",
  "global_filter_whole-unit": "L'intera unità",
  global_filter_wifi: H6e,
  global_filters: G6e,
  global_fixDates: K6e,
  global_flexDates_aMonth: J6e,
  global_flexDates_aWeekend: Z6e,
  global_flexDates_oneWeek: Y6e,
  global_flexDates_twoWeek: X6e,
  global_flexibleDates: Q6e,
  global_guests: eGe,
  global_homes: tGe,
  global_lastMinute: aGe,
  global_location: oGe,
  global_modify: nGe,
  global_name: rGe,
  global_next: iGe,
  global_numberOfAdults_zero: sGe,
  global_numberOfAdults_one: lGe,
  global_numberOfAdults_other: cGe,
  global_numberOfBabies_zero: uGe,
  global_numberOfBabies_one: dGe,
  global_numberOfBabies_other: gGe,
  global_numberOfChildren_zero: hGe,
  global_numberOfChildren_one: pGe,
  global_numberOfChildren_other: mGe,
  global_numberOfGuests_zero: fGe,
  global_numberOfGuests_one: bGe,
  global_numberOfGuests_other: _Ge,
  global_phoneNumber_notValid: vGe,
  global_receiveEmailAlerts: yGe,
  global_save: wGe,
  global_searchBar_noLocationFound: kGe,
  global_seeMore_link: xGe,
  global_travelWishlist: $Ge,
  "modal.error-occured.content": "Ci spiace davvero per l'inconveniente, ti chiediamo di riprovare.",
  "modal.error-occured.title": "Oh no, si è verificato un errore!",
  no_result: SGe,
  optional: CGe,
  "privacy-policy": "Informativa sulla privacy"
}, jGe = "https://www.homeexchange.it/blog/", OGe = "/p/homeexchange-condizioni-di-uso", zGe = "https://www.homeexchange.it/p/comunita", AGe = "https://homeexchangehelp.zendesk.com/hc/it", PGe = "", DGe = "https://www.homeexchange.it/p/service-homeexchange-it", NGe = "https://www.homeexchange.it/p/guestpoints-it", RGe = "https://www.homeexchange.it/p/stampa", IGe = "https://www.homeexchange.com/p/racconti-homeexchangers", TGe = "https://help.homeexchange.com/hc/it/articles/360000623717-Cosa-sono-le-mie-destinazioni-preferite-e-a-cosa-servono", LGe = "", MGe = "https://www.homeexchange.it/p/la-dove-accoglienza-inizia-davvero", WGe = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.it/p/about-us-it",
  blog: jGe,
  cgu: OGe,
  community: zGe,
  "contact-us": "https://www.homeexchange.it/contattaci-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/HomeExchangeIT/",
  faq: AGe,
  forum: PGe,
  guarantees: DGe,
  guestpoints: NGe,
  "happiness-team": "https://www.homeexchange.it/p/happiness-team-it",
  "how-it-works": "https://www.homeexchange.it/p/come-funziona-it",
  "join-us": "https://www.homeexchange.it/p/join-us-it",
  "legal-notice": "/p/avviso-legale",
  "mobile-app": "https://www.homeexchange.it/p/app-mobile",
  "our-team": "https://www.homeexchange.it/p/nostro-team",
  press: RGe,
  "privacy-policy": "/p/homeexchange-informativa-privacy",
  "subscription-cost": "https://www.homeexchange.it/p/subscription-homeexchange-it",
  "term-of-use": "/p/homeexchange-condizioni-di-uso",
  testimonials: IGe,
  travelWishlist_faq_links: TGe,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: LGe,
  values: MGe
}, BGe = "Nome", FGe = "Cognome", VGe = "Aggiungi ai progetti di viaggio", UGe = "Una lista dei tuoi progetti di viaggio aggiornata ti consentirà di ricevere più richieste di scambio reciproco.", qGe = "Vuoi davvero eliminare {{fullAddress}}?", HGe = "Hai selezionato questi filtri. Se hai cambiato idea, puoi eliminarne alcuni qui sotto. Se invece desideri aggiungerne altri, dovrai avviare una nuova ricerca (ma presto non sarà più così... non perderti gli aggiornamenti)!", GGe = "Potrebbe trattarsi di un paese, una città o un'intera regione. Se scegli una zona ampia, i risultati potrebbero essere meno accurati.", KGe = "Digita un paese, una città o una regione", JGe = "Vedi le case disponibili", ZGe = "Quando le case disponibili corrispondono ai tuoi progetti di viaggio.", YGe = "Aggiungi ai progetti di viaggio", XGe = "{{fullAddress}} è stato eliminato dai tuoi progetti di viaggio.", QGe = "Seleziona le date di viaggio ideali (flessibili o fisse).", eKe = "Aggiungi dei dettagli per aiutare gli altri utenti che utilizzano la funzione di ricerca inversa a capire perché ti interessa la loro zona.", tKe = "Specifica quante persone viaggeranno con te.", aKe = "Ops! {{fullAddress}} non è stato salvato nella lista dei tuoi progetti di viaggio per un motivo imprevisto.", oKe = "Facci sapere quando e dove vorresti viaggiare per ricevere richieste di scambio e avvisi non appena saranno disponibili delle case adatte. Salveremo le tue ricerche nella lista dei tuoi progetti di viaggio!", nKe = "Ci sono nuove avventure che vorresti iniziare a pianificare?", rKe = "<updateDates>Aggiorna le tue date</updateDates> per continuare a ricevere gli avvisi pertinenti via mail oppure <delete>elimina questa destinazione</delete> dalla lista dei tuoi progetti di viaggio se hai cambiato idea.", iKe = "Queste date sono già passate", sKe = "{{fullAddress}} è stato aggiunto alla lista dei tuoi progetti di viaggio!", lKe = "{{fullAddress}} è stato aggiornato correttamente.", cKe = "La tua ricerca è stata salvata e il tuo calendario è aggiornato!", uKe = "La tua ricerca è stata salvata. La trovi nella lista dei tuoi progetti di viaggio.", dKe = "Scopri di più sulle liste per i progetti di viaggio", gKe = {
  firstname: BGe,
  lastname: FGe,
  modal_travelWishlist_addNew_title: VGe,
  modal_travelWishlist_delete_body: UGe,
  modal_travelWishlist_delete_title: qGe,
  modal_travelWishlist_filtersApplied_helper: HGe,
  modal_travelWishlist_location_helper: GGe,
  modal_travelWishlist_searchBar_placeholder: KGe,
  page_travelWishlist_card_cta: JGe,
  page_travelWishlist_card_emailAlerts_helper: ZGe,
  page_travelWishlist_cta: YGe,
  page_travelWishlist_deleted_toast: XGe,
  page_travelWishlist_edit_dates_helper: QGe,
  page_travelWishlist_edit_description_helper: eKe,
  page_travelWishlist_edit_guests_helper: tKe,
  page_travelWishlist_error_toast: aKe,
  page_travelWishlist_none_body: oKe,
  page_travelWishlist_none_subheader: nKe,
  page_travelWishlist_pastDates_desc: rKe,
  page_travelWishlist_pastDates_title: iKe,
  page_travelWishlist_saved_toast: sKe,
  page_travelWishlist_updated_toast: lKe,
  search_travelWishlist_calendarUpdated_toast: cKe,
  search_travelWishlist_saved_toast: uKe,
  travelWishlist_faq: dKe
}, hKe = {
  "modal.emailVerif.alreadyVerified.desc": "",
  "modal.emailVerif.alreadyVerified.title": "",
  "modal.emailVerif.callout": "En verifiserings-e-post har blitt sendt til <b>{{email}}</b>.",
  "modal.emailVerif.desc": "Sjekk innboksen din. Lenken i denne e-posten vil utløpe om 24 timer.",
  "modal.emailVerif.linkExpired.desc": "",
  "modal.emailVerif.linkExpired.title": "",
  "modal.emailVerif.resend-email-link": "Send bekreftelsesmeldingen på nytt",
  "modal.emailVerif.resend-email.rate-limit": "Du har nådd grensen for e-postforespørsler. Prøv igjen om 1 minutt.",
  "modal.emailVerif.resend-link": "Send bekreftelsesmeldingen på nytt",
  "modal.emailVerif.title": "Verifiser din e-postadresse",
  "modal.finishCreatingAccount.event": "",
  "modal.finishCreatingAccount.everyone_knows_homeexchange": "",
  "modal.finishCreatingAccount.facebook": "",
  "modal.finishCreatingAccount.firstName.error": "",
  "modal.finishCreatingAccount.friends_family": "",
  "modal.finishCreatingAccount.hearAboutHE": "",
  "modal.finishCreatingAccount.instagram": "",
  "modal.finishCreatingAccount.lastName.error": "",
  "modal.finishCreatingAccount.other": "",
  "modal.finishCreatingAccount.phone_number": "Telefonnummer",
  "modal.finishCreatingAccount.phone_number.error": "Skriv inn telefonnummeret",
  "modal.finishCreatingAccount.pleaseSpecify": "",
  "modal.finishCreatingAccount.press": "",
  "modal.finishCreatingAccount.press_online": "",
  "modal.finishCreatingAccount.press_print": "",
  "modal.finishCreatingAccount.radio": "",
  "modal.finishCreatingAccount.referral": "",
  "modal.finishCreatingAccount.referralCode.error": "",
  "modal.finishCreatingAccount.search_engine": "",
  "modal.finishCreatingAccount.social_media": "",
  "modal.finishCreatingAccount.social_network_other": "",
  "modal.finishCreatingAccount.title": "",
  "modal.finishCreatingAccount.tv": "",
  "modal.finishCreatingAccount.tv_ad": "",
  "modal.finishCreatingAccount.tv_show": "",
  "modal.genericError.desc": "",
  "modal.genericError.title": "",
  "modal.noEmailRecieved.desc": "",
  "modal.noEmailRecieved.error": "",
  "modal.verifyEmail.emailResent.toast": "Vi har sendt deg en ny e-post for verifisering til <b>{{email}}</b>.",
  "signin-modal.apple.button": "Logg inn med Apple",
  "signin-modal.button": "Logg inn",
  "signin-modal.email.button": "Logg inn",
  "signin-modal.error.content": "",
  "signin-modal.error.email_no_verified.content": "",
  "signin-modal.error.email_no_verified.title": "",
  "signin-modal.error.title": "",
  "signin-modal.facebook.button": "Logg inn med Facebook",
  "signin-modal.no-account": "Ingen konto ennå?",
  "signin-modal.reset-password": "",
  "signin-modal.title": "",
  "signin.modal.reset-password": "Tilbakestill passord",
  "signup-modal.accept-cgu": "Ved å opprette en konto, aksepterer jeg",
  "signup-modal.apple.button": "Logg inn med Apple",
  "signup-modal.button": "Registrer deg",
  "signup-modal.cgu.link": "Generelle vilkår for bruk",
  "signup-modal.description": "Oppdag en ny måte å reise på med HomeExchange: bli ønsket velkommen over hele verden og spar penger!",
  "signup-modal.email.button": "Registrer deg med e-postadresse",
  "signup-modal.email.form.submit": "",
  "signup-modal.error.content": "",
  "signup-modal.error.title": "",
  "signup-modal.facebook.button": "Registrer deg med Facebook",
  "signup-modal.have-an-account": "Har du allerede en konto?"
}, pKe = "Studio", mKe = "{{count}} soverom", fKe = "{{count}} soverom", bKe = "", _Ke = "{{count}} seng", vKe = "{{count}} senger", yKe = "Voksne", wKe = "Babyer", kKe = "", xKe = "En måned", $Ke = "Nøyaktige datoer", SKe = "Uke", CKe = "", EKe = "", jKe = "", OKe = "", zKe = "To uker", AKe = "", PKe = "Barn", DKe = "Datoer", NKe = "", RKe = "Beskrivelse", IKe = "Reisemål", TKe = "", LKe = "", MKe = "alle typer boligbytter", WKe = "Badekar", BKe = "Grill", FKe = "Sykkel", VKe = "Bil", UKe = "Katt", qKe = "By", HKe = "Landlig", GKe = "Oppvaskmaskin", KKe = "Hund", JKe = "Tørketrommel", ZKe = "Heis", YKe = "Favoritthjem", XKe = "Peis", QKe = "Leilighet", e5e = "", t5e = "mindre enn {{max}} GP", a5e = "fra {{min}} GP", o5e = "Mellom {{min}} og {{max}} GP", n5e = "Privat treningsrom", r5e = "Hus", i5e = "Øy", s5e = "Isolert", l5e = "Jacuzzi", c5e = "Innsjøer", u5e = "Collection-hjem", d5e = "Fjell", g5e = "", h5e = "Andre dyr", p5e = "Piano", m5e = "", f5e = "Primær", b5e = "Gjensidig boligbytte", _5e = "Omvendt søk", v5e = "Elv", y5e = "", w5e = "Sekundær", k5e = "TV", x5e = "Landsbygd", $5e = "WiFi", S5e = "Filtrer", C5e = "Nøyaktige datoer", E5e = "", j5e = "", O5e = "", z5e = "", A5e = "Fleksible datoer", P5e = "Gjester", D5e = "", N5e = "Siste øyeblikk", R5e = "Beliggenhet", I5e = "", T5e = "", L5e = "", M5e = "", W5e = "", B5e = "", F5e = "", V5e = "", U5e = "", q5e = "", H5e = "", G5e = "", K5e = "", J5e = "", Z5e = "", Y5e = "", X5e = "", Q5e = "Lagre", e9e = "", t9e = "Se mer", a9e = "", o9e = "", n9e = "", r9e = {
  "autocomplete.button": "Søk",
  "autocomplete.placeholder": "Hvor skal du ?",
  bedroomsNumbers_zero: pKe,
  bedroomsNumbers_one: mKe,
  bedroomsNumbers_other: fKe,
  beds_zero: bKe,
  beds_one: _Ke,
  beds_other: vKe,
  "button.free-signup": "Registrer deg gratis",
  "button.validate": "Bekreft",
  "common.try-again": "",
  "contact-tech-email": "contact@homeexchange.com",
  "error.characters_max_limit": "Kan ikke overstige {{limit}} tegn",
  "error.reload": "Oppdater siden",
  "error.return-homepage": "Gå tilbake til startsiden",
  "error.subtitle": "Denne siden kan dessverre ikke nås.",
  "error.title": "En feil har oppstått på siden",
  "errors.unable_to_submit.subtitle": "Skjemaet ditt kunne dessverre ikke sendes inn akkurat nå. Vennligst prøv igjen senere.",
  "errors.unable_to_submit.title": "Oops, det har oppstått et problem",
  "global.back": "Tilbake",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "Fortsett",
  "global.getStarted": "",
  "global.login": "",
  "global.select": "",
  global_adults: yKe,
  global_babies: wKe,
  global_calendarUpdated_toast: kKe,
  global_calendar_aMonth: xKe,
  global_calendar_exactDates: $Ke,
  global_calendar_oneWeek: SKe,
  global_calendar_oneWeekend: CKe,
  global_calendar_plusMinusDay_zero: EKe,
  global_calendar_plusMinusDay_one: jKe,
  global_calendar_plusMinusDay_other: OKe,
  global_calendar_twoWeeks: zKe,
  global_cancel: AKe,
  global_children: PKe,
  global_dates: DKe,
  global_delete: NKe,
  global_description: RKe,
  global_destination: IKe,
  global_done: TKe,
  global_edit: LKe,
  "global_filter_a-c": "Klimaanlegg",
  global_filter_available: MKe,
  "global_filter_baby-bed": "Sprinkelsenger",
  "global_filter_baby-gear": "Babyutstyr",
  "global_filter_balcony-terrace": "",
  global_filter_bathtub: WKe,
  global_filter_bbq: BKe,
  global_filter_bicycle: FKe,
  global_filter_car: VKe,
  global_filter_cat: UKe,
  "global_filter_children-welcome": "Barn velkommen",
  global_filter_cities: qKe,
  "global_filter_cleaning-person": "Rengjøringsperson",
  global_filter_countryside: HKe,
  "global_filter_dedicated-workspace": "",
  "global_filter_disabled-access": "Tilgjengelig for funksjonshemmede",
  global_filter_dishwasher: GKe,
  global_filter_dog: KKe,
  global_filter_dryer: JKe,
  "global_filter_eco-level": "Bare bærekraftige hjem",
  "global_filter_electric-car-plug": "Elektrisk bilplugg",
  global_filter_elevator: ZKe,
  global_filter_favorite: YKe,
  global_filter_fireplace: XKe,
  global_filter_flat: QKe,
  global_filter_garden: e5e,
  "global_filter_guest-wanted": "Boligbytte med GuestPoints",
  global_filter_guestPointsMax: t5e,
  global_filter_guestPointsMin: a5e,
  global_filter_guestPointsMinMax: o5e,
  global_filter_gym: n5e,
  "global_filter_heating-system": "Oppvarming",
  "global_filter_high-speed-connexion": "Høyhastighets tilkobling",
  global_filter_home: r5e,
  "global_filter_home-verified": "Verifiserte hjem",
  global_filter_island: i5e,
  global_filter_isolated: s5e,
  global_filter_jacuzzi: l5e,
  "global_filter_kids-toys": "Barneleker",
  global_filter_lakes: c5e,
  global_filter_luxury: u5e,
  global_filter_mountains: d5e,
  "global_filter_no-bed-up": "",
  global_filter_numOfBathrooms: g5e,
  global_filter_other: h5e,
  "global_filter_parking-space": "Privat parkering",
  "global_filter_pets-welcome": "Kjæledyr velkommen",
  global_filter_piano: p5e,
  global_filter_playground: m5e,
  global_filter_primary: f5e,
  "global_filter_public-transit-access": "Tilgang til offentlig transport",
  global_filter_reciprocal: b5e,
  "global_filter_response-rate-above-threshold": "",
  global_filter_reverse: _5e,
  global_filter_river: v5e,
  global_filter_seaside: y5e,
  global_filter_secondary: w5e,
  "global_filter_secured-pool": "Sikret badebasseng",
  "global_filter_smokers-welcome": "Røykere velkommen",
  "global_filter_swimming-pool": "Svømmebasseng",
  global_filter_tv: k5e,
  global_filter_villages: x5e,
  "global_filter_washing-machine": "Vaskemaskin",
  "global_filter_whole-unit": "Hele boligen",
  global_filter_wifi: $5e,
  global_filters: S5e,
  global_fixDates: C5e,
  global_flexDates_aMonth: E5e,
  global_flexDates_aWeekend: j5e,
  global_flexDates_oneWeek: O5e,
  global_flexDates_twoWeek: z5e,
  global_flexibleDates: A5e,
  global_guests: P5e,
  global_homes: D5e,
  global_lastMinute: N5e,
  global_location: R5e,
  global_modify: I5e,
  global_name: T5e,
  global_next: L5e,
  global_numberOfAdults_zero: M5e,
  global_numberOfAdults_one: W5e,
  global_numberOfAdults_other: B5e,
  global_numberOfBabies_zero: F5e,
  global_numberOfBabies_one: V5e,
  global_numberOfBabies_other: U5e,
  global_numberOfChildren_zero: q5e,
  global_numberOfChildren_one: H5e,
  global_numberOfChildren_other: G5e,
  global_numberOfGuests_zero: K5e,
  global_numberOfGuests_one: J5e,
  global_numberOfGuests_other: Z5e,
  global_phoneNumber_notValid: Y5e,
  global_receiveEmailAlerts: X5e,
  global_save: Q5e,
  global_searchBar_noLocationFound: e9e,
  global_seeMore_link: t9e,
  global_travelWishlist: a9e,
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: o9e,
  optional: n9e,
  "privacy-policy": "Personvernpolicy"
}, i9e = "https://www.homeexchange.com/blog/", s9e = "/p/general-terms-of-use", l9e = "https://www.homeexchange.com/nb/p/nettverk", c9e = "https://homeexchangehelp.zendesk.com/hc/pt", u9e = "", d9e = "https://www.homeexchange.com/nb/p/service-homeexchange-no", g9e = "https://www.homeexchange.com/nb/p/guestpoints-no", h9e = "https://www.homeexchange.com/nb/p/press-no", p9e = "https://www.homeexchange.com/p/ifolge-homeexchangers", m9e = "", f9e = "", b9e = "https://www.homeexchange.com/nb/p/der-velkomsten-virkelig-starter", _9e = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/nb/p/about-us-no",
  blog: i9e,
  cgu: s9e,
  community: l9e,
  "contact-us": "https://www.homeexchange.com/nb/p/kontact-oss-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: c9e,
  forum: u9e,
  guarantees: d9e,
  guestpoints: g9e,
  "happiness-team": "https://www.homeexchange.com/nb/p/happiness-team-no",
  "how-it-works": "https://www.homeexchange.com/nb/p/hvordan-fungerer-det-no",
  "join-us": "https://www.homeexchange.com/nb/p/join-us-no",
  "legal-notice": "/p/legal-notice-no",
  "mobile-app": "https://www.homeexchange.com/nb/p/mobile-app",
  "our-team": "https://www.homeexchange.com/nb/p/teamet-vart",
  press: h9e,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/nb/p/subscription-homeexchange-no",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: p9e,
  travelWishlist_faq_links: m9e,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: f9e,
  values: b9e
}, v9e = "Fornavn", y9e = "Etternavn", w9e = "", k9e = "", x9e = "", $9e = "", S9e = "", C9e = "", E9e = "Se tilgjengelige hjem", j9e = "", O9e = "", z9e = "", A9e = "", P9e = "", D9e = "", N9e = "", R9e = "", I9e = "", T9e = "", L9e = "", M9e = "", W9e = "", B9e = "", F9e = "", V9e = "", U9e = {
  firstname: v9e,
  lastname: y9e,
  modal_travelWishlist_addNew_title: w9e,
  modal_travelWishlist_delete_body: k9e,
  modal_travelWishlist_delete_title: x9e,
  modal_travelWishlist_filtersApplied_helper: $9e,
  modal_travelWishlist_location_helper: S9e,
  modal_travelWishlist_searchBar_placeholder: C9e,
  page_travelWishlist_card_cta: E9e,
  page_travelWishlist_card_emailAlerts_helper: j9e,
  page_travelWishlist_cta: O9e,
  page_travelWishlist_deleted_toast: z9e,
  page_travelWishlist_edit_dates_helper: A9e,
  page_travelWishlist_edit_description_helper: P9e,
  page_travelWishlist_edit_guests_helper: D9e,
  page_travelWishlist_error_toast: N9e,
  page_travelWishlist_none_body: R9e,
  page_travelWishlist_none_subheader: I9e,
  page_travelWishlist_pastDates_desc: T9e,
  page_travelWishlist_pastDates_title: L9e,
  page_travelWishlist_saved_toast: M9e,
  page_travelWishlist_updated_toast: W9e,
  search_travelWishlist_calendarUpdated_toast: B9e,
  search_travelWishlist_saved_toast: F9e,
  travelWishlist_faq: V9e
}, q9e = {
  "modal.emailVerif.alreadyVerified.desc": "Je e-mailadres is klaar! Log in om verder te gaan.",
  "modal.emailVerif.alreadyVerified.title": "Je e-mailadres is al geverifieerd",
  "modal.emailVerif.callout": "Er is een verificatie-e-mail verzonden naar <b>{{email}}</b>.",
  "modal.emailVerif.desc": "Controleer je inbox. De link in deze e-mail verloopt binnen 24 uur.",
  "modal.emailVerif.linkExpired.desc": "Log in om een nieuwe verificatielink in je inbox te ontvangen.",
  "modal.emailVerif.linkExpired.title": "Deze link is verlopen",
  "modal.emailVerif.resend-email-link": "Verificatie-e-mail opnieuw verzenden",
  "modal.emailVerif.resend-email.rate-limit": "Je hebt de limiet voor e-mailverzoeken bereikt. Probeer het opnieuw over 1 minuut.",
  "modal.emailVerif.resend-link": "Verificatie-e-mail opnieuw verzenden",
  "modal.emailVerif.title": "Verifieer je e-mailadres",
  "modal.finishCreatingAccount.event": "Op een evenement",
  "modal.finishCreatingAccount.everyone_knows_homeexchange": "Iedereen kent HomeExchange",
  "modal.finishCreatingAccount.facebook": "Facebook",
  "modal.finishCreatingAccount.firstName.error": "Voer je voornaam in",
  "modal.finishCreatingAccount.friends_family": "Via vrienden, familie of kennissen",
  "modal.finishCreatingAccount.hearAboutHE": "Hoe heb je over HomeExchange gehoord?",
  "modal.finishCreatingAccount.instagram": "Instagram",
  "modal.finishCreatingAccount.lastName.error": "Voer je achternaam in",
  "modal.finishCreatingAccount.other": "Andere",
  "modal.finishCreatingAccount.phone_number": "Telefoonnummer",
  "modal.finishCreatingAccount.phone_number.error": "Voer je telefoonnummer in",
  "modal.finishCreatingAccount.pleaseSpecify": "Gelieve te specificeren",
  "modal.finishCreatingAccount.press": "In de pers",
  "modal.finishCreatingAccount.press_online": "Online",
  "modal.finishCreatingAccount.press_print": "Gedrukte pers",
  "modal.finishCreatingAccount.radio": "Op de radio",
  "modal.finishCreatingAccount.referral": "Doorverwijzingscode",
  "modal.finishCreatingAccount.referralCode.error": "Deze doorverwijzingscode is ongeldig",
  "modal.finishCreatingAccount.search_engine": "Op een zoekmachine",
  "modal.finishCreatingAccount.social_media": "Via sociale media",
  "modal.finishCreatingAccount.social_network_other": "Ander sociaal netwerk (specificeer)",
  "modal.finishCreatingAccount.title": "Voltooi het aanmaken van je account",
  "modal.finishCreatingAccount.tv": "Op tv",
  "modal.finishCreatingAccount.tv_ad": "Via een advertentie",
  "modal.finishCreatingAccount.tv_show": "Tijdens een reportage/tv-programma",
  "modal.genericError.desc": "Het platform is mogelijk niet beschikbaar of er kan een tijdelijke storing zijn aan onze kant, dus probeer het opnieuw.<br><br> We traceren deze fouten automatisch, maar als het probleem zich blijft voordoen, neem dan gerust contact met ons op:<br><a> tech@homeexchange.com</a>",
  "modal.genericError.title": "Oeps! Er is iets misgegaan",
  "modal.noEmailRecieved.desc": "<b>Geen e-mail ontvangen?</b>Controleer je spammap en de spelling van je e-mail voordat je een nieuwe verificatiemail aanvraagt.",
  "modal.noEmailRecieved.error": "Er is iets misgegaan, probeer het later opnieuw",
  "modal.verifyEmail.emailResent.toast": "We hebben je een nieuwe verificatiemail gestuurd naar <b>{{email}}</b>.",
  "signin-modal.apple.button": "Meld je aan zonder Google",
  "signin-modal.button": "Inloggen",
  "signin-modal.email.button": "Inloggen",
  "signin-modal.error.content": "Er is een fout opgetreden",
  "signin-modal.error.email_no_verified.content": "E-mailadres niet geverifieerd",
  "signin-modal.error.email_no_verified.title": "Fout",
  "signin-modal.error.title": "Fout",
  "signin-modal.facebook.button": "Meld je aan zonder Facebook",
  "signin-modal.no-account": "Heb je nog geen account?",
  "signin-modal.reset-password": "Wachtwoord opnieuw instellen",
  "signin-modal.title": "Inloggen",
  "signin.modal.reset-password": "Wachtwoord opnieuw instellen",
  "signup-modal.accept-cgu": "Door een account aan te maken, accepteer ik de",
  "signup-modal.apple.button": "Inloggen met Apple",
  "signup-modal.button": "Inschrijven",
  "signup-modal.cgu.link": "Wettelijke bepalingen",
  "signup-modal.description": "Ontdek een nieuwe manier van reizen met HomeExchange: word overal ter wereld verwelkomd en bespaar geld!",
  "signup-modal.email.button": "Meld je aan met je e-mail adres",
  "signup-modal.email.form.submit": "Registreren",
  "signup-modal.error.content": "Er is een fout opgetreden",
  "signup-modal.error.title": "Fout",
  "signup-modal.facebook.button": "Inloggen met Facebook",
  "signup-modal.have-an-account": "Heb je al een account?"
}, H9e = "Studio", G9e = "{{count}} slaapkamer", K9e = "{{count}} slaapkamers", J9e = "", Z9e = "{{count}} bed", Y9e = "{{count}} bedden", X9e = "Volwassenen", Q9e = "Baby's", e8e = "Je kalender is bijgewerkt.", t8e = "Een maand", a8e = "Exacte data", o8e = "Een week", n8e = "Een weekend", r8e = "", i8e = "", s8e = "± {{count}} dagen", l8e = "Twee weken", c8e = "Annuleren", u8e = "Kinderen", d8e = "Data", g8e = "Verwijderen", h8e = "Beschrijving", p8e = "Bestemming", m8e = "Klaar!", f8e = "Bewerken", b8e = "Elk type ruil", _8e = "Bad", v8e = "BBQ", y8e = "Fiets", w8e = "Auto", k8e = "Kat", x8e = "De stad", $8e = "Het platteland", S8e = "Vaatwasmachine", C8e = "Hond", E8e = "Droger", j8e = "Lift", O8e = "Favoriete huizen", z8e = "Open haard", A8e = "Appartement", P8e = "Privétuin", D8e = "Minder dan {{max}} GP", N8e = "vanaf {{min}} GP", R8e = "Tussen {{min}} en {{max}} GP", I8e = "Privésportzaal", T8e = "Huis", L8e = "Een eiland", M8e = "Geïsoleerd", W8e = "Jacuzzi", B8e = "Een meer", F8e = "Collection-huizen", V8e = "De bergen", U8e = "{{count}} badkamers", q8e = "Andere dieren", H8e = "", G8e = "Speeltuin", K8e = "Eerste", J8e = "Wederzijdse huizenruil", Z8e = "Omgekeerd zoeken", Y8e = "Rivier", X8e = "Kust", Q8e = "Vakantiehuis", e7e = "TV", t7e = "Dorp", a7e = "WiFi", o7e = "Filters", n7e = "Vaste data", r7e = "Een maand in {{date}}", i7e = "Een weekend in {{date}}", s7e = "Een week in {{date}}", l7e = "Twee weken in {{date}}", c7e = "Flexibele data", u7e = "Gasten", d7e = "huizen", g7e = "Last minute", h7e = "Locatie", p7e = "Wijzigen", m7e = "Naam", f7e = "Volgende", b7e = "", _7e = "{{count}} volwassene", v7e = "{{count}} volwassenen", y7e = "", w7e = "{{count}} baby", k7e = "{{count}} baby's", x7e = "", $7e = "{{count}} kind", S7e = "{{count}} kinderen", C7e = "", E7e = "{{count}} gast", j7e = "{{count}} gasten", O7e = "De indeling van het telefoonnummer is niet geldig.", z7e = "E-mailmeldingen ontvangen", A7e = "Opslaan", P7e = "Geen locaties gevonden", D7e = "Bekijk meer", N7e = "Reisplannen", R7e = "Geen resultaat", I7e = "optioneel", T7e = {
  "autocomplete.button": "Zoeken",
  "autocomplete.placeholder": "Waar ga je naar toe ?",
  bedroomsNumbers_zero: H9e,
  bedroomsNumbers_one: G9e,
  bedroomsNumbers_other: K9e,
  beds_zero: J9e,
  beds_one: Z9e,
  beds_other: Y9e,
  "button.free-signup": "Meld je gratis aan",
  "button.validate": "Bevestigen",
  "common.try-again": "Opnieuw proberen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Mag de {{limit}} karakters niet overschrijden",
  "error.reload": "Deze pagina vernieuwen ",
  "error.return-homepage": "Terug naar de startpagina",
  "error.subtitle": "Helaas kon deze pagina niet gevonden worden.",
  "error.title": "Er is een fout opgetreden op de pagina",
  "errors.unable_to_submit.subtitle": "Helaas kon het formulier niet verzonden worden. Probeer het later nog eens.",
  "errors.unable_to_submit.title": "Oeps... het is niet gelukt om het formulier te verzenden.",
  "global.back": "Terug",
  "global.cancel": "Annuleren",
  "global.collection.browsehomes": "Blader door huizen",
  "global.collection.contactus": "Neem contact met ons op",
  "global.confirm": "Bevestigen",
  "global.continue": "Doorgaan",
  "global.getStarted": "Ga van start",
  "global.login": "Inloggen",
  "global.select": "Selecteren",
  global_adults: X9e,
  global_babies: Q9e,
  global_calendarUpdated_toast: e8e,
  global_calendar_aMonth: t8e,
  global_calendar_exactDates: a8e,
  global_calendar_oneWeek: o8e,
  global_calendar_oneWeekend: n8e,
  global_calendar_plusMinusDay_zero: r8e,
  global_calendar_plusMinusDay_one: i8e,
  global_calendar_plusMinusDay_other: s8e,
  global_calendar_twoWeeks: l8e,
  global_cancel: c8e,
  global_children: u8e,
  global_dates: d8e,
  global_delete: g8e,
  global_description: h8e,
  global_destination: p8e,
  global_done: m8e,
  global_edit: f8e,
  "global_filter_a-c": "Airco",
  global_filter_available: b8e,
  "global_filter_baby-bed": "Babybedden",
  "global_filter_baby-gear": "Baby spullen",
  "global_filter_balcony-terrace": "",
  global_filter_bathtub: _8e,
  global_filter_bbq: v8e,
  global_filter_bicycle: y8e,
  global_filter_car: w8e,
  global_filter_cat: k8e,
  "global_filter_children-welcome": "Kinderen welkom",
  global_filter_cities: x8e,
  "global_filter_cleaning-person": "Schoonmaakster",
  global_filter_countryside: $8e,
  "global_filter_dedicated-workspace": "Toegewijde werkruimte",
  "global_filter_disabled-access": "Toegankelijk voor invaliden",
  global_filter_dishwasher: S8e,
  global_filter_dog: C8e,
  global_filter_dryer: E8e,
  "global_filter_eco-level": "Alleen duurzame woningen",
  "global_filter_electric-car-plug": "Elektrische auto stekker",
  global_filter_elevator: j8e,
  global_filter_favorite: O8e,
  global_filter_fireplace: z8e,
  global_filter_flat: A8e,
  global_filter_garden: P8e,
  "global_filter_guest-wanted": "Ruil tegen GuestPoints",
  global_filter_guestPointsMax: D8e,
  global_filter_guestPointsMin: N8e,
  global_filter_guestPointsMinMax: R8e,
  global_filter_gym: I8e,
  "global_filter_heating-system": "Verwarming",
  "global_filter_high-speed-connexion": "Snelle verbinding",
  global_filter_home: T8e,
  "global_filter_home-verified": "Geverifieerde huizen",
  global_filter_island: L8e,
  global_filter_isolated: M8e,
  global_filter_jacuzzi: W8e,
  "global_filter_kids-toys": "Kinderen speelgoed",
  global_filter_lakes: B8e,
  global_filter_luxury: F8e,
  global_filter_mountains: V8e,
  "global_filter_no-bed-up": "Geen tijdelijke bedden",
  global_filter_numOfBathrooms: U8e,
  global_filter_other: q8e,
  "global_filter_parking-space": "Privé parkeerplaats",
  "global_filter_pets-welcome": "Huisdieren toegestaan ",
  global_filter_piano: H8e,
  global_filter_playground: G8e,
  global_filter_primary: K8e,
  "global_filter_public-transit-access": "Toegang tot het openbaar vervoer",
  global_filter_reciprocal: J8e,
  "global_filter_response-rate-above-threshold": "Responspercentage ≥ Gemiddeld",
  global_filter_reverse: Z8e,
  global_filter_river: Y8e,
  global_filter_seaside: X8e,
  global_filter_secondary: Q8e,
  "global_filter_secured-pool": "Beveiligd zwembad",
  "global_filter_smokers-welcome": "Roken toegestaan ",
  "global_filter_swimming-pool": "Zwembad",
  global_filter_tv: e7e,
  global_filter_villages: t7e,
  "global_filter_washing-machine": "Wasmachine",
  "global_filter_whole-unit": "De hele woning",
  global_filter_wifi: a7e,
  global_filters: o7e,
  global_fixDates: n7e,
  global_flexDates_aMonth: r7e,
  global_flexDates_aWeekend: i7e,
  global_flexDates_oneWeek: s7e,
  global_flexDates_twoWeek: l7e,
  global_flexibleDates: c7e,
  global_guests: u7e,
  global_homes: d7e,
  global_lastMinute: g7e,
  global_location: h7e,
  global_modify: p7e,
  global_name: m7e,
  global_next: f7e,
  global_numberOfAdults_zero: b7e,
  global_numberOfAdults_one: _7e,
  global_numberOfAdults_other: v7e,
  global_numberOfBabies_zero: y7e,
  global_numberOfBabies_one: w7e,
  global_numberOfBabies_other: k7e,
  global_numberOfChildren_zero: x7e,
  global_numberOfChildren_one: $7e,
  global_numberOfChildren_other: S7e,
  global_numberOfGuests_zero: C7e,
  global_numberOfGuests_one: E7e,
  global_numberOfGuests_other: j7e,
  global_phoneNumber_notValid: O7e,
  global_receiveEmailAlerts: z7e,
  global_save: A7e,
  global_searchBar_noLocationFound: P7e,
  global_seeMore_link: D7e,
  global_travelWishlist: N7e,
  "modal.error-occured.content": "Onze excuses voor het ongemak, probeer het alsjeblieft opnieuw.",
  "modal.error-occured.title": "Oh nee, er is een fout opgetreden!",
  no_result: R7e,
  optional: I7e,
  "privacy-policy": "Privacy"
}, L7e = "https://www.homeexchange.com/nl/blog/", M7e = "/nl/p/homeexchangegebruiksvoorwaarden", W7e = "https://www.homeexchange.com/nl/p/gemeenschap", B7e = "https://homeexchangehelp.zendesk.com/hc/en-us", F7e = "https://forum.homeexchange.com/c/english/20", V7e = "https://www.homeexchange.com/nl/p/service-homeexchange-nl", U7e = "https://www.homeexchange.com/nl/p/guestpoints-nl", q7e = "https://www.homeexchange.com/nl/p/pers", H7e = "https://www.homeexchange.com/p/wordsonhomeexchange", G7e = "https://help.homeexchange.com/hc/nl/articles/360000623717-Wat-zijn-Mijn-voorkeursbestemmingen-en-hoe-gebruik-ik-ze", K7e = "https://www.homeexchange.com/nl/p/where-the-welcome-really-begins", J7e = "https://www.guesttoguest.com/nl/p/waar-het-welkom-echt-begint", Z7e = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/nl/p/about-us-nl",
  blog: L7e,
  cgu: M7e,
  community: W7e,
  "contact-us": "https://www.homeexchange.com/nl/contact-op-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: B7e,
  forum: F7e,
  guarantees: V7e,
  guestpoints: U7e,
  "happiness-team": "https://www.homeexchange.com/nl/p/happiness-team-nl",
  "how-it-works": "https://www.homeexchange.com/nl/p/hoe-werkt-het-nl",
  "join-us": "https://www.homeexchange.com/nl/p/join-us-nl",
  "legal-notice": "/p/wettelijke-vermeldingen",
  "mobile-app": "https://www.homeexchange.com/nl/p/mobiele-app",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: q7e,
  "privacy-policy": "/p/homeexchange-privacy",
  "subscription-cost": "https://www.homeexchange.com/nl/p/subscription-homeexchange-nl",
  "term-of-use": "/p/homeexchangegebruiksvoorwaarden",
  testimonials: H7e,
  travelWishlist_faq_links: G7e,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: K7e,
  values: J7e
}, Y7e = "Voornaam", X7e = "Achternaam", Q7e = "Een nieuw reisplan toevoegen", eJe = "Met bijgewerkte reisplannen kun je meer wederzijdse uitwisselingsverzoeken ontvangen.", tJe = "Weet je zeker dat je {{fullAddress}} wilt verwijderen?", aJe = "Dit zijn de filters die je hebt geselecteerd. Als je van gedachten bent veranderd, kun je er hieronder een paar verwijderen. Maar als je extra filters wilt toevoegen, moet je een nieuwe zoekopdracht starten (dit zal binnenkort veranderen...hou het in de gaten)!", oJe = "Dit kan een land, stad of een hele regio zijn. Als je een brede locatie kiest, zijn je resultaten mogelijk minder nauwkeurig.", nJe = "Typ een land, stad of regio", rJe = "Bekijk beschikbare huizen", iJe = "Als er beschikbare huizen zijn die overeenkomen met je reisplannen.", sJe = "Een nieuw reisplan toevoegen", lJe = "{{fullAddress}} is verwijderd uit je reisplannen.", cJe = "Selecteer je ideale reisdata (flexibel of vast).", uJe = "Voeg details toe zodat anderen die de omgekeerde zoekfunctie gebruiken kunnen zien waarom je geïnteresseerd bent in hun locatie.", dJe = "Geef aan hoeveel mensen met je meereizen voor deze reis.", gJe = "Oeps! {{fullAddress}} kon om een onverwachte reden niet worden opgeslagen in je reisplannen.", hJe = "Laat ons weten wanneer en waar je naartoe wilt reizen en ontvang uitwisselingsverzoeken en meldingen zodra er geschikte huizen beschikbaar zijn. We slaan je zoekopdrachten op in je reisplannen!", pJe = "Zijn er nog reisavonturen die je wilt plannen?", mJe = "<updateDates>Werk je data</updateDates> bij om relevante e-mailmeldingen te blijven ontvangen of <delete>verwijder deze bestemming</delete> uit je reisplannen als je het niet langer overweegt.", fJe = "Deze data liggen in het verleden", bJe = "{{fullAddress}} is toegevoegd aan je reisplannen!", _Je = "{{fullAddress}} is succesvol bijgewerkt.", vJe = "Je zoekopdracht is opgeslagen en je kalender is bijgewerkt!", yJe = "Je zoekopdracht is opgeslagen. Je vindt hem in je reisplannen.", wJe = "Meer informatie over reisplannen", kJe = {
  firstname: Y7e,
  lastname: X7e,
  modal_travelWishlist_addNew_title: Q7e,
  modal_travelWishlist_delete_body: eJe,
  modal_travelWishlist_delete_title: tJe,
  modal_travelWishlist_filtersApplied_helper: aJe,
  modal_travelWishlist_location_helper: oJe,
  modal_travelWishlist_searchBar_placeholder: nJe,
  page_travelWishlist_card_cta: rJe,
  page_travelWishlist_card_emailAlerts_helper: iJe,
  page_travelWishlist_cta: sJe,
  page_travelWishlist_deleted_toast: lJe,
  page_travelWishlist_edit_dates_helper: cJe,
  page_travelWishlist_edit_description_helper: uJe,
  page_travelWishlist_edit_guests_helper: dJe,
  page_travelWishlist_error_toast: gJe,
  page_travelWishlist_none_body: hJe,
  page_travelWishlist_none_subheader: pJe,
  page_travelWishlist_pastDates_desc: mJe,
  page_travelWishlist_pastDates_title: fJe,
  page_travelWishlist_saved_toast: bJe,
  page_travelWishlist_updated_toast: _Je,
  search_travelWishlist_calendarUpdated_toast: vJe,
  search_travelWishlist_saved_toast: yJe,
  travelWishlist_faq: wJe
}, xJe = {
  "modal.emailVerif.alreadyVerified.desc": "",
  "modal.emailVerif.alreadyVerified.title": "",
  "modal.emailVerif.callout": "Foi enviado um e-mail de verificação para <b>{{email}}<br/>.",
  "modal.emailVerif.desc": "",
  "modal.emailVerif.linkExpired.desc": "",
  "modal.emailVerif.linkExpired.title": "",
  "modal.emailVerif.resend-email-link": "",
  "modal.emailVerif.resend-email.rate-limit": "",
  "modal.emailVerif.resend-link": "",
  "modal.emailVerif.title": "",
  "modal.finishCreatingAccount.event": "",
  "modal.finishCreatingAccount.everyone_knows_homeexchange": "",
  "modal.finishCreatingAccount.facebook": "",
  "modal.finishCreatingAccount.firstName.error": "",
  "modal.finishCreatingAccount.friends_family": "",
  "modal.finishCreatingAccount.hearAboutHE": "",
  "modal.finishCreatingAccount.instagram": "",
  "modal.finishCreatingAccount.lastName.error": "",
  "modal.finishCreatingAccount.other": "",
  "modal.finishCreatingAccount.phone_number": "",
  "modal.finishCreatingAccount.phone_number.error": "",
  "modal.finishCreatingAccount.pleaseSpecify": "",
  "modal.finishCreatingAccount.press": "",
  "modal.finishCreatingAccount.press_online": "",
  "modal.finishCreatingAccount.press_print": "",
  "modal.finishCreatingAccount.radio": "",
  "modal.finishCreatingAccount.referral": "",
  "modal.finishCreatingAccount.referralCode.error": "",
  "modal.finishCreatingAccount.search_engine": "",
  "modal.finishCreatingAccount.social_media": "",
  "modal.finishCreatingAccount.social_network_other": "",
  "modal.finishCreatingAccount.title": "",
  "modal.finishCreatingAccount.tv": "",
  "modal.finishCreatingAccount.tv_ad": "",
  "modal.finishCreatingAccount.tv_show": "",
  "modal.genericError.desc": "",
  "modal.genericError.title": "",
  "modal.noEmailRecieved.desc": "",
  "modal.noEmailRecieved.error": "",
  "modal.verifyEmail.emailResent.toast": "Enviámos-lhe um novo e-mail de verificação para <b>{{email}}<br/>.",
  "signin-modal.apple.button": "Iniciar sessão com a Apple",
  "signin-modal.button": "Iniciar sessão",
  "signin-modal.email.button": "Iniciar sessão",
  "signin-modal.error.content": "",
  "signin-modal.error.email_no_verified.content": "",
  "signin-modal.error.email_no_verified.title": "",
  "signin-modal.error.title": "",
  "signin-modal.facebook.button": "Iniciar sessão com o Facebook",
  "signin-modal.no-account": "Ainda não tem conta?",
  "signin-modal.reset-password": "",
  "signin-modal.title": "",
  "signin.modal.reset-password": "Redefinir palavra-passe",
  "signup-modal.accept-cgu": "Ao criar uma conta, eu aceito os",
  "signup-modal.apple.button": "Iniciar sessão com a Apple",
  "signup-modal.button": "Inscreva-se",
  "signup-modal.cgu.link": "Termos Gerais de Utilização",
  "signup-modal.description": "Descubra uma nova forma de viajar com a HomeExchange: sinta-se bem-vindo/a em todo o mundo e poupe dinheiro!",
  "signup-modal.email.button": "Inscreva-se com o seu endereço de e-mail",
  "signup-modal.email.form.submit": "",
  "signup-modal.error.content": "",
  "signup-modal.error.title": "",
  "signup-modal.facebook.button": "Inscreva-se com o Facebook",
  "signup-modal.have-an-account": "Já possui uma conta?"
}, $Je = "Studio", SJe = "{{count}} quarto", CJe = "{{count}} quartos", EJe = "", jJe = "{{count}} cama", OJe = "{{count}} camas", zJe = "", AJe = "", PJe = "O seu calendário foi atualizado.", DJe = "Um mês", NJe = "Datas exatas", RJe = "Uma semana", IJe = "Um fim de semana", TJe = "", LJe = "± 1:{{count}} dia", MJe = "± {{count]] dias", WJe = "Duas semanas", BJe = "Cancelar", FJe = "", VJe = "Datas", UJe = "Eliminar", qJe = "Descrição", HJe = "Destino", GJe = "Feito!", KJe = "Editar", JJe = "Qualquer tipo de pedido de Troca", ZJe = "Banheiro", YJe = "BBQ", XJe = "Bicicleta", QJe = "Carro", eZe = "Gato", tZe = "Cidade", aZe = "Campo", oZe = "Lavadora de louças", nZe = "Cão", rZe = "Secadora", iZe = "Elevador", sZe = "Casas favoritas", lZe = "Lareira", cZe = "Apartamento", uZe = "Quintal privado", dZe = "", gZe = "", hZe = "", pZe = "", mZe = "Casa", fZe = "Ilha", bZe = "Isolada", _Ze = "Jacuzzi", vZe = "Lagos", yZe = "Casas Collection", wZe = "", kZe = "{{count}} casas de banho", xZe = "Outros animais", $Ze = "Piano", SZe = "Parque infantil", CZe = "Principal", EZe = "Troca Reciproca", jZe = "Busca invertida", OZe = "Rio", zZe = "Litoral", AZe = "Secundária", PZe = "TV", DZe = "Aldeia", NZe = "WiFi", RZe = "Filtros", IZe = "Datas fixas", TZe = "Um mês em {{date}}", LZe = "Um fim de semana em {{date}}", MZe = "Uma semana em {{date}}", WZe = "Duas semanas em {{date}}", BZe = "Datas flexíveis", FZe = "Convidados", VZe = "casas", UZe = "Última hora", qZe = "Localização", HZe = "Modificar", GZe = "Nome", KZe = "Seguinte", JZe = "", ZZe = "{{count}} adulto", YZe = "{{count}} adultos", XZe = "", QZe = "{{count}} bebé", eYe = "{{count}} bebés", tYe = "", aYe = "{{count}} criança", oYe = "{{count}} crianças", nYe = "", rYe = "{{count}} convidado", iYe = "{{count}} convidados", sYe = "O formato do número de telefone não é válido.", lYe = "Receber alertas por e-mail", cYe = "Guardar", uYe = "Não foram encontradas localizações", dYe = "Ver mais", gYe = "Ideias de viagens", hYe = "", pYe = "", mYe = {
  "autocomplete.button": "Procurar",
  "autocomplete.placeholder": "Para onde vai ?",
  bedroomsNumbers_zero: $Je,
  bedroomsNumbers_one: SJe,
  bedroomsNumbers_other: CJe,
  beds_zero: EJe,
  beds_one: jJe,
  beds_other: OJe,
  "button.free-signup": "Filie-se gratuitamente",
  "button.validate": "Validar",
  "common.try-again": "",
  "contact-tech-email": "",
  "error.characters_max_limit": "Não deve ser superior a {{limit}} caracteres",
  "error.reload": "Atualizar esta página",
  "error.return-homepage": "Voltar à página inicial",
  "error.subtitle": "Infelizmente, não foi possível aceder a esta página.",
  "error.title": "Ocorreu um erro na página",
  "errors.unable_to_submit.subtitle": "Infelizmente, não foi possível submeter o formulário. Tente novamente mais tarde.",
  "errors.unable_to_submit.title": "Ups, ocorreu um problema!",
  "global.back": "",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "",
  "global.getStarted": "",
  "global.login": "",
  "global.select": "",
  global_adults: zJe,
  global_babies: AJe,
  global_calendarUpdated_toast: PJe,
  global_calendar_aMonth: DJe,
  global_calendar_exactDates: NJe,
  global_calendar_oneWeek: RJe,
  global_calendar_oneWeekend: IJe,
  global_calendar_plusMinusDay_zero: TJe,
  global_calendar_plusMinusDay_one: LJe,
  global_calendar_plusMinusDay_other: MJe,
  global_calendar_twoWeeks: WJe,
  global_cancel: BJe,
  global_children: FJe,
  global_dates: VJe,
  global_delete: UJe,
  global_description: qJe,
  global_destination: HJe,
  global_done: GJe,
  global_edit: KJe,
  "global_filter_a-c": "A/C",
  global_filter_available: JJe,
  "global_filter_baby-bed": "",
  "global_filter_baby-gear": "Equipamento para bebês",
  "global_filter_balcony-terrace": "Varanda/Terraço",
  global_filter_bathtub: ZJe,
  global_filter_bbq: YJe,
  global_filter_bicycle: XJe,
  global_filter_car: QJe,
  global_filter_cat: eZe,
  "global_filter_children-welcome": "Crianças bem vindas",
  global_filter_cities: tZe,
  "global_filter_cleaning-person": "Faxineiro",
  global_filter_countryside: aZe,
  "global_filter_dedicated-workspace": "Espaço de trabalho dedicado",
  "global_filter_disabled-access": "Casa acessível",
  global_filter_dishwasher: oZe,
  global_filter_dog: nZe,
  global_filter_dryer: rZe,
  "global_filter_eco-level": "Só casas sustentáveis",
  "global_filter_electric-car-plug": "Tomada para carro elétrico",
  global_filter_elevator: iZe,
  global_filter_favorite: sZe,
  global_filter_fireplace: lZe,
  global_filter_flat: cZe,
  global_filter_garden: uZe,
  "global_filter_guest-wanted": "Troca por GuestPoints",
  global_filter_guestPointsMax: dZe,
  global_filter_guestPointsMin: gZe,
  global_filter_guestPointsMinMax: hZe,
  global_filter_gym: pZe,
  "global_filter_heating-system": "Sistema de aquecimento",
  "global_filter_high-speed-connexion": "Wi-fi de alta velocidade",
  global_filter_home: mZe,
  "global_filter_home-verified": "Casas verificadas",
  global_filter_island: fZe,
  global_filter_isolated: bZe,
  global_filter_jacuzzi: _Ze,
  "global_filter_kids-toys": "",
  global_filter_lakes: vZe,
  global_filter_luxury: yZe,
  global_filter_mountains: wZe,
  "global_filter_no-bed-up": "Sem camas temporárias",
  global_filter_numOfBathrooms: kZe,
  global_filter_other: xZe,
  "global_filter_parking-space": "",
  "global_filter_pets-welcome": "Animais de estimação bem-vindos",
  global_filter_piano: $Ze,
  global_filter_playground: SZe,
  global_filter_primary: CZe,
  "global_filter_public-transit-access": "",
  global_filter_reciprocal: EZe,
  "global_filter_response-rate-above-threshold": "",
  global_filter_reverse: jZe,
  global_filter_river: OZe,
  global_filter_seaside: zZe,
  global_filter_secondary: AZe,
  "global_filter_secured-pool": "Piscina protegida",
  "global_filter_smokers-welcome": "Fumantes bem-vindos",
  "global_filter_swimming-pool": "Piscina",
  global_filter_tv: PZe,
  global_filter_villages: DZe,
  "global_filter_washing-machine": "Máquina de lavar",
  "global_filter_whole-unit": "",
  global_filter_wifi: NZe,
  global_filters: RZe,
  global_fixDates: IZe,
  global_flexDates_aMonth: TZe,
  global_flexDates_aWeekend: LZe,
  global_flexDates_oneWeek: MZe,
  global_flexDates_twoWeek: WZe,
  global_flexibleDates: BZe,
  global_guests: FZe,
  global_homes: VZe,
  global_lastMinute: UZe,
  global_location: qZe,
  global_modify: HZe,
  global_name: GZe,
  global_next: KZe,
  global_numberOfAdults_zero: JZe,
  global_numberOfAdults_one: ZZe,
  global_numberOfAdults_other: YZe,
  global_numberOfBabies_zero: XZe,
  global_numberOfBabies_one: QZe,
  global_numberOfBabies_other: eYe,
  global_numberOfChildren_zero: tYe,
  global_numberOfChildren_one: aYe,
  global_numberOfChildren_other: oYe,
  global_numberOfGuests_zero: nYe,
  global_numberOfGuests_one: rYe,
  global_numberOfGuests_other: iYe,
  global_phoneNumber_notValid: sYe,
  global_receiveEmailAlerts: lYe,
  global_save: cYe,
  global_searchBar_noLocationFound: uYe,
  global_seeMore_link: dYe,
  global_travelWishlist: gYe,
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: hYe,
  optional: pYe,
  "privacy-policy": "Privacidade"
}, fYe = "https://www.homeexchange.com/pt/blog/", bYe = "/p/general-terms-of-use", _Ye = "https://www.homeexchange.com/pt/p/a-nossa-comunidade-pt", vYe = "https://homeexchangehelp.zendesk.com/hc/en-us", yYe = "", wYe = "https://www.homeexchange.com/pt/p/service-homeexchange-pt", kYe = "https://www.homeexchange.com/pt/p/os-guestpoints", xYe = "https://www.homeexchange.com/pt/p/press-pt", $Ye = "https://www.homeexchange.com/p/palavras-de-homeexchangers", SYe = "", CYe = "", EYe = "https://www.homeexchange.com/pt/p/onde-as-boas-vindas-comecam", jYe = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/pt/p/about-us-pt",
  blog: fYe,
  cgu: bYe,
  community: _Ye,
  "contact-us": "https://www.homeexchange.com/pt/contactos-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: vYe,
  forum: yYe,
  guarantees: wYe,
  guestpoints: kYe,
  "happiness-team": "https://www.homeexchange.com/pt/p/happiness-team-pt",
  "how-it-works": "https://www.homeexchange.com/pt/p/como-funciona-homeexchange",
  "join-us": "https://www.homeexchange.com/pt/p/join-us-pt",
  "legal-notice": "/p/mencoes-legais",
  "mobile-app": "https://www.homeexchange.com/pt/p/app-homeexchange",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: xYe,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/pt/p/subscription-homeexchange-pt",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: $Ye,
  travelWishlist_faq_links: SYe,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: CYe,
  values: EYe
}, OYe = "", zYe = "", AYe = "Criar nova ideia de viagem", PYe = "As ideias de viagens atualizadas permitem-lhe receber mais pedidos de trocas recíprocas.", DYe = "Tem a certeza de que pretende eliminar {{fullAddress}}?", NYe = "Estes são os filtros que selecionou. Se tiver mudado de ideias, pode eliminar alguns deles abaixo. Contudo, se quiser adicionar outros filtros, terá de iniciar uma nova pesquisa (contudo, isto será alterado em breve... mantenha-se a par)!", RYe = "Pode ser um país, cidade ou região. Se optar por uma localização mais ampla, os resultados podem ser menos precisos.", IYe = "Escreva um país, cidade ou região", TYe = "Ver casas disponíveis", LYe = "Quando existirem casas com disponibilidade correspondentes aos seus planos de viagem.", MYe = "Criar nova ideia de viagem", WYe = "{{fullAddress}} foi eliminada das suas ideias de viagens.", BYe = "Selecione as suas datas de viagem ideais (flexíveis ou fixas).", FYe = "Adicione detalhes, para ajudar as pessoas que utilizam a funcionalidade de busca invertida a perceber porque tem interesse na respetiva região.", VYe = "Especifique quantas pessoas vão viajar consigo.", UYe = "Ups! Não foi possível guardar {{fullAddress}} nas suas ideias de viagens devido a um motivo inesperado.", qYe = "Diga-nos para onde e quando quer viajar para receber pedidos de troca e alertas quando se tornarem disponíveis casas correspondentes. Vamos guardar estas pesquisas nas suas ideias de viagens!", HYe = "Existem aventuras de viagens que queira começar a planear?", GYe = "<updateDates>Atualize as datas</updateDates> para continuar a receber alertas relevantes por e-mail ou <delete>elimine este destino</delete> das suas ideias de viagens se já não está a considerá-lo.", KYe = "Estas datas já passaram", JYe = "{{fullAddress}} foi adicionada às suas ideias de viagens!", ZYe = "{{fullAddress}} foi atualizada com sucesso.", YYe = "A sua pesquisa foi guardada e o calendário foi atualizado!", XYe = "A sua pesquisa foi guardada. Encontre-a nas suas ideias de viagens.", QYe = "Saiba mais sobre as ideias de viagens", eXe = {
  firstname: OYe,
  lastname: zYe,
  modal_travelWishlist_addNew_title: AYe,
  modal_travelWishlist_delete_body: PYe,
  modal_travelWishlist_delete_title: DYe,
  modal_travelWishlist_filtersApplied_helper: NYe,
  modal_travelWishlist_location_helper: RYe,
  modal_travelWishlist_searchBar_placeholder: IYe,
  page_travelWishlist_card_cta: TYe,
  page_travelWishlist_card_emailAlerts_helper: LYe,
  page_travelWishlist_cta: MYe,
  page_travelWishlist_deleted_toast: WYe,
  page_travelWishlist_edit_dates_helper: BYe,
  page_travelWishlist_edit_description_helper: FYe,
  page_travelWishlist_edit_guests_helper: VYe,
  page_travelWishlist_error_toast: UYe,
  page_travelWishlist_none_body: qYe,
  page_travelWishlist_none_subheader: HYe,
  page_travelWishlist_pastDates_desc: GYe,
  page_travelWishlist_pastDates_title: KYe,
  page_travelWishlist_saved_toast: JYe,
  page_travelWishlist_updated_toast: ZYe,
  search_travelWishlist_calendarUpdated_toast: YYe,
  search_travelWishlist_saved_toast: XYe,
  travelWishlist_faq: QYe
}, tXe = {
  "modal.emailVerif.alreadyVerified.desc": "Din e-post är redo! Logga in för att fortsätta.",
  "modal.emailVerif.alreadyVerified.title": "Din e-postadress har redan verifierats",
  "modal.emailVerif.callout": "Ett verifieringsmail har skickats till <b>{{email}}</b>.",
  "modal.emailVerif.desc": "Kontrollera din inkorg. Länken i det här mailet löper ut om 24 timmar.",
  "modal.emailVerif.linkExpired.desc": "Logga in för att få en ny verifieringslänk till din e-post.",
  "modal.emailVerif.linkExpired.title": "Den här länken har löpt ut",
  "modal.emailVerif.resend-email-link": "Skicka nytt bekräftelsemail",
  "modal.emailVerif.resend-email.rate-limit": "Du har nått gränsen för e-postförfrågningar. Försök igen om 1 minut.",
  "modal.emailVerif.resend-link": "Skicka verifieringsmailet igen",
  "modal.emailVerif.title": "Verifiera din e-postadress",
  "modal.finishCreatingAccount.event": "På ett evenemang",
  "modal.finishCreatingAccount.everyone_knows_homeexchange": "Alla känner till HomeExchange",
  "modal.finishCreatingAccount.facebook": "Facebook",
  "modal.finishCreatingAccount.firstName.error": "Ange ditt förnamn",
  "modal.finishCreatingAccount.friends_family": "Genom vänner, familj eller bekanta",
  "modal.finishCreatingAccount.hearAboutHE": "Hur hörde du talas om HomeExchange?",
  "modal.finishCreatingAccount.instagram": "Instagram",
  "modal.finishCreatingAccount.lastName.error": "Ange ditt efternamn",
  "modal.finishCreatingAccount.other": "Annat",
  "modal.finishCreatingAccount.phone_number": "Telefonnummer",
  "modal.finishCreatingAccount.phone_number.error": "Ange ditt telefonnummer",
  "modal.finishCreatingAccount.pleaseSpecify": "Specificera",
  "modal.finishCreatingAccount.press": "Genom nyhetskanaler",
  "modal.finishCreatingAccount.press_online": "Online",
  "modal.finishCreatingAccount.press_print": "Tryckt media",
  "modal.finishCreatingAccount.radio": "På radion",
  "modal.finishCreatingAccount.referral": "Referenskod",
  "modal.finishCreatingAccount.referralCode.error": "Den här referenskoden är ogiltig",
  "modal.finishCreatingAccount.search_engine": "Från en sökmotor",
  "modal.finishCreatingAccount.social_media": "Via sociala medier",
  "modal.finishCreatingAccount.social_network_other": "Andra sociala medier (vänligen specificera)",
  "modal.finishCreatingAccount.title": "Slutför kontoskapandet",
  "modal.finishCreatingAccount.tv": "På tv",
  "modal.finishCreatingAccount.tv_ad": "Genom en annons",
  "modal.finishCreatingAccount.tv_show": "Under ett reportage/tv-program",
  "modal.genericError.desc": "Plattformen kan vara nere eller så kan det vara ett tillfälligt fel hos oss, vänligen försök igen.<br><br>Vi spårar de här felen automatiskt, men om problemet kvarstår, kontakta oss gärna på:<br><a>tech@homeexchange.com</a>",
  "modal.genericError.title": "Hoppsan! Något gick fel",
  "modal.noEmailRecieved.desc": "<b>Fick du inget e-postmeddelande?</b> Kontrollera din skräppost och stavningen av din e-post innan du begär ett nytt verifieringsmail.",
  "modal.noEmailRecieved.error": "Något gick fel, försök igen senare",
  "modal.verifyEmail.emailResent.toast": "Vi har skickat ett nytt verifieringsmail till dig till <b>{{email}}</b>.",
  "signin-modal.apple.button": "Logga in med Apple",
  "signin-modal.button": "Logga in",
  "signin-modal.email.button": "Logga in",
  "signin-modal.error.content": "",
  "signin-modal.error.email_no_verified.content": "",
  "signin-modal.error.email_no_verified.title": "",
  "signin-modal.error.title": "",
  "signin-modal.facebook.button": "Logga in med Facebook",
  "signin-modal.no-account": "Har du inget konto ännu?",
  "signin-modal.reset-password": "",
  "signin-modal.title": "",
  "signin.modal.reset-password": "Återställ lösenord",
  "signup-modal.accept-cgu": "Genom att skapa ett konto godkänner jag",
  "signup-modal.apple.button": "Logga in med Apple",
  "signup-modal.button": "Registrera dig",
  "signup-modal.cgu.link": "de allmänna villkoren",
  "signup-modal.description": "Upptäck ett nytt sätt att resa med HomeExchange: bli välkomnad över hela världen och spara pengar!",
  "signup-modal.email.button": "Registrera dig med din e-postadress",
  "signup-modal.email.form.submit": "",
  "signup-modal.error.content": "",
  "signup-modal.error.title": "",
  "signup-modal.facebook.button": "Registrera dig med Facebook",
  "signup-modal.have-an-account": "Har du redan ett konto?"
}, aXe = "Studio", oXe = "{{count}} sovrum", nXe = "{{count}} sovrum", rXe = "", iXe = "{{count}} säng", sXe = "{{count}} sängar", lXe = "Vuxna", cXe = "Småbarn", uXe = "Din kalender har uppdaterats.", dXe = "En månad", gXe = "Exakta datum", hXe = "En vecka", pXe = "En helg", mXe = "", fXe = "± {{count}} dag", bXe = "± {{count}} dagar", _Xe = "Två veckor", vXe = "Avbryt", yXe = "Barn", wXe = "Datum", kXe = "Ta bort", xXe = "Beskrivning", $Xe = "Resmål", SXe = "Klart!", CXe = "Ändra", EXe = "Alla typer av hembyten", jXe = "Badkar", OXe = "Grill", zXe = "Cykel", AXe = "Bil", PXe = "Katt", DXe = "Stad", NXe = "Landsbygd", RXe = "Diskmaskin", IXe = "Hund", TXe = "Torktumlare", LXe = "Hiss", MXe = "Favorithem", WXe = "Eldstad", BXe = "Lägenhet", FXe = "Privat trädgård", VXe = "Mindre än {{max}} GP", UXe = "från {{min}} GP", qXe = "Mellan {{min}} och {{max}} GuestPoints", HXe = "Hemmagym", GXe = "Hus", KXe = "Ö", JXe = "Isolerat", ZXe = "Jacuzzi", YXe = "Sjö", XXe = "Collection-hem", QXe = "Berg", eQe = "{{count}} badrum", tQe = "Andra djur", aQe = "Piano", oQe = "Lekplats för barn", nQe = "Primärt", rQe = "Ömsesidigt hembyte", iQe = "Omvänd sökning", sQe = "Älv", lQe = "Kustnära", cQe = "Sekundärt", uQe = "TV", dQe = "By", gQe = "WiFi", hQe = "Filter", pQe = "Fasta datum", mQe = "En månad i {{date}}", fQe = "En helg i {{date}}", bQe = "En vecka i {{date}}", _Qe = "Två veckor i {{date}}", vQe = "Flexibla datum", yQe = "Gäster", wQe = "hem", kQe = "Sista minuten", xQe = "Plats", $Qe = "Ändra", SQe = "Namn", CQe = "Nästa", EQe = "", jQe = "{{count}} vuxen", OQe = "{{count}} vuxna", zQe = "", AQe = "{{count}} bebis", PQe = "{{count}} bebisar", DQe = "", NQe = "{{count}} barn", RQe = "{{count}} barn", IQe = "", TQe = "{{count}} gäst", LQe = "{{count}} gäster", MQe = "Telefonnumrets format är inte giltigt.", WQe = "Få e-postaviseringar", BQe = "Spara", FQe = "Inga resmål hittades", VQe = "Se mer", UQe = "Reselista", qQe = "", HQe = "valfritt", GQe = {
  "autocomplete.button": "Sök",
  "autocomplete.placeholder": "Vart ska du ?",
  bedroomsNumbers_zero: aXe,
  bedroomsNumbers_one: oXe,
  bedroomsNumbers_other: nXe,
  beds_zero: rXe,
  beds_one: iXe,
  beds_other: sXe,
  "button.free-signup": "Registrera dig gratis",
  "button.validate": "Godkänn",
  "common.try-again": "Försök igen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Får inte överskrida {{limit}} tecken",
  "error.reload": "Ladda om sidan",
  "error.return-homepage": "Gå tillbaka till startsidan",
  "error.subtitle": "Tyvärr kan inte den här sidan nås.",
  "error.title": "Ett fel uppstod på sidan",
  "errors.unable_to_submit.subtitle": "Tyvärr kunde inte ditt formulär skickas in just nu. Vänligen försök igen senare.",
  "errors.unable_to_submit.title": "Hoppsan, vi har stött på ett problem",
  "global.back": "Tillbaka",
  "global.cancel": "Avbryt",
  "global.collection.browsehomes": "Se fler hem",
  "global.collection.contactus": "Kontakta oss",
  "global.confirm": "Bekräfta",
  "global.continue": "Fortsätt",
  "global.getStarted": "Kom igång",
  "global.login": "Logga in",
  "global.select": "Välj",
  global_adults: lXe,
  global_babies: cXe,
  global_calendarUpdated_toast: uXe,
  global_calendar_aMonth: dXe,
  global_calendar_exactDates: gXe,
  global_calendar_oneWeek: hXe,
  global_calendar_oneWeekend: pXe,
  global_calendar_plusMinusDay_zero: mXe,
  global_calendar_plusMinusDay_one: fXe,
  global_calendar_plusMinusDay_other: bXe,
  global_calendar_twoWeeks: _Xe,
  global_cancel: vXe,
  global_children: yXe,
  global_dates: wXe,
  global_delete: kXe,
  global_description: xXe,
  global_destination: $Xe,
  global_done: SXe,
  global_edit: CXe,
  "global_filter_a-c": "Luftkonditionering",
  global_filter_available: EXe,
  "global_filter_baby-bed": "Bebissäng",
  "global_filter_baby-gear": "Barnutrustning",
  "global_filter_balcony-terrace": "Balkong/terrass",
  global_filter_bathtub: jXe,
  global_filter_bbq: OXe,
  global_filter_bicycle: zXe,
  global_filter_car: AXe,
  global_filter_cat: PXe,
  "global_filter_children-welcome": "Barn är välkomna",
  global_filter_cities: DXe,
  "global_filter_cleaning-person": "Städare",
  global_filter_countryside: NXe,
  "global_filter_dedicated-workspace": "Kontor",
  "global_filter_disabled-access": "Tillgängligt hem",
  global_filter_dishwasher: RXe,
  global_filter_dog: IXe,
  global_filter_dryer: TXe,
  "global_filter_eco-level": "Endast hållbara hem",
  "global_filter_electric-car-plug": "Elbilsladdare",
  global_filter_elevator: LXe,
  global_filter_favorite: MXe,
  global_filter_fireplace: WXe,
  global_filter_flat: BXe,
  global_filter_garden: FXe,
  "global_filter_guest-wanted": "Hembyte för GuestPoints",
  global_filter_guestPointsMax: VXe,
  global_filter_guestPointsMin: UXe,
  global_filter_guestPointsMinMax: qXe,
  global_filter_gym: HXe,
  "global_filter_heating-system": "Värmesystem",
  "global_filter_high-speed-connexion": "Bredband med hög hastighet",
  global_filter_home: GXe,
  "global_filter_home-verified": "Verifierade hem",
  global_filter_island: KXe,
  global_filter_isolated: JXe,
  global_filter_jacuzzi: ZXe,
  "global_filter_kids-toys": "Barnleksaker",
  global_filter_lakes: YXe,
  global_filter_luxury: XXe,
  global_filter_mountains: QXe,
  "global_filter_no-bed-up": "Inga tillfälliga sängar",
  global_filter_numOfBathrooms: eQe,
  global_filter_other: tQe,
  "global_filter_parking-space": "Privat parkeringsplats",
  "global_filter_pets-welcome": "Husdjur är välkomna",
  global_filter_piano: aQe,
  global_filter_playground: oQe,
  global_filter_primary: nQe,
  "global_filter_public-transit-access": "Tillgång till kollektivtrafik",
  global_filter_reciprocal: rQe,
  "global_filter_response-rate-above-threshold": "Svarsprocent ≥ Genomsnittlig",
  global_filter_reverse: iQe,
  global_filter_river: sQe,
  global_filter_seaside: lQe,
  global_filter_secondary: cQe,
  "global_filter_secured-pool": "Säker pool",
  "global_filter_smokers-welcome": "Rökning tillåtet",
  "global_filter_swimming-pool": "Pool",
  global_filter_tv: uQe,
  global_filter_villages: dQe,
  "global_filter_washing-machine": "Tvättmaskin",
  "global_filter_whole-unit": "Hela hemmet",
  global_filter_wifi: gQe,
  global_filters: hQe,
  global_fixDates: pQe,
  global_flexDates_aMonth: mQe,
  global_flexDates_aWeekend: fQe,
  global_flexDates_oneWeek: bQe,
  global_flexDates_twoWeek: _Qe,
  global_flexibleDates: vQe,
  global_guests: yQe,
  global_homes: wQe,
  global_lastMinute: kQe,
  global_location: xQe,
  global_modify: $Qe,
  global_name: SQe,
  global_next: CQe,
  global_numberOfAdults_zero: EQe,
  global_numberOfAdults_one: jQe,
  global_numberOfAdults_other: OQe,
  global_numberOfBabies_zero: zQe,
  global_numberOfBabies_one: AQe,
  global_numberOfBabies_other: PQe,
  global_numberOfChildren_zero: DQe,
  global_numberOfChildren_one: NQe,
  global_numberOfChildren_other: RQe,
  global_numberOfGuests_zero: IQe,
  global_numberOfGuests_one: TQe,
  global_numberOfGuests_other: LQe,
  global_phoneNumber_notValid: MQe,
  global_receiveEmailAlerts: WQe,
  global_save: BQe,
  global_searchBar_noLocationFound: FQe,
  global_seeMore_link: VQe,
  global_travelWishlist: UQe,
  "modal.error-occured.content": "Vi ber om ursäkt för det, men försök gärna igen.",
  "modal.error-occured.title": "Hoppsan, ett fel uppstod!",
  no_result: qQe,
  optional: HQe,
  "privacy-policy": "Sekretesspolicy"
}, KQe = "https://www.homeexchange.com/blog/", JQe = "/p/general-terms-of-use", ZQe = "https://www.homeexchange.com/sv/p/natverket", YQe = "https://homeexchangehelp.zendesk.com/hc/es", XQe = "", QQe = "https://www.homeexchange.com/sv/p/service-homeexchange-sv", eet = "https://www.homeexchange.com/sv/p/guestpoints-sv", tet = "https://www.homeexchange.com/sv/p/press-sv", aet = "https://www.homeexchange.com/p/medlemmarna-har-ordet", oet = "", net = "", ret = "https://www.homeexchange.com/sv/p/dar-valkomnandet-borjar", iet = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/sv/p/about-us-sv",
  blog: KQe,
  cgu: JQe,
  community: ZQe,
  "contact-us": "https://www.homeexchange.com/sv/kontakta-oss-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: YQe,
  forum: XQe,
  guarantees: QQe,
  guestpoints: eet,
  "happiness-team": "https://www.homeexchange.com/sv/p/happiness-team-sv",
  "how-it-works": "https://www.homeexchange.com/sv/p/hur-fungerar-det-sv",
  "join-us": "https://www.homeexchange.com/sv/p/join-us-sv",
  "legal-notice": "/p/juridisk-information",
  "mobile-app": "https://www.homeexchange.com/sv/p/app-mobil",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: tet,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/sv/p/subscription-homeexchange-sv",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: aet,
  travelWishlist_faq_links: oet,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: net,
  values: ret
}, set = "Förnamn", cet = "Efternamn", uet = "Skapa din reselista", det = "En uppdaterad reselista gör att du kan få fler ömsesidiga hembytesförslag.", get = "Är du säker på att du vill radera {{fullAddress}}?", het = "Det här är filtren du har valt. Om du har ändrat dig kan du ta bort några av dem nedan. Men om du vill lägga till fler måste du starta en ny sökning (detta kommer dock snart att ändras... håll utkik)!", pet = "Det kan vara ett land, en stad eller en hel region. Om du väljer en bred plats kan dina resultat bli mindre exakta.", met = "Ange ett land, en stad eller en region", fet = "Visa tillgängliga hem", bet = "När hem med tillgänglighet matchar dina resplaner.", _et = "Skapa din reselista", vet = "{{fullAddress}} har tagits bort från din reselista.", yet = "Välj dina ideala resedatum (flexibla eller fasta).", wet = "Lägg till detaljer för att hjälpa andra som använder funktionen för omvänd sökning att se varför du är intresserad av deras ställe.", ket = "Ange hur många personer som följer med dig på den här resan.", xet = "Hoppsan! {{fullAddress}} kunde inte sparas i din reselista av en oväntad anledning.", $et = "Meddela oss när och vart du vill resa för att få hembytesförslag och aviseringar så snart passande hem blir tillgängliga. Vi sparar dina sökningar i din reselista!", Cet = "Har du några reseäventyr du vill börja planera?", Eet = "<updateDates>Uppdatera dina datum</updateDates> för att fortsätta få relevanta mejl eller <delete>ta bort det här resmålet</delete>från din reselista om du inte längre vill resa dit.", jet = "Dessa datum har redan varit", Oet = "{{fullAddress}} har lagts till i din reselista!", zet = "{{fullAddress}} har uppdaterats.", Aet = "Din sökning har sparats och din kalender har uppdaterats!", Pet = "Din sökning har sparats. Se den i din reselista.", Det = "Läs mer om reselistor", Net = {
  firstname: set,
  lastname: cet,
  modal_travelWishlist_addNew_title: uet,
  modal_travelWishlist_delete_body: det,
  modal_travelWishlist_delete_title: get,
  modal_travelWishlist_filtersApplied_helper: het,
  modal_travelWishlist_location_helper: pet,
  modal_travelWishlist_searchBar_placeholder: met,
  page_travelWishlist_card_cta: fet,
  page_travelWishlist_card_emailAlerts_helper: bet,
  page_travelWishlist_cta: _et,
  page_travelWishlist_deleted_toast: vet,
  page_travelWishlist_edit_dates_helper: yet,
  page_travelWishlist_edit_description_helper: wet,
  page_travelWishlist_edit_guests_helper: ket,
  page_travelWishlist_error_toast: xet,
  page_travelWishlist_none_body: $et,
  page_travelWishlist_none_subheader: Cet,
  page_travelWishlist_pastDates_desc: Eet,
  page_travelWishlist_pastDates_title: jet,
  page_travelWishlist_saved_toast: Oet,
  page_travelWishlist_updated_toast: zet,
  search_travelWishlist_calendarUpdated_toast: Aet,
  search_travelWishlist_saved_toast: Pet,
  travelWishlist_faq: Det
}, Ret = "en", Bk = YDe({
  fallbackLng: Ret,
  debug: !1,
  interpolation: {
    escapeValue: !1
  },
  returnEmptyString: !1,
  resources: {
    da: {
      auth: XDe,
      common: URe,
      user: OIe,
      links: oIe
    },
    de: {
      auth: zIe,
      common: kLe,
      user: sMe,
      links: RLe
    },
    en: {
      auth: lMe,
      common: e2e,
      user: M2e,
      links: h2e
    },
    es: {
      auth: W2e,
      common: PFe,
      user: bVe,
      links: qFe
    },
    fr: {
      auth: _Ve,
      common: u4e,
      user: J4e,
      links: x4e
    },
    hr: {
      auth: Z4e,
      common: Jqe,
      user: NHe,
      links: lHe
    },
    it: {
      auth: RHe,
      common: EGe,
      user: gKe,
      links: WGe
    },
    nb: {
      auth: hKe,
      common: r9e,
      user: U9e,
      links: _9e
    },
    nl: {
      auth: q9e,
      common: T7e,
      user: kJe,
      links: Z7e
    },
    pt: {
      auth: xJe,
      common: mYe,
      user: eXe,
      links: jYe
    },
    sv: {
      auth: tXe,
      common: GQe,
      user: Net,
      links: iet
    }
  }
});
Bk.init();
const Cn = Bk, Iet = ne.createContext(null);
Iet.displayName = "HookFormContext";
typeof window < "u" ? ne.useLayoutEffect : ne.useEffect;
function F(e, t, a) {
  function o(s, l) {
    var c;
    Object.defineProperty(s, "_zod", {
      value: s._zod ?? {},
      enumerable: !1
    }), (c = s._zod).traits ?? (c.traits = /* @__PURE__ */ new Set()), s._zod.traits.add(e), t(s, l);
    for (const u in i.prototype)
      u in s || Object.defineProperty(s, u, { value: i.prototype[u].bind(s) });
    s._zod.constr = i, s._zod.def = l;
  }
  const n = a?.Parent ?? Object;
  class r extends n {
  }
  Object.defineProperty(r, "name", { value: e });
  function i(s) {
    var l;
    const c = a?.Parent ? new r() : this;
    o(c, s), (l = c._zod).deferred ?? (l.deferred = []);
    for (const u of c._zod.deferred)
      u();
    return c;
  }
  return Object.defineProperty(i, "init", { value: o }), Object.defineProperty(i, Symbol.hasInstance, {
    value: (s) => a?.Parent && s instanceof a.Parent ? !0 : s?._zod?.traits?.has(e)
  }), Object.defineProperty(i, "name", { value: e }), i;
}
class qo extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class Fk extends Error {
  constructor(t) {
    super(`Encountered unidirectional transform during encode: ${t}`), this.name = "ZodEncodeError";
  }
}
const Vk = {};
function uo(e) {
  return Vk;
}
function Tet(e) {
  const t = Object.values(e).filter((a) => typeof a == "number");
  return Object.entries(e).filter(([a, o]) => t.indexOf(+a) === -1).map(([a, o]) => o);
}
function eu(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function Wd(e) {
  return {
    get value() {
      {
        const t = e();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function Bd(e) {
  return e == null;
}
function Fd(e) {
  const t = e.startsWith("^") ? 1 : 0, a = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(t, a);
}
const zm = Symbol("evaluating");
function Re(e, t, a) {
  let o;
  Object.defineProperty(e, t, {
    get() {
      if (o !== zm)
        return o === void 0 && (o = zm, o = a()), o;
    },
    set(n) {
      Object.defineProperty(e, t, {
        value: n
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function Let(e) {
  return Object.create(Object.getPrototypeOf(e), Object.getOwnPropertyDescriptors(e));
}
function Ma(e, t, a) {
  Object.defineProperty(e, t, {
    value: a,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function gn(...e) {
  const t = {};
  for (const a of e) {
    const o = Object.getOwnPropertyDescriptors(a);
    Object.assign(t, o);
  }
  return Object.defineProperties({}, t);
}
function Am(e) {
  return JSON.stringify(e);
}
const Uk = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {
};
function Qi(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const Met = Wd(() => {
  if (typeof navigator < "u" && navigator?.userAgent?.includes("Cloudflare"))
    return !1;
  try {
    const e = Function;
    return new e(""), !0;
  } catch {
    return !1;
  }
});
function Gn(e) {
  if (Qi(e) === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const a = t.prototype;
  return !(Qi(a) === !1 || Object.prototype.hasOwnProperty.call(a, "isPrototypeOf") === !1);
}
function qk(e) {
  return Gn(e) ? { ...e } : Array.isArray(e) ? [...e] : e;
}
const Wet = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function an(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Wa(e, t, a) {
  const o = new e._zod.constr(t ?? e._zod.def);
  return (!t || a?.parent) && (o._zod.parent = e), o;
}
function re(e) {
  const t = e;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if (t?.message !== void 0) {
    if (t?.error !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function Bet(e) {
  return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
function Fet(e, t) {
  const a = e._zod.def, o = gn(e._zod.def, {
    get shape() {
      const n = {};
      for (const r in t) {
        if (!(r in a.shape))
          throw new Error(`Unrecognized key: "${r}"`);
        t[r] && (n[r] = a.shape[r]);
      }
      return Ma(this, "shape", n), n;
    },
    checks: []
  });
  return Wa(e, o);
}
function Vet(e, t) {
  const a = e._zod.def, o = gn(e._zod.def, {
    get shape() {
      const n = { ...e._zod.def.shape };
      for (const r in t) {
        if (!(r in a.shape))
          throw new Error(`Unrecognized key: "${r}"`);
        t[r] && delete n[r];
      }
      return Ma(this, "shape", n), n;
    },
    checks: []
  });
  return Wa(e, o);
}
function Uet(e, t) {
  if (!Gn(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const a = e._zod.def.checks;
  if (a && a.length > 0)
    throw new Error("Object schemas containing refinements cannot be extended. Use `.safeExtend()` instead.");
  const o = gn(e._zod.def, {
    get shape() {
      const n = { ...e._zod.def.shape, ...t };
      return Ma(this, "shape", n), n;
    },
    checks: []
  });
  return Wa(e, o);
}
function qet(e, t) {
  if (!Gn(t))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const a = {
    ...e._zod.def,
    get shape() {
      const o = { ...e._zod.def.shape, ...t };
      return Ma(this, "shape", o), o;
    },
    checks: e._zod.def.checks
  };
  return Wa(e, a);
}
function Het(e, t) {
  const a = gn(e._zod.def, {
    get shape() {
      const o = { ...e._zod.def.shape, ...t._zod.def.shape };
      return Ma(this, "shape", o), o;
    },
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return Wa(e, a);
}
function Get(e, t, a) {
  const o = gn(t._zod.def, {
    get shape() {
      const n = t._zod.def.shape, r = { ...n };
      if (a)
        for (const i in a) {
          if (!(i in n))
            throw new Error(`Unrecognized key: "${i}"`);
          a[i] && (r[i] = e ? new e({
            type: "optional",
            innerType: n[i]
          }) : n[i]);
        }
      else
        for (const i in n)
          r[i] = e ? new e({
            type: "optional",
            innerType: n[i]
          }) : n[i];
      return Ma(this, "shape", r), r;
    },
    checks: []
  });
  return Wa(t, o);
}
function Ket(e, t, a) {
  const o = gn(t._zod.def, {
    get shape() {
      const n = t._zod.def.shape, r = { ...n };
      if (a)
        for (const i in a) {
          if (!(i in r))
            throw new Error(`Unrecognized key: "${i}"`);
          a[i] && (r[i] = new e({
            type: "nonoptional",
            innerType: n[i]
          }));
        }
      else
        for (const i in n)
          r[i] = new e({
            type: "nonoptional",
            innerType: n[i]
          });
      return Ma(this, "shape", r), r;
    },
    checks: []
  });
  return Wa(t, o);
}
function Mo(e, t = 0) {
  if (e.aborted === !0)
    return !0;
  for (let a = t; a < e.issues.length; a++)
    if (e.issues[a]?.continue !== !0)
      return !0;
  return !1;
}
function Hk(e, t) {
  return t.map((a) => {
    var o;
    return (o = a).path ?? (o.path = []), a.path.unshift(e), a;
  });
}
function qr(e) {
  return typeof e == "string" ? e : e?.message;
}
function go(e, t, a) {
  const o = { ...e, path: e.path ?? [] };
  if (!e.message) {
    const n = qr(e.inst?._zod.def?.error?.(e)) ?? qr(t?.error?.(e)) ?? qr(a.customError?.(e)) ?? qr(a.localeError?.(e)) ?? "Invalid input";
    o.message = n;
  }
  return delete o.inst, delete o.continue, t?.reportInput || delete o.input, o;
}
function Vd(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function Kn(...e) {
  const [t, a, o] = e;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: a,
    inst: o
  } : { ...t };
}
const Gk = (e, t) => {
  e.name = "$ZodError", Object.defineProperty(e, "_zod", {
    value: e._zod,
    enumerable: !1
  }), Object.defineProperty(e, "issues", {
    value: t,
    enumerable: !1
  }), e.message = JSON.stringify(t, eu, 2), Object.defineProperty(e, "toString", {
    value: () => e.message,
    enumerable: !1
  });
}, Kk = F("$ZodError", Gk), Jk = F("$ZodError", Gk, { Parent: Error });
function Jet(e, t = (a) => a.message) {
  const a = {}, o = [];
  for (const n of e.issues)
    n.path.length > 0 ? (a[n.path[0]] = a[n.path[0]] || [], a[n.path[0]].push(t(n))) : o.push(t(n));
  return { formErrors: o, fieldErrors: a };
}
function Zet(e, t) {
  const a = t || function(r) {
    return r.message;
  }, o = { _errors: [] }, n = (r) => {
    for (const i of r.issues)
      if (i.code === "invalid_union" && i.errors.length)
        i.errors.map((s) => n({ issues: s }));
      else if (i.code === "invalid_key")
        n({ issues: i.issues });
      else if (i.code === "invalid_element")
        n({ issues: i.issues });
      else if (i.path.length === 0)
        o._errors.push(a(i));
      else {
        let s = o, l = 0;
        for (; l < i.path.length; ) {
          const c = i.path[l];
          l === i.path.length - 1 ? (s[c] = s[c] || { _errors: [] }, s[c]._errors.push(a(i))) : s[c] = s[c] || { _errors: [] }, s = s[c], l++;
        }
      }
  };
  return n(e), o;
}
const Ud = (e) => (t, a, o, n) => {
  const r = o ? Object.assign(o, { async: !1 }) : { async: !1 }, i = t._zod.run({ value: a, issues: [] }, r);
  if (i instanceof Promise)
    throw new qo();
  if (i.issues.length) {
    const s = new (n?.Err ?? e)(i.issues.map((l) => go(l, r, uo())));
    throw Uk(s, n?.callee), s;
  }
  return i.value;
}, qd = (e) => async (t, a, o, n) => {
  const r = o ? Object.assign(o, { async: !0 }) : { async: !0 };
  let i = t._zod.run({ value: a, issues: [] }, r);
  if (i instanceof Promise && (i = await i), i.issues.length) {
    const s = new (n?.Err ?? e)(i.issues.map((l) => go(l, r, uo())));
    throw Uk(s, n?.callee), s;
  }
  return i.value;
}, Hs = (e) => (t, a, o) => {
  const n = o ? { ...o, async: !1 } : { async: !1 }, r = t._zod.run({ value: a, issues: [] }, n);
  if (r instanceof Promise)
    throw new qo();
  return r.issues.length ? {
    success: !1,
    error: new (e ?? Kk)(r.issues.map((i) => go(i, n, uo())))
  } : { success: !0, data: r.value };
}, Yet = /* @__PURE__ */ Hs(Jk), Gs = (e) => async (t, a, o) => {
  const n = o ? Object.assign(o, { async: !0 }) : { async: !0 };
  let r = t._zod.run({ value: a, issues: [] }, n);
  return r instanceof Promise && (r = await r), r.issues.length ? {
    success: !1,
    error: new e(r.issues.map((i) => go(i, n, uo())))
  } : { success: !0, data: r.value };
}, Xet = /* @__PURE__ */ Gs(Jk), Qet = (e) => (t, a, o) => {
  const n = o ? Object.assign(o, { direction: "backward" }) : { direction: "backward" };
  return Ud(e)(t, a, n);
}, ett = (e) => (t, a, o) => Ud(e)(t, a, o), ttt = (e) => async (t, a, o) => {
  const n = o ? Object.assign(o, { direction: "backward" }) : { direction: "backward" };
  return qd(e)(t, a, n);
}, att = (e) => async (t, a, o) => qd(e)(t, a, o), ott = (e) => (t, a, o) => {
  const n = o ? Object.assign(o, { direction: "backward" }) : { direction: "backward" };
  return Hs(e)(t, a, n);
}, ntt = (e) => (t, a, o) => Hs(e)(t, a, o), rtt = (e) => async (t, a, o) => {
  const n = o ? Object.assign(o, { direction: "backward" }) : { direction: "backward" };
  return Gs(e)(t, a, n);
}, itt = (e) => async (t, a, o) => Gs(e)(t, a, o), stt = /^[cC][^\s-]{8,}$/, ltt = /^[0-9a-z]+$/, ctt = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, utt = /^[0-9a-vA-V]{20}$/, dtt = /^[A-Za-z0-9]{27}$/, gtt = /^[a-zA-Z0-9_-]{21}$/, htt = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, ptt = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, Pm = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, mtt = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, ftt = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function btt() {
  return new RegExp(ftt, "u");
}
const _tt = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, vtt = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, ytt = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, wtt = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, ktt = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, Zk = /^[A-Za-z0-9_-]*$/, xtt = /^(?=.{1,253}\.?$)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[-0-9a-zA-Z]{0,61}[0-9a-zA-Z])?)*\.?$/, $tt = /^\+(?:[0-9]){6,14}[0-9]$/, Yk = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", Stt = /* @__PURE__ */ new RegExp(`^${Yk}$`);
function Xk(e) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function Ctt(e) {
  return new RegExp(`^${Xk(e)}$`);
}
function Ett(e) {
  const t = Xk({ precision: e.precision }), a = ["Z"];
  e.local && a.push(""), e.offset && a.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const o = `${t}(?:${a.join("|")})`;
  return new RegExp(`^${Yk}T(?:${o})$`);
}
const jtt = (e) => {
  const t = e ? `[\\s\\S]{${e?.minimum ?? 0},${e?.maximum ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, Ott = /^[^A-Z]*$/, ztt = /^[^a-z]*$/, ra = /* @__PURE__ */ F("$ZodCheck", (e, t) => {
  var a;
  e._zod ?? (e._zod = {}), e._zod.def = t, (a = e._zod).onattach ?? (a.onattach = []);
}), Att = /* @__PURE__ */ F("$ZodCheckMaxLength", (e, t) => {
  var a;
  ra.init(e, t), (a = e._zod.def).when ?? (a.when = (o) => {
    const n = o.value;
    return !Bd(n) && n.length !== void 0;
  }), e._zod.onattach.push((o) => {
    const n = o._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < n && (o._zod.bag.maximum = t.maximum);
  }), e._zod.check = (o) => {
    const n = o.value;
    if (n.length <= t.maximum)
      return;
    const r = Vd(n);
    o.issues.push({
      origin: r,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: n,
      inst: e,
      continue: !t.abort
    });
  };
}), Ptt = /* @__PURE__ */ F("$ZodCheckMinLength", (e, t) => {
  var a;
  ra.init(e, t), (a = e._zod.def).when ?? (a.when = (o) => {
    const n = o.value;
    return !Bd(n) && n.length !== void 0;
  }), e._zod.onattach.push((o) => {
    const n = o._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > n && (o._zod.bag.minimum = t.minimum);
  }), e._zod.check = (o) => {
    const n = o.value;
    if (n.length >= t.minimum)
      return;
    const r = Vd(n);
    o.issues.push({
      origin: r,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: n,
      inst: e,
      continue: !t.abort
    });
  };
}), Dtt = /* @__PURE__ */ F("$ZodCheckLengthEquals", (e, t) => {
  var a;
  ra.init(e, t), (a = e._zod.def).when ?? (a.when = (o) => {
    const n = o.value;
    return !Bd(n) && n.length !== void 0;
  }), e._zod.onattach.push((o) => {
    const n = o._zod.bag;
    n.minimum = t.length, n.maximum = t.length, n.length = t.length;
  }), e._zod.check = (o) => {
    const n = o.value, r = n.length;
    if (r === t.length)
      return;
    const i = Vd(n), s = r > t.length;
    o.issues.push({
      origin: i,
      ...s ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: o.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Ks = /* @__PURE__ */ F("$ZodCheckStringFormat", (e, t) => {
  var a, o;
  ra.init(e, t), e._zod.onattach.push((n) => {
    const r = n._zod.bag;
    r.format = t.format, t.pattern && (r.patterns ?? (r.patterns = /* @__PURE__ */ new Set()), r.patterns.add(t.pattern));
  }), t.pattern ? (a = e._zod).check ?? (a.check = (n) => {
    t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: n.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: e,
      continue: !t.abort
    });
  }) : (o = e._zod).check ?? (o.check = () => {
  });
}), Ntt = /* @__PURE__ */ F("$ZodCheckRegex", (e, t) => {
  Ks.init(e, t), e._zod.check = (a) => {
    t.pattern.lastIndex = 0, !t.pattern.test(a.value) && a.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: a.value,
      pattern: t.pattern.toString(),
      inst: e,
      continue: !t.abort
    });
  };
}), Rtt = /* @__PURE__ */ F("$ZodCheckLowerCase", (e, t) => {
  t.pattern ?? (t.pattern = Ott), Ks.init(e, t);
}), Itt = /* @__PURE__ */ F("$ZodCheckUpperCase", (e, t) => {
  t.pattern ?? (t.pattern = ztt), Ks.init(e, t);
}), Ttt = /* @__PURE__ */ F("$ZodCheckIncludes", (e, t) => {
  ra.init(e, t);
  const a = an(t.includes), o = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${a}` : a);
  t.pattern = o, e._zod.onattach.push((n) => {
    const r = n._zod.bag;
    r.patterns ?? (r.patterns = /* @__PURE__ */ new Set()), r.patterns.add(o);
  }), e._zod.check = (n) => {
    n.value.includes(t.includes, t.position) || n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Ltt = /* @__PURE__ */ F("$ZodCheckStartsWith", (e, t) => {
  ra.init(e, t);
  const a = new RegExp(`^${an(t.prefix)}.*`);
  t.pattern ?? (t.pattern = a), e._zod.onattach.push((o) => {
    const n = o._zod.bag;
    n.patterns ?? (n.patterns = /* @__PURE__ */ new Set()), n.patterns.add(a);
  }), e._zod.check = (o) => {
    o.value.startsWith(t.prefix) || o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: o.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Mtt = /* @__PURE__ */ F("$ZodCheckEndsWith", (e, t) => {
  ra.init(e, t);
  const a = new RegExp(`.*${an(t.suffix)}$`);
  t.pattern ?? (t.pattern = a), e._zod.onattach.push((o) => {
    const n = o._zod.bag;
    n.patterns ?? (n.patterns = /* @__PURE__ */ new Set()), n.patterns.add(a);
  }), e._zod.check = (o) => {
    o.value.endsWith(t.suffix) || o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: o.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Wtt = /* @__PURE__ */ F("$ZodCheckOverwrite", (e, t) => {
  ra.init(e, t), e._zod.check = (a) => {
    a.value = t.tx(a.value);
  };
});
class Btt {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const a = t.split(`
`).filter((r) => r), o = Math.min(...a.map((r) => r.length - r.trimStart().length)), n = a.map((r) => r.slice(o)).map((r) => " ".repeat(this.indent * 2) + r);
    for (const r of n)
      this.content.push(r);
  }
  compile() {
    const t = Function, a = this?.args, o = [...(this?.content ?? [""]).map((n) => `  ${n}`)];
    return new t(...a, o.join(`
`));
  }
}
const Ftt = {
  major: 4,
  minor: 1,
  patch: 9
}, Ge = /* @__PURE__ */ F("$ZodType", (e, t) => {
  var a;
  e ?? (e = {}), e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = Ftt;
  const o = [...e._zod.def.checks ?? []];
  e._zod.traits.has("$ZodCheck") && o.unshift(e);
  for (const n of o)
    for (const r of n._zod.onattach)
      r(e);
  if (o.length === 0)
    (a = e._zod).deferred ?? (a.deferred = []), e._zod.deferred?.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const n = (i, s, l) => {
      let c = Mo(i), u;
      for (const d of s) {
        if (d._zod.def.when) {
          if (!d._zod.def.when(i))
            continue;
        } else if (c)
          continue;
        const h = i.issues.length, m = d._zod.check(i);
        if (m instanceof Promise && l?.async === !1)
          throw new qo();
        if (u || m instanceof Promise)
          u = (u ?? Promise.resolve()).then(async () => {
            await m, i.issues.length !== h && (c || (c = Mo(i, h)));
          });
        else {
          if (i.issues.length === h)
            continue;
          c || (c = Mo(i, h));
        }
      }
      return u ? u.then(() => i) : i;
    }, r = (i, s, l) => {
      if (Mo(i))
        return i.aborted = !0, i;
      const c = n(s, o, l);
      if (c instanceof Promise) {
        if (l.async === !1)
          throw new qo();
        return c.then((u) => e._zod.parse(u, l));
      }
      return e._zod.parse(c, l);
    };
    e._zod.run = (i, s) => {
      if (s.skipChecks)
        return e._zod.parse(i, s);
      if (s.direction === "backward") {
        const c = e._zod.parse({ value: i.value, issues: [] }, { ...s, skipChecks: !0 });
        return c instanceof Promise ? c.then((u) => r(u, i, s)) : r(c, i, s);
      }
      const l = e._zod.parse(i, s);
      if (l instanceof Promise) {
        if (s.async === !1)
          throw new qo();
        return l.then((c) => n(c, o, s));
      }
      return n(l, o, s);
    };
  }
  e["~standard"] = {
    validate: (n) => {
      try {
        const r = Yet(e, n);
        return r.success ? { value: r.data } : { issues: r.error?.issues };
      } catch {
        return Xet(e, n).then((r) => r.success ? { value: r.data } : { issues: r.error?.issues });
      }
    },
    vendor: "zod",
    version: 1
  };
}), Hd = /* @__PURE__ */ F("$ZodString", (e, t) => {
  Ge.init(e, t), e._zod.pattern = [...e?._zod.bag?.patterns ?? []].pop() ?? jtt(e._zod.bag), e._zod.parse = (a, o) => {
    if (t.coerce)
      try {
        a.value = String(a.value);
      } catch {
      }
    return typeof a.value == "string" || a.issues.push({
      expected: "string",
      code: "invalid_type",
      input: a.value,
      inst: e
    }), a;
  };
}), Te = /* @__PURE__ */ F("$ZodStringFormat", (e, t) => {
  Ks.init(e, t), Hd.init(e, t);
}), Vtt = /* @__PURE__ */ F("$ZodGUID", (e, t) => {
  t.pattern ?? (t.pattern = ptt), Te.init(e, t);
}), Utt = /* @__PURE__ */ F("$ZodUUID", (e, t) => {
  if (t.version) {
    const a = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (a === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = Pm(a));
  } else
    t.pattern ?? (t.pattern = Pm());
  Te.init(e, t);
}), qtt = /* @__PURE__ */ F("$ZodEmail", (e, t) => {
  t.pattern ?? (t.pattern = mtt), Te.init(e, t);
}), Htt = /* @__PURE__ */ F("$ZodURL", (e, t) => {
  Te.init(e, t), e._zod.check = (a) => {
    try {
      const o = a.value.trim(), n = new URL(o);
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(n.hostname) || a.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: xtt.source,
        input: a.value,
        inst: e,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(n.protocol.endsWith(":") ? n.protocol.slice(0, -1) : n.protocol) || a.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: a.value,
        inst: e,
        continue: !t.abort
      })), t.normalize ? a.value = n.href : a.value = o;
      return;
    } catch {
      a.issues.push({
        code: "invalid_format",
        format: "url",
        input: a.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), Gtt = /* @__PURE__ */ F("$ZodEmoji", (e, t) => {
  t.pattern ?? (t.pattern = btt()), Te.init(e, t);
}), Ktt = /* @__PURE__ */ F("$ZodNanoID", (e, t) => {
  t.pattern ?? (t.pattern = gtt), Te.init(e, t);
}), Jtt = /* @__PURE__ */ F("$ZodCUID", (e, t) => {
  t.pattern ?? (t.pattern = stt), Te.init(e, t);
}), Ztt = /* @__PURE__ */ F("$ZodCUID2", (e, t) => {
  t.pattern ?? (t.pattern = ltt), Te.init(e, t);
}), Ytt = /* @__PURE__ */ F("$ZodULID", (e, t) => {
  t.pattern ?? (t.pattern = ctt), Te.init(e, t);
}), Xtt = /* @__PURE__ */ F("$ZodXID", (e, t) => {
  t.pattern ?? (t.pattern = utt), Te.init(e, t);
}), Qtt = /* @__PURE__ */ F("$ZodKSUID", (e, t) => {
  t.pattern ?? (t.pattern = dtt), Te.init(e, t);
}), eat = /* @__PURE__ */ F("$ZodISODateTime", (e, t) => {
  t.pattern ?? (t.pattern = Ett(t)), Te.init(e, t);
}), tat = /* @__PURE__ */ F("$ZodISODate", (e, t) => {
  t.pattern ?? (t.pattern = Stt), Te.init(e, t);
}), aat = /* @__PURE__ */ F("$ZodISOTime", (e, t) => {
  t.pattern ?? (t.pattern = Ctt(t)), Te.init(e, t);
}), oat = /* @__PURE__ */ F("$ZodISODuration", (e, t) => {
  t.pattern ?? (t.pattern = htt), Te.init(e, t);
}), nat = /* @__PURE__ */ F("$ZodIPv4", (e, t) => {
  t.pattern ?? (t.pattern = _tt), Te.init(e, t), e._zod.onattach.push((a) => {
    const o = a._zod.bag;
    o.format = "ipv4";
  });
}), rat = /* @__PURE__ */ F("$ZodIPv6", (e, t) => {
  t.pattern ?? (t.pattern = vtt), Te.init(e, t), e._zod.onattach.push((a) => {
    const o = a._zod.bag;
    o.format = "ipv6";
  }), e._zod.check = (a) => {
    try {
      new URL(`http://[${a.value}]`);
    } catch {
      a.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: a.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), iat = /* @__PURE__ */ F("$ZodCIDRv4", (e, t) => {
  t.pattern ?? (t.pattern = ytt), Te.init(e, t);
}), sat = /* @__PURE__ */ F("$ZodCIDRv6", (e, t) => {
  t.pattern ?? (t.pattern = wtt), Te.init(e, t), e._zod.check = (a) => {
    const o = a.value.split("/");
    try {
      if (o.length !== 2)
        throw new Error();
      const [n, r] = o;
      if (!r)
        throw new Error();
      const i = Number(r);
      if (`${i}` !== r)
        throw new Error();
      if (i < 0 || i > 128)
        throw new Error();
      new URL(`http://[${n}]`);
    } catch {
      a.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: a.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
});
function Qk(e) {
  if (e === "")
    return !0;
  if (e.length % 4 !== 0)
    return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
const lat = /* @__PURE__ */ F("$ZodBase64", (e, t) => {
  t.pattern ?? (t.pattern = ktt), Te.init(e, t), e._zod.onattach.push((a) => {
    a._zod.bag.contentEncoding = "base64";
  }), e._zod.check = (a) => {
    Qk(a.value) || a.issues.push({
      code: "invalid_format",
      format: "base64",
      input: a.value,
      inst: e,
      continue: !t.abort
    });
  };
});
function cat(e) {
  if (!Zk.test(e))
    return !1;
  const t = e.replace(/[-_]/g, (o) => o === "-" ? "+" : "/"), a = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return Qk(a);
}
const uat = /* @__PURE__ */ F("$ZodBase64URL", (e, t) => {
  t.pattern ?? (t.pattern = Zk), Te.init(e, t), e._zod.onattach.push((a) => {
    a._zod.bag.contentEncoding = "base64url";
  }), e._zod.check = (a) => {
    cat(a.value) || a.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: a.value,
      inst: e,
      continue: !t.abort
    });
  };
}), dat = /* @__PURE__ */ F("$ZodE164", (e, t) => {
  t.pattern ?? (t.pattern = $tt), Te.init(e, t);
});
function gat(e, t = null) {
  try {
    const a = e.split(".");
    if (a.length !== 3)
      return !1;
    const [o] = a;
    if (!o)
      return !1;
    const n = JSON.parse(atob(o));
    return !("typ" in n && n?.typ !== "JWT" || !n.alg || t && (!("alg" in n) || n.alg !== t));
  } catch {
    return !1;
  }
}
const hat = /* @__PURE__ */ F("$ZodJWT", (e, t) => {
  Te.init(e, t), e._zod.check = (a) => {
    gat(a.value, t.alg) || a.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: a.value,
      inst: e,
      continue: !t.abort
    });
  };
}), pat = /* @__PURE__ */ F("$ZodUnknown", (e, t) => {
  Ge.init(e, t), e._zod.parse = (a) => a;
}), mat = /* @__PURE__ */ F("$ZodNever", (e, t) => {
  Ge.init(e, t), e._zod.parse = (a, o) => (a.issues.push({
    expected: "never",
    code: "invalid_type",
    input: a.value,
    inst: e
  }), a);
});
function Dm(e, t, a) {
  e.issues.length && t.issues.push(...Hk(a, e.issues)), t.value[a] = e.value;
}
const fat = /* @__PURE__ */ F("$ZodArray", (e, t) => {
  Ge.init(e, t), e._zod.parse = (a, o) => {
    const n = a.value;
    if (!Array.isArray(n))
      return a.issues.push({
        expected: "array",
        code: "invalid_type",
        input: n,
        inst: e
      }), a;
    a.value = Array(n.length);
    const r = [];
    for (let i = 0; i < n.length; i++) {
      const s = n[i], l = t.element._zod.run({
        value: s,
        issues: []
      }, o);
      l instanceof Promise ? r.push(l.then((c) => Dm(c, a, i))) : Dm(l, a, i);
    }
    return r.length ? Promise.all(r).then(() => a) : a;
  };
});
function es(e, t, a, o) {
  e.issues.length && t.issues.push(...Hk(a, e.issues)), e.value === void 0 ? a in o && (t.value[a] = void 0) : t.value[a] = e.value;
}
function ex(e) {
  const t = Object.keys(e.shape);
  for (const o of t)
    if (!e.shape?.[o]?._zod?.traits?.has("$ZodType"))
      throw new Error(`Invalid element at key "${o}": expected a Zod schema`);
  const a = Bet(e.shape);
  return {
    ...e,
    keys: t,
    keySet: new Set(t),
    numKeys: t.length,
    optionalKeys: new Set(a)
  };
}
function tx(e, t, a, o, n, r) {
  const i = [], s = n.keySet, l = n.catchall._zod, c = l.def.type;
  for (const u of Object.keys(t)) {
    if (s.has(u))
      continue;
    if (c === "never") {
      i.push(u);
      continue;
    }
    const d = l.run({ value: t[u], issues: [] }, o);
    d instanceof Promise ? e.push(d.then((h) => es(h, a, u, t))) : es(d, a, u, t);
  }
  return i.length && a.issues.push({
    code: "unrecognized_keys",
    keys: i,
    input: t,
    inst: r
  }), e.length ? Promise.all(e).then(() => a) : a;
}
const bat = /* @__PURE__ */ F("$ZodObject", (e, t) => {
  Ge.init(e, t);
  const a = Wd(() => ex(t));
  Re(e._zod, "propValues", () => {
    const i = t.shape, s = {};
    for (const l in i) {
      const c = i[l]._zod;
      if (c.values) {
        s[l] ?? (s[l] = /* @__PURE__ */ new Set());
        for (const u of c.values)
          s[l].add(u);
      }
    }
    return s;
  });
  const o = Qi, n = t.catchall;
  let r;
  e._zod.parse = (i, s) => {
    r ?? (r = a.value);
    const l = i.value;
    if (!o(l))
      return i.issues.push({
        expected: "object",
        code: "invalid_type",
        input: l,
        inst: e
      }), i;
    i.value = {};
    const c = [], u = r.shape;
    for (const d of r.keys) {
      const h = u[d]._zod.run({ value: l[d], issues: [] }, s);
      h instanceof Promise ? c.push(h.then((m) => es(m, i, d, l))) : es(h, i, d, l);
    }
    return n ? tx(c, l, i, s, a.value, e) : c.length ? Promise.all(c).then(() => i) : i;
  };
}), _at = /* @__PURE__ */ F("$ZodObjectJIT", (e, t) => {
  bat.init(e, t);
  const a = e._zod.parse, o = Wd(() => ex(t)), n = (d) => {
    const h = new Btt(["shape", "payload", "ctx"]), m = o.value, f = (_) => {
      const y = Am(_);
      return `shape[${y}]._zod.run({ value: input[${y}], issues: [] }, ctx)`;
    };
    h.write("const input = payload.value;");
    const p = /* @__PURE__ */ Object.create(null);
    let b = 0;
    for (const _ of m.keys)
      p[_] = `key_${b++}`;
    h.write("const newResult = {};");
    for (const _ of m.keys) {
      const y = p[_], k = Am(_);
      h.write(`const ${y} = ${f(_)};`), h.write(`
        if (${y}.issues.length) {
          payload.issues = payload.issues.concat(${y}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${k}, ...iss.path] : [${k}]
          })));
        }
        
        
        if (${y}.value === undefined) {
          if (${k} in input) {
            newResult[${k}] = undefined;
          }
        } else {
          newResult[${k}] = ${y}.value;
        }
        
      `);
    }
    h.write("payload.value = newResult;"), h.write("return payload;");
    const w = h.compile();
    return (_, y) => w(d, _, y);
  };
  let r;
  const i = Qi, s = !Vk.jitless, l = s && Met.value, c = t.catchall;
  let u;
  e._zod.parse = (d, h) => {
    u ?? (u = o.value);
    const m = d.value;
    return i(m) ? s && l && h?.async === !1 && h.jitless !== !0 ? (r || (r = n(t.shape)), d = r(d, h), c ? tx([], m, d, h, u, e) : d) : a(d, h) : (d.issues.push({
      expected: "object",
      code: "invalid_type",
      input: m,
      inst: e
    }), d);
  };
});
function Nm(e, t, a, o) {
  for (const r of e)
    if (r.issues.length === 0)
      return t.value = r.value, t;
  const n = e.filter((r) => !Mo(r));
  return n.length === 1 ? (t.value = n[0].value, n[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: a,
    errors: e.map((r) => r.issues.map((i) => go(i, o, uo())))
  }), t);
}
const vat = /* @__PURE__ */ F("$ZodUnion", (e, t) => {
  Ge.init(e, t), Re(e._zod, "optin", () => t.options.some((n) => n._zod.optin === "optional") ? "optional" : void 0), Re(e._zod, "optout", () => t.options.some((n) => n._zod.optout === "optional") ? "optional" : void 0), Re(e._zod, "values", () => {
    if (t.options.every((n) => n._zod.values))
      return new Set(t.options.flatMap((n) => Array.from(n._zod.values)));
  }), Re(e._zod, "pattern", () => {
    if (t.options.every((n) => n._zod.pattern)) {
      const n = t.options.map((r) => r._zod.pattern);
      return new RegExp(`^(${n.map((r) => Fd(r.source)).join("|")})$`);
    }
  });
  const a = t.options.length === 1, o = t.options[0]._zod.run;
  e._zod.parse = (n, r) => {
    if (a)
      return o(n, r);
    let i = !1;
    const s = [];
    for (const l of t.options) {
      const c = l._zod.run({
        value: n.value,
        issues: []
      }, r);
      if (c instanceof Promise)
        s.push(c), i = !0;
      else {
        if (c.issues.length === 0)
          return c;
        s.push(c);
      }
    }
    return i ? Promise.all(s).then((l) => Nm(l, n, e, r)) : Nm(s, n, e, r);
  };
}), yat = /* @__PURE__ */ F("$ZodIntersection", (e, t) => {
  Ge.init(e, t), e._zod.parse = (a, o) => {
    const n = a.value, r = t.left._zod.run({ value: n, issues: [] }, o), i = t.right._zod.run({ value: n, issues: [] }, o);
    return r instanceof Promise || i instanceof Promise ? Promise.all([r, i]).then(([s, l]) => Rm(a, s, l)) : Rm(a, r, i);
  };
});
function tu(e, t) {
  if (e === t)
    return { valid: !0, data: e };
  if (e instanceof Date && t instanceof Date && +e == +t)
    return { valid: !0, data: e };
  if (Gn(e) && Gn(t)) {
    const a = Object.keys(t), o = Object.keys(e).filter((r) => a.indexOf(r) !== -1), n = { ...e, ...t };
    for (const r of o) {
      const i = tu(e[r], t[r]);
      if (!i.valid)
        return {
          valid: !1,
          mergeErrorPath: [r, ...i.mergeErrorPath]
        };
      n[r] = i.data;
    }
    return { valid: !0, data: n };
  }
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const a = [];
    for (let o = 0; o < e.length; o++) {
      const n = e[o], r = t[o], i = tu(n, r);
      if (!i.valid)
        return {
          valid: !1,
          mergeErrorPath: [o, ...i.mergeErrorPath]
        };
      a.push(i.data);
    }
    return { valid: !0, data: a };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function Rm(e, t, a) {
  if (t.issues.length && e.issues.push(...t.issues), a.issues.length && e.issues.push(...a.issues), Mo(e))
    return e;
  const o = tu(t.value, a.value);
  if (!o.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(o.mergeErrorPath)}`);
  return e.value = o.data, e;
}
const wat = /* @__PURE__ */ F("$ZodEnum", (e, t) => {
  Ge.init(e, t);
  const a = Tet(t.entries), o = new Set(a);
  e._zod.values = o, e._zod.pattern = new RegExp(`^(${a.filter((n) => Wet.has(typeof n)).map((n) => typeof n == "string" ? an(n) : n.toString()).join("|")})$`), e._zod.parse = (n, r) => {
    const i = n.value;
    return o.has(i) || n.issues.push({
      code: "invalid_value",
      values: a,
      input: i,
      inst: e
    }), n;
  };
}), kat = /* @__PURE__ */ F("$ZodLiteral", (e, t) => {
  if (Ge.init(e, t), t.values.length === 0)
    throw new Error("Cannot create literal schema with no valid values");
  e._zod.values = new Set(t.values), e._zod.pattern = new RegExp(`^(${t.values.map((a) => typeof a == "string" ? an(a) : a ? an(a.toString()) : String(a)).join("|")})$`), e._zod.parse = (a, o) => {
    const n = a.value;
    return e._zod.values.has(n) || a.issues.push({
      code: "invalid_value",
      values: t.values,
      input: n,
      inst: e
    }), a;
  };
}), xat = /* @__PURE__ */ F("$ZodTransform", (e, t) => {
  Ge.init(e, t), e._zod.parse = (a, o) => {
    if (o.direction === "backward")
      throw new Fk(e.constructor.name);
    const n = t.transform(a.value, a);
    if (o.async)
      return (n instanceof Promise ? n : Promise.resolve(n)).then((r) => (a.value = r, a));
    if (n instanceof Promise)
      throw new qo();
    return a.value = n, a;
  };
});
function Im(e, t) {
  return e.issues.length && t === void 0 ? { issues: [], value: void 0 } : e;
}
const $at = /* @__PURE__ */ F("$ZodOptional", (e, t) => {
  Ge.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", Re(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), Re(e._zod, "pattern", () => {
    const a = t.innerType._zod.pattern;
    return a ? new RegExp(`^(${Fd(a.source)})?$`) : void 0;
  }), e._zod.parse = (a, o) => {
    if (t.innerType._zod.optin === "optional") {
      const n = t.innerType._zod.run(a, o);
      return n instanceof Promise ? n.then((r) => Im(r, a.value)) : Im(n, a.value);
    }
    return a.value === void 0 ? a : t.innerType._zod.run(a, o);
  };
}), Sat = /* @__PURE__ */ F("$ZodNullable", (e, t) => {
  Ge.init(e, t), Re(e._zod, "optin", () => t.innerType._zod.optin), Re(e._zod, "optout", () => t.innerType._zod.optout), Re(e._zod, "pattern", () => {
    const a = t.innerType._zod.pattern;
    return a ? new RegExp(`^(${Fd(a.source)}|null)$`) : void 0;
  }), Re(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (a, o) => a.value === null ? a : t.innerType._zod.run(a, o);
}), Cat = /* @__PURE__ */ F("$ZodDefault", (e, t) => {
  Ge.init(e, t), e._zod.optin = "optional", Re(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (a, o) => {
    if (o.direction === "backward")
      return t.innerType._zod.run(a, o);
    if (a.value === void 0)
      return a.value = t.defaultValue, a;
    const n = t.innerType._zod.run(a, o);
    return n instanceof Promise ? n.then((r) => Tm(r, t)) : Tm(n, t);
  };
});
function Tm(e, t) {
  return e.value === void 0 && (e.value = t.defaultValue), e;
}
const Eat = /* @__PURE__ */ F("$ZodPrefault", (e, t) => {
  Ge.init(e, t), e._zod.optin = "optional", Re(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (a, o) => (o.direction === "backward" || a.value === void 0 && (a.value = t.defaultValue), t.innerType._zod.run(a, o));
}), jat = /* @__PURE__ */ F("$ZodNonOptional", (e, t) => {
  Ge.init(e, t), Re(e._zod, "values", () => {
    const a = t.innerType._zod.values;
    return a ? new Set([...a].filter((o) => o !== void 0)) : void 0;
  }), e._zod.parse = (a, o) => {
    const n = t.innerType._zod.run(a, o);
    return n instanceof Promise ? n.then((r) => Lm(r, e)) : Lm(n, e);
  };
});
function Lm(e, t) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: t
  }), e;
}
const Oat = /* @__PURE__ */ F("$ZodCatch", (e, t) => {
  Ge.init(e, t), Re(e._zod, "optin", () => t.innerType._zod.optin), Re(e._zod, "optout", () => t.innerType._zod.optout), Re(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (a, o) => {
    if (o.direction === "backward")
      return t.innerType._zod.run(a, o);
    const n = t.innerType._zod.run(a, o);
    return n instanceof Promise ? n.then((r) => (a.value = r.value, r.issues.length && (a.value = t.catchValue({
      ...a,
      error: {
        issues: r.issues.map((i) => go(i, o, uo()))
      },
      input: a.value
    }), a.issues = []), a)) : (a.value = n.value, n.issues.length && (a.value = t.catchValue({
      ...a,
      error: {
        issues: n.issues.map((r) => go(r, o, uo()))
      },
      input: a.value
    }), a.issues = []), a);
  };
}), zat = /* @__PURE__ */ F("$ZodPipe", (e, t) => {
  Ge.init(e, t), Re(e._zod, "values", () => t.in._zod.values), Re(e._zod, "optin", () => t.in._zod.optin), Re(e._zod, "optout", () => t.out._zod.optout), Re(e._zod, "propValues", () => t.in._zod.propValues), e._zod.parse = (a, o) => {
    if (o.direction === "backward") {
      const r = t.out._zod.run(a, o);
      return r instanceof Promise ? r.then((i) => Hr(i, t.in, o)) : Hr(r, t.in, o);
    }
    const n = t.in._zod.run(a, o);
    return n instanceof Promise ? n.then((r) => Hr(r, t.out, o)) : Hr(n, t.out, o);
  };
});
function Hr(e, t, a) {
  return e.issues.length ? (e.aborted = !0, e) : t._zod.run({ value: e.value, issues: e.issues }, a);
}
const Aat = /* @__PURE__ */ F("$ZodReadonly", (e, t) => {
  Ge.init(e, t), Re(e._zod, "propValues", () => t.innerType._zod.propValues), Re(e._zod, "values", () => t.innerType._zod.values), Re(e._zod, "optin", () => t.innerType._zod.optin), Re(e._zod, "optout", () => t.innerType._zod.optout), e._zod.parse = (a, o) => {
    if (o.direction === "backward")
      return t.innerType._zod.run(a, o);
    const n = t.innerType._zod.run(a, o);
    return n instanceof Promise ? n.then(Mm) : Mm(n);
  };
});
function Mm(e) {
  return e.value = Object.freeze(e.value), e;
}
const Pat = /* @__PURE__ */ F("$ZodCustom", (e, t) => {
  ra.init(e, t), Ge.init(e, t), e._zod.parse = (a, o) => a, e._zod.check = (a) => {
    const o = a.value, n = t.fn(o);
    if (n instanceof Promise)
      return n.then((r) => Wm(r, a, o, e));
    Wm(n, a, o, e);
  };
});
function Wm(e, t, a, o) {
  if (!e) {
    const n = {
      code: "custom",
      input: a,
      inst: o,
      // incorporates params.error into issue reporting
      path: [...o._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !o._zod.def.abort
      // params: inst._zod.def.params,
    };
    o._zod.def.params && (n.params = o._zod.def.params), t.issues.push(Kn(n));
  }
}
class Dat {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...a) {
    const o = a[0];
    if (this._map.set(t, o), o && typeof o == "object" && "id" in o) {
      if (this._idmap.has(o.id))
        throw new Error(`ID ${o.id} already exists in the registry`);
      this._idmap.set(o.id, t);
    }
    return this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const a = this._map.get(t);
    return a && typeof a == "object" && "id" in a && this._idmap.delete(a.id), this._map.delete(t), this;
  }
  get(t) {
    const a = t._zod.parent;
    if (a) {
      const o = { ...this.get(a) ?? {} };
      delete o.id;
      const n = { ...o, ...this._map.get(t) };
      return Object.keys(n).length ? n : void 0;
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
}
function Nat() {
  return new Dat();
}
const Gr = /* @__PURE__ */ Nat();
function Rat(e, t) {
  return new e({
    type: "string",
    ...re(t)
  });
}
function ax(e, t) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Bm(e, t) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Iat(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Tat(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...re(t)
  });
}
function Lat(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...re(t)
  });
}
function Mat(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...re(t)
  });
}
function Wat(e, t) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Bat(e, t) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Fat(e, t) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Vat(e, t) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Uat(e, t) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function qat(e, t) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Hat(e, t) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Gat(e, t) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Kat(e, t) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Jat(e, t) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Zat(e, t) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Yat(e, t) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Xat(e, t) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Qat(e, t) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function eot(e, t) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function tot(e, t) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function aot(e, t) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...re(t)
  });
}
function oot(e, t) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...re(t)
  });
}
function not(e, t) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...re(t)
  });
}
function rot(e, t) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...re(t)
  });
}
function iot(e) {
  return new e({
    type: "unknown"
  });
}
function sot(e, t) {
  return new e({
    type: "never",
    ...re(t)
  });
}
function ox(e, t) {
  return new Att({
    check: "max_length",
    ...re(t),
    maximum: e
  });
}
function ts(e, t) {
  return new Ptt({
    check: "min_length",
    ...re(t),
    minimum: e
  });
}
function nx(e, t) {
  return new Dtt({
    check: "length_equals",
    ...re(t),
    length: e
  });
}
function lot(e, t) {
  return new Ntt({
    check: "string_format",
    format: "regex",
    ...re(t),
    pattern: e
  });
}
function cot(e) {
  return new Rtt({
    check: "string_format",
    format: "lowercase",
    ...re(e)
  });
}
function uot(e) {
  return new Itt({
    check: "string_format",
    format: "uppercase",
    ...re(e)
  });
}
function dot(e, t) {
  return new Ttt({
    check: "string_format",
    format: "includes",
    ...re(t),
    includes: e
  });
}
function got(e, t) {
  return new Ltt({
    check: "string_format",
    format: "starts_with",
    ...re(t),
    prefix: e
  });
}
function hot(e, t) {
  return new Mtt({
    check: "string_format",
    format: "ends_with",
    ...re(t),
    suffix: e
  });
}
function dr(e) {
  return new Wtt({
    check: "overwrite",
    tx: e
  });
}
function pot(e) {
  return dr((t) => t.normalize(e));
}
function mot() {
  return dr((e) => e.trim());
}
function fot() {
  return dr((e) => e.toLowerCase());
}
function bot() {
  return dr((e) => e.toUpperCase());
}
function _ot(e, t, a) {
  return new e({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...re(a)
  });
}
function vot(e, t, a) {
  return new e({
    type: "custom",
    check: "custom",
    fn: t,
    ...re(a)
  });
}
function yot(e) {
  const t = wot((a) => (a.addIssue = (o) => {
    if (typeof o == "string")
      a.issues.push(Kn(o, a.value, t._zod.def));
    else {
      const n = o;
      n.fatal && (n.continue = !1), n.code ?? (n.code = "custom"), n.input ?? (n.input = a.value), n.inst ?? (n.inst = t), n.continue ?? (n.continue = !t._zod.def.abort), a.issues.push(Kn(n));
    }
  }, e(a.value, a)));
  return t;
}
function wot(e, t) {
  const a = new ra({
    check: "custom",
    ...re(t)
  });
  return a._zod.check = e, a;
}
const kot = /* @__PURE__ */ F("ZodISODateTime", (e, t) => {
  eat.init(e, t), Me.init(e, t);
});
function xot(e) {
  return aot(kot, e);
}
const $ot = /* @__PURE__ */ F("ZodISODate", (e, t) => {
  tat.init(e, t), Me.init(e, t);
});
function Sot(e) {
  return oot($ot, e);
}
const Cot = /* @__PURE__ */ F("ZodISOTime", (e, t) => {
  aat.init(e, t), Me.init(e, t);
});
function Eot(e) {
  return not(Cot, e);
}
const jot = /* @__PURE__ */ F("ZodISODuration", (e, t) => {
  oat.init(e, t), Me.init(e, t);
});
function Oot(e) {
  return rot(jot, e);
}
const zot = (e, t) => {
  Kk.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
    format: {
      value: (a) => Zet(e, a)
      // enumerable: false,
    },
    flatten: {
      value: (a) => Jet(e, a)
      // enumerable: false,
    },
    addIssue: {
      value: (a) => {
        e.issues.push(a), e.message = JSON.stringify(e.issues, eu, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (a) => {
        e.issues.push(...a), e.message = JSON.stringify(e.issues, eu, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return e.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, Nt = F("ZodError", zot, {
  Parent: Error
}), Aot = /* @__PURE__ */ Ud(Nt), Pot = /* @__PURE__ */ qd(Nt), Dot = /* @__PURE__ */ Hs(Nt), Not = /* @__PURE__ */ Gs(Nt), Rot = /* @__PURE__ */ Qet(Nt), Iot = /* @__PURE__ */ ett(Nt), Tot = /* @__PURE__ */ ttt(Nt), Lot = /* @__PURE__ */ att(Nt), Mot = /* @__PURE__ */ ott(Nt), Wot = /* @__PURE__ */ ntt(Nt), Bot = /* @__PURE__ */ rtt(Nt), Fot = /* @__PURE__ */ itt(Nt), Ze = /* @__PURE__ */ F("ZodType", (e, t) => (Ge.init(e, t), e.def = t, e.type = t.type, Object.defineProperty(e, "_def", { value: t }), e.check = (...a) => e.clone(
  {
    ...t,
    checks: [
      ...t.checks ?? [],
      ...a.map((o) => typeof o == "function" ? { _zod: { check: o, def: { check: "custom" }, onattach: [] } } : o)
    ]
  }
  // { parent: true }
), e.clone = (a, o) => Wa(e, a, o), e.brand = () => e, e.register = (a, o) => (a.add(e, o), e), e.parse = (a, o) => Aot(e, a, o, { callee: e.parse }), e.safeParse = (a, o) => Dot(e, a, o), e.parseAsync = async (a, o) => Pot(e, a, o, { callee: e.parseAsync }), e.safeParseAsync = async (a, o) => Not(e, a, o), e.spa = e.safeParseAsync, e.encode = (a, o) => Rot(e, a, o), e.decode = (a, o) => Iot(e, a, o), e.encodeAsync = async (a, o) => Tot(e, a, o), e.decodeAsync = async (a, o) => Lot(e, a, o), e.safeEncode = (a, o) => Mot(e, a, o), e.safeDecode = (a, o) => Wot(e, a, o), e.safeEncodeAsync = async (a, o) => Bot(e, a, o), e.safeDecodeAsync = async (a, o) => Fot(e, a, o), e.refine = (a, o) => e.check(Nnt(a, o)), e.superRefine = (a) => e.check(Rnt(a)), e.overwrite = (a) => e.check(dr(a)), e.optional = () => Um(e), e.nullable = () => qm(e), e.nullish = () => Um(qm(e)), e.nonoptional = (a) => Ent(e, a), e.array = () => dnt(e), e.or = (a) => pnt([e, a]), e.and = (a) => fnt(e, a), e.transform = (a) => Hm(e, wnt(a)), e.default = (a) => $nt(e, a), e.prefault = (a) => Cnt(e, a), e.catch = (a) => Ont(e, a), e.pipe = (a) => Hm(e, a), e.readonly = () => Pnt(e), e.describe = (a) => {
  const o = e.clone();
  return Gr.add(o, { description: a }), o;
}, Object.defineProperty(e, "description", {
  get() {
    return Gr.get(e)?.description;
  },
  configurable: !0
}), e.meta = (...a) => {
  if (a.length === 0)
    return Gr.get(e);
  const o = e.clone();
  return Gr.add(o, a[0]), o;
}, e.isOptional = () => e.safeParse(void 0).success, e.isNullable = () => e.safeParse(null).success, e)), rx = /* @__PURE__ */ F("_ZodString", (e, t) => {
  Hd.init(e, t), Ze.init(e, t);
  const a = e._zod.bag;
  e.format = a.format ?? null, e.minLength = a.minimum ?? null, e.maxLength = a.maximum ?? null, e.regex = (...o) => e.check(lot(...o)), e.includes = (...o) => e.check(dot(...o)), e.startsWith = (...o) => e.check(got(...o)), e.endsWith = (...o) => e.check(hot(...o)), e.min = (...o) => e.check(ts(...o)), e.max = (...o) => e.check(ox(...o)), e.length = (...o) => e.check(nx(...o)), e.nonempty = (...o) => e.check(ts(1, ...o)), e.lowercase = (o) => e.check(cot(o)), e.uppercase = (o) => e.check(uot(o)), e.trim = () => e.check(mot()), e.normalize = (...o) => e.check(pot(...o)), e.toLowerCase = () => e.check(fot()), e.toUpperCase = () => e.check(bot());
}), Vot = /* @__PURE__ */ F("ZodString", (e, t) => {
  Hd.init(e, t), rx.init(e, t), e.email = (a) => e.check(ax(ix, a)), e.url = (a) => e.check(Wat(qot, a)), e.jwt = (a) => e.check(tot(int, a)), e.emoji = (a) => e.check(Bat(Hot, a)), e.guid = (a) => e.check(Bm(Fm, a)), e.uuid = (a) => e.check(Iat(Kr, a)), e.uuidv4 = (a) => e.check(Tat(Kr, a)), e.uuidv6 = (a) => e.check(Lat(Kr, a)), e.uuidv7 = (a) => e.check(Mat(Kr, a)), e.nanoid = (a) => e.check(Fat(Got, a)), e.guid = (a) => e.check(Bm(Fm, a)), e.cuid = (a) => e.check(Vat(Kot, a)), e.cuid2 = (a) => e.check(Uat(Jot, a)), e.ulid = (a) => e.check(qat(Zot, a)), e.base64 = (a) => e.check(Xat(ont, a)), e.base64url = (a) => e.check(Qat(nnt, a)), e.xid = (a) => e.check(Hat(Yot, a)), e.ksuid = (a) => e.check(Gat(Xot, a)), e.ipv4 = (a) => e.check(Kat(Qot, a)), e.ipv6 = (a) => e.check(Jat(ent, a)), e.cidrv4 = (a) => e.check(Zat(tnt, a)), e.cidrv6 = (a) => e.check(Yat(ant, a)), e.e164 = (a) => e.check(eot(rnt, a)), e.datetime = (a) => e.check(xot(a)), e.date = (a) => e.check(Sot(a)), e.time = (a) => e.check(Eot(a)), e.duration = (a) => e.check(Oot(a));
});
function lt(e) {
  return Rat(Vot, e);
}
const Me = /* @__PURE__ */ F("ZodStringFormat", (e, t) => {
  Te.init(e, t), rx.init(e, t);
}), ix = /* @__PURE__ */ F("ZodEmail", (e, t) => {
  qtt.init(e, t), Me.init(e, t);
});
function Uot(e) {
  return ax(ix, e);
}
const Fm = /* @__PURE__ */ F("ZodGUID", (e, t) => {
  Vtt.init(e, t), Me.init(e, t);
}), Kr = /* @__PURE__ */ F("ZodUUID", (e, t) => {
  Utt.init(e, t), Me.init(e, t);
}), qot = /* @__PURE__ */ F("ZodURL", (e, t) => {
  Htt.init(e, t), Me.init(e, t);
}), Hot = /* @__PURE__ */ F("ZodEmoji", (e, t) => {
  Gtt.init(e, t), Me.init(e, t);
}), Got = /* @__PURE__ */ F("ZodNanoID", (e, t) => {
  Ktt.init(e, t), Me.init(e, t);
}), Kot = /* @__PURE__ */ F("ZodCUID", (e, t) => {
  Jtt.init(e, t), Me.init(e, t);
}), Jot = /* @__PURE__ */ F("ZodCUID2", (e, t) => {
  Ztt.init(e, t), Me.init(e, t);
}), Zot = /* @__PURE__ */ F("ZodULID", (e, t) => {
  Ytt.init(e, t), Me.init(e, t);
}), Yot = /* @__PURE__ */ F("ZodXID", (e, t) => {
  Xtt.init(e, t), Me.init(e, t);
}), Xot = /* @__PURE__ */ F("ZodKSUID", (e, t) => {
  Qtt.init(e, t), Me.init(e, t);
}), Qot = /* @__PURE__ */ F("ZodIPv4", (e, t) => {
  nat.init(e, t), Me.init(e, t);
}), ent = /* @__PURE__ */ F("ZodIPv6", (e, t) => {
  rat.init(e, t), Me.init(e, t);
}), tnt = /* @__PURE__ */ F("ZodCIDRv4", (e, t) => {
  iat.init(e, t), Me.init(e, t);
}), ant = /* @__PURE__ */ F("ZodCIDRv6", (e, t) => {
  sat.init(e, t), Me.init(e, t);
}), ont = /* @__PURE__ */ F("ZodBase64", (e, t) => {
  lat.init(e, t), Me.init(e, t);
}), nnt = /* @__PURE__ */ F("ZodBase64URL", (e, t) => {
  uat.init(e, t), Me.init(e, t);
}), rnt = /* @__PURE__ */ F("ZodE164", (e, t) => {
  dat.init(e, t), Me.init(e, t);
}), int = /* @__PURE__ */ F("ZodJWT", (e, t) => {
  hat.init(e, t), Me.init(e, t);
}), snt = /* @__PURE__ */ F("ZodUnknown", (e, t) => {
  pat.init(e, t), Ze.init(e, t);
});
function Vm() {
  return iot(snt);
}
const lnt = /* @__PURE__ */ F("ZodNever", (e, t) => {
  mat.init(e, t), Ze.init(e, t);
});
function cnt(e) {
  return sot(lnt, e);
}
const unt = /* @__PURE__ */ F("ZodArray", (e, t) => {
  fat.init(e, t), Ze.init(e, t), e.element = t.element, e.min = (a, o) => e.check(ts(a, o)), e.nonempty = (a) => e.check(ts(1, a)), e.max = (a, o) => e.check(ox(a, o)), e.length = (a, o) => e.check(nx(a, o)), e.unwrap = () => e.element;
});
function dnt(e, t) {
  return _ot(unt, e, t);
}
const gnt = /* @__PURE__ */ F("ZodObject", (e, t) => {
  _at.init(e, t), Ze.init(e, t), Re(e, "shape", () => t.shape), e.keyof = () => bnt(Object.keys(e._zod.def.shape)), e.catchall = (a) => e.clone({ ...e._zod.def, catchall: a }), e.passthrough = () => e.clone({ ...e._zod.def, catchall: Vm() }), e.loose = () => e.clone({ ...e._zod.def, catchall: Vm() }), e.strict = () => e.clone({ ...e._zod.def, catchall: cnt() }), e.strip = () => e.clone({ ...e._zod.def, catchall: void 0 }), e.extend = (a) => Uet(e, a), e.safeExtend = (a) => qet(e, a), e.merge = (a) => Het(e, a), e.pick = (a) => Fet(e, a), e.omit = (a) => Vet(e, a), e.partial = (...a) => Get(sx, e, a[0]), e.required = (...a) => Ket(lx, e, a[0]);
});
function as(e, t) {
  const a = {
    type: "object",
    get shape() {
      return Ma(this, "shape", e ? Let(e) : {}), this.shape;
    },
    ...re(t)
  };
  return new gnt(a);
}
const hnt = /* @__PURE__ */ F("ZodUnion", (e, t) => {
  vat.init(e, t), Ze.init(e, t), e.options = t.options;
});
function pnt(e, t) {
  return new hnt({
    type: "union",
    options: e,
    ...re(t)
  });
}
const mnt = /* @__PURE__ */ F("ZodIntersection", (e, t) => {
  yat.init(e, t), Ze.init(e, t);
});
function fnt(e, t) {
  return new mnt({
    type: "intersection",
    left: e,
    right: t
  });
}
const au = /* @__PURE__ */ F("ZodEnum", (e, t) => {
  wat.init(e, t), Ze.init(e, t), e.enum = t.entries, e.options = Object.values(t.entries);
  const a = new Set(Object.keys(t.entries));
  e.extract = (o, n) => {
    const r = {};
    for (const i of o)
      if (a.has(i))
        r[i] = t.entries[i];
      else
        throw new Error(`Key ${i} not found in enum`);
    return new au({
      ...t,
      checks: [],
      ...re(n),
      entries: r
    });
  }, e.exclude = (o, n) => {
    const r = { ...t.entries };
    for (const i of o)
      if (a.has(i))
        delete r[i];
      else
        throw new Error(`Key ${i} not found in enum`);
    return new au({
      ...t,
      checks: [],
      ...re(n),
      entries: r
    });
  };
});
function bnt(e, t) {
  const a = Array.isArray(e) ? Object.fromEntries(e.map((o) => [o, o])) : e;
  return new au({
    type: "enum",
    entries: a,
    ...re(t)
  });
}
const _nt = /* @__PURE__ */ F("ZodLiteral", (e, t) => {
  kat.init(e, t), Ze.init(e, t), e.values = new Set(t.values), Object.defineProperty(e, "value", {
    get() {
      if (t.values.length > 1)
        throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
      return t.values[0];
    }
  });
});
function vnt(e, t) {
  return new _nt({
    type: "literal",
    values: Array.isArray(e) ? e : [e],
    ...re(t)
  });
}
const ynt = /* @__PURE__ */ F("ZodTransform", (e, t) => {
  xat.init(e, t), Ze.init(e, t), e._zod.parse = (a, o) => {
    if (o.direction === "backward")
      throw new Fk(e.constructor.name);
    a.addIssue = (r) => {
      if (typeof r == "string")
        a.issues.push(Kn(r, a.value, t));
      else {
        const i = r;
        i.fatal && (i.continue = !1), i.code ?? (i.code = "custom"), i.input ?? (i.input = a.value), i.inst ?? (i.inst = e), a.issues.push(Kn(i));
      }
    };
    const n = t.transform(a.value, a);
    return n instanceof Promise ? n.then((r) => (a.value = r, a)) : (a.value = n, a);
  };
});
function wnt(e) {
  return new ynt({
    type: "transform",
    transform: e
  });
}
const sx = /* @__PURE__ */ F("ZodOptional", (e, t) => {
  $at.init(e, t), Ze.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Um(e) {
  return new sx({
    type: "optional",
    innerType: e
  });
}
const knt = /* @__PURE__ */ F("ZodNullable", (e, t) => {
  Sat.init(e, t), Ze.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function qm(e) {
  return new knt({
    type: "nullable",
    innerType: e
  });
}
const xnt = /* @__PURE__ */ F("ZodDefault", (e, t) => {
  Cat.init(e, t), Ze.init(e, t), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function $nt(e, t) {
  return new xnt({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : qk(t);
    }
  });
}
const Snt = /* @__PURE__ */ F("ZodPrefault", (e, t) => {
  Eat.init(e, t), Ze.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Cnt(e, t) {
  return new Snt({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : qk(t);
    }
  });
}
const lx = /* @__PURE__ */ F("ZodNonOptional", (e, t) => {
  jat.init(e, t), Ze.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Ent(e, t) {
  return new lx({
    type: "nonoptional",
    innerType: e,
    ...re(t)
  });
}
const jnt = /* @__PURE__ */ F("ZodCatch", (e, t) => {
  Oat.init(e, t), Ze.init(e, t), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function Ont(e, t) {
  return new jnt({
    type: "catch",
    innerType: e,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const znt = /* @__PURE__ */ F("ZodPipe", (e, t) => {
  zat.init(e, t), Ze.init(e, t), e.in = t.in, e.out = t.out;
});
function Hm(e, t) {
  return new znt({
    type: "pipe",
    in: e,
    out: t
    // ...util.normalizeParams(params),
  });
}
const Ant = /* @__PURE__ */ F("ZodReadonly", (e, t) => {
  Aat.init(e, t), Ze.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Pnt(e) {
  return new Ant({
    type: "readonly",
    innerType: e
  });
}
const Dnt = /* @__PURE__ */ F("ZodCustom", (e, t) => {
  Pat.init(e, t), Ze.init(e, t);
});
function Nnt(e, t = {}) {
  return vot(Dnt, e, t);
}
function Rnt(e) {
  return yot(e);
}
as({
  email: Uot(),
  password: lt().min(8)
}).required();
as({
  firstname: lt().min(1),
  lastname: lt().min(1),
  email: lt().email(),
  password: lt().min(8),
  sponsor: lt().optional(),
  cgus: vnt(!0)
});
function Int({ children: e, onLogout: t }) {
  return e ? Gm(e, {
    onClick: async () => {
      await DCe(), t && await t();
    }
  }) : null;
}
function cx({ config: e, children: t, onLogout: a }) {
  return dje(e.apiUrl), /* @__PURE__ */ v(zDe, { config: e, children: /* @__PURE__ */ v(Int, { onLogout: a, children: t }) });
}
function ux(e) {
  var t, a, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var n = e.length;
    for (t = 0; t < n; t++) e[t] && (a = ux(e[t])) && (o && (o += " "), o += a);
  } else for (a in e) e[a] && (o && (o += " "), o += a);
  return o;
}
function Tnt() {
  for (var e, t, a = 0, o = "", n = arguments.length; a < n; a++) (e = arguments[a]) && (t = ux(e)) && (o && (o += " "), o += t);
  return o;
}
const Lnt = [
  "accessible-bathroom",
  "accessible-bedroom",
  "ac",
  "ambassador_sidebar",
  "animals-card",
  "angle-left",
  "angle-left-rounded",
  "angle-right",
  "angle-right-rounded",
  "anywhere-in-the-world",
  "arrow-thin",
  "arrow-thin-right",
  "available-exchange-type",
  "average-reactivity",
  "baby-bed",
  "baby-gear",
  "baby-gear-old",
  "baby-sitter",
  "balcony-terrace",
  "bathroom",
  "bathtub",
  "bbq",
  "bedroom",
  "beds",
  "bicycle",
  "briefcase3",
  "button-power",
  "cancel",
  "calendar",
  "car",
  "cat-to-feed",
  "chat-lock",
  "check",
  "checkbox-fill",
  "children-welcome",
  "circle-close",
  "circle-help",
  "circle-left-arrow",
  "circle-right-arrow",
  "cities",
  "cleaning-person",
  "clock",
  "computer",
  "cook",
  "corona-virus",
  "countryside",
  "credit-card",
  "dashboard-saved-search",
  "dedicated-work-space",
  "disabled-access",
  "dishwasher",
  "docs",
  "dog-to-feed",
  "dollar",
  "doorman",
  "double-bed",
  "double-bed-up",
  "dryer",
  "easy-navigation",
  "electric-car",
  "electric-car-plug",
  "elevator",
  "error",
  "error-regular",
  "error-warning-fill",
  "excellent-reactivity",
  "eye",
  "eye-slash",
  "eye-slash-back",
  "facebook",
  "filter-picture",
  "fireplace",
  "flag",
  "flat",
  "folk",
  "freezer",
  "fridge",
  "garden",
  "gift",
  "gp",
  "great-reactivity",
  "guarantees",
  "guestpoint-exchange-type",
  "guestpoints",
  "guide",
  "gym",
  "header-help",
  "header-message-new",
  "header-message-read",
  "header-profile-home",
  "header-profile-profile",
  "header-profile-settings",
  "header-profile-they-love-my-home",
  "heart",
  "heart-fill",
  "heating-system",
  "high-speed-connection",
  "home-bin",
  "home-camera",
  "home-cinema",
  "home-exchange",
  "home-panel",
  "house",
  "ic-compass",
  "ic-flip-left",
  "ic-flip-right",
  "ic-location",
  "ic-move",
  "ic-shelter",
  "ic-transfer",
  "icon_facebook",
  "icon_gmail",
  "icon_messanger",
  "icon_outlook",
  "id",
  "information-circle",
  "information-circle-regular",
  "instagram",
  "internet",
  "isolated",
  "island",
  "jacuzzi",
  "key",
  "keys",
  "kids-playground",
  "kids-toys",
  "lakes",
  "lifebuoy",
  "linkedin",
  "location",
  "lock",
  "lock-credit-card",
  "low-consumption-machines",
  "marker-home",
  "marker-home-favorite",
  "marker-home-selected",
  "marker-home-selected-favorite",
  "marker-home-unavailable",
  "marker-home-unavailable-favorite",
  "low-reactivity",
  "map-1",
  "megaphone",
  "membership",
  "messenger",
  "microwave-oven",
  "minus",
  "moonplus",
  "more-filter",
  "motorboat",
  "motorcycle",
  "motor-scooter",
  "mountains",
  "my-family",
  "new-tab",
  "notification",
  "noun-loyalty-card",
  "number-eight",
  "number-five",
  "number-four",
  "number-nine",
  "number-one",
  "number-seven",
  "number-six",
  "number-three",
  "number-two",
  "ok",
  "oven",
  "parking-space",
  "pencil",
  "people",
  "pets-welcome",
  "phone",
  "piano",
  "ping-pong-table",
  "pin",
  "plants-to-water",
  "playground",
  "plus",
  "plus-sign",
  "pool-table",
  "preferred-destinations",
  "primary-home",
  "private-room",
  "public-transit-access",
  "rabbit",
  "raw",
  "reciprocal-exchange-type",
  "remove",
  "renewable-energy-provider",
  "river",
  "rooms",
  "sailboat",
  "satellite-cable",
  "sauna",
  "search",
  "search-location-pin",
  "seaside",
  "secondary-home",
  "secured-swimming-pool",
  "selective-waste-sorting",
  "shape-close",
  "share-fat",
  "simple-bed",
  "simple-bed-up",
  "size",
  "smart-tv",
  "smokers-welcome",
  "solar-panels",
  "sort-order",
  "sponsor-hand-icon",
  "star-black",
  "star-full",
  "step-free-entry",
  "sugesstion",
  "sun",
  "swimming-pool",
  "tennis-court",
  "tiktok",
  "triangle-warning",
  "tv",
  "tv-icon",
  "twitter",
  "types_of_exchanges",
  "unavailable",
  "up-arrow",
  "upload",
  "user",
  "vegetable-garden",
  "verification-check",
  "verification-check-regular",
  "video-game-console",
  "villages",
  "warning",
  "warning-regular",
  "washing-machine",
  "wide-angle",
  "wide-doors",
  "wifi",
  "youtube"
], Mnt = {
  "marker-home-favorite": 3,
  "marker-home": 2,
  "marker-home-selected-favorite": 3,
  "marker-home-selected": 2,
  "marker-home-unavailable-favorite": 3,
  "marker-home-unavailable": 2,
  icon_facebook: 2,
  icon_gmail: 5
}, Wnt = Lnt.map((e) => ({
  name: e,
  class: `icon-${e}`,
  paths: Mnt[e]
})), Bnt = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, Fnt = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl",
  "8xl": "is-8xl",
  "9xl": "is-9xl",
  "10xl": "is-10xl"
};
function Vnt(e = 0) {
  const t = [];
  for (let a = 0; a < e; a++)
    t[a] = `path${a + 1}`;
  return t.map((a) => /* @__PURE__ */ v("span", { className: a }, a));
}
const Unt = mt(
  ({ name: e, size: t = "medium", color: a = "base", className: o = "", ...n }, r) => {
    const i = Wnt.find((l) => l.name === e), s = Tnt("icon", `ds-${i?.class}`, Fnt[t], Bnt[a], o);
    return /* @__PURE__ */ v("i", { className: s, ...n, ref: r, children: Vnt(i?.paths) });
  }
);
Unt.displayName = "Icon";
Ot({
  locale: "en"
});
const qnt = as({
  firstName: lt({ error: Cn.t("auth:modal.finishCreatingAccount.firstName.error") }).min(1, Cn.t("auth:modal.finishCreatingAccount.firstName.error")),
  lastName: lt({ error: Cn.t("auth:modal.finishCreatingAccount.lastName.error") }).min(1, Cn.t("auth:modal.finishCreatingAccount.lastName.error")),
  referralCode: lt().optional(),
  phoneNumber: lt().optional(),
  howDoYouKnowHE: as({
    firstLevel: lt().optional(),
    secondLevel: lt().optional(),
    openField: lt().optional()
  })
});
qnt.extend({
  phoneNumber: lt().min(1, { error: Cn.t("auth:modal.finishCreatingAccount.phone_number.error") })
});
function dx() {
  const { t: e } = mo("header");
  return /* @__PURE__ */ T(xu, { children: [
    /* @__PURE__ */ v($u, { children: /* @__PURE__ */ T(ue, { gap: "2", alignItems: "center", children: [
      /* @__PURE__ */ v(Se, { name: "header-help" }),
      e("help")
    ] }) }),
    /* @__PURE__ */ T(Su, { children: [
      /* @__PURE__ */ v(de, { href: e("links:faq"), children: e("faq") }),
      /* @__PURE__ */ v(Et, {}),
      /* @__PURE__ */ v(de, { href: e("links:guestpoints"), children: e("guestpoints") }),
      /* @__PURE__ */ v(Et, {}),
      /* @__PURE__ */ v(de, { href: e("links:about-calendar"), children: e("about-the-calendar") }),
      /* @__PURE__ */ v(Et, {}),
      /* @__PURE__ */ v(de, { href: e("links:guarantees"), children: e("guarantees") }),
      /* @__PURE__ */ v(Et, {}),
      /* @__PURE__ */ v(de, { href: e("links:contact-us"), children: e("contact") })
    ] })
  ] });
}
function Hnt() {
  const { url: e } = Oe("/conversations"), { conversations: t, userInfos: a } = ro((n) => ({
    conversations: n.conversations,
    userInfos: n.userInfos
  })), { t: o } = mo("header");
  return /* @__PURE__ */ T(xu, { hideOn: "mobile", children: [
    /* @__PURE__ */ v($u, { children: /* @__PURE__ */ T(ue, { gap: "2", alignItems: "center", children: [
      t && t?.notifications > 0 && /* @__PURE__ */ v(fu, { value: t?.notifications, onIcon: !0, children: /* @__PURE__ */ v(Se, { name: "header-message-new" }) }),
      o("messages")
    ] }) }),
    /* @__PURE__ */ T(Su, { size: "medium", children: [
      t?.all?.length ? /* @__PURE__ */ v(de, { noPaddingRight: !0, noTopBottomPadding: !0, children: /* @__PURE__ */ v(Gnt, { conversations: t }) }) : /* @__PURE__ */ v(de, { children: /* @__PURE__ */ T(ue, { justifyContent: "center", children: [
        /* @__PURE__ */ v(Je, { children: o("no-messages") }),
        /* @__PURE__ */ v(
          "img",
          {
            src: "https://d2kzpkef14nfxb.cloudfront.net/images/website/header/messages_empty.svg",
            alt: "no messages"
          }
        )
      ] }) }),
      /* @__PURE__ */ v(de, { noPaddingRight: !0, noTopBottomPadding: !0, children: /* @__PURE__ */ T(ue, { justifyContent: "space-between", isFullWidth: !0, alignItems: "center", children: [
        /* @__PURE__ */ T(Je, { size: "sm", children: [
          o("my-response-rate"),
          " ",
          /* @__PURE__ */ T(Je, { isSpan: !0, isBold: !0, size: "sm", children: [
            a?.response_rate,
            "%"
          ] })
        ] }),
        /* @__PURE__ */ v(ou, { color: "tertiary", size: "medium", href: e, children: o("view-inbox") })
      ] }) })
    ] })
  ] });
}
const Gnt = ({ conversations: e }) => /* @__PURE__ */ v(
  IS,
  {
    isFullWidth: !0,
    size: "small",
    tabs: [
      {
        title: "All",
        content: /* @__PURE__ */ v(De, { children: e.all.map((t) => /* @__PURE__ */ v(Kl, { conversation: t }, t.id)) })
      },
      {
        title: `Unreplied (${e.stats.unreplied})`,
        content: /* @__PURE__ */ v(De, { children: e.unreplied.map((t) => /* @__PURE__ */ v(Kl, { conversation: t }, t.id)) })
      },
      {
        title: `Finalized (${e.stats.finalized})`,
        content: /* @__PURE__ */ v(De, { children: e.finalized.map((t) => /* @__PURE__ */ v(Kl, { conversation: t }, t.id)) })
      }
    ]
  }
), Kl = ({ conversation: e }) => {
  const { url: t } = Oe(`/conversations/${e.id}`);
  return /* @__PURE__ */ T("a", { href: t, children: [
    /* @__PURE__ */ T(ue, { gap: "4", alignItems: "center", noMargin: !0, children: [
      /* @__PURE__ */ v(
        "img",
        {
          src: e.interlocutor.profilePicture,
          style: { height: "40px", width: "40px", background: "blue", borderRadius: "9999px" },
          alt: "user"
        }
      ),
      /* @__PURE__ */ T(
        "div",
        {
          style: {
            overflow: "hidden",
            flex: "1 0 0"
          },
          children: [
            /* @__PURE__ */ v(
              "div",
              {
                style: {
                  fontWeight: "bold"
                },
                children: e.interlocutor.firstName
              }
            ),
            /* @__PURE__ */ v(Je, { ellipsis: !0, size: "sm", children: e.lastMessage.content })
          ]
        }
      ),
      /* @__PURE__ */ v("div", { children: fx(e.lastMessage.createdAt) })
    ] }),
    /* @__PURE__ */ v(SS, { space: "small" })
  ] });
};
function Knt() {
  const { t: e } = mo("header"), { userInfos: t, completionRate: a, userProfile: o, userMembership: n, apiUrl: r } = ro((p) => ({
    userInfos: p.userInfos,
    completionRate: p.userInfos?.profil.completionRate ?? 0,
    userProfile: p.userInfos?.notifications?.user?.details.userProfile,
    userMembership: p.userInfos?.notifications?.user?.details.membership,
    apiUrl: p.apiUrl
  })), { signout: i } = zs((p) => ({
    signout: p.signout
  })), { url: s } = Oe(`/user/edit/${t?.profil.id}`), { url: l } = Oe("/homes/edit"), { url: c } = Oe("/homes/create"), { url: u } = Oe("/myexchanges"), { url: d } = Oe("/my-plan"), { url: h } = Oe("/user/favorite"), { url: m } = Oe("/user/they-love-my-home"), { url: f } = Oe(`/user/settings/${t?.profil.id}`);
  return /* @__PURE__ */ T(De, { children: [
    /* @__PURE__ */ v(de, { noPaddingRight: !0, href: s, children: /* @__PURE__ */ T(ue, { gap: "2", isFullWidth: !0, children: [
      /* @__PURE__ */ T(ue, { isFullWidth: !0, justifyContent: "space-between", children: [
        /* @__PURE__ */ T(ue, { gap: "4", alignItems: "center", children: [
          /* @__PURE__ */ v(Se, { name: "header-profile-profile" }),
          e("my-profile")
        ] }),
        /* @__PURE__ */ T(ue, { alignItems: "center", gap: "2", children: [
          /* @__PURE__ */ T(Je, { size: "sm", children: [
            a,
            "%"
          ] }),
          /* @__PURE__ */ v(hg, { value: a, color: "tertiary", size: "small", ariaLabel: "User completion rate" })
        ] })
      ] }),
      /* @__PURE__ */ v(Je, { isBold: !0, size: "sm", color: "tertiary", children: o && e(`notification.user_profile.${o.status}`, {
        gp: o.gpReward
      }) })
    ] }) }),
    /* @__PURE__ */ v(Et, {}),
    t?.homes?.map((p) => /* @__PURE__ */ T("div", { children: [
      /* @__PURE__ */ v(de, { noPaddingRight: !0, href: `${l}/${p.id}`, children: /* @__PURE__ */ T(ue, { gap: "2", isFullWidth: !0, children: [
        /* @__PURE__ */ T(ue, { isFullWidth: !0, justifyContent: "space-between", children: [
          /* @__PURE__ */ T(ue, { gap: "4", alignItems: "center", children: [
            /* @__PURE__ */ v(Se, { name: "header-profile-home" }),
            /* @__PURE__ */ v(Je, { size: "sm", children: "My Home" })
          ] }),
          /* @__PURE__ */ T(ue, { alignItems: "center", gap: "2", children: [
            /* @__PURE__ */ T(Je, { size: "sm", children: [
              p.completionRate,
              "%"
            ] }),
            /* @__PURE__ */ v(
              hg,
              {
                value: p.completionRate,
                color: "tertiary",
                size: "small",
                ariaLabel: "Home completion rate"
              }
            )
          ] })
        ] }),
        p.notifications?.status && /* @__PURE__ */ v(Je, { size: "sm", color: "tertiary", isBold: !0, children: e(`notification.home.${p.notifications.status}`, {
          gp: p.notifications.gpReward
        }) })
      ] }) }),
      /* @__PURE__ */ v(Et, {})
    ] }, p.id)),
    /* @__PURE__ */ v(de, { noPaddingRight: !0, href: c, children: /* @__PURE__ */ T(ue, { isFullWidth: !0, justifyContent: "start", gap: "4", alignItems: "center", children: [
      /* @__PURE__ */ v(Se, { name: "plus" }),
      e("add-home")
    ] }) }),
    /* @__PURE__ */ v(Et, {}),
    /* @__PURE__ */ v(de, { noPaddingRight: !0, href: u, children: /* @__PURE__ */ T(ue, { isFullWidth: !0, justifyContent: "start", gap: "4", alignItems: "center", children: [
      /* @__PURE__ */ v(Se, { name: "keys" }),
      e("my-exchanges")
    ] }) }),
    /* @__PURE__ */ v(Et, {}),
    /* @__PURE__ */ v(de, { noPaddingRight: !0, href: d, children: /* @__PURE__ */ T(ue, { gap: "2", children: [
      /* @__PURE__ */ v(ue, { isFullWidth: !0, justifyContent: "space-between", children: /* @__PURE__ */ v(ue, { isFullWidth: !0, justifyContent: "space-between", children: /* @__PURE__ */ T(ue, { gap: "4", alignItems: "center", children: [
        /* @__PURE__ */ v(Se, { name: "credit-card" }),
        e("my-membership")
      ] }) }) }),
      n && /* @__PURE__ */ v(Je, { size: "sm", color: "tertiary", isBold: !0, children: e(`notification.membership.${n.status}`, {
        gp: n.gpReward
      }) })
    ] }) }),
    /* @__PURE__ */ v(Et, {}),
    /* @__PURE__ */ v(de, { noPaddingRight: !0, href: h, children: /* @__PURE__ */ T(ue, { isFullWidth: !0, gap: "4", justifyContent: "start", alignItems: "center", children: [
      /* @__PURE__ */ v(Se, { name: "heart" }),
      e("my-favorite-homes")
    ] }) }),
    /* @__PURE__ */ v(Et, {}),
    /* @__PURE__ */ v(de, { noPaddingRight: !0, href: m, children: /* @__PURE__ */ T(ue, { gap: "4", isFullWidth: !0, justifyContent: "start", alignItems: "center", children: [
      /* @__PURE__ */ v(Se, { name: "header-profile-they-love-my-home" }),
      e("they-love-my-home")
    ] }) }),
    /* @__PURE__ */ v(Et, {}),
    /* @__PURE__ */ v(de, { noPaddingRight: !0, href: f, children: /* @__PURE__ */ T(ue, { gap: "4", isFullWidth: !0, justifyContent: "start", alignItems: "center", children: [
      /* @__PURE__ */ v(Se, { name: "header-profile-settings" }),
      e("settings")
    ] }) }),
    /* @__PURE__ */ v(Et, {}),
    /* @__PURE__ */ v(cx, { config: { apiUrl: r }, onLogout: i, children: /* @__PURE__ */ v(de, { noPaddingRight: !0, children: /* @__PURE__ */ T(ue, { gap: "4", isFullWidth: !0, justifyContent: "start", alignItems: "center", children: [
      /* @__PURE__ */ v(Se, { name: "button-power" }),
      e("logout")
    ] }) }) })
  ] });
}
function Jnt() {
  const { t: e } = mo("header"), { userInfos: t, userProfile: a, userCompletionRate: o, userMemberShip: n } = ro((p) => ({
    userInfos: p.userInfos,
    userProfile: p.userInfos?.profil,
    userCompletionRate: p.userInfos?.profil.completionRate ?? 0,
    userMemberShip: p.userInfos?.notifications?.user?.details.membership
  })), { url: r } = Oe("/conversations"), { url: i } = Oe(`/user/edit/${t?.profil.id}`), { url: s } = Oe("/homes/edit"), { url: l } = Oe("/homes/create"), { url: c } = Oe("/myexchanges"), { url: u } = Oe("/my-plan"), { url: d } = Oe("/user/favorite"), { url: h } = Oe("/user/they-love-my-home"), { url: m } = Oe("/user/gpdetails"), { url: f } = Oe(`/user/settings/${t?.profil.id}`);
  return /* @__PURE__ */ T(De, { children: [
    /* @__PURE__ */ v(de, { largerPaddingBottom: !0, children: /* @__PURE__ */ T(ue, { isFullWidth: !0, justifyContent: "start", alignItems: "center", children: [
      /* @__PURE__ */ v(Sb, { url: a?.profilePicture ?? "", alt: "avatar" }),
      /* @__PURE__ */ T("div", { children: [
        /* @__PURE__ */ T(Je, { isBold: !0, isSpan: !0, children: [
          a?.firstName,
          " ",
          t?.profil.lastName
        ] }),
        /* @__PURE__ */ T("div", { children: [
          /* @__PURE__ */ v(Je, { isBold: !0, isSpan: !0, color: "secondary", children: a?.totalGP }),
          " ",
          "GP"
        ] })
      ] })
    ] }) }),
    /* @__PURE__ */ v(de, { href: r, children: /* @__PURE__ */ v(ue, { isFullWidth: !0, justifyContent: "space-between", children: /* @__PURE__ */ T(ue, { gap: "4", alignItems: "center", children: [
      /* @__PURE__ */ v(Se, { name: "header-message-new" }),
      "Inbox"
    ] }) }) }),
    /* @__PURE__ */ v(de, { href: i, children: /* @__PURE__ */ T(ue, { isFullWidth: !0, justifyContent: "space-between", children: [
      /* @__PURE__ */ T(ue, { gap: "4", alignItems: "center", children: [
        /* @__PURE__ */ v(Se, { name: "header-profile-profile" }),
        "My Profile"
      ] }),
      /* @__PURE__ */ T(Je, { color: o === 1 ? "primary" : "tertiary", children: [
        o,
        "%"
      ] })
    ] }) }),
    t?.homes?.map((p) => /* @__PURE__ */ v(de, { href: `${s}/${p.id}`, children: /* @__PURE__ */ T(ue, { gap: "0", isFullWidth: !0, children: [
      /* @__PURE__ */ T(ue, { isFullWidth: !0, justifyContent: "space-between", children: [
        /* @__PURE__ */ T(ue, { gap: "4", alignItems: "center", children: [
          /* @__PURE__ */ v(Se, { name: "header-profile-home" }),
          "My Home"
        ] }),
        /* @__PURE__ */ T(Je, { color: p.completionRate === 1 ? "primary" : "tertiary", children: [
          p.completionRate,
          "%"
        ] })
      ] }),
      p.notifications?.status && /* @__PURE__ */ v(Je, { size: "sm", color: "tertiary", isBold: !0, children: e(`notification.home.${p.notifications.status}`, {
        gp: p.notifications.gpReward
      }) })
    ] }) }, p.id)),
    /* @__PURE__ */ v(de, { href: l, children: /* @__PURE__ */ T(ue, { isFullWidth: !0, justifyContent: "start", gap: "4", alignItems: "center", children: [
      /* @__PURE__ */ v(Se, { name: "plus" }),
      "Add a home"
    ] }) }),
    /* @__PURE__ */ v(de, { href: c, children: /* @__PURE__ */ T(ue, { isFullWidth: !0, justifyContent: "start", gap: "4", alignItems: "center", children: [
      /* @__PURE__ */ v(Se, { name: "keys" }),
      "My exchanges"
    ] }) }),
    /* @__PURE__ */ v(de, { href: u, children: /* @__PURE__ */ T(ue, { gap: "0", children: [
      /* @__PURE__ */ v(ue, { isFullWidth: !0, justifyContent: "space-between", children: /* @__PURE__ */ T(ue, { justifyContent: "start", gap: "4", alignItems: "center", children: [
        /* @__PURE__ */ v(Se, { name: "credit-card" }),
        "My membership"
      ] }) }),
      n && /* @__PURE__ */ v(Je, { size: "sm", color: "tertiary", isBold: !0, children: e(`notification.membership.${n.status}`, {
        gp: n.gpReward
      }) })
    ] }) }),
    /* @__PURE__ */ v(de, { href: d, children: /* @__PURE__ */ T(ue, { isFullWidth: !0, justifyContent: "start", gap: "4", alignItems: "center", children: [
      /* @__PURE__ */ v(Se, { name: "heart" }),
      "My favorite homes"
    ] }) }),
    /* @__PURE__ */ v(de, { href: h, children: /* @__PURE__ */ T(ue, { isFullWidth: !0, justifyContent: "start", gap: "4", alignItems: "center", children: [
      /* @__PURE__ */ v(Se, { name: "header-profile-they-love-my-home" }),
      "They love my home"
    ] }) }),
    /* @__PURE__ */ v(de, { href: f, children: /* @__PURE__ */ T(ue, { isFullWidth: !0, justifyContent: "start", gap: "4", alignItems: "center", children: [
      /* @__PURE__ */ v(Se, { name: "header-profile-settings" }),
      "My settings"
    ] }) }),
    /* @__PURE__ */ v(de, { href: m, children: /* @__PURE__ */ v(Je, { isSpan: !0, color: "secondary", children: "Sponsor 10 friends and receive up to 2500 GP" }) })
  ] });
}
function Znt() {
  const { t: e } = mo("header"), { url: t } = Oe("/user/gpdetails"), { url: a } = Oe("/"), { url: o } = Oe("/collection"), { userInfos: n, apiUrl: r } = ro((s) => ({
    userInfos: s.userInfos,
    apiUrl: s.apiUrl
  })), { signout: i } = zs((s) => ({
    signout: s.signout
  }));
  return /* @__PURE__ */ T(kb, { notificationValue: n?.notifications?.user?.total, children: [
    /* @__PURE__ */ T(xb, { position: "end", children: [
      /* @__PURE__ */ v(Ko, { hideOn: "desktop", children: /* @__PURE__ */ v(Jnt, {}) }),
      /* @__PURE__ */ v(To, { hideOn: "desktop" }),
      /* @__PURE__ */ v(dx, {}),
      /* @__PURE__ */ v(To, {}),
      /* @__PURE__ */ v(Hnt, {}),
      /* @__PURE__ */ v(To, { hideOn: "mobile" }),
      /* @__PURE__ */ v(de, { href: t, hideOn: "mobile", children: /* @__PURE__ */ T(ue, { gap: "1", children: [
        /* @__PURE__ */ v(Je, { isSpan: !0, isBold: !0, color: "secondary", children: n?.profil.totalGP }),
        /* @__PURE__ */ v(Je, { isSpan: !0, children: "GP" })
      ] }) }),
      /* @__PURE__ */ v(To, { hideOn: "mobile" }),
      /* @__PURE__ */ T(xu, { hideOn: "mobile", children: [
        /* @__PURE__ */ v($u, { children: /* @__PURE__ */ T(ue, { alignItems: "center", gap: "2", children: [
          /* @__PURE__ */ v(fu, { value: n?.notifications?.user?.total ?? 0, children: /* @__PURE__ */ v(Sb, { url: n?.profil.profilePicture ?? "", alt: "avatar" }) }),
          e("my-account")
        ] }) }),
        /* @__PURE__ */ v(Su, { size: "small", children: /* @__PURE__ */ v(Knt, {}) })
      ] }),
      /* @__PURE__ */ v(de, { hideOn: "desktop", href: o, children: "Home Exchange Collection" }),
      /* @__PURE__ */ v(de, { hideOn: "desktop", href: a, children: "English" }),
      /* @__PURE__ */ v(de, { hideOn: "desktop", href: a, children: "US dollars - $" })
    ] }),
    /* @__PURE__ */ v(cx, { config: { apiUrl: r }, onLogout: i, children: /* @__PURE__ */ v(de, { marginAutoTop: !0, hideOn: "desktop", children: /* @__PURE__ */ T(ue, { isFullWidth: !0, justifyContent: "start", children: [
      /* @__PURE__ */ v(Se, { name: "button-power" }),
      e("logout")
    ] }) }) })
  ] });
}
function Ynt() {
  const [e, t] = Pe(!1), [a, o] = Pe(!1), { url: n } = Oe("/#signup"), { url: r } = Oe("/#signin"), { url: i } = Oe("/"), { url: s } = Oe("/collection"), { apiUrl: l } = ro((m) => ({ apiUrl: m.apiUrl })), { currentWidth: c } = Vee(), { t: u } = mo(["header", "links"]), { setIsSignedIn: d } = zs((m) => ({
    setIsSignedIn: m.setIsSignedIn
  })), { setNavigationBarData: h } = ro((m) => ({
    setNavigationBarData: m.setNavigationBarData
  }));
  return Uee("navigation-bar:open-signup-modal", () => {
    o(!0);
  }), /* @__PURE__ */ v(kb, { children: /* @__PURE__ */ T(xb, { position: "end", children: [
    /* @__PURE__ */ v(de, { href: u("links:how-it-works"), children: c && c <= 1300 ? /* @__PURE__ */ v(Se, { name: "circle-help" }) : u("how-it-works") }),
    /* @__PURE__ */ v(de, { href: u("links:subscription-cost"), children: c && c <= 1300 ? /* @__PURE__ */ v(Se, { name: "dollar" }) : u("how-much-does-it-cost") }),
    /* @__PURE__ */ v(Ko, { hideOn: "desktop", children: /* @__PURE__ */ v(To, {}) }),
    /* @__PURE__ */ v(dx, {}),
    /* @__PURE__ */ v(Ko, { hideOn: "desktop", children: /* @__PURE__ */ v(To, {}) }),
    /* @__PURE__ */ v(de, { href: s, hideOn: "desktop", children: "Home Exchange Collection" }),
    /* @__PURE__ */ v(de, { href: i, hideOn: "desktop", children: "English" }),
    /* @__PURE__ */ v(de, { href: i, hideOn: "desktop", children: "US dollars - $" }),
    /* @__PURE__ */ T(De, { children: [
      /* @__PURE__ */ v(de, { href: r, isSecondOnMobile: !0, isButton: !0, children: u("sign-in") }),
      /* @__PURE__ */ v(de, { isFirstOnMobile: !0, largerPaddingBottom: !0, children: /* @__PURE__ */ v(ou, { href: n, size: "regular", color: "primary", children: u("sign-up-for-free") }) })
    ] })
  ] }) });
}
function Xnt({ theme: e, locale: t }) {
  const { t: a } = mo("header"), { apiUrl: o, assetsUrl: n } = ro((l) => ({ apiUrl: l.apiUrl, assetsUrl: l.assetsUrl })), { isSignedIn: r } = zs((l) => ({ isSignedIn: l.isSignedIn })), { url: i } = Oe("/"), s = `${n}/navigation/he-logo${e === "collection" ? "-collection" : ""}.svg`;
  return /* @__PURE__ */ T(wb, { children: [
    /* @__PURE__ */ T($b, { children: [
      /* @__PURE__ */ v(de, { backgroundOnHover: !1, href: i, children: /* @__PURE__ */ v("img", { src: s, alt: `HomeExchange ${e} logo ` }) }),
      /* @__PURE__ */ v(de, { isFlexGrow: !0, children: /* @__PURE__ */ v(
        KD,
        {
          config: { apiUrl: o, locale: t },
          id: "navbar-search-bar",
          placeholder: a("common:autocomplete.placeholder"),
          buttonText: a("common:autocomplete.button"),
          hideButtonText: !0
        }
      ) })
    ] }),
    r ? /* @__PURE__ */ v(Znt, {}) : /* @__PURE__ */ v(Ynt, {})
  ] });
}
function xit({
  conversations: e,
  userInfos: t,
  theme: a,
  isSignedIn: o,
  locale: n = "en",
  apiUrl: r,
  assetsUrl: i
}) {
  return ip.changeLanguage(n), bx(r), /* @__PURE__ */ v(Yee, { isSignedIn: o, children: /* @__PURE__ */ v(Gee, { conversations: e, userInfos: t, apiUrl: r, assetsUrl: i, children: /* @__PURE__ */ v(Dx, { i18n: ip, children: /* @__PURE__ */ v(jb, { locale: n, children: /* @__PURE__ */ v(Xnt, { theme: a, locale: n }) }) }) }) });
}
const Qnt = ({ logoIsLink: e, theme: t, assetsUrl: a }) => {
  const { url: o } = Oe("/"), n = `${a}/navigation/he-logo${t === "collection" ? "-collection" : ""}.svg`;
  return /* @__PURE__ */ v(wb, { isFixedTop: !0, children: /* @__PURE__ */ v($b, { children: /* @__PURE__ */ v(de, { href: e ? o : void 0, children: /* @__PURE__ */ v("img", { src: n, alt: `HomeExchange ${t} logo ` }) }) }) });
}, $it = ({ logoIsLink: e, locale: t, theme: a, assetsUrl: o }) => /* @__PURE__ */ v(jb, { locale: t || "en", children: /* @__PURE__ */ v(Qnt, { logoIsLink: e, theme: a, assetsUrl: o }) });
function Sit({ locale: e }) {
  const [t, a] = Pe();
  return Ce(() => {
    _x(e).then(a);
  }, [e]), t && /* @__PURE__ */ v(
    j0,
    {
      text: t.communicationBanner.data.text,
      url: t.communicationBanner.data.link
    }
  );
}
export {
  Sit as CommunicationBanner,
  Knt as DesktopMenu,
  dx as HelpItem,
  $it as LiteHeader,
  Znt as LoggedInMenu,
  Ynt as LoggedOutMenu,
  Hnt as MessagesItem,
  Jnt as MobileMenu,
  xit as NavigationBar,
  Gee as NavigationBarProvider,
  Gnt as TabContent,
  ky as UserContext,
  Yee as UserProvider,
  Hee as createNavigationBarStore,
  Zee as createUserStore,
  _x as getCommunicationBannerData,
  jit as getNavigationBarData,
  Oit as heFetch,
  ip as i18nConfig,
  bx as setNavigationBarFetchConfig,
  ro as useNavigationBarContext,
  zs as useUserContext
};
